/*jshint browser: true
*/

(function () {
    'use strict';

    if (!Function.prototype.bind) {
        Function.prototype.bind = function (oThis) {
            if (typeof this !== 'function') {
                // closest thing possible to the ECMAScript 5 internal IsCallable function
                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
            }
            
            var self = this,
                args = Array.prototype.slice.call(arguments, 1);
            return function () {
                return self.apply(oThis, args.concat(Array.prototype.slice.call(arguments)));
            };
        };
    }

})();
/*jshint browser: true
*/
/**
@module daumtools
**/
(function (exports) {
    "use strict";
    
    /**
    HTMLElement 의 className attribute 값을 관리한다.

    @class daumtools.classList
    @static
    **/
    var classList = exports.classList = (function () {
        if ('classList' in document.documentElement) {
            return {
                has: function (el, cname) {
                    assertElement(el, cname, 'has');
                    return el.classList.contains(cname);
                },
                add: function (el, cname) {
                    assertElement(el, cname, 'add');
                    el.classList.add(cname);
                },
                remove: function (el, cname) {
                    assertElement(el, cname, 'remove');
                    el.classList.remove(cname);
                },
                toggle: function (el, cname) {
                    assertElement(el, cname, 'toggle');
                    el.classList.toggle(cname);
                }
            };
        } else {
            return {
                /**
                HTMLElement 의 class list에 주어진 class가 존재하는지 판단한다.

                @method daumtools.classList.has
                @param el {HTMLElement} dom element
                @param cname {String} class name
                @return {Boolean} el의 class name에 cname이 존재할 경우 true, 그렇지 않을 경우 false.
                **/
                has: function (el, cname) {
                    assertElement(el, cname, 'has');
                    return el.className && ((" " + el.className + " ").lastIndexOf(" " + cname + " ") > -1);
                },
                /**
                HTMLElement 의 class list에 주어진 class 를 추가한다.

                @method daumtools.classList.add
                @param el {HTMLElement} dom element
                @param cname {String} el에 추가할 class name
                **/
                add: function (el, cname) {
                    assertElement(el, cname, 'add');
                    if (!el.className) {
                        el.className = cname;
                    } else if (!classList.has(el, cname)) {
                        el.className += " " + cname;
                    }
                },
                /**
                HTMLElement 의 class list에 주어진 class 를 삭제한다.

                @method daumtools.classList.remove
                @param el {HTMLElement} dom element
                @param cname {String} el에서 삭제할 class name
                **/
                remove: function (el, cname) {
                    assertElement(el, cname, 'remove');
                    if (el.className) {
                        el.className = (" " + el.className + " ").replace(" " + cname + " ", " ").replace(/^\s+|\s+$/g, '');
                    }
                },
                /**
                HTMLElement 의 class list에 주어진 class 를 추가 혹은 삭제한다.

                @method daumtools.classList.toggle
                @param el {HTMLElement} dom element
                @param cname {String} class name
                **/
                toggle: function (el, cname) {
                    assertElement(el, cname, 'toggle');
                    if (el.className && classList.has(el, cname)) {
                        classList.remove(el, cname);
                    } else {
                        classList.add(el, cname);
                    }
                }
            };
        }
    })();

    function assertElement(el, cname, method) {
        if (!el) {
            throw new Error('el is not valid, el : ' + el + ', method : ' + method + ', className : ' + cname);
        }
    }
        
})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);

/*jshint loopfunc: true, expr: true, newcap: false, latedef: false, noarg: false, undef:false */

/* Simple JavaScript Inheritance
 * By John Resig http://ejohn.org/
 * MIT Licensed.
 */
// Inspired by base2 and Prototype
(function(exports){
  var initializing = false, fnTest = /xyz/.test(function(){xyz;}) ? /\b_super\b/ : /.*/;
  // The base Class implementation (does nothing)
  this.Class = exports.Class = function(){};
  
  // Create a new Class that inherits from this class
  Class.extend = function(prop) {
    var _super = this.prototype;
    
    // Instantiate a base class (but only create the instance,
    // don't run the init constructor)
    initializing = true;
    var prototype = new this();
    initializing = false;
    
    // Copy the properties over onto the new prototype
    for (var name in prop) {
      // Check if we're overwriting an existing function
      prototype[name] = typeof prop[name] === "function" &&
        typeof _super[name] === "function" && fnTest.test(prop[name]) ?
        (function(name, fn){
          return function() {
            var tmp = this._super;
            
            // Add a new ._super() method that is the same method
            // but on the super-class
            this._super = _super[name];
            
            // The method only need to be bound temporarily, so we
            // remove it when we're done executing
            var ret = fn.apply(this, arguments);        
            this._super = tmp;
            
            return ret;
          };
        })(name, prop[name]) :
        prop[name];
    }
    
    // The dummy class constructor
    function Class() {
      // All construction is actually done in the init method
      if ( !initializing && this.init ) {
        this.init.apply(this, arguments);
      }
    }
    
    // Populate our constructed prototype object
    Class.prototype = prototype;
    
    // Enforce the constructor to be what we expect
    Class.prototype.constructor = Class;

    // And make this class extendable
    Class.extend = arguments.callee;
    
    return Class;
  };
})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);
/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.2.20171210
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in self) {

    // Full polyfill for browsers with no classList support
    // Including IE < Edge missing SVGElement.classList
    if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {

        (function(view) {

            "use strict";

            if (!('Element' in view)) return;

            var
                classListProp = "classList",
                protoProp = "prototype",
                elemCtrProto = view.Element[protoProp],
                objCtr = Object,
                strTrim = String[protoProp].trim || function() {
                    return this.replace(/^\s+|\s+$/g, "");
                }, arrIndexOf = Array[protoProp].indexOf || function(item) {
                    var
                        i = 0,
                        len = this.length;
                    for (; i < len; i++) {
                        if (i in this && this[i] === item) {
                            return i;
                        }
                    }
                    return -1;
                }
                // Vendors: please allow content code to instantiate DOMExceptions
                ,
                DOMEx = function(type, message) {
                    this.name = type;
                    this.code = DOMException[type];
                    this.message = message;
                }, checkTokenAndGetIndex = function(classList, token) {
                    if (token === "") {
                        throw new DOMEx("SYNTAX_ERR", "The token must not be empty.");
                    }
                    if (/\s/.test(token)) {
                        throw new DOMEx("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
                    }
                    return arrIndexOf.call(classList, token);
                }, ClassList = function(elem) {
                    var
                        trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
                        classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
                        i = 0,
                        len = classes.length;
                    for (; i < len; i++) {
                        this.push(classes[i]);
                    }
                    this._updateClassName = function() {
                        elem.setAttribute("class", this.toString());
                    };
                }, classListProto = ClassList[protoProp] = [],
                classListGetter = function() {
                    return new ClassList(this);
                };
            // Most DOMException implementations don't allow calling DOMException's toString()
            // on non-DOMExceptions. Error's toString() is sufficient here.
            DOMEx[protoProp] = Error[protoProp];
            classListProto.item = function(i) {
                return this[i] || null;
            };
            classListProto.contains = function(token) {
                return~checkTokenAndGetIndex(this, token + "");
            };
            classListProto.add = function() {
                var
                    tokens = arguments,
                    i = 0,
                    l = tokens.length,
                    token, updated = false;
                do {
                    token = tokens[i] + "";
                    if (!~checkTokenAndGetIndex(this, token)) {
                        this.push(token);
                        updated = true;
                    }
                }
                while (++i < l);

                if (updated) {
                    this._updateClassName();
                }
            };
            classListProto.remove = function() {
                var
                    tokens = arguments,
                    i = 0,
                    l = tokens.length,
                    token, updated = false,
                    index;
                do {
                    token = tokens[i] + "";
                    index = checkTokenAndGetIndex(this, token);
                    while (~index) {
                        this.splice(index, 1);
                        updated = true;
                        index = checkTokenAndGetIndex(this, token);
                    }
                }
                while (++i < l);

                if (updated) {
                    this._updateClassName();
                }
            };
            classListProto.toggle = function(token, force) {
                var
                    result = this.contains(token),
                    method = result ? force !== true && "remove" : force !== false && "add";

                if (method) {
                    this[method](token);
                }

                if (force === true || force === false) {
                    return force;
                } else {
                    return !result;
                }
            };
            classListProto.replace = function(token, replacement_token) {
                var index = checkTokenAndGetIndex(token + "");
                if (~index) {
                    this.splice(index, 1, replacement_token);
                    this._updateClassName();
                }
            }
            classListProto.toString = function() {
                return this.join(" ");
            };

            if (objCtr.defineProperty) {
                var classListPropDesc = {
                    get: classListGetter,
                    enumerable: true,
                    configurable: true
                };
                try {
                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                } catch (ex) { // IE 8 doesn't support enumerable:true
                    // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                    // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                    if (ex.number === undefined || ex.number === -0x7FF5EC54) {
                        classListPropDesc.enumerable = false;
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    }
                }
            } else if (objCtr[protoProp].__defineGetter__) {
                elemCtrProto.__defineGetter__(classListProp, classListGetter);
            }

        }(self));

    }

    // There is full or partial native classList support, so just check if we need
    // to normalize the add/remove and toggle APIs.

    (function() {
        "use strict";

        var testElement = document.createElement("_");

        testElement.classList.add("c1", "c2");

        // Polyfill for IE 10/11 and Firefox <26, where classList.add and
        // classList.remove exist but support only one argument at a time.
        if (!testElement.classList.contains("c2")) {
            var createMethod = function(method) {
                var original = DOMTokenList.prototype[method];

                DOMTokenList.prototype[method] = function(token) {
                    var i, len = arguments.length;

                    for (i = 0; i < len; i++) {
                        token = arguments[i];
                        original.call(this, token);
                    }
                };
            };
            createMethod('add');
            createMethod('remove');
        }

        testElement.classList.toggle("c3", false);

        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
        // support the second argument.
        if (testElement.classList.contains("c3")) {
            var _toggle = DOMTokenList.prototype.toggle;

            DOMTokenList.prototype.toggle = function(token, force) {
                if (1 in arguments && !this.contains(token) === !force) {
                    return force;
                } else {
                    return _toggle.call(this, token);
                }
            };

        }

        // replace() polyfill
        if (!("replace" in document.createElement("_").classList)) {
            DOMTokenList.prototype.replace = function(token, replacement_token) {
                var
                    tokens = this.toString().split(" "),
                    index = tokens.indexOf(token + "");
                if (~index) {
                    tokens = tokens.slice(index);
                    this.remove.apply(this, tokens);
                    this.add(replacement_token);
                    this.add.apply(this, tokens.slice(1));
                }
            }
        }

        testElement = null;
    }());

}

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) {
                return el;
            }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

/*jshint devel: true
 */
/*global Class, daumtools:true*/
(function (exports) {
    'use strict';

    exports.Observable = Class.extend({
        on: function (event, listener) {
            var events = [].concat(event);
            for (var i = 0, l = events.length; i < l; i++) {
                this.addListener.apply(this, [events[i], listener]);
            }

            return this;
        },
        addListener: function (event, listener) {
            var listeners = this.getListeners(event);
            listeners.push(listener);
            return this;
        },
        once: function (event, listener) {
            if (!listener) {
                return ;
            }
            var self = this;
            var onetimeListener = function () {
                self.off(event, onetimeListener);
                listener.apply(this, arguments);
            };
            listener.__onetime_listener = onetimeListener;
            this.on(event, onetimeListener);
        },
        emit: function (event) {
            var events = [].concat(event);
            var args = [].slice.call(arguments, 1);
            for (var i = 0, l = events.length; i < l; i++) {
                this._emit(events[i], args);
            }

            return this;
        },
        _emit: function (event, args) {
            var cloneListeners = this.getListeners(event).slice(0);
            if (typeof cloneListeners !== 'undefined') {
                for (var i = 0, len = cloneListeners.length; i < len; i++) {
                    try {
                        cloneListeners[i].apply(this, args);
                    } catch (e) {
                        if (typeof console !== 'undefined') {
                            console.error('failed on while "' + event + '" event, caused by\r\n > ' + e);
                        }
                        throw e;
                    }
                }
            }
        },
        getListeners: function (event) {
            this.listeners = this.listeners || {};
            this.listeners[event] = this.listeners[event] || [];
            return this.listeners[event];
        },
        off: function (event, listener) {
            var events = [].concat(event);
            if (listener && typeof listener.__onetime_listener === 'function') {
                listener = listener.__onetime_listener;
            }

            for (var i = 0, l = events.length; i < l; i++) {
                this.removeListener.apply(this, [events[i], listener]);
            }

            if (listener && typeof listener.__onetime_listener === 'function') {
                delete listener.__onetime_listener;
            }
            return this;
        },
        removeListener: function (event, listener) {
            var listeners = this.getListeners(event);
            if (typeof listeners !== 'undefined') {
                for (var i = 0, len = listeners.length; i < len; i++) {
                    if (listeners[i] === listener || listeners[i].__original__ === listener) {
                        listeners.splice(i, 1);
                        break;
                    }
                }
            }
            return this;
        },
        destroy: function () {
            this.listeners = null;
        }
    });
})(window.daumtools = (typeof daumtools === 'undefined') ? {} : daumtools);
/*jshint browser: true
 */
/*global daumtools: true*/

(function (exports) {
    "use strict";

    /**
     * 주어진 엘리먼트의 문서(body) 좌상단(0, 0)으로부터의 위치(coordinates)를 반환한다.
     * @param el
     * @returns {{x: (Number|number), y: (Number|number)}}
     */
    exports.offset = function (el) {
        var x = el.offsetLeft,
            y = el.offsetTop,
            offsetNode = el;

        while (offsetNode.offsetParent && offsetNode.offsetParent !== document.body) {
            offsetNode = offsetNode.offsetParent;
            x += offsetNode.offsetLeft;
            y += offsetNode.offsetTop;
        }

        return {
            x: x,
            y: y
        };
    };

})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);
/*! ua_parser - v1.2.7 - 2020-06-03
* Copyright (c) 2020 HTML5 Tech. Team in Daum Communications Corp.;
* Licensed MIT */
/*jshint browser: true, node: true
*/

(function (exports) {
    'use strict';

    if (!Array.isArray) {
        Array.isArray = function(arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }
    
    function checkUserAgent(ua) {
        var browser = {};
        var match = /(dolfin)[ \/]([\w.]+)/.exec( ua ) ||
                /(edge)[ \/]([\w.]+)/.exec( ua ) ||
                /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
                /(tizen)[ \/]([\w.]+)/.exec( ua ) ||
                /(opera)(?:.*version)?[ \/]([\w.]+)/.exec( ua ) ||
                /(webkit)(?:.*version)?[ \/]([\w.]+)/.exec( ua ) ||
                /(msie) ([\w.]+)/.exec( ua ) ||
                ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+))?/.exec( ua ) ||
                ["","unknown"];
        if (match[1] === "webkit") {
            match = /(iphone|ipad|ipod)[\S\s]*os ([\w._\-]+) like/.exec(ua) ||
                /(android)[ \/]([\w._\-]+);/.exec(ua) || [match[0], "safari", match[2]];
        } else if (match[1] === "mozilla") {
            if (/trident/.test(ua)) {
                match[1] = "msie";
            } else {
                match[1] = "firefox";
            }
        } else if (/polaris|natebrowser|([010|011|016|017|018|019]{3}\d{3,4}\d{4}$)/.test(ua)) {
            match[1] = "polaris";
        }

        browser[match[1]] = true;
        browser.name = match[1];
        browser.version = setVersion(match[2]);

        return browser;
    }

    function setVersion(versionString) {
        var version = {};

        var versions = versionString ? versionString.split(/\.|-|_/) : ["0","0","0"];
        version.info = versions.join(".");
        version.major = versions[0] || "0";
        version.minor = versions[1] || "0";
        version.patch = versions[2] || "0";

        return version;
    }

    function checkPlatform (ua) {
        if (isPc(ua)) {
            return "pc";
        } else if (isTablet(ua)) {
            return "tablet";
        } else if (isMobile(ua)) {
            return "mobile";
        } else {
            return "";
        }
    }
    function isPc (ua) {
        if (ua.match(/linux|windows (nt|98)|macintosh|cros/) && !ua.match(/android|mobile|polaris|lgtelecom|uzard|natebrowser|ktf;|skt;/)) {
            return true;
        }
        return false;
    }
    function isTablet (ua) {
        if (ua.match(/ipad/) || (ua.match(/android/) && !ua.match(/mobi|mini|fennec/)) || 
        (ua.match(/macintosh/) && window.navigator.maxTouchPoints > 1)) {
            return true;
        }
        return false;
    }
    function isMobile (ua) {
        if (!!ua.match(/ip(hone|od)|android.+mobile|windows (ce|phone)|blackberry|bb10|symbian|webos|firefox.+fennec|opera m(ob|in)i|tizen.+mobile|polaris|iemobile|lgtelecom|nokia|sonyericsson|dolfin|uzard|natebrowser|ktf;|skt;/)) {
            return true;
        } else {
            return false;
        }
    }

    function checkOs (ua) {
        var os = {},
            match = /(iphone|ipad|ipod)[\S\s]*os ([\w._\-]+) like/.exec(ua) ||
                    (/polaris|natebrowser|([010|011|016|017|018|019]{3}\d{3,4}\d{4}$)/.test(ua)? ["", "polaris", "0.0.0"] : false) ||
                    /(windows)(?: nt | phone(?: os){0,1} | )([\w._\-]+)/.exec(ua) ||
                    /(android)[ \/]([\w._\-]+);/.exec(ua) ||
                    (/android/.test(ua)? ["", "android", "0.0.0"] : false) ||
                    (/(windows)/.test(ua)? ["", "windows", "0.0.0"] : false) ||
                    /(mac) os x ([\w._\-]+)/.exec(ua) ||
                    /(tizen)[ \/]([\w._\-]+);/.exec(ua) ||
                    (/(linux)/.test(ua)? ["", "linux", "0.0.0"] : false) ||
                    (/webos/.test(ua)? ["", "webos", "0.0.0"] : false) ||
                    /(cros)(?:\s[\w]+\s)([\d._\-]+)/.exec(ua) ||
                    /(bada)[ \/]([\w._\-]+)/.exec(ua) ||
                    (/bada/.test(ua)? ["", "bada", "0.0.0"] : false) ||
                    (/(rim|blackberry|bb10)/.test(ua)? ["", "blackberry", "0.0.0"] : false) ||
                    ["", "unknown", "0.0.0"];

        if (match[1] === "iphone" || match[1] === "ipad" || match[1] === "ipod") {
            match[1] = "ios";
        } else if (match[1] === "windows" && match[2] === "98") {
            match[2] = "0.98.0";
        }

        if (match[1] === "mac" && window.navigator.maxTouchPoints > 1) {
            match[1] = "ios";
        }
        if (match[1] === 'cros') {
            match[1] = "chrome";
        }
        os[match[1]] = true;
        os.name = match[1];
        os.version = setVersion(match[2]);
        return os;
    }

    var baseAppList = ['crios', 'fxios', 'daumapps'];
    function checkApp (ua, customAppList) {
        var app = {},
            match = null,
            checkAppList = baseAppList;

        if (Array.isArray(customAppList)) {
            checkAppList = baseAppList.concat(customAppList);  
        } else if (typeof customAppList === 'string') {
            checkAppList = baseAppList.concat([customAppList]);
        }

        for(var i=0, len=checkAppList.length; i<len; i+=1) {
            var appname = checkAppList[i];
            var regex = new RegExp('('+ appname + ')[ \\/]([\\w._\\-]+)');
            match = regex.exec( ua );
            if (match) {
                break;
            }
        }

        if (!match) {
            match = ["",""];
        }

        if (match[1]) {
            app.isApp = true;
            app.name = match[1];
            app.version = setVersion(match[2]);
        } else {
            app.isApp = false;
        }

        return app;
    }

    function getLowerUserAgent(ua) {
        var lowerUa = '';
        if (!ua) {
            if (typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgent === 'string') {
                lowerUa = window.navigator.userAgent.toLowerCase();
            } else {
                lowerUa = '';
            }
        } else {
            lowerUa = ua.toLowerCase();
        }

        return lowerUa;
    }

    var userAgent = exports.userAgent = function (ua, customAppList) {
        var lowerUa = getLowerUserAgent(ua);
        
        return {
            ua: lowerUa,
            browser: checkUserAgent(lowerUa),
            platform: checkPlatform(lowerUa),
            os: checkOs(lowerUa),
            app: checkApp(lowerUa, customAppList)
        };
    };

    if (typeof window === 'object' && window.navigator.userAgent) {
        window.ua_result = userAgent(window.navigator.userAgent) || null;
    }

})((function (){
    // Make userAgent a Node module, if possible.
    if (typeof exports === 'object') {
        exports.daumtools = exports;
        exports.util = exports;
        return exports;
    } else if (typeof window === 'object') {
        window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools;
        window.util = (typeof window.util === 'undefined') ? window.daumtools : window.util;
        return window.daumtools;
    } else if (typeof self === 'object') {
        // for use in web workers
        self.daumtools = (typeof self.daumtools === 'undefined') ? {} : self.daumtools;
        self.util = (typeof self.util === 'undefined') ? self.daumtools : self.util;
        return self;
    }
})());

/*jshint browser: true
*/

(function (exports) {
    "use strict";
    
    exports.extend = function (dest, src, overwrite) {
        dest = dest || {};
        
        for(var key in src) {
            if (src.hasOwnProperty(key)) {
                if (!dest[key] || overwrite) {
                    dest[key] = src[key];
                }
            }
        }

        return dest;
    };
        
})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);
/*jshint browser: true
*/

(function (exports) {
    "use strict";

    exports.event = {
        on: function () {
            if (document.addEventListener) {
                return function (el, type, fn) {
                    if (!el) {
                        throw 'failed to add event. Element: "' + el + '", Event: "' + type + '", handler: ' + fn.toString();
                    }
                    el.addEventListener(type, fn, false);
                };
            } else {
                return function (el, type, fn) {
                    el.attachEvent('on' + type, fn);
                };
            }
        }(),
        off: function () {
            if (document.removeEventListener) {
                return function (el, type, fn) {
                    el.removeEventListener(type, fn, false);
                };
            } else {
                return function (el, type, fn) {
                    el.detachEvent("on" + type, fn);
                };
            }
        }(),
        preventDefault: function (e) {
            var ev = e || window.event;
            if (ev.preventDefault) {
                ev.preventDefault();
            } else {
                ev.returnValue = false;
            }
        },
        stopPropagation: function (e) {
            var ev = e || window.event;
            if (ev.stopPropagation) {
                ev.stopPropagation();
            } else {
                ev.cancelBubble = true;
            }
        },
        getTarget: function (e) {
            var ev = e || window.event;
            return ev.target || ev.srcElement;
        }
    };
})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);

/*jshint browser: true
*/

(function (exports){

    exports.$ = function (id) {
        return document.getElementById(id);
    };

    if (window.Sizzle) {
        exports.$$ = window.Sizzle;
        return;
    } else if (window.jQuery && window.jQuery.find) {
        exports.$$ = window.jQuery.find;
        return;
    }

    exports.$$ = function (select, start) {
        if (typeof start === "object" && start.querySelectorAll) {
            return start.querySelectorAll(select);
        } else if(typeof start === "string") {
            return document.querySelectorAll(start + " " + select);
        } else {
            return document.querySelectorAll(select);
        }
    };

})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);
/*jshint browser: true
 */

(function (exports) {
    "use strict";

    function delegate (el, selector, type, fn) {

        if (exports.assert) {
            exports.assert(!!el, 'failed to delegate event. Element: "' + el + '", Selector: "' + selector + '", Event: "' + type + '", handler: ' + fn.toString());
        }

        exports.event.on(el, type, function(e) {
            var currentTarget = exports.event.getTarget(e),
                targets = exports.$$(selector, el);

            targets = Array.prototype.slice.apply(targets);

            while (currentTarget && currentTarget !== el) {
                if (currentTarget.nodeType === 1 && targets.indexOf(currentTarget) > -1) {
                    fn(e, currentTarget);
                    break;
                }
                currentTarget = currentTarget.parentNode;
            }
        });
    }

    exports.event.delegate = delegate;

})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);

/*! gesture - v1.0.6 - 2013-07-09
 * http://digit.daumcorp.com/eastkiki/gesture
 * Copyright (c) 2013 FT tech team, Daum corp; Licensed  */


(function(exports) {
    "use strict";

    var DEFAULT_FLICK_THRESHOLD = 30,
        DEFAULT_GESTURE_THRESHOLD = 30,
        EventUtil;

    function point(x, y) {
        return {
            'x': x,
            'y': y,
            'minus': function(aPoint) {
                return point(this.x - aPoint.x, this.y - aPoint.y);
            }
        };
    }

    function GestureSession(lastSession, startPosX, startPosY, gestureThreshold, flickThreshold) {
        this.type = 'unindentified';
        this.direction = 'unindentified';
        this.startPos = point(startPosX, startPosY);
        this.delta = point(0, 0);
        this.targetEvent = null;
        this.term = 0;
        this.startTime = new Date();
        this.gestureThreshold = gestureThreshold;
        this.flickThreshold = flickThreshold;
        this.lastSession = lastSession;
    }

    GestureSession.prototype = {};
    GestureSession.prototype.isSwipe = function() {
        return this.type === 'swipe';
    };
    GestureSession.prototype.isScroll = function() {
        return this.type === 'scroll';
    };
    GestureSession.prototype.isLeft = function() {
        return this.direction === 'left';
    };
    GestureSession.prototype.isRight = function() {
        return this.direction === 'right';
    };
    GestureSession.prototype.isUp = function() {
        return this.direction === 'up';
    };
    GestureSession.prototype.isDown = function() {
        return this.direction === 'down';
    };
    GestureSession.prototype.isFlick = function() {
        return this.term < 200;
    };
    GestureSession.prototype.getTerm = function() {
        return this.term;
    };
    GestureSession.prototype.isTab = function() {
        return this.type === 'unindentified';
    };
    GestureSession.prototype.isDoubleTab = function() {
        if (typeof this.checkDoubleTab !== 'boolean') {
            this.checkDoubleTab = this.lastSession ? (this.startTime.getTime() - this.lastSession.startTime < 500 && this.lastSession.isTab === true && this.lastSession.isDoubleTab === false && this.type === 'unindentified') : false;
        }

        return this.checkDoubleTab;
    };

    GestureSession.prototype.recognizeGesture = function(x, y) {
        var currentPos = point(x, y),
            delta = currentPos.minus(this.startPos);

        this.delta = delta;

        if (this.type === 'unindentified') {
            if (Math.abs(delta.x) > this.gestureThreshold && Math.abs(delta.x) >= Math.abs(delta.y)) {
                this.type = 'swipe';
                if (delta.x < 0) {
                    this.direction = 'left';
                } else {
                    this.direction = 'right';
                }
            } else if (Math.abs(delta.y) > this.gestureThreshold && Math.abs(delta.y) > Math.abs(delta.x)) {
                this.type = 'scroll';
                if (delta.y < 0) {
                    this.direction = 'up';
                } else {
                    this.direction = 'down';
                }
            }
        }
    };

    GestureSession.prototype.checkFlick = function() {
        this.term = new Date().getTime() - this.startTime;
    };

    EventUtil = {
        START: function() {
            return ('ontouchstart' in window) ? 'touchstart' : 'mousedown';
        }(),
        MOVE: function() {
            return ('ontouchstart' in window) ? 'touchmove' : 'mousemove';
        }(),
        END: function() {
            return ('ontouchstart' in window) ? 'touchend' : 'mouseup';
        }(),
        listen: function() {
            if (document.addEventListener) {
                return function(el, type, fn) {
                    el.addEventListener(type, fn, false);
                };
            } else {
                return function(el, type, fn) {
                    el.attachEvent('on' + type, fn);
                };
            }
        }(),
        unListen: function() {
            if (document.removeEventListener) {
                return function(el, type, fn) {
                    el.removeEventListener(type, fn, false);
                };
            } else {
                return function(el, type, fn) {
                    el.detachEvent("on" + type, fn);
                };
            }
        }(),
        getX: function(e) {
            var point = e.touches ? e.touches[0] : e;
            return point.pageX || point.clientX;
        },
        getY: function(e) {
            var point = e.touches ? e.touches[0] : e;
            return point.pageY || point.clientY;
        }
    };


    function GestureListener(elem, gestureThreshold, flickThreshold) {
        var session = null,
            lastSession = null,
            gestureHandlers = {
                'onGestureStart': null,
                'onGestureMove': null,
                'onGetstureEnd': null
            };

        if (typeof gestureThreshold === 'undefined') {
            gestureThreshold = DEFAULT_GESTURE_THRESHOLD;
        } else if (typeof gestureThreshold !== "number") {
            throw new Error('gestureThreshold must be a number');
        }
        if (typeof flickThreshold === 'undefined') {
            flickThreshold = DEFAULT_FLICK_THRESHOLD;
        } else if (typeof flickThreshold !== "number") {
            throw new Error('flickThreshold must be a number');
        }

        function onMoveGesture(e) {
            if (session) {
                session.recognizeGesture(EventUtil.getX(e), EventUtil.getY(e));
                session.targetEvent = e || window.event;
                if (gestureHandlers.onGestureMove) {
                    gestureHandlers.onGestureMove(session);
                }
            }
        }

        function onEndGesture(e) {
            if (session) {
                session.checkFlick();
                session.targetEvent = e || window.event;

                if (gestureHandlers.onGestureEnd) {
                    gestureHandlers.onGestureEnd(session);
                }

                lastSession = {
                    isTab: session.isTab(),
                    isDoubleTab: session.isDoubleTab(),
                    startTime: session.startTime
                };
                session = null;
            }
            EventUtil.unListen(document, EventUtil.MOVE, onMoveGesture);
            EventUtil.unListen(document, EventUtil.END, onEndGesture);
            if ('ontouchstart' in window) {
                EventUtil.unListen(document, "touchcancel", onEndGesture);
            }
        }

        function onStartGesture(e) {
            session = new GestureSession(lastSession, EventUtil.getX(e), EventUtil.getY(e), gestureThreshold, flickThreshold);
            session.targetEvent = e || window.event;

            if (gestureHandlers.onGestureStart) {
                gestureHandlers.onGestureStart(session);
            }

            EventUtil.listen(document, EventUtil.MOVE, onMoveGesture);
            EventUtil.listen(document, EventUtil.END, onEndGesture);
            if ('ontouchstart' in window) {
                EventUtil.listen(document, "touchcancel", onEndGesture);
            }
        }

        EventUtil.listen(elem, EventUtil.START, onStartGesture);

        function destroy() {
            EventUtil.unListen(elem, EventUtil.START, onStartGesture);
        }

        return {
            onGestureStart: function(fn) {
                gestureHandlers.onGestureStart = fn;
            },
            onGestureMove: function(fn) {
                gestureHandlers.onGestureMove = fn;
            },
            onGestureEnd: function(fn) {
                gestureHandlers.onGestureEnd = fn;
            },
            destroy: function() {
                destroy();
            }
        };
    }

    exports.GestureListener = GestureListener;
    exports.GestureSession = GestureSession;
    exports.EventUtil = EventUtil;
})(window.gesture = {});
(function (exports) {
    "use strict";

    function emptyFn () {}
    function isOldVersionsOfOperaMobile() {
        return hasUserAgent("opera") && hasUserAgent("windows ce");
    }
    function isAndroidStockBrowser() {
        return hasUserAgent("android") && hasUserAgent("webkit") && !hasUserAgent("chrome");
    }

    function hasUserAgent(uaString) {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf(uaString) !== -1;
    }

    var availOrientationChange = "onorientationchange" in window && !isAndroidStockBrowser() ? true : false,
        availResize = "onresize" in window;


    /**
     * 해당 모바일 기기의 현재 Orientation 을 반환한다.
     * window.orientation가 있으면 orient체크(safari,android)
     * opera 는 client 사이즈가 고정이므로 screen 사이즈로 비교, 나머지는 client 사이즈로 비교
     * @return orient portrait/landscape
     */
    var OrientationManager = function () {
        this.init();
    };
    OrientationManager.prototype = {
        init: function () {
            this.orientList = [];
            this.state = this.getOrientation();
            this.bindEvent();
        },
        bindEvent: function () {
            var self = this;
            if (availOrientationChange || availResize) {
                var resize = availOrientationChange ? "orientationchange" : "resize";
                if (document.addEventListener) {
                    window.addEventListener(resize, function (){
                        self.onOrientationChange();
                    });
                } else {
                    window.attachEvent("on" + resize, function (){
                        self.onOrientationChange();
                    }, false);
                }
            } else {
                window.setInterval(function () {
                    self.onOrientationChange();
                }, 1000);
            }
        },
        onOrientationChange: function () {
            var currentState = this.getOrientation();
            this.state = currentState;
            this.emitOrientation(this.state);
        },
        getOrientation: function () {
            if (isOldVersionsOfOperaMobile()) {
                return function () {
                    return (window.screen.width > window.screen.height) ? "landscape" : "portrait";
                };
            } else {
                var body = document.documentElement || document.body;
                return function () {
                    return (body.clientWidth > body.clientHeight) ? "landscape" : "portrait";
                };
            }
        }(),
        emitOrientation: function (state) {
            for (var i=0, len=this.orientList.length; i<len; i+=1) {
                this.orientList[i](state);
            }
        },
        addOrientationCallback: function (callback) {
            if (typeof callback !== 'function') {
                throw new TypeError('callback is not function');
            }

            this.orientList.push(callback);
        }
    };

    var orientationManager = new OrientationManager();
    var Orientation = exports.Orientation = function () {
        this.init();
    };
    Orientation.prototype = {
        init: function () {
            this.onPortraitCallback = emptyFn;
            this.onLandscapeCallback = emptyFn;
            this.onOrientationCallback = emptyFn;
            this.bindEvent();

            return this;
        },
        bindEvent: function () {
            var self = this;
            orientationManager.addOrientationCallback(function (orientation) {
                self.updateOrientation(orientation);
            });
        },
        updateOrientation: function (orientation) {
            orientation = orientation || orientationManager.state;

            this.onOrientationCallback(orientation);
            if (orientation === "portrait") {
                this.onPortraitCallback();
            } else {
                this.onLandscapeCallback();
            }
        },
        onOrientationChange: function (fn) {
            this.onOrientationCallback = fn;
            return this;
        },
        onPortrait: function (fn) {
            this.onPortraitCallback = fn;
            return this;
        },
        onLandscape: function (fn) {
            this.onLandscapeCallback = fn;
            return this;
        }
    };
})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);

/*jshint loopfunc:true, devel:true*/

/*
 * add console facility on clay core
 */
(function (exports) {
    'use strict';

    var methods = ['log', 'debug', 'info', 'warn', 'error', 'group', 'groupEnd', 'table'],
        buffer = [];

    for (var i = 0; i < methods.length; i++) {
        exports[methods[i]] = function (method) {
            if (typeof console === 'undefined' || typeof console.log.apply === 'undefined') {
                return function () {
                    buffer.push([method, arguments]);
                };
            } else {
                var realMethod = method;
                if (!(method in console)) {
                    realMethod = 'log';
                }

                return function () {
                    var args = [],
                        namespace = exports.__CONSOLE_NAMESPACE;

                    if (namespace) {
                        args.push('[' + namespace + ']');
                    }
                    args = args.concat(Array.prototype.slice.call(arguments));

                    if (!!exports.__CONSOLE_QUIET) {
                        buffer.push([method, arguments]);
                    } else {
                        console[realMethod].apply(console, args);
                    }
                };
            }
        }(methods[i]);
    }

    exports.dumpLog = function () {
        return buffer.splice(0);
    };

    exports.replayLog = function () {
        buffer.forEach(function (call) {
            if (typeof console[call[0]] === 'object') { // opera
                console[call[0]](call[1]);
            } else {
                console[call[0]].apply(console, call[1]);
            }
        });
    };
}(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools));
(function(global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory() : typeof define === 'function' && define.amd ? define(factory) : (factory());
}(this, (function() {
    'use strict';

    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */
    function applyFocusVisiblePolyfill(scope) {
        var hadKeyboardEvent = true;
        var hadFocusVisibleRecently = false;
        var hadFocusVisibleRecentlyTimeout = null;

        var inputTypesWhitelist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            'datetime-local': true
        };

        /**
         * Helper function for legacy browsers and iframes which sometimes focus
         * elements like document, body, and non-interactive SVG.
         * @param {Element} el
         */
        function isValidFocusTarget(el) {
            if (
                el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
                return true;
            }
            return false;
        }

        /**
         * Computes whether the given element should automatically trigger the
         * `focus-visible` class being added, i.e. whether it should always match
         * `:focus-visible` when focused.
         * @param {Element} el
         * @return {boolean}
         */
        function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;

            if (tagName == 'INPUT' && inputTypesWhitelist[type] && !el.readOnly) {
                return true;
            }

            if (tagName == 'TEXTAREA' && !el.readOnly) {
                return true;
            }

            if (el.isContentEditable) {
                return true;
            }

            return false;
        }

        /**
         * Add the `focus-visible` class to the given element if it was not added by
         * the author.
         * @param {Element} el
         */
        function addFocusVisibleClass(el) {
            if (el.classList.contains('focus-visible')) {
                return;
            }
            el.classList.add('focus-visible');
            el.setAttribute('data-focus-visible-added', '');
        }

        /**
         * Remove the `focus-visible` class from the given element if it was not
         * originally added by the author.
         * @param {Element} el
         */
        function removeFocusVisibleClass(el) {
            if (!el.hasAttribute('data-focus-visible-added')) {
                return;
            }
            el.classList.remove('focus-visible');
            el.removeAttribute('data-focus-visible-added');
        }

        /**
         * If the most recent user interaction was via the keyboard;
         * and the key press did not include a meta, alt/option, or control key;
         * then the modality is keyboard. Otherwise, the modality is not keyboard.
         * Apply `focus-visible` to any current active element and keep track
         * of our keyboard modality state with `hadKeyboardEvent`.
         * @param {KeyboardEvent} e
         */
        function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) {
                return;
            }

            if (isValidFocusTarget(scope.activeElement)) {
                addFocusVisibleClass(scope.activeElement);
            }

            hadKeyboardEvent = true;
        }

        /**
         * If at any point a user clicks with a pointing device, ensure that we change
         * the modality away from keyboard.
         * This avoids the situation where a user presses a key on an already focused
         * element, and then clicks on a different element, focusing it with a
         * pointing device, while we still think we're in keyboard modality.
         * @param {Event} e
         */
        function onPointerDown(e) {
            hadKeyboardEvent = false;
        }

        /**
         * On `focus`, add the `focus-visible` class to the target if:
         * - the target received focus as a result of keyboard navigation, or
         * - the event target is an element that will likely require interaction
         *   via the keyboard (e.g. a text box)
         * @param {Event} e
         */
        function onFocus(e) {
            // Prevent IE from focusing the document or HTML element.
            if (!isValidFocusTarget(e.target)) {
                return;
            }

            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
                addFocusVisibleClass(e.target);
            }
        }

        /**
         * On `blur`, remove the `focus-visible` class from the target.
         * @param {Event} e
         */
        function onBlur(e) {
            if (!isValidFocusTarget(e.target)) {
                return;
            }

            if (
                e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
                // To detect a tab/window switch, we look for a blur event followed
                // rapidly by a visibility change.
                // If we don't see a visibility change within 100ms, it's probably a
                // regular focus change.
                hadFocusVisibleRecently = true;
                window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                    hadFocusVisibleRecently = false;
                    window.clearTimeout(hadFocusVisibleRecentlyTimeout);
                }, 100);
                removeFocusVisibleClass(e.target);
            }
        }

        /**
         * If the user changes tabs, keep track of whether or not the previously
         * focused element had .focus-visible.
         * @param {Event} e
         */
        function onVisibilityChange(e) {
            if (document.visibilityState == 'hidden') {
                // If the tab becomes active again, the browser will handle calling focus
                // on the element (Safari actually calls it twice).
                // If this tab change caused a blur on an element with focus-visible,
                // re-apply the class when the user switches back to the tab.
                if (hadFocusVisibleRecently) {
                    hadKeyboardEvent = true;
                }
                addInitialPointerMoveListeners();
            }
        }

        /**
         * Add a group of listeners to detect usage of any pointing devices.
         * These listeners will be added when the polyfill first loads, and anytime
         * the window is blurred, so that they are active when the window regains
         * focus.
         */
        function addInitialPointerMoveListeners() {
            document.addEventListener('mousemove', onInitialPointerMove);
            document.addEventListener('mousedown', onInitialPointerMove);
            document.addEventListener('mouseup', onInitialPointerMove);
            document.addEventListener('pointermove', onInitialPointerMove);
            document.addEventListener('pointerdown', onInitialPointerMove);
            document.addEventListener('pointerup', onInitialPointerMove);
            document.addEventListener('touchmove', onInitialPointerMove);
            document.addEventListener('touchstart', onInitialPointerMove);
            document.addEventListener('touchend', onInitialPointerMove);
        }

        function removeInitialPointerMoveListeners() {
            document.removeEventListener('mousemove', onInitialPointerMove);
            document.removeEventListener('mousedown', onInitialPointerMove);
            document.removeEventListener('mouseup', onInitialPointerMove);
            document.removeEventListener('pointermove', onInitialPointerMove);
            document.removeEventListener('pointerdown', onInitialPointerMove);
            document.removeEventListener('pointerup', onInitialPointerMove);
            document.removeEventListener('touchmove', onInitialPointerMove);
            document.removeEventListener('touchstart', onInitialPointerMove);
            document.removeEventListener('touchend', onInitialPointerMove);
        }

        /**
         * When the polfyill first loads, assume the user is in keyboard modality.
         * If any event is received from a pointing device (e.g. mouse, pointer,
         * touch), turn off keyboard modality.
         * This accounts for situations where focus enters the page from the URL bar.
         * @param {Event} e
         */
        function onInitialPointerMove(e) {
            // Work around a Safari quirk that fires a mousemove on <html> whenever the
            // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
                return;
            }

            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
        }

        // For some kinds of state, we are interested in changes at the global scope
        // only. For example, global pointer input, global key presses and global
        // visibility change should affect the state at every scope:
        document.addEventListener('keydown', onKeyDown, true);
        document.addEventListener('mousedown', onPointerDown, true);
        document.addEventListener('pointerdown', onPointerDown, true);
        document.addEventListener('touchstart', onPointerDown, true);
        document.addEventListener('visibilitychange', onVisibilityChange, true);

        addInitialPointerMoveListeners();

        // For focus and blur, we specifically care about state changes in the local
        // scope. This is because focus / blur events that originate from within a
        // shadow root are not re-dispatched from the host element if it was already
        // the active element in its own scope:
        scope.addEventListener('focus', onFocus, true);
        scope.addEventListener('blur', onBlur, true);

        // We detect that a node is a ShadowRoot by ensuring that it is a
        // DocumentFragment and also has a host property. This check covers native
        // implementation and polyfill implementation transparently. If we only cared
        // about the native implementation, we could just check if the scope was
        // an instance of a ShadowRoot.
        if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
            // Since a ShadowRoot is a special kind of DocumentFragment, it does not
            // have a root element to add a class to. So, we add this attribute to the
            // host element instead:
            scope.host.setAttribute('data-js-focus-visible', '');
        } else if (scope.nodeType === Node.DOCUMENT_NODE) {
            document.documentElement.classList.add('js-focus-visible');
        }
    }

    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        // Make the polyfill helper globally available. This can be used as a signal
        // to interested libraries that wish to coordinate with the polyfill for e.g.,
        // applying the polyfill to a shadow root:
        window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

        // Notify interested libraries of the polyfill's presence, in case the
        // polyfill was loaded lazily:
        var event;

        try {
            event = new CustomEvent('focus-visible-polyfill-ready');
        } catch (error) {
            // IE11 does not support using CustomEvent as a constructor directly:
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
        }

        window.dispatchEvent(event);
    }

    if (typeof document !== 'undefined') {
        // Apply the polyfill to the global document, so that no JavaScript
        // coordination is required to use the polyfill in the top-level document:
        applyFocusVisiblePolyfill(document);
    }

})));

(function () {
    if (!window.performance) {
        window.performance = {};
    }

    if (!Date.now) {
        Date.now = function () {
            return new Date().getTime();
        }
    }

    if (!window.performance.now) {
        var nowOffset = Date.now();

        if (performance.timing && performance.timing.navigationStart) {
            nowOffset = performance.timing.navigationStart
        }

        window.performance.now = function () {
            return Date.now() - nowOffset;
        }
    }
})();

(function () {
    var lastTime = 0;
    var vendors = ['webkit', 'moz','ms','o'];

    for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
        window.requestAnimationFrame = window[vendors[i]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[i]+'CancelAnimationFrame'] || window[vendors[i]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function (callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () { callback(currTime + timeToCall); },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }

    if (!window.cancelAnimationFrame) {
        window.cancelAnimationFrame = function (id) {
            clearTimeout(id);
        };
    }
}());

/* global daumtools, jshint devel: true */
(function (exports) {
    "use strict";

    exports.web2app = (function () {

        var TIMEOUT_IOS = 2 * 1000,
            TIMEOUT_ANDROID = 3 * 100,
            INTERVAL = 100,
            ua = daumtools.userAgent(),
            os = ua.os,
            intentNotSupportedBrowserList = [
                'firefox',
                'opr'
            ];

        function moveToStore (storeURL) {
            window.location.href = storeURL;
        }

        function web2app (context) {
            var willInvokeApp = (typeof context.willInvokeApp === 'function') ? context.willInvokeApp : function(){},
                onAppMissing  = (typeof context.onAppMissing === 'function')  ? context.onAppMissing  : moveToStore,
                onUnsupportedEnvironment = (typeof context.onUnsupportedEnvironment === 'function') ? context.onUnsupportedEnvironment : function(){};

            willInvokeApp();

            if (os.android) {
                if (isIntentSupportedBrowser() && context.intentURI && !context.useUrlScheme) {
                    web2appViaIntentURI(context.intentURI);
                } else if (context.storeURL) {
                    web2appViaCustomUrlSchemeForAndroid(context.urlScheme, context.storeURL, onAppMissing);
                }
            } else if (os.ios && context.storeURL) {
                web2appViaCustomUrlSchemeForIOS(context.urlScheme, context.storeURL, onAppMissing, context.universalLink);
            } else {
                setTimeout(function () {
                    onUnsupportedEnvironment();
                }, 100);
            }
        }

        // chrome 25 and later supports intent. https://developer.chrome.com/multidevice/android/intents
        function isIntentSupportedBrowser () {
            var supportsIntent = ua.browser.chrome && +(ua.browser.version.major) >= 25;
            var blackListRegexp = new RegExp(intentNotSupportedBrowserList.join('|'), "i");
            return supportsIntent && !blackListRegexp.test(ua.ua);
        }

        function web2appViaCustomUrlSchemeForAndroid (urlScheme, storeURL, fallback) {
            deferFallback(TIMEOUT_ANDROID, storeURL, fallback);
            launchAppViaHiddenIframe(urlScheme);
        }

        function deferFallback(timeout, storeURL, fallback) {
            var clickedAt = new Date().getTime();
            return setTimeout(function () {
                var now = new Date().getTime();
                if (isPageVisible() && now - clickedAt < timeout + INTERVAL) {
                    fallback(storeURL);
                }
            }, timeout);
        }

        function web2appViaIntentURI (launchURI) {
            if ( ua.browser.chrome ){
                move();
            }else{
                setTimeout(move, 100);
            }

            function move(){
                top.location.href = launchURI;
            }
        }

        function web2appViaCustomUrlSchemeForIOS (urlScheme, storeURL, fallback, universalLink) {
            var tid = deferFallback(TIMEOUT_IOS, storeURL, fallback);
            if (parseInt(ua.os.version.major, 10) < 8) {
                bindPagehideEvent(tid);
            } else {
                bindVisibilityChangeEvent(tid);
            }

            // https://developer.apple.com/library/prerelease/ios/documentation/General/Conceptual/AppSearch/UniversalLinks.html#//apple_ref/doc/uid/TP40016308-CH12
            if ( isSupportUniversalLinks() ){
                if (universalLink === undefined) {
                    universalLink = urlScheme;
                } else {
                    clearTimeout(tid);
                }
                launchAppViaChangingLocation(universalLink);
            }else{
                launchAppViaHiddenIframe(urlScheme);
            }
        }

        function bindPagehideEvent (tid) {
            window.addEventListener('pagehide', function clear () {
                if (isPageVisible()) {
                    clearTimeout(tid);
                    window.removeEventListener('pagehide', clear);
                }
            });
        }

        function bindVisibilityChangeEvent (tid) {
            document.addEventListener('visibilitychange', function clear () {
                if (isPageVisible()) {
                    clearTimeout(tid);
                    document.removeEventListener('visibilitychange', clear);
                }
            });
        }

        function isPageVisible () {
            var attrNames = ['hidden', 'webkitHidden'];
            for(var i=0, len=attrNames.length; i<len; i++) {
                if (typeof document[attrNames[i]] !== 'undefined') {
                    return !document[attrNames[i]];
                }
            }
            return true;
        }

        function launchAppViaChangingLocation (urlScheme){
            window.top.location.href = urlScheme;
        }

        function launchAppViaHiddenIframe (urlScheme) {
            setTimeout(function () {
                var iframe = createHiddenIframe('appLauncher');
                iframe.src = urlScheme;
            }, 100);
        }

        function createHiddenIframe (id) {
            var iframe = document.createElement('iframe');
            iframe.id = id;
            iframe.style.border = 'none';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.display = 'none';
            iframe.style.overflow = 'hidden';
            document.body.appendChild(iframe);
            return iframe;
        }

        function isSupportUniversalLinks(){
            return (parseInt(ua.os.version.major, 10) > 8 && ua.os.ios);
        }

        /**
         * app.을 실행하거나 / store 페이지에 연결하여 준다.
         * @function
         * @param context {object} urlScheme, intentURI, storeURL, appName, onAppMissing, onUnsupportedEnvironment, willInvokeApp
         * @example daumtools.web2app({ urlScheme : 'daumapps://open', intentURI : '', storeURL: 'itms-app://...', appName: '다음앱' });
         */
        return web2app;

    })();

})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);


/**
 @module daumtools
 **/
(function (exports) {
    'use strict';

    exports.classListAll = (function () {
        return {
            add: function (el, cname) {
                assertElement(el, cname, 'add');

                if (!el || !cname || typeof cname !== 'string') {
                    return;
                }

                for (var i = 0, len = el.length; i < len; i += 1) {
                    daumtools.classList.add(el[i], cname);
                }
            },
            remove: function (el, cname) {
                assertElement(el, cname, 'remove');

                if (!el || !cname || typeof cname !== 'string') {
                    return;
                }

                for (var i = 0, len = el.length; i < len; i += 1) {
                    daumtools.classList.remove(el[i], cname);
                }
            }
        };
    })();

    function assertElement(el, cname, method) {
        if (!el) {
            throw new Error('el is not valid, el : ' + el + ', method : ' + method + ', className : ' + cname);
        }
    }

})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);

/**
 @module daumtools
 **/
(function (exports) {
    'use strict';

    exports.dataset = function (node, attr, value) {

        var self = {
            set: function (node, attr, value) {
                node.setAttribute('data-' + attr, value);
            },
            get: function (node, attr) {
                return node.getAttribute('data-' + attr);
            }
        };

        if (arguments.length === 3) {
            return self.set(node, attr, value);
        }
        if (arguments.length === 2) {
            return self.get(node, attr);
        }

        return self;
    }

})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);
/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
    if(typeof exports === 'object' && typeof module === 'object')
        module.exports = factory();
    else if(typeof define === 'function' && define.amd)
        define([], factory);
    else if(typeof exports === 'object')
        exports["ClipboardJS"] = factory();
    else
        root["ClipboardJS"] = factory();
})(this, function() {
    return /******/ (function(modules) { // webpackBootstrap
        /******/ 	// The module cache
        /******/ 	var installedModules = {};
        /******/
        /******/ 	// The require function
        /******/ 	function __webpack_require__(moduleId) {
            /******/
            /******/ 		// Check if module is in cache
            /******/ 		if(installedModules[moduleId]) {
                /******/ 			return installedModules[moduleId].exports;
                /******/ 		}
            /******/ 		// Create a new module (and put it into the cache)
            /******/ 		var module = installedModules[moduleId] = {
                /******/ 			i: moduleId,
                /******/ 			l: false,
                /******/ 			exports: {}
                /******/ 		};
            /******/
            /******/ 		// Execute the module function
            /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ 		// Flag the module as loaded
            /******/ 		module.l = true;
            /******/
            /******/ 		// Return the exports of the module
            /******/ 		return module.exports;
            /******/ 	}
        /******/
        /******/
        /******/ 	// expose the modules object (__webpack_modules__)
        /******/ 	__webpack_require__.m = modules;
        /******/
        /******/ 	// expose the module cache
        /******/ 	__webpack_require__.c = installedModules;
        /******/
        /******/ 	// define getter function for harmony exports
        /******/ 	__webpack_require__.d = function(exports, name, getter) {
            /******/ 		if(!__webpack_require__.o(exports, name)) {
                /******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
                /******/ 		}
            /******/ 	};
        /******/
        /******/ 	// define __esModule on exports
        /******/ 	__webpack_require__.r = function(exports) {
            /******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                /******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                /******/ 		}
            /******/ 		Object.defineProperty(exports, '__esModule', { value: true });
            /******/ 	};
        /******/
        /******/ 	// create a fake namespace object
        /******/ 	// mode & 1: value is a module id, require it
        /******/ 	// mode & 2: merge all properties of value into the ns
        /******/ 	// mode & 4: return value when already ns object
        /******/ 	// mode & 8|1: behave like require
        /******/ 	__webpack_require__.t = function(value, mode) {
            /******/ 		if(mode & 1) value = __webpack_require__(value);
            /******/ 		if(mode & 8) return value;
            /******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
            /******/ 		var ns = Object.create(null);
            /******/ 		__webpack_require__.r(ns);
            /******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
            /******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
            /******/ 		return ns;
            /******/ 	};
        /******/
        /******/ 	// getDefaultExport function for compatibility with non-harmony modules
        /******/ 	__webpack_require__.n = function(module) {
            /******/ 		var getter = module && module.__esModule ?
                /******/ 			function getDefault() { return module['default']; } :
                /******/ 			function getModuleExports() { return module; };
            /******/ 		__webpack_require__.d(getter, 'a', getter);
            /******/ 		return getter;
            /******/ 	};
        /******/
        /******/ 	// Object.prototype.hasOwnProperty.call
        /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ 	// __webpack_public_path__
        /******/ 	__webpack_require__.p = "";
        /******/
        /******/
        /******/ 	// Load entry module and return exports
        /******/ 	return __webpack_require__(__webpack_require__.s = 0);
        /******/ })
    /************************************************************************/
    /******/ ([
        /* 0 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

            var _clipboardAction = __webpack_require__(1);

            var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

            var _tinyEmitter = __webpack_require__(3);

            var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

            var _goodListener = __webpack_require__(4);

            var _goodListener2 = _interopRequireDefault(_goodListener);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

            /**
             * Base class which takes one or more elements, adds event listeners to them,
             * and instantiates a new `ClipboardAction` on each click.
             */
            var Clipboard = function (_Emitter) {
                _inherits(Clipboard, _Emitter);

                /**
                 * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                 * @param {Object} options
                 */
                function Clipboard(trigger, options) {
                    _classCallCheck(this, Clipboard);

                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

                    _this.resolveOptions(options);
                    _this.listenClick(trigger);
                    return _this;
                }

                /**
                 * Defines if attributes would be resolved using internal setter functions
                 * or custom functions that were passed in the constructor.
                 * @param {Object} options
                 */


                _createClass(Clipboard, [{
                    key: 'resolveOptions',
                    value: function resolveOptions() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                        this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                        this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                        this.container = _typeof(options.container) === 'object' ? options.container : document.body;
                    }

                    /**
                     * Adds a click event listener to the passed trigger.
                     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                     */

                }, {
                    key: 'listenClick',
                    value: function listenClick(trigger) {
                        var _this2 = this;

                        this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                            return _this2.onClick(e);
                        });
                    }

                    /**
                     * Defines a new `ClipboardAction` on each click event.
                     * @param {Event} e
                     */

                }, {
                    key: 'onClick',
                    value: function onClick(e) {
                        var trigger = e.delegateTarget || e.currentTarget;

                        if (this.clipboardAction) {
                            this.clipboardAction = null;
                        }

                        this.clipboardAction = new _clipboardAction2.default({
                            action: this.action(trigger),
                            target: this.target(trigger),
                            text: this.text(trigger),
                            container: this.container,
                            trigger: trigger,
                            emitter: this
                        });
                    }

                    /**
                     * Default `action` lookup function.
                     * @param {Element} trigger
                     */

                }, {
                    key: 'defaultAction',
                    value: function defaultAction(trigger) {
                        return getAttributeValue('action', trigger);
                    }

                    /**
                     * Default `target` lookup function.
                     * @param {Element} trigger
                     */

                }, {
                    key: 'defaultTarget',
                    value: function defaultTarget(trigger) {
                        var selector = getAttributeValue('target', trigger);

                        if (selector) {
                            return document.querySelector(selector);
                        }
                    }

                    /**
                     * Returns the support of the given action, or all actions if no action is
                     * given.
                     * @param {String} [action]
                     */

                }, {
                    key: 'defaultText',


                    /**
                     * Default `text` lookup function.
                     * @param {Element} trigger
                     */
                    value: function defaultText(trigger) {
                        return getAttributeValue('text', trigger);
                    }

                    /**
                     * Destroy lifecycle.
                     */

                }, {
                    key: 'destroy',
                    value: function destroy() {
                        this.listener.destroy();

                        if (this.clipboardAction) {
                            this.clipboardAction.destroy();
                            this.clipboardAction = null;
                        }
                    }
                }], [{
                    key: 'isSupported',
                    value: function isSupported() {
                        var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                        var actions = typeof action === 'string' ? [action] : action;
                        var support = !!document.queryCommandSupported;

                        actions.forEach(function (action) {
                            support = support && !!document.queryCommandSupported(action);
                        });

                        return support;
                    }
                }]);

                return Clipboard;
            }(_tinyEmitter2.default);

            /**
             * Helper function to retrieve attribute value.
             * @param {String} suffix
             * @param {Element} element
             */


            function getAttributeValue(suffix, element) {
                var attribute = 'data-clipboard-' + suffix;

                if (!element.hasAttribute(attribute)) {
                    return;
                }

                return element.getAttribute(attribute);
            }

            module.exports = Clipboard;

            /***/ }),
        /* 1 */
        /***/ (function(module, exports, __webpack_require__) {

            "use strict";


            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

            var _select = __webpack_require__(2);

            var _select2 = _interopRequireDefault(_select);

            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

            /**
             * Inner class which performs selection from either `text` or `target`
             * properties and then executes copy or cut operations.
             */
            var ClipboardAction = function () {
                /**
                 * @param {Object} options
                 */
                function ClipboardAction(options) {
                    _classCallCheck(this, ClipboardAction);

                    this.resolveOptions(options);
                    this.initSelection();
                }

                /**
                 * Defines base properties passed from constructor.
                 * @param {Object} options
                 */


                _createClass(ClipboardAction, [{
                    key: 'resolveOptions',
                    value: function resolveOptions() {
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                        this.action = options.action;
                        this.container = options.container;
                        this.emitter = options.emitter;
                        this.target = options.target;
                        this.text = options.text;
                        this.trigger = options.trigger;

                        this.selectedText = '';
                    }

                    /**
                     * Decides which selection strategy is going to be applied based
                     * on the existence of `text` and `target` properties.
                     */

                }, {
                    key: 'initSelection',
                    value: function initSelection() {
                        if (this.text) {
                            this.selectFake();
                        } else if (this.target) {
                            this.selectTarget();
                        }
                    }

                    /**
                     * Creates a fake textarea element, sets its value from `text` property,
                     * and makes a selection on it.
                     */

                }, {
                    key: 'selectFake',
                    value: function selectFake() {
                        var _this = this;

                        var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                        this.removeFake();

                        this.fakeHandlerCallback = function () {
                            return _this.removeFake();
                        };
                        this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                        this.fakeElem = document.createElement('textarea');
                        // Prevent zooming on iOS
                        this.fakeElem.style.fontSize = '12pt';
                        // Reset box model
                        this.fakeElem.style.border = '0';
                        this.fakeElem.style.padding = '0';
                        this.fakeElem.style.margin = '0';
                        // Move element out of screen horizontally
                        this.fakeElem.style.position = 'absolute';
                        this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                        // Move element to the same position vertically
                        var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                        this.fakeElem.style.top = yPosition + 'px';

                        this.fakeElem.setAttribute('readonly', '');
                        this.fakeElem.value = this.text;

                        this.container.appendChild(this.fakeElem);

                        this.selectedText = (0, _select2.default)(this.fakeElem);
                        this.copyText();
                    }

                    /**
                     * Only removes the fake element after another click event, that way
                     * a user can hit `Ctrl+C` to copy because selection still exists.
                     */

                }, {
                    key: 'removeFake',
                    value: function removeFake() {
                        if (this.fakeHandler) {
                            this.container.removeEventListener('click', this.fakeHandlerCallback);
                            this.fakeHandler = null;
                            this.fakeHandlerCallback = null;
                        }

                        if (this.fakeElem) {
                            this.container.removeChild(this.fakeElem);
                            this.fakeElem = null;
                        }
                    }

                    /**
                     * Selects the content from element passed on `target` property.
                     */

                }, {
                    key: 'selectTarget',
                    value: function selectTarget() {
                        this.selectedText = (0, _select2.default)(this.target);
                        this.copyText();
                    }

                    /**
                     * Executes the copy operation based on the current selection.
                     */

                }, {
                    key: 'copyText',
                    value: function copyText() {
                        var succeeded = void 0;

                        try {
                            succeeded = document.execCommand(this.action);
                        } catch (err) {
                            succeeded = false;
                        }

                        this.handleResult(succeeded);
                    }

                    /**
                     * Fires an event based on the copy operation result.
                     * @param {Boolean} succeeded
                     */

                }, {
                    key: 'handleResult',
                    value: function handleResult(succeeded) {
                        this.emitter.emit(succeeded ? 'success' : 'error', {
                            action: this.action,
                            text: this.selectedText,
                            trigger: this.trigger,
                            clearSelection: this.clearSelection.bind(this)
                        });
                    }

                    /**
                     * Moves focus away from `target` and back to the trigger, removes current selection.
                     */

                }, {
                    key: 'clearSelection',
                    value: function clearSelection() {
                        if (this.trigger) {
                            this.trigger.focus();
                        }

                        window.getSelection().removeAllRanges();
                    }

                    /**
                     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
                     * @param {String} action
                     */

                }, {
                    key: 'destroy',


                    /**
                     * Destroy lifecycle.
                     */
                    value: function destroy() {
                        this.removeFake();
                    }
                }, {
                    key: 'action',
                    set: function set() {
                        var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                        this._action = action;

                        if (this._action !== 'copy' && this._action !== 'cut') {
                            throw new Error('Invalid "action" value, use either "copy" or "cut"');
                        }
                    }

                    /**
                     * Gets the `action` property.
                     * @return {String}
                     */
                    ,
                    get: function get() {
                        return this._action;
                    }

                    /**
                     * Sets the `target` property using an element
                     * that will be have its content copied.
                     * @param {Element} target
                     */

                }, {
                    key: 'target',
                    set: function set(target) {
                        if (target !== undefined) {
                            if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                                if (this.action === 'copy' && target.hasAttribute('disabled')) {
                                    throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                                }

                                if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                                    throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                                }

                                this._target = target;
                            } else {
                                throw new Error('Invalid "target" value, use a valid Element');
                            }
                        }
                    }

                    /**
                     * Gets the `target` property.
                     * @return {String|HTMLElement}
                     */
                    ,
                    get: function get() {
                        return this._target;
                    }
                }]);

                return ClipboardAction;
            }();

            module.exports = ClipboardAction;

            /***/ }),
        /* 2 */
        /***/ (function(module, exports) {

            function select(element) {
                var selectedText;

                if (element.nodeName === 'SELECT') {
                    element.focus();

                    selectedText = element.value;
                }
                else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                    var isReadOnly = element.hasAttribute('readonly');

                    if (!isReadOnly) {
                        element.setAttribute('readonly', '');
                    }

                    element.select();
                    element.setSelectionRange(0, element.value.length);

                    if (!isReadOnly) {
                        element.removeAttribute('readonly');
                    }

                    selectedText = element.value;
                }
                else {
                    if (element.hasAttribute('contenteditable')) {
                        element.focus();
                    }

                    var selection = window.getSelection();
                    var range = document.createRange();

                    range.selectNodeContents(element);
                    selection.removeAllRanges();
                    selection.addRange(range);

                    selectedText = selection.toString();
                }

                return selectedText;
            }

            module.exports = select;


            /***/ }),
        /* 3 */
        /***/ (function(module, exports) {

            function E () {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
            }

            E.prototype = {
                on: function (name, callback, ctx) {
                    var e = this.e || (this.e = {});

                    (e[name] || (e[name] = [])).push({
                        fn: callback,
                        ctx: ctx
                    });

                    return this;
                },

                once: function (name, callback, ctx) {
                    var self = this;
                    function listener () {
                        self.off(name, listener);
                        callback.apply(ctx, arguments);
                    };

                    listener._ = callback
                    return this.on(name, listener, ctx);
                },

                emit: function (name) {
                    var data = [].slice.call(arguments, 1);
                    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                    var i = 0;
                    var len = evtArr.length;

                    for (i; i < len; i++) {
                        evtArr[i].fn.apply(evtArr[i].ctx, data);
                    }

                    return this;
                },

                off: function (name, callback) {
                    var e = this.e || (this.e = {});
                    var evts = e[name];
                    var liveEvents = [];

                    if (evts && callback) {
                        for (var i = 0, len = evts.length; i < len; i++) {
                            if (evts[i].fn !== callback && evts[i].fn._ !== callback)
                                liveEvents.push(evts[i]);
                        }
                    }

                    // Remove event from queue to prevent memory leak
                    // Suggested by https://github.com/lazd
                    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

                    (liveEvents.length)
                        ? e[name] = liveEvents
                        : delete e[name];

                    return this;
                }
            };

            module.exports = E;


            /***/ }),
        /* 4 */
        /***/ (function(module, exports, __webpack_require__) {

            var is = __webpack_require__(5);
            var delegate = __webpack_require__(6);

            /**
             * Validates all params and calls the right
             * listener function based on its target type.
             *
             * @param {String|HTMLElement|HTMLCollection|NodeList} target
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listen(target, type, callback) {
                if (!target && !type && !callback) {
                    throw new Error('Missing required arguments');
                }

                if (!is.string(type)) {
                    throw new TypeError('Second argument must be a String');
                }

                if (!is.fn(callback)) {
                    throw new TypeError('Third argument must be a Function');
                }

                if (is.node(target)) {
                    return listenNode(target, type, callback);
                }
                else if (is.nodeList(target)) {
                    return listenNodeList(target, type, callback);
                }
                else if (is.string(target)) {
                    return listenSelector(target, type, callback);
                }
                else {
                    throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
                }
            }

            /**
             * Adds an event listener to a HTML element
             * and returns a remove listener function.
             *
             * @param {HTMLElement} node
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listenNode(node, type, callback) {
                node.addEventListener(type, callback);

                return {
                    destroy: function() {
                        node.removeEventListener(type, callback);
                    }
                }
            }

            /**
             * Add an event listener to a list of HTML elements
             * and returns a remove listener function.
             *
             * @param {NodeList|HTMLCollection} nodeList
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listenNodeList(nodeList, type, callback) {
                Array.prototype.forEach.call(nodeList, function(node) {
                    node.addEventListener(type, callback);
                });

                return {
                    destroy: function() {
                        Array.prototype.forEach.call(nodeList, function(node) {
                            node.removeEventListener(type, callback);
                        });
                    }
                }
            }

            /**
             * Add an event listener to a selector
             * and returns a remove listener function.
             *
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listenSelector(selector, type, callback) {
                return delegate(document.body, selector, type, callback);
            }

            module.exports = listen;


            /***/ }),
        /* 5 */
        /***/ (function(module, exports) {

            /**
             * Check if argument is a HTML element.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.node = function(value) {
                return value !== undefined
                    && value instanceof HTMLElement
                    && value.nodeType === 1;
            };

            /**
             * Check if argument is a list of HTML elements.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.nodeList = function(value) {
                var type = Object.prototype.toString.call(value);

                return value !== undefined
                    && (type === '[object NodeList]' || type === '[object HTMLCollection]')
                    && ('length' in value)
                    && (value.length === 0 || exports.node(value[0]));
            };

            /**
             * Check if argument is a string.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.string = function(value) {
                return typeof value === 'string'
                    || value instanceof String;
            };

            /**
             * Check if argument is a function.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.fn = function(value) {
                var type = Object.prototype.toString.call(value);

                return type === '[object Function]';
            };


            /***/ }),
        /* 6 */
        /***/ (function(module, exports, __webpack_require__) {

            var closest = __webpack_require__(7);

            /**
             * Delegates event to a selector.
             *
             * @param {Element} element
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @param {Boolean} useCapture
             * @return {Object}
             */
            function _delegate(element, selector, type, callback, useCapture) {
                var listenerFn = listener.apply(this, arguments);

                element.addEventListener(type, listenerFn, useCapture);

                return {
                    destroy: function() {
                        element.removeEventListener(type, listenerFn, useCapture);
                    }
                }
            }

            /**
             * Delegates event to a selector.
             *
             * @param {Element|String|Array} [elements]
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @param {Boolean} useCapture
             * @return {Object}
             */
            function delegate(elements, selector, type, callback, useCapture) {
                // Handle the regular Element usage
                if (typeof elements.addEventListener === 'function') {
                    return _delegate.apply(null, arguments);
                }

                // Handle Element-less usage, it defaults to global delegation
                if (typeof type === 'function') {
                    // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                }

                // Handle Selector-based usage
                if (typeof elements === 'string') {
                    elements = document.querySelectorAll(elements);
                }

                // Handle Array-like based usage
                return Array.prototype.map.call(elements, function (element) {
                    return _delegate(element, selector, type, callback, useCapture);
                });
            }

            /**
             * Finds closest match and invokes callback.
             *
             * @param {Element} element
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @return {Function}
             */
            function listener(element, selector, type, callback) {
                return function(e) {
                    e.delegateTarget = closest(e.target, selector);

                    if (e.delegateTarget) {
                        callback.call(element, e);
                    }
                }
            }

            module.exports = delegate;


            /***/ }),
        /* 7 */
        /***/ (function(module, exports) {

            var DOCUMENT_NODE_TYPE = 9;

            /**
             * A polyfill for Element.matches()
             */
            if (typeof Element !== 'undefined' && !Element.prototype.matches) {
                var proto = Element.prototype;

                proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
            }

            /**
             * Finds the closest parent that matches a selector.
             *
             * @param {Element} element
             * @param {String} selector
             * @return {Function}
             */
            function closest (element, selector) {
                while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
                    if (typeof element.matches === 'function' &&
                        element.matches(selector)) {
                        return element;
                    }
                    element = element.parentNode;
                }
            }

            module.exports = closest;


            /***/ })
        /******/ ]);
});

/*! GetDevicePixelRatio | Author: Tyson Matanich, 2012 | License: MIT */
(function (window) {
    window.getDevicePixelRatio = function () {
        var ratio = 1;
        // To account for zoom, change to use deviceXDPI instead of systemXDPI
        if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
            // Only allow for values > 1
            ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
        }
        else if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        }
        return ratio;
    };
})(this);

(function () {
    'use strict';

    function startLazyModuls() {
        setTimeout(function () {
            daumtools.group('event: window:ready_1');
            monet.queue.emit('window:ready_1');
            daumtools.groupEnd();
        }, 500);
        setTimeout(function () {
            daumtools.group('event: window:ready_2');
            monet.queue.emit('window:ready_2');
            daumtools.groupEnd();
        }, 1000);
    }

    monet.fireLoadEvent = function () {
        var isNotFiredLoadEvent = true;
        return function () {
            if (isNotFiredLoadEvent) {
                isNotFiredLoadEvent = false;
                monet.queue.emit('window:load');
                setTimeout(function () {
                    daumtools.group('event: window:ready');
                    monet.queue.emit('window:ready');
                    daumtools.groupEnd();

                    startLazyModuls();
                }, 25);
                daumtools.info('Now Load event fire');
            } else {
                daumtools.warn('Already Load event is fired');
            }
        };
    }();
    daumtools.event.on(window, 'load', function () {
        if(!monet.disableLoadEvent) {
            monet.fireLoadEvent();
        }
    });

    daumtools.event.on(window, 'unload', function () {
        monet.queue.emit('window:unload');
    });

    daumtools.event.on(window, 'pageshow', function (e) {
        if (e.persisted) {
            monet.queue.emit('window:restored');
        }
    });

    daumtools.event.on(window, 'pagehide', function (e) {
        if (e.persisted) {
            monet.queue.emit('window:saved');
        }
    });
}());
/*! iScroll v5.2.0-snapshot ~ (c) 2008-2017 Matteo Spinelli ~ http://cubiq.org/license */
(function(window, document, Math) {
    var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
        window.setTimeout(callback, 1000 / 60);
    };

    var utils = (function() {
        var me = {};

        var _elementStyle = document.createElement('div').style;
        var _vendor = (function() {
            var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
                transform,
                i = 0,
                l = vendors.length;

            for (; i < l; i++) {
                transform = vendors[i] + 'ransform';
                if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
            }

            return false;
        })();

        function _prefixStyle(style) {
            if (_vendor === false) return false;
            if (_vendor === '') return style;
            return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
        }

        me.getTime = Date.now || function getTime() {
            return new Date().getTime();
        };

        me.extend = function(target, obj) {
            for (var i in obj) {
                target[i] = obj[i];
            }
        };

        me.addEvent = function(el, type, fn, capture) {
            el.addEventListener(type, fn, !! capture);
        };

        me.removeEvent = function(el, type, fn, capture) {
            el.removeEventListener(type, fn, !! capture);
        };

        me.prefixPointerEvent = function(pointerEvent) {
            return window.MSPointerEvent ? 'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8) : pointerEvent;
        };

        me.momentum = function(current, start, time, lowerMargin, wrapperSize, deceleration) {
            var distance = current - start,
                speed = Math.abs(distance) / time,
                destination,
                duration;

            deceleration = deceleration === undefined ? 0.0006 : deceleration;

            destination = current + (speed * speed) / (2 * deceleration) * (distance < 0 ? -1 : 1);
            duration = speed / deceleration;

            if (destination < lowerMargin) {
                destination = wrapperSize ? lowerMargin - (wrapperSize / 2.5 * (speed / 8)) : lowerMargin;
                distance = Math.abs(destination - current);
                duration = distance / speed;
            } else if (destination > 0) {
                destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
                distance = Math.abs(current) + destination;
                duration = distance / speed;
            }

            return {
                destination: Math.round(destination),
                duration: duration
            };
        };

        var _transform = _prefixStyle('transform');

        me.extend(me, {
            hasTransform: _transform !== false,
            hasPerspective: _prefixStyle('perspective') in _elementStyle,
            hasTouch: 'ontouchstart' in window,
            hasPointer: !! (window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
            hasTransition: _prefixStyle('transition') in _elementStyle
        });

        /*
	This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	- galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
        me.isBadAndroid = (function() {
            var appVersion = window.navigator.appVersion;
            // Android browser is not a chrome browser.
            if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
                var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
                if (safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
                    return parseFloat(safariVersion[1]) < 535.19;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        })();

        me.extend(me.style = {}, {
            transform: _transform,
            transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
            transitionDuration: _prefixStyle('transitionDuration'),
            transitionDelay: _prefixStyle('transitionDelay'),
            transformOrigin: _prefixStyle('transformOrigin'),
            touchAction: _prefixStyle('touchAction')
        });

        me.hasClass = function(e, c) {
            var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
            return re.test(e.className);
        };

        me.addClass = function(e, c) {
            if (me.hasClass(e, c)) {
                return;
            }

            var newclass = e.className.split(' ');
            newclass.push(c);
            e.className = newclass.join(' ');
        };

        me.removeClass = function(e, c) {
            if (!me.hasClass(e, c)) {
                return;
            }

            var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
            e.className = e.className.replace(re, ' ');
        };

        me.offset = function(el) {
            var left = -el.offsetLeft,
                top = -el.offsetTop;

            // jshint -W084
            while (el = el.offsetParent) {
                left -= el.offsetLeft;
                top -= el.offsetTop;
            }
            // jshint +W084

            return {
                left: left,
                top: top
            };
        };

        me.preventDefaultException = function(el, exceptions) {
            for (var i in exceptions) {
                if (exceptions[i].test(el[i])) {
                    return true;
                }
            }

            return false;
        };

        me.extend(me.eventType = {}, {
            touchstart: 1,
            touchmove: 1,
            touchend: 1,

            mousedown: 2,
            mousemove: 2,
            mouseup: 2,

            pointerdown: 1,
            pointermove: 1,
            pointerup: 1,

            MSPointerDown: 3,
            MSPointerMove: 3,
            MSPointerUp: 3
        });

        me.extend(me.ease = {}, {
            quadratic: {
                style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                fn: function(k) {
                    return k * (2 - k);
                }
            },
            circular: {
                style: 'cubic-bezier(0.1, 0.57, 0.1, 1)', // Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
                fn: function(k) {
                    return Math.sqrt(1 - (--k * k));
                }
            },
            back: {
                style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                fn: function(k) {
                    var b = 4;
                    return (k = k - 1) * k * ((b + 1) * k + b) + 1;
                }
            },
            bounce: {
                style: '',
                fn: function(k) {
                    if ((k /= 1) < (1 / 2.75)) {
                        return 7.5625 * k * k;
                    } else if (k < (2 / 2.75)) {
                        return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
                    } else if (k < (2.5 / 2.75)) {
                        return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
                    } else {
                        return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
                    }
                }
            },
            elastic: {
                style: '',
                fn: function(k) {
                    var f = 0.22,
                        e = 0.4;

                    if (k === 0) {
                        return 0;
                    }
                    if (k == 1) {
                        return 1;
                    }

                    return (e * Math.pow(2, - 10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1);
                }
            }
        });

        me.tap = function(e, eventName) {
            var ev = document.createEvent('Event');
            ev.initEvent(eventName, true, true);
            ev.pageX = e.pageX;
            ev.pageY = e.pageY;
            e.target.dispatchEvent(ev);
        };

        me.click = function(e) {
            var target = e.target,
                ev;

            if (!(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName)) {
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
                // initMouseEvent is deprecated.
                ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
                ev.initEvent('click', true, true);
                ev.view = e.view || window;
                ev.detail = 1;
                ev.screenX = target.screenX || 0;
                ev.screenY = target.screenY || 0;
                ev.clientX = target.clientX || 0;
                ev.clientY = target.clientY || 0;
                ev.ctrlKey = !! e.ctrlKey;
                ev.altKey = !! e.altKey;
                ev.shiftKey = !! e.shiftKey;
                ev.metaKey = !! e.metaKey;
                ev.button = 0;
                ev.relatedTarget = null;
                ev._constructed = true;
                target.dispatchEvent(ev);
            }
        };

        me.getTouchAction = function(eventPassthrough, addPinch) {
            var touchAction = 'none';
            if (eventPassthrough === 'vertical') {
                touchAction = 'pan-y';
            } else if (eventPassthrough === 'horizontal') {
                touchAction = 'pan-x';
            }
            if (addPinch && touchAction != 'none') {
                // add pinch-zoom support if the browser supports it, but if not (eg. Chrome <55) do nothing
                touchAction += ' pinch-zoom';
            }
            return touchAction;
        };

        me.getRect = function(el) {
            if (el instanceof SVGElement) {
                var rect = el.getBoundingClientRect();
                return {
                    top: rect.top,
                    left: rect.left,
                    width: rect.width,
                    height: rect.height
                };
            } else {
                return {
                    top: el.offsetTop,
                    left: el.offsetLeft,
                    width: el.offsetWidth,
                    height: el.offsetHeight
                };
            }
        };

        return me;
    })();

    function IScroll(el, options) {
        this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
        this.scroller = this.wrapper.children[0];
        this.scrollerStyle = this.scroller.style; // cache style for better performance

        this.options = {

            resizeScrollbars: true,

            mouseWheelSpeed: 20,

            snapThreshold: 0.334,

            // INSERT POINT: OPTIONS
            disablePointer: false,
            disableTouch: utils.hasPointer || !utils.hasTouch,
            disableMouse: utils.hasPointer || utils.hasTouch,
            startX: 0,
            startY: 0,
            scrollY: true,
            directionLockThreshold: 5,
            momentum: true,

            bounce: true,
            bounceTime: 600,
            bounceEasing: '',

            preventDefault: true,
            preventDefaultException: {
                tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/
            },

            HWCompositing: true,
            useTransition: true,
            useTransform: true,
            bindToWrapper: typeof window.onmousedown === "undefined"
        };

        for (var i in options) {
            this.options[i] = options[i];
        }

        // Normalize options
        this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

        this.options.useTransition = utils.hasTransition && this.options.useTransition;
        this.options.useTransform = utils.hasTransform && this.options.useTransform;

        this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
        this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

        // If you want eventPassthrough I have to lock one of the axes
        this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
        this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

        // With eventPassthrough we also need lockDirection mechanism
        this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
        this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

        this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

        this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

        if (this.options.tap === true) {
            this.options.tap = 'tap';
        }

        // https://github.com/cubiq/iscroll/issues/1029
        if (!this.options.useTransition && !this.options.useTransform) {
            if (!(/relative|absolute/i).test(this.scrollerStyle.position)) {
                this.scrollerStyle.position = "relative";
            }
        }

        if (this.options.shrinkScrollbars == 'scale') {
            this.options.useTransition = false;
        }

        this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

        if (this.options.probeType == 3) {
            this.options.useTransition = false;
        }

        // INSERT POINT: NORMALIZATION

        // Some defaults
        this.x = 0;
        this.y = 0;
        this.directionX = 0;
        this.directionY = 0;
        this._events = {};

        // INSERT POINT: DEFAULTS

        this._init();
        this.refresh();

        this.scrollTo(this.options.startX, this.options.startY);
        this.enable();
    }

    IScroll.prototype = {
        version: '5.2.0-snapshot',

        _init: function() {
            this._initEvents();

            if (this.options.scrollbars || this.options.indicators) {
                this._initIndicators();
            }

            if (this.options.mouseWheel) {
                this._initWheel();
            }

            if (this.options.snap) {
                this._initSnap();
            }

            if (this.options.keyBindings) {
                this._initKeys();
            }

            // INSERT POINT: _init

        },

        destroy: function() {
            this._initEvents(true);
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = null;
            this._execEvent('destroy');
        },

        _transitionEnd: function(e) {
            if (e.target != this.scroller || !this.isInTransition) {
                return;
            }

            this._transitionTime();
            if (!this.resetPosition(this.options.bounceTime)) {
                this.isInTransition = false;
                this._execEvent('scrollEnd');
            }
        },

        _start: function(e) {
            // React to left mouse button only
            if (utils.eventType[e.type] != 1) {
                // for button property
                // http://unixpapa.com/js/mouse.html
                var button;
                if (!e.which) {
                    /* IE case */
                    button = (e.button < 2) ? 0 : ((e.button == 4) ? 1 : 2);
                } else {
                    /* All others */
                    button = e.button;
                }
                if (button !== 0) {
                    return;
                }
            }

            if (!this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated)) {
                return;
            }

            if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
                e.preventDefault();
            }

            var point = e.touches ? e.touches[0] : e,
                pos;

            this.initiated = utils.eventType[e.type];
            this.moved = false;
            this.distX = 0;
            this.distY = 0;
            this.directionX = 0;
            this.directionY = 0;
            this.directionLocked = 0;

            this.startTime = utils.getTime();

            if (this.options.useTransition && this.isInTransition) {
                this._transitionTime();
                this.isInTransition = false;
                pos = this.getComputedPosition();
                this._translate(Math.round(pos.x), Math.round(pos.y));
                this._execEvent('scrollEnd');
            } else if (!this.options.useTransition && this.isAnimating) {
                this.isAnimating = false;
                this._execEvent('scrollEnd');
            }

            this.startX = this.x;
            this.startY = this.y;
            this.absStartX = this.x;
            this.absStartY = this.y;
            this.pointX = point.pageX;
            this.pointY = point.pageY;

            this._execEvent('beforeScrollStart');
        },

        _move: function(e) {
            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault) { // increases performance on Android? TODO: check!
                e.preventDefault();
            }

            var point = e.touches ? e.touches[0] : e,
                deltaX = point.pageX - this.pointX,
                deltaY = point.pageY - this.pointY,
                timestamp = utils.getTime(),
                newX, newY,
                absDistX, absDistY;

            this.pointX = point.pageX;
            this.pointY = point.pageY;

            this.distX += deltaX;
            this.distY += deltaY;
            absDistX = Math.abs(this.distX);
            absDistY = Math.abs(this.distY);

            // We need to move at least 10 pixels for the scrolling to initiate
            if (timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10)) {
                return;
            }

            // If you are scrolling in one direction lock the other
            if (!this.directionLocked && !this.options.freeScroll) {
                if (absDistX > absDistY + this.options.directionLockThreshold) {
                    this.directionLocked = 'h'; // lock horizontally
                } else if (absDistY >= absDistX + this.options.directionLockThreshold) {
                    this.directionLocked = 'v'; // lock vertically
                } else {
                    this.directionLocked = 'n'; // no lock
                }
            }

            if (this.directionLocked == 'h') {
                if (this.options.eventPassthrough == 'vertical') {
                    e.preventDefault();
                } else if (this.options.eventPassthrough == 'horizontal') {
                    this.initiated = false;
                    return;
                }

                deltaY = 0;
            } else if (this.directionLocked == 'v') {
                if (this.options.eventPassthrough == 'horizontal') {
                    e.preventDefault();
                } else if (this.options.eventPassthrough == 'vertical') {
                    this.initiated = false;
                    return;
                }

                deltaX = 0;
            }

            deltaX = this.hasHorizontalScroll ? deltaX : 0;
            deltaY = this.hasVerticalScroll ? deltaY : 0;

            newX = this.x + deltaX;
            newY = this.y + deltaY;

            // Slow down if outside of the boundaries
            if (newX > 0 || newX < this.maxScrollX) {
                newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
            }
            if (newY > 0 || newY < this.maxScrollY) {
                newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
            }

            this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
            this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

            if (!this.moved) {
                this._execEvent('scrollStart');
            }

            this.moved = true;

            this._translate(newX, newY);

            /* REPLACE START: _move */
            if (timestamp - this.startTime > 300) {
                this.startTime = timestamp;
                this.startX = this.x;
                this.startY = this.y;

                if (this.options.probeType == 1) {
                    this._execEvent('scroll');
                }
            }

            if (this.options.probeType > 1) {
                this._execEvent('scroll');
            }
            /* REPLACE END: _move */

        },

        _end: function(e) {
            if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
                return;
            }

            if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
                e.preventDefault();
            }

            var point = e.changedTouches ? e.changedTouches[0] : e,
                momentumX,
                momentumY,
                duration = utils.getTime() - this.startTime,
                newX = Math.round(this.x),
                newY = Math.round(this.y),
                distanceX = Math.abs(newX - this.startX),
                distanceY = Math.abs(newY - this.startY),
                time = 0,
                easing = '';

            this.isInTransition = 0;
            this.initiated = 0;
            this.endTime = utils.getTime();

            // reset if we are outside of the boundaries
            if (this.resetPosition(this.options.bounceTime)) {
                return;
            }

            this.scrollTo(newX, newY); // ensures that the last position is rounded

            // we scrolled less than 10 pixels
            if (!this.moved) {
                if (this.options.tap) {
                    utils.tap(e, this.options.tap);
                }

                if (this.options.click) {
                    utils.click(e);
                }

                this._execEvent('scrollCancel');
                return;
            }

            if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
                this._execEvent('flick');
                return;
            }

            // start momentum animation if needed
            if (this.options.momentum && duration < 300) {
                momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : {
                    destination: newX,
                    duration: 0
                };
                momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : {
                    destination: newY,
                    duration: 0
                };
                newX = momentumX.destination;
                newY = momentumY.destination;
                time = Math.max(momentumX.duration, momentumY.duration);
                this.isInTransition = 1;
            }


            if (this.options.snap) {
                var snap = this._nearestSnap(newX, newY);
                this.currentPage = snap;
                time = this.options.snapSpeed || Math.max(
                    Math.max(
                        Math.min(Math.abs(newX - snap.x), 1000),
                        Math.min(Math.abs(newY - snap.y), 1000)), 300);
                newX = snap.x;
                newY = snap.y;

                this.directionX = 0;
                this.directionY = 0;
                easing = this.options.bounceEasing;
            }

            // INSERT POINT: _end

            if (newX != this.x || newY != this.y) {
                // change easing function when scroller goes out of the boundaries
                if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
                    easing = utils.ease.quadratic;
                }

                this.scrollTo(newX, newY, time, easing);
                return;
            }

            this._execEvent('scrollEnd');
        },

        _resize: function() {
            var that = this;

            clearTimeout(this.resizeTimeout);

            this.resizeTimeout = setTimeout(function() {
                that.refresh();
            }, this.options.resizePolling);
        },

        resetPosition: function(time) {
            var x = this.x,
                y = this.y;

            time = time || 0;

            if (!this.hasHorizontalScroll || this.x > 0) {
                x = 0;
            } else if (this.x < this.maxScrollX) {
                x = this.maxScrollX;
            }

            if (!this.hasVerticalScroll || this.y > 0) {
                y = 0;
            } else if (this.y < this.maxScrollY) {
                y = this.maxScrollY;
            }

            if (x == this.x && y == this.y) {
                return false;
            }

            this.scrollTo(x, y, time, this.options.bounceEasing);

            return true;
        },

        disable: function() {
            this.enabled = false;
        },

        enable: function() {
            this.enabled = true;
        },

        refresh: function() {
            utils.getRect(this.wrapper); // Force reflow

            this.wrapperWidth = this.wrapper.clientWidth;
            this.wrapperHeight = this.wrapper.clientHeight;

            var rect = utils.getRect(this.scroller);
            /* REPLACE START: refresh */

            this.scrollerWidth = rect.width;
            this.scrollerHeight = rect.height;

            this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
            this.maxScrollY = this.wrapperHeight - this.scrollerHeight;

            /* REPLACE END: refresh */

            this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
            this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;

            if (!this.hasHorizontalScroll) {
                this.maxScrollX = 0;
                this.scrollerWidth = this.wrapperWidth;
            }

            if (!this.hasVerticalScroll) {
                this.maxScrollY = 0;
                this.scrollerHeight = this.wrapperHeight;
            }

            this.endTime = 0;
            this.directionX = 0;
            this.directionY = 0;

            if (utils.hasPointer && !this.options.disablePointer) {
                // The wrapper should have `touchAction` property for using pointerEvent.
                this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, true);

                // case. not support 'pinch-zoom'
                // https://github.com/cubiq/iscroll/issues/1118#issuecomment-270057583
                if (!this.wrapper.style[utils.style.touchAction]) {
                    this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, false);
                }
            }
            this.wrapperOffset = utils.offset(this.wrapper);

            this._execEvent('refresh');

            this.resetPosition();

            // INSERT POINT: _refresh

        },

        on: function(type, fn) {
            if (!this._events[type]) {
                this._events[type] = [];
            }

            this._events[type].push(fn);
        },

        off: function(type, fn) {
            if (!this._events[type]) {
                return;
            }

            var index = this._events[type].indexOf(fn);

            if (index > -1) {
                this._events[type].splice(index, 1);
            }
        },

        _execEvent: function(type) {
            if (!this._events[type]) {
                return;
            }

            var i = 0,
                l = this._events[type].length;

            if (!l) {
                return;
            }

            for (; i < l; i++) {
                this._events[type][i].apply(this, [].slice.call(arguments, 1));
            }
        },

        scrollBy: function(x, y, time, easing) {
            x = this.x + x;
            y = this.y + y;
            time = time || 0;

            this.scrollTo(x, y, time, easing);
        },

        scrollTo: function(x, y, time, easing) {
            easing = easing || utils.ease.circular;

            this.isInTransition = this.options.useTransition && time > 0;
            var transitionType = this.options.useTransition && easing.style;
            if (!time || transitionType) {
                if (transitionType) {
                    this._transitionTimingFunction(easing.style);
                    this._transitionTime(time);
                }
                this._translate(x, y);
            } else {
                this._animate(x, y, time, easing.fn);
            }
        },

        scrollToElement: function(el, time, offsetX, offsetY, easing) {
            el = el.nodeType ? el : this.scroller.querySelector(el);

            if (!el) {
                return;
            }

            var pos = utils.offset(el);

            pos.left -= this.wrapperOffset.left;
            pos.top -= this.wrapperOffset.top;

            // if offsetX/Y are true we center the element to the screen
            var elRect = utils.getRect(el);
            var wrapperRect = utils.getRect(this.wrapper);
            if (offsetX === true) {
                offsetX = Math.round(elRect.width / 2 - wrapperRect.width / 2);
            }
            if (offsetY === true) {
                offsetY = Math.round(elRect.height / 2 - wrapperRect.height / 2);
            }

            pos.left -= offsetX || 0;
            pos.top -= offsetY || 0;

            pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
            pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;

            time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;

            this.scrollTo(pos.left, pos.top, time, easing);
        },

        _transitionTime: function(time) {
            if (!this.options.useTransition) {
                return;
            }
            time = time || 0;
            var durationProp = utils.style.transitionDuration;
            if (!durationProp) {
                return;
            }

            this.scrollerStyle[durationProp] = time + 'ms';

            if (!time && utils.isBadAndroid) {
                this.scrollerStyle[durationProp] = '0.0001ms';
                // remove 0.0001ms
                var self = this;
                rAF(function() {
                    if (self.scrollerStyle[durationProp] === '0.0001ms') {
                        self.scrollerStyle[durationProp] = '0s';
                    }
                });
            }


            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].transitionTime(time);
                }
            }


            // INSERT POINT: _transitionTime

        },

        _transitionTimingFunction: function(easing) {
            this.scrollerStyle[utils.style.transitionTimingFunction] = easing;


            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].transitionTimingFunction(easing);
                }
            }


            // INSERT POINT: _transitionTimingFunction

        },

        _translate: function(x, y) {
            if (this.options.useTransform) {

                /* REPLACE START: _translate */

                this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

                /* REPLACE END: _translate */

            } else {
                x = Math.round(x);
                y = Math.round(y);
                this.scrollerStyle.left = x + 'px';
                this.scrollerStyle.top = y + 'px';
            }

            this.x = x;
            this.y = y;


            if (this.indicators) {
                for (var i = this.indicators.length; i--;) {
                    this.indicators[i].updatePosition();
                }
            }


            // INSERT POINT: _translate

        },

        _initEvents: function(remove) {
            var eventType = remove ? utils.removeEvent : utils.addEvent,
                target = this.options.bindToWrapper ? this.wrapper : window;

            eventType(window, 'orientationchange', this);
            eventType(window, 'resize', this);

            if (this.options.click) {
                eventType(this.wrapper, 'click', this, true);
            }

            if (!this.options.disableMouse) {
                eventType(this.wrapper, 'mousedown', this);
                eventType(target, 'mousemove', this);
                eventType(target, 'mousecancel', this);
                eventType(target, 'mouseup', this);
            }

            if (utils.hasPointer && !this.options.disablePointer) {
                eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
                eventType(target, utils.prefixPointerEvent('pointermove'), this);
                eventType(target, utils.prefixPointerEvent('pointercancel'), this);
                eventType(target, utils.prefixPointerEvent('pointerup'), this);
            }

            if (utils.hasTouch && !this.options.disableTouch) {
                eventType(this.wrapper, 'touchstart', this);
                eventType(target, 'touchmove', this);
                eventType(target, 'touchcancel', this);
                eventType(target, 'touchend', this);
            }

            eventType(this.scroller, 'transitionend', this);
            eventType(this.scroller, 'webkitTransitionEnd', this);
            eventType(this.scroller, 'oTransitionEnd', this);
            eventType(this.scroller, 'MSTransitionEnd', this);
        },

        getComputedPosition: function() {
            var matrix = window.getComputedStyle(this.scroller, null),
                x, y;

            if (this.options.useTransform) {
                matrix = matrix[utils.style.transform].split(')')[0].split(', ');
                x = +(matrix[12] || matrix[4]);
                y = +(matrix[13] || matrix[5]);
            } else {
                x = +matrix.left.replace(/[^-\d.]/g, '');
                y = +matrix.top.replace(/[^-\d.]/g, '');
            }

            return {
                x: x,
                y: y
            };
        },
        _initIndicators: function() {
            var interactive = this.options.interactiveScrollbars,
                customStyle = typeof this.options.scrollbars != 'string',
                indicators = [],
                indicator;

            var that = this;

            this.indicators = [];

            if (this.options.scrollbars) {
                // Vertical scrollbar
                if (this.options.scrollY) {
                    indicator = {
                        el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenX: false
                    };

                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }

                // Horizontal scrollbar
                if (this.options.scrollX) {
                    indicator = {
                        el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
                        interactive: interactive,
                        defaultScrollbars: true,
                        customStyle: customStyle,
                        resize: this.options.resizeScrollbars,
                        shrink: this.options.shrinkScrollbars,
                        fade: this.options.fadeScrollbars,
                        listenY: false
                    };

                    this.wrapper.appendChild(indicator.el);
                    indicators.push(indicator);
                }
            }

            if (this.options.indicators) {
                // TODO: check concat compatibility
                indicators = indicators.concat(this.options.indicators);
            }

            for (var i = indicators.length; i--;) {
                this.indicators.push(new Indicator(this, indicators[i]));
            }

            // TODO: check if we can use array.map (wide compatibility and performance issues)
            function _indicatorsMap(fn) {
                if (that.indicators) {
                    for (var i = that.indicators.length; i--;) {
                        fn.call(that.indicators[i]);
                    }
                }
            }

            if (this.options.fadeScrollbars) {
                this.on('scrollEnd', function() {
                    _indicatorsMap(function() {
                        this.fade();
                    });
                });

                this.on('scrollCancel', function() {
                    _indicatorsMap(function() {
                        this.fade();
                    });
                });

                this.on('scrollStart', function() {
                    _indicatorsMap(function() {
                        this.fade(1);
                    });
                });

                this.on('beforeScrollStart', function() {
                    _indicatorsMap(function() {
                        this.fade(1, true);
                    });
                });
            }


            this.on('refresh', function() {
                _indicatorsMap(function() {
                    this.refresh();
                });
            });

            this.on('destroy', function() {
                _indicatorsMap(function() {
                    this.destroy();
                });

                delete this.indicators;
            });
        },

        _initWheel: function() {
            utils.addEvent(this.wrapper, 'wheel', this);
            utils.addEvent(this.wrapper, 'mousewheel', this);
            utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

            this.on('destroy', function() {
                clearTimeout(this.wheelTimeout);
                this.wheelTimeout = null;
                utils.removeEvent(this.wrapper, 'wheel', this);
                utils.removeEvent(this.wrapper, 'mousewheel', this);
                utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
            });
        },

        _wheel: function(e) {
            if (!this.enabled) {
                return;
            }

            e.preventDefault();

            var wheelDeltaX, wheelDeltaY,
                newX, newY,
                that = this;

            if (this.wheelTimeout === undefined) {
                that._execEvent('scrollStart');
            }

            // Execute the scrollEnd event after 400ms the wheel stopped scrolling
            clearTimeout(this.wheelTimeout);
            this.wheelTimeout = setTimeout(function() {
                if (!that.options.snap) {
                    that._execEvent('scrollEnd');
                }
                that.wheelTimeout = undefined;
            }, 400);

            if ('deltaX' in e) {
                if (e.deltaMode === 1) {
                    wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
                    wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
                } else {
                    wheelDeltaX = -e.deltaX;
                    wheelDeltaY = -e.deltaY;
                }
            } else if ('wheelDeltaX' in e) {
                wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
                wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
            } else if ('wheelDelta' in e) {
                wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
            } else if ('detail' in e) {
                wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
            } else {
                return;
            }

            wheelDeltaX *= this.options.invertWheelDirection;
            wheelDeltaY *= this.options.invertWheelDirection;

            if (!this.hasVerticalScroll) {
                wheelDeltaX = wheelDeltaY;
                wheelDeltaY = 0;
            }

            if (this.options.snap) {
                newX = this.currentPage.pageX;
                newY = this.currentPage.pageY;

                if (wheelDeltaX > 0) {
                    newX--;
                } else if (wheelDeltaX < 0) {
                    newX++;
                }

                if (wheelDeltaY > 0) {
                    newY--;
                } else if (wheelDeltaY < 0) {
                    newY++;
                }

                this.goToPage(newX, newY);

                return;
            }

            newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
            newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

            this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
            this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

            if (newX > 0) {
                newX = 0;
            } else if (newX < this.maxScrollX) {
                newX = this.maxScrollX;
            }

            if (newY > 0) {
                newY = 0;
            } else if (newY < this.maxScrollY) {
                newY = this.maxScrollY;
            }

            this.scrollTo(newX, newY, 0);

            if (this.options.probeType > 1) {
                this._execEvent('scroll');
            }

            // INSERT POINT: _wheel
        },

        _initSnap: function() {
            this.currentPage = {};

            if (typeof this.options.snap == 'string') {
                this.options.snap = this.scroller.querySelectorAll(this.options.snap);
            }

            this.on('refresh', function() {
                var i = 0,
                    l,
                    m = 0,
                    n,
                    cx, cy,
                    x = 0,
                    y,
                    stepX = this.options.snapStepX || this.wrapperWidth,
                    stepY = this.options.snapStepY || this.wrapperHeight,
                    el,
                    rect;

                this.pages = [];

                if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
                    return;
                }

                if (this.options.snap === true) {
                    cx = Math.round(stepX / 2);
                    cy = Math.round(stepY / 2);

                    while (x > -this.scrollerWidth) {
                        this.pages[i] = [];
                        l = 0;
                        y = 0;

                        while (y > -this.scrollerHeight) {
                            this.pages[i][l] = {
                                x: Math.max(x, this.maxScrollX),
                                y: Math.max(y, this.maxScrollY),
                                width: stepX,
                                height: stepY,
                                cx: x - cx,
                                cy: y - cy
                            };

                            y -= stepY;
                            l++;
                        }

                        x -= stepX;
                        i++;
                    }
                } else {
                    el = this.options.snap;
                    l = el.length;
                    n = -1;

                    for (; i < l; i++) {
                        rect = utils.getRect(el[i]);
                        if (i === 0 || rect.left <= utils.getRect(el[i - 1]).left) {
                            m = 0;
                            n++;
                        }

                        if (!this.pages[m]) {
                            this.pages[m] = [];
                        }

                        x = Math.max(-rect.left, this.maxScrollX);
                        y = Math.max(-rect.top, this.maxScrollY);
                        cx = x - Math.round(rect.width / 2);
                        cy = y - Math.round(rect.height / 2);

                        this.pages[m][n] = {
                            x: x,
                            y: y,
                            width: rect.width,
                            height: rect.height,
                            cx: cx,
                            cy: cy
                        };

                        if (x > this.maxScrollX) {
                            m++;
                        }
                    }
                }

                this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

                // Update snap threshold if needed
                if (this.options.snapThreshold % 1 === 0) {
                    this.snapThresholdX = this.options.snapThreshold;
                    this.snapThresholdY = this.options.snapThreshold;
                } else {
                    this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
                    this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
                }
            });

            this.on('flick', function() {
                var time = this.options.snapSpeed || Math.max(
                    Math.max(
                        Math.min(Math.abs(this.x - this.startX), 1000),
                        Math.min(Math.abs(this.y - this.startY), 1000)), 300);

                this.goToPage(
                    this.currentPage.pageX + this.directionX,
                    this.currentPage.pageY + this.directionY,
                    time);
            });
        },

        _nearestSnap: function(x, y) {
            if (!this.pages.length) {
                return {
                    x: 0,
                    y: 0,
                    pageX: 0,
                    pageY: 0
                };
            }

            var i = 0,
                l = this.pages.length,
                m = 0;

            // Check if we exceeded the snap threshold
            if (Math.abs(x - this.absStartX) < this.snapThresholdX && Math.abs(y - this.absStartY) < this.snapThresholdY) {
                return this.currentPage;
            }

            if (x > 0) {
                x = 0;
            } else if (x < this.maxScrollX) {
                x = this.maxScrollX;
            }

            if (y > 0) {
                y = 0;
            } else if (y < this.maxScrollY) {
                y = this.maxScrollY;
            }

            for (; i < l; i++) {
                if (x >= this.pages[i][0].cx) {
                    x = this.pages[i][0].x;
                    break;
                }
            }

            l = this.pages[i].length;

            for (; m < l; m++) {
                if (y >= this.pages[0][m].cy) {
                    y = this.pages[0][m].y;
                    break;
                }
            }

            if (i == this.currentPage.pageX) {
                i += this.directionX;

                if (i < 0) {
                    i = 0;
                } else if (i >= this.pages.length) {
                    i = this.pages.length - 1;
                }

                x = this.pages[i][0].x;
            }

            if (m == this.currentPage.pageY) {
                m += this.directionY;

                if (m < 0) {
                    m = 0;
                } else if (m >= this.pages[0].length) {
                    m = this.pages[0].length - 1;
                }

                y = this.pages[0][m].y;
            }

            return {
                x: x,
                y: y,
                pageX: i,
                pageY: m
            };
        },

        goToPage: function(x, y, time, easing) {
            easing = easing || this.options.bounceEasing;

            if (x >= this.pages.length) {
                x = this.pages.length - 1;
            } else if (x < 0) {
                x = 0;
            }

            if (y >= this.pages[x].length) {
                y = this.pages[x].length - 1;
            } else if (y < 0) {
                y = 0;
            }

            var posX = this.pages[x][y].x,
                posY = this.pages[x][y].y;

            time = time === undefined ? this.options.snapSpeed || Math.max(
                Math.max(
                    Math.min(Math.abs(posX - this.x), 1000),
                    Math.min(Math.abs(posY - this.y), 1000)), 300) : time;

            this.currentPage = {
                x: posX,
                y: posY,
                pageX: x,
                pageY: y
            };

            this.scrollTo(posX, posY, time, easing);
        },

        next: function(time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;

            x++;

            if (x >= this.pages.length && this.hasVerticalScroll) {
                x = 0;
                y++;
            }

            this.goToPage(x, y, time, easing);
        },

        prev: function(time, easing) {
            var x = this.currentPage.pageX,
                y = this.currentPage.pageY;

            x--;

            if (x < 0 && this.hasVerticalScroll) {
                x = 0;
                y--;
            }

            this.goToPage(x, y, time, easing);
        },

        _initKeys: function(e) {
            // default key bindings
            var keys = {
                pageUp: 33,
                pageDown: 34,
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40
            };
            var i;

            // if you give me characters I give you keycode
            if (typeof this.options.keyBindings == 'object') {
                for (i in this.options.keyBindings) {
                    if (typeof this.options.keyBindings[i] == 'string') {
                        this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
                    }
                }
            } else {
                this.options.keyBindings = {};
            }

            for (i in keys) {
                this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
            }

            utils.addEvent(window, 'keydown', this);

            this.on('destroy', function() {
                utils.removeEvent(window, 'keydown', this);
            });
        },

        _key: function(e) {
            if (!this.enabled) {
                return;
            }

            var snap = this.options.snap, // we are using this alot, better to cache it
                newX = snap ? this.currentPage.pageX : this.x,
                newY = snap ? this.currentPage.pageY : this.y,
                now = utils.getTime(),
                prevTime = this.keyTime || 0,
                acceleration = 0.250,
                pos;

            if (this.options.useTransition && this.isInTransition) {
                pos = this.getComputedPosition();

                this._translate(Math.round(pos.x), Math.round(pos.y));
                this.isInTransition = false;
            }

            this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

            switch (e.keyCode) {
                case this.options.keyBindings.pageUp:
                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
                        newX += snap ? 1 : this.wrapperWidth;
                    } else {
                        newY += snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.pageDown:
                    if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
                        newX -= snap ? 1 : this.wrapperWidth;
                    } else {
                        newY -= snap ? 1 : this.wrapperHeight;
                    }
                    break;
                case this.options.keyBindings.end:
                    newX = snap ? this.pages.length - 1 : this.maxScrollX;
                    newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
                    break;
                case this.options.keyBindings.home:
                    newX = 0;
                    newY = 0;
                    break;
                case this.options.keyBindings.left:
                    newX += snap ? -1 : 5 + this.keyAcceleration >> 0;
                    break;
                case this.options.keyBindings.up:
                    newY += snap ? 1 : 5 + this.keyAcceleration >> 0;
                    break;
                case this.options.keyBindings.right:
                    newX -= snap ? -1 : 5 + this.keyAcceleration >> 0;
                    break;
                case this.options.keyBindings.down:
                    newY -= snap ? 1 : 5 + this.keyAcceleration >> 0;
                    break;
                default:
                    return;
            }

            if (snap) {
                this.goToPage(newX, newY);
                return;
            }

            if (newX > 0) {
                newX = 0;
                this.keyAcceleration = 0;
            } else if (newX < this.maxScrollX) {
                newX = this.maxScrollX;
                this.keyAcceleration = 0;
            }

            if (newY > 0) {
                newY = 0;
                this.keyAcceleration = 0;
            } else if (newY < this.maxScrollY) {
                newY = this.maxScrollY;
                this.keyAcceleration = 0;
            }

            this.scrollTo(newX, newY, 0);

            this.keyTime = now;
        },

        _animate: function(destX, destY, duration, easingFn) {
            var that = this,
                startX = this.x,
                startY = this.y,
                startTime = utils.getTime(),
                destTime = startTime + duration;

            function step() {
                var now = utils.getTime(),
                    newX, newY,
                    easing;

                if (now >= destTime) {
                    that.isAnimating = false;
                    that._translate(destX, destY);

                    if (!that.resetPosition(that.options.bounceTime)) {
                        that._execEvent('scrollEnd');
                    }

                    return;
                }

                now = (now - startTime) / duration;
                easing = easingFn(now);
                newX = (destX - startX) * easing + startX;
                newY = (destY - startY) * easing + startY;
                that._translate(newX, newY);

                if (that.isAnimating) {
                    rAF(step);
                }

                if (that.options.probeType == 3) {
                    that._execEvent('scroll');
                }
            }

            this.isAnimating = true;
            step();
        },

        handleEvent: function(e) {
            switch (e.type) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
                case 'orientationchange':
                case 'resize':
                    this._resize();
                    break;
                case 'transitionend':
                case 'webkitTransitionEnd':
                case 'oTransitionEnd':
                case 'MSTransitionEnd':
                    this._transitionEnd(e);
                    break;
                case 'wheel':
                case 'DOMMouseScroll':
                case 'mousewheel':
                    this._wheel(e);
                    break;
                case 'keydown':
                    this._key(e);
                    break;
                case 'click':
                    if (this.enabled && !e._constructed) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    break;
            }
        }
    };

    function createDefaultScrollbar(direction, interactive, type) {
        var scrollbar = document.createElement('div'),
            indicator = document.createElement('div');

        if (type === true) {
            scrollbar.style.cssText = 'position:absolute;z-index:9999';
            indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
        }

        indicator.className = 'iScrollIndicator';

        if (direction == 'h') {
            if (type === true) {
                scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
                indicator.style.height = '100%';
            }
            scrollbar.className = 'iScrollHorizontalScrollbar';
        } else {
            if (type === true) {
                scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
                indicator.style.width = '100%';
            }
            scrollbar.className = 'iScrollVerticalScrollbar';
        }

        scrollbar.style.cssText += ';overflow:hidden';

        if (!interactive) {
            scrollbar.style.pointerEvents = 'none';
        }

        scrollbar.appendChild(indicator);

        return scrollbar;
    }

    function Indicator(scroller, options) {
        this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
        this.wrapperStyle = this.wrapper.style;
        this.indicator = this.wrapper.children[0];
        this.indicatorStyle = this.indicator.style;
        this.scroller = scroller;

        this.options = {
            listenX: true,
            listenY: true,
            interactive: false,
            resize: true,
            defaultScrollbars: false,
            shrink: false,
            fade: false,
            speedRatioX: 0,
            speedRatioY: 0
        };

        for (var i in options) {
            this.options[i] = options[i];
        }

        this.sizeRatioX = 1;
        this.sizeRatioY = 1;
        this.maxPosX = 0;
        this.maxPosY = 0;

        if (this.options.interactive) {
            if (!this.options.disableTouch) {
                utils.addEvent(this.indicator, 'touchstart', this);
                utils.addEvent(window, 'touchend', this);
            }
            if (!this.options.disablePointer) {
                utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
            }
            if (!this.options.disableMouse) {
                utils.addEvent(this.indicator, 'mousedown', this);
                utils.addEvent(window, 'mouseup', this);
            }
        }

        if (this.options.fade) {
            this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
            var durationProp = utils.style.transitionDuration;
            if (!durationProp) {
                return;
            }
            this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
            // remove 0.0001ms
            var self = this;
            if (utils.isBadAndroid) {
                rAF(function() {
                    if (self.wrapperStyle[durationProp] === '0.0001ms') {
                        self.wrapperStyle[durationProp] = '0s';
                    }
                });
            }
            this.wrapperStyle.opacity = '0';
        }
    }

    Indicator.prototype = {
        handleEvent: function(e) {
            switch (e.type) {
                case 'touchstart':
                case 'pointerdown':
                case 'MSPointerDown':
                case 'mousedown':
                    this._start(e);
                    break;
                case 'touchmove':
                case 'pointermove':
                case 'MSPointerMove':
                case 'mousemove':
                    this._move(e);
                    break;
                case 'touchend':
                case 'pointerup':
                case 'MSPointerUp':
                case 'mouseup':
                case 'touchcancel':
                case 'pointercancel':
                case 'MSPointerCancel':
                case 'mousecancel':
                    this._end(e);
                    break;
            }
        },

        destroy: function() {
            if (this.options.fadeScrollbars) {
                clearTimeout(this.fadeTimeout);
                this.fadeTimeout = null;
            }
            if (this.options.interactive) {
                utils.removeEvent(this.indicator, 'touchstart', this);
                utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
                utils.removeEvent(this.indicator, 'mousedown', this);

                utils.removeEvent(window, 'touchmove', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
                utils.removeEvent(window, 'mousemove', this);

                utils.removeEvent(window, 'touchend', this);
                utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
                utils.removeEvent(window, 'mouseup', this);
            }

            if (this.options.defaultScrollbars && this.wrapper.parentNode) {
                this.wrapper.parentNode.removeChild(this.wrapper);
            }
        },

        _start: function(e) {
            var point = e.touches ? e.touches[0] : e;

            e.preventDefault();
            e.stopPropagation();

            this.transitionTime();

            this.initiated = true;
            this.moved = false;
            this.lastPointX = point.pageX;
            this.lastPointY = point.pageY;

            this.startTime = utils.getTime();

            if (!this.options.disableTouch) {
                utils.addEvent(window, 'touchmove', this);
            }
            if (!this.options.disablePointer) {
                utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
            }
            if (!this.options.disableMouse) {
                utils.addEvent(window, 'mousemove', this);
            }

            this.scroller._execEvent('beforeScrollStart');
        },

        _move: function(e) {
            var point = e.touches ? e.touches[0] : e,
                deltaX, deltaY,
                newX, newY,
                timestamp = utils.getTime();

            if (!this.moved) {
                this.scroller._execEvent('scrollStart');
            }

            this.moved = true;

            deltaX = point.pageX - this.lastPointX;
            this.lastPointX = point.pageX;

            deltaY = point.pageY - this.lastPointY;
            this.lastPointY = point.pageY;

            newX = this.x + deltaX;
            newY = this.y + deltaY;

            this._pos(newX, newY);


            if (this.scroller.options.probeType == 1 && timestamp - this.startTime > 300) {
                this.startTime = timestamp;
                this.scroller._execEvent('scroll');
            } else if (this.scroller.options.probeType > 1) {
                this.scroller._execEvent('scroll');
            }


            // INSERT POINT: indicator._move

            e.preventDefault();
            e.stopPropagation();
        },

        _end: function(e) {
            if (!this.initiated) {
                return;
            }

            this.initiated = false;

            e.preventDefault();
            e.stopPropagation();

            utils.removeEvent(window, 'touchmove', this);
            utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
            utils.removeEvent(window, 'mousemove', this);

            if (this.scroller.options.snap) {
                var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

                var time = this.options.snapSpeed || Math.max(
                    Math.max(
                        Math.min(Math.abs(this.scroller.x - snap.x), 1000),
                        Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);

                if (this.scroller.x != snap.x || this.scroller.y != snap.y) {
                    this.scroller.directionX = 0;
                    this.scroller.directionY = 0;
                    this.scroller.currentPage = snap;
                    this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
                }
            }

            if (this.moved) {
                this.scroller._execEvent('scrollEnd');
            }
        },

        transitionTime: function(time) {
            time = time || 0;
            var durationProp = utils.style.transitionDuration;
            if (!durationProp) {
                return;
            }

            this.indicatorStyle[durationProp] = time + 'ms';

            if (!time && utils.isBadAndroid) {
                this.indicatorStyle[durationProp] = '0.0001ms';
                // remove 0.0001ms
                var self = this;
                rAF(function() {
                    if (self.indicatorStyle[durationProp] === '0.0001ms') {
                        self.indicatorStyle[durationProp] = '0s';
                    }
                });
            }
        },

        transitionTimingFunction: function(easing) {
            this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
        },

        refresh: function() {
            this.transitionTime();

            if (this.options.listenX && !this.options.listenY) {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
            } else if (this.options.listenY && !this.options.listenX) {
                this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
            } else {
                this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
            }

            if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
                utils.addClass(this.wrapper, 'iScrollBothScrollbars');
                utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

                if (this.options.defaultScrollbars && this.options.customStyle) {
                    if (this.options.listenX) {
                        this.wrapper.style.right = '8px';
                    } else {
                        this.wrapper.style.bottom = '8px';
                    }
                }
            } else {
                utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
                utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

                if (this.options.defaultScrollbars && this.options.customStyle) {
                    if (this.options.listenX) {
                        this.wrapper.style.right = '2px';
                    } else {
                        this.wrapper.style.bottom = '2px';
                    }
                }
            }

            utils.getRect(this.wrapper); // force refresh

            if (this.options.listenX) {
                this.wrapperWidth = this.wrapper.clientWidth;
                if (this.options.resize) {
                    this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
                    this.indicatorStyle.width = this.indicatorWidth + 'px';
                } else {
                    this.indicatorWidth = this.indicator.clientWidth;
                }

                this.maxPosX = this.wrapperWidth - this.indicatorWidth;

                if (this.options.shrink == 'clip') {
                    this.minBoundaryX = -this.indicatorWidth + 8;
                    this.maxBoundaryX = this.wrapperWidth - 8;
                } else {
                    this.minBoundaryX = 0;
                    this.maxBoundaryX = this.maxPosX;
                }

                this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
            }

            if (this.options.listenY) {
                this.wrapperHeight = this.wrapper.clientHeight;
                if (this.options.resize) {
                    this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
                    this.indicatorStyle.height = this.indicatorHeight + 'px';
                } else {
                    this.indicatorHeight = this.indicator.clientHeight;
                }

                this.maxPosY = this.wrapperHeight - this.indicatorHeight;

                if (this.options.shrink == 'clip') {
                    this.minBoundaryY = -this.indicatorHeight + 8;
                    this.maxBoundaryY = this.wrapperHeight - 8;
                } else {
                    this.minBoundaryY = 0;
                    this.maxBoundaryY = this.maxPosY;
                }

                this.maxPosY = this.wrapperHeight - this.indicatorHeight;
                this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
            }

            this.updatePosition();
        },

        updatePosition: function() {
            var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
                y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

            if (!this.options.ignoreBoundaries) {
                if (x < this.minBoundaryX) {
                    if (this.options.shrink == 'scale') {
                        this.width = Math.max(this.indicatorWidth + x, 8);
                        this.indicatorStyle.width = this.width + 'px';
                    }
                    x = this.minBoundaryX;
                } else if (x > this.maxBoundaryX) {
                    if (this.options.shrink == 'scale') {
                        this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
                        this.indicatorStyle.width = this.width + 'px';
                        x = this.maxPosX + this.indicatorWidth - this.width;
                    } else {
                        x = this.maxBoundaryX;
                    }
                } else if (this.options.shrink == 'scale' && this.width != this.indicatorWidth) {
                    this.width = this.indicatorWidth;
                    this.indicatorStyle.width = this.width + 'px';
                }

                if (y < this.minBoundaryY) {
                    if (this.options.shrink == 'scale') {
                        this.height = Math.max(this.indicatorHeight + y * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                    }
                    y = this.minBoundaryY;
                } else if (y > this.maxBoundaryY) {
                    if (this.options.shrink == 'scale') {
                        this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
                        this.indicatorStyle.height = this.height + 'px';
                        y = this.maxPosY + this.indicatorHeight - this.height;
                    } else {
                        y = this.maxBoundaryY;
                    }
                } else if (this.options.shrink == 'scale' && this.height != this.indicatorHeight) {
                    this.height = this.indicatorHeight;
                    this.indicatorStyle.height = this.height + 'px';
                }
            }

            this.x = x;
            this.y = y;

            if (this.scroller.options.useTransform) {
                this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
            } else {
                this.indicatorStyle.left = x + 'px';
                this.indicatorStyle.top = y + 'px';
            }
        },

        _pos: function(x, y) {
            if (x < 0) {
                x = 0;
            } else if (x > this.maxPosX) {
                x = this.maxPosX;
            }

            if (y < 0) {
                y = 0;
            } else if (y > this.maxPosY) {
                y = this.maxPosY;
            }

            x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
            y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

            this.scroller.scrollTo(x, y);
        },

        fade: function(val, hold) {
            if (hold && !this.visible) {
                return;
            }

            clearTimeout(this.fadeTimeout);
            this.fadeTimeout = null;

            var time = val ? 250 : 500,
                delay = val ? 0 : 300;

            val = val ? '1' : '0';

            this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

            this.fadeTimeout = setTimeout((function(val) {
                this.wrapperStyle.opacity = val;
                this.visible = +val;
            }).bind(this, val), delay);
        }
    };

    IScroll.utils = utils;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = IScroll;
    } else if (typeof define == 'function' && define.amd) {
        define(function() {
            return IScroll;
        });
    } else {
        window.IScroll = IScroll;
    }

})(window, document, Math);

// ProgressBar.js 1.0.1
// https://kimmobrunfeldt.github.io/progressbar.js
// License: MIT

(function(f) {
    if (typeof exports === "object" && typeof module !== "undefined") {
        module.exports = f()
    } else if (typeof define === "function" && define.amd) {
        define([], f)
    } else {
        var g;
        if (typeof window !== "undefined") {
            g = window
        } else if (typeof global !== "undefined") {
            g = global
        } else if (typeof self !== "undefined") {
            g = self
        } else {
            g = this
        }
        g.ProgressBar = f()
    }
})(function() {
    var define, module, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof require == "function" && require;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e)
                }, l, l.exports, e, t, n, r)
            }
            return n[o].exports
        }
        var i = typeof require == "function" && require;
        for (var o = 0; o < r.length; o++) s(r[o]);
        return s
    })({
        1: [function(require, module, exports) {
            /* shifty - v1.5.2 - 2016-02-10 - http://jeremyckahn.github.io/shifty */;
            (function() {
                var root = this || Function('return this')();

                /**
                 * Shifty Core
                 * By Jeremy Kahn - jeremyckahn@gmail.com
                 */

                var Tweenable = (function() {

                    'use strict';

                    // Aliases that get defined later in this function
                    var formula;

                    // CONSTANTS
                    var DEFAULT_SCHEDULE_FUNCTION;
                    var DEFAULT_EASING = 'linear';
                    var DEFAULT_DURATION = 500;
                    var UPDATE_TIME = 1000 / 60;

                    var _now = Date.now ? Date.now : function() {
                        return +new Date();
                    };

                    var now = typeof SHIFTY_DEBUG_NOW !== 'undefined' ? SHIFTY_DEBUG_NOW : _now;

                    if (typeof window !== 'undefined') {
                        // requestAnimationFrame() shim by Paul Irish (modified for Shifty)
                        // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
                        DEFAULT_SCHEDULE_FUNCTION = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || (window.mozCancelRequestAnimationFrame && window.mozRequestAnimationFrame) || setTimeout;
                    } else {
                        DEFAULT_SCHEDULE_FUNCTION = setTimeout;
                    }

                    function noop() {
                        // NOOP!
                    }

                    /**
                     * Handy shortcut for doing a for-in loop. This is not a "normal" each
                     * function, it is optimized for Shifty.  The iterator function only receives
                     * the property name, not the value.
                     * @param {Object} obj
                     * @param {Function(string)} fn
                     * @private
                     */
                    function each(obj, fn) {
                        var key;
                        for (key in obj) {
                            if (Object.hasOwnProperty.call(obj, key)) {
                                fn(key);
                            }
                        }
                    }

                    /**
                     * Perform a shallow copy of Object properties.
                     * @param {Object} targetObject The object to copy into
                     * @param {Object} srcObject The object to copy from
                     * @return {Object} A reference to the augmented `targetObj` Object
                     * @private
                     */
                    function shallowCopy(targetObj, srcObj) {
                        each(srcObj, function(prop) {
                            targetObj[prop] = srcObj[prop];
                        });

                        return targetObj;
                    }

                    /**
                     * Copies each property from src onto target, but only if the property to
                     * copy to target is undefined.
                     * @param {Object} target Missing properties in this Object are filled in
                     * @param {Object} src
                     * @private
                     */
                    function defaults(target, src) {
                        each(src, function(prop) {
                            if (typeof target[prop] === 'undefined') {
                                target[prop] = src[prop];
                            }
                        });
                    }

                    /**
                     * Calculates the interpolated tween values of an Object for a given
                     * timestamp.
                     * @param {Number} forPosition The position to compute the state for.
                     * @param {Object} currentState Current state properties.
                     * @param {Object} originalState: The original state properties the Object is
                     * tweening from.
                     * @param {Object} targetState: The destination state properties the Object
                     * is tweening to.
                     * @param {number} duration: The length of the tween in milliseconds.
                     * @param {number} timestamp: The UNIX epoch time at which the tween began.
                     * @param {Object} easing: This Object's keys must correspond to the keys in
                     * targetState.
                     * @private
                     */
                    function tweenProps(forPosition, currentState, originalState, targetState,
                                        duration, timestamp, easing) {
                        var normalizedPosition = forPosition < timestamp ? 0 : (forPosition - timestamp) / duration;


                        var prop;
                        var easingObjectProp;
                        var easingFn;
                        for (prop in currentState) {
                            if (currentState.hasOwnProperty(prop)) {
                                easingObjectProp = easing[prop];
                                easingFn = typeof easingObjectProp === 'function' ? easingObjectProp : formula[easingObjectProp];

                                currentState[prop] = tweenProp(
                                    originalState[prop],
                                    targetState[prop],
                                    easingFn,
                                    normalizedPosition);
                            }
                        }

                        return currentState;
                    }

                    /**
                     * Tweens a single property.
                     * @param {number} start The value that the tween started from.
                     * @param {number} end The value that the tween should end at.
                     * @param {Function} easingFunc The easing curve to apply to the tween.
                     * @param {number} position The normalized position (between 0.0 and 1.0) to
                     * calculate the midpoint of 'start' and 'end' against.
                     * @return {number} The tweened value.
                     * @private
                     */
                    function tweenProp(start, end, easingFunc, position) {
                        return start + (end - start) * easingFunc(position);
                    }

                    /**
                     * Applies a filter to Tweenable instance.
                     * @param {Tweenable} tweenable The `Tweenable` instance to call the filter
                     * upon.
                     * @param {String} filterName The name of the filter to apply.
                     * @private
                     */
                    function applyFilter(tweenable, filterName) {
                        var filters = Tweenable.prototype.filter;
                        var args = tweenable._filterArgs;

                        each(filters, function(name) {
                            if (typeof filters[name][filterName] !== 'undefined') {
                                filters[name][filterName].apply(tweenable, args);
                            }
                        });
                    }

                    var timeoutHandler_endTime;
                    var timeoutHandler_currentTime;
                    var timeoutHandler_isEnded;
                    var timeoutHandler_offset;
                    /**
                     * Handles the update logic for one step of a tween.
                     * @param {Tweenable} tweenable
                     * @param {number} timestamp
                     * @param {number} delay
                     * @param {number} duration
                     * @param {Object} currentState
                     * @param {Object} originalState
                     * @param {Object} targetState
                     * @param {Object} easing
                     * @param {Function(Object, *, number)} step
                     * @param {Function(Function,number)}} schedule
                     * @param {number=} opt_currentTimeOverride Needed for accurate timestamp in
                     * Tweenable#seek.
                     * @private
                     */
                    function timeoutHandler(tweenable, timestamp, delay, duration, currentState,
                                            originalState, targetState, easing, step, schedule,
                                            opt_currentTimeOverride) {

                        timeoutHandler_endTime = timestamp + delay + duration;

                        timeoutHandler_currentTime = Math.min(opt_currentTimeOverride || now(), timeoutHandler_endTime);

                        timeoutHandler_isEnded = timeoutHandler_currentTime >= timeoutHandler_endTime;

                        timeoutHandler_offset = duration - (
                            timeoutHandler_endTime - timeoutHandler_currentTime);

                        if (tweenable.isPlaying()) {
                            if (timeoutHandler_isEnded) {
                                step(targetState, tweenable._attachment, timeoutHandler_offset);
                                tweenable.stop(true);
                            } else {
                                tweenable._scheduleId = schedule(tweenable._timeoutHandler, UPDATE_TIME);

                                applyFilter(tweenable, 'beforeTween');

                                // If the animation has not yet reached the start point (e.g., there was
                                // delay that has not yet completed), just interpolate the starting
                                // position of the tween.
                                if (timeoutHandler_currentTime < (timestamp + delay)) {
                                    tweenProps(1, currentState, originalState, targetState, 1, 1, easing);
                                } else {
                                    tweenProps(timeoutHandler_currentTime, currentState, originalState,
                                        targetState, duration, timestamp + delay, easing);
                                }

                                applyFilter(tweenable, 'afterTween');

                                step(currentState, tweenable._attachment, timeoutHandler_offset);
                            }
                        }
                    }


                    /**
                     * Creates a usable easing Object from a string, a function or another easing
                     * Object.  If `easing` is an Object, then this function clones it and fills
                     * in the missing properties with `"linear"`.
                     * @param {Object.<string|Function>} fromTweenParams
                     * @param {Object|string|Function} easing
                     * @return {Object.<string|Function>}
                     * @private
                     */
                    function composeEasingObject(fromTweenParams, easing) {
                        var composedEasing = {};
                        var typeofEasing = typeof easing;

                        if (typeofEasing === 'string' || typeofEasing === 'function') {
                            each(fromTweenParams, function(prop) {
                                composedEasing[prop] = easing;
                            });
                        } else {
                            each(fromTweenParams, function(prop) {
                                if (!composedEasing[prop]) {
                                    composedEasing[prop] = easing[prop] || DEFAULT_EASING;
                                }
                            });
                        }

                        return composedEasing;
                    }

                    /**
                     * Tweenable constructor.
                     * @class Tweenable
                     * @param {Object=} opt_initialState The values that the initial tween should
                     * start at if a `from` object is not provided to `{{#crossLink
                     * "Tweenable/tween:method"}}{{/crossLink}}` or `{{#crossLink
                     * "Tweenable/setConfig:method"}}{{/crossLink}}`.
                     * @param {Object=} opt_config Configuration object to be passed to
                     * `{{#crossLink "Tweenable/setConfig:method"}}{{/crossLink}}`.
                     * @module Tweenable
                     * @constructor
                     */
                    function Tweenable(opt_initialState, opt_config) {
                        this._currentState = opt_initialState || {};
                        this._configured = false;
                        this._scheduleFunction = DEFAULT_SCHEDULE_FUNCTION;

                        // To prevent unnecessary calls to setConfig do not set default
                        // configuration here.  Only set default configuration immediately before
                        // tweening if none has been set.
                        if (typeof opt_config !== 'undefined') {
                            this.setConfig(opt_config);
                        }
                    }

                    /**
                     * Configure and start a tween.
                     * @method tween
                     * @param {Object=} opt_config Configuration object to be passed to
                     * `{{#crossLink "Tweenable/setConfig:method"}}{{/crossLink}}`.
                     * @chainable
                     */
                    Tweenable.prototype.tween = function(opt_config) {
                        if (this._isTweening) {
                            return this;
                        }

                        // Only set default config if no configuration has been set previously and
                        // none is provided now.
                        if (opt_config !== undefined || !this._configured) {
                            this.setConfig(opt_config);
                        }

                        this._timestamp = now();
                        this._start(this.get(), this._attachment);
                        return this.resume();
                    };

                    /**
                     * Configure a tween that will start at some point in the future.
                     *
                     * @method setConfig
                     * @param {Object} config The following values are valid:
                     * - __from__ (_Object=_): Starting position.  If omitted, `{{#crossLink
                     *   "Tweenable/get:method"}}get(){{/crossLink}}` is used.
                     * - __to__ (_Object=_): Ending position.
                     * - __duration__ (_number=_): How many milliseconds to animate for.
                     * - __delay__ (_delay=_): How many milliseconds to wait before starting the
                     *   tween.
                     * - __start__ (_Function(Object, *)_): Function to execute when the tween
                     *   begins.  Receives the state of the tween as the first parameter and
                     *   `attachment` as the second parameter.
                     * - __step__ (_Function(Object, *, number)_): Function to execute on every
                     *   tick.  Receives `{{#crossLink
                     *   "Tweenable/get:method"}}get(){{/crossLink}}` as the first parameter,
                     *   `attachment` as the second parameter, and the time elapsed since the
                     *   start of the tween as the third. This function is not called on the
                     *   final step of the animation, but `finish` is.
                     * - __finish__ (_Function(Object, *)_): Function to execute upon tween
                     *   completion.  Receives the state of the tween as the first parameter and
                     *   `attachment` as the second parameter.
                     * - __easing__ (_Object.<string|Function>|string|Function=_): Easing curve
                     *   name(s) or function(s) to use for the tween.
                     * - __attachment__ (_*_): Cached value that is passed to the
                     *   `step`/`start`/`finish` methods.
                     * @chainable
                     */
                    Tweenable.prototype.setConfig = function(config) {
                        config = config || {};
                        this._configured = true;

                        // Attach something to this Tweenable instance (e.g.: a DOM element, an
                        // object, a string, etc.);
                        this._attachment = config.attachment;

                        // Init the internal state
                        this._pausedAtTime = null;
                        this._scheduleId = null;
                        this._delay = config.delay || 0;
                        this._start = config.start || noop;
                        this._step = config.step || noop;
                        this._finish = config.finish || noop;
                        this._duration = config.duration || DEFAULT_DURATION;
                        this._currentState = shallowCopy({}, config.from) || this.get();
                        this._originalState = this.get();
                        this._targetState = shallowCopy({}, config.to) || this.get();

                        var self = this;
                        this._timeoutHandler = function() {
                            timeoutHandler(self,
                                self._timestamp,
                                self._delay,
                                self._duration,
                                self._currentState,
                                self._originalState,
                                self._targetState,
                                self._easing,
                                self._step,
                                self._scheduleFunction);
                        };

                        // Aliases used below
                        var currentState = this._currentState;
                        var targetState = this._targetState;

                        // Ensure that there is always something to tween to.
                        defaults(targetState, currentState);

                        this._easing = composeEasingObject(
                            currentState, config.easing || DEFAULT_EASING);

                        this._filterArgs = [currentState, this._originalState, targetState, this._easing];

                        applyFilter(this, 'tweenCreated');
                        return this;
                    };

                    /**
                     * @method get
                     * @return {Object} The current state.
                     */
                    Tweenable.prototype.get = function() {
                        return shallowCopy({}, this._currentState);
                    };

                    /**
                     * @method set
                     * @param {Object} state The current state.
                     */
                    Tweenable.prototype.set = function(state) {
                        this._currentState = state;
                    };

                    /**
                     * Pause a tween.  Paused tweens can be resumed from the point at which they
                     * were paused.  This is different from `{{#crossLink
                     * "Tweenable/stop:method"}}{{/crossLink}}`, as that method
                     * causes a tween to start over when it is resumed.
                     * @method pause
                     * @chainable
                     */
                    Tweenable.prototype.pause = function() {
                        this._pausedAtTime = now();
                        this._isPaused = true;
                        return this;
                    };

                    /**
                     * Resume a paused tween.
                     * @method resume
                     * @chainable
                     */
                    Tweenable.prototype.resume = function() {
                        if (this._isPaused) {
                            this._timestamp += now() - this._pausedAtTime;
                        }

                        this._isPaused = false;
                        this._isTweening = true;

                        this._timeoutHandler();

                        return this;
                    };

                    /**
                     * Move the state of the animation to a specific point in the tween's
                     * timeline.  If the animation is not running, this will cause the `step`
                     * handlers to be called.
                     * @method seek
                     * @param {millisecond} millisecond The millisecond of the animation to seek
                     * to.  This must not be less than `0`.
                     * @chainable
                     */
                    Tweenable.prototype.seek = function(millisecond) {
                        millisecond = Math.max(millisecond, 0);
                        var currentTime = now();

                        if ((this._timestamp + millisecond) === 0) {
                            return this;
                        }

                        this._timestamp = currentTime - millisecond;

                        if (!this.isPlaying()) {
                            this._isTweening = true;
                            this._isPaused = false;

                            // If the animation is not running, call timeoutHandler to make sure that
                            // any step handlers are run.
                            timeoutHandler(this,
                                this._timestamp,
                                this._delay,
                                this._duration,
                                this._currentState,
                                this._originalState,
                                this._targetState,
                                this._easing,
                                this._step,
                                this._scheduleFunction,
                                currentTime);

                            this.pause();
                        }

                        return this;
                    };

                    /**
                     * Stops and cancels a tween.
                     * @param {boolean=} gotoEnd If `false` or omitted, the tween just stops at
                     * its current state, and the `finish` handler is not invoked.  If `true`,
                     * the tweened object's values are instantly set to the target values, and
                     * `finish` is invoked.
                     * @method stop
                     * @chainable
                     */
                    Tweenable.prototype.stop = function(gotoEnd) {
                        this._isTweening = false;
                        this._isPaused = false;
                        this._timeoutHandler = noop;

                        (root.cancelAnimationFrame || root.webkitCancelAnimationFrame || root.oCancelAnimationFrame || root.msCancelAnimationFrame || root.mozCancelRequestAnimationFrame || root.clearTimeout)(this._scheduleId);

                        if (gotoEnd) {
                            applyFilter(this, 'beforeTween');
                            tweenProps(
                                1,
                                this._currentState,
                                this._originalState,
                                this._targetState,
                                1,
                                0,
                                this._easing);
                            applyFilter(this, 'afterTween');
                            applyFilter(this, 'afterTweenEnd');
                            this._finish.call(this, this._currentState, this._attachment);
                        }

                        return this;
                    };

                    /**
                     * @method isPlaying
                     * @return {boolean} Whether or not a tween is running.
                     */
                    Tweenable.prototype.isPlaying = function() {
                        return this._isTweening && !this._isPaused;
                    };

                    /**
                     * Set a custom schedule function.
                     *
                     * If a custom function is not set,
                     * [`requestAnimationFrame`](https://developer.mozilla.org/en-US/docs/Web/API/window.requestAnimationFrame)
                     * is used if available, otherwise
                     * [`setTimeout`](https://developer.mozilla.org/en-US/docs/Web/API/Window.setTimeout)
                     * is used.
                     * @method setScheduleFunction
                     * @param {Function(Function,number)} scheduleFunction The function to be
                     * used to schedule the next frame to be rendered.
                     */
                    Tweenable.prototype.setScheduleFunction = function(scheduleFunction) {
                        this._scheduleFunction = scheduleFunction;
                    };

                    /**
                     * `delete` all "own" properties.  Call this when the `Tweenable` instance
                     * is no longer needed to free memory.
                     * @method dispose
                     */
                    Tweenable.prototype.dispose = function() {
                        var prop;
                        for (prop in this) {
                            if (this.hasOwnProperty(prop)) {
                                delete this[prop];
                            }
                        }
                    };

                    /**
                     * Filters are used for transforming the properties of a tween at various
                     * points in a Tweenable's life cycle.  See the README for more info on this.
                     * @private
                     */
                    Tweenable.prototype.filter = {};

                    /**
                     * This object contains all of the tweens available to Shifty.  It is
                     * extensible - simply attach properties to the `Tweenable.prototype.formula`
                     * Object following the same format as `linear`.
                     *
                     * `pos` should be a normalized `number` (between 0 and 1).
                     * @property formula
                     * @type {Object(function)}
                     */
                    Tweenable.prototype.formula = {
                        linear: function(pos) {
                            return pos;
                        }
                    };

                    formula = Tweenable.prototype.formula;

                    shallowCopy(Tweenable, {
                        'now': now,
                        'each': each,
                        'tweenProps': tweenProps,
                        'tweenProp': tweenProp,
                        'applyFilter': applyFilter,
                        'shallowCopy': shallowCopy,
                        'defaults': defaults,
                        'composeEasingObject': composeEasingObject
                    });

                    // `root` is provided in the intro/outro files.

                    // A hook used for unit testing.
                    if (typeof SHIFTY_DEBUG_NOW === 'function') {
                        root.timeoutHandler = timeoutHandler;
                    }

                    // Bootstrap Tweenable appropriately for the environment.
                    if (typeof exports === 'object') {
                        // CommonJS
                        module.exports = Tweenable;
                    } else if (typeof define === 'function' && define.amd) {
                        // AMD
                        define(function() {
                            return Tweenable;
                        });
                    } else if (typeof root.Tweenable === 'undefined') {
                        // Browser: Make `Tweenable` globally accessible.
                        root.Tweenable = Tweenable;
                    }

                    return Tweenable;

                }());

                /*!
                 * All equations are adapted from Thomas Fuchs'
                 * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js).
                 *
                 * Based on Easing Equations (c) 2003 [Robert
                 * Penner](http://www.robertpenner.com/), all rights reserved. This work is
                 * [subject to terms](http://www.robertpenner.com/easing_terms_of_use.html).
                 */

                /*!
                 *  TERMS OF USE - EASING EQUATIONS
                 *  Open source under the BSD License.
                 *  Easing Equations (c) 2003 Robert Penner, all rights reserved.
                 */

                ;
                (function() {

                    Tweenable.shallowCopy(Tweenable.prototype.formula, {
                        easeInQuad: function(pos) {
                            return Math.pow(pos, 2);
                        },

                        easeOutQuad: function(pos) {
                            return -(Math.pow((pos - 1), 2) - 1);
                        },

                        easeInOutQuad: function(pos) {
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * Math.pow(pos, 2);
                            }
                            return -0.5 * ((pos -= 2) * pos - 2);
                        },

                        easeInCubic: function(pos) {
                            return Math.pow(pos, 3);
                        },

                        easeOutCubic: function(pos) {
                            return (Math.pow((pos - 1), 3) + 1);
                        },

                        easeInOutCubic: function(pos) {
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * Math.pow(pos, 3);
                            }
                            return 0.5 * (Math.pow((pos - 2), 3) + 2);
                        },

                        easeInQuart: function(pos) {
                            return Math.pow(pos, 4);
                        },

                        easeOutQuart: function(pos) {
                            return -(Math.pow((pos - 1), 4) - 1);
                        },

                        easeInOutQuart: function(pos) {
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * Math.pow(pos, 4);
                            }
                            return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
                        },

                        easeInQuint: function(pos) {
                            return Math.pow(pos, 5);
                        },

                        easeOutQuint: function(pos) {
                            return (Math.pow((pos - 1), 5) + 1);
                        },

                        easeInOutQuint: function(pos) {
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * Math.pow(pos, 5);
                            }
                            return 0.5 * (Math.pow((pos - 2), 5) + 2);
                        },

                        easeInSine: function(pos) {
                            return -Math.cos(pos * (Math.PI / 2)) + 1;
                        },

                        easeOutSine: function(pos) {
                            return Math.sin(pos * (Math.PI / 2));
                        },

                        easeInOutSine: function(pos) {
                            return (-0.5 * (Math.cos(Math.PI * pos) - 1));
                        },

                        easeInExpo: function(pos) {
                            return (pos === 0) ? 0 : Math.pow(2, 10 * (pos - 1));
                        },

                        easeOutExpo: function(pos) {
                            return (pos === 1) ? 1 : -Math.pow(2, - 10 * pos) + 1;
                        },

                        easeInOutExpo: function(pos) {
                            if (pos === 0) {
                                return 0;
                            }
                            if (pos === 1) {
                                return 1;
                            }
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * Math.pow(2, 10 * (pos - 1));
                            }
                            return 0.5 * (-Math.pow(2, - 10 * --pos) + 2);
                        },

                        easeInCirc: function(pos) {
                            return -(Math.sqrt(1 - (pos * pos)) - 1);
                        },

                        easeOutCirc: function(pos) {
                            return Math.sqrt(1 - Math.pow((pos - 1), 2));
                        },

                        easeInOutCirc: function(pos) {
                            if ((pos /= 0.5) < 1) {
                                return -0.5 * (Math.sqrt(1 - pos * pos) - 1);
                            }
                            return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
                        },

                        easeOutBounce: function(pos) {
                            if ((pos) < (1 / 2.75)) {
                                return (7.5625 * pos * pos);
                            } else if (pos < (2 / 2.75)) {
                                return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
                            } else if (pos < (2.5 / 2.75)) {
                                return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
                            } else {
                                return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
                            }
                        },

                        easeInBack: function(pos) {
                            var s = 1.70158;
                            return (pos) * pos * ((s + 1) * pos - s);
                        },

                        easeOutBack: function(pos) {
                            var s = 1.70158;
                            return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
                        },

                        easeInOutBack: function(pos) {
                            var s = 1.70158;
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s));
                            }
                            return 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
                        },

                        elastic: function(pos) {
                            // jshint maxlen:90
                            return -1 * Math.pow(4, - 8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
                        },

                        swingFromTo: function(pos) {
                            var s = 1.70158;
                            return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) : 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
                        },

                        swingFrom: function(pos) {
                            var s = 1.70158;
                            return pos * pos * ((s + 1) * pos - s);
                        },

                        swingTo: function(pos) {
                            var s = 1.70158;
                            return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
                        },

                        bounce: function(pos) {
                            if (pos < (1 / 2.75)) {
                                return (7.5625 * pos * pos);
                            } else if (pos < (2 / 2.75)) {
                                return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
                            } else if (pos < (2.5 / 2.75)) {
                                return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
                            } else {
                                return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
                            }
                        },

                        bouncePast: function(pos) {
                            if (pos < (1 / 2.75)) {
                                return (7.5625 * pos * pos);
                            } else if (pos < (2 / 2.75)) {
                                return 2 - (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
                            } else if (pos < (2.5 / 2.75)) {
                                return 2 - (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
                            } else {
                                return 2 - (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
                            }
                        },

                        easeFromTo: function(pos) {
                            if ((pos /= 0.5) < 1) {
                                return 0.5 * Math.pow(pos, 4);
                            }
                            return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
                        },

                        easeFrom: function(pos) {
                            return Math.pow(pos, 4);
                        },

                        easeTo: function(pos) {
                            return Math.pow(pos, 0.25);
                        }
                    });

                }());

                // jshint maxlen:100
                /**
                 * The Bezier magic in this file is adapted/copied almost wholesale from
                 * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/cubic-bezier.js),
                 * which was adapted from Apple code (which probably came from
                 * [here](http://opensource.apple.com/source/WebCore/WebCore-955.66/platform/graphics/UnitBezier.h)).
                 * Special thanks to Apple and Thomas Fuchs for much of this code.
                 */

                /**
                 *  Copyright (c) 2006 Apple Computer, Inc. All rights reserved.
                 *
                 *  Redistribution and use in source and binary forms, with or without
                 *  modification, are permitted provided that the following conditions are met:
                 *
                 *  1. Redistributions of source code must retain the above copyright notice,
                 *  this list of conditions and the following disclaimer.
                 *
                 *  2. Redistributions in binary form must reproduce the above copyright notice,
                 *  this list of conditions and the following disclaimer in the documentation
                 *  and/or other materials provided with the distribution.
                 *
                 *  3. Neither the name of the copyright holder(s) nor the names of any
                 *  contributors may be used to endorse or promote products derived from
                 *  this software without specific prior written permission.
                 *
                 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
                 *  AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
                 *  IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
                 *  ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
                 *  LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
                 *  CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
                 *  SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
                 *  INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
                 *  CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
                 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
                 *  POSSIBILITY OF SUCH DAMAGE.
                 */;
                (function() {
                    // port of webkit cubic bezier handling by http://www.netzgesta.de/dev/
                    function cubicBezierAtTime(t, p1x, p1y, p2x, p2y, duration) {
                        var ax = 0,
                            bx = 0,
                            cx = 0,
                            ay = 0,
                            by = 0,
                            cy = 0;

                        function sampleCurveX(t) {
                            return ((ax * t + bx) * t + cx) * t;
                        }

                        function sampleCurveY(t) {
                            return ((ay * t + by) * t + cy) * t;
                        }

                        function sampleCurveDerivativeX(t) {
                            return (3.0 * ax * t + 2.0 * bx) * t + cx;
                        }

                        function solveEpsilon(duration) {
                            return 1.0 / (200.0 * duration);
                        }

                        function solve(x, epsilon) {
                            return sampleCurveY(solveCurveX(x, epsilon));
                        }

                        function fabs(n) {
                            if (n >= 0) {
                                return n;
                            } else {
                                return 0 - n;
                            }
                        }

                        function solveCurveX(x, epsilon) {
                            var t0, t1, t2, x2, d2, i;
                            for (t2 = x, i = 0; i < 8; i++) {
                                x2 = sampleCurveX(t2) - x;
                                if (fabs(x2) < epsilon) {
                                    return t2;
                                }
                                d2 = sampleCurveDerivativeX(t2);
                                if (fabs(d2) < 1e-6) {
                                    break;
                                }
                                t2 = t2 - x2 / d2;
                            }
                            t0 = 0.0;
                            t1 = 1.0;
                            t2 = x;
                            if (t2 < t0) {
                                return t0;
                            }
                            if (t2 > t1) {
                                return t1;
                            }
                            while (t0 < t1) {
                                x2 = sampleCurveX(t2);
                                if (fabs(x2 - x) < epsilon) {
                                    return t2;
                                }
                                if (x > x2) {
                                    t0 = t2;
                                } else {
                                    t1 = t2;
                                }
                                t2 = (t1 - t0) * 0.5 + t0;
                            }
                            return t2; // Failure.
                        }
                        cx = 3.0 * p1x;
                        bx = 3.0 * (p2x - p1x) - cx;
                        ax = 1.0 - cx - bx;
                        cy = 3.0 * p1y;
                        by = 3.0 * (p2y - p1y) - cy;
                        ay = 1.0 - cy - by;
                        return solve(t, solveEpsilon(duration));
                    }
                    /**
                     *  getCubicBezierTransition(x1, y1, x2, y2) -> Function
                     *
                     *  Generates a transition easing function that is compatible
                     *  with WebKit's CSS transitions `-webkit-transition-timing-function`
                     *  CSS property.
                     *
                     *  The W3C has more information about CSS3 transition timing functions:
                     *  http://www.w3.org/TR/css3-transitions/#transition-timing-function_tag
                     *
                     *  @param {number} x1
                     *  @param {number} y1
                     *  @param {number} x2
                     *  @param {number} y2
                     *  @return {function}
                     *  @private
                     */
                    function getCubicBezierTransition(x1, y1, x2, y2) {
                        return function(pos) {
                            return cubicBezierAtTime(pos, x1, y1, x2, y2, 1);
                        };
                    }
                    // End ported code

                    /**
                     * Create a Bezier easing function and attach it to `{{#crossLink
                     * "Tweenable/formula:property"}}Tweenable#formula{{/crossLink}}`.  This
                     * function gives you total control over the easing curve.  Matthew Lein's
                     * [Ceaser](http://matthewlein.com/ceaser/) is a useful tool for visualizing
                     * the curves you can make with this function.
                     * @method setBezierFunction
                     * @param {string} name The name of the easing curve.  Overwrites the old
                     * easing function on `{{#crossLink
                     * "Tweenable/formula:property"}}Tweenable#formula{{/crossLink}}` if it
                     * exists.
                     * @param {number} x1
                     * @param {number} y1
                     * @param {number} x2
                     * @param {number} y2
                     * @return {function} The easing function that was attached to
                     * Tweenable.prototype.formula.
                     */
                    Tweenable.setBezierFunction = function(name, x1, y1, x2, y2) {
                        var cubicBezierTransition = getCubicBezierTransition(x1, y1, x2, y2);
                        cubicBezierTransition.displayName = name;
                        cubicBezierTransition.x1 = x1;
                        cubicBezierTransition.y1 = y1;
                        cubicBezierTransition.x2 = x2;
                        cubicBezierTransition.y2 = y2;

                        return Tweenable.prototype.formula[name] = cubicBezierTransition;
                    };


                    /**
                     * `delete` an easing function from `{{#crossLink
                     * "Tweenable/formula:property"}}Tweenable#formula{{/crossLink}}`.  Be
                     * careful with this method, as it `delete`s whatever easing formula matches
                     * `name` (which means you can delete standard Shifty easing functions).
                     * @method unsetBezierFunction
                     * @param {string} name The name of the easing function to delete.
                     * @return {function}
                     */
                    Tweenable.unsetBezierFunction = function(name) {
                        delete Tweenable.prototype.formula[name];
                    };

                })();

                ;
                (function() {

                    function getInterpolatedValues(
                        from, current, targetState, position, easing, delay) {
                        return Tweenable.tweenProps(
                            position, current, from, targetState, 1, delay, easing);
                    }

                    // Fake a Tweenable and patch some internals.  This approach allows us to
                    // skip uneccessary processing and object recreation, cutting down on garbage
                    // collection pauses.
                    var mockTweenable = new Tweenable();
                    mockTweenable._filterArgs = [];

                    /**
                     * Compute the midpoint of two Objects.  This method effectively calculates a
                     * specific frame of animation that `{{#crossLink
                     * "Tweenable/tween:method"}}{{/crossLink}}` does many times over the course
                     * of a full tween.
                     *
                     *     var interpolatedValues = Tweenable.interpolate({
                     *       width: '100px',
                     *       opacity: 0,
                     *       color: '#fff'
                     *     }, {
                     *       width: '200px',
                     *       opacity: 1,
                     *       color: '#000'
                     *     }, 0.5);
                     *
                     *     console.log(interpolatedValues);
                     *     // {opacity: 0.5, width: "150px", color: "rgb(127,127,127)"}
                     *
                     * @static
                     * @method interpolate
                     * @param {Object} from The starting values to tween from.
                     * @param {Object} targetState The ending values to tween to.
                     * @param {number} position The normalized position value (between `0.0` and
                     * `1.0`) to interpolate the values between `from` and `to` for.  `from`
                     * represents `0` and `to` represents `1`.
                     * @param {Object.<string|Function>|string|Function} easing The easing
                     * curve(s) to calculate the midpoint against.  You can reference any easing
                     * function attached to `Tweenable.prototype.formula`, or provide the easing
                     * function(s) directly.  If omitted, this defaults to "linear".
                     * @param {number=} opt_delay Optional delay to pad the beginning of the
                     * interpolated tween with.  This increases the range of `position` from (`0`
                     * through `1`) to (`0` through `1 + opt_delay`).  So, a delay of `0.5` would
                     * increase all valid values of `position` to numbers between `0` and `1.5`.
                     * @return {Object}
                     */
                    Tweenable.interpolate = function(
                        from, targetState, position, easing, opt_delay) {

                        var current = Tweenable.shallowCopy({}, from);
                        var delay = opt_delay || 0;
                        var easingObject = Tweenable.composeEasingObject(
                            from, easing || 'linear');

                        mockTweenable.set({});

                        // Alias and reuse the _filterArgs array instead of recreating it.
                        var filterArgs = mockTweenable._filterArgs;
                        filterArgs.length = 0;
                        filterArgs[0] = current;
                        filterArgs[1] = from;
                        filterArgs[2] = targetState;
                        filterArgs[3] = easingObject;

                        // Any defined value transformation must be applied
                        Tweenable.applyFilter(mockTweenable, 'tweenCreated');
                        Tweenable.applyFilter(mockTweenable, 'beforeTween');

                        var interpolatedValues = getInterpolatedValues(
                            from, current, targetState, position, easingObject, delay);

                        // Transform values back into their original format
                        Tweenable.applyFilter(mockTweenable, 'afterTween');

                        return interpolatedValues;
                    };

                }());

                /**
                 * This module adds string interpolation support to Shifty.
                 *
                 * The Token extension allows Shifty to tween numbers inside of strings.  Among
                 * other things, this allows you to animate CSS properties.  For example, you
                 * can do this:
                 *
                 *     var tweenable = new Tweenable();
                 *     tweenable.tween({
                 *       from: { transform: 'translateX(45px)' },
                 *       to: { transform: 'translateX(90xp)' }
                 *     });
                 *
                 * `translateX(45)` will be tweened to `translateX(90)`.  To demonstrate:
                 *
                 *     var tweenable = new Tweenable();
                 *     tweenable.tween({
                 *       from: { transform: 'translateX(45px)' },
                 *       to: { transform: 'translateX(90px)' },
                 *       step: function (state) {
                 *         console.log(state.transform);
                 *       }
                 *     });
                 *
                 * The above snippet will log something like this in the console:
                 *
                 *     translateX(60.3px)
                 *     ...
                 *     translateX(76.05px)
                 *     ...
                 *     translateX(90px)
                 *
                 * Another use for this is animating colors:
                 *
                 *     var tweenable = new Tweenable();
                 *     tweenable.tween({
                 *       from: { color: 'rgb(0,255,0)' },
                 *       to: { color: 'rgb(255,0,255)' },
                 *       step: function (state) {
                 *         console.log(state.color);
                 *       }
                 *     });
                 *
                 * The above snippet will log something like this:
                 *
                 *     rgb(84,170,84)
                 *     ...
                 *     rgb(170,84,170)
                 *     ...
                 *     rgb(255,0,255)
                 *
                 * This extension also supports hexadecimal colors, in both long (`#ff00ff`)
                 * and short (`#f0f`) forms.  Be aware that hexadecimal input values will be
                 * converted into the equivalent RGB output values.  This is done to optimize
                 * for performance.
                 *
                 *     var tweenable = new Tweenable();
                 *     tweenable.tween({
                 *       from: { color: '#0f0' },
                 *       to: { color: '#f0f' },
                 *       step: function (state) {
                 *         console.log(state.color);
                 *       }
                 *     });
                 *
                 * This snippet will generate the same output as the one before it because
                 * equivalent values were supplied (just in hexadecimal form rather than RGB):
                 *
                 *     rgb(84,170,84)
                 *     ...
                 *     rgb(170,84,170)
                 *     ...
                 *     rgb(255,0,255)
                 *
                 * ## Easing support
                 *
                 * Easing works somewhat differently in the Token extension.  This is because
                 * some CSS properties have multiple values in them, and you might need to
                 * tween each value along its own easing curve.  A basic example:
                 *
                 *     var tweenable = new Tweenable();
                 *     tweenable.tween({
                 *       from: { transform: 'translateX(0px) translateY(0px)' },
                 *       to: { transform:   'translateX(100px) translateY(100px)' },
                 *       easing: { transform: 'easeInQuad' },
                 *       step: function (state) {
                 *         console.log(state.transform);
                 *       }
                 *     });
                 *
                 * The above snippet will create values like this:
                 *
                 *     translateX(11.56px) translateY(11.56px)
                 *     ...
                 *     translateX(46.24px) translateY(46.24px)
                 *     ...
                 *     translateX(100px) translateY(100px)
                 *
                 * In this case, the values for `translateX` and `translateY` are always the
                 * same for each step of the tween, because they have the same start and end
                 * points and both use the same easing curve.  We can also tween `translateX`
                 * and `translateY` along independent curves:
                 *
                 *     var tweenable = new Tweenable();
                 *     tweenable.tween({
                 *       from: { transform: 'translateX(0px) translateY(0px)' },
                 *       to: { transform:   'translateX(100px) translateY(100px)' },
                 *       easing: { transform: 'easeInQuad bounce' },
                 *       step: function (state) {
                 *         console.log(state.transform);
                 *       }
                 *     });
                 *
                 * The above snippet will create values like this:
                 *
                 *     translateX(10.89px) translateY(82.35px)
                 *     ...
                 *     translateX(44.89px) translateY(86.73px)
                 *     ...
                 *     translateX(100px) translateY(100px)
                 *
                 * `translateX` and `translateY` are not in sync anymore, because `easeInQuad`
                 * was specified for `translateX` and `bounce` for `translateY`.  Mixing and
                 * matching easing curves can make for some interesting motion in your
                 * animations.
                 *
                 * The order of the space-separated easing curves correspond the token values
                 * they apply to.  If there are more token values than easing curves listed,
                 * the last easing curve listed is used.
                 * @submodule Tweenable.token
                 */

                // token function is defined above only so that dox-foundation sees it as
                // documentation and renders it.  It is never used, and is optimized away at
                // build time.

                ;
                (function(Tweenable) {

                    /**
                     * @typedef {{
                     *   formatString: string
                     *   chunkNames: Array.<string>
                     * }}
                     * @private
                     */
                    var formatManifest;

                    // CONSTANTS

                    var R_NUMBER_COMPONENT = /(\d|\-|\.)/;
                    var R_FORMAT_CHUNKS = /([^\-0-9\.]+)/g;
                    var R_UNFORMATTED_VALUES = /[0-9.\-]+/g;
                    var R_RGB = new RegExp('rgb\\(' + R_UNFORMATTED_VALUES.source + (/,\s*/.source) + R_UNFORMATTED_VALUES.source + (/,\s*/.source) + R_UNFORMATTED_VALUES.source + '\\)', 'g');
                    var R_RGB_PREFIX = /^.*\(/;
                    var R_HEX = /#([0-9]|[a-f]){3,6}/gi;
                    var VALUE_PLACEHOLDER = 'VAL';

                    // HELPERS

                    /**
                     * @param {Array.number} rawValues
                     * @param {string} prefix
                     *
                     * @return {Array.<string>}
                     * @private
                     */
                    function getFormatChunksFrom(rawValues, prefix) {
                        var accumulator = [];

                        var rawValuesLength = rawValues.length;
                        var i;

                        for (i = 0; i < rawValuesLength; i++) {
                            accumulator.push('_' + prefix + '_' + i);
                        }

                        return accumulator;
                    }

                    /**
                     * @param {string} formattedString
                     *
                     * @return {string}
                     * @private
                     */
                    function getFormatStringFrom(formattedString) {
                        var chunks = formattedString.match(R_FORMAT_CHUNKS);

                        if (!chunks) {
                            // chunks will be null if there were no tokens to parse in
                            // formattedString (for example, if formattedString is '2').  Coerce
                            // chunks to be useful here.
                            chunks = ['', ''];

                            // If there is only one chunk, assume that the string is a number
                            // followed by a token...
                            // NOTE: This may be an unwise assumption.
                        } else if (chunks.length === 1 ||
                                // ...or if the string starts with a number component (".", "-", or a
                                // digit)...
                            formattedString[0].match(R_NUMBER_COMPONENT)) {
                            // ...prepend an empty string here to make sure that the formatted number
                            // is properly replaced by VALUE_PLACEHOLDER
                            chunks.unshift('');
                        }

                        return chunks.join(VALUE_PLACEHOLDER);
                    }

                    /**
                     * Convert all hex color values within a string to an rgb string.
                     *
                     * @param {Object} stateObject
                     *
                     * @return {Object} The modified obj
                     * @private
                     */
                    function sanitizeObjectForHexProps(stateObject) {
                        Tweenable.each(stateObject, function(prop) {
                            var currentProp = stateObject[prop];

                            if (typeof currentProp === 'string' && currentProp.match(R_HEX)) {
                                stateObject[prop] = sanitizeHexChunksToRGB(currentProp);
                            }
                        });
                    }

                    /**
                     * @param {string} str
                     *
                     * @return {string}
                     * @private
                     */
                    function sanitizeHexChunksToRGB(str) {
                        return filterStringChunks(R_HEX, str, convertHexToRGB);
                    }

                    /**
                     * @param {string} hexString
                     *
                     * @return {string}
                     * @private
                     */
                    function convertHexToRGB(hexString) {
                        var rgbArr = hexToRGBArray(hexString);
                        return 'rgb(' + rgbArr[0] + ',' + rgbArr[1] + ',' + rgbArr[2] + ')';
                    }

                    var hexToRGBArray_returnArray = [];
                    /**
                     * Convert a hexadecimal string to an array with three items, one each for
                     * the red, blue, and green decimal values.
                     *
                     * @param {string} hex A hexadecimal string.
                     *
                     * @returns {Array.<number>} The converted Array of RGB values if `hex` is a
                     * valid string, or an Array of three 0's.
                     * @private
                     */
                    function hexToRGBArray(hex) {

                        hex = hex.replace(/#/, '');

                        // If the string is a shorthand three digit hex notation, normalize it to
                        // the standard six digit notation
                        if (hex.length === 3) {
                            hex = hex.split('');
                            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                        }

                        hexToRGBArray_returnArray[0] = hexToDec(hex.substr(0, 2));
                        hexToRGBArray_returnArray[1] = hexToDec(hex.substr(2, 2));
                        hexToRGBArray_returnArray[2] = hexToDec(hex.substr(4, 2));

                        return hexToRGBArray_returnArray;
                    }

                    /**
                     * Convert a base-16 number to base-10.
                     *
                     * @param {Number|String} hex The value to convert
                     *
                     * @returns {Number} The base-10 equivalent of `hex`.
                     * @private
                     */
                    function hexToDec(hex) {
                        return parseInt(hex, 16);
                    }

                    /**
                     * Runs a filter operation on all chunks of a string that match a RegExp
                     *
                     * @param {RegExp} pattern
                     * @param {string} unfilteredString
                     * @param {function(string)} filter
                     *
                     * @return {string}
                     * @private
                     */
                    function filterStringChunks(pattern, unfilteredString, filter) {
                        var pattenMatches = unfilteredString.match(pattern);
                        var filteredString = unfilteredString.replace(pattern, VALUE_PLACEHOLDER);

                        if (pattenMatches) {
                            var pattenMatchesLength = pattenMatches.length;
                            var currentChunk;

                            for (var i = 0; i < pattenMatchesLength; i++) {
                                currentChunk = pattenMatches.shift();
                                filteredString = filteredString.replace(
                                    VALUE_PLACEHOLDER, filter(currentChunk));
                            }
                        }

                        return filteredString;
                    }

                    /**
                     * Check for floating point values within rgb strings and rounds them.
                     *
                     * @param {string} formattedString
                     *
                     * @return {string}
                     * @private
                     */
                    function sanitizeRGBChunks(formattedString) {
                        return filterStringChunks(R_RGB, formattedString, sanitizeRGBChunk);
                    }

                    /**
                     * @param {string} rgbChunk
                     *
                     * @return {string}
                     * @private
                     */
                    function sanitizeRGBChunk(rgbChunk) {
                        var numbers = rgbChunk.match(R_UNFORMATTED_VALUES);
                        var numbersLength = numbers.length;
                        var sanitizedString = rgbChunk.match(R_RGB_PREFIX)[0];

                        for (var i = 0; i < numbersLength; i++) {
                            sanitizedString += parseInt(numbers[i], 10) + ',';
                        }

                        sanitizedString = sanitizedString.slice(0, - 1) + ')';

                        return sanitizedString;
                    }

                    /**
                     * @param {Object} stateObject
                     *
                     * @return {Object} An Object of formatManifests that correspond to
                     * the string properties of stateObject
                     * @private
                     */
                    function getFormatManifests(stateObject) {
                        var manifestAccumulator = {};

                        Tweenable.each(stateObject, function(prop) {
                            var currentProp = stateObject[prop];

                            if (typeof currentProp === 'string') {
                                var rawValues = getValuesFrom(currentProp);

                                manifestAccumulator[prop] = {
                                    'formatString': getFormatStringFrom(currentProp),
                                    'chunkNames': getFormatChunksFrom(rawValues, prop)
                                };
                            }
                        });

                        return manifestAccumulator;
                    }

                    /**
                     * @param {Object} stateObject
                     * @param {Object} formatManifests
                     * @private
                     */
                    function expandFormattedProperties(stateObject, formatManifests) {
                        Tweenable.each(formatManifests, function(prop) {
                            var currentProp = stateObject[prop];
                            var rawValues = getValuesFrom(currentProp);
                            var rawValuesLength = rawValues.length;

                            for (var i = 0; i < rawValuesLength; i++) {
                                stateObject[formatManifests[prop].chunkNames[i]] = +rawValues[i];
                            }

                            delete stateObject[prop];
                        });
                    }

                    /**
                     * @param {Object} stateObject
                     * @param {Object} formatManifests
                     * @private
                     */
                    function collapseFormattedProperties(stateObject, formatManifests) {
                        Tweenable.each(formatManifests, function(prop) {
                            var currentProp = stateObject[prop];
                            var formatChunks = extractPropertyChunks(
                                stateObject, formatManifests[prop].chunkNames);
                            var valuesList = getValuesList(
                                formatChunks, formatManifests[prop].chunkNames);
                            currentProp = getFormattedValues(
                                formatManifests[prop].formatString, valuesList);
                            stateObject[prop] = sanitizeRGBChunks(currentProp);
                        });
                    }

                    /**
                     * @param {Object} stateObject
                     * @param {Array.<string>} chunkNames
                     *
                     * @return {Object} The extracted value chunks.
                     * @private
                     */
                    function extractPropertyChunks(stateObject, chunkNames) {
                        var extractedValues = {};
                        var currentChunkName, chunkNamesLength = chunkNames.length;

                        for (var i = 0; i < chunkNamesLength; i++) {
                            currentChunkName = chunkNames[i];
                            extractedValues[currentChunkName] = stateObject[currentChunkName];
                            delete stateObject[currentChunkName];
                        }

                        return extractedValues;
                    }

                    var getValuesList_accumulator = [];
                    /**
                     * @param {Object} stateObject
                     * @param {Array.<string>} chunkNames
                     *
                     * @return {Array.<number>}
                     * @private
                     */
                    function getValuesList(stateObject, chunkNames) {
                        getValuesList_accumulator.length = 0;
                        var chunkNamesLength = chunkNames.length;

                        for (var i = 0; i < chunkNamesLength; i++) {
                            getValuesList_accumulator.push(stateObject[chunkNames[i]]);
                        }

                        return getValuesList_accumulator;
                    }

                    /**
                     * @param {string} formatString
                     * @param {Array.<number>} rawValues
                     *
                     * @return {string}
                     * @private
                     */
                    function getFormattedValues(formatString, rawValues) {
                        var formattedValueString = formatString;
                        var rawValuesLength = rawValues.length;

                        for (var i = 0; i < rawValuesLength; i++) {
                            formattedValueString = formattedValueString.replace(
                                VALUE_PLACEHOLDER, + rawValues[i].toFixed(4));
                        }

                        return formattedValueString;
                    }

                    /**
                     * Note: It's the duty of the caller to convert the Array elements of the
                     * return value into numbers.  This is a performance optimization.
                     *
                     * @param {string} formattedString
                     *
                     * @return {Array.<string>|null}
                     * @private
                     */
                    function getValuesFrom(formattedString) {
                        return formattedString.match(R_UNFORMATTED_VALUES);
                    }

                    /**
                     * @param {Object} easingObject
                     * @param {Object} tokenData
                     * @private
                     */
                    function expandEasingObject(easingObject, tokenData) {
                        Tweenable.each(tokenData, function(prop) {
                            var currentProp = tokenData[prop];
                            var chunkNames = currentProp.chunkNames;
                            var chunkLength = chunkNames.length;

                            var easing = easingObject[prop];
                            var i;

                            if (typeof easing === 'string') {
                                var easingChunks = easing.split(' ');
                                var lastEasingChunk = easingChunks[easingChunks.length - 1];

                                for (i = 0; i < chunkLength; i++) {
                                    easingObject[chunkNames[i]] = easingChunks[i] || lastEasingChunk;
                                }

                            } else {
                                for (i = 0; i < chunkLength; i++) {
                                    easingObject[chunkNames[i]] = easing;
                                }
                            }

                            delete easingObject[prop];
                        });
                    }

                    /**
                     * @param {Object} easingObject
                     * @param {Object} tokenData
                     * @private
                     */
                    function collapseEasingObject(easingObject, tokenData) {
                        Tweenable.each(tokenData, function(prop) {
                            var currentProp = tokenData[prop];
                            var chunkNames = currentProp.chunkNames;
                            var chunkLength = chunkNames.length;

                            var firstEasing = easingObject[chunkNames[0]];
                            var typeofEasings = typeof firstEasing;

                            if (typeofEasings === 'string') {
                                var composedEasingString = '';

                                for (var i = 0; i < chunkLength; i++) {
                                    composedEasingString += ' ' + easingObject[chunkNames[i]];
                                    delete easingObject[chunkNames[i]];
                                }

                                easingObject[prop] = composedEasingString.substr(1);
                            } else {
                                easingObject[prop] = firstEasing;
                            }
                        });
                    }

                    Tweenable.prototype.filter.token = {
                        'tweenCreated': function(currentState, fromState, toState, easingObject) {
                            sanitizeObjectForHexProps(currentState);
                            sanitizeObjectForHexProps(fromState);
                            sanitizeObjectForHexProps(toState);
                            this._tokenData = getFormatManifests(currentState);
                        },

                        'beforeTween': function(currentState, fromState, toState, easingObject) {
                            expandEasingObject(easingObject, this._tokenData);
                            expandFormattedProperties(currentState, this._tokenData);
                            expandFormattedProperties(fromState, this._tokenData);
                            expandFormattedProperties(toState, this._tokenData);
                        },

                        'afterTween': function(currentState, fromState, toState, easingObject) {
                            collapseFormattedProperties(currentState, this._tokenData);
                            collapseFormattedProperties(fromState, this._tokenData);
                            collapseFormattedProperties(toState, this._tokenData);
                            collapseEasingObject(easingObject, this._tokenData);
                        }
                    };

                }(Tweenable));

            }).call(null);

        }, {}],
        2: [function(require, module, exports) {
            // Circle shaped progress bar

            var Shape = require('./shape');
            var utils = require('./utils');

            var Circle = function Circle(container, options) {
                // Use two arcs to form a circle
                // See this answer http://stackoverflow.com/a/10477334/1446092
                this._pathTemplate = 'M 50,50 m 0,-{radius}' + ' a {radius},{radius} 0 1 1 0,{2radius}' + ' a {radius},{radius} 0 1 1 0,-{2radius}';

                this.containerAspectRatio = 1;

                Shape.apply(this, arguments);
            };

            Circle.prototype = new Shape();
            Circle.prototype.constructor = Circle;

            Circle.prototype._pathString = function _pathString(opts) {
                var widthOfWider = opts.strokeWidth;
                if (opts.trailWidth && opts.trailWidth > opts.strokeWidth) {
                    widthOfWider = opts.trailWidth;
                }

                var r = 50 - widthOfWider / 2;

                return utils.render(this._pathTemplate, {
                    radius: r,
                    '2radius': r * 2
                });
            };

            Circle.prototype._trailString = function _trailString(opts) {
                return this._pathString(opts);
            };

            module.exports = Circle;

        }, {
            "./shape": 7,
            "./utils": 8
        }],
        3: [function(require, module, exports) {
            // Line shaped progress bar

            var Shape = require('./shape');
            var utils = require('./utils');

            var Line = function Line(container, options) {
                this._pathTemplate = 'M 0,{center} L 100,{center}';
                Shape.apply(this, arguments);
            };

            Line.prototype = new Shape();
            Line.prototype.constructor = Line;

            Line.prototype._initializeSvg = function _initializeSvg(svg, opts) {
                svg.setAttribute('viewBox', '0 0 100 ' + opts.strokeWidth);
                svg.setAttribute('preserveAspectRatio', 'none');
            };

            Line.prototype._pathString = function _pathString(opts) {
                return utils.render(this._pathTemplate, {
                    center: opts.strokeWidth / 2
                });
            };

            Line.prototype._trailString = function _trailString(opts) {
                return this._pathString(opts);
            };

            module.exports = Line;

        }, {
            "./shape": 7,
            "./utils": 8
        }],
        4: [function(require, module, exports) {
            module.exports = {
                // Higher level API, different shaped progress bars
                Line: require('./line'),
                Circle: require('./circle'),
                SemiCircle: require('./semicircle'),

                // Lower level API to use any SVG path
                Path: require('./path'),

                // Base-class for creating new custom shapes
                // to be in line with the API of built-in shapes
                // Undocumented.
                Shape: require('./shape'),

                // Internal utils, undocumented.
                utils: require('./utils')
            };

        }, {
            "./circle": 2,
            "./line": 3,
            "./path": 5,
            "./semicircle": 6,
            "./shape": 7,
            "./utils": 8
        }],
        5: [function(require, module, exports) {
            // Lower level API to animate any kind of svg path

            var Tweenable = require('shifty');
            var utils = require('./utils');

            var EASING_ALIASES = {
                easeIn: 'easeInCubic',
                easeOut: 'easeOutCubic',
                easeInOut: 'easeInOutCubic'
            };

            var Path = function Path(path, opts) {
                // Throw a better error if not initialized with `new` keyword
                if (!(this instanceof Path)) {
                    throw new Error('Constructor was called without new keyword');
                }

                // Default parameters for animation
                opts = utils.extend({
                    duration: 800,
                    easing: 'linear',
                    from: {},
                    to: {},
                    step: function() {}
                }, opts);

                var element;
                if (utils.isString(path)) {
                    element = document.querySelector(path);
                } else {
                    element = path;
                }

                // Reveal .path as public attribute
                this.path = element;
                this._opts = opts;
                this._tweenable = null;

                // Set up the starting positions
                var length = this.path.getTotalLength();
                this.path.style.strokeDasharray = length + ' ' + length;
                this.set(0);
            };

            Path.prototype.value = function value() {
                var offset = this._getComputedDashOffset();
                var length = this.path.getTotalLength();

                var progress = 1 - offset / length;
                // Round number to prevent returning very small number like 1e-30, which
                // is practically 0
                return parseFloat(progress.toFixed(6), 10);
            };

            Path.prototype.set = function set(progress) {
                this.stop();

                this.path.style.strokeDashoffset = this._progressToOffset(progress);

                var step = this._opts.step;
                if (utils.isFunction(step)) {
                    var easing = this._easing(this._opts.easing);
                    var values = this._calculateTo(progress, easing);
                    var reference = this._opts.shape || this;
                    step(values, reference, this._opts.attachment);
                }
            };

            Path.prototype.stop = function stop() {
                this._stopTween();
                this.path.style.strokeDashoffset = this._getComputedDashOffset();
            };

            // Method introduced here:
            // http://jakearchibald.com/2013/animated-line-drawing-svg/
            Path.prototype.animate = function animate(progress, opts, cb) {
                opts = opts || {};

                if (utils.isFunction(opts)) {
                    cb = opts;
                    opts = {};
                }

                var passedOpts = utils.extend({}, opts);

                // Copy default opts to new object so defaults are not modified
                var defaultOpts = utils.extend({}, this._opts);
                opts = utils.extend(defaultOpts, opts);

                var shiftyEasing = this._easing(opts.easing);
                var values = this._resolveFromAndTo(progress, shiftyEasing, passedOpts);

                this.stop();

                // Trigger a layout so styles are calculated & the browser
                // picks up the starting position before animating
                this.path.getBoundingClientRect();

                var offset = this._getComputedDashOffset();
                var newOffset = this._progressToOffset(progress);

                var self = this;
                this._tweenable = new Tweenable();
                this._tweenable.tween({
                    from: utils.extend({
                        offset: offset
                    }, values.from),
                    to: utils.extend({
                        offset: newOffset
                    }, values.to),
                    duration: opts.duration,
                    easing: shiftyEasing,
                    step: function(state) {
                        self.path.style.strokeDashoffset = state.offset;
                        var reference = opts.shape || self;
                        opts.step(state, reference, opts.attachment);
                    },
                    finish: function(state) {
                        if (utils.isFunction(cb)) {
                            cb();
                        }
                    }
                });
            };

            Path.prototype._getComputedDashOffset = function _getComputedDashOffset() {
                var computedStyle = window.getComputedStyle(this.path, null);
                return parseFloat(computedStyle.getPropertyValue('stroke-dashoffset'), 10);
            };

            Path.prototype._progressToOffset = function _progressToOffset(progress) {
                var length = this.path.getTotalLength();
                return length - progress * length;
            };

            // Resolves from and to values for animation.
            Path.prototype._resolveFromAndTo = function _resolveFromAndTo(progress, easing, opts) {
                if (opts.from && opts.to) {
                    return {
                        from: opts.from,
                        to: opts.to
                    };
                }

                return {
                    from: this._calculateFrom(easing),
                    to: this._calculateTo(progress, easing)
                };
            };

            // Calculate `from` values from options passed at initialization
            Path.prototype._calculateFrom = function _calculateFrom(easing) {
                return Tweenable.interpolate(this._opts.from, this._opts.to, this.value(), easing);
            };

            // Calculate `to` values from options passed at initialization
            Path.prototype._calculateTo = function _calculateTo(progress, easing) {
                return Tweenable.interpolate(this._opts.from, this._opts.to, progress, easing);
            };

            Path.prototype._stopTween = function _stopTween() {
                if (this._tweenable !== null) {
                    this._tweenable.stop();
                    this._tweenable = null;
                }
            };

            Path.prototype._easing = function _easing(easing) {
                if (EASING_ALIASES.hasOwnProperty(easing)) {
                    return EASING_ALIASES[easing];
                }

                return easing;
            };

            module.exports = Path;

        }, {
            "./utils": 8,
            "shifty": 1
        }],
        6: [function(require, module, exports) {
            // Semi-SemiCircle shaped progress bar

            var Shape = require('./shape');
            var Circle = require('./circle');
            var utils = require('./utils');

            var SemiCircle = function SemiCircle(container, options) {
                // Use one arc to form a SemiCircle
                // See this answer http://stackoverflow.com/a/10477334/1446092
                this._pathTemplate = 'M 50,50 m -{radius},0' + ' a {radius},{radius} 0 1 1 {2radius},0';

                this.containerAspectRatio = 2;

                Shape.apply(this, arguments);
            };

            SemiCircle.prototype = new Shape();
            SemiCircle.prototype.constructor = SemiCircle;

            SemiCircle.prototype._initializeSvg = function _initializeSvg(svg, opts) {
                svg.setAttribute('viewBox', '0 0 100 50');
            };

            SemiCircle.prototype._initializeTextContainer = function _initializeTextContainer(
                opts,
                container,
                textContainer) {
                if (opts.text.style) {
                    // Reset top style
                    textContainer.style.top = 'auto';
                    textContainer.style.bottom = '0';

                    if (opts.text.alignToBottom) {
                        utils.setStyle(textContainer, 'transform', 'translate(-50%, 0)');
                    } else {
                        utils.setStyle(textContainer, 'transform', 'translate(-50%, 50%)');
                    }
                }
            };

            // Share functionality with Circle, just have different path
            SemiCircle.prototype._pathString = Circle.prototype._pathString;
            SemiCircle.prototype._trailString = Circle.prototype._trailString;

            module.exports = SemiCircle;

        }, {
            "./circle": 2,
            "./shape": 7,
            "./utils": 8
        }],
        7: [function(require, module, exports) {
            // Base object for different progress bar shapes

            var Path = require('./path');
            var utils = require('./utils');

            var DESTROYED_ERROR = 'Object is destroyed';

            var Shape = function Shape(container, opts) {
                // Throw a better error if progress bars are not initialized with `new`
                // keyword
                if (!(this instanceof Shape)) {
                    throw new Error('Constructor was called without new keyword');
                }

                // Prevent calling constructor without parameters so inheritance
                // works correctly. To understand, this is how Shape is inherited:
                //
                //   Line.prototype = new Shape();
                //
                // We just want to set the prototype for Line.
                if (arguments.length === 0) {
                    return;
                }

                // Default parameters for progress bar creation
                this._opts = utils.extend({
                    color: '#555',
                    strokeWidth: 1.0,
                    trailColor: null,
                    trailWidth: null,
                    fill: null,
                    text: {
                        style: {
                            color: null,
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            padding: 0,
                            margin: 0,
                            transform: {
                                prefix: true,
                                value: 'translate(-50%, -50%)'
                            }
                        },
                        autoStyleContainer: true,
                        alignToBottom: true,
                        value: null,
                        className: 'progressbar-text'
                    },
                    svgStyle: {
                        display: 'block',
                        width: '100%'
                    },
                    warnings: false
                }, opts, true); // Use recursive extend

                // If user specifies e.g. svgStyle or text style, the whole object
                // should replace the defaults to make working with styles easier
                if (utils.isObject(opts) && opts.svgStyle !== undefined) {
                    this._opts.svgStyle = opts.svgStyle;
                }
                if (utils.isObject(opts) && utils.isObject(opts.text) && opts.text.style !== undefined) {
                    this._opts.text.style = opts.text.style;
                }

                var svgView = this._createSvgView(this._opts);

                var element;
                if (utils.isString(container)) {
                    element = document.querySelector(container);
                } else {
                    element = container;
                }

                if (!element) {
                    throw new Error('Container does not exist: ' + container);
                }

                this._container = element;
                this._container.appendChild(svgView.svg);
                if (this._opts.warnings) {
                    this._warnContainerAspectRatio(this._container);
                }

                if (this._opts.svgStyle) {
                    utils.setStyles(svgView.svg, this._opts.svgStyle);
                }

                // Expose public attributes before Path initialization
                this.svg = svgView.svg;
                this.path = svgView.path;
                this.trail = svgView.trail;
                this.text = null;

                var newOpts = utils.extend({
                    attachment: undefined,
                    shape: this
                }, this._opts);
                this._progressPath = new Path(svgView.path, newOpts);

                if (utils.isObject(this._opts.text) && this._opts.text.value !== null) {
                    this.setText(this._opts.text.value);
                }
            };

            Shape.prototype.animate = function animate(progress, opts, cb) {
                if (this._progressPath === null) {
                    throw new Error(DESTROYED_ERROR);
                }

                this._progressPath.animate(progress, opts, cb);
            };

            Shape.prototype.stop = function stop() {
                if (this._progressPath === null) {
                    throw new Error(DESTROYED_ERROR);
                }

                // Don't crash if stop is called inside step function
                if (this._progressPath === undefined) {
                    return;
                }

                this._progressPath.stop();
            };

            Shape.prototype.destroy = function destroy() {
                if (this._progressPath === null) {
                    throw new Error(DESTROYED_ERROR);
                }

                this.stop();
                this.svg.parentNode.removeChild(this.svg);
                this.svg = null;
                this.path = null;
                this.trail = null;
                this._progressPath = null;

                if (this.text !== null) {
                    this.text.parentNode.removeChild(this.text);
                    this.text = null;
                }
            };

            Shape.prototype.set = function set(progress) {
                if (this._progressPath === null) {
                    throw new Error(DESTROYED_ERROR);
                }

                this._progressPath.set(progress);
            };

            Shape.prototype.value = function value() {
                if (this._progressPath === null) {
                    throw new Error(DESTROYED_ERROR);
                }

                if (this._progressPath === undefined) {
                    return 0;
                }

                return this._progressPath.value();
            };

            Shape.prototype.setText = function setText(newText) {
                if (this._progressPath === null) {
                    throw new Error(DESTROYED_ERROR);
                }

                if (this.text === null) {
                    // Create new text node
                    this.text = this._createTextContainer(this._opts, this._container);
                    this._container.appendChild(this.text);
                }

                // Remove previous text and add new
                if (utils.isObject(newText)) {
                    utils.removeChildren(this.text);
                    this.text.appendChild(newText);
                } else {
                    this.text.innerHTML = newText;
                }
            };

            Shape.prototype._createSvgView = function _createSvgView(opts) {
                var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                this._initializeSvg(svg, opts);

                var trailPath = null;
                // Each option listed in the if condition are 'triggers' for creating
                // the trail path
                if (opts.trailColor || opts.trailWidth) {
                    trailPath = this._createTrail(opts);
                    svg.appendChild(trailPath);
                }

                var path = this._createPath(opts);
                svg.appendChild(path);

                return {
                    svg: svg,
                    path: path,
                    trail: trailPath
                };
            };

            Shape.prototype._initializeSvg = function _initializeSvg(svg, opts) {
                svg.setAttribute('viewBox', '0 0 100 100');
            };

            Shape.prototype._createPath = function _createPath(opts) {
                var pathString = this._pathString(opts);
                return this._createPathElement(pathString, opts);
            };

            Shape.prototype._createTrail = function _createTrail(opts) {
                // Create path string with original passed options
                var pathString = this._trailString(opts);

                // Prevent modifying original
                var newOpts = utils.extend({}, opts);

                // Defaults for parameters which modify trail path
                if (!newOpts.trailColor) {
                    newOpts.trailColor = '#eee';
                }
                if (!newOpts.trailWidth) {
                    newOpts.trailWidth = newOpts.strokeWidth;
                }

                newOpts.color = newOpts.trailColor;
                newOpts.strokeWidth = newOpts.trailWidth;

                // When trail path is set, fill must be set for it instead of the
                // actual path to prevent trail stroke from clipping
                newOpts.fill = null;

                return this._createPathElement(pathString, newOpts);
            };

            Shape.prototype._createPathElement = function _createPathElement(pathString, opts) {
                var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                path.setAttribute('d', pathString);
                path.setAttribute('stroke', opts.color);
                path.setAttribute('stroke-width', opts.strokeWidth);

                if (opts.fill) {
                    path.setAttribute('fill', opts.fill);
                } else {
                    path.setAttribute('fill-opacity', '0');
                }

                return path;
            };

            Shape.prototype._createTextContainer = function _createTextContainer(opts, container) {
                var textContainer = document.createElement('div');
                textContainer.className = opts.text.className;

                var textStyle = opts.text.style;
                if (textStyle) {
                    if (opts.text.autoStyleContainer) {
                        container.style.position = 'relative';
                    }

                    utils.setStyles(textContainer, textStyle);
                    // Default text color to progress bar's color
                    if (!textStyle.color) {
                        textContainer.style.color = opts.color;
                    }
                }

                this._initializeTextContainer(opts, container, textContainer);
                return textContainer;
            };

            // Give custom shapes possibility to modify text element
            Shape.prototype._initializeTextContainer = function(opts, container, element) {
                // By default, no-op
                // Custom shapes should respect API options, such as text.style
            };

            Shape.prototype._pathString = function _pathString(opts) {
                throw new Error('Override this function for each progress bar');
            };

            Shape.prototype._trailString = function _trailString(opts) {
                throw new Error('Override this function for each progress bar');
            };

            Shape.prototype._warnContainerAspectRatio = function _warnContainerAspectRatio(container) {
                if (!this.containerAspectRatio) {
                    return;
                }

                var computedStyle = window.getComputedStyle(container, null);
                var width = parseFloat(computedStyle.getPropertyValue('width'), 10);
                var height = parseFloat(computedStyle.getPropertyValue('height'), 10);
                if (!utils.floatEquals(this.containerAspectRatio, width / height)) {
                    console.warn('Incorrect aspect ratio of container', '#' + container.id, 'detected:',
                        computedStyle.getPropertyValue('width') + '(width)', '/',
                        computedStyle.getPropertyValue('height') + '(height)', '=',
                        width / height);

                    console.warn('Aspect ratio of should be',
                        this.containerAspectRatio);
                }
            };

            module.exports = Shape;

        }, {
            "./path": 5,
            "./utils": 8
        }],
        8: [function(require, module, exports) {
            // Utility functions

            var PREFIXES = 'Webkit Moz O ms'.split(' ');
            var FLOAT_COMPARISON_EPSILON = 0.001;

            // Copy all attributes from source object to destination object.
            // destination object is mutated.
            function extend(destination, source, recursive) {
                destination = destination || {};
                source = source || {};
                recursive = recursive || false;

                for (var attrName in source) {
                    if (source.hasOwnProperty(attrName)) {
                        var destVal = destination[attrName];
                        var sourceVal = source[attrName];
                        if (recursive && isObject(destVal) && isObject(sourceVal)) {
                            destination[attrName] = extend(destVal, sourceVal, recursive);
                        } else {
                            destination[attrName] = sourceVal;
                        }
                    }
                }

                return destination;
            }

            // Renders templates with given variables. Variables must be surrounded with
            // braces without any spaces, e.g. {variable}
            // All instances of variable placeholders will be replaced with given content
            // Example:
            // render('Hello, {message}!', {message: 'world'})
            function render(template, vars) {
                var rendered = template;

                for (var key in vars) {
                    if (vars.hasOwnProperty(key)) {
                        var val = vars[key];
                        var regExpString = '\\{' + key + '\\}';
                        var regExp = new RegExp(regExpString, 'g');

                        rendered = rendered.replace(regExp, val);
                    }
                }

                return rendered;
            }

            function setStyle(element, style, value) {
                var elStyle = element.style; // cache for performance

                for (var i = 0; i < PREFIXES.length; ++i) {
                    var prefix = PREFIXES[i];
                    elStyle[prefix + capitalize(style)] = value;
                }

                elStyle[style] = value;
            }

            function setStyles(element, styles) {
                forEachObject(styles, function(styleValue, styleName) {
                    // Allow disabling some individual styles by setting them
                    // to null or undefined
                    if (styleValue === null || styleValue === undefined) {
                        return;
                    }

                    // If style's value is {prefix: true, value: '50%'},
                    // Set also browser prefixed styles
                    if (isObject(styleValue) && styleValue.prefix === true) {
                        setStyle(element, styleName, styleValue.value);
                    } else {
                        element.style[styleName] = styleValue;
                    }
                });
            }

            function capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }

            function isString(obj) {
                return typeof obj === 'string' || obj instanceof String;
            }

            function isFunction(obj) {
                return typeof obj === 'function';
            }

            function isArray(obj) {
                return Object.prototype.toString.call(obj) === '[object Array]';
            }

            // Returns true if `obj` is object as in {a: 1, b: 2}, not if it's function or
            // array
            function isObject(obj) {
                if (isArray(obj)) {
                    return false;
                }

                var type = typeof obj;
                return type === 'object' && !! obj;
            }

            function forEachObject(object, callback) {
                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        var val = object[key];
                        callback(val, key);
                    }
                }
            }

            function floatEquals(a, b) {
                return Math.abs(a - b) < FLOAT_COMPARISON_EPSILON;
            }

            // https://coderwall.com/p/nygghw/don-t-use-innerhtml-to-empty-dom-elements
            function removeChildren(el) {
                while (el.firstChild) {
                    el.removeChild(el.firstChild);
                }
            }

            module.exports = {
                extend: extend,
                render: render,
                setStyle: setStyle,
                setStyles: setStyles,
                capitalize: capitalize,
                isString: isString,
                isFunction: isFunction,
                isObject: isObject,
                forEachObject: forEachObject,
                floatEquals: floatEquals,
                removeChildren: removeChildren
            };

        }, {}]
    }, {}, [4])(4)
}); 
/*!
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */



var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);



(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);


(function (exports){
    "use strict";

    function Timer(callback, delay) {
        this.callback = callback;
        this.originalDelay = delay;
        this.delay = delay;
        this.timerId = null;
    }

    Timer.prototype.start = function(delay) {
        var self = this;

        if (!this.callback) {
            daumtools.error('Timer requires a function parameter');
            return;
        }

        if (!delay) {
            this.clear();
        } else {
            this.delay = delay;
        }

        this.startTime = new Date().getTime();
        this.timerId = setTimeout(function() {
            self.callback();
            self.timerId = null;
        }, this.delay || 0);
        this.paused = false;
    };

    Timer.prototype.pause = function() {
        if (!this.timerId || this.paused) {
            return;
        }
        clearTimeout(this.timerId);
        this.timerId = null;

        this.paused = true;
        this.delay = this.startTime + this.delay - new Date().getTime();
    };

    Timer.prototype.resume = function() {
        if (!this.paused) {
            return;
        }
        this.start(this.delay);
    };

    Timer.prototype.clear = function() {
        clearTimeout(this.timerId);
        this.timerId = null;
        this.delay = this.originalDelay;
    };

    exports.Timer = Timer;
})(window.daumtools = (typeof window.daumtools === 'undefined') ? {} : window.daumtools);

/* jshint browser: true
 */

(function(exports) {
    'use strict';

    function StopWatch() {
        this.watches = {};
    }

    function getMeasuringTime(name) {
        var time = 0;
        if (this.watches[name]) {
            if (this.watches[name].timestamp !== 0) {
                time = performance.now() - this.watches[name].timestamp;
            }
            time += this.watches[name].accumulationTime;
        }

        return parseInt(time.toFixed(0), 10);
    }

    StopWatch.prototype.start = function(name) {
        if (!this.watches[name]) {
            this.watches[name] = { timestamp: performance.now(), accumulationTime: 0, isPaused: false };
        }
    };

    StopWatch.prototype.has = function(name) {
        return getMeasuringTime.call(this, name);
    };

    StopWatch.prototype.pause = function(name) {
        if (this.watches[name] && !this.watches[name].isPaused) {
            var time = performance.now() - this.watches[name].timestamp;
            this.watches[name].accumulationTime += time;
            this.watches[name].timestamp = 0;
            this.watches[name].isPaused = true;
        }
    };

    StopWatch.prototype.resume = function(name) {
        if (this.watches[name] && this.watches[name].isPaused) {
            this.watches[name].timestamp = performance.now();
            this.watches[name].isPaused = false;
        }
    };

    StopWatch.prototype.stop = function(name) {
        var time = getMeasuringTime.call(this, name);
        if (this.watches[name]) {
            delete this.watches[name];
        }

        return time;
    };

    exports.StopWatch = new StopWatch();
})((window.daumtools = typeof window.daumtools === 'undefined' ? {} : window.daumtools));

(function(exports) {
    'use strict';

    function Interval(callback, delay) {
        this.callback = callback;
        this.delay = delay;
        this.isRunning = false;
    }

    Interval.prototype.start = function() {
        this.IntervalId = setInterval(this.callback, this.delay);
        this.isRunning = true;
    };

    Interval.prototype.stop = function() {
        clearInterval(this.IntervalId);
        this.isRunning = false;
        this.IntervalId = null;
    };

    exports.Interval = Interval;
})((window.daumtools = typeof window.daumtools === 'undefined' ? {} : window.daumtools));

(function(){var innerGlobal=typeof window!="undefined"?window:global;var exportTo={};(function(window,global){var n,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(b,c,d){b!=Array.prototype&&b!=Object.prototype&&(b[c]=d.value)},ba="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ca(){ca=function(){};ba.Symbol||(ba.Symbol=da)}var da=function(){var b=0;return function(c){return"jscomp_symbol_"+(c||"")+b++}}();
function ea(){ca();var b=ba.Symbol.iterator;b||(b=ba.Symbol.iterator=ba.Symbol("iterator"));"function"!=typeof Array.prototype[b]&&aa(Array.prototype,b,{configurable:!0,writable:!0,value:function(){return fa(this)}});ea=function(){}}function fa(b){var c=0;return ha(function(){return c<b.length?{done:!1,value:b[c++]}:{done:!0}})}function ha(b){ea();b={next:b};b[ba.Symbol.iterator]=function(){return this};return b}function q(b){ea();var c=b[Symbol.iterator];return c?c.call(b):fa(b)}
function ia(b,c){if(c){for(var d=ba,e=b.split("."),f=0;f<e.length-1;f++){var g=e[f];g in d||(d[g]={});d=d[g]}e=e[e.length-1];f=d[e];g=c(f);g!=f&&null!=g&&aa(d,e,{configurable:!0,writable:!0,value:g})}}
ia("Promise",function(b){function c(b){this.b=0;this.g=void 0;this.a=[];var c=this.c();try{b(c.resolve,c.reject)}catch(m){c.reject(m)}}function d(){this.a=null}function e(b){return b instanceof c?b:new c(function(c){c(b)})}if(b)return b;d.prototype.b=function(b){null==this.a&&(this.a=[],this.f());this.a.push(b)};d.prototype.f=function(){var b=this;this.c(function(){b.h()})};var f=ba.setTimeout;d.prototype.c=function(b){f(b,0)};d.prototype.h=function(){for(;this.a&&this.a.length;){var b=this.a;this.a=
[];for(var c=0;c<b.length;++c){var d=b[c];b[c]=null;try{d()}catch(l){this.g(l)}}}this.a=null};d.prototype.g=function(b){this.c(function(){throw b;})};c.prototype.c=function(){function b(b){return function(e){d||(d=!0,b.call(c,e))}}var c=this,d=!1;return{resolve:b(this.o),reject:b(this.f)}};c.prototype.o=function(b){if(b===this)this.f(new TypeError("A Promise cannot resolve to itself"));else if(b instanceof c)this.s(b);else{a:switch(typeof b){case "object":var d=null!=b;break a;case "function":d=!0;
break a;default:d=!1}d?this.l(b):this.h(b)}};c.prototype.l=function(b){var c=void 0;try{c=b.then}catch(m){this.f(m);return}"function"==typeof c?this.u(c,b):this.h(b)};c.prototype.f=function(b){this.i(2,b)};c.prototype.h=function(b){this.i(1,b)};c.prototype.i=function(b,c){if(0!=this.b)throw Error("Cannot settle("+b+", "+c+"): Promise already settled in state"+this.b);this.b=b;this.g=c;this.j()};c.prototype.j=function(){if(null!=this.a){for(var b=0;b<this.a.length;++b)g.b(this.a[b]);this.a=null}};
var g=new d;c.prototype.s=function(b){var c=this.c();b.xb(c.resolve,c.reject)};c.prototype.u=function(b,c){var d=this.c();try{b.call(c,d.resolve,d.reject)}catch(l){d.reject(l)}};c.prototype.then=function(b,d){function e(b,c){return"function"==typeof b?function(c){try{f(b(c))}catch(F){g(F)}}:c}var f,g,h=new c(function(b,c){f=b;g=c});this.xb(e(b,f),e(d,g));return h};c.prototype["catch"]=function(b){return this.then(void 0,b)};c.prototype.xb=function(b,c){function d(){switch(e.b){case 1:b(e.g);break;
case 2:c(e.g);break;default:throw Error("Unexpected state: "+e.b);}}var e=this;null==this.a?g.b(d):this.a.push(d)};c.resolve=e;c.reject=function(b){return new c(function(c,d){d(b)})};c.race=function(b){return new c(function(c,d){for(var f=q(b),g=f.next();!g.done;g=f.next())e(g.value).xb(c,d)})};c.all=function(b){var d=q(b),f=d.next();return f.done?e([]):new c(function(b,c){function g(c){return function(d){h[c]=d;k--;0==k&&b(h)}}var h=[],k=0;do h.push(void 0),k++,e(f.value).xb(g(h.length-1),c),f=d.next();
while(!f.done)})};return c});ia("Promise.prototype.finally",function(b){return b?b:function(b){return this.then(function(c){return Promise.resolve(b()).then(function(){return c})},function(c){return Promise.resolve(b()).then(function(){throw c;})})}});function ja(b){function c(c){return b.next(c)}function d(c){return b["throw"](c)}return new Promise(function(e,f){function g(b){b.done?e(b.value):Promise.resolve(b.value).then(c,d).then(g,f)}g(b.next())})}function r(b){return ja(b())}
function ka(){this.g=!1;this.c=null;this.w=void 0;this.m=1;this.b=this.f=0;this.i=this.a=null}function la(b){if(b.g)throw new TypeError("Generator is already running");b.g=!0}ka.prototype.h=function(b){this.w=b};function ma(b,c){b.a={Hc:c,Pc:!0};b.m=b.f||b.b}ka.prototype["return"]=function(b){this.a={"return":b};this.m=this.b};function u(b,c,d){b.m=d;return{value:c}}ka.prototype.D=function(b){this.m=b};function oa(b,c,d){b.f=c;void 0!=d&&(b.b=d)}function pa(b,c){b.f=0;b.b=c||0}
function qa(b,c){b.m=c;b.f=0}function ra(b){b.f=0;var c=b.a.Hc;b.a=null;return c}function sa(b){b.i=[b.a];b.f=0;b.b=0}function ta(b,c){var d=b.i.splice(0)[0];(d=b.a=b.a||d)?d.Pc?b.m=b.f||b.b:void 0!=d.D&&b.b<d.D?(b.m=d.D,b.a=null):b.m=b.b:b.m=c}function ua(b){this.a=new ka;this.b=b}function wa(b,c){la(b.a);var d=b.a.c;if(d)return xa(b,"return"in d?d["return"]:function(b){return{value:b,done:!0}},c,b.a["return"]);b.a["return"](c);return ya(b)}
function xa(b,c,d,e){try{var f=c.call(b.a.c,d);if(!(f instanceof Object))throw new TypeError("Iterator result "+f+" is not an object");if(!f.done)return b.a.g=!1,f;var g=f.value}catch(h){return b.a.c=null,ma(b.a,h),ya(b)}b.a.c=null;e.call(b.a,g);return ya(b)}
function ya(b){for(;b.a.m;)try{var c=b.b(b.a);if(c)return b.a.g=!1,{value:c.value,done:!1}}catch(d){b.a.w=void 0,ma(b.a,d)}b.a.g=!1;if(b.a.a){c=b.a.a;b.a.a=null;if(c.Pc)throw c.Hc;return{value:c["return"],done:!0}}return{value:void 0,done:!0}}
function za(b){this.next=function(c){la(b.a);b.a.c?c=xa(b,b.a.c.next,c,b.a.h):(b.a.h(c),c=ya(b));return c};this["throw"]=function(c){la(b.a);b.a.c?c=xa(b,b.a.c["throw"],c,b.a.h):(ma(b.a,c),c=ya(b));return c};this["return"]=function(c){return wa(b,c)};ea();this[Symbol.iterator]=function(){return this}}function v(b,c){za.prototype=b.prototype;return new za(new ua(c))}function Aa(b,c){return Object.prototype.hasOwnProperty.call(b,c)}
ia("WeakMap",function(b){function c(b){this.a=(g+=Math.random()+1).toString();if(b){ca();ea();b=q(b);for(var c;!(c=b.next()).done;)c=c.value,this.set(c[0],c[1])}}function d(b){Aa(b,f)||aa(b,f,{value:{}})}function e(b){var c=Object[b];c&&(Object[b]=function(b){d(b);return c(b)})}if(function(){if(!b||!Object.seal)return!1;try{var c=Object.seal({}),d=Object.seal({}),e=new b([[c,2],[d,3]]);if(2!=e.get(c)||3!=e.get(d))return!1;e["delete"](c);e.set(d,4);return!e.has(c)&&4==e.get(d)}catch(l){return!1}}())return b;
var f="$jscomp_hidden_"+Math.random();e("freeze");e("preventExtensions");e("seal");var g=0;c.prototype.set=function(b,c){d(b);if(!Aa(b,f))throw Error("WeakMap key fail: "+b);b[f][this.a]=c;return this};c.prototype.get=function(b){return Aa(b,f)?b[f][this.a]:void 0};c.prototype.has=function(b){return Aa(b,f)&&Aa(b[f],this.a)};c.prototype["delete"]=function(b){return Aa(b,f)&&Aa(b[f],this.a)?delete b[f][this.a]:!1};return c});
ia("Map",function(b){function c(){var b={};return b.ra=b.next=b.head=b}function d(b,c){var d=b.a;return ha(function(){if(d){for(;d.head!=b.a;)d=d.ra;for(;d.next!=d.head;)return d=d.next,{done:!1,value:c(d)};d=null}return{done:!0,value:void 0}})}function e(b,c){var d=c&&typeof c;"object"==d||"function"==d?g.has(c)?d=g.get(c):(d=""+ ++h,g.set(c,d)):d="p_"+c;var e=b.b[d];if(e&&Aa(b.b,d))for(var f=0;f<e.length;f++){var k=e[f];if(c!==c&&k.key!==k.key||c===k.key)return{id:d,list:e,index:f,R:k}}return{id:d,
list:e,index:-1,R:void 0}}function f(b){this.b={};this.a=c();this.size=0;if(b){b=q(b);for(var d;!(d=b.next()).done;)d=d.value,this.set(d[0],d[1])}}if(function(){if(!b||"function"!=typeof b||!b.prototype.entries||"function"!=typeof Object.seal)return!1;try{var c=Object.seal({x:4}),d=new b(q([[c,"s"]]));if("s"!=d.get(c)||1!=d.size||d.get({x:4})||d.set({x:4},"t")!=d||2!=d.size)return!1;var e=d.entries(),f=e.next();if(f.done||f.value[0]!=c||"s"!=f.value[1])return!1;f=e.next();return f.done||4!=f.value[0].x||
"t"!=f.value[1]||!e.next().done?!1:!0}catch(t){return!1}}())return b;ca();ea();var g=new WeakMap;f.prototype.set=function(b,c){var d=e(this,b);d.list||(d.list=this.b[d.id]=[]);d.R?d.R.value=c:(d.R={next:this.a,ra:this.a.ra,head:this.a,key:b,value:c},d.list.push(d.R),this.a.ra.next=d.R,this.a.ra=d.R,this.size++);return this};f.prototype["delete"]=function(b){b=e(this,b);return b.R&&b.list?(b.list.splice(b.index,1),b.list.length||delete this.b[b.id],b.R.ra.next=b.R.next,b.R.next.ra=b.R.ra,b.R.head=
null,this.size--,!0):!1};f.prototype.clear=function(){this.b={};this.a=this.a.ra=c();this.size=0};f.prototype.has=function(b){return!!e(this,b).R};f.prototype.get=function(b){return(b=e(this,b).R)&&b.value};f.prototype.entries=function(){return d(this,function(b){return[b.key,b.value]})};f.prototype.keys=function(){return d(this,function(b){return b.key})};f.prototype.values=function(){return d(this,function(b){return b.value})};f.prototype.forEach=function(b,c){for(var d=this.entries(),e;!(e=d.next()).done;)e=
e.value,b.call(c,e[1],e[0],this)};f.prototype[Symbol.iterator]=f.prototype.entries;var h=0;return f});
ia("Set",function(b){function c(b){this.a=new Map;if(b){b=q(b);for(var c;!(c=b.next()).done;)this.add(c.value)}this.size=this.a.size}if(function(){if(!b||"function"!=typeof b||!b.prototype.entries||"function"!=typeof Object.seal)return!1;try{var c=Object.seal({x:4}),e=new b(q([c]));if(!e.has(c)||1!=e.size||e.add(c)!=e||1!=e.size||e.add({x:4})!=e||2!=e.size)return!1;var f=e.entries(),g=f.next();if(g.done||g.value[0]!=c||g.value[1]!=c)return!1;g=f.next();return g.done||g.value[0]==c||4!=g.value[0].x||
g.value[1]!=g.value[0]?!1:f.next().done}catch(h){return!1}}())return b;ca();ea();c.prototype.add=function(b){this.a.set(b,b);this.size=this.a.size;return this};c.prototype["delete"]=function(b){b=this.a["delete"](b);this.size=this.a.size;return b};c.prototype.clear=function(){this.a.clear();this.size=0};c.prototype.has=function(b){return this.a.has(b)};c.prototype.entries=function(){return this.a.entries()};c.prototype.values=function(){return this.a.values()};c.prototype.keys=c.prototype.values;
c.prototype[Symbol.iterator]=c.prototype.values;c.prototype.forEach=function(b,c){var d=this;this.a.forEach(function(e){return b.call(c,e,e,d)})};return c});function Ba(b,c,d){b instanceof String&&(b=String(b));for(var e=b.length,f=0;f<e;f++){var g=b[f];if(c.call(d,g,f,b))return{Lc:f,rd:g}}return{Lc:-1,rd:void 0}}ia("Array.prototype.findIndex",function(b){return b?b:function(b,d){return Ba(this,b,d).Lc}});
ia("Array.from",function(b){return b?b:function(b,d,e){ea();d=null!=d?d:function(b){return b};var c=[],g=b[Symbol.iterator];if("function"==typeof g)for(b=g.call(b);!(g=b.next()).done;)c.push(d.call(e,g.value));else{g=b.length;for(var h=0;h<g;h++)c.push(d.call(e,b[h]))}return c}});ia("Object.is",function(b){return b?b:function(b,d){return b===d?0!==b||1/b===1/d:b!==b&&d!==d}});
ia("Array.prototype.includes",function(b){return b?b:function(b,d){var c=this;c instanceof String&&(c=String(c));var f=c.length,g=d||0;for(0>g&&(g=Math.max(g+f,0));g<f;g++){var h=c[g];if(h===b||Object.is(h,b))return!0}return!1}});function Ca(b,c,d){if(null==b)throw new TypeError("The 'this' value for String.prototype."+d+" must not be null or undefined");if(c instanceof RegExp)throw new TypeError("First argument to String.prototype."+d+" must not be a regular expression");return b+""}
ia("String.prototype.includes",function(b){return b?b:function(b,d){return-1!==Ca(this,b,"includes").indexOf(b,d||0)}});ia("Array.prototype.find",function(b){return b?b:function(b,d){return Ba(this,b,d).rd}});ia("String.prototype.startsWith",function(b){return b?b:function(b,d){for(var c=Ca(this,b,"startsWith"),f=c.length,g=b.length,h=Math.max(0,Math.min(d|0,c.length)),k=0;k<g&&h<f;)if(c[h++]!=b[k++])return!1;return k>=g}});var Da=this;Da.a=!0;
function y(b,c){var d=b.split("."),e=Da;d[0]in e||!e.execScript||e.execScript("var "+d[0]);for(var f;d.length&&(f=d.shift());)d.length||void 0===c?e[f]?e=e[f]:e=e[f]={}:e[f]=c}function Ea(b,c){function d(){}d.prototype=c.prototype;b.Ff=c.prototype;b.prototype=new d;b.prototype.constructor=b;b.zf=function(b,d,g){return c.prototype[d].apply(b,Array.prototype.slice.call(arguments,2))}};/*

 Copyright 2016 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function Fa(b){this.c=Math.exp(Math.log(.5)/b);this.b=this.a=0}function Ga(b,c,d){var e=Math.pow(b.c,c);d=d*(1-e)+e*b.a;isNaN(d)||(b.a=d,b.b+=c)}function Ha(b){return b.a/(1-Math.pow(b.c,b.b))};function Ia(){this.b=new Fa(2);this.c=new Fa(5);this.a=0}function Ja(b,c,d){if(!(16E3>d)){var e=8E3*d/c;c/=1E3;b.a+=d;Ga(b.b,c,e);Ga(b.c,c,e)}}Ia.prototype.getBandwidthEstimate=function(b){return 128E3>this.a?b:Math.min(Ha(this.b),Ha(this.c))};function Ka(){}function La(){}window.console&&window.console.log.bind&&(Ka=console.warn.bind(console));var Ma=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;function Na(b){var c;b instanceof Na?(Oa(this,b.la),this.Ka=b.Ka,this.na=b.na,Pa(this,b.Wa),this.da=b.da,Qa(this,b.a.clone()),this.Ca=b.Ca):b&&(c=String(b).match(Ma))?(Oa(this,c[1]||"",!0),this.Ka=Ra(c[2]||""),this.na=Ra(c[3]||"",!0),Pa(this,c[4]),this.da=Ra(c[5]||"",!0),Qa(this,c[6]||"",!0),this.Ca=Ra(c[7]||"")):this.a=new Sa(null)}n=Na.prototype;n.la="";n.Ka="";n.na="";n.Wa=null;n.da="";n.Ca="";
n.toString=function(){var b=[],c=this.la;c&&b.push(Va(c,Wa,!0),":");if(c=this.na){b.push("//");var d=this.Ka;d&&b.push(Va(d,Wa,!0),"@");b.push(encodeURIComponent(c).replace(/%25([0-9a-fA-F]{2})/g,"%$1"));c=this.Wa;null!=c&&b.push(":",String(c))}if(c=this.da)this.na&&"/"!=c.charAt(0)&&b.push("/"),b.push(Va(c,"/"==c.charAt(0)?Xa:Ya,!0));(c=this.a.toString())&&b.push("?",c);(c=this.Ca)&&b.push("#",Va(c,Za));return b.join("")};
n.resolve=function(b){var c=this.clone();"data"===c.la&&(c=new Na);var d=!!b.la;d?Oa(c,b.la):d=!!b.Ka;d?c.Ka=b.Ka:d=!!b.na;d?c.na=b.na:d=null!=b.Wa;var e=b.da;if(d)Pa(c,b.Wa);else if(d=!!b.da){if("/"!=e.charAt(0))if(this.na&&!this.da)e="/"+e;else{var f=c.da.lastIndexOf("/");-1!=f&&(e=c.da.substr(0,f+1)+e)}if(".."==e||"."==e)e="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){f=0==e.lastIndexOf("/",0);e=e.split("/");for(var g=[],h=0;h<e.length;){var k=e[h++];"."==k?f&&h==e.length&&g.push(""):".."==
k?((1<g.length||1==g.length&&""!=g[0])&&g.pop(),f&&h==e.length&&g.push("")):(g.push(k),f=!0)}e=g.join("/")}}d?c.da=e:d=""!==b.a.toString();d?Qa(c,b.a.clone()):d=!!b.Ca;d&&(c.Ca=b.Ca);return c};n.clone=function(){return new Na(this)};function Oa(b,c,d){b.la=d?Ra(c,!0):c;b.la&&(b.la=b.la.replace(/:$/,""))}function Pa(b,c){if(c){c=Number(c);if(isNaN(c)||0>c)throw Error("Bad port number "+c);b.Wa=c}else b.Wa=null}function Qa(b,c,d){c instanceof Sa?b.a=c:(d||(c=Va(c,$a)),b.a=new Sa(c))}
function Ra(b,c){return b?c?decodeURI(b):decodeURIComponent(b):""}function Va(b,c,d){return"string"==typeof b?(b=encodeURI(b).replace(c,ab),d&&(b=b.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),b):null}function ab(b){b=b.charCodeAt(0);return"%"+(b>>4&15).toString(16)+(b&15).toString(16)}var Wa=/[#\/\?@]/g,Ya=/[#\?:]/g,Xa=/[#\?]/g,$a=/[#\?@]/g,Za=/#/g;function Sa(b){this.a=b||null}n=Sa.prototype;n.ca=null;n.zb=null;
n.add=function(b,c){if(!this.ca&&(this.ca={},this.zb=0,this.a))for(var d=this.a.split("&"),e=0;e<d.length;e++){var f=d[e].indexOf("="),g=null;if(0<=f){var h=d[e].substring(0,f);g=d[e].substring(f+1)}else h=d[e];h=decodeURIComponent(h.replace(/\+/g," "));g=g||"";this.add(h,decodeURIComponent(g.replace(/\+/g," ")))}this.a=null;(d=this.ca.hasOwnProperty(b)&&this.ca[b])||(this.ca[b]=d=[]);d.push(c);this.zb++;return this};
n.toString=function(){if(this.a)return this.a;if(!this.ca)return"";var b=[],c;for(c in this.ca)for(var d=encodeURIComponent(c),e=this.ca[c],f=0;f<e.length;f++){var g=d;""!==e[f]&&(g+="="+encodeURIComponent(e[f]));b.push(g)}return this.a=b.join("&")};n.clone=function(){var b=new Sa;b.a=this.a;if(this.ca){var c={},d;for(d in this.ca)c[d]=this.ca[d].concat();b.ca=c;b.zb=this.zb}return b};function z(){var b,c,d=new Promise(function(d,f){b=d;c=f});d.resolve=b;d.reject=c;return d}z.prototype.resolve=function(){};z.prototype.reject=function(){};function bb(b,c){var d=db();this.i=null==b.maxAttempts?d.maxAttempts:b.maxAttempts;this.f=null==b.baseDelay?d.baseDelay:b.baseDelay;this.h=null==b.fuzzFactor?d.fuzzFactor:b.fuzzFactor;this.g=null==b.backoffFactor?d.backoffFactor:b.backoffFactor;this.a=0;this.b=this.f;if(this.c=void 0===c?!1:c)this.a=1}function eb(b){if(b.a>=b.i)if(b.c)b.a=1,b.b=b.f;else return Promise.reject();var c=new z;b.a?(window.setTimeout(c.resolve,b.b*(1+(2*Math.random()-1)*b.h)),b.b*=b.g):c.resolve();b.a++;return c}
function db(){return{maxAttempts:2,baseDelay:1E3,backoffFactor:2,fuzzFactor:.5,timeout:0}};function B(b,c,d,e){for(var f=[],g=3;g<arguments.length;++g)f[g-3]=arguments[g];this.severity=b;this.category=c;this.code=d;this.data=f;this.handled=!1}y("shaka.util.Error",B);B.prototype.toString=function(){return"shaka.util.Error "+JSON.stringify(this,null,"  ")};B.Severity={RECOVERABLE:1,CRITICAL:2};B.Category={NETWORK:1,TEXT:2,MEDIA:3,MANIFEST:4,STREAMING:5,DRM:6,PLAYER:7,CAST:8,STORAGE:9};
B.Code={UNSUPPORTED_SCHEME:1E3,BAD_HTTP_STATUS:1001,HTTP_ERROR:1002,TIMEOUT:1003,MALFORMED_DATA_URI:1004,UNKNOWN_DATA_URI_ENCODING:1005,REQUEST_FILTER_ERROR:1006,RESPONSE_FILTER_ERROR:1007,MALFORMED_TEST_URI:1008,UNEXPECTED_TEST_REQUEST:1009,INVALID_TEXT_HEADER:2E3,INVALID_TEXT_CUE:2001,UNABLE_TO_DETECT_ENCODING:2003,BAD_ENCODING:2004,INVALID_XML:2005,INVALID_MP4_TTML:2007,INVALID_MP4_VTT:2008,UNABLE_TO_EXTRACT_CUE_START_TIME:2009,BUFFER_READ_OUT_OF_BOUNDS:3E3,JS_INTEGER_OVERFLOW:3001,EBML_OVERFLOW:3002,
EBML_BAD_FLOATING_POINT_SIZE:3003,MP4_SIDX_WRONG_BOX_TYPE:3004,MP4_SIDX_INVALID_TIMESCALE:3005,MP4_SIDX_TYPE_NOT_SUPPORTED:3006,WEBM_CUES_ELEMENT_MISSING:3007,WEBM_EBML_HEADER_ELEMENT_MISSING:3008,WEBM_SEGMENT_ELEMENT_MISSING:3009,WEBM_INFO_ELEMENT_MISSING:3010,WEBM_DURATION_ELEMENT_MISSING:3011,WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING:3012,WEBM_CUE_TIME_ELEMENT_MISSING:3013,MEDIA_SOURCE_OPERATION_FAILED:3014,MEDIA_SOURCE_OPERATION_THREW:3015,VIDEO_ERROR:3016,QUOTA_EXCEEDED_ERROR:3017,TRANSMUXING_FAILED:3018,
UNABLE_TO_GUESS_MANIFEST_TYPE:4E3,DASH_INVALID_XML:4001,DASH_NO_SEGMENT_INFO:4002,DASH_EMPTY_ADAPTATION_SET:4003,DASH_EMPTY_PERIOD:4004,DASH_WEBM_MISSING_INIT:4005,DASH_UNSUPPORTED_CONTAINER:4006,DASH_PSSH_BAD_ENCODING:4007,DASH_NO_COMMON_KEY_SYSTEM:4008,DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED:4009,DASH_CONFLICTING_KEY_IDS:4010,UNPLAYABLE_PERIOD:4011,RESTRICTIONS_CANNOT_BE_MET:4012,NO_PERIODS:4014,HLS_PLAYLIST_HEADER_MISSING:4015,INVALID_HLS_TAG:4016,HLS_INVALID_PLAYLIST_HIERARCHY:4017,DASH_DUPLICATE_REPRESENTATION_ID:4018,
HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND:4020,HLS_COULD_NOT_GUESS_MIME_TYPE:4021,HLS_MASTER_PLAYLIST_NOT_PROVIDED:4022,HLS_REQUIRED_ATTRIBUTE_MISSING:4023,HLS_REQUIRED_TAG_MISSING:4024,HLS_COULD_NOT_GUESS_CODECS:4025,HLS_KEYFORMATS_NOT_SUPPORTED:4026,DASH_UNSUPPORTED_XLINK_ACTUATE:4027,DASH_XLINK_DEPTH_LIMIT:4028,HLS_COULD_NOT_PARSE_SEGMENT_START_TIME:4030,CONTENT_UNSUPPORTED_BY_BROWSER:4032,CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM:4033,INVALID_STREAMS_CHOSEN:5005,NO_RECOGNIZED_KEY_SYSTEMS:6E3,REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE:6001,
FAILED_TO_CREATE_CDM:6002,FAILED_TO_ATTACH_TO_VIDEO:6003,INVALID_SERVER_CERTIFICATE:6004,FAILED_TO_CREATE_SESSION:6005,FAILED_TO_GENERATE_LICENSE_REQUEST:6006,LICENSE_REQUEST_FAILED:6007,LICENSE_RESPONSE_REJECTED:6008,ENCRYPTED_CONTENT_WITHOUT_DRM_INFO:6010,NO_LICENSE_SERVER_GIVEN:6012,OFFLINE_SESSION_REMOVED:6013,EXPIRED:6014,LOAD_INTERRUPTED:7E3,OPERATION_ABORTED:7001,NO_VIDEO_ELEMENT:7002,CAST_API_UNAVAILABLE:8E3,NO_CAST_RECEIVERS:8001,ALREADY_CASTING:8002,UNEXPECTED_CAST_ERROR:8003,CAST_CANCELED_BY_USER:8004,
CAST_CONNECTION_TIMED_OUT:8005,CAST_RECEIVER_APP_UNAVAILABLE:8006,STORAGE_NOT_SUPPORTED:9E3,INDEXED_DB_ERROR:9001,DEPRECATED_OPERATION_ABORTED:9002,REQUESTED_ITEM_NOT_FOUND:9003,MALFORMED_OFFLINE_URI:9004,CANNOT_STORE_LIVE_OFFLINE:9005,STORE_ALREADY_IN_PROGRESS:9006,NO_INIT_DATA_FOR_OFFLINE:9007,LOCAL_PLAYER_INSTANCE_REQUIRED:9008,NEW_KEY_OPERATION_NOT_SUPPORTED:9011,KEY_NOT_FOUND:9012,MISSING_STORAGE_CELL:9013};function C(b,c){this.promise=b;this.b=c;this.a=!1}y("shaka.util.AbortableOperation",C);function fb(b){return new C(Promise.reject(b),function(){return Promise.resolve()})}C.failed=fb;function gb(){var b=Promise.reject(new B(2,7,7001));b["catch"](function(){});return new C(b,function(){return Promise.resolve()})}C.aborted=gb;function hb(b){return new C(Promise.resolve(b),function(){return Promise.resolve()})}C.completed=hb;
function ib(b){return new C(b,function(){return b["catch"](function(){})})}C.notAbortable=ib;C.prototype.abort=function(){this.a=!0;return this.b()};C.prototype.abort=C.prototype.abort;function jb(b){return new C(Promise.all(b.map(function(b){return b.promise})),function(){return Promise.all(b.map(function(b){return b.abort()}))})}C.all=jb;C.prototype["finally"]=function(b){this.promise.then(function(){return b(!0)},function(){return b(!1)});return this};C.prototype["finally"]=C.prototype["finally"];
C.prototype.Y=function(b,c){function d(){f.reject(new B(2,7,7001));return e.abort()}var e=this,f=new z;this.promise.then(function(c){e.a?f.reject(new B(2,7,7001)):b?d=kb(b,c,f):f.resolve(c)},function(b){c?d=kb(c,b,f):f.reject(b)});return new C(f,function(){return d()})};C.prototype.chain=C.prototype.Y;
function kb(b,c,d){try{var e=b(c);if(e&&e.promise&&e.abort)return d.resolve(e.promise),function(){return e.abort()};d.resolve(e);return function(){return Promise.resolve(e).then(function(){})["catch"](function(){})}}catch(f){return d.reject(f),function(){return Promise.resolve()}}};function D(b,c){c=void 0===c?{}:c;for(var d in c)this[d]=c[d];this.defaultPrevented=this.cancelable=this.bubbles=!1;this.timeStamp=window.performance&&window.performance.now?window.performance.now():Date.now();this.type=b;this.isTrusted=!1;this.target=this.currentTarget=null;this.a=!1}D.prototype.preventDefault=function(){this.cancelable&&(this.defaultPrevented=!0)};D.prototype.stopImmediatePropagation=function(){this.a=!0};D.prototype.stopPropagation=function(){};function lb(){this.a={}}n=lb.prototype;n.push=function(b,c){this.a.hasOwnProperty(b)?this.a[b].push(c):this.a[b]=[c]};n.get=function(b){return(b=this.a[b])?b.slice():null};n.getAll=function(){var b=[],c;for(c in this.a)b.push.apply(b,this.a[c]);return b};n.remove=function(b,c){var d=this.a[b];if(d)for(var e=0;e<d.length;++e)d[e]==c&&(d.splice(e,1),--e)};n.forEach=function(b){for(var c in this.a)b(c,this.a[c])};function E(){this.Nb=new lb;this.pb=this}E.prototype.addEventListener=function(b,c){this.Nb.push(b,c)};E.prototype.removeEventListener=function(b,c){this.Nb.remove(b,c)};E.prototype.dispatchEvent=function(b){for(var c=this.Nb.get(b.type)||[],d=0;d<c.length;++d){b.target=this.pb;b.currentTarget=this.pb;var e=c[d];try{e.handleEvent?e.handleEvent(b):e.call(this,b)}catch(f){}if(b.a)break}return b.defaultPrevented};function mb(b){function c(b){switch(typeof b){case "undefined":case "boolean":case "number":case "string":case "symbol":case "function":return b;default:if(!b||b.buffer&&b.buffer.constructor==ArrayBuffer)return b;if(d.has(b))return null;var e=b.constructor==Array;if(b.constructor!=Object&&!e)return null;d.add(b);var g=e?[]:{},h;for(h in b)g[h]=c(b[h]);e&&(g.length=b.length);return g}}var d=new Set;return c(b)};function nb(b,c){return"number"===typeof b&&"number"===typeof c&&isNaN(b)&&isNaN(c)?!0:b===c}function ob(b,c){var d=b.indexOf(c);-1<d&&b.splice(d,1)}function pb(b,c){var d=0;b.forEach(function(b){d+=c(b)?1:0});return d}
function qb(b,c,d){d||(d=nb);if(b.length!=c.length)return!1;c=c.slice();var e={};b=q(b);for(var f=b.next();!f.done;e={item:e.item},f=b.next()){e.item=f.value;f=c.findIndex(function(b){return function(c){return d(b.item,c)}}(e));if(-1==f)return!1;c[f]=c[c.length-1];c.pop()}return 0==c.length};function rb(){this.a=[]}function sb(b,c){b.a.push(c["finally"](function(){ob(b.a,c)}))}rb.prototype.destroy=function(){var b=[];this.a.forEach(function(c){c.promise["catch"](function(){});b.push(c.abort())});this.a=[];return Promise.all(b)};function G(b){E.call(this);this.f=!1;this.g=new rb;this.a=new Set;this.b=new Set;this.c=b||null}Ea(G,E);y("shaka.net.NetworkingEngine",G);G.RequestType={MANIFEST:0,SEGMENT:1,LICENSE:2,APP:3,TIMING:4};G.PluginPriority={FALLBACK:1,PREFERRED:2,APPLICATION:3};var tb={};function wb(b,c,d){d=d||3;var e=tb[b];if(!e||d>=e.priority)tb[b]={priority:d,Ge:c}}G.registerScheme=wb;G.unregisterScheme=function(b){delete tb[b]};G.prototype.He=function(b){this.a.add(b)};G.prototype.registerRequestFilter=G.prototype.He;
G.prototype.mf=function(b){this.a["delete"](b)};G.prototype.unregisterRequestFilter=G.prototype.mf;G.prototype.Ed=function(){this.a.clear()};G.prototype.clearAllRequestFilters=G.prototype.Ed;G.prototype.Ie=function(b){this.b.add(b)};G.prototype.registerResponseFilter=G.prototype.Ie;G.prototype.nf=function(b){this.b["delete"](b)};G.prototype.unregisterResponseFilter=G.prototype.nf;G.prototype.Fd=function(){this.b.clear()};G.prototype.clearAllResponseFilters=G.prototype.Fd;
function xb(b,c){return{uris:b,method:"GET",body:null,headers:{},allowCrossSiteCredentials:!1,retryParameters:c,licenseRequestType:null}}G.prototype.destroy=function(){this.f=!0;this.a.clear();this.b.clear();return this.g.destroy()};G.prototype.destroy=G.prototype.destroy;
function yb(b){b.then=function(c,d){Ka("The network request interface has changed!  Please update your application to the new interface, which allows operations to be aborted.  Support for the old API will be removed in v2.5.");return b.promise.then(c,d)};b["catch"]=function(c){Ka("The network request interface has changed!  Please update your application to the new interface, which allows operations to be aborted.  Support for the old API will be removed in v2.5.");return b.promise["catch"](c)};
return b}
G.prototype.request=function(b,c){var d=this;if(this.f)return yb(gb());c.method=c.method||"GET";c.headers=c.headers||{};c.retryParameters=c.retryParameters?mb(c.retryParameters):db();c.uris=mb(c.uris);var e=zb(this,b,c),f=e.Y(function(){return Ab(d,b,c,new bb(c.retryParameters,!1),0,null)}),g=f.Y(function(c){return Bb(d,b,c)}),h=Date.now(),k=0;e.promise.then(function(){k=Date.now()-h},function(){});var m=0;f.promise.then(function(){m=Date.now()},function(){});e=g.Y(function(c){var e=Date.now()-m,
f=c.response;f.timeMs+=k;f.timeMs+=e;c.$d||!d.c||f.fromCache||1!=b||d.c(f.timeMs,f.data.byteLength);return f},function(b){b&&(b.severity=2);throw b;});sb(this.g,e);return yb(e)};G.prototype.request=G.prototype.request;function zb(b,c,d){var e=hb(void 0),f={};b=q(b.a);for(var g=b.next();!g.done;f={qc:f.qc},g=b.next())f.qc=g.value,e=e.Y(function(b){return function(){return b.qc(c,d)}}(f));return e.Y(void 0,function(b){if(b&&7001==b.code)throw b;throw new B(2,1,1006,b);})}
function Ab(b,c,d,e,f,g){var h=new Na(d.uris[f]),k=h.la,m=!1;k||(k=location.protocol,k=k.slice(0,-1),Oa(h,k),d.uris[f]=h.toString());var l=(k=tb[k])?k.Ge:null;if(!l)return fb(new B(2,1,1E3,h));var p;return ib(eb(e)).Y(function(){if(b.f)return gb();p=Date.now();var e=l(d.uris[f],d,c,function(d,e){b.c&&1==c&&(b.c(d,e),m=!0)});void 0==e.promise&&(Ka("The scheme plugin interface has changed!  Please update your scheme plugins to the new interface to add support for abort().  Support for the old plugin interface will be removed in v2.5."),
e=ib(e));return e}).Y(function(b){void 0==b.timeMs&&(b.timeMs=Date.now()-p);return{response:b,$d:m}},function(h){if(h&&7001==h.code)throw h;if(b.f)return gb();if(h&&1==h.severity)return b.dispatchEvent(new D("retry",{error:h instanceof B?h:null})),f=(f+1)%d.uris.length,Ab(b,c,d,e,f,h);throw h||g;})}
function Bb(b,c,d){var e=hb(void 0);b=q(b.b);for(var f=b.next();!f.done;f=b.next())e=e.Y(f.value.bind(null,c,d.response));return e.Y(function(){return d},function(b){if(b&&7001==b.code)throw b;var c=2;b instanceof B&&(c=b.severity);throw new B(c,1,1007,b);})};function Cb(){this.a=new lb}Cb.prototype.destroy=function(){Db(this);this.a=null;return Promise.resolve()};function H(b,c,d,e){b.a&&(c=new Eb(c,d,e),b.a.push(d,c))}function Fb(b,c,d,e){H(b,c,d,function(b){this.sa(c,d);e(b)}.bind(b))}Cb.prototype.sa=function(b,c){if(this.a)for(var d=this.a.get(c)||[],e=0;e<d.length;++e){var f=d[e];f.target==b&&(f.sa(),this.a.remove(c,f))}};function Db(b){if(b.a){for(var c=b.a.getAll(),d=0;d<c.length;++d)c[d].sa();b.a.a={}}}
function Eb(b,c,d){this.target=b;this.type=c;this.a=d;this.target.addEventListener(c,d,!1)}Eb.prototype.sa=function(){this.target.removeEventListener(this.type,this.a,!1);this.a=this.target=null};var I={Gd:function(b,c){return b.reduce(function(b,c,f){return c["catch"](b.bind(null,f))}.bind(null,c),Promise.reject())},Pb:function(b,c){return b.concat(c)},Ea:function(){},ta:function(b){return null!=b}};function Gb(b,c){for(var d=[],e=q(b),f=e.next();!f.done;f=e.next())d.push(c(f.value));return d}function Hb(b,c){for(var d=q(b),e=d.next();!e.done;e=d.next())if(!c(e.value))return!1;return!0};function Ib(b){var c=new Map;Object.keys(b).forEach(function(d){c.set(d,b[d])});return c}function Jb(b){var c={};b.forEach(function(b,e){c[e]=b});return c};function Kb(b,c){var d=b;c&&(d+='; codecs="'+c+'"');return d}function Lb(b){var c=[b.mimeType];Mb.forEach(function(d,e){var f=b[e];f&&c.push(d+'="'+f+'"')});return c.join(";")}function Nb(b){b=b.split(".");var c=b[0];b.pop();return[c,b.join(".")]}var Mb=(new Map).set("codecs","codecs").set("frameRate","framerate").set("bandwidth","bitrate").set("width","width").set("height","height").set("channelsCount","channels");function Ob(b){if(!b)return"";b=new Uint8Array(b);239==b[0]&&187==b[1]&&191==b[2]&&(b=b.subarray(3));b=escape(Pb(b));try{return decodeURIComponent(b)}catch(c){throw new B(2,2,2004);}}y("shaka.util.StringUtils.fromUTF8",Ob);
function Qb(b,c,d){if(!b)return"";if(!d&&0!=b.byteLength%2)throw new B(2,2,2004);if(b instanceof ArrayBuffer)var e=b;else d=new Uint8Array(b.byteLength),d.set(new Uint8Array(b)),e=d.buffer;b=Math.floor(b.byteLength/2);d=new Uint16Array(b);e=new DataView(e);for(var f=0;f<b;f++)d[f]=e.getUint16(2*f,c);return Pb(d)}y("shaka.util.StringUtils.fromUTF16",Qb);
function Rb(b){var c=new Uint8Array(b);if(239==c[0]&&187==c[1]&&191==c[2])return Ob(c);if(254==c[0]&&255==c[1])return Qb(c.subarray(2),!1);if(255==c[0]&&254==c[1])return Qb(c.subarray(2),!0);var d=function(b,c){return b.byteLength<=c||32<=b[c]&&126>=b[c]}.bind(null,c);if(0==c[0]&&0==c[2])return Qb(b,!1);if(0==c[1]&&0==c[3])return Qb(b,!0);if(d(0)&&d(1)&&d(2)&&d(3))return Ob(b);throw new B(2,2,2003);}y("shaka.util.StringUtils.fromBytesAutoDetect",Rb);
function Sb(b){b=encodeURIComponent(b);b=unescape(b);for(var c=new Uint8Array(b.length),d=0;d<b.length;++d)c[d]=b.charCodeAt(d);return c.buffer}y("shaka.util.StringUtils.toUTF8",Sb);function Pb(b){for(var c="",d=0;d<b.length;d+=16E3)c+=String.fromCharCode.apply(null,b.subarray(d,d+16E3));return c};function Tb(b){this.a=null;this.b=function(){this.a=null;b()}.bind(this)}Tb.prototype.cancel=function(){null!=this.a&&(clearTimeout(this.a),this.a=null)};function Ub(b){var c=Zb;b.cancel();b.a=setTimeout(b.b,1E3*c)}function $b(b,c){b.cancel();var d=function(){this.b();this.a=setTimeout(d,1E3*c)}.bind(b);b.a=setTimeout(d,1E3*c)};function ac(b,c){var d=Pb(b);c=void 0==c?!0:c;d=window.btoa(d).replace(/\+/g,"-").replace(/\//g,"_");return c?d:d.replace(/=*$/,"")}y("shaka.util.Uint8ArrayUtils.toBase64",ac);function bc(b){b=window.atob(b.replace(/-/g,"+").replace(/_/g,"/"));for(var c=new Uint8Array(b.length),d=0;d<b.length;++d)c[d]=b.charCodeAt(d);return c}y("shaka.util.Uint8ArrayUtils.fromBase64",bc);function cc(b){for(var c=new Uint8Array(b.length/2),d=0;d<b.length;d+=2)c[d/2]=window.parseInt(b.substr(d,2),16);return c}
y("shaka.util.Uint8ArrayUtils.fromHex",cc);function dc(b){for(var c="",d=0;d<b.length;++d){var e=b[d].toString(16);1==e.length&&(e="0"+e);c+=e}return c}y("shaka.util.Uint8ArrayUtils.toHex",dc);function ec(b,c){if(!b&&!c)return!0;if(!b||!c||b.length!=c.length)return!1;for(var d=0;d<b.length;++d)if(b[d]!=c[d])return!1;return!0}y("shaka.util.Uint8ArrayUtils.equal",ec);
function fc(b){for(var c=[],d=0;d<arguments.length;++d)c[d]=arguments[d];for(var e=d=0;e<c.length;++e)d+=c[e].length;d=new Uint8Array(d);for(var f=e=0;f<c.length;++f)d.set(c[f],e),e+=c[f].length;return d}y("shaka.util.Uint8ArrayUtils.concat",fc);function gc(b){var c=this;this.u=b;this.l=this.i=this.o=null;this.P=!1;this.a=null;this.g=new Cb;this.b=new Map;this.s=[];this.j=new z;this.f=null;this.h=function(d){c.j.reject(d);b.onError(d)};this.ia=new Map;this.Z=new Map;this.J=new Tb(function(){return hc(c)});this.A=this.c=!1;this.M=[];this.$=!1;this.B=new Tb(function(){return ic(c)});$b(this.B,1);this.j["catch"](function(){})}n=gc.prototype;
n.destroy=function(){this.c=!0;var b=[],c=this.b.keys(),d={};c=q(c);for(var e=c.next();!e.done;d={$b:d.$b},e=c.next()){e=e.value;d.$b=!1;e=e.close().then(function(b){return function(){b.$b=!0}}(d),I.Ea);var f=jc(kc).then(function(){return function(){}}(d));b.push(Promise.race([e,f]))}this.j.reject();this.g&&b.push(this.g.destroy());this.l&&b.push(this.l.setMediaKeys(null)["catch"](I.Ea));this.B&&(this.B.cancel(),this.B=null);this.J&&(this.J.cancel(),this.J=null);this.g=this.l=this.i=this.o=this.a=
null;this.b.clear();this.s=[];this.u=this.h=this.f=null;return Promise.all(b)};n.configure=function(b){this.f=b};function lc(b,c,d){b.s=[];b.A=d;return mc(b,c)}function nc(b,c,d){b.s=d;b.A=0<d.length;return mc(b,c)}
function mc(b,c){var d=c.some(function(b){return 0<b.drmInfos.length});if(!d){var e=Ib(b.f.servers);oc(c,e)}var f=pc(b);if(f){var g=q(c);for(e=g.next();!e.done;e=g.next())e.value.drmInfos=[f]}f=q(c);for(e=f.next();!e.done;e=f.next())for(e=q(e.value.drmInfos),g=e.next();!g.done;g=e.next())qc(g.value,Ib(b.f.servers),Ib(b.f.advanced||{}));e=rc(b,c);if(!e.size)return b.P=!0,Promise.resolve();e=sc(b,e);return d?e:e["catch"](function(){})}
n.wb=function(b){var c=this;if(!this.i)return Fb(this.g,b,"encrypted",function(){c.h(new B(2,6,6010))}),Promise.resolve();this.l=b;Fb(this.g,this.l,"play",function(){for(var b=0;b<c.M.length;b++)tc(c,c.M[b]);c.$=!0;c.M=[]});b=this.l.setMediaKeys(this.i);b=b["catch"](function(b){return Promise.reject(new B(2,6,6003,b.message))});var d=uc(this);return Promise.all([b,d]).then(function(){if(c.c)return Promise.reject();vc(c);c.a.initData.length||c.s.length||H(c.g,c.l,"encrypted",function(b){return wc(c,
b.initDataType,new Uint8Array(b.initData))})})["catch"](function(b){return c.c?Promise.resolve():Promise.reject(b)})};function uc(b){return r(function d(){var e;return v(d,function(d){switch(d.m){case 1:if(!(b.i&&b.a&&b.a.serverCertificate&&b.a.serverCertificate.length)){d.D(0);break}oa(d,3);return u(d,b.i.setServerCertificate(b.a.serverCertificate),5);case 5:qa(d,0);break;case 3:return e=ra(d),d["return"](Promise.reject(new B(2,6,6004,e.message)))}})})}
function vc(b){var c=b.a?b.a.initData:[];c.forEach(function(c){return xc(b,c.initDataType,c.initData)});b.s.forEach(function(c){return yc(b,c)});c.length||b.s.length||b.j.resolve();return b.j}function wc(b,c,d){var e=b.b.values();e=q(e);for(var f=e.next();!f.done;f=e.next())if(ec(d,f.value.initData))return;xc(b,c,d)}n.keySystem=function(){return this.a?this.a.keySystem:""};function zc(b){b=b.b.keys();b=Gb(b,function(b){return b.sessionId});return Array.from(b)}
n.Db=function(){var b=Infinity,c=this.b.keys();c=q(c);for(var d=c.next();!d.done;d=c.next())d=d.value,isNaN(d.expiration)||(b=Math.min(b,d.expiration));return b};
function rc(b,c){for(var d=new Set,e=q(c),f=e.next();!f.done;f=e.next()){var g=q(f.value.drmInfos);for(f=g.next();!f.done;f=g.next())d.add(f.value)}e=q(d);for(f=e.next();!f.done;f=e.next())qc(f.value,Ib(b.f.servers),Ib(b.f.advanced||{}));g=b.A?"required":"optional";var h=b.A?["persistent-license"]:["temporary"];e=new Map;d=q(d);for(f=d.next();!f.done;f=d.next())f=f.value,e.set(f.keySystem,{audioCapabilities:[],videoCapabilities:[],distinctiveIdentifier:"optional",persistentState:g,sessionTypes:h,
label:f.keySystem,drmInfos:[]});d=q(c);for(f=d.next();!f.done;f=d.next()){f=f.value;g=f.audio;h=f.video;var k=g?Kb(g.mimeType,g.codecs):"",m=h?Kb(h.mimeType,h.codecs):"",l=q(f.drmInfos);for(f=l.next();!f.done;f=l.next()){f=f.value;var p=e.get(f.keySystem);p.drmInfos.push(f);f.distinctiveIdentifierRequired&&(p.distinctiveIdentifier="required");f.persistentStateRequired&&(p.persistentState="required");g&&p.audioCapabilities.push({robustness:f.audioRobustness||"",contentType:k});h&&p.videoCapabilities.push({robustness:f.videoRobustness||
"",contentType:m})}}return e}
function sc(b,c){if(1==c.size&&c.has(""))return Promise.reject(new B(2,6,6E3));for(var d=q(c.values()),e=d.next();!e.done;e=d.next())e=e.value,0==e.audioCapabilities.length&&delete e.audioCapabilities,0==e.videoCapabilities.length&&delete e.videoCapabilities;var f=d=new z;[!0,!1].forEach(function(b){var d=this;c.forEach(function(c,e){c.drmInfos.some(function(b){return!!b.licenseServerUri})==b&&(f=f["catch"](function(){return this.c?Promise.reject():navigator.requestMediaKeySystemAccess(e,[c])}.bind(d)))})}.bind(b));
f=f["catch"](function(){return Promise.reject(new B(2,6,6001))});f=f.then(function(b){if(this.c)return Promise.reject();var d=navigator.userAgent.includes("Edge/"),e=b.getConfiguration(),f=e.audioCapabilities||[];e=e.videoCapabilities||[];this.o=new Set;var g=q(f);for(f=g.next();!f.done;f=g.next())this.o.add(f.value.contentType);e=q(e);for(f=e.next();!f.done;f=e.next())this.o.add(f.value.contentType);d&&(this.o=null);d=b.keySystem;e=c.get(b.keySystem);f=[];g=[];var p=[],t=[];Ac(e.drmInfos,f,g,p,t);
this.a={keySystem:d,licenseServerUri:f[0],distinctiveIdentifierRequired:"required"==e.distinctiveIdentifier,persistentStateRequired:"required"==e.persistentState,audioRobustness:e.audioCapabilities?e.audioCapabilities[0].robustness:"",videoRobustness:e.videoCapabilities?e.videoCapabilities[0].robustness:"",serverCertificate:g[0],initData:p,keyIds:t};return this.a.licenseServerUri?b.createMediaKeys():Promise.reject(new B(2,6,6012))}.bind(b)).then(function(b){if(this.c)return Promise.reject();this.i=
b;this.P=!0}.bind(b))["catch"](function(b){if(this.c)return Promise.resolve();this.o=this.a=null;return b instanceof B?Promise.reject(b):Promise.reject(new B(2,6,6002,b.message))}.bind(b));d.reject();return f}
function pc(b){b=Ib(b.f.clearKeys);if(0==b.size)return null;var c=[],d=[];b.forEach(function(b,e){var f=cc(e),g=cc(b);f={kty:"oct",kid:ac(f,!1),k:ac(g,!1)};c.push(f);d.push(f.kid)});b=JSON.stringify({keys:c});var e=JSON.stringify({kids:d});e=[{initData:new Uint8Array(Sb(e)),initDataType:"keyids"}];return{keySystem:"org.w3.clearkey",licenseServerUri:"data:application/json;base64,"+window.btoa(b),distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,
initData:e,keyIds:[]}}
function yc(b,c){try{var d=b.i.createSession("persistent-license")}catch(g){var e=new B(2,6,6005,g.message);b.h(e);return Promise.reject(e)}H(b.g,d,"message",b.$c.bind(b));H(b.g,d,"keystatuseschange",b.Wc.bind(b));var f={initData:null,loaded:!1,jc:Infinity,xa:null};b.b.set(d,f);return d.load(c).then(function(b){if(!this.c){if(b)return f.loaded=!0,Bc(this)&&this.j.resolve(),d;this.b["delete"](d);this.h(new B(2,6,6013))}}.bind(b),function(b){this.c||(this.b["delete"](d),this.h(new B(2,6,6005,b.message)))}.bind(b))}
function xc(b,c,d){try{var e=b.A?b.i.createSession("persistent-license"):b.i.createSession()}catch(f){b.h(new B(2,6,6005,f.message));return}H(b.g,e,"message",b.$c.bind(b));H(b.g,e,"keystatuseschange",b.Wc.bind(b));b.b.set(e,{initData:d,loaded:!1,jc:Infinity,xa:null});e.generateRequest(c,d.buffer)["catch"](function(c){b.c||(b.b["delete"](e),b.h(new B(2,6,6006,c.message)))})}n.$c=function(b){this.f.delayLicenseRequestUntilPlayed&&this.l.paused&&!this.$?this.M.push(b):tc(this,b)};
function tc(b,c){var d=c.target,e=b.b.get(d),f=b.a.licenseServerUri,g=b.f.advanced[b.a.keySystem];"individualization-request"==c.messageType&&g&&g.individualizationServer&&(f=g.individualizationServer);f=xb([f],b.f.retryParameters);f.body=c.message;f.method="POST";f.licenseRequestType=c.messageType;"com.microsoft.playready"!=b.a.keySystem&&"com.chromecast.playready"!=b.a.keySystem||Cc(f);b.u.Gb.request(2,f).promise.then(function(b){return this.c?Promise.reject():d.update(b.data).then(function(){var b=
this;this.u.onEvent(new D("drmsessionupdate"));e&&(e.xa&&e.xa.resolve(),jc(Dc).then(function(){e.loaded=!0;Bc(b)&&b.j.resolve()}))}.bind(this))}.bind(b),function(b){if(this.c)return Promise.resolve();b=new B(2,6,6007,b);this.h(b);e&&e.xa&&e.xa.reject(b)}.bind(b))["catch"](function(b){if(this.c)return Promise.resolve();b=new B(2,6,6008,b.message);this.h(b);e&&e.xa&&e.xa.reject(b)}.bind(b))}
function Cc(b){var c=Qb(b.body,!0,!0);if(c.includes("PlayReadyKeyMessage")){c=(new DOMParser).parseFromString(c,"application/xml");for(var d=c.getElementsByTagName("HttpHeader"),e=0;e<d.length;++e)b.headers[d[e].querySelector("name").textContent]=d[e].querySelector("value").textContent;b.body=bc(c.querySelector("Challenge").textContent).buffer}else b.headers["Content-Type"]="text/xml; charset=utf-8"}
n.Wc=function(b){b=b.target;var c=this.b.get(b);if(c){var d=!1;b.keyStatuses.forEach(function(b,e){if("string"==typeof e){var f=e;e=b;b=f}if("com.microsoft.playready"==this.a.keySystem&&16==e.byteLength){f=new DataView(e);var g=f.getUint32(0,!0),m=f.getUint16(4,!0),l=f.getUint16(6,!0);f.setUint32(0,g,!1);f.setUint16(4,m,!1);f.setUint16(6,l,!1)}"com.microsoft.playready"==this.a.keySystem&&"status-pending"==b&&(b="usable");"status-pending"!=b&&(c.loaded=!0);"expired"==b&&(d=!0);f=dc(new Uint8Array(e));
this.ia.set(f,b)}.bind(this));var e=b.expiration-Date.now();(0>e||d&&1E3>e)&&!c.xa&&(this.b["delete"](b),b.close()["catch"](function(){}));Bc(this)&&(this.j.resolve(),Ub(this.J))}};function hc(b){var c=b.ia,d=b.Z;d.clear();c.forEach(function(b,c){return d.set(c,b)});c=Array.from(d.values());c.length&&c.every(function(b){return"expired"==b})&&b.h(new B(2,6,6014));b.u.Vc(Jb(d))}
function Ec(){function b(b){return r(function h(){var c,f,l;return v(h,function(h){switch(h.m){case 1:return oa(h,2),u(h,navigator.requestMediaKeySystemAccess(b,d),4);case 4:return c=h.w,l=(f=c.getConfiguration().sessionTypes)?f.includes("persistent-license"):!1,navigator.userAgent.includes("Tizen 3")&&(l=!1),e.set(b,{persistentState:l}),u(h,c.createMediaKeys(),5);case 5:qa(h,0);break;case 2:ra(h),e.set(b,null),h.m=0}})})}var c=[{contentType:'video/mp4; codecs="avc1.42E01E"'},{contentType:'video/webm; codecs="vp8"'}],
d=[{videoCapabilities:c,persistentState:"required",sessionTypes:["persistent-license"]},{videoCapabilities:c}],e=new Map;c="org.w3.clearkey com.widevine.alpha com.microsoft.playready com.apple.fps.2_0 com.apple.fps.1_0 com.apple.fps com.adobe.primetime".split(" ").map(function(c){return b(c)});return Promise.all(c).then(function(){return Jb(e)})}
function Fc(b,c){if(c.audio&&c.audio.encrypted&&!Gc(b,c.audio)||c.video&&c.video.encrypted&&!Gc(b,c.video))return!1;var d=b.keySystem();return 0==c.drmInfos.length||c.drmInfos.some(function(b){return b.keySystem==d})}function Gc(b,c){return null==b.o?!0:b.o.has(Kb(c.mimeType,c.codecs))}
function Hc(b,c){if(!b.length)return c;if(!c.length)return b;for(var d=[],e=0;e<b.length;e++)for(var f=0;f<c.length;f++)if(b[e].keySystem==c[f].keySystem){var g=b[e];f=c[f];var h=[];h=h.concat(g.initData||[]);h=h.concat(f.initData||[]);var k=[];k=k.concat(g.keyIds);k=k.concat(f.keyIds);d.push({keySystem:g.keySystem,licenseServerUri:g.licenseServerUri||f.licenseServerUri,distinctiveIdentifierRequired:g.distinctiveIdentifierRequired||f.distinctiveIdentifierRequired,persistentStateRequired:g.persistentStateRequired||
f.persistentStateRequired,videoRobustness:g.videoRobustness||f.videoRobustness,audioRobustness:g.audioRobustness||f.audioRobustness,serverCertificate:g.serverCertificate||f.serverCertificate,initData:h,keyIds:k});break}return d}function ic(b){b.b.forEach(function(c,d){var e=c.jc,f=d.expiration;isNaN(f)&&(f=Infinity);f!=e&&(b.u.onExpirationUpdated(d.sessionId,f),c.jc=f)})}function Bc(b){b=b.b.values();return Hb(b,function(b){return b.loaded})}
function jc(b){return new Promise(function(c){return setTimeout(c,1E3*b)})}function oc(b,c){var d=[];c.forEach(function(b,c){d.push({keySystem:c,licenseServerUri:b,distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,initData:[],keyIds:[]})});for(var e=q(b),f=e.next();!f.done;f=e.next())f.value.drmInfos=d}
function Ac(b,c,d,e,f){b.forEach(function(b){c.includes(b.licenseServerUri)||c.push(b.licenseServerUri);b.serverCertificate&&(d.some(function(c){return ec(c,b.serverCertificate)})||d.push(b.serverCertificate));b.initData&&b.initData.forEach(function(b){e.some(function(c){return c.keyId&&c.keyId==b.keyId?!0:c.initDataType==b.initDataType&&ec(c.initData,b.initData)})||e.push(b)});if(b.keyIds)for(var g=0;g<b.keyIds.length;++g)f.includes(b.keyIds[g])||f.push(b.keyIds[g])})}
function qc(b,c,d){var e=b.keySystem;if(e){!b.licenseServerUri&&(c=c.get(e))&&(b.licenseServerUri=c);b.keyIds||(b.keyIds=[]);if(d=d.get(e))b.distinctiveIdentifierRequired||(b.distinctiveIdentifierRequired=d.distinctiveIdentifierRequired),b.persistentStateRequired||(b.persistentStateRequired=d.persistentStateRequired),b.videoRobustness||(b.videoRobustness=d.videoRobustness),b.audioRobustness||(b.audioRobustness=d.audioRobustness),b.serverCertificate||(b.serverCertificate=d.serverCertificate);window.cast&&
window.cast.__platform__&&"com.microsoft.playready"==b.keySystem&&(b.keySystem="com.chromecast.playready")}}var kc=1,Dc=5,Zb=.5;function Ic(b){return!b||1==b.length&&1E-6>b.end(0)-b.start(0)?null:b.length?b.end(b.length-1):null}function Jc(b,c,d){d=void 0===d?0:d;return!b||!b.length||1==b.length&&1E-6>b.end(0)-b.start(0)||c>b.end(b.length-1)?!1:c+d>=b.start(0)}function Kc(b,c){if(!b||!b.length||1==b.length&&1E-6>b.end(0)-b.start(0))return 0;for(var d=0,e=b.length-1;0<=e&&b.end(e)>c;--e)d+=b.end(e)-Math.max(b.start(e),c);return d}
function Lc(b){if(!b)return[];for(var c=[],d=0;d<b.length;d++)c.push({start:b.start(d),end:b.end(d)});return c};function Mc(b,c,d){this.startTime=b;this.endTime=c;this.payload=d;this.region=new Nc;this.position=null;this.positionAlign=Sc;this.size=100;this.textAlign=Tc;this.writingDirection=Uc;this.lineInterpretation=Vc;this.line=null;this.lineHeight="";this.lineAlign=Wc;this.displayAlign=Xc;this.fontSize=this.backgroundColor=this.color="";this.fontWeight=Yc;this.fontStyle=Zc;this.fontFamily="";this.textDecoration=[];this.wrapLine=!0;this.id=""}y("shaka.text.Cue",Mc);var Sc="auto";
Mc.positionAlign={LEFT:"line-left",RIGHT:"line-right",CENTER:"center",AUTO:Sc};var Tc="center",$c={LEFT:"left",RIGHT:"right",CENTER:Tc,START:"start",END:"end"};Mc.textAlign=$c;var Xc="before",ad={BEFORE:Xc,CENTER:"center",AFTER:"after"};Mc.displayAlign=ad;var Uc=0;Mc.writingDirection={HORIZONTAL_LEFT_TO_RIGHT:Uc,HORIZONTAL_RIGHT_TO_LEFT:1,VERTICAL_LEFT_TO_RIGHT:2,VERTICAL_RIGHT_TO_LEFT:3};var Vc=0;Mc.lineInterpretation={LINE_NUMBER:Vc,PERCENTAGE:1};var Wc="center",bd={CENTER:Wc,START:"start",END:"end"};
Mc.lineAlign=bd;var Yc=400;Mc.fontWeight={NORMAL:Yc,BOLD:700};var Zc="normal",cd={NORMAL:Zc,ITALIC:"italic",OBLIQUE:"oblique"};Mc.fontStyle=cd;Mc.textDecoration={UNDERLINE:"underline",LINE_THROUGH:"lineThrough",OVERLINE:"overline"};function Nc(){this.id="";this.regionAnchorY=this.regionAnchorX=this.viewportAnchorY=this.viewportAnchorX=0;this.height=this.width=100;this.viewportAnchorUnits=this.widthUnits=this.heightUnits=dd;this.scroll=ed}y("shaka.text.CueRegion",Nc);var dd=1;
Nc.units={PX:0,PERCENTAGE:dd,LINES:2};var ed="";Nc.scrollMode={NONE:ed,UP:"up"};function fd(b,c){if(0==c.length)return b;var d=c.map(function(b){return new Na(b)});return b.map(function(b){return new Na(b)}).map(function(b){return d.map(b.resolve.bind(b))}).reduce(I.Pb,[]).map(function(b){return b.toString()})}function gd(b,c){return{keySystem:b,licenseServerUri:"",distinctiveIdentifierRequired:!1,persistentStateRequired:!1,audioRobustness:"",videoRobustness:"",serverCertificate:null,initData:c||[],keyIds:[]}}var hd={xd:"video",sd:"audio",Ma:"text",vf:"application"},id=1/15;function jd(){this.a=new muxjs.mp4.Transmuxer({keepOriginalTimestamps:!0});this.b=null;this.g=[];this.c=[];this.f=!1;this.a.on("data",this.i.bind(this));this.a.on("done",this.h.bind(this))}jd.prototype.destroy=function(){this.a.dispose();this.a=null;return Promise.resolve()};function kd(b,c){return window.muxjs&&"mp2t"==b.split(";")[0].split("/")[1]?c?MediaSource.isTypeSupported(ld(c,b)):MediaSource.isTypeSupported(ld("audio",b))||MediaSource.isTypeSupported(ld("video",b)):!1}
function ld(b,c){var d=c.replace("mp2t","mp4");"audio"==b&&(d=d.replace("video","audio"));var e=/avc1\.(66|77|100)\.(\d+)/.exec(d);if(e){var f="avc1.",g=e[1],h=Number(e[2]);f=("66"==g?f+"4200":"77"==g?f+"4d00":f+"6400")+(h>>4).toString(16);f+=(h&15).toString(16);d=d.replace(e[0],f)}return d}function md(b,c){b.f=!0;b.b=new z;b.g=[];b.c=[];var d=new Uint8Array(c);b.a.push(d);b.a.flush();b.f&&b.b.reject(new B(2,3,3018));return b.b}
jd.prototype.i=function(b){for(var c=0;c<b.captions.length;c++){var d=b.captions[c];this.c.push(new Mc(d.startTime,d.endTime,d.text))}c=new Uint8Array(b.data.byteLength+b.initSegment.byteLength);c.set(b.initSegment,0);c.set(b.data,b.initSegment.byteLength);this.g.push(c)};jd.prototype.h=function(){var b={data:fc.apply(null,this.g),cues:this.c};this.b.resolve(b);this.f=!1};function nd(b){this.f=null;this.c=b;this.h=this.i=0;this.g=Infinity;this.b=this.a=null}var od={};y("shaka.text.TextEngine.registerParser",function(b,c){od[b]=c});y("shaka.text.TextEngine.unregisterParser",function(b){delete od[b]});nd.prototype.destroy=function(){this.c=this.f=null;return Promise.resolve()};nd.prototype.Ye=function(b){this.c=b};nd.prototype.setDisplayer=nd.prototype.Ye;
nd.prototype.Xb=function(b){var c={periodStart:0,segmentStart:null,segmentEnd:0};try{return this.f.parseMedia(new Uint8Array(b),c)[0].startTime}catch(d){throw new B(2,2,2009,d);}};
function pd(b,c,d,e){return Promise.resolve().then(function(){if(this.f&&this.c)if(null==d||null==e)this.f.parseInit(new Uint8Array(c));else{var b={periodStart:this.i,segmentStart:d,segmentEnd:e};b=this.f.parseMedia(new Uint8Array(c),b).filter(function(b){return b.startTime>=this.h&&b.startTime<this.g}.bind(this));this.c.append(b);null==this.a&&(this.a=Math.max(d,this.h));this.b=Math.min(e,this.g)}}.bind(b))}
nd.prototype.remove=function(b,c){return Promise.resolve().then(function(){!this.c||!this.c.remove(b,c)||null==this.a||c<=this.a||b>=this.b||(b<=this.a&&c>=this.b?this.a=this.b=null:b<=this.a&&c<this.b?this.a=c:b>this.a&&c>=this.b&&(this.b=b))}.bind(this))};nd.prototype.Cc=function(b){this.c.append(b)};nd.prototype.appendCues=nd.prototype.Cc;function qd(b){this.f=b;this.s=null;this.b={};this.a=null;this.c={};this.h=new Cb;this.o=!1;this.i={};this.l=!1;b=this.j=new z;var c=new MediaSource;Fb(this.h,c,"sourceopen",b.resolve);this.f.src=window.URL.createObjectURL(c);this.g=c}function rd(b){var c=Kb(b.mimeType,b.codecs),d=Lb(b);return!!od[c]||MediaSource.isTypeSupported(d)||kd(c,b.type)}
function sd(){var b={};'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="opus",audio/mp4; codecs="flac",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").forEach(function(c){b[c]=!!od[c]||
MediaSource.isTypeSupported(c)||kd(c);var d=c.split(";")[0];b[d]=b[d]||b[c]});return b}n=qd.prototype;
n.destroy=function(){this.o=!0;var b=[],c;for(c in this.c){var d=this.c[c],e=d[0];this.c[c]=d.slice(0,1);e&&b.push(e.p["catch"](I.Ea));for(e=1;e<d.length;++e)d[e].p["catch"](I.Ea),d[e].p.reject()}this.a&&b.push(this.a.destroy());for(var f in this.i)b.push(this.i[f].destroy());return Promise.all(b).then(function(){var b=this.h?this.h.destroy():null;this.f&&(this.f.removeAttribute("src"),this.f.load());this.s=this.a=this.g=this.f=this.h=null;this.b={};this.i={};this.c={};return b}.bind(this))};
n.init=function(b,c){var d=this;return r(function f(){var g;return v(f,function(f){switch(f.m){case 1:return g=hd,u(f,d.j,2);case 2:b.forEach(function(b,f){var h=Kb(b.mimeType,b.codecs);f==g.Ma?td(d,h):(!c&&MediaSource.isTypeSupported(h)||!kd(h,f)||(d.i[f]=new jd,h=ld(f,h)),h=d.g.addSourceBuffer(h),H(d.h,h,"error",d.hf.bind(d,f)),H(d.h,h,"updateend",d.Ua.bind(d,f)),d.b[f]=h,d.c[f]=[])}),f.m=0}})})};function td(b,c){b.a||(b.a=new nd(b.s));b.a.f=new od[c]}
function ud(b,c){if("text"==c)var d=b.a.a;else d=vd(b,c),d=!d||1==d.length&&1E-6>d.end(0)-d.start(0)?null:1==d.length&&0>d.start(0)?0:d.length?d.start(0):null;return d}function wd(b,c){return"text"==c?b.a.b:Ic(vd(b,c))}function xd(b,c,d){if("text"==c)return b=b.a,null==b.b||b.b<d?0:b.b-Math.max(d,b.a);b=vd(b,c);return Kc(b,d)}n.Ub=function(){var b=this.a&&null!=this.a.a?[{start:this.a.a,end:this.a.b}]:[];return{total:Lc(this.f.buffered),audio:Lc(vd(this,"audio")),video:Lc(vd(this,"video")),text:b}};
function vd(b,c){try{return b.b[c].buffered}catch(d){return null}}function yd(b,c,d,e,f){return"text"==c?pd(b.a,d,e,f):b.i[c]?md(b.i[c],d).then(function(b){this.a||td(this,"text/vtt");this.l&&this.a.Cc(b.cues);return zd(this,c,this.nd.bind(this,c,b.data.buffer))}.bind(b)):zd(b,c,b.nd.bind(b,c,d))}n.remove=function(b,c,d){return"text"==b?this.a.remove(c,d):zd(this,b,this.od.bind(this,b,c,d))};
function Ad(b,c){return"text"==c?b.a?b.a.remove(0,Infinity):Promise.resolve():zd(b,c,b.od.bind(b,c,0,b.g.duration))}n.flush=function(b){return"text"==b?Promise.resolve():zd(this,b,this.Kd.bind(this,b))};function Bd(b,c,d,e,f){return"text"==c?(b.a.i=d,b=b.a,b.h=e,b.g=f,Promise.resolve()):Promise.all([zd(b,c,b.zd.bind(b,c)),zd(b,c,b.$e.bind(b,c,d)),zd(b,c,b.We.bind(b,c,e,f))])}n.endOfStream=function(b){return Cd(this,function(){b?this.g.endOfStream(b):this.g.endOfStream()}.bind(this))};
n.ma=function(b){return Cd(this,function(){this.g.duration=b}.bind(this))};n.S=function(){return this.g.duration};n.nd=function(b,c){this.b[b].appendBuffer(c)};n.od=function(b,c,d){d<=c?this.Ua(b):this.b[b].remove(c,d)};n.zd=function(b){var c=this.b[b].appendWindowStart,d=this.b[b].appendWindowEnd;this.b[b].abort();this.b[b].appendWindowStart=c;this.b[b].appendWindowEnd=d;this.Ua(b)};n.Kd=function(b){this.f.currentTime-=.001;this.Ua(b)};
n.$e=function(b,c){0>c&&(c+=.001);this.b[b].timestampOffset=c;this.Ua(b)};n.We=function(b,c,d){this.b[b].appendWindowStart=0;this.b[b].appendWindowEnd=d;this.b[b].appendWindowStart=c;this.Ua(b)};n.hf=function(b){this.c[b][0].p.reject(new B(2,3,3014,this.f.error?this.f.error.code:0))};n.Ua=function(b){var c=this.c[b][0];c&&(c.p.resolve(),Dd(this,b))};
function zd(b,c,d){if(b.o)return Promise.reject();d={start:d,p:new z};b.c[c].push(d);if(1==b.c[c].length)try{d.start()}catch(e){"QuotaExceededError"==e.name?d.p.reject(new B(2,3,3017,c)):d.p.reject(new B(2,3,3015,e)),Dd(b,c)}return d.p}
function Cd(b,c){if(b.o)return Promise.reject();var d=[],e;for(e in b.b){var f=new z,g={start:function(b){b.resolve()}.bind(null,f),p:f};b.c[e].push(g);d.push(f);1==b.c[e].length&&g.start()}return Promise.all(d).then(function(){try{c()}catch(m){var b=Promise.reject(new B(2,3,3015,m))}for(var d in this.b)Dd(this,d);return b}.bind(b),function(){return Promise.reject()}.bind(b))}function Dd(b,c){b.c[c].shift();var d=b.c[c][0];if(d)try{d.start()}catch(e){d.p.reject(new B(2,3,3015,e)),Dd(b,c)}};function Ed(b,c,d){return d==c||b>=Fd&&d==c.split("-")[0]||b>=Gd&&d.split("-")[0]==c.split("-")[0]?!0:!1}function Hd(b){var c=b.indexOf("-");if(0<=c){var d=b.substring(0,c);b=b.substring(c+1)}else d=b,b="";d=d.toLowerCase();d=Id.get(d)||d;return(b=b.toUpperCase())?d+"-"+b:d}
var Fd=1,Gd=2,Id=new Map([["aar","aa"],["abk","ab"],["afr","af"],["aka","ak"],["alb","sq"],["amh","am"],["ara","ar"],["arg","an"],["arm","hy"],["asm","as"],["ava","av"],["ave","ae"],["aym","ay"],["aze","az"],["bak","ba"],["bam","bm"],["baq","eu"],["bel","be"],["ben","bn"],["bih","bh"],["bis","bi"],["bod","bo"],["bos","bs"],["bre","br"],["bul","bg"],["bur","my"],["cat","ca"],["ces","cs"],["cha","ch"],["che","ce"],["chi","zh"],["chu","cu"],["chv","cv"],["cor","kw"],["cos","co"],["cre","cr"],["cym",
"cy"],["cze","cs"],["dan","da"],["deu","de"],["div","dv"],["dut","nl"],["dzo","dz"],["ell","el"],["eng","en"],["epo","eo"],["est","et"],["eus","eu"],["ewe","ee"],["fao","fo"],["fas","fa"],["fij","fj"],["fin","fi"],["fra","fr"],["fre","fr"],["fry","fy"],["ful","ff"],["geo","ka"],["ger","de"],["gla","gd"],["gle","ga"],["glg","gl"],["glv","gv"],["gre","el"],["grn","gn"],["guj","gu"],["hat","ht"],["hau","ha"],["heb","he"],["her","hz"],["hin","hi"],["hmo","ho"],["hrv","hr"],["hun","hu"],["hye","hy"],["ibo",
"ig"],["ice","is"],["ido","io"],["iii","ii"],["iku","iu"],["ile","ie"],["ina","ia"],["ind","id"],["ipk","ik"],["isl","is"],["ita","it"],["jav","jv"],["jpn","ja"],["kal","kl"],["kan","kn"],["kas","ks"],["kat","ka"],["kau","kr"],["kaz","kk"],["khm","km"],["kik","ki"],["kin","rw"],["kir","ky"],["kom","kv"],["kon","kg"],["kor","ko"],["kua","kj"],["kur","ku"],["lao","lo"],["lat","la"],["lav","lv"],["lim","li"],["lin","ln"],["lit","lt"],["ltz","lb"],["lub","lu"],["lug","lg"],["mac","mk"],["mah","mh"],["mal",
"ml"],["mao","mi"],["mar","mr"],["may","ms"],["mkd","mk"],["mlg","mg"],["mlt","mt"],["mon","mn"],["mri","mi"],["msa","ms"],["mya","my"],["nau","na"],["nav","nv"],["nbl","nr"],["nde","nd"],["ndo","ng"],["nep","ne"],["nld","nl"],["nno","nn"],["nob","nb"],["nor","no"],["nya","ny"],["oci","oc"],["oji","oj"],["ori","or"],["orm","om"],["oss","os"],["pan","pa"],["per","fa"],["pli","pi"],["pol","pl"],["por","pt"],["pus","ps"],["que","qu"],["roh","rm"],["ron","ro"],["rum","ro"],["run","rn"],["rus","ru"],["sag",
"sg"],["san","sa"],["sin","si"],["slk","sk"],["slo","sk"],["slv","sl"],["sme","se"],["smo","sm"],["sna","sn"],["snd","sd"],["som","so"],["sot","st"],["spa","es"],["sqi","sq"],["srd","sc"],["srp","sr"],["ssw","ss"],["sun","su"],["swa","sw"],["swe","sv"],["tah","ty"],["tam","ta"],["tat","tt"],["tel","te"],["tgk","tg"],["tgl","tl"],["tha","th"],["tib","bo"],["tir","ti"],["ton","to"],["tsn","tn"],["tso","ts"],["tuk","tk"],["tur","tr"],["twi","tw"],["uig","ug"],["ukr","uk"],["urd","ur"],["uzb","uz"],["ven",
"ve"],["vie","vi"],["vol","vo"],["wel","cy"],["wln","wa"],["wol","wo"],["xho","xh"],["yid","yi"],["yor","yo"],["zha","za"],["zho","zh"],["zul","zu"]]);function Jd(b,c,d){function e(b,c,d){return b>=c&&b<=d}var f=b.video;return f&&f.width&&f.height&&!(e(f.width,c.minWidth,Math.min(c.maxWidth,d.width))&&e(f.height,c.minHeight,Math.min(c.maxHeight,d.height))&&e(f.width*f.height,c.minPixels,c.maxPixels))||!e(b.bandwidth,c.minBandwidth,c.maxBandwidth)?!1:!0}function Kd(b,c,d){var e=!1;b.forEach(function(b){var f=b.allowedByApplication;b.allowedByApplication=Jd(b,c,d);f!=b.allowedByApplication&&(e=!0)});return e}
function Ld(b,c,d,e){e.variants=e.variants.filter(function(e){if(b&&b.P&&!Fc(b,e))return!1;var f=e.audio;e=e.video;return f&&!rd(f)||e&&!rd(e)||f&&c&&!Md(f,c)||e&&d&&!Md(e,d)?!1:!0});e.textStreams=e.textStreams.filter(function(b){return!!od[Kb(b.mimeType,b.codecs)]})}function Md(b,c){return b.mimeType!=c.mimeType||b.codecs.split(".")[0]!=c.codecs.split(".")[0]?!1:!0}
function Nd(b){var c=b.audio,d=b.video,e=c?c.codecs:null,f=d?d.codecs:null,g=[];f&&g.push(f);e&&g.push(e);var h=[];d&&h.push(d.mimeType);c&&h.push(c.mimeType);h=h[0]||null;var k=[];c&&k.push(c.kind);d&&k.push(d.kind);k=k[0]||null;var m=new Set;c&&c.roles.forEach(function(b){return m.add(b)});d&&d.roles.forEach(function(b){return m.add(b)});b={id:b.id,active:!1,type:"variant",bandwidth:b.bandwidth,language:b.language,label:null,kind:k,width:null,height:null,frameRate:null,mimeType:h,codecs:g.join(", "),
audioCodec:e,videoCodec:f,primary:b.primary,roles:Array.from(m),videoId:null,audioId:null,channelsCount:null,audioBandwidth:null,videoBandwidth:null,originalVideoId:null,originalAudioId:null,originalTextId:null};d&&(b.videoId=d.id,b.originalVideoId=d.originalId,b.width=d.width||null,b.height=d.height||null,b.frameRate=d.frameRate||null,b.videoBandwidth=d.bandwidth||null);c&&(b.audioId=c.id,b.originalAudioId=c.originalId,b.channelsCount=c.channelsCount,b.audioBandwidth=c.bandwidth||null,b.label=c.label);
return b}function Od(b){return{id:b.id,active:!1,type:"text",bandwidth:0,language:b.language,label:b.label,kind:b.kind||null,width:null,height:null,frameRate:null,mimeType:b.mimeType,codecs:b.codecs||null,audioCodec:null,videoCodec:null,primary:b.primary,roles:b.roles,videoId:null,audioId:null,channelsCount:null,audioBandwidth:null,videoBandwidth:null,originalVideoId:null,originalAudioId:null,originalTextId:b.originalId}}
function Pd(b,c,d){return Qd(b.variants).map(function(b){var e=Nd(b);b.video&&b.audio?e.active=d==b.video.id&&c==b.audio.id:b.video?e.active=d==b.video.id:b.audio&&(e.active=c==b.audio.id);return e})}function Rd(b,c){return b.textStreams.map(function(b){var d=Od(b);d.active=c==b.id;return d})}function Sd(b){return b.allowedByApplication&&b.allowedByKeySystem}function Qd(b){return b.filter(function(b){return Sd(b)})}
function Td(b,c){var d=b.filter(function(b){return b.audio&&b.audio.channelsCount}).reduce(function(b,c){var d=c.audio.channelsCount;b[d]?b[d].push(c):b[d]=[c];return b},{}),e=Object.keys(d);if(0==e.length)return b;var f=e.filter(function(b){return b<=c});return f.length?d[Math.max.apply(null,f)]:d[Math.min.apply(null,e)]}
function Ud(b,c,d){var e=b,f=b.filter(function(b){return b.primary});f.length&&(e=f);var g=e.length?e[0].language:"";e=e.filter(function(b){return b.language==g});if(c){var h=Hd(c);[Gd,Fd,0].forEach(function(c){var d=!1;b.forEach(function(b){var f=Hd(b.language);Ed(c,h,f)&&(d?e.push(b):(e=[b],d=!0))})})}if(d){if(c=Vd(e,d),c.length)return c}else if(c=e.filter(function(b){return 0==b.roles.length}),c.length)return c;c=e.map(function(b){return b.roles}).reduce(I.Pb,[]);return c.length?Vd(e,c[0]):e}
function Vd(b,c){return b.filter(function(b){return b.roles.includes(c)})}function Wd(b,c,d){for(var e=0;e<d.length;e++)if(d[e].audio==b&&d[e].video==c)return d[e];return null}function Xd(b,c,d){function e(b,c){return null==b?null==c:c.id==b}for(var f=0;f<d.length;f++)if(e(b,d[f].audio)&&e(c,d[f].video))return d[f];return null}function Yd(b,c){for(var d=b.periods.length-1;0<d;--d)if(c+id>=b.periods[d].startTime)return d;return 0}
function Zd(b,c){for(var d=0;d<b.periods.length;++d){var e=b.periods[d];if("text"==c.type)for(var f=0;f<e.textStreams.length;++f){if(e.textStreams[f]==c)return d}else for(f=0;f<e.variants.length;++f){var g=e.variants[f];if(g.audio==c||g.video==c||g.video&&g.video.trickModeVideo==c)return d}}return-1}function $d(b){var c=[];b.periods.forEach(function(b){b.variants.forEach(function(b){c.push(b)})});return c}function ae(b){var c=[];b.audio&&c.push(b.audio);b.video&&c.push(b.video);return c};function J(){this.h=this.i=null;this.c=!1;this.b=new Ia;this.g=[];this.j=!1;this.a=this.f=null}y("shaka.abr.KakaotvAbrManager",J);J.prototype.stop=function(){this.h=this.i=null;this.c=!1;this.g=[];this.f=null};J.prototype.stop=J.prototype.stop;J.prototype.init=function(b){this.i=b};J.prototype.init=J.prototype.init;
J.prototype.chooseVariant=function(){var b=be(this.a.restrictions,this.g),c=this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate);this.g.length&&!b.length&&(b=be(null,this.g),b=[b[0]]);for(var d=b[0]||null,e=0;e<b.length;++e){var f=b[e],g=(b[e+1]||{bandwidth:Infinity}).bandwidth/this.a.bandwidthUpgradeTarget;c>=f.bandwidth/this.a.bandwidthDowngradeTarget&&c<=g&&(d=f)}this.f=Date.now();return d};J.prototype.chooseVariant=J.prototype.chooseVariant;J.prototype.enable=function(){this.c=!0};
J.prototype.enable=J.prototype.enable;J.prototype.disable=function(){this.c=!1};J.prototype.disable=J.prototype.disable;J.prototype.segmentDownloaded=function(b,c){Ja(this.b,b,c);if(null!=this.f&&this.c)a:{if(!this.j){if(!(128E3<=this.b.a))break a;this.j=!0}else if(Date.now()-this.f<1E3*this.a.switchInterval)break a;var d=this.chooseVariant();this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate);this.i(d)}this.h&&this.h({Bf:b,Ef:c,Cf:this.f,enabled:this.c,yf:this.b})};
J.prototype.segmentDownloaded=J.prototype.segmentDownloaded;J.prototype.getBandwidthEstimate=function(){return this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate)};J.prototype.getBandwidthEstimate=J.prototype.getBandwidthEstimate;J.prototype.setVariants=function(b){this.g=b};J.prototype.setVariants=J.prototype.setVariants;J.prototype.configure=function(b){this.a=b};J.prototype.configure=J.prototype.configure;
function be(b,c){b&&(c=c.filter(function(c){return Jd(c,b,{width:Infinity,height:Infinity})}));return c.sort(function(b,c){return b.bandwidth-c.bandwidth})};function K(){this.h=null;this.f=!1;this.b=new Ia;this.c=[];this.i=!1;this.a=this.g=null}y("shaka.abr.SimpleAbrManager",K);K.prototype.stop=function(){this.h=null;this.f=!1;this.c=[];this.g=null};K.prototype.stop=K.prototype.stop;K.prototype.init=function(b){this.h=b};K.prototype.init=K.prototype.init;
K.prototype.chooseVariant=function(){var b=ce(this.a.restrictions,this.c),c=this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate);this.c.length&&!b.length&&(b=ce(null,this.c),b=[b[0]]);for(var d=b[0]||null,e=0;e<b.length;++e){var f=b[e],g=(b[e+1]||{bandwidth:Infinity}).bandwidth/this.a.bandwidthUpgradeTarget;c>=f.bandwidth/this.a.bandwidthDowngradeTarget&&c<=g&&(d=f)}this.g=Date.now();return d};K.prototype.chooseVariant=K.prototype.chooseVariant;K.prototype.enable=function(){this.f=!0};
K.prototype.enable=K.prototype.enable;K.prototype.disable=function(){this.f=!1};K.prototype.disable=K.prototype.disable;K.prototype.segmentDownloaded=function(b,c){Ja(this.b,b,c);if(null!=this.g&&this.f)a:{if(!this.i){if(!(128E3<=this.b.a))break a;this.i=!0}else if(Date.now()-this.g<1E3*this.a.switchInterval)break a;var d=this.chooseVariant();this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate);this.h(d)}};K.prototype.segmentDownloaded=K.prototype.segmentDownloaded;
K.prototype.getBandwidthEstimate=function(){return this.b.getBandwidthEstimate(this.a.defaultBandwidthEstimate)};K.prototype.getBandwidthEstimate=K.prototype.getBandwidthEstimate;K.prototype.setVariants=function(b){this.c=b};K.prototype.setVariants=K.prototype.setVariants;K.prototype.configure=function(b){this.a=b};K.prototype.configure=K.prototype.configure;
function ce(b,c){b&&(c=c.filter(function(c){return Jd(c,b,{width:Infinity,height:Infinity})}));return c.sort(function(b,c){return b.bandwidth-c.bandwidth})};var de="ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "),ee="buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "),fe=["loop","playbackRate"],ge=["pause","play"],he="adaptation buffering emsg error loading streaming texttrackvisibility timelineregionadded timelineregionenter timelineregionexit trackschanged unloading".split(" "),ie={getAssetUri:2,getAudioLanguages:2,getAudioLanguagesAndRoles:2,
getBufferedInfo:2,getConfiguration:2,getExpiration:2,getPlaybackRate:2,getTextLanguages:2,getTextLanguagesAndRoles:2,getTextTracks:2,getStats:5,usingEmbeddedTextTrack:2,getVariantTracks:2,isAudioOnly:10,isBuffering:1,isInProgress:1,isLive:10,isTextTrackVisible:1,keySystem:10,seekRange:1},je={getPlayheadTimeAsDate:1,getPresentationStartTimeAsDate:20},ke=[["getConfiguration","configure"]],le=[["isTextTrackVisible","setTextTrackVisibility"]],me="addTextTrack cancelTrickPlay configure resetConfiguration retryStreaming selectAudioLanguage selectEmbeddedTextTrack selectTextLanguage selectTextTrack selectVariantTrack setTextTrackVisibility trickPlay".split(" "),
ne=["attach","detach","load","unload"];
function oe(b){return JSON.stringify(b,function(b,d){if("function"!=typeof d){if(d instanceof Event||d instanceof D){var c={},f;for(f in d){var g=d[f];g&&"object"==typeof g?"detail"==f&&(c[f]=g):f in Event||(c[f]=g)}return c}if(d instanceof TimeRanges)for(c={__type__:"TimeRanges",length:d.length,start:[],end:[]},f=0;f<d.length;++f)c.start.push(d.start(f)),c.end.push(d.end(f));else c="number"==typeof d?isNaN(d)?"NaN":isFinite(d)?d:0>d?"-Infinity":"Infinity":d;return c}})}
function pe(b){return JSON.parse(b,function(b,d){return"NaN"==d?NaN:"-Infinity"==d?-Infinity:"Infinity"==d?Infinity:d&&"object"==typeof d&&"TimeRanges"==d.__type__?qe(d):d})}function qe(b){return{length:b.length,start:function(c){return b.start[c]},end:function(c){return b.end[c]}}};function re(b,c,d,e,f,g){this.M=b;this.g=c;this.P=d;this.j=!1;this.B=e;this.J=f;this.u=g;this.b=this.h=!1;this.A="";this.i=null;this.l=this.Tc.bind(this);this.o=this.ke.bind(this);this.a={video:{},player:{}};this.s=0;this.c={};this.f=null}var se=!1,te=null;n=re.prototype;n.destroy=function(){ue(this);te&&ve(this);this.J=this.B=this.g=null;this.b=this.h=!1;this.o=this.l=this.f=this.c=this.a=this.i=null;return Promise.resolve()};n.ba=function(){return this.b};n.nc=function(){return this.A};
n.init=function(){if(window.chrome&&chrome.cast&&chrome.cast.isAvailable){delete window.__onGCastApiAvailable;this.h=!0;this.g();var b=new chrome.cast.SessionRequest(this.M);b=new chrome.cast.ApiConfig(b,this.Uc.bind(this),this.qe.bind(this),"origin_scoped");chrome.cast.initialize(b,function(){},function(){});se&&setTimeout(this.g.bind(this),20);(b=te)&&b.status!=chrome.cast.SessionStatus.STOPPED?this.Uc(b):te=null}else window.__onGCastApiAvailable=function(b){b&&this.init()}.bind(this)};
n.sc=function(b){this.i=b;this.b&&we({type:"appData",appData:this.i})};n.cast=function(b){if(!this.h)return Promise.reject(new B(1,8,8E3));if(!se)return Promise.reject(new B(1,8,8001));if(this.b)return Promise.reject(new B(1,8,8002));this.f=new z;chrome.cast.requestSession(this.kc.bind(this,b),this.Sc.bind(this));return this.f};n.Bb=function(){this.b&&(ue(this),te&&(ve(this),te.stop(function(){},function(){}),te=null))};
n.get=function(b,c){if("video"==b){if(ge.includes(c))return this.ed.bind(this,b,c)}else if("player"==b){if(je[c]&&!this.get("player","isLive")())return function(){};if(me.includes(c))return this.ed.bind(this,b,c);if(ne.includes(c))return this.Ke.bind(this,b,c);if(ie[c])return this.bd.bind(this,b,c)}return this.bd(b,c)};n.set=function(b,c,d){this.a[b][c]=d;we({type:"set",targetName:b,property:c,value:d})};
n.kc=function(b,c){te=c;c.addUpdateListener(this.l);c.addMessageListener("urn:x-cast:com.google.shaka.v2",this.o);this.Tc();we({type:"init",initState:b,appData:this.i});this.f.resolve()};n.Sc=function(b){var c=8003;switch(b.code){case "cancel":c=8004;break;case "timeout":c=8005;break;case "receiver_unavailable":c=8006}this.f.reject(new B(2,8,c,b))};n.bd=function(b,c){return this.a[b][c]};
n.ed=function(b,c,d){for(var e=[],f=2;f<arguments.length;++f)e[f-2]=arguments[f];we({type:"call",targetName:b,methodName:c,args:e})};n.Ke=function(b,c,d){for(var e=[],f=2;f<arguments.length;++f)e[f-2]=arguments[f];f=new z;var g=this.s.toString();this.s++;this.c[g]=f;we({type:"asyncCall",targetName:b,methodName:c,args:e,id:g});return f};n.Uc=function(b){var c=this.u();this.f=new z;this.j=!0;this.kc(c,b)};n.qe=function(b){se="available"==b;this.g()};
function ve(b){var c=te;c.removeUpdateListener(b.l);c.removeMessageListener("urn:x-cast:com.google.shaka.v2",b.o)}n.Tc=function(){var b=te?"connected"==te.status:!1;if(this.b&&!b){this.J();for(var c in this.a)this.a[c]={};ue(this)}this.A=(this.b=b)?te.receiver.friendlyName:"";this.g()};function ue(b){for(var c in b.c){var d=b.c[c];delete b.c[c];d.reject(new B(1,7,7E3))}}
n.ke=function(b,c){var d=pe(c);switch(d.type){case "event":var e=d.event;this.B(d.targetName,new D(e.type,e));break;case "update":e=d.update;for(var f in e){d=this.a[f]||{};for(var g in e[f])d[g]=e[f][g]}this.j&&(this.P(),this.j=!1);break;case "asyncComplete":if(f=d.id,d=d.error,g=this.c[f],delete this.c[f],g)if(d){f=new B(d.severity,d.category,d.code);for(e in d)f[e]=d[e];g.reject(f)}else g.resolve()}};function we(b){b=oe(b);te.sendMessage("urn:x-cast:com.google.shaka.v2",b,function(){},La)};function L(b,c,d){E.call(this);this.c=b;this.b=c;this.i=this.g=this.f=this.j=this.h=null;this.a=new re(d,this.cf.bind(this),this.df.bind(this),this.ef.bind(this),this.ff.bind(this),this.Kc.bind(this));xe(this)}Ea(L,E);y("shaka.cast.CastProxy",L);L.prototype.destroy=function(b){b&&this.a&&this.a.Bb();b=[this.i?this.i.destroy():null,this.b?this.b.destroy():null,this.a?this.a.destroy():null];this.a=this.i=this.j=this.h=this.b=this.c=null;return Promise.all(b)};L.prototype.destroy=L.prototype.destroy;
L.prototype.Zd=function(){return this.h};L.prototype.getVideo=L.prototype.Zd;L.prototype.Td=function(){return this.j};L.prototype.getPlayer=L.prototype.Td;L.prototype.Bd=function(){return this.a?this.a.h&&se:!1};L.prototype.canCast=L.prototype.Bd;L.prototype.ba=function(){return this.a?this.a.ba():!1};L.prototype.isCasting=L.prototype.ba;L.prototype.nc=function(){return this.a?this.a.nc():""};L.prototype.receiverName=L.prototype.nc;L.prototype.cast=function(){var b=this.Kc();return this.a.cast(b).then(function(){if(this.b)return this.b.nb()}.bind(this))};
L.prototype.cast=L.prototype.cast;L.prototype.sc=function(b){this.a.sc(b)};L.prototype.setAppData=L.prototype.sc;L.prototype.kf=function(){var b=this.a;if(b.b){var c=b.u();chrome.cast.requestSession(b.kc.bind(b,c),b.Sc.bind(b))}};L.prototype.suggestDisconnect=L.prototype.kf;L.prototype.Bb=function(){this.a.Bb()};L.prototype.forceDisconnect=L.prototype.Bb;
function xe(b){b.a.init();b.i=new Cb;de.forEach(function(b){H(this.i,this.c,b,this.tf.bind(this))}.bind(b));he.forEach(function(b){H(this.i,this.b,b,this.Fe.bind(this))}.bind(b));b.h={};for(var c in b.c)Object.defineProperty(b.h,c,{configurable:!1,enumerable:!0,get:b.sf.bind(b,c),set:b.uf.bind(b,c)});b.j={};for(var d in b.b)Object.defineProperty(b.j,d,{configurable:!1,enumerable:!0,get:b.ad.bind(b,d)});b.f=new E;b.f.pb=b.h;b.g=new E;b.g.pb=b.j}n=L.prototype;
n.Kc=function(){var b={video:{},player:{},playerAfterLoad:{},manifest:this.b.Tb(),startTime:null};this.c.pause();fe.forEach(function(c){b.video[c]=this.c[c]}.bind(this));this.c.ended||(b.startTime=this.c.currentTime);ke.forEach(function(c){var d=c[1];c=this.b[c[0]]();b.player[d]=c}.bind(this));le.forEach(function(c){var d=c[1];c=this.b[c[0]]();b.playerAfterLoad[d]=c}.bind(this));return b};n.cf=function(){this.dispatchEvent(new D("caststatuschanged"))};
n.df=function(){this.f.dispatchEvent(new D(this.h.paused?"pause":"play"))};
n.ff=function(){var b=this;ke.forEach(function(b){var c=b[1];b=this.a.get("player",b[0])();this.b[c](b)}.bind(this));var c=this.a.get("player","getAssetUri")(),d=this.a.get("video","ended"),e=Promise.resolve(),f=this.c.autoplay,g=null;d||(g=this.a.get("video","currentTime"));c&&(this.c.autoplay=!1,e=this.b.load(c,g));var h={};fe.forEach(function(b){h[b]=this.a.get("video",b)}.bind(this));e.then(function(){b.c&&(fe.forEach(function(b){this.c[b]=h[b]}.bind(b)),le.forEach(function(b){var c=b[1];b=this.a.get("player",
b[0])();this.b[c](b)}.bind(b)),b.c.autoplay=f,c&&b.c.play())},function(c){b.b.dispatchEvent(new D("error",{detail:c}))})};n.sf=function(b){if("addEventListener"==b)return this.f.addEventListener.bind(this.f);if("removeEventListener"==b)return this.f.removeEventListener.bind(this.f);if(this.a.ba()&&0==Object.keys(this.a.a.video).length){var c=this.c[b];if("function"!=typeof c)return c}return this.a.ba()?this.a.get("video",b):(b=this.c[b],"function"==typeof b&&(b=b.bind(this.c)),b)};
n.uf=function(b,c){this.a.ba()?this.a.set("video",b,c):this.c[b]=c};n.tf=function(b){this.a.ba()||this.f.dispatchEvent(new D(b.type,b))};
n.ad=function(b){if("addEventListener"==b)return this.g.addEventListener.bind(this.g);if("removeEventListener"==b)return this.g.removeEventListener.bind(this.g);if("getMediaElement"==b)return function(){return this.h}.bind(this);if("getSharedConfiguration"==b)return this.a.get("player","getConfiguration");if("getNetworkingEngine"==b)return this.b.Oa.bind(this.b);if(this.a.ba()){if("getManifest"==b||"drmInfo"==b)return function(){Ka(b+"() does not work while casting!");return null};if("getManifestUri"==
b)return Ka('"getManifestUri" is deprecated. Please use "getAssetUri".'),this.ad("getAssetUri");if("attach"==b||"detach"==b)return function(){Ka(b+"() does not work while casting!");return Promise.resolve()}}return this.a.ba()&&0==Object.keys(this.a.a.video).length&&ie[b]||!this.a.ba()?this.b[b].bind(this.b):this.a.get("player",b)};n.Fe=function(b){this.a.ba()||this.g.dispatchEvent(b)};n.ef=function(b,c){this.a.ba()&&("video"==b?this.f.dispatchEvent(c):"player"==b&&this.g.dispatchEvent(c))};function ye(b,c,d,e){E.call(this);this.a=b;this.b=c;this.c=new Cb;this.u={video:b,player:c};this.A=d||function(){};this.B=e||function(b){return b};this.s=!1;this.h=!0;this.g=0;this.o=!1;this.j=!0;this.l=this.i=this.f=null;ze(this)}Ea(ye,E);y("shaka.cast.CastReceiver",ye);ye.prototype.isConnected=function(){return this.s};ye.prototype.isConnected=ye.prototype.isConnected;ye.prototype.ce=function(){return this.h};ye.prototype.isIdle=ye.prototype.ce;
ye.prototype.destroy=function(){var b=[this.c?this.c.destroy():null,this.b?this.b.destroy():null];null!=this.l&&window.clearTimeout(this.l);this.A=this.u=this.c=this.b=this.a=null;this.s=!1;this.h=!0;this.l=this.i=this.f=null;return Promise.all(b).then(function(){cast.receiver.CastReceiverManager.getInstance().stop()})};ye.prototype.destroy=ye.prototype.destroy;
function ze(b){var c=cast.receiver.CastReceiverManager.getInstance();c.onSenderConnected=b.Zc.bind(b);c.onSenderDisconnected=b.Zc.bind(b);c.onSystemVolumeChanged=b.Id.bind(b);b.i=c.getCastMessageBus("urn:x-cast:com.google.cast.media");b.i.onMessage=b.ge.bind(b);b.f=c.getCastMessageBus("urn:x-cast:com.google.shaka.v2");b.f.onMessage=b.te.bind(b);c.start();de.forEach(function(b){H(this.c,this.a,b,this.cd.bind(this,"video"))}.bind(b));he.forEach(function(b){H(this.c,this.b,b,this.cd.bind(this,"player"))}.bind(b));
cast.__platform__&&cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160')?b.b.tc(3840,2160):b.b.tc(1920,1080);H(b.c,b.a,"loadeddata",function(){this.o=!0}.bind(b));H(b.c,b.b,"loading",function(){this.h=!1;Ae(this)}.bind(b));H(b.c,b.a,"playing",function(){this.h=!1;Ae(this)}.bind(b));H(b.c,b.a,"pause",function(){Ae(this)}.bind(b));H(b.c,b.b,"unloading",function(){this.h=!0;Ae(this)}.bind(b));H(b.c,b.a,"ended",function(){window.setTimeout(function(){this.a&&this.a.ended&&
(this.h=!0,Ae(this))}.bind(this),5E3)}.bind(b))}n=ye.prototype;n.Zc=function(){this.g=0;this.j=!0;this.s=0!=cast.receiver.CastReceiverManager.getInstance().getSenders().length;Ae(this)};function Ae(b){Promise.resolve().then(function(){this.b&&(this.dispatchEvent(new D("caststatuschanged")),Be(this)||Ce(this,0))}.bind(b))}
function De(b,c,d){for(var e in c.player)b.b[e](c.player[e]);b.A(d);d=Promise.resolve();var f=b.a.autoplay;c.manifest&&(b.a.autoplay=!1,d=b.b.load(c.manifest,c.startTime));d.then(function(){if(b.b){for(var d in c.video)b.a[d]=c.video[d];for(var e in c.playerAfterLoad)b.b[e](c.playerAfterLoad[e]);b.a.autoplay=f;c.manifest&&(b.a.play(),Ce(b,0))}},function(c){b.b.dispatchEvent(new D("error",{detail:c}))})}n.cd=function(b,c){this.b&&(this.lc(),Ee(this,{type:"event",targetName:b,event:c},this.f))};
n.lc=function(){null!=this.l&&window.clearTimeout(this.l);this.l=window.setTimeout(this.lc.bind(this),500);var b={video:{},player:{}};ee.forEach(function(c){b.video[c]=this.a[c]}.bind(this));if(this.b.W())for(var c in je)0==this.g%je[c]&&(b.player[c]=this.b[c]());for(var d in ie)0==this.g%ie[d]&&(b.player[d]=this.b[d]());if(c=cast.receiver.CastReceiverManager.getInstance().getSystemVolume())b.video.volume=c.level,b.video.muted=c.muted;this.o&&(this.g+=1);Ee(this,{type:"update",update:b},this.f);Be(this)};
function Be(b){return b.j&&(b.a.duration||b.b.W())?(Fe(b),b.j=!1,!0):!1}function Fe(b){var c={contentId:b.b.Tb(),streamType:b.b.W()?"LIVE":"BUFFERED",duration:b.a.duration,contentType:""};Ce(b,0,c)}n.Id=function(){var b=cast.receiver.CastReceiverManager.getInstance().getSystemVolume();b&&Ee(this,{type:"update",update:{video:{volume:b.level,muted:b.muted}}},this.f);Ee(this,{type:"event",targetName:"video",event:{type:"volumechange"}},this.f)};
n.te=function(b){var c=pe(b.data);switch(c.type){case "init":this.g=0;this.o=!1;this.j=!0;De(this,c.initState,c.appData);this.lc();break;case "appData":this.A(c.appData);break;case "set":var d=c.targetName,e=c.property;c=c.value;if("video"==d){var f=cast.receiver.CastReceiverManager.getInstance();if("volume"==e){f.setSystemVolumeLevel(c);break}else if("muted"==e){f.setSystemVolumeMuted(c);break}}this.u[d][e]=c;break;case "call":d=this.u[c.targetName];d[c.methodName].apply(d,c.args);break;case "asyncCall":d=
c.targetName;e=c.methodName;"player"==d&&"load"==e&&(this.g=0,this.o=!1);f=c.id;b=b.senderId;var g=this.u[d];c=g[e].apply(g,c.args);"player"==d&&"load"==e&&(c=c.then(function(){this.j=!0}.bind(this)));c.then(this.jd.bind(this,b,f,null),this.jd.bind(this,b,f))}};
n.ge=function(b){var c=pe(b.data);switch(c.type){case "PLAY":this.a.play();Ce(this,0);break;case "PAUSE":this.a.pause();Ce(this,0);break;case "SEEK":b=c.currentTime;var d=c.resumeState;null!=b&&(this.a.currentTime=Number(b));d&&"PLAYBACK_START"==d?(this.a.play(),Ce(this,0)):d&&"PLAYBACK_PAUSE"==d&&(this.a.pause(),Ce(this,0));break;case "STOP":this.b.nb().then(function(){this.b&&Ce(this,0)}.bind(this));break;case "GET_STATUS":Ce(this,Number(c.requestId));break;case "VOLUME":d=c.volume;b=d.level;d=
d.muted;var e=this.a.volume,f=this.a.muted;null!=b&&(this.a.volume=Number(b));null!=d&&(this.a.muted=d);e==this.a.volume&&f==this.a.muted||Ce(this,0);break;case "LOAD":this.g=0;this.j=this.o=!1;b=c.currentTime;d=this.B(c.media.contentId);this.a.autoplay=!0;this.b.load(d,b).then(function(){this.b&&Fe(this)}.bind(this))["catch"](function(b){var d="LOAD_FAILED";7==b.category&&7E3==b.code&&(d="LOAD_CANCELLED");Ee(this,{requestId:Number(c.requestId),type:d},this.i)}.bind(this));break;default:Ee(this,{requestId:Number(c.requestId),
type:"INVALID_REQUEST",reason:"INVALID_COMMAND"},this.i)}};n.jd=function(b,c,d){this.b&&Ee(this,{type:"asyncComplete",id:c,error:d},this.f,b)};function Ee(b,c,d,e){b.s&&(b=oe(c),e?d.getCastChannel(e).send(b):d.broadcast(b))}
function Ce(b,c,d){var e=b.a.playbackRate;var f=Ge;f=b.h?f.IDLE:b.b.Oc()?f.td:b.a.paused?f.vd:f.wd;e={mediaSessionId:0,playbackRate:e,playerState:f,currentTime:b.a.currentTime,supportedMediaCommands:15,volume:{level:b.a.volume,muted:b.a.muted}};d&&(e.media=d);Ee(b,{requestId:c,type:"MEDIA_STATUS",status:[e]},b.i)}var Ge={IDLE:"IDLE",wd:"PLAYING",td:"BUFFERING",vd:"PAUSED"};var M={Ab:function(b,c){var d=M.N(b,c);return 1!=d.length?null:d[0]},N:function(b,c){return Array.prototype.filter.call(b.childNodes,function(b){return b instanceof Element&&b.tagName==c})},Jd:function(b,c,d){return Array.prototype.filter.call(b.childNodes,function(b){return b instanceof Element&&b.localName==d&&b.namespaceURI==c})},getAttributeNS:function(b,c,d){return b.hasAttributeNS(c,d)?b.getAttributeNS(c,d):null},Cb:function(b){return Array.prototype.every.call(b.childNodes,function(b){return b.nodeType==
Node.TEXT_NODE||b.nodeType==Node.CDATA_SECTION_NODE})?b.textContent.trim():null},G:function(b,c,d,e){e=void 0===e?null:e;var f=null;b=b.getAttribute(c);null!=b&&(f=d(b));return null==f?e:f},Be:function(b){if(!b)return null;/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(b)&&(b+="Z");b=Date.parse(b);return isNaN(b)?null:Math.floor(b/1E3)},qa:function(b){if(!b)return null;b=/^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$/.exec(b);if(!b)return null;b=31536E3*
Number(b[1]||null)+2592E3*Number(b[2]||null)+86400*Number(b[3]||null)+3600*Number(b[4]||null)+60*Number(b[5]||null)+Number(b[6]||null);return isFinite(b)?b:null},Jb:function(b){var c=/([0-9]+)-([0-9]+)/.exec(b);if(!c)return null;b=Number(c[1]);if(!isFinite(b))return null;c=Number(c[2]);return isFinite(c)?{start:b,end:c}:null},parseInt:function(b){b=Number(b);return 0===b%1?b:null},Ib:function(b){b=Number(b);return 0===b%1&&0<b?b:null},Va:function(b){b=Number(b);return 0===b%1&&0<=b?b:null},parseFloat:function(b){b=
Number(b);return isNaN(b)?null:b},Hd:function(b){var c;b=(c=b.match(/^(\d+)\/(\d+)$/))?Number(c[1]/c[2]):Number(b);return isNaN(b)?null:b}};var He=(new Map).set("urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b","org.w3.clearkey").set("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed","com.widevine.alpha").set("urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95","com.microsoft.playready").set("urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb","com.adobe.primetime");
function Ie(b,c,d){var e=Je(b),f=null;b=[];var g=[],h=new Set(e.map(function(b){return b.keyId}));h["delete"](null);if(1<h.size)throw new B(2,4,4010);d||(g=e.filter(function(b){return"urn:mpeg:dash:mp4protection:2011"==b.hd?(f=b.init||f,!1):!0}),g.length&&(b=Ke(f,c,g),0==b.length&&(b=[gd("",f)])));if(e.length&&(d||!g.length))for(b=[],c=q(He.values()),d=c.next();!d.done;d=c.next())d=d.value,"org.w3.clearkey"!=d&&b.push(gd(d,f));if(h=Array.from(h)[0]||null)for(c=q(b),d=c.next();!d.done;d=c.next())for(d=
q(d.value.initData),e=d.next();!e.done;e=d.next())e.value.keyId=h;return{Ec:h,Af:f,drmInfos:b,Jc:!0}}function Le(b,c,d,e){var f=Ie(b,c,e);if(d.Jc){b=1==d.drmInfos.length&&!d.drmInfos[0].keySystem;c=0==f.drmInfos.length;if(0==d.drmInfos.length||b&&!c)d.drmInfos=f.drmInfos;d.Jc=!1}else if(0<f.drmInfos.length&&(d.drmInfos=d.drmInfos.filter(function(b){return f.drmInfos.some(function(c){return c.keySystem==b.keySystem})}),0==d.drmInfos.length))throw new B(2,4,4008);return f.Ec||d.Ec}
function Ke(b,c,d){var e=[];d=q(d);for(var f=d.next();!f.done;f=d.next()){f=f.value;var g=He.get(f.hd);if(g)e.push(gd(g,f.init||b));else for(f=c(f.node)||[],f=q(f),g=f.next();!g.done;g=f.next())e.push(g.value)}return e}function Je(b){var c=[];b=q(b);for(var d=b.next();!d.done;d=b.next())(d=Me(d.value))&&c.push(d);return c}
function Me(b){var c=b.getAttribute("schemeIdUri"),d=M.getAttributeNS(b,"urn:mpeg:cenc:2013","default_KID"),e=M.Jd(b,"urn:mpeg:cenc:2013","pssh").map(M.Cb);if(!c)return null;c=c.toLowerCase();if(d&&(d=d.replace(/-/g,"").toLowerCase(),d.includes(" ")))throw new B(2,4,4009);var f=[];try{f=e.map(function(b){return{initDataType:"cenc",initData:bc(b),keyId:null}})}catch(g){throw new B(2,4,4007);}return{node:b,hd:c,keyId:d,init:0<f.length?f:null}};function Ne(b,c,d,e,f){var g={RepresentationID:c,Number:d,Bandwidth:e,Time:f};return b.replace(/\$(RepresentationID|Number|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g,function(b,c,d,e){if("$$"==b)return"$";var f=g[c];if(null==f)return b;"RepresentationID"==c&&d&&(d=void 0);"Time"==c&&(f=Math.round(f));switch(e){case void 0:case "d":case "i":case "u":b=f.toString();break;case "o":b=f.toString(8);break;case "x":b=f.toString(16);break;case "X":b=f.toString(16).toUpperCase();break;default:b=f.toString()}d=
window.parseInt(d,10)||1;return Array(Math.max(0,d-b.length)+1).join("0")+b})}
function Oe(b,c){var d=Pe(b,c,"timescale"),e=1;d&&(e=M.Ib(d)||1);d=Pe(b,c,"duration");(d=M.Ib(d||""))&&(d/=e);var f=Pe(b,c,"startNumber"),g=Number(Pe(b,c,"presentationTimeOffset"))||0,h=M.Va(f||"");if(null==f||null==h)h=1;var k=Qe(b,c,"SegmentTimeline");f=null;if(k){f=e;var m=b.O.duration||Infinity;k=M.N(k,"S");for(var l=[],p=0,t=0;t<k.length;++t){var w=k[t],x=M.G(w,"t",M.Va),A=M.G(w,"d",M.Va);w=M.G(w,"r",M.parseInt);null!=x&&(x-=g);if(!A)break;x=null!=x?x:p;w=w||0;if(0>w)if(t+1<k.length){w=M.G(k[t+
1],"t",M.Va);if(null==w)break;else if(x>=w)break;w=Math.ceil((w-x)/A)-1}else{if(Infinity==m)break;else if(x/f>=m)break;w=Math.ceil((m*f-x)/A)-1}0<l.length&&x!=p&&(l[l.length-1].end=x/f);for(var F=0;F<=w;++F)p=x+A,l.push({start:x/f,end:p/f,pf:x}),x=p}f=l}return{timescale:e,T:d,Ja:h,ga:g/e||0,yc:g,K:f}}function Pe(b,c,d){return[c(b.v),c(b.X),c(b.ea)].filter(I.ta).map(function(b){return b.getAttribute(d)}).reduce(function(b,c){return b||c})}
function Qe(b,c,d){return[c(b.v),c(b.X),c(b.ea)].filter(I.ta).map(function(b){return M.Ab(b,d)}).reduce(function(b,c){return b||c})}function Re(b,c){var d=new DOMParser;try{var e=Ob(b);var f=d.parseFromString(e,"text/xml")}catch(h){}if(f&&f.documentElement.tagName==c)var g=f.documentElement;return g&&0<g.getElementsByTagName("parsererror").length?null:g}
function Se(b,c,d,e,f,g){for(var h=M.getAttributeNS(b,"http://www.w3.org/1999/xlink","href"),k=M.getAttributeNS(b,"http://www.w3.org/1999/xlink","actuate")||"onRequest",m=0;m<b.attributes.length;m++){var l=b.attributes[m];"http://www.w3.org/1999/xlink"==l.namespaceURI&&(b.removeAttributeNS(l.namespaceURI,l.localName),--m)}if(5<=g)return fb(new B(2,4,4028));if("onLoad"!=k)return fb(new B(2,4,4027));var p=fd([e],[h]);return f.request(0,xb(p,c)).Y(function(e){e=Re(e.data,b.tagName);if(!e)return fb(new B(2,
4,4001,h));for(;b.childNodes.length;)b.removeChild(b.childNodes[0]);for(;e.childNodes.length;){var k=e.childNodes[0];e.removeChild(k);b.appendChild(k)}for(k=0;k<e.attributes.length;k++){var m=e.attributes[k].nodeName,l=e.getAttribute(m);b.setAttribute(m,l)}return Te(b,c,d,p[0],f,g+1)})}
function Te(b,c,d,e,f,g){g=void 0===g?0:g;if(M.getAttributeNS(b,"http://www.w3.org/1999/xlink","href")){var h=Se(b,c,d,e,f,g);d&&(h=h.Y(void 0,function(){return Te(b,c,d,e,f,g)}));return h}h=[];for(var k=0;k<b.childNodes.length;k++){var m=b.childNodes[k];m instanceof Element&&("urn:mpeg:dash:resolve-to-zero:2013"==M.getAttributeNS(m,"http://www.w3.org/1999/xlink","href")?(b.removeChild(m),--k):"SegmentTimeline"!=m.tagName&&h.push(Te(m,c,d,e,f,g)))}return jb(h).Y(function(){return b})};function Ue(b,c,d){this.c=b;this.b=c;this.a=d}y("shaka.media.InitSegmentReference",Ue);Ue.prototype.Qb=function(){return this.c()};Ue.prototype.createUris=Ue.prototype.Qb;Ue.prototype.Wb=function(){return this.b};Ue.prototype.getStartByte=Ue.prototype.Wb;Ue.prototype.Vb=function(){return this.a};Ue.prototype.getEndByte=Ue.prototype.Vb;function N(b,c,d,e,f,g){this.position=b;this.startTime=c;this.endTime=d;this.c=e;this.b=f;this.a=g}y("shaka.media.SegmentReference",N);N.prototype.V=function(){return this.position};
N.prototype.getPosition=N.prototype.V;N.prototype.Xb=function(){return this.startTime};N.prototype.getStartTime=N.prototype.Xb;N.prototype.Od=function(){return this.endTime};N.prototype.getEndTime=N.prototype.Od;N.prototype.Qb=function(){return this.c()};N.prototype.createUris=N.prototype.Qb;N.prototype.Wb=function(){return this.b};N.prototype.getStartByte=N.prototype.Wb;N.prototype.Vb=function(){return this.a};N.prototype.getEndByte=N.prototype.Vb;function O(b,c){this.H=b;this.b=c==Ve;this.a=0}y("shaka.util.DataViewReader",O);var Ve=1;O.Endianness={wf:0,xf:Ve};O.prototype.ja=function(){return this.a<this.H.byteLength};O.prototype.hasMoreData=O.prototype.ja;O.prototype.V=function(){return this.a};O.prototype.getPosition=O.prototype.V;O.prototype.Pd=function(){return this.H.byteLength};O.prototype.getLength=O.prototype.Pd;O.prototype.fa=function(){try{var b=this.H.getUint8(this.a);this.a+=1;return b}catch(c){We()}};O.prototype.readUint8=O.prototype.fa;
O.prototype.hb=function(){try{var b=this.H.getUint16(this.a,this.b);this.a+=2;return b}catch(c){We()}};O.prototype.readUint16=O.prototype.hb;O.prototype.C=function(){try{var b=this.H.getUint32(this.a,this.b);this.a+=4;return b}catch(c){We()}};O.prototype.readUint32=O.prototype.C;O.prototype.dd=function(){try{var b=this.H.getInt32(this.a,this.b);this.a+=4;return b}catch(c){We()}};O.prototype.readInt32=O.prototype.dd;
O.prototype.Xa=function(){try{if(this.b){var b=this.H.getUint32(this.a,!0);var c=this.H.getUint32(this.a+4,!0)}else c=this.H.getUint32(this.a,!1),b=this.H.getUint32(this.a+4,!1)}catch(d){We()}if(2097151<c)throw new B(2,3,3001);this.a+=8;return c*Math.pow(2,32)+b};O.prototype.readUint64=O.prototype.Xa;O.prototype.Ha=function(b){this.a+b>this.H.byteLength&&We();var c=new Uint8Array(this.H.buffer,this.H.byteOffset+this.a,b);this.a+=b;return new Uint8Array(c)};O.prototype.readBytes=O.prototype.Ha;
O.prototype.I=function(b){this.a+b>this.H.byteLength&&We();this.a+=b};O.prototype.skip=O.prototype.I;O.prototype.gd=function(b){this.a<b&&We();this.a-=b};O.prototype.rewind=O.prototype.gd;O.prototype.seek=function(b){(0>b||b>this.H.byteLength)&&We();this.a=b};O.prototype.seek=O.prototype.seek;O.prototype.mc=function(){for(var b=this.a;this.ja()&&0!=this.H.getUint8(this.a);)this.a+=1;b=new Uint8Array(this.H.buffer,this.H.byteOffset+b,this.a-b);this.a+=1;return Ob(b)};
O.prototype.readTerminatedString=O.prototype.mc;function We(){throw new B(2,3,3E3);};function Q(){this.c=[];this.b=[];this.a=!1}y("shaka.util.Mp4Parser",Q);Q.prototype.F=function(b,c){var d=Xe(b);this.c[d]=0;this.b[d]=c;return this};Q.prototype.box=Q.prototype.F;Q.prototype.aa=function(b,c){var d=Xe(b);this.c[d]=1;this.b[d]=c;return this};Q.prototype.fullBox=Q.prototype.aa;Q.prototype.stop=function(){this.a=!0};Q.prototype.stop=Q.prototype.stop;
Q.prototype.parse=function(b,c){var d=new Uint8Array(b);d=new O(new DataView(d.buffer,d.byteOffset,d.byteLength),0);for(this.a=!1;d.ja()&&!this.a;)this.Hb(0,d,c)};Q.prototype.parse=Q.prototype.parse;
Q.prototype.Hb=function(b,c,d){var e=c.V(),f=c.C(),g=c.C();switch(f){case 0:f=c.H.byteLength-e;break;case 1:f=c.Xa()}var h=this.b[g];if(h){var k=null,m=null;1==this.c[g]&&(m=c.C(),k=m>>>24,m&=16777215);g=e+f;d&&g>c.H.byteLength&&(g=c.H.byteLength);g-=c.V();c=0<g?c.Ha(g):new Uint8Array(0);c=new O(new DataView(c.buffer,c.byteOffset,c.byteLength),0);h({parser:this,partialOkay:d||!1,version:k,flags:m,reader:c,size:f,start:e+b})}else c.I(Math.min(e+f-c.V(),c.H.byteLength-c.V()))};
Q.prototype.parseNext=Q.prototype.Hb;function R(b){for(;b.reader.ja()&&!b.parser.a;)b.parser.Hb(b.start,b.reader,b.partialOkay)}Q.children=R;function Ye(b){for(var c=b.reader.C();0<c&&!b.parser.a;--c)b.parser.Hb(b.start,b.reader,b.partialOkay)}Q.sampleDescription=Ye;function Ze(b){return function(c){b(c.reader.Ha(c.reader.H.byteLength-c.reader.V()))}}Q.allData=Ze;function Xe(b){for(var c=0,d=0;d<b.length;d++)c=c<<8|b.charCodeAt(d);return c}
function $e(b){return String.fromCharCode(b>>24&255,b>>16&255,b>>8&255,b&255)}Q.typeToString=$e;function af(b,c,d,e){var f,g=(new Q).aa("sidx",function(b){f=bf(c,e,d,b)});b&&g.parse(b);if(f)return f;throw new B(2,3,3004);}
function bf(b,c,d,e){var f=[];e.reader.I(4);var g=e.reader.C();if(0==g)throw new B(2,3,3005);if(0==e.version){var h=e.reader.C();var k=e.reader.C()}else h=e.reader.Xa(),k=e.reader.Xa();e.reader.I(2);var m=e.reader.hb();b=b+e.size+k;for(k=0;k<m;k++){var l=e.reader.C(),p=(l&2147483648)>>>31;l&=2147483647;var t=e.reader.C();e.reader.I(4);if(1==p)throw new B(2,3,3006);f.push(new N(f.length,h/g-c,(h+t)/g-c,function(){return d},b,b+l-1));h+=t;b+=l}e.parser.stop();return f};function S(b){this.a=b}y("shaka.media.SegmentIndex",S);S.prototype.destroy=function(){this.a=null;return Promise.resolve()};S.prototype.destroy=S.prototype.destroy;S.prototype.find=function(b){for(var c=this.a.length-1;0<=c;--c){var d=this.a[c];if(b>=d.startTime&&b<d.endTime)return d.position}return this.a.length&&b<this.a[0].startTime?this.a[0].position:null};S.prototype.find=S.prototype.find;
S.prototype.get=function(b){if(0==this.a.length)return null;b-=this.a[0].position;return 0>b||b>=this.a.length?null:this.a[b]};S.prototype.get=S.prototype.get;S.prototype.offset=function(b){for(var c=0;c<this.a.length;++c)this.a[c].startTime+=b,this.a[c].endTime+=b};S.prototype.offset=S.prototype.offset;
S.prototype.fc=function(b){for(var c=[],d=0,e=0;d<this.a.length&&e<b.length;){var f=this.a[d],g=b[e];f.startTime<g.startTime?(c.push(f),d++):(f.startTime>g.startTime?0==d&&c.push(g):(.1<Math.abs(f.endTime-g.endTime)?c.push(new N(f.position,g.startTime,g.endTime,g.c,g.b,g.a)):c.push(f),d++),e++)}for(;d<this.a.length;)c.push(this.a[d++]);if(c.length)for(d=c[c.length-1].position+1;e<b.length;)f=b[e++],f=new N(d++,f.startTime,f.endTime,f.c,f.b,f.a),c.push(f);else c=b;this.a=c};S.prototype.merge=S.prototype.fc;
S.prototype.Rb=function(b){for(var c=0;c<this.a.length;++c)if(this.a[c].endTime>b){this.a.splice(0,c);return}this.a=[]};S.prototype.evict=S.prototype.Rb;function cf(b,c){for(;b.a.length;)if(b.a[b.a.length-1].startTime>=c)b.a.pop();else break;for(;b.a.length;)if(0>=b.a[0].endTime)b.a.shift();else break;if(0!=b.a.length){var d=b.a[b.a.length-1];b.a[b.a.length-1]=new N(d.position,d.startTime,c,d.c,d.b,d.a)}};function df(b){this.b=b;this.a=new O(b,0);ef||(ef=[new Uint8Array([255]),new Uint8Array([127,255]),new Uint8Array([63,255,255]),new Uint8Array([31,255,255,255]),new Uint8Array([15,255,255,255,255]),new Uint8Array([7,255,255,255,255,255]),new Uint8Array([3,255,255,255,255,255,255]),new Uint8Array([1,255,255,255,255,255,255,255])])}var ef;df.prototype.ja=function(){return this.a.ja()};
function ff(b){var c=gf(b);if(7<c.length)throw new B(2,3,3002);for(var d=0,e=0;e<c.length;e++)d=256*d+c[e];c=d;d=gf(b);a:{for(e=0;e<ef.length;e++)if(ec(d,ef[e])){e=!0;break a}e=!1}if(e)d=b.b.byteLength-b.a.V();else{if(8==d.length&&d[1]&224)throw new B(2,3,3001);e=d[0]&(1<<8-d.length)-1;for(var f=1;f<d.length;f++)e=256*e+d[f];d=e}d=b.a.V()+d<=b.b.byteLength?d:b.b.byteLength-b.a.V();e=new DataView(b.b.buffer,b.b.byteOffset+b.a.V(),d);b.a.I(d);return new hf(c,e)}
function gf(b){var c=b.a.fa(),d;for(d=1;8>=d&&!(c&1<<8-d);d++);if(8<d)throw new B(2,3,3002);var e=new Uint8Array(d);e[0]=c;for(c=1;c<d;c++)e[c]=b.a.fa();return e}function hf(b,c){this.id=b;this.a=c}function jf(b){if(8<b.a.byteLength)throw new B(2,3,3002);if(8==b.a.byteLength&&b.a.getUint8(0)&224)throw new B(2,3,3001);for(var c=0,d=0;d<b.a.byteLength;d++){var e=b.a.getUint8(d);c=256*c+e}return c};function kf(){}
kf.prototype.parse=function(b,c,d,e){var f;c=new df(new DataView(c));if(440786851!=ff(c).id)throw new B(2,3,3008);var g=ff(c);if(408125543!=g.id)throw new B(2,3,3009);c=g.a.byteOffset;g=new df(g.a);for(f=null;g.ja();){var h=ff(g);if(357149030==h.id){f=h;break}}if(!f)throw new B(2,3,3010);g=new df(f.a);f=1E6;for(h=null;g.ja();){var k=ff(g);if(2807729==k.id)f=jf(k);else if(17545==k.id)if(h=k,4==h.a.byteLength)h=h.a.getFloat32(0);else if(8==h.a.byteLength)h=h.a.getFloat64(0);else throw new B(2,3,3003);
}if(null==h)throw new B(2,3,3011);g=f/1E9;f=h*g;b=ff(new df(new DataView(b)));if(475249515!=b.id)throw new B(2,3,3007);return lf(b,c,g,f,d,e)};function lf(b,c,d,e,f,g){function h(){return f}var k=[];b=new df(b.a);for(var m=null,l=null;b.ja();){var p=ff(b);if(187==p.id){var t=mf(p);t&&(p=d*t.qf,t=c+t.Je,null!=m&&k.push(new N(k.length,m-g,p-g,h,l,t-1)),m=p,l=t)}}null!=m&&k.push(new N(k.length,m-g,e-g,h,l,null));return k}
function mf(b){var c=new df(b.a);b=ff(c);if(179!=b.id)throw new B(2,3,3013);b=jf(b);c=ff(c);if(183!=c.id)throw new B(2,3,3012);c=new df(c.a);for(var d=0;c.ja();){var e=ff(c);if(241==e.id){d=jf(e);break}}return{qf:b,Je:d}};function nf(b,c){var d=Qe(b,c,"Initialization");if(!d)return null;var e=b.v.ha,f=d.getAttribute("sourceURL");f&&(e=fd(b.v.ha,[f]));f=0;var g=null;if(d=M.G(d,"range",M.Jb))f=d.start,g=d.end;return new Ue(function(){return e},f,g)}
function of(b,c){var d=Number(Pe(b,pf,"presentationTimeOffset"))||0,e=Pe(b,pf,"timescale"),f=1;e&&(f=M.Ib(e)||1);d=d/f||0;e=nf(b,pf);var g=b.v.contentType;f=b.v.mimeType.split("/")[1];if("text"!=g&&"mp4"!=f&&"webm"!=f)throw new B(2,4,4006);if("webm"==f&&!e)throw new B(2,4,4005);g=Qe(b,pf,"RepresentationIndex");var h=Pe(b,pf,"indexRange"),k=b.v.ha;h=M.Jb(h||"");if(g){var m=g.getAttribute("sourceURL");m&&(k=fd(b.v.ha,[m]));h=M.G(g,"range",M.Jb,h)}if(!h)throw new B(2,4,4002);f=qf(b,c,e,k,h.start,h.end,
f,d);return{createSegmentIndex:f.createSegmentIndex,findSegmentPosition:f.findSegmentPosition,getSegmentReference:f.getSegmentReference,initSegmentReference:e,ga:d}}
function qf(b,c,d,e,f,g,h,k){var m=b.presentationTimeline,l=!b.Na||!b.O.ac,p=b.O.start,t=b.O.duration,w=c,x=null;return{createSegmentIndex:function(){var b=[w(e,f,g),"webm"==h?w(d.c(),d.b,d.a):null];w=null;return Promise.all(b).then(function(b){var c=b[0];b=b[1]||null;c="mp4"==h?af(c,f,e,k):(new kf).parse(c,b,e,k);m.Ta(c,p);x=new S(c);l&&cf(x,t)})},findSegmentPosition:function(b){return x.find(b)},getSegmentReference:function(b){return x.get(b)}}}function pf(b){return b.ib};function rf(b,c){var d=nf(b,sf);var e=tf(b);var f=Oe(b,sf),g=f.Ja;0==g&&(g=1);var h=0;f.T?h=f.T*(g-1):f.K&&0<f.K.length&&(h=f.K[0].start);e={T:f.T,startTime:h,Ja:g,ga:f.ga,K:f.K,Sa:e};if(!e.T&&!e.K&&1<e.Sa.length)throw new B(2,4,4002);if(!e.T&&!b.O.duration&&!e.K&&1==e.Sa.length)throw new B(2,4,4002);if(e.K&&0==e.K.length)throw new B(2,4,4002);g=f=null;b.ea.id&&b.v.id&&(g=b.ea.id+","+b.v.id,f=c[g]);h=uf(b.O.duration,e.Ja,b.v.ha,e);f?(f.fc(h),g=b.presentationTimeline.cb(),f.Rb(g-b.O.start)):(b.presentationTimeline.Ta(h,
b.O.start),f=new S(h),g&&b.Na&&(c[g]=f));b.Na&&b.O.ac||cf(f,b.O.duration);return{createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:f.find.bind(f),getSegmentReference:f.get.bind(f),initSegmentReference:d,ga:e.ga}}function sf(b){return b.wa}
function uf(b,c,d,e){var f=e.Sa.length;e.K&&e.K.length!=e.Sa.length&&(f=Math.min(e.K.length,e.Sa.length));for(var g=[],h=e.startTime,k=0;k<f;k++){var m=e.Sa[k],l=fd(d,[m.de]),p=void 0;p=null!=e.T?h+e.T:e.K?e.K[k].end:h+b;g.push(new N(k+c,h,p,function(b){return b}.bind(null,l),m.start,m.end));h=p}return g}
function tf(b){return[b.v.wa,b.X.wa,b.ea.wa].filter(I.ta).map(function(b){return M.N(b,"SegmentURL")}).reduce(function(b,d){return 0<b.length?b:d}).map(function(c){c.getAttribute("indexRange")&&!b.Nc&&(b.Nc=!0);var d=c.getAttribute("media");c=M.G(c,"mediaRange",M.Jb,{start:0,end:null});return{de:d,start:c.start,end:c.end}})};function vf(b,c,d,e){var f=wf(b);var g=Oe(b,xf);var h=Pe(b,xf,"media"),k=Pe(b,xf,"index");g={T:g.T,timescale:g.timescale,Ja:g.Ja,ga:g.ga,yc:g.yc,K:g.K,ec:h,fb:k};h=g.fb?1:0;h+=g.K?1:0;h+=g.T?1:0;if(0==h)throw new B(2,4,4002);1!=h&&(g.fb&&(g.K=null),g.T=null);if(!g.fb&&!g.ec)throw new B(2,4,4002);if(g.fb){d=b.v.mimeType.split("/")[1];if("mp4"!=d&&"webm"!=d)throw new B(2,4,4006);if("webm"==d&&!f)throw new B(2,4,4005);e=Ne(g.fb,b.v.id,null,b.bandwidth||null,null);e=fd(b.v.ha,[e]);b=qf(b,c,f,e,0,null,
d,g.ga)}else g.T?(e||b.presentationTimeline.hc(g.T),b=yf(b,g)):(h=c=null,b.ea.id&&b.v.id&&(h=b.ea.id+","+b.v.id,c=d[h]),k=zf(b,g),e=!b.Na||!b.O.ac,c?(e&&cf(new S(k),b.O.duration),c.fc(k),d=b.presentationTimeline.cb(),c.Rb(d-b.O.start)):(b.presentationTimeline.Ta(k,b.O.start),c=new S(k),h&&b.Na&&(d[h]=c)),e&&cf(c,b.O.duration),b={createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:c.find.bind(c),getSegmentReference:c.get.bind(c)});return{createSegmentIndex:b.createSegmentIndex,findSegmentPosition:b.findSegmentPosition,
getSegmentReference:b.getSegmentReference,initSegmentReference:f,ga:g.ga}}function xf(b){return b.kb}
function yf(b,c){var d=b.O.duration,e=c.T,f=c.Ja,g=c.timescale,h=c.ec,k=b.bandwidth||null,m=b.v.id,l=b.v.ha;return{createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:function(b){return 0>b||d&&b>=d?null:Math.floor(b/e)},getSegmentReference:function(b){var c=b*e,p=c+e;d&&(p=Math.min(p,d));return 0>p||d&&c>=d?null:new N(b,c,p,function(){var d=Ne(h,m,b+f,k,c*g);return fd(l,[d])},0,null)}}}
function zf(b,c){for(var d=[],e=0;e<c.K.length;e++){var f=e+c.Ja;d.push(new N(f,c.K[e].start,c.K[e].end,function(b,c,d,e,f,p){b=Ne(b,c,f,d,p);return fd(e,[b]).map(function(b){return b.toString()})}.bind(null,c.ec,b.v.id,b.bandwidth||null,b.v.ha,f,c.K[e].pf+c.yc),0,null))}return d}function wf(b){var c=Pe(b,xf,"initialization");if(!c)return null;var d=b.v.id,e=b.bandwidth||null,f=b.v.ha;return new Ue(function(){var b=Ne(c,d,null,e,null);return fd(f,[b])},0,null)};var Af={},Bf={};y("shaka.media.ManifestParser.registerParserByExtension",function(b,c){Bf[b]=c});y("shaka.media.ManifestParser.registerParserByMime",function(b,c){Af[b]=c});function Cf(){var b={},c;for(c in Af)b[c]=!0;for(var d in Bf)b[d]=!0;["application/dash+xml","application/x-mpegurl","application/vnd.apple.mpegurl","application/vnd.ms-sstr+xml"].forEach(function(c){b[c]=!!Af[c]});["mpd","m3u8","ism"].forEach(function(c){b[c]=!!Bf[c]});return b}
function Df(b,c,d,e){return r(function g(){var h;return v(g,function(g){switch(g.m){case 1:return oa(g,2),u(g,Ef(b,c,d,e),4);case 4:return g["return"](g.w);case 2:throw h=ra(g),h.severity=2,h;}})})}
function Ef(b,c,d,e){return r(function g(){var h,k,m,l,p,t,w,x,A,F;return v(g,function(g){switch(g.m){case 1:if(e&&(h=e.toLowerCase(),k=Af[h]))return g["return"](k);m=new Na(b);l=m.da.split("/");p=l.pop();t=p.split(".");return 1<t.length&&(w=t.pop().toLowerCase(),x=Bf[w])?g["return"](x):u(g,Ff(b,c,d),2);case 2:A=g.w;if(F=Af[A])return g["return"](F);throw new B(2,4,4E3,b);}})})}
function Ff(b,c,d){return r(function f(){var g,h,k;return v(f,function(f){switch(f.m){case 1:return g=xb([b],d),g.method="HEAD",u(f,c.request(0,g).promise,2);case 2:return h=f.w,k=h.headers["content-type"],f["return"](k?k.toLowerCase():"")}})})};function U(b,c){this.f=b;this.Kb=c;this.h=this.g=Infinity;this.a=1;this.b=this.c=null;this.j=0;this.l=!0;this.i=0}y("shaka.media.PresentationTimeline",U);U.prototype.S=function(){return this.g};U.prototype.getDuration=U.prototype.S;U.prototype.ma=function(b){this.g=b};U.prototype.setDuration=U.prototype.ma;U.prototype.Vd=function(){return this.f};U.prototype.getPresentationStartTime=U.prototype.Vd;U.prototype.kd=function(b){this.j=b};U.prototype.setClockOffset=U.prototype.kd;
U.prototype.lb=function(b){this.l=b};U.prototype.setStatic=U.prototype.lb;U.prototype.uc=function(b){this.h=b};U.prototype.setSegmentAvailabilityDuration=U.prototype.uc;U.prototype.Xe=function(b){this.Kb=b};U.prototype.setDelay=U.prototype.Xe;U.prototype.Nd=function(){return this.Kb};U.prototype.getDelay=U.prototype.Nd;
U.prototype.Ta=function(b,c){if(0!=b.length){var d=b[0].startTime+c,e=b[b.length-1].endTime+c;this.c=null==this.c?d:Math.min(this.c,d);this.a=b.reduce(function(b,c){return Math.max(b,c.endTime-c.startTime)},this.a);this.b=Math.max(this.b,e);null!=this.f&&(this.f=(Date.now()+this.j)/1E3-this.b-this.a)}};U.prototype.notifySegments=U.prototype.Ta;U.prototype.hc=function(b){this.a=Math.max(this.a,b)};U.prototype.notifyMaxSegmentDuration=U.prototype.hc;
U.prototype.offset=function(b){null!=this.c&&(this.c+=b);null!=this.b&&(this.b+=b)};U.prototype.offset=U.prototype.offset;U.prototype.W=function(){return Infinity==this.g&&!this.l};U.prototype.isLive=U.prototype.W;U.prototype.Da=function(){return Infinity!=this.g&&!this.l};U.prototype.isInProgress=U.prototype.Da;U.prototype.cb=function(){if(Infinity==this.h)return this.i;var b=this.Qa()-this.h;return Math.max(this.i,b)};U.prototype.getSegmentAvailabilityStart=U.prototype.cb;
U.prototype.ld=function(b){this.i=b};U.prototype.setUserSeekStart=U.prototype.ld;U.prototype.Qa=function(){return this.W()||this.Da()?Math.min(Math.max(0,(Date.now()+this.j)/1E3-this.a-this.f),this.g):this.g};U.prototype.getSegmentAvailabilityEnd=U.prototype.Qa;U.prototype.bb=function(b){var c=Math.max(this.c,this.i);if(Infinity==this.h)return c;var d=this.Qa()-this.h;b=Math.min(d+b,this.oa());return Math.max(c,b)};U.prototype.getSafeSeekRangeStart=U.prototype.bb;U.prototype.Pa=function(){return this.bb(0)};
U.prototype.getSeekRangeStart=U.prototype.Pa;U.prototype.oa=function(){var b=this.W()||this.Da()?this.Kb:0;return Math.max(0,this.Qa()-b)};U.prototype.getSeekRangeEnd=U.prototype.oa;U.prototype.qd=function(){return null==this.f||null!=this.b?!1:!0};U.prototype.usingPresentationStartTime=U.prototype.qd;function Gf(){this.a=this.b=null;this.h=[];this.c=null;this.j=[];this.i=1;this.l={};this.o=0;this.s=new Fa(5);this.g=null;this.f=new rb}y("shaka.dash.DashParser",Gf);n=Gf.prototype;n.configure=function(b){this.b=b};n.start=function(b,c){this.h=[b];this.a=c;return Hf(this).then(function(b){this.a&&If(this,b);return this.c}.bind(this))};n.stop=function(){this.b=this.a=null;this.h=[];this.c=null;this.j=[];this.l={};null!=this.g&&(window.clearTimeout(this.g),this.g=null);return this.f.destroy()};
n.update=function(){Hf(this)["catch"](function(b){if(this.a)this.a.onError(b)}.bind(this))};n.onExpirationUpdated=function(){};function Hf(b){var c=Date.now(),d=b.a.networkingEngine.request(0,xb(b.h,b.b.retryParameters));sb(b.f,d);return d.promise.then(function(c){if(b.a)return Jf(b,c.data,c.uri)}).then(function(){var d=(Date.now()-c)/1E3;Ga(b.s,1,d);return d})}
function Jf(b,c,d){c=Re(c,"MPD");if(!c)throw new B(2,4,4001,d);c=Te(c,b.b.retryParameters,b.b.dash.xlinkFailGracefully,d,b.a.networkingEngine);sb(b.f,c);return c.promise.then(function(c){return Kf(b,c,d)})}
function Kf(b,c,d){return r(function f(){var g,h,k,m,l,p,t,w,x,A,F,P,W,T,na,va,X,Vb,Wb,Oc,Xb,ub,wg,xg,yg;return v(f,function(f){switch(f.m){case 1:m=I;l=M;p=[d];t=l.N(c,"Location").map(l.Cb).filter(m.ta);0<t.length&&(p=b.h=t);w=l.N(c,"BaseURL").map(l.Cb);x=fd(p,w);(A=b.b.dash.ignoreMinBufferTime)||(F=l.G(c,"minBufferTime",l.qa));b.o=l.G(c,"minimumUpdatePeriod",l.qa,-1);P=l.G(c,"availabilityStartTime",l.Be);W=l.G(c,"timeShiftBufferDepth",l.qa);T=l.G(c,"suggestedPresentationDelay",l.qa);na=l.G(c,"maxSegmentDuration",
l.qa);va=c.getAttribute("type")||"static";b.c?X=b.c.presentationTimeline:(Vb=Math.max(b.b.dash.defaultPresentationDelay,1.5*F),Wb=null!=T?T:Vb,X=new U(P,Wb));Oc={Na:"static"!=va,presentationTimeline:X,ea:null,O:null,X:null,v:null,bandwidth:0,Nc:!1};for(var zg=Oc,Wj=x,Pc=M.G(c,"mediaPresentationDuration",M.qa),Qc=[],Ta=0,Yb=M.N(c,"Period"),vb=0;vb<Yb.length;vb++){var cb=Yb[vb];Ta=M.G(cb,"start",M.qa,Ta);var Rc=M.G(cb,"duration",M.qa),Ua=null;if(vb!=Yb.length-1){var Ag=M.G(Yb[vb+1],"start",M.qa);null!=
Ag&&(Ua=Ag-Ta)}else null!=Pc&&(Ua=Pc-Ta);null==Ua&&(Ua=Rc);cb=Lf(b,zg,Wj,{start:Ta,duration:Ua,node:cb,ac:null==Ua||vb==Yb.length-1});Qc.push(cb);Rc=zg.ea.id;b.j.includes(Rc)||(b.j.push(Rc),b.c&&(b.a.filterNewPeriod(cb),b.c.periods.push(cb)));if(null==Ua){Ta=null;break}Ta+=Ua}null==b.c&&b.a.filterAllPeriods(Qc);null!=Pc?(g=Qc,h=Pc,k=!1):(g=Qc,h=Ta,k=!0);Xb=h;ub=g;X.lb("static"==va);"static"!=va&&k||X.ma(Xb||Infinity);(wg=X.W())&&!isNaN(b.b.availabilityWindowOverride)&&(W=b.b.availabilityWindowOverride);
null==W&&(W=Infinity);X.uc(W);X.hc(na||1);if(b.c){f.D(0);break}b.c={presentationTimeline:X,periods:ub,offlineSessionIds:[],minBufferTime:F||0};if(!X.qd()){f.D(0);break}xg=l.N(c,"UTCTiming");return u(f,Mf(b,x,xg,wg),4);case 4:yg=f.w;if(!b.a)return f["return"]();X.kd(yg);f.m=0}})})}
function Lf(b,c,d,e){c.ea=Nf(e.node,null,d);c.O=e;c.ea.id||(c.ea.id="__shaka_period_"+e.start);M.N(e.node,"EventStream").forEach(b.De.bind(b,e.start,e.duration));d=M.N(e.node,"AdaptationSet").map(b.Ae.bind(b,c)).filter(I.ta);if(c.Na){c=[];for(var f=q(d),g=f.next();!g.done;g=f.next()){g=q(g.value.Me);for(var h=g.next();!h.done;h=g.next())c.push(h.value)}if(c.length!=(new Set(c)).size)throw new B(2,4,4018);}var k=d.filter(function(b){return!b.xc});d.filter(function(b){return b.xc}).forEach(function(b){var c=
b.streams[0],d=b.xc;k.forEach(function(b){b.id==d&&b.streams.forEach(function(b){b.trickModeVideo=c})})});c=Of(k,"video");f=Of(k,"audio");if(!c.length&&!f.length)throw new B(2,4,4004);f.length||(f=[null]);c.length||(c=[null]);d=[];for(g=0;g<f.length;g++)for(h=0;h<c.length;h++)Pf(b,f[g],c[h],d);b=Of(k,"text");c=[];for(f=0;f<b.length;f++)c.push.apply(c,b[f].streams);return{startTime:e.start,textStreams:c,variants:d}}function Of(b,c){return b.filter(function(b){return b.contentType==c})}
function Pf(b,c,d,e){if(c||d)if(c&&d){var f=c.drmInfos;var g=d.drmInfos;if(f.length&&g.length?0<Hc(f,g).length:1){g=Hc(c.drmInfos,d.drmInfos);for(var h=0;h<c.streams.length;h++)for(var k=0;k<d.streams.length;k++)f=(d.streams[k].bandwidth||0)+(c.streams[h].bandwidth||0),f={id:b.i++,language:c.language,primary:c.cc||d.cc,audio:c.streams[h],video:d.streams[k],bandwidth:f,drmInfos:g,allowedByApplication:!0,allowedByKeySystem:!0},e.push(f)}}else for(g=c||d,h=0;h<g.streams.length;h++)f=g.streams[h].bandwidth||
0,f={id:b.i++,language:g.language||"und",primary:g.cc,audio:c?g.streams[h]:null,video:d?g.streams[h]:null,bandwidth:f,drmInfos:g.drmInfos,allowedByApplication:!0,allowedByKeySystem:!0},e.push(f)}
n.Ae=function(b,c){b.X=Nf(c,b.ea,null);var d=!1,e=M.N(c,"Role"),f=e.map(function(b){return b.getAttribute("value")}).filter(I.ta),g=void 0,h="text"==b.X.contentType;h&&(g="subtitle");for(var k=0;k<e.length;k++){var m=e[k].getAttribute("schemeIdUri");if(null==m||"urn:mpeg:dash:role:2011"==m)switch(m=e[k].getAttribute("value"),m){case "main":d=!0;break;case "caption":case "subtitle":g=m}}var l=null,p=!1;M.N(c,"EssentialProperty").forEach(function(b){"http://dashif.org/guidelines/trickmode"==b.getAttribute("schemeIdUri")?
l=b.getAttribute("value"):p=!0});e=M.N(c,"Accessibility");var t={},w=0;e=q(e);for(k=e.next();!k.done;k=e.next())if(k=k.value,m=k.getAttribute("schemeIdUri"),"urn:scte:dash:cc:cea-608:2015"==m||"urn:scte:dash:cc:cea-708:2015"==m)k=k.getAttribute("value"),null!=k&&k.split(";").forEach(function(b){if(b.includes("=")){b=q(b.split("="));var c=b.next().value;b=b.next().value}else c=(w++).toString();t[c]=Hd(b)});if(p)return null;e=M.N(c,"ContentProtection");var x=Ie(e,this.b.dash.customScheme,this.b.dash.ignoreDrmInfo);
e=Hd(c.getAttribute("lang")||"und");m=c.getAttribute("label");k=M.N(c,"Representation");f=k.map(this.Ee.bind(this,b,x,g,e,m,d,f,t)).filter(function(b){return!!b});if(0==f.length){if(h)return null;throw new B(2,4,4003);}b.X.contentType&&"application"!=b.X.contentType||(b.X.contentType=Qf(f[0].mimeType,f[0].codecs),f.forEach(function(c){c.type=b.X.contentType}));f.forEach(function(b){x.drmInfos.forEach(function(c){b.keyId&&c.keyIds.push(b.keyId)})});h=k.map(function(b){return b.getAttribute("id")}).filter(I.ta);
return{id:b.X.id||"__fake__"+this.i++,contentType:b.X.contentType,language:e,cc:d,streams:f,drmInfos:x.drmInfos,xc:l,Me:h}};
n.Ee=function(b,c,d,e,f,g,h,k,m){b.v=Nf(m,b.X,null);if(!Rf(b.v))return null;b.bandwidth=M.G(m,"bandwidth",M.Ib)||0;var l=b.v.contentType;l="text"==l||"application"==l;try{var p=this.Ne.bind(this);if(b.v.ib)var t=of(b,p);else if(b.v.wa)t=rf(b,this.l);else if(b.v.kb)t=vf(b,p,this.l,!!this.c);else{var w=b.v.ha,x=b.O.duration||0;t={createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:function(b){return 0<=b&&b<x?1:null},getSegmentReference:function(b){return 1!=b?null:new N(1,0,x,function(){return w},
0,null)},initSegmentReference:null,ga:0}}}catch(A){if(l&&4002==A.code)return null;throw A;}m=M.N(m,"ContentProtection");m=Le(m,this.b.dash.customScheme,c,this.b.dash.ignoreDrmInfo);return{id:this.i++,originalId:b.v.id,createSegmentIndex:t.createSegmentIndex,findSegmentPosition:t.findSegmentPosition,getSegmentReference:t.getSegmentReference,initSegmentReference:t.initSegmentReference,presentationTimeOffset:t.ga,mimeType:b.v.mimeType,codecs:b.v.codecs,frameRate:b.v.frameRate,bandwidth:b.bandwidth,width:b.v.width,
height:b.v.height,kind:d,encrypted:0<c.drmInfos.length,keyId:m,language:e,label:f,type:b.X.contentType,primary:g,trickModeVideo:null,emsgSchemeIdUris:b.v.emsgSchemeIdUris,roles:h,channelsCount:b.v.ic,closedCaptions:k}};n.gf=function(){this.g=null;Hf(this).then(function(b){this.a&&If(this,b)}.bind(this))["catch"](function(b){this.a&&(b.severity=1,this.a.onError(b),If(this,0))}.bind(this))};function If(b,c){0>b.o||(b.g=window.setTimeout(b.gf.bind(b),1E3*Math.max(3,b.o-c,Ha(b.s))))}
function Nf(b,c,d){c=c||{contentType:"",mimeType:"",codecs:"",emsgSchemeIdUris:[],frameRate:void 0,ic:null};d=d||c.ha;var e=M.Va,f=M.Hd,g=M.N(b,"BaseURL").map(M.Cb),h=b.getAttribute("contentType")||c.contentType,k=b.getAttribute("mimeType")||c.mimeType,m=b.getAttribute("codecs")||c.codecs;f=M.G(b,"frameRate",f)||c.frameRate;var l=M.N(b,"InbandEventStream"),p=c.emsgSchemeIdUris.slice();l=q(l);for(var t=l.next();!t.done;t=l.next())t=t.value.getAttribute("schemeIdUri"),p.includes(t)||p.push(t);l=M.N(b,
"AudioChannelConfiguration");l=Sf(l)||c.ic;h||(h=Qf(k,m));return{ha:fd(d,g),ib:M.Ab(b,"SegmentBase")||c.ib,wa:M.Ab(b,"SegmentList")||c.wa,kb:M.Ab(b,"SegmentTemplate")||c.kb,width:M.G(b,"width",e)||c.width,height:M.G(b,"height",e)||c.height,contentType:h,mimeType:k,codecs:m,frameRate:f,emsgSchemeIdUris:p,id:b.getAttribute("id"),ic:l}}
function Sf(b){for(var c=0;c<b.length;++c){var d=b[c],e=d.getAttribute("schemeIdUri");if(e&&(d=d.getAttribute("value")))switch(e){case "urn:mpeg:dash:outputChannelPositionList:2012":return d.trim().split(/ +/).length;case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":case "urn:dts:dash:audio_channel_configuration:2012":e=parseInt(d,10);if(!e)continue;return e;case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":case "urn:dolby:dash:audio_channel_configuration:2011":if(e=parseInt(d,
16)){for(b=0;e;)e&1&&++b,e>>=1;return b}}}return null}function Rf(b){var c=b.ib?1:0;c+=b.wa?1:0;c+=b.kb?1:0;if(0==c)return"text"==b.contentType||"application"==b.contentType?!0:!1;1!=c&&(b.ib&&(b.wa=null),b.kb=null);return!0}
function Tf(b,c,d,e){c=fd(c,[d]);c=xb(c,b.b.retryParameters);c.method=e;c=b.a.networkingEngine.request(4,c);sb(b.f,c);return c.promise.then(function(b){if("HEAD"==e){if(!b.headers||!b.headers.date)return 0;b=b.headers.date}else b=Ob(b.data);b=Date.parse(b);return isNaN(b)?0:b-Date.now()})}
function Mf(b,c,d,e){d=d.map(function(b){return{scheme:b.getAttribute("schemeIdUri"),value:b.getAttribute("value")}});var f=b.b.dash.clockSyncUri;e&&!d.length&&f&&d.push({scheme:"urn:mpeg:dash:utc:http-head:2014",value:f});return I.Gd(d,function(b){var d=b.value;switch(b.scheme){case "urn:mpeg:dash:utc:http-head:2014":case "urn:mpeg:dash:utc:http-head:2012":return Tf(this,c,d,"HEAD");case "urn:mpeg:dash:utc:http-xsdate:2014":case "urn:mpeg:dash:utc:http-iso:2014":case "urn:mpeg:dash:utc:http-xsdate:2012":case "urn:mpeg:dash:utc:http-iso:2012":return Tf(this,
c,d,"GET");case "urn:mpeg:dash:utc:direct:2014":case "urn:mpeg:dash:utc:direct:2012":return b=Date.parse(d),isNaN(b)?0:b-Date.now();case "urn:mpeg:dash:utc:http-ntp:2014":case "urn:mpeg:dash:utc:ntp:2014":case "urn:mpeg:dash:utc:sntp:2014":return Promise.reject();default:return Promise.reject()}}.bind(b))["catch"](function(){return 0})}
n.De=function(b,c,d){var e=M.Va,f=d.getAttribute("schemeIdUri")||"",g=d.getAttribute("value")||"",h=M.G(d,"timescale",e)||1;M.N(d,"Event").forEach(function(d){var k=M.G(d,"presentationTime",e)||0,l=M.G(d,"duration",e)||0;k=k/h+b;l=k+l/h;null!=c&&(k=Math.min(k,b+c),l=Math.min(l,b+c));d={schemeIdUri:f,value:g,startTime:k,endTime:l,id:d.getAttribute("id")||"",eventElement:d};this.a.onTimelineRegionAdded(d)}.bind(this))};
n.Ne=function(b,c,d){b=xb(b,this.b.retryParameters);null!=c&&(b.headers.Range="bytes="+c+"-"+(null!=d?d:""));c=this.a.networkingEngine.request(1,b);sb(this.f,c);return c.promise.then(function(b){return b.data})};function Qf(b,c){return od[Kb(b,c)]?"text":b.split("/")[0]}Bf.mpd=Gf;Af["application/dash+xml"]=Gf;function Uf(b,c,d,e){this.uri=b;this.type=c;this.a=d;this.segments=e||null}function Vf(b,c,d,e){this.id=b;this.name=c;this.a=d;this.value=void 0===e?null:e}Vf.prototype.toString=function(){function b(b){return b.name+'="'+b.value+'"'}return this.value?"#"+this.name+":"+this.value:0<this.a.length?"#"+this.name+":"+this.a.map(b).join(","):"#"+this.name};function Wf(b,c){this.name=b;this.value=c}
Vf.prototype.getAttribute=function(b){var c=this.a.filter(function(c){return c.name==b});return c.length?c[0]:null};function Xf(b,c,d){return(b=b.getAttribute(c))?b.value:d||null}function Yf(b,c){this.a=c;this.uri=b};function Zf(b,c){return b.filter(function(b){return b.name==c})}function $f(b,c){var d=Zf(b,c);return d.length?d[0]:null}function ag(b,c,d){return b.filter(function(b){var e=b.getAttribute("TYPE");b=b.getAttribute("GROUP-ID");return e.value==c&&b.value==d})}function bg(b,c){return fd([b],[c])[0]};function cg(b){this.b=b;this.a=0}function dg(b){eg(b,/[ \t]+/gm)}function eg(b,c){c.lastIndex=b.a;var d=c.exec(b.b);d=null==d?null:{position:d.index,length:d[0].length,Pe:d};if(b.a==b.b.length||null==d||d.position!=b.a)return null;b.a+=d.length;return d.Pe}function fg(b){return b.a==b.b.length?null:(b=eg(b,/[^ \t\n]*/gm))?b[0]:null};function gg(){this.a=0}
function hg(b,c,d){c=Ob(c);c=c.replace(/\r\n|\r(?=[^\n]|$)/gm,"\n").trim();var e=c.split(/\n+/m);if(!/^#EXTM3U($|[ \t\n])/m.test(e[0]))throw new B(2,4,4015);c=0;for(var f=1;f<e.length;f++)if(!/^#(?!EXT)/m.test(e[f])){var g=ig(b,e[f]);--b.a;if(jg.includes(g.name)){c=1;break}else"EXT-X-STREAM-INF"==g.name&&(f+=1)}f=[];for(g=1;g<e.length;)if(/^#(?!EXT)/m.test(e[g]))g+=1;else{var h=ig(b,e[g]);if(kg.includes(h.name)){if(1!=c)throw new B(2,4,4017);e=e.splice(g,e.length-g);b=lg(b,e,f);return new Uf(d,c,
f,b)}f.push(h);g+=1;"EXT-X-STREAM-INF"==h.name&&(h.a.push(new Wf("URI",e[g])),g+=1)}return new Uf(d,c,f)}function lg(b,c,d){var e=[],f=[];c.forEach(function(c){if(/^(#EXT)/.test(c))c=ig(b,c),jg.includes(c.name)?d.push(c):f.push(c);else{if(/^#(?!EXT)/m.test(c))return[];e.push(new Yf(c.trim(),f));f=[]}});return e}
function ig(b,c){a:{var d=b.a++;var e=c.match(/^#(EXT[^:]*)(?::(.*))?$/);if(!e)throw new B(2,4,4016,c);var f=e[1],g=e[2];e=[];if(g&&g.includes("=")){g=new cg(g);for(var h,k=/([^=]+)=(?:"([^"]*)"|([^",]*))(?:,|$)/g;h=eg(g,k);)e.push(new Wf(h[1],h[2]||h[3]))}else if(g){d=new Vf(d,f,e,g);break a}d=new Vf(d,f,e)}return d}var jg="EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-MAP EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST".split(" "),kg="EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE".split(" ");function mg(b){try{var c=mg.parse(b);return hb({uri:b,data:c.data,headers:{"content-type":c.contentType}})}catch(d){return fb(d)}}y("shaka.net.DataUriPlugin",mg);
mg.parse=function(b){var c=b.split(":");if(2>c.length||"data"!=c[0])throw new B(2,1,1004,b);c=c.slice(1).join(":").split(",");if(2>c.length)throw new B(2,1,1004,b);var d=c[0];c=window.decodeURIComponent(c.slice(1).join(","));d=d.split(";");var e=null;1<d.length&&(e=d[1]);if("base64"==e)b=bc(c).buffer;else{if(e)throw new B(2,1,1005,b);b=Sb(c)}return{data:b,contentType:d[0]}};wb("data",mg);function ng(){this.g=this.c=null;this.P=1;this.A={};this.M={};this.$={};this.a={};this.b=null;this.l="";this.s=new gg;this.j=this.i=null;this.f=og;this.o=null;this.u=0;this.B=Infinity;this.h=new rb;this.J=[]}y("shaka.hls.HlsParser",ng);n=ng.prototype;n.configure=function(b){this.g=b};n.start=function(b,c){this.c=c;this.l=b;return pg(this,b).then(function(c){return qg(this,c.data,b).then(function(){rg(this,this.i);return this.o}.bind(this))}.bind(this))};
n.stop=function(){this.g=this.c=null;this.A={};this.M={};this.o=null;return this.h.destroy()};n.update=function(){if(this.f!=sg.Aa){var b=[],c;for(c in this.a)b.push(tg(this,this.a[c],c));return Promise.all(b)}};
function tg(b,c,d){pg(b,d).then(function(b){var e=sg,g=hg(this.s,b.data,d);if(1!=g.type)throw new B(2,4,4017);b=$f(g.a,"EXT-X-MEDIA-SEQUENCE");var h=c.stream;ug(this,g,b?Number(b.value):0,h.mimeType,h.codecs).then(function(b){c.jb.a=b;b=b[b.length-1];$f(g.a,"EXT-X-ENDLIST")&&(vg(this,e.Aa),this.b.ma(b.endTime))}.bind(this))}.bind(b))}n.onExpirationUpdated=function(){};
function qg(b,c,d){c=hg(b.s,c,d);if(0!=c.type)throw new B(2,4,4022);return Bg(b,c).then(function(b){this.c.filterAllPeriods([b]);var c=Infinity,d=0,e=Infinity,k;for(k in this.a){var m=this.a[k];c=Math.min(c,m.gc);d=Math.max(d,m.gc);"text"!=m.stream.type&&(e=Math.min(e,m.duration))}this.f!=sg.Aa?(this.b=new U(0,3*this.u),this.b.lb(!1)):(this.b=new U(null,0),this.b.lb(!0));Cg(this);if(this.f!=sg.Aa){this.i=this.B;this.f==sg.zc&&(c=this.b.Kb,isNaN(this.g.availabilityWindowOverride)||(c=this.g.availabilityWindowOverride),
this.b.uc(c));for(c=0;95443.7176888889<=d;)c+=95443.7176888889,d-=95443.7176888889;if(c)for(var l in this.a)d=this.a[l],95443.7176888889>d.gc&&(d.stream.presentationTimeOffset=-c,d.jb.offset(c))}else{this.b.ma(e);this.b.offset(-c);for(var p in this.a)l=this.a[p],l.stream.presentationTimeOffset=c,l.jb.offset(-c),cf(l.jb,e)}this.o={presentationTimeline:this.b,periods:[b],offlineSessionIds:[],minBufferTime:0}}.bind(b))}
function Bg(b,c){var d=c.a,e=Zf(c.a,"EXT-X-MEDIA").filter(function(b){return"SUBTITLES"==Dg(b,"TYPE")}.bind(b)).map(function(b){return Eg(this,b)}.bind(b));return Promise.all(e).then(function(b){var e=Zf(d,"EXT-X-STREAM-INF").map(function(b){return Fg(this,b,c)}.bind(this));return Promise.all(e).then(function(c){return{startTime:0,variants:c.reduce(I.Pb,[]),textStreams:b}}.bind(this))}.bind(b))}
function Fg(b,c,d){var e=Xf(c,"CODECS","avc1.42E01E,mp4a.40.2").split(/\s*,\s*/),f=c.getAttribute("RESOLUTION"),g=null,h=null,k=Xf(c,"FRAME-RATE"),m=Number(Dg(c,"BANDWIDTH"));if(f){var l=f.value.split("x");g=l[0];h=l[1]}d=Zf(d.a,"EXT-X-MEDIA");var p=Xf(c,"AUDIO"),t=Xf(c,"VIDEO");p?d=ag(d,"AUDIO",p):t&&(d=ag(d,"VIDEO",t));if(l=Gg("text",e)){var w=Xf(c,"SUBTITLES");w&&(w=ag(d,"SUBTITLES",w),w.length&&(b.A[w[0].id].stream.codecs=l));ob(e,l)}d=d.map(function(b){return Hg(this,b,e)}.bind(b));var x=[],
A=[];return Promise.all(d).then(function(b){p?x=b:t&&(A=b);b=!1;if(x.length||A.length)if(x.length)if(Dg(c,"URI")==x[0].pc){var d="audio";b=!0}else d="video";else d="audio";else 1==e.length?(d=Gg("video",e),d=f||k||d?"video":"audio"):(d="video",e=[e.join(",")]);return b?Promise.resolve():Ig(this,c,e,d)}.bind(b)).then(function(b){b&&("audio"==b.stream.type?x=[b]:A=[b]);A&&Jg(A);x&&Jg(x);return Kg(this,x,A,m,g,h,k)}.bind(b))}
function Jg(b){b.forEach(function(b){var c=b.stream.codecs.split(",");c=c.filter(function(b){return"mp4a.40.34"!=b});b.stream.codecs=c.join(",")})}
function Kg(b,c,d,e,f,g,h){d.forEach(function(b){if(b=b.stream)b.width=Number(f)||void 0,b.height=Number(g)||void 0,b.frameRate=Number(h)||void 0}.bind(b));c.length||(c=[null]);d.length||(d=[null]);for(var k=[],m=0;m<c.length;m++)for(var l=0;l<d.length;l++){var p=c[m]?c[m].stream:null,t=d[l]?d[l].stream:null,w=c[m]?c[m].drmInfos:null,x=d[l]?d[l].drmInfos:null,A=void 0;if(p&&t)if(w.length&&x.length?0<Hc(w,x).length:1)A=Hc(w,x);else continue;else p?A=w:t&&(A=x);w=(d[m]?d[m].pc:"")+" - "+(c[m]?c[m].pc:
"");b.M[w]||(p=Lg(b,p,t,e,A),k.push(p),b.M[w]=p)}return k}function Lg(b,c,d,e,f){return{id:b.P++,language:c?c.language:"und",primary:!!c&&c.primary||!!d&&d.primary,audio:c,video:d,bandwidth:e,drmInfos:f,allowedByApplication:!0,allowedByKeySystem:!0}}function Eg(b,c){Dg(c,"TYPE");return Hg(b,c,[]).then(function(b){return b.stream})}
function Hg(b,c,d){var e=Dg(c,"URI");e=bg(b.l,e);if(b.a[e])return Promise.resolve(b.a[e]);var f=Dg(c,"TYPE").toLowerCase();"subtitles"==f&&(f="text");var g=Hd(Xf(c,"LANGUAGE","und")),h=Xf(c,"NAME"),k=c.getAttribute("DEFAULT"),m=c.getAttribute("AUTOSELECT"),l=Xf(c,"CHANNELS");return Mg(b,e,d,f,g,!!k||!!m,h,"audio"==f?Ng(l):null).then(function(b){if(this.a[e])return this.a[e];this.A[c.id]=b;return this.a[e]=b}.bind(b))}function Ng(b){if(!b)return null;b=b.split("/")[0];return parseInt(b,10)}
function Ig(b,c,d,e){var f=Dg(c,"URI");f=bg(b.l,f);return b.a[f]?Promise.resolve(b.a[f]):Mg(b,f,d,e,"und",!1,null,null).then(function(b){return this.a[f]?this.a[f]:this.a[f]=b}.bind(b))}
function Mg(b,c,d,e,f,g,h,k){var m=c;c=bg(b.l,c);var l,p="",t;return pg(b,c).then(function(b){l=hg(this.s,b.data,c);if(1!=l.type)throw new B(2,4,4017);b=l;var f=sg,g=$f(b.a,"EXT-X-PLAYLIST-TYPE"),h=$f(b.a,"EXT-X-ENDLIST");h=g&&"VOD"==g.value||h;g=g&&"EVENT"==g.value&&!h;g=!h&&!g;h?vg(this,f.Aa):(g?vg(this,f.zc):vg(this,f.ud),b=Og(b.a,"EXT-X-TARGETDURATION"),b=Number(b.value),this.u=Math.max(b,this.u),this.B=Math.min(b,this.B));if(1==d.length)p=d[0];else if(b=Gg(e,d),null!=b)p=b;else throw new B(2,
4,4025,d);return Pg(this,e,p,l)}.bind(b)).then(function(b){t=b;b=$f(l.a,"EXT-X-MEDIA-SEQUENCE");return ug(this,l,b?Number(b.value):0,t,p)}.bind(b)).then(function(b){var c=b[0].startTime,d=b[b.length-1].endTime,w=d-c;b=new S(b);var P=Qg(l),W=void 0;"text"==e&&(W="subtitle");var T=[];l.segments.forEach(function(b){b=Zf(b.a,"EXT-X-KEY");T.push.apply(T,b)});var na=!1,va=[],X=null;T.forEach(function(b){if("NONE"!=Dg(b,"METHOD")){na=!0;var c=Dg(b,"KEYFORMAT");if(b=(c=Rg[c])?c(b):null)b.keyIds.length&&(X=
b.keyIds[0]),va.push(b)}});if(na&&!va.length)throw new B(2,4,4026);P={id:this.P++,originalId:h,createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:b.find.bind(b),getSegmentReference:b.get.bind(b),initSegmentReference:P,presentationTimeOffset:0,mimeType:t,codecs:p,kind:W,encrypted:na,keyId:X,language:f,label:h,type:e,primary:g,trickModeVideo:null,emsgSchemeIdUris:null,frameRate:void 0,width:void 0,height:void 0,bandwidth:void 0,roles:[],channelsCount:k,closedCaptions:{}};this.$[P.id]=
b;return{stream:P,jb:b,drmInfos:va,pc:m,gc:c,Df:d,duration:w}}.bind(b))}function Qg(b){var c=Zf(b.a,"EXT-X-MAP");if(!c.length)return null;if(1<c.length)throw new B(2,4,4020);c=c[0];var d=Dg(c,"URI"),e=bg(b.uri,d);b=0;d=null;if(c=Xf(c,"BYTERANGE"))b=c.split("@"),c=Number(b[0]),b=Number(b[1]),d=b+c-1;return new Ue(function(){return[e]},b,d)}
function Sg(b,c,d,e,f){var g=d.a,h=bg(b.uri,d.uri);b=Og(g,"EXTINF").value.split(",");b=f+Number(b[0]);d=0;var k=null;if(g=$f(g,"EXT-X-BYTERANGE"))d=g.value.split("@"),g=Number(d[0]),d=d[1]?Number(d[1]):c.a+1,k=d+g-1;return new N(e,f,b,function(){return[h]},d,k)}function Cg(b){b.b&&(b.J.forEach(function(c){b.b.Ta(c,0)}),b.J=[])}
function ug(b,c,d,e,f){var g=c.segments,h=[],k=bg(c.uri,g[0].uri),m=Sg(c,null,g[0],d,0),l=Qg(c);return Tg(b,c.uri,l,m,e,f).then(function(b){k.split("/").pop();for(var e=0;e<g.length;++e){var f=h[h.length-1];f=Sg(c,f,g[e],d+e,0==e?b:f.endTime);h.push(f)}this.J.push(h);Cg(this);return h}.bind(b))}
function Ug(b,c){var d=b.c.networkingEngine,e=xb(c.c(),b.g.retryParameters),f={},g=c.b;f.Range="bytes="+g+"-"+(g+2048-1);var h={};if(0!=g||null!=c.a)g="bytes="+g+"-",null!=c.a&&(g+=c.a),h.Range=g;e.headers=f;f=d.request(1,e);sb(b.h,f);return f.promise["catch"](function(){Ka("Unable to fetch a partial HLS segment! Falling back to a full segment request, which is expensive!  Your server should support Range requests and CORS preflights.",e.uris[0]);e.headers=h;var c=d.request(1,e);sb(b.h,c);return c.promise})}
function Tg(b,c,d,e,f,g){if(b.o&&(c=b.a[c].jb.get(e.position)))return Promise.resolve(c.startTime);e=[Ug(b,e)];if("video/mp4"==f||"audio/mp4"==f)d?e.push(Ug(b,d)):e.push(e[0]);return Promise.all(e).then(function(b){if("video/mp4"==f||"audio/mp4"==f)return Vg(b[0].data,b[1].data);if("audio/mpeg"==f)return 0;if("video/mp2t"==f)return Wg(b[0].data);if("application/mp4"==f||f.startsWith("text/")){b=b[0].data;var c=Kb(f,g);if(od[c]){var d=new nd(null);d.f=new od[c];b=d.Xb(b)}else b=0;return b}throw new B(2,
4,4030);}.bind(b))}function Vg(b,c){var d=0;(new Q).F("moov",R).F("trak",R).F("mdia",R).aa("mdhd",function(b){b.reader.I(0==b.version?8:16);d=b.reader.C();b.parser.stop()}).parse(c,!0);if(!d)throw new B(2,4,4030);var e=0,f=!1;(new Q).F("moof",R).F("traf",R).aa("tfdt",function(b){e=(0==b.version?b.reader.C():b.reader.Xa())/d;f=!0;b.parser.stop()}).parse(b,!0);if(!f)throw new B(2,4,4030);return e}
function Wg(b){function c(){throw new B(2,4,4030);}b=new O(new DataView(b),0);for(var d=0,e=0;;)if(d=b.V(),e=b.fa(),71!=e&&c(),b.hb()&16384||c(),e=(b.fa()&48)>>4,0!=e&&2!=e||c(),3==e&&(e=b.fa(),b.I(e)),1!=b.C()>>8)b.seek(d+188),e=b.fa(),71!=e&&(b.seek(d+192),e=b.fa()),71!=e&&(b.seek(d+204),e=b.fa()),71!=e&&c(),b.gd(1);else return b.I(3),d=b.fa()>>6,0!=d&&1!=d||c(),0==b.fa()&&c(),d=b.fa(),e=b.hb(),b=b.hb(),(1073741824*((d&14)>>1)+((e&65534)<<14|(b&65534)>>1))/9E4}
function Gg(b,c){for(var d=Xg[b],e=0;e<d.length;e++)for(var f=0;f<c.length;f++)if(d[e].test(c[f].trim()))return c[f].trim();return"text"==b?"":null}
function Pg(b,c,d,e){e=bg(e.uri,e.segments[0].uri);var f=(new Na(e)).da.split(".").pop(),g=Yg[c][f];if(g)return Promise.resolve(g);if("text"==c)return d&&"vtt"!=d?Promise.resolve("application/mp4"):Promise.resolve("text/vtt");c=xb([e],b.g.retryParameters);c.method="HEAD";c=b.c.networkingEngine.request(1,c);sb(b.h,c);return c.promise.then(function(b){b=b.headers["content-type"];if(!b)throw new B(2,4,4021,f);return b.split(";")[0]})}
function Dg(b,c){var d=b.getAttribute(c);if(!d)throw new B(2,4,4023,c);return d.value}function Og(b,c){var d=$f(b,c);if(!d)throw new B(2,4,4024,c);return d}function pg(b,c){var d=b.c.networkingEngine.request(0,xb([c],b.g.retryParameters));sb(b.h,d);return d.promise}
var Xg={audio:[/^vorbis$/,/^opus$/,/^flac$/,/^mp4a/,/^[ae]c-3$/],video:[/^avc/,/^hev/,/^hvc/,/^vp0?[89]/,/^av1$/],text:[/^vtt$/,/^wvtt/,/^stpp/]},Yg={audio:{mp4:"audio/mp4",m4s:"audio/mp4",m4i:"audio/mp4",m4a:"audio/mp4",ts:"video/mp2t"},video:{mp4:"video/mp4",m4s:"video/mp4",m4i:"video/mp4",m4v:"video/mp4",ts:"video/mp2t"},text:{mp4:"application/mp4",m4s:"application/mp4",m4i:"application/mp4",vtt:"text/vtt",ttml:"application/ttml+xml"}};
ng.prototype.Z=function(){this.c&&(this.j=null,this.update().then(function(){rg(this,this.i)}.bind(this))["catch"](function(b){this.c&&(b.severity=1,this.c.onError(b),rg(this,0))}.bind(this)))};function rg(b,c){null!=b.i&&null!=c&&(b.j=window.setTimeout(b.Z.bind(b),1E3*c))}function vg(b,c){b.f=c;b.b&&b.b.lb(b.f==sg.Aa);b.f==sg.Aa&&null!=b.j&&(window.clearTimeout(b.j),b.j=null,b.i=null)}
var Rg={"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed":function(b){var c=Dg(b,"METHOD");if(!["SAMPLE-AES","SAMPLE-AES-CTR","SAMPLE-AES-CENC"].includes(c))return null;c=Dg(b,"URI");c=mg.parse(c);c=new Uint8Array(c.data);c=gd("com.widevine.alpha",[{initDataType:"cenc",initData:c}]);if(b=Xf(b,"KEYID"))c.keyIds=[b.substr(2).toLowerCase()];return c}},og="VOD",sg={Aa:og,ud:"EVENT",zc:"LIVE"};Bf.m3u8=ng;Af["application/x-mpegurl"]=ng;Af["application/vnd.apple.mpegurl"]=ng;function Zg(){this.a={}}function $g(b,c,d,e){b.a[c]=b.a[c]||new ah;b.a[c].a[d]=e}Zg.prototype.get=function(b,c){var d=this.a[b];return d?d.get(c):null};function ah(){this.a={}}ah.prototype.get=function(b){return this.a[b]};function bh(b,c){this.a=b;this.b=new Set([b]);c=c||[];for(var d=q(c),e=d.next();!e.done;e=d.next())this.add(e.value)}bh.prototype.add=function(b){return ch(this.a,b)?(this.b.add(b),!0):!1};function ch(b,c){var d;if(!(d=!!b.audio!=!!c.audio||!!b.video!=!!c.video||b.language!=c.language)&&(d=b.audio&&c.audio)){d=b.audio;var e=c.audio;d=!(d.channelsCount==e.channelsCount&&dh(d,e)&&eh(d.roles,e.roles))}!d&&(d=b.video&&c.video)&&(d=b.video,e=c.video,d=!(dh(d,e)&&eh(d.roles,e.roles)));return d?!1:!0}
bh.prototype.values=function(){return this.b.values()};function dh(b,c){if(b.mimeType!=c.mimeType)return!1;var d=b.codecs.split(",").map(function(b){return Nb(b)[0]}),e=c.codecs.split(",").map(function(b){return Nb(b)[0]});if(d.length!=e.length)return!1;d.sort();e.sort();for(var f=0;f<d.length;f++)if(d[f]!=e[f])return!1;return!0}
function eh(b,c){var d=new Set(b),e=new Set(c);d["delete"]("main");e["delete"]("main");if(d.size!=e.size)return!1;d=q(d);for(var f=d.next();!f.done;f=d.next())if(!e.has(f.value))return!1;return!0};function fh(b){this.a=b;this.b=new gh(b.language,"",b.audio&&b.audio.channelsCount?b.audio.channelsCount:0)}fh.prototype.create=function(b){var c=this,d=b.filter(function(b){return ch(c.a,b)});return d.length?new bh(d[0],d):this.b.create(b)};function gh(b,c,d){this.c=b;this.b=c;this.a=d}
gh.prototype.create=function(b){var c=[];c=hh(b,this.c);var d=b.filter(function(b){return b.primary});c=c.length?c:d.length?d:b;this.b&&(b=ih(c,this.b),b.length&&(c=b));this.a&&(b=Td(c,this.a),b.length&&(c=b));b=new bh(c[0]);c=q(c);for(d=c.next();!d.done;d=c.next())d=d.value,ch(b.a,d)&&b.add(d);return b};
function hh(b,c){c=Hd(c);if(!c)return[];for(var d={},e=q([0,Fd,Gd]),f=e.next();!f.done;d={dc:d.dc},f=e.next())if(d.dc=f.value,f=b.filter(function(b){return function(d){d=Hd(d.language);return Ed(b.dc,c,d)}}(d)),f.length)return f;return[]}function ih(b,c){return b.filter(function(b){var d=b.audio;b=b.video;return d&&0<=d.roles.indexOf(c)||b&&0<=b.roles.indexOf(c)})};function jh(b,c,d,e){this.a=b;this.A=c;this.s=d;this.u=e;this.h=new Cb;this.b=null;this.g=!1;this.o=b.readyState;this.c=!1;this.j=this.B=-1;this.f=this.i=!1;c=this.l.bind(this);H(this.h,b,"waiting",c);this.b=new Tb(c);$b(this.b,.25)}jh.prototype.destroy=function(){var b=this.h.destroy();this.u=this.A=this.a=this.h=null;null!=this.b&&(this.b.cancel(),this.b=null);return b};jh.prototype.gb=function(){this.f=!0;this.l()};
jh.prototype.l=function(){if(0!=this.a.readyState){if(this.a.seeking){if(!this.g)return}else this.g=!1;if(!this.a.paused){this.a.readyState!=this.o&&(this.c=!1,this.o=this.a.readyState);var b=this.s.smallGapLimit,c=this.a.currentTime,d=this.a.buffered;a:{if(d&&d.length&&!(1==d.length&&1E-6>d.end(0)-d.start(0))){var e=.1;/(Edge\/|Trident\/|Tizen)/.test(navigator.userAgent)&&(e=.5);for(var f=0;f<d.length;f++)if(d.start(f)>c&&(0==f||d.end(f-1)-c<=e)){e=f;break a}}e=null}if(null==e){if(d=this.a.currentTime,
c=this.a.buffered,!this.a.paused&&0<this.a.playbackRate)if(this.j!=d)this.j=d,this.B=Date.now(),this.i=!1;else if(!this.i&&this.B<Date.now()-1E3)for(e=0;e<c.length;e++)if(d>=c.start(e)&&d<c.end(e)-.5){this.a.currentTime+=.1;this.j=this.a.currentTime;this.i=!0;break}}else if(0!=e||this.f){f=d.start(e);var g=this.A.oa();if(!(f>=g)){g=f-c;b=g<=b;var h=!1;.001>g||(b||this.c||(this.c=!0,c=new D("largegap",{currentTime:c,gapSize:g}),c.cancelable=!0,this.u(c),this.s.jumpLargeGaps&&!c.defaultPrevented&&(h=
!0)),!b&&!h)||(0!=e&&d.end(e-1),this.a.currentTime=f)}}}}};function kh(b,c,d){this.a=b;this.i=c;this.h=d;this.c=new Cb;this.f=1;this.g=!1;this.b=null;0<b.readyState?this.Xc():Fb(this.c,b,"loadedmetadata",this.Xc.bind(this));H(this.c,b,"ratechange",this.pe.bind(this))}n=kh.prototype;n.destroy=function(){var b=this.c.destroy();this.c=null;null!=this.b&&(this.b.cancel(),this.b=null);this.i=this.a=null;return b};function lh(b){return 0<b.a.readyState?b.a.currentTime:b.h}function mh(b,c){0<b.a.readyState?nh(b,b.a.currentTime,c):(b.h=c,setTimeout(b.i,0))}
n.ab=function(){return this.f};function oh(b,c){null!=b.b&&(b.b.cancel(),b.b=null);b.f=c;b.a.playbackRate=b.g||0>c?0:c;!b.g&&0>c&&(b.b=new Tb(function(){b.a.currentTime+=c/4}),$b(b.b,.25))}n.pe=function(){var b=this.g||0>this.f?0:this.f;this.a.playbackRate&&this.a.playbackRate!=b&&oh(this,this.a.playbackRate)};n.Xc=function(){.001>Math.abs(this.a.currentTime-this.h)?this.Yc():(Fb(this.c,this.a,"seeking",this.Yc.bind(this)),this.a.currentTime=0==this.a.currentTime?this.h:this.a.currentTime)};
n.Yc=function(){var b=this;H(this.c,this.a,"seeking",function(){return b.i()})};function nh(b,c,d){function e(){!b.a||10<=f++||b.a.currentTime!=c||(b.a.currentTime=d,setTimeout(e,100))}b.a.currentTime=d;var f=0;setTimeout(e,100)};function ph(b,c,d,e,f,g,h){this.c=b;this.a=c;this.l=d;this.h=e;this.j=g;this.f=null;this.g=new jh(b,c,e,h);c=this.re.bind(this);null==f?f=Infinity>this.a.S()?this.a.Pa():this.a.oa():0>f&&(f=this.a.oa()+f);f=qh(this,rh(this,f));this.b=new kh(b,c,f);this.f=new Tb(this.oe.bind(this));$b(this.f,.25)}n=ph.prototype;n.destroy=function(){var b=Promise.all([this.b.destroy(),this.g.destroy()]);this.g=this.b=null;null!=this.f&&(this.f.cancel(),this.f=null);this.j=this.h=this.a=this.c=null;return b};
function sh(b){var c=lh(b.b);0<b.c.readyState&&(b.c.paused||(c=rh(b,c)));return c}n.ab=function(){return this.b.ab()};n.gb=function(){this.g.gb()};n.oe=function(){if(0!=this.c.readyState&&!this.c.paused){var b=this.c.currentTime,c=this.a.Pa(),d=this.a.oa();3>d-c&&(c=d-3);b<c&&(b=th(this,b),this.c.currentTime=b)}};n.re=function(){var b=this.g;b.g=!0;b.f=!1;b.c=!1;var c=lh(this.b);b=th(this,c);if(.001<Math.abs(b-c)&&(c=(new Date).getTime()/1E3,!this.i||this.i<c-1)){this.i=c;mh(this.b,b);return}this.j()};
function qh(b,c){var d=b.a.S();return c>=d?d-b.h.durationBackoff:c}function th(b,c){var d=Jc.bind(null,b.c.buffered),e=Math.max(b.l,b.h.rebufferingGoal),f=b.a.Pa(),g=b.a.oa(),h=b.a.S();3>g-f&&(f=g-3);var k=b.a.bb(e),m=b.a.bb(5);e=b.a.bb(e+5);return c>=h?qh(b,c):c>g?g:c<f?d(m)?m:e:c>=k||d(c)?c:e}function rh(b,c){var d=b.a.Pa();if(c<d)return d;d=b.a.oa();return c>d?d:c};function uh(b){this.a=!1;this.b=new z;this.c=b}uh.prototype.destroy=function(){var b=this;if(this.a)return this.b;this.a=!0;return this.c().then(function(){b.b.resolve()},function(){b.b.resolve()})};function vh(b,c){return r(function e(){return v(e,function(e){switch(e.m){case 1:return pa(e,2),u(e,Promise.resolve(c()),4);case 4:return e["return"](e.w);case 2:return sa(e),u(e,Promise.all(b.map(function(b){return b.destroy()})),5);case 5:ta(e,0)}})})};function wh(b,c,d,e,f,g,h){var k=this;this.a=b;this.J=c;this.s=d;this.l=e;this.h=f;this.u=g;this.f=[];this.j=new Cb;this.c=!1;this.i=-1;this.g=null;this.b=h;this.B=new uh(function(){var b=Promise.all([k.j?k.j.destroy():null,k.b?k.b.destroy():null]);k.j=null;xh(k);k.a=null;k.s=null;k.l=null;k.h=null;k.u=null;k.f=[];k.b=null;return b});yh(this)}wh.prototype.destroy=function(){return this.B.destroy()};
function zh(b,c){if(!b.f.some(function(b){return b.info.schemeIdUri==c.schemeIdUri&&b.info.startTime==c.startTime&&b.info.endTime==c.endTime})){var d={info:c,status:1};b.f.push(d);var e=new D("timelineregionadded",{detail:Ah(c)});b.h(e);b.o(!0,d)}}function Ah(b){var c=mb(b);c.eventElement=b.eventElement;return c}
wh.prototype.o=function(b,c){var d=c.info.startTime>this.a.currentTime?1:c.info.endTime<this.a.currentTime?3:2,e=2==c.status,f=2==d;if(d!=c.status){if(!b||e||f)e||this.h(new D("timelineregionenter",{detail:Ah(c.info)})),f||this.h(new D("timelineregionexit",{detail:Ah(c.info)}));c.status=d}};function yh(b){xh(b);b.g=window.setTimeout(b.A.bind(b),250)}function xh(b){b.g&&(window.clearTimeout(b.g),b.g=null)}
wh.prototype.A=function(){this.g=null;yh(this);var b=Yd(this.b.a,this.a.currentTime);b!=this.i&&(-1!=this.i&&this.u(),this.i=b);b=Kc(this.a.buffered,this.a.currentTime);var c=Ic(this.a.buffered);var d=this.b;c=c||0;var e=d.a.presentationTimeline,f=e.Qa();c=e.W()&&c>=f;e=d.b;e=e.g?"ended"==e.g.readyState:!0;d=c||e||d.c.ended;this.c?(c=Math.max(this.J,this.s.rebufferingGoal),(d||b>=c)&&0!=this.c&&(this.c=!1,this.l(!1))):!d&&.5>b&&1!=this.c&&(this.c=!0,this.l(!0));this.f.forEach(this.o.bind(this,!1))};
function Bh(b,c,d){this.c=b;this.b=c;this.a=d}Bh.prototype.destroy=function(){this.a=this.b=this.c=null;return Promise.resolve()};function Ch(b,c){this.a=c;this.b=b;this.g=null;this.j=1;this.o=Promise.resolve();this.h=[];this.i=new Map;this.c=new Map;this.s=!1;this.B=null;this.A=this.f=this.l=!1;this.u=0}n=Ch.prototype;n.destroy=function(){for(var b=q(this.c.values()),c=b.next();!c.done;c=b.next())Dh(c.value);this.c.clear();this.i.clear();this.g=this.h=this.o=this.b=this.a=null;this.f=!0;return Promise.resolve()};
n.configure=function(b){this.g=b;this.B=new bb({maxAttempts:Math.max(b.retryParameters.maxAttempts,2),baseDelay:b.retryParameters.baseDelay,backoffFactor:b.retryParameters.backoffFactor,fuzzFactor:b.retryParameters.fuzzFactor,timeout:0},!0)};n.init=function(){var b=sh(this.a.Ga);b=this.a.Rc(this.b.periods[Yd(this.b,b)]);return b.variant||b.text?Eh(this,b).then(function(){!this.f&&this.a&&this.a.he&&this.a.he()}.bind(this)):Promise.reject(new B(2,5,5005))};
function Fh(b){var c=sh(b.a.Ga);return b.b.periods[Yd(b.b,c)]}function Gh(b){var c=b.c.get("video");return c?b.b.periods[c.ua]:(c=b.c.get("audio"))?b.b.periods[c.ua]:null}function Hh(b){return Ih(b,"audio")}function Jh(b){return Ih(b,"video")}function Ih(b,c){var d=b.c.get(c);return d?d.va||d.stream:null}
function Kh(b,c){return r(function e(){var f,g,h,k,m,l,p,t;return v(e,function(e){switch(e.m){case 1:return f=hd,Ad(b.a.L,f.Ma),b.u++,b.A=!1,g=b.u,h=b.a.L,k=new Map,m=new Set,k.set(f.Ma,c),m.add(c),u(e,h.init(k,!1),2);case 2:return b.f?e["return"]():u(e,Lh(b,m),3);case 3:if(b.f)return e["return"]();b.u!=g||b.c.has(f.Ma)||b.A||(l=sh(b.a.Ga),p=Yd(b.b,l),t=Mh(c,p),b.c.set(f.Ma,t),Nh(b,t,0));e.m=0}})})}function Oh(b){b.A=!0;var c=b.c.get("text");c&&(Dh(c),b.c["delete"]("text"))}
function Ph(b,c){var d=b.c.get("video");if(d){var e=d.stream;if(e)if(c){var f=e.trickModeVideo;f&&!d.va&&(Qh(b,f,!1,0),d.va=e)}else if(e=d.va)d.va=null,Qh(b,e,!0,0)}}function Rh(b,c,d,e){c.video&&Qh(b,c.video,d,e);c.audio&&Qh(b,c.audio,d,e)}
function Qh(b,c,d,e){var f=b.c.get(c.type);if(!f&&"text"==c.type&&b.g.ignoreTextStreamFailures)Kh(b,c);else if(f){var g=Zd(b.b,c);d&&g!=f.ua?Sh(b):(f.va&&(c.trickModeVideo?(f.va=c,c=c.trickModeVideo):f.va=null),(g=b.h[g])&&g.Ya&&(g=b.i.get(c.id))&&g.Ya&&f.stream!=c&&("text"==c.type&&td(b.a.L,Kb(c.mimeType,c.codecs)),f.stream=c,f.Fb=!0,d&&(f.Ba?f.Lb=!0:f.Fa?(f.za=!0,f.yb=e,f.Lb=!0):(Dh(f),Th(b,f,!0,e)))))}}
function Uh(b){var c=sh(b.a.Ga),d=b.g.smallGapLimit;Array.from(b.c.keys()).every(function(e){var f=b.a.L;"text"==e?(e=f.a,e=c>=e.a&&c<e.b):(e=vd(f,e),e=Jc(e,c,d));return e})||Sh(b)}function Sh(b){b.c.forEach(function(c,d){c.Ba||c.za||(c.Fa?(c.za=!0,c.yb=0):null==ud(b.a.L,d)?null==c.ya&&Nh(b,c,0):(Dh(c),Th(b,c,!1,0)))})}
function Eh(b,c,d){return r(function f(){var g,h,k,m,l,p,t;return v(f,function(f){switch(f.m){case 1:return g=sh(b.a.Ga),h=Yd(b.b,g),k=hd,m=new Map,l=new Set,c.variant&&c.variant.audio&&(m.set(k.sd,c.variant.audio),l.add(c.variant.audio)),c.variant&&c.variant.video&&(m.set(k.xd,c.variant.video),l.add(c.variant.video)),c.text&&(m.set(k.Ma,c.text),l.add(c.text)),p=b.a.L,t=b.g.forceTransmuxTS,u(f,p.init(m,t),2);case 2:if(b.f)return f["return"]();Vh(b);return u(f,Lh(b,l),3);case 3:if(b.f)return f["return"]();
m.forEach(function(c,f){if(!b.c.has(f)){var g=Mh(c,h,d);b.c.set(f,g);Nh(b,g,0)}});f.m=0}})})}function Mh(b,c,d){return{stream:b,type:b.type,Ra:null,pa:null,va:null,Fb:!0,ua:c,endOfStream:!1,Fa:!1,ya:null,za:!1,yb:0,Lb:!1,Ba:!1,oc:!1,eb:!1,fd:d||0}}
function Wh(b,c){var d=b.h[c];if(d)return d.promise;d={promise:new z,Ya:!1};b.h[c]=d;for(var e=new Set,f=q(b.b.periods[c].variants),g=f.next();!g.done;g=f.next())g=g.value,g.video&&e.add(g.video),g.video&&g.video.trickModeVideo&&e.add(g.video.trickModeVideo),g.audio&&e.add(g.audio);f=q(b.b.periods[c].textStreams);for(g=f.next();!g.done;g=f.next())e.add(g.value);b.o=b.o.then(function(){if(!this.f)return Lh(this,e)}.bind(b)).then(function(){this.f||(this.h[c].promise.resolve(),this.h[c].Ya=!0)}.bind(b))["catch"](function(b){this.f||
(this.h[c].promise["catch"](function(){}),this.h[c].promise.reject(),delete this.h[c],this.a.onError(b))}.bind(b));return d.promise}
function Lh(b,c){return r(function e(){var f,g,h,k,m,l,p;return v(e,function(e){switch(e.m){case 1:f=[];for(var t=q(c),x=t.next();!x.done;x=t.next())g=x.value,(h=b.i.get(g.id))?f.push(h.promise):(b.i.set(g.id,{promise:new z,Ya:!1}),f.push(g.createSegmentIndex()));oa(e,2);return u(e,Promise.all(f),4);case 4:if(b.f)return e["return"]();qa(e,3);break;case 2:k=ra(e);if(b.f)return e["return"]();e=q(c);for(x=e.next();!x.done;x=e.next())m=x.value,b.i.get(m.id).promise["catch"](function(){}),b.i.get(m.id).promise.reject(),
b.i["delete"](m.id);throw k;case 3:t=q(c);for(x=t.next();!x.done;x=t.next())l=x.value,p=b.i.get(l.id),p.Ya||(p.promise.resolve(),p.Ya=!0);e.m=0}})})}function Vh(b){var c=b.b.presentationTimeline.S();Infinity>c?b.a.L.ma(c):b.a.L.ma(Math.pow(2,32))}
n.jf=function(b){if(!this.f&&!b.Fa&&null!=b.ya&&!b.Ba)if(b.ya=null,b.za)Th(this,b,b.Lb,b.yb);else{try{var c=Xh(this,b);null!=c&&(Nh(this,b,c),b.eb=!1)}catch(d){Yh(this,d);return}c=Array.from(this.c.values());Zh(this,b);c.every(function(b){return b.endOfStream})&&this.a.L.endOfStream().then(function(){if(!this.f){var b=this.a.L.S();b<this.b.presentationTimeline.S()&&this.b.presentationTimeline.ma(b)}}.bind(this))}};
function Xh(b,c){var d=sh(b.a.Ga),e=$h(b,c,d),f=Zd(b.b,c.stream),g=Yd(b.b,e),h=xd(b.a.L,c.type,d),k=Math.max(b.b.minBufferTime||0,b.g.rebufferingGoal,b.g.bufferingGoal)*b.j;if(e>=b.b.presentationTimeline.S())return c.endOfStream=!0,null;c.endOfStream=!1;c.ua=g;if(g!=f)return null;if(h>=k)return.5;g=wd(b.a.L,c.type);g=ai(b,c,d,g,f);if(!g)return 1;var m=Infinity;Array.from(b.c.values()).forEach(function(c){m=Math.min(m,$h(b,c,d))});if(e>=m+b.b.presentationTimeline.a)return 1;c.fd=0;bi(b,c,d,f,g);return null}
function $h(b,c,d){return c.Ra&&c.pa?b.b.periods[Zd(b.b,c.Ra)].startTime+c.pa.endTime:Math.max(d,c.fd)}function ai(b,c,d,e,f){if(c.pa&&c.stream==c.Ra)return ci(b,c,f,c.pa.position+1);d=c.pa?c.stream.findSegmentPosition(Math.max(0,b.b.periods[Zd(b.b,c.Ra)].startTime+c.pa.endTime-b.b.periods[f].startTime)):c.stream.findSegmentPosition(Math.max(0,(e||d)-b.b.periods[f].startTime));if(null==d)return null;var g=null;null==e&&(g=ci(b,c,f,Math.max(0,d-1)));return g||ci(b,c,f,d)}
function ci(b,c,d,e){d=b.b.periods[d];c=c.stream.getSegmentReference(e);if(!c)return null;e=b.b.presentationTimeline;b=e.cb();e=e.Qa();return d.startTime+c.endTime<b||d.startTime+c.startTime>e?null:c}
function bi(b,c,d,e,f){var g=b.b.periods[e],h=c.stream,k=b.b.presentationTimeline.S(),m=b.b.periods[e+1];e=di(b,c,e,Math.max(0,g.startTime-.1),m?m.startTime:k);c.Fa=!0;c.Fb=!1;k=ei(b,f);Promise.all([e,k]).then(function(b){if(!this.f&&!this.l)return fi(this,c,d,g,h,f,b[1])}.bind(b)).then(function(){this.f||this.l||(c.Fa=!1,c.oc=!1,c.za||this.a.gb(),Nh(this,c,0),gi(this,h))}.bind(b))["catch"](function(b){this.f||this.l||(c.Fa=!1,"text"==c.type&&this.g.ignoreTextStreamFailures?this.c["delete"]("text"):
3017==b.code?hi(this,c,b):(c.eb=!0,b.severity=2,Yh(this,b)))}.bind(b))}function hi(b,c,d){if(!Array.from(b.c.values()).some(function(b){return b!=c&&b.oc})){var e=Math.round(100*b.j);if(20<e)b.j-=.2;else if(4<e)b.j-=.04;else{c.eb=!0;b.l=!0;b.a.onError(d);return}c.oc=!0}Nh(b,c,4)}
function di(b,c,d,e,f){if(!c.Fb)return Promise.resolve();d=Bd(b.a.L,c.type,b.b.periods[d].startTime-c.stream.presentationTimeOffset,e,f);if(!c.stream.initSegmentReference)return d;b=ei(b,c.stream.initSegmentReference).then(function(b){if(!this.f)return yd(this.a.L,c.type,b,null,null)}.bind(b))["catch"](function(b){c.Fb=!0;return Promise.reject(b)});return Promise.all([d,b])}
function fi(b,c,d,e,f,g,h){null!=f.emsgSchemeIdUris&&0<f.emsgSchemeIdUris.length&&(new Q).aa("emsg",b.Ce.bind(b,e,g,f.emsgSchemeIdUris)).parse(h);return ii(b,c,d).then(function(){if(!this.f)return yd(this.a.L,c.type,h,g.startTime+e.startTime,g.endTime+e.startTime)}.bind(b)).then(function(){if(!this.f)return c.Ra=f,c.pa=g,Promise.resolve()}.bind(b))}
n.Ce=function(b,c,d,e){var f=e.reader.mc(),g=e.reader.mc(),h=e.reader.C(),k=e.reader.C(),m=e.reader.C(),l=e.reader.C();e=e.reader.Ha(e.reader.H.byteLength-e.reader.V());b=b.startTime+c.startTime+k/h;if(d.includes(f))if("urn:mpeg:dash:event:2012"==f)this.a.ie();else this.a.onEvent(new D("emsg",{detail:{startTime:b,endTime:b+m/h,schemeIdUri:f,value:g,timescale:h,presentationTimeDelta:k,eventDuration:m,id:l,messageData:e}}))};
function ii(b,c,d){var e=Math.max(b.g.bufferBehind,b.b.presentationTimeline.a),f=ud(b.a.L,c.type);if(null==f)return Promise.resolve();d=d-f-e;return 0>=d?Promise.resolve():b.a.L.remove(c.type,f,f+d).then(function(){}.bind(b))}
function gi(b,c){if(!b.s&&(b.s=Array.from(b.c.values()).every(function(b){return"text"==b.type?!0:!b.za&&!b.Ba&&b.pa}),b.s)){var d=Zd(b.b,c);b.h[d]||Wh(b,d).then(function(){this.f||this.a.Qc()}.bind(b))["catch"](I.Ea);for(d=0;d<b.b.periods.length;++d)Wh(b,d)["catch"](I.Ea);b.a.ue&&b.a.ue()}}
function Zh(b,c){if(c.ua!=Zd(b.b,c.stream)){var d=c.ua,e=Array.from(b.c.values());e.every(function(b){return b.ua==d})&&e.every(ji)&&Wh(b,d).then(function(){if(!this.f&&e.every(function(b){var c=Zd(this.b,b.stream);return ji(b)&&b.ua==d&&c!=d}.bind(this))){var b=this.b.periods[d],c=this.a.Rc(b),h=new Map;c.variant&&c.variant.video&&h.set("video",c.variant.video);c.variant&&c.variant.audio&&h.set("audio",c.variant.audio);c.text&&h.set("text",c.text);var k=q(this.c.keys());for(c=k.next();!c.done;c=
k.next())if(c=c.value,!h.has(c)&&"text"!=c){this.a.onError(new B(2,5,5005));return}k=q(Array.from(h.keys()));for(c=k.next();!c.done;c=k.next())if(c=c.value,!this.c.has(c))if("text"==c)Eh(this,{text:h.get("text")},b.startTime),h["delete"](c);else{this.a.onError(new B(2,5,5005));return}b=q(Array.from(this.c.keys()));for(c=b.next();!c.done;c=b.next())c=c.value,(k=h.get(c))?(Qh(this,k,!1,0),Nh(this,this.c.get(c),0)):this.c["delete"](c);this.a.Qc()}}.bind(b))["catch"](I.Ea)}}
function ji(b){return!b.Fa&&null==b.ya&&!b.za&&!b.Ba}function ei(b,c){var d=xb(c.c(),b.g.retryParameters);if(0!=c.b||null!=c.a){var e="bytes="+c.b+"-";null!=c.a&&(e+=c.a);d.headers.Range=e}return b.a.Gb.request(1,d).promise.then(function(b){return b.data})}
function Th(b,c,d,e){c.za=!1;c.Lb=!1;c.yb=0;c.Ba=!0;if(e){var f=sh(b.a.Ga);e=b.a.L.remove(c.type,f+e,b.a.L.S())}else e=Ad(b.a.L,c.type).then(function(){if(!this.f&&d)return this.a.L.flush(c.type)}.bind(b));e.then(function(){this.f||(c.Ra=null,c.pa=null,c.Ba=!1,c.endOfStream=!1,Nh(this,c,0))}.bind(b))}function Nh(b,c,d){c.ya=window.setTimeout(b.jf.bind(b,c),1E3*d)}function Dh(b){null!=b.ya&&(window.clearTimeout(b.ya),b.ya=null)}
function Yh(b,c){eb(b.B).then(function(){this.f||(this.a.onError(c),c.handled||this.g.failureCallback(c))}.bind(b))};function ki(b,c,d,e,f,g){if(200<=d&&299>=d&&202!=d)return f&&(e=f),{uri:e,data:c,headers:b,fromCache:!!b["x-shaka-from-cache"]};f=null;try{f=Rb(c)}catch(h){}throw new B(401==d||403==d?2:1,1,1001,e,d,f,b,g);};function V(b,c,d,e){var f=new V.b;Ib(c.headers).forEach(function(b,c){f.append(c,b)});var g=new V.a,h={body:c.body||void 0,headers:f,method:c.method,signal:g.signal,credentials:c.allowCrossSiteCredentials?"include":void 0},k={Dc:!1,pd:!1},m;c.retryParameters.timeout&&(m=setTimeout(function(){k.pd=!0;g.abort()},c.retryParameters.timeout));b=V.h(b,d,h,k,m,e);return new C(b,function(){k.Dc=!0;g.abort();return Promise.resolve()})}y("shaka.net.HttpFetchPlugin",V);
V.h=function(b,c,d,e,f,g){return r(function k(){var m,l,p,t,w,x,A,F,P,W,T,na;return v(k,function(k){switch(k.m){case 1:return m=V.g,l=V.c,x=w=0,A=Date.now(),oa(k,2,3),u(k,m(b,d),5);case 5:return p=k.w,F=p.clone().body.getReader(),P=function(b){function c(){return r(function Oc(){var d,e;return v(Oc,function(f){switch(f.m){case 1:return u(f,F.read(),2);case 2:d=f.w;d.done||(w+=d.value.byteLength);e=Date.now();if(100<e-A||d.done)g(e-A,w-x),x=w,A=e;d.done?b.close():(b.enqueue(d.value),c());f.m=0}})})}
c()},new l({start:P}),u(k,p.arrayBuffer(),6);case 6:t=k.w;case 3:sa(k);clearTimeout(f);ta(k,4);break;case 2:W=ra(k);if(e.Dc)throw new B(1,1,7001,b,c);if(e.pd)throw new B(1,1,1003,b,c);throw new B(1,1,1002,b,W,c);case 4:return T={},na=p.headers,na.forEach(function(b,c){T[c.trim()]=b}),k["return"](ki(T,t,p.status,b,p.url,c))}})})};V.isSupported=function(){if(window.ReadableStream)try{new ReadableStream({})}catch(b){return!1}else return!1;return!(!window.fetch||!window.AbortController)};
V.isSupported=V.isSupported;V.g=window.fetch;V.a=window.AbortController;V.c=window.ReadableStream;V.b=window.Headers;V.isSupported()&&(wb("http",V,2),wb("https",V,2));function li(b,c,d,e){var f=new li.f,g=Date.now(),h=0,k=new Promise(function(k,l){f.open(c.method,b,!0);f.responseType="arraybuffer";f.timeout=c.retryParameters.timeout;f.withCredentials=c.allowCrossSiteCredentials;f.onabort=function(){l(new B(1,1,7001,b,d))};f.onload=function(c){c=c.target;var e=c.getAllResponseHeaders().trim().split("\r\n"),f={};e=q(e);for(var g=e.next();!g.done;g=e.next())g=g.value.split(": "),f[g[0].toLowerCase()]=g.slice(1).join(": ");try{var h=ki(f,c.response,c.status,b,c.responseURL,
d);k(h)}catch(P){l(P)}};f.onerror=function(c){l(new B(1,1,1002,b,c,d))};f.ontimeout=function(){l(new B(1,1,1003,b,d))};f.onprogress=function(b){var c=Date.now();if(100<c-g||b.lengthComputable&&b.loaded==b.total)e(c-g,b.loaded-h),h=b.loaded,g=c};for(var m in c.headers)f.setRequestHeader(m.toLowerCase(),c.headers[m]);f.send(c.body)});return new C(k,function(){f.abort();return Promise.resolve()})}y("shaka.net.HttpXHRPlugin",li);li.f=window.XMLHttpRequest;wb("http",li,1);wb("https",li,1);function mi(b){this.b=new Map;this.c=Promise.resolve();this.h=!1;this.i=b;this.f=this.a=this.g=0}mi.prototype.destroy=function(){this.h=!0;var b=this.c["catch"](function(){});this.c=Promise.resolve();return b};function ni(b,c,d,e,f){var g=b.b.get(c)||[];g.push({request:d,Fc:e,fe:f});b.b.set(c,g)}
function oi(b,c){var d=Array.from(b.b.values());b.b.clear();for(var e=q(d),f=e.next();!f.done;f=e.next()){f=q(f.value);for(var g=f.next();!g.done;g=f.next())b.a+=g.value.Fc}var h=Promise.all(d.map(function(d){return pi(b,c,d)}));b.c=b.c.then(function(){return h});return h}function pi(b,c,d){var e=Promise.resolve();d.forEach(function(d){e=e.then(function(){qi(b);return ri(b,c,d)})});return e}
function ri(b,c,d){return Promise.resolve().then(function(){qi(b);return c.request(1,d.request).promise}).then(function(c){qi(b);b.g+=d.Fc;b.f+=c.data.byteLength;b.i(b.a?b.g/b.a:0,b.f);return d.fe(c.data)})}function qi(b){if(b.h)throw new B(2,9,7001);};function si(b,c){var d=this;this.c=b;this.b=b.objectStore(c);this.a=new z;b.onabort=function(b){b.preventDefault();d.a.reject()};b.onerror=function(b){b.preventDefault();d.a.reject()};b.oncomplete=function(){d.a.resolve()}}si.prototype.abort=function(){try{this.c.abort()}catch(b){}return this.a["catch"](function(){})};
function ti(b,c){return new Promise(function(d,e){var f=b.b.openCursor();f.onerror=e;f.onsuccess=function(b){b=b.target.result;if(!b)return d();c(b.key,b.value,b);b["continue"]()}})}si.prototype.store=function(){return this.b};si.prototype.promise=function(){return this.a};function ui(b){this.b=b;this.a=[]}ui.prototype.destroy=function(){return Promise.all(this.a.map(function(b){return b.abort()}))};function vi(b,c){return wi(b,c,"readonly")}function xi(b,c){return wi(b,c,"readwrite")}function wi(b,c,d){d=b.b.transaction([c],d);var e=new si(d,c);b.a.push(e);e.promise().then(function(){ob(b.a,e)},function(){ob(b.a,e)});return e};function yi(b){this.a=new ui(b)}yi.prototype.destroy=function(){return this.a.destroy()};yi.prototype.getAll=function(){var b=this;return r(function d(){var e,f;return v(d,function(d){switch(d.m){case 1:return e=vi(b.a,"session-ids"),f=[],u(d,ti(e,function(b,d){f.push(d)}),2);case 2:return u(d,e.promise(),3);case 3:return d["return"](f)}})})};yi.prototype.add=function(b){var c=xi(this.a,"session-ids"),d=c.store();b=q(b);for(var e=b.next();!e.done;e=b.next())d.add(e.value);return c.promise()};
yi.prototype.remove=function(b){var c=this;return r(function e(){var f;return v(e,function(e){switch(e.m){case 1:return f=xi(c.a,"session-ids"),u(e,ti(f,function(c,e,f){0<=b.indexOf(e.sessionId)&&f["delete"]()}),2);case 2:return u(e,f.promise(),0)}})})};function zi(){this.a=new Map}zi.prototype.destroy=function(){for(var b=[],c=q(this.a.values()),d=c.next();!d.done;d=c.next())b.push(d.value.destroy());this.a.clear();return Promise.all(b)};zi.prototype.init=function(){var b=this;Ai.forEach(function(c,d){var e=c();e&&b.a.set(d,e)});for(var c=[],d=q(this.a.values()),e=d.next();!e.done;e=d.next())c.push(e.value.init());return Promise.all(c)};
function Bi(b){var c=null;b.a.forEach(function(b,e){b.getCells().forEach(function(b,d){b.hasFixedKeySpace()||c||(c={path:{ka:e,U:d},U:b})})});if(c)return c;throw new B(2,9,9013,"Could not find a cell that supports add-operations");}function Ci(b,c){b.a.forEach(function(b,e){b.getCells().forEach(function(b,d){c({ka:e,U:d},b)})})}
function Di(b,c,d){b=b.a.get(c);if(!b)throw new B(2,9,9013,"Could not find mechanism with name "+c);c=b.getCells().get(d);if(!c)throw new B(2,9,9013,"Could not find cell with name "+d);return c}function Ei(b,c){b.a.forEach(function(b){c(b.getEmeSessionCell())})}function Fi(b){var c=Array.from(b.a.keys());if(!c.length)throw new B(2,9,9E3,"No supported storage mechanisms found");return b.a.get(c[0]).getEmeSessionCell()}function Gi(b,c){Ai.set(b,c)}y("shaka.offline.StorageMuxer.register",Gi);
y("shaka.offline.StorageMuxer.unregister",function(b){Ai["delete"](b)});function Hi(){for(var b=q(Ai.values()),c=b.next();!c.done;c=b.next())if(c=c.value,c=c())return c.destroy(),!0;return!1}var Ai=new Map;function Ii(b){this.a=new ui(b)}n=Ii.prototype;n.destroy=function(){return this.a.destroy()};n.hasFixedKeySpace=function(){return!0};n.addSegments=function(){return Ji("segment")};n.removeSegments=function(b,c){return Ki(this,"segment",b,c)};n.getSegments=function(b){return Li(this,"segment",b).then(function(b){return b.map(Mi)})};n.addManifests=function(){return Ji("manifest")};
n.updateManifestExpiration=function(b,c){var d=xi(this.a,"manifest"),e=d.store(),f=new z;e.get(b).onsuccess=function(d){(d=d.target.result)?(d.expiration=c,e.put(d),f.resolve()):f.reject(new B(2,9,9012,"Could not find values for "+b))};return d.promise().then(function(){return f})};n.removeManifests=function(b,c){return Ki(this,"manifest",b,c)};n.getManifests=function(b){return Li(this,"manifest",b).then(function(b){return b.map(Ni)})};
n.getAllManifests=function(){var b=this;return r(function d(){var e,f,g;return v(d,function(d){switch(d.m){case 1:return e=Ni,f=vi(b.a,"manifest"),g=new Map,u(d,ti(f,function(b,d){g.set(b,e(d))}),2);case 2:return u(d,f.promise(),3);case 3:return d["return"](g)}})})};function Ji(b){return Promise.reject(new B(2,9,9011,"Cannot add new value to "+b))}function Ki(b,c,d,e){b=xi(b.a,c);var f=b.store();d.forEach(function(b){f["delete"](b).onsuccess=function(){return e(b)}});return b.promise()}
function Li(b,c,d){b=vi(b.a,c);var e=b.store(),f={},g=[];d.forEach(function(b){e.get(b).onsuccess=function(c){c=c.target.result;void 0==c&&g.push(b);f[b]=c}});return b.promise().then(function(){return g.length?Promise.reject(new B(2,9,9012,"Could not find values for "+g)):d.map(function(b){return f[b]})})}
function Ni(b){return{originalManifestUri:b.originalManifestUri,duration:b.duration,size:b.size,expiration:null==b.expiration?Infinity:b.expiration,periods:b.periods.map(Oi),sessionIds:b.sessionIds,drmInfo:b.drmInfo,appMetadata:b.appMetadata}}function Oi(b){Pi(b);b.streams.forEach(function(){});return{startTime:b.startTime,streams:b.streams.map(Qi)}}
function Qi(b){var c=b.ae?Ri(b.ae):null;return{id:b.id,originalId:null,primary:b.primary,presentationTimeOffset:b.presentationTimeOffset,contentType:b.contentType,mimeType:b.mimeType,codecs:b.codecs,frameRate:b.frameRate,kind:b.kind,language:b.language,label:b.label,width:b.width,height:b.height,initSegmentKey:c,encrypted:b.encrypted,keyId:b.keyId,segments:b.segments.map(Si),variantIds:b.variantIds}}function Si(b){var c=Ri(b.uri);return{startTime:b.startTime,endTime:b.endTime,dataKey:c}}
function Mi(b){return{data:b.data}}function Ri(b){var c;if((c=/^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(b))||(c=/^offline:segment\/([0-9]+)$/.exec(b)))return Number(c[1]);throw new B(2,9,9004,"Could not parse uri "+b);}
function Pi(b){var c=b.streams.filter(function(b){return"audio"==b.contentType}),d=b.streams.filter(function(b){return"video"==b.contentType});if(!c.every(function(b){return b.variantIds})||!d.every(function(b){return b.variantIds})){c.forEach(function(b){b.variantIds=[]});d.forEach(function(b){b.variantIds=[]});var e=0;if(d.length&&!c.length){var f=e++;d.forEach(function(b){b.variantIds.push(f)})}if(!d.length&&c.length){var g=e++;c.forEach(function(b){b.variantIds.push(g)})}d.length&&c.length&&c.forEach(function(b){d.forEach(function(c){var d=
e++;b.variantIds.push(d);c.variantIds.push(d)})})}};function Ti(b,c,d,e){this.a=new ui(b);this.c=c;this.b=d;this.f=e}n=Ti.prototype;n.destroy=function(){return this.a.destroy()};n.hasFixedKeySpace=function(){return this.f};n.addSegments=function(b){return Ui(this,this.c,b)};n.removeSegments=function(b,c){return Vi(this,this.c,b,c)};n.getSegments=function(b){return Wi(this,this.c,b)};n.addManifests=function(b){return Ui(this,this.b,b)};
n.updateManifestExpiration=function(b,c){var d=xi(this.a,this.b),e=d.store();e.get(b).onsuccess=function(d){if(d=d.target.result)d.expiration=c,e.put(d,b)};return d.promise()};n.removeManifests=function(b,c){return Vi(this,this.b,b,c)};n.getManifests=function(b){return Wi(this,this.b,b)};
n.getAllManifests=function(){var b=this;return r(function d(){var e,f;return v(d,function(d){switch(d.m){case 1:return e=vi(b.a,b.b),f=new Map,u(d,ti(e,function(b,d){f.set(b,d)}),2);case 2:return u(d,e.promise(),3);case 3:return d["return"](f)}})})};
function Ui(b,c,d){if(b.f)return Promise.reject(new B(1,9,9011,"Cannot add new value to "+c));b=xi(b.a,c);var e=b.store(),f=[];d.forEach(function(b){e.add(b).onsuccess=function(b){f.push(b.target.result)}});return b.promise().then(function(){return f})}function Vi(b,c,d,e){b=xi(b.a,c);var f=b.store();d.forEach(function(b){f["delete"](b).onsuccess=function(){return e(b)}});return b.promise()}
function Wi(b,c,d){b=vi(b.a,c);var e=b.store(),f={},g=[];d.forEach(function(b){var c=e.get(b);c.onsuccess=function(){void 0==c.result&&g.push(b);f[b]=c.result}});return b.promise().then(function(){return g.length?Promise.reject(new B(1,9,9012,"Could not find values for "+g)):d.map(function(b){return f[b]})})};function Xi(){this.g=this.c=this.b=this.a=this.f=null}n=Xi.prototype;
n.init=function(){var b=this,c=new z,d=window.indexedDB.open("shaka_offline_db",4);d.onsuccess=function(d){d=d.target.result;b.f=d;var e=d.objectStoreNames;e=e.contains("manifest")&&e.contains("segment")?new Ii(d):null;b.a=e;e=d.objectStoreNames;e=e.contains("manifest-v2")&&e.contains("segment-v2")?new Ti(d,"segment-v2","manifest-v2",!0):null;b.b=e;e=d.objectStoreNames;e=e.contains("manifest-v3")&&e.contains("segment-v3")?new Ti(d,"segment-v3","manifest-v3",!1):null;b.c=e;d=d.objectStoreNames.contains("session-ids")?
new yi(d):null;b.g=d;c.resolve()};d.onupgradeneeded=function(b){b=b.target.result;for(var c=q(["segment-v3","manifest-v3","session-ids"]),d=c.next();!d.done;d=c.next())d=d.value,b.objectStoreNames.contains(d)||b.createObjectStore(d,{autoIncrement:!0})};d.onerror=function(b){c.reject(new B(2,9,9001,d.error));b.preventDefault()};return c};
n.destroy=function(){var b=this;return r(function d(){return v(d,function(d){switch(d.m){case 1:if(!b.a){d.D(2);break}return u(d,b.a.destroy(),2);case 2:if(!b.b){d.D(4);break}return u(d,b.b.destroy(),4);case 4:if(!b.c){d.D(6);break}return u(d,b.c.destroy(),6);case 6:if(!b.g){d.D(8);break}return u(d,b.g.destroy(),8);case 8:b.f&&b.f.close(),d.m=0}})})};n.getCells=function(){var b=new Map;this.a&&b.set("v1",this.a);this.b&&b.set("v2",this.b);this.c&&b.set("v3",this.c);return b};n.getEmeSessionCell=function(){return this.g};
n.erase=function(){var b=this;return r(function d(){return v(d,function(d){switch(d.m){case 1:if(!b.a){d.D(2);break}return u(d,b.a.destroy(),2);case 2:if(!b.b){d.D(4);break}return u(d,b.b.destroy(),4);case 4:if(!b.c){d.D(6);break}return u(d,b.c.destroy(),6);case 6:return b.f&&b.f.close(),u(d,Yi(),8);case 8:return b.f=null,b.a=null,b.b=null,b.c=null,u(d,b.init(),0)}})})};
function Yi(){var b=new z,c=window.indexedDB.deleteDatabase("shaka_offline_db");c.onblocked=function(){};c.onsuccess=function(){b.resolve()};c.onerror=function(d){b.reject(new B(2,9,9001,c.error));d.preventDefault()};return b}Gi("idb",function(){return window.indexedDB?new Xi:null});function Zi(b,c,d,e){this.a=b;this.g=c;this.f=d;this.c=e;this.b=["offline:",b,"/",c,"/",d,"/",e].join("")}Zi.prototype.ka=function(){return this.g};Zi.prototype.U=function(){return this.f};Zi.prototype.key=function(){return this.c};Zi.prototype.toString=function(){return this.b};
function $i(b){b=/^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(b);if(null==b)return null;var c=b[1];if("manifest"!=c&&"segment"!=c)return null;var d=b[2];if(!d)return null;var e=b[3];return e&&null!=c?new Zi(c,d,e,Number(b[4])):null};function aj(b,c){this.b=b;this.a=c}function bj(b,c){var d=new U(null,0);d.ma(c.duration);var e=c.periods.map(function(c){return cj(b,c,d)}),f=c.drmInfo?[c.drmInfo]:[];c.drmInfo&&e.forEach(function(b){b.variants.forEach(function(b){b.drmInfos=f})});return{presentationTimeline:d,minBufferTime:2,offlineSessionIds:c.sessionIds,periods:e}}
function cj(b,c,d){var e=c.streams.filter(function(b){return"audio"==b.contentType}),f=c.streams.filter(function(b){return"video"==b.contentType});e=dj(b,e,f);f=c.streams.filter(function(b){return"text"==b.contentType}).map(function(c){return ej(b,c)});c.streams.forEach(function(e){e=e.segments.map(function(c,d){return fj(b,d,c)});d.Ta(e,c.startTime)});return{startTime:c.startTime,variants:Array.from(e.values()),textStreams:f}}
function dj(b,c,d){for(var e=new Set,f=q(c),g=f.next();!g.done;g=f.next()){var h=q(g.value.variantIds);for(g=h.next();!g.done;g=h.next())e.add(g.value)}f=q(d);for(g=f.next();!g.done;g=f.next())for(h=q(g.value.variantIds),g=h.next();!g.done;g=h.next())e.add(g.value);f=new Map;e=q(e);for(g=e.next();!g.done;g=e.next())g=g.value,f.set(g,{id:g,language:"",primary:!1,audio:null,video:null,bandwidth:0,drmInfos:[],allowedByApplication:!0,allowedByKeySystem:!0});c=q(c);for(e=c.next();!e.done;e=c.next())for(e=
e.value,g=ej(b,e),h=q(e.variantIds),e=h.next();!e.done;e=h.next())e=f.get(e.value),e.language=g.language,e.primary=e.primary||g.primary,e.audio=g;d=q(d);for(c=d.next();!c.done;c=d.next())for(e=c.value,c=ej(b,e),g=q(e.variantIds),e=g.next();!e.done;e=g.next())e=f.get(e.value),e.primary=e.primary||c.primary,e.video=c;return f}
function ej(b,c){var d=c.segments.map(function(c,d){return fj(b,d,c)}),e=new S(d);d={id:c.id,originalId:c.originalId,createSegmentIndex:function(){return Promise.resolve()},findSegmentPosition:function(b){return e.find(b)},getSegmentReference:function(b){return e.get(b)},initSegmentReference:null,presentationTimeOffset:c.presentationTimeOffset,mimeType:c.mimeType,codecs:c.codecs,width:c.width||void 0,height:c.height||void 0,frameRate:c.frameRate||void 0,kind:c.kind,encrypted:c.encrypted,keyId:c.keyId,
language:c.language,label:c.label||null,type:c.contentType,primary:c.primary,trickModeVideo:null,emsgSchemeIdUris:null,roles:[],channelsCount:null,closedCaptions:{}};null!=c.initSegmentKey&&(d.initSegmentReference=gj(b,c.initSegmentKey));return d}function fj(b,c,d){var e=new Zi("segment",b.b,b.a,d.dataKey);return new N(c,d.startTime,d.endTime,function(){return[e.toString()]},0,null)}function gj(b,c){var d=new Zi("segment",b.b,b.a,c);return new Ue(function(){return[d.toString()]},0,null)};function hj(){this.a=null}n=hj.prototype;n.configure=function(){};n.start=function(b){var c=$i(b);this.a=c;if(null==c||"manifest"!=c.a)return Promise.reject(new B(2,1,9004,c));var d=new zi;return vh([d],function(){return r(function f(){var b,h,k,m;return v(f,function(f){switch(f.m){case 1:return u(f,d.init(),2);case 2:return u(f,Di(d,c.ka(),c.U()),3);case 3:return b=f.w,u(f,b.getManifests([c.key()]),4);case 4:return h=f.w,k=h[0],m=new aj(c.ka(),c.U()),f["return"](bj(m,k))}})})})};n.stop=function(){return Promise.resolve()};
n.update=function(){};n.onExpirationUpdated=function(b,c){var d=this.a,e=new zi;return vh([e],function(){return r(function g(){var h,k,m,l,p;return v(g,function(g){switch(g.m){case 1:return u(g,e.init(),2);case 2:return u(g,Di(e,d.ka(),d.U()),3);case 3:return h=g.w,u(g,h.getManifests([d.key()]),4);case 4:k=g.w;m=k[0];l=m.sessionIds.includes(b);p=void 0==m.expiration||m.expiration>c;if(l&&p)return u(g,h.updateManifestExpiration(d.key(),c),0);g.D(0)}})})})["catch"](function(){})};
Af["application/x-offline-manifest"]=hj;function ij(b){var c=$i(b);return c&&"manifest"==c.a?ij.a(b):c&&"segment"==c.a?ij.b(c.key(),c):fb(new B(2,1,9004,b))}y("shaka.offline.OfflineScheme",ij);ij.a=function(b){b={uri:b,data:new ArrayBuffer(0),headers:{"content-type":"application/x-offline-manifest"}};return hb(b)};
ij.b=function(b,c){var d=new zi,e=vh([d],function(){return r(function g(){var b,e,m;return v(g,function(g){switch(g.m){case 1:return u(g,d.init(),2);case 2:return u(g,Di(d,c.ka(),c.U()),3);case 3:return b=g.w,u(g,b.getSegments([c.key()]),4);case 4:return e=g.w,m=e[0],g["return"]({uri:c,data:m.data,headers:{}})}})})});return ib(e)};wb("offline",ij);function jj(){}
function kj(b,c,d){return r(function f(){var g,h,k,m,l,p,t;return v(f,function(f){switch(f.m){case 1:g=jj;h=[];for(var x=[],w=q(d),F=w.next();!F.done;F=w.next()){F=F.value;for(var P=!1,W=q(x),T=W.next();!T.done;T=W.next())if(T=T.value,lj(T.info,F)){T.sessionIds.push(F.sessionId);P=!0;break}P||x.push({info:F,sessionIds:[F.sessionId]})}k=q(x);m=k.next();case 2:if(m.done){f.D(4);break}l=m.value;p=g.a(b,c,l);return u(f,p,5);case 5:t=f.w;h=h.concat(t);m=k.next();f.D(2);break;case 4:return f["return"](h)}})})}
function lj(b,c){function d(b,c){return b.robustness==c.robustness&&b.contentType==c.contentType}return b.keySystem==c.keySystem&&b.licenseUri==c.licenseUri&&qb(b.audioCapabilities,c.audioCapabilities,d)&&qb(b.videoCapabilities,c.videoCapabilities,d)};function mj(b){this.a=null;for(var c=0;c<b.textTracks.length;++c){var d=b.textTracks[c];d.mode="disabled";"Shaka Player TextTrack"==d.label&&(this.a=d)}this.a||(this.a=b.addTextTrack("subtitles","Shaka Player TextTrack"));this.a.mode="hidden"}y("shaka.text.SimpleTextDisplayer",mj);mj.prototype.remove=function(b,c){if(!this.a)return!1;nj(this.a,function(d){return d.startTime<c&&d.endTime>b});return!0};mj.prototype.remove=mj.prototype.remove;
mj.prototype.append=function(b){for(var c=oj,d=[],e=0;e<b.length;e++){var f=c(b[e]);f&&d.push(f)}d.slice().sort(function(b,c){return b.startTime!=c.startTime?b.startTime-c.startTime:b.endTime!=c.endTime?b.endTime-c.startTime:d.indexOf(c)-d.indexOf(b)}).forEach(function(b){this.a.addCue(b)}.bind(this))};mj.prototype.append=mj.prototype.append;mj.prototype.destroy=function(){this.a&&nj(this.a,function(){return!0});this.a=null;return Promise.resolve()};mj.prototype.destroy=mj.prototype.destroy;
mj.prototype.isTextVisible=function(){return"showing"==this.a.mode};mj.prototype.isTextVisible=mj.prototype.isTextVisible;mj.prototype.setTextVisibility=function(b){this.a.mode=b?"showing":"hidden"};mj.prototype.setTextVisibility=mj.prototype.setTextVisibility;
function oj(b){if(b.startTime>=b.endTime)return null;var c=new VTTCue(b.startTime,b.endTime,b.payload);c.lineAlign=b.lineAlign;c.positionAlign=b.positionAlign;c.size=b.size;try{c.align=b.textAlign}catch(d){}"center"==b.textAlign&&"center"!=c.align&&(c.align="middle");2==b.writingDirection?c.vertical="lr":3==b.writingDirection&&(c.vertical="rl");1==b.lineInterpretation&&(c.snapToLines=!1);null!=b.line&&(c.line=b.line);null!=b.position&&(c.position=b.position);return c}
function nj(b,c){var d=b.mode;b.mode="showing"==d?"showing":"hidden";for(var e=b.cues,f=e.length-1;0<=f;f--){var g=e[f];g&&c(g)&&b.removeCue(g)}b.mode=d};function pj(b,c,d,e,f){var g=f in e,h=!0,k;for(k in c){var m=f+"."+k,l=g?e[f]:d[k];g||k in d?void 0===c[k]?void 0===l||g?delete b[k]:b[k]=mb(l):l.constructor==Object&&c[k]&&c[k].constructor==Object?(b[k]||(b[k]=mb(l)),m=pj(b[k],c[k],l,e,m),h=h&&m):typeof c[k]!=typeof l||null==c[k]||c[k].constructor!=l.constructor?h=!1:b[k]=c[k]:h=!1}return h};function qj(){var b=5E5,c=Infinity;navigator.connection&&navigator.connection.type&&(b=1E6*navigator.connection.downlink,navigator.connection.saveData&&(c=360));var d={trackSelectionCallback:function(b){return b},progressCallback:function(){},usePersistentLicense:!0},e={drm:{retryParameters:db(),servers:{},clearKeys:{},advanced:{},delayLicenseRequestUntilPlayed:!1},manifest:{retryParameters:db(),availabilityWindowOverride:NaN,dash:{customScheme:function(b){if(b)return null},clockSyncUri:"",ignoreDrmInfo:!1,
xlinkFailGracefully:!1,defaultPresentationDelay:10,ignoreMinBufferTime:!1}},streaming:{retryParameters:db(),failureCallback:function(){},rebufferingGoal:2,bufferingGoal:10,bufferBehind:30,ignoreTextStreamFailures:!1,alwaysStreamText:!1,startAtSegmentBoundary:!1,smallGapLimit:.5,jumpLargeGaps:!1,durationBackoff:1,forceTransmuxTS:!1},offline:d,abrFactory:K,abr:{enabled:!0,defaultBandwidthEstimate:b,switchInterval:8,bandwidthUpgradeTarget:.85,bandwidthDowngradeTarget:.95,restrictions:{minWidth:0,maxWidth:Infinity,
minHeight:0,maxHeight:c,minPixels:0,maxPixels:Infinity,minBandwidth:0,maxBandwidth:Infinity}},preferredAudioLanguage:"",preferredTextLanguage:"",preferredVariantRole:"",preferredTextRole:"",preferredAudioChannelCount:2,restrictions:{minWidth:0,maxWidth:Infinity,minHeight:0,maxHeight:Infinity,minPixels:0,maxPixels:Infinity,minBandwidth:0,maxBandwidth:Infinity},playRangeStart:0,playRangeEnd:Infinity,textDisplayFactory:function(){return null}};d.trackSelectionCallback=function(b){return rj(b,e.preferredAudioLanguage)};
return e}function sj(b,c,d){return pj(b,c,d||qj(),{".drm.servers":"",".drm.clearKeys":"",".drm.advanced":{distinctiveIdentifierRequired:!1,persistentStateRequired:!1,videoRobustness:"",audioRobustness:"",serverCertificate:new Uint8Array(0),individualizationServer:""}},"")}
function rj(b,c){var d=[],e=Hd(c),f=[0,Fd,Gd],g=b.filter(function(b){return"variant"==b.type});f=f.map(function(b){return g.filter(function(c){c=Hd(c.language);return Ed(b,e,c)})});for(var h,k=0;k<f.length;k++)if(f[k].length){h=f[k];break}h||(f=g.filter(function(b){return b.primary}),f.length&&(h=f));h||(h=g,g.map(function(b){return b.language}));var m=h.filter(function(b){return b.height&&480>=b.height});m.length&&(m.sort(function(b,c){return c.height-b.height}),h=m.filter(function(b){return b.height==
m[0].height}));h.sort(function(b,c){return b.bandwidth-c.bandwidth});h.length&&d.push(h[Math.floor(h.length/2)]);d.push.apply(d,b.filter(function(b){return"text"==b.type}));return d};function Y(b,c){var d=this;E.call(this);this.f=null;this.ub=!1;this.A=null;this.s=new Cb;this.Mb=this.h=this.Za=this.b=this.o=this.a=this.J=this.g=this.j=this.i=this.M=null;this.yd=1E9;this.Ob=[];this.tb=!1;this.ia=!0;this.P=this.vb=this.La=null;this.Bc=!1;this.Ac=0;this.B=null;this.sb=[];this.u=new Zg;this.c=tj(this);this.rb={width:Infinity,height:Infinity};this.l=uj();this.qb=0;this.ob=new gh(this.c.preferredAudioLanguage,this.c.preferredVariantRole,this.c.preferredAudioChannelCount);this.Z=this.c.preferredTextLanguage;
this.$a=this.c.preferredTextRole;c&&c(this);this.M=vj(this);b&&this.wb(b,!0);this.$=new uh(function(){return r(function f(){var b;return v(f,function(c){switch(c.m){case 1:return b=Promise.all([d.s?d.s.destroy():null,d.M?d.M.destroy():null]),d.ub=!1,d.s=null,d.h=null,d.Mb=null,d.M=null,d.c=null,u(c,b,0)}})})});H(this.s,window,"online",function(){d.rc()})}Ea(Y,E);y("shaka.Player",Y);
function wj(b){if(!b.La)return Promise.resolve();var c=Promise.resolve();b.o&&(c=b.o.stop(),b.o=null);return Promise.all([c,b.La()])}Y.prototype.destroy=function(){var b=this;return r(function d(){return v(d,function(d){switch(d.m){case 1:return u(d,b.detach(),2);case 2:return u(d,b.$.destroy(),0)}})})};Y.prototype.destroy=Y.prototype.destroy;Y.version="v2.5.0-beta-109-g74b97ed4-dirty";var xj=["output-restricted","internal-error"],yj={};Y.registerSupportPlugin=function(b,c){yj[b]=c};
Y.isBrowserSupported=function(){return!!window.Promise&&!!window.Uint8Array&&!!Array.prototype.forEach&&!!window.MediaSource&&!!MediaSource.isTypeSupported&&!!window.MediaKeys&&!!window.navigator&&!!window.navigator.requestMediaKeySystemAccess&&!!window.MediaKeySystemAccess&&!!window.MediaKeySystemAccess.prototype.getConfiguration};Y.probeSupport=function(){return Ec().then(function(b){var c=Cf(),d=sd();b={manifest:c,media:d,drm:b};for(var e in yj)b[e]=yj[e]();return b})};
Y.prototype.wb=function(b,c){var d=this;return r(function f(){return v(f,function(f){switch(f.m){case 1:void 0===c&&(c=!0);if(!d.f){f.D(2);break}return u(f,d.detach(),2);case 2:d.f=b;H(d.s,d.f,"error",d.ve.bind(d));if(c)return d.j=new qd(d.f),u(f,d.j.j,0);f.D(0)}})})};Y.prototype.attach=Y.prototype.wb;Y.prototype.detach=function(){var b=this;return r(function d(){return v(d,function(d){switch(d.m){case 1:return b.f?u(d,b.nb(!1),2):d["return"]();case 2:b.s.sa(b.f,"error"),b.f=null,d.m=0}})})};
Y.prototype.detach=Y.prototype.detach;function zj(b,c,d){return r(function f(){var g;return v(f,function(f){switch(f.m){case 1:return u(f,Df(c,b.M,b.c.manifest.retryParameters,d),2);case 2:return g=f.w,f["return"](new g)}})})}function Aj(b){return b.o.start(b.Za,{networkingEngine:b.M,filterNewPeriod:b.Sb.bind(b),filterAllPeriods:b.Ic.bind(b),onTimelineRegionAdded:function(c){b.J?zh(b.J,c):b.sb.push(c)},onEvent:b.mb.bind(b),onError:b.Ia.bind(b)})}
function Bj(b){function c(b){return b.video&&b.audio||b.video&&b.video.codecs.includes(",")}b.b.periods.some(function(b){return b.variants.some(c)})&&b.b.periods.forEach(function(b){b.variants=b.variants.filter(c)});if(0==b.b.periods.length)throw new B(2,4,4014);}
Y.prototype.load=function(b,c,d){c=void 0===c?null:c;var e=this;return r(function g(){var h,k,m,l,p,t,w,x,A,F,P,W,T,na,va,X,Vb,Wb;return v(g,function(g){switch(g.m){case 1:if(!e.f)throw new B(2,7,7002);k=new z;m=function(){h=new B(2,7,7E3);return k};e.dispatchEvent(new D("loading"));l=Date.now();oa(g,2);p=e.f;t=e.nb();e.La=m;return u(g,t,4);case 4:e.l=uj();H(e.s,p,"playing",function(){return Cj(e)});H(e.s,p,"pause",function(){return Cj(e)});H(e.s,p,"ended",function(){return Cj(e)});w=e.c.abrFactory;
e.h&&e.Mb==w||(e.Mb=w,e.h=new w,e.h.configure(e.c.abr));x=e.c.textDisplayFactory;e.A=new x;e.A.setTextVisibility(e.ub);if(h)throw h;F=A=null;d&&("string"==typeof d?F=d:(Ka("Loading with a manifest parser factory is deprecated. Instead please register a manifest parser and pass in the mime type."),A=d));P=e;if(A){W=new A;g.D(5);break}return u(g,zj(e,b,F),6);case 6:W=g.w;case 5:return P.o=W,e.o.configure(e.c.manifest),e.Za=b,u(g,Aj(e),7);case 7:T=g.w;e.b=T;if(h)throw h;Bj(e);na=e;return u(g,Dj(e,T),
8);case 8:na.i=g.w;if(h)throw h;e.Ic(e.b.periods);e.qb=Date.now()/1E3;e.ob=new gh(e.c.preferredAudioLanguage,e.c.preferredVariantRole,e.c.preferredAudioChannelCount);e.Z=e.c.preferredTextLanguage;Ej(e.b.presentationTimeline,e.c.playRangeStart,e.c.playRangeEnd,e.W());return u(g,e.i.wb(p),9);case 9:if(h)throw h;e.h.init(function(b,c,d){c=void 0===c?!1:c;d=void 0===d?0:d;Fj(e,b,!0);e.a&&(Rh(e.a,b,c,d),Gj(e))});e.j||(e.j=new qd(e.f));e.j.s=e.A;e.g=new ph(e.f,e.b.presentationTimeline,e.b.minBufferTime||
0,e.c.streaming,c,e.bf.bind(e),e.mb.bind(e));e.J=new wh(e.f,e.b.minBufferTime,e.c.streaming,e.md.bind(e),e.mb.bind(e),e.af.bind(e),new Bh(e.f,e.j,e.b));e.a=new Ch(e.b,{Ga:e.g,L:e.j,Gb:e.M,Rc:e.ee.bind(e),Qc:e.Cd.bind(e),onError:e.Ia.bind(e),onEvent:e.mb.bind(e),ie:e.je.bind(e),gb:e.se.bind(e)});e.a.configure(e.c.streaming);Hj(e);e.dispatchEvent(new D("streaming"));return u(g,e.a.init(),10);case 10:if(h)throw h;e.c.streaming.startAtSegmentBoundary&&(va=Ij(e,sh(e.g)),mh(e.g.b,va));e.b.periods.forEach(e.Sb.bind(e));
Jj(e);Gj(e);X=Fh(e.a);X.variants.some(function(b){return b.primary});Kj(e,X.variants);for(var Xb=q(e.sb),ub=Xb.next();!ub.done;ub=Xb.next())Vb=ub.value,zh(e.J,Vb);e.sb=[];Fb(e.s,p,"loadeddata",function(){e.l.loadLatency=(Date.now()-l)/1E3});if(h)throw h;e.La=null;qa(g,0);break;case 2:return Wb=ra(g),k.resolve(),e.La==m&&(e.La=null,e.dispatchEvent(new D("unloading"))),h?g["return"](Promise.reject(h)):g["return"](Promise.reject(Wb))}})})};Y.prototype.load=Y.prototype.load;
function Hj(b){function c(b){var c="";b.video&&(c=Nb(b.video.codecs)[0]);var d="";b.audio&&(d=Nb(b.audio.codecs)[0]);return c+"-"+d}var d=b.b.periods.reduce(function(b,c){return b.concat(c.variants)},[]);d=Td(d,b.c.preferredAudioChannelCount);var e=new lb;d.forEach(function(b){var d=c(b);e.push(d,b)});var f=null,g=Infinity;e.forEach(function(b,c){var d=0,e=0;c.forEach(function(b){d+=b.bandwidth||0;++e});var h=d/e;h<g&&(f=b,g=h)});b.b.periods.forEach(function(b){b.variants=b.variants.filter(function(b){return c(b)==
f?!0:!1})})}function Dj(b,c){return r(function e(){var f,g,h;return v(e,function(e){switch(e.m){case 1:return f={Gb:b.M,onError:function(c){b.Ia(c)},Vc:function(c){Lj(b,c)},onExpirationUpdated:function(c,e){if(b.o&&b.o.onExpirationUpdated)b.o.onExpirationUpdated(c,e);b.dispatchEvent(new D("expirationupdated"))},onEvent:function(c){b.mb(c)}},g=new gc(f),g.configure(b.c.drm),h=$d(c),u(e,nc(g,h,c.offlineSessionIds),2);case 2:return e["return"](g)}})})}
function vj(b){return new G(function(c,d){b.h&&b.h.segmentDownloaded(c,d)})}Y.prototype.configure=function(b,c){if(2==arguments.length&&"string"==typeof b){for(var d=b,e={},f=e,g=0,h=0;;){g=d.indexOf(".",g);if(0>g)break;if(0==g||"\\"!=d[g-1])h=d.substring(h,g).replace(/\\\./g,"."),f[h]={},f=f[h],h=g+1;g+=1}f[d.substring(h).replace(/\\\./g,".")]=c;b=e}d=sj(this.c,b,tj(this));Mj(this);return d};Y.prototype.configure=Y.prototype.configure;
function Mj(b){b.o&&b.o.configure(b.c.manifest);b.i&&b.i.configure(b.c.drm);if(b.a){b.a.configure(b.c.streaming);try{b.b.periods.forEach(b.Sb.bind(b))}catch(f){b.Ia(f)}var c=Hh(b.a),d=Jh(b.a),e=Fh(b.a);c=Wd(c,d,e.variants);b.h&&c&&c.allowedByApplication&&c.allowedByKeySystem?Kj(b,e.variants):Nj(b,e)}b.h&&(b.h.configure(b.c.abr),b.c.abr.enabled&&!b.ia?b.h.enable():b.h.disable())}Y.prototype.getConfiguration=function(){var b=tj(this);sj(b,this.c,tj(this));return b};Y.prototype.getConfiguration=Y.prototype.getConfiguration;
Y.prototype.Oe=function(){for(var b in this.c)delete this.c[b];sj(this.c,tj(this),tj(this));Mj(this)};Y.prototype.resetConfiguration=Y.prototype.Oe;Y.prototype.Sd=function(){return this.f};Y.prototype.getMediaElement=Y.prototype.Sd;Y.prototype.Oa=function(){return this.M};Y.prototype.getNetworkingEngine=Y.prototype.Oa;Y.prototype.Tb=function(){return this.Za};Y.prototype.getAssetUri=Y.prototype.Tb;
Y.prototype.Rd=function(){Ka('"getManifestUri" is deprecated and will be removed in v2.6. Please use "getAssetUri" instead.');return this.Za};Y.prototype.getManifestUri=Y.prototype.Rd;Y.prototype.W=function(){return this.b?this.b.presentationTimeline.W():!1};Y.prototype.isLive=Y.prototype.W;Y.prototype.Da=function(){return this.b?this.b.presentationTimeline.Da():!1};Y.prototype.isInProgress=Y.prototype.Da;
Y.prototype.be=function(){if(!this.b||!this.b.periods.length)return!1;var b=this.b.periods[0].variants;return b.length?!b[0].video:!1};Y.prototype.isAudioOnly=Y.prototype.be;Y.prototype.Qe=function(){var b=0,c=0;this.b&&(c=this.b.presentationTimeline,b=c.Pa(),c=c.oa());return{start:b,end:c}};Y.prototype.seekRange=Y.prototype.Qe;Y.prototype.keySystem=function(){return this.i?this.i.keySystem():""};Y.prototype.keySystem=Y.prototype.keySystem;Y.prototype.drmInfo=function(){return this.i?this.i.a:null};
Y.prototype.drmInfo=Y.prototype.drmInfo;Y.prototype.Db=function(){return this.i?this.i.Db():Infinity};Y.prototype.getExpiration=Y.prototype.Db;Y.prototype.Oc=function(){return this.tb};Y.prototype.isBuffering=Y.prototype.Oc;
Y.prototype.nb=function(b){var c=this;return r(function e(){return v(e,function(e){switch(e.m){case 1:if(c.$.a)return e["return"]();void 0===b&&(b=!0);c.dispatchEvent(new D("unloading"));return u(e,wj(c),2);case 2:return c.vb||(c.vb=Oj(c).then(function(){c.md(!1);c.vb=null})),u(e,c.vb,3);case 3:if(b)return c.j=new qd(c.f),u(e,c.j.j,0);e.D(0)}})})};Y.prototype.unload=Y.prototype.nb;Y.prototype.ab=function(){return this.g?this.g.ab():0};Y.prototype.getPlaybackRate=Y.prototype.ab;
Y.prototype.lf=function(b){this.g&&oh(this.g.b,b);this.a&&Ph(this.a,1!=b)};Y.prototype.trickPlay=Y.prototype.lf;Y.prototype.Dd=function(){this.g&&oh(this.g.b,1);this.a&&Ph(this.a,!1)};Y.prototype.cancelTrickPlay=Y.prototype.Dd;Y.prototype.Zb=function(){if(!this.b||!this.g)return[];var b=Yd(this.b,sh(this.g));return Pd(this.b.periods[b],this.u.get(b,"audio"),this.u.get(b,"video"))};Y.prototype.getVariantTracks=Y.prototype.Zb;
Y.prototype.Yb=function(){if(!this.b||!this.g)return[];var b=Yd(this.b,sh(this.g));if(!this.u.get(b,"text")){var c=Ud(this.b.periods[b].textStreams,this.Z,this.$a);c.length&&$g(this.u,b,"text",c[0].id)}return Rd(this.b.periods[b],this.u.get(b,"text")).filter(function(b){return!this.Ob.includes(b.id)}.bind(this))};Y.prototype.getTextTracks=Y.prototype.Yb;
Y.prototype.Ue=function(b){if(this.a){var c=Fh(this.a);a:{for(var d=0;d<c.textStreams.length;d++)if(c.textStreams[d].id==b.id){b=c.textStreams[d];break a}b=null}b&&(this.j.l=!1,Pj(this,b,!1),c=b,this.ia?this.B=c:Qh(this.a,c,!0,0),this.Z=b.language)}};Y.prototype.selectTextTrack=Y.prototype.Ue;Y.prototype.Se=function(){this.j.l=!0;Oh(this.a)};Y.prototype.selectEmbeddedTextTrack=Y.prototype.Se;Y.prototype.rf=function(){return this.j?this.j.l:!1};Y.prototype.usingEmbeddedTextTrack=Y.prototype.rf;
Y.prototype.Ve=function(b,c,d){d=void 0===d?0:d;if(this.a){this.c.abr.enabled&&Ka("Changing tracks while abr manager is enabled will likely result in the selected track being overriden. Consider disabling abr before calling selectVariantTrack().");var e=Fh(this.a);a:{for(var f=0;f<e.variants.length;f++)if(e.variants[f].id==b.id){b=e.variants[f];break a}b=null}b&&Sd(b)&&(Fj(this,b,!1),Qj(this,b,c,d),this.ob=new fh(b),Kj(this,e.variants))}};Y.prototype.selectVariantTrack=Y.prototype.Ve;
Y.prototype.Md=function(){return Rj(this.Zb())};Y.prototype.getAudioLanguagesAndRoles=Y.prototype.Md;Y.prototype.Yd=function(){return Rj(this.Yb())};Y.prototype.getTextLanguagesAndRoles=Y.prototype.Yd;Y.prototype.Ld=function(){var b=this.Zb();return Array.from(Sj(b))};Y.prototype.getAudioLanguages=Y.prototype.Ld;Y.prototype.Xd=function(){var b=this.Yb();return Array.from(Sj(b))};Y.prototype.getTextLanguages=Y.prototype.Xd;
Y.prototype.Re=function(b,c){if(this.a){this.ob=new gh(b,c||"",0);var d=Fh(this.a);Nj(this,d)}};Y.prototype.selectAudioLanguage=Y.prototype.Re;Y.prototype.Te=function(b,c){if(this.a){var d=Fh(this.a);this.Z=b;this.$a=c||"";Nj(this,d)}};Y.prototype.selectTextLanguage=Y.prototype.Te;Y.prototype.bc=function(){return this.A?this.A.isTextVisible():this.ub};Y.prototype.isTextTrackVisible=Y.prototype.bc;
Y.prototype.Ze=function(b){this.A&&this.A.setTextVisibility(b);this.ub=b;Tj(this);!this.c.streaming.alwaysStreamText&&this.a&&(b?(b=Fh(this.a),(b=Ud(b.textStreams,this.Z,this.$a)[0])&&Kh(this.a,b)):Oh(this.a))};Y.prototype.setTextTrackVisibility=Y.prototype.Ze;Y.prototype.Ud=function(){return this.b?new Date(1E3*this.b.presentationTimeline.f+1E3*this.f.currentTime):null};Y.prototype.getPlayheadTimeAsDate=Y.prototype.Ud;
Y.prototype.Wd=function(){return this.b?new Date(1E3*this.b.presentationTimeline.f):null};Y.prototype.getPresentationStartTimeAsDate=Y.prototype.Wd;Y.prototype.Ub=function(){return this.j?this.j.Ub():{total:[],audio:[],video:[],text:[]}};Y.prototype.getBufferedInfo=Y.prototype.Ub;
Y.prototype.getStats=function(){Uj(this);Cj(this);var b=null,c=null,d=this.f;d=d&&d.getVideoPlaybackQuality?d.getVideoPlaybackQuality():{};if(this.g&&this.b){var e=Yd(this.b,sh(this.g)),f=this.b.periods[e];null!=this.u.a[e]&&(c=Xd(this.u.get(e,"audio"),this.u.get(e,"video"),f.variants),b=c.video||{})}b||(b={});c||(c={});return{width:b.width||0,height:b.height||0,streamBandwidth:c.bandwidth||0,decodedFrames:Number(d.totalVideoFrames),droppedFrames:Number(d.droppedVideoFrames),estimatedBandwidth:this.h?
this.h.getBandwidthEstimate():NaN,loadLatency:this.l.loadLatency,playTime:this.l.playTime,bufferingTime:this.l.bufferingTime,switchHistory:mb(this.l.switchHistory),stateHistory:mb(this.l.stateHistory)}};Y.prototype.getStats=Y.prototype.getStats;
Y.prototype.addTextTrack=function(b,c,d,e,f,g){if(!this.a)return Promise.reject();var h=Fh(this.a),k=this.b.periods.indexOf(h)+1,m=(k>=this.b.periods.length?this.b.presentationTimeline.S():this.b.periods[k].startTime)-h.startTime;if(Infinity==m)return Promise.reject(new B(1,4,4033));var l={id:this.yd++,originalId:null,createSegmentIndex:Promise.resolve.bind(Promise),findSegmentPosition:function(){return 1},getSegmentReference:function(c){return 1!=c?null:new N(1,0,m,function(){return[b]},0,null)},
initSegmentReference:null,presentationTimeOffset:0,mimeType:e,codecs:f||"",kind:d,encrypted:!1,keyId:null,language:c,label:g||null,type:"text",primary:!1,trickModeVideo:null,emsgSchemeIdUris:null,roles:[],channelsCount:null,closedCaptions:{}};this.Ob.push(l.id);h.textStreams.push(l);return Kh(this.a,l).then(function(){if(!this.$.a){var b=this.b.periods.indexOf(h),e=Ih(this.a,"text");e&&$g(this.u,b,"text",e.id);ob(this.Ob,l.id);Nj(this,h);Jj(this);return{id:l.id,active:!1,type:"text",bandwidth:0,language:c,
label:g||null,kind:d,width:null,height:null}}}.bind(this))};Y.prototype.addTextTrack=Y.prototype.addTextTrack;Y.prototype.tc=function(b,c){this.rb.width=b;this.rb.height=c};Y.prototype.setMaxHardwareResolution=Y.prototype.tc;Y.prototype.rc=function(){if(this.a){var b=this.a;if(b.f)b=!1;else if(b.l)b=!1;else{for(var c=q(b.c.values()),d=c.next();!d.done;d=c.next())d=d.value,d.eb&&(d.eb=!1,Nh(b,d,.1));b=!0}}else b=!1;return b};Y.prototype.retryStreaming=Y.prototype.rc;Y.prototype.Qd=function(){return this.b};
Y.prototype.getManifest=Y.prototype.Qd;function Fj(b,c,d){c.video&&Vj(b,c.video);c.audio&&Vj(b,c.audio);var e=Gh(b.a);e=Wd(Hh(b.a),Jh(b.a),e?e.variants:[]);c!=e&&b.l.switchHistory.push({timestamp:Date.now()/1E3,id:c.id,type:"variant",fromAdaptation:d,bandwidth:c.bandwidth})}function Pj(b,c,d){Vj(b,c);b.l.switchHistory.push({timestamp:Date.now()/1E3,id:c.id,type:"text",fromAdaptation:d,bandwidth:null})}function Vj(b,c){$g(b.u,Zd(b.b,c),c.type,c.id)}
function Oj(b){b.s&&(b.s.sa(b.f,"loadeddata"),b.s.sa(b.f,"playing"),b.s.sa(b.f,"pause"),b.s.sa(b.f,"ended"));var c=b.i,d=Promise.all([b.h?b.h.stop():null,b.j?b.j.destroy():null,b.g?b.g.destroy():null,b.J?b.J.destroy():null,b.a?b.a.destroy():null,b.o?b.o.stop():null,b.A?b.A.destroy():null]).then(function(){return c?c.destroy():null});b.ia=!0;b.i=null;b.j=null;b.g=null;b.J=null;b.a=null;b.o=null;b.A=null;b.b=null;b.Za=null;b.sb=[];b.u=new Zg;b.l=uj();return d}
function tj(b){var c=qj();c.streaming.failureCallback=function(c){var d=[1001,1002,1003];b.W()&&d.includes(c.code)&&(c.severity=1,b.rc())};c.textDisplayFactory=function(){return new mj(b.f)};return c}function uj(){return{width:NaN,height:NaN,streamBandwidth:NaN,decodedFrames:NaN,droppedFrames:NaN,estimatedBandwidth:NaN,loadLatency:NaN,playTime:0,bufferingTime:0,switchHistory:[],stateHistory:[]}}n=Y.prototype;
n.Ic=function(b){var c=this.a?Hh(this.a):null,d=this.a?Jh(this.a):null;b.forEach(Ld.bind(null,this.i,c,d));c=pb(b,function(b){return b.variants.some(Sd)});if(0==c)throw new B(2,4,4032);if(c<b.length)throw new B(2,4,4011);b.forEach(function(b){Kd(b.variants,this.c.restrictions,this.rb)&&this.a&&Fh(this.a)==b&&Jj(this);Xj(this,b.variants)}.bind(this))};
n.Sb=function(b){var c=this.a?Hh(this.a):null,d=this.a?Jh(this.a):null;Ld(this.i,c,d,b);c=b.variants;if(!c.some(Sd))throw new B(2,4,4011);Xj(this,b.variants);Kd(c,this.c.restrictions,this.rb)&&this.a&&Fh(this.a)==b&&Jj(this);if(b=this.i?this.i.a:null)for(c=q(c),d=c.next();!d.done;d=c.next()){d=q(d.value.drmInfos);for(var e=d.next();!e.done;e=d.next())if(e=e.value,e.keySystem==b.keySystem){e=q(e.initData||[]);for(var f=e.next();!f.done;f=e.next())f=f.value,wc(this.i,f.initDataType,f.initData)}}};
function Qj(b,c,d,e){d=void 0===d?!1:d;e=void 0===e?0:e;b.ia?(b.P=c,b.Bc=d,b.Ac=e):Rh(b.a,c,d,e)}function Uj(b){if(b.b){var c=Date.now()/1E3;b.tb?b.l.bufferingTime+=c-b.qb:b.l.playTime+=c-b.qb;b.qb=c}}function Ij(b,c){function d(b,c){if(!b)return null;var d=b.findSegmentPosition(c-g.startTime);return null==d?null:(d=b.getSegmentReference(d))?d.startTime+g.startTime:null}var e=Hh(b.a),f=Jh(b.a),g=Fh(b.a);e=d(e,c);f=d(f,c);return null!=f&&null!=e?Math.max(f,e):null!=f?f:null!=e?e:c}
n.md=function(b){Uj(this);this.tb=b;Cj(this);if(this.g){var c=this.g.b;b!=c.g&&(c.g=b,oh(c,c.f))}this.dispatchEvent(new D("buffering",{buffering:b}))};n.af=function(){Jj(this)};function Cj(b){if(!b.$.a){var c=b.tb?"buffering":b.f.ended?"ended":b.f.paused?"paused":"playing";var d=Date.now()/1E3;if(b.l.stateHistory.length){var e=b.l.stateHistory[b.l.stateHistory.length-1];e.duration=d-e.timestamp;if(c==e.state)return}b.l.stateHistory.push({timestamp:d,state:c,duration:0})}}
n.bf=function(){if(this.J){var b=this.J;b.f.forEach(b.o.bind(b,!0))}this.a&&Uh(this.a)};function Kj(b,c){try{Xj(b,c)}catch(e){return b.Ia(e),null}var d=c.filter(function(b){return Sd(b)});d=b.ob.create(d);b.h.setVariants(Array.from(d.values()));return b.h.chooseVariant()}function Nj(b,c){var d=Kj(b,c.variants);d&&(Fj(b,d,!0),Qj(b,d,!0));(d=Ud(c.textStreams,b.Z,b.$a)[0]||null)&&(b.c.streaming.alwaysStreamText||b.bc())&&(Pj(b,d,!0),b.ia?b.B=d:Qh(b.a,d,!0,0));Gj(b)}
n.ee=function(b){try{var c=this.b;this.ia=!0;this.h.disable();var d=Kj(this,b.variants),e=Ud(b.textStreams,this.Z,this.$a)[0]||null;if(this.P){a:{for(var f=0;f<c.periods.length;++f)for(var g=c.periods[f],h=0;h<g.variants.length;++h)if(g.variants[h]==this.P){var k=f;break a}k=-1}c.periods[k]==b&&(d=this.P);this.P=null}this.B&&(c.periods[Zd(c,this.B)]==b&&(e=this.B),this.B=null);d&&Fj(this,d,!0);e&&Pj(this,e,!0);var m=!Gh(this.a),l=d?d.audio:null;m&&l&&e&&Yj(this,l,e)&&(this.A.setTextVisibility(!0),
Tj(this));return this.c.streaming.alwaysStreamText||this.bc()?{variant:d,text:e}:{variant:d,text:null}}catch(p){return this.Ia(p),{variant:null,text:null}}};function Yj(b,c,d){var e=Hd(b.c.preferredTextLanguage);b=Hd(c.language);var f=Hd(d.language);return[Gd,Fd,0].some(function(b){return Ed(b,e,f)})&&f!=b}n.Cd=function(){this.ia=!1;this.c.abr.enabled&&this.h.enable();this.P&&(Rh(this.a,this.P,this.Bc,this.Ac),this.P=null);this.B&&(Qh(this.a,this.B,!0,0),this.B=null)};
n.je=function(){this.o&&this.o.update&&this.o.update()};n.se=function(){this.g&&this.g.gb()};function Gj(b){r(function d(){var e;return v(d,function(d){switch(d.m){case 1:return u(d,Promise.resolve(),2);case 2:if(b.$.a)return d["return"]();e=new D("adaptation");b.dispatchEvent(e);d.m=0}})})}function Jj(b){r(function d(){var e;return v(d,function(d){switch(d.m){case 1:return u(d,Promise.resolve(),2);case 2:if(b.$.a)return d["return"]();e=new D("trackschanged");b.dispatchEvent(e);d.m=0}})})}
function Tj(b){b.dispatchEvent(new D("texttrackvisibility"))}n.Ia=function(b){if(!this.$.a){var c=new D("error",{detail:b});this.dispatchEvent(c);c.defaultPrevented&&(b.handled=!0)}};n.mb=function(b){this.dispatchEvent(b)};n.ve=function(){if(this.f.error){var b=this.f.error.code;if(1!=b){var c=this.f.error.msExtendedCode;c&&(0>c&&(c+=Math.pow(2,32)),c=c.toString(16));this.Ia(new B(2,3,3016,b,c,this.f.error.message))}}};
function Lj(b,c){var d=Fh(b.a),e=!1,f=Object.keys(c),g=1==f.length&&"00"==f[0];f.length&&d.variants.forEach(function(b){ae(b).forEach(function(d){var f=b.allowedByKeySystem;d.keyId&&(d=c[g?"00":d.keyId],b.allowedByKeySystem=!!d&&!xj.includes(d));f!=b.allowedByKeySystem&&(e=!0)})});f=Hh(b.a);var h=Jh(b.a);(f=Wd(f,h,d.variants))&&!f.allowedByKeySystem&&Nj(b,d);e&&(Jj(b),Kj(b,d.variants))}function Ej(b,c,d,e){0<c&&(e||b.ld(c));d<b.S()&&(e||b.ma(d))}
function Xj(b,c){var d=b.i?Jb(b.i.Z):{},e=Object.keys(d);e=e.length&&"00"==e[0];for(var f=!1,g=!1,h=[],k=[],m=q(c),l=m.next();!l.done;l=m.next()){l=l.value;var p=[];l.audio&&p.push(l.audio);l.video&&p.push(l.video);p=q(p);for(var t=p.next();!t.done;t=p.next())if(t=t.value,t.keyId){var w=d[e?"00":t.keyId];w?xj.includes(w)&&(k.includes(w)||k.push(w)):h.includes(t.keyId)||h.push(t.keyId)}l.allowedByApplication?l.allowedByKeySystem&&(f=!0):g=!0}if(!f)throw new B(2,4,4012,{hasAppRestrictions:g,missingKeys:h,
restrictedKeyStatuses:k});}function Rj(b){var c=new Map;b=q(b);for(var d=b.next();!d.done;d=b.next()){var e=d.value;d=Hd(e.language);var f=c.get(d)||new Set;e=q(e.roles);for(var g=e.next();!g.done;g=e.next())f.add(g.value);c.set(d,f)}c.forEach(function(b){0==b.size&&b.add("")});var h=[];c.forEach(function(b,c){for(var d=q(b),e=d.next();!e.done;e=d.next())h.push({language:c,role:e.value})});return h}
function Sj(b){var c=new Set;b=q(b);for(var d=b.next();!d.done;d=b.next())d=Hd(d.value.language),c.add(d);return c};function Zj(b,c,d){var e=void 0==c.expiration?Infinity:c.expiration,f=c.presentationTimeline.S();c=ak(c.periods[0]);return{offlineUri:null,originalManifestUri:b,duration:f,size:0,expiration:e,tracks:c,appMetadata:d}}function bk(b,c){var d=cj(new aj(b.ka(),b.U()),c.periods[0],new U(null,0)),e=c.appMetadata||{};d=ak(d);return{offlineUri:b.toString(),originalManifestUri:c.originalManifestUri,duration:c.duration,size:c.size,expiration:c.expiration,tracks:d,appMetadata:e}}
function ak(b){var c=[],d=Qd(b.variants);d=q(d);for(var e=d.next();!e.done;e=d.next())c.push(Nd(e.value));b=q(b.textStreams);for(d=b.next();!d.done;d=b.next())c.push(Od(d.value));return c};function ck(){this.a={}}function dk(b,c,d){d=d.endTime-d.startTime;return ek(b,c)*d}function ek(b,c){var d=b.a[c];null==d&&(d=0);return d};function fk(b,c){for(var d={width:Infinity,height:Infinity},e=q(b.periods),f=e.next();!f.done;f=e.next())f=f.value,f.variants=f.variants.filter(function(b){return Jd(b,c,d)})}function gk(b){b=q(b.periods);for(var c=b.next();!c.done;c=b.next())c=c.value,c.variants=c.variants.filter(function(b){var c=!0;b.audio&&(c=c&&rd(b.audio));b.video&&(c=c&&rd(b.video));return c})}
function hk(b,c){for(var d=q(b.periods),e=d.next();!e.done;e=d.next())e=e.value,e.variants=e.variants.filter(function(b){return Fc(c,b)})}function ik(b){var c=new jk;b.periods.forEach(function(b,d){var e=kk(b.variants);if(0==d){e=q(e.a);for(var f=e.next();!f.done;f=e.next())c.add(f.value)}else lk(c,e)});b=q(b.periods);for(var d=b.next();!d.done;d=b.next())d=d.value,d.variants=d.variants.filter(function(b){return mk(c,new nk(b))})}
function ok(b,c){var d=new jk;b.periods.forEach(function(b,f){0<f&&(b.variants=b.variants.filter(function(b){return mk(d,new nk(b))}));c(b);d=kk(b.variants)})}function nk(b){var c=b.audio;b=b.video;this.b=c?c.mimeType:null;this.a=c?c.codecs.split(".")[0]:null;this.f=b?b.mimeType:null;this.c=b?b.codecs.split(".")[0]:null}function jk(){this.a=[]}jk.prototype.add=function(b){mk(this,b)||this.a.push(b)};function lk(b,c){b.a=b.a.filter(function(b){return mk(c,b)})}
function mk(b,c){return b.a.some(function(b){return c.b==b.b&&c.a==b.a&&c.f==b.f&&c.c==b.c})}function kk(b){var c=new jk;b=q(b);for(var d=b.next();!d.done;d=b.next())c.add(new nk(d.value));return c};function Z(b){var c=this;if(b&&b.constructor!=Y)throw new B(2,9,9008);this.b=this.a=null;b?(this.a=b.c,this.b=b.Oa()):(this.a=qj(),this.b=new G);this.g=!1;this.c=[];this.f=[];var d=!b;this.h=new uh(function(){return r(function f(){var b;return v(f,function(f){switch(f.m){case 1:return b=function(){},u(f,Promise.all(c.f.map(function(c){return c.then(b,b)})),2);case 2:if(!d){f.D(3);break}return u(f,c.b.destroy(),3);case 3:c.a=null,c.b=null,f.m=0}})})})}y("shaka.offline.Storage",Z);
function pk(){return Hi()}Z.support=pk;Z.prototype.destroy=function(){return this.h.destroy()};Z.prototype.destroy=Z.prototype.destroy;
Z.prototype.configure=function(b){var c=!1;null!=b.trackSelectionCallback&&(c=!0,b.offline=b.offline||{},b.offline.trackSelectionCallback=b.trackSelectionCallback);null!=b.progressCallback&&(c=!0,b.offline=b.offline||{},b.offline.progressCallback=b.progressCallback);null!=b.usePersistentLicense&&(c=!0,b.offline=b.offline||{},b.offline.usePersistentLicense=b.usePersistentLicense);c&&Ka("Storage.configure should now be passed a player configuration structure. Using a non-player configuration will be deprecated in v2.6.");
return sj(this.a,b)};Z.prototype.configure=Z.prototype.configure;Z.prototype.Oa=function(){return this.b};Z.prototype.getNetworkingEngine=Z.prototype.Oa;
Z.prototype.store=function(b,c,d){var e=this;return qk(this,rk(this,b,c||{},function(){return r(function g(){var c;return v(g,function(g){switch(g.m){case 1:if(d&&"string"!=typeof d){Ka("Loading with a manifest parser factory is deprecated. Instead please register a manifest parser and pass in the mime type.");c=d;g.D(2);break}return u(g,Df(b,e.b,e.a.manifest.retryParameters,d),3);case 3:c=g.w;case 2:return g["return"](new c)}})})}))};Z.prototype.store=Z.prototype.store;
function rk(b,c,d,e){return r(function g(){var h,k,m,l,p,t,w,x,A,F;return v(g,function(g){switch(g.m){case 1:sk();if(b.g)return g["return"](Promise.reject(new B(2,9,9006)));b.g=!0;return u(g,tk(b,c,e),2);case 2:h=g.w;uk(b);k=!h.presentationTimeline.W()&&!h.presentationTimeline.Da();if(!k)throw new B(2,9,9005,c);m=null;l=new zi;t=p=null;oa(g,3,4);return u(g,vk(b,h,function(b){t=t||b}),6);case 6:m=g.w;uk(b);if(t)throw t;wk(b,h,m);return u(g,l.init(),7);case 7:return uk(b),u(g,Bi(l),8);case 8:return p=
g.w,uk(b),u(g,xk(b,p.U,m,h,c,d),9);case 9:w=g.w;uk(b);if(t)throw t;return u(g,p.U.addManifests([w]),10);case 10:return x=g.w,uk(b),A=new Zi("manifest",p.path.ka,p.path.U,x[0]),g["return"](bk(A,w));case 4:return sa(g),b.g=!1,b.c=[],u(g,l.destroy(),11);case 11:if(!m){g.D(12);break}return u(g,m.destroy(),12);case 12:ta(g,0);break;case 3:F=ra(g);if(!p){g.D(14);break}return u(g,p.U.removeSegments(b.c,function(){}),14);case 14:throw t||F;}})})}
function wk(b,c,d){fk(c,b.a.restrictions);gk(c);hk(c,d);ik(c);ok(c,function(c){var d=[];d=d.concat(Pd(c,null,null));d=d.concat(Rd(c,null));d=b.a.offline.trackSelectionCallback(d);var e=new Set,h=new Set;d=q(d);for(var k=d.next();!k.done;k=d.next())k=k.value,"variant"==k.type&&e.add(k.id),"text"==k.type&&h.add(k.id);c.variants=c.variants.filter(function(b){return e.has(b.id)});c.textStreams=c.textStreams.filter(function(b){return h.has(b.id)})});yk(c)}
function xk(b,c,d,e,f,g){return r(function k(){var m,l,p;return v(k,function(k){switch(k.m){case 1:return m=Zj(f,e,g),l=new mi(function(c,d){m.size=d;b.a.offline.progressCallback(m,c)}),pa(k,2),p=zk(b,l,c,d,e,f,g),u(k,oi(l,b.b),4);case 4:return p.size=m.size,k["return"](p);case 2:return sa(k),u(k,l.destroy(),5);case 5:ta(k,0)}})})}Z.prototype.remove=function(b){return qk(this,Ak(this,b))};Z.prototype.remove=Z.prototype.remove;
function Ak(b,c){sk();var d=$i(c);if(null==d||"manifest"!=d.a)return Promise.reject(new B(2,9,9004,c));var e=new zi;return vh([e],function(){return r(function g(){var c,k,m;return v(g,function(g){switch(g.m){case 1:return u(g,e.init(),2);case 2:return u(g,Di(e,d.ka(),d.U()),3);case 3:return c=g.w,u(g,c.getManifests([d.key()]),4);case 4:return k=g.w,m=k[0],u(g,Promise.all([Bk(b,m,e),Ck(b,c,d,m)]),0)}})})})}
function Dk(b,c){for(var d=[],e=q(b.periods),f=e.next();!f.done;f=e.next()){f=q(f.value.streams);for(var g=f.next();!g.done;g=f.next())g=g.value,c&&"video"==g.contentType?d.push({contentType:Kb(g.mimeType,g.codecs),robustness:b.drmInfo.videoRobustness}):c||"audio"!=g.contentType||d.push({contentType:Kb(g.mimeType,g.codecs),robustness:b.drmInfo.audioRobustness})}return d}function Bk(b,c,d){return r(function f(){return v(f,function(f){switch(f.m){case 1:return u(f,Ek(b.b,b.a.drm,d,c),0)}})})}
function Ck(b,c,d,e){function f(){k+=1;b.a.offline.progressCallback(m,k/h)}var g=Fk(e),h=g.length+1,k=0,m=bk(d,e);return Promise.all([c.removeSegments(g,f),c.removeManifests([d.key()],f)])}Z.prototype.Le=function(){return qk(this,Gk(this))};Z.prototype.removeEmeSessions=Z.prototype.Le;
function Gk(b){sk();var c=b.b,d=b.a.drm,e=new zi;return vh([e],function(){return r(function g(){var b,k,m,l,p,t,w;return v(g,function(g){switch(g.m){case 1:return u(g,e.init(),2);case 2:b=!1,k=[],Ei(e,function(b){return k.push(b)}),m=q(k),l=m.next();case 3:if(l.done){g.D(5);break}p=l.value;return u(g,p.getAll(),6);case 6:return t=g.w,u(g,kj(d,c,t),7);case 7:return w=g.w,u(g,p.remove(w),8);case 8:w.length!=t.length&&(b=!0);l=m.next();g.D(3);break;case 5:return g["return"](!b)}})})})}
Z.prototype.list=function(){return qk(this,Hk())};Z.prototype.list=Z.prototype.list;
function Hk(){function b(b,d){return r(function h(){var e;return v(h,function(f){switch(f.m){case 1:return u(f,d.getAllManifests(),2);case 2:e=f.w,e.forEach(function(d,e){var f=bk(new Zi("manifest",b.ka,b.U,e),d);c.push(f)}),f.m=0}})})}sk();var c=[],d=new zi;return vh([d],function(){return r(function f(){var c;return v(f,function(f){switch(f.m){case 1:return u(f,d.init(),2);case 2:return c=Promise.resolve(),Ci(d,function(d,f){c=c.then(function(){return b(d,f)})}),u(f,c,0)}})})}).then(function(){return c})}
function tk(b,c,d){return r(function f(){var g,h,k,m,l,p,t,w;return v(f,function(f){switch(f.m){case 1:return g=null,h={networkingEngine:b.b,filterAllPeriods:function(){},filterNewPeriod:function(){},onTimelineRegionAdded:function(){},onEvent:function(){},onError:function(b){g=b}},u(f,d(),2);case 2:return k=f.w,k.configure(b.a.manifest),uk(b),pa(f,3),u(f,k.start(c,h),5);case 5:m=f.w;uk(b);l=new Set;for(var x=q(m.periods),F=x.next();!F.done;F=x.next()){p=F.value;F=q(p.variants);for(var P=F.next();!P.done;P=
F.next())t=P.value,t.audio&&l.add(t.audio),t.video&&l.add(t.video);F=q(p.textStreams);for(P=F.next();!P.done;P=F.next())w=P.value,l.add(w)}return u(f,Promise.all(Array.from(l).map(function(b){return b.createSegmentIndex()})),6);case 6:uk(b);if(g)throw g;return f["return"](m);case 3:return sa(f),u(f,k.stop(),7);case 7:ta(f,0)}})})}
function vk(b,c,d){return r(function f(){var g,h,k;return v(f,function(f){switch(f.m){case 1:return g=new gc({Gb:b.b,onError:d,Vc:function(){},onExpirationUpdated:function(){},onEvent:function(){}}),h=$d(c),k=b.a,g.configure(k.drm),u(f,lc(g,h,k.offline.usePersistentLicense),2);case 2:return u(f,uc(g),3);case 3:return u(f,vc(g),4);case 4:return f["return"](g)}})})}
function zk(b,c,d,e,f,g,h){var k=new ck,m=f.periods.map(function(e){return Ik(b,c,d,k,f,e)}),l=e.a,p=zc(e);if(l&&b.a.offline.usePersistentLicense){if(!p.length)throw new B(2,9,9007,g);l.initData=[]}return{originalManifestUri:g,duration:f.presentationTimeline.S(),size:0,expiration:e.Db(),periods:m,sessionIds:b.a.offline.usePersistentLicense?p:[],drmInfo:l,appMetadata:h}}
function Ik(b,c,d,e,f,g){f.periods.forEach(function(b){b.variants.forEach(function(b){var c=b.audio,d=b.video;c&&!d&&(e.a[c.id]=c.bandwidth||b.bandwidth);!c&&d&&(e.a[d.id]=d.bandwidth||b.bandwidth);if(c&&d){var f=c.bandwidth||393216,g=d.bandwidth||b.bandwidth-f;0>=g&&(g=b.bandwidth);e.a[c.id]=f;e.a[d.id]=g}});b.textStreams.forEach(function(b){e.a[b.id]=52})});var h=Jk(f),k=new Map;h=q(h);for(var m=h.next();!m.done;m=h.next()){m=m.value;var l=Kk(b,c,d,e,f,m);k.set(m.id,l)}g.variants.forEach(function(b){b.audio&&
k.get(b.audio.id).variantIds.push(b.id);b.video&&k.get(b.video.id).variantIds.push(b.id)});return{startTime:g.startTime,streams:Array.from(k.values())}}
function Kk(b,c,d,e,f,g){var h={id:g.id,originalId:g.originalId,primary:g.primary,presentationTimeOffset:g.presentationTimeOffset||0,contentType:g.type,mimeType:g.mimeType,codecs:g.codecs,frameRate:g.frameRate,kind:g.kind,language:g.language,label:g.label,width:g.width||null,height:g.height||null,initSegmentKey:null,encrypted:g.encrypted,keyId:g.keyId,segments:[],variantIds:[]};f=f.presentationTimeline.cb();var k=g.id;Lk(g,f,function(f){ni(c,k,Mk(b,f),dk(e,g.id,f),function(c){return d.addSegments([{data:c}]).then(function(c){b.c.push(c[0]);
h.segments.push({startTime:f.startTime,endTime:f.endTime,dataKey:c[0]})})})});(f=g.initSegmentReference)&&ni(c,k,Mk(b,f),.5*ek(e,g.id),function(c){return d.addSegments([{data:c}]).then(function(c){b.c.push(c[0]);h.initSegmentKey=c[0]})});return h}function Lk(b,c,d){c=b.findSegmentPosition(c);for(var e=null==c?null:b.getSegmentReference(c);e;)d(e),e=b.getSegmentReference(++c)}function uk(b){if(b.h.a)throw new B(2,9,7001);}function sk(){if(!Hi())throw new B(2,9,9E3);}
function Mk(b,c){var d=b.a.streaming.retryParameters;d=xb(c.c(),d);if(0!=c.b||null!=c.a)d.headers.Range="bytes="+c.b+"-"+(null==c.a?"":c.a);return d}function qk(b,c){return r(function e(){return v(e,function(e){switch(e.m){case 1:return b.f.push(c),pa(e,2),u(e,c,4);case 4:return e["return"](e.w);case 2:sa(e),ob(b.f,c),ta(e,0)}})})}
function Fk(b){var c=[];b.periods.forEach(function(b){b.streams.forEach(function(b){null!=b.initSegmentKey&&c.push(b.initSegmentKey);b.segments.forEach(function(b){c.push(b.dataKey)})})});return c}Z.deleteAll=function(b){var c=b.Oa();b=b.getConfiguration();return Nk(c,b.drm)};
function Nk(b,c){var d=new zi;return vh([d],function(){return r(function f(){var g,h,k;return v(f,function(f){switch(f.m){case 1:return u(f,d.init(),2);case 2:return u(f,Ok(d),3);case 3:g=f.w,h=0;case 4:if(!(h<g.length)){var l=[];for(var m=q(d.a.values()),t=m.next();!t.done;t=m.next())l.push(t.value.erase());l=Promise.all(l);return u(f,l,0)}k=Ek(b,c,d,g[h]);return u(f,k,5);case 5:h++,f.D(4)}})})})}
function Ek(b,c,d,e){return r(function g(){var h,k,m;return v(g,function(g){switch(g.m){case 1:if(!e.drmInfo)return g["return"]();h=Fi(d);k=e.sessionIds.map(function(b){return{sessionId:b,keySystem:e.drmInfo.keySystem,licenseUri:e.drmInfo.licenseServerUri,serverCertificate:e.drmInfo.serverCertificate,audioCapabilities:Dk(e,!1),videoCapabilities:Dk(e,!0)}});return u(g,kj(c,b,k),2);case 2:return m=g.w,u(g,h.remove(m),3);case 3:return u(g,h.add(k.filter(function(b){return-1==m.indexOf(b.sessionId)})),
0)}})})}function Jk(b){var c=new Set;b.periods.forEach(function(b){b.textStreams.forEach(function(b){c.add(b)});b.variants.forEach(function(b){b.audio&&c.add(b.audio);b.video&&c.add(b.video)})});return c}function Ok(b){var c=[],d=[];Ci(b,function(b,f){d.push(f.getAllManifests().then(function(b){b=q(b.values());for(var d=b.next();!d.done;d=b.next())c.push(d.value)}))});return Promise.all(d).then(function(){return c})}
function yk(b){if(0==b.periods.length)throw new B(2,4,4014);b=q(b.periods);for(var c=b.next();!c.done;c=b.next())Pk(c.value)}function Pk(b){b.variants.map(function(b){return b.video});var c=new Set(b.variants.map(function(b){return b.audio}));b=b.textStreams;for(var d=q(c),e=d.next();!e.done;e=d.next()){e=q(c);for(var f=e.next();!f.done;f=e.next());}c=q(b);for(d=c.next();!d.done;d=c.next())for(d=q(b),e=d.next();!e.done;e=d.next());}yj.offline=pk;y("shaka.polyfill.installAll",function(){for(var b=0;b<Qk.length;++b)Qk[b].Ad()});var Qk=[];function Rk(b,c){c=c||0;for(var d={priority:c,Ad:b},e=0;e<Qk.length;e++)if(Qk[e].priority<c){Qk.splice(e,0,d);return}Qk.push(d)}y("shaka.polyfill.register",Rk);function Sk(b){var c=b.type.replace(/^(webkit|moz|MS)/,"").toLowerCase();if("function"===typeof Event)var d=new Event(c,b);else d=document.createEvent("Event"),d.initEvent(c,b.bubbles,b.cancelable);b.target.dispatchEvent(d)}
Rk(function(){if(window.Document){var b=Element.prototype;b.requestFullscreen=b.requestFullscreen||b.mozRequestFullScreen||b.msRequestFullscreen||b.webkitRequestFullscreen;b=Document.prototype;b.exitFullscreen=b.exitFullscreen||b.mozCancelFullScreen||b.msExitFullscreen||b.webkitExitFullscreen;"fullscreenElement"in document||(Object.defineProperty(document,"fullscreenElement",{get:function(){return document.mozFullScreenElement||document.msFullscreenElement||document.webkitFullscreenElement}}),Object.defineProperty(document,
"fullscreenEnabled",{get:function(){return document.mozFullScreenEnabled||document.msFullscreenEnabled||document.webkitFullscreenEnabled}}));document.addEventListener("webkitfullscreenchange",Sk);document.addEventListener("webkitfullscreenerror",Sk);document.addEventListener("mozfullscreenchange",Sk);document.addEventListener("mozfullscreenerror",Sk);document.addEventListener("MSFullscreenChange",Sk);document.addEventListener("MSFullscreenError",Sk)}});Rk(function(){var b=navigator.userAgent;b&&b.includes("CrKey")&&delete window.indexedDB});var Tk;function Uk(b,c,d){if("input"==b)switch(this.type){case "range":b="change"}Tk.call(this,b,c,d)}Rk(function(){navigator.userAgent.includes("Trident/")&&HTMLInputElement.prototype.addEventListener!=Uk&&(Tk=HTMLInputElement.prototype.addEventListener,HTMLInputElement.prototype.addEventListener=Uk)});Rk(function(){});function Vk(){var b=MediaSource.prototype.addSourceBuffer;MediaSource.prototype.addSourceBuffer=function(c){for(var d=[],e=0;e<arguments.length;++e)d[e]=arguments[e];d=b.apply(this,d);d.abort=function(){};return d}}function Wk(){var b=SourceBuffer.prototype.remove;SourceBuffer.prototype.remove=function(c,d){return b.call(this,c,d-.001)}}
function Xk(){var b=MediaSource.prototype.endOfStream;MediaSource.prototype.endOfStream=function(c){for(var d=[],e=0;e<arguments.length;++e)d[e]=arguments[e];for(var h=e=0;h<this.sourceBuffers.length;++h){var k=this.sourceBuffers[h];k=k.buffered.end(k.buffered.length-1);e=Math.max(e,k)}if(!isNaN(this.duration)&&e<this.duration)for(this.Mc=!0,e=0;e<this.sourceBuffers.length;++e)this.sourceBuffers[e].Gc=!1;return b.apply(this,d)};var c=!1,d=MediaSource.prototype.addSourceBuffer;MediaSource.prototype.addSourceBuffer=
function(b){for(var e=[],g=0;g<arguments.length;++g)e[g]=arguments[g];e=d.apply(this,e);e.mediaSource_=this;e.addEventListener("updateend",Yk,!1);c||(this.addEventListener("sourceclose",Zk,!1),c=!0);return e}}function Yk(b){var c=b.target,d=c.mediaSource_;if(d.Mc){b.preventDefault();b.stopPropagation();b.stopImmediatePropagation();c.Gc=!0;for(b=0;b<d.sourceBuffers.length;++b)if(0==d.sourceBuffers[b].Gc)return;d.Mc=!1}}
function Zk(b){b=b.target;for(var c=0;c<b.sourceBuffers.length;++c)b.sourceBuffers[c].removeEventListener("updateend",Yk,!1);b.removeEventListener("sourceclose",Zk,!1)}function $k(){var b=MediaSource.isTypeSupported;MediaSource.isTypeSupported=function(c){return"mp2t"==c.split(/ *; */)[0].split("/")[1]?!1:b(c)}}
function al(){var b=MediaSource.isTypeSupported,c=/^dv(?:he|av)\./;MediaSource.isTypeSupported=function(d){for(var e=d.split(/ *; */),f=e[0],g={},h=1;h<e.length;++h){var k=e[h].split("="),m=k[0];k=k[1].replace(/"(.*)"/,"$1");g[m]=k}e=g.codecs;if(!e)return b(d);var l=!1,p=!1;d=e.split(",").filter(function(b){if(c.test(b))return p=!0,!1;/^(hev|hvc)1\.2/.test(b)&&(l=!0);return!0});p&&(l=!1);g.codecs=d.join(",");l&&(g.eotf="smpte2084");for(var t in g)f+="; "+t+'="'+g[t]+'"';return cast.__platform__.canDisplayType(f)}}
Rk(function(){if(window.MediaSource)if(window.cast&&cast.__platform__&&cast.__platform__.canDisplayType)al();else if(navigator.vendor&&navigator.vendor.includes("Apple")){var b=navigator.appVersion;$k();b.includes("Version/8")?window.MediaSource=null:b.includes("Version/9")?Vk():b.includes("Version/10")?(Vk(),Xk()):b.includes("Version/11")&&(Vk(),Wk())}});function bl(b){this.f=[];this.b=[];this.a=[];(new Q).aa("pssh",this.c.bind(this)).parse(b.buffer)}bl.prototype.c=function(b){if(!(1<b.version)){var c=dc(b.reader.Ha(16)),d=[];if(0<b.version)for(var e=b.reader.C(),f=0;f<e;++f){var g=dc(b.reader.Ha(16));d.push(g)}e=b.reader.C();b.reader.I(e);this.b.push.apply(this.b,d);this.f.push(c);this.a.push({start:b.start,end:b.start+b.size-1})}};function cl(b,c){try{var d=new dl(b,c);return Promise.resolve(d)}catch(e){return Promise.reject(e)}}
function dl(b,c){this.keySystem=b;for(var d=!1,e=0;e<c.length;++e){var f=c[e],g={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:f.initDataTypes,sessionTypes:["temporary"],label:f.label},h=!1;if(f.audioCapabilities)for(var k=0;k<f.audioCapabilities.length;++k){var m=f.audioCapabilities[k];if(m.contentType){h=!0;var l=m.contentType.split(";")[0];MSMediaKeys.isTypeSupported(this.keySystem,l)&&(g.audioCapabilities.push(m),d=!0)}}if(f.videoCapabilities)for(k=
0;k<f.videoCapabilities.length;++k)m=f.videoCapabilities[k],m.contentType&&(h=!0,l=m.contentType.split(";")[0],MSMediaKeys.isTypeSupported(this.keySystem,l)&&(g.videoCapabilities.push(m),d=!0));h||(d=MSMediaKeys.isTypeSupported(this.keySystem,"video/mp4"));"required"==f.persistentState&&(d=!1);if(d){this.a=g;return}}d=Error("Unsupported keySystem");d.name="NotSupportedError";d.code=DOMException.NOT_SUPPORTED_ERR;throw d;}dl.prototype.createMediaKeys=function(){var b=new el(this.keySystem);return Promise.resolve(b)};
dl.prototype.getConfiguration=function(){return this.a};function fl(b){var c=this.mediaKeys;c&&c!=b&&gl(c,null);delete this.mediaKeys;return(this.mediaKeys=b)?gl(b,this):Promise.resolve()}function el(b){this.a=new MSMediaKeys(b);this.b=new Cb}el.prototype.createSession=function(b){b=b||"temporary";if("temporary"!=b)throw new TypeError("Session type "+b+" is unsupported on this platform.");return new hl(this.a,b)};el.prototype.setServerCertificate=function(){return Promise.resolve(!1)};
function gl(b,c){function d(){c.msSetMediaKeys(e.a);c.removeEventListener("loadedmetadata",d)}Db(b.b);if(!c)return Promise.resolve();H(b.b,c,"msneedkey",il);var e=b;try{return 1<=c.readyState?c.msSetMediaKeys(b.a):c.addEventListener("loadedmetadata",d),Promise.resolve()}catch(f){return Promise.reject(f)}}function hl(b){E.call(this);this.c=null;this.g=b;this.b=this.a=null;this.f=new Cb;this.sessionId="";this.expiration=NaN;this.closed=new z;this.keyStatuses=new jl}Ea(hl,E);n=hl.prototype;
n.generateRequest=function(b,c){this.a=new z;try{this.c=this.g.createSession("video/mp4",new Uint8Array(c),null),H(this.f,this.c,"mskeymessage",this.ne.bind(this)),H(this.f,this.c,"mskeyadded",this.le.bind(this)),H(this.f,this.c,"mskeyerror",this.me.bind(this)),kl(this,"status-pending")}catch(d){this.a.reject(d)}return this.a};n.load=function(){return Promise.reject(Error("MediaKeySession.load not yet supported"))};n.update=function(b){this.b=new z;try{this.c.update(new Uint8Array(b))}catch(c){this.b.reject(c)}return this.b};
n.close=function(){try{this.c.close(),this.closed.resolve(),Db(this.f)}catch(b){this.closed.reject(b)}return this.closed};n.remove=function(){return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"))};function il(b){var c=document.createEvent("CustomEvent");c.initCustomEvent("encrypted",!1,!1,null);c.initDataType="cenc";c.initData=ll(b.initData);this.dispatchEvent(c)}
function ll(b){if(!b)return b;var c=new bl(b);if(1>=c.a.length)return b;for(var d=[],e=0;e<c.a.length;e++)d.push(b.subarray(c.a[e].start,c.a[e].end+1));b=[];c={};e=q(d);for(d=e.next();!d.done;c={Eb:c.Eb},d=e.next())c.Eb=d.value,b.some(function(b){return function(c){return ec(c,b.Eb)}}(c))||b.push(c.Eb);c=0;e=q(b);for(d=e.next();!d.done;d=e.next())c+=d.value.length;c=new Uint8Array(c);e=0;b=q(b);for(d=b.next();!d.done;d=b.next())d=d.value,c.set(d,e),e+=d.length;return c}
n.ne=function(b){this.a&&(this.a.resolve(),this.a=null);this.dispatchEvent(new D("message",{messageType:void 0==this.keyStatuses.a?"licenserequest":"licenserenewal",message:b.message.buffer}))};n.le=function(){this.a?(kl(this,"usable"),this.a.resolve(),this.a=null):this.b&&(kl(this,"usable"),this.b.resolve(),this.b=null)};
n.me=function(){var b=Error("EME PatchedMediaKeysMs key error");b.errorCode=this.c.error;if(null!=this.a)this.a.reject(b),this.a=null;else if(null!=this.b)this.b.reject(b),this.b=null;else switch(this.c.error.code){case MSMediaKeyError.MS_MEDIA_KEYERR_OUTPUT:case MSMediaKeyError.MS_MEDIA_KEYERR_HARDWARECHANGE:kl(this,"output-not-allowed");break;default:kl(this,"internal-error")}};function kl(b,c){var d=b.keyStatuses;d.size=void 0==c?0:1;d.a=c;b.dispatchEvent(new D("keystatuseschange"))}
function jl(){this.size=0;this.a=void 0}var ml;n=jl.prototype;n.forEach=function(b){this.a&&b(this.a,ml)};n.get=function(b){if(this.has(b))return this.a};n.has=function(b){var c=ml;return this.a&&ec(new Uint8Array(b),new Uint8Array(c))?!0:!1};n.entries=function(){};n.keys=function(){};n.values=function(){};
Rk(function(){!window.HTMLVideoElement||!window.MSMediaKeys||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration||(ml=(new Uint8Array([0])).buffer,delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,HTMLMediaElement.prototype.setMediaKeys=fl,window.MediaKeys=el,window.MediaKeySystemAccess=dl,navigator.requestMediaKeySystemAccess=cl)});function nl(){return Promise.reject(Error("The key system specified is not supported."))}function ol(b){return null==b?Promise.resolve():Promise.reject(Error("MediaKeys not supported."))}function pl(){throw new TypeError("Illegal constructor.");}pl.prototype.createSession=function(){};pl.prototype.setServerCertificate=function(){};function ql(){throw new TypeError("Illegal constructor.");}ql.prototype.getConfiguration=function(){};ql.prototype.createMediaKeys=function(){};
Rk(function(){!window.HTMLVideoElement||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration||(navigator.requestMediaKeySystemAccess=nl,delete HTMLMediaElement.prototype.mediaKeys,HTMLMediaElement.prototype.mediaKeys=null,HTMLMediaElement.prototype.setMediaKeys=ol,window.MediaKeys=pl,window.MediaKeySystemAccess=ql)},-10);var rl="";function sl(b){var c=rl;return c?c+b.charAt(0).toUpperCase()+b.slice(1):b}function tl(b,c){try{var d=new ul(b,c);return Promise.resolve(d)}catch(e){return Promise.reject(e)}}function vl(b){var c=this.mediaKeys;c&&c!=b&&wl(c,null);delete this.mediaKeys;(this.mediaKeys=b)&&wl(b,this);return Promise.resolve()}
function ul(b,c){this.a=this.keySystem=b;var d=!1;"org.w3.clearkey"==b&&(this.a="webkit-org.w3.clearkey",d=!1);var e=!1;var f=document.getElementsByTagName("video");f=f.length?f[0]:document.createElement("video");for(var g=0;g<c.length;++g){var h=c[g],k={audioCapabilities:[],videoCapabilities:[],persistentState:"optional",distinctiveIdentifier:"optional",initDataTypes:h.initDataTypes,sessionTypes:["temporary"],label:h.label},m=!1;if(h.audioCapabilities)for(var l=0;l<h.audioCapabilities.length;++l){var p=
h.audioCapabilities[l];if(p.contentType){m=!0;var t=p.contentType.split(";")[0];f.canPlayType(t,this.a)&&(k.audioCapabilities.push(p),e=!0)}}if(h.videoCapabilities)for(l=0;l<h.videoCapabilities.length;++l)p=h.videoCapabilities[l],p.contentType&&(m=!0,f.canPlayType(p.contentType,this.a)&&(k.videoCapabilities.push(p),e=!0));m||(e=f.canPlayType("video/mp4",this.a)||f.canPlayType("video/webm",this.a));"required"==h.persistentState&&(d?(k.persistentState="required",k.sessionTypes=["persistent-license"]):
e=!1);if(e){this.b=k;return}}d="Unsupported keySystem";if("org.w3.clearkey"==b||"com.widevine.alpha"==b)d="None of the requested configurations were supported.";d=Error(d);d.name="NotSupportedError";d.code=DOMException.NOT_SUPPORTED_ERR;throw d;}ul.prototype.createMediaKeys=function(){var b=new xl(this.a);return Promise.resolve(b)};ul.prototype.getConfiguration=function(){return this.b};function xl(b){this.g=b;this.b=null;this.a=new Cb;this.c=[];this.f={}}
function wl(b,c){b.b=c;Db(b.a);var d=rl;c&&(H(b.a,c,d+"needkey",b.ze.bind(b)),H(b.a,c,d+"keymessage",b.ye.bind(b)),H(b.a,c,d+"keyadded",b.we.bind(b)),H(b.a,c,d+"keyerror",b.xe.bind(b)))}n=xl.prototype;n.createSession=function(b){b=b||"temporary";if("temporary"!=b&&"persistent-license"!=b)throw new TypeError("Session type "+b+" is unsupported on this platform.");var c=this.b||document.createElement("video");c.src||(c.src="about:blank");b=new yl(c,this.g,b);this.c.push(b);return b};
n.setServerCertificate=function(){return Promise.resolve(!1)};n.ze=function(b){var c=document.createEvent("CustomEvent");c.initCustomEvent("encrypted",!1,!1,null);c.initDataType="webm";c.initData=b.initData;this.b.dispatchEvent(c)};n.ye=function(b){var c=zl(this,b.sessionId);c&&(b=new D("message",{messageType:void 0==c.keyStatuses.a?"licenserequest":"licenserenewal",message:b.message}),c.b&&(c.b.resolve(),c.b=null),c.dispatchEvent(b))};
n.we=function(b){if(b=zl(this,b.sessionId))Al(b,"usable"),b.a&&b.a.resolve(),b.a=null};
n.xe=function(b){var c=zl(this,b.sessionId);if(c){var d=Error("EME v0.1b key error");d.errorCode=b.errorCode;d.errorCode.systemCode=b.systemCode;!b.sessionId&&c.b?(d.method="generateRequest",45==b.systemCode&&(d.message="Unsupported session type."),c.b.reject(d),c.b=null):b.sessionId&&c.a?(d.method="update",c.a.reject(d),c.a=null):(d=b.systemCode,b.errorCode.code==MediaKeyError.MEDIA_KEYERR_OUTPUT?Al(c,"output-restricted"):1==d?Al(c,"expired"):Al(c,"internal-error"))}};
function zl(b,c){var d=b.f[c];return d?d:(d=b.c.shift())?(d.sessionId=c,b.f[c]=d):null}function yl(b,c,d){E.call(this);this.f=b;this.h=!1;this.a=this.b=null;this.c=c;this.g=d;this.sessionId="";this.expiration=NaN;this.closed=new z;this.keyStatuses=new Bl}Ea(yl,E);
function Cl(b,c,d){if(b.h)return Promise.reject(Error("The session is already initialized."));b.h=!0;try{if("persistent-license"==b.g)if(d)var e=new Uint8Array(Sb("LOAD_SESSION|"+d));else{var f=Sb("PERSISTENT|"),g=new Uint8Array(f.byteLength+c.byteLength);g.set(new Uint8Array(f),0);g.set(new Uint8Array(c),f.byteLength);e=g}else e=new Uint8Array(c)}catch(k){return Promise.reject(k)}b.b=new z;var h=sl("generateKeyRequest");try{b.f[h](b.c,e)}catch(k){if("InvalidStateError"!=k.name)return b.b=null,Promise.reject(k);
setTimeout(function(){try{this.f[h](this.c,e)}catch(m){this.b.reject(m),this.b=null}}.bind(b),10)}return b.b}n=yl.prototype;
n.vc=function(b,c){if(this.a)this.a.then(this.vc.bind(this,b,c))["catch"](this.vc.bind(this,b,c));else{this.a=b;if("webkit-org.w3.clearkey"==this.c){var d=Ob(c);var e=JSON.parse(d);"oct"!=e.keys[0].kty&&(this.a.reject(Error("Response is not a valid JSON Web Key Set.")),this.a=null);d=bc(e.keys[0].k);e=bc(e.keys[0].kid)}else d=new Uint8Array(c),e=null;var f=sl("addKey");try{this.f[f](this.c,d,e,this.sessionId)}catch(g){this.a.reject(g),this.a=null}}};
function Al(b,c){var d=b.keyStatuses;d.size=void 0==c?0:1;d.a=c;b.dispatchEvent(new D("keystatuseschange"))}n.generateRequest=function(b,c){return Cl(this,c,null)};n.load=function(b){return"persistent-license"==this.g?Cl(this,null,b):Promise.reject(Error("Not a persistent session."))};n.update=function(b){var c=new z;this.vc(c,b);return c};
n.close=function(){if("persistent-license"!=this.g){if(!this.sessionId)return this.closed.reject(Error("The session is not callable.")),this.closed;var b=sl("cancelKeyRequest");try{this.f[b](this.c,this.sessionId)}catch(c){}}this.closed.resolve();return this.closed};n.remove=function(){return"persistent-license"!=this.g?Promise.reject(Error("Not a persistent session.")):this.close()};function Bl(){this.size=0;this.a=void 0}var Dl;n=Bl.prototype;n.forEach=function(b){this.a&&b(this.a,Dl)};n.get=function(b){if(this.has(b))return this.a};
n.has=function(b){var c=Dl;return this.a&&ec(new Uint8Array(b),new Uint8Array(c))?!0:!1};n.entries=function(){};n.keys=function(){};n.values=function(){};
Rk(function(){if(!(!window.HTMLVideoElement||navigator.requestMediaKeySystemAccess&&MediaKeySystemAccess.prototype.getConfiguration)){if(HTMLMediaElement.prototype.webkitGenerateKeyRequest)rl="webkit";else if(!HTMLMediaElement.prototype.generateKeyRequest)return;Dl=(new Uint8Array([0])).buffer;navigator.requestMediaKeySystemAccess=tl;delete HTMLMediaElement.prototype.mediaKeys;HTMLMediaElement.prototype.mediaKeys=null;HTMLMediaElement.prototype.setMediaKeys=vl;window.MediaKeys=xl;window.MediaKeySystemAccess=
ul}});Rk(function(){if(window.HTMLMediaElement){var b=HTMLMediaElement.prototype.play;HTMLMediaElement.prototype.play=function(){var c=b.apply(this);c&&c["catch"](function(){});return c}}});function El(){return{droppedVideoFrames:this.webkitDroppedFrameCount,totalVideoFrames:this.webkitDecodedFrameCount,corruptedVideoFrames:0,creationTime:NaN,totalFrameDelay:0}}Rk(function(){if(window.HTMLVideoElement){var b=HTMLVideoElement.prototype;!b.getVideoPlaybackQuality&&"webkitDroppedFrameCount"in b&&(b.getVideoPlaybackQuality=El)}});function Fl(b,c,d){return new window.TextTrackCue(b,c,d)}function Gl(b,c,d){return new window.TextTrackCue(b+"-"+c+"-"+d,b,c,d)}Rk(function(){if(!window.VTTCue&&window.TextTrackCue){var b=TextTrackCue.length;if(3==b)window.VTTCue=Fl;else if(6==b)window.VTTCue=Gl;else{try{var c=!!Fl(1,2,"")}catch(d){c=!1}c&&(window.VTTCue=Fl)}}});function Hl(){}Hl.prototype.parseInit=function(){};
Hl.prototype.parseMedia=function(b,c){var d=Ob(b),e=[],f=new DOMParser,g=null;try{g=f.parseFromString(d,"text/xml")}catch(F){throw new B(2,2,2005);}if(g){if(f=g.getElementsByTagName("tt")[0]){g=M.getAttributeNS(f,"http://www.w3.org/ns/ttml#parameter","frameRate");var h=M.getAttributeNS(f,"http://www.w3.org/ns/ttml#parameter","subFrameRate");var k=M.getAttributeNS(f,"http://www.w3.org/ns/ttml#parameter","frameRateMultiplier");var m=M.getAttributeNS(f,"http://www.w3.org/ns/ttml#parameter","tickRate");
d=f.getAttribute("xml:space")||"default"}else throw new B(2,2,2005);if("default"!=d&&"preserve"!=d)throw new B(2,2,2005);d="default"==d;g=new Il(g,h,k,m);h=Jl(f.getElementsByTagName("styling")[0]);k=Jl(f.getElementsByTagName("layout")[0]);m=[];for(var l=0;l<k.length;l++){var p=k[l],t=h;var w=new Nc;var x=p.getAttribute("xml:id");if(x){w.id=x;var A;if(A=Kl(p,t,"extent"))A=(x=Ll.exec(A))||Ml.exec(A),null!=A&&(w.width=Number(A[1]),w.height=Number(A[2]),w.widthUnits=x?dd:0,w.heightUnits=x?dd:0);if(p=
Kl(p,t,"origin"))A=(x=Ll.exec(p))||Ml.exec(p),null!=A&&(w.viewportAnchorX=Number(A[1]),w.viewportAnchorY=Number(A[2]),w.viewportAnchorUnits=x?dd:0)}else w=null;w&&m.push(w)}f=Jl(f.getElementsByTagName("body")[0]);for(l=0;l<f.length;l++)(w=Nl(f[l],c.periodStart,g,h,k,m,d))&&e.push(w)}return e};
var Ll=/^(\d{1,2}|100)% (\d{1,2}|100)%$/,Ol=/^(\d+px|\d+em)$/,Ml=/^(\d+)px (\d+)px$/,Pl=/^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,Ql=/^(?:(\d{2,}):)?(\d{2}):(\d{2})$/,Rl=/^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/,Sl=/^(\d*(?:\.\d*)?)f$/,Tl=/^(\d*(?:\.\d*)?)t$/,Ul=/^(?:(\d*(?:\.\d*)?)h)?(?:(\d*(?:\.\d*)?)m)?(?:(\d*(?:\.\d*)?)s)?(?:(\d*(?:\.\d*)?)ms)?$/,Vl={left:"start",center:Wc,right:"end",start:"start",end:"end"},Wl={left:"line-left",center:"center",right:"line-right"};
function Jl(b){var c=[];if(!b)return c;for(var d=b.childNodes,e=0;e<d.length;e++){var f="span"==d[e].nodeName&&"p"==b.nodeName;d[e].nodeType!=Node.ELEMENT_NODE||"br"==d[e].nodeName||f||(f=Jl(d[e]),c=c.concat(f))}c.length||c.push(b);return c}function Xl(b,c){for(var d=b.childNodes,e=0;e<d.length;e++)if("br"==d[e].nodeName&&0<e)d[e-1].textContent+="\n";else if(0<d[e].childNodes.length)Xl(d[e],c);else if(c){var f=d[e].textContent.trim();f=f.replace(/\s+/g," ");d[e].textContent=f}}
function Nl(b,c,d,e,f,g,h){if(!b.hasAttribute("begin")&&!b.hasAttribute("end")&&/^\s*$/.test(b.textContent))return null;Xl(b,h);h=Yl(b.getAttribute("begin"),d);var k=Yl(b.getAttribute("end"),d);d=Yl(b.getAttribute("dur"),d);var m=b.textContent;null==k&&null!=d&&(k=h+d);if(null==h||null==k)throw new B(2,2,2001);c=new Mc(h+c,k+c,m);if((f=Zl(b,"region",f))&&f.getAttribute("xml:id")){var l=f.getAttribute("xml:id");g=g.filter(function(b){return b.id==l});c.region=g[0]}$l(c,b,f,e);return c}
function $l(b,c,d,e){"rtl"==am(c,d,e,"direction")&&(b.writingDirection=1);var f=am(c,d,e,"writingMode");"tb"==f||"tblr"==f?b.writingDirection=2:"tbrl"==f?b.writingDirection=3:"rltb"==f||"rl"==f?b.writingDirection=1:f&&(b.writingDirection=Uc);if(f=am(c,d,e,"textAlign"))b.positionAlign=Wl[f],b.lineAlign=Vl[f],b.textAlign=$c[f.toUpperCase()];if(f=am(c,d,e,"displayAlign"))b.displayAlign=ad[f.toUpperCase()];if(f=am(c,d,e,"color"))b.color=f;if(f=am(c,d,e,"backgroundColor"))b.backgroundColor=f;if(f=am(c,
d,e,"fontFamily"))b.fontFamily=f;(f=am(c,d,e,"fontWeight"))&&"bold"==f&&(b.fontWeight=700);(f=am(c,d,e,"wrapOption"))&&"noWrap"==f&&(b.wrapLine=!1);(f=am(c,d,e,"lineHeight"))&&f.match(Ol)&&(b.lineHeight=f);(f=am(c,d,e,"fontSize"))&&f.match(Ol)&&(b.fontSize=f);if(f=am(c,d,e,"fontStyle"))b.fontStyle=cd[f.toUpperCase()];(d=Kl(d,e,"textDecoration"))&&bm(b,d);(c=cm(c,e,"textDecoration"))&&bm(b,c)}
function bm(b,c){for(var d=c.split(" "),e=0;e<d.length;e++)switch(d[e]){case "underline":b.textDecoration.includes("underline")||b.textDecoration.push("underline");break;case "noUnderline":b.textDecoration.includes("underline")&&ob(b.textDecoration,"underline");break;case "lineThrough":b.textDecoration.includes("lineThrough")||b.textDecoration.push("lineThrough");break;case "noLineThrough":b.textDecoration.includes("lineThrough")&&ob(b.textDecoration,"lineThrough");break;case "overline":b.textDecoration.includes("overline")||
b.textDecoration.push("overline");break;case "noOverline":b.textDecoration.includes("overline")&&ob(b.textDecoration,"overline")}}function am(b,c,d,e){return(b=cm(b,d,e))?b:Kl(c,d,e)}function Kl(b,c,d){for(var e=Jl(b),f=0;f<e.length;f++){var g=M.getAttributeNS(e[f],"http://www.w3.org/ns/ttml#styling",d);if(g)return g}return(b=Zl(b,"style",c))?M.getAttributeNS(b,"http://www.w3.org/ns/ttml#styling",d):null}
function cm(b,c,d){return(b=Zl(b,"style",c))?M.getAttributeNS(b,"http://www.w3.org/ns/ttml#styling",d):null}function Zl(b,c,d){if(!b||1>d.length)return null;var e=null,f=b;for(b=null;f&&!(b=f.getAttribute(c))&&(f=f.parentNode,f instanceof Element););if(c=b)for(b=0;b<d.length;b++)if(d[b].getAttribute("xml:id")==c){e=d[b];break}return e}
function Yl(b,c){var d=null;if(Pl.test(b)){d=Pl.exec(b);var e=Number(d[1]),f=Number(d[2]),g=Number(d[3]),h=Number(d[4]);h+=(Number(d[5])||0)/c.b;g+=h/c.frameRate;d=g+60*f+3600*e}else Ql.test(b)?d=dm(Ql,b):Rl.test(b)?d=dm(Rl,b):Sl.test(b)?(d=Sl.exec(b),d=Number(d[1])/c.frameRate):Tl.test(b)?(d=Tl.exec(b),d=Number(d[1])/c.a):Ul.test(b)&&(d=dm(Ul,b));return d}
function dm(b,c){var d=b.exec(c);return null==d||""==d[0]?null:(Number(d[4])||0)/1E3+(Number(d[3])||0)+60*(Number(d[2])||0)+3600*(Number(d[1])||0)}function Il(b,c,d,e){this.frameRate=Number(b)||30;this.b=Number(c)||1;this.a=Number(e);0==this.a&&(this.a=b?this.frameRate*this.b:1);d&&(b=/^(\d+) (\d+)$/g.exec(d))&&(this.frameRate*=b[1]/b[2])}od["application/ttml+xml"]=Hl;function em(){this.a=new Hl}em.prototype.parseInit=function(b){var c=!1;(new Q).F("moov",R).F("trak",R).F("mdia",R).F("minf",R).F("stbl",R).aa("stsd",Ye).F("stpp",function(b){c=!0;b.parser.stop()}).parse(b);if(!c)throw new B(2,2,2007);};em.prototype.parseMedia=function(b,c){var d=!1,e=[];(new Q).F("mdat",Ze(function(b){d=!0;e=e.concat(this.a.parseMedia(b,c))}.bind(this))).parse(b);if(!d)throw new B(2,2,2007);return e};od['application/mp4; codecs="stpp"']=em;
od['application/mp4; codecs="stpp.TTML.im1t"']=em;function fm(){}fm.prototype.parseInit=function(){};
fm.prototype.parseMedia=function(b,c){var d=Ob(b);d=d.replace(/\r\n|\r(?=[^\n]|$)/gm,"\n");d=d.split(/\n{2,}/m);if(!/^WEBVTT($|[ \t\n])/m.test(d[0]))throw new B(2,2,2E3);var e=c.segmentStart;if(null==e&&(e=0,d[0].includes("X-TIMESTAMP-MAP"))){var f=d[0].match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m),g=d[0].match(/MPEGTS:(\d+)/m);f&&g&&(e=gm(new cg(f[1])),e=c.periodStart+(Number(g[1])/9E4-e))}g=[];var h=d[0].split("\n");for(f=1;f<h.length;f++)if(/^Region:/.test(h[f])){var k=new cg(h[f]),
m=new Nc;fg(k);dg(k);for(var l=fg(k);l;){var p=m,t=l;(l=/^id=(.*)$/.exec(t))?p.id=l[1]:(l=/^width=(\d{1,2}|100)%$/.exec(t))?p.width=Number(l[1]):(l=/^lines=(\d+)$/.exec(t))?(p.height=Number(l[1]),p.heightUnits=2):(l=/^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(t))?(p.regionAnchorX=Number(l[1]),p.regionAnchorY=Number(l[2])):(l=/^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(t))?(p.viewportAnchorX=Number(l[1]),p.viewportAnchorY=Number(l[2])):/^scroll=up$/.exec(t)&&(p.scroll="up");dg(k);
l=fg(k)}g.push(m)}f=[];for(k=1;k<d.length;k++){h=d[k].split("\n");l=h;t=e;h=g;if(1==l.length&&!l[0]||/^NOTE($|[ \t])/.test(l[0])||"STYLE"==l[0])h=null;else{m=null;l[0].includes("--\x3e")||(m=l[0],l.splice(0,1));p=new cg(l[0]);var w=gm(p),x=eg(p,/[ \t]+--\x3e[ \t]+/g),A=gm(p);if(null==w||null==x||null==A)throw new B(2,2,2001);l=new Mc(w+t,A+t,l.slice(1).join("\n").trim());dg(p);for(t=fg(p);t;)hm(l,t,h),dg(p),t=fg(p);null!=m&&(l.id=m);h=l}h&&f.push(h)}return f};
function hm(b,c,d){var e;if(e=/^align:(start|middle|center|end|left|right)$/.exec(c))c=e[1],"middle"==c?b.textAlign=Tc:b.textAlign=$c[c.toUpperCase()];else if(e=/^vertical:(lr|rl)$/.exec(c))b.writingDirection="lr"==e[1]?2:3;else if(e=/^size:([\d.]+)%$/.exec(c))b.size=Number(e[1]);else if(e=/^position:([\d.]+)%(?:,(line-left|line-right|center|start|end))?$/.exec(c))b.position=Number(e[1]),e[2]&&(c=e[2],b.positionAlign="line-left"==c||"start"==c?"line-left":"line-right"==c||"end"==c?"line-right":"center");
else if(e=/^region:(.*)$/.exec(c)){if(c=im(d,e[1]))b.region=c}else if(d=/^line:([\d.]+)%(?:,(start|end|center))?$/.exec(c))b.lineInterpretation=1,b.line=Number(d[1]),d[2]&&(b.lineAlign=bd[d[2].toUpperCase()]);else if(d=/^line:(-?\d+)(?:,(start|end|center))?$/.exec(c))b.lineInterpretation=Vc,b.line=Number(d[1]),d[2]&&(b.lineAlign=bd[d[2].toUpperCase()])}function im(b,c){var d=b.filter(function(b){return b.id==c});return d.length?d[0]:null}
function gm(b){b=eg(b,/(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3})/g);if(null==b)return null;var c=Number(b[2]),d=Number(b[3]);return 59<c||59<d?null:Number(b[4])/1E3+d+60*c+3600*(Number(b[1])||0)}od["text/vtt"]=fm;od['text/vtt; codecs="vtt"']=fm;function jm(){this.a=null}jm.prototype.parseInit=function(b){var c=!1;(new Q).F("moov",R).F("trak",R).F("mdia",R).aa("mdhd",function(b){0==b.version?(b.reader.I(4),b.reader.I(4),this.a=b.reader.C(),b.reader.I(4)):(b.reader.I(8),b.reader.I(8),this.a=b.reader.C(),b.reader.I(8));b.reader.I(4)}.bind(this)).F("minf",R).F("stbl",R).aa("stsd",Ye).F("wvtt",function(){c=!0}).parse(b);if(!this.a)throw new B(2,2,2008);if(!c)throw new B(2,2,2008);};
jm.prototype.parseMedia=function(b,c){var d=this;if(!this.a)throw new B(2,2,2008);var e=0,f=[],g,h=[],k=!1,m=!1,l=!1,p=null;(new Q).F("moof",R).F("traf",R).aa("tfdt",function(b){k=!0;e=0==b.version?b.reader.C():b.reader.Xa()}).aa("tfhd",function(b){var c=b.flags;b=b.reader;b.I(4);c&1&&b.I(8);c&2&&b.I(4);p=c&8?b.C():null}).aa("trun",function(b){m=!0;var c=b.version,d=b.flags;b=b.reader;var e=b.C();d&1&&b.I(4);d&4&&b.I(4);for(var g=[],h=0;h<e;h++){var k={duration:null,sampleSize:null,wc:null};d&256&&
(k.duration=b.C());d&512&&(k.sampleSize=b.C());d&1024&&b.I(4);d&2048&&(k.wc=0==c?b.C():b.dd());g.push(k)}f=g}).F("mdat",Ze(function(b){l=!0;g=b})).parse(b);if(!l&&!k&&!m)throw new B(2,2,2008);var t=e,w=new DataView(g.buffer,g.byteOffset,g.byteLength),x=new O(w,0);f.forEach(function(b){var f=b.duration||p,g=b.wc?e+b.wc:t;t=g+(f||0);var k=0;do{var l=x.C();k+=l;var m=x.C(),w=null;"vttc"==$e(m)?8<l&&(w=x.Ha(l-8)):x.I(l-8);f&&w&&h.push(km(w,c.periodStart+g/d.a,c.periodStart+t/d.a))}while(b.sampleSize&&
k<b.sampleSize)});return h.filter(I.ta)};function km(b,c,d){var e,f,g;(new Q).F("payl",Ze(function(b){e=Ob(b)})).F("iden",Ze(function(b){f=Ob(b)})).F("sttg",Ze(function(b){g=Ob(b)})).parse(b);return e?lm(e,f,g,c,d):null}function lm(b,c,d,e,f){b=new Mc(e,f,b);c&&(b.id=c);if(d)for(c=new cg(d),d=fg(c);d;)hm(b,d,[]),dg(c),d=fg(c);return b}od['application/mp4; codecs="wvtt"']=jm;}).call(exportTo,innerGlobal,innerGlobal);if(typeof exports!="undefined")for(var k in exportTo.shaka)exports[k]=exportTo.shaka[k];else if(typeof define!="undefined"&&define.amd)define(function(){return exportTo.shaka});else innerGlobal.shaka=exportTo.shaka})();


(function(){var d;window.AmCharts?d=window.AmCharts:(d={},window.AmCharts=d,d.themes={},d.maps={},d.inheriting={},d.charts=[],d.onReadyArray=[],d.useUTC=!1,d.updateRate=60,d.uid=0,d.lang={},d.translations={},d.mapTranslations={},d.windows={},d.initHandlers=[],d.amString="am",d.pmString="pm");d.Class=function(a){var b=function(){arguments[0]!==d.inheriting&&(this.events={},this.construct.apply(this,arguments))};a.inherits?(b.prototype=new a.inherits(d.inheriting),b.base=a.inherits.prototype,delete a.inherits):
(b.prototype.createEvents=function(){for(var a=0;a<arguments.length;a++)this.events[arguments[a]]=[]},b.prototype.listenTo=function(a,b,c){this.removeListener(a,b,c);a.events[b].push({handler:c,scope:this})},b.prototype.addListener=function(a,b,c){this.removeListener(this,a,b);a&&this.events[a]&&this.events[a].push({handler:b,scope:c})},b.prototype.removeListener=function(a,b,c){if(a&&a.events&&(a=a.events[b]))for(b=a.length-1;0<=b;b--)a[b].handler===c&&a.splice(b,1)},b.prototype.fire=function(a){for(var b=
this.events[a.type],c=0;c<b.length;c++){var d=b[c];d.handler.call(d.scope,a)}});for(var c in a)b.prototype[c]=a[c];return b};d.addChart=function(a){window.requestAnimationFrame?d.animationRequested||(d.animationRequested=!0,window.requestAnimationFrame(d.update)):d.updateInt||(d.updateInt=setInterval(function(){d.update()},Math.round(1E3/d.updateRate)));d.charts.push(a)};d.removeChart=function(a){for(var b=d.charts,c=b.length-1;0<=c;c--)b[c]==a&&b.splice(c,1);0===b.length&&(d.requestAnimation&&(window.cancelAnimationFrame(d.requestAnimation),
d.animationRequested=!1),d.updateInt&&(clearInterval(d.updateInt),d.updateInt=NaN))};d.isModern=!0;d.getIEVersion=function(){var a=0,b,c;"Microsoft Internet Explorer"==navigator.appName&&(b=navigator.userAgent,c=/MSIE ([0-9]{1,}[.0-9]{0,})/,null!==c.exec(b)&&(a=parseFloat(RegExp.$1)));return a};d.applyLang=function(a,b){var c=d.translations;b.dayNames=d.extend({},d.dayNames);b.shortDayNames=d.extend({},d.shortDayNames);b.monthNames=d.extend({},d.monthNames);b.shortMonthNames=d.extend({},d.shortMonthNames);
b.amString="am";b.pmString="pm";c&&(c=c[a])&&(d.lang=c,b.langObj=c,c.monthNames&&(b.dayNames=d.extend({},c.dayNames),b.shortDayNames=d.extend({},c.shortDayNames),b.monthNames=d.extend({},c.monthNames),b.shortMonthNames=d.extend({},c.shortMonthNames)),c.am&&(b.amString=c.am),c.pm&&(b.pmString=c.pm));d.amString=b.amString;d.pmString=b.pmString};d.IEversion=d.getIEVersion();9>d.IEversion&&0<d.IEversion&&(d.isModern=!1,d.isIE=!0);d.dx=0;d.dy=0;if(document.addEventListener||window.opera)d.isNN=!0,d.isIE=
!1,d.dx=.5,d.dy=.5;document.attachEvent&&(d.isNN=!1,d.isIE=!0,d.isModern||(d.dx=0,d.dy=0));window.chrome&&(d.chrome=!0);d.handleMouseUp=function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];e&&e.handleReleaseOutside&&e.handleReleaseOutside(a)}};d.handleMouseMove=function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];e&&e.handleMouseMove&&e.handleMouseMove(a)}};d.handleKeyUp=function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];e&&e.handleKeyUp&&e.handleKeyUp(a)}};d.handleWheel=
function(a){for(var b=d.charts,c=0;c<b.length;c++){var e=b[c];if(e&&e.mouseIsOver){(e.mouseWheelScrollEnabled||e.mouseWheelZoomEnabled)&&e.handleWheel&&(e.handleMouseMove(a),e.handleWheel(a));break}}};d.resetMouseOver=function(){for(var a=d.charts,b=0;b<a.length;b++){var c=a[b];c&&(c.mouseIsOver=!1)}};d.ready=function(a){d.onReadyArray.push(a)};d.handleLoad=function(){d.isReady=!0;for(var a=d.onReadyArray,b=0;b<a.length;b++){var c=a[b];isNaN(d.processDelay)?c():setTimeout(c,d.processDelay*b)}d.onReadyArray=
[]};d.addInitHandler=function(a,b){d.initHandlers.push({method:a,types:b})};d.callInitHandler=function(a){var b=d.initHandlers;if(d.initHandlers)for(var c=0;c<b.length;c++){var e=b[c];e.types?d.isInArray(e.types,a.type)&&e.method(a):e.method(a)}};d.getUniqueId=function(){d.uid++;return"AmChartsEl-"+d.uid};d.addGlobalListeners=function(){d.globalListenersAdded||(d.globalListenersAdded=!0,d.isNN&&(document.addEventListener("mousemove",d.handleMouseMove),document.addEventListener("keyup",d.handleKeyUp),
document.addEventListener("mouseup",d.handleMouseUp,!0),window.addEventListener("load",d.handleLoad,!0)),d.isIE&&(document.attachEvent("onmousemove",d.handleMouseMove),document.attachEvent("onmouseup",d.handleMouseUp),window.attachEvent("onload",d.handleLoad)))};d.addGlobalListeners();d.addWheelListeners=function(){d.wheelIsListened||(d.isNN&&(window.addEventListener("DOMMouseScroll",d.handleWheel,{passive:!1,useCapture:!0}),document.addEventListener("mousewheel",d.handleWheel,{passive:!1,useCapture:!0})),
d.isIE&&document.attachEvent("onmousewheel",d.handleWheel));d.wheelIsListened=!0};d.clear=function(){var a=d.charts;if(a)for(var b=a.length-1;0<=b;b--)a[b].clear();d.updateInt&&clearInterval(d.updateInt);d.requestAnimation&&window.cancelAnimationFrame(d.requestAnimation);d.charts=[];d.isNN&&(document.removeEventListener("mousemove",d.handleMouseMove,!0),document.removeEventListener("keyup",d.handleKeyUp,!0),document.removeEventListener("mouseup",d.handleMouseUp,!0),window.removeEventListener("load",
d.handleLoad,!0),window.removeEventListener("DOMMouseScroll",d.handleWheel,!0),document.removeEventListener("mousewheel",d.handleWheel,!0));d.isIE&&(document.detachEvent("onmousemove",d.handleMouseMove),document.detachEvent("onmouseup",d.handleMouseUp),window.detachEvent("onload",d.handleLoad));d.globalListenersAdded=!1;d.wheelIsListened=!1};d.makeChart=function(a,b,c){var e=b.type,g=b.theme;d.addGlobalListeners();d.isString(g)&&(g=d.themes[g],b.theme=g);var f;switch(e){case "serial":f=new d.AmSerialChart(g);
break;case "xy":f=new d.AmXYChart(g);break;case "pie":f=new d.AmPieChart(g);break;case "radar":f=new d.AmRadarChart(g);break;case "gauge":f=new d.AmAngularGauge(g);break;case "funnel":f=new d.AmFunnelChart(g);break;case "map":f=new d.AmMap(g);break;case "stock":f=new d.AmStockChart(g);break;case "gantt":f=new d.AmGanttChart(g)}d.extend(f,b);d.isReady?isNaN(c)?f.write(a):setTimeout(function(){d.realWrite(f,a)},c):d.ready(function(){isNaN(c)?f.write(a):setTimeout(function(){d.realWrite(f,a)},c)});return f};
d.realWrite=function(a,b){a.write(b)};d.updateCount=0;d.validateAt=Math.round(d.updateRate/10);d.update=function(){var a=d.charts;d.updateCount++;var b=!1;d.updateCount==d.validateAt&&(b=!0,d.updateCount=0);if(a)for(var c=a.length-1;0<=c;c--)a[c].update&&a[c].update(),b&&(a[c].autoResize?a[c].validateSize&&a[c].validateSize():a[c].premeasure&&a[c].premeasure());window.requestAnimationFrame&&(d.requestAnimation=window.requestAnimationFrame(d.update))};"complete"==document.readyState&&d.handleLoad()})();(function(){var d=window.AmCharts;d.toBoolean=function(a,b){if(void 0===a)return b;switch(String(a).toLowerCase()){case "true":case "yes":case "1":return!0;case "false":case "no":case "0":case null:return!1;default:return!!a}};d.removeFromArray=function(a,b){var c;if(void 0!==b&&void 0!==a)for(c=a.length-1;0<=c;c--)a[c]==b&&a.splice(c,1)};d.getPath=function(){var a=document.getElementsByTagName("script");if(a)for(var b=0;b<a.length;b++){var c=a[b].src;if(-1!==c.search(/\/(amcharts|ammap)\.js/))return c.replace(/\/(amcharts|ammap)\.js.*/,
"/")}};d.normalizeUrl=function(a){return""!==a&&-1===a.search(/\/$/)?a+"/":a};d.isAbsolute=function(a){return 0===a.search(/^http[s]?:|^\//)};d.isInArray=function(a,b){for(var c=0;c<a.length;c++)if(a[c]==b)return!0;return!1};d.getDecimals=function(a){var b=0;isNaN(a)||(a=String(a),-1!=a.indexOf("e-")?b=Number(a.split("-")[1]):-1!=a.indexOf(".")&&(b=a.split(".")[1].length));return b};d.wordwrap=function(a,b,c,e){var g,f,h,k;a+="";if(1>b)return a;g=-1;for(a=(k=a.split(/\r\n|\n|\r/)).length;++g<a;k[g]+=
h){h=k[g];for(k[g]="";h.length>b;k[g]+=d.trim(h.slice(0,f))+((h=h.slice(f)).length?c:""))f=2==e||(f=h.slice(0,b+1).match(/\S*(\s)?$/))[1]?b:f.input.length-f[0].length||1==e&&b||f.input.length+(f=h.slice(b).match(/^\S*/))[0].length;h=d.trim(h)}return k.join(c)};d.trim=function(a){return a.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")};d.wrappedText=function(a,b,c,e,g,f,h,k){var l=d.text(a,b,c,e,g,f,h);if(l){var m=l.getBBox();if(m.width>k){var n="\n";d.isModern||(n="<br>");k=Math.floor(k/(m.width/
b.length));2<k&&(k-=2);b=d.wordwrap(b,k,n,!0);l.remove();l=d.text(a,b,c,e,g,f,h)}}return l};d.getStyle=function(a,b){var c="";if(document.defaultView&&document.defaultView.getComputedStyle)try{c=document.defaultView.getComputedStyle(a,"").getPropertyValue(b)}catch(e){}else a.currentStyle&&(b=b.replace(/\-(\w)/g,function(a,b){return b.toUpperCase()}),c=a.currentStyle[b]);return c};d.removePx=function(a){if(void 0!==a)return Number(a.substring(0,a.length-2))};d.getURL=function(a,b){if(a)if("_self"!=
b&&b)if("_top"==b&&window.top)window.top.location.href=a;else if("_parent"==b&&window.parent)window.parent.location.href=a;else if("_blank"==b)window.open(a);else{var c=document.getElementsByName(b)[0];c?c.src=a:(c=d.windows[b])?c.opener&&!c.opener.closed?c.location.href=a:d.windows[b]=window.open(a):d.windows[b]=window.open(a)}else window.location.href=a};d.ifArray=function(a){return a&&"object"==typeof a&&0<a.length?!0:!1};d.callMethod=function(a,b){var c;for(c=0;c<b.length;c++){var e=b[c];if(e){if(e[a])e[a]();
var d=e.length;if(0<d){var f;for(f=0;f<d;f++){var h=e[f];if(h&&h[a])h[a]()}}}}};d.toNumber=function(a){return"number"==typeof a?a:Number(String(a).replace(/[^0-9\-.]+/g,""))};d.toColor=function(a){if(""!==a&&void 0!==a)if(-1!=a.indexOf(",")){a=a.split(",");var b;for(b=0;b<a.length;b++){var c=a[b].substring(a[b].length-6,a[b].length);a[b]="#"+c}}else a=a.substring(a.length-6,a.length),a="#"+a;return a};d.toCoordinate=function(a,b,c){var e;void 0!==a&&(a=String(a),c&&c<b&&(b=c),e=Number(a),-1!=a.indexOf("!")&&
(e=b-Number(a.substr(1))),-1!=a.indexOf("%")&&(e=b*Number(a.substr(0,a.length-1))/100));return e};d.fitToBounds=function(a,b,c){a<b&&(a=b);a>c&&(a=c);return a};d.isDefined=function(a){return void 0===a?!1:!0};d.stripNumbers=function(a){return a.replace(/[0-9]+/g,"")};d.roundTo=function(a,b){if(0>b)return a;var c=Math.pow(10,b);return Math.round(a*c)/c};d.toFixed=function(a,b){var c=!1;0>a&&(c=!0,a=Math.abs(a));var e=String(Math.round(a*Math.pow(10,b)));if(0<b){var d=e.length;if(d<b){var f;for(f=0;f<
b-d;f++)e="0"+e}d=e.substring(0,e.length-b);""===d&&(d=0);e=d+"."+e.substring(e.length-b,e.length);return c?"-"+e:e}return String(e)};d.formatDuration=function(a,b,c,e,g,f){var h=d.intervals,k=f.decimalSeparator;if(a>=h[b].contains){var l=a-Math.floor(a/h[b].contains)*h[b].contains;"ss"==b?(l=d.formatNumber(l,f),1==l.split(k)[0].length&&(l="0"+l)):l=d.roundTo(l,f.precision);("mm"==b||"hh"==b)&&10>l&&(l="0"+l);c=l+""+e[b]+""+c;a=Math.floor(a/h[b].contains);b=h[b].nextInterval;return d.formatDuration(a,
b,c,e,g,f)}"ss"==b&&(a=d.formatNumber(a,f),1==a.split(k)[0].length&&(a="0"+a));"mm"==b&&(a=d.roundTo(a,f.precision));("mm"==b||"hh"==b)&&10>a&&(a="0"+a);c=a+""+e[b]+""+c;if(h[g].count>h[b].count)for(a=h[b].count;a<h[g].count;a++)b=h[b].nextInterval,"ss"==b||"mm"==b||"hh"==b?c="00"+e[b]+""+c:"DD"==b&&(c="0"+e[b]+""+c);":"==c.charAt(c.length-1)&&(c=c.substring(0,c.length-1));return c};d.formatNumber=function(a,b,c,e,g){a=d.roundTo(a,b.precision);isNaN(c)&&(c=b.precision);var f=b.decimalSeparator;b=
b.thousandsSeparator;void 0==f&&(f=",");void 0==b&&(b=" ");var h;h=0>a?"-":"";a=Math.abs(a);var k=String(a),l=!1;-1!=k.indexOf("e")&&(l=!0);0<=c&&!l&&(k=d.toFixed(a,c));var m="";if(l)m=k;else{var k=k.split("."),l=String(k[0]),n;for(n=l.length;0<=n;n-=3)m=n!=l.length?0!==n?l.substring(n-3,n)+b+m:l.substring(n-3,n)+m:l.substring(n-3,n);void 0!==k[1]&&(m=m+f+k[1]);void 0!==c&&0<c&&"0"!=m&&(m=d.addZeroes(m,f,c))}m=h+m;""===h&&!0===e&&0!==a&&(m="+"+m);!0===g&&(m+="%");return m};d.addZeroes=function(a,
b,c){a=a.split(b);void 0===a[1]&&0<c&&(a[1]="0");return a[1].length<c?(a[1]+="0",d.addZeroes(a[0]+b+a[1],b,c)):void 0!==a[1]?a[0]+b+a[1]:a[0]};d.scientificToNormal=function(a){var b;a=String(a).split("e");var c;if("-"==a[1].substr(0,1)){b="0.";for(c=0;c<Math.abs(Number(a[1]))-1;c++)b+="0";b+=a[0].split(".").join("")}else{var e=0;b=a[0].split(".");b[1]&&(e=b[1].length);b=a[0].split(".").join("");for(c=0;c<Math.abs(Number(a[1]))-e;c++)b+="0"}return b};d.toScientific=function(a,b){if(0===a)return"0";
var c=Math.floor(Math.log(Math.abs(a))*Math.LOG10E),e=String(e).split(".").join(b);return String(e)+"e"+c};d.randomColor=function(){return"#"+("00000"+(16777216*Math.random()<<0).toString(16)).substr(-6)};d.hitTest=function(a,b,c){var e=!1,g=a.x,f=a.x+a.width,h=a.y,k=a.y+a.height,l=d.isInRectangle;e||(e=l(g,h,b));e||(e=l(g,k,b));e||(e=l(f,h,b));e||(e=l(f,k,b));e||!0===c||(e=d.hitTest(b,a,!0));return e};d.isInRectangle=function(a,b,c){return a>=c.x-5&&a<=c.x+c.width+5&&b>=c.y-5&&b<=c.y+c.height+5?
!0:!1};d.isPercents=function(a){if(-1!=String(a).indexOf("%"))return!0};d.formatValue=function(a,b,c,e,g,f,h,k){if(b){void 0===g&&(g="");var l;for(l=0;l<c.length;l++){var m=c[l],n=b[m];void 0!==n&&(n=f?d.addPrefix(n,k,h,e):d.formatNumber(n,e),a=a.replace(new RegExp("\\[\\["+g+""+m+"\\]\\]","g"),n))}}return a};d.formatDataContextValue=function(a,b){if(a){var c=a.match(/\[\[.*?\]\]/g),e;for(e=0;e<c.length;e++){var d=c[e],d=d.substr(2,d.length-4);void 0!==b[d]&&(a=a.replace(new RegExp("\\[\\["+d+"\\]\\]",
"g"),b[d]))}}return a};d.massReplace=function(a,b){for(var c in b)if(b.hasOwnProperty(c)){var e=b[c];void 0===e&&(e="");a=a.replace(c,e)}return a};d.cleanFromEmpty=function(a){return a.replace(/\[\[[^\]]*\]\]/g,"")};d.addPrefix=function(a,b,c,e,g){var f=d.formatNumber(a,e),h="",k,l,m;if(0===a)return"0";0>a&&(h="-");a=Math.abs(a);if(1<a)for(k=b.length-1;-1<k;k--){if(a>=b[k].number&&(l=a/b[k].number,m=Number(e.precision),1>m&&(m=1),c=d.roundTo(l,m),m=d.formatNumber(c,{precision:-1,decimalSeparator:e.decimalSeparator,
thousandsSeparator:e.thousandsSeparator}),!g||l==c)){f=h+""+m+""+b[k].prefix;break}}else for(k=0;k<c.length;k++)if(a<=c[k].number){l=a/c[k].number;m=Math.abs(Math.floor(Math.log(l)*Math.LOG10E));l=d.roundTo(l,m);f=h+""+l+""+c[k].prefix;break}return f};d.remove=function(a){a&&a.remove()};d.getEffect=function(a){">"==a&&(a="easeOutSine");"<"==a&&(a="easeInSine");"elastic"==a&&(a="easeOutElastic");return a};d.getObjById=function(a,b){var c,e;for(e=0;e<a.length;e++){var d=a[e];if(d.id==b){c=d;break}}return c};
d.applyTheme=function(a,b,c){b||(b=d.theme);try{b=JSON.parse(JSON.stringify(b))}catch(e){}b&&b[c]&&d.extend(a,b[c])};d.isString=function(a){return"string"==typeof a?!0:!1};d.extend=function(a,b,c){var e;a||(a={});for(e in b)c?a.hasOwnProperty(e)||(a[e]=b[e]):a[e]=b[e];return a};d.copyProperties=function(a,b){for(var c in a)a.hasOwnProperty(c)&&"events"!=c&&void 0!==a[c]&&"function"!=typeof a[c]&&"cname"!=c&&(b[c]=a[c])};d.processObject=function(a,b,c,e){if(!1===a instanceof b&&(a=e?d.extend(new b(c),
a):d.extend(a,new b(c),!0),a.listeners))for(var g in a.listeners)b=a.listeners[g],a.addListener(b.event,b.method);return a};d.fixNewLines=function(a){var b=RegExp("\\n","g");a&&(a=a.replace(b,"<br />"));return a};d.fixBrakes=function(a){if(d.isModern){var b=RegExp("<br>","g");a&&(a=a.replace(b,"\n"))}else a=d.fixNewLines(a);return a};d.deleteObject=function(a,b){if(a){if(void 0===b||null===b)b=20;if(0!==b)if("[object Array]"===Object.prototype.toString.call(a))for(var c=0;c<a.length;c++)d.deleteObject(a[c],
b-1),a[c]=null;else if(a&&!a.tagName)try{for(c in a.theme=null,a)a[c]&&("object"==typeof a[c]&&d.deleteObject(a[c],b-1),"function"!=typeof a[c]&&(a[c]=null))}catch(e){}}};d.bounce=function(a,b,c,e,d){return(b/=d)<1/2.75?7.5625*e*b*b+c:b<2/2.75?e*(7.5625*(b-=1.5/2.75)*b+.75)+c:b<2.5/2.75?e*(7.5625*(b-=2.25/2.75)*b+.9375)+c:e*(7.5625*(b-=2.625/2.75)*b+.984375)+c};d.easeInOutQuad=function(a,b,c,e,d){b/=d/2;if(1>b)return e/2*b*b+c;b--;return-e/2*(b*(b-2)-1)+c};d.easeInSine=function(a,b,c,e,d){return-e*
Math.cos(b/d*(Math.PI/2))+e+c};d.easeOutSine=function(a,b,c,e,d){return e*Math.sin(b/d*(Math.PI/2))+c};d.easeOutElastic=function(a,b,c,e,d){a=1.70158;var f=0,h=e;if(0===b)return c;if(1==(b/=d))return c+e;f||(f=.3*d);h<Math.abs(e)?(h=e,a=f/4):a=f/(2*Math.PI)*Math.asin(e/h);return h*Math.pow(2,-10*b)*Math.sin(2*(b*d-a)*Math.PI/f)+e+c};d.fixStepE=function(a){a=a.toExponential(0).split("e");var b=Number(a[1]);9==Number(a[0])&&b++;return d.generateNumber(1,b)};d.generateNumber=function(a,b){var c="",e;
e=0>b?Math.abs(b)-1:Math.abs(b);var d;for(d=0;d<e;d++)c+="0";return 0>b?Number("0."+c+String(a)):Number(String(a)+c)};d.setCN=function(a,b,c,e){if(a.addClassNames&&b&&(b=b.node)&&c){var d=b.getAttribute("class");a=a.classNamePrefix+"-";e&&(a="");d?b.setAttribute("class",d+" "+a+c):b.setAttribute("class",a+c)}};d.removeCN=function(a,b,c){b&&(b=b.node)&&c&&(b=b.classList)&&b.remove(a.classNamePrefix+"-"+c)};d.parseDefs=function(a,b){for(var c in a){var e=typeof a[c];if(0<a[c].length&&"object"==e)for(var g=
0;g<a[c].length;g++)e=document.createElementNS(d.SVG_NS,c),b.appendChild(e),d.parseDefs(a[c][g],e);else"object"==e?(e=document.createElementNS(d.SVG_NS,c),b.appendChild(e),d.parseDefs(a[c],e)):b.setAttribute(c,a[c])}}})();(function(){var d=window.AmCharts;d.AxisBase=d.Class({construct:function(a){this.createEvents("clickItem","rollOverItem","rollOutItem","rollOverGuide","rollOutGuide","clickGuide");this.titleDY=this.y=this.x=this.dy=this.dx=0;this.axisThickness=1;this.axisColor="#000000";this.axisAlpha=1;this.gridCount=this.tickLength=5;this.gridAlpha=.15;this.gridThickness=1;this.gridColor="#000000";this.dashLength=0;this.labelFrequency=1;this.showLastLabel=this.showFirstLabel=!0;this.fillColor="#FFFFFF";this.fillAlpha=
0;this.labelsEnabled=!0;this.labelRotation=0;this.autoGridCount=!0;this.offset=0;this.guides=[];this.visible=!0;this.counter=0;this.guides=[];this.ignoreAxisWidth=this.inside=!1;this.minHorizontalGap=75;this.minVerticalGap=35;this.titleBold=!0;this.minorGridEnabled=!1;this.minorGridAlpha=.07;this.autoWrap=!1;this.titleAlign="middle";this.labelOffset=0;this.bcn="axis-";this.centerLabels=!1;this.firstDayOfWeek=1;this.centerLabelOnFullPeriod=this.markPeriodChange=this.boldPeriodBeginning=!0;this.titleWidth=
0;this.periods=[{period:"fff",count:1},{period:"fff",count:5},{period:"fff",count:10},{period:"fff",count:50},{period:"fff",count:100},{period:"fff",count:500},{period:"ss",count:1},{period:"ss",count:5},{period:"ss",count:10},{period:"ss",count:30},{period:"mm",count:1},{period:"mm",count:5},{period:"mm",count:10},{period:"mm",count:30},{period:"hh",count:1},{period:"hh",count:3},{period:"hh",count:6},{period:"hh",count:12},{period:"DD",count:1},{period:"DD",count:2},{period:"DD",count:3},{period:"DD",
count:4},{period:"DD",count:5},{period:"WW",count:1},{period:"MM",count:1},{period:"MM",count:2},{period:"MM",count:3},{period:"MM",count:6},{period:"YYYY",count:1},{period:"YYYY",count:2},{period:"YYYY",count:5},{period:"YYYY",count:10},{period:"YYYY",count:50},{period:"YYYY",count:100}];this.dateFormats=[{period:"fff",format:"NN:SS.QQQ"},{period:"ss",format:"JJ:NN:SS"},{period:"mm",format:"JJ:NN"},{period:"hh",format:"JJ:NN"},{period:"DD",format:"MMM DD"},{period:"WW",format:"MMM DD"},{period:"MM",
format:"MMM"},{period:"YYYY",format:"YYYY"}];this.nextPeriod={fff:"ss",ss:"mm",mm:"hh",hh:"DD",DD:"MM",MM:"YYYY"};d.applyTheme(this,a,"AxisBase")},zoom:function(a,b){this.start=a;this.end=b;this.dataChanged=!0;this.draw()},fixAxisPosition:function(){var a=this.position;"H"==this.orientation?("left"==a&&(a="bottom"),"right"==a&&(a="top")):("bottom"==a&&(a="left"),"top"==a&&(a="right"));this.position=a},init:function(){this.createBalloon()},draw:function(){var a=this.chart;this.prevBY=this.prevBX=NaN;
this.allLabels=[];this.counter=0;this.destroy();this.fixAxisPosition();this.setBalloonBounds();this.labels=[];var b=a.container,c=b.set();a.gridSet.push(c);this.set=c;b=b.set();a.axesLabelsSet.push(b);this.labelsSet=b;this.axisLine=new this.axisRenderer(this);this.autoGridCount?("V"==this.orientation?(a=this.height/this.minVerticalGap,3>a&&(a=3)):a=this.width/this.minHorizontalGap,this.gridCountR=Math.max(a,1)):this.gridCountR=this.gridCount;this.axisWidth=this.axisLine.axisWidth;this.addTitle()},
setOrientation:function(a){this.orientation=a?"H":"V"},addTitle:function(){var a=this.title;this.titleLabel=null;if(a){var b=this.chart,c=this.titleColor;void 0===c&&(c=b.color);var e=this.titleFontSize;isNaN(e)&&(e=b.fontSize+1);a=d.text(b.container,a,c,b.fontFamily,e,this.titleAlign,this.titleBold);d.setCN(b,a,this.bcn+"title");this.titleLabel=a}},positionTitle:function(){var a=this.titleLabel;if(a){var b,c,e=this.labelsSet,g={};0<e.length()?g=e.getBBox():(g.x=0,g.y=0,g.width=this.width,g.height=
this.height,d.VML&&(g.y+=this.y,g.x+=this.x));e.push(a);var e=g.x,f=g.y;d.VML&&(f-=this.y,e-=this.x);var h=g.width,g=g.height,k=this.width,l=this.height,m=0,n=a.getBBox().height/2,q=this.inside,p=this.titleAlign;switch(this.position){case "top":b="left"==p?-1:"right"==p?k:k/2;c=f-10-n;break;case "bottom":b="left"==p?-1:"right"==p?k:k/2;c=f+g+10+n;break;case "left":b=e-10-n;q&&(b-=5);m=-90;c=("left"==p?l+1:"right"==p?-1:l/2)+this.titleDY;this.titleWidth=n+10;break;case "right":b=e+h+10+n,q&&(b+=7),
c=("left"==p?l+2:"right"==p?-2:l/2)+this.titleDY,this.titleWidth=n+10,m=-90}this.marginsChanged?(a.translate(b,c),this.tx=b,this.ty=c):a.translate(this.tx,this.ty);this.marginsChanged=!1;isNaN(this.titleRotation)||(m=this.titleRotation);0!==m&&a.rotate(m)}},pushAxisItem:function(a,b){var c=this,e=a.graphics();0<e.length()&&(b?c.labelsSet.push(e):c.set.push(e));if(e=a.getLabel())c.labelsSet.push(e),e.click(function(b){c.handleMouse(b,a,"clickItem")}).touchend(function(b){c.handleMouse(b,a,"clickItem")}).mouseover(function(b){c.handleMouse(b,
a,"rollOverItem")}).mouseout(function(b){c.handleMouse(b,a,"rollOutItem")})},handleMouse:function(a,b,c){this.fire({type:c,value:b.value,serialDataItem:b.serialDataItem,axis:this,target:b.label,chart:this.chart,event:a})},addGuide:function(a){for(var b=this.guides,c=!1,e=b.length,g=0;g<b.length;g++)b[g]==a&&(c=!0,e=g);a=d.processObject(a,d.Guide,this.theme);a.id||(a.id="guideAuto"+e+"_"+(new Date).getTime());c||b.push(a)},removeGuide:function(a){var b=this.guides,c;for(c=0;c<b.length;c++)b[c]==a&&
b.splice(c,1)},handleGuideOver:function(a){clearTimeout(this.chart.hoverInt);var b={x:0,y:0,width:0,height:0};a.graphics&&(b=a.graphics.getBBox());var c=this.x+b.x+b.width/2,b=this.y+b.y+b.height/2,e=a.fillColor;void 0===e&&(e=a.lineColor);this.chart.showBalloon(a.balloonText,e,!0,c,b);this.fire({type:"rollOverGuide",guide:a,chart:this.chart})},handleGuideOut:function(a){this.chart.hideBalloon();this.fire({type:"rollOutGuide",guide:a,chart:this.chart})},handleGuideClick:function(a){this.chart.hideBalloon();
this.fire({type:"clickGuide",guide:a,chart:this.chart})},addEventListeners:function(a,b){var c=this;a.mouseover(function(){c.handleGuideOver(b)});a.mouseup(function(){c.handleGuideClick(b)});a.touchstart(function(){c.handleGuideOver(b)});a.mouseout(function(){c.handleGuideOut(b)})},getBBox:function(){var a;this.labelsSet&&(a=this.labelsSet.getBBox());a?d.VML||(a={x:a.x+this.x,y:a.y+this.y,width:a.width,height:a.height}):a={x:0,y:0,width:0,height:0};return a},destroy:function(){d.remove(this.set);
d.remove(this.labelsSet);var a=this.axisLine;a&&d.remove(a.axisSet);d.remove(this.grid0)},chooseMinorFrequency:function(a){for(var b=10;0<b;b--)if(a/b==Math.round(a/b))return a/b},parseDatesDraw:function(){var a,b=this.chart,c=this.showFirstLabel,e=this.showLastLabel,g,f="",h=d.extractPeriod(this.minPeriod),k=d.getPeriodDuration(h.period,h.count),l,m,n,q,p,t=this.firstDayOfWeek,r=this.boldPeriodBeginning;a=this.minorGridEnabled;var w,z=this.gridAlpha,x,u=this.choosePeriod(0),A=u.period,u=u.count,
y=d.getPeriodDuration(A,u);y<k&&(A=h.period,u=h.count,y=k);h=A;"WW"==h&&(h="DD");this.stepWidth=this.getStepWidth(this.timeDifference);var B=Math.ceil(this.timeDifference/y)+5,D=l=d.resetDateToMin(new Date(this.startTime-y),A,u,t).getTime();if(h==A&&1==u&&this.centerLabelOnFullPeriod||this.autoWrap||this.centerLabels)n=y*this.stepWidth,this.autoWrap&&!this.centerLabels&&(n=-n);this.cellWidth=k*this.stepWidth;q=Math.round(l/y);k=-1;q/2==Math.round(q/2)&&(k=-2,l-=y);q=this.firstTime;var C=0,I=0;a&&
1<u&&(w=this.chooseMinorFrequency(u),x=d.getPeriodDuration(A,w),"DD"==A&&(x+=d.getPeriodDuration("hh")),"fff"==A&&(x=1));if(0<this.gridCountR)for(B-5-k>this.autoRotateCount&&!isNaN(this.autoRotateAngle)&&(this.labelRotationR=this.autoRotateAngle),a=k;a<=B;a++){p=q+y*(a+Math.floor((D-q)/y))-C;"DD"==A&&(p+=36E5);p=d.resetDateToMin(new Date(p),A,u,t).getTime();"MM"==A&&(g=(p-l)/y,1.5<=(p-l)/y&&(p=p-(g-1)*y+d.getPeriodDuration("DD",3),p=d.resetDateToMin(new Date(p),A,1).getTime(),C+=y));g=(p-this.startTime)*
this.stepWidth;if("radar"==b.type){if(g=this.axisWidth-g,0>g||g>this.axisWidth)continue}else this.rotate?"date"==this.type&&"middle"==this.gridPosition&&(I=-y*this.stepWidth/2):"date"==this.type&&(g=this.axisWidth-g);f=!1;this.nextPeriod[h]&&(f=this.checkPeriodChange(this.nextPeriod[h],1,p,l,h));l=!1;f&&this.markPeriodChange?(f=this.dateFormatsObject[this.nextPeriod[h]],this.twoLineMode&&(f=this.dateFormatsObject[h]+"\n"+f,f=d.fixBrakes(f)),l=!0):f=this.dateFormatsObject[h];r||(l=!1);this.currentDateFormat=
f;f=d.formatDate(new Date(p),f,b);if(a==k&&!c||a==B&&!e)f=" ";this.labelFunction&&(f=this.labelFunction(f,new Date(p),this,A,u,m).toString());this.boldLabels&&(l=!0);m=new this.axisItemRenderer(this,g,f,!1,n,I,!1,l);this.pushAxisItem(m);m=l=p;if(!isNaN(w))for(g=1;g<u;g+=w)this.gridAlpha=this.minorGridAlpha,f=p+x*g,f=d.resetDateToMin(new Date(f),A,w,t).getTime(),f=new this.axisItemRenderer(this,(f-this.startTime)*this.stepWidth,void 0,void 0,void 0,void 0,void 0,void 0,void 0,!0),this.pushAxisItem(f);
this.gridAlpha=z}},choosePeriod:function(a){var b=d.getPeriodDuration(this.periods[a].period,this.periods[a].count),c=this.periods;return this.timeDifference<b&&0<a?c[a-1]:Math.ceil(this.timeDifference/b)<=this.gridCountR?c[a]:a+1<c.length?this.choosePeriod(a+1):c[a]},getStepWidth:function(a){var b;this.startOnAxis?(b=this.axisWidth/(a-1),1==a&&(b=this.axisWidth)):b=this.axisWidth/a;return b},timeZoom:function(a,b){this.startTime=a;this.endTime=b},minDuration:function(){var a=d.extractPeriod(this.minPeriod);
return d.getPeriodDuration(a.period,a.count)},checkPeriodChange:function(a,b,c,e,g){c=new Date(c);var f=new Date(e),h=this.firstDayOfWeek;e=b;"DD"==a&&(b=1);c=d.resetDateToMin(c,a,b,h).getTime();b=d.resetDateToMin(f,a,b,h).getTime();return"DD"==a&&"hh"!=g&&c-b<d.getPeriodDuration(a,e)-d.getPeriodDuration("hh",1)?!1:c!=b?!0:!1},generateDFObject:function(){this.dateFormatsObject={};var a;for(a=0;a<this.dateFormats.length;a++){var b=this.dateFormats[a];this.dateFormatsObject[b.period]=b.format}},hideBalloon:function(){this.balloon&&
this.balloon.hide&&this.balloon.hide();this.prevBY=this.prevBX=NaN},formatBalloonText:function(a){return a},showBalloon:function(a,b,c,e){var d=this.offset;switch(this.position){case "bottom":b=this.height+d;break;case "top":b=-d;break;case "left":a=-d;break;case "right":a=this.width+d}c||(c=this.currentDateFormat);if("V"==this.orientation){if(0>b||b>this.height)return;if(isNaN(b)){this.hideBalloon();return}b=this.adjustBalloonCoordinate(b,e);e=this.coordinateToValue(b)}else{if(0>a||a>this.width)return;
if(isNaN(a)){this.hideBalloon();return}a=this.adjustBalloonCoordinate(a,e);e=this.coordinateToValue(a)}var f;if(d=this.chart.chartCursor)f=d.index;if(this.balloon&&void 0!==e&&this.balloon.enabled){if(this.balloonTextFunction){if("date"==this.type||!0===this.parseDates)e=new Date(e);e=this.balloonTextFunction(e)}else this.balloonText?e=this.formatBalloonText(this.balloonText,f,c):isNaN(e)||(e=this.formatValue(e,c));if(a!=this.prevBX||b!=this.prevBY)this.balloon.setPosition(a,b),this.prevBX=a,this.prevBY=
b,e&&this.balloon.showBalloon(e)}},adjustBalloonCoordinate:function(a){return a},createBalloon:function(){var a=this.chart,b=a.chartCursor;b&&(b=b.cursorPosition,"mouse"!=b&&(this.stickBalloonToCategory=!0),"start"==b&&(this.stickBalloonToStart=!0),"ValueAxis"==this.cname&&(this.stickBalloonToCategory=!1));this.balloon&&(this.balloon.destroy&&this.balloon.destroy(),d.extend(this.balloon,a.balloon,!0))},setBalloonBounds:function(){var a=this.balloon;if(a){var b=this.chart;a.cornerRadius=0;a.shadowAlpha=
0;a.borderThickness=1;a.borderAlpha=1;a.adjustBorderColor=!1;a.showBullet=!1;this.balloon=a;a.chart=b;a.mainSet=b.plotBalloonsSet;a.pointerWidth=this.tickLength;if(this.parseDates||"date"==this.type)a.pointerWidth=0;a.className=this.id;b="V";"V"==this.orientation&&(b="H");this.stickBalloonToCategory||(a.animationDuration=0);var c,e,d,f,h=this.inside,k=this.width,l=this.height;switch(this.position){case "bottom":c=0;e=k;h?(d=0,f=l):(d=l,f=l+1E3);break;case "top":c=0;e=k;h?(d=0,f=l):(d=-1E3,f=0);break;
case "left":d=0;f=l;h?(c=0,e=k):(c=-1E3,e=0);break;case "right":d=0,f=l,h?(c=0,e=k):(c=k,e=k+1E3)}a.drop||(a.pointerOrientation=b);a.setBounds(c,d,e,f)}}})})();(function(){var d=window.AmCharts;d.ValueAxis=d.Class({inherits:d.AxisBase,construct:function(a){this.cname="ValueAxis";this.createEvents("axisChanged","logarithmicAxisFailed","axisZoomed","axisIntZoomed");d.ValueAxis.base.construct.call(this,a);this.dataChanged=!0;this.stackType="none";this.position="left";this.unitPosition="right";this.includeAllValues=this.recalculateToPercents=this.includeHidden=this.includeGuidesInMinMax=this.integersOnly=!1;this.durationUnits={DD:"d. ",hh:":",mm:":",ss:""};
this.scrollbar=!1;this.baseValue=0;this.radarCategoriesEnabled=!0;this.axisFrequency=1;this.gridType="polygons";this.useScientificNotation=!1;this.axisTitleOffset=10;this.pointPosition="axis";this.minMaxMultiplier=1;this.logGridLimit=2;this.totalTextOffset=this.treatZeroAs=0;this.minPeriod="ss";this.relativeStart=0;this.relativeEnd=1;d.applyTheme(this,a,this.cname)},updateData:function(){0>=this.gridCountR&&(this.gridCountR=1);this.totals=[];this.data=this.chart.chartData;var a=this.chart;"xy"!=a.type&&
(this.stackGraphs("smoothedLine"),this.stackGraphs("line"),this.stackGraphs("column"),this.stackGraphs("step"));this.recalculateToPercents&&this.recalculate();if(this.synchronizationMultiplier&&this.synchronizeWith)d.isString(this.synchronizeWith)&&(this.synchronizeWith=a.getValueAxisById(this.synchronizeWith)),this.synchronizeWith&&(this.synchronizeWithAxis(this.synchronizeWith),this.foundGraphs=!0);else if(this.foundGraphs=!1,this.getMinMax(),0===this.start&&this.end==this.data.length-1&&isNaN(this.minZoom)&&
isNaN(this.maxZoom)||isNaN(this.fullMin)&&isNaN(this.fullMax))this.fullMin=this.min,this.fullMax=this.max,"date"!=this.type&&this.strictMinMax&&(isNaN(this.minimum)||(this.fullMin=this.minimum),isNaN(this.maximum)||(this.fullMax=this.maximum)),this.logarithmic&&(this.fullMin=this.logMin,0===this.fullMin&&(this.fullMin=this.treatZeroAs)),"date"==this.type&&(this.minimumDate||(this.fullMin=this.minRR),this.maximumDate||(this.fullMax=this.maxRR),this.strictMinMax&&(this.minimumDate&&(this.fullMin=this.minimumDate.getTime()),
this.maximumDate&&(this.fullMax=this.maximumDate.getTime())))},draw:function(){d.ValueAxis.base.draw.call(this);var a=this.chart,b=this.set;this.labelRotationR=this.labelRotation;d.setCN(a,this.set,"value-axis value-axis-"+this.id);d.setCN(a,this.labelsSet,"value-axis value-axis-"+this.id);d.setCN(a,this.axisLine.axisSet,"value-axis value-axis-"+this.id);var c=this.type;"duration"==c&&(this.duration="ss");!0===this.dataChanged&&(this.updateData(),this.dataChanged=!1);"date"==c&&(this.logarithmic=
!1,this.min=this.minRR,this.max=this.maxRR,this.reversed=!1,this.getDateMinMax());if(this.logarithmic){var e=this.treatZeroAs,g=this.getExtremes(0,this.data.length-1).min;!isNaN(this.minimum)&&this.minimum<g&&(g=this.minimum);this.logMin=g;this.minReal<g&&(this.minReal=g);isNaN(this.minReal)&&(this.minReal=g);0<e&&0===g&&(this.minReal=g=e);if(0>=g||0>=this.minimum){this.fire({type:"logarithmicAxisFailed",chart:a});return}}this.grid0=null;var f,h,k=a.dx,l=a.dy,e=!1,g=this.logarithmic;if(isNaN(this.min)||
isNaN(this.max)||!this.foundGraphs||Infinity==this.min||-Infinity==this.max)e=!0;else{"date"==this.type&&this.min==this.max&&(this.max+=this.minDuration(),this.min-=this.minDuration());var m=this.labelFrequency,n=this.showFirstLabel,q=this.showLastLabel,p=1,t=0;this.minCalc=this.min;this.maxCalc=this.max;if(this.strictMinMax&&(isNaN(this.minimum)||(this.min=this.minimum),isNaN(this.maximum)||(this.max=this.maximum),this.min==this.max))return;isNaN(this.minZoom)||(this.minReal=this.min=this.minZoom);
isNaN(this.maxZoom)||(this.max=this.maxZoom);if(this.logarithmic){h=this.fullMin;var r=this.fullMax;isNaN(this.minimum)||(h=this.minimum);isNaN(this.maximum)||(r=this.maximum);var r=Math.log(r)*Math.LOG10E-Math.log(h)*Math.LOG10E,w=Math.log(this.max)/Math.LN10-Math.log(h)*Math.LOG10E;this.relativeStart=d.roundTo((Math.log(this.minReal)/Math.LN10-Math.log(h)*Math.LOG10E)/r,5);this.relativeEnd=d.roundTo(w/r,5)}else this.relativeStart=d.roundTo(d.fitToBounds((this.min-this.fullMin)/(this.fullMax-this.fullMin),
0,1),5),this.relativeEnd=d.roundTo(d.fitToBounds((this.max-this.fullMin)/(this.fullMax-this.fullMin),0,1),5);var r=Math.round((this.maxCalc-this.minCalc)/this.step)+1,z;!0===g?(z=Math.log(this.max)*Math.LOG10E-Math.log(this.minReal)*Math.LOG10E,this.stepWidth=this.axisWidth/z,z>this.logGridLimit&&(r=Math.ceil(Math.log(this.max)*Math.LOG10E)+1,t=Math.round(Math.log(this.minReal)*Math.LOG10E),r>this.gridCountR&&(p=Math.ceil(r/this.gridCountR)))):this.stepWidth=this.axisWidth/(this.max-this.min);var x=
0;1>this.step&&-1<this.step&&(x=d.getDecimals(this.step));this.integersOnly&&(x=0);x>this.maxDecCount&&(x=this.maxDecCount);w=this.precision;isNaN(w)||(x=w);isNaN(this.maxZoom)&&(this.max=d.roundTo(this.max,this.maxDecCount),this.min=d.roundTo(this.min,this.maxDecCount));h={};h.precision=x;h.decimalSeparator=a.nf.decimalSeparator;h.thousandsSeparator=a.nf.thousandsSeparator;this.numberFormatter=h;var u;this.exponential=!1;for(h=t;h<r;h+=p){var A=d.roundTo(this.step*h+this.min,x);-1!=String(A).indexOf("e")&&
(this.exponential=!0)}this.duration&&(this.maxInterval=d.getMaxInterval(this.max,this.duration));var x=this.step,y,A=this.minorGridAlpha;this.minorGridEnabled&&(y=this.getMinorGridStep(x,this.stepWidth*x));if(this.autoGridCount||0!==this.gridCount)if("date"==c)this.generateDFObject(),this.timeDifference=this.max-this.min,this.maxTime=this.lastTime=this.max,this.startTime=this.firstTime=this.min,this.parseDatesDraw();else for(r>=this.autoRotateCount&&!isNaN(this.autoRotateAngle)&&(this.labelRotationR=
this.autoRotateAngle),c=this.minCalc,g&&(r++,c=this.maxCalc-r*x),this.gridCountReal=r,h=this.startCount=t;h<r;h+=p)if(t=x*h+c,t=d.roundTo(t,this.maxDecCount+1),!this.integersOnly||Math.round(t)==t)if(isNaN(w)||Number(d.toFixed(t,w))==t){if(!0===g)if(z>this.logGridLimit){if(t=Math.pow(10,h),t>this.max)continue}else if(0>=t&&(t=c+x*h+x/2,0>=t))continue;u=this.formatValue(t,!1,h);Math.round(h/m)!=h/m&&(u=void 0);if(0===h&&!n||h==r-1&&!q)u=" ";f=this.getCoordinate(t);var B;this.rotate&&this.autoWrap&&
(B=this.stepWidth*x-10);u=new this.axisItemRenderer(this,f,u,void 0,B,void 0,void 0,this.boldLabels);this.pushAxisItem(u);if(t==this.baseValue&&"radar"!=a.type){var D,C,I=this.width,H=this.height;"H"==this.orientation?0<=f&&f<=I+1&&(D=[f,f,f+k],C=[H,0,l]):0<=f&&f<=H+1&&(D=[0,I,I+k],C=[f,f,f+l]);D&&(f=d.fitToBounds(2*this.gridAlpha,0,1),isNaN(this.zeroGridAlpha)||(f=this.zeroGridAlpha),f=d.line(a.container,D,C,this.gridColor,f,1,this.dashLength),f.translate(this.x,this.y),this.grid0=f,a.axesSet.push(f),
f.toBack(),d.setCN(a,f,this.bcn+"zero-grid-"+this.id),d.setCN(a,f,this.bcn+"zero-grid"))}if(!isNaN(y)&&0<A&&h<r-1){f=x/y;g&&(y=x*(h+p)+this.minCalc,y=d.roundTo(y,this.maxDecCount+1),z>this.logGridLimit&&(y=Math.pow(10,h+p)),f=9,y=(y-t)/f);I=this.gridAlpha;this.gridAlpha=this.minorGridAlpha;for(H=1;H<f;H++){var Q=this.getCoordinate(t+y*H),Q=new this.axisItemRenderer(this,Q,"",!1,0,0,!1,!1,0,!0);this.pushAxisItem(Q)}this.gridAlpha=I}}z=this.guides;B=z.length;if(0<B){D=this.fillAlpha;for(h=this.fillAlpha=
0;h<B;h++)C=z[h],k=NaN,y=C.above,isNaN(C.toValue)||(k=this.getCoordinate(C.toValue),u=new this.axisItemRenderer(this,k,"",!0,NaN,NaN,C),this.pushAxisItem(u,y)),l=NaN,isNaN(C.value)||(l=this.getCoordinate(C.value),u=new this.axisItemRenderer(this,l,C.label,!0,NaN,(k-l)/2,C),this.pushAxisItem(u,y)),isNaN(k)&&(l-=3,k=l+3),u&&(m=u.label)&&this.addEventListeners(m,C),isNaN(k-l)||0>l&&0>k||(k=new this.guideFillRenderer(this,l,k,C),this.pushAxisItem(k,y),y=k.graphics(),C.graphics=y,this.addEventListeners(y,
C));this.fillAlpha=D}u=this.baseValue;this.min>this.baseValue&&this.max>this.baseValue&&(u=this.min);this.min<this.baseValue&&this.max<this.baseValue&&(u=this.max);g&&u<this.minReal&&(u=this.minReal);this.baseCoord=this.getCoordinate(u,!0);u={type:"axisChanged",target:this,chart:a};u.min=g?this.minReal:this.min;u.max=this.max;this.fire(u);this.axisCreated=!0}g=this.axisLine.set;u=this.labelsSet;b.translate(this.x,this.y);u.translate(this.x,this.y);this.positionTitle();"radar"!=a.type&&g.toFront();
!this.visible||e?(b.hide(),g.hide(),u.hide()):(b.show(),g.show(),u.show());this.axisY=this.y;this.axisX=this.x},getDateMinMax:function(){this.minimumDate&&(this.minimumDate instanceof Date||(this.minimumDate=d.getDate(this.minimumDate,this.chart.dataDateFormat,"fff")),this.min=this.minimumDate.getTime());this.maximumDate&&(this.maximumDate instanceof Date||(this.maximumDate=d.getDate(this.maximumDate,this.chart.dataDateFormat,"fff")),this.max=this.maximumDate.getTime())},formatValue:function(a,b,
c){var e=this.exponential,g=this.logarithmic,f=this.numberFormatter,h=this.chart;if(f)return!0===this.logarithmic&&(e=-1!=String(a).indexOf("e")?!0:!1),this.useScientificNotation&&(e=!0),this.usePrefixes&&(e=!1),e?(c=-1==String(a).indexOf("e")?a.toExponential(15):String(a),e=c.split("e"),c=Number(e[0]),e=Number(e[1]),c=d.roundTo(c,14),b||isNaN(this.precision)||(c=d.roundTo(c,this.precision)),10==c&&(c=1,e+=1),c=c+"e"+e,0===a&&(c="0"),1==a&&(c="1")):(g&&(e=String(a).split("."),e[1]?(f.precision=e[1].length,
0>c&&(f.precision=Math.abs(c)),b&&1<a&&(f.precision=0),b||isNaN(this.precision)||(f.precision=this.precision)):f.precision=-1),c=this.usePrefixes?d.addPrefix(a,h.prefixesOfBigNumbers,h.prefixesOfSmallNumbers,f,!b):d.formatNumber(a,f,f.precision)),this.duration&&(b&&(f.precision=0),c=d.formatDuration(a,this.duration,"",this.durationUnits,this.maxInterval,f)),"date"==this.type&&(c=d.formatDate(new Date(a),this.currentDateFormat,h)),this.recalculateToPercents?c+="%":(b=this.unit)&&(c="left"==this.unitPosition?
b+c:c+b),this.labelFunction&&(c="date"==this.type?this.labelFunction(c,new Date(a),this).toString():this.labelFunction(a,c,this).toString()),c},getMinorGridStep:function(a,b){var c=[5,4,2];60>b&&c.shift();for(var e=Math.floor(Math.log(Math.abs(a))*Math.LOG10E),d=0;d<c.length;d++){var f=a/c[d],h=Math.floor(Math.log(Math.abs(f))*Math.LOG10E);if(!(1<Math.abs(e-h)))if(1>a){if(h=Math.pow(10,-h)*f,h==Math.round(h))return f}else if(f==Math.round(f))return f}return 1},stackGraphs:function(a){var b=this.stackType;
"stacked"==b&&(b="regular");"line"==b&&(b="none");"100% stacked"==b&&(b="100%");this.stackType=b;var c=[],e=[],g=[],f=[],h,k=this.chart.graphs,l,m,n,q,p,t=this.baseValue,r=!1;if("line"==a||"step"==a||"smoothedLine"==a)r=!0;if(r&&("regular"==b||"100%"==b))for(q=0;q<k.length;q++)n=k[q],n.stackGraph=null,n.hidden||(m=n.type,n.chart==this.chart&&n.valueAxis==this&&a==m&&n.stackable&&(l&&(n.stackGraph=l),l=n));n=this.start-10;l=this.end+10;q=this.data.length-1;n=d.fitToBounds(n,0,q);l=d.fitToBounds(l,
0,q);for(p=n;p<=l;p++){var w=0;for(q=0;q<k.length;q++)if(n=k[q],n.hidden)n.newStack&&(g[p]=NaN,e[p]=NaN);else if(m=n.type,n.chart==this.chart&&n.valueAxis==this&&a==m&&n.stackable)if(m=this.data[p].axes[this.id].graphs[n.id],h=m.values.value,isNaN(h))n.newStack&&(g[p]=NaN,e[p]=NaN);else{var z=d.getDecimals(h);w<z&&(w=z);isNaN(f[p])?f[p]=Math.abs(h):f[p]+=Math.abs(h);f[p]=d.roundTo(f[p],w);z=n.fillToGraph;r&&z&&(z=this.data[p].axes[this.id].graphs[z.id])&&(m.values.open=z.values.value);"regular"==
b&&(r&&(isNaN(c[p])?(c[p]=h,m.values.close=h,m.values.open=this.baseValue):(isNaN(h)?m.values.close=c[p]:m.values.close=h+c[p],m.values.open=c[p],c[p]=m.values.close)),"column"==a&&(n.newStack&&(g[p]=NaN,e[p]=NaN),m.values.close=h,0>h?(m.values.close=h,isNaN(e[p])?m.values.open=t:(m.values.close+=e[p],m.values.open=e[p]),e[p]=m.values.close):(m.values.close=h,isNaN(g[p])?m.values.open=t:(m.values.close+=g[p],m.values.open=g[p]),g[p]=m.values.close)))}}for(p=this.start;p<=this.end;p++)for(q=0;q<k.length;q++)(n=
k[q],n.hidden)?n.newStack&&(g[p]=NaN,e[p]=NaN):(m=n.type,n.chart==this.chart&&n.valueAxis==this&&a==m&&n.stackable&&(m=this.data[p].axes[this.id].graphs[n.id],h=m.values.value,isNaN(h)||(c=h/f[p]*100,m.values.percents=c,m.values.total=f[p],n.newStack&&(g[p]=NaN,e[p]=NaN),"100%"==b&&(isNaN(e[p])&&(e[p]=0),isNaN(g[p])&&(g[p]=0),0>c?(m.values.close=d.fitToBounds(c+e[p],-100,100),m.values.open=e[p],e[p]=m.values.close):(m.values.close=d.fitToBounds(c+g[p],-100,100),m.values.open=g[p],g[p]=m.values.close)))))},
recalculate:function(){var a=this.chart,b=a.graphs,c;for(c=0;c<b.length;c++){var e=b[c];if(e.valueAxis==this){var g="value";if("candlestick"==e.type||"ohlc"==e.type)g="open";var f,h,k=this.end+2,k=d.fitToBounds(this.end+1,0,this.data.length-1),l=this.start;0<l&&l--;var m;h=this.start;e.compareFromStart&&(h=0);if(!isNaN(a.startTime)&&(m=a.categoryAxis)){var n=m.minDuration(),n=new Date(a.startTime+n/2),q=d.resetDateToMin(new Date(a.startTime),m.minPeriod).getTime();d.resetDateToMin(new Date(n),m.minPeriod).getTime()>
q&&h++}if(m=a.recalculateFromDate)m=d.getDate(m,a.dataDateFormat,"fff"),h=a.getClosestIndex(a.chartData,"time",m.getTime(),!0,0,a.chartData.length),k=a.chartData.length-1;for(m=h;m<=k&&(h=this.data[m].axes[this.id].graphs[e.id],f=h.values[g],e.recalculateValue&&(f=h.dataContext[e.valueField+e.recalculateValue]),isNaN(f));m++);this.recBaseValue=f;for(g=l;g<=k;g++){h=this.data[g].axes[this.id].graphs[e.id];h.percents={};var l=h.values,p;for(p in l)h.percents[p]="percents"!=p?l[p]/f*100-100:l[p]}}}},
getMinMax:function(){var a=!1,b=this.chart,c=b.graphs,e;for(e=0;e<c.length;e++){var g=c[e].type;("line"==g||"step"==g||"smoothedLine"==g)&&this.expandMinMax&&(a=!0)}a&&(0<this.start&&this.start--,this.end<this.data.length-1&&this.end++);"serial"==b.type&&(!0!==b.categoryAxis.parseDates||a||this.end<this.data.length-1&&this.end++);this.includeAllValues&&(this.start=0,this.end=this.data.length-1);a=this.minMaxMultiplier;b=this.getExtremes(this.start,this.end);this.min=b.min;this.max=b.max;this.minRR=
this.min;this.maxRR=this.max;a=(this.max-this.min)*(a-1);this.min-=a;this.max+=a;a=this.guides.length;if(this.includeGuidesInMinMax&&0<a)for(b=0;b<a;b++)c=this.guides[b],c.toValue<this.min&&(this.min=c.toValue),c.value<this.min&&(this.min=c.value),c.toValue>this.max&&(this.max=c.toValue),c.value>this.max&&(this.max=c.value);isNaN(this.minimum)||(this.min=this.minimum);isNaN(this.maximum)||(this.max=this.maximum);"date"==this.type&&this.getDateMinMax();this.min>this.max&&(a=this.max,this.max=this.min,
this.min=a);isNaN(this.minZoom)||(this.min=this.minZoom);isNaN(this.maxZoom)||(this.max=this.maxZoom);this.minCalc=this.min;this.maxCalc=this.max;this.minReal=this.min;this.maxReal=this.max;0===this.min&&0===this.max&&(this.max=9);this.min>this.max&&(this.min=this.max-1);a=this.min;b=this.max;c=this.max-this.min;e=0===c?Math.pow(10,Math.floor(Math.log(Math.abs(this.max))*Math.LOG10E))/10:Math.pow(10,Math.floor(Math.log(Math.abs(c))*Math.LOG10E))/10;isNaN(this.maximum)&&(this.max=Math.ceil(this.max/
e)*e+e);isNaN(this.minimum)&&(this.min=Math.floor(this.min/e)*e-e);0>this.min&&0<=a&&(this.min=0);0<this.max&&0>=b&&(this.max=0);"100%"==this.stackType&&(this.min=0>this.min?-100:0,this.max=0>this.max?0:100);c=this.max-this.min;e=Math.pow(10,Math.floor(Math.log(Math.abs(c))*Math.LOG10E))/10;this.step=Math.ceil(c/this.gridCountR/e)*e;c=Math.pow(10,Math.floor(Math.log(Math.abs(this.step))*Math.LOG10E));c=d.fixStepE(c);e=Math.ceil(this.step/c);5<e&&(e=10);5>=e&&2<e&&(e=5);this.step=Math.ceil(this.step/
(c*e))*c*e;isNaN(this.setStep)||(this.step=this.setStep);1>c?(this.maxDecCount=Math.abs(Math.log(Math.abs(c))*Math.LOG10E),this.maxDecCount=Math.round(this.maxDecCount),this.step=d.roundTo(this.step,this.maxDecCount+1)):this.maxDecCount=0;this.min=this.step*Math.floor(this.min/this.step);this.max=this.step*Math.ceil(this.max/this.step);0>this.min&&0<=a&&(this.min=0);0<this.max&&0>=b&&(this.max=0);1<this.minReal&&1<this.max-this.minReal&&(this.minReal=Math.floor(this.minReal));c=Math.pow(10,Math.floor(Math.log(Math.abs(this.minReal))*
Math.LOG10E));0===this.min&&(this.minReal=c);0===this.min&&1<this.minReal&&(this.minReal=1);0<this.min&&0<this.minReal-this.step&&(this.minReal=this.min+this.step<this.minReal?this.min+this.step:this.min);this.logarithmic&&(2<Math.log(b)*Math.LOG10E-Math.log(a)*Math.LOG10E?(this.minReal=this.min=Math.pow(10,Math.floor(Math.log(Math.abs(a))*Math.LOG10E)),this.maxReal=this.max=Math.pow(10,Math.ceil(Math.log(Math.abs(b))*Math.LOG10E))):(a=Math.pow(10,Math.floor(Math.log(Math.abs(a))*Math.LOG10E))/10,
Math.pow(10,Math.floor(Math.log(Math.abs(this.min))*Math.LOG10E))/10<a&&(this.minReal=this.min=10*a)))},getExtremes:function(a,b){var c,e,d;for(d=a;d<=b;d++){var f=this.data[d].axes[this.id].graphs,h;for(h in f)if(f.hasOwnProperty(h)){var k=this.chart.graphsById[h];if(k.includeInMinMax&&(!k.hidden||this.includeHidden)){isNaN(c)&&(c=Infinity);isNaN(e)&&(e=-Infinity);this.foundGraphs=!0;k=f[h].values;this.recalculateToPercents&&(k=f[h].percents);var l;if(this.minMaxField)l=k[this.minMaxField],l<c&&
(c=l),l>e&&(e=l);else for(var m in k)k.hasOwnProperty(m)&&"percents"!=m&&"total"!=m&&"error"!=m&&(l=k[m],l<c&&(c=l),l>e&&(e=l))}}}return{min:c,max:e}},zoomOut:function(a){this.maxZoom=this.minZoom=NaN;this.zoomToRelativeValues(0,1,a)},zoomToRelativeValues:function(a,b,c){if(this.reversed){var e=a;a=1-b;b=1-e}var d=this.fullMax,e=this.fullMin,f=e+(d-e)*a,h=e+(d-e)*b;0<=this.minimum&&0>f&&(f=0);this.logarithmic&&(isNaN(this.minimum)||(e=this.minimum),isNaN(this.maximum)||(d=this.maximum),d=Math.log(d)*
Math.LOG10E-Math.log(e)*Math.LOG10E,f=Math.pow(10,d*a+Math.log(e)*Math.LOG10E),h=Math.pow(10,d*b+Math.log(e)*Math.LOG10E));return this.zoomToValues(f,h,c)},zoomToValues:function(a,b,c){if(b<a){var e=b;b=a;a=e}var g=this.fullMax,e=this.fullMin;this.relativeStart=d.roundTo((a-e)/(g-e),9);this.relativeEnd=d.roundTo((b-e)/(g-e),9);if(this.logarithmic){isNaN(this.minimum)||(e=this.minimum);isNaN(this.maximum)||(g=this.maximum);var g=Math.log(g)*Math.LOG10E-Math.log(e)*Math.LOG10E,f=Math.log(b)/Math.LN10-
Math.log(e)*Math.LOG10E;this.relativeStart=d.roundTo((Math.log(a)/Math.LN10-Math.log(e)*Math.LOG10E)/g,9);this.relativeEnd=d.roundTo(f/g,9)}if(this.minZoom!=a||this.maxZoom!=b)return this.minZoom=a,this.maxZoom=b,e={type:"axisZoomed"},e.chart=this.chart,e.valueAxis=this,e.startValue=a,e.endValue=b,e.relativeStart=this.relativeStart,e.relativeEnd=this.relativeEnd,this.prevStartValue==a&&this.prevEndValue==b||this.fire(e),this.prevStartValue=a,this.prevEndValue=b,c||(a={},d.copyProperties(e,a),a.type=
"axisIntZoomed",this.fire(a)),0===this.relativeStart&&1==this.relativeEnd&&(this.maxZoom=this.minZoom=NaN),!0},coordinateToValue:function(a){if(isNaN(a))return NaN;var b=this.axisWidth,c=this.stepWidth,e=this.reversed,d=this.rotate,f=this.min,h=this.minReal;return!0===this.logarithmic?Math.pow(10,(d?!0===e?(b-a)/c:a/c:!0===e?a/c:(b-a)/c)+Math.log(h)*Math.LOG10E):!0===e?d?f-(a-b)/c:a/c+f:d?a/c+f:f-(a-b)/c},getCoordinate:function(a,b){if(isNaN(a))return NaN;var c=this.rotate,e=this.reversed,d=this.axisWidth,
f=this.stepWidth,h=this.min,k=this.minReal;!0===this.logarithmic?(0===a&&(a=this.treatZeroAs),h=Math.log(a)*Math.LOG10E-Math.log(k)*Math.LOG10E,c=c?!0===e?d-f*h:f*h:!0===e?f*h:d-f*h):c=!0===e?c?d-f*(a-h):f*(a-h):c?f*(a-h):d-f*(a-h);1E7<Math.abs(c)&&(c=c/Math.abs(c)*1E7);b||(c=Math.round(c));return c},synchronizeWithAxis:function(a){this.synchronizeWith=a;this.listenTo(this.synchronizeWith,"axisChanged",this.handleSynchronization)},handleSynchronization:function(){if(this.synchronizeWith){d.isString(this.synchronizeWith)&&
(this.synchronizeWith=this.chart.getValueAxisById(this.synchronizeWith));var a=this.synchronizeWith,b=a.min,c=a.max,a=a.step,e=this.synchronizationMultiplier;e&&(this.min=b*e,this.max=c*e,this.step=a*e,b=Math.abs(Math.log(Math.abs(Math.pow(10,Math.floor(Math.log(Math.abs(this.step))*Math.LOG10E))))*Math.LOG10E),this.maxDecCount=b=Math.round(b),this.draw())}}})})();(function(){var d=window.AmCharts;d.RecAxis=d.Class({construct:function(a){var b=a.chart,c=a.axisThickness,e=a.axisColor,g=a.axisAlpha,f=a.offset,h=a.dx,k=a.dy,l=a.x,m=a.y,n=a.height,q=a.width,p=b.container;"H"==a.orientation?(e=d.line(p,[0,q],[0,0],e,g,c),this.axisWidth=a.width,"bottom"==a.position?(k=c/2+f+n+m-1,c=l):(k=-c/2-f+m+k,c=h+l)):(this.axisWidth=a.height,"right"==a.position?(e=d.line(p,[0,0,-h],[0,n,n-k],e,g,c),k=m+k,c=c/2+f+h+q+l-1):(e=d.line(p,[0,0],[0,n],e,g,c),k=m,c=-c/2-f+l));e.translate(c,
k);c=b.container.set();c.push(e);b.axesSet.push(c);d.setCN(b,e,a.bcn+"line");this.axisSet=c;this.set=e}})})();(function(){var d=window.AmCharts;d.RecItem=d.Class({construct:function(a,b,c,e,g,f,h,k,l,m,n,q){b=Math.round(b);var p=a.chart;this.value=c;void 0==c&&(c="");l||(l=0);void 0==e&&(e=!0);var t=p.fontFamily,r=a.fontSize;void 0==r&&(r=p.fontSize);var w=a.color;void 0==w&&(w=p.color);void 0!==n&&(w=n);var z=a.chart.container,x=z.set();this.set=x;var u=a.axisThickness,A=a.axisColor,y=a.axisAlpha,B=a.tickLength,D=a.gridAlpha,C=a.gridThickness,I=a.gridColor,H=a.dashLength,Q=a.fillColor,M=a.fillAlpha,P=a.labelsEnabled;
n=a.labelRotationR;var ia=a.counter,J=a.inside,aa=a.labelOffset,ma=a.dx,na=a.dy,Pa=a.orientation,Z=a.position,da=a.previousCoord,X=a.height,xa=a.width,ea=a.offset,fa,Ba;h?(void 0!==h.id&&(q=p.classNamePrefix+"-guide-"+h.id),P=!0,isNaN(h.tickLength)||(B=h.tickLength),void 0!=h.lineColor&&(I=h.lineColor),void 0!=h.color&&(w=h.color),isNaN(h.lineAlpha)||(D=h.lineAlpha),isNaN(h.dashLength)||(H=h.dashLength),isNaN(h.lineThickness)||(C=h.lineThickness),!0===h.inside&&(J=!0,0<ea&&(ea=0)),isNaN(h.labelRotation)||
(n=h.labelRotation),isNaN(h.fontSize)||(r=h.fontSize),h.position&&(Z=h.position),void 0!==h.boldLabel&&(k=h.boldLabel),isNaN(h.labelOffset)||(aa=h.labelOffset)):""===c&&(B=0);m&&!isNaN(a.minorTickLength)&&(B=a.minorTickLength);var ga="start";0<g&&(ga="middle");a.centerLabels&&(ga="middle");var V=n*Math.PI/180,Y,Da,G=0,v=0,oa=0,ha=Y=0,Qa=0;"V"==Pa&&(n=0);var ca;P&&""!==c&&(ca=a.autoWrap&&0===n?d.wrappedText(z,c,w,t,r,ga,k,Math.abs(g),0):d.text(z,c,w,t,r,ga,k),ga=ca.getBBox(),ha=ga.width,Qa=ga.height);
if("H"==Pa){if(0<=b&&b<=xa+1&&(0<B&&0<y&&b+l<=xa+1&&(fa=d.line(z,[b+l,b+l],[0,B],A,y,C),x.push(fa)),0<D&&(Ba=d.line(z,[b,b+ma,b+ma],[X,X+na,na],I,D,C,H),x.push(Ba))),v=0,G=b,h&&90==n&&J&&(G-=r),!1===e?(ga="start",v="bottom"==Z?J?v+B:v-B:J?v-B:v+B,G+=3,0<g&&(G+=g/2-3,ga="middle"),0<n&&(ga="middle")):ga="middle",1==ia&&0<M&&!h&&!m&&da<xa&&(e=d.fitToBounds(b,0,xa),da=d.fitToBounds(da,0,xa),Y=e-da,0<Y&&(Da=d.rect(z,Y,a.height,Q,M),Da.translate(e-Y+ma,na),x.push(Da))),"bottom"==Z?(v+=X+r/2+ea,J?(0<n?(v=
X-ha/2*Math.sin(V)-B-3,a.centerRotatedLabels||(G+=ha/2*Math.cos(V)-4+2)):0>n?(v=X+ha*Math.sin(V)-B-3+2,G+=-ha*Math.cos(V)-Qa*Math.sin(V)-4):v-=B+r+3+3,v-=aa):(0<n?(v=X+ha/2*Math.sin(V)+B+3,a.centerRotatedLabels||(G-=ha/2*Math.cos(V))):0>n?(v=X+B+3-ha/2*Math.sin(V)+2,G+=ha/2*Math.cos(V)):v+=B+u+3+3,v+=aa)):(v+=na+r/2-ea,G+=ma,J?(0<n?(v=ha/2*Math.sin(V)+B+3,a.centerRotatedLabels||(G-=ha/2*Math.cos(V))):v+=B+3,v+=aa):(0<n?(v=-(ha/2)*Math.sin(V)-B-6,a.centerRotatedLabels||(G+=ha/2*Math.cos(V))):v-=B+
r+3+u+3,v-=aa)),"bottom"==Z?Y=(J?X-B-1:X+u-1)+ea:(oa=ma,Y=(J?na:na-B-u+1)-ea),f&&(G+=f),r=G,0<n&&(r+=ha/2*Math.cos(V)),ca&&(f=0,J&&(f=ha/2*Math.cos(V)),r+f>xa+2||0>r))ca.remove(),ca=null}else{0<=b&&b<=X+1&&(0<B&&0<y&&b+l<=X+1&&(fa=d.line(z,[0,B+1],[b+l,b+l],A,y,C),x.push(fa)),0<D&&(Ba=d.line(z,[0,ma,xa+ma],[b,b+na,b+na],I,D,C,H),x.push(Ba)));ga="end";if(!0===J&&"left"==Z||!1===J&&"right"==Z)ga="start";v=b-Qa/2+2;1==ia&&0<M&&!h&&!m&&(e=d.fitToBounds(b,0,X),da=d.fitToBounds(da,0,X),V=e-da,Da=d.polygon(z,
[0,a.width,a.width,0],[0,0,V,V],Q,M),Da.translate(ma,e-V+na),x.push(Da));v+=r/2;"right"==Z?(G+=ma+xa+ea,v+=na,J?(f||(v-=r/2+3),G=G-(B+4)-aa):(G+=B+4+u,v-=2,G+=aa)):J?(G+=B+4-ea,f||(v-=r/2+3),h&&(G+=ma,v+=na),G+=aa):(G+=-B-u-4-2-ea,v-=2,G-=aa);fa&&("right"==Z?(oa+=ma+ea+xa-1,Y+=na,oa=J?oa-u:oa+u):(oa-=ea,J||(oa-=B+u)));f&&(v+=f);J=-3;"right"==Z&&(J+=na);ca&&(v>X+1||v<J-r/10)&&(ca.remove(),ca=null)}fa&&(fa.translate(oa,Y),d.setCN(p,fa,a.bcn+"tick"),d.setCN(p,fa,q,!0),h&&d.setCN(p,fa,"guide"));!1===
a.visible&&(fa&&fa.remove(),ca&&(ca.remove(),ca=null));ca&&(ca.attr({"text-anchor":ga}),ca.translate(G,v,NaN,!0),0!==n&&ca.rotate(-n,a.chart.backgroundColor),a.allLabels.push(ca),this.label=ca,d.setCN(p,ca,a.bcn+"label"),d.setCN(p,ca,q,!0),h&&d.setCN(p,ca,"guide"));Ba&&(d.setCN(p,Ba,a.bcn+"grid"),d.setCN(p,Ba,q,!0),h&&d.setCN(p,Ba,"guide"));Da&&(d.setCN(p,Da,a.bcn+"fill"),d.setCN(p,Da,q,!0));m?Ba&&d.setCN(p,Ba,a.bcn+"grid-minor"):(a.counter=0===ia?1:0,a.previousCoord=b);0===this.set.node.childNodes.length&&
this.set.remove()},graphics:function(){return this.set},getLabel:function(){return this.label}})})();(function(){var d=window.AmCharts;d.RecFill=d.Class({construct:function(a,b,c,e){var g=a.dx,f=a.dy,h=a.orientation,k=0;if(c<b){var l=b;b=c;c=l}var m=e.fillAlpha;isNaN(m)&&(m=0);var l=a.chart.container,n=e.fillColor;"V"==h?(b=d.fitToBounds(b,0,a.height),c=d.fitToBounds(c,0,a.height)):(b=d.fitToBounds(b,0,a.width),c=d.fitToBounds(c,0,a.width));c-=b;isNaN(c)&&(c=4,k=2,m=0);0>c&&"object"==typeof n&&(n=n.join(",").split(",").reverse());"V"==h?(h=d.rect(l,a.width,c,n,m),h.translate(g,b-k+f)):(h=d.rect(l,
c,a.height,n,m),h.translate(b-k+g,f));d.setCN(a.chart,h,"guide-fill");e.id&&d.setCN(a.chart,h,"guide-fill-"+e.id);this.set=l.set([h])},graphics:function(){return this.set},getLabel:function(){}})})();(function(){var d=window.AmCharts;d.AmChart=d.Class({construct:function(a){this.svgIcons=this.tapToActivate=!0;this.theme=a;this.classNamePrefix="amcharts";this.addClassNames=!1;this.version="3.21.15";d.addChart(this);this.createEvents("buildStarted","dataUpdated","init","rendered","drawn","failed","resized","animationFinished");this.height=this.width="100%";this.dataChanged=!0;this.chartCreated=!1;this.previousWidth=this.previousHeight=0;this.backgroundColor="#FFFFFF";this.borderAlpha=this.backgroundAlpha=
0;this.color=this.borderColor="#000000";this.fontFamily="Verdana";this.fontSize=11;this.usePrefixes=!1;this.autoResize=!0;this.autoDisplay=!1;this.addCodeCredits=this.accessible=!0;this.touchStartTime=this.touchClickDuration=0;this.precision=-1;this.percentPrecision=2;this.decimalSeparator=".";this.thousandsSeparator=",";this.labels=[];this.allLabels=[];this.titles=[];this.marginRight=this.marginLeft=this.autoMarginOffset=0;this.timeOuts=[];this.creditsPosition="top-left";var b=document.createElement("div"),
c=b.style;c.overflow="hidden";c.position="relative";c.textAlign="left";this.chartDiv=b;b=document.createElement("div");c=b.style;c.overflow="hidden";c.position="relative";c.textAlign="left";this.legendDiv=b;this.titleHeight=0;this.hideBalloonTime=150;this.handDrawScatter=2;this.cssScale=this.handDrawThickness=1;this.cssAngle=0;this.prefixesOfBigNumbers=[{number:1E3,prefix:"k"},{number:1E6,prefix:"M"},{number:1E9,prefix:"G"},{number:1E12,prefix:"T"},{number:1E15,prefix:"P"},{number:1E18,prefix:"E"},
{number:1E21,prefix:"Z"},{number:1E24,prefix:"Y"}];this.prefixesOfSmallNumbers=[{number:1E-24,prefix:"y"},{number:1E-21,prefix:"z"},{number:1E-18,prefix:"a"},{number:1E-15,prefix:"f"},{number:1E-12,prefix:"p"},{number:1E-9,prefix:"n"},{number:1E-6,prefix:"\u03bc"},{number:.001,prefix:"m"}];this.panEventsEnabled=!0;this.product="amcharts";this.animations=[];this.balloon=new d.AmBalloon(this.theme);this.balloon.chart=this;this.processTimeout=0;this.processCount=1E3;this.animatable=[];this.langObj={};
d.applyTheme(this,a,"AmChart")},drawChart:function(){0<this.realWidth&&0<this.realHeight&&(this.drawBackground(),this.redrawLabels(),this.drawTitles(),this.brr(),this.renderFix(),this.chartDiv&&(this.boundingRect=this.chartDiv.getBoundingClientRect()))},makeAccessible:function(a,b,c){this.accessible&&a&&(c&&a.setAttr("role",c),a.setAttr("aria-label",b))},drawBackground:function(){d.remove(this.background);var a=this.container,b=this.backgroundColor,c=this.backgroundAlpha,e=this.set;d.isModern||0!==
c||(c=.001);var g=this.updateWidth();this.realWidth=g;var f=this.updateHeight();this.realHeight=f;b=d.polygon(a,[0,g-1,g-1,0],[0,0,f-1,f-1],b,c,1,this.borderColor,this.borderAlpha);d.setCN(this,b,"bg");this.background=b;e.push(b);if(b=this.backgroundImage)a=a.image(b,0,0,g,f),d.setCN(this,b,"bg-image"),this.bgImg=a,e.push(a)},drawTitles:function(a){var b=this.titles;this.titleHeight=0;if(d.ifArray(b)){var c=20,e;for(e=0;e<b.length;e++){var g=b[e],g=d.processObject(g,d.Title,this.theme);if(!1!==g.enabled){var f=
g.color;void 0===f&&(f=this.color);var h=g.size;isNaN(h)&&(h=this.fontSize+2);isNaN(g.alpha);var k=this.marginLeft,l=!0;void 0!==g.bold&&(l=g.bold);f=d.wrappedText(this.container,g.text,f,this.fontFamily,h,"middle",l,this.realWidth-35-this.marginRight-k);f.translate(k+(this.realWidth-this.marginRight-k)/2,c);f.node.style.pointerEvents="none";g.sprite=f;void 0!==g.tabIndex&&f.setAttr("tabindex",g.tabIndex);d.setCN(this,f,"title");g.id&&d.setCN(this,f,"title-"+g.id);f.attr({opacity:g.alpha});c+=f.getBBox().height+
5;a?f.remove():this.freeLabelsSet.push(f)}}this.titleHeight=c-10}},write:function(a){var b=this;if(b.listeners)for(var c=0;c<b.listeners.length;c++){var e=b.listeners[c];b.addListener(e.event,e.method)}b.fire({type:"buildStarted",chart:b});b.afterWriteTO&&clearTimeout(b.afterWriteTO);0<b.processTimeout?b.afterWriteTO=setTimeout(function(){b.afterWrite.call(b,a)},b.processTimeout):b.afterWrite(a)},afterWrite:function(a){var b;if(b="object"!=typeof a?document.getElementById(a):a){for(;b.firstChild;)b.removeChild(b.firstChild);
this.div=b;b.style.overflow="hidden";b.style.textAlign="left";a=this.chartDiv;var c=this.legendDiv,e=this.legend,g=c.style,f=a.style;this.measure();this.previousHeight=this.divRealHeight;this.previousWidth=this.divRealWidth;var h,k=document.createElement("div");h=k.style;h.position="relative";this.containerDiv=k;k.className=this.classNamePrefix+"-main-div";a.className=this.classNamePrefix+"-chart-div";b.appendChild(k);(b=this.exportConfig)&&d.AmExport&&!this.AmExport&&(this.AmExport=new d.AmExport(this,
b));this.amExport&&d.AmExport&&(this.AmExport=d.extend(this.amExport,new d.AmExport(this),!0));this.AmExport&&this.AmExport.init&&this.AmExport.init();if(e){e=this.addLegend(e,e.divId);if(e.enabled)switch(g.left=null,g.top=null,g.right=null,f.left=null,f.right=null,f.top=null,g.position="relative",f.position="relative",h.width="100%",h.height="100%",e.position){case "bottom":k.appendChild(a);k.appendChild(c);break;case "top":k.appendChild(c);k.appendChild(a);break;case "absolute":g.position="absolute";
f.position="absolute";void 0!==e.left&&(g.left=e.left+"px");void 0!==e.right&&(g.right=e.right+"px");void 0!==e.top&&(g.top=e.top+"px");void 0!==e.bottom&&(g.bottom=e.bottom+"px");e.marginLeft=0;e.marginRight=0;k.appendChild(a);k.appendChild(c);break;case "right":g.position="relative";f.position="absolute";k.appendChild(a);k.appendChild(c);break;case "left":g.position="absolute";f.position="relative";k.appendChild(a);k.appendChild(c);break;case "outside":k.appendChild(a)}else k.appendChild(a);this.prevLegendPosition=
e.position}else k.appendChild(a);this.listenersAdded||(this.addListeners(),this.listenersAdded=!0);(this.mouseWheelScrollEnabled||this.mouseWheelZoomEnabled)&&d.addWheelListeners();this.initChart()}},createLabelsSet:function(){d.remove(this.labelsSet);this.labelsSet=this.container.set();this.freeLabelsSet.push(this.labelsSet)},initChart:function(){this.balloon=d.processObject(this.balloon,d.AmBalloon,this.theme);window.AmCharts_path&&(this.path=window.AmCharts_path);void 0===this.path&&(this.path=
d.getPath());void 0===this.path&&(this.path="amcharts/");this.path=d.normalizeUrl(this.path);void 0===this.pathToImages&&(this.pathToImages=this.path+"images/");this.initHC||(d.callInitHandler(this),this.initHC=!0);d.applyLang(this.language,this);var a=this.numberFormatter;a&&(isNaN(a.precision)||(this.precision=a.precision),void 0!==a.thousandsSeparator&&(this.thousandsSeparator=a.thousandsSeparator),void 0!==a.decimalSeparator&&(this.decimalSeparator=a.decimalSeparator));(a=this.percentFormatter)&&
!isNaN(a.precision)&&(this.percentPrecision=a.precision);this.nf={precision:this.precision,thousandsSeparator:this.thousandsSeparator,decimalSeparator:this.decimalSeparator};this.pf={precision:this.percentPrecision,thousandsSeparator:this.thousandsSeparator,decimalSeparator:this.decimalSeparator};this.destroy();(a=this.container)?(a.container.innerHTML="",a.width=this.realWidth,a.height=this.realHeight,a.addDefs(this),this.chartDiv.appendChild(a.container)):a=new d.AmDraw(this.chartDiv,this.realWidth,
this.realHeight,this);this.container=a;this.extension=".png";this.svgIcons&&d.SVG&&(this.extension=".svg");this.checkDisplay();this.checkTransform(this.div);a.chart=this;d.VML||d.SVG?(a.handDrawn=this.handDrawn,a.handDrawScatter=this.handDrawScatter,a.handDrawThickness=this.handDrawThickness,d.remove(this.set),this.set=a.set(),d.remove(this.gridSet),this.gridSet=a.set(),d.remove(this.cursorLineSet),this.cursorLineSet=a.set(),d.remove(this.graphsBehindSet),this.graphsBehindSet=a.set(),d.remove(this.bulletBehindSet),
this.bulletBehindSet=a.set(),d.remove(this.columnSet),this.columnSet=a.set(),d.remove(this.graphsSet),this.graphsSet=a.set(),d.remove(this.trendLinesSet),this.trendLinesSet=a.set(),d.remove(this.axesSet),this.axesSet=a.set(),d.remove(this.cursorSet),this.cursorSet=a.set(),d.remove(this.scrollbarsSet),this.scrollbarsSet=a.set(),d.remove(this.bulletSet),this.bulletSet=a.set(),d.remove(this.freeLabelsSet),this.freeLabelsSet=a.set(),d.remove(this.axesLabelsSet),this.axesLabelsSet=a.set(),d.remove(this.balloonsSet),
this.balloonsSet=a.set(),d.remove(this.plotBalloonsSet),this.plotBalloonsSet=a.set(),d.remove(this.zoomButtonSet),this.zoomButtonSet=a.set(),d.remove(this.zbSet),this.zbSet=null,d.remove(this.linkSet),this.linkSet=a.set()):this.fire({type:"failed",chart:this})},premeasure:function(){var a=this.div;if(a){try{this.boundingRect=this.chartDiv.getBoundingClientRect()}catch(e){}var b=a.offsetWidth,c=a.offsetHeight;a.clientHeight&&(b=a.clientWidth,c=a.clientHeight);if(b!=this.mw||c!=this.mh)this.mw=b,this.mh=
c,this.measure()}},measure:function(){var a=this.div;if(a){var b=this.chartDiv,c=a.offsetWidth,e=a.offsetHeight,g=this.container;a.clientHeight&&(c=a.clientWidth,e=a.clientHeight);var e=Math.round(e),c=Math.round(c),a=Math.round(d.toCoordinate(this.width,c)),f=Math.round(d.toCoordinate(this.height,e));(c!=this.previousWidth||e!=this.previousHeight)&&0<a&&0<f&&(b.style.width=a+"px",b.style.height=f+"px",b.style.padding=0,g&&g.setSize(a,f),this.balloon=d.processObject(this.balloon,d.AmBalloon,this.theme));
this.balloon&&this.balloon.setBounds&&this.balloon.setBounds(2,2,a-2,f);this.updateWidth();this.balloon.chart=this;this.realWidth=a;this.realHeight=f;this.divRealWidth=c;this.divRealHeight=e}},checkDisplay:function(){if(this.autoDisplay&&this.container){var a=d.rect(this.container,10,10),b=a.getBBox();0===b.width&&0===b.height&&(this.divRealHeight=this.divRealWidth=this.realHeight=this.realWidth=0,this.previousWidth=this.previousHeight=NaN);a.remove()}},checkTransform:function(a){if(this.autoTransform&&
window.getComputedStyle&&a){if(a.style){var b=window.getComputedStyle(a,null);if(b&&(b=b.getPropertyValue("-webkit-transform")||b.getPropertyValue("-moz-transform")||b.getPropertyValue("-ms-transform")||b.getPropertyValue("-o-transform")||b.getPropertyValue("transform"))&&"none"!==b){var c=b.split("(")[1].split(")")[0].split(","),b=c[0],c=c[1],b=Math.sqrt(b*b+c*c);isNaN(b)||(this.cssScale*=b)}}a.parentNode&&this.checkTransform(a.parentNode)}},destroy:function(){this.chartDiv.innerHTML="";this.clearTimeOuts();
this.legend&&this.legend.destroy&&this.legend.destroy()},clearTimeOuts:function(){var a=this.timeOuts;if(a){var b;for(b=0;b<a.length;b++)clearTimeout(a[b])}this.timeOuts=[]},clear:function(a){try{document.removeEventListener("touchstart",this.docfn1,!0),document.removeEventListener("touchend",this.docfn2,!0)}catch(b){}d.callMethod("clear",[this.chartScrollbar,this.scrollbarV,this.scrollbarH,this.chartCursor]);this.chartCursor=this.scrollbarH=this.scrollbarV=this.chartScrollbar=null;this.clearTimeOuts();
this.container&&(this.container.remove(this.chartDiv),this.container.remove(this.legendDiv));a||d.removeChart(this);if(a=this.div)for(;a.firstChild;)a.removeChild(a.firstChild);this.legend&&this.legend.destroy&&this.legend.destroy();this.AmExport&&this.AmExport.clear&&this.AmExport.clear()},setMouseCursor:function(a){"auto"==a&&d.isNN&&(a="default");this.chartDiv.style.cursor=a;this.legendDiv.style.cursor=a},redrawLabels:function(){this.labels=[];var a=this.allLabels;this.createLabelsSet();var b;
for(b=0;b<a.length;b++)this.drawLabel(a[b])},drawLabel:function(a){var b=this;if(b.container&&!1!==a.enabled){a=d.processObject(a,d.Label,b.theme);var c=a.y,e=a.text,g=a.align,f=a.size,h=a.color,k=a.rotation,l=a.alpha,m=a.bold,n=d.toCoordinate(a.x,b.realWidth),c=d.toCoordinate(c,b.realHeight);n||(n=0);c||(c=0);void 0===h&&(h=b.color);isNaN(f)&&(f=b.fontSize);g||(g="start");"left"==g&&(g="start");"right"==g&&(g="end");"center"==g&&(g="middle",k?c=b.realHeight-c+c/2:n=b.realWidth/2-n);void 0===l&&(l=
1);void 0===k&&(k=0);c+=f/2;e=d.text(b.container,e,h,b.fontFamily,f,g,m,l);e.translate(n,c);void 0!==a.tabIndex&&e.setAttr("tabindex",a.tabIndex);d.setCN(b,e,"label");a.id&&d.setCN(b,e,"label-"+a.id);0!==k&&e.rotate(k);a.url?(e.setAttr("cursor","pointer"),e.click(function(){d.getURL(a.url,b.urlTarget)})):e.node.style.pointerEvents="none";b.labelsSet.push(e);b.labels.push(e)}},addLabel:function(a,b,c,e,d,f,h,k,l,m){a={x:a,y:b,text:c,align:e,size:d,color:f,alpha:k,rotation:h,bold:l,url:m,enabled:!0};
this.container&&this.drawLabel(a);this.allLabels.push(a)},clearLabels:function(){var a=this.labels,b;for(b=a.length-1;0<=b;b--)a[b].remove();this.labels=[];this.allLabels=[]},updateHeight:function(){var a=this.divRealHeight,b=this.legend;if(b){var c=this.legendDiv.offsetHeight,b=b.position;if("top"==b||"bottom"==b){a-=c;if(0>a||isNaN(a))a=0;this.chartDiv.style.height=a+"px"}}return a},updateWidth:function(){var a=this.divRealWidth,b=this.divRealHeight,c=this.legend;if(c){var e=this.legendDiv,d=e.offsetWidth;
isNaN(c.width)||(d=c.width);c.ieW&&(d=c.ieW);var f=e.offsetHeight,e=e.style,h=this.chartDiv.style,k=c.position;if(("right"==k||"left"==k)&&void 0===c.divId){a-=d;if(0>a||isNaN(a))a=0;h.width=a+"px";this.balloon&&this.balloon.setBounds&&this.balloon.setBounds(2,2,a-2,this.realHeight);"left"==k?(h.left=d+"px",e.left="0px"):(h.left="0px",e.left=a+"px");b>f&&(e.top=(b-f)/2+"px")}}return a},getTitleHeight:function(){this.drawTitles(!0);return this.titleHeight},addTitle:function(a,b,c,e,d){isNaN(b)&&(b=
this.fontSize+2);a={text:a,size:b,color:c,alpha:e,bold:d,enabled:!0};this.titles.push(a);return a},handleWheel:function(a){var b=0;a||(a=window.event);a.wheelDelta?b=a.wheelDelta/120:a.detail&&(b=-a.detail/3);b&&this.handleWheelReal(b,a.shiftKey);a.preventDefault&&a.preventDefault()},handleWheelReal:function(){},handleDocTouchStart:function(){this.handleMouseMove();this.tmx=this.mouseX;this.tmy=this.mouseY;this.touchStartTime=(new Date).getTime()},handleDocTouchEnd:function(){-.5<this.tmx&&this.tmx<
this.divRealWidth+1&&0<this.tmy&&this.tmy<this.divRealHeight?(this.handleMouseMove(),4>Math.abs(this.mouseX-this.tmx)&&4>Math.abs(this.mouseY-this.tmy)?(this.tapped=!0,this.panRequired&&this.panEventsEnabled&&this.chartDiv&&(this.chartDiv.style.msTouchAction="none",this.chartDiv.style.touchAction="none")):this.mouseIsOver||this.resetTouchStyle()):(this.tapped=!1,this.resetTouchStyle())},resetTouchStyle:function(){this.panEventsEnabled&&this.chartDiv&&(this.chartDiv.style.msTouchAction="auto",this.chartDiv.style.touchAction=
"auto")},checkTouchDuration:function(a){var b=this,c=(new Date).getTime();if(a)if(a.touches)b.isTouchEvent=!0;else if(!b.isTouchEvent)return!0;if(c-b.touchStartTime>b.touchClickDuration)return!0;setTimeout(function(){b.resetTouchDuration()},300)},resetTouchDuration:function(){this.isTouchEvent=!1},checkTouchMoved:function(){if(4<Math.abs(this.mouseX-this.tmx)||4<Math.abs(this.mouseY-this.tmy))return!0},addListeners:function(){var a=this,b=a.chartDiv;document.addEventListener?("ontouchstart"in document.documentElement&&
(b.addEventListener("touchstart",function(b){a.handleTouchStart.call(a,b)},!0),b.addEventListener("touchmove",function(b){a.handleMouseMove.call(a,b)},!0),b.addEventListener("touchend",function(b){a.handleTouchEnd.call(a,b)},!0),a.docfn1=function(b){a.handleDocTouchStart.call(a,b)},a.docfn2=function(b){a.handleDocTouchEnd.call(a,b)},document.addEventListener("touchstart",a.docfn1,!0),document.addEventListener("touchend",a.docfn2,!0)),b.addEventListener("mousedown",function(b){a.mouseIsOver=!0;a.handleMouseMove.call(a,
b);a.handleMouseDown.call(a,b);a.handleDocTouchStart.call(a,b)},!0),b.addEventListener("mouseover",function(b){a.handleMouseOver.call(a,b)},!0),b.addEventListener("mouseout",function(b){a.handleMouseOut.call(a,b)},!0),b.addEventListener("mouseup",function(b){a.handleDocTouchEnd.call(a,b)},!0)):(b.attachEvent("onmousedown",function(b){a.handleMouseDown.call(a,b)}),b.attachEvent("onmouseover",function(b){a.handleMouseOver.call(a,b)}),b.attachEvent("onmouseout",function(b){a.handleMouseOut.call(a,b)}))},
dispDUpd:function(){this.skipEvents||(this.dispatchDataUpdated&&(this.dispatchDataUpdated=!1,this.fire({type:"dataUpdated",chart:this})),this.chartCreated||(this.chartCreated=!0,this.fire({type:"init",chart:this})),!this.chartRendered&&0<this.divRealWidth&&0<this.divRealHeight&&(this.fire({type:"rendered",chart:this}),this.chartRendered=!0),this.fire({type:"drawn",chart:this}));this.skipEvents=!1},validateSize:function(){var a=this;a.premeasure();a.checkDisplay();a.cssScale=1;a.cssAngle=0;a.checkTransform(a.div);
if(a.divRealWidth!=a.previousWidth||a.divRealHeight!=a.previousHeight){var b=a.legend;if(0<a.realWidth&&0<a.realHeight){a.sizeChanged=!0;if(b){a.legendInitTO&&clearTimeout(a.legendInitTO);var c=setTimeout(function(){b.invalidateSize()},10);a.timeOuts.push(c);a.legendInitTO=c}a.marginsUpdated=!1;clearTimeout(a.initTO);c=setTimeout(function(){a.initChart()},10);a.timeOuts.push(c);a.initTO=c}a.renderFix();b&&b.renderFix&&b.renderFix();a.positionCred();clearTimeout(a.resizedTO);a.resizedTO=setTimeout(function(){a.fire({type:"resized",
chart:a})},10);a.previousHeight=a.divRealHeight;a.previousWidth=a.divRealWidth}},invalidateSize:function(){this.previousHeight=this.previousWidth=NaN;this.invalidateSizeReal()},invalidateSizeReal:function(){var a=this;a.marginsUpdated=!1;clearTimeout(a.validateTO);var b=setTimeout(function(){a.validateSize()},5);a.timeOuts.push(b);a.validateTO=b},validateData:function(a){this.chartCreated&&(this.dataChanged=!0,this.marginsUpdated=!1,this.initChart(a))},validateNow:function(a,b){this.initTO&&clearTimeout(this.initTO);
a&&(this.dataChanged=!0,this.marginsUpdated=!1);this.skipEvents=b;this.chartRendered=!1;var c=this.legend;c&&c.position!=this.prevLegendPosition&&(this.previousWidth=this.mw=0,c.invalidateSize&&(c.invalidateSize(),this.validateSize()));this.write(this.div)},showItem:function(a){a.hidden=!1;this.initChart()},hideItem:function(a){a.hidden=!0;this.initChart()},hideBalloon:function(){var a=this;clearTimeout(a.hoverInt);clearTimeout(a.balloonTO);a.hoverInt=setTimeout(function(){a.hideBalloonReal.call(a)},
a.hideBalloonTime)},cleanChart:function(){},hideBalloonReal:function(){var a=this.balloon;a&&a.hide&&a.hide()},showBalloon:function(a,b,c,e,d){var f=this;clearTimeout(f.balloonTO);clearTimeout(f.hoverInt);f.balloonTO=setTimeout(function(){f.showBalloonReal.call(f,a,b,c,e,d)},1)},showBalloonReal:function(a,b,c,e,d){this.handleMouseMove();var f=this.balloon;f.enabled&&(f.followCursor(!1),f.changeColor(b),!c||f.fixedPosition?(f.setPosition(e,d),isNaN(e)||isNaN(d)?f.followCursor(!0):f.followCursor(!1)):
f.followCursor(!0),a&&f.showBalloon(a))},handleMouseOver:function(){this.outTO&&clearTimeout(this.outTO);d.resetMouseOver();this.mouseIsOver=!0},handleMouseOut:function(){var a=this;d.resetMouseOver();a.outTO&&clearTimeout(a.outTO);a.outTO=setTimeout(function(){a.handleMouseOutReal()},10)},handleMouseOutReal:function(){this.mouseIsOver=!1},handleMouseMove:function(a){a||(a=window.event);this.mouse2Y=this.mouse2X=NaN;var b,c,e,d;if(a){if(a.touches){var f=a.touches.item(1);f&&this.panEventsEnabled&&
this.boundingRect&&(e=f.clientX-this.boundingRect.left,d=f.clientY-this.boundingRect.top);a=a.touches.item(0);if(!a)return}else this.wasTouched=!1;this.boundingRect&&a.clientX&&(b=a.clientX-this.boundingRect.left,c=a.clientY-this.boundingRect.top);isNaN(e)?this.mouseX=b:(this.mouseX=Math.min(b,e),this.mouse2X=Math.max(b,e));isNaN(d)?this.mouseY=c:(this.mouseY=Math.min(c,d),this.mouse2Y=Math.max(c,d));this.autoTransform&&(this.mouseX/=this.cssScale,this.mouseY/=this.cssScale)}},handleTouchStart:function(a){this.hideBalloonReal();
a&&(a.touches&&this.tapToActivate&&!this.tapped||!this.panRequired)||(this.handleMouseMove(a),this.handleMouseDown(a))},handleTouchEnd:function(a){this.wasTouched=!0;this.handleMouseMove(a);d.resetMouseOver();this.handleReleaseOutside(a)},handleReleaseOutside:function(){this.handleDocTouchEnd.call(this)},handleMouseDown:function(a){d.resetMouseOver();this.mouseIsOver=!0;a&&a.preventDefault&&(this.panEventsEnabled?a.preventDefault():a.touches||a.preventDefault())},handleKeyUp:function(a){},addLegend:function(a,
b){a=d.processObject(a,d.AmLegend,this.theme);a.divId=b;a.ieW=0;var c;c="object"!=typeof b&&b?document.getElementById(b):b;this.legend=a;a.chart=this;c?(a.div=c,a.position="outside",a.autoMargins=!1):a.div=this.legendDiv;return a},removeLegend:function(){this.legend=void 0;this.previousWidth=0;this.legendDiv.innerHTML=""},handleResize:function(){(d.isPercents(this.width)||d.isPercents(this.height))&&this.invalidateSizeReal();this.renderFix()},renderFix:function(){if(!d.VML){var a=this.container;a&&
a.renderFix()}},getSVG:function(){if(d.hasSVG)return this.container},animate:function(a,b,c,e,g,f,h){a["an_"+b]&&d.removeFromArray(this.animations,a["an_"+b]);c={obj:a,frame:0,attribute:b,from:c,to:e,time:g,effect:f,suffix:h};a["an_"+b]=c;this.animations.push(c);return c},setLegendData:function(a){var b=this.legend;b&&b.setData(a)},stopAnim:function(a){d.removeFromArray(this.animations,a)},updateAnimations:function(){var a;this.container&&this.container.update();if(this.animations)for(a=this.animations.length-
1;0<=a;a--){var b=this.animations[a],c=d.updateRate*b.time,e=b.frame+1,g=b.obj,f=b.attribute;if(e<=c){b.frame++;var h=Number(b.from),k=Number(b.to)-h,c=d[b.effect](0,e,h,k,c);0===k?(this.animations.splice(a,1),g.node.style[f]=Number(b.to)+b.suffix):g.node.style[f]=c+b.suffix}else g.node.style[f]=Number(b.to)+b.suffix,g.animationFinished=!0,this.animations.splice(a,1)}},update:function(){this.updateAnimations();var a=this.animatable;if(0<a.length){for(var b=!0,c=a.length-1;0<=c;c--){var e=a[c];e&&
(e.animationFinished?a.splice(c,1):b=!1)}b&&(this.fire({type:"animationFinished",chart:this}),this.animatable=[])}},inIframe:function(){try{return window.self!==window.top}catch(a){return!0}},brr:function(){},positionCred:function(){var a=this.amLink;if(a){var b=this.creditsPosition,c=a.style,e=a.offsetWidth,a=a.offsetHeight,d=0,f=0,h=this.realWidth,k=this.realHeight,l=this.type;if("serial"==l||"xy"==l||"gantt"==l)d=this.marginLeftReal,f=this.marginTopReal,h=d+this.plotAreaWidth,k=f+this.plotAreaHeight;
var l=5+d,m=f+5;"bottom-left"==b&&(l=5+d,m=k-a-3);"bottom-right"==b&&(l=h-e-5,m=k-a-3);"top-right"==b&&(l=h-e-5,m=f+5);c.left=l+"px";c.top=m+"px"}}});d.Slice=d.Class({construct:function(){}});d.SerialDataItem=d.Class({construct:function(){}});d.GraphDataItem=d.Class({construct:function(){}});d.Guide=d.Class({construct:function(a){this.cname="Guide";d.applyTheme(this,a,this.cname)}});d.Title=d.Class({construct:function(a){this.cname="Title";d.applyTheme(this,a,this.cname)}});d.Label=d.Class({construct:function(a){this.cname=
"Label";d.applyTheme(this,a,this.cname)}})})();(function(){var d=window.AmCharts;d.AmGraph=d.Class({construct:function(a){this.cname="AmGraph";this.createEvents("rollOverGraphItem","rollOutGraphItem","clickGraphItem","doubleClickGraphItem","rightClickGraphItem","clickGraph","rollOverGraph","rollOutGraph");this.type="line";this.stackable=!0;this.columnCount=1;this.columnIndex=0;this.centerCustomBullets=this.showBalloon=!0;this.maxBulletSize=50;this.minBulletSize=4;this.balloonText="[[value]]";this.hidden=this.scrollbar=this.animationPlayed=!1;
this.pointPosition="middle";this.depthCount=1;this.includeInMinMax=!0;this.negativeBase=0;this.visibleInLegend=!0;this.showAllValueLabels=!1;this.showBulletsAt=this.showBalloonAt="close";this.lineThickness=1;this.dashLength=0;this.connect=!0;this.lineAlpha=1;this.bullet="none";this.bulletBorderThickness=2;this.bulletBorderAlpha=0;this.bulletAlpha=1;this.bulletSize=8;this.cornerRadiusTop=this.hideBulletsCount=this.bulletOffset=0;this.cursorBulletAlpha=1;this.gradientOrientation="vertical";this.dy=
this.dx=0;this.periodValue="";this.clustered=!0;this.periodSpan=1;this.accessibleLabel="[[title]] [[category]] [[value]]";this.accessibleSkipText="Press enter to skip [[title]]";this.y=this.x=0;this.switchable=!0;this.minDistance=.8;this.tcc=1;this.labelRotation=0;this.labelAnchor="auto";this.labelOffset=3;this.bcn="graph-";this.dateFormat="MMM DD, YYYY";this.noRounding=!0;d.applyTheme(this,a,this.cname)},init:function(){this.createBalloon()},draw:function(){var a=this.chart;a.isRolledOverBullet=
!1;var b=a.type;if(a.drawGraphs){isNaN(this.precision)||(this.numberFormatter?this.numberFormatter.precision=this.precision:this.numberFormatter={precision:this.precision,decimalSeparator:a.decimalSeparator,thousandsSeparator:a.thousandsSeparator});var c=a.container;this.container=c;this.destroy();var e=c.set();this.set=e;e.translate(this.x,this.y);var g=c.set();this.bulletSet=g;g.translate(this.x,this.y);this.behindColumns?(a.graphsBehindSet.push(e),a.bulletBehindSet.push(g)):(a.graphsSet.push(e),
a.bulletSet.push(g));var f=this.bulletAxis;d.isString(f)&&(this.bulletAxis=a.getValueAxisById(f));c=c.set();d.remove(this.columnsSet);this.columnsSet=c;d.setCN(a,e,"graph-"+this.type);d.setCN(a,e,"graph-"+this.id);d.setCN(a,g,"graph-"+this.type);d.setCN(a,g,"graph-"+this.id);this.columnsArray=[];this.ownColumns=[];this.allBullets=[];this.animationArray=[];g=this.labelPosition;g||(f=this.valueAxis.stackType,g="top","column"==this.type&&(a.rotate&&(g="right"),"100%"==f||"regular"==f)&&(g="middle"),
this.labelPosition=g);d.ifArray(this.data)&&(a=!1,"xy"==b?this.xAxis.axisCreated&&this.yAxis.axisCreated&&(a=!0):this.valueAxis.axisCreated&&(a=!0),!this.hidden&&a&&this.createGraph());e.push(c)}},createGraph:function(){var a=this,b=a.chart;a.startAlpha=b.startAlpha;a.seqAn=b.sequencedAnimation;a.baseCoord=a.valueAxis.baseCoord;void 0===a.fillAlphas&&(a.fillAlphas=0);a.bulletColorR=a.bulletColor;void 0===a.bulletColorR&&(a.bulletColorR=a.lineColorR,a.bulletColorNegative=a.negativeLineColor);void 0===
a.bulletAlpha&&(a.bulletAlpha=a.lineAlpha);if("step"==c||d.VML)a.noRounding=!1;var c=b.type;"gantt"==c&&(c="serial");clearTimeout(a.playedTO);if(!isNaN(a.valueAxis.min)&&!isNaN(a.valueAxis.max)){switch(c){case "serial":a.categoryAxis&&(a.createSerialGraph(),"candlestick"==a.type&&1>a.valueAxis.minMaxMultiplier&&a.positiveClip(a.set));break;case "radar":a.createRadarGraph();break;case "xy":a.createXYGraph()}a.playedTO=setTimeout(function(){a.setAnimationPlayed.call(a)},500*a.chart.startDuration)}},
setAnimationPlayed:function(){this.animationPlayed=!0},createXYGraph:function(){var a=[],b=[],c=this.xAxis,e=this.yAxis;this.pmh=e.height;this.pmw=c.width;this.pmy=this.pmx=0;var d;for(d=this.start;d<=this.end;d++){var f=this.data[d].axes[c.id].graphs[this.id],h=f.values,k=h.x,l=h.y,h=c.getCoordinate(k,this.noRounding),m=e.getCoordinate(l,this.noRounding);if(!isNaN(k)&&!isNaN(l)&&(a.push(h),b.push(m),f.x=h,f.y=m,k=this.createBullet(f,h,m,d),l=this.labelText)){var l=this.createLabel(f,l),n=0;k&&(n=
k.size);this.positionLabel(f,h,m,l,n)}}this.drawLineGraph(a,b);this.launchAnimation()},createRadarGraph:function(){var a=this.valueAxis.stackType,b=[],c=[],e=[],d=[],f,h,k,l,m;for(m=this.start;m<=this.end;m++){var n=this.data[m].axes[this.valueAxis.id].graphs[this.id],q,p;"none"==a||"3d"==a?q=n.values.value:(q=n.values.close,p=n.values.open);if(isNaN(q))this.connect||(this.drawLineGraph(b,c,e,d),b=[],c=[],e=[],d=[]);else{var t=this.valueAxis.getCoordinate(q,this.noRounding)-this.height,t=t*this.valueAxis.rMultiplier,
r=-360/(this.end-this.start+1)*m;"middle"==this.valueAxis.pointPosition&&(r-=180/(this.end-this.start+1));q=t*Math.sin(r/180*Math.PI);t*=Math.cos(r/180*Math.PI);b.push(q);c.push(t);if(!isNaN(p)){var w=this.valueAxis.getCoordinate(p,this.noRounding)-this.height,w=w*this.valueAxis.rMultiplier,z=w*Math.sin(r/180*Math.PI),r=w*Math.cos(r/180*Math.PI);e.push(z);d.push(r);isNaN(k)&&(k=z);isNaN(l)&&(l=r)}r=this.createBullet(n,q,t,m);n.x=q;n.y=t;if(z=this.labelText)z=this.createLabel(n,z),w=0,r&&(w=r.size),
this.positionLabel(n,q,t,z,w);isNaN(f)&&(f=q);isNaN(h)&&(h=t)}}b.push(f);c.push(h);isNaN(k)||(e.push(k),d.push(l));this.drawLineGraph(b,c,e,d);this.launchAnimation()},positionLabel:function(a,b,c,e,d){if(e){var f=this.chart,h=this.valueAxis,k="middle",l=!1,m=this.labelPosition,n=e.getBBox(),q=this.chart.rotate,p=a.isNegative,t=this.fontSize;void 0===t&&(t=this.chart.fontSize);c-=n.height/2-t/2-1;void 0!==a.labelIsNegative&&(p=a.labelIsNegative);switch(m){case "right":m=q?p?"left":"right":"right";
break;case "top":m=q?"top":p?"bottom":"top";break;case "bottom":m=q?"bottom":p?"top":"bottom";break;case "left":m=q?p?"right":"left":"left"}var t=a.columnGraphics,r=0,w=0;t&&(r=t.x,w=t.y);var z=this.labelOffset;switch(m){case "right":k="start";b+=d/2+z;break;case "top":c=h.reversed?c+(d/2+n.height/2+z):c-(d/2+n.height/2+z);break;case "bottom":c=h.reversed?c-(d/2+n.height/2+z):c+(d/2+n.height/2+z);break;case "left":k="end";b-=d/2+z;break;case "inside":"column"==this.type&&(l=!0,q?p?(k="end",b=r-3-
z):(k="start",b=r+3+z):c=p?w+7+z:w-10-z);break;case "middle":"column"==this.type&&(l=!0,q?b-=(b-r)/2+z-3:c-=(c-w)/2+z-3)}"auto"!=this.labelAnchor&&(k=this.labelAnchor);e.attr({"text-anchor":k});this.labelRotation&&e.rotate(this.labelRotation);e.translate(b,c);!this.showAllValueLabels&&t&&l&&(n=e.getBBox(),n.height>a.columnHeight||n.width>a.columnWidth)&&(e.remove(),e=null);if(e&&"radar"!=f.type)if(q){if(0>c||c>this.height)e.remove(),e=null;!this.showAllValueLabels&&e&&(0>b||b>this.width)&&(e.remove(),
e=null)}else{if(0>b||b>this.width)e.remove(),e=null;!this.showAllValueLabels&&e&&(0>c||c>this.height)&&(e.remove(),e=null)}e&&this.allBullets.push(e);return e}},getGradRotation:function(){var a=270;"horizontal"==this.gradientOrientation&&(a=0);return this.gradientRotation=a},createSerialGraph:function(){this.dashLengthSwitched=this.fillColorsSwitched=this.lineColorSwitched=void 0;var a=this.chart,b=this.id,c=this.index,e=this.data,g=this.chart.container,f=this.valueAxis,h=this.type,k=this.columnWidthReal,
l=this.showBulletsAt;isNaN(this.columnWidth)||(k=this.columnWidth);isNaN(k)&&(k=.8);var m=this.useNegativeColorIfDown,n=this.width,q=this.height,p=this.y,t=this.rotate,r=this.columnCount,w=d.toCoordinate(this.cornerRadiusTop,k/2),z=this.connect,x=[],u=[],A,y,B,D,C=this.chart.graphs.length,I,H=this.dx/this.tcc,Q=this.dy/this.tcc,M=f.stackType,P=this.start,ia=this.end,J=this.scrollbar,aa="graph-column-";J&&(aa="scrollbar-graph-column-");var ma=this.categoryAxis,na=this.baseCoord,Pa=this.negativeBase,
Z=this.columnIndex,da=this.lineThickness,X=this.lineAlpha,xa=this.lineColorR,ea=this.dashLength,fa=this.set,Ba,ga=this.getGradRotation(),V=this.chart.columnSpacing,Y=ma.cellWidth,Da=(Y*k-r)/r;V>Da&&(V=Da);var G,v,oa,ha=q,Qa=n,ca=0,tb=0,ub=0,vb=0,lb=0,mb=0,wb=this.fillColorsR,Ra=this.negativeFillColors,Ja=this.negativeLineColor,bb=this.fillAlphas,cb=this.negativeFillAlphas;"object"==typeof bb&&(bb=bb[0]);"object"==typeof cb&&(cb=cb[0]);var xb=this.noRounding;"step"==h&&(xb=!1);var nb=f.getCoordinate(f.min);
f.logarithmic&&(nb=f.getCoordinate(f.minReal));this.minCoord=nb;this.resetBullet&&(this.bullet="none");if(!(J||"line"!=h&&"smoothedLine"!=h&&"step"!=h||(1==e.length&&"step"!=h&&"none"==this.bullet&&(this.bullet="round",this.resetBullet=!0),!Ra&&void 0==Ja||m))){var Ua=Pa;Ua>f.max&&(Ua=f.max);Ua<f.min&&(Ua=f.min);f.logarithmic&&(Ua=f.minReal);var Ka=f.getCoordinate(Ua)+.5,Mb=f.getCoordinate(f.max);t?(ha=q,Qa=Math.abs(Mb-Ka),ub=q,vb=Math.abs(nb-Ka),mb=tb=0,f.reversed?(ca=0,lb=Ka):(ca=Ka,lb=0)):(Qa=
n,ha=Math.abs(Mb-Ka),vb=n,ub=Math.abs(nb-Ka),lb=ca=0,f.reversed?(mb=p,tb=Ka):mb=Ka)}var La=Math.round;this.pmx=La(ca);this.pmy=La(tb);this.pmh=La(ha);this.pmw=La(Qa);this.nmx=La(lb);this.nmy=La(mb);this.nmh=La(ub);this.nmw=La(vb);d.isModern||(this.nmy=this.nmx=0,this.nmh=this.height);this.clustered||(r=1);k="column"==h?(Y*k-V*(r-1))/r:Y*k;1>k&&(k=1);var Nb=this.fixedColumnWidth;isNaN(Nb)||(k=Nb);var L;if("line"==h||"step"==h||"smoothedLine"==h){if(0<P){for(L=P-1;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],
oa=v.values.value,!isNaN(oa)){P=L;break}if(this.lineColorField)for(L=P;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],v.lineColor){this.lineColorSwitched=v.lineColor;void 0===this.bulletColor&&(this.bulletColorSwitched=this.lineColorSwitched);break}if(this.fillColorsField)for(L=P;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],v.fillColors){this.fillColorsSwitched=v.fillColors;break}if(this.dashLengthField)for(L=P;-1<L;L--)if(G=e[L],v=G.axes[f.id].graphs[b],!isNaN(v.dashLength)){this.dashLengthSwitched=
v.dashLength;break}}if(ia<e.length-1)for(L=ia+1;L<e.length;L++)if(G=e[L],v=G.axes[f.id].graphs[b],oa=v.values.value,!isNaN(oa)){ia=L;break}}ia<e.length-1&&ia++;var T=[],U=[],Ma=!1;if("line"==h||"step"==h||"smoothedLine"==h)if(this.stackable&&"regular"==M||"100%"==M||this.fillToGraph)Ma=!0;var Ob=this.noStepRisers,db=-1E3,eb=-1E3,ob=this.minDistance,Sa=!0,Va=!1;for(L=P;L<=ia;L++){G=e[L];v=G.axes[f.id].graphs[b];v.index=L;var fb,Ta=NaN;if(m&&void 0==this.openField)for(var yb=L+1;yb<e.length&&(!e[yb]||
!(fb=e[L+1].axes[f.id].graphs[b])||!fb.values||(Ta=fb.values.value,isNaN(Ta)));yb++);var S,R,K,ba,ja=NaN,E=NaN,F=NaN,O=NaN,N=NaN,qa=NaN,ra=NaN,sa=NaN,ta=NaN,ya=NaN,Ea=NaN,ka=NaN,la=NaN,W=NaN,zb=NaN,Ab=NaN,ua=NaN,va=void 0,Na=wb,Wa=bb,Ha=xa,Ca,za,Bb=this.proCandlesticks,pb=this.topRadius,Fa=q-1,pa=n-1,gb=this.pattern;void 0!=v.pattern&&(gb=v.pattern);isNaN(v.alpha)||(Wa=v.alpha);isNaN(v.dashLength)||(ea=v.dashLength);var Ia=v.values;f.recalculateToPercents&&(Ia=v.percents);"none"==M&&(Z=isNaN(v.columnIndex)?
this.columnIndex:v.columnIndex);if(Ia){W=this.stackable&&"none"!=M&&"3d"!=M?Ia.close:Ia.value;if("candlestick"==h||"ohlc"==h)W=Ia.close,Ab=Ia.low,ra=f.getCoordinate(Ab),zb=Ia.high,ta=f.getCoordinate(zb);ua=Ia.open;F=f.getCoordinate(W,xb);isNaN(ua)||(N=f.getCoordinate(ua,xb),m&&"regular"!=M&&"100%"!=M&&(Ta=ua,ua=N=NaN));m&&(void 0==this.openField?fb&&(fb.isNegative=Ta<W?!0:!1,isNaN(Ta)&&(v.isNegative=!Sa)):v.isNegative=Ta>W?!0:!1);if(!J)switch(this.showBalloonAt){case "close":v.y=F;break;case "open":v.y=
N;break;case "high":v.y=ta;break;case "low":v.y=ra}var ja=G.x[ma.id],Xa=this.periodSpan-1;"step"!=h||isNaN(G.cellWidth)||(Y=G.cellWidth);var wa=Math.floor(Y/2)+Math.floor(Xa*Y/2),Ga=wa,qb=0;"left"==this.stepDirection&&(qb=(2*Y+Xa*Y)/2,ja-=qb);"center"==this.stepDirection&&(qb=Y/2,ja-=qb);"start"==this.pointPosition&&(ja-=Y/2+Math.floor(Xa*Y/2),wa=0,Ga=Math.floor(Y)+Math.floor(Xa*Y));"end"==this.pointPosition&&(ja+=Y/2+Math.floor(Xa*Y/2),wa=Math.floor(Y)+Math.floor(Xa*Y),Ga=0);if(Ob){var Cb=this.columnWidth;
isNaN(Cb)||(wa*=Cb,Ga*=Cb)}J||(v.x=ja);-1E5>ja&&(ja=-1E5);ja>n+1E5&&(ja=n+1E5);t?(E=F,O=N,N=F=ja,isNaN(ua)&&!this.fillToGraph&&(O=na),qa=ra,sa=ta):(O=E=ja,isNaN(ua)&&!this.fillToGraph&&(N=na));if(!Bb&&W<ua||Bb&&W<Ba)v.isNegative=!0,Ra&&(Na=Ra),cb&&(Wa=cb),void 0!=Ja&&(Ha=Ja);Va=!1;isNaN(W)||(m?W>Ta?(Sa&&(Va=!0),Sa=!1):(Sa||(Va=!0),Sa=!0):v.isNegative=W<Pa?!0:!1,Ba=W);var Pb=!1;J&&a.chartScrollbar.ignoreCustomColors&&(Pb=!0);Pb||(void 0!=v.color&&(Na=v.color),v.fillColors&&(Na=v.fillColors));F=d.fitToBounds(F,
-3E4,3E4);switch(h){case "line":if(isNaN(W))z||(this.drawLineGraph(x,u,T,U),x=[],u=[],T=[],U=[]);else{if(Math.abs(E-db)>=ob||Math.abs(F-eb)>=ob)x.push(E),u.push(F),db=E,eb=F;ya=E;Ea=F;ka=E;la=F;!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N));if(Va||void 0!=v.lineColor&&v.lineColor!=this.lineColorSwitched||void 0!=v.fillColors&&v.fillColors!=this.fillColorsSwitched||!isNaN(v.dashLength))this.drawLineGraph(x,u,T,U),x=[E],u=[F],T=[],U=[],!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N)),m?(Sa?(this.lineColorSwitched=
xa,this.fillColorsSwitched=wb):(this.lineColorSwitched=Ja,this.fillColorsSwitched=Ra),void 0===this.bulletColor&&(this.bulletColorSwitched=xa)):(this.lineColorSwitched=v.lineColor,this.fillColorsSwitched=v.fillColors,void 0===this.bulletColor&&(this.bulletColorSwitched=this.lineColorSwitched)),this.dashLengthSwitched=v.dashLength;v.gap&&(this.drawLineGraph(x,u,T,U),x=[],u=[],T=[],U=[],eb=db=-1E3)}break;case "smoothedLine":if(isNaN(W))z||(this.drawSmoothedGraph(x,u,T,U),x=[],u=[],T=[],U=[]);else{if(Math.abs(E-
db)>=ob||Math.abs(F-eb)>=ob)x.push(E),u.push(F),db=E,eb=F;ya=E;Ea=F;ka=E;la=F;!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N));if(Va||void 0!=v.lineColor&&v.lineColor!=this.lineColorSwitched||void 0!=v.fillColors&&v.fillColors!=this.fillColorsSwitched||!isNaN(v.dashLength))this.drawSmoothedGraph(x,u,T,U),x=[E],u=[F],T=[],U=[],!Ma||isNaN(N)||isNaN(O)||(T.push(O),U.push(N)),this.lineColorSwitched=v.lineColor,this.fillColorsSwitched=v.fillColors,this.dashLengthSwitched=v.dashLength;v.gap&&(this.drawSmoothedGraph(x,
u,T,U),x=[],u=[],T=[],U=[])}break;case "step":if(!isNaN(W)){t?(isNaN(A)||(x.push(A),u.push(F-wa)),u.push(F-wa),x.push(E),u.push(F+Ga),x.push(E),!Ma||isNaN(N)||isNaN(O)||(isNaN(B)||(T.push(B),U.push(N-wa)),T.push(O),U.push(N-wa),T.push(O),U.push(N+Ga))):(isNaN(y)||(u.push(y),x.push(E-wa)),x.push(E-wa),u.push(F),x.push(E+Ga),u.push(F),!Ma||isNaN(N)||isNaN(O)||(isNaN(D)||(T.push(O-wa),U.push(D)),T.push(O-wa),U.push(N),T.push(O+Ga),U.push(N)));A=E;y=F;B=O;D=N;ya=E;Ea=F;ka=E;la=F;if(Va||void 0!=v.lineColor||
void 0!=v.fillColors||!isNaN(v.dashLength)){var Db=x[x.length-2],dc=u[u.length-2];x.pop();u.pop();T.pop();U.pop();this.drawLineGraph(x,u,T,U);x=[Db];u=[dc];T=[];U=[];Ma&&(T=[Db,Db+wa+Ga],U=[D,D]);t?(u.push(F+Ga),x.push(E)):(x.push(E+Ga),u.push(F));this.lineColorSwitched=v.lineColor;this.fillColorsSwitched=v.fillColors;this.dashLengthSwitched=v.dashLength;m&&(Sa?(this.lineColorSwitched=xa,this.fillColorsSwitched=wb):(this.lineColorSwitched=Ja,this.fillColorsSwitched=Ra))}if(Ob||v.gap)A=y=NaN,v.gap&&
2>=x.length||this.drawLineGraph(x,u,T,U),x=[],u=[],T=[],U=[]}else if(!z){if(1>=this.periodSpan||1<this.periodSpan&&E-A>wa+Ga)A=y=NaN;this.drawLineGraph(x,u,T,U);x=[];u=[];T=[];U=[]}break;case "column":Ca=Ha;void 0!=v.lineColor&&(Ca=v.lineColor);if(!isNaN(W)){m||(v.isNegative=W<Pa?!0:!1);v.isNegative&&(Ra&&(Na=Ra),void 0!=Ja&&(Ca=Ja));var Qb=f.min,Rb=f.max,rb=ua;isNaN(rb)&&(rb=Pa);if(!(W<Qb&&rb<Qb||W>Rb&&rb>Rb)){var Aa;if(t){"3d"==M?(R=F-(r/2-this.depthCount+1)*(k+V)+V/2+Q*Z,S=O+H*Z,Aa=Z):(R=Math.floor(F-
(r/2-Z)*(k+V)+V/2),S=O,Aa=0);K=k;ya=E;Ea=R+k/2;ka=E;la=R+k/2;R+K>q+Aa*Q&&(K=q-R+Aa*Q);R<Aa*Q&&(K+=R,R=Aa*Q);ba=E-O;var ec=S;S=d.fitToBounds(S,0,n);ba+=ec-S;ba=d.fitToBounds(ba,-S,n-S+H*Z);v.labelIsNegative=0>ba?!0:!1;0===ba&&1/W===1/-0&&(v.labelIsNegative=!0);isNaN(G.percentWidthValue)||(K=this.height*G.percentWidthValue/100,R=ja-K/2,Ea=R+K/2);K=d.roundTo(K,2);ba=d.roundTo(ba,2);R<q&&0<K&&(va=new d.Cuboid(g,ba,K,H-a.d3x,Q-a.d3y,Na,Wa,da,Ca,X,ga,w,t,ea,gb,pb,aa),v.columnWidth=Math.abs(ba),v.columnHeight=
Math.abs(K))}else{"3d"==M?(S=E-(r/2-this.depthCount+1)*(k+V)+V/2+H*Z,R=N+Q*Z,Aa=Z):(S=E-(r/2-Z)*(k+V)+V/2,R=N,Aa=0);K=k;ya=S+k/2;Ea=F;ka=S+k/2;la=F;S+K>n+Aa*H&&(K=n-S+Aa*H);S<Aa*H&&(K+=S-Aa*H,S=Aa*H);ba=F-N;v.labelIsNegative=0<ba?!0:!1;0===ba&&1/W!==1/Math.abs(W)&&(v.labelIsNegative=!0);var fc=R;R=d.fitToBounds(R,this.dy,q);ba+=fc-R;ba=d.fitToBounds(ba,-R+Q*Aa,q-R);isNaN(G.percentWidthValue)||(K=this.width*G.percentWidthValue/100,S=ja-K/2,ya=S+K/2);K=d.roundTo(K,2);ba=d.roundTo(ba,2);S<n+Z*H&&0<K&&
(this.showOnAxis&&(R-=Q/2),va=new d.Cuboid(g,K,ba,H-a.d3x,Q-a.d3y,Na,Wa,da,Ca,this.lineAlpha,ga,w,t,ea,gb,pb,aa),v.columnHeight=Math.abs(ba),v.columnWidth=Math.abs(K))}}if(va){za=va.set;d.setCN(a,va.set,"graph-"+this.type);d.setCN(a,va.set,"graph-"+this.id);v.className&&d.setCN(a,va.set,v.className,!0);v.columnGraphics=za;S=d.roundTo(S,2);R=d.roundTo(R,2);za.translate(S,R);(v.url||this.showHandOnHover)&&za.setAttr("cursor","pointer");if(!J){"none"==M&&(I=t?(this.end+1-L)*C-c:C*L+c);"3d"==M&&(t?(I=
(this.end+1-L)*C-c-1E3*this.depthCount,ya+=H*Z,ka+=H*Z,v.y+=H*Z):(I=(C-c)*(L+1)+1E3*this.depthCount,Ea+=Q*Z,la+=Q*Z,v.y+=Q*Z));if("regular"==M||"100%"==M)I=t?0<Ia.value?(this.end+1-L)*C+c+1E3*this.depthCount:(this.end+1-L)*C-c+1E3*this.depthCount:0<Ia.value?C*L+c:C*L-c;this.columnsArray.push({column:va,depth:I});v.x=t?R+K/2:S+K/2;this.ownColumns.push(va);this.animateColumns(va,L,E,O,F,N);this.addListeners(za,v);void 0!==this.tabIndex&&za.setAttr("tabindex",this.tabIndex)}this.columnsSet.push(za)}}break;
case "candlestick":if(!isNaN(ua)&&!isNaN(W)){var Ya,hb;Ca=Ha;void 0!=v.lineColor&&(Ca=v.lineColor);ya=E;la=Ea=F;ka=E;if(t){"open"==l&&(ka=O);"high"==l&&(ka=sa);"low"==l&&(ka=qa);E=d.fitToBounds(E,0,pa);O=d.fitToBounds(O,0,pa);qa=d.fitToBounds(qa,0,pa);sa=d.fitToBounds(sa,0,pa);if(0===E&&0===O&&0===qa&&0===sa)continue;if(E==pa&&O==pa&&qa==pa&&sa==pa)continue;R=F-k/2;S=O;K=k;R+K>q&&(K=q-R);0>R&&(K+=R,R=0);if(R<q&&0<K){var Eb,Fb;W>ua?(Eb=[E,sa],Fb=[O,qa]):(Eb=[O,sa],Fb=[E,qa]);!isNaN(sa)&&!isNaN(qa)&&
F<q&&0<F&&(Ya=d.line(g,Eb,[F,F],Ca,X,da),hb=d.line(g,Fb,[F,F],Ca,X,da));ba=E-O;va=new d.Cuboid(g,ba,K,H,Q,Na,bb,da,Ca,X,ga,w,t,ea,gb,pb,aa)}}else{"open"==l&&(la=N);"high"==l&&(la=ta);"low"==l&&(la=ra);F=d.fitToBounds(F,0,Fa);N=d.fitToBounds(N,0,Fa);ra=d.fitToBounds(ra,0,Fa);ta=d.fitToBounds(ta,0,Fa);if(0===F&&0===N&&0===ra&&0===ta)continue;if(F==Fa&&N==Fa&&ra==Fa&&ta==Fa)continue;S=E-k/2;R=N+da/2;K=k;S+K>n&&(K=n-S);0>S&&(K+=S,S=0);ba=F-N;if(S<n&&0<K){Bb&&W>=ua&&(Wa=0);var va=new d.Cuboid(g,K,ba,H,
Q,Na,Wa,da,Ca,X,ga,w,t,ea,gb,pb,aa),Gb,Hb;W>ua?(Gb=[F,ta],Hb=[N,ra]):(Gb=[N,ta],Hb=[F,ra]);!isNaN(ta)&&!isNaN(ra)&&E<n&&0<E&&(Ya=d.line(g,[E,E],Gb,Ca,X,da),hb=d.line(g,[E,E],Hb,Ca,X,da),d.setCN(a,Ya,this.bcn+"line-high"),v.className&&d.setCN(a,Ya,v.className,!0),d.setCN(a,hb,this.bcn+"line-low"),v.className&&d.setCN(a,hb,v.className,!0))}}va&&(za=va.set,v.columnGraphics=za,fa.push(za),za.translate(S,R-da/2),(v.url||this.showHandOnHover)&&za.setAttr("cursor","pointer"),Ya&&(fa.push(Ya),fa.push(hb)),
J||(v.x=t?R+K/2:S+K/2,this.animateColumns(va,L,E,O,F,N),this.addListeners(za,v),void 0!==this.tabIndex&&za.setAttr("tabindex",this.tabIndex)))}break;case "ohlc":if(!(isNaN(ua)||isNaN(zb)||isNaN(Ab)||isNaN(W))){var Sb=g.set();fa.push(Sb);W<ua&&(v.isNegative=!0,void 0!=Ja&&(Ha=Ja));void 0!=v.lineColor&&(Ha=v.lineColor);var Za,$a,ab;if(t){la=F;ka=E;"open"==l&&(ka=O);"high"==l&&(ka=sa);"low"==l&&(ka=qa);qa=d.fitToBounds(qa,0,pa);sa=d.fitToBounds(sa,0,pa);if(0===E&&0===O&&0===qa&&0===sa)continue;if(E==
pa&&O==pa&&qa==pa&&sa==pa)continue;var Ib=F-k/2,Ib=d.fitToBounds(Ib,0,q),Tb=d.fitToBounds(F,0,q),Jb=F+k/2,Jb=d.fitToBounds(Jb,0,q);0<=O&&O<=pa&&($a=d.line(g,[O,O],[Ib,Tb],Ha,X,da,ea));0<F&&F<q&&(Za=d.line(g,[qa,sa],[F,F],Ha,X,da,ea));0<=E&&E<=pa&&(ab=d.line(g,[E,E],[Tb,Jb],Ha,X,da,ea))}else{la=F;"open"==l&&(la=N);"high"==l&&(la=ta);"low"==l&&(la=ra);var ka=E,ra=d.fitToBounds(ra,0,Fa),ta=d.fitToBounds(ta,0,Fa),Kb=E-k/2,Kb=d.fitToBounds(Kb,0,n),Ub=d.fitToBounds(E,0,n),Lb=E+k/2,Lb=d.fitToBounds(Lb,0,
n);0<=N&&N<=Fa&&($a=d.line(g,[Kb,Ub],[N,N],Ha,X,da,ea));0<E&&E<n&&(Za=d.line(g,[E,E],[ra,ta],Ha,X,da,ea));0<=F&&F<=Fa&&(ab=d.line(g,[Ub,Lb],[F,F],Ha,X,da,ea))}fa.push($a);fa.push(Za);fa.push(ab);d.setCN(a,$a,this.bcn+"stroke-open");d.setCN(a,ab,this.bcn+"stroke-close");d.setCN(a,Za,this.bcn+"stroke");v.className&&d.setCN(a,Sb,v.className,!0);Za&&this.addListeners(Za,v);ab&&this.addListeners(ab,v);$a&&this.addListeners($a,v);ya=E;Ea=F}}if(!J&&!isNaN(W)){var Vb=this.hideBulletsCount;if(this.end-this.start<=
Vb||0===Vb){var Wb=this.createBullet(v,ka,la,L),Xb=this.labelText;if(Xb&&!isNaN(ya)&&!isNaN(ya)){var gc=this.createLabel(v,Xb),Yb=0;Wb&&(Yb=Wb.size);this.positionLabel(v,ya,Ea,gc,Yb)}if("regular"==M||"100%"==M){var Zb=f.totalText;if(Zb){var Oa=this.createLabel(v,Zb,f.totalTextColor);d.setCN(a,Oa,this.bcn+"label-total");this.allBullets.push(Oa);if(Oa){var $b=Oa.getBBox(),ac=$b.width,bc=$b.height,ib,jb,sb=f.totalTextOffset,cc=f.totals[L];cc&&cc.remove();var kb=0;"column"!=h&&(kb=this.bulletSize);t?
(jb=Ea,ib=0>W?E-ac/2-2-kb-sb:E+ac/2+3+kb+sb):(ib=ya,jb=0>W?F+bc/2+kb+sb:F-bc/2-3-kb-sb);Oa.translate(ib,jb);f.totals[L]=Oa;t?(0>jb||jb>q)&&Oa.remove():(0>ib||ib>n)&&Oa.remove()}}}}}}}this.lastDataItem=v;if("line"==h||"step"==h||"smoothedLine"==h)"smoothedLine"==h?this.drawSmoothedGraph(x,u,T,U):this.drawLineGraph(x,u,T,U),J||this.launchAnimation();this.bulletsHidden&&this.hideBullets();this.customBulletsHidden&&this.hideCustomBullets()},animateColumns:function(a,b){var c=this,e=c.chart.startDuration;
0<e&&!c.animationPlayed&&(c.seqAn?(a.set.hide(),c.animationArray.push(a),e=setTimeout(function(){c.animate.call(c)},e/(c.end-c.start+1)*(b-c.start)*1E3),c.timeOuts.push(e)):c.animate(a),c.chart.animatable.push(a))},createLabel:function(a,b,c){var e=this.chart,g=a.labelColor;g||(g=this.color);g||(g=e.color);c&&(g=c);c=this.fontSize;void 0===c&&(this.fontSize=c=e.fontSize);var f=this.labelFunction;b=e.formatString(b,a);b=d.cleanFromEmpty(b);f&&(b=f(a,b));if(void 0!==b&&""!==b)return a=d.text(this.container,
b,g,e.fontFamily,c),a.node.style.pointerEvents="none",d.setCN(e,a,this.bcn+"label"),this.bulletSet.push(a),a},positiveClip:function(a){a.clipRect(this.pmx,this.pmy,this.pmw,this.pmh)},negativeClip:function(a){a.clipRect(this.nmx,this.nmy,this.nmw,this.nmh)},drawLineGraph:function(a,b,c,e){var g=this;if(1<a.length){var f=g.noRounding,h=g.set,k=g.chart,l=g.container,m=l.set(),n=l.set();h.push(n);h.push(m);var q=g.lineAlpha,p=g.lineThickness,h=g.fillAlphas,t=g.lineColorR,r=g.negativeLineAlpha;isNaN(r)&&
(r=q);var w=g.lineColorSwitched;w&&(t=w);var w=g.fillColorsR,z=g.fillColorsSwitched;z&&(w=z);var x=g.dashLength;(z=g.dashLengthSwitched)&&(x=z);var z=g.negativeLineColor,u=g.negativeFillColors,A=g.negativeFillAlphas,y=g.baseCoord;0!==g.negativeBase&&(y=g.valueAxis.getCoordinate(g.negativeBase,f),y>g.height&&(y=g.height),0>y&&(y=0));q=d.line(l,a,b,t,q,p,x,!1,!1,f);q.node.setAttribute("stroke-linejoin","round");d.setCN(k,q,g.bcn+"stroke");m.push(q);m.click(function(a){g.handleGraphEvent(a,"clickGraph")}).mouseover(function(a){g.handleGraphEvent(a,
"rollOverGraph")}).mouseout(function(a){g.handleGraphEvent(a,"rollOutGraph")}).touchmove(function(a){g.chart.handleMouseMove(a)}).touchend(function(a){g.chart.handleTouchEnd(a)});void 0===z||g.useNegativeColorIfDown||(p=d.line(l,a,b,z,r,p,x,!1,!1,f),p.node.setAttribute("stroke-linejoin","round"),d.setCN(k,p,g.bcn+"stroke"),d.setCN(k,p,g.bcn+"stroke-negative"),n.push(p));if(0<h||0<A)if(p=a.join(";").split(";"),r=b.join(";").split(";"),q=k.type,"serial"==q||"radar"==q?0<c.length?(c.reverse(),e.reverse(),
p=a.concat(c),r=b.concat(e)):"radar"==q?(r.push(0),p.push(0)):g.rotate?(r.push(r[r.length-1]),p.push(y),r.push(r[0]),p.push(y),r.push(r[0]),p.push(p[0])):(p.push(p[p.length-1]),r.push(y),p.push(p[0]),r.push(y),p.push(a[0]),r.push(r[0])):"xy"==q&&(b=g.fillToAxis)&&(d.isString(b)&&(b=k.getValueAxisById(b)),"H"==b.orientation?(y="top"==b.position?0:b.height,p.push(p[p.length-1]),r.push(y),p.push(p[0]),r.push(y),p.push(a[0]),r.push(r[0])):(y="left"==b.position?0:b.width,r.push(r[r.length-1]),p.push(y),
r.push(r[0]),p.push(y),r.push(r[0]),p.push(p[0]))),a=g.gradientRotation,0<h&&(b=d.polygon(l,p,r,w,h,1,"#000",0,a,f),b.pattern(g.pattern,NaN,k.path),d.setCN(k,b,g.bcn+"fill"),m.push(b),b.toBack()),u||void 0!==z)isNaN(A)&&(A=h),u||(u=z),f=d.polygon(l,p,r,u,A,1,"#000",0,a,f),d.setCN(k,f,g.bcn+"fill"),d.setCN(k,f,g.bcn+"fill-negative"),f.pattern(g.pattern,NaN,k.path),n.push(f),f.toBack(),n.click(function(a){g.handleGraphEvent(a,"clickGraph")}).mouseover(function(a){g.handleGraphEvent(a,"rollOverGraph")}).mouseout(function(a){g.handleGraphEvent(a,
"rollOutGraph")}).touchmove(function(a){g.chart.handleMouseMove(a)}).touchend(function(a){g.chart.handleTouchEnd(a)});g.applyMask(n,m)}},applyMask:function(a,b){var c=a.length();"serial"!=this.chart.type||this.scrollbar||(this.positiveClip(b),0<c&&this.negativeClip(a))},drawSmoothedGraph:function(a,b,c,e){if(1<a.length){var g=this.set,f=this.chart,h=this.container,k=h.set(),l=h.set();g.push(l);g.push(k);var m=this.lineAlpha,n=this.lineThickness,g=this.dashLength,q=this.fillAlphas,p=this.lineColorR,
t=this.fillColorsR,r=this.negativeLineColor,w=this.negativeFillColors,z=this.negativeFillAlphas,x=this.baseCoord,u=this.lineColorSwitched;u&&(p=u);(u=this.fillColorsSwitched)&&(t=u);var A=this.negativeLineAlpha;isNaN(A)&&(A=m);u=this.getGradRotation();m=new d.Bezier(h,a,b,p,m,n,t,0,g,void 0,u);d.setCN(f,m,this.bcn+"stroke");k.push(m.path);void 0!==r&&(n=new d.Bezier(h,a,b,r,A,n,t,0,g,void 0,u),d.setCN(f,n,this.bcn+"stroke"),d.setCN(f,n,this.bcn+"stroke-negative"),l.push(n.path));0<q&&(n=a.join(";").split(";"),
m=b.join(";").split(";"),p="",0<c.length?(c.push("M"),e.push("M"),c.reverse(),e.reverse(),n=a.concat(c),m=b.concat(e)):(this.rotate?(p+=" L"+x+","+b[b.length-1],p+=" L"+x+","+b[0]):(p+=" L"+a[a.length-1]+","+x,p+=" L"+a[0]+","+x),p+=" L"+a[0]+","+b[0]),a=new d.Bezier(h,n,m,NaN,0,0,t,q,g,p,u),d.setCN(f,a,this.bcn+"fill"),a.path.pattern(this.pattern,NaN,f.path),k.push(a.path),w||void 0!==r)&&(z||(z=q),w||(w=r),h=new d.Bezier(h,n,m,NaN,0,0,w,z,g,p,u),h.path.pattern(this.pattern,NaN,f.path),d.setCN(f,
h,this.bcn+"fill"),d.setCN(f,h,this.bcn+"fill-negative"),l.push(h.path));this.applyMask(l,k)}},launchAnimation:function(){var a=this,b=a.chart.startDuration;if(0<b&&!a.animationPlayed){var c=a.set,e=a.bulletSet;d.VML||(c.attr({opacity:a.startAlpha}),e.attr({opacity:a.startAlpha}));c.hide();e.hide();a.seqAn?(b=setTimeout(function(){a.animateGraphs.call(a)},a.index*b*1E3),a.timeOuts.push(b)):a.animateGraphs()}},animateGraphs:function(){var a=this.chart,b=this.set,c=this.bulletSet,e=this.x,d=this.y;
b.show();c.show();var f=a.startDuration,h=a.startEffect;b&&(this.rotate?(b.translate(-1E3,d),c.translate(-1E3,d)):(b.translate(e,-1E3),c.translate(e,-1E3)),b.animate({opacity:1,translate:e+","+d},f,h),c.animate({opacity:1,translate:e+","+d},f,h),a.animatable.push(b))},animate:function(a){var b=this.chart,c=this.animationArray;!a&&0<c.length&&(a=c[0],c.shift());c=d[d.getEffect(b.startEffect)];b=b.startDuration;a&&(this.rotate?a.animateWidth(b,c):a.animateHeight(b,c),a.set.show())},legendKeyColor:function(){var a=
this.legendColor,b=this.lineAlpha;void 0===a&&(a=this.lineColorR,0===b&&(b=this.fillColorsR)&&(a="object"==typeof b?b[0]:b));return a},legendKeyAlpha:function(){var a=this.legendAlpha;void 0===a&&(a=this.lineAlpha,this.fillAlphas>a&&(a=this.fillAlphas),0===a&&(a=this.bulletAlpha),0===a&&(a=1));return a},createBullet:function(a,b,c){if(!isNaN(b)&&!isNaN(c)&&("none"!=this.bullet||this.customBullet||a.bullet||a.customBullet)){var e=this.chart,g=this.container,f=this.bulletOffset,h=this.bulletSize;isNaN(a.bulletSize)||
(h=a.bulletSize);var k=a.values.value,l=this.maxValue,m=this.minValue,n=this.maxBulletSize,q=this.minBulletSize;isNaN(l)||(isNaN(k)||(h=(k-m)/(l-m)*(n-q)+q),m==l&&(h=n));l=h;this.bulletAxis&&(h=a.values.error,isNaN(h)||(k=h),h=this.bulletAxis.stepWidth*k);h<this.minBulletSize&&(h=this.minBulletSize);this.rotate?b=a.isNegative?b-f:b+f:c=a.isNegative?c+f:c-f;q=this.bulletColorR;a.lineColor&&void 0===this.bulletColor&&(this.bulletColorSwitched=a.lineColor);this.bulletColorSwitched&&(q=this.bulletColorSwitched);
a.isNegative&&void 0!==this.bulletColorNegative&&(q=this.bulletColorNegative);void 0!==a.color&&(q=a.color);var p;"xy"==e.type&&this.valueField&&(p=this.pattern,a.pattern&&(p=a.pattern));f=this.bullet;a.bullet&&(f=a.bullet);var k=this.bulletBorderThickness,m=this.bulletBorderColorR,n=this.bulletBorderAlpha,t=this.bulletAlpha;m||(m=q);this.useLineColorForBulletBorder&&(m=this.lineColorR,a.isNegative&&this.negativeLineColor&&(m=this.negativeLineColor),this.lineColorSwitched&&(m=this.lineColorSwitched));
var r=a.alpha;isNaN(r)||(t=r);p=d.bullet(g,f,h,q,t,k,m,n,l,0,p,e.path);l=this.customBullet;a.customBullet&&(l=a.customBullet);l&&(p&&p.remove(),"function"==typeof l?(l=new l,l.chart=e,a.bulletConfig&&(l.availableSpace=c,l.graph=this,l.graphDataItem=a,l.bulletY=c,a.bulletConfig.minCoord=this.minCoord-c,l.bulletConfig=a.bulletConfig),l.write(g),p&&l.showBullet&&l.set.push(p),a.customBulletGraphics=l.cset,p=l.set):(p=g.set(),l=g.image(l,0,0,h,h),p.push(l),this.centerCustomBullets&&l.translate(-h/2,-h/
2)));if(p){(a.url||this.showHandOnHover)&&p.setAttr("cursor","pointer");if("serial"==e.type||"gantt"==e.type)if(-.5>b||b>this.width||c<-h/2||c>this.height)p.remove(),p=null;p&&(this.bulletSet.push(p),p.translate(b,c),this.addListeners(p,a),this.allBullets.push(p));a.bx=b;a.by=c;d.setCN(e,p,this.bcn+"bullet");a.className&&d.setCN(e,p,a.className,!0)}if(p){p.size=h||0;if(e=this.bulletHitAreaSize)g=d.circle(g,e,"#FFFFFF",.001,0),g.translate(b,c),a.hitBullet=g,this.bulletSet.push(g),this.addListeners(g,
a);a.bulletGraphics=p;void 0!==this.tabIndex&&p.setAttr("tabindex",this.tabIndex)}else p={size:0};p.graphDataItem=a;return p}},showBullets:function(){var a=this.allBullets,b;this.bulletsHidden=!1;for(b=0;b<a.length;b++)a[b].show()},hideBullets:function(){var a=this.allBullets,b;this.bulletsHidden=!0;for(b=0;b<a.length;b++)a[b].hide()},showCustomBullets:function(){var a=this.allBullets,b;this.customBulletsHidden=!1;for(b=0;b<a.length;b++){var c=a[b].graphDataItem;c&&c.customBulletGraphics&&c.customBulletGraphics.show()}},
hideCustomBullets:function(){var a=this.allBullets,b;this.customBulletsHidden=!0;for(b=0;b<a.length;b++){var c=a[b].graphDataItem;c&&c.customBulletGraphics&&c.customBulletGraphics.hide()}},addListeners:function(a,b){var c=this;a.mouseover(function(a){c.handleRollOver(b,a)}).mouseout(function(a){c.handleRollOut(b,a)}).touchend(function(a){c.handleRollOver(b,a);c.chart.panEventsEnabled&&c.handleClick(b,a)}).touchstart(function(a){c.handleRollOver(b,a)}).click(function(a){c.handleClick(b,a)}).dblclick(function(a){c.handleDoubleClick(b,
a)}).contextmenu(function(a){c.handleRightClick(b,a)});var e=c.chart;if(e.accessible&&c.accessibleLabel){var d=e.formatString(c.accessibleLabel,b);e.makeAccessible(a,d)}},handleRollOver:function(a,b){this.handleGraphEvent(b,"rollOverGraph");if(a){var c=this.chart;a.bulletConfig&&(c.isRolledOverBullet=!0);var e={type:"rollOverGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(e);c.fire(e);clearTimeout(c.hoverInt);(c=c.chartCursor)&&c.valueBalloonsEnabled||this.showGraphBalloon(a,
"V",!0)}},handleRollOut:function(a,b){var c=this.chart;if(a){var e={type:"rollOutGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(e);c.fire(e);c.isRolledOverBullet=!1}this.handleGraphEvent(b,"rollOutGraph");(c=c.chartCursor)&&c.valueBalloonsEnabled||this.hideBalloon()},handleClick:function(a,b){if(!this.chart.checkTouchMoved()&&this.chart.checkTouchDuration(b)){if(a){var c={type:"clickGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,
event:b};this.fire(c);this.chart.fire(c);d.getURL(a.url,this.urlTarget)}this.handleGraphEvent(b,"clickGraph")}},handleGraphEvent:function(a,b){var c={type:b,graph:this,target:this,chart:this.chart,event:a};this.fire(c);this.chart.fire(c)},handleRightClick:function(a,b){if(a){var c={type:"rightClickGraphItem",item:a,index:a.index,graph:this,target:this,chart:this.chart,event:b};this.fire(c);this.chart.fire(c)}},handleDoubleClick:function(a,b){if(a){var c={type:"doubleClickGraphItem",item:a,index:a.index,
graph:this,target:this,chart:this.chart,event:b};this.fire(c);this.chart.fire(c)}},zoom:function(a,b){this.start=a;this.end=b;this.draw()},changeOpacity:function(a){var b=this.set;b&&b.setAttr("opacity",a);if(b=this.ownColumns){var c;for(c=0;c<b.length;c++){var e=b[c].set;e&&e.setAttr("opacity",a)}}(b=this.bulletSet)&&b.setAttr("opacity",a)},destroy:function(){d.remove(this.set);d.remove(this.bulletSet);var a=this.timeOuts;if(a){var b;for(b=0;b<a.length;b++)clearTimeout(a[b])}this.timeOuts=[]},createBalloon:function(){var a=
this.chart;this.balloon?this.balloon.destroy&&this.balloon.destroy():this.balloon={};var b=this.balloon;d.extend(b,a.balloon,!0);b.chart=a;b.mainSet=a.plotBalloonsSet;b.className=this.id},hideBalloon:function(){var a=this,b=a.chart;b.chartCursor?b.chartCursor.valueBalloonsEnabled||b.hideBalloon():b.hideBalloon();clearTimeout(a.hoverInt);a.hoverInt=setTimeout(function(){a.hideBalloonReal.call(a)},b.hideBalloonTime)},hideBalloonReal:function(){this.balloon&&this.balloon.hide();this.fixBulletSize()},
fixBulletSize:function(){if(d.isModern){var a=this.resizedDItem;if(a){var b=a.bulletGraphics;if(b&&!b.doNotScale){b.translate(a.bx,a.by,1);var c=this.bulletAlpha;isNaN(a.alpha)||(c=a.alpha);b.setAttr("fill-opacity",c);b.setAttr("stroke-opacity",this.bulletBorderAlpha)}}this.resizedDItem=null}},showGraphBalloon:function(a,b,c,e,g){if(a){var f=this.chart,h=this.balloon,k=0,l=0,m=f.chartCursor,n=!0;m?m.valueBalloonsEnabled||(h=f.balloon,k=this.x,l=this.y,n=!1):(h=f.balloon,k=this.x,l=this.y,n=!1);clearTimeout(this.hoverInt);
if(f.chartCursor&&(this.currentDataItem=a,"serial"==f.type&&f.isRolledOverBullet&&f.chartCursor.valueBalloonsEnabled)){this.hideBalloonReal();return}this.resizeBullet(a,e,g);if(h&&h.enabled&&this.showBalloon&&!this.hidden){var m=f.formatString(this.balloonText,a,!0),q=this.balloonFunction;q&&(m=q(a,a.graph));m&&(m=d.cleanFromEmpty(m));m&&""!==m?(e=f.getBalloonColor(this,a),h.drop||(h.pointerOrientation=b),b=a.x,g=a.y,f.rotate&&(b=a.y,g=a.x),b+=k,g+=l,isNaN(b)||isNaN(g)?this.hideBalloonReal():(a=this.width,
q=this.height,n&&h.setBounds(k,l,a+k,q+l),h.changeColor(e),h.setPosition(b,g),h.fixPrevious(),h.fixedPosition&&(c=!1),!c&&"radar"!=f.type&&(b<k-.5||b>a+k||g<l-.5||g>q+l)?(h.showBalloon(m),h.hide(0)):(h.followCursor(c),h.showBalloon(m)))):(this.hideBalloonReal(),h.hide(),this.resizeBullet(a,e,g))}else this.hideBalloonReal()}},resizeBullet:function(a,b,c){this.fixBulletSize();if(a&&d.isModern&&(1!=b||!isNaN(c))){var e=a.bulletGraphics;e&&!e.doNotScale&&(e.translate(a.bx,a.by,b),isNaN(c)||(e.setAttr("fill-opacity",
c),e.setAttr("stroke-opacity",c)),this.resizedDItem=a)}}})})();(function(){var d=window.AmCharts;d.ChartCursor=d.Class({construct:function(a){this.cname="ChartCursor";this.createEvents("changed","zoomed","onHideCursor","onShowCursor","draw","selected","moved","panning","zoomStarted");this.enabled=!0;this.cursorAlpha=1;this.selectionAlpha=.2;this.cursorColor="#CC0000";this.categoryBalloonAlpha=1;this.color="#FFFFFF";this.type="cursor";this.zoomed=!1;this.zoomable=!0;this.pan=!1;this.categoryBalloonDateFormat="MMM DD, YYYY";this.categoryBalloonText="[[category]]";
this.categoryBalloonEnabled=this.valueBalloonsEnabled=!0;this.rolledOver=!1;this.cursorPosition="middle";this.bulletsEnabled=this.skipZoomDispatch=!1;this.bulletSize=8;this.selectWithoutZooming=this.oneBalloonOnly=!1;this.graphBulletSize=1.7;this.animationDuration=.3;this.zooming=!1;this.adjustment=0;this.avoidBalloonOverlapping=!0;this.leaveCursor=!1;this.leaveAfterTouch=!0;this.valueZoomable=!1;this.balloonPointerOrientation="horizontal";this.hLineEnabled=this.vLineEnabled=!0;this.vZoomEnabled=
this.hZoomEnabled=!1;d.applyTheme(this,a,this.cname)},draw:function(){this.destroy();var a=this.chart;a.panRequired=!0;var b=a.container;this.rotate=a.rotate;this.container=b;this.prevLineHeight=this.prevLineWidth=NaN;b=b.set();b.translate(this.x,this.y);this.set=b;a.cursorSet.push(b);this.createElements();d.isString(this.limitToGraph)&&(this.limitToGraph=d.getObjById(a.graphs,this.limitToGraph),this.fullWidth=!1,this.cursorPosition="middle");this.pointer=this.balloonPointerOrientation.substr(0,1).toUpperCase();
this.isHidden=!1;this.hideLines();this.valueLineAxis||(this.valueLineAxis=a.valueAxes[0])},createElements:function(){var a=this,b=a.chart,c=b.dx,e=b.dy,g=a.width,f=a.height,h,k,l=a.cursorAlpha,m=a.valueLineAlpha;a.rotate?(h=m,k=l):(k=m,h=l);"xy"==b.type&&(k=l,void 0!==m&&(k=m),h=l);a.vvLine=d.line(a.container,[c,0,0],[e,0,f],a.cursorColor,h,1);d.setCN(b,a.vvLine,"cursor-line");d.setCN(b,a.vvLine,"cursor-line-vertical");a.hhLine=d.line(a.container,[0,g,g+c],[0,0,e],a.cursorColor,k,1);d.setCN(b,a.hhLine,
"cursor-line");d.setCN(b,a.hhLine,"cursor-line-horizontal");a.vLine=a.rotate?a.vvLine:a.hhLine;a.set.push(a.vvLine);a.set.push(a.hhLine);a.set.node.style.pointerEvents="none";a.fullLines=a.container.set();b=b.cursorLineSet;b.push(a.fullLines);b.translate(a.x,a.y);b.clipRect(-1,-1,g+2,f+2);void 0!==a.tabIndex&&(b.setAttr("tabindex",a.tabIndex),b.keyup(function(b){a.handleKeys(b)}).focus(function(b){a.showCursor()}).blur(function(b){a.hideCursor()}));a.set.clipRect(0,0,g,f)},handleKeys:function(a){var b=
this.prevIndex,c=this.chart;if(c){var e=c.chartData;e&&(isNaN(b)&&(b=e.length-1),37!=a.keyCode&&40!=a.keyCode||b--,39!=a.keyCode&&38!=a.keyCode||b++,b=d.fitToBounds(b,c.startIndex,c.endIndex),(a=this.chart.chartData[b])&&this.setPosition(a.x.categoryAxis),this.prevIndex=b)}},update:function(){var a=this.chart;if(a){var b=a.mouseX-this.x,c=a.mouseY-this.y;this.mouseX=b;this.mouseY=c;this.mouse2X=a.mouse2X-this.x;this.mouse2Y=a.mouse2Y-this.y;var e;if(a.chartData&&0<a.chartData.length){this.mouseIsOver()?
(this.hideGraphBalloons=!1,this.rolledOver=e=!0,this.updateDrawing(),this.vvLine&&isNaN(this.fx)&&(a.rotate||!this.limitToGraph)&&this.vvLine.translate(b,0),!this.hhLine||!isNaN(this.fy)||a.rotate&&this.limitToGraph||this.hhLine.translate(0,c),isNaN(this.mouse2X)?this.dispatchMovedEvent(b,c):e=!1):this.forceShow||this.hideCursor();if(this.zooming){if(!isNaN(this.mouse2X)){isNaN(this.mouse2X0)||this.dispatchPanEvent();return}if(this.pan){this.dispatchPanEvent();return}(this.hZoomEnabled||this.vZoomEnabled)&&
this.zooming&&this.updateSelection()}e&&this.showCursor()}}},updateDrawing:function(){this.drawing&&this.chart.setMouseCursor("crosshair");if(this.drawingNow&&(d.remove(this.drawingLine),1<Math.abs(this.drawStartX-this.mouseX)||1<Math.abs(this.drawStartY-this.mouseY))){var a=this.chart,b=a.marginTop,a=a.marginLeft;this.drawingLine=d.line(this.container,[this.drawStartX+a,this.mouseX+a],[this.drawStartY+b,this.mouseY+b],this.cursorColor,1,1)}},fixWidth:function(a){if(this.fullWidth&&this.prevLineWidth!=
a){var b=this.vvLine,c=0;b&&(b.remove(),c=b.x);b=this.container.set();b.translate(c,0);c=d.rect(this.container,a,this.height,this.cursorColor,this.cursorAlpha,this.cursorAlpha,this.cursorColor);d.setCN(this.chart,c,"cursor-fill");c.translate(-a/2-1,0);b.push(c);this.vvLine=b;this.fullLines.push(b);this.prevLineWidth=a}},fixHeight:function(a){if(this.fullWidth&&this.prevLineHeight!=a){var b=this.hhLine,c=0;b&&(b.remove(),c=b.y);b=this.container.set();b.translate(0,c);c=d.rect(this.container,this.width,
a,this.cursorColor,this.cursorAlpha);c.translate(0,-a/2);b.push(c);this.fullLines.push(b);this.hhLine=b;this.prevLineHeight=a}},fixVLine:function(a,b){if(!isNaN(a)&&this.vvLine){if(isNaN(this.prevLineX)){var c=0,e=this.mouseX;if(this.limitToGraph){var d=this.chart.categoryAxis;d&&(this.chart.rotate||(c="bottom"==d.position?this.height:-this.height),e=a)}this.vvLine.translate(e,c)}else this.prevLineX!=a&&this.vvLine.translate(this.prevLineX,this.prevLineY);this.fx=a;this.prevLineX!=a&&(c=this.animationDuration,
this.zooming&&(c=0),this.vvLine.stop(),this.vvLine.animate({translate:a+","+b},c,"easeOutSine"),this.prevLineX=a,this.prevLineY=b)}},fixHLine:function(a,b){if(!isNaN(a)&&this.hhLine){if(isNaN(this.prevLineY)){var c=0,e=this.mouseY;if(this.limitToGraph){var d=this.chart.categoryAxis;d&&(this.chart.rotate&&(c="right"==d.position?this.width:-this.width),e=a)}this.hhLine.translate(c,e)}else this.prevLineY!=a&&this.hhLine.translate(this.prevLineX,this.prevLineY);this.fy=a;this.prevLineY!=a&&(c=this.animationDuration,
this.zooming&&(c=0),this.hhLine.stop(),this.hhLine.animate({translate:b+","+a},c,"easeOutSine"),this.prevLineY=a,this.prevLineX=b)}},hideCursor:function(a){this.forceShow=!1;this.chart.wasTouched&&this.leaveAfterTouch||this.isHidden||this.leaveCursor||(this.hideCursorReal(),a?this.chart.handleCursorHide():this.fire({target:this,chart:this.chart,type:"onHideCursor"}),this.chart.setMouseCursor("auto"))},hideCursorReal:function(){this.hideLines();this.isHidden=!0;this.index=this.prevLineY=this.prevLineX=
this.mouseY0=this.mouseX0=this.fy=this.fx=NaN},hideLines:function(){this.vvLine&&this.vvLine.hide();this.hhLine&&this.hhLine.hide();this.fullLines&&this.fullLines.hide();this.isHidden=!0;this.chart.handleCursorHide()},showCursor:function(a){!this.drawing&&this.enabled&&(this.vLineEnabled&&this.vvLine&&this.vvLine.show(),this.hLineEnabled&&this.hhLine&&this.hhLine.show(),this.isHidden=!1,this.updateFullLine(),a||this.fire({target:this,chart:this.chart,type:"onShowCursor"}),this.pan&&this.chart.setMouseCursor("move"))},
updateFullLine:function(){this.zooming&&this.fullWidth&&this.selection&&(this.rotate?0<this.selection.height&&this.hhLine.hide():0<this.selection.width&&this.vvLine.hide())},updateSelection:function(){if(!this.pan&&this.enabled){var a=this.mouseX,b=this.mouseY;isNaN(this.fx)||(a=this.fx);isNaN(this.fy)||(b=this.fy);this.clearSelection();var c=this.mouseX0,e=this.mouseY0,g=this.width,f=this.height,a=d.fitToBounds(a,0,g),b=d.fitToBounds(b,0,f),h;a<c&&(h=a,a=c,c=h);b<e&&(h=b,b=e,e=h);this.hZoomEnabled?
g=a-c:c=0;this.vZoomEnabled?f=b-e:e=0;isNaN(this.mouse2X)&&0<Math.abs(g)&&0<Math.abs(f)&&(a=this.chart,b=d.rect(this.container,g,f,this.cursorColor,this.selectionAlpha),d.setCN(a,b,"cursor-selection"),b.width=g,b.height=f,b.translate(c,e),this.set.push(b),this.selection=b);this.updateFullLine()}},mouseIsOver:function(){var a=this.mouseX,b=this.mouseY;if(this.justReleased)return this.justReleased=!1,!0;if(this.mouseIsDown)return!0;if(!this.chart.mouseIsOver)return this.handleMouseOut(),!1;if(0<a&&
a<this.width&&0<b&&b<this.height)return!0;this.handleMouseOut();return!1},fixPosition:function(){this.prevY=this.prevX=NaN},handleMouseDown:function(){this.update();if(this.mouseIsOver())if(this.mouseIsDown=!0,this.mouseX0=this.mouseX,this.mouseY0=this.mouseY,this.mouse2X0=this.mouse2X,this.mouse2Y0=this.mouse2Y,this.drawing)this.drawStartY=this.mouseY,this.drawStartX=this.mouseX,this.drawingNow=!0;else if(this.dispatchMovedEvent(this.mouseX,this.mouseY),!this.pan&&isNaN(this.mouse2X0)&&(isNaN(this.fx)||
(this.mouseX0=this.fx),isNaN(this.fy)||(this.mouseY0=this.fy)),this.hZoomEnabled||this.vZoomEnabled){this.zooming=!0;var a={chart:this.chart,target:this,type:"zoomStarted"};a.x=this.mouseX/this.width;a.y=this.mouseY/this.height;this.index0=a.index=this.index;this.timestamp0=this.timestamp;this.fire(a)}},registerInitialMouse:function(){},handleReleaseOutside:function(){this.mouseIsDown=!1;if(this.drawingNow){this.drawingNow=!1;d.remove(this.drawingLine);var a=this.drawStartX,b=this.drawStartY,c=this.mouseX,
e=this.mouseY,g=this.chart;(2<Math.abs(a-c)||2<Math.abs(b-e))&&this.fire({type:"draw",target:this,chart:g,initialX:a,initialY:b,finalX:c,finalY:e})}this.zooming&&(this.zooming=!1,this.selectWithoutZooming?this.dispatchZoomEvent("selected"):(this.hZoomEnabled||this.vZoomEnabled)&&this.dispatchZoomEvent("zoomed"),this.rolledOver&&this.dispatchMovedEvent(this.mouseX,this.mouseY));this.mouse2Y0=this.mouse2X0=this.mouseY0=this.mouseX0=NaN},dispatchZoomEvent:function(a){if(!this.pan){var b=this.selection;
if(b&&3<Math.abs(b.width)&&3<Math.abs(b.height)){var c=Math.min(this.index,this.index0),e=Math.max(this.index,this.index0),d=c,f=e,h=this.chart,k=h.chartData,l=h.categoryAxis;l&&l.parseDates&&!l.equalSpacing&&(d=k[c]?k[c].time:Math.min(this.timestamp0,this.timestamp),f=k[e]?h.getEndTime(k[e].time):Math.max(this.timestamp0,this.timestamp));var b={type:a,chart:this.chart,target:this,end:f,start:d,startIndex:c,endIndex:e,selectionHeight:b.height,selectionWidth:b.width,selectionY:b.y,selectionX:b.x},
m;this.hZoomEnabled&&4<Math.abs(this.mouseX0-this.mouseX)&&(b.startX=this.mouseX0/this.width,b.endX=this.mouseX/this.width,m=!0);this.vZoomEnabled&&4<Math.abs(this.mouseY0-this.mouseY)&&(b.startY=1-this.mouseY0/this.height,b.endY=1-this.mouseY/this.height,m=!0);m&&(this.prevY=this.prevX=NaN,this.fire(b),"selected"!=a&&this.clearSelection());this.hideCursor()}}},dispatchMovedEvent:function(a,b,c,e){a=Math.round(a);b=Math.round(b);if(!this.isHidden&&(a!=this.prevX||b!=this.prevY||"changed"==c)){c||
(c="moved");var d=this.fx,f=this.fy;isNaN(d)&&(d=a);isNaN(f)&&(f=b);var h=!1;this.zooming&&this.pan&&(h=!0);h={hidden:this.isHidden,type:c,chart:this.chart,target:this,x:a,y:b,finalX:d,finalY:f,zooming:this.zooming,panning:h,mostCloseGraph:this.mostCloseGraph,index:this.index,skip:e,hideBalloons:this.hideGraphBalloons};this.prevIndex=this.index;this.rotate?(h.position=b,h.finalPosition=f):(h.position=a,h.finalPosition=d);this.prevX=a;this.prevY=b;e?this.chart.handleCursorMove(h):(this.fire(h),"changed"==
c&&this.chart.fire(h))}},dispatchPanEvent:function(){if(this.mouseIsDown){var a=d.roundTo((this.mouseX-this.mouseX0)/this.width,3),b=d.roundTo((this.mouseY-this.mouseY0)/this.height,3),c=d.roundTo((this.mouse2X-this.mouse2X0)/this.width,3),e=d.roundTo((this.mouse2Y-this.mouse2Y0)/this.height,2),g=!1;0!==Math.abs(a)&&0!==Math.abs(b)&&(g=!0);if(this.prevDeltaX==a||this.prevDeltaY==b)g=!1;isNaN(c)||isNaN(e)||(0!==Math.abs(c)&&0!==Math.abs(e)&&(g=!0),this.prevDelta2X!=c&&this.prevDelta2Y!=e)||(g=!1);
g&&(this.hideLines(),this.fire({type:"panning",chart:this.chart,target:this,deltaX:a,deltaY:b,delta2X:c,delta2Y:e,index:this.index}),this.prevDeltaX=a,this.prevDeltaY=b,this.prevDelta2X=c,this.prevDelta2Y=e)}},clearSelection:function(){var a=this.selection;a&&(a.width=0,a.height=0,a.remove())},destroy:function(){this.clear();d.remove(this.selection);this.selection=null;clearTimeout(this.syncTO);d.remove(this.set)},clear:function(){},setTimestamp:function(a){this.timestamp=a},setIndex:function(a,b){a!=
this.index&&(this.index=a,b||this.isHidden||this.dispatchMovedEvent(this.mouseX,this.mouseY,"changed"))},handleMouseOut:function(){this.enabled&&this.rolledOver&&(this.leaveCursor||this.setIndex(void 0),this.forceShow=!1,this.hideCursor(),this.rolledOver=!1)},showCursorAt:function(a){var b=this.chart.categoryAxis;b&&this.setPosition(b.categoryToCoordinate(a),a)},setPosition:function(a,b){var c=this.chart,e=c.categoryAxis;if(e){var d,f;void 0===b&&(b=e.coordinateToValue(a));e.showBalloonAt(b,a);this.forceShow=
!0;e.stickBalloonToCategory?c.rotate?this.fixHLine(a,0):this.fixVLine(a,0):(this.showCursor(),c.rotate?this.hhLine.translate(0,a):this.vvLine.translate(a,0));c.rotate?d=a:f=a;c.rotate?(this.vvLine&&this.vvLine.hide(),this.hhLine&&this.hhLine.show()):(this.hhLine&&this.hhLine.hide(),this.vvLine&&this.vvLine.show());this.updateFullLine();this.isHidden=!1;this.dispatchMovedEvent(f,d,"moved",!0)}},enableDrawing:function(a){this.enabled=!a;this.hideCursor();this.drawing=a},syncWithCursor:function(a,b){clearTimeout(this.syncTO);
a&&(a.isHidden?this.hideCursor(!0):this.syncWithCursorReal(a,b))},isZooming:function(a){this.zooming=a},syncWithCursorReal:function(a,b){var c=a.vvLine,e=a.hhLine;this.index=a.index;this.forceShow=!0;this.zooming&&this.pan||this.showCursor(!0);this.hideGraphBalloons=b;this.justReleased=a.justReleased;this.zooming=a.zooming;this.index0=a.index0;this.mouseX0=a.mouseX0;this.mouseY0=a.mouseY0;this.mouse2X0=a.mouse2X0;this.mouse2Y0=a.mouse2Y0;this.timestamp0=a.timestamp0;this.prevDeltaX=a.prevDeltaX;this.prevDeltaY=
a.prevDeltaY;this.prevDelta2X=a.prevDelta2X;this.prevDelta2Y=a.prevDelta2Y;this.fx=a.fx;this.fy=a.fy;a.zooming&&this.updateSelection();var d=a.mouseX,f=a.mouseY;this.rotate?(d=NaN,this.vvLine&&this.vvLine.hide(),this.hhLine&&e&&(isNaN(a.fy)?this.hhLine.translate(0,a.mouseY):this.fixHLine(a.fy,0))):(f=NaN,this.hhLine&&this.hhLine.hide(),this.vvLine&&c&&(isNaN(a.fx)?this.vvLine.translate(a.mouseX,0):this.fixVLine(a.fx,0)));this.dispatchMovedEvent(d,f,"moved",!0)}})})();(function(){var d=window.AmCharts;d.SimpleChartScrollbar=d.Class({construct:function(a){this.createEvents("zoomed","zoomStarted","zoomEnded");this.backgroundColor="#D4D4D4";this.backgroundAlpha=1;this.selectedBackgroundColor="#EFEFEF";this.scrollDuration=this.selectedBackgroundAlpha=1;this.resizeEnabled=!0;this.hideResizeGrips=!1;this.scrollbarHeight=20;this.updateOnReleaseOnly=!1;9>document.documentMode&&(this.updateOnReleaseOnly=!0);this.dragIconHeight=this.dragIconWidth=35;this.dragIcon="dragIconRoundBig";
this.dragCursorHover="cursor: move; cursor: grab; cursor: -moz-grab; cursor: -webkit-grab;";this.dragCursorDown="cursor: move; cursor: grab; cursor: -moz-grabbing; cursor: -webkit-grabbing;";this.vResizeCursor="ns-resize";this.hResizeCursor="ew-resize";this.enabled=!0;this.percentStart=this.offset=0;this.percentEnd=1;d.applyTheme(this,a,"SimpleChartScrollbar")},getPercents:function(){var a=this.getDBox(),b=a.x,c=a.y,e=a.width,a=a.height;this.rotate?(b=1-c/this.height,c=1-(c+a)/this.height):(c=b/this.width,
b=(b+e)/this.width);this.percentStart=c;this.percentEnd=b},draw:function(){var a=this;a.destroy();if(a.enabled){var b=a.chart.container,c=a.rotate,e=a.chart;e.panRequired=!0;var g=b.set();a.set=g;c?d.setCN(e,g,"scrollbar-vertical"):d.setCN(e,g,"scrollbar-horizontal");e.scrollbarsSet.push(g);var f,h;c?(f=a.scrollbarHeight,h=e.plotAreaHeight):(h=a.scrollbarHeight,f=e.plotAreaWidth);a.width=f;if((a.height=h)&&f){var k=d.rect(b,f,h,a.backgroundColor,a.backgroundAlpha,1,a.backgroundColor,a.backgroundAlpha);
d.setCN(e,k,"scrollbar-bg");a.bg=k;g.push(k);k=d.rect(b,f,h,"#000",.005);g.push(k);a.invisibleBg=k;k.click(function(){a.handleBgClick()}).mouseover(function(){a.handleMouseOver()}).mouseout(function(){a.handleMouseOut()}).touchend(function(){a.handleBgClick()});k=d.rect(b,f,h,a.selectedBackgroundColor,a.selectedBackgroundAlpha);d.setCN(e,k,"scrollbar-bg-selected");a.selectedBG=k;g.push(k);f=d.rect(b,f,h,"#000",.005);a.dragger=f;g.push(f);f.mousedown(function(b){a.handleDragStart(b)}).mouseup(function(){a.handleDragStop()}).mouseover(function(){a.handleDraggerOver()}).mouseout(function(){a.handleMouseOut()}).touchstart(function(b){a.handleDragStart(b)}).touchend(function(){a.handleDragStop()});
h=e.pathToImages;var l,k=a.dragIcon.replace(/\.[a-z]*$/i,"");d.isAbsolute(k)&&(h="");c?(l=h+k+"H"+e.extension,h=a.dragIconWidth,c=a.dragIconHeight):(l=h+k+e.extension,c=a.dragIconWidth,h=a.dragIconHeight);k=b.image(l,0,0,c,h);d.setCN(e,k,"scrollbar-grip-left");l=b.image(l,0,0,c,h);d.setCN(e,l,"scrollbar-grip-right");var m=10,n=20;e.panEventsEnabled&&(m=25,n=a.scrollbarHeight);var q=d.rect(b,m,n,"#000",.005),p=d.rect(b,m,n,"#000",.005);p.translate(-(m-c)/2,-(n-h)/2);q.translate(-(m-c)/2,-(n-h)/2);
c=b.set([k,p]);b=b.set([l,q]);a.iconLeft=c;g.push(a.iconLeft);a.iconRight=b;g.push(b);a.updateGripCursor(!1);e.makeAccessible(c,a.accessibleLabel);e.makeAccessible(b,a.accessibleLabel);e.makeAccessible(f,a.accessibleLabel);c.setAttr("role","menuitem");b.setAttr("role","menuitem");f.setAttr("role","menuitem");void 0!==a.tabIndex&&(c.setAttr("tabindex",a.tabIndex),c.keyup(function(b){a.handleKeys(b,1,0)}));void 0!==a.tabIndex&&(f.setAttr("tabindex",a.tabIndex),f.keyup(function(b){a.handleKeys(b,1,1)}));
void 0!==a.tabIndex&&(b.setAttr("tabindex",a.tabIndex),b.keyup(function(b){a.handleKeys(b,0,1)}));c.mousedown(function(){a.leftDragStart()}).mouseup(function(){a.leftDragStop()}).mouseover(function(){a.iconRollOver()}).mouseout(function(){a.iconRollOut()}).touchstart(function(){a.leftDragStart()}).touchend(function(){a.leftDragStop()});b.mousedown(function(){a.rightDragStart()}).mouseup(function(){a.rightDragStop()}).mouseover(function(){a.iconRollOver()}).mouseout(function(){a.iconRollOut()}).touchstart(function(){a.rightDragStart()}).touchend(function(){a.rightDragStop()});
d.ifArray(e.chartData)?g.show():g.hide();a.hideDragIcons();a.clipDragger(!1)}g.translate(a.x,a.y);g.node.style.msTouchAction="none";g.node.style.touchAction="none"}},handleKeys:function(a,b,c){this.getPercents();var e=this.percentStart,d=this.percentEnd;if(this.rotate)var f=d,d=e,e=f;if(37==a.keyCode||40==a.keyCode)e-=.02*b,d-=.02*c;if(39==a.keyCode||38==a.keyCode)e+=.02*b,d+=.02*c;this.rotate&&(a=d,d=e,e=a);isNaN(d)||isNaN(e)||this.percentZoom(e,d,!0)},updateScrollbarSize:function(a,b){if(!isNaN(a)&&
!isNaN(b)){a=Math.round(a);b=Math.round(b);var c=this.dragger,e,d,f,h,k;this.rotate?(e=0,d=a,f=this.width+1,h=b-a,c.setAttr("height",b-a),c.setAttr("y",d)):(e=a,d=0,f=b-a,h=this.height+1,k=b-a,c.setAttr("x",e),c.setAttr("width",k));this.clipAndUpdate(e,d,f,h)}},update:function(){var a,b=!1,c,e,d=this.x,f=this.y,h=this.dragger,k=this.getDBox();if(k){c=k.x+d;e=k.y+f;var l=k.width,k=k.height,m=this.rotate,n=this.chart,q=this.width,p=this.height,t=n.mouseX,n=n.mouseY;a=this.initialMouse;this.forceClip&&
this.clipDragger(!0);if(this.dragging){var r=this.initialCoord;if(m)a=r+(n-a),0>a&&(a=0),r=p-k,a>r&&(a=r),h.setAttr("y",a);else{a=r+(t-a);0>a&&(a=0);r=q-l;if(a>r||isNaN(a))a=r;h.setAttr("x",a)}this.clipDragger(!0)}if(this.resizingRight){if(m)if(a=n-e,!isNaN(this.maxHeight)&&a>this.maxHeight&&(a=this.maxHeight),a+e>p+f&&(a=p-e+f),0>a)this.resizingRight=!1,b=this.resizingLeft=!0;else{if(0===a||isNaN(a))a=.1;h.setAttr("height",a)}else if(a=t-c,!isNaN(this.maxWidth)&&a>this.maxWidth&&(a=this.maxWidth),
a+c>q+d&&(a=q-c+d),0>a)this.resizingRight=!1,b=this.resizingLeft=!0;else{if(0===a||isNaN(a))a=.1;h.setAttr("width",a)}this.clipDragger(!0)}if(this.resizingLeft){if(m)if(c=e,e=n,e<f&&(e=f),isNaN(e)&&(e=f),e>p+f&&(e=p+f),a=!0===b?c-e:k+c-e,!isNaN(this.maxHeight)&&a>this.maxHeight&&(a=this.maxHeight,e=c),0>a)this.resizingRight=!0,this.resizingLeft=!1,h.setAttr("y",c+k-f);else{if(0===a||isNaN(a))a=.1;h.setAttr("y",e-f);h.setAttr("height",a)}else if(e=t,e<d&&(e=d),isNaN(e)&&(e=d),e>q+d&&(e=q+d),a=!0===
b?c-e:l+c-e,!isNaN(this.maxWidth)&&a>this.maxWidth&&(a=this.maxWidth,e=c),0>a)this.resizingRight=!0,this.resizingLeft=!1,h.setAttr("x",c+l-d);else{if(0===a||isNaN(a))a=.1;h.setAttr("x",e-d);h.setAttr("width",a)}this.clipDragger(!0)}}},stopForceClip:function(){this.animating=this.forceClip=!1},clipDragger:function(a){var b=this.getDBox();if(b){var c=b.x,e=b.y,d=b.width,b=b.height,f=!1;if(this.rotate){if(c=0,d=this.width+1,this.clipY!=e||this.clipH!=b)f=!0}else if(e=0,b=this.height+1,this.clipX!=c||
this.clipW!=d)f=!0;f&&this.clipAndUpdate(c,e,d,b);a&&(this.updateOnReleaseOnly||this.dispatchScrollbarEvent())}},maskGraphs:function(){},clipAndUpdate:function(a,b,c,e){this.clipX=a;this.clipY=b;this.clipW=c;this.clipH=e;this.selectedBG.setAttr("width",c);this.selectedBG.setAttr("height",e);this.selectedBG.translate(a,b);this.updateDragIconPositions();this.maskGraphs(a,b,c,e)},dispatchScrollbarEvent:function(){if(this.skipEvent)this.skipEvent=!1;else{var a=this.chart;a.hideBalloon();var b=this.getDBox(),
c=b.x,e=b.y,d=b.width,b=b.height;this.getPercents();this.rotate?(c=e,d=this.height/b):d=this.width/d;a={type:"zoomed",position:c,chart:a,target:this,multiplier:d,relativeStart:this.percentStart,relativeEnd:this.percentEnd};if(this.percentStart!=this.prevPercentStart||this.percentEnd!=this.prevPercentEnd||this.prevMultiplier!=d)this.fire(a),this.prevPercentStart=this.percentStart,this.prevPercentEnd=this.percentEnd,this.prevMultiplier=d}},updateDragIconPositions:function(){var a=this.getDBox(),b=a.x,
c=a.y,d=this.iconLeft,g=this.iconRight,f,h,k=this.scrollbarHeight;this.rotate?(f=this.dragIconWidth,h=this.dragIconHeight,d.translate((k-h)/2,c-f/2),g.translate((k-h)/2,c+a.height-f/2)):(f=this.dragIconHeight,h=this.dragIconWidth,d.translate(b-h/2,(k-f)/2),g.translate(b-h/2+a.width,(k-f)/2))},showDragIcons:function(){this.resizeEnabled&&(this.iconLeft.show(),this.iconRight.show())},hideDragIcons:function(){if(!this.resizingLeft&&!this.resizingRight&&!this.dragging){if(this.hideResizeGrips||!this.resizeEnabled)this.iconLeft.hide(),
this.iconRight.hide();this.removeCursors()}},removeCursors:function(){this.chart.setMouseCursor("auto")},fireZoomEvent:function(a){this.fire({type:a,chart:this.chart,target:this})},percentZoom:function(a,b,c){a=d.fitToBounds(a,0,b);b=d.fitToBounds(b,a,1);if(this.dragger&&this.enabled){this.dragger.stop();isNaN(a)&&(a=0);isNaN(b)&&(b=1);var e,g;this.rotate?(e=this.height,b=e-e*b,g=e-e*a):(e=this.width,g=e*b,b=e*a);this.updateScrollbarSize(b,g);this.clipDragger(!1);this.getPercents();c&&this.dispatchScrollbarEvent()}},
destroy:function(){this.clear();d.remove(this.set);d.remove(this.iconRight);d.remove(this.iconLeft)},clear:function(){},handleDragStart:function(){if(this.enabled){this.fireZoomEvent("zoomStarted");var a=this.chart;this.dragger.stop();this.removeCursors();d.isModern&&(this.dragger.node.style.cssText=this.dragCursorDown);this.dragging=!0;var b=this.getDBox();this.rotate?(this.initialCoord=b.y,this.initialMouse=a.mouseY):(this.initialCoord=b.x,this.initialMouse=a.mouseX)}},handleDragStop:function(){this.updateOnReleaseOnly&&
(this.update(),this.skipEvent=!1,this.dispatchScrollbarEvent());this.dragging=!1;this.mouseIsOver&&this.removeCursors();d.isModern&&(this.dragger.node.style.cssText=this.dragCursorHover);this.update();this.fireZoomEvent("zoomEnded")},handleDraggerOver:function(){this.handleMouseOver();d.isModern&&(this.dragger.node.style.cssText=this.dragCursorHover)},leftDragStart:function(){this.fireZoomEvent("zoomStarted");this.dragger.stop();this.resizingLeft=!0;this.updateGripCursor(!0)},updateGripCursor:function(a){d.isModern&&
(a=this.rotate?a?this.vResizeCursorDown:this.vResizeCursorHover:a?this.hResizeCursorDown:this.hResizeCursorHover)&&(this.iconRight&&(this.iconRight.node.style.cssText=a),this.iconLeft&&(this.iconLeft.node.style.cssText=a))},leftDragStop:function(){this.resizingLeft&&(this.resizingLeft=!1,this.mouseIsOver||this.removeCursors(),this.updateOnRelease(),this.fireZoomEvent("zoomEnded"));this.updateGripCursor(!1)},rightDragStart:function(){this.fireZoomEvent("zoomStarted");this.dragger.stop();this.resizingRight=
!0;this.updateGripCursor(!0)},rightDragStop:function(){this.resizingRight&&(this.resizingRight=!1,this.mouseIsOver||this.removeCursors(),this.updateOnRelease(),this.fireZoomEvent("zoomEnded"));this.updateGripCursor(!1)},iconRollOut:function(){this.removeCursors()},iconRollOver:function(){this.rotate?this.vResizeCursor&&this.chart.setMouseCursor(this.vResizeCursor):this.hResizeCursor&&this.chart.setMouseCursor(this.hResizeCursor);this.handleMouseOver()},getDBox:function(){if(this.dragger)return this.dragger.getBBox()},
handleBgClick:function(){var a=this;if(!a.resizingRight&&!a.resizingLeft){a.zooming=!0;var b,c,e=a.scrollDuration,g=a.dragger;b=a.getDBox();var f=b.height,h=b.width;c=a.chart;var k=a.y,l=a.x,m=a.rotate;m?(b="y",c=c.mouseY-f/2-k,c=d.fitToBounds(c,0,a.height-f)):(b="x",c=c.mouseX-h/2-l,c=d.fitToBounds(c,0,a.width-h));a.updateOnReleaseOnly?(a.skipEvent=!1,g.setAttr(b,c),a.dispatchScrollbarEvent(),a.clipDragger()):(a.animating=!0,c=Math.round(c),m?g.animate({y:c},e,">"):g.animate({x:c},e,">"),a.forceClip=
!0,clearTimeout(a.forceTO),a.forceTO=setTimeout(function(){a.stopForceClip.call(a)},5E3*e))}},updateOnRelease:function(){this.updateOnReleaseOnly&&(this.update(),this.skipEvent=!1,this.dispatchScrollbarEvent())},handleReleaseOutside:function(){if(this.set){if(this.resizingLeft||this.resizingRight||this.dragging)this.dragging=this.resizingRight=this.resizingLeft=!1,this.updateOnRelease(),this.removeCursors();this.animating=this.mouseIsOver=!1;this.hideDragIcons();this.update()}},handleMouseOver:function(){this.mouseIsOver=
!0;this.showDragIcons()},handleMouseOut:function(){this.mouseIsOver=!1;this.hideDragIcons();this.removeCursors()}})})();(function(){var d=window.AmCharts;d.ChartScrollbar=d.Class({inherits:d.SimpleChartScrollbar,construct:function(a){this.cname="ChartScrollbar";d.ChartScrollbar.base.construct.call(this,a);this.graphLineColor="#BBBBBB";this.graphLineAlpha=0;this.graphFillColor="#BBBBBB";this.graphFillAlpha=1;this.selectedGraphLineColor="#888888";this.selectedGraphLineAlpha=0;this.selectedGraphFillColor="#888888";this.selectedGraphFillAlpha=1;this.gridCount=0;this.gridColor="#FFFFFF";this.gridAlpha=.7;this.skipEvent=
this.autoGridCount=!1;this.color="#FFFFFF";this.scrollbarCreated=!1;this.oppositeAxis=!0;this.accessibleLabel="Zoom chart using cursor arrows";d.applyTheme(this,a,this.cname)},init:function(){var a=this.categoryAxis,b=this.chart,c=this.gridAxis;a||("CategoryAxis"==this.gridAxis.cname?(this.catScrollbar=!0,a=new d.CategoryAxis,a.id="scrollbar"):(a=new d.ValueAxis,a.data=b.chartData,a.id=c.id,a.type=c.type,a.maximumDate=c.maximumDate,a.minimumDate=c.minimumDate,a.minPeriod=c.minPeriod,a.minMaxField=
c.minMaxField),this.categoryAxis=a);a.chart=b;var e=b.categoryAxis;e&&(a.firstDayOfWeek=e.firstDayOfWeek);a.dateFormats=c.dateFormats;a.markPeriodChange=c.markPeriodChange;a.boldPeriodBeginning=c.boldPeriodBeginning;a.labelFunction=c.labelFunction;a.axisItemRenderer=d.RecItem;a.axisRenderer=d.RecAxis;a.guideFillRenderer=d.RecFill;a.inside=!0;a.fontSize=this.fontSize;a.tickLength=0;a.axisAlpha=0;d.isString(this.graph)&&(this.graph=d.getObjById(b.graphs,this.graph));(a=this.graph)&&this.catScrollbar&&
(c=this.valueAxis,c||(this.valueAxis=c=new d.ValueAxis,c.visible=!1,c.scrollbar=!0,c.axisItemRenderer=d.RecItem,c.axisRenderer=d.RecAxis,c.guideFillRenderer=d.RecFill,c.labelsEnabled=!1,c.chart=b),b=this.unselectedGraph,b||(b=new d.AmGraph,b.scrollbar=!0,this.unselectedGraph=b,b.negativeBase=a.negativeBase,b.noStepRisers=a.noStepRisers),b=this.selectedGraph,b||(b=new d.AmGraph,b.scrollbar=!0,this.selectedGraph=b,b.negativeBase=a.negativeBase,b.noStepRisers=a.noStepRisers));this.scrollbarCreated=!0},
draw:function(){var a=this;d.ChartScrollbar.base.draw.call(a);if(a.enabled){a.scrollbarCreated||a.init();var b=a.chart,c=b.chartData,e=a.categoryAxis,g=a.rotate,f=a.x,h=a.y,k=a.width,l=a.height,m=a.gridAxis,n=a.set;e.setOrientation(!g);e.parseDates=m.parseDates;"ValueAxis"==a.categoryAxis.cname&&(e.rotate=!g);e.equalSpacing=m.equalSpacing;e.minPeriod=m.minPeriod;e.startOnAxis=m.startOnAxis;e.width=k-1;e.height=l;e.gridCount=a.gridCount;e.gridColor=a.gridColor;e.gridAlpha=a.gridAlpha;e.color=a.color;
e.tickLength=0;e.axisAlpha=0;e.autoGridCount=a.autoGridCount;e.parseDates&&!e.equalSpacing&&e.timeZoom(b.firstTime,b.lastTime);e.minimum=a.gridAxis.fullMin;e.maximum=a.gridAxis.fullMax;e.strictMinMax=!0;e.zoom(0,c.length-1);if((m=a.graph)&&a.catScrollbar){var q=a.valueAxis,p=m.valueAxis;q.id=p.id;q.rotate=g;q.setOrientation(g);q.width=k;q.height=l;q.dataProvider=c;q.reversed=p.reversed;q.logarithmic=p.logarithmic;q.gridAlpha=0;q.axisAlpha=0;n.push(q.set);g?(q.y=h,q.x=0):(q.x=f,q.y=0);var f=Infinity,
h=-Infinity,t;for(t=0;t<c.length;t++){var r=c[t].axes[p.id].graphs[m.id].values,w;for(w in r)if(r.hasOwnProperty(w)&&"percents"!=w&&"total"!=w){var z=r[w];z<f&&(f=z);z>h&&(h=z)}}Infinity!=f&&(q.minimum=f);-Infinity!=h&&(q.maximum=h+.1*(h-f));f==h&&(--q.minimum,q.maximum+=1);void 0!==a.minimum&&(q.minimum=a.minimum);void 0!==a.maximum&&(q.maximum=a.maximum);q.zoom(0,c.length-1);w=a.unselectedGraph;w.id=m.id;w.bcn="scrollbar-graph-";w.rotate=g;w.chart=b;w.data=c;w.valueAxis=q;w.chart=m.chart;w.categoryAxis=
a.categoryAxis;w.periodSpan=m.periodSpan;w.valueField=m.valueField;w.openField=m.openField;w.closeField=m.closeField;w.highField=m.highField;w.lowField=m.lowField;w.lineAlpha=a.graphLineAlpha;w.lineColorR=a.graphLineColor;w.fillAlphas=a.graphFillAlpha;w.fillColorsR=a.graphFillColor;w.connect=m.connect;w.hidden=m.hidden;w.width=k;w.height=l;w.pointPosition=m.pointPosition;w.stepDirection=m.stepDirection;w.periodSpan=m.periodSpan;p=a.selectedGraph;p.id=m.id;p.bcn=w.bcn+"selected-";p.rotate=g;p.chart=
b;p.data=c;p.valueAxis=q;p.chart=m.chart;p.categoryAxis=e;p.periodSpan=m.periodSpan;p.valueField=m.valueField;p.openField=m.openField;p.closeField=m.closeField;p.highField=m.highField;p.lowField=m.lowField;p.lineAlpha=a.selectedGraphLineAlpha;p.lineColorR=a.selectedGraphLineColor;p.fillAlphas=a.selectedGraphFillAlpha;p.fillColorsR=a.selectedGraphFillColor;p.connect=m.connect;p.hidden=m.hidden;p.width=k;p.height=l;p.pointPosition=m.pointPosition;p.stepDirection=m.stepDirection;p.periodSpan=m.periodSpan;
b=a.graphType;b||(b=m.type);w.type=b;p.type=b;c=c.length-1;w.zoom(0,c);p.zoom(0,c);p.set.click(function(){a.handleBackgroundClick()}).mouseover(function(){a.handleMouseOver()}).mouseout(function(){a.handleMouseOut()});w.set.click(function(){a.handleBackgroundClick()}).mouseover(function(){a.handleMouseOver()}).mouseout(function(){a.handleMouseOut()});n.push(w.set);n.push(p.set)}n.push(e.set);n.push(e.labelsSet);a.bg.toBack();a.invisibleBg.toFront();a.dragger.toFront();a.iconLeft.toFront();a.iconRight.toFront()}},
timeZoom:function(a,b,c){this.startTime=a;this.endTime=b;this.timeDifference=b-a;this.skipEvent=!d.toBoolean(c);this.zoomScrollbar();this.dispatchScrollbarEvent()},zoom:function(a,b){this.start=a;this.end=b;this.skipEvent=!0;this.zoomScrollbar()},dispatchScrollbarEvent:function(){if(this.categoryAxis&&"ValueAxis"==this.categoryAxis.cname)d.ChartScrollbar.base.dispatchScrollbarEvent.call(this);else if(this.skipEvent)this.skipEvent=!1;else{var a=this.chart.chartData,b,c,e=this.dragger.getBBox();b=e.x;
var g=e.y,f=e.width,e=e.height,h=this.chart;this.rotate?(b=g,c=e):c=f;f={type:"zoomed",target:this};f.chart=h;var k=this.categoryAxis,l=this.stepWidth,e=h.minSelectedTime,m=h.maxSelectedTime,g=!1;if(k.parseDates&&!k.equalSpacing){if(a=h.lastTime,h=h.firstTime,k=Math.round(b/l)+h,b=this.dragging?k+this.timeDifference:Math.round((b+c)/l)+h,k>b&&(k=b),0<e&&b-k<e&&(b=Math.round(k+(b-k)/2),g=Math.round(e/2),k=b-g,b+=g,g=!0),0<m&&b-k>m&&(b=Math.round(k+(b-k)/2),g=Math.round(m/2),k=b-g,b+=g,g=!0),b>a&&(b=
a),b-e<k&&(k=b-e),k<h&&(k=h),k+e>b&&(b=k+e),k!=this.startTime||b!=this.endTime)this.startTime=k,this.endTime=b,f.start=k,f.end=b,f.startDate=new Date(k),f.endDate=new Date(b),this.fire(f)}else{m=l/2;k.startOnAxis||(b+=m,c-=m);e=k.xToIndex(b);k.startOnAxis||(b=k.getCoordinate(e)-m);b=k.xToIndex(b+c);if(e!=this.start||this.end!=b)k.startOnAxis&&(this.resizingRight&&e==b&&b++,this.resizingLeft&&e==b&&(0<e?e--:b=1)),b==a.length&&(b=a.length-1),e==b&&b==a.length-1&&(e=b-1),this.start=e,this.end=this.dragging?
this.start+this.difference:b,f.start=this.start,f.end=this.end,k.parseDates&&(a[this.start]&&(f.startDate=new Date(a[this.start].time)),a[this.end]&&(f.endDate=new Date(a[this.end].time))),this.fire(f);this.percentStart=e;this.percentEnd=b}g&&this.zoomScrollbar(!0)}},zoomScrollbar:function(a){if((!(this.dragging||this.resizingLeft||this.resizingRight||this.animating)||a)&&this.dragger&&this.enabled){var b,c,d=this.chart;a=d.chartData;var g=this.categoryAxis;g.parseDates&&!g.equalSpacing?(a=g.stepWidth,
c=d.firstTime,b=a*(this.startTime-c),c=a*(this.endTime-c)):(a[this.start]&&(b=a[this.start].x[g.id]),a[this.end]&&(c=a[this.end].x[g.id]),a=g.stepWidth,g.startOnAxis||(d=a/2,b-=d,c+=d));this.stepWidth=a;isNaN(b)||isNaN(c)||this.updateScrollbarSize(b,c)}},maskGraphs:function(a,b,c,d){var g=this.selectedGraph;g&&g.set.clipRect(a,b,c,d)},handleDragStart:function(){d.ChartScrollbar.base.handleDragStart.call(this);this.difference=this.end-this.start;this.timeDifference=this.endTime-this.startTime;0>this.timeDifference&&
(this.timeDifference=0)},handleBackgroundClick:function(){d.ChartScrollbar.base.handleBackgroundClick.call(this);this.dragging||(this.difference=this.end-this.start,this.timeDifference=this.endTime-this.startTime,0>this.timeDifference&&(this.timeDifference=0))}})})();(function(){var d=window.AmCharts;d.AmBalloon=d.Class({construct:function(a){this.cname="AmBalloon";this.enabled=!0;this.fillColor="#FFFFFF";this.fillAlpha=.8;this.borderThickness=2;this.borderColor="#FFFFFF";this.borderAlpha=1;this.cornerRadius=0;this.maxWidth=220;this.horizontalPadding=8;this.verticalPadding=4;this.pointerWidth=6;this.pointerOrientation="V";this.color="#000000";this.adjustBorderColor=!0;this.show=this.follow=this.showBullet=!1;this.bulletSize=3;this.shadowAlpha=.4;this.shadowColor=
"#000000";this.fadeOutDuration=this.animationDuration=.3;this.fixedPosition=!0;this.offsetY=6;this.offsetX=1;this.textAlign="center";this.disableMouseEvents=!0;this.deltaSignX=this.deltaSignY=1;d.isModern||(this.offsetY*=1.5);this.sdy=this.sdx=0;d.applyTheme(this,a,this.cname)},draw:function(){var a=this.pointToX,b=this.pointToY;d.isModern||(this.drop=!1);var c=this.chart;d.VML&&(this.fadeOutDuration=0);this.xAnim&&c.stopAnim(this.xAnim);this.yAnim&&c.stopAnim(this.yAnim);this.sdy=this.sdx=0;if(!isNaN(a)){var e=
this.follow,g=c.container,f=this.set;d.remove(f);this.removeDiv();f=g.set();f.node.style.pointerEvents="none";this.set=f;this.mainSet?(this.mainSet.push(this.set),this.sdx=this.mainSet.x,this.sdy=this.mainSet.y):c.balloonsSet.push(f);if(this.show){var h=this.l,k=this.t,l=this.r,m=this.b,n=this.balloonColor,q=this.fillColor,p=this.borderColor,t=q;void 0!=n&&(this.adjustBorderColor?t=p=n:q=n);var r=this.horizontalPadding,w=this.verticalPadding,z=this.pointerWidth,x=this.pointerOrientation,u=this.cornerRadius,
A=c.fontFamily,y=this.fontSize;void 0==y&&(y=c.fontSize);var n=document.createElement("div"),B=c.classNamePrefix;n.className=B+"-balloon-div";this.className&&(n.className=n.className+" "+B+"-balloon-div-"+this.className);B=n.style;this.disableMouseEvents&&(B.pointerEvents="none");B.position="absolute";var D=this.minWidth,C=document.createElement("div");n.appendChild(C);var I=C.style;isNaN(D)||(I.minWidth=D-2*r+"px");I.textAlign=this.textAlign;I.maxWidth=this.maxWidth+"px";I.fontSize=y+"px";I.color=
this.color;I.fontFamily=A;C.innerHTML=this.text;c.chartDiv.appendChild(n);this.textDiv=n;var I=n.offsetWidth,H=n.offsetHeight;n.clientHeight&&(I=n.clientWidth,H=n.clientHeight);A=H+2*w;C=I+2*r;!isNaN(D)&&C<D&&(C=D);window.opera&&(A+=2);var Q=!1,y=this.offsetY;c.handDrawn&&(y+=c.handDrawScatter+2);"H"!=x?(D=a-C/2,b<k+A+10&&"down"!=x?(Q=!0,e&&(b+=y),y=b+z,this.deltaSignY=-1):(e&&(b-=y),y=b-A-z,this.deltaSignY=1)):(2*z>A&&(z=A/2),y=b-A/2,a<h+(l-h)/2?(D=a+z,this.deltaSignX=-1):(D=a-C-z,this.deltaSignX=
1));y+A>=m&&(y=m-A);y<k&&(y=k);D<h&&(D=h);D+C>l&&(D=l-C);var k=y+w,m=D+r,M=this.shadowAlpha,P=this.shadowColor,r=this.borderThickness,ia=this.bulletSize,J,w=this.fillAlpha,aa=this.borderAlpha;this.showBullet&&(J=d.circle(g,ia,t,w),f.push(J));this.drop?(h=C/1.6,l=0,"V"==x&&(x="down"),"H"==x&&(x="left"),"down"==x&&(D=a+1,y=b-h-h/3),"up"==x&&(l=180,D=a+1,y=b+h+h/3),"left"==x&&(l=270,D=a+h+h/3+2,y=b),"right"==x&&(l=90,D=a-h-h/3+2,y=b),k=y-H/2+1,m=D-I/2-1,q=d.drop(g,h,l,q,w,r,p,aa)):0<u||0===z?(0<M&&(a=
d.rect(g,C,A,q,0,r+1,P,M,u),d.isModern?a.translate(1,1):a.translate(4,4),f.push(a)),q=d.rect(g,C,A,q,w,r,p,aa,u)):(t=[],u=[],"H"!=x?(h=a-D,h>C-z&&(h=C-z),h<z&&(h=z),t=[0,h-z,a-D,h+z,C,C,0,0],u=Q?[0,0,b-y,0,0,A,A,0]:[A,A,b-y,A,A,0,0,A]):(x=b-y,x>A-z&&(x=A-z),x<z&&(x=z),u=[0,x-z,b-y,x+z,A,A,0,0],t=a<h+(l-h)/2?[0,0,D<a?0:a-D,0,0,C,C,0]:[C,C,D+C>a?C:a-D,C,C,0,0,C]),0<M&&(a=d.polygon(g,t,u,q,0,r,P,M),a.translate(1,1),f.push(a)),q=d.polygon(g,t,u,q,w,r,p,aa));this.bg=q;f.push(q);q.toFront();d.setCN(c,q,
"balloon-bg");this.className&&d.setCN(c,q,"balloon-bg-"+this.className);g=1*this.deltaSignX;m+=this.sdx;k+=this.sdy;B.left=m+"px";B.top=k+"px";f.translate(D-g,y,1,!0);q=q.getBBox();this.bottom=y+A+1;this.yPos=q.y+y;J&&J.translate(this.pointToX-D+g,b-y);b=this.animationDuration;0<this.animationDuration&&!e&&!isNaN(this.prevX)&&(f.translate(this.prevX,this.prevY,NaN,!0),f.animate({translate:D-g+","+y},b,"easeOutSine"),n&&(B.left=this.prevTX+"px",B.top=this.prevTY+"px",this.xAnim=c.animate({node:n},
"left",this.prevTX,m,b,"easeOutSine","px"),this.yAnim=c.animate({node:n},"top",this.prevTY,k,b,"easeOutSine","px")));this.prevX=D-g;this.prevY=y;this.prevTX=m;this.prevTY=k}}},fixPrevious:function(){this.rPrevX=this.prevX;this.rPrevY=this.prevY;this.rPrevTX=this.prevTX;this.rPrevTY=this.prevTY},restorePrevious:function(){this.prevX=this.rPrevX;this.prevY=this.rPrevY;this.prevTX=this.rPrevTX;this.prevTY=this.rPrevTY},followMouse:function(){if(this.follow&&this.show){var a=this.chart.mouseX-this.offsetX*
this.deltaSignX-this.sdx,b=this.chart.mouseY-this.sdy;this.pointToX=a;this.pointToY=b;if(a!=this.previousX||b!=this.previousY)if(this.previousX=a,this.previousY=b,0===this.cornerRadius)this.draw();else{var c=this.set;if(c){var d=c.getBBox(),a=a-d.width/2,g=b-d.height-10;a<this.l&&(a=this.l);a>this.r-d.width&&(a=this.r-d.width);g<this.t&&(g=b+10);c.translate(a,g);b=this.textDiv.style;b.left=a+this.horizontalPadding+"px";b.top=g+this.verticalPadding+"px"}}}},changeColor:function(a){this.balloonColor=
a},setBounds:function(a,b,c,d){this.l=a;this.t=b;this.r=c;this.b=d;this.destroyTO&&clearTimeout(this.destroyTO)},showBalloon:function(a){if(this.text!=a||this.positionChanged)this.text=a,this.isHiding=!1,this.show=!0,this.destroyTO&&clearTimeout(this.destroyTO),a=this.chart,this.fadeAnim1&&a.stopAnim(this.fadeAnim1),this.fadeAnim2&&a.stopAnim(this.fadeAnim2),this.draw(),this.positionChanged=!1},hide:function(a){var b=this;b.text=void 0;isNaN(a)&&(a=b.fadeOutDuration);var c=b.chart;if(0<a&&!b.isHiding){b.isHiding=
!0;b.destroyTO&&clearTimeout(b.destroyTO);b.destroyTO=setTimeout(function(){b.destroy.call(b)},1E3*a);b.follow=!1;b.show=!1;var d=b.set;d&&(d.setAttr("opacity",b.fillAlpha),b.fadeAnim1=d.animate({opacity:0},a,"easeInSine"));b.textDiv&&(b.fadeAnim2=c.animate({node:b.textDiv},"opacity",1,0,a,"easeInSine",""))}else b.show=!1,b.follow=!1,b.destroy()},setPosition:function(a,b){if(a!=this.pointToX||b!=this.pointToY)this.previousX=this.pointToX,this.previousY=this.pointToY,this.pointToX=a,this.pointToY=
b,this.positionChanged=!0},followCursor:function(a){var b=this;b.follow=a;clearInterval(b.interval);var c=b.chart.mouseX-b.sdx,d=b.chart.mouseY-b.sdy;!isNaN(c)&&a&&(b.pointToX=c-b.offsetX*b.deltaSignX,b.pointToY=d,b.followMouse(),b.interval=setInterval(function(){b.followMouse.call(b)},40))},removeDiv:function(){if(this.textDiv){var a=this.textDiv.parentNode;a&&a.removeChild(this.textDiv)}},destroy:function(){clearInterval(this.interval);d.remove(this.set);this.removeDiv();this.set=null}})})();(function(){var d=window.AmCharts;d.AmCoordinateChart=d.Class({inherits:d.AmChart,construct:function(a){d.AmCoordinateChart.base.construct.call(this,a);this.theme=a;this.createEvents("rollOverGraphItem","rollOutGraphItem","clickGraphItem","doubleClickGraphItem","rightClickGraphItem","clickGraph","rollOverGraph","rollOutGraph");this.startAlpha=1;this.startDuration=0;this.startEffect="elastic";this.sequencedAnimation=!0;this.colors="#FF6600 #FCD202 #B0DE09 #0D8ECF #2A0CD0 #CD0D74 #CC0000 #00CC00 #0000CC #DDDDDD #999999 #333333 #990000".split(" ");
this.balloonDateFormat="MMM DD, YYYY";this.valueAxes=[];this.graphs=[];this.guides=[];this.gridAboveGraphs=!1;d.applyTheme(this,a,"AmCoordinateChart")},initChart:function(){d.AmCoordinateChart.base.initChart.call(this);this.drawGraphs=!0;var a=this.categoryAxis;a&&(this.categoryAxis=d.processObject(a,d.CategoryAxis,this.theme));this.processValueAxes();this.createValueAxes();this.processGraphs();this.processGuides();d.VML&&(this.startAlpha=1);this.setLegendData(this.graphs);this.gridAboveGraphs&&(this.gridSet.toFront(),
this.bulletSet.toFront(),this.balloonsSet.toFront())},createValueAxes:function(){if(0===this.valueAxes.length){var a=new d.ValueAxis;this.addValueAxis(a)}},parseData:function(){this.processValueAxes();this.processGraphs()},parseSerialData:function(a){this.chartData=[];if(a)if(0<this.processTimeout){1>this.processCount&&(this.processCount=1);var b=a.length/this.processCount;this.parseCount=Math.ceil(b)-1;for(var c=0;c<b;c++)this.delayParseSerialData(a,c)}else this.parseCount=0,this.parsePartSerialData(a,
0,a.length,0);else this.onDataUpdated()},delayParseSerialData:function(a,b){var c=this,d=c.processCount;setTimeout(function(){c.parsePartSerialData.call(c,a,b*d,(b+1)*d,b)},c.processTimeout)},parsePartSerialData:function(a,b,c,e){c>a.length&&(c=a.length);var g=this.graphs,f={},h=this.seriesIdField;h||(h=this.categoryField);var k=!1,l,m=this.categoryAxis,n,q,p;m&&(k=m.parseDates,n=m.forceShowField,p=m.classNameField,q=m.labelColorField,l=m.categoryFunction);var t,r,w={},z;k&&(t=d.extractPeriod(m.minPeriod),
r=t.period,t=t.count,z=d.getPeriodDuration(r,t));var x={};this.lookupTable=x;var u,A=this.dataDateFormat,y={};for(u=b;u<c;u++){var B={},D=a[u];b=D[this.categoryField];B.dataContext=D;B.category=l?l(b,D,m):String(b);n&&(B.forceShow=D[n]);p&&(B.className=D[p]);q&&(B.labelColor=D[q]);x[D[h]]=B;if(k&&(m.categoryFunction?b=m.categoryFunction(b,D,m):(!A||b instanceof Date||(b=b.toString()+" |"),b=d.getDate(b,A,m.minPeriod)),b=d.resetDateToMin(b,r,t,m.firstDayOfWeek),B.category=b,B.time=b.getTime(),isNaN(B.time)))continue;
var C=this.valueAxes;B.axes={};B.x={};var I;for(I=0;I<C.length;I++){var H=C[I].id;B.axes[H]={};B.axes[H].graphs={};var Q;for(Q=0;Q<g.length;Q++){b=g[Q];var M=b.id,P=1.1;isNaN(b.gapPeriod)||(P=b.gapPeriod);var ia=b.periodValue;if(b.valueAxis.id==H){B.axes[H].graphs[M]={};var J={};J.index=u;var aa=D;b.dataProvider&&(aa=f);J.values=this.processValues(aa,b,ia);if(!b.connect||b.forceGap&&!isNaN(b.gapPeriod))if(y&&y[M]&&0<P&&B.time-w[M]>=z*P&&(y[M].gap=!0),b.forceGap){var P=0,ma;for(ma in J.values)P++;
0<P&&(w[M]=B.time,y[M]=J)}else w[M]=B.time,y[M]=J;this.processFields(b,J,aa);J.category=B.category;J.serialDataItem=B;J.graph=b;B.axes[H].graphs[M]=J}}}this.chartData[u]=B}if(this.parseCount==e){for(a=0;a<g.length;a++)b=g[a],b.dataProvider&&this.parseGraphData(b);this.dataChanged=!1;this.dispatchDataUpdated=!0;this.onDataUpdated()}},processValues:function(a,b,c){var e={},g,f=!1;"candlestick"!=b.type&&"ohlc"!=b.type||""===c||(f=!0);for(var h="value error open close low high".split(" "),k=0;k<h.length;k++){var l=
h[k];"value"!=l&&"error"!=l&&f&&(c=l.charAt(0).toUpperCase()+l.slice(1));var m=a[b[l+"Field"]+c];null!==m&&(g=Number(m),isNaN(g)||(e[l]=g),"date"==b.valueAxis.type&&void 0!==m&&(g=d.getDate(m,b.chart.dataDateFormat),e[l]=g.getTime()))}return e},parseGraphData:function(a){var b=a.dataProvider,c=a.seriesIdField;c||(c=this.seriesIdField);c||(c=this.categoryField);var d;for(d=0;d<b.length;d++){var g=b[d],f=this.lookupTable[String(g[c])],h=a.valueAxis.id;f&&(h=f.axes[h].graphs[a.id],h.serialDataItem=f,
h.values=this.processValues(g,a,a.periodValue),this.processFields(a,h,g))}},addValueAxis:function(a){a.chart=this;this.valueAxes.push(a);this.validateData()},removeValueAxesAndGraphs:function(){var a=this.valueAxes,b;for(b=a.length-1;-1<b;b--)this.removeValueAxis(a[b])},removeValueAxis:function(a){var b=this.graphs,c;for(c=b.length-1;0<=c;c--){var d=b[c];d&&d.valueAxis==a&&this.removeGraph(d)}b=this.valueAxes;for(c=b.length-1;0<=c;c--)b[c]==a&&b.splice(c,1);this.validateData()},addGraph:function(a){this.graphs.push(a);
this.chooseGraphColor(a,this.graphs.length-1);this.validateData()},removeGraph:function(a){var b=this.graphs,c;for(c=b.length-1;0<=c;c--)b[c]==a&&(b.splice(c,1),a.destroy());this.validateData()},handleValueAxisZoom:function(){},processValueAxes:function(){var a=this.valueAxes,b;for(b=0;b<a.length;b++){var c=a[b],c=d.processObject(c,d.ValueAxis,this.theme);a[b]=c;c.chart=this;c.init();this.listenTo(c,"axisIntZoomed",this.handleValueAxisZoom);c.id||(c.id="valueAxisAuto"+b+"_"+(new Date).getTime());
void 0===c.usePrefixes&&(c.usePrefixes=this.usePrefixes)}},processGuides:function(){var a=this.guides,b=this.categoryAxis;if(a)for(var c=0;c<a.length;c++){var e=a[c];(void 0!==e.category||void 0!==e.date)&&b&&b.addGuide(e);e.id||(e.id="guideAuto"+c+"_"+(new Date).getTime());var g=e.valueAxis;g?(d.isString(g)&&(g=this.getValueAxisById(g)),g?g.addGuide(e):this.valueAxes[0].addGuide(e)):isNaN(e.value)||this.valueAxes[0].addGuide(e)}},processGraphs:function(){var a=this.graphs,b;this.graphsById={};for(b=
0;b<a.length;b++){var c=a[b],c=d.processObject(c,d.AmGraph,this.theme);a[b]=c;this.chooseGraphColor(c,b);c.chart=this;c.init();d.isString(c.valueAxis)&&(c.valueAxis=this.getValueAxisById(c.valueAxis));c.valueAxis||(c.valueAxis=this.valueAxes[0]);c.id||(c.id="graphAuto"+b+"_"+(new Date).getTime());this.graphsById[c.id]=c}},formatString:function(a,b,c){var e=b.graph,g=e.valueAxis;if(g.duration&&g.maxInterval&&b.values.value){var f=g.numberFormatter;f||(f=chart.nf);g=d.formatDuration(b.values.value,
g.duration,"",g.durationUnits,g.maxInterval,f);a=a.split("[[value]]").join(g)}a=d.massReplace(a,{"[[title]]":e.title,"[[description]]":b.description});a=c?d.fixNewLines(a):d.fixBrakes(a);return a=d.cleanFromEmpty(a)},getBalloonColor:function(a,b,c){var e=a.lineColor,g=a.balloonColor;c&&(g=e);c=a.fillColorsR;"object"==typeof c?e=c[0]:void 0!==c&&(e=c);b.isNegative&&(c=a.negativeLineColor,a=a.negativeFillColors,"object"==typeof a?c=a[0]:void 0!==a&&(c=a),void 0!==c&&(e=c));void 0!==b.color&&(e=b.color);
void 0!==b.lineColor&&(e=b.lineColor);b=b.fillColors;void 0!==b&&(e=b,d.ifArray(b)&&(e=b[0]));void 0===g&&(g=e);return g},getGraphById:function(a){return d.getObjById(this.graphs,a)},getValueAxisById:function(a){return d.getObjById(this.valueAxes,a)},processFields:function(a,b,c){if(a.itemColors){var e=a.itemColors,g=b.index;b.color=g<e.length?e[g]:d.randomColor()}e="lineColor color alpha fillColors description bullet customBullet bulletSize bulletConfig url labelColor dashLength pattern gap className columnIndex".split(" ");
for(g=0;g<e.length;g++){var f=e[g],h=a[f+"Field"];h&&(h=c[h],d.isDefined(h)&&(b[f]=h))}b.dataContext=c},chooseGraphColor:function(a,b){if(a.lineColor)a.lineColorR=a.lineColor;else{var c;c=this.colors.length>b?this.colors[b]:a.lineColorR?a.lineColorR:d.randomColor();a.lineColorR=c}a.fillColorsR=a.fillColors?a.fillColors:a.lineColorR;a.bulletBorderColorR=a.bulletBorderColor?a.bulletBorderColor:a.useLineColorForBulletBorder?a.lineColorR:a.bulletColor;a.bulletColorR=a.bulletColor?a.bulletColor:a.lineColorR;
if(c=this.patterns)a.pattern=c[b]},handleLegendEvent:function(a){var b=a.type;if(a=a.dataItem){var c=a.hidden,d=a.showBalloon;switch(b){case "clickMarker":this.textClickEnabled&&(d?this.hideGraphsBalloon(a):this.showGraphsBalloon(a));break;case "clickLabel":d?this.hideGraphsBalloon(a):this.showGraphsBalloon(a);break;case "rollOverItem":c||this.highlightGraph(a);break;case "rollOutItem":c||this.unhighlightGraph();break;case "hideItem":this.hideGraph(a);break;case "showItem":this.showGraph(a)}}},highlightGraph:function(a){var b=
this.graphs;if(b){var c,d=.2;this.legend&&(d=this.legend.rollOverGraphAlpha);if(1!=d)for(c=0;c<b.length;c++){var g=b[c];g!=a&&g.changeOpacity(d)}}},unhighlightGraph:function(){var a;this.legend&&(a=this.legend.rollOverGraphAlpha);if(1!=a){a=this.graphs;var b;for(b=0;b<a.length;b++)a[b].changeOpacity(1)}},showGraph:function(a){a.switchable&&(a.hidden=!1,this.dataChanged=!0,"xy"!=this.type&&(this.marginsUpdated=!1),this.chartCreated&&this.initChart())},hideGraph:function(a){a.switchable&&(this.dataChanged=
!0,"xy"!=this.type&&(this.marginsUpdated=!1),a.hidden=!0,this.chartCreated&&this.initChart())},hideGraphsBalloon:function(a){a.showBalloon=!1;this.updateLegend()},showGraphsBalloon:function(a){a.showBalloon=!0;this.updateLegend()},updateLegend:function(){this.legend&&this.legend.invalidateSize()},resetAnimation:function(){this.animatable=[];var a=this.graphs;if(a){var b;for(b=0;b<a.length;b++)a[b].animationPlayed=!1}},animateAgain:function(){this.resetAnimation();this.validateNow()}})})();(function(){var d=window.AmCharts;d.TrendLine=d.Class({construct:function(a){this.cname="TrendLine";this.createEvents("click","rollOver","rollOut");this.isProtected=!1;this.dashLength=0;this.lineColor="#00CC00";this.lineThickness=this.lineAlpha=1;d.applyTheme(this,a,this.cname)},draw:function(){var a=this;a.destroy();var b=a.chart,c=b.container,e,g,f,h,k=a.categoryAxis,l=a.initialDate,m=a.initialCategory,n=a.finalDate,q=a.finalCategory,p=a.valueAxis,t=a.valueAxisX,r=a.initialXValue,w=a.finalXValue,
z=a.initialValue,x=a.finalValue,u=p.recalculateToPercents,A=b.dataDateFormat;k&&(l&&(l=d.getDate(l,A,"fff"),a.initialDate=l,e=k.dateToCoordinate(l)),m&&(e=k.categoryToCoordinate(m)),n&&(n=d.getDate(n,A,"fff"),a.finalDate=n,g=k.dateToCoordinate(n)),q&&(g=k.categoryToCoordinate(q)));t&&!u&&(isNaN(r)||(e=t.getCoordinate(r)),isNaN(w)||(g=t.getCoordinate(w)));p&&!u&&(isNaN(z)||(f=p.getCoordinate(z)),isNaN(x)||(h=p.getCoordinate(x)));if(!(isNaN(e)||isNaN(g)||isNaN(f)||isNaN(f))){b.rotate?(k=[f,h],h=[e,
g]):(k=[e,g],h=[f,h]);f=d.line(c,k,h,a.lineColor,a.lineAlpha,a.lineThickness,a.dashLength);e=k;g=h;n=k[1]-k[0];q=h[1]-h[0];0===n&&(n=.01);0===q&&(q=.01);l=n/Math.abs(n);m=q/Math.abs(q);q=90*Math.PI/180-Math.asin(n/(n*q/Math.abs(n*q)*Math.sqrt(Math.pow(n,2)+Math.pow(q,2))));n=Math.abs(5*Math.cos(q));q=Math.abs(5*Math.sin(q));e.push(k[1]-l*q,k[0]-l*q);g.push(h[1]+m*n,h[0]+m*n);h=d.polygon(c,e,g,"#ffffff",.005,0);c=c.set([h,f]);c.translate(b.marginLeftReal,b.marginTopReal);b.trendLinesSet.push(c);d.setCN(b,
f,"trend-line");d.setCN(b,f,"trend-line-"+a.id);a.line=f;a.set=c;if(f=a.initialImage)f=d.processObject(f,d.Image,a.theme),f.chart=b,f.draw(),f.translate(e[0]+f.offsetX,g[0]+f.offsetY),c.push(f.set);if(f=a.finalImage)f=d.processObject(f,d.Image,a.theme),f.chart=b,f.draw(),f.translate(e[1]+f.offsetX,g[1]+f.offsetY),c.push(f.set);c.mouseup(function(){a.handleLineClick()}).mouseover(function(){a.handleLineOver()}).mouseout(function(){a.handleLineOut()});c.touchend&&c.touchend(function(){a.handleLineClick()});
c.clipRect(0,0,b.plotAreaWidth,b.plotAreaHeight)}},handleLineClick:function(){this.fire({type:"click",trendLine:this,chart:this.chart})},handleLineOver:function(){var a=this.rollOverColor;void 0!==a&&this.line.attr({stroke:a});this.balloonText&&(clearTimeout(this.chart.hoverInt),a=this.line.getBBox(),this.chart.showBalloon(this.balloonText,this.lineColor,!0,this.x+a.x+a.width/2,this.y+a.y+a.height/2));this.fire({type:"rollOver",trendLine:this,chart:this.chart})},handleLineOut:function(){this.line.attr({stroke:this.lineColor});
this.balloonText&&this.chart.hideBalloon();this.fire({type:"rollOut",trendLine:this,chart:this.chart})},destroy:function(){d.remove(this.set)}})})();(function(){var d=window.AmCharts;d.Image=d.Class({construct:function(a){this.cname="Image";this.height=this.width=20;this.rotation=this.offsetY=this.offsetX=0;this.balloonColor=this.color="#000000";this.opacity=1;d.applyTheme(this,a,this.cname)},draw:function(){var a=this;a.set&&a.set.remove();var b=a.chart.container;a.set=b.set();var c,d;a.url?(c=b.image(a.url,0,0,a.width,a.height),d=1):a.svgPath&&(c=b.path(a.svgPath),c.setAttr("fill",a.color),c.setAttr("stroke",a.outlineColor),b=c.getBBox(),d=
Math.min(a.width/b.width,a.height/b.height));c&&(c.setAttr("opacity",a.opacity),a.set.rotate(a.rotation),c.translate(-a.width/2,-a.height/2,d),a.balloonText&&c.mouseover(function(){a.chart.showBalloon(a.balloonText,a.balloonColor,!0)}).mouseout(function(){a.chart.hideBalloon()}).touchend(function(){a.chart.hideBalloon()}).touchstart(function(){a.chart.showBalloon(a.balloonText,a.balloonColor,!0)}),a.set.push(c))},translate:function(a,b){this.set&&this.set.translate(a,b)}})})();(function(){var d=window.AmCharts;d.circle=function(a,b,c,e,g,f,h,k,l){0>=b&&(b=.001);if(void 0==g||0===g)g=.01;void 0===f&&(f="#000000");void 0===h&&(h=0);e={fill:c,stroke:f,"fill-opacity":e,"stroke-width":g,"stroke-opacity":h};a=isNaN(l)?a.circle(0,0,b).attr(e):a.ellipse(0,0,b,l).attr(e);k&&a.gradient("radialGradient",[c,d.adjustLuminosity(c,-.6)]);return a};d.text=function(a,b,c,e,g,f,h,k){f||(f="middle");"right"==f&&(f="end");"left"==f&&(f="start");isNaN(k)&&(k=1);void 0!==b&&(b=String(b),d.isIE&&
!d.isModern&&(b=b.replace("&amp;","&"),b=b.replace("&","&amp;")));c={fill:c,"font-family":e,"font-size":g+"px",opacity:k};!0===h&&(c["font-weight"]="bold");c["text-anchor"]=f;return a.text(b,c)};d.polygon=function(a,b,c,e,g,f,h,k,l,m,n){isNaN(f)&&(f=.01);isNaN(k)&&(k=g);var q=e,p=!1;"object"==typeof q&&1<q.length&&(p=!0,q=q[0]);void 0===h&&(h=q);g={fill:q,stroke:h,"fill-opacity":g,"stroke-width":f,"stroke-opacity":k};void 0!==n&&0<n&&(g["stroke-dasharray"]=n);n=d.dx;f=d.dy;a.handDrawn&&(c=d.makeHD(b,
c,a.handDrawScatter),b=c[0],c=c[1]);h=Math.round;m&&(h=Number);k="M"+(h(b[0])+n)+","+(h(c[0])+f);for(q=1;q<b.length;q++)m&&(b[q]=d.roundTo(b[q],5),c[q]=d.roundTo(c[q],5)),k+=" L"+(h(b[q])+n)+","+(h(c[q])+f);a=a.path(k+" Z").attr(g);p&&a.gradient("linearGradient",e,l);return a};d.rect=function(a,b,c,e,g,f,h,k,l,m,n){if(isNaN(b)||isNaN(c))return a.set();isNaN(f)&&(f=0);void 0===l&&(l=0);void 0===m&&(m=270);isNaN(g)&&(g=0);var q=e,p=!1;"object"==typeof q&&(q=q[0],p=!0);void 0===h&&(h=q);void 0===k&&
(k=g);b=Math.round(b);c=Math.round(c);var t=0,r=0;0>b&&(b=Math.abs(b),t=-b);0>c&&(c=Math.abs(c),r=-c);t+=d.dx;r+=d.dy;g={fill:q,stroke:h,"fill-opacity":g,"stroke-opacity":k};void 0!==n&&0<n&&(g["stroke-dasharray"]=n);a=a.rect(t,r,b,c,l,f).attr(g);p&&a.gradient("linearGradient",e,m);return a};d.bullet=function(a,b,c,e,g,f,h,k,l,m,n,q,p){var t;"circle"==b&&(b="round");switch(b){case "round":t=d.circle(a,c/2,e,g,f,h,k);break;case "square":t=d.polygon(a,[-c/2,c/2,c/2,-c/2],[c/2,c/2,-c/2,-c/2],e,g,f,h,
k,m-180,void 0,p);break;case "rectangle":t=d.polygon(a,[-c,c,c,-c],[c/2,c/2,-c/2,-c/2],e,g,f,h,k,m-180,void 0,p);break;case "diamond":t=d.polygon(a,[-c/2,0,c/2,0],[0,-c/2,0,c/2],e,g,f,h,k);break;case "triangleUp":t=d.triangle(a,c,0,e,g,f,h,k);break;case "triangleDown":t=d.triangle(a,c,180,e,g,f,h,k);break;case "triangleLeft":t=d.triangle(a,c,270,e,g,f,h,k);break;case "triangleRight":t=d.triangle(a,c,90,e,g,f,h,k);break;case "bubble":t=d.circle(a,c/2,e,g,f,h,k,!0);break;case "line":t=d.line(a,[-c/
2,c/2],[0,0],e,g,f,h,k);break;case "yError":t=a.set();t.push(d.line(a,[0,0],[-c/2,c/2],e,g,f));t.push(d.line(a,[-l,l],[-c/2,-c/2],e,g,f));t.push(d.line(a,[-l,l],[c/2,c/2],e,g,f));break;case "xError":t=a.set(),t.push(d.line(a,[-c/2,c/2],[0,0],e,g,f)),t.push(d.line(a,[-c/2,-c/2],[-l,l],e,g,f)),t.push(d.line(a,[c/2,c/2],[-l,l],e,g,f))}t&&t.pattern(n,NaN,q);return t};d.triangle=function(a,b,c,d,g,f,h,k){if(void 0===f||0===f)f=1;void 0===h&&(h="#000");void 0===k&&(k=0);d={fill:d,stroke:h,"fill-opacity":g,
"stroke-width":f,"stroke-opacity":k};b/=2;var l;0===c&&(l=" M"+-b+","+b+" L0,"+-b+" L"+b+","+b+" Z");180==c&&(l=" M"+-b+","+-b+" L0,"+b+" L"+b+","+-b+" Z");90==c&&(l=" M"+-b+","+-b+" L"+b+",0 L"+-b+","+b+" Z");270==c&&(l=" M"+-b+",0 L"+b+","+b+" L"+b+","+-b+" Z");return a.path(l).attr(d)};d.line=function(a,b,c,e,g,f,h,k,l,m,n){if(a.handDrawn&&!n)return d.handDrawnLine(a,b,c,e,g,f,h,k,l,m,n);f={fill:"none","stroke-width":f};void 0!==h&&0<h&&(f["stroke-dasharray"]=h);isNaN(g)||(f["stroke-opacity"]=
g);e&&(f.stroke=e);e=Math.round;m&&(e=Number,b[0]=d.roundTo(b[0],5),c[0]=d.roundTo(c[0],5));m=d.dx;g=d.dy;h="M"+(e(b[0])+m)+","+(e(c[0])+g);for(k=1;k<b.length;k++)b[k]=d.roundTo(b[k],5),c[k]=d.roundTo(c[k],5),h+=" L"+(e(b[k])+m)+","+(e(c[k])+g);if(d.VML)return a.path(h,void 0,!0).attr(f);l&&(h+=" M0,0 L0,0");return a.path(h).attr(f)};d.makeHD=function(a,b,c){for(var d=[],g=[],f=1;f<a.length;f++)for(var h=Number(a[f-1]),k=Number(b[f-1]),l=Number(a[f]),m=Number(b[f]),n=Math.round(Math.sqrt(Math.pow(l-
h,2)+Math.pow(m-k,2))/50)+1,l=(l-h)/n,m=(m-k)/n,q=0;q<=n;q++){var p=k+q*m+Math.random()*c;d.push(h+q*l+Math.random()*c);g.push(p)}return[d,g]};d.handDrawnLine=function(a,b,c,e,g,f,h,k,l,m){var n,q=a.set();for(n=1;n<b.length;n++)for(var p=[b[n-1],b[n]],t=[c[n-1],c[n]],t=d.makeHD(p,t,a.handDrawScatter),p=t[0],t=t[1],r=1;r<p.length;r++)q.push(d.line(a,[p[r-1],p[r]],[t[r-1],t[r]],e,g,f+Math.random()*a.handDrawThickness-a.handDrawThickness/2,h,k,l,m,!0));return q};d.doNothing=function(a){return a};d.drop=
function(a,b,c,d,g,f,h,k){var l=1/180*Math.PI,m=c-20,n=Math.sin(m*l)*b,q=Math.cos(m*l)*b,p=Math.sin((m+40)*l)*b,t=Math.cos((m+40)*l)*b,r=.8*b,w=-b/3,z=b/3;0===c&&(w=-w,z=0);180==c&&(z=0);90==c&&(w=0);270==c&&(w=0,z=-z);c={fill:d,stroke:h,"stroke-width":f,"stroke-opacity":k,"fill-opacity":g};b="M"+n+","+q+" A"+b+","+b+",0,1,1,"+p+","+t+(" A"+r+","+r+",0,0,0,"+(Math.sin((m+20)*l)*b+z)+","+(Math.cos((m+20)*l)*b+w));b+=" A"+r+","+r+",0,0,0,"+n+","+q;return a.path(b,void 0,void 0,"1000,1000").attr(c)};
d.wedge=function(a,b,c,e,g,f,h,k,l,m,n,q,p,t){var r=Math.round;f=r(f);h=r(h);k=r(k);var w=r(h/f*k),z=d.VML,x=359.5+f/100;359.94<x&&(x=359.94);g>=x&&(g=x);var u=1/180*Math.PI,x=b+Math.sin(e*u)*k,A=c-Math.cos(e*u)*w,y=b+Math.sin(e*u)*f,B=c-Math.cos(e*u)*h,D=b+Math.sin((e+g)*u)*f,C=c-Math.cos((e+g)*u)*h,I=b+Math.sin((e+g)*u)*k,u=c-Math.cos((e+g)*u)*w,H={fill:d.adjustLuminosity(m.fill,-.2),"stroke-opacity":0,"fill-opacity":m["fill-opacity"]},Q=0;180<Math.abs(g)&&(Q=1);e=a.set();var M;z&&(x=r(10*x),y=
r(10*y),D=r(10*D),I=r(10*I),A=r(10*A),B=r(10*B),C=r(10*C),u=r(10*u),b=r(10*b),l=r(10*l),c=r(10*c),f*=10,h*=10,k*=10,w*=10,1>Math.abs(g)&&1>=Math.abs(D-y)&&1>=Math.abs(C-B)&&(M=!0));g="";var P;q&&(H["fill-opacity"]=0,H["stroke-opacity"]=m["stroke-opacity"]/2,H.stroke=m.stroke);if(0<l){P=" M"+x+","+(A+l)+" L"+y+","+(B+l);z?(M||(P+=" A"+(b-f)+","+(l+c-h)+","+(b+f)+","+(l+c+h)+","+y+","+(B+l)+","+D+","+(C+l)),P+=" L"+I+","+(u+l),0<k&&(M||(P+=" B"+(b-k)+","+(l+c-w)+","+(b+k)+","+(l+c+w)+","+I+","+(l+u)+
","+x+","+(l+A)))):(P+=" A"+f+","+h+",0,"+Q+",1,"+D+","+(C+l)+" L"+I+","+(u+l),0<k&&(P+=" A"+k+","+w+",0,"+Q+",0,"+x+","+(A+l)));P+=" Z";var ia=l;z&&(ia/=10);for(var J=0;J<ia;J+=10){var aa=a.path(P,void 0,void 0,"1000,1000").attr(H);e.push(aa);aa.translate(0,-J)}P=a.path(" M"+x+","+A+" L"+x+","+(A+l)+" L"+y+","+(B+l)+" L"+y+","+B+" L"+x+","+A+" Z",void 0,void 0,"1000,1000").attr(H);l=a.path(" M"+D+","+C+" L"+D+","+(C+l)+" L"+I+","+(u+l)+" L"+I+","+u+" L"+D+","+C+" Z",void 0,void 0,"1000,1000").attr(H);
e.push(P);e.push(l)}z?(M||(g=" A"+r(b-f)+","+r(c-h)+","+r(b+f)+","+r(c+h)+","+r(y)+","+r(B)+","+r(D)+","+r(C)),h=" M"+r(x)+","+r(A)+" L"+r(y)+","+r(B)+g+" L"+r(I)+","+r(u)):h=" M"+x+","+A+" L"+y+","+B+(" A"+f+","+h+",0,"+Q+",1,"+D+","+C)+" L"+I+","+u;0<k&&(z?M||(h+=" B"+(b-k)+","+(c-w)+","+(b+k)+","+(c+w)+","+I+","+u+","+x+","+A):h+=" A"+k+","+w+",0,"+Q+",0,"+x+","+A);a.handDrawn&&(k=d.line(a,[x,y],[A,B],m.stroke,m.thickness*Math.random()*a.handDrawThickness,m["stroke-opacity"]),e.push(k));a=a.path(h+
" Z",void 0,void 0,"1000,1000").attr(m);if(n){k=[];for(w=0;w<n.length;w++)k.push(d.adjustLuminosity(m.fill,n[w]));"radial"!=t||d.isModern||(k=[]);0<k.length&&a.gradient(t+"Gradient",k)}d.isModern&&"radial"==t&&a.grad&&(a.grad.setAttribute("gradientUnits","userSpaceOnUse"),a.grad.setAttribute("r",f),a.grad.setAttribute("cx",b),a.grad.setAttribute("cy",c));a.pattern(q,NaN,p);e.wedge=a;e.push(a);return e};d.rgb2hex=function(a){return(a=a.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i))&&
4===a.length?"#"+("0"+parseInt(a[1],10).toString(16)).slice(-2)+("0"+parseInt(a[2],10).toString(16)).slice(-2)+("0"+parseInt(a[3],10).toString(16)).slice(-2):""};d.adjustLuminosity=function(a,b){a&&-1!=a.indexOf("rgb")&&(a=d.rgb2hex(a));a=String(a).replace(/[^0-9a-f]/gi,"");6>a.length&&(a=String(a[0])+String(a[0])+String(a[1])+String(a[1])+String(a[2])+String(a[2]));b=b||0;var c="#",e,g;for(g=0;3>g;g++)e=parseInt(a.substr(2*g,2),16),e=Math.round(Math.min(Math.max(0,e+e*b),255)).toString(16),c+=("00"+
e).substr(e.length);return c}})();(function(){var d=window.AmCharts;d.Bezier=d.Class({construct:function(a,b,c,e,g,f,h,k,l,m,n){var q=a.chart,p=d.bezierX,t=d.bezierY;isNaN(q.bezierX)||(p=q.bezierX);isNaN(q.bezierY)||(t=q.bezierY);isNaN(p)&&(q.rotate?(p=20,t=4):(t=20,p=4));var r,w;"object"==typeof h&&1<h.length&&(w=!0,r=h,h=h[0]);"object"==typeof k&&(k=k[0]);0===k&&(h="none");f={fill:h,"fill-opacity":k,"stroke-width":f};void 0!==l&&0<l&&(f["stroke-dasharray"]=l);isNaN(g)||(f["stroke-opacity"]=g);e&&(f.stroke=e);e="M"+Math.round(b[0])+
","+Math.round(c[0])+" ";g=[];for(l=0;l<b.length;l++)isNaN(b[l])||isNaN(c[l])?(e+=this.drawSegment(g,p,t),l<b.length-1&&(e+="L"+b[l+1]+","+c[l+1]+" "),g=[]):g.push({x:Number(b[l]),y:Number(c[l])});e+=this.drawSegment(g,p,t);m&&(e+=m);this.path=a.path(e).attr(f);this.node=this.path.node;w&&this.path.gradient("linearGradient",r,n)},drawSegment:function(a,b,c){var d="";if(2<a.length)for(var g=0;g<a.length-1;g++){var f=[],h=a[g-1],k=a[g],l=a[g+1],m=a[g+2];0===g?(f.push({x:k.x,y:k.y}),f.push({x:k.x,y:k.y}),
f.push({x:l.x,y:l.y}),f.push({x:m.x,y:m.y})):g>=a.length-2?(f.push({x:h.x,y:h.y}),f.push({x:k.x,y:k.y}),f.push({x:l.x,y:l.y}),f.push({x:l.x,y:l.y})):(f.push({x:h.x,y:h.y}),f.push({x:k.x,y:k.y}),f.push({x:l.x,y:l.y}),f.push({x:m.x,y:m.y}));h=[];k=Math.round;h.push({x:k(f[1].x),y:k(f[1].y)});h.push({x:k((-f[0].x+b*f[1].x+f[2].x)/b),y:k((-f[0].y+c*f[1].y+f[2].y)/c)});h.push({x:k((f[1].x+b*f[2].x-f[3].x)/b),y:k((f[1].y+c*f[2].y-f[3].y)/c)});h.push({x:k(f[2].x),y:k(f[2].y)});d+="C"+h[1].x+","+h[1].y+","+
h[2].x+","+h[2].y+","+h[3].x+","+h[3].y+" "}else 1<a.length&&(d+="L"+a[1].x+","+a[1].y);return d}})})();(function(){var d=window.AmCharts;d.AmDraw=d.Class({construct:function(a,b,c,e){d.SVG_NS="http://www.w3.org/2000/svg";d.SVG_XLINK="http://www.w3.org/1999/xlink";d.hasSVG=!!document.createElementNS&&!!document.createElementNS(d.SVG_NS,"svg").createSVGRect;1>b&&(b=10);1>c&&(c=10);this.div=a;this.width=b;this.height=c;this.rBin=document.createElement("div");d.hasSVG?(d.SVG=!0,b=this.createSvgElement("svg"),a.appendChild(b),this.container=b,this.addDefs(e),this.R=new d.SVGRenderer(this)):d.isIE&&d.VMLRenderer&&
(d.VML=!0,d.vmlStyleSheet||(document.namespaces.add("amvml","urn:schemas-microsoft-com:vml"),31>document.styleSheets.length?(b=document.createStyleSheet(),b.addRule(".amvml","behavior:url(#default#VML); display:inline-block; antialias:true"),d.vmlStyleSheet=b):document.styleSheets[0].addRule(".amvml","behavior:url(#default#VML); display:inline-block; antialias:true")),this.container=a,this.R=new d.VMLRenderer(this,e),this.R.disableSelection(a))},createSvgElement:function(a){return document.createElementNS(d.SVG_NS,
a)},circle:function(a,b,c,e){var g=new d.AmDObject("circle",this);g.attr({r:c,cx:a,cy:b});this.addToContainer(g.node,e);return g},ellipse:function(a,b,c,e,g){var f=new d.AmDObject("ellipse",this);f.attr({rx:c,ry:e,cx:a,cy:b});this.addToContainer(f.node,g);return f},setSize:function(a,b){0<a&&0<b&&(this.container.style.width=a+"px",this.container.style.height=b+"px")},rect:function(a,b,c,e,g,f,h){var k=new d.AmDObject("rect",this);d.VML&&(g=Math.round(100*g/Math.min(c,e)),c+=2*f,e+=2*f,k.bw=f,k.node.style.marginLeft=
-f,k.node.style.marginTop=-f);1>c&&(c=1);1>e&&(e=1);k.attr({x:a,y:b,width:c,height:e,rx:g,ry:g,"stroke-width":f});this.addToContainer(k.node,h);return k},image:function(a,b,c,e,g,f){var h=new d.AmDObject("image",this);h.attr({x:b,y:c,width:e,height:g});this.R.path(h,a);this.addToContainer(h.node,f);return h},addToContainer:function(a,b){b||(b=this.container);b.appendChild(a)},text:function(a,b,c){return this.R.text(a,b,c)},path:function(a,b,c,e){var g=new d.AmDObject("path",this);e||(e="100,100");
g.attr({cs:e});c?g.attr({dd:a}):g.attr({d:a});this.addToContainer(g.node,b);return g},set:function(a){return this.R.set(a)},remove:function(a){if(a){var b=this.rBin;b.appendChild(a);b.innerHTML=""}},renderFix:function(){var a=this.container,b=a.style;b.top="0px";b.left="0px";try{var c=a.getBoundingClientRect(),d=c.left-Math.round(c.left),g=c.top-Math.round(c.top);d&&(b.left=d+"px");g&&(b.top=g+"px")}catch(f){}},update:function(){this.R.update()},addDefs:function(a){if(d.hasSVG){var b=this.createSvgElement("desc"),
c=this.container;c.setAttribute("version","1.1");c.style.position="absolute";this.setSize(this.width,this.height);if(a.accessibleTitle){var e=this.createSvgElement("text");c.appendChild(e);e.innerHTML=a.accessibleTitle;e.style.opacity=0}d.rtl&&(c.setAttribute("direction","rtl"),c.style.left="auto",c.style.right="0px");a&&(a.addCodeCredits&&b.appendChild(document.createTextNode("JavaScript chart by amCharts "+a.version)),a.accessibleDescription&&(b.innerHTML="",b.appendChild(document.createTextNode(a.accessibleDescription))),
c.appendChild(b),a.defs&&(b=this.createSvgElement("defs"),c.appendChild(b),d.parseDefs(a.defs,b),this.defs=b))}}})})();(function(){var d=window.AmCharts;d.AmDObject=d.Class({construct:function(a,b){this.D=b;this.R=b.R;this.node=this.R.create(this,a);this.y=this.x=0;this.scale=1},attr:function(a){this.R.attr(this,a);return this},getAttr:function(a){return this.node.getAttribute(a)},setAttr:function(a,b){this.R.setAttr(this,a,b);return this},clipRect:function(a,b,c,d){this.R.clipRect(this,a,b,c,d)},translate:function(a,b,c,d){d||(a=Math.round(a),b=Math.round(b));this.R.move(this,a,b,c);this.x=a;this.y=b;this.scale=
c;this.angle&&this.rotate(this.angle)},rotate:function(a,b){this.R.rotate(this,a,b);this.angle=a},animate:function(a,b,c){for(var e in a)if(a.hasOwnProperty(e)){var g=e,f=a[e];c=d.getEffect(c);this.R.animate(this,g,f,b,c)}},push:function(a){if(a){var b=this.node;b.appendChild(a.node);var c=a.clipPath;c&&b.appendChild(c);(a=a.grad)&&b.appendChild(a)}},text:function(a){this.R.setText(this,a)},remove:function(){this.stop();this.R.remove(this)},clear:function(){var a=this.node;if(a.hasChildNodes())for(;1<=
a.childNodes.length;)a.removeChild(a.firstChild)},hide:function(){this.setAttr("visibility","hidden")},show:function(){this.setAttr("visibility","visible")},getBBox:function(){return this.R.getBBox(this)},toFront:function(){var a=this.node;if(a){this.prevNextNode=a.nextSibling;var b=a.parentNode;b&&b.appendChild(a)}},toPrevious:function(){var a=this.node;a&&this.prevNextNode&&(a=a.parentNode)&&a.insertBefore(this.prevNextNode,null)},toBack:function(){var a=this.node;if(a){this.prevNextNode=a.nextSibling;
var b=a.parentNode;if(b){var c=b.firstChild;c&&b.insertBefore(a,c)}}},mouseover:function(a){this.R.addListener(this,"mouseover",a);return this},mouseout:function(a){this.R.addListener(this,"mouseout",a);return this},click:function(a){this.R.addListener(this,"click",a);return this},dblclick:function(a){this.R.addListener(this,"dblclick",a);return this},mousedown:function(a){this.R.addListener(this,"mousedown",a);return this},mouseup:function(a){this.R.addListener(this,"mouseup",a);return this},touchmove:function(a){this.R.addListener(this,
"touchmove",a);return this},touchstart:function(a){this.R.addListener(this,"touchstart",a);return this},touchend:function(a){this.R.addListener(this,"touchend",a);return this},keyup:function(a){this.R.addListener(this,"keyup",a);return this},focus:function(a){this.R.addListener(this,"focus",a);return this},blur:function(a){this.R.addListener(this,"blur",a);return this},contextmenu:function(a){this.node.addEventListener?this.node.addEventListener("contextmenu",a,!0):this.R.addListener(this,"contextmenu",
a);return this},stop:function(){d.removeFromArray(this.R.animations,this.an_translate);d.removeFromArray(this.R.animations,this.an_y);d.removeFromArray(this.R.animations,this.an_x)},length:function(){return this.node.childNodes.length},gradient:function(a,b,c){this.R.gradient(this,a,b,c)},pattern:function(a,b,c){a&&this.R.pattern(this,a,b,c)}})})();(function(){var d=window.AmCharts;d.VMLRenderer=d.Class({construct:function(a,b){this.chart=b;this.D=a;this.cNames={circle:"oval",ellipse:"oval",rect:"roundrect",path:"shape"};this.styleMap={x:"left",y:"top",width:"width",height:"height","font-family":"fontFamily","font-size":"fontSize",visibility:"visibility"}},create:function(a,b){var c;if("group"==b)c=document.createElement("div"),a.type="div";else if("text"==b)c=document.createElement("div"),a.type="text";else if("image"==b)c=document.createElement("img"),
a.type="image";else{a.type="shape";a.shapeType=this.cNames[b];c=document.createElement("amvml:"+this.cNames[b]);var d=document.createElement("amvml:stroke");c.appendChild(d);a.stroke=d;var g=document.createElement("amvml:fill");c.appendChild(g);a.fill=g;g.className="amvml";d.className="amvml";c.className="amvml"}c.style.position="absolute";c.style.top=0;c.style.left=0;return c},path:function(a,b){a.node.setAttribute("src",b)},setAttr:function(a,b,c){if(void 0!==c){var e;8===document.documentMode&&
(e=!0);var g=a.node,f=a.type,h=g.style;"r"==b&&(h.width=2*c,h.height=2*c);"oval"==a.shapeType&&("rx"==b&&(h.width=2*c),"ry"==b&&(h.height=2*c));"roundrect"==a.shapeType&&("width"!=b&&"height"!=b||--c);"cursor"==b&&(h.cursor=c);"cx"==b&&(h.left=c-d.removePx(h.width)/2);"cy"==b&&(h.top=c-d.removePx(h.height)/2);var k=this.styleMap[b];"width"==k&&0>c&&(c=0);void 0!==k&&(h[k]=c);"text"==f&&("text-anchor"==b&&(a.anchor=c,k=g.clientWidth,"end"==c&&(h.marginLeft=-k+"px"),"middle"==c&&(h.marginLeft=-(k/2)+
"px",h.textAlign="center"),"start"==c&&(h.marginLeft="0px")),"fill"==b&&(h.color=c),"font-weight"==b&&(h.fontWeight=c));if(h=a.children)for(k=0;k<h.length;k++)h[k].setAttr(b,c);if("shape"==f){"cs"==b&&(g.style.width="100px",g.style.height="100px",g.setAttribute("coordsize",c));"d"==b&&g.setAttribute("path",this.svgPathToVml(c));"dd"==b&&g.setAttribute("path",c);f=a.stroke;a=a.fill;"stroke"==b&&(e?f.color=c:f.setAttribute("color",c));"stroke-width"==b&&(e?f.weight=c:f.setAttribute("weight",c));"stroke-opacity"==
b&&(e?f.opacity=c:f.setAttribute("opacity",c));"stroke-dasharray"==b&&(h="solid",0<c&&3>c&&(h="dot"),3<=c&&6>=c&&(h="dash"),6<c&&(h="longdash"),e?f.dashstyle=h:f.setAttribute("dashstyle",h));if("fill-opacity"==b||"opacity"==b)0===c?e?a.on=!1:a.setAttribute("on",!1):e?a.opacity=c:a.setAttribute("opacity",c);"fill"==b&&(e?a.color=c:a.setAttribute("color",c));"rx"==b&&(e?g.arcSize=c+"%":g.setAttribute("arcsize",c+"%"))}}},attr:function(a,b){for(var c in b)b.hasOwnProperty(c)&&this.setAttr(a,c,b[c])},
text:function(a,b,c){var e=new d.AmDObject("text",this.D),g=e.node;g.style.whiteSpace="pre";g.innerHTML=a;this.D.addToContainer(g,c);this.attr(e,b);return e},getBBox:function(a){return this.getBox(a.node)},getBox:function(a){var b=a.offsetLeft,c=a.offsetTop,d=a.offsetWidth,g=a.offsetHeight,f;if(a.hasChildNodes()){var h,k,l;for(l=0;l<a.childNodes.length;l++){f=this.getBox(a.childNodes[l]);var m=f.x;isNaN(m)||(isNaN(h)?h=m:m<h&&(h=m));var n=f.y;isNaN(n)||(isNaN(k)?k=n:n<k&&(k=n));m=f.width+m;isNaN(m)||
(d=Math.max(d,m));f=f.height+n;isNaN(f)||(g=Math.max(g,f))}0>h&&(b+=h);0>k&&(c+=k)}return{x:b,y:c,width:d,height:g}},setText:function(a,b){var c=a.node;c&&(c.innerHTML=b);this.setAttr(a,"text-anchor",a.anchor)},addListener:function(a,b,c){a.node["on"+b]=c},move:function(a,b,c){var e=a.node,g=e.style;"text"==a.type&&(c-=d.removePx(g.fontSize)/2-1);"oval"==a.shapeType&&(b-=d.removePx(g.width)/2,c-=d.removePx(g.height)/2);a=a.bw;isNaN(a)||(b-=a,c-=a);isNaN(b)||isNaN(c)||(e.style.left=b+"px",e.style.top=
c+"px")},svgPathToVml:function(a){var b=a.split(" ");a="";var c,d=Math.round,g;for(g=0;g<b.length;g++){var f=b[g],h=f.substring(0,1),f=f.substring(1),k=f.split(","),l=d(k[0])+","+d(k[1]);"M"==h&&(a+=" m "+l);"L"==h&&(a+=" l "+l);"Z"==h&&(a+=" x e");if("Q"==h){var m=c.length,n=c[m-1],q=k[0],p=k[1],l=k[2],t=k[3];c=d(c[m-2]/3+2/3*q);n=d(n/3+2/3*p);q=d(2/3*q+l/3);p=d(2/3*p+t/3);a+=" c "+c+","+n+","+q+","+p+","+l+","+t}"C"==h&&(a+=" c "+k[0]+","+k[1]+","+k[2]+","+k[3]+","+k[4]+","+k[5]);"A"==h&&(a+=" wa "+
f);"B"==h&&(a+=" at "+f);c=k}return a},animate:function(a,b,c,d,g){var f=a.node,h=this.chart;a.animationFinished=!1;if("translate"==b){b=c.split(",");c=b[1];var k=f.offsetTop;h.animate(a,"left",f.offsetLeft,b[0],d,g,"px");h.animate(a,"top",k,c,d,g,"px")}},clipRect:function(a,b,c,d,g){a=a.node;0===b&&0===c?(a.style.width=d+"px",a.style.height=g+"px",a.style.overflow="hidden"):a.style.clip="rect("+c+"px "+(b+d)+"px "+(c+g)+"px "+b+"px)"},rotate:function(a,b,c){if(0!==Number(b)){var e=a.node;a=e.style;
c||(c=this.getBGColor(e.parentNode));a.backgroundColor=c;a.paddingLeft=1;c=b*Math.PI/180;var g=Math.cos(c),f=Math.sin(c),h=d.removePx(a.left),k=d.removePx(a.top),l=e.offsetWidth,e=e.offsetHeight;b/=Math.abs(b);a.left=h+l/2-l/2*Math.cos(c)-b*e/2*Math.sin(c)+3;a.top=k-b*l/2*Math.sin(c)+b*e/2*Math.sin(c);a.cssText=a.cssText+"; filter:progid:DXImageTransform.Microsoft.Matrix(M11='"+g+"', M12='"+-f+"', M21='"+f+"', M22='"+g+"', sizingmethod='auto expand');"}},getBGColor:function(a){var b="#FFFFFF";if(a.style){var c=
a.style.backgroundColor;""!==c?b=c:a.parentNode&&(b=this.getBGColor(a.parentNode))}return b},set:function(a){var b=new d.AmDObject("group",this.D);this.D.container.appendChild(b.node);if(a){var c;for(c=0;c<a.length;c++)b.push(a[c])}return b},gradient:function(a,b,c,d){var g="";"radialGradient"==b&&(b="gradientradial",c.reverse());"linearGradient"==b&&(b="gradient");var f;for(f=0;f<c.length;f++)g+=Math.round(100*f/(c.length-1))+"% "+c[f],f<c.length-1&&(g+=",");a=a.fill;90==d?d=0:270==d?d=180:180==
d?d=90:0===d&&(d=270);8===document.documentMode?(a.type=b,a.angle=d):(a.setAttribute("type",b),a.setAttribute("angle",d));g&&(a.colors.value=g)},remove:function(a){a.clipPath&&this.D.remove(a.clipPath);this.D.remove(a.node)},disableSelection:function(a){a.onselectstart=function(){return!1};a.style.cursor="default"},pattern:function(a,b,c,e){c=a.node;a=a.fill;var g="none";b.color&&(g=b.color);c.fillColor=g;b=b.url;d.isAbsolute(b)||(b=e+b);8===document.documentMode?(a.type="tile",a.src=b):(a.setAttribute("type",
"tile"),a.setAttribute("src",b))},update:function(){}})})();(function(){var d=window.AmCharts;d.SVGRenderer=d.Class({construct:function(a){this.D=a;this.animations=[]},create:function(a,b){return document.createElementNS(d.SVG_NS,b)},attr:function(a,b){for(var c in b)b.hasOwnProperty(c)&&this.setAttr(a,c,b[c])},setAttr:function(a,b,c){void 0!==c&&a.node.setAttribute(b,c)},animate:function(a,b,c,e,g){a.animationFinished=!1;var f=a.node;a["an_"+b]&&d.removeFromArray(this.animations,a["an_"+b]);"translate"==b?(f=(f=f.getAttribute("transform"))?String(f).substring(10,
f.length-1):"0,0",f=f.split(", ").join(" "),f=f.split(" ").join(","),0===f&&(f="0,0")):f=Number(f.getAttribute(b));c={obj:a,frame:0,attribute:b,from:f,to:c,time:e,effect:g};this.animations.push(c);a["an_"+b]=c},update:function(){var a,b=this.animations;for(a=b.length-1;0<=a;a--){var c=b[a],e=c.time*d.updateRate,g=c.frame+1,f=c.obj,h=c.attribute,k,l,m;if(g<=e){c.frame++;if("translate"==h){k=c.from.split(",");h=Number(k[0]);k=Number(k[1]);isNaN(k)&&(k=0);l=c.to.split(",");m=Number(l[0]);l=Number(l[1]);
m=0===m-h?m:Math.round(d[c.effect](0,g,h,m-h,e));c=0===l-k?l:Math.round(d[c.effect](0,g,k,l-k,e));h="transform";if(isNaN(m)||isNaN(c))continue;c="translate("+m+","+c+")"}else l=Number(c.from),k=Number(c.to),m=k-l,c=d[c.effect](0,g,l,m,e),isNaN(c)&&(c=k),0===m&&this.animations.splice(a,1);this.setAttr(f,h,c)}else"translate"==h?(l=c.to.split(","),m=Number(l[0]),l=Number(l[1]),f.translate(m,l)):(k=Number(c.to),this.setAttr(f,h,k)),f.animationFinished=!0,this.animations.splice(a,1)}},getBBox:function(a){if(a=
a.node)try{return a.getBBox()}catch(b){}return{width:0,height:0,x:0,y:0}},path:function(a,b){a.node.setAttributeNS(d.SVG_XLINK,"xlink:href",b)},clipRect:function(a,b,c,e,g){var f=a.node,h=a.clipPath;h&&this.D.remove(h);var k=f.parentNode;k&&(f=document.createElementNS(d.SVG_NS,"clipPath"),h=d.getUniqueId(),f.setAttribute("id",h),this.D.rect(b,c,e,g,0,0,f),k.appendChild(f),b="#",d.baseHref&&!d.isIE&&(b=this.removeTarget(window.location.href)+b),this.setAttr(a,"clip-path","url("+b+h+")"),this.clipPathC++,
a.clipPath=f)},text:function(a,b,c){var e=new d.AmDObject("text",this.D);a=String(a).split("\n");var g=d.removePx(b["font-size"]),f;for(f=0;f<a.length;f++){var h=this.create(null,"tspan");h.appendChild(document.createTextNode(a[f]));h.setAttribute("y",(g+2)*f+Math.round(g/2));h.setAttribute("x",0);e.node.appendChild(h)}e.node.setAttribute("y",Math.round(g/2));this.attr(e,b);this.D.addToContainer(e.node,c);return e},setText:function(a,b){var c=a.node;c&&(c.removeChild(c.firstChild),c.appendChild(document.createTextNode(b)))},
move:function(a,b,c,d){isNaN(b)&&(b=0);isNaN(c)&&(c=0);b="translate("+b+","+c+")";d&&(b=b+" scale("+d+")");this.setAttr(a,"transform",b)},rotate:function(a,b){var c=a.node.getAttribute("transform"),d="rotate("+b+")";c&&(d=c+" "+d);this.setAttr(a,"transform",d)},set:function(a){var b=new d.AmDObject("g",this.D);this.D.container.appendChild(b.node);if(a){var c;for(c=0;c<a.length;c++)b.push(a[c])}return b},addListener:function(a,b,c){a.node["on"+b]=c},gradient:function(a,b,c,e){var g=a.node,f=a.grad;
f&&this.D.remove(f);b=document.createElementNS(d.SVG_NS,b);f=d.getUniqueId();b.setAttribute("id",f);if(!isNaN(e)){var h=0,k=0,l=0,m=0;90==e?l=100:270==e?m=100:180==e?h=100:0===e&&(k=100);b.setAttribute("x1",h+"%");b.setAttribute("x2",k+"%");b.setAttribute("y1",l+"%");b.setAttribute("y2",m+"%")}for(e=0;e<c.length;e++)h=document.createElementNS(d.SVG_NS,"stop"),k=100*e/(c.length-1),0===e&&(k=0),h.setAttribute("offset",k+"%"),h.setAttribute("stop-color",c[e]),b.appendChild(h);g.parentNode.appendChild(b);
c="#";d.baseHref&&!d.isIE&&(c=this.removeTarget(window.location.href)+c);g.setAttribute("fill","url("+c+f+")");a.grad=b},removeTarget:function(a){return a.split("#")[0]},pattern:function(a,b,c,e){var g=a.node;isNaN(c)&&(c=1);var f=a.patternNode;f&&this.D.remove(f);var f=document.createElementNS(d.SVG_NS,"pattern"),h=d.getUniqueId(),k=b;b.url&&(k=b.url);d.isAbsolute(k)||-1!=k.indexOf("data:image")||(k=e+k);e=Number(b.width);isNaN(e)&&(e=4);var l=Number(b.height);isNaN(l)&&(l=4);e/=c;l/=c;c=b.x;isNaN(c)&&
(c=0);var m=-Math.random()*Number(b.randomX);isNaN(m)||(c=m);m=b.y;isNaN(m)&&(m=0);var n=-Math.random()*Number(b.randomY);isNaN(n)||(m=n);f.setAttribute("id",h);f.setAttribute("width",e);f.setAttribute("height",l);f.setAttribute("patternUnits","userSpaceOnUse");f.setAttribute("xlink:href",k);b.color&&(n=document.createElementNS(d.SVG_NS,"rect"),n.setAttributeNS(null,"height",e),n.setAttributeNS(null,"width",l),n.setAttributeNS(null,"fill",b.color),f.appendChild(n));this.D.image(k,0,0,e,l,f).translate(c,
m);k="#";d.baseHref&&!d.isIE&&(k=this.removeTarget(window.location.href)+k);g.setAttribute("fill","url("+k+h+")");a.patternNode=f;g.parentNode.appendChild(f)},remove:function(a){a.clipPath&&this.D.remove(a.clipPath);a.grad&&this.D.remove(a.grad);a.patternNode&&this.D.remove(a.patternNode);this.D.remove(a.node)}})})();(function(){var d=window.AmCharts;d.AmLegend=d.Class({construct:function(a){this.enabled=!0;this.cname="AmLegend";this.createEvents("rollOverMarker","rollOverItem","rollOutMarker","rollOutItem","showItem","hideItem","clickMarker","clickLabel");this.position="bottom";this.borderColor=this.color="#000000";this.borderAlpha=0;this.markerLabelGap=5;this.verticalGap=10;this.align="left";this.horizontalGap=0;this.spacing=10;this.markerDisabledColor="#AAB3B3";this.markerType="square";this.markerSize=16;this.markerBorderThickness=
this.markerBorderAlpha=1;this.marginBottom=this.marginTop=0;this.marginLeft=this.marginRight=20;this.autoMargins=!0;this.valueWidth=50;this.switchable=!0;this.switchType="x";this.switchColor="#FFFFFF";this.rollOverColor="#CC0000";this.reversedOrder=!1;this.labelText="[[title]]";this.valueText="[[value]]";this.accessibleLabel="[[title]]";this.useMarkerColorForLabels=!1;this.rollOverGraphAlpha=1;this.textClickEnabled=!1;this.equalWidths=!0;this.backgroundColor="#FFFFFF";this.backgroundAlpha=0;this.useGraphSettings=
!1;this.showEntries=!0;this.labelDx=0;d.applyTheme(this,a,this.cname)},setData:function(a){this.legendData=a;this.invalidateSize()},invalidateSize:function(){this.destroy();this.entries=[];this.valueLabels=[];var a=this.legendData;this.enabled&&(d.ifArray(a)||d.ifArray(this.data))&&this.drawLegend()},drawLegend:function(){var a=this.chart,b=this.position,c=this.width,e=a.divRealWidth,g=a.divRealHeight,f=this.div,h=this.legendData;this.data&&(h=this.combineLegend?this.legendData.concat(this.data):
this.data);isNaN(this.fontSize)&&(this.fontSize=a.fontSize);this.maxColumnsReal=this.maxColumns;if("right"==b||"left"==b)this.maxColumnsReal=1,this.autoMargins&&(this.marginLeft=this.marginRight=10);else if(this.autoMargins){this.marginRight=a.marginRight;this.marginLeft=a.marginLeft;var k=a.autoMarginOffset;"bottom"==b?(this.marginBottom=k,this.marginTop=0):(this.marginTop=k,this.marginBottom=0)}c=void 0!==c?d.toCoordinate(c,e):"right"!=b&&"left"!=b?a.realWidth:0<this.ieW?this.ieW:a.realWidth;"outside"==
b?(c=f.offsetWidth,g=f.offsetHeight,f.clientHeight&&(c=f.clientWidth,g=f.clientHeight)):(isNaN(c)||(f.style.width=c+"px"),f.className="amChartsLegend "+a.classNamePrefix+"-legend-div");this.divWidth=c;(b=this.container)?(b.container.innerHTML="",f.appendChild(b.container),b.width=c,b.height=g,b.setSize(c,g),b.addDefs(a)):b=new d.AmDraw(f,c,g,a);this.container=b;this.lx=0;this.ly=8;g=this.markerSize;g>this.fontSize&&(this.ly=g/2-1);0<g&&(this.lx+=g+this.markerLabelGap);this.titleWidth=0;if(g=this.title)g=
d.text(this.container,g,this.color,a.fontFamily,this.fontSize,"start",!0),d.setCN(a,g,"legend-title"),g.translate(this.marginLeft,this.marginTop+this.verticalGap+this.ly+1),a=g.getBBox(),this.titleWidth=a.width+15,this.titleHeight=a.height+6;this.index=this.maxLabelWidth=0;if(this.showEntries){for(a=0;a<h.length;a++)this.createEntry(h[a]);for(a=this.index=0;a<h.length;a++)this.createValue(h[a])}this.arrangeEntries();this.updateValues()},arrangeEntries:function(){var a=this.position,b=this.marginLeft+
this.titleWidth,c=this.marginRight,e=this.marginTop,g=this.marginBottom,f=this.horizontalGap,h=this.div,k=this.divWidth,l=this.maxColumnsReal,m=this.verticalGap,n=this.spacing,q=k-c-b,p=0,t=0,r=this.container;this.set&&this.set.remove();var w=r.set();this.set=w;var z=r.set();w.push(z);var x=this.entries,u,A;for(A=0;A<x.length;A++){u=x[A].getBBox();var y=u.width;y>p&&(p=y);u=u.height;u>t&&(t=u)}var y=t=0,B=f,D=0,C=0;for(A=0;A<x.length;A++){var I=x[A];this.reversedOrder&&(I=x[x.length-A-1]);u=I.getBBox();
var H;this.equalWidths?H=y*(p+n+this.markerLabelGap):(H=B,B=B+u.width+f+n);H+u.width>q&&0<A&&0!==y&&(t++,H=y=0,B=H+u.width+f+n,D=D+C+m,C=0);u.height>C&&(C=u.height);I.translate(H,D);y++;!isNaN(l)&&y>=l&&(y=0,t++,D=D+C+m,B=f,C=0);z.push(I)}u=z.getBBox();l=u.height+2*m-1;"left"==a||"right"==a?(n=u.width+2*f,k=n+b+c,h.style.width=k+"px",this.ieW=k):n=k-b-c-1;c=d.polygon(this.container,[0,n,n,0],[0,0,l,l],this.backgroundColor,this.backgroundAlpha,1,this.borderColor,this.borderAlpha);d.setCN(this.chart,
c,"legend-bg");w.push(c);w.translate(b,e);c.toBack();b=f;if("top"==a||"bottom"==a||"absolute"==a||"outside"==a)"center"==this.align?b=f+(n-u.width)/2:"right"==this.align&&(b=f+n-u.width);z.translate(b,m+1);this.titleHeight>l&&(l=this.titleHeight);e=l+e+g+1;0>e&&(e=0);"absolute"!=a&&"outside"!=a&&e>this.chart.divRealHeight&&(h.style.top="0px");h.style.height=Math.round(e)+"px";r.setSize(this.divWidth,e)},createEntry:function(a){if(!1!==a.visibleInLegend&&!a.hideFromLegend){var b=this,c=b.chart,e=b.useGraphSettings,
g=a.markerType;g&&(e=!1);a.legendEntryWidth=b.markerSize;g||(g=b.markerType);var f=a.color,h=a.alpha;a.legendKeyColor&&(f=a.legendKeyColor());a.legendKeyAlpha&&(h=a.legendKeyAlpha());var k;!0===a.hidden&&(k=f=b.markerDisabledColor);var l=a.pattern,m,n=a.customMarker;n||(n=b.customMarker);var q=b.container,p=b.markerSize,t=0,r=0,w=p/2;if(e){e=a.type;b.switchType=void 0;if("line"==e||"step"==e||"smoothedLine"==e||"ohlc"==e)m=q.set(),a.hidden||(f=a.lineColorR,k=a.bulletBorderColorR),t=d.line(q,[0,2*
p],[p/2,p/2],f,a.lineAlpha,a.lineThickness,a.dashLength),d.setCN(c,t,"graph-stroke"),m.push(t),a.bullet&&(a.hidden||(f=a.bulletColorR),t=d.bullet(q,a.bullet,a.bulletSize,f,a.bulletAlpha,a.bulletBorderThickness,k,a.bulletBorderAlpha))&&(d.setCN(c,t,"graph-bullet"),t.translate(p+1,p/2),m.push(t)),w=0,t=p,r=p/3;else{a.getGradRotation&&(m=a.getGradRotation(),0===m&&(m=180));t=a.fillColorsR;!0===a.hidden&&(t=f);if(m=b.createMarker("rectangle",t,a.fillAlphas,a.lineThickness,f,a.lineAlpha,m,l,a.dashLength))w=
p,m.translate(w,p/2);t=p}d.setCN(c,m,"graph-"+e);d.setCN(c,m,"graph-"+a.id)}else if(n)m=q.image(n,0,0,p,p);else{var z;isNaN(b.gradientRotation)||(z=180+b.gradientRotation);(m=b.createMarker(g,f,h,void 0,void 0,void 0,z,l))&&m.translate(p/2,p/2)}d.setCN(c,m,"legend-marker");b.addListeners(m,a);q=q.set([m]);b.switchable&&a.switchable&&q.setAttr("cursor","pointer");void 0!==a.id&&d.setCN(c,q,"legend-item-"+a.id);d.setCN(c,q,a.className,!0);k=b.switchType;var x;k&&"none"!=k&&0<p&&("x"==k?(x=b.createX(),
x.translate(p/2,p/2)):x=b.createV(),x.dItem=a,!0!==a.hidden?"x"==k?x.hide():x.show():"x"!=k&&x.hide(),b.switchable||x.hide(),b.addListeners(x,a),a.legendSwitch=x,q.push(x),d.setCN(c,x,"legend-switch"));k=b.color;a.showBalloon&&b.textClickEnabled&&void 0!==b.selectedColor&&(k=b.selectedColor);b.useMarkerColorForLabels&&!l&&(k=f);!0===a.hidden&&(k=b.markerDisabledColor);f=d.massReplace(b.labelText,{"[[title]]":a.title});void 0!==b.tabIndex&&(q.setAttr("tabindex",b.tabIndex),q.setAttr("role","menuitem"),
q.keyup(function(c){13==c.keyCode&&b.clickMarker(a,c)}));c.accessible&&b.accessibleLabel&&(l=d.massReplace(b.accessibleLabel,{"[[title]]":a.title}),c.makeAccessible(q,l));l=b.fontSize;m&&(p<=l&&(p=p/2+b.ly-l/2+(l+2-p)/2-r,m.translate(w,p),x&&x.translate(x.x,p)),a.legendEntryWidth=m.getBBox().width);var u;f&&(f=d.fixBrakes(f),a.legendTextReal=f,u=b.labelWidth,u=isNaN(u)?d.text(b.container,f,k,c.fontFamily,l,"start"):d.wrappedText(b.container,f,k,c.fontFamily,l,"start",!1,u,0),d.setCN(c,u,"legend-label"),
u.translate(b.lx+t,b.ly),q.push(u),b.labelDx=t,c=u.getBBox().width,b.maxLabelWidth<c&&(b.maxLabelWidth=c));b.entries[b.index]=q;a.legendEntry=b.entries[b.index];a.legendMarker=m;a.legendLabel=u;b.index++}},addListeners:function(a,b){var c=this;a&&a.mouseover(function(a){c.rollOverMarker(b,a)}).mouseout(function(a){c.rollOutMarker(b,a)}).click(function(a){c.clickMarker(b,a)})},rollOverMarker:function(a,b){this.switchable&&this.dispatch("rollOverMarker",a,b);this.dispatch("rollOverItem",a,b)},rollOutMarker:function(a,
b){this.switchable&&this.dispatch("rollOutMarker",a,b);this.dispatch("rollOutItem",a,b)},clickMarker:function(a,b){this.switchable&&(!0===a.hidden?this.dispatch("showItem",a,b):this.dispatch("hideItem",a,b));this.dispatch("clickMarker",a,b)},rollOverLabel:function(a,b){a.hidden||this.textClickEnabled&&a.legendLabel&&a.legendLabel.attr({fill:this.rollOverColor});this.dispatch("rollOverItem",a,b)},rollOutLabel:function(a,b){if(!a.hidden&&this.textClickEnabled&&a.legendLabel){var c=this.color;void 0!==
this.selectedColor&&a.showBalloon&&(c=this.selectedColor);this.useMarkerColorForLabels&&(c=a.lineColor,void 0===c&&(c=a.color));a.legendLabel.attr({fill:c})}this.dispatch("rollOutItem",a,b)},clickLabel:function(a,b){this.textClickEnabled?a.hidden||this.dispatch("clickLabel",a,b):this.switchable&&(!0===a.hidden?this.dispatch("showItem",a,b):this.dispatch("hideItem",a,b))},dispatch:function(a,b,c){a={type:a,dataItem:b,target:this,event:c,chart:this.chart};this.chart&&this.chart.handleLegendEvent(a);
this.fire(a)},createValue:function(a){var b=this,c=b.fontSize,e=b.chart;if(!1!==a.visibleInLegend&&!a.hideFromLegend){var g=b.maxLabelWidth,f=0;b.forceWidth&&(g=b.labelWidth);b.equalWidths||(b.valueAlign="left");f={x:0,y:0,width:0,height:0};a.legendLabel&&(f=a.legendLabel.getBBox());"left"==b.valueAlign&&(g=f.width);var f=f.height,h=g,k=b.markerSize;k<c+7&&(k=c+7,d.VML&&(k+=3));if(b.valueText&&0<b.valueWidth){var l=b.color;b.useMarkerColorForValues&&(l=a.color,a.legendKeyColor&&(l=a.legendKeyColor()));
!0===a.hidden&&(l=b.markerDisabledColor);var m=b.valueText,g=g+b.lx+b.labelDx+b.markerLabelGap+b.valueWidth,n="end";"left"==b.valueAlign&&(g-=b.valueWidth,n="start");c=d.text(b.container,m,l,b.chart.fontFamily,c,n);d.setCN(e,c,"legend-value");c.translate(g,b.ly);b.entries[b.index].push(c);h+=b.valueWidth+2*b.markerLabelGap;c.dItem=a;b.valueLabels.push(c);k<f+5&&(k=f+5)}b.index++;e=b.container.rect(a.legendEntryWidth,0,h,k,0,0).attr({stroke:"none",fill:"#fff","fill-opacity":.005});e.dItem=a;b.entries[b.index-
1].push(e);e.mouseover(function(c){b.rollOverLabel(a,c)}).mouseout(function(c){b.rollOutLabel(a,c)}).click(function(c){b.clickLabel(a,c)})}},createV:function(){var a=this.markerSize;return d.polygon(this.container,[a/5,a/2,a-a/5,a/2],[a/3,a-a/5,a/5,a/1.7],this.switchColor)},createX:function(){var a=(this.markerSize-4)/2,b={stroke:this.switchColor,"stroke-width":3},c=this.container,e=d.line(c,[-a,a],[-a,a]).attr(b),a=d.line(c,[-a,a],[a,-a]).attr(b);return this.container.set([e,a])},createMarker:function(a,
b,c,e,g,f,h,k,l){var m=this.markerSize,n=this.container;g||(g=this.markerBorderColor);g||(g=b);isNaN(e)&&(e=this.markerBorderThickness);isNaN(f)&&(f=this.markerBorderAlpha);return d.bullet(n,a,m,b,c,e,g,f,m,h,k,this.chart.path,l)},validateNow:function(){this.invalidateSize()},updateValues:function(){var a=this.valueLabels,b=this.chart,c,e=this.data;if(a)for(c=0;c<a.length;c++){var g=a[c],f=g.dItem;f.periodDataItem=void 0;f.periodPercentDataItem=void 0;var h=" ";if(e)f.value?g.text(f.value):g.text("");
else{var k=null;if(void 0!==f.type){var k=f.currentDataItem,l=this.periodValueText;f.legendPeriodValueText&&(l=f.legendPeriodValueText);f.legendPeriodValueTextR&&(l=f.legendPeriodValueTextR);k?(h=this.valueText,f.legendValueText&&(h=f.legendValueText),f.legendValueTextR&&(h=f.legendValueTextR),h=b.formatString(h,k)):l&&b.formatPeriodString&&(l=d.massReplace(l,{"[[title]]":f.title}),h=b.formatPeriodString(l,f))}else h=b.formatString(this.valueText,f);l=f;k&&(l=k);var m=this.valueFunction;m&&(h=m(l,
h,b.periodDataItem));var n;this.useMarkerColorForLabels&&!k&&f.lastDataItem&&(k=f.lastDataItem);k?n=b.getBalloonColor(f,k):f.legendKeyColor&&(n=f.legendKeyColor());f.legendColorFunction&&(n=f.legendColorFunction(l,h,f.periodDataItem,f.periodPercentDataItem));g.text(h);if(!f.pattern&&(this.useMarkerColorForValues&&g.setAttr("fill",n),this.useMarkerColorForLabels)){if(g=f.legendMarker)g.setAttr("fill",n),g.setAttr("stroke",n);(g=f.legendLabel)&&(f.hidden?g.setAttr("fill",this.markerDisabledColor):g.setAttr("fill",
n))}}}},renderFix:function(){if(!d.VML&&this.enabled){var a=this.container;a&&a.renderFix()}},destroy:function(){this.div.innerHTML="";d.remove(this.set)}})})();(function(){var d=window.AmCharts;d.formatMilliseconds=function(a,b){if(-1!=a.indexOf("fff")){var c=b.getMilliseconds(),d=String(c);10>c&&(d="00"+c);10<=c&&100>c&&(d="0"+c);a=a.replace(/fff/g,d)}return a};d.extractPeriod=function(a){var b=d.stripNumbers(a),c=1;b!=a&&(c=Number(a.slice(0,a.indexOf(b))));return{period:b,count:c}};d.getDate=function(a,b,c){return a instanceof Date?d.newDate(a,c):b&&isNaN(a)?d.stringToDate(a,b):new Date(a)};d.daysInMonth=function(a){return(new Date(a.getYear(),a.getMonth()+
1,0)).getDate()};d.newDate=function(a,b){return b&&-1==b.indexOf("fff")?new Date(a):new Date(a.getFullYear(),a.getMonth(),a.getDate(),a.getHours(),a.getMinutes(),a.getSeconds(),a.getMilliseconds())};d.resetDateToMin=function(a,b,c,e){void 0===e&&(e=1);var g,f,h,k,l,m,n;d.useUTC?(g=a.getUTCFullYear(),f=a.getUTCMonth(),h=a.getUTCDate(),k=a.getUTCHours(),l=a.getUTCMinutes(),m=a.getUTCSeconds(),n=a.getUTCMilliseconds(),a=a.getUTCDay()):(g=a.getFullYear(),f=a.getMonth(),h=a.getDate(),k=a.getHours(),l=
a.getMinutes(),m=a.getSeconds(),n=a.getMilliseconds(),a=a.getDay());switch(b){case "YYYY":g=Math.floor(g/c)*c;f=0;h=1;n=m=l=k=0;break;case "MM":f=Math.floor(f/c)*c;h=1;n=m=l=k=0;break;case "WW":h=a>=e?h-a+e:h-(7+a)+e;n=m=l=k=0;break;case "DD":n=m=l=k=0;break;case "hh":k=Math.floor(k/c)*c;n=m=l=0;break;case "mm":l=Math.floor(l/c)*c;n=m=0;break;case "ss":m=Math.floor(m/c)*c;n=0;break;case "fff":n=Math.floor(n/c)*c}d.useUTC?(a=new Date,a.setUTCFullYear(g,f,h),a.setUTCHours(k,l,m,n)):a=new Date(g,f,h,
k,l,m,n);return a};d.getPeriodDuration=function(a,b){void 0===b&&(b=1);var c;switch(a){case "YYYY":c=316224E5;break;case "MM":c=26784E5;break;case "WW":c=6048E5;break;case "DD":c=864E5;break;case "hh":c=36E5;break;case "mm":c=6E4;break;case "ss":c=1E3;break;case "fff":c=1}return c*b};d.intervals={s:{nextInterval:"ss",contains:1E3},ss:{nextInterval:"mm",contains:60,count:0},mm:{nextInterval:"hh",contains:60,count:1},hh:{nextInterval:"DD",contains:24,count:2},DD:{nextInterval:"",contains:Infinity,count:3}};
d.getMaxInterval=function(a,b){var c=d.intervals;return a>=c[b].contains?(a=Math.round(a/c[b].contains),b=c[b].nextInterval,d.getMaxInterval(a,b)):"ss"==b?c[b].nextInterval:b};d.dayNames="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" ");d.shortDayNames="Sun Mon Tue Wed Thu Fri Sat".split(" ");d.monthNames="January February March April May June July August September October November December".split(" ");d.shortMonthNames="Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ");
d.getWeekNumber=function(a){a=new Date(a);a.setHours(0,0,0);a.setDate(a.getDate()+4-(a.getDay()||7));var b=new Date(a.getFullYear(),0,1);return Math.ceil(((a-b)/864E5+1)/7)};d.stringToDate=function(a,b){var c={},e=[{pattern:"YYYY",period:"year"},{pattern:"YY",period:"year"},{pattern:"MM",period:"month"},{pattern:"M",period:"month"},{pattern:"DD",period:"date"},{pattern:"D",period:"date"},{pattern:"JJ",period:"hours"},{pattern:"J",period:"hours"},{pattern:"HH",period:"hours"},{pattern:"H",period:"hours"},
{pattern:"KK",period:"hours"},{pattern:"K",period:"hours"},{pattern:"LL",period:"hours"},{pattern:"L",period:"hours"},{pattern:"NN",period:"minutes"},{pattern:"N",period:"minutes"},{pattern:"SS",period:"seconds"},{pattern:"S",period:"seconds"},{pattern:"QQQ",period:"milliseconds"},{pattern:"QQ",period:"milliseconds"},{pattern:"Q",period:"milliseconds"}],g=!0,f=b.indexOf("AA");-1!=f&&(a.substr(f,2),"pm"==a.toLowerCase&&(g=!1));var f=b,h,k,l;for(l=0;l<e.length;l++)k=e[l].period,c[k]=0,"date"==k&&(c[k]=
1);for(l=0;l<e.length;l++)if(h=e[l].pattern,k=e[l].period,-1!=b.indexOf(h)){var m=d.getFromDateString(h,a,f);b=b.replace(h,"");if("KK"==h||"K"==h||"LL"==h||"L"==h)g||(m+=12);c[k]=m}d.useUTC?(e=new Date,e.setUTCFullYear(c.year,c.month,c.date),e.setUTCHours(c.hours,c.minutes,c.seconds,c.milliseconds)):e=new Date(c.year,c.month,c.date,c.hours,c.minutes,c.seconds,c.milliseconds);return e};d.getFromDateString=function(a,b,c){if(void 0!==b)return c=c.indexOf(a),b=String(b),b=b.substr(c,a.length),"0"==b.charAt(0)&&
(b=b.substr(1,b.length-1)),b=Number(b),isNaN(b)&&(b=0),-1!=a.indexOf("M")&&b--,b};d.formatDate=function(a,b,c){c||(c=d);var e,g,f,h,k,l,m,n,q=d.getWeekNumber(a);d.useUTC?(e=a.getUTCFullYear(),g=a.getUTCMonth(),f=a.getUTCDate(),h=a.getUTCDay(),k=a.getUTCHours(),l=a.getUTCMinutes(),m=a.getUTCSeconds(),n=a.getUTCMilliseconds()):(e=a.getFullYear(),g=a.getMonth(),f=a.getDate(),h=a.getDay(),k=a.getHours(),l=a.getMinutes(),m=a.getSeconds(),n=a.getMilliseconds());var p=String(e).substr(2,2),t="0"+h;b=b.replace(/W/g,
q);q=k;24==q&&(q=0);var r=q;10>r&&(r="0"+r);b=b.replace(/JJ/g,r);b=b.replace(/J/g,q);r=k;0===r&&(r=24,-1!=b.indexOf("H")&&(f--,0===f&&(e=new Date(a),e.setDate(e.getDate()-1),g=e.getMonth(),f=e.getDate(),e=e.getFullYear())));a=g+1;9>g&&(a="0"+a);q=f;10>f&&(q="0"+f);var w=r;10>w&&(w="0"+w);b=b.replace(/HH/g,w);b=b.replace(/H/g,r);r=k;11<r&&(r-=12);w=r;10>w&&(w="0"+w);b=b.replace(/KK/g,w);b=b.replace(/K/g,r);r=k;0===r&&(r=12);12<r&&(r-=12);w=r;10>w&&(w="0"+w);b=b.replace(/LL/g,w);b=b.replace(/L/g,r);
r=l;10>r&&(r="0"+r);b=b.replace(/NN/g,r);b=b.replace(/N/g,l);l=m;10>l&&(l="0"+l);b=b.replace(/SS/g,l);b=b.replace(/S/g,m);m=n;10>m?m="00"+m:100>m&&(m="0"+m);l=n;10>l&&(l="00"+l);b=b.replace(/A/g,"@A@");b=b.replace(/QQQ/g,m);b=b.replace(/QQ/g,l);b=b.replace(/Q/g,n);b=b.replace(/YYYY/g,"@IIII@");b=b.replace(/YY/g,"@II@");b=b.replace(/MMMM/g,"@XXXX@");b=b.replace(/MMM/g,"@XXX@");b=b.replace(/MM/g,"@XX@");b=b.replace(/M/g,"@X@");b=b.replace(/DD/g,"@RR@");b=b.replace(/D/g,"@R@");b=b.replace(/EEEE/g,"@PPPP@");
b=b.replace(/EEE/g,"@PPP@");b=b.replace(/EE/g,"@PP@");b=b.replace(/E/g,"@P@");b=b.replace(/@IIII@/g,e);b=b.replace(/@II@/g,p);b=b.replace(/@XXXX@/g,c.monthNames[g]);b=b.replace(/@XXX@/g,c.shortMonthNames[g]);b=b.replace(/@XX@/g,a);b=b.replace(/@X@/g,g+1);b=b.replace(/@RR@/g,q);b=b.replace(/@R@/g,f);b=b.replace(/@PPPP@/g,c.dayNames[h]);b=b.replace(/@PPP@/g,c.shortDayNames[h]);b=b.replace(/@PP@/g,t);b=b.replace(/@P@/g,h);return b=12>k?b.replace(/@A@/g,c.amString):b.replace(/@A@/g,c.pmString)};d.changeDate=
function(a,b,c,e,g){if(d.useUTC)return d.changeUTCDate(a,b,c,e,g);var f=-1;void 0===e&&(e=!0);void 0===g&&(g=!1);!0===e&&(f=1);switch(b){case "YYYY":a.setFullYear(a.getFullYear()+c*f);e||g||a.setDate(a.getDate()+1);break;case "MM":b=a.getMonth();var h=a.getFullYear();a.setMonth(b+c*f);var k=a.getMonth();if(e&&k-b>c)for(;a.getMonth()-b>c;)a.setDate(a.getDate()-1);h==a.getFullYear()&&a.getMonth()>b+c*f&&a.setDate(a.getDate()-1);e||g||a.setDate(a.getDate()+1);break;case "DD":a.setDate(a.getDate()+c*
f);break;case "WW":a.setDate(a.getDate()+c*f*7);break;case "hh":a.setHours(a.getHours()+c*f);break;case "mm":a.setMinutes(a.getMinutes()+c*f);break;case "ss":a.setSeconds(a.getSeconds()+c*f);break;case "fff":a.setMilliseconds(a.getMilliseconds()+c*f)}return a};d.changeUTCDate=function(a,b,c,d,g){var f=-1;void 0===d&&(d=!0);void 0===g&&(g=!1);!0===d&&(f=1);switch(b){case "YYYY":a.setUTCFullYear(a.getUTCFullYear()+c*f);d||g||a.setUTCDate(a.getUTCDate()+1);break;case "MM":b=a.getUTCMonth();a.setUTCMonth(a.getUTCMonth()+
c*f);a.getUTCMonth()>b+c*f&&a.setUTCDate(a.getUTCDate()-1);d||g||a.setUTCDate(a.getUTCDate()+1);break;case "DD":a.setUTCDate(a.getUTCDate()+c*f);break;case "WW":a.setUTCDate(a.getUTCDate()+c*f*7);break;case "hh":a.setUTCHours(a.getUTCHours()+c*f);break;case "mm":a.setUTCMinutes(a.getUTCMinutes()+c*f);break;case "ss":a.setUTCSeconds(a.getUTCSeconds()+c*f);break;case "fff":a.setUTCMilliseconds(a.getUTCMilliseconds()+c*f)}return a}})();

(function(){var e=window.AmCharts;e.AmRectangularChart=e.Class({inherits:e.AmCoordinateChart,construct:function(a){e.AmRectangularChart.base.construct.call(this,a);this.theme=a;this.createEvents("zoomed","changed");this.marginRight=this.marginBottom=this.marginTop=this.marginLeft=20;this.depth3D=this.angle=0;this.plotAreaFillColors="#FFFFFF";this.plotAreaFillAlphas=0;this.plotAreaBorderColor="#000000";this.plotAreaBorderAlpha=0;this.maxZoomFactor=20;this.zoomOutButtonImageSize=19;this.zoomOutButtonImage=
"lens";this.zoomOutText="Show all";this.zoomOutButtonColor="#e5e5e5";this.zoomOutButtonAlpha=0;this.zoomOutButtonRollOverAlpha=1;this.zoomOutButtonPadding=8;this.trendLines=[];this.autoMargins=!0;this.marginsUpdated=!1;this.autoMarginOffset=10;e.applyTheme(this,a,"AmRectangularChart")},initChart:function(){e.AmRectangularChart.base.initChart.call(this);this.updateDxy();!this.marginsUpdated&&this.autoMargins&&(this.resetMargins(),this.drawGraphs=!1);this.processScrollbars();this.updateMargins();this.updatePlotArea();
this.updateScrollbars();this.updateTrendLines();this.updateChartCursor();this.updateValueAxes();this.scrollbarOnly||this.updateGraphs()},drawChart:function(){e.AmRectangularChart.base.drawChart.call(this);this.drawPlotArea();if(e.ifArray(this.chartData)){var a=this.chartCursor;a&&a.draw()}},resetMargins:function(){var a={},b;if("xy"==this.type){var c=this.xAxes,d=this.yAxes;for(b=0;b<c.length;b++){var g=c[b];g.ignoreAxisWidth||(g.setOrientation(!0),g.fixAxisPosition(),a[g.position]=!0)}for(b=0;b<
d.length;b++)c=d[b],c.ignoreAxisWidth||(c.setOrientation(!1),c.fixAxisPosition(),a[c.position]=!0)}else{d=this.valueAxes;for(b=0;b<d.length;b++)c=d[b],c.ignoreAxisWidth||(c.setOrientation(this.rotate),c.fixAxisPosition(),a[c.position]=!0);(b=this.categoryAxis)&&!b.ignoreAxisWidth&&(b.setOrientation(!this.rotate),b.fixAxisPosition(),b.fixAxisPosition(),a[b.position]=!0)}a.left&&(this.marginLeft=0);a.right&&(this.marginRight=0);a.top&&(this.marginTop=0);a.bottom&&(this.marginBottom=0);this.fixMargins=
a},measureMargins:function(){var a=this.valueAxes,b,c=this.autoMarginOffset,d=this.fixMargins,g=this.realWidth,h=this.realHeight,f=c,e=c,k=g;b=h;var m;for(m=0;m<a.length;m++)a[m].handleSynchronization(),b=this.getAxisBounds(a[m],f,k,e,b),f=Math.round(b.l),k=Math.round(b.r),e=Math.round(b.t),b=Math.round(b.b);if(a=this.categoryAxis)b=this.getAxisBounds(a,f,k,e,b),f=Math.round(b.l),k=Math.round(b.r),e=Math.round(b.t),b=Math.round(b.b);d.left&&f<c&&(this.marginLeft=Math.round(-f+c),!isNaN(this.minMarginLeft)&&
this.marginLeft<this.minMarginLeft&&(this.marginLeft=this.minMarginLeft));d.right&&k>=g-c&&(this.marginRight=Math.round(k-g+c),!isNaN(this.minMarginRight)&&this.marginRight<this.minMarginRight&&(this.marginRight=this.minMarginRight));d.top&&e<c+this.titleHeight&&(this.marginTop=Math.round(this.marginTop-e+c+this.titleHeight),!isNaN(this.minMarginTop)&&this.marginTop<this.minMarginTop&&(this.marginTop=this.minMarginTop));d.bottom&&b>h-c&&(this.marginBottom=Math.round(this.marginBottom+b-h+c),!isNaN(this.minMarginBottom)&&
this.marginBottom<this.minMarginBottom&&(this.marginBottom=this.minMarginBottom));this.initChart()},getAxisBounds:function(a,b,c,d,g){if(!a.ignoreAxisWidth){var h=a.labelsSet,f=a.tickLength;a.inside&&(f=0);if(h)switch(h=a.getBBox(),a.position){case "top":a=h.y;d>a&&(d=a);break;case "bottom":a=h.y+h.height;g<a&&(g=a);break;case "right":a=h.x+h.width+f+3;c<a&&(c=a);break;case "left":a=h.x-f,b>a&&(b=a)}}return{l:b,t:d,r:c,b:g}},drawZoomOutButton:function(){var a=this;if(!a.zbSet){var b=a.container.set();
a.zoomButtonSet.push(b);var c=a.color,d=a.fontSize,g=a.zoomOutButtonImageSize,h=a.zoomOutButtonImage.replace(/\.[a-z]*$/i,""),f=a.langObj.zoomOutText||a.zoomOutText,l=a.zoomOutButtonColor,k=a.zoomOutButtonAlpha,m=a.zoomOutButtonFontSize,p=a.zoomOutButtonPadding;isNaN(m)||(d=m);(m=a.zoomOutButtonFontColor)&&(c=m);var m=a.zoomOutButton,n;m&&(m.fontSize&&(d=m.fontSize),m.color&&(c=m.color),m.backgroundColor&&(l=m.backgroundColor),isNaN(m.backgroundAlpha)||(a.zoomOutButtonRollOverAlpha=m.backgroundAlpha));
var u=m=0,u=a.pathToImages;if(h){if(e.isAbsolute(h)||void 0===u)u="";n=a.container.image(u+h+a.extension,0,0,g,g);e.setCN(a,n,"zoom-out-image");b.push(n);n=n.getBBox();m=n.width+5}void 0!==f&&(c=e.text(a.container,f,c,a.fontFamily,d,"start"),e.setCN(a,c,"zoom-out-label"),d=c.getBBox(),u=n?n.height/2-3:d.height/2,c.translate(m,u),b.push(c));n=b.getBBox();c=1;e.isModern||(c=0);l=e.rect(a.container,n.width+2*p+5,n.height+2*p-2,l,1,1,l,c);l.setAttr("opacity",k);l.translate(-p,-p);e.setCN(a,l,"zoom-out-bg");
b.push(l);l.toBack();a.zbBG=l;n=l.getBBox();b.translate(a.marginLeftReal+a.plotAreaWidth-n.width+p,a.marginTopReal+p);b.hide();b.mouseover(function(){a.rollOverZB()}).mouseout(function(){a.rollOutZB()}).click(function(){a.clickZB()}).touchstart(function(){a.rollOverZB()}).touchend(function(){a.rollOutZB();a.clickZB()});for(k=0;k<b.length;k++)b[k].attr({cursor:"pointer"});void 0!==a.zoomOutButtonTabIndex&&(b.setAttr("tabindex",a.zoomOutButtonTabIndex),b.setAttr("role","menuitem"),b.keyup(function(b){13==
b.keyCode&&a.clickZB()}));a.zbSet=b}},rollOverZB:function(){this.rolledOverZB=!0;this.zbBG.setAttr("opacity",this.zoomOutButtonRollOverAlpha)},rollOutZB:function(){this.rolledOverZB=!1;this.zbBG.setAttr("opacity",this.zoomOutButtonAlpha)},clickZB:function(){this.rolledOverZB=!1;this.zoomOut()},zoomOut:function(){this.zoomOutValueAxes()},drawPlotArea:function(){var a=this.dx,b=this.dy,c=this.marginLeftReal,d=this.marginTopReal,g=this.plotAreaWidth-1,h=this.plotAreaHeight-1,f=this.plotAreaFillColors,
l=this.plotAreaFillAlphas,k=this.plotAreaBorderColor,m=this.plotAreaBorderAlpha;"object"==typeof l&&(l=l[0]);f=e.polygon(this.container,[0,g,g,0,0],[0,0,h,h,0],f,l,1,k,m,this.plotAreaGradientAngle);e.setCN(this,f,"plot-area");f.translate(c+a,d+b);this.set.push(f);0!==a&&0!==b&&(f=this.plotAreaFillColors,"object"==typeof f&&(f=f[0]),f=e.adjustLuminosity(f,-.15),g=e.polygon(this.container,[0,a,g+a,g,0],[0,b,b,0,0],f,l,1,k,m),e.setCN(this,g,"plot-area-bottom"),g.translate(c,d+h),this.set.push(g),a=e.polygon(this.container,
[0,0,a,a,0],[0,h,h+b,b,0],f,l,1,k,m),e.setCN(this,a,"plot-area-left"),a.translate(c,d),this.set.push(a));(c=this.bbset)&&this.scrollbarOnly&&c.remove()},updatePlotArea:function(){var a=this.updateWidth(),b=this.updateHeight(),c=this.container;this.realWidth=a;this.realWidth=b;c&&this.container.setSize(a,b);var c=this.marginLeftReal,d=this.marginTopReal,a=a-c-this.marginRightReal-this.dx,b=b-d-this.marginBottomReal;1>a&&(a=1);1>b&&(b=1);this.plotAreaWidth=Math.round(a);this.plotAreaHeight=Math.round(b);
this.plotBalloonsSet.translate(c,d)},updateDxy:function(){this.dx=Math.round(this.depth3D*Math.cos(this.angle*Math.PI/180));this.dy=Math.round(-this.depth3D*Math.sin(this.angle*Math.PI/180));this.d3x=Math.round(this.columnSpacing3D*Math.cos(this.angle*Math.PI/180));this.d3y=Math.round(-this.columnSpacing3D*Math.sin(this.angle*Math.PI/180))},updateMargins:function(){var a=this.getTitleHeight();this.titleHeight=a;this.marginTopReal=this.marginTop-this.dy;this.fixMargins&&!this.fixMargins.top&&(this.marginTopReal+=
a);this.marginBottomReal=this.marginBottom;this.marginLeftReal=this.marginLeft;this.marginRightReal=this.marginRight},updateValueAxes:function(){var a=this.valueAxes,b;for(b=0;b<a.length;b++){var c=a[b];this.setAxisRenderers(c);this.updateObjectSize(c)}},setAxisRenderers:function(a){a.axisRenderer=e.RecAxis;a.guideFillRenderer=e.RecFill;a.axisItemRenderer=e.RecItem;a.marginsChanged=!0},updateGraphs:function(){var a=this.graphs,b;for(b=0;b<a.length;b++){var c=a[b];c.index=b;c.rotate=this.rotate;this.updateObjectSize(c)}},
updateObjectSize:function(a){a.width=this.plotAreaWidth-1;a.height=this.plotAreaHeight-1;a.x=this.marginLeftReal;a.y=this.marginTopReal;a.dx=this.dx;a.dy=this.dy},updateChartCursor:function(){var a=this.chartCursor;a&&(a=e.processObject(a,e.ChartCursor,this.theme),this.updateObjectSize(a),this.addChartCursor(a),a.chart=this)},processScrollbars:function(){var a=this.chartScrollbar;a&&(a=e.processObject(a,e.ChartScrollbar,this.theme),this.addChartScrollbar(a))},updateScrollbars:function(){},removeChartCursor:function(){e.callMethod("destroy",
[this.chartCursor]);this.chartCursor=null},zoomTrendLines:function(){var a=this.trendLines,b;for(b=0;b<a.length;b++){var c=a[b];c.valueAxis.recalculateToPercents?c.set&&c.set.hide():(c.x=this.marginLeftReal,c.y=this.marginTopReal,c.draw())}},handleCursorValueZoom:function(){},addTrendLine:function(a){this.trendLines.push(a)},zoomOutValueAxes:function(){for(var a=this.valueAxes,b=0;b<a.length;b++)a[b].zoomOut()},removeTrendLine:function(a){var b=this.trendLines,c;for(c=b.length-1;0<=c;c--)b[c]==a&&
b.splice(c,1)},adjustMargins:function(a,b){var c=a.position,d=a.scrollbarHeight+a.offset;a.enabled&&("top"==c?b?this.marginLeftReal+=d:this.marginTopReal+=d:b?this.marginRightReal+=d:this.marginBottomReal+=d)},getScrollbarPosition:function(a,b,c){var d="bottom",g="top";a.oppositeAxis||(g=d,d="top");a.position=b?"bottom"==c||"left"==c?d:g:"top"==c||"right"==c?d:g},updateChartScrollbar:function(a,b){if(a){a.rotate=b;var c=this.marginTopReal,d=this.marginLeftReal,g=a.scrollbarHeight,h=this.dx,f=this.dy,
e=a.offset;"top"==a.position?b?(a.y=c,a.x=d-g-e):(a.y=c-g+f-e,a.x=d+h):b?(a.y=c+f,a.x=d+this.plotAreaWidth+h+e):(a.y=c+this.plotAreaHeight+e,a.x=this.marginLeftReal)}},showZB:function(a){var b=this.zbSet;a&&(b=this.zoomOutText,""!==b&&b&&this.drawZoomOutButton());if(b=this.zbSet)this.zoomButtonSet.push(b),a?b.show():b.hide(),this.rollOutZB()},handleReleaseOutside:function(a){e.AmRectangularChart.base.handleReleaseOutside.call(this,a);(a=this.chartCursor)&&a.handleReleaseOutside&&a.handleReleaseOutside()},
handleMouseDown:function(a){e.AmRectangularChart.base.handleMouseDown.call(this,a);var b=this.chartCursor;b&&b.handleMouseDown&&!this.rolledOverZB&&b.handleMouseDown(a)},update:function(){e.AmRectangularChart.base.update.call(this);this.chartCursor&&this.chartCursor.update&&this.chartCursor.update()},handleScrollbarValueZoom:function(a){this.relativeZoomValueAxes(a.target.valueAxes,a.relativeStart,a.relativeEnd);this.zoomAxesAndGraphs()},zoomValueScrollbar:function(a){if(a&&a.enabled){var b=a.valueAxes[0],
c=b.relativeStart,d=b.relativeEnd;b.reversed&&(d=1-c,c=1-b.relativeEnd);a.percentZoom(c,d)}},zoomAxesAndGraphs:function(){if(!this.scrollbarOnly){var a=this.valueAxes,b;for(b=0;b<a.length;b++)a[b].zoom(this.start,this.end);a=this.graphs;for(b=0;b<a.length;b++)a[b].zoom(this.start,this.end);(b=this.chartCursor)&&b.clearSelection();this.zoomTrendLines()}},handleValueAxisZoomReal:function(a,b){var c=a.relativeStart,d=a.relativeEnd;if(c>d)var g=c,c=d,d=g;this.relativeZoomValueAxes(b,c,d);this.updateAfterValueZoom()},
updateAfterValueZoom:function(){this.zoomAxesAndGraphs();this.zoomScrollbar()},relativeZoomValueAxes:function(a,b,c){this.hideBalloonReal();b=e.fitToBounds(b,0,1);c=e.fitToBounds(c,0,1);if(b>c){var d=b;b=c;c=d}var d=1/this.maxZoomFactor,g=e.getDecimals(d)+4;c-b<d&&(c=b+(c-b)/2,b=c-d/2,c+=d/2,1<c&&(b-=c-1,c=1),0>b&&(b=0,c=d));b=e.roundTo(b,g);c=e.roundTo(c,g);d=!1;if(a){for(g=0;g<a.length;g++){var h=a[g].zoomToRelativeValues(b,c,!0);h&&(d=h)}this.showZB()}return d},addChartCursor:function(a){e.callMethod("destroy",
[this.chartCursor]);a&&(this.listenTo(a,"moved",this.handleCursorMove),this.listenTo(a,"zoomed",this.handleCursorZoom),this.listenTo(a,"zoomStarted",this.handleCursorZoomStarted),this.listenTo(a,"panning",this.handleCursorPanning),this.listenTo(a,"onHideCursor",this.handleCursorHide));this.chartCursor=a},handleCursorChange:function(){},handleCursorMove:function(a){var b,c=this.valueAxes;for(b=0;b<c.length;b++)if(!a.panning){var d=c[b];d&&d.showBalloon&&d.showBalloon(a.x,a.y)}},handleCursorZoom:function(a){if(this.skipZoomed)this.skipZoomed=
!1;else{var b=this.startX0,c=this.endX0,d=this.endY0,g=this.startY0,e=a.startX,f=a.endX,l=a.startY,k=a.endY;this.startX0=this.endX0=this.startY0=this.endY0=NaN;this.handleCursorZoomReal(b+e*(c-b),b+f*(c-b),g+l*(d-g),g+k*(d-g),a)}},handleCursorHide:function(){var a,b=this.valueAxes;for(a=0;a<b.length;a++)b[a].hideBalloon();b=this.graphs;for(a=0;a<b.length;a++)b[a].hideBalloonReal()}})})();(function(){var e=window.AmCharts;e.AmSerialChart=e.Class({inherits:e.AmRectangularChart,construct:function(a){this.type="serial";e.AmSerialChart.base.construct.call(this,a);this.cname="AmSerialChart";this.theme=a;this.columnSpacing=5;this.columnSpacing3D=0;this.columnWidth=.8;var b=new e.CategoryAxis(a);b.chart=this;this.categoryAxis=b;this.zoomOutOnDataUpdate=!0;this.mouseWheelZoomEnabled=this.mouseWheelScrollEnabled=this.rotate=this.skipZoom=!1;this.minSelectedTime=0;e.applyTheme(this,a,this.cname)},
initChart:function(){e.AmSerialChart.base.initChart.call(this);this.updateCategoryAxis(this.categoryAxis,this.rotate,"categoryAxis");if(this.dataChanged)this.parseData();else this.onDataUpdated();this.drawGraphs=!0},onDataUpdated:function(){var a=this.countColumns(),b=this.chartData,c=this.graphs,d;for(d=0;d<c.length;d++){var g=c[d];g.data=b;g.columnCount=a}0<b.length&&(this.firstTime=this.getStartTime(b[0].time),this.lastTime=this.getEndTime(b[b.length-1].time));this.drawChart();this.autoMargins&&
!this.marginsUpdated?(this.marginsUpdated=!0,this.measureMargins()):this.dispDUpd()},syncGrid:function(){if(this.synchronizeGrid){var a=this.valueAxes,b,c;if(0<a.length){var d=0;for(c=0;c<a.length;c++)b=a[c],d<b.gridCountReal&&(d=b.gridCountReal);var g=!1;for(c=0;c<a.length;c++)if(b=a[c],b.gridCountReal<d){var h=(d-b.gridCountReal)/2,f=g=h;0!==h-Math.round(h)&&(g-=.5,f+=.5);0<=b.min&&0>b.min-g*b.step&&(f+=g,g=0);0>=b.max&&0<b.max+f*b.step&&(g+=f,f=0);h=e.getDecimals(b.step);b.minimum=e.roundTo(b.min-
g*b.step,h);b.maximum=e.roundTo(b.max+f*b.step,h);b.setStep=b.step;g=b.strictMinMax=!0}g&&this.updateAfterValueZoom();for(c=0;c<a.length;c++)b=a[c],b.minimum=NaN,b.maximum=NaN,b.setStep=NaN,b.strictMinMax=!1}}},handleWheelReal:function(a,b){if(!this.wheelBusy){var c=this.categoryAxis,d=c.parseDates,g=c.minDuration(),e=1,f=1;this.mouseWheelZoomEnabled?b||(e=-1):b&&(e=-1);var l=this.chartCursor;if(l)if(l.mouseIsOver()){var k=l.mouseX,l=l.mouseY;e!=f&&(k=this.rotate?l/this.plotAreaHeight:k/this.plotAreaWidth,
e*=k,f*=1-k);k=.05*(this.end-this.start);d&&(k=.05*(this.endTime-this.startTime)/g);1>k&&(k=1);e*=k;f*=k;if(!d||c.equalSpacing)e=Math.round(e),f=Math.round(f);l=this.chartData.length;c=this.lastTime;k=this.firstTime;0>a?d?(l=this.endTime-this.startTime,d=this.startTime+e*g,g=this.endTime+f*g,0<f&&0<e&&g>=c&&(g=c,d=c-l),this.zoomToDates(new Date(d),new Date(g))):(0<f&&0<e&&this.end>=l-1&&(e=f=0),d=this.start+e,g=this.end+f,this.zoomToIndexes(d,g)):d?(l=this.endTime-this.startTime,d=this.startTime-
e*g,g=this.endTime-f*g,0<f&&0<e&&d<=k&&(d=k,g=k+l),this.zoomToDates(new Date(d),new Date(g))):(0<f&&0<e&&1>this.start&&(e=f=0),d=this.start-e,g=this.end-f,this.zoomToIndexes(d,g))}else this.handleMouseOut()}},validateData:function(a){this.marginsUpdated=!1;this.zoomOutOnDataUpdate&&!a&&(this.endTime=this.end=this.startTime=this.start=NaN);var b=a=!1,c=!1,d=this.chartScrollbar;d&&(d.dragging&&(a=!0,d.handleDragStop()),d.resizingRight&&(c=!0,d.rightDragStop()),d.resizingLeft&&(b=!0,d.leftDragStop()));
e.AmSerialChart.base.validateData.call(this);a&&d.handleDragStart();c&&d.rightDragStart();b&&d.leftDragStart()},drawChart:function(){if(0<this.realWidth&&0<this.realHeight){e.AmSerialChart.base.drawChart.call(this);var a=this.chartData;if(e.ifArray(a)){var b=this.chartScrollbar;!b||!this.marginsUpdated&&this.autoMargins||b.draw();(b=this.valueScrollbar)&&b.draw();var b=a.length-1,c,d;c=this.categoryAxis;if(c.parseDates&&!c.equalSpacing){if(c=this.startTime,d=this.endTime,isNaN(c)||isNaN(d))c=this.firstTime,
d=this.lastTime}else{c=this.start;d=this.end;if(isNaN(c)||isNaN(d))d=c=NaN;isNaN(c)&&(isNaN(this.startTime)||(c=this.getClosestIndex(a,"time",this.startTime,!0,0,a.length)));isNaN(d)&&(isNaN(this.endTime)||(d=this.getClosestIndex(a,"time",this.endTime,!1,0,a.length)));if(isNaN(c)||isNaN(d))c=0,d=b}this.endTime=this.startTime=this.end=this.start=void 0;this.zoom(c,d)}}else this.cleanChart()},cleanChart:function(){e.callMethod("destroy",[this.valueAxes,this.graphs,this.categoryAxis,this.chartScrollbar,
this.chartCursor,this.valueScrollbar])},updateCategoryAxis:function(a,b,c){a.chart=this;a.id=c;a.rotate=b;a.setOrientation(!this.rotate);a.init();this.setAxisRenderers(a);this.updateObjectSize(a)},updateValueAxes:function(){e.AmSerialChart.base.updateValueAxes.call(this);var a=this.valueAxes,b;for(b=0;b<a.length;b++){var c=a[b],d=this.rotate;c.rotate=d;c.setOrientation(d);d=this.categoryAxis;if(!d.startOnAxis||d.parseDates)c.expandMinMax=!0}},getStartTime:function(a){var b=this.categoryAxis;return e.resetDateToMin(new Date(a),
b.minPeriod,1,b.firstDayOfWeek).getTime()},getEndTime:function(a){var b=e.extractPeriod(this.categoryAxis.minPeriod);return e.changeDate(new Date(a),b.period,b.count,!0).getTime()-1},updateMargins:function(){e.AmSerialChart.base.updateMargins.call(this);var a=this.chartScrollbar;a&&(this.getScrollbarPosition(a,this.rotate,this.categoryAxis.position),this.adjustMargins(a,this.rotate));if(a=this.valueScrollbar)this.getScrollbarPosition(a,!this.rotate,this.valueAxes[0].position),this.adjustMargins(a,
!this.rotate)},updateScrollbars:function(){e.AmSerialChart.base.updateScrollbars.call(this);this.updateChartScrollbar(this.chartScrollbar,this.rotate);this.updateChartScrollbar(this.valueScrollbar,!this.rotate)},zoom:function(a,b){var c=this.categoryAxis;c.parseDates&&!c.equalSpacing?(this.timeZoom(a,b),isNaN(a)&&this.zoomOutValueAxes()):this.indexZoom(a,b);(c=this.chartCursor)&&(c.pan||c.hideCursorReal());this.updateLegendValues()},timeZoom:function(a,b){var c=this.maxSelectedTime;isNaN(c)||(b!=
this.endTime&&b-a>c&&(a=b-c),a!=this.startTime&&b-a>c&&(b=a+c));var d=this.minSelectedTime;if(0<d&&b-a<d){var g=Math.round(a+(b-a)/2),d=Math.round(d/2);a=g-d;b=g+d}d=this.chartData;g=this.categoryAxis;if(e.ifArray(d)&&(a!=this.startTime||b!=this.endTime)){var h=g.minDuration(),f=this.firstTime,l=this.lastTime;a||(a=f,isNaN(c)||(a=l-c));b||(b=l);a>l&&(a=l);b<f&&(b=f);a<f&&(a=f);b>l&&(b=l);b<a&&(b=a+h);b-a<h/5&&(b<l?b=a+h/5:a=b-h/5);this.startTime=a;this.endTime=b;c=d.length-1;h=this.getClosestIndex(d,
"time",a,!0,0,c);d=this.getClosestIndex(d,"time",b,!1,h,c);g.timeZoom(a,b);g.zoom(h,d);this.start=e.fitToBounds(h,0,c);this.end=e.fitToBounds(d,0,c);this.zoomAxesAndGraphs();this.zoomScrollbar();this.fixCursor();this.showZB();this.syncGrid();this.updateColumnsDepth();this.dispatchTimeZoomEvent()}},showZB:function(){var a,b=this.categoryAxis;b&&b.parseDates&&!b.equalSpacing&&(this.startTime>this.firstTime&&(a=!0),this.endTime<this.lastTime&&(a=!0));0<this.start&&(a=!0);this.end<this.chartData.length-
1&&(a=!0);if(b=this.valueAxes)b=b[0],isNaN(b.relativeStart)||(0!==e.roundTo(b.relativeStart,3)&&(a=!0),1!=e.roundTo(b.relativeEnd,3)&&(a=!0));e.AmSerialChart.base.showZB.call(this,a)},updateAfterValueZoom:function(){e.AmSerialChart.base.updateAfterValueZoom.call(this);this.updateColumnsDepth()},indexZoom:function(a,b){var c=this.maxSelectedSeries,d=!1;isNaN(c)||(b!=this.end&&b-a>c&&(a=b-c,d=!0),a!=this.start&&b-a>c&&(b=a+c,d=!0));if(d&&(d=this.chartScrollbar)&&d.dragger){var g=d.dragger.getBBox();
d.maxWidth=g.width;d.maxHeight=g.height}if(a!=this.start||b!=this.end)d=this.chartData.length-1,isNaN(a)&&(a=0,isNaN(c)||(a=d-c)),isNaN(b)&&(b=d),b<a&&(b=a),b>d&&(b=d),a>d&&(a=d-1),0>a&&(a=0),this.start=a,this.end=b,this.categoryAxis.zoom(a,b),this.zoomAxesAndGraphs(),this.zoomScrollbar(),this.fixCursor(),0!==a||b!=this.chartData.length-1?this.showZB(!0):this.showZB(!1),this.syncGrid(),this.updateColumnsDepth(),this.dispatchIndexZoomEvent()},updateGraphs:function(){e.AmSerialChart.base.updateGraphs.call(this);
var a=this.graphs,b;for(b=0;b<a.length;b++){var c=a[b];c.columnWidthReal=this.columnWidth;c.categoryAxis=this.categoryAxis;e.isString(c.fillToGraph)&&(c.fillToGraph=this.graphsById[c.fillToGraph])}},zoomAxesAndGraphs:function(){e.AmSerialChart.base.zoomAxesAndGraphs.call(this);this.updateColumnsDepth()},updateColumnsDepth:function(){if(0!==this.depth3D||0!==this.angle){var a,b=this.graphs,c;this.columnsArray=[];for(a=0;a<b.length;a++){c=b[a];var d=c.columnsArray;if(d){var g;for(g=0;g<d.length;g++)this.columnsArray.push(d[g])}}this.columnsArray.sort(this.compareDepth);
b=this.columnsSet;if(0<this.columnsArray.length){d=this.container.set();this.columnSet.push(d);for(a=0;a<this.columnsArray.length;a++)d.push(this.columnsArray[a].column.set);c&&d.translate(c.x,c.y);this.columnsSet=d}e.remove(b)}},compareDepth:function(a,b){return a.depth>b.depth?1:-1},zoomScrollbar:function(){var a=this.chartScrollbar,b=this.categoryAxis;if(a){if(!this.zoomedByScrollbar){var c=a.dragger;c&&c.stop()}this.zoomedByScrollbar=!1;b.parseDates&&!b.equalSpacing?a.timeZoom(this.startTime,
this.endTime):a.zoom(this.start,this.end)}this.zoomValueScrollbar(this.valueScrollbar)},updateTrendLines:function(){var a=this.trendLines,b;for(b=0;b<a.length;b++){var c=a[b],c=e.processObject(c,e.TrendLine,this.theme);a[b]=c;c.chart=this;c.id||(c.id="trendLineAuto"+b+"_"+(new Date).getTime());e.isString(c.valueAxis)&&(c.valueAxis=this.getValueAxisById(c.valueAxis));c.valueAxis||(c.valueAxis=this.valueAxes[0]);c.categoryAxis=this.categoryAxis}},validateNow:function(a,b){a&&this.zoomOutOnDataUpdate&&
(this.endTime=this.end=this.startTime=this.start=NaN);e.AmSerialChart.base.validateNow.call(this,a,b)},countColumns:function(){var a=0,b=this.valueAxes.length,c=this.graphs.length,d,g,e=!1,f,l;for(l=0;l<b;l++){g=this.valueAxes[l];var k=g.stackType,m=0;if("100%"==k||"regular"==k)for(e=!1,f=0;f<c;f++)d=this.graphs[f],d.tcc=1,d.valueAxis==g&&"column"==d.type&&(!e&&d.stackable&&(a++,e=!0),(!d.stackable&&d.clustered||d.newStack&&0!==m)&&a++,d.columnIndex=a-1,d.clustered||(d.columnIndex=0),m++);if("none"==
k||"3d"==k){m=!1;for(f=0;f<c;f++)d=this.graphs[f],d.valueAxis==g&&"column"==d.type&&(d.clustered?(d.tcc=1,d.newStack&&(a=0),d.hidden||(d.columnIndex=a,a++)):d.hidden||(m=!0,d.tcc=1,d.columnIndex=0));m&&0===a&&(a=1)}if("3d"==k){g=1;for(m=0;m<c;m++)d=this.graphs[m],d.newStack&&g++,d.depthCount=g,d.tcc=a;a=g}if("regular"==k||"100%"==k)for(g=10,m=0;m<c;m++)d=this.graphs[m],d.newStack&&g--,d.depthCount=g,d.tcc=a}return a},parseData:function(){e.AmSerialChart.base.parseData.call(this);this.parseSerialData(this.dataProvider)},
getCategoryIndexByValue:function(a){var b=this.chartData,c;for(c=0;c<b.length;c++)if(b[c].category==a)return c},handleScrollbarZoom:function(a){this.zoomedByScrollbar=!0;this.zoom(a.start,a.end)},dispatchTimeZoomEvent:function(){if(this.drawGraphs&&(this.prevStartTime!=this.startTime||this.prevEndTime!=this.endTime)){var a={type:"zoomed"};a.startDate=new Date(this.startTime);a.endDate=new Date(this.endTime);a.startIndex=this.start;a.endIndex=this.end;this.startIndex=this.start;this.endIndex=this.end;
this.startDate=a.startDate;this.endDate=a.endDate;this.prevStartTime=this.startTime;this.prevEndTime=this.endTime;var b=this.categoryAxis,c=e.extractPeriod(b.minPeriod).period,b=b.dateFormatsObject[c];a.startValue=e.formatDate(a.startDate,b,this);a.endValue=e.formatDate(a.endDate,b,this);a.chart=this;a.target=this;this.fire(a)}},dispatchIndexZoomEvent:function(){if(this.drawGraphs&&(this.prevStartIndex!=this.start||this.prevEndIndex!=this.end)){this.startIndex=this.start;this.endIndex=this.end;var a=
this.chartData;if(e.ifArray(a)&&!isNaN(this.start)&&!isNaN(this.end)){var b={chart:this,target:this,type:"zoomed"};b.startIndex=this.start;b.endIndex=this.end;b.startValue=a[this.start].category;b.endValue=a[this.end].category;this.categoryAxis.parseDates&&(this.startTime=a[this.start].time,this.endTime=a[this.end].time,b.startDate=new Date(this.startTime),b.endDate=new Date(this.endTime));this.prevStartIndex=this.start;this.prevEndIndex=this.end;this.fire(b)}}},updateLegendValues:function(){this.legend&&
this.legend.updateValues()},getClosestIndex:function(a,b,c,d,g,e){0>g&&(g=0);e>a.length-1&&(e=a.length-1);var f=g+Math.round((e-g)/2),l=a[f][b];return c==l?f:1>=e-g?d?g:Math.abs(a[g][b]-c)<Math.abs(a[e][b]-c)?g:e:c==l?f:c<l?this.getClosestIndex(a,b,c,d,g,f):this.getClosestIndex(a,b,c,d,f,e)},zoomToIndexes:function(a,b){var c=this.chartData;if(c){var d=c.length;0<d&&(0>a&&(a=0),b>d-1&&(b=d-1),d=this.categoryAxis,d.parseDates&&!d.equalSpacing?this.zoom(c[a].time,this.getEndTime(c[b].time)):this.zoom(a,
b))}},zoomToDates:function(a,b){var c=this.chartData;if(c)if(this.categoryAxis.equalSpacing){var d=this.getClosestIndex(c,"time",a.getTime(),!0,0,c.length);b=e.resetDateToMin(b,this.categoryAxis.minPeriod,1);c=this.getClosestIndex(c,"time",b.getTime(),!1,0,c.length);this.zoom(d,c)}else this.zoom(a.getTime(),b.getTime())},zoomToCategoryValues:function(a,b){this.chartData&&this.zoom(this.getCategoryIndexByValue(a),this.getCategoryIndexByValue(b))},formatPeriodString:function(a,b){if(b){b.periodDataItem=
{};b.periodPercentDataItem={};var c=["value","open","low","high","close"],d="value open low high close average sum count".split(" "),g=b.valueAxis,h=this.chartData,f=b.numberFormatter;f||(f=this.nf);for(var l=0;l<c.length;l++){for(var k=c[l],m=0,p=0,n=0,u=0,v,x,E,t,r,B,q,w,y,C,F=this.start;F<=this.end;F++){var D=h[F];if(D){var A=D.axes[g.id].graphs[b.id];if(A){if(A.values){var z=A.values[k],D=D.x.categoryAxis;if(this.rotate){if(0>D||D>A.graph.height)z=NaN}else if(0>D||D>A.graph.width)z=NaN;if(!isNaN(z)){isNaN(v)&&
(v=z);x=z;if(isNaN(E)||E>z)E=z;if(isNaN(t)||t<z)t=z;r=e.getDecimals(m);D=e.getDecimals(z);m+=z;m=e.roundTo(m,Math.max(r,D));p++;r=m/p}}if(A.percents&&(A=A.percents[k],!isNaN(A))){isNaN(B)&&(B=A);q=A;if(isNaN(w)||w>A)w=A;if(isNaN(y)||y<A)y=A;C=e.getDecimals(n);z=e.getDecimals(A);n+=A;n=e.roundTo(n,Math.max(C,z));u++;C=n/u}}}}m={open:v,close:x,high:t,low:E,average:r,sum:m,count:p};n={open:B,close:q,high:y,low:w,average:C,sum:n,count:u};a=e.formatValue(a,m,d,f,k+"\\.",this.usePrefixes,this.prefixesOfSmallNumbers,
this.prefixesOfBigNumbers);a=e.formatValue(a,n,d,this.pf,"percents\\."+k+"\\.");b.periodDataItem[k]=m;b.periodPercentDataItem[k]=n}}return a=e.cleanFromEmpty(a)},formatString:function(a,b,c){if(b){var d=b.graph;if(void 0!==a){if(-1!=a.indexOf("[[category]]")){var g=b.serialDataItem.category;if(this.categoryAxis.parseDates){var h=this.balloonDateFormat,f=this.chartCursor;f&&f.categoryBalloonDateFormat&&(h=f.categoryBalloonDateFormat);h=e.formatDate(g,h,this);-1!=h.indexOf("fff")&&(h=e.formatMilliseconds(h,
g));g=h}a=a.replace(/\[\[category\]\]/g,String(g.replace("$","$$$")))}g=d.numberFormatter;g||(g=this.nf);h=b.graph.valueAxis;(f=h.duration)&&!isNaN(b.values.value)&&h.maxInterval&&(f=e.formatDuration(b.values.value,f,"",h.durationUnits,h.maxInterval,g),a=a.replace(RegExp("\\[\\[value\\]\\]","g"),f));"date"==h.type&&(h=e.formatDate(new Date(b.values.value),d.dateFormat,this),f=RegExp("\\[\\[value\\]\\]","g"),a=a.replace(f,h),h=e.formatDate(new Date(b.values.open),d.dateFormat,this),f=RegExp("\\[\\[open\\]\\]",
"g"),a=a.replace(f,h));d="value open low high close total".split(" ");h=this.pf;a=e.formatValue(a,b.percents,d,h,"percents\\.");a=e.formatValue(a,b.values,d,g,"",this.usePrefixes,this.prefixesOfSmallNumbers,this.prefixesOfBigNumbers);a=e.formatValue(a,b.values,["percents"],h);-1!=a.indexOf("[[")&&(a=e.formatDataContextValue(a,b.dataContext));-1!=a.indexOf("[[")&&b.graph.customData&&(a=e.formatDataContextValue(a,b.graph.customData));a=e.AmSerialChart.base.formatString.call(this,a,b,c)}return a}},updateChartCursor:function(){e.AmSerialChart.base.updateChartCursor.call(this);
var a=this.chartCursor,b=this.categoryAxis;if(a){var c=a.categoryBalloonAlpha,d=a.categoryBalloonColor,g=a.color;void 0===d&&(d=a.cursorColor);var h=a.valueZoomable,f=a.zoomable,l=a.valueLineEnabled;this.rotate?(a.vLineEnabled=l,a.hZoomEnabled=h,a.vZoomEnabled=f):(a.hLineEnabled=l,a.vZoomEnabled=h,a.hZoomEnabled=f);if(a.valueLineBalloonEnabled)for(l=0;l<this.valueAxes.length;l++)h=this.valueAxes[l],(f=h.balloon)||(f={}),f=e.extend(f,this.balloon,!0),f.fillColor=d,f.balloonColor=d,f.fillAlpha=c,f.borderColor=
d,f.color=g,h.balloon=f;else for(f=0;f<this.valueAxes.length;f++)h=this.valueAxes[f],h.balloon&&(h.balloon=null);b&&(b.balloonTextFunction=a.categoryBalloonFunction,a.categoryLineAxis=b,b.balloonText=a.categoryBalloonText,a.categoryBalloonEnabled&&((f=b.balloon)||(f={}),f=e.extend(f,this.balloon,!0),f.fillColor=d,f.balloonColor=d,f.fillAlpha=c,f.borderColor=d,f.color=g,b.balloon=f),b.balloon&&(b.balloon.enabled=a.categoryBalloonEnabled))}},addChartScrollbar:function(a){e.callMethod("destroy",[this.chartScrollbar]);
a&&(a.chart=this,this.listenTo(a,"zoomed",this.handleScrollbarZoom));this.rotate?void 0===a.width&&(a.width=a.scrollbarHeight):void 0===a.height&&(a.height=a.scrollbarHeight);a.gridAxis=this.categoryAxis;this.chartScrollbar=a},addValueScrollbar:function(a){e.callMethod("destroy",[this.valueScrollbar]);a&&(a.chart=this,this.listenTo(a,"zoomed",this.handleScrollbarValueZoom),this.listenTo(a,"zoomStarted",this.handleCursorZoomStarted));var b=a.scrollbarHeight;this.rotate?void 0===a.height&&(a.height=
b):void 0===a.width&&(a.width=b);a.gridAxis||(a.gridAxis=this.valueAxes[0]);a.valueAxes=this.valueAxes;this.valueScrollbar=a},removeChartScrollbar:function(){e.callMethod("destroy",[this.chartScrollbar]);this.chartScrollbar=null},removeValueScrollbar:function(){e.callMethod("destroy",[this.valueScrollbar]);this.valueScrollbar=null},handleReleaseOutside:function(a){e.AmSerialChart.base.handleReleaseOutside.call(this,a);e.callMethod("handleReleaseOutside",[this.chartScrollbar,this.valueScrollbar])},
update:function(){e.AmSerialChart.base.update.call(this);this.chartScrollbar&&this.chartScrollbar.update&&this.chartScrollbar.update();this.valueScrollbar&&this.valueScrollbar.update&&this.valueScrollbar.update()},processScrollbars:function(){e.AmSerialChart.base.processScrollbars.call(this);var a=this.valueScrollbar;a&&(a=e.processObject(a,e.ChartScrollbar,this.theme),a.id="valueScrollbar",this.addValueScrollbar(a))},handleValueAxisZoom:function(a){this.handleValueAxisZoomReal(a,this.valueAxes)},
zoomOut:function(){e.AmSerialChart.base.zoomOut.call(this);this.zoom();this.syncGrid()},getNextItem:function(a){var b=a.index,c=this.chartData,d=a.graph;if(b+1<c.length)for(b+=1;b<c.length;b++)if(a=c[b])if(a=a.axes[d.valueAxis.id].graphs[d.id],!isNaN(a.y))return a},handleCursorZoomReal:function(a,b,c,d,e){var h=e.target,f,l;this.rotate?(isNaN(a)||isNaN(b)||this.relativeZoomValueAxes(this.valueAxes,a,b)&&this.updateAfterValueZoom(),h.vZoomEnabled&&(f=e.start,l=e.end)):(isNaN(c)||isNaN(d)||this.relativeZoomValueAxes(this.valueAxes,
c,d)&&this.updateAfterValueZoom(),h.hZoomEnabled&&(f=e.start,l=e.end));isNaN(f)||isNaN(l)||(a=this.categoryAxis,a.parseDates&&!a.equalSpacing?this.zoomToDates(new Date(f),new Date(l)):this.zoomToIndexes(f,l))},handleCursorZoomStarted:function(){var a=this.valueAxes;if(a){var a=a[0],b=a.relativeStart,c=a.relativeEnd;a.reversed&&(b=1-a.relativeEnd,c=1-a.relativeStart);this.rotate?(this.startX0=b,this.endX0=c):(this.startY0=b,this.endY0=c)}this.categoryAxis&&(this.start0=this.start,this.end0=this.end,
this.startTime0=this.startTime,this.endTime0=this.endTime)},fixCursor:function(){this.chartCursor&&this.chartCursor.fixPosition();this.prevCursorItem=null},handleCursorMove:function(a){e.AmSerialChart.base.handleCursorMove.call(this,a);var b=a.target,c=this.categoryAxis;if(a.panning)this.handleCursorHide(a);else if(this.chartData&&!b.isHidden){var d=this.graphs;if(d){var g;g=c.xToIndex(this.rotate?a.y:a.x);if(g=this.chartData[g]){var h,f,l,k;if(b.oneBalloonOnly&&b.valueBalloonsEnabled){var m=Infinity;
for(h=d.length-1;0<=h;h--)if(f=d[h],f.balloon.enabled&&f.showBalloon&&!f.hidden){l=f.valueAxis.id;l=g.axes[l].graphs[f.id];if(b.showNextAvailable&&isNaN(l.y)&&(l=this.getNextItem(l),!l))continue;l=l.y;"top"==f.showBalloonAt&&(l=0);"bottom"==f.showBalloonAt&&(l=this.height);var p=b.mouseX,n=b.mouseY;l=this.rotate?Math.abs(p-l):Math.abs(n-l);l<m&&(m=l,k=f)}b.mostCloseGraph=k}if(this.prevCursorItem!=g||k!=this.prevMostCloseGraph){m=[];for(h=0;h<d.length;h++){f=d[h];l=f.valueAxis.id;l=g.axes[l].graphs[f.id];
if(b.showNextAvailable&&isNaN(l.y)&&(l=this.getNextItem(l),!l&&f.balloon)){f.balloon.hide();continue}k&&f!=k?(f.showGraphBalloon(l,b.pointer,!1,b.graphBulletSize,b.graphBulletAlpha),f.balloon.hide(0)):b.valueBalloonsEnabled?(f.balloon.showBullet=b.bulletsEnabled,f.balloon.bulletSize=b.bulletSize/2,a.hideBalloons||(f.showGraphBalloon(l,b.pointer,!1,b.graphBulletSize,b.graphBulletAlpha),f.balloon.set&&m.push({balloon:f.balloon,y:f.balloon.pointToY}))):(f.currentDataItem=l,f.resizeBullet(l,b.graphBulletSize,
b.graphBulletAlpha))}b.avoidBalloonOverlapping&&this.arrangeBalloons(m);this.prevCursorItem=g}this.prevMostCloseGraph=k}}d=e.fitToBounds(a.x,0,b.width);k=e.fitToBounds(a.y,0,b.height);c.showBalloon(d,k,b.categoryBalloonDateFormat,a.skip);this.updateLegendValues()}},handleCursorHide:function(a){e.AmSerialChart.base.handleCursorHide.call(this,a);a=this.categoryAxis;this.prevCursorItem=null;this.updateLegendValues();a&&a.hideBalloon();a=this.graphs;var b;for(b=0;b<a.length;b++)a[b].currentDataItem=null},
handleCursorPanning:function(a){var b=a.target,c,d=a.deltaX,g=a.deltaY,h=a.delta2X,f=a.delta2Y;a=!1;if(this.rotate){isNaN(h)&&(h=d,a=!0);var l=this.endX0;c=this.startX0;var k=l-c,l=l-k*h,m=k;a||(m=0);a=e.fitToBounds(c-k*d,0,1-m)}else isNaN(f)&&(f=g,a=!0),l=this.endY0,c=this.startY0,k=l-c,l+=k*g,m=k,a||(m=0),a=e.fitToBounds(c+k*f,0,1-m);c=e.fitToBounds(l,m,1);var p;b.valueZoomable&&(p=this.relativeZoomValueAxes(this.valueAxes,a,c));var n;c=this.categoryAxis;this.rotate&&(d=g,h=f);a=!1;isNaN(h)&&(h=
d,a=!0);if(b.zoomable&&(0<Math.abs(d)||0<Math.abs(h)))if(c.parseDates&&!c.equalSpacing){if(f=this.startTime0,g=this.endTime0,c=g-f,h*=c,k=this.firstTime,l=this.lastTime,m=c,a||(m=0),a=Math.round(e.fitToBounds(f-c*d,k,l-m)),h=Math.round(e.fitToBounds(g-h,k+m,l)),this.startTime!=a||this.endTime!=h)n={chart:this,target:b,type:"zoomed",start:a,end:h},this.skipZoomed=!0,b.fire(n),this.zoom(a,h),n=!0}else if(f=this.start0,g=this.end0,c=g-f,d=Math.round(c*d),h=Math.round(c*h),k=this.chartData.length-1,a||
(c=0),a=e.fitToBounds(f-d,0,k-c),c=e.fitToBounds(g-h,c,k),this.start!=a||this.end!=c)this.skipZoomed=!0,b.fire({chart:this,target:b,type:"zoomed",start:a,end:c}),this.zoom(a,c),n=!0;!n&&p&&this.updateAfterValueZoom()},arrangeBalloons:function(a){var b=this.plotAreaHeight;a.sort(this.compareY);var c,d,e,h=this.plotAreaWidth,f=a.length;for(c=0;c<f;c++)d=a[c].balloon,d.setBounds(0,0,h,b),d.restorePrevious(),d.draw(),b=d.yPos-3;a.reverse();for(c=0;c<f;c++){d=a[c].balloon;var b=d.bottom,l=d.bottom-d.yPos;
0<c&&b-l<e+3&&d.setBounds&&(d.setBounds(0,e+3,h,e+l+3),d.restorePrevious(),d.draw());d.set&&d.set.show();e=d.bottom}},compareY:function(a,b){return a.y<b.y?1:-1}})})();(function(){var e=window.AmCharts;e.Cuboid=e.Class({construct:function(a,b,c,d,e,h,f,l,k,m,p,n,u,v,x,E,t){this.set=a.set();this.container=a;this.h=Math.round(c);this.w=Math.round(b);this.dx=d;this.dy=e;this.colors=h;this.alpha=f;this.bwidth=l;this.bcolor=k;this.balpha=m;this.dashLength=v;this.topRadius=E;this.pattern=x;this.rotate=u;this.bcn=t;u?0>b&&0===p&&(p=180):0>c&&270==p&&(p=90);this.gradientRotation=p;0===d&&0===e&&(this.cornerRadius=n);this.draw()},draw:function(){var a=this.set;a.clear();
var b=this.container,c=b.chart,d=this.w,g=this.h,h=this.dx,f=this.dy,l=this.colors,k=this.alpha,m=this.bwidth,p=this.bcolor,n=this.balpha,u=this.gradientRotation,v=this.cornerRadius,x=this.dashLength,E=this.pattern,t=this.topRadius,r=this.bcn,B=l,q=l;"object"==typeof l&&(B=l[0],q=l[l.length-1]);var w,y,C,F,D,A,z,L,M,Q=k;E&&(k=0);var G,H,I,J,K=this.rotate;if(0<Math.abs(h)||0<Math.abs(f))if(isNaN(t))z=q,q=e.adjustLuminosity(B,-.2),q=e.adjustLuminosity(B,-.2),w=e.polygon(b,[0,h,d+h,d,0],[0,f,f,0,0],
q,k,1,p,0,u),0<n&&(M=e.line(b,[0,h,d+h],[0,f,f],p,n,m,x)),y=e.polygon(b,[0,0,d,d,0],[0,g,g,0,0],q,k,1,p,0,u),y.translate(h,f),0<n&&(C=e.line(b,[h,h],[f,f+g],p,n,m,x)),F=e.polygon(b,[0,0,h,h,0],[0,g,g+f,f,0],q,k,1,p,0,u),D=e.polygon(b,[d,d,d+h,d+h,d],[0,g,g+f,f,0],q,k,1,p,0,u),0<n&&(A=e.line(b,[d,d+h,d+h,d],[0,f,g+f,g],p,n,m,x)),q=e.adjustLuminosity(z,.2),z=e.polygon(b,[0,h,d+h,d,0],[g,g+f,g+f,g,g],q,k,1,p,0,u),0<n&&(L=e.line(b,[0,h,d+h],[g,g+f,g+f],p,n,m,x));else{var N,O,P;K?(N=g/2,q=h/2,P=g/2,O=
d+h/2,H=Math.abs(g/2),G=Math.abs(h/2)):(q=d/2,N=f/2,O=d/2,P=g+f/2+1,G=Math.abs(d/2),H=Math.abs(f/2));I=G*t;J=H*t;.1<G&&.1<G&&(w=e.circle(b,G,B,k,m,p,n,!1,H),w.translate(q,N));.1<I&&.1<I&&(z=e.circle(b,I,e.adjustLuminosity(B,.5),k,m,p,n,!1,J),z.translate(O,P))}k=Q;1>Math.abs(g)&&(g=0);1>Math.abs(d)&&(d=0);!isNaN(t)&&(0<Math.abs(h)||0<Math.abs(f))?(l=[B],l={fill:l,stroke:p,"stroke-width":m,"stroke-opacity":n,"fill-opacity":k},K?(k="M0,0 L"+d+","+(g/2-g/2*t),m=" B",0<d&&(m=" A"),e.VML?(k+=m+Math.round(d-
I)+","+Math.round(g/2-J)+","+Math.round(d+I)+","+Math.round(g/2+J)+","+d+",0,"+d+","+g,k=k+(" L0,"+g)+(m+Math.round(-G)+","+Math.round(g/2-H)+","+Math.round(G)+","+Math.round(g/2+H)+",0,"+g+",0,0")):(k+="A"+I+","+J+",0,0,0,"+d+","+(g-g/2*(1-t))+"L0,"+g,k+="A"+G+","+H+",0,0,1,0,0"),G=90):(m=d/2-d/2*t,k="M0,0 L"+m+","+g,e.VML?(k="M0,0 L"+m+","+g,m=" B",0>g&&(m=" A"),k+=m+Math.round(d/2-I)+","+Math.round(g-J)+","+Math.round(d/2+I)+","+Math.round(g+J)+",0,"+g+","+d+","+g,k+=" L"+d+",0",k+=m+Math.round(d/
2+G)+","+Math.round(H)+","+Math.round(d/2-G)+","+Math.round(-H)+","+d+",0,0,0"):(k+="A"+I+","+J+",0,0,0,"+(d-d/2*(1-t))+","+g+"L"+d+",0",k+="A"+G+","+H+",0,0,1,0,0"),G=180),b=b.path(k).attr(l),b.gradient("linearGradient",[B,e.adjustLuminosity(B,-.3),e.adjustLuminosity(B,-.3),B],G),K?b.translate(h/2,0):b.translate(0,f/2)):b=0===g?e.line(b,[0,d],[0,0],p,n,m,x):0===d?e.line(b,[0,0],[0,g],p,n,m,x):0<v?e.rect(b,d,g,l,k,m,p,n,v,u,x):e.polygon(b,[0,0,d,d,0],[0,g,g,0,0],l,k,m,p,n,u,!1,x);d=isNaN(t)?0>g?[w,
M,y,C,F,D,A,z,L,b]:[z,L,y,C,F,D,w,M,A,b]:K?0<d?[w,b,z]:[z,b,w]:0>g?[w,b,z]:[z,b,w];e.setCN(c,b,r+"front");e.setCN(c,y,r+"back");e.setCN(c,z,r+"top");e.setCN(c,w,r+"bottom");e.setCN(c,F,r+"left");e.setCN(c,D,r+"right");for(w=0;w<d.length;w++)if(y=d[w])a.push(y),e.setCN(c,y,r+"element");E&&b.pattern(E,NaN,c.path)},width:function(a){isNaN(a)&&(a=0);this.w=Math.round(a);this.draw()},height:function(a){isNaN(a)&&(a=0);this.h=Math.round(a);this.draw()},animateHeight:function(a,b){var c=this;c.animationFinished=
!1;c.easing=b;c.totalFrames=a*e.updateRate;c.rh=c.h;c.frame=0;c.height(1);setTimeout(function(){c.updateHeight.call(c)},1E3/e.updateRate)},updateHeight:function(){var a=this;a.frame++;var b=a.totalFrames;a.frame<=b?(b=a.easing(0,a.frame,1,a.rh-1,b),a.height(b),window.requestAnimationFrame?window.requestAnimationFrame(function(){a.updateHeight.call(a)}):setTimeout(function(){a.updateHeight.call(a)},1E3/e.updateRate)):(a.height(a.rh),a.animationFinished=!0)},animateWidth:function(a,b){var c=this;c.animationFinished=
!1;c.easing=b;c.totalFrames=a*e.updateRate;c.rw=c.w;c.frame=0;c.width(1);setTimeout(function(){c.updateWidth.call(c)},1E3/e.updateRate)},updateWidth:function(){var a=this;a.frame++;var b=a.totalFrames;a.frame<=b?(b=a.easing(0,a.frame,1,a.rw-1,b),a.width(b),window.requestAnimationFrame?window.requestAnimationFrame(function(){a.updateWidth.call(a)}):setTimeout(function(){a.updateWidth.call(a)},1E3/e.updateRate)):(a.width(a.rw),a.animationFinished=!0)}})})();(function(){var e=window.AmCharts;e.CategoryAxis=e.Class({inherits:e.AxisBase,construct:function(a){this.cname="CategoryAxis";e.CategoryAxis.base.construct.call(this,a);this.minPeriod="DD";this.equalSpacing=this.parseDates=!1;this.position="bottom";this.startOnAxis=!1;this.gridPosition="middle";this.safeDistance=30;this.stickBalloonToCategory=!1;e.applyTheme(this,a,this.cname)},draw:function(){e.CategoryAxis.base.draw.call(this);this.generateDFObject();var a=this.chart.chartData;this.data=a;this.labelRotationR=
this.labelRotation;this.type=null;if(e.ifArray(a)){var b,c=this.chart;"scrollbar"!=this.id?(e.setCN(c,this.set,"category-axis"),e.setCN(c,this.labelsSet,"category-axis"),e.setCN(c,this.axisLine.axisSet,"category-axis")):this.bcn=this.id+"-";var d=this.start,g=this.labelFrequency,h=0,f=this.end-d+1,l=this.gridCountR,k=this.showFirstLabel,m=this.showLastLabel,p,n="",n=e.extractPeriod(this.minPeriod),u=e.getPeriodDuration(n.period,n.count),v,x,E,t,r,B=this.rotate,q=this.firstDayOfWeek,w=this.boldPeriodBeginning;
b=e.resetDateToMin(new Date(a[a.length-1].time+1.05*u),this.minPeriod,1,q).getTime();this.firstTime=c.firstTime;this.endTime>b&&(this.endTime=b);r=this.minorGridEnabled;x=this.gridAlpha;var y=0,C=0;if(this.widthField)for(b=this.start;b<=this.end;b++)if(t=this.data[b]){var F=Number(this.data[b].dataContext[this.widthField]);isNaN(F)||(y+=F,t.widthValue=F)}if(this.parseDates&&!this.equalSpacing)this.lastTime=a[a.length-1].time,this.maxTime=e.resetDateToMin(new Date(this.lastTime+1.05*u),this.minPeriod,
1,q).getTime(),this.timeDifference=this.endTime-this.startTime,this.parseDatesDraw();else if(!this.parseDates){if(this.cellWidth=this.getStepWidth(f),f<l&&(l=f),h+=this.start,this.stepWidth=this.getStepWidth(f),0<l)for(q=Math.floor(f/l),t=this.chooseMinorFrequency(q),f=h,f/2==Math.round(f/2)&&f--,0>f&&(f=0),w=0,this.widthField&&(f=this.start,q=1),this.end-f+1>=this.autoRotateCount&&(this.labelRotationR=this.autoRotateAngle),b=f;b<=this.end+2;b++){l=!1;0<=b&&b<this.data.length?(v=this.data[b],n=v.category,
l=v.forceShow):n="";if(r&&!isNaN(t))if(b/t==Math.round(b/t)||l)b/q==Math.round(b/q)||l||(this.gridAlpha=this.minorGridAlpha,n=void 0);else continue;else if(b/q!=Math.round(b/q)&&!l)continue;f=this.getCoordinate(b-h);l=0;"start"==this.gridPosition&&(f-=this.cellWidth/2,l=this.cellWidth/2);p=!0;E=l;"start"==this.tickPosition&&(E=0,p=!1,l=0);if(b==d&&!k||b==this.end&&!m)n=void 0;Math.round(w/g)!=w/g&&(n=void 0);w++;a=this.cellWidth;B&&(a=NaN,this.ignoreAxisWidth||!c.autoMargins)&&(a="right"==this.position?
c.marginRight-this.titleWidth:c.marginLeft-this.titleWidth,a-=this.tickLength+10);this.labelFunction&&v&&(n=this.labelFunction(n,v,this));n=e.fixBrakes(n);u=!1;this.boldLabels&&(u=!0);b>this.end&&"start"==this.tickPosition&&(n=" ");this.rotate&&this.inside&&(l-=2);isNaN(v.widthValue)||(v.percentWidthValue=v.widthValue/y*100,a=this.rotate?this.height*v.widthValue/y:this.width*v.widthValue/y,f=C,C+=a,E=l=a/2);p=new this.axisItemRenderer(this,f,n,p,a,l,void 0,u,E,!1,v.labelColor,v.className);p.serialDataItem=
v;this.pushAxisItem(p);this.gridAlpha=x}}else if(this.parseDates&&this.equalSpacing){h=this.start;this.startTime=this.data[this.start].time;this.endTime=this.data[this.end].time;this.timeDifference=this.endTime-this.startTime;b=this.choosePeriod(0);g=b.period;v=b.count;b=e.getPeriodDuration(g,v);b<u&&(g=n.period,v=n.count,b=u);x=g;"WW"==x&&(x="DD");this.currentDateFormat=this.dateFormatsObject[x];this.stepWidth=this.getStepWidth(f);l=Math.ceil(this.timeDifference/b)+1;n=e.resetDateToMin(new Date(this.startTime-
b),g,v,q).getTime();this.cellWidth=this.getStepWidth(f);f=Math.round(n/b);d=-1;f/2==Math.round(f/2)&&(d=-2,n-=b);f=this.start;f/2==Math.round(f/2)&&f--;0>f&&(f=0);C=this.end+2;C>=this.data.length&&(C=this.data.length);a=!1;a=!k;this.previousPos=-1E3;20<this.labelRotationR&&(this.safeDistance=5);F=f;if(this.data[f].time!=e.resetDateToMin(new Date(this.data[f].time),g,v,q).getTime()){var u=0,D=n;for(b=f;b<C;b++)t=this.data[b].time,this.checkPeriodChange(g,v,t,D)&&(u++,2<=u&&(F=b,b=C),D=t)}r&&1<v&&(t=
this.chooseMinorFrequency(v),e.getPeriodDuration(g,t));if(0<this.gridCountR)for(b=f;b<C;b++)if(t=this.data[b].time,this.checkPeriodChange(g,v,t,n)&&b>=F){f=this.getCoordinate(b-this.start);r=!1;this.nextPeriod[x]&&(r=this.checkPeriodChange(this.nextPeriod[x],1,t,n,x))&&e.resetDateToMin(new Date(t),this.nextPeriod[x],1,q).getTime()!=t&&(r=!1);u=!1;r&&this.markPeriodChange?(r=this.dateFormatsObject[this.nextPeriod[x]],u=!0):r=this.dateFormatsObject[x];n=e.formatDate(new Date(t),r,c);if(b==d&&!k||b==
l&&!m)n=" ";a?a=!1:(w||(u=!1),f-this.previousPos>this.safeDistance*Math.cos(this.labelRotationR*Math.PI/180)&&(this.labelFunction&&(n=this.labelFunction(n,new Date(t),this,g,v,E)),this.boldLabels&&(u=!0),p=new this.axisItemRenderer(this,f,n,void 0,void 0,void 0,void 0,u),r=p.graphics(),this.pushAxisItem(p),r=r.getBBox().width,e.isModern||(r-=f),this.previousPos=f+r));E=n=t}}for(b=k=0;b<this.data.length;b++)if(t=this.data[b])this.parseDates&&!this.equalSpacing?(m=t.time,d=this.cellWidth,"MM"==this.minPeriod&&
(d=864E5*e.daysInMonth(new Date(m))*this.stepWidth,t.cellWidth=d),m=Math.round((m-this.startTime)*this.stepWidth+d/2)):m=this.getCoordinate(b-h),t.x[this.id]=m;if(this.widthField)for(b=this.start;b<=this.end;b++)t=this.data[b],d=t.widthValue,t.percentWidthValue=d/y*100,this.rotate?(m=this.height*d/y/2+k,k=this.height*d/y+k):(m=this.width*d/y/2+k,k=this.width*d/y+k),t.x[this.id]=m;y=this.guides.length;for(b=0;b<y;b++)if(k=this.guides[b],q=q=q=r=d=NaN,m=k.above,k.toCategory&&(q=c.getCategoryIndexByValue(k.toCategory),
isNaN(q)||(d=this.getCoordinate(q-h),k.expand&&(d+=this.cellWidth/2),p=new this.axisItemRenderer(this,d,"",!0,NaN,NaN,k),this.pushAxisItem(p,m))),k.category&&(q=c.getCategoryIndexByValue(k.category),isNaN(q)||(r=this.getCoordinate(q-h),k.expand&&(r-=this.cellWidth/2),q=(d-r)/2,p=new this.axisItemRenderer(this,r,k.label,!0,NaN,q,k),this.pushAxisItem(p,m))),w=c.dataDateFormat,k.toDate&&(!w||k.toDate instanceof Date||(k.toDate=k.toDate.toString()+" |"),k.toDate=e.getDate(k.toDate,w),this.equalSpacing?
(q=c.getClosestIndex(this.data,"time",k.toDate.getTime(),!1,0,this.data.length-1),isNaN(q)||(d=this.getCoordinate(q-h))):d=(k.toDate.getTime()-this.startTime)*this.stepWidth,p=new this.axisItemRenderer(this,d,"",!0,NaN,NaN,k),this.pushAxisItem(p,m)),k.date&&(!w||k.date instanceof Date||(k.date=k.date.toString()+" |"),k.date=e.getDate(k.date,w),this.equalSpacing?(q=c.getClosestIndex(this.data,"time",k.date.getTime(),!1,0,this.data.length-1),isNaN(q)||(r=this.getCoordinate(q-h))):r=(k.date.getTime()-
this.startTime)*this.stepWidth,q=(d-r)/2,p=!0,k.toDate&&(p=!1),p="H"==this.orientation?new this.axisItemRenderer(this,r,k.label,p,2*q,NaN,k):new this.axisItemRenderer(this,r,k.label,!1,NaN,q,k),this.pushAxisItem(p,m)),p&&(q=p.label)&&this.addEventListeners(q,k),0<d||0<r){q=!1;if(this.rotate){if(d<this.height||r<this.height)q=!0}else if(d<this.width||r<this.width)q=!0;q&&(d=new this.guideFillRenderer(this,r,d,k),r=d.graphics(),this.pushAxisItem(d,m),k.graphics=r,r.index=b,this.addEventListeners(r,
k))}if(c=c.chartCursor)B?c.fixHeight(this.cellWidth):(c.fixWidth(this.cellWidth),c.fullWidth&&this.balloon&&(this.balloon.minWidth=this.cellWidth));this.previousHeight=A}this.axisCreated=!0;this.set.translate(this.x,this.y);this.labelsSet.translate(this.x,this.y);this.labelsSet.show();this.positionTitle();(B=this.axisLine.set)&&B.toFront();var A=this.getBBox().height;2<A-this.previousHeight&&this.autoWrap&&!this.parseDates&&(this.axisCreated=this.chart.marginsUpdated=!1)},xToIndex:function(a){var b=
this.data,c=this.chart,d=c.rotate,g=this.stepWidth,h;if(this.parseDates&&!this.equalSpacing)a=this.startTime+Math.round(a/g)-this.minDuration()/2,h=c.getClosestIndex(b,"time",a,!1,this.start,this.end+1);else if(this.widthField)for(c=Infinity,g=this.start;g<=this.end;g++){var f=this.data[g];f&&(f=Math.abs(f.x[this.id]-a),f<c&&(c=f,h=g))}else this.startOnAxis||(a-=g/2),h=this.start+Math.round(a/g);h=e.fitToBounds(h,0,b.length-1);var l;b[h]&&(l=b[h].x[this.id]);d?l>this.height+1&&h--:l>this.width+1&&
h--;0>l&&h++;return h=e.fitToBounds(h,0,b.length-1)},dateToCoordinate:function(a){return this.parseDates&&!this.equalSpacing?(a.getTime()-this.startTime)*this.stepWidth:this.parseDates&&this.equalSpacing?(a=this.chart.getClosestIndex(this.data,"time",a.getTime(),!1,0,this.data.length-1),this.getCoordinate(a-this.start)):NaN},categoryToCoordinate:function(a){if(this.chart){if(this.parseDates)return this.dateToCoordinate(new Date(a));a=this.chart.getCategoryIndexByValue(a);if(!isNaN(a))return this.getCoordinate(a-
this.start)}else return NaN},coordinateToDate:function(a){return this.equalSpacing?(a=this.xToIndex(a),new Date(this.data[a].time)):new Date(this.startTime+a/this.stepWidth)},coordinateToValue:function(a){a=this.xToIndex(a);if(a=this.data[a])return this.parseDates?a.time:a.category},getCoordinate:function(a){a*=this.stepWidth;this.startOnAxis||(a+=this.stepWidth/2);return Math.round(a)},formatValue:function(a,b){b||(b=this.currentDateFormat);this.parseDates&&(a=e.formatDate(new Date(a),b,this.chart));
return a},showBalloonAt:function(a,b){void 0===b&&(b=this.parseDates?this.dateToCoordinate(new Date(a)):this.categoryToCoordinate(a));return this.adjustBalloonCoordinate(b)},formatBalloonText:function(a,b,c){var d="",g="",h=this.chart,f=this.data[b];if(f)if(this.parseDates)d=e.formatDate(f.category,c,h),b=e.changeDate(new Date(f.category),this.minPeriod,1),g=e.formatDate(b,c,h),-1!=d.indexOf("fff")&&(d=e.formatMilliseconds(d,f.category),g=e.formatMilliseconds(g,b));else{var l;this.data[b+1]&&(l=this.data[b+
1]);d=e.fixNewLines(f.category);l&&(g=e.fixNewLines(l.category))}a=a.replace(/\[\[category\]\]/g,String(d));return a=a.replace(/\[\[toCategory\]\]/g,String(g))},adjustBalloonCoordinate:function(a,b){var c=this.xToIndex(a),d=this.chart.chartCursor;if(this.stickBalloonToCategory){var e=this.data[c];e&&(a=e.x[this.id]);this.stickBalloonToStart&&(a-=this.cellWidth/2);var h=0;if(d){var f=d.limitToGraph;if(f){var l=f.valueAxis.id;f.hidden||(h=e.axes[l].graphs[f.id].y)}this.rotate?("left"==this.position?
(f&&(h-=d.width),0<h&&(h=0)):0>h&&(h=0),d.fixHLine(a,h)):("top"==this.position?(f&&(h-=d.height),0<h&&(h=0)):0>h&&(h=0),d.fullWidth&&(a+=1),d.fixVLine(a,h))}}d&&!b&&(d.setIndex(c),this.parseDates&&d.setTimestamp(this.coordinateToDate(a).getTime()));return a}})})();

(function(){var k=window.AmCharts;k.AmSlicedChart=k.Class({inherits:k.AmChart,construct:function(a){this.createEvents("rollOverSlice","rollOutSlice","clickSlice","pullOutSlice","pullInSlice","rightClickSlice");k.AmSlicedChart.base.construct.call(this,a);this.colors="#FF0F00 #FF6600 #FF9E01 #FCD202 #F8FF01 #B0DE09 #04D215 #0D8ECF #0D52D1 #2A0CD0 #8A0CCF #CD0D74 #754DEB #DDDDDD #999999 #333333 #000000 #57032A #CA9726 #990000 #4B0C25".split(" ");this.alpha=1;this.groupPercent=0;this.groupedTitle="Other";
this.groupedPulled=!1;this.groupedAlpha=1;this.marginLeft=0;this.marginBottom=this.marginTop=10;this.marginRight=0;this.hoverAlpha=1;this.outlineColor="#FFFFFF";this.outlineAlpha=0;this.outlineThickness=1;this.startAlpha=0;this.startDuration=1;this.startEffect="bounce";this.sequencedAnimation=!0;this.pullOutDuration=1;this.pullOutEffect="bounce";this.pullOnHover=this.pullOutOnlyOne=!1;this.labelsEnabled=!0;this.labelTickColor="#000000";this.labelTickAlpha=.2;this.hideLabelsPercent=0;this.urlTarget=
"_self";this.autoMarginOffset=10;this.gradientRatio=[];this.maxLabelWidth=200;this.accessibleLabel="[[title]]: [[percents]]% [[value]] [[description]]";k.applyTheme(this,a,"AmSlicedChart")},initChart:function(){k.AmSlicedChart.base.initChart.call(this);this.dataChanged&&(this.parseData(),this.dispatchDataUpdated=!0,this.dataChanged=!1,this.setLegendData(this.chartData));this.drawChart()},handleLegendEvent:function(a){var b=a.type,c=a.dataItem,d=this.legend;if(c.wedge&&c){var g=c.hidden;a=a.event;
switch(b){case "clickMarker":g||d.switchable||this.clickSlice(c,a);break;case "clickLabel":g||this.clickSlice(c,a,!1);break;case "rollOverItem":g||this.rollOverSlice(c,!1,a);break;case "rollOutItem":g||this.rollOutSlice(c,a);break;case "hideItem":this.hideSlice(c,a);break;case "showItem":this.showSlice(c,a)}}},invalidateVisibility:function(){this.recalculatePercents();this.initChart();var a=this.legend;a&&a.invalidateSize()},addEventListeners:function(a,b){var c=this;a.mouseover(function(a){c.rollOverSlice(b,
!0,a)}).mouseout(function(a){c.rollOutSlice(b,a)}).touchend(function(a){c.rollOverSlice(b,a)}).mouseup(function(a){c.clickSlice(b,a)}).contextmenu(function(a){c.handleRightClick(b,a)}).focus(function(a){c.rollOverSlice(b,a)}).blur(function(a){c.rollOutSlice(b,a)})},formatString:function(a,b,c){a=k.formatValue(a,b,["value"],this.nf,"",this.usePrefixes,this.prefixesOfSmallNumbers,this.prefixesOfBigNumbers);var d=this.pf.precision;isNaN(this.tempPrec)||(this.pf.precision=this.tempPrec);a=k.formatValue(a,
b,["percents"],this.pf);a=k.massReplace(a,{"[[title]]":b.title,"[[description]]":b.description});this.pf.precision=d;-1!=a.indexOf("[[")&&(a=k.formatDataContextValue(a,b.dataContext));a=c?k.fixNewLines(a):k.fixBrakes(a);return a=k.cleanFromEmpty(a)},startSlices:function(){var a;for(a=0;a<this.chartData.length;a++)0<this.startDuration&&this.sequencedAnimation?this.setStartTO(a):this.startSlice(this.chartData[a])},setStartTO:function(a){var b=this;a=setTimeout(function(){b.startSequenced.call(b)},b.startDuration/
b.chartData.length*500*a);b.timeOuts.push(a)},pullSlices:function(a){var b=this.chartData,c;for(c=0;c<b.length;c++){var d=b[c];d.pulled&&this.pullSlice(d,1,a)}},startSequenced:function(){var a=this.chartData,b;for(b=0;b<a.length;b++)if(!a[b].started){this.startSlice(this.chartData[b]);break}},startSlice:function(a){a.started=!0;var b=a.wedge,c=this.startDuration,d=a.labelSet;b&&0<c&&(0<a.alpha&&b.show(),b.translate(a.startX,a.startY),this.animatable.push(b),b.animate({opacity:1,translate:"0,0"},c,
this.startEffect));d&&0<c&&(0<a.alpha&&d.show(),d.translate(a.startX,a.startY),d.animate({opacity:1,translate:"0,0"},c,this.startEffect))},showLabels:function(){var a=this.chartData,b;for(b=0;b<a.length;b++){var c=a[b];if(0<c.alpha){var d=c.label;d&&d.show();(c=c.tick)&&c.show()}}},showSlice:function(a){isNaN(a)?a.hidden=!1:this.chartData[a].hidden=!1;this.invalidateVisibility()},hideSlice:function(a){isNaN(a)?a.hidden=!0:this.chartData[a].hidden=!0;this.hideBalloon();this.invalidateVisibility()},
rollOverSlice:function(a,b,c){isNaN(a)||(a=this.chartData[a]);clearTimeout(this.hoverInt);if(!a.hidden){this.pullOnHover&&this.pullSlice(a,1);1>this.hoverAlpha&&a.wedge&&a.wedge.attr({opacity:this.hoverAlpha});var d=a.balloonX,g=a.balloonY;a.pulled&&(d+=a.pullX,g+=a.pullY);var f=this.formatString(this.balloonText,a,!0),h=this.balloonFunction;h&&(f=h(a,f));h=k.adjustLuminosity(a.color,-.15);f?this.showBalloon(f,h,b,d,g):this.hideBalloon();0===a.value&&this.hideBalloon();this.fire({type:"rollOverSlice",
dataItem:a,chart:this,event:c})}},rollOutSlice:function(a,b){isNaN(a)||(a=this.chartData[a]);a.wedge&&a.wedge.attr({opacity:1});this.hideBalloon();this.fire({type:"rollOutSlice",dataItem:a,chart:this,event:b})},clickSlice:function(a,b,c){this.checkTouchDuration(b)&&(isNaN(a)||(a=this.chartData[a]),a.pulled?this.pullSlice(a,0):this.pullSlice(a,1),k.getURL(a.url,this.urlTarget),c||this.fire({type:"clickSlice",dataItem:a,chart:this,event:b}))},handleRightClick:function(a,b){isNaN(a)||(a=this.chartData[a]);
this.fire({type:"rightClickSlice",dataItem:a,chart:this,event:b})},drawTicks:function(){var a=this.chartData,b;for(b=0;b<a.length;b++){var c=a[b];if(c.label&&!c.skipTick){var d=c.ty,d=k.line(this.container,[c.tx0,c.tx,c.tx2],[c.ty0,d,d],this.labelTickColor,this.labelTickAlpha);k.setCN(this,d,this.type+"-tick");k.setCN(this,d,c.className,!0);c.tick=d;c.wedge.push(d);"AmFunnelChart"==this.cname&&d.toBack()}}},initialStart:function(){var a=this,b=a.startDuration,c=setTimeout(function(){a.showLabels.call(a)},
1E3*b);a.timeOuts.push(c);a.chartCreated?a.pullSlices(!0):(a.startSlices(),0<b?(b=setTimeout(function(){a.pullSlices.call(a)},1200*b),a.timeOuts.push(b)):a.pullSlices(!0))},pullSlice:function(a,b,c){var d=this.pullOutDuration;!0===c&&(d=0);if(c=a.wedge)0<d?(c.animate({translate:b*a.pullX+","+b*a.pullY},d,this.pullOutEffect),a.labelSet&&a.labelSet.animate({translate:b*a.pullX+","+b*a.pullY},d,this.pullOutEffect)):(a.labelSet&&a.labelSet.translate(b*a.pullX,b*a.pullY),c.translate(b*a.pullX,b*a.pullY));
1==b?(a.pulled=!0,this.pullOutOnlyOne&&this.pullInAll(a.index),a={type:"pullOutSlice",dataItem:a,chart:this}):(a.pulled=!1,a={type:"pullInSlice",dataItem:a,chart:this});this.fire(a)},pullInAll:function(a){var b=this.chartData,c;for(c=0;c<this.chartData.length;c++)c!=a&&b[c].pulled&&this.pullSlice(b[c],0)},pullOutAll:function(){var a=this.chartData,b;for(b=0;b<a.length;b++)a[b].pulled||this.pullSlice(a[b],1)},parseData:function(){var a=[];this.chartData=a;var b=this.dataProvider;isNaN(this.pieAlpha)||
(this.alpha=this.pieAlpha);if(void 0!==b){var c=b.length,d=0,g,f,h;for(g=0;g<c;g++){f={};var e=b[g];f.dataContext=e;null!==e[this.valueField]&&(f.value=Number(e[this.valueField]));(h=e[this.titleField])||(h="");f.title=h;f.pulled=k.toBoolean(e[this.pulledField],!1);(h=e[this.descriptionField])||(h="");f.description=h;f.labelRadius=Number(e[this.labelRadiusField]);f.switchable=!0;f.className=e[this.classNameField];f.url=e[this.urlField];h=e[this.patternField];!h&&this.patterns&&(h=this.patterns[g]);
f.pattern=h;f.visibleInLegend=k.toBoolean(e[this.visibleInLegendField],!0);h=e[this.alphaField];f.alpha=void 0!==h?Number(h):this.alpha;h=e[this.colorField];void 0!==h&&(f.color=h);f.labelColor=k.toColor(e[this.labelColorField]);d+=f.value;f.hidden=!1;a[g]=f}for(g=b=0;g<c;g++)f=a[g],f.percents=f.value/d*100,f.percents<this.groupPercent&&b++;1<b&&(this.groupValue=0,this.removeSmallSlices(),a.push({title:this.groupedTitle,value:this.groupValue,percents:this.groupValue/d*100,pulled:this.groupedPulled,
color:this.groupedColor,url:this.groupedUrl,description:this.groupedDescription,alpha:this.groupedAlpha,pattern:this.groupedPattern,className:this.groupedClassName,dataContext:{}}));c=this.baseColor;c||(c=this.pieBaseColor);d=this.brightnessStep;d||(d=this.pieBrightnessStep);for(g=0;g<a.length;g++)c?h=k.adjustLuminosity(c,g*d/100):(h=this.colors[g],void 0===h&&(h=k.randomColor())),void 0===a[g].color&&(a[g].color=h);this.recalculatePercents()}},recalculatePercents:function(){var a=this.chartData,
b=0,c,d;for(c=0;c<a.length;c++)d=a[c],!d.hidden&&0<d.value&&(b+=d.value);for(c=0;c<a.length;c++)d=this.chartData[c],d.percents=!d.hidden&&0<d.value?100*d.value/b:0},removeSmallSlices:function(){var a=this.chartData,b;for(b=a.length-1;0<=b;b--)a[b].percents<this.groupPercent&&(this.groupValue+=a[b].value,a.splice(b,1))},animateAgain:function(){var a=this;a.startSlices();for(var b=0;b<a.chartData.length;b++){var c=a.chartData[b];c.started=!1;var d=c.wedge;d&&(d.setAttr("opacity",a.startAlpha),d.translate(c.startX,
c.startY));if(d=c.labelSet)d.setAttr("opacity",a.startAlpha),d.translate(c.startX,c.startY)}b=a.startDuration;0<b?(b=setTimeout(function(){a.pullSlices.call(a)},1200*b),a.timeOuts.push(b)):a.pullSlices()},measureMaxLabel:function(){var a=this.chartData,b=0,c;for(c=0;c<a.length;c++){var d=a[c],g=this.formatString(this.labelText,d),f=this.labelFunction;f&&(g=f(d,g));d=k.text(this.container,g,this.color,this.fontFamily,this.fontSize);g=d.getBBox().width;g>b&&(b=g);d.remove()}return b}})})();(function(){var k=window.AmCharts;k.AmPieChart=k.Class({inherits:k.AmSlicedChart,construct:function(a){this.type="pie";k.AmPieChart.base.construct.call(this,a);this.cname="AmPieChart";this.pieBrightnessStep=30;this.minRadius=10;this.depth3D=0;this.startAngle=90;this.angle=this.innerRadius=0;this.startRadius="500%";this.pullOutRadius="20%";this.labelRadius=20;this.labelText="[[title]]: [[percents]]%";this.balloonText="[[title]]: [[percents]]% ([[value]])\n[[description]]";this.previousScale=1;this.adjustPrecision=
!1;this.gradientType="radial";k.applyTheme(this,a,this.cname)},drawChart:function(){k.AmPieChart.base.drawChart.call(this);var a=this.chartData;if(k.ifArray(a)){if(0<this.realWidth&&0<this.realHeight){k.VML&&(this.startAlpha=1);var b=this.startDuration,c=this.container,d=this.updateWidth();this.realWidth=d;var g=this.updateHeight();this.realHeight=g;var f=k.toCoordinate,h=f(this.marginLeft,d),e=f(this.marginRight,d),z=f(this.marginTop,g)+this.getTitleHeight(),n=f(this.marginBottom,g)+this.depth3D,
A,B,m,w=k.toNumber(this.labelRadius),q=this.measureMaxLabel();q>this.maxLabelWidth&&(q=this.maxLabelWidth);this.labelText&&this.labelsEnabled||(w=q=0);A=void 0===this.pieX?(d-h-e)/2+h:f(this.pieX,this.realWidth);B=void 0===this.pieY?(g-z-n)/2+z:f(this.pieY,g);m=f(this.radius,d,g);m||(d=0<=w?d-h-e-2*q:d-h-e,g=g-z-n,m=Math.min(d,g),g<d&&(m/=1-this.angle/90,m>d&&(m=d)),g=k.toCoordinate(this.pullOutRadius,m),m=(0<=w?m-1.8*(w+g):m-1.8*g)/2);m<this.minRadius&&(m=this.minRadius);g=f(this.pullOutRadius,m);
z=k.toCoordinate(this.startRadius,m);f=f(this.innerRadius,m);f>=m&&(f=m-1);n=k.fitToBounds(this.startAngle,0,360);0<this.depth3D&&(n=270<=n?270:90);n-=90;360<n&&(n-=360);d=m-m*this.angle/90;for(h=q=0;h<a.length;h++)e=a[h],!0!==e.hidden&&(q+=k.roundTo(e.percents,this.pf.precision));q=k.roundTo(q,this.pf.precision);this.tempPrec=NaN;this.adjustPrecision&&100!=q&&(this.tempPrec=this.pf.precision+1);for(var E,h=0;h<a.length;h++)if(e=a[h],!0!==e.hidden&&(this.showZeroSlices||0!==e.percents)){var r=360*
e.percents/100,q=Math.sin((n+r/2)/180*Math.PI),C=d/m*-Math.cos((n+r/2)/180*Math.PI),p=this.outlineColor;p||(p=e.color);var u=this.alpha;isNaN(e.alpha)||(u=e.alpha);p={fill:e.color,stroke:p,"stroke-width":this.outlineThickness,"stroke-opacity":this.outlineAlpha,"fill-opacity":u};e.url&&(p.cursor="pointer");p=k.wedge(c,A,B,n,r,m,d,f,this.depth3D,p,this.gradientRatio,e.pattern,this.path,this.gradientType);k.setCN(this,p,"pie-item");k.setCN(this,p.wedge,"pie-slice");k.setCN(this,p,e.className,!0);this.addEventListeners(p,
e);e.startAngle=n;a[h].wedge=p;0<b&&(this.chartCreated||p.setAttr("opacity",this.startAlpha));e.ix=q;e.iy=C;e.wedge=p;e.index=h;e.label=null;u=c.set();if(this.labelsEnabled&&this.labelText&&e.percents>=this.hideLabelsPercent){var l=n+r/2;0>l&&(l+=360);360<l&&(l-=360);var t=w;isNaN(e.labelRadius)||(t=e.labelRadius,0>t&&(e.skipTick=!0));var r=A+q*(m+t),D=B+C*(m+t),x,v=0;isNaN(E)&&350<l&&1<a.length-h&&(E=h-1+Math.floor((a.length-h)/2));if(0<=t){var y;90>=l&&0<=l?(y=0,x="start",v=8):90<=l&&180>l?(y=1,
x="start",v=8):180<=l&&270>l?(y=2,x="end",v=-8):270<=l&&354>=l?(y=3,x="end",v=-8):354<=l&&(h>E?(y=0,x="start",v=8):(y=3,x="end",v=-8));e.labelQuarter=y}else x="middle";l=this.formatString(this.labelText,e);(t=this.labelFunction)&&(l=t(e,l));t=e.labelColor;t||(t=this.color);""!==l&&(l=k.wrappedText(c,l,t,this.fontFamily,this.fontSize,x,!1,this.maxLabelWidth),k.setCN(this,l,"pie-label"),k.setCN(this,l,e.className,!0),l.translate(r+1.5*v,D),0>w&&(l.node.style.pointerEvents="none"),l.node.style.cursor=
"default",e.ty=D,e.textX=r+1.5*v,u.push(l),this.axesSet.push(u),e.labelSet=u,e.label=l,this.addEventListeners(u,e));e.tx=r;e.tx2=r+v;e.tx0=A+q*m;e.ty0=B+C*m}r=f+(m-f)/2;e.pulled&&(r+=g);this.accessible&&this.accessibleLabel&&(D=this.formatString(this.accessibleLabel,e),this.makeAccessible(p,D));void 0!==this.tabIndex&&p.setAttr("tabindex",this.tabIndex);e.balloonX=q*r+A;e.balloonY=C*r+B;e.startX=Math.round(q*z);e.startY=Math.round(C*z);e.pullX=Math.round(q*g);e.pullY=Math.round(C*g);this.graphsSet.push(p);
if(0===e.alpha||0<b&&!this.chartCreated)p.hide(),u&&u.hide();n+=360*e.percents/100;360<n&&(n-=360)}0<w&&this.arrangeLabels();this.pieXReal=A;this.pieYReal=B;this.radiusReal=m;this.innerRadiusReal=f;0<w&&this.drawTicks();this.initialStart();this.setDepths()}(a=this.legend)&&a.invalidateSize()}else this.cleanChart();this.dispDUpd()},setDepths:function(){var a=this.chartData,b;for(b=0;b<a.length;b++){var c=a[b],d=c.wedge,c=c.startAngle;0<=c&&180>c?d.toFront():180<=c&&d.toBack()}},arrangeLabels:function(){var a=
this.chartData,b=a.length,c,d;for(d=b-1;0<=d;d--)c=a[d],0!==c.labelQuarter||c.hidden||this.checkOverlapping(d,c,0,!0,0);for(d=0;d<b;d++)c=a[d],1!=c.labelQuarter||c.hidden||this.checkOverlapping(d,c,1,!1,0);for(d=b-1;0<=d;d--)c=a[d],2!=c.labelQuarter||c.hidden||this.checkOverlapping(d,c,2,!0,0);for(d=0;d<b;d++)c=a[d],3!=c.labelQuarter||c.hidden||this.checkOverlapping(d,c,3,!1,0)},checkOverlapping:function(a,b,c,d,g){var f,h,e=this.chartData,k=e.length,n=b.label;if(n){if(!0===d)for(h=a+1;h<k;h++)e[h].labelQuarter==
c&&(f=this.checkOverlappingReal(b,e[h],c))&&(h=k);else for(h=a-1;0<=h;h--)e[h].labelQuarter==c&&(f=this.checkOverlappingReal(b,e[h],c))&&(h=0);!0===f&&200>g&&isNaN(b.labelRadius)&&(f=b.ty+3*b.iy,b.ty=f,n.translate(b.textX,f),this.checkOverlapping(a,b,c,d,g+1))}},checkOverlappingReal:function(a,b,c){var d=!1,g=a.label,f=b.label;a.labelQuarter!=c||a.hidden||b.hidden||!f||(g=g.getBBox(),c={},c.width=g.width,c.height=g.height,c.y=a.ty,c.x=a.tx,a=f.getBBox(),f={},f.width=a.width,f.height=a.height,f.y=
b.ty,f.x=b.tx,k.hitTest(c,f)&&(d=!0));return d}})})();

/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.7.1
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var u=new Error("Cannot find module '"+s+"'");throw u.code="MODULE_NOT_FOUND",u}var l=e[s]={exports:{}};t[s][0].call(l.exports,function(e){var n=t[s][1][e];return i(n?n:e)},l,l.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new f(16),this._normalQueue=new f(16),this._haveDrainedQueues=!1;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var u;try{throw new Error}catch(l){u=l}var p=t("./schedule"),f=t("./queue");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s,r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=u},{"./queue":26,"./schedule":29}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var u=n(o),l=new t(e);l._propagateFrom(this,1);var p=this._target();if(l._setBoundTo(u),u instanceof t){var f={promiseRejectionQueued:!1,promise:l,target:p,bindingPromise:u};p._then(e,s,void 0,l,f),u._then(a,c,void 0,l,f),l._setOnCancel(u)}else l._resolveCallback(p);return l},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var u=a._boundValue();t:for(var l=0;l<t.length;++l){var p=t[l];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(u,c)}else if("function"==typeof p){var f=o(p).call(u,c);if(f===s)return f;if(f)return o(n).call(u,c)}else if(r.isObject(c)){for(var h=i(p),_=0;_<h.length;++_){var d=h[_];if(p[d]!=c[d])continue t}return o(n).call(u,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,e){return{promise:e}}function s(){return!1}function a(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+B.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function c(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?B.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function u(){return this._onCancelField}function l(t){this._onCancelField=t}function p(){this._cancellationParent=void 0,this._onCancelField=void 0}function f(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function _(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function d(){this._trace=new V(this._peekContext())}function v(t,e){if(q(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=F(t);B.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),B.notEnumerableProp(t,"__stackCleaned__",!0)}}}function y(){this._trace=void 0}function g(t,e,n,r,i){if(void 0===t&&null!==e&&Z){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=k(a),u=c.length-1;u>=0;--u){var l=c[u];if(!Q.test(l)){var p=l.match(G);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var f=c[0],u=0;u<a.length;++u)if(a[u]===f){u>0&&(s="\n"+a[u-1]);break}}var h="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(h,!0,e)}}function m(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),b(n)}function b(t,n,r){if(lt.warnings){var i,o=new U(t);if(n)r._attachExtraTrace(o);else if(lt.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=F(o);o.stack=s.message+"\n"+s.stack.join("\n")}ot("warning",o)||x(o,"",!0)}}function w(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function C(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function j(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function k(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||W.test(r),o=i&&at(r);i&&!o&&(X&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function E(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||W.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function F(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?E(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:k(e)}}function x(t,e,n){if("undefined"!=typeof console){var r;if(B.isObject(t)){var i=t.stack;r=e+z(i,t)}else r=e+String(t);"function"==typeof I?I(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function T(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){N.throwLater(o)}"unhandledRejection"===t?ot(t,n,r)||i||x(n,"Unhandled rejection "):ot(t,r)}function P(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():B.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+R(e)+">, no stack trace)"}function R(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function S(){return"function"==typeof ut}function O(t){var e=t.match(ct);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function A(t,e){if(S()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var u=O(i[c]);if(u){n=u.fileName,s=u.line;break}}for(var c=0;c<o.length;++c){var u=O(o[c]);if(u){r=u.fileName,a=u.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(at=function(t){if($.test(t))return!0;var e=O(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function V(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);ut(this,V),e>32&&this.uncycle()}var H,D,I,L,N=e._async,U=t("./errors").Warning,B=t("./util"),M=t("./es5"),q=B.canAttachTrace,$=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,Q=/\((?:timers\.js):\d+:\d+\)/,G=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,W=null,z=null,X=!1,K=!(0==B.env("BLUEBIRD_DEBUG")||!B.env("BLUEBIRD_DEBUG")&&"development"!==B.env("NODE_ENV")),J=!(0==B.env("BLUEBIRD_WARNINGS")||!K&&!B.env("BLUEBIRD_WARNINGS")),Y=!(0==B.env("BLUEBIRD_LONG_STACK_TRACES")||!K&&!B.env("BLUEBIRD_LONG_STACK_TRACES")),Z=0!=B.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(J||!!B.env("BLUEBIRD_W_FORGOTTEN_RETURN"));!function(){function t(){for(var t=0;t<r.length;++t)r[t]._notifyUnhandledRejection();n()}function n(){r.length=0}var r=[];L="object"==typeof document&&document.createElement?function(){function e(){if(document.body){var t=document.createElement("iframe");document.body.appendChild(t),t.contentWindow&&t.contentWindow.setTimeout&&(n=t.contentWindow.setTimeout),document.body.removeChild(t)}}var n;return e(),function(i){r.push(i),n?n(t,1):e()}}():function(e){r.push(e),setTimeout(t,1)},M.defineProperty(e,"_unhandledRejectionCheck",{value:t}),M.defineProperty(e,"_unhandledRejectionClear",{value:n})}(),e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){0===(524288&this._bitField)&&(this._setRejectionIsUnhandled(),L(this))},e.prototype._notifyUnhandledRejectionIsHandled=function(){T("rejectionHandled",H,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),T("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return b(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var n=e._getContext();D=B.contextBind(n,t)},e.onUnhandledRejectionHandled=function(t){var n=e._getContext();H=B.contextBind(n,t)};var tt=function(){};e.longStackTraces=function(){if(N.haveItemsQueued()&&!lt.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!lt.longStackTraces&&S()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;lt.longStackTraces=!0,tt=function(){if(N.haveItemsQueued()&&!lt.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),lt.longStackTraces=!1},e.prototype._captureStackTrace=d,e.prototype._attachExtraTrace=v,e.prototype._dereferenceTrace=y,n.activateLongStackTraces()}},e.hasLongStackTraces=function(){return lt.longStackTraces&&S()};var et={unhandledrejection:{before:function(){var t=B.global.onunhandledrejection;return B.global.onunhandledrejection=null,t},after:function(t){B.global.onunhandledrejection=t}},rejectionhandled:{before:function(){var t=B.global.onrejectionhandled;return B.global.onrejectionhandled=null,t},after:function(t){B.global.onrejectionhandled=t}}},nt=function(){var t=function(t,e){if(!t)return!B.global.dispatchEvent(e);var n;try{return n=t.before(),!B.global.dispatchEvent(e)}finally{t.after(n)}};try{if("function"==typeof CustomEvent){var e=new CustomEvent("CustomEvent");return B.global.dispatchEvent(e),function(e,n){e=e.toLowerCase();var r={detail:n,cancelable:!0},i=new CustomEvent(e,r);return M.defineProperty(i,"promise",{value:n.promise}),M.defineProperty(i,"reason",{value:n.reason}),t(et[e],i)}}if("function"==typeof Event){var e=new Event("CustomEvent");return B.global.dispatchEvent(e),function(e,n){e=e.toLowerCase();var r=new Event(e,{cancelable:!0});return r.detail=n,M.defineProperty(r,"promise",{value:n.promise}),M.defineProperty(r,"reason",{value:n.reason}),t(et[e],r)}}var e=document.createEvent("CustomEvent");return e.initCustomEvent("testingtheevent",!1,!0,{}),B.global.dispatchEvent(e),function(e,n){e=e.toLowerCase();var r=document.createEvent("CustomEvent");return r.initCustomEvent(e,!1,!0,n),t(et[e],r)}}catch(n){}return function(){return!1}}(),rt=function(){return B.isNode?function(){return process.emit.apply(process,arguments)}:B.global?function(t){var e="on"+t.toLowerCase(),n=B.global[e];return n?(n.apply(B.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),it={promiseCreated:o,promiseFulfilled:o,promiseRejected:o,promiseResolved:o,promiseCancelled:o,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:o},ot=function(t){var e=!1;try{e=rt.apply(null,arguments)}catch(n){N.throwLater(n),e=!0}var r=!1;try{r=nt(t,it[t].apply(null,arguments))}catch(n){N.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&tt()),"warnings"in t){var n=t.warnings;lt.warnings=!!n,Z=lt.warnings,B.isObject(n)&&"wForgottenReturn"in n&&(Z=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!lt.cancellation){if(N.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=p,e.prototype._propagateFrom=f,e.prototype._onCancel=u,e.prototype._setOnCancel=l,e.prototype._attachCancellationCallback=c,e.prototype._execute=a,st=f,lt.cancellation=!0}if("monitoring"in t&&(t.monitoring&&!lt.monitoring?(lt.monitoring=!0,e.prototype._fireEvent=ot):!t.monitoring&&lt.monitoring&&(lt.monitoring=!1,e.prototype._fireEvent=s)),"asyncHooks"in t&&B.nodeSupportsAsyncResource){var o=lt.asyncHooks,h=!!t.asyncHooks;o!==h&&(lt.asyncHooks=h,h?r():i())}return e},e.prototype._fireEvent=s,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var st=h,at=function(){return!1},ct=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;B.inherits(V,Error),n.CapturedTrace=V,V.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var u=c._length+1,l=r-2;l>=0;--l)e[l]._length=u,u++;return}}}},V.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=F(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(k(i.stack.split("\n"))),i=i._parent;j(r),C(r),B.notEnumerableProp(t,"stack",w(n,r)),B.notEnumerableProp(t,"__stackCleaned__",!0)}};var ut=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():P(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,W=t,z=e;var n=Error.captureStackTrace;return at=function(t){return $.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return W=/@/,z=e,X=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(z=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?P(e):e.toString()},null):(W=t,z=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(I=function(t){console.warn(t)},B.isNode&&process.stderr.isTTY?I=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:B.isNode||"string"!=typeof(new Error).stack||(I=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var lt={warnings:J,longStackTraces:!1,cancellation:!1,monitoring:!1,asyncHooks:!1};return Y&&e.longStackTraces(),{asyncHooks:function(){return lt.asyncHooks},longStackTraces:function(){return lt.longStackTraces},warnings:function(){return lt.warnings},cancellation:function(){return lt.cancellation},monitoring:function(){return lt.monitoring},propagateFromFunction:function(){return st},boundValueFunction:function(){return _},checkForgottenReturns:g,setBounds:A,warn:b,deprecated:m,CapturedTrace:V,fireDomEvent:nt,fireGlobalEvent:rt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return l(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,u=t("./util"),l=u.inherits,p=u.notEnumerableProp,f=r("Warning","warning"),h=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),g=0;g<y.length;++g)"function"==typeof Array.prototype[y[g]]&&(d.prototype[y[g]]=Array.prototype[y[g]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var m=0;d.prototype.toString=function(){var t=Array(4*m+1).join(" "),e="\n"+t+"AggregateError of:\n";m++,t=Array(4*m+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return m--,e},l(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:h,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:f}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},u=function(t,e,n){return t[e]=n.value,t},l=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},f=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:f,keys:a,names:a,defineProperty:u,getDescriptor:c,freeze:l,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return u.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(f.e=t,f)}function u(t){var i=this.promise,u=this.handler;if(!this.called){this.called=!0;var l=this.isFinallyHandler()?u.call(i._boundValue()):u.call(i._boundValue(),t);if(l===r)return l;if(void 0!==l){i._setReturnedNonUndefined();var h=n(l,i);if(h instanceof e){if(null!=this.cancelPromise){if(h._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),f.e=_,f}h.isPending()&&h._attachCancellationCallback(new o(this))}return h._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),f.e=t,f):(s(this),t)}var l=t("./util"),p=e.CancellationError,f=l.errorObj,h=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,u,u)},e.prototype.tap=function(t){return this._passThrough(t,1,u)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,u);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!l.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+l.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(h(i,a,this),1,void 0,u)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=h(n[o])(t);if(r._popContext(),s===f){r._pushContext();var a=e.reject(f.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var u=this._promise=new e(r);u._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var u=t("./errors"),l=u.TypeError,p=t("./util"),f=p.errorObj,h=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=h(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=h(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=h(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=h(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),
this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===f)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),null===o))return void this._promiseRejected(new l("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new l("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new l("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util");s.canEvaluate,s.tryCatch,s.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t),this._promise._captureStackTrace();var s=e._getContext();if(this._callback=u.contextBind(s,n),this._preservedValues=i===o?new Array(this.length()):null,this._limit=r,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0),u.isArray(t))for(var a=0;a<t.length;++a){var c=t[a];c instanceof e&&c.suppressUnhandledRejections()}}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var u=t("./util"),l=u.tryCatch,p=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var u=this._promise,f=this._callback,h=u._boundValue();u._pushContext();var _=l(f).call(h,t,n,o),d=u._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",u),_===p)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var g=++this._totalResolved;return g>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var u=arguments[1],l=arguments[2];c=s.isArray(u)?a(t).apply(l,u):a(t).call(l,u)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&l.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new u(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=l.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),u=c.OperationalError,l=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new E("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new E("expecting a function but got "+f.classString(e))}function i(t){t!==x&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(x);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c=function(){return new E("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},l=function(t){return i.reject(new E(t))},p={},f=t("./util");f.setReflectHandler(u);var h=function(){var t=process.domain;return void 0===t?null:t},_=function(){return null},d=function(){return{domain:h(),async:null}},v=f.isNode&&f.nodeSupportsAsyncResource?t("async_hooks").AsyncResource:null,y=function(){return{domain:h(),async:new v("Bluebird::Promise")}},g=f.isNode?d:_;f.notEnumerableProp(i,"_getContext",g);var m=function(){g=y,f.notEnumerableProp(i,"_getContext",y)},b=function(){g=d,f.notEnumerableProp(i,"_getContext",d)},w=t("./es5"),C=t("./async"),j=new C;w.defineProperty(i,"_async",{value:j});var k=t("./errors"),E=i.TypeError=k.TypeError;i.RangeError=k.RangeError;var F=i.CancellationError=k.CancellationError;i.TimeoutError=k.TimeoutError,i.OperationalError=k.OperationalError,i.RejectionError=k.OperationalError,i.AggregateError=k.AggregateError;var x=function(){},T={},P={},R=t("./thenables")(i,x),S=t("./promise_array")(i,x,R,l,n),O=t("./context")(i),A=O.create,V=t("./debuggability")(i,O,m,b),H=(V.CapturedTrace,t("./finally")(i,R,P)),D=t("./catch_filter")(P),I=t("./nodeback"),L=f.errorObj,N=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return l("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new E("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,D(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(V.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?l("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,T,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new S(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(x);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=N(t)(I(e,n));return r===L&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new S(t).promise()},i.cast=function(t){var e=R(t);return e instanceof i||(e=new i(x),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(x);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new E("expecting a function but got "+f.classString(t));return j.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(x),c=this._target(),u=c._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():c===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var l=g();if(0!==(50397184&u)){var p,h,_=c._settlePromiseCtx;0!==(33554432&u)?(h=c._rejectionHandler0,p=t):0!==(16777216&u)?(h=c._fulfillmentHandler0,p=e,c._unsetRejectionIsUnhandled()):(_=c._settlePromiseLateCancellationObserver,h=new F("late cancellation observer"),c._attachExtraTrace(h),p=e),j.invoke(_,c,{handler:f.contextBind(l,p),promise:a,receiver:r,value:h})}else c._addCallbacks(t,e,a,r,l);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){if(!j.hasCustomScheduler()){var t=this._bitField;this._bitField=t|(536870912&t)>>2^134217728}},i.prototype._setNoAsyncGuarantee=function(){this._bitField=-134217729&(536870912|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===p?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=p),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=p),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=f.contextBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=f.contextBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=f.contextBind(i,t)),"function"==typeof e&&(this[s+1]=f.contextBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(c(),!1);var n=R(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(c());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(n)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var u=new F("late cancellation observer");r._attachExtraTrace(u),this._reject(u)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&V.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==x){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===T?n&&"number"==typeof n.length?o=N(t).apply(this._boundValue(),n):(o=L,o.e=new E("cannot .spread() a non-array: "+f.classString(n))):o=N(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===P?r._reject(n):o===L?r._rejectCallback(o.e,!1):(V.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof H&&r.isFinallyHandler()?(r.cancelPromise=t,N(e).call(r,o)===L&&t._reject(L.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof S?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=c();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():j.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?j.fatalError(t,f.isNode):void((65535&e)>0?j.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&w.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){V.deprecated("Promise.defer","new Promise");var t=new i(x);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",c),t("./method")(i,x,R,l,V),t("./bind")(i,x,R,V),t("./cancel")(i,S,l,V),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,S,R,x,j),i.Promise=i,i.version="3.7.1",t("./call_get.js")(i),t("./generators.js")(i,l,x,R,n,V),t("./map.js")(i,S,l,R,x,V),t("./nodeify.js")(i),t("./promisify.js")(i,x),t("./props.js")(i,S,R,l),t("./race.js")(i,x,R,l),t("./reduce.js")(i,S,l,R,x,V),t("./settle.js")(i,S,V),t("./some.js")(i,S,l),t("./timers.js")(i,x,V),t("./using.js")(i,l,R,A,x,V),t("./any.js")(i),t("./each.js")(i,x),t("./filter.js")(i,x),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(x)),V.setBounds(C.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36,async_hooks:void 0}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&(r._propagateFrom(t,3),t.suppressUnhandledRejections()),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function u(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(u,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var l=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(l,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=h.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new g("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=h.inheritedDataKeys(t),c=[],u=0;u<a.length;++u){var l=a[u],p=t[l],f=r===j?!0:j(l,p,t);"function"!=typeof p||i(p)||o(t,l,e)||!r(l,p,t,f)||c.push(l,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===f&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof l&&this!==u?this[l]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var u=function(){return this}(),l=t;return"string"==typeof l&&(t=o),h.notEnumerableProp(c,"__isPromisified__",!0),c}function u(t,e,n,r,i){for(var o=new RegExp(k(e)+"$"),s=a(t,e,o,n),c=0,u=s.length;u>c;c+=2){var l=s[c],p=s[c+1],_=l+e;if(r===E)t[_]=E(l,f,l,p,e,i);else{var d=r(p,function(){return E(l,f,l,p,e,i)});h.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return h.toFastProperties(t),t}function l(t,e,n){return E(t,e,void 0,t,null,n)}var p,f={},h=t("./util"),_=t("./nodeback"),d=h.withAppended,v=h.maybeWrapAsError,y=h.canEvaluate,g=t("./errors").TypeError,m="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return h.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},k=function(t){return t.replace(/([$])/,"\\$")},E=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new g("expecting a function but got "+h.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?f:e.context,o=!!e.multiArgs,s=l(t,n,o);return h.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new g("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=m);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=E),!h.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=h.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&h.isClass(c)&&(u(c.prototype,r,i,o,n),u(c,r,i,o,n))}return u(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=l.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return u(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),u=c.isObject,l=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),f=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=f(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var u=new e(n);void 0!==o&&u._propagateFrom(o,3);for(var l=u._fulfill,p=u._reject,f=0,h=t.length;h>f;++f){var _=t[f];(void 0!==_||f in t)&&e.cast(_)._then(l,p,void 0,u,null)}return u}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=e._getContext();this._fn=f.contextBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function u(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function l(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=h(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var f=t("./util"),h=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n;for(var o=r;i>o;++o){var s=t[o];s instanceof e&&s.suppressUnhandledRejections()}if(!n.isRejected())for(;i>r;++r){var a={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(l,void 0,void 0,a,void 0),0===(127&r)&&n._setNoAsyncGuarantee()}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return u(this,t,e,null)},e.reduce=function(t,e,n,r){return u(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){
throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){var u=s.resolve();r=function(t){u.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.allSettled=function(t){return new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,u=s.isArray,l={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=u(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(l),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==l&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(l(t)){if(t instanceof e)return t;var i=o(t);if(i===u){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return u.e=e,u}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),l=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,f=c.tryCatch(r).call(t,o,s);return p=!1,a&&f===u&&(a._rejectCallback(f.e,!0,!0),a=null),l}var c=t("./util"),u=c.errorObj,l=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var u=function(t){return l(+this).thenReturn(t)},l=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(u,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return l(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function u(t,n){function i(){if(s>=u)return l._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,u=t.length,l=new e(o);return i(),l}function l(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function f(t){return l.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function h(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,g=_.tryCatch,m={};l.prototype.data=function(){return this._data},l.prototype.promise=function(){return this._promise},l.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():m},l.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==m?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},l.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,l),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},h.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new h(t),p=0;t>p;++p){var d=o[p];if(l.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var m=r(d);m instanceof e&&(d=m._then(f,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=g(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return u(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return T.e=e,T}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function u(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function l(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function f(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function h(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return V.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function g(t){try{l(t,"isOperational",!0)}catch(e){}}function m(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return N?process.env[t]:void 0}function k(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"===w(t))return Promise}catch(e){}}function E(t,e){if(null===t||"function"!=typeof e||e===U)return e;null!==t.domain&&(e=t.domain.bind(e));var n=t.async;if(null!==n){var r=e;e=function(){var t=new Array(2).concat([].slice.call(arguments));return t[0]=r,t[1]=this,n.runInAsyncScope.apply(n,t)}}return e}var F=t("./es5"),x="undefined"==typeof navigator,T={e:{}},P,R="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,S=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var u=Object.getOwnPropertyDescriptor(t,c);null!=u&&null==u.get&&null==u.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,V=/^[a-z$_][a-z$_0-9]*$/i,H=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),D=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var I="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};D=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?I(t):null}}var L="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),N="undefined"!=typeof process&&"undefined"!=typeof process.env,U,B={setReflectHandler:function(t){U=t},isClass:f,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:u,thrower:p,isArray:F.isArray,asArray:D,notEnumerableProp:l,isPrimitive:o,isObject:s,isError:y,canEvaluate:x,errorObj:T,tryCatch:i,inherits:S,withAppended:c,maybeWrapAsError:a,toFastProperties:h,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:H,originatesFromRejection:m,markAsOriginatingFromRejection:g,classString:w,copyDescriptors:C,isNode:L,hasEnvVariables:N,env:j,global:R,getNativePromise:k,contextBind:E};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.nodeSupportsAsyncResource=B.isNode&&function(){var e=!1;try{var n=t("async_hooks").AsyncResource;e="function"==typeof n.prototype.runInAsyncScope}catch(r){e=!1}return e}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(M){B.lastLineError=M}e.exports=B},{"./es5":13,async_hooks:void 0}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
var parser =
    /******/
    (function(modules) { // webpackBootstrap
        /******/
        // The module cache
        /******/
        var installedModules = {};
        /******/
        /******/
        // The require function
        /******/
        function __webpack_require__(moduleId) {
            /******/
            /******/
            // Check if module is in cache
            /******/
            if (installedModules[moduleId]) {
                /******/
                return installedModules[moduleId].exports;
                /******/
            }
            /******/
            // Create a new module (and put it into the cache)
            /******/
            var module = installedModules[moduleId] = {
                /******/
                i: moduleId,
                /******/
                l: false,
                /******/
                exports: {}
                /******/
            };
            /******/
            /******/
            // Execute the module function
            /******/
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/
            // Flag the module as loaded
            /******/
            module.l = true;
            /******/
            /******/
            // Return the exports of the module
            /******/
            return module.exports;
            /******/
        }
        /******/
        /******/
        /******/
        // expose the modules object (__webpack_modules__)
        /******/
        __webpack_require__.m = modules;
        /******/
        /******/
        // expose the module cache
        /******/
        __webpack_require__.c = installedModules;
        /******/
        /******/
        // define getter function for harmony exports
        /******/
        __webpack_require__.d = function(exports, name, getter) {
            /******/
            if (!__webpack_require__.o(exports, name)) {
                /******/
                Object.defineProperty(exports, name, {
                    enumerable: true,
                    get: getter
                });
                /******/
            }
            /******/
        };
        /******/
        /******/
        // define __esModule on exports
        /******/
        __webpack_require__.r = function(exports) {
            /******/
            if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
                /******/
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/
            }
            /******/
            Object.defineProperty(exports, '__esModule', {
                value: true
            });
            /******/
        };
        /******/
        /******/
        // create a fake namespace object
        /******/
        // mode & 1: value is a module id, require it
        /******/
        // mode & 2: merge all properties of value into the ns
        /******/
        // mode & 4: return value when already ns object
        /******/
        // mode & 8|1: behave like require
        /******/
        __webpack_require__.t = function(value, mode) {
            /******/
            if (mode & 1) value = __webpack_require__(value);
            /******/
            if (mode & 8) return value;
            /******/
            if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
            /******/
            var ns = Object.create(null);
            /******/
            __webpack_require__.r(ns);
            /******/
            Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/
            if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            /******/
            return ns;
            /******/
        };
        /******/
        /******/
        // getDefaultExport function for compatibility with non-harmony modules
        /******/
        __webpack_require__.n = function(module) {
            /******/
            var getter = module && module.__esModule ?
                /******/
                function getDefault() {
                    return module['default'];
                } :
                /******/
                function getModuleExports() {
                    return module;
                };
            /******/
            __webpack_require__.d(getter, 'a', getter);
            /******/
            return getter;
            /******/
        };
        /******/
        /******/
        // Object.prototype.hasOwnProperty.call
        /******/
        __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/
        /******/
        // __webpack_public_path__
        /******/
        __webpack_require__.p = "";
        /******/
        /******/
        /******/
        // Load entry module and return exports
        /******/
        return __webpack_require__(__webpack_require__.s = "./src/parser.js");
        /******/
    })
        /************************************************************************/
        /******/
        ({

            /***/
            "./src/json2xml.js":
            /*!*************************!*\
          !*** ./src/json2xml.js ***!
          \*************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    //parse Empty Node as self closing node
                    var buildOptions = __webpack_require__( /*! ./util */ "./src/util.js").buildOptions;
                    var defaultOptions = {
                        attributeNamePrefix: '@_',
                        attrNodeName: false,
                        textNodeName: '#text',
                        ignoreAttributes: true,
                        cdataTagName: false,
                        cdataPositionChar: '\\c',
                        format: false,
                        indentBy: '  ',
                        supressEmptyNode: false,
                        tagValueProcessor: function tagValueProcessor(a) {
                            return a;
                        },
                        attrValueProcessor: function attrValueProcessor(a) {
                            return a;
                        }
                    };
                    var props = ['attributeNamePrefix', 'attrNodeName', 'textNodeName', 'ignoreAttributes', 'cdataTagName', 'cdataPositionChar', 'format', 'indentBy', 'supressEmptyNode', 'tagValueProcessor', 'attrValueProcessor'];

                    function Parser(options) {
                        this.options = buildOptions(options, defaultOptions, props);
                        if (this.options.ignoreAttributes || this.options.attrNodeName) {
                            this.isAttribute = function() /*a*/
                            {
                                return false;
                            };
                        } else {
                            this.attrPrefixLen = this.options.attributeNamePrefix.length;
                            this.isAttribute = isAttribute;
                        }
                        if (this.options.cdataTagName) {
                            this.isCDATA = isCDATA;
                        } else {
                            this.isCDATA = function() /*a*/
                            {
                                return false;
                            };
                        }
                        this.replaceCDATAstr = replaceCDATAstr;
                        this.replaceCDATAarr = replaceCDATAarr;
                        if (this.options.format) {
                            this.indentate = indentate;
                            this.tagEndChar = '>\n';
                            this.newLine = '\n';
                        } else {
                            this.indentate = function() {
                                return '';
                            };
                            this.tagEndChar = '>';
                            this.newLine = '';
                        }
                        if (this.options.supressEmptyNode) {
                            this.buildTextNode = buildEmptyTextNode;
                            this.buildObjNode = buildEmptyObjNode;
                        } else {
                            this.buildTextNode = buildTextValNode;
                            this.buildObjNode = buildObjectNode;
                        }
                        this.buildTextValNode = buildTextValNode;
                        this.buildObjectNode = buildObjectNode;
                    }
                    Parser.prototype.parse = function(jObj) {
                        return this.j2x(jObj, 0).val;
                    };
                    Parser.prototype.j2x = function(jObj, level) {
                        var attrStr = '';
                        var val = '';
                        var keys = Object.keys(jObj);
                        var len = keys.length;
                        for (var i = 0; i < len; i++) {
                            var key = keys[i];
                            if (typeof jObj[key] === 'undefined') { // supress undefined node
                            } else if (jObj[key] === null) {
                                val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                            } else if (jObj[key] instanceof Date) {
                                val += this.buildTextNode(jObj[key], key, '', level);
                            } else if (typeof jObj[key] !== 'object') { //premitive type
                                var attr = this.isAttribute(key);
                                if (attr) {
                                    attrStr += ' ' + attr + '="' + this.options.attrValueProcessor('' + jObj[key]) + '"';
                                } else if (this.isCDATA(key)) {
                                    if (jObj[this.options.textNodeName]) {
                                        val += this.replaceCDATAstr(jObj[this.options.textNodeName], jObj[key]);
                                    } else {
                                        val += this.replaceCDATAstr('', jObj[key]);
                                    }
                                } else { //tag value
                                    if (key === this.options.textNodeName) {
                                        if (jObj[this.options.cdataTagName]) { //value will added while processing cdata
                                        } else {
                                            val += this.options.tagValueProcessor('' + jObj[key]);
                                        }
                                    } else {
                                        val += this.buildTextNode(jObj[key], key, '', level);
                                    }
                                }
                            } else if (Array.isArray(jObj[key])) { //repeated nodes
                                if (this.isCDATA(key)) {
                                    val += this.indentate(level);
                                    if (jObj[this.options.textNodeName]) {
                                        val += this.replaceCDATAarr(jObj[this.options.textNodeName], jObj[key]);
                                    } else {
                                        val += this.replaceCDATAarr('', jObj[key]);
                                    }
                                } else { //nested nodes
                                    var arrLen = jObj[key].length;
                                    for (var j = 0; j < arrLen; j++) {
                                        var item = jObj[key][j];
                                        if (typeof item === 'undefined') { // supress undefined node
                                        } else if (item === null) {
                                            val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                                        } else if (typeof item === 'object') {
                                            var result = this.j2x(item, level + 1);
                                            val += this.buildObjNode(result.val, key, result.attrStr, level);
                                        } else {
                                            val += this.buildTextNode(item, key, '', level);
                                        }
                                    }
                                }
                            } else { //nested node
                                if (this.options.attrNodeName && key === this.options.attrNodeName) {
                                    var Ks = Object.keys(jObj[key]);
                                    var L = Ks.length;
                                    for (var _j = 0; _j < L; _j++) {
                                        attrStr += ' ' + Ks[_j] + '="' + this.options.attrValueProcessor('' + jObj[key][Ks[_j]]) + '"';
                                    }
                                } else {
                                    var _result = this.j2x(jObj[key], level + 1);
                                    val += this.buildObjNode(_result.val, key, _result.attrStr, level);
                                }
                            }
                        }
                        return {
                            attrStr: attrStr,
                            val: val
                        };
                    };

                    function replaceCDATAstr(str, cdata) {
                        str = this.options.tagValueProcessor('' + str);
                        if (this.options.cdataPositionChar === '' || str === '') {
                            return str + '<![CDATA[' + cdata + ']]' + this.tagEndChar;
                        } else {
                            return str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata + ']]' + this.tagEndChar);
                        }
                    }
                    function replaceCDATAarr(str, cdata) {
                        str = this.options.tagValueProcessor('' + str);
                        if (this.options.cdataPositionChar === '' || str === '') {
                            return str + '<![CDATA[' + cdata.join(']]><![CDATA[') + ']]' + this.tagEndChar;
                        } else {
                            for (var v in cdata) {
                                str = str.replace(this.options.cdataPositionChar, '<![CDATA[' + cdata[v] + ']]>');
                            }
                            return str + this.newLine;
                        }
                    }
                    function buildObjectNode(val, key, attrStr, level) {
                        if (attrStr && !val.includes('<')) {
                            return this.indentate(level) + '<' + key + attrStr + '>' + val + //+ this.newLine
                                // + this.indentate(level)
                                '</' + key + this.tagEndChar;
                        } else {
                            return this.indentate(level) + '<' + key + attrStr + this.tagEndChar + val + //+ this.newLine
                                this.indentate(level) + '</' + key + this.tagEndChar;
                        }
                    }
                    function buildEmptyObjNode(val, key, attrStr, level) {
                        if (val !== '') {
                            return this.buildObjectNode(val, key, attrStr, level);
                        } else {
                            return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar; //+ this.newLine
                        }
                    }
                    function buildTextValNode(val, key, attrStr, level) {
                        return this.indentate(level) + '<' + key + attrStr + '>' + this.options.tagValueProcessor(val) + '</' + key + this.tagEndChar;
                    }
                    function buildEmptyTextNode(val, key, attrStr, level) {
                        if (val !== '') {
                            return this.buildTextValNode(val, key, attrStr, level);
                        } else {
                            return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
                        }
                    }
                    function indentate(level) {
                        return this.options.indentBy.repeat(level);
                    }
                    function isAttribute(name /*, options*/ ) {
                        if (name.startsWith(this.options.attributeNamePrefix)) {
                            return name.substr(this.attrPrefixLen);
                        } else {
                            return false;
                        }
                    }
                    function isCDATA(name) {
                        return name === this.options.cdataTagName;
                    } //formatting
                    //indentation
                    //\n after each closing or self closing tag
                    module.exports = Parser;

                    /***/
                }),

            /***/
            "./src/nimndata.js":
            /*!*************************!*\
          !*** ./src/nimndata.js ***!
          \*************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var _char = function _char(a) {
                        return String.fromCharCode(a);
                    };
                    var chars = {
                        nilChar: _char(176),
                        missingChar: _char(201),
                        nilPremitive: _char(175),
                        missingPremitive: _char(200),
                        emptyChar: _char(178),
                        emptyValue: _char(177), //empty Premitive
                        boundryChar: _char(179),
                        objStart: _char(198),
                        arrStart: _char(204),
                        arrayEnd: _char(185)
                    };
                    var charsArr = [chars.nilChar, chars.nilPremitive, chars.missingChar, chars.missingPremitive, chars.boundryChar, chars.emptyChar, chars.emptyValue, chars.arrayEnd, chars.objStart, chars.arrStart];
                    var _e = function _e(node, e_schema, options) {
                        if (typeof e_schema === 'string') { //premitive
                            if (node && node[0] && node[0].val !== undefined) {
                                return getValue(node[0].val, e_schema);
                            } else {
                                return getValue(node, e_schema);
                            }
                        } else {
                            var hasValidData = hasData(node);
                            if (hasValidData === true) {
                                var str = '';
                                if (Array.isArray(e_schema)) { //attributes can't be repeated. hence check in children tags only
                                    str += chars.arrStart;
                                    var itemSchema = e_schema[0]; //var itemSchemaType = itemSchema;
                                    var arr_len = node.length;
                                    if (typeof itemSchema === 'string') {
                                        for (var arr_i = 0; arr_i < arr_len; arr_i++) {
                                            var r = getValue(node[arr_i].val, itemSchema);
                                            str = processValue(str, r);
                                        }
                                    } else {
                                        for (var _arr_i = 0; _arr_i < arr_len; _arr_i++) {
                                            var _r = _e(node[_arr_i], itemSchema, options);
                                            str = processValue(str, _r);
                                        }
                                    }
                                    str += chars.arrayEnd; //indicates that next item is not array item
                                } else { //object
                                    str += chars.objStart;
                                    var keys = Object.keys(e_schema);
                                    if (Array.isArray(node)) {
                                        node = node[0];
                                    }
                                    for (var i in keys) {
                                        var key = keys[i]; //a property defined in schema can be present either in attrsMap or children tags
                                        //options.textNodeName will not present in both maps, take it's value from val
                                        //options.attrNodeName will be present in attrsMap
                                        var _r2 = void 0;
                                        if (!options.ignoreAttributes && node.attrsMap && node.attrsMap[key]) {
                                            _r2 = _e(node.attrsMap[key], e_schema[key], options);
                                        } else if (key === options.textNodeName) {
                                            _r2 = _e(node.val, e_schema[key], options);
                                        } else {
                                            _r2 = _e(node.child[key], e_schema[key], options);
                                        }
                                        str = processValue(str, _r2);
                                    }
                                }
                                return str;
                            } else {
                                return hasValidData;
                            }
                        }
                    };
                    var getValue = function getValue(a /*, type*/ ) {
                        switch (a) {
                            case undefined:
                                return chars.missingPremitive;
                            case null:
                                return chars.nilPremitive;
                            case '':
                                return chars.emptyValue;
                            default:
                                return a;
                        }
                    };
                    var processValue = function processValue(str, r) {
                        if (!isAppChar(r[0]) && !isAppChar(str[str.length - 1])) {
                            str += chars.boundryChar;
                        }
                        return str + r;
                    };
                    var isAppChar = function isAppChar(ch) {
                        return charsArr.indexOf(ch) !== -1;
                    };

                    function hasData(jObj) {
                        if (jObj === undefined) {
                            return chars.missingChar;
                        } else if (jObj === null) {
                            return chars.nilChar;
                        } else if (jObj.child && Object.keys(jObj.child).length === 0 && (!jObj.attrsMap || Object.keys(jObj.attrsMap).length === 0)) {
                            return chars.emptyChar;
                        } else {
                            return true;
                        }
                    }
                    var x2j = __webpack_require__( /*! ./xmlstr2xmlnode */ "./src/xmlstr2xmlnode.js");
                    var buildOptions = __webpack_require__( /*! ./util */ "./src/util.js").buildOptions;
                    var convert2nimn = function convert2nimn(node, e_schema, options) {
                        options = buildOptions(options, x2j.defaultOptions, x2j.props);
                        return _e(node, e_schema, options);
                    };
                    exports.convert2nimn = convert2nimn;

                    /***/
                }),

            /***/
            "./src/node2json.js":
            /*!**************************!*\
          !*** ./src/node2json.js ***!
          \**************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var util = __webpack_require__( /*! ./util */ "./src/util.js");
                    var convertToJson = function convertToJson(node, options) {
                        var jObj = {}; //when no child node or attr is present
                        if ((!node.child || util.isEmptyObject(node.child)) && (!node.attrsMap || util.isEmptyObject(node.attrsMap))) {
                            return util.isExist(node.val) ? node.val : '';
                        } else { //otherwise create a textnode if node has some text
                            if (util.isExist(node.val)) {
                                if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
                                    if (options.arrayMode === "strict") {
                                        jObj[options.textNodeName] = [node.val];
                                    } else {
                                        jObj[options.textNodeName] = node.val;
                                    }
                                }
                            }
                        }
                        util.merge(jObj, node.attrsMap, options.arrayMode);
                        var keys = Object.keys(node.child);
                        for (var index = 0; index < keys.length; index++) {
                            var tagname = keys[index];
                            if (node.child[tagname] && node.child[tagname].length > 1) {
                                jObj[tagname] = [];
                                for (var tag in node.child[tagname]) {
                                    jObj[tagname].push(convertToJson(node.child[tagname][tag], options));
                                }
                            } else {
                                if (options.arrayMode === true) {
                                    var result = convertToJson(node.child[tagname][0], options);
                                    if (typeof result === 'object') jObj[tagname] = [result];
                                    else jObj[tagname] = result;
                                } else if (options.arrayMode === "strict") {
                                    jObj[tagname] = [convertToJson(node.child[tagname][0], options)];
                                } else {
                                    jObj[tagname] = convertToJson(node.child[tagname][0], options);
                                }
                            }
                        } //add value
                        return jObj;
                    };
                    exports.convertToJson = convertToJson;

                    /***/
                }),

            /***/
            "./src/node2json_str.js":
            /*!******************************!*\
          !*** ./src/node2json_str.js ***!
          \******************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var util = __webpack_require__( /*! ./util */ "./src/util.js");
                    var buildOptions = __webpack_require__( /*! ./util */ "./src/util.js").buildOptions;
                    var x2j = __webpack_require__( /*! ./xmlstr2xmlnode */ "./src/xmlstr2xmlnode.js"); //TODO: do it later
                    var convertToJsonString = function convertToJsonString(node, options) {
                        options = buildOptions(options, x2j.defaultOptions, x2j.props);
                        options.indentBy = options.indentBy || '';
                        return _cToJsonStr(node, options, 0);
                    };
                    var _cToJsonStr = function _cToJsonStr(node, options, level) {
                        var jObj = '{'; //traver through all the children
                        var keys = Object.keys(node.child);
                        for (var index = 0; index < keys.length; index++) {
                            var tagname = keys[index];
                            if (node.child[tagname] && node.child[tagname].length > 1) {
                                jObj += '"' + tagname + '" : [ ';
                                for (var tag in node.child[tagname]) {
                                    jObj += _cToJsonStr(node.child[tagname][tag], options) + ' , ';
                                }
                                jObj = jObj.substr(0, jObj.length - 1) + ' ] '; //remove extra comma in last
                            } else {
                                jObj += '"' + tagname + '" : ' + _cToJsonStr(node.child[tagname][0], options) + ' ,';
                            }
                        }
                        util.merge(jObj, node.attrsMap); //add attrsMap as new children
                        if (util.isEmptyObject(jObj)) {
                            return util.isExist(node.val) ? node.val : '';
                        } else {
                            if (util.isExist(node.val)) {
                                if (!(typeof node.val === 'string' && (node.val === '' || node.val === options.cdataPositionChar))) {
                                    jObj += '"' + options.textNodeName + '" : ' + stringval(node.val);
                                }
                            }
                        } //add value
                        if (jObj[jObj.length - 1] === ',') {
                            jObj = jObj.substr(0, jObj.length - 2);
                        }
                        return jObj + '}';
                    };

                    function stringval(v) {
                        if (v === true || v === false || !isNaN(v)) {
                            return v;
                        } else {
                            return '"' + v + '"';
                        }
                    }
                    function indentate(options, level) {
                        return options.indentBy.repeat(level);
                    }
                    exports.convertToJsonString = convertToJsonString;

                    /***/
                }),

            /***/
            "./src/parser.js":
            /*!***********************!*\
          !*** ./src/parser.js ***!
          \***********************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var nodeToJson = __webpack_require__( /*! ./node2json */ "./src/node2json.js");
                    var xmlToNodeobj = __webpack_require__( /*! ./xmlstr2xmlnode */ "./src/xmlstr2xmlnode.js");
                    var x2xmlnode = __webpack_require__( /*! ./xmlstr2xmlnode */ "./src/xmlstr2xmlnode.js");
                    var buildOptions = __webpack_require__( /*! ./util */ "./src/util.js").buildOptions;
                    var validator = __webpack_require__( /*! ./validator */ "./src/validator.js");
                    exports.parse = function(xmlData, options, validationOption) {
                        if (validationOption) {
                            if (validationOption === true) validationOption = {};
                            var result = validator.validate(xmlData, validationOption);
                            if (result !== true) {
                                throw Error(result.err.msg);
                            }
                        }
                        options = buildOptions(options, x2xmlnode.defaultOptions, x2xmlnode.props);
                        return nodeToJson.convertToJson(xmlToNodeobj.getTraversalObj(xmlData, options), options);
                    };
                    exports.convertTonimn = __webpack_require__( /*! ../src/nimndata */ "./src/nimndata.js").convert2nimn;
                    exports.getTraversalObj = xmlToNodeobj.getTraversalObj;
                    exports.convertToJson = nodeToJson.convertToJson;
                    exports.convertToJsonString = __webpack_require__( /*! ./node2json_str */ "./src/node2json_str.js").convertToJsonString;
                    exports.validate = validator.validate;
                    exports.j2xParser = __webpack_require__( /*! ./json2xml */ "./src/json2xml.js");
                    exports.parseToNimn = function(xmlData, schema, options) {
                        return exports.convertTonimn(exports.getTraversalObj(xmlData, options), schema, options);
                    };

                    /***/
                }),

            /***/
            "./src/util.js":
            /*!*********************!*\
          !*** ./src/util.js ***!
          \*********************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var getAllMatches = function getAllMatches(string, regex) {
                        var matches = [];
                        var match = regex.exec(string);
                        while (match) {
                            var allmatches = [];
                            var len = match.length;
                            for (var index = 0; index < len; index++) {
                                allmatches.push(match[index]);
                            }
                            matches.push(allmatches);
                            match = regex.exec(string);
                        }
                        return matches;
                    };
                    var doesMatch = function doesMatch(string, regex) {
                        var match = regex.exec(string);
                        return !(match === null || typeof match === 'undefined');
                    };
                    var doesNotMatch = function doesNotMatch(string, regex) {
                        return !doesMatch(string, regex);
                    };
                    exports.isExist = function(v) {
                        return typeof v !== 'undefined';
                    };
                    exports.isEmptyObject = function(obj) {
                        return Object.keys(obj).length === 0;
                    };
                    /**
                     * Copy all the properties of a into b.
                     * @param {*} target
                     * @param {*} a
                     */
                    exports.merge = function(target, a, arrayMode) {
                        if (a) {
                            var keys = Object.keys(a); // will return an array of own properties
                            var len = keys.length; //don't make it inline
                            for (var i = 0; i < len; i++) {
                                if (arrayMode === 'strict') {
                                    target[keys[i]] = [a[keys[i]]];
                                } else {
                                    target[keys[i]] = a[keys[i]];
                                }
                            }
                        }
                    };
                    /* exports.merge =function (b,a){
              return Object.assign(b,a);
            } */
                    exports.getValue = function(v) {
                        if (exports.isExist(v)) {
                            return v;
                        } else {
                            return '';
                        }
                    }; // const fakeCall = function(a) {return a;};
                    // const fakeCallNoReturn = function() {};
                    exports.buildOptions = function(options, defaultOptions, props) {
                        var newOptions = {};
                        if (!options) {
                            return defaultOptions; //if there are not options
                        }
                        for (var i = 0; i < props.length; i++) {
                            if (options[props[i]] !== undefined) {
                                newOptions[props[i]] = options[props[i]];
                            } else {
                                newOptions[props[i]] = defaultOptions[props[i]];
                            }
                        }
                        return newOptions;
                    };
                    exports.doesMatch = doesMatch;
                    exports.doesNotMatch = doesNotMatch;
                    exports.getAllMatches = getAllMatches;

                    /***/
                }),

            /***/
            "./src/validator.js":
            /*!**************************!*\
          !*** ./src/validator.js ***!
          \**************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var util = __webpack_require__( /*! ./util */ "./src/util.js");
                    var defaultOptions = {
                        allowBooleanAttributes: false, //A tag can have attributes without any value
                        localeRange: 'a-zA-Z'
                    };
                    var props = ['allowBooleanAttributes', 'localeRange']; //const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
                    exports.validate = function(xmlData, options) {
                        options = util.buildOptions(options, defaultOptions, props); //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
                        //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
                        //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
                        var localRangeRegex = new RegExp("[" + options.localeRange + "]");
                        if (localRangeRegex.test("<#$'\"\\\/:0")) {
                            return getErrorObject('InvalidOptions', 'Invalid localeRange', 1);
                        }
                        var tags = [];
                        var tagFound = false; //indicates that the root tag has been closed (aka. depth 0 has been reached)
                        var reachedRoot = false;
                        if (xmlData[0] === "\uFEFF") { // check for byte order mark (BOM)
                            xmlData = xmlData.substr(1);
                        }
                        var regxAttrName = new RegExp("^[" + options.localeRange + "_][" + options.localeRange + "0-9\\-\\.:]*$");
                        var regxTagName = new RegExp("^([" + options.localeRange + "_])[" + options.localeRange + "0-9\\.\\-_:]*$");
                        for (var i = 0; i < xmlData.length; i++) {
                            if (xmlData[i] === '<') { //starting of tag
                                //read until you reach to '>' avoiding any '>' in attribute value
                                i++;
                                if (xmlData[i] === '?') {
                                    i = readPI(xmlData, ++i);
                                    if (i.err) {
                                        return i;
                                    }
                                } else if (xmlData[i] === '!') {
                                    i = readCommentAndCDATA(xmlData, i);
                                    continue;
                                } else {
                                    var closingTag = false;
                                    if (xmlData[i] === '/') { //closing tag
                                        closingTag = true;
                                        i++;
                                    } //read tagname
                                    var tagName = '';
                                    for (; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++) {
                                        tagName += xmlData[i];
                                    }
                                    tagName = tagName.trim(); //console.log(tagName);
                                    if (tagName[tagName.length - 1] === '/') { //self closing tag without attributes
                                        tagName = tagName.substring(0, tagName.length - 1); //continue;
                                        i--;
                                    }
                                    if (!validateTagName(tagName, regxTagName)) {
                                        var msg = void 0;
                                        if (tagName.trim().length === 0) {
                                            msg = "There is an unnecessary space between tag name and backward slash '</ ..'.";
                                        } else {
                                            msg = "Tag '" + tagName + "' is an invalid name.";
                                        }
                                        return getErrorObject('InvalidTag', msg, getLineNumberForPosition(xmlData, i));
                                    }
                                    var result = readAttributeStr(xmlData, i);
                                    if (result === false) {
                                        return getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", getLineNumberForPosition(xmlData, i));
                                    }
                                    var attrStr = result.value;
                                    i = result.index;
                                    if (attrStr[attrStr.length - 1] === '/') { //self closing tag
                                        attrStr = attrStr.substring(0, attrStr.length - 1);
                                        var isValid = validateAttributeString(attrStr, options, regxAttrName);
                                        if (isValid === true) {
                                            tagFound = true; //continue; //text may presents after self closing tag
                                        } else { //the result from the nested function returns the position of the error within the attribute
                                            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                                            //this gives us the absolute index in the entire xml, which we can use to find the line at last
                                            return getErrorObject(isValid.err.code, isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                                        }
                                    } else if (closingTag) {
                                        if (!result.tagClosed) {
                                            return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", getLineNumberForPosition(xmlData, i));
                                        } else if (attrStr.trim().length > 0) {
                                            return getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, i));
                                        } else {
                                            var otg = tags.pop();
                                            if (tagName !== otg) {
                                                return getErrorObject('InvalidTag', "Closing tag '" + otg + "' is expected inplace of '" + tagName + "'.", getLineNumberForPosition(xmlData, i));
                                            } //when there are no more tags, we reached the root level.
                                            if (tags.length == 0) {
                                                reachedRoot = true;
                                            }
                                        }
                                    } else {
                                        var _isValid = validateAttributeString(attrStr, options, regxAttrName);
                                        if (_isValid !== true) { //the result from the nested function returns the position of the error within the attribute
                                            //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                                            //this gives us the absolute index in the entire xml, which we can use to find the line at last
                                            return getErrorObject(_isValid.err.code, _isValid.err.msg, getLineNumberForPosition(xmlData, i - attrStr.length + _isValid.err.line));
                                        } //if the root level has been reached before ...
                                        if (reachedRoot === true) {
                                            return getErrorObject('InvalidXml', 'Multiple possible root nodes found.', getLineNumberForPosition(xmlData, i));
                                        } else {
                                            tags.push(tagName);
                                        }
                                        tagFound = true;
                                    } //skip tag text value
                                    //It may include comments and CDATA value
                                    for (i++; i < xmlData.length; i++) {
                                        if (xmlData[i] === '<') {
                                            if (xmlData[i + 1] === '!') { //comment or CADATA
                                                i++;
                                                i = readCommentAndCDATA(xmlData, i);
                                                continue;
                                            } else {
                                                break;
                                            }
                                        }
                                    } //end of reading tag text value
                                    if (xmlData[i] === '<') {
                                        i--;
                                    }
                                }
                            } else {
                                if (xmlData[i] === ' ' || xmlData[i] === '\t' || xmlData[i] === '\n' || xmlData[i] === '\r') {
                                    continue;
                                }
                                return getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", getLineNumberForPosition(xmlData, i));
                            }
                        }
                        if (!tagFound) {
                            return getErrorObject('InvalidXml', 'Start tag expected.', 1);
                        } else if (tags.length > 0) {
                            return getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags, null, 4).replace(/\r?\n/g, '') + "' found.", 1);
                        }
                        return true;
                    };
                    /**
                     * Read Processing insstructions and skip
                     * @param {*} xmlData
                     * @param {*} i
                     */
                    function readPI(xmlData, i) {
                        var start = i;
                        for (; i < xmlData.length; i++) {
                            if (xmlData[i] == '?' || xmlData[i] == ' ') { //tagname
                                var tagname = xmlData.substr(start, i - start);
                                if (i > 5 && tagname === 'xml') {
                                    return getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', getLineNumberForPosition(xmlData, i));
                                } else if (xmlData[i] == '?' && xmlData[i + 1] == '>') { //check if valid attribut string
                                    i++;
                                    break;
                                } else {
                                    continue;
                                }
                            }
                        }
                        return i;
                    }
                    function readCommentAndCDATA(xmlData, i) {
                        if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') { //comment
                            for (i += 3; i < xmlData.length; i++) {
                                if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
                                    i += 2;
                                    break;
                                }
                            }
                        } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
                            var angleBracketsCount = 1;
                            for (i += 8; i < xmlData.length; i++) {
                                if (xmlData[i] === '<') {
                                    angleBracketsCount++;
                                } else if (xmlData[i] === '>') {
                                    angleBracketsCount--;
                                    if (angleBracketsCount === 0) {
                                        break;
                                    }
                                }
                            }
                        } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
                            for (i += 8; i < xmlData.length; i++) {
                                if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
                                    i += 2;
                                    break;
                                }
                            }
                        }
                        return i;
                    }
                    var doubleQuote = '"';
                    var singleQuote = "'";
                    /**
                     * Keep reading xmlData until '<' is found outside the attribute value.
                     * @param {string} xmlData
                     * @param {number} i
                     */
                    function readAttributeStr(xmlData, i) {
                        var attrStr = '';
                        var startChar = '';
                        var tagClosed = false;
                        for (; i < xmlData.length; i++) {
                            if (xmlData[i] === doubleQuote || xmlData[i] === singleQuote) {
                                if (startChar === '') {
                                    startChar = xmlData[i];
                                } else if (startChar !== xmlData[i]) { //if vaue is enclosed with double quote then single quotes are allowed inside the value and vice versa
                                    continue;
                                } else {
                                    startChar = '';
                                }
                            } else if (xmlData[i] === '>') {
                                if (startChar === '') {
                                    tagClosed = true;
                                    break;
                                }
                            }
                            attrStr += xmlData[i];
                        }
                        if (startChar !== '') {
                            return false;
                        }
                        return {
                            value: attrStr,
                            index: i,
                            tagClosed: tagClosed
                        };
                    }
                    /**
                     * Select all the attributes whether valid or invalid.
                     */
                    var validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g'); //attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
                    function validateAttributeString(attrStr, options, regxAttrName) { //console.log("start:"+attrStr+":end");
                        //if(attrStr.trim().length === 0) return true; //empty string
                        var matches = util.getAllMatches(attrStr, validAttrStrRegxp);
                        var attrNames = {};
                        for (var i = 0; i < matches.length; i++) {
                            if (matches[i][1].length === 0) { //nospace before attribute name: a="sd"b="saf"
                                return getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", getPositionFromMatch(attrStr, matches[i][0]));
                            } else if (matches[i][3] === undefined && !options.allowBooleanAttributes) { //independent attribute: ab
                                return getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", getPositionFromMatch(attrStr, matches[i][0]));
                            }
                            /* else if(matches[i][6] === undefined){//attribute without value: ab=
                                return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                            } */
                            var attrName = matches[i][2];
                            if (!validateAttrName(attrName, regxAttrName)) {
                                return getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", getPositionFromMatch(attrStr, matches[i][0]));
                            }
                            if (!attrNames.hasOwnProperty(attrName)) { //check for duplicate attribute.
                                attrNames[attrName] = 1;
                            } else {
                                return getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", getPositionFromMatch(attrStr, matches[i][0]));
                            }
                        }
                        return true;
                    }
                    function getErrorObject(code, message, lineNumber) {
                        return {
                            err: {
                                code: code,
                                msg: message,
                                line: lineNumber
                            }
                        };
                    }
                    function validateAttrName(attrName, regxAttrName) { // const validAttrRegxp = new RegExp(regxAttrName);
                        return util.doesMatch(attrName, regxAttrName);
                    } //const startsWithXML = new RegExp("^[Xx][Mm][Ll]");
                    //  startsWith = /^([a-zA-Z]|_)[\w.\-_:]*/;
                    function validateTagName(tagname, regxTagName) {
                        /*if(util.doesMatch(tagname,startsWithXML)) return false;
                else*/
                        //return !tagname.toLowerCase().startsWith("xml") || !util.doesNotMatch(tagname, regxTagName);
                        return !util.doesNotMatch(tagname, regxTagName);
                    } //this function returns the line number for the character at the given index
                    function getLineNumberForPosition(xmlData, index) {
                        var lines = xmlData.substring(0, index).split(/\r?\n/);
                        return lines.length;
                    } //this function returns the position of the last character of match within attrStr
                    function getPositionFromMatch(attrStr, match) {
                        return attrStr.indexOf(match) + match.length;
                    }

                    /***/
                }),

            /***/
            "./src/xmlNode.js":
            /*!************************!*\
          !*** ./src/xmlNode.js ***!
          \************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    module.exports = function(tagname, parent, val) {
                        this.tagname = tagname;
                        this.parent = parent;
                        this.child = {}; //child tags
                        this.attrsMap = {}; //attributes map
                        this.val = val; //text only
                        this.addChild = function(child) {
                            if (Array.isArray(this.child[child.tagname])) { //already presents
                                this.child[child.tagname].push(child);
                            } else {
                                this.child[child.tagname] = [child];
                            }
                        };
                    };

                    /***/
                }),

            /***/
            "./src/xmlstr2xmlnode.js":
            /*!*******************************!*\
          !*** ./src/xmlstr2xmlnode.js ***!
          \*******************************/
            /*! no static exports found */
            /***/
                (function(module, exports, __webpack_require__) {

                    "use strict";
                    var util = __webpack_require__( /*! ./util */ "./src/util.js");
                    var buildOptions = __webpack_require__( /*! ./util */ "./src/util.js").buildOptions;
                    var xmlNode = __webpack_require__( /*! ./xmlNode */ "./src/xmlNode.js");
                    var TagType = {
                        OPENING: 1,
                        CLOSING: 2,
                        SELF: 3,
                        CDATA: 4
                    };
                    var regx = '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|(([\\w:\\-._]*:)?([\\w:\\-._]+))([^>]*)>|((\\/)(([\\w:\\-._]*:)?([\\w:\\-._]+))\\s*>))([^<]*)'; //const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
                    //const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
                    //polyfill
                    if (!Number.parseInt && window.parseInt) {
                        Number.parseInt = window.parseInt;
                    }
                    if (!Number.parseFloat && window.parseFloat) {
                        Number.parseFloat = window.parseFloat;
                    }
                    var defaultOptions = {
                        attributeNamePrefix: '@_',
                        attrNodeName: false,
                        textNodeName: '#text',
                        ignoreAttributes: true,
                        ignoreNameSpace: false,
                        allowBooleanAttributes: false, //a tag can have attributes without any value
                        //ignoreRootElement : false,
                        parseNodeValue: true,
                        parseAttributeValue: false,
                        arrayMode: false,
                        trimValues: true, //Trim string values of tag and attributes
                        cdataTagName: false,
                        cdataPositionChar: '\\c',
                        localeRange: '',
                        tagValueProcessor: function tagValueProcessor(a, tagName) {
                            return a;
                        },
                        attrValueProcessor: function attrValueProcessor(a, attrName) {
                            return a;
                        },
                        stopNodes: [] //decodeStrict: false,
                    };
                    exports.defaultOptions = defaultOptions;
                    var props = ['attributeNamePrefix', 'attrNodeName', 'textNodeName', 'ignoreAttributes', 'ignoreNameSpace', 'allowBooleanAttributes', 'parseNodeValue', 'parseAttributeValue', 'arrayMode', 'trimValues', 'cdataTagName', 'cdataPositionChar', 'localeRange', 'tagValueProcessor', 'attrValueProcessor', 'parseTrueNumberOnly', 'stopNodes'];
                    exports.props = props;
                    var getTraversalObj = function getTraversalObj(xmlData, options) {
                        options = buildOptions(options, defaultOptions, props); //xmlData = xmlData.replace(/\r?\n/g, " ");//make it single line
                        xmlData = xmlData.replace(/<!--[\s\S]*?-->/g, ''); //Remove  comments
                        var xmlObj = new xmlNode('!xml');
                        var currentNode = xmlObj;
                        regx = regx.replace(/\[\\w/g, '[' + options.localeRange + '\\w');
                        var tagsRegx = new RegExp(regx, 'g');
                        var tag = tagsRegx.exec(xmlData);
                        var nextTag = tagsRegx.exec(xmlData);
                        while (tag) {
                            var tagType = checkForTagType(tag);
                            if (tagType === TagType.CLOSING) { //add parsed data to parent node
                                if (currentNode.parent && tag[14]) {
                                    currentNode.parent.val = util.getValue(currentNode.parent.val) + '' + processTagValue(tag, options, currentNode.parent.tagname);
                                }
                                if (options.stopNodes.length && options.stopNodes.includes(currentNode.tagname)) {
                                    currentNode.child = [];
                                    if (currentNode.attrsMap == undefined) {
                                        currentNode.attrsMap = {};
                                    }
                                    currentNode.val = xmlData.substr(currentNode.startIndex + 1, tag.index - currentNode.startIndex - 1);
                                }
                                currentNode = currentNode.parent;
                            } else if (tagType === TagType.CDATA) {
                                if (options.cdataTagName) { //add cdata node
                                    var childNode = new xmlNode(options.cdataTagName, currentNode, tag[3]);
                                    childNode.attrsMap = buildAttributesMap(tag[8], options);
                                    currentNode.addChild(childNode); //for backtracking
                                    currentNode.val = util.getValue(currentNode.val) + options.cdataPositionChar; //add rest value to parent node
                                    if (tag[14]) {
                                        currentNode.val += processTagValue(tag, options);
                                    }
                                } else {
                                    currentNode.val = (currentNode.val || '') + (tag[3] || '') + processTagValue(tag, options);
                                }
                            } else if (tagType === TagType.SELF) {
                                if (currentNode && tag[14]) {
                                    currentNode.val = util.getValue(currentNode.val) + '' + processTagValue(tag, options);
                                }
                                var _childNode = new xmlNode(options.ignoreNameSpace ? tag[7] : tag[5], currentNode, '');
                                if (tag[8] && tag[8].length > 0) {
                                    tag[8] = tag[8].substr(0, tag[8].length - 1);
                                }
                                _childNode.attrsMap = buildAttributesMap(tag[8], options);
                                currentNode.addChild(_childNode);
                            } else { //TagType.OPENING
                                var _childNode2 = new xmlNode(options.ignoreNameSpace ? tag[7] : tag[5], currentNode, processTagValue(tag, options));
                                if (options.stopNodes.length && options.stopNodes.includes(_childNode2.tagname)) {
                                    _childNode2.startIndex = tag.index + tag[1].length;
                                }
                                _childNode2.attrsMap = buildAttributesMap(tag[8], options);
                                currentNode.addChild(_childNode2);
                                currentNode = _childNode2;
                            }
                            tag = nextTag;
                            nextTag = tagsRegx.exec(xmlData);
                        }
                        return xmlObj;
                    };

                    function processTagValue(parsedTags, options, parentTagName) {
                        var tagName = parsedTags[7] || parentTagName;
                        var val = parsedTags[14];
                        if (val) {
                            if (options.trimValues) {
                                val = val.trim();
                            }
                            val = options.tagValueProcessor(val, tagName);
                            val = parseValue(val, options.parseNodeValue, options.parseTrueNumberOnly);
                        }
                        return val;
                    }
                    function checkForTagType(match) {
                        if (match[4] === ']]>') {
                            return TagType.CDATA;
                        } else if (match[10] === '/') {
                            return TagType.CLOSING;
                        } else if (typeof match[8] !== 'undefined' && match[8].substr(match[8].length - 1) === '/') {
                            return TagType.SELF;
                        } else {
                            return TagType.OPENING;
                        }
                    }
                    function resolveNameSpace(tagname, options) {
                        if (options.ignoreNameSpace) {
                            var tags = tagname.split(':');
                            var prefix = tagname.charAt(0) === '/' ? '/' : '';
                            if (tags[0] === 'xmlns') {
                                return '';
                            }
                            if (tags.length === 2) {
                                tagname = prefix + tags[1];
                            }
                        }
                        return tagname;
                    }
                    function parseValue(val, shouldParse, parseTrueNumberOnly) {
                        if (shouldParse && typeof val === 'string') {
                            var parsed;
                            if (val.trim() === '' || isNaN(val)) {
                                parsed = val === 'true' ? true : val === 'false' ? false : val;
                            } else {
                                if (val.indexOf('0x') !== -1) { //support hexa decimal
                                    parsed = Number.parseInt(val, 16);
                                } else if (val.indexOf('.') !== -1) {
                                    parsed = Number.parseFloat(val);
                                    val = val.replace(/0+$/, "");
                                } else {
                                    parsed = Number.parseInt(val, 10);
                                }
                                if (parseTrueNumberOnly) {
                                    parsed = String(parsed) === val ? parsed : val;
                                }
                            }
                            return parsed;
                        } else {
                            if (util.isExist(val)) {
                                return val;
                            } else {
                                return '';
                            }
                        }
                    } //TODO: change regex to capture NS
                    //const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
                    var attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])(.*?)\\3)?', 'g');

                    function buildAttributesMap(attrStr, options) {
                        if (!options.ignoreAttributes && typeof attrStr === 'string') {
                            attrStr = attrStr.replace(/\r?\n/g, ' '); //attrStr = attrStr || attrStr.trim();
                            var matches = util.getAllMatches(attrStr, attrsRegx);
                            var len = matches.length; //don't make it inline
                            var attrs = {};
                            for (var i = 0; i < len; i++) {
                                var attrName = resolveNameSpace(matches[i][1], options);
                                if (attrName.length) {
                                    if (matches[i][4] !== undefined) {
                                        if (options.trimValues) {
                                            matches[i][4] = matches[i][4].trim();
                                        }
                                        matches[i][4] = options.attrValueProcessor(matches[i][4], attrName);
                                        attrs[options.attributeNamePrefix + attrName] = parseValue(matches[i][4], options.parseAttributeValue, options.parseTrueNumberOnly);
                                    } else if (options.allowBooleanAttributes) {
                                        attrs[options.attributeNamePrefix + attrName] = true;
                                    }
                                }
                            }
                            if (!Object.keys(attrs).length) {
                                return;
                            }
                            if (options.attrNodeName) {
                                var attrCollection = {};
                                attrCollection[options.attrNodeName] = attrs;
                                return attrCollection;
                            }
                            return attrs;
                        }
                    }
                    exports.getTraversalObj = getTraversalObj;

                    /***/
                })

            /******/
        });


(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ISO6391"] = factory();
	else
		root["ISO6391"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/values.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "./node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.keys.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es7.object.values.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.values;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");
var toIObject = __webpack_require__("./node_modules/core-js/library/modules/_to-iobject.js");
var isEnum = __webpack_require__("./node_modules/core-js/library/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var $keys = __webpack_require__("./node_modules/core-js/library/modules/_object-keys.js");

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var $values = __webpack_require__("./node_modules/core-js/library/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "./src/data.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LANGUAGES_LIST = {
  aa: {
    name: 'Afar',
    nativeName: 'Afaraf'
  },
  ab: {
    name: 'Abkhaz',
    nativeName: 'аҧсуа бызшәа'
  },
  ae: {
    name: 'Avestan',
    nativeName: 'avesta'
  },
  af: {
    name: 'Afrikaans',
    nativeName: 'Afrikaans'
  },
  ak: {
    name: 'Akan',
    nativeName: 'Akan'
  },
  am: {
    name: 'Amharic',
    nativeName: 'አማርኛ'
  },
  an: {
    name: 'Aragonese',
    nativeName: 'aragonés'
  },
  ar: {
    name: 'Arabic',
    nativeName: 'اللغة العربية'
  },
  as: {
    name: 'Assamese',
    nativeName: 'অসমীয়া'
  },
  av: {
    name: 'Avaric',
    nativeName: 'авар мацӀ'
  },
  ay: {
    name: 'Aymara',
    nativeName: 'aymar aru'
  },
  az: {
    name: 'Azerbaijani',
    nativeName: 'azərbaycan dili'
  },
  ba: {
    name: 'Bashkir',
    nativeName: 'башҡорт теле'
  },
  be: {
    name: 'Belarusian',
    nativeName: 'беларуская мова'
  },
  bg: {
    name: 'Bulgarian',
    nativeName: 'български език'
  },
  bh: {
    name: 'Bihari',
    nativeName: 'भोजपुरी'
  },
  bi: {
    name: 'Bislama',
    nativeName: 'Bislama'
  },
  bm: {
    name: 'Bambara',
    nativeName: 'bamanankan'
  },
  bn: {
    name: 'Bengali',
    nativeName: 'বাংলা'
  },
  bo: {
    name: 'Tibetan Standard',
    nativeName: 'བོད་ཡིག'
  },
  br: {
    name: 'Breton',
    nativeName: 'brezhoneg'
  },
  bs: {
    name: 'Bosnian',
    nativeName: 'bosanski jezik'
  },
  ca: {
    name: 'Catalan',
    nativeName: 'Català'
  },
  ce: {
    name: 'Chechen',
    nativeName: 'нохчийн мотт'
  },
  ch: {
    name: 'Chamorro',
    nativeName: 'Chamoru'
  },
  co: {
    name: 'Corsican',
    nativeName: 'corsu'
  },
  cr: {
    name: 'Cree',
    nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ'
  },
  cs: {
    name: 'Czech',
    nativeName: 'čeština'
  },
  cu: {
    name: 'Old Church Slavonic',
    nativeName: 'ѩзыкъ словѣньскъ'
  },
  cv: {
    name: 'Chuvash',
    nativeName: 'чӑваш чӗлхи'
  },
  cy: {
    name: 'Welsh',
    nativeName: 'Cymraeg'
  },
  da: {
    name: 'Danish',
    nativeName: 'dansk'
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch'
  },
  dv: {
    name: 'Divehi',
    nativeName: 'Dhivehi'
  },
  dz: {
    name: 'Dzongkha',
    nativeName: 'རྫོང་ཁ'
  },
  ee: {
    name: 'Ewe',
    nativeName: 'Eʋegbe'
  },
  el: {
    name: 'Greek',
    nativeName: 'Ελληνικά'
  },
  en: {
    name: 'English',
    nativeName: 'English'
  },
  eo: {
    name: 'Esperanto',
    nativeName: 'Esperanto'
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español'
  },
  et: {
    name: 'Estonian',
    nativeName: 'eesti'
  },
  eu: {
    name: 'Basque',
    nativeName: 'euskara'
  },
  fa: {
    name: 'Persian',
    nativeName: 'فارسی'
  },
  ff: {
    name: 'Fula',
    nativeName: 'Fulfulde'
  },
  fi: {
    name: 'Finnish',
    nativeName: 'suomi'
  },
  fj: {
    name: 'Fijian',
    nativeName: 'Vakaviti'
  },
  fo: {
    name: 'Faroese',
    nativeName: 'føroyskt'
  },
  fr: {
    name: 'French',
    nativeName: 'Français'
  },
  fy: {
    name: 'Western Frisian',
    nativeName: 'Frysk'
  },
  ga: {
    name: 'Irish',
    nativeName: 'Gaeilge'
  },
  gd: {
    name: 'Scottish Gaelic',
    nativeName: 'Gàidhlig'
  },
  gl: {
    name: 'Galician',
    nativeName: 'galego'
  },
  gn: {
    name: 'Guaraní',
    nativeName: "Avañe'ẽ"
  },
  gu: {
    name: 'Gujarati',
    nativeName: 'ગુજરાતી'
  },
  gv: {
    name: 'Manx',
    nativeName: 'Gaelg'
  },
  ha: {
    name: 'Hausa',
    nativeName: 'هَوُسَ'
  },
  he: {
    name: 'Hebrew',
    nativeName: 'עברית'
  },
  hi: {
    name: 'Hindi',
    nativeName: 'हिन्दी'
  },
  ho: {
    name: 'Hiri Motu',
    nativeName: 'Hiri Motu'
  },
  hr: {
    name: 'Croatian',
    nativeName: 'hrvatski jezik'
  },
  ht: {
    name: 'Haitian',
    nativeName: 'Kreyòl ayisyen'
  },
  hu: {
    name: 'Hungarian',
    nativeName: 'magyar'
  },
  hy: {
    name: 'Armenian',
    nativeName: 'Հայերեն'
  },
  hz: {
    name: 'Herero',
    nativeName: 'Otjiherero'
  },
  ia: {
    name: 'Interlingua',
    nativeName: 'Interlingua'
  },
  id: {
    name: 'Indonesian',
    nativeName: 'Bahasa Indonesia'
  },
  ie: {
    name: 'Interlingue',
    nativeName: 'Interlingue'
  },
  ig: {
    name: 'Igbo',
    nativeName: 'Asụsụ Igbo'
  },
  ii: {
    name: 'Nuosu',
    nativeName: 'ꆈꌠ꒿ Nuosuhxop'
  },
  ik: {
    name: 'Inupiaq',
    nativeName: 'Iñupiaq'
  },
  io: {
    name: 'Ido',
    nativeName: 'Ido'
  },
  is: {
    name: 'Icelandic',
    nativeName: 'Íslenska'
  },
  it: {
    name: 'Italian',
    nativeName: 'Italiano'
  },
  iu: {
    name: 'Inuktitut',
    nativeName: 'ᐃᓄᒃᑎᑐᑦ'
  },
  ja: {
    name: 'Japanese',
    nativeName: '日本語'
  },
  jv: {
    name: 'Javanese',
    nativeName: 'basa Jawa'
  },
  ka: {
    name: 'Georgian',
    nativeName: 'ქართული'
  },
  kg: {
    name: 'Kongo',
    nativeName: 'Kikongo'
  },
  ki: {
    name: 'Kikuyu',
    nativeName: 'Gĩkũyũ'
  },
  kj: {
    name: 'Kwanyama',
    nativeName: 'Kuanyama'
  },
  kk: {
    name: 'Kazakh',
    nativeName: 'қазақ тілі'
  },
  kl: {
    name: 'Kalaallisut',
    nativeName: 'kalaallisut'
  },
  km: {
    name: 'Khmer',
    nativeName: 'ខេមរភាសា'
  },
  kn: {
    name: 'Kannada',
    nativeName: 'ಕನ್ನಡ'
  },
  ko: {
    name: 'Korean',
    nativeName: '한국어'
  },
  kr: {
    name: 'Kanuri',
    nativeName: 'Kanuri'
  },
  ks: {
    name: 'Kashmiri',
    nativeName: 'कश्मीरी'
  },
  ku: {
    name: 'Kurdish',
    nativeName: 'Kurdî'
  },
  kv: {
    name: 'Komi',
    nativeName: 'коми кыв'
  },
  kw: {
    name: 'Cornish',
    nativeName: 'Kernewek'
  },
  ky: {
    name: 'Kyrgyz',
    nativeName: 'Кыргызча'
  },
  la: {
    name: 'Latin',
    nativeName: 'latine'
  },
  lb: {
    name: 'Luxembourgish',
    nativeName: 'Lëtzebuergesch'
  },
  lg: {
    name: 'Ganda',
    nativeName: 'Luganda'
  },
  li: {
    name: 'Limburgish',
    nativeName: 'Limburgs'
  },
  ln: {
    name: 'Lingala',
    nativeName: 'Lingála'
  },
  lo: {
    name: 'Lao',
    nativeName: 'ພາສາ'
  },
  lt: {
    name: 'Lithuanian',
    nativeName: 'lietuvių kalba'
  },
  lu: {
    name: 'Luba-Katanga',
    nativeName: 'Tshiluba'
  },
  lv: {
    name: 'Latvian',
    nativeName: 'latviešu valoda'
  },
  mg: {
    name: 'Malagasy',
    nativeName: 'fiteny malagasy'
  },
  mh: {
    name: 'Marshallese',
    nativeName: 'Kajin M̧ajeļ'
  },
  mi: {
    name: 'Māori',
    nativeName: 'te reo Māori'
  },
  mk: {
    name: 'Macedonian',
    nativeName: 'македонски јазик'
  },
  ml: {
    name: 'Malayalam',
    nativeName: 'മലയാളം'
  },
  mn: {
    name: 'Mongolian',
    nativeName: 'Монгол хэл'
  },
  mr: {
    name: 'Marathi',
    nativeName: 'मराठी'
  },
  ms: {
    name: 'Malay',
    nativeName: 'Bahasa Malaysia'
  },
  mt: {
    name: 'Maltese',
    nativeName: 'Malti'
  },
  my: {
    name: 'Burmese',
    nativeName: 'ဗမာစာ'
  },
  na: {
    name: 'Nauru',
    nativeName: 'Ekakairũ Naoero'
  },
  nb: {
    name: 'Norwegian Bokmål',
    nativeName: 'Norsk bokmål'
  },
  nd: {
    name: 'Northern Ndebele',
    nativeName: 'isiNdebele'
  },
  ne: {
    name: 'Nepali',
    nativeName: 'नेपाली'
  },
  ng: {
    name: 'Ndonga',
    nativeName: 'Owambo'
  },
  nl: {
    name: 'Dutch',
    nativeName: 'Nederlands'
  },
  nn: {
    name: 'Norwegian Nynorsk',
    nativeName: 'Norsk nynorsk'
  },
  no: {
    name: 'Norwegian',
    nativeName: 'Norsk'
  },
  nr: {
    name: 'Southern Ndebele',
    nativeName: 'isiNdebele'
  },
  nv: {
    name: 'Navajo',
    nativeName: 'Diné bizaad'
  },
  ny: {
    name: 'Chichewa',
    nativeName: 'chiCheŵa'
  },
  oc: {
    name: 'Occitan',
    nativeName: 'occitan'
  },
  oj: {
    name: 'Ojibwe',
    nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ'
  },
  om: {
    name: 'Oromo',
    nativeName: 'Afaan Oromoo'
  },
  or: {
    name: 'Oriya',
    nativeName: 'ଓଡ଼ିଆ'
  },
  os: {
    name: 'Ossetian',
    nativeName: 'ирон æвзаг'
  },
  pa: {
    name: 'Panjabi',
    nativeName: 'ਪੰਜਾਬੀ'
  },
  pi: {
    name: 'Pāli',
    nativeName: 'पाऴि'
  },
  pl: {
    name: 'Polish',
    nativeName: 'język polski'
  },
  ps: {
    name: 'Pashto',
    nativeName: 'پښتو'
  },
  pt: {
    name: 'Portuguese',
    nativeName: 'Português'
  },
  qu: {
    name: 'Quechua',
    nativeName: 'Runa Simi'
  },
  rm: {
    name: 'Romansh',
    nativeName: 'rumantsch grischun'
  },
  rn: {
    name: 'Kirundi',
    nativeName: 'Ikirundi'
  },
  ro: {
    name: 'Romanian',
    nativeName: 'Română'
  },
  ru: {
    name: 'Russian',
    nativeName: 'Русский'
  },
  rw: {
    name: 'Kinyarwanda',
    nativeName: 'Ikinyarwanda'
  },
  sa: {
    name: 'Sanskrit',
    nativeName: 'संस्कृतम्'
  },
  sc: {
    name: 'Sardinian',
    nativeName: 'sardu'
  },
  sd: {
    name: 'Sindhi',
    nativeName: 'सिन्धी'
  },
  se: {
    name: 'Northern Sami',
    nativeName: 'Davvisámegiella'
  },
  sg: {
    name: 'Sango',
    nativeName: 'yângâ tî sängö'
  },
  si: {
    name: 'Sinhala',
    nativeName: 'සිංහල'
  },
  sk: {
    name: 'Slovak',
    nativeName: 'slovenčina'
  },
  sl: {
    name: 'Slovene',
    nativeName: 'slovenski jezik'
  },
  sm: {
    name: 'Samoan',
    nativeName: "gagana fa'a Samoa"
  },
  sn: {
    name: 'Shona',
    nativeName: 'chiShona'
  },
  so: {
    name: 'Somali',
    nativeName: 'Soomaaliga'
  },
  sq: {
    name: 'Albanian',
    nativeName: 'Shqip'
  },
  sr: {
    name: 'Serbian',
    nativeName: 'српски језик'
  },
  ss: {
    name: 'Swati',
    nativeName: 'SiSwati'
  },
  st: {
    name: 'Southern Sotho',
    nativeName: 'Sesotho'
  },
  su: {
    name: 'Sundanese',
    nativeName: 'Basa Sunda'
  },
  sv: {
    name: 'Swedish',
    nativeName: 'svenska'
  },
  sw: {
    name: 'Swahili',
    nativeName: 'Kiswahili'
  },
  ta: {
    name: 'Tamil',
    nativeName: 'தமிழ்'
  },
  te: {
    name: 'Telugu',
    nativeName: 'తెలుగు'
  },
  tg: {
    name: 'Tajik',
    nativeName: 'тоҷикӣ'
  },
  th: {
    name: 'Thai',
    nativeName: 'ไทย'
  },
  ti: {
    name: 'Tigrinya',
    nativeName: 'ትግርኛ'
  },
  tk: {
    name: 'Turkmen',
    nativeName: 'Türkmen'
  },
  tl: {
    name: 'Tagalog',
    nativeName: 'Wikang Tagalog'
  },
  tn: {
    name: 'Tswana',
    nativeName: 'Setswana'
  },
  to: {
    name: 'Tonga',
    nativeName: 'faka Tonga'
  },
  tr: {
    name: 'Turkish',
    nativeName: 'Türkçe'
  },
  ts: {
    name: 'Tsonga',
    nativeName: 'Xitsonga'
  },
  tt: {
    name: 'Tatar',
    nativeName: 'татар теле'
  },
  tw: {
    name: 'Twi',
    nativeName: 'Twi'
  },
  ty: {
    name: 'Tahitian',
    nativeName: 'Reo Tahiti'
  },
  ug: {
    name: 'Uyghur',
    nativeName: 'ئۇيغۇرچە‎'
  },
  uk: {
    name: 'Ukrainian',
    nativeName: 'Українська'
  },
  ur: {
    name: 'Urdu',
    nativeName: 'اردو'
  },
  uz: {
    name: 'Uzbek',
    nativeName: 'Ўзбек'
  },
  ve: {
    name: 'Venda',
    nativeName: 'Tshivenḓa'
  },
  vi: {
    name: 'Vietnamese',
    nativeName: 'Tiếng Việt'
  },
  vo: {
    name: 'Volapük',
    nativeName: 'Volapük'
  },
  wa: {
    name: 'Walloon',
    nativeName: 'walon'
  },
  wo: {
    name: 'Wolof',
    nativeName: 'Wollof'
  },
  xh: {
    name: 'Xhosa',
    nativeName: 'isiXhosa'
  },
  yi: {
    name: 'Yiddish',
    nativeName: 'ייִדיש'
  },
  yo: {
    name: 'Yoruba',
    nativeName: 'Yorùbá'
  },
  za: {
    name: 'Zhuang',
    nativeName: 'Saɯ cueŋƅ'
  },
  zh: {
    name: 'Chinese',
    nativeName: '中文'
  },
  zu: {
    name: 'Zulu',
    nativeName: 'isiZulu'
  }
};

exports.default = LANGUAGES_LIST;
module.exports = exports['default'];

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("./node_modules/babel-runtime/core-js/object/keys.js");

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__("./node_modules/babel-runtime/core-js/object/values.js");

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _data = __webpack_require__("./src/data.js");

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ISO6391 = function () {
  function ISO6391() {
    (0, _classCallCheck3.default)(this, ISO6391);
  }

  (0, _createClass3.default)(ISO6391, null, [{
    key: 'getLanguages',
    value: function getLanguages() {
      var codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return codes.map(function (code) {
        return {
          code: code,
          name: ISO6391.getName(code),
          nativeName: ISO6391.getNativeName(code)
        };
      });
    }
  }, {
    key: 'getName',
    value: function getName(code) {
      return ISO6391.validate(code) ? _data2.default[code].name : '';
    }
  }, {
    key: 'getAllNames',
    value: function getAllNames() {
      return (0, _values2.default)(_data2.default).map(function (l) {
        return l.name;
      });
    }
  }, {
    key: 'getNativeName',
    value: function getNativeName(code) {
      return ISO6391.validate(code) ? _data2.default[code].nativeName : '';
    }
  }, {
    key: 'getAllNativeNames',
    value: function getAllNativeNames() {
      return (0, _values2.default)(_data2.default).map(function (l) {
        return l.nativeName;
      });
    }
  }, {
    key: 'getCode',
    value: function getCode(name) {
      var code = (0, _keys2.default)(_data2.default).find(function (code) {
        var language = _data2.default[code];

        return language.name.toLowerCase() === name.toLowerCase() || language.nativeName.toLowerCase() === name.toLowerCase();
      });
      return code || '';
    }
  }, {
    key: 'getAllCodes',
    value: function getAllCodes() {
      return (0, _keys2.default)(_data2.default);
    }
  }, {
    key: 'validate',
    value: function validate(code) {
      return _data2.default.hasOwnProperty(code);
    }
  }]);
  return ISO6391;
}();

exports.default = ISO6391;
module.exports = exports['default'];

/***/ })

/******/ });
});

var utils = (function (exports) {
    'use strict';

    var parseXmlToJson=function parseXmlToJson(xmldata,option){var helpers=window.monet.helpers;var result={};try{result=window.parser.parse(xmldata,option);}catch(error){helpers.debug.error('parse xml to json',error.message);}return result;};var isNonEmptyArray=function isNonEmptyArray(arr){return Array.isArray(arr)&&arr.length>0;};var isNonEmptyString=function isNonEmptyString(str){return typeof str==='string'&&str.length>0;};var hasValue=function hasValue(item){return item!=null&&isNonEmptyString(item);};var isEmptyObject=function isEmptyObject(obj){return Object.keys(obj).length===0&&obj.constructor===Object;};

    exports.hasValue = hasValue;
    exports.isEmptyObject = isEmptyObject;
    exports.isNonEmptyArray = isNonEmptyArray;
    exports.isNonEmptyString = isNonEmptyString;
    exports.parseXmlToJson = parseXmlToJson;

    Object.defineProperty(exports, '__esModule', { value: true });

    return exports;

}({}));

(function(exports) {
    'use strict';

    var Constants = {};

    Constants.CONTENT_TYPE = {
        MP4: 'MP4',
        HLS: 'HLS',
        RTSP: 'RTSP',
        RTMP: 'RTMP',
        NPP: 'NPP',
        LINEAR: 'LINEAR',
        DASH: 'DASH'
    };

    Constants.MEDIA_TYPE = {
        NPP: 'application/x-nppURL',
        HLS: 'application/x-mpegURL',
        MP4: 'video/mp4'
    };

    Constants.ENV = {
        MOBILE_WEB: 'MOBILE_WEB',
        MOBILE_WEB_ALLOW_HD: 'MOBILE_WEB_ALLOW_HD',
        TVPOT_WEB: 'TVPOT_WEB',
        DAUM_APP: 'DAUM_APP',
        KAKAOTV: 'KAKAOTV',
        IOS: 'IOS',
        ANDROID: 'ANDROID'
    };

    Constants.PHASE = {
        DEV: 'DEV',
        CBT: 'CBT',
        SANDBOX: 'SANDBOX',
        PROD: 'PROD',
        PRODSLV: 'PROD',
        LOCAL: 'LOCAL'
    };

    Constants.SUB_DOMAIN = {
        KAKAO: {
            DEV: 'alpha-tv',
            CBT: 'beta-tv',
            SANDBOX: 'sandbox-tv',
            PROD: 'tv',
            LOCAL: '',
            PLAYER: 'play-tv'
        },
        DAUM: {
            DEV: 'alpha-tv.dev',
            CBT: 'beta-tv.dev',
            SANDBOX: 'sandbox-tv.dev',
            PROD: 'kakaotv',
            LOCAL: ''
        }
    };

    Constants.DOMAIN = {
        KAKAO: 'kakao.com',
        DAUM: 'daum.net'
    };

    Constants.HOST = location.protocol + '//' + location.host;

    Constants.SHARE_DOMAIN =
        location.protocol + '//' + Constants.SUB_DOMAIN.KAKAO.PLAYER + '.' + Constants.DOMAIN.KAKAO;

    Constants.APP_KEY = {
        DEV: 'c6e6645efbe2d0d688e9136aa0c44fc4',
        CBT: '8ea44e3f160a4c276592eda5f1c7cb61',
        SANDBOX: 'a16c74899bb0672c71ca8024b8d78cd5',
        PROD: '8ea44e3f160a4c276592eda5f1c7cb61',
        LOCAL: '8ea44e3f160a4c276592eda5f1c7cb61'
    };

    Constants.DTE_TYPE = {
        IPHONE: 'IPHONE',
        IPAD: 'IPAD',
        ANDROID: 'ANDROID',
        PC: 'PC',
        ETC: 'ETC'
    };

    Constants.VIDEO_TYPE = {
        AD: 'AD',
        VOD: 'VOD',
        LIVE: 'LIVE'
    };

    Constants.PROFILE = {
        LOW: 'LOW',
        BASE: 'BASE',
        MAIN: 'MAIN',
        HIGH: 'HIGH',
        HIGH4: 'HIGH4',
        SUPER: 'SUPER',
        ULTRA: 'ULTRA',
        AUTO: 'AUTO'
    };

    Constants.DASH_PROFILE = {
        AUTO: Constants.PROFILE.AUTO,
        0: Constants.PROFILE.LOW,
        1: Constants.PROFILE.BASE,
        2: Constants.PROFILE.MAIN,
        3: Constants.PROFILE.HIGH,
        4: Constants.PROFILE.HIGH4,
        5: Constants.PROFILE.SUPER,
        6: Constants.PROFILE.ULTRA
    };

    Constants.PROFILE_RESOULTION = {};
    Constants.PROFILE_RESOULTION[Constants.PROFILE.LOW] = '240P';
    Constants.PROFILE_RESOULTION[Constants.PROFILE.BASE] = '360P';
    Constants.PROFILE_RESOULTION[Constants.PROFILE.MAIN] = '480P';
    Constants.PROFILE_RESOULTION[Constants.PROFILE.HIGH] = '720P HD';
    Constants.PROFILE_RESOULTION[Constants.PROFILE.HIGH4] = '1080P HD';
    Constants.PROFILE_RESOULTION[Constants.PROFILE.SUPER] = '1440P HD';
    Constants.PROFILE_RESOULTION[Constants.PROFILE.ULTRA] = '2160P 4K';

    Constants.ID = {
        VIDEO_ELEMENT: 'videoElement',
        VIDEO_CONTAINER: 'videoContainer'
    };

    Constants.URL = {
        THUMBNAIL_FARM_URL: '//t1.daumcdn.net/thumb/#{type}.q50.fjpg/?fname=#{url}',
        KEMI_LOG_URL: Constants.HOST + '/api/v1/ft/logging/player',
        DONATE_URL: '/cookie/donate/#{livelinkid}',
        LIVEAGENT_DOWNLOAD_URL_MAC: '//t1.daumcdn.net/liveagent/v2/macOS/LiveAgentMac.dmg',
        LIVEAGENT_DOWNLOAD_URL_WIN: '//t1.daumcdn.net/liveagent/v1/KakaoLiveAgentSetup.exe',
        LIVEAGENT_SETUP_GUIDE: '//cs.kakao.com/helps?category=242&device=659&locale=ko&service=53&articleId=1073187694',
        LIVEAGENT_CHROME_EXTENSION:
            '//chrome.google.com/webstore/detail/%EC%B9%B4%EC%B9%B4%EC%98%A4-hls-%EB%A7%A4%EB%8B%88%EC%A0%80/mphadpdpmhhbkmmmfgkcbbfnlnlkikch'
    };

    Constants.STORAGE = {
        UUID: 'player_uuid',
        VOLUME: 'player_volume',
        ALERT_MSG: '3g4g_alert_msg',
        PROFILE: 'player_profile',
        MUTE: 'player_mute',
        ABR: 'player_abr',
        CHART: 'player_chart',
        SUBTITLE: 'player_subtitle'
    };

    Constants.ERROR = {
        CLASS: {
            BACKGROUND_ALPHA: 'background_alpha',
            BACKGROUND_DIMMED: 'background_dimmed',
            THUMBNAIL_IMG: 'thumbnail_img'
        },
        STATUS: {
            Age18: {
                NAME: 'Age18',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '이 비디오물은 청소년 관람불가 등급으로 <br />만 18세 미만의 청소년은 시청할 수 없습니다.',
                CLASS_NAME: 'message_intro',
                HAS_OUT_LINK: false
            },
            Age19: {
                NAME: 'Age19',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION:
                    '이 정보 내용은 청소년 유해매체물로서<br />정보 통신망 이용 촉진 및 정보 보호 등에 관한<br />' +
                    '법률 및 청소년 보호법에 따라<br />19세 미만의 청소년이 이용할 수 없습니다.',
                CLASS_NAME: 'type_agelimit_intro message_intro',
                HAS_OUT_LINK: false
            },
            AgeLimited18: {
                NAME: 'AgeLimited18',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '인증 결과 청소년으로 확인되어 이 동영상을 시청할 수 없습니다.',
                CLASS_NAME: 'type_agelimit',
                HAS_OUT_LINK: false
            },
            AgeLimited19: {
                NAME: 'AgeLimited19',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '인증 결과 청소년으로 확인되어 이 동영상을 시청할 수 없습니다.',
                CLASS_NAME: 'type_agelimit',
                HAS_OUT_LINK: false
            },
            AgeLimitedLive19: {
                NAME: 'AgeLimitedLive19',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION:
                    '본 방송은 미성년자가 시청하기에 적합하지 않은 터프한 방송입니다. 미성년자는 터프한 방송 시청이 제한됩니다.',
                CLASS_NAME: 'type_tough',
                HAS_OUT_LINK: false
            },
            AudioCopyright: {
                NAME: 'AudioCopyright',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '음원 저작권자의 권리보호를 위해 재생 차단되었습니다.',
                CLASS_NAME: 'message_info outlink_none',
                HAS_OUT_LINK: false
            },
            CleanCenterTemporaryRightViolations: {
                NAME: 'CleanCenterTemporaryRightViolations',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '해당 콘텐츠는 권리침해 신고로 임시 조치 되었습니다.',
                CLASS_NAME: 'message_info',
                LINK_TYPE: 'qna'
            },
            CodecNotInstalled: {
                NAME: 'CodecNotInstalled',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION:
                    '윈도우에서 HTML5플레이어로 재생하기 위해서는<br /> 윈도우 미디어 기능팩 설치가 필요합니다.',
                CLASS_NAME: 'message_info',
                LINK_TYPE: 'qna',
                LINK_URL:
                    'https://cs.kakao.com/helps?' +
                    'category=242&device=659&locale=ko&service=53&articleId=1073187747&page=1'
            },
            LiveAgentNotInstalled: {
                NAME: 'LiveAgentNotInstalled',
                MESSAGE_TYPE: 'install',
                DESCRIPTION: '고화질로 생생한 라이브를 시청하기 위해서는 라이브 에이전트 설치가 필요합니다.',
                LINK_URL:
                    'https://cs.kakao.com/helps?' +
                    'category=242&device=659&locale=ko&service=53&articleId=1073187747&page=1'
            },
            EncodingNotCompleted: {
                NAME: 'EncodingNotCompleted',
                MESSAGE_TYPE: 'process',
                DESCRIPTION: '동영상 인코딩 중입니다.<br /> 잠시 후 다시 확인해주세요.',
                CLASS_NAME: 'message_popup',
                LINK_TYPE: 'refresh'
            },
            ExceededAllowance: {
                NAME: 'ExceededAllowance',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '허용된 방송 시청자수를 초과하였습니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            FailedEncoding: {
                NAME: 'FailedEncoding',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '동영상을 등록할 수 없습니다. 다시 업로드 해주세요.',
                CLASS_NAME: 'message_info outlink_none'
            },
            GeoBlocked: {
                NAME: 'GeoBlocked',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '해당 국가에서의 접근은 금지되어 있습니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            LiveFinished: {
                NAME: 'LiveFinished',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '종료된 방송입니다.',
                CLASS_NAME: 'message_info outlink_none thumbnail_img type_stop background_dimmed'
            },
            LiveException: {
                NAME: 'LiveException',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '라이브가 종료되었거나, 재생이 원활하지 않습니다.',
                CLASS_NAME: 'message_info outlink_none thumbnail_img'
            },
            LivefarmServerError: {
                NAME: 'LivefarmServerError',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '현재 이용자가 많아 <br />접속이 원활하지 않습니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            Need19Login: {
                NAME: 'Need19Login',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '19금 컨텐츠에 접근하기 위해서는 로그인이 필요합니다.',
                CLASS_NAME: 'type_nineteen',
                LINK_TYPE: 'auth'
            },
            NeedAuth: {
                NAME: 'NeedAuth',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '본인인증이 필요합니다.',
                CLASS_NAME: 'type_nineteen',
                LINK_TYPE: 'auth'
            },
            NeedAuth18: {
                NAME: 'NeedAuth18',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '청소년은 시청할 수 없는 동영상으로 본인인증 후 이용이 가능합니다.',
                CLASS_NAME: 'type_nineteen',
                LINK_TYPE: 'auth'
            },
            NeedAuth19: {
                NAME: 'NeedAuth19',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '청소년은 시청할 수 없는 동영상으로 본인인증 후 이용이 가능합니다.',
                CLASS_NAME: 'type_nineteen',
                LINK_TYPE: 'auth'
            },
            NeedAuthLive19: {
                NAME: 'NeedAuthLive19',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION:
                    '터프한 방송은 비속어 또는 일부 폭력적인 영상이 포함되어 있어 19세 미만의 청소년은 시청할 수 없습니다.',
                CLASS_NAME: 'type_tough',
                LINK_TYPE: 'auth'
            },
            NeedChannel: {
                NAME: 'NeedChannel',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '하나 이상의 채널이 필요합니다.',
                CLASS_NAME: 'message_info'
            },
            NoOwnership: {
                NAME: 'NoOwnership',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '권한이 없습니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            NotFound: {
                NAME: 'NotFound',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '존재하지 않거나 삭제된 영상입니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            NotOpenClipOrLive: {
                NAME: 'NotOpenClipOrLive',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '비공개된 영상입니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            RightViolations: {
                NAME: 'RightViolations',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '해당 콘텐츠는 권리침해 신고로 <br /> 임시 접근 금지되었습니다.',
                CLASS_NAME: 'message_info',
                LINK_TYPE: 'qna'
            },
            UNAVAILABLE: {
                NAME: 'UNAVAILABLE',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '동영상을 재생할 수 없습니다.',
                CLASS_NAME: 'message_info outlink_none',
                LINK_TYPE: 'refresh'
            },
            Violation: {
                NAME: 'Violation',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '규제되었습니다.',
                CLASS_NAME: 'message_info'
            },
            VideoCopyright: {
                NAME: 'VideoCopyright',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '저작권자의 권리보호를 위해 재생 차단되었습니다.',
                CLASS_NAME: 'message_info outlink_none'
            },
            OperationPolicy: {
                NAME: 'OperationPolicy',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '카카오TV 운영정책 위반으로 규제 되었습니다.',
                CLASS_NAME: 'message_info'
            },
            LegacyPlayerNotice: {
                NAME: 'LegacyPlayerNotice',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION:
                    '최신 버전의 카카오 TV 플레이어에서만 <br /> 바로 재생이 가능합니다. 재생하시려면 <br />아래 확인 버튼을 눌러 주세요.',
                CLASS_NAME: 'message_info message_type1',
                LINK_TYPE: 'redirect',
                LINK_URL: 'https://cs.kakao.com/requests?category=298&locale=ko&service=53'
            },
            UNAVAILABLE_ADBLOCK: {
                NAME: 'UNAVAILABLE_ADBLOCK',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION:
                    '동영상을 재생할 수 없습니다.<br /> 광고 차단 프로그램이 원인일 수 있으므로 <br />해제 또는 삭제 후 재생하시기 바랍니다.',
                CLASS_NAME: 'message_info outlink_none',
                LINK_TYPE: 'refresh'
            },
            UNAVAILABLE_ADCONTENTS: {
                NAME: 'UNAVAILABLE_ADCONTENTS',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '일시적인 오류로 광고 정보를 불러오지 못했습니다.',
                CLASS_NAME: 'message_info outlink_none',
                LINK_TYPE: 'refresh'
            },
            NETWORK_OFFLINE: {
                NAME: 'NETWORK_OFFLINE',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '네트워크 상태를 확인해주세요.',
                CLASS_NAME: 'message_info',
                LINK_TYPE: 'refresh'
            },
            ReservedClip: {
                NAME: 'ReservedClip',
                MESSAGE_TYPE: 'notice',
                DESCRIPTION: '공개 예정인 영상입니다.',
                CLASS_NAME: 'message_info outlink_none'
            }
        }
    };

    Constants.CONFIRM = {
        CLASS: {
            BACKGROUND_ALPHA: 'background_alpha'
        },
        STATUS: {
            CARRIER: {
                NAME: 'CARRIER',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '사용 중인 요금제에 따라 데이터 요금이<br /> 발생할 수 있습니다.',
                CLASS_NAME: 'background_alpha',
                LINK_TYPE: 'normal'
            },
            LinearLive: {
                NAME: 'LinearLive',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: 'tvingTV 채널 방송은<br /> 카카오TV 라이브앱에서 재생할 수 있습니다.',
                CLASS_NAME: '',
                LINK_TYPE: 'web2app'
            },
            LAUNCH_APP: {
                NAME: 'LAUNCH_APP',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION:
                    'HD화질 시청을 위해 카카오TV 라이브앱으로<br /> 연결합니다. 설치가 안된 경우 설치하시겠습니까?',
                CLASS_NAME: 'background_alpha',
                LINK_TYPE: 'normal'
            },
            NeedJoinAgreement: {
                NAME: 'NeedJoinAgreement',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '가입 동의가 필요합니다.',
                CLASS_NAME: 'background_alpha',
                LINK_TYPE: 'normal'
            },
            NeedLaunchApp: {
                NAME: 'NeedLaunchApp',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '카카오TV 라이브앱에서만<br /> 시청 가능한 콘텐츠입니다.',
                CLASS_NAME: 'background_alpha',
                LINK_TYPE: 'web2app'
            },
            NeedPassword: {
                NAME: 'NeedPassword',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '비밀번호 입력이 필요한 컨텐츠입니다.',
                CLASS_NAME: 'message_popup background_alpha',
                LINK_TYPE: 'password'
            },
            NeedLogin: {
                NAME: 'NeedLogin',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '로그인 후 시청 가능한 컨텐츠입니다.',
                CLASS_NAME: 'message_popup background_alpha',
                LINK_TYPE: 'login'
            },
            PasswordIncorrect: {
                NAME: 'PasswordIncorrect',
                MESSAGE_TYPE: 'input',
                DESCRIPTION: '잘못된 비밀번호입니다. 다시 입력해주세요.',
                CLASS_NAME: 'message_popup background_alpha color_g',
                LINK_TYPE: 'password'
            },
            NoPurchased: {
                NAME: 'NoPurchased',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '영상 시청을 위해 모바일 카카오톡에서 구매가 필요합니다.',
                CLASS_NAME: 'background_alpha background_dimmed',
                LINK_TYPE: 'purchase'
            },
            NoPurchasedForMobile: {
                NAME: 'NoPurchasedForMobile',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '영상 시청을 위해 구매가 필요합니다.',
                CLASS_NAME: 'background_alpha background_dimmed',
                LINK_TYPE: 'purchase'
            },
            NeedPurchased: {
                NAME: 'NeedPurchased',
                MESSAGE_TYPE: 'confirm',
                DESCRIPTION: '영상 시청을 위해 구매가 필요합니다.',
                CLASS_NAME: 'background_alpha background_dimmed',
                LINK_TYPE: 'purchase'
            },
            EncodingNotCompleted: Constants.ERROR.STATUS.EncodingNotCompleted
        }
    };

    Constants.HTTP = {
        TYPE: {
            XML: 'xml',
            JSON: 'json',
            TEXT: 'text'
        },
        METHOD: {
            GET: 'get',
            POST: 'post',
            PUT: 'put'
        }
    };

    Constants.SHAKA = {
        CONFIGURE: {
            PC: {
                abr: {
                    defaultBandwidthEstimate: 2500000,
                    bandwidthUpgradeTarget: 0.8,
                    switchInterval: 2
                },
                manifest: {
                    retryParameters: {
                        maxAttempts: 2
                    }
                },
                streaming: {
                    rebufferingGoal: 4,
                    bufferingGoal: 10,
                    retryParameters: {
                        baseDelay: 5000,
                        maxAttempts: 1,
                        timeout: 60000
                    },
                    smallGapLimit: 1
                }
            },
            MOBILE: {
                abr: {
                    defaultBandwidthEstimate: 1250000,
                    bandwidthUpgradeTarget: 0.8,
                    switchInterval: 2
                },
                manifest: {
                    retryParameters: {
                        maxAttempts: 2
                    }
                },
                streaming: {
                    rebufferingGoal: 4,
                    bufferingGoal: 10,
                    retryParameters: {
                        baseDelay: 5000,
                        maxAttempts: 1,
                        timeout: 60000
                    }
                }
            }
        }
    };

    Constants.SHAKA.ERROR = {
        HTTP_ERROR: {
            CODE: 1002
        },
        BAD_HTTP_STATUS: {
            CODE: 1001
        },
        MEDIA_FORMAT_ERROR: {
            CODE: 3016
        }
    };

    Constants.QOE = {
        EVENT: {
            PLAYBACK_FAIL: 'playback_fail',
            REBUFFERING: 'rebuffering',
            SEEK: 'seek',
            RESOLUTION_CHANGE: 'resolution_change',
            INITIAL_DELAY: 'initial_delay',
            BANDWIDTH: 'bandwidth',
            FRAME_DROP: 'frame_drop',
            DISPLAY_SIZE_CHANGE: 'display_size_change'
        }
    };

    Constants.PLAYER_CALLBACK_NAME = {
        notReadyCallback: 'notReadyCallback',
        onAddPlaylist: 'onAddPlaylist',
        onCheckNextVideo: 'onCheckNextVideo',
        onChangeAutoPlayMode: 'onChangeAutoPlayMode',
        onKakaoIframeAPIReady: 'onKakaoIframeAPIReady',
        onEndAutoPlayTimer: 'onEndAutoPlayTimer',
        onFullScreenChange: 'onFullScreenChange',
        onLoadedContentVideo: 'onLoadedContentVideo',
        onMeasureHeight: 'onMeasureHeight',
        onClickEventStart: 'onClickEventStart',
        onPlayError: 'onPlayError',
        onPlayCancel: 'onPlayCancel',
        onReadyComplete: 'onReadyComplete',
        onReadyVideo: 'onReadyVideo',
        onStartImpression: 'onStartImpression',
        onStartLoadVideo: 'onStartLoadVideo',
        onTouchEventStart: 'onTouchEventStart',
        onTouchEventEnd: 'onTouchEventEnd',
        onVideoStateChange: 'onVideoStateChange',
        onWideScreenChange: 'onWideScreenChange',
        onPlayStart: 'onPlayStart',
        onPlayEnd: 'onPlayEnd',
        onAlreadyInited: 'onAlreadyInited',
        onOffsetPointUpdate: 'onOffsetPointUpdate',
        /**
         * @deprecated
         */
        onPlayInlineStart: 'onPlayInlineStart',
        /**
         * @deprecated
         */
        onPlayInlineEnd: 'onPlayInlineEnd',
        /**
         * @deprecated
         */
        onChangeEmpathyStatus: 'onChangeEmpathyStatus',
        /**
         * @deprecated
         */
        onReceiveToastMessage: 'onReceiveToastMessage',
        /**
         * @deprecated
         */
        onClickPlayerExitButton: 'onClickPlayerExitButton',
        /**
         * @deprecated
         */
        onHandleLogin: 'onHandleLogin'
    };

    Constants.PLAYER_VIDEO_STATE = {
        PLAYING: 'playing',
        PLAY: 'play',
        PAUSE: 'pause',
        PASSED: 'passed',
        ENDED: 'ended'
    };

    Constants.PLAYER_CLICK_ACTION = {
        PLAY: 'play',
        PAUSE: 'pause'
    };

    Constants.TRACKING_OFF_PARAM = 'tk=off';

    Constants.SENTRY = {
        DEFAULT_MESSAGE_OPTION: {
            level: 'warning'
        },
        CONFIG: {
            DSN: {
                DEV: 'https://6c3a23572a38405cbcbb6f7f76b7dc59@aem-collector.daumkakao.io/400',
                SANDBOX: 'https://06d4965dc4ff4a0c82a3ffcaf491233b@aem-collector.daumkakao.io/391',
                CBT: 'https://3b52761fbc4144088d2e577ccc535e19@aem-collector.daumkakao.io/397',
                PROD: 'https://711c55a031e544338c0b272f0fb34990@aem-collector.daumkakao.io/1561'
            }
        }
    };

    Constants.PLAYERCLASS = {
        SHAKA: 'shaka',
        KAMP: 'kamp',
        HTML5: 'html5',
        CAST: 'cast'
    };

    Constants.AGE_LIMIT = {
        ALL: {
            name: 'ALL',
            class: 'ico_watchall'
        },
        AGE_12: {
            name: 'AGE_12',
            class: 'ico_watch12'
        },
        AGE_15: {
            name: 'AGE_15',
            class: 'ico_watch15'
        },
        AGE_18: {
            name: 'AGE_18',
            class: 'ico_watch19'
        },
        AGE_19: {
            name: 'AGE_19',
            class: 'ico_watch19'
        }
    };

    Constants.RATING = {
        subject: {
            key: 'subject',
            name: '주제',
            class: 'ico_watchsubject'
        },
        sexual: {
            key: 'sexual',
            name: '선정성',
            class: 'ico_watchsexuality'
        },
        violence: {
            key: 'violence',
            name: '폭력성',
            class: 'ico_watchviolence'
        },
        dialogue: {
            key: 'dialogue',
            name: '대사',
            class: 'ico_watchcurse'
        },
        fear: {
            key: 'fear',
            name: '공포',
            class: 'ico_watchfear'
        },
        drug: {
            key: 'drug',
            name: '약물',
            class: 'ico_watchdrug'
        },
        imitation: {
            key: 'imitation',
            name: '모방위험',
            class: 'ico_watchcopyrisk'
        }
    };

    Constants.RATING_LEVEL = {
        NONE: {
            key: 'NONE',
            value: 0,
            name: ''
        },
        LOW: {
            key: 'LOW',
            value: 1,
            name: '낮음'
        },
        NORMAL: {
            key: 'NORMAL',
            value: 2,
            name: '보통'
        },
        LOW_HIGH: {
            key: 'LOW_HIGH',
            value: 3,
            name: '다소높음'
        },
        MEDIUM_HIGH: {
            key: 'MEDIUM_HIGH',
            value: 4,
            name: '높음'
        },
        HIGH: {
            key: 'HIGH',
            value: 5,
            name: '매우높음'
        }
    };

    Constants.SUBTITLE = {
        STATUS: {
            OFF: 'off'
        }
    };

    exports.constants = Constants;
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';

    var env = exports.ENV;
    var ua = window.ua_result;
    var constants = exports.constants;

    var hp = (exports.helpers = {
        http: {
            ajax: function(url, callbacks, config) {
                if (!config) {
                    config = {};
                }

                if (typeof callbacks === 'function') {
                    var successCallback = callbacks;
                    callbacks = {};
                    callbacks.onSuccess = successCallback;
                }

                try {
                    var _async = config.async;
                    var _type = config.type ? config.type : constants.HTTP.TYPE.TEXT;
                    var _method = config.method ? config.method : constants.HTTP.METHOD.GET;
                    var _body = config.body || null;

                    var xmlHttp = new XMLHttpRequest();
                    xmlHttp.open(_method, url, _async);
                    xmlHttp.onreadystatechange = function() {
                        if (xmlHttp.readyState !== 4) {
                            return;
                        }
                        var result = xmlHttp.responseText;
                        if (_type === constants.HTTP.TYPE.JSON && result) {
                            if (result) {
                                try {
                                    result = JSON.parse(result);
                                } catch (e) {
                                    hp.debug.error(e.message);
                                }
                            }
                        }

                        if (xmlHttp.status === 200) {
                            callbacks.onSuccess(result);
                        } else if (typeof callbacks.onError === 'function') {
                            callbacks.onError(result);
                        }
                    };
                    if (config.credentials === 'include') {
                        xmlHttp.withCredentials = true;
                    }

                    if (config.async && config.timeout > 0) {
                        if (typeof callbacks.onTimeout === 'function') {
                            xmlHttp.timeout = config.timeout;
                            xmlHttp.ontimeout = callbacks.onTimeout;
                        }
                    }

                    if (config && config.headers) {
                        for (var key in config.headers) {
                            xmlHttp.setRequestHeader(key, config.headers[key]);
                        }
                    }
                    xmlHttp.send(_body);
                } catch (e) {
                    if (typeof callbacks.onError === 'function') {
                        callbacks.onError();
                    }
                }
            },
            fetchMethod: function(url, callbacks, config) {
                var onSuccess = callbacks.onSuccess;
                var onError = callbacks.onError;
                var onTimeout = callbacks.onTimeout;
                var didTimeOut = false;
                var timeout = {};

                if (config.timeout > 0) {
                    timeout = setTimeout(function() {
                        didTimeOut = true;
                        onTimeout();
                    }, config.timeout);
                }

                window
                    .fetch(url, config)
                    .then(function(response) {
                        clearTimeout(timeout);

                        if (didTimeOut) {
                            return;
                        }

                        var result = config.type === constants.HTTP.TYPE.JSON ? response.json() : response.text();

                        return result.then(function(json) {
                            if (response.status === 200) {
                                onSuccess(json);
                            } else {
                                onError(json);
                            }
                        });
                    })
                    .catch(function(e) {
                        if (didTimeOut) {
                            return;
                        }

                        onError(e);
                    });
            },
            fetch: function(url, option) {
                var http = this;

                return new Promise(function(resolve, reject) {
                    var config = http.setConfig(option);
                    var httpRequestMethod = http.getHttpRequestMethod(config.async);

                    httpRequestMethod(
                        url,
                        {
                            onSuccess: resolve,
                            onError: http.reject.bind(http, 'onError', reject),
                            onTimeout: http.reject.bind(http, 'onTimeout', reject)
                        },
                        config
                    );
                });
            },
            getHttpRequestMethod: function(async) {
                var httpRequestMethod;

                if (!this.supportFetch() || !async) {
                    httpRequestMethod = this.ajax;
                } else {
                    httpRequestMethod = this.fetchMethod;
                }

                return httpRequestMethod;
            },
            supportFetch: function() {
                var supportFetch = window.fetch;
                var response = window.Response ? new window.Response() : {};
                var supportResponseJson = response.json;

                return !!(supportFetch && supportResponseJson);
            },
            setConfig: function(option) {
                var headers = {};
                var config = option || {};

                if (config.headers) {
                    headers = option.headers;
                }

                if (config.contentType) {
                    headers['Content-Type'] = config.contentType;
                } else {
                    headers['Content-Type'] = 'application/x-www-form-urlencoded';
                }

                if (typeof option.async === 'undefined') {
                    config.async = true;
                }

                config.headers = headers;

                return config;
            },
            reject: function(type, reject, e) {
                var error = e || {};
                error.type = type;

                reject(error);
            },
            sendBeacon: function(url) {
                var img = new Image();
                img.src = url;
                return img;
            }
        },
        debug: (function() {
            var _isDebug = env.debugMode;
            var isShowServerSetting = false;

            return {
                isDebug: function() {
                    return _isDebug;
                },
                setDebug: function(isDebug) {
                    _isDebug = isDebug;
                },
                log: function() {
                    if (_isDebug) {
                        dt.log.apply(null, arguments);
                    }
                },
                debug: function() {
                    if (_isDebug) {
                        dt.debug.apply(null, arguments);
                    }
                },
                info: function() {
                    if (_isDebug) {
                        dt.info.apply(null, arguments);
                    }
                },
                warn: function() {
                    if (_isDebug) {
                        dt.warn.apply(null, arguments);
                    }
                },
                error: function() {
                    if (_isDebug) {
                        dt.error.apply(null, arguments);
                    }
                    hp.sentry.captureException(arguments);
                },
                table: function() {
                    if (_isDebug) {
                        dt.table.apply(null, arguments);
                    }
                },
                group: function() {
                    if (_isDebug) {
                        dt.group.apply(null, arguments);
                    }
                },
                groupEnd: function() {
                    if (_isDebug) {
                        dt.groupEnd.apply(null, arguments);
                    }
                },
                groupCollapsed: function() {
                    if (_isDebug) {
                        dt.groupCollapsed.apply(null, arguments);
                    }
                },
                tooltip: function(message, log) {
                    if (_isDebug) {
                        var div = document.createElement('div');

                        var length = dt.$$('.debug_tooltip div').length;
                        div.innerHTML = message + log;
                        dt.$$('.debug_tooltip')[0].appendChild(div);

                        dt.classList.add(div, 'visible');
                        dt.classList.remove(div, 'hidden');

                        var self = this;
                        var timer = setTimeout(function() {
                            self.hideTooltip(div);
                            clearTimeout(timer);
                        }, (length + 1) * 1700);
                    }
                },
                hideTooltip: function(target) {
                    var self = this;
                    dt.classList.add(target, 'hidden');
                    dt.classList.remove(target, 'visible');
                    self.removeTooltip(target);
                },
                removeTooltip: function(target) {
                    setTimeout(function() {
                        dt.$$('.debug_tooltip')[0].removeChild(target);
                    }, 1500);
                },
                isShowServerSetting: function() {
                    return isShowServerSetting;
                },
                setShowServerSetting: function(show) {
                    isShowServerSetting = show;
                }
            };
        })(),
        device: {
            getDteType: function(ua) {
                if (ua.os.name === 'ios') {
                    if (ua.platform === 'tablet') {
                        return constants.DTE_TYPE.IPAD;
                    } else {
                        return constants.DTE_TYPE.IPHONE;
                    }
                } else if (ua.os.name === 'android') {
                    return constants.DTE_TYPE.ANDROID;
                } else if (ua.platform === 'pc') {
                    return constants.DTE_TYPE.PC;
                } else {
                    return constants.DTE_TYPE.ETC;
                }
            },
            isTV: function(ua) {
                var televisions = ['netcast', 'smarttv', 'smart-tv'];

                function checkDevice(arr, ua) {
                    return arr.some(function(arrVal) {
                        return ua.ua.indexOf(arrVal) !== -1;
                    });
                }
                return checkDevice(televisions, ua);
            },
            isSupportThumbnailVideo: function(ua) {
                return !this.isTV(ua) && !this.isAndroidDown5(ua);
            },
            isSupportUniversalLinks: function(ua) {
                return parseInt(ua.os.version.major, 10) > 8 && ua.os.ios;
            },
            isSupportMutedControl: function(ua) {
                if (ua.os.ios && ua.os.version.major <= 9) {
                    return false;
                }
                return true;
            },
            isPCWithSafari: function(ua) {
                var isPC = ua.platform === 'pc';
                return !!(isPC && ua.ua.match(/version\/[\d.]+.*safari/));
            },
            isMobileWithSafari: function(ua) {
                var isMobile = ua.platform === 'mobile';
                return !!(isMobile && ua.ua.match(/version\/[\d.]+.*safari/));
            },
            isSupportInlinePlayOnIOS: function(ua) {
                // ios이고 playsinline이 true일 경우 => true
                return ua.os.ios && env.playsinline;
            },
            isSupportInlinePlayOnPC: function(ua) {
                var isPC = ua.platform === 'pc';
                var isIE = ua.browser.msie;
                var isIE9Under = isIE && ua.browser.version.major < 9;

                return isPC && (!isIE || !isIE9Under);
            },
            isAndroidDown5: function(ua) {
                return !!(ua.os.android && ua.os.version.major < 5);
            },
            isSupportDesktopBrowser: function(ua) {
                var isPC = ua.platform === 'pc';
                var isIE = !!ua.browser.msie;
                var isIE11Under = isIE && ua.browser.version.major < 11;
                return isPC && (!isIE || !isIE11Under);
            },
            isIMASupportedBrowser: function(ua) {
                if (this.isSupportDesktopBrowser(ua) || !this.isAndroidDown5(ua)) {
                    return true;
                }
                return false;
            },
            isSupportInlinePlay: function(ua) {
                // iOS환경에서 playsinline 옵션 true인지 확인
                if (this.isSupportInlinePlayOnIOS(ua)) {
                    return true;
                }

                if (this.isSupportInlinePlayOnPC(ua)) {
                    return true;
                }

                var androidOver4 = ua.os.android && ua.browser.version.major >= 4;
                var ipad = ua.browser.ipad;
                var androidChrome = ua.browser.chrome;
                var smarttv = /smarttv/gi.test(ua.ua);

                return androidOver4 || ipad || androidChrome || smarttv;
            },
            isSupportCustomController: function(ua) {
                if (!this.isSupportInlinePlay(ua)) {
                    return false;
                }

                if (
                    /LG-\wU540/gi.test(ua.ua) ||
                    /KM-S220/gi.test(ua.ua) ||
                    (ua.os.version.major === 4 && parseInt(ua.os.version.minor) === 0 && / IM-[AT]/gi.test(ua.ua)) ||
                    (ua.os.version.major === 4 && parseInt(ua.os.version.minor) === 0 && / SHV-E160/gi.test(ua.ua)) ||
                    (ua.os.version.major === 4 && parseInt(ua.os.version.minor) === 0 && / SHW-M250/gi.test(ua.ua))
                ) {
                    return false;
                }

                return true;
            },
            isSupportAd: function(ua) {
                if (this.isSupportCustomController(ua)) {
                    return true;
                }

                var uaStr = ua.ua;
                var major = ua.os.version.major;
                var minor = ua.os.version.minor;

                if (/LG-\w180/gi.test(uaStr) && major === 4 && minor < 2) {
                    return false;
                }
            },
            isFacebookWebview: function() {
                try {
                    return /.*FBIOS.*/.test(window.navigator.userAgent);
                } catch (e) {}

                return false;
            },
            isiPadOS: function() {
                var isIOS =
                    (/iPad|iPhone|iPod/.test(navigator.platform) ||
                        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
                    !window.MSStream;

                return isIOS;
            },
            isSupportAjaxAsync: function(ua) {
                var isAllowedChromeVersion = true;

                if (ua.browser.chrome && ua.browser.version.major < 66) {
                    isAllowedChromeVersion = false;
                }

                return !ua.os.ios && !this.isPCWithSafari(ua) && !this.isAndroidDown5(ua) && isAllowedChromeVersion;
            },
            isIeBrowser11Under: function(ua) {
                var isIE = !!ua.browser.msie;
                var isIE11Under = isIE && ua.browser.version.major < 11;
                return isIE && isIE11Under;
            }
        },
        env: {
            phase: env.phase.toUpperCase(),
            isProd: function() {
                return this.phase === constants.PHASE.PROD;
            },
            isCbt: function() {
                return this.phase === constants.PHASE.CBT;
            },
            isDev: function() {
                return this.phase === constants.PHASE.DEV;
            },
            isSandbox: function() {
                return this.phase === constants.PHASE.SANDBOX;
            },
            isLocal: function() {
                return this.phase === constants.PHASE.LOCAL;
            }
        },
        feature: {
            supportsHLS: function() {
                var v = document.getElementById(constants.ID.VIDEO_ELEMENT);
                return !!(
                    v.canPlayType && v.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, '')
                );
            },
            supportsH264: function() {
                var v = document.getElementById(constants.ID.VIDEO_ELEMENT);
                return !!(
                    v.canPlayType &&
                    (this.canPlayType(ua, v, 'video/mp4; codecs="avc1.42E01E"') ||
                        this.canPlayType(ua, v, 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"'))
                );
            },
            getVideoExtra: function(profile) {
                return profile === 'HIGH' ? '1' : profile === 'MAIN' ? '2' : profile === 'BASE' ? '3' : '4';
            },
            supportsHLSAndroid: function() {
                var osVersion = ua.os.version;

                var supportedOS =
                    ua.os.android && (osVersion.major > 4 || (osVersion.major > 3 && osVersion.minor > 3));
                var supportedBrowser = ua.browser.chrome && ua.browser.version.major > 35;

                if (supportedOS && supportedBrowser && this.supportsHLS()) {
                    return true;
                }

                return false;
            },
            /**
             * There is a bug in iOS 4.1 or earlier where probably and maybe are switched around.
             * This bug was reported and fixed in iOS 4.2
             * @param {HTMLElement} element
             * @param {string} type
             * @returns {boolean}
             * @see {@link https://bugs.webkit.org/show_bug.cgi?id=44519|webkit}
             */
            canPlayType: function(ua, element, type) {
                var version = ua.os.version;

                if (ua.os === 'ios' && version.major <= 4 && version.minor < 2) {
                    return element.canPlayType(type) === 'probably' || element.canPlayType(type) === 'maybe';
                } else {
                    return element.canPlayType(type) === 'probably';
                }
            },
            supportsVideoProfile: function(profile) {
                for (var p in constants.PROFILE) {
                    if (constants.PROFILE.hasOwnProperty(p)) {
                        if (profile === p) {
                            return true;
                        }
                    }
                }
                return false;
            }
        },
        date: {
            hhmmssToDate: function(hhmmss) {
                if (hhmmss) {
                    var time = hhmmss.split(':');
                    var d = new Date(); // creates a Date Object using the clients current time

                    d.setHours(+time[0]); // set Time accordingly, using implicit type coercion
                    d.setMinutes(time[1]); // you can pass Number or String, it doesn't matter
                    d.setSeconds(time[2]);

                    return d;
                }
                return null;
            }
        },
        fullscreen: function(playerElement, videoElement) {
            var requestFullscreen =
                playerElement.requestFullscreen ||
                playerElement.webkitRequestFullscreen ||
                playerElement.webkitRequestFullScreen ||
                playerElement.mozRequestFullScreen ||
                playerElement.msRequestFullscreen;

            var exitFullscreen =
                document.exitFullscreen ||
                document.webkitExitFullscreen ||
                document.webkitCancelFullScreen ||
                document.mozCancelFullScreen ||
                document.msExitFullscreen;

            var webkitEnterFullscreen = videoElement.webkitEnterFullscreen;
            var webkitExitFullscreen = videoElement.webkitExitFullScreen;

            var supportFullscreen = !!(requestFullscreen && exitFullscreen);

            return {
                isSupport: function() {
                    return supportFullscreen;
                },
                request: function(options) {
                    return requestFullscreen.call(playerElement, options);
                },
                exit: function() {
                    if (this.isFullScreen()) {
                        exitFullscreen.call(document);
                    }
                },
                isSupportOnlyIOS: function() {
                    return videoElement.webkitSupportsFullscreen;
                },
                setFullscreen: function(state) {
                    if (state) {
                        try {
                            webkitEnterFullscreen.call(videoElement);
                        } catch (e) {}
                    } else {
                        webkitExitFullscreen.call(videoElement);
                    }
                },
                isFullScreen: function() {
                    var fullscreen =
                        !!(
                            document.fullScreen ||
                            document.fullscreenElement ||
                            document.webkitCurrentFullScreenElement ||
                            document.mozFullScreenElement ||
                            document.msFullscreenElement
                        ) || videoElement.webkitDisplayingFullscreen;

                    if (!fullscreen) {
                        return false;
                    }

                    if (
                        videoElement.webkitPresentationMode &&
                        videoElement.webkitPresentationMode === 'picture-in-picture'
                    ) {
                        return false;
                    }

                    return fullscreen;
                },
                isFullScreenChangeEvent: function(e) {
                    var eventType = e.type && e.type.toLowerCase();
                    return eventType && eventType.indexOf('fullscreenchange') > -1;
                }
            };
        },
        string: {
            escapeHtml: function(unsafe) {
                return unsafe
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#039;');
            },
            jsonToQueryString: function(data) {
                if (typeof data !== 'object') {
                    return;
                }

                var result = '';
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        result += key + '=' + data[key] + '&';
                    }
                }
                result = result.slice(0, result.length - 1);
                return result;
            },
            separateTimes: function(totalSec) {
                var sec = Math.floor(totalSec % 60);
                var min = Math.floor(totalSec / 60);
                var hour = Math.floor(min / 60);

                min = Math.floor(min % 60);

                if (min < 10) {
                    min = '0' + min;
                }

                if (sec < 10) {
                    sec = '0' + sec;
                }

                return {
                    hour: hour,
                    min: min,
                    sec: sec
                };
            },
            timeToString: function(totalSec) {
                var times = this.separateTimes(totalSec);
                return (times.hour > 0 ? times.hour + '시간' : '') + times.min + '분' + times.sec + '초';
            },
            stringToSec: function(timeString) {
                var sec = 0;
                var splitTime = timeString.split(':').reverse();

                for (var i = 0; i < splitTime.length; i++) {
                    var calcTime = parseInt(splitTime[i]) * Math.pow(60, i);
                    sec += calcTime;
                }

                return sec;
            },
            delimitTimes: function(totalSec, de) {
                var times = this.separateTimes(totalSec);
                var delimiter = de || ':';
                return (times.hour > 0 ? times.hour + delimiter : '') + times.min + delimiter + times.sec;
            },
            delimitNumbers: function(str) {
                return (str + '').replace(/\b(\d+)((\.\d+)*)\b/g, function(a, b, c) {
                    return (
                        (b.charAt(0) > 0 && !(c || '.').lastIndexOf('.') ? b.replace(/(\d)(?=(\d{3})+$)/g, '$1,') : b) +
                        c
                    );
                });
            },
            sec2hhmmss: function(timeInSeconds) {
                var time = parseFloat(timeInSeconds).toFixed(0);
                var hours = Math.floor(time / 60 / 60);
                var minutes = Math.floor(time / 60) % 60;
                var seconds = Math.floor(time - minutes * 60);

                return this.pad(hours, 2) + ':' + this.pad(minutes, 2) + ':' + this.pad(seconds, 2);
            },
            pad: function(num, size) {
                return ('000' + num).slice(size * -1);
            },
            format: function(string, data) {
                for (var key in data) {
                    if (data.hasOwnProperty(key) && key) {
                        var value = data[key];

                        if (value === null || typeof value === 'undefined') {
                            value = '';
                        }
                        if (typeof value === 'string') {
                            value = value.replace('$', '$$$$');
                        }
                        string = string.replace('#{' + key + '}', value);
                    }
                }
                return string;
            },
            getThumbnailFarmUrl: function(url, type) {
                if (!url) {
                    return '';
                }

                if (type) {
                    url = url.replace(/thumb\/(.+)\/\?fname/, 'thumb/' + type + '.q50.fjpeg/?fname');
                } else {
                    url = url.replace(/thumb\/(.+)\/\?fname/, 'thumb/$1.q50.fjpg/?fname');
                }

                return hp.string.format(constants.URL.THUMBNAIL_FARM_URL, {
                    type: type,
                    url: encodeURIComponent(url)
                });
            },
            replaceLinefeed: function(string) {
                if (!string || typeof string !== 'string') {
                    return string;
                }
                return string.replace(/\n/g, '<br>');
            }
        },
        orientation: (function() {
            return {
                getOrientation: function() {
                    return window.screen.width > window.screen.height ? 'landscape' : 'portrait';
                },
                isSupportOrientation: function() {
                    return window.screen.orientation;
                }
            };
        })(),
        window: {
            openPopup: function(url, windowName, features) {
                var windowRef = window.open(url, windowName, features);
                if (windowRef) {
                    windowRef.focus();
                    windowRef.opener = null;
                }
            }
        },
        url: (function() {
            return {
                getParameter: function(param) {
                    if (!window.location.search) {
                        return;
                    }
                    var m = new RegExp(param + '=([^&]*)').exec(window.location.search.substring(1));
                    if (!m) {
                        return;
                    }
                    return decodeURIComponent(m[1]);
                },
                setParameter: function(search, name, value) {
                    search = this.removeParameter(search, name);
                    if (search === '') {
                        search = '?';
                    }
                    if (search.length > 1) {
                        search += '&';
                    }
                    return search + name + '=' + encodeURIComponent(value);
                },
                removeParameter: function(search, name) {
                    if (search[0] === '?') {
                        search = search.substring(1);
                    }
                    var parts = search.split('&');
                    var res = [];
                    for (var i = 0; i < parts.length; i++) {
                        var pair = parts[i].split('=');
                        if (pair[0] === name) {
                            continue;
                        }
                        res.push(parts[i]);
                    }
                    search = res.join('&');
                    if (search.length > 0) {
                        search = '?' + search;
                    }
                    return search;
                },
                isValidate: function(value) {
                    var expression = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
                    var regexp = new RegExp(expression);
                    return regexp.test(value);
                }
            };
        })(),
        store: {
            set: function(name, value, expireDay) {
                var date = new Date();
                var expireTime = (expireDay || 365) * 24 * 60 * 60 * 1000;
                var timeZoneOffset = 9;

                date.setTime(date.getTime() + expireTime + timeZoneOffset * 3600000);
                var time = date.toGMTString();

                hp.storage.setItem(name, value, time);
                hp.cookie.setItem(name, value, time);
            },
            get: function(name) {
                if (!hp.storage.enabled && !hp.cookie.enabled) {
                    return null;
                }

                var value = hp.storage.getItem(name);
                if (!value || value === '') {
                    value = hp.cookie.getItem(name);
                }

                return value;
            }
        },
        cookie: (function() {
            var enabled = true;

            function sendError(e, key) {
                enabled = false;
                dt.error(e, key);
            }

            try {
                var d = new Date();
                d.setTime(d.getTime() + 1000);
                setItem('testcookie', 'test', d);
                enabled = !!getItem('testcookie');
                removeItem('testcookie');
            } catch (e) {
                enabled = false;
                sendError(e, 'cookie setItem error');
            }

            function getItem(name) {
                if (enabled) {
                    var ckName = name + '=';
                    var cookie = document.cookie;
                    var start = cookie.indexOf(ckName);
                    var end;

                    if (start !== -1) {
                        start += ckName.length;
                        end = cookie.indexOf(';', start);
                        if (end === -1) {
                            end = cookie.length;
                        }
                        return decodeURIComponent(cookie.substring(start, end));
                    }
                }

                return '';
            }

            function setItem(name, value, expireTime) {
                if (enabled) {
                    var expires = 'expires=' + expireTime;
                    document.cookie = name + '=' + value + '; ' + expires;
                }
            }

            function removeItem(name) {
                var d = new Date();
                d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
                var expires = 'expires=' + d.toGMTString();
                document.cookie = name + '=' + '; ' + expires;
            }

            return {
                enabled: enabled,
                setItem: setItem,
                getItem: getItem
            };
        })(),
        storage: (function(frame) {
            var enabled = true;

            function sendError(e, key) {
                enabled = false;
                dt.error(e, key);
            }

            try {
                frame.localStorage.setItem('t', 1);
                frame.localStorage.removeItem('t');
            } catch (e) {
                enabled = false;
            }

            return {
                enabled: enabled,
                forEach: function(callback) {
                    var i;
                    var keys = [];
                    var length = frame.localStorage.length;

                    for (i = 0; i < length; i += 1) {
                        keys.push(frame.localStorage.key(i));
                    }
                    for (i = 0; i < length; i += 1) {
                        callback(keys[i], i);
                    }
                },
                setItem: function(key, value, expireTime) {
                    var data = {
                        value: value,
                        expires: expireTime
                    };

                    if (enabled) {
                        try {
                            frame.localStorage.setItem(key, JSON.stringify(data));
                        } catch (e) {
                            sendError(e, 'storage setItem error');
                        }
                    }
                },
                getItem: function(key) {
                    var data;

                    if (enabled) {
                        data = frame.localStorage.getItem(key);

                        try {
                            if (data) {
                                data = JSON.parse(data);

                                if (!this.isExpiredTime(key, data.expires)) {
                                    return data.value;
                                }
                            }

                            return '';
                        } catch (e) {
                            this.removeItem(key);
                            sendError(e, 'storage getItem error');
                        }
                    }
                    return '';
                },
                isExpiredTime: function(key, expires) {
                    var isExpired = true;
                    var date = new Date();
                    var currentTime = date.getTime();

                    date = new Date(expires);
                    var expiredTime = date.getTime();

                    if (expiredTime) {
                        currentTime = parseInt(currentTime, 10);
                        expiredTime = parseInt(expiredTime, 10);

                        if (currentTime < expiredTime) {
                            isExpired = false;
                        } else {
                            hp.debug.info('remove', key, 'from localstorage');
                            this.removeItem(key);
                        }
                    }
                    return isExpired;
                },
                removeItem: function(key) {
                    if (enabled) {
                        try {
                            frame.localStorage.removeItem(key);
                        } catch (e) {
                            sendError(e, 'storage removeItem error');
                        }
                    }
                }
            };
        })(window),
        webapi: (function() {
            var network = {
                getConnection: function() {
                    return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                },
                isWifi: function() {
                    var connection = this.getConnection();
                    return connection && connection.type === 'wifi';
                }
            };

            var share = {};
            var pip = {
                enabled: document.pictureInPictureEnabled,
                isPipScreen: function() {
                    var pip = document.pictureInPictureElement;
                    var pipscreen =
                        pip ||
                        (pip && pip.webkitPresentationMode && pip.webkitPresentationMode === 'picture-in-picture');

                    return pipscreen;
                },
                request: function(videoElement) {
                    return videoElement.requestPictureInPicture().catch(hp.debug.error);
                },
                exit: function() {
                    return document.exitPictureInPicture().catch(hp.debug.error);
                }
            };

            return {
                share: share,
                network: network,
                pip: pip
            };
        })(),
        traversal: {
            nextAll: function(element) {
                var next = [element];
                while (element.nextElementSibling) {
                    next.push((element = element.nextElementSibling));
                }
                return next;
            }
        },
        ui: {
            preventDoubleClick: function(el) {
                if (el.tagName === 'BUTTON') {
                    el.disabled = true;

                    setTimeout(function() {
                        el.disabled = false;
                    }, 500);
                }
            }
        },
        sdk: {
            getDefaultCallbackParams: function(video) {
                var params;
                if (video.type === constants.VIDEO_TYPE.VOD) {
                    params = [video.vid, video.type, video.id];
                } else if (video.type === constants.VIDEO_TYPE.LIVE) {
                    params = [null, video.type, video.id];
                }

                return params;
            },
            sendEventCallback: function(cbName, cbParam) {
                var hasProperty = constants.PLAYER_CALLBACK_NAME.hasOwnProperty(cbName);
                var callbackParam = [];

                if (hasProperty) {
                    if (typeof cbParam !== 'undefined' && cbParam instanceof Array) {
                        callbackParam = cbParam;
                    }

                    if (window.apiMessenger) {
                        window.apiMessenger.sendCallback(cbName, callbackParam);
                    }
                } else {
                    hp.debug.warn('[event callback] name or parameter is not valid');
                }
            }
        },
        polyfill: {
            getProps: function(prop) {
                var el = document.createElement('div');
                var prefix = this.getPrefix(el.style, prop);

                return prefix ? prefix + prop.charAt(0).toUpperCase() + prop.slice(1) : prop;
            },
            getPrefix: function(target, prop) {
                var prefixes = ['', 'webkit', 'moz', 'ms', 'o'];

                for (var p = 0, pl = prefixes.length; p < pl; p++) {
                    var prefixedProp = prefixes[p] ? prefixes[p] + prop.charAt(0).toUpperCase() + prop.slice(1) : prop;

                    if (prefixedProp in target) {
                        return prefixes[p];
                    }
                }
            }
        },
        web2app: {
            launchTalk: function(urlScheme) {
                var appName = '카카오톡';
                var deviceType = ua.os.android ? 'android' : 'ios';
                var appBridgeLink = '/talkbridge';
                var storeURL = 'https//play.google.com/store/apps/details?id=com.kakao.talk';

                var packageName = 'com.kakao.talk';
                var urlParse = urlScheme && urlScheme.split('://');
                var scheme = urlParse[0];
                var url = urlParse[1];
                var intentURI =
                    'intent://' + url + '#Intent' + ';scheme=' + scheme + ';package=' + packageName + ';end;';

                var opt = {
                    urlScheme: urlScheme,
                    appName: appName,
                    intentURI: intentURI,
                    storeURL: storeURL
                };

                if (deviceType === 'ios') {
                    window.top.location.href = appBridgeLink + '?shouldMoveStore=1&appScheme=' + urlScheme;
                } else {
                    dt.web2app(opt);
                }
            },
            launchApp: function(runType, linkId, profile, from) {
                var deviceType = ua.os.android ? 'android' : 'ios';
                var phase = '';
                var packageName = 'com.kakao.playball';
                var params = '';
                var path = {
                    open: 'open',
                    live: 'live',
                    vod: 'clip'
                };

                if (env.phase !== 'prod' && env.phase !== 'cbt') {
                    phase = env.phase;
                    packageName = packageName + '.' + env.phase;
                }
                if (runType !== 'open' && linkId !== '') {
                    params = linkId + '&profile=' + profile + '&from=' + from;
                    path.live += '?liveLinkId=' + params;
                    path.vod += '?clipLinkId=' + params;
                }

                var urlScheme = 'kakaotvlive' + phase + '://' + path[runType];
                var intentURI = 'intent://' + path[runType];

                var storeURL =
                    deviceType === 'ios'
                        ? 'itms-apps://itunes.apple.com/kr/app/id1180460837'
                        : 'https://play.google.com/store/apps/details?id=com.kakao.playball';

                var appSuffix =
                    '#Intent;scheme=kakaotvlive' +
                    phase +
                    ';action=android.intent.action.VIEW' +
                    ';category=android.intent.category.BROWSABLE' +
                    ';package=' +
                    packageName +
                    ';S.browser_fallback_url=' +
                    encodeURIComponent(storeURL) +
                    ';end';

                var appName = '카카오 TV';
                var opt = {
                    urlScheme: urlScheme,
                    intentURI: intentURI + appSuffix,
                    appName: appName,
                    storeURL: storeURL
                };

                hp.debug.info('kakaotv web2app config', opt);
                dt.web2app(opt);
            },
            launchKakaoTV: function(ua, linkId, profile) {
                var isSupportUniversalLinks = hp.device.isSupportUniversalLinks(ua);
                var deviceType;
                var phaseScheme = {
                    ios: 'kakaotvlive',
                    android: 'kakaotvlive'
                };

                if (ua.os.android) {
                    deviceType = 'android';
                } else {
                    deviceType = 'ios';
                }

                var packageName = 'com.kakao.playball';

                if (env.phase !== 'prod' && env.phase !== 'cbt') {
                    phaseScheme.android = phaseScheme.android + env.phase;
                    phaseScheme.ios = phaseScheme.ios + env.phase;
                    packageName = packageName + '.' + env.phase;
                }

                var urlScheme = {
                    ios:
                        phaseScheme.ios +
                        '://live?liveLinkId=' +
                        linkId +
                        '&profile=' +
                        profile +
                        '&from=' +
                        env.service,
                    android:
                        phaseScheme.android +
                        '://live?liveLinkId=' +
                        linkId +
                        '&profile=' +
                        profile +
                        '&from=' +
                        env.service
                };

                var appName = '카카오 TV';
                var storeURL =
                    deviceType === 'ios'
                        ? 'https://itunes.apple.com/kr/app/id1180460837'
                        : 'https://play.google.com/store/apps/details?id=com.kakao.playball';

                var intentURI = 'intent://live?liveLinkId=' + linkId + '&profile=' + profile + '&from=' + env.service;
                var appSuffix =
                    '#Intent' +
                    ';scheme=' +
                    phaseScheme.android +
                    ';action=android.intent.action.VIEW' +
                    ';category=android.intent.category.BROWSABLE' +
                    ';package=' +
                    packageName +
                    ';S.browser_fallback_url=' +
                    encodeURIComponent(storeURL) +
                    ';end';

                var origin = 'play-tv.kakao.com';
                if (document.domain) {
                    if (document.domain.indexOf(origin) >= 0) {
                        origin = 'tv.kakao.com';
                    }
                }
                var universalLink =
                    'https://' +
                    origin +
                    '/scheme/live?liveLinkId=' +
                    linkId +
                    '&profile=' +
                    profile +
                    '&from=' +
                    env.service;

                var appBridgeLink = '/appbridge';

                var opt = {
                    urlScheme: urlScheme[deviceType],
                    intentURI: intentURI + appSuffix,
                    appName: appName,
                    storeURL: storeURL,
                    onAppMissing: function() {
                        if (top !== self) {
                            top.location.href = appBridgeLink;
                        } else {
                            window.open(appBridgeLink, 'blank');
                        }
                    }
                };

                if (isSupportUniversalLinks) {
                    opt.universalLink = universalLink;
                }

                dt.web2app(opt);
            },
            launchPlusFriend: function(ua, uuid) {
                var deviceType;

                if (ua.os.android) {
                    deviceType = 'android';
                } else {
                    deviceType = 'ios';
                }

                var phaseScheme = 'kakaoplus';
                if (env.phase !== 'prod') {
                    phaseScheme = 'alphaplus';
                }

                var urlScheme = {
                    android: phaseScheme + '://plusfriend/home/' + encodeURIComponent(uuid),
                    ios: phaseScheme + '://plusfriend/home/' + encodeURIComponent(uuid)
                };

                var intentURI = 'intent://plusfriend/home/' + encodeURIComponent(uuid);
                var appSuffix = '#Intent;scheme=kakaoplus;package=com.kakao.talk;end';

                var appName = '플러스친구';
                var storeURL = 'itms-apps://itunes.apple.com/kr/app/da-eum-daum/id365494029?mt=8';

                hp.debug.log('urlScheme: ' + urlScheme[deviceType]);

                var opt = {
                    urlScheme: urlScheme[deviceType],
                    intentURI: intentURI + appSuffix,
                    appName: appName,
                    storeURL: storeURL,
                    onAppMissing: function(storeURL) {
                        try {
                            if (typeof window.top.goStore === 'function') {
                                window.top.goStore(storeURL);
                            }
                        } catch (e) {
                            hp.debug.error('An error has occurred: ' + e.message);
                        }
                    }
                };

                dt.web2app(opt);
            }
        },
        sentry: (function() {
            if (window.Sentry) {
                window.Sentry.init({
                    dsn: constants.SENTRY.CONFIG.DSN[env.phase.toUpperCase()],
                    release: env.playerVersion
                });
            }

            function captureException(error) {
                if (!window.Sentry) {
                    return;
                }

                var keys = Object.keys(error);
                var exceptionMassage = [];

                for (var i = 0; i < keys.length; i++) {
                    var errorDetail = error[keys[i]];

                    if (!errorDetail) {
                        continue;
                    }

                    if (typeof errorDetail === 'object') {
                        for (var property in errorDetail) {
                            if (errorDetail.hasOwnProperty(property)) {
                                exceptionMassage.push(property + ': ' + errorDetail[property]);
                            }
                        }
                    } else if (
                        typeof errorDetail === 'string' &&
                        errorDetail &&
                        !errorDetail.match(/^(%c%s|color: #\d+)/)
                    ) {
                        exceptionMassage.push(errorDetail);
                    } else {
                        exceptionMassage.push(errorDetail);
                    }
                }

                window.Sentry.captureException(exceptionMassage.join(', '));
            }

            function captureMessage(message) {
                if (window.Sentry) {
                    window.Sentry.captureMessage(message, constants.SENTRY.DEFAULT_MESSAGE_OPTION.level);
                }
            }

            return {
                captureException: captureException,
                captureMessage: captureMessage
            };
        })(),
        uuid: {
            get: function() {
                var uuid = hp.store.get(constants.STORAGE.UUID);
                return uuid === null ? '-1' : uuid;
            },
            set: function(uuid) {
                var cached = this.get();
                if (uuid) {
                    hp.store.set(constants.STORAGE.UUID, uuid !== cached ? uuid : cached);
                }
            }
        },
        serverHost: {
            create: function(envHost, phase, scheme) {
                var host = scheme ? scheme + '://' : '//';
                var locationHost = window.location.host;

                if (envHost && phase !== constants.PHASE.PROD) {
                    host += envHost;
                } else if (
                    locationHost.indexOf('tv.kakao.com') >= 0 ||
                    locationHost.indexOf('kakaotv.daum.net') >= 0 ||
                    locationHost.indexOf('tv.devel.kakao.com') >= 0 ||
                    locationHost.indexOf('dev.daum.net') >= 0
                ) {
                    host += window.location.host;
                } else {
                    host += constants.SUB_DOMAIN.KAKAO[phase] + '.kakao.com';
                }

                return host;
            },
            link: function(phase) {
                return 'https://' + constants.SUB_DOMAIN.KAKAO[phase] + '.kakao.com';
            }
        },
        sendOnAlreadyInited: function() {
            var documentState = document.readyState;

            if (documentState !== 'loading') {
                this.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onAlreadyInited);
            }
        },
        parser: {
            xml2json: function(xml) {
                var isValid = true;
                var config = {
                    attributeNamePrefix: '@_',
                    ignoreNameSpace: true,
                    ignoreAttributes: false
                };
                return window.utils.parseXmlToJson(xml, config, isValid);
            }
        },
        validator: {
            hasValue: function(value) {
                return window.utils.hasValue(value);
            },
            isNonEmptyArray: function(arr) {
                return window.utils.isNonEmptyArray(arr);
            },
            isNonEmptyString: function(str) {
                return window.utils.isNonEmptyString(str);
            },
            isEmptyObject: function(obj) {
                return window.utils.isEmptyObject(obj);
            },
            isHlsVideo: function(videoUrl) {
                return videoUrl.indexOf('m3u8') > -1;
            }
        },
        tv: {
            isConnected: function() {
                var state = window.cast && window.cast.framework.CastContext.getInstance().getCastState();

                return state === 'CONNECTED';
            },
            isOnTv: function(videoElement) {
                var isOnAirPlay = videoElement.webkitCurrentPlaybackTargetIsWireless;
                var isOnChromecast = this.isConnected();

                if (isOnAirPlay || isOnChromecast) {
                    return true;
                }

                return false;
            }
        },
        waiter: {
            // copied from debounce function of underscore.js
            debounce: function(func, wait, immediate) {
                var timeout, result;

                var later = function(context, args) {
                    timeout = null;
                    if (args) {
                        result = func.apply(context, args);
                    }
                };

                function restArguments(func, startIndex) {
                    startIndex = startIndex == null ? func.length - 1 : +startIndex;
                    return function() {
                        var length = Math.max(arguments.length - startIndex, 0);
                        var rest = Array(length);
                        var index = 0;
                        for (; index < length; index++) {
                            rest[index] = arguments[index + startIndex];
                        }
                        switch (startIndex) {
                            case 0:
                                return func.call(this, rest);
                            case 1:
                                return func.call(this, arguments[0], rest);
                            case 2:
                                return func.call(this, arguments[0], arguments[1], rest);
                        }
                        var args = Array(startIndex + 1);
                        for (index = 0; index < startIndex; index++) {
                            args[index] = arguments[index];
                        }
                        args[startIndex] = rest;
                        return func.apply(this, args);
                    };
                }

                var delay = restArguments(function(func, wait, args) {
                    return setTimeout(function() {
                        return func.apply(null, args);
                    }, wait);
                });

                var debounced = restArguments(function(args) {
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    if (immediate) {
                        var callNow = !timeout;
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            result = func.apply(this, args);
                        }
                    } else {
                        timeout = delay(later, wait, this, args);
                    }

                    return result;
                });

                debounced.cancel = function() {
                    clearTimeout(timeout);
                    timeout = null;
                };

                return debounced;
            },
            // copied from throttle function of underscore.js
            throttle: function(func, wait, options) {
                var now =
                    Date.now ||
                    function() {
                        return new Date().getTime();
                    };

                var timeout, context, args, result;
                var previous = 0;
                if (!options) {
                    options = {};
                }

                var later = function() {
                    previous = options.leading === false ? 0 : now();
                    timeout = null;
                    result = func.apply(context, args);
                    if (!timeout) {
                        context = args = null;
                    }
                };

                var throttled = function() {
                    var _now = now();
                    if (!previous && options.leading === false) {
                        previous = _now;
                    }
                    var remaining = wait - (_now - previous);
                    context = this;
                    args = arguments;
                    if (remaining <= 0 || remaining > wait) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        previous = _now;
                        result = func.apply(context, args);
                        if (!timeout) {
                            context = args = null;
                        }
                    } else if (!timeout && options.trailing !== false) {
                        timeout = setTimeout(later, remaining);
                    }
                    return result;
                };

                throttled.cancel = function() {
                    clearTimeout(timeout);
                    previous = 0;
                    timeout = context = args = null;
                };

                return throttled;
            }
        },
        kakao: {
            sendMe: function(templateID, templateArgs, successCallback, failCallback) {
                window.Kakao.Auth.login({
                    scope: 'PROFILE,TALK_MESSAGE',
                    success: function() {
                        window.Kakao.API.request({
                            url: '/v2/api/talk/memo/send',
                            data: {
                                template_id: templateID,
                                template_args: templateArgs
                            },
                            success: function() {
                                if (successCallback) {
                                    successCallback();
                                }
                            },
                            fail: function() {
                                if (failCallback) {
                                    failCallback();
                                }
                            }
                        });
                    },
                    fail: function(err) {
                        alert('failed to login: ' + JSON.stringify(err));
                    }
                });
            }
        }
    });
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

this["monet"] = this["monet"] || {};
this["monet"]["template"] = this["monet"]["template"] || {};
this["monet"]["template"]["m_clip_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("clipList",c,p,1),c,p,0,13,413,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li>");t.b("\n" + i);t.b("    <a href=\"");t.b(t.v(t.f("linkUrl",c,p,0)));t.b("\" data-cliplink-id=\"");t.b(t.v(t.f("clipLinkID",c,p,0)));t.b("\" data-clip-id=\"");t.b(t.v(t.f("clipID",c,p,0)));t.b("\"");t.b("\n" + i);t.b("       data-channel-id=\"");t.b(t.v(t.f("channelID",c,p,0)));t.b("\"");t.b("\n" + i);t.b("       data-feedback-id=\"");t.b(t.v(t.f("feedbackID",c,p,0)));t.b("\" class=\"link_vod\">");t.b("\n" + i);t.b("        <span class=\"thumb_box\">");t.b("\n" + i);t.b("            <img src=\"");t.b(t.v(t.f("imageUrl",c,p,0)));t.b("\" width=\"184\" height=\"104\" alt=\"\">");t.b("\n" + i);t.b("            <strong>");t.b(t.v(t.f("title",c,p,0)));t.b("</strong>");t.b("\n" + i);t.b("            <span>");t.b(t.v(t.f("duration",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        </span>");t.b("\n" + i);t.b("    </a>");t.b("\n" + i);t.b("</li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("noDataList",c,p,1),c,p,0,442,471,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li>");t.b("\n" + i);t.b(t.rp("<noData0",c,p,"    "));t.b("</li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<noData0":{name:"noData", partials: {}, subs: {  }}}, subs: {  }});
this["monet"]["template"]["pc_clip_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("clipList",c,p,1),c,p,0,13,379,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li>");t.b("\n" + i);t.b("    <a href=\"");t.b(t.v(t.f("linkUrl",c,p,0)));t.b("\" data-cliplink-id=\"");t.b(t.v(t.f("clipLinkID",c,p,0)));t.b("\" data-clip-id=\"");t.b(t.v(t.f("clipID",c,p,0)));t.b("\"");t.b("\n" + i);t.b("       data-channel-id=\"");t.b(t.v(t.f("channelID",c,p,0)));t.b("\"");t.b("\n" + i);t.b("       data-feedback-id=\"");t.b(t.v(t.f("feedbackID",c,p,0)));t.b("\" class=\"link_item\">");t.b("\n" + i);t.b("        <img src=\"");t.b(t.v(t.f("imageUrl",c,p,0)));t.b("\" class=\"thumb_item\" alt=\"\">");t.b("\n" + i);t.b("        <em class=\"tit_item\">");t.b(t.v(t.f("title",c,p,0)));t.b("</em>");t.b("\n" + i);t.b("        <span class=\"txt_count\">조회수 ");t.b(t.v(t.f("viewCount",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </a>");t.b("\n" + i);t.b("</li>");t.b("\n" + i);});c.pop();}if(t.s(t.f("noDataList",c,p,1),c,p,0,408,437,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li>");t.b("\n" + i);t.b(t.rp("<noData0",c,p,"    "));t.b("</li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {"<noData0":{name:"noData", partials: {}, subs: {  }}}, subs: {  }});
this["monet"]["template"]["cover_profile_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("outputs",c,p,1),c,p,0,12,170,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<button data-profile=\"");t.b(t.v(t.f("profileName",c,p,0)));t.b("\" class=\"btn_quality ");t.b(t.v(t.f("profileOn",c,p,0)));t.b("\" aria-label=\"");t.b(t.v(t.f("profileLabel",c,p,0)));t.b("화질로 재생\">");t.b(t.v(t.f("profileLabel",c,p,0)));t.b(t.t(t.f("supHD",c,p,0)));t.b(t.t(t.f("sup4K",c,p,0)));t.b("</button>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["install_agent"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"alert_liveagent\">");t.b("\n" + i);t.b("    <div class=\"box_liveagent\">");t.b("\n" + i);t.b("        <strong class=\"tit_liveagent\"><span class=\"txt_liveagent\">HD 고화질 </span>라이브</strong>");t.b("\n" + i);t.b("        <p class=\"desc_liveagent\">고화질로 생생한 라이브를 시청하기 위해서는 아래 프로그램 설치가 필요합니다.</p>");t.b("\n" + i);t.b("        <p class=\"box_help\">");t.b("\n" + i);if(t.s(t.f("installExt",c,p,1),c,p,0,292,418,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                라이브 에이전트는 사용자의 PC자원 일부를 사용합니다.<br>프로그램 설치가 안될 경우 <a class=\"link_liveagent2 setup_guide\">설치안내</a>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("installExt",c,p,1),c,p,1,0,0,"")){t.b("                    설치 후에도 고화질 시청이 안될경우,<br><a class=\"link_liveagent\">크롬 설정 &gt; 도구 더보기 &gt; 확장 프로그램 메뉴에서 카카오 HLS 매니저 프로그램 활성화</a> 여부를 확인해주세요.");t.b("\n" + i);};t.b("        </p>");t.b("\n" + i);t.b("        <div class=\"liveagent_setup\">");t.b("\n" + i);if(t.s(t.f("isChromePC",c,p,1),c,p,0,711,1230,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("            <button type=\"button\"");t.b("\n" + i);t.b("                    class=\"");if(t.s(t.f("installExt",c,p,1),c,p,0,788,799,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("btn_graybox");});c.pop();}t.b(" ");if(!t.s(t.f("installExt",c,p,1),c,p,1,0,0,"")){t.b("btn_yellowbox");};t.b(" btn_extension_setup\"");t.b("\n" + i);t.b("                    ");if(t.s(t.f("installExt",c,p,1),c,p,0,915,925,"{{ }}")){t.rs(c,p,function(c,p,t){t.b(" disabled ");});c.pop();}t.b(">");t.b("\n" + i);if(t.s(t.f("installExt",c,p,1),c,p,0,973,1086,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("                    크롬익스텐션 완료");t.b("\n" + i);t.b("                    <span class=\"img_player ico_complete\"></span>");t.b("\n" + i);});c.pop();}if(!t.s(t.f("installExt",c,p,1),c,p,1,0,0,"")){t.b("                    크롬익스텐션 설치");t.b("\n" + i);};t.b("            </button>");t.b("\n" + i);});c.pop();}t.b("            <button type=\"button\"");t.b("\n" + i);t.b("                    data-profile=\"");t.b(t.v(t.f("profile",c,p,0)));t.b("\" class=\"");if(t.s(t.f("installExt",c,p,1),c,p,0,1349,1362,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("btn_yellowbox");});c.pop();}t.b(" ");if(!t.s(t.f("installExt",c,p,1),c,p,1,0,0,"")){t.b("btn_graybox");};t.b(" btn_agent_setup\"");t.b("\n" + i);t.b("                    ");if(!t.s(t.f("installExt",c,p,1),c,p,1,0,0,"")){t.b(" disabled ");};t.b(">");t.b("\n" + i);t.b("                라이브에이전트 설치");t.b("\n" + i);t.b("            </button>");t.b("\n" + i);t.b("        </div>");t.b("\n" + i);t.b("    </div>");t.b("\n" + i);t.b("    <a href=\"#none\" class=\"link_liveagent a_agent_not_setup\">설치 없이 일반화질로 재생</a>");t.b("\n" + i);t.b("    <button type=\"button\" class=\"img_player btn_close\">레이어 닫기</button>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["link_info"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a href=\"");t.b(t.v(t.f("infoUrl",c,p,0)));t.b("\" target=\"_blank\" class=\"link_info\">문의하기</a>");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["extension_profile_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("outputs",c,p,1),c,p,0,12,160,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li class = \"");t.b(t.v(t.f("profileOn",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    <button data-profile=\"");t.b(t.v(t.f("profileName",c,p,0)));t.b("\" class=\"link_quality\">");t.b(t.v(t.f("profileLabel",c,p,0)));t.b(t.t(t.f("supHD",c,p,0)));t.b(t.t(t.f("sup4K",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("</li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["action_button"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<a target=\"_blank\" class=\"link_go\" href=\"");t.b(t.v(t.f("actionUrl",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    ");t.b(t.t(t.f("actionText",c,p,0)));t.b("\n" + i);t.b("    <span class=\"img_player\"></span>");t.b("\n" + i);t.b("</a>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["ad_noti_text"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<p class=\"txt_noti\">");t.b("\n" + i);t.b("    <a href=\"");t.b(t.v(t.f("optoutClickUrl",c,p,0)));t.b("\" target=\"_blank\" class=\"link_optout link_adinfo ");if(t.s(t.f("optouthide",c,p,1),c,p,0,116,120,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("hide");});c.pop();}t.b(" ");if(t.s(t.f("txt_single",c,p,1),c,p,0,151,162,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("type_single");});c.pop();}t.b("\" >");t.b("\n" + i);t.b("        <span class=\"img_player ico_info2\" ");if(t.s(t.f("optoutImageUrl",c,p,1),c,p,0,243,285,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("style=\"background:url(");t.b(t.v(t.f("optoutImageUrl",c,p,0)));t.b(")\"");});c.pop();}t.b(">맞춤형 광고 안내</span>");t.b("\n" + i);t.b("    </a>");t.b("\n" + i);t.b("    <span class=\"txt_g ");if(t.s(t.f("txt_single",c,p,1),c,p,0,369,379,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("txt_single");});c.pop();}t.b("\">");t.b("\n" + i);t.b("        ");t.b(t.t(t.f("notiText",c,p,0)));t.b("\n" + i);t.b("    </span>");t.b("\n" + i);t.b("</p>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["clip_cover_image"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("thumbnails",c,p,1),c,p,0,15,195,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li class=\"");t.b(t.v(t.f("className",c,p,0)));t.b("\">");t.b("\n" + i);t.b("    <a href=\"#none\" class=\"link_cover\" data-thumbnail-index=\"");t.b(t.v(t.f("imageIndex",c,p,0)));t.b("\">");t.b("\n" + i);t.b("        <img src=\"");t.b(t.v(t.f("imageSrc",c,p,0)));t.b("\" class=\"thumb_item\" alt=\"\">");t.b("\n" + i);t.b("    </a>");t.b("\n" + i);t.b("</li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["keyboard_effect_text"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span class=\"");t.b(t.v(t.f("className",c,p,0)));t.b("\">");t.b(t.v(t.f("effectText",c,p,0)));t.b("</span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["mobile_profile_text"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span class=\"img_function\">");t.b("\n" + i);t.b("    <span class=\"txt_dp ");if(t.s(t.f("profileAuto",c,p,1),c,p,0,68,76,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("txt_auto");});c.pop();}t.b("\">");if(t.s(t.f("profileAuto",c,p,1),c,p,0,110,116,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("자동<br>");});c.pop();}t.b(t.v(t.f("profile",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("</span>화질변경");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["mobile_subtitle_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("textTracks",c,p,1),c,p,0,15,114,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li><button data-subtitle=\"");t.b(t.v(t.f("subtitle",c,p,0)));t.b("\" class=\"link_subtitle\">");t.b(t.v(t.f("subtitleText",c,p,0)));t.b("</button></li>");t.b("\n" + i);});c.pop();}t.b("<li class='on'><button data-subtitle=\"off\" class=\"link_subtitle\">사용 안함</button></li>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["pc_profile_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("outputs",c,p,1),c,p,0,12,165,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li class=\"");t.b(t.v(t.f("profileOn",c,p,0)));t.b("\">");t.b("\n" + i);t.b("        <button data-profile=\"");t.b(t.v(t.f("profileName",c,p,0)));t.b("\" class=\"link_dp\">");t.b(t.v(t.f("profileLabel",c,p,0)));t.b(t.t(t.f("supHD",c,p,0)));t.b(t.t(t.f("sup4K",c,p,0)));t.b("</button>");t.b("\n" + i);t.b("    </li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["pc_subtitle_list"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("textTracks",c,p,1),c,p,0,15,114,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <li><button data-subtitle=\"");t.b(t.v(t.f("subtitle",c,p,0)));t.b("\" class=\"btn_subtitles\">");t.b(t.v(t.f("subtitleText",c,p,0)));t.b("</button></li>");t.b("\n" + i);});c.pop();}t.b("<li class='on'><button data-subtitle=\"off\" class=\"btn_subtitles\">사용 안함</button></li>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["profile_text"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("profileAuto",c,p,1),c,p,0,16,50,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<span class=\"txt_auto\">자동</span>");t.b("\n" + i);});c.pop();}t.b("<span class=\"txt_num\">");t.b(t.v(t.f("profileText",c,p,0)));t.b("</span>");t.b("\n" + i);if(t.s(t.f("profileHD",c,p,1),c,p,0,126,156,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<sup class=\"txt_dp\">HD</sup>");t.b("\n" + i);});c.pop();}if(t.s(t.f("profile4K",c,p,1),c,p,0,185,215,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<sup class=\"txt_dp\">4K</sup>");t.b("\n" + i);});c.pop();}t.b("<span class=\"img_player ico_nextarrow\">");t.b("\n" + i);t.b("    <span class=\"screen_out\">버튼</span>");t.b("\n" + i);t.b("</span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["rating_level"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"watchgrade_cont\">");t.b("\n" + i);if(t.s(t.f("isMobile",c,p,1),c,p,0,47,90,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <div class=\"bg_watchgrade\"></div>");t.b("\n" + i);});c.pop();}t.b("\n" + i);if(t.s(t.f("ageLimit",c,p,1),c,p,0,122,225,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <strong class=\"tit_watchgrade\">");t.b("\n" + i);t.b("        <span class=\"");t.b(t.v(t.f("class",c,p,0)));t.b("\">");t.b(t.v(t.f("name",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </strong>");t.b("\n" + i);});c.pop();}t.b("\n" + i);t.b("    <ul class=\"list_watchgrade\">");t.b("\n" + i);if(t.s(t.f("ratingList",c,p,1),c,p,0,296,447,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b("\n" + i);t.b("            <span class=\"");t.b(t.v(t.f("class",c,p,0)));t.b("\">");t.b(t.v(t.f("name",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("            <span class=\"txt_watchgrade\">");t.b(t.v(t.d("level.name",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("        </li>");t.b("\n" + i);});c.pop();}t.b("    </ul>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["still_image"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("thumbnails",c,p,1),c,p,0,15,257,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("<li>");t.b("\n" + i);t.b("    <a href=\"#none\" class=\"link_section\" data-time=\"");t.b(t.v(t.f("seconds",c,p,0)));t.b("\">");t.b("\n" + i);t.b("        <img src=\"");t.b(t.v(t.f("imageSrc",c,p,0)));t.b("\" class=\"thumb_item\" alt=\"\">");t.b("\n" + i);t.b("        <span class=\"screen_out\">구간 타임 : </span>");t.b("\n" + i);t.b("        <span class=\"time_num\">");t.b(t.v(t.f("time",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("    </a>");t.b("\n" + i);t.b("</li>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["list_no_data"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(" <img src=\"//t1.daumcdn.net/kakaotv/alpha600.png\" class=\"thumb_item\" alt=\"\">");t.b("\n" + i);t.b(" <img src=\"//t1.daumcdn.net/kakaotv/services/2020/icon/logo_image.svg\" class=\"svg_logo\" alt=\"\">");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["profile_auto"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span class=\"txt_auto\">자동</span>");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["superscript_4k"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<sup class=\"txt_dp\">4K</sup>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
this["monet"]["template"]["superscript_hd"] = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<sup class=\"txt_dp\">HD</sup>");t.b("\n");return t.fl(); },partials: {}, subs: {  }});
(function(exports) {
    'use strict';

    var env = exports.ENV;
    var daumtools = window.daumtools;
    daumtools.__CONSOLE_QUIET = env.phase === 'prod' && !env.debugMode;

    exports.ua = {};
    exports.configure = typeof exports.configure === 'object' ? exports.configure : {};
    exports.ua = window.ua_result;
    exports.modules = {};

    var queue = new daumtools.Observable();
    var Sandbox = (exports.Sandbox = daumtools.Class.extend({
        init: function(module) {
            this.module = module;
        },
        on: function(event, callback) {
            var module = this.module;
            var callbackWrapper = function callbackWrapper() {
                try {
                    callback.apply(module, arguments);
                } catch (e) {
                    daumtools.error(
                        'event handler error. event: ' +
                            event +
                            ', module "' +
                            module.__moduleName__ +
                            '"' +
                            '\r\ncaused by ' +
                            e.message
                    );
                }
            };
            callbackWrapper.__original__ = callback;
            queue.on(event, callbackWrapper);
        },
        emit: function() {
            var params = arguments[1];

            queue.emit.apply(queue, arguments);

            return new Promise(function(resolve) {
                resolve(params);
            });
        },
        off: function(event, callback) {
            queue.off(event, callback);
        }
    }));

    exports.init = function(player) {
        var modules = exports.modules;

        daumtools.group('initialize modules');
        for (var moduleName in modules) {
            if (modules.hasOwnProperty(moduleName)) {
                var module = modules[moduleName];

                if (module && module.init) {
                    try {
                        module.init(player, new Sandbox(module));
                    } catch (e) {
                        daumtools.error('failed to initialize module "' + moduleName + '". caused by ' + e.message);
                    }
                } else {
                    daumtools.warn('Not exsisted module : "' + moduleName + '".');
                }
            }
        }
        daumtools.groupEnd();
    };

    exports.addModule = function(name, module, overwrite) {
        var modules = exports.modules;
        if (modules[name] && !overwrite) {
            throw new Error('module "' + name + '" already registered');
        }
        modules[name] = module;
        module.__moduleName__ = name;
        daumtools.log('module "' + name + '" registered');
        return module;
    };

    exports.loadModule = function(name) {
        var modules = exports.modules;
        if (modules[name]) {
            return modules[name];
        }
    };

    exports.assert = function(condition, message) {
        if (!condition) {
            throw new Error(message);
        }
    };

    exports.queue = new Sandbox({
        __moduleName__: 'Global'
    });
})((window.monet = typeof window.monet === 'object' ? window.monet : {}));

(function(exports) {
    'use strict';

    var Bean;

    Bean = (function() {
        function Bean() {}

        Bean.prototype.init = function() {};

        Bean.prototype.set = function(values) {
            if (typeof values !== 'object') {
                return;
            }

            var keys = Object.keys(values);

            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];

                if (this.hasOwnProperty(key)) {
                    this[key] = values[key];
                }
            }
        };

        return Bean;
    })();

    exports.addModule('model.bean', new Bean());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var Clip;

    Clip = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var constants = exports.constants;

        var bean = exports.loadModule('model.bean');

        function Clip() {
            this.id = null;
            this.vid = null;
            this.linkId = null;
            this.channelId = null;
            this.clipId = null;
            this.userId = null;
            this.videoUrl = null;
            this.status = null;
            this.profile = null;
            this.type = null;
            this.thumbnailList = null;
            this.coverUrl = null;
            this.duration = null;
            this.xylophoneReq = null;
            this.prerollReq = null;
            this.midrollReq = [];
            this.postrollReq = null;
            this.vmapReq = null;
            this.dsp = 'etc';
            this.tracking = {
                pvt: null,
                pct: null,
                qoe: null
            };
            this.title = null;
            this.canScrap = null;
            this.shouldGeoBlock = null;
            this.hasPlusFriend = null;
            this.plusFriendProfile = null;
            this.isOpen = null;
            this.isLegacy = null;
            this.isOriginal = null;
            this.description = null;
            this.isVertical = null;
            this.ageLimit = null;
            this.tid = null;
            this.wasLive = null;
            this.playingInfo = null;
            this.outputList = [];
            this.login = null;
            this.owner = null;
            this.playCount = null;
            this.channelName = null;
            this.profileImageUrl = null;
            this.skipOnErrorOfAdApi = null;
            this.skipOnErrorOfAdContents = null;
            this.seekUrl = null;
            this.abrVideoLocationList = null;
            this.metaUrl = null;
            this.resumeOffset = null;
            this.originVideoUrl = null;
            this.originProfile = null;
            this.hasRating = null;
            this.ratingValue = null;
            this.textTrack = null;
            this.contentType = null;
            this.purchase = null;
        }

        Clip.prototype.init = function() {
            this.id = null;
            this.vid = null;
            this.linkId = null;
            this.channelId = null;
            this.clipId = null;
            this.userId = null;
            this.videoUrl = null;
            this.status = null;
            this.profile = null;
            this.type = constants.VIDEO_TYPE.VOD;
            this.thumbnailList = null;
            this.coverUrl = null;
            this.duration = null;
            this.xylophoneReq = null;
            this.prerollReq = null;
            this.midrollReq = [];
            this.postrollReq = null;
            this.vmapReq = null;
            this.dsp = 'etc';
            this.tracking = {
                pvt: null,
                pct: null,
                qoe: null
            };
            this.title = null;
            this.canScrap = null;
            this.shouldGeoBlock = null;
            this.hasPlusFriend = null;
            this.plusFriendProfile = null;
            this.isOpen = null;
            this.isLegacy = null;
            this.isOriginal = null;
            this.description = null;
            this.isVertical = null;
            this.ageLimit = null;
            this.tid = null;
            this.wasLive = null;
            this.playingInfo = null;
            this.outputList = [];
            this.login = null;
            this.owner = null;
            this.playCount = null;
            this.channelName = null;
            this.profileImageUrl = null;
            this.skipOnErrorOfAdApi = null;
            this.skipOnErrorOfAdContents = null;
            this.seekUrl = null;
            this.abrVideoLocationList = null;
            this.metaUrl = null;
            this.resumeOffset = null;
            this.originVideoUrl = null;
            this.originProfile = null;
            this.hasRating = null;
            this.ratingValue = null;
            this.textTrack = [];
            this.contentType = null;
            this.purchase = null;
        };

        Clip.prototype.set = function(values) {
            debug.log('%c%s', 'color: #EF1414', '[Set] Clip', values);

            bean.set.call(this, values);
        };

        return Clip;
    })();

    exports.addModule('model.clip', new Clip());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var Live;

    Live = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var constants = exports.constants;

        var bean = exports.loadModule('model.bean');

        function Live() {
            this.id = null;
            this.linkId = null;
            this.channelId = null;
            this.liveId = null;
            this.userId = null;
            this.videoUrl = null;
            this.status = null;
            this.profile = null;
            this.type = null;
            this.coverUrl = null;
            this.xylophoneReq = null;
            this.prerollReq = null;
            this.midrollReq = [];
            this.postrollReq = null;
            this.vmapReq = null;
            this.tracking = {
                pvt: null,
                pct: null
            };
            this.title = null;
            this.contentType = '';
            this.liveType = null;
            this.canScrap = null;
            this.shouldGeoBlock = null;
            this.hasPlusFriend = null;
            this.isOpen = null;
            this.isOriginal = null;
            this.description = null;
            this.ageLimit = null;
            this.needPassword = null;
            this.ccuCount = null;
            this.tid = null;
            this.playingInfo = null;
            this.login = null;
            this.owner = null;
            this.channelName = null;
            this.profileImageUrl = null;
            this.skipOnErrorOfAdApi = false;
            this.skipOnErrorOfAdContents = false;
            this.coverThumbnailUrl = null;
            this.outputList = [];
            this.hasBizDonationPartner = null;
            this.metaUrl = null;
            this.ratingValue = null;
        }

        Live.prototype.init = function() {
            this.id = null;
            this.linkId = null;
            this.channelId = null;
            this.liveId = null;
            this.userId = null;
            this.videoUrl = null;
            this.status = null;
            this.profile = null;
            this.type = constants.VIDEO_TYPE.LIVE;
            this.coverUrl = null;
            this.xylophoneReq = null;
            this.prerollReq = null;
            this.midrollReq = [];
            this.postrollReq = null;
            this.vmapReq = null;
            this.tracking = {
                pvt: null,
                pct: null
            };
            this.title = null;
            this.contentType = '';
            this.liveType = null;
            this.canScrap = null;
            this.shouldGeoBlock = null;
            this.hasPlusFriend = null;
            this.isOpen = null;
            this.isOriginal = null;
            this.description = null;
            this.ageLimit = null;
            this.needPassword = null;
            this.ccuCount = null;
            this.tid = null;
            this.playingInfo = null;
            this.login = null;
            this.owner = null;
            this.channelName = null;
            this.profileImageUrl = null;
            this.skipOnErrorOfAdApi = false;
            this.skipOnErrorOfAdContents = false;
            this.coverThumbnailUrl = null;
            this.outputList = [];
            this.hasBizDonationPartner = null;
            this.metaUrl = null;
            this.ratingValue = null;
        };

        Live.prototype.set = function(values) {
            debug.log('%c%s', 'color: #EF1414', '[Set] Live', values);

            bean.set.call(this, values);
        };

        return Live;
    })();

    exports.addModule('model.live', new Live());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var Ad;

    Ad = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var constants = exports.constants;

        var bean = exports.loadModule('model.bean');

        function Ad() {
            this.id = null;
            this.videoUrl = null;
            this.type = null;
            this.breakId = null;
            this.breakType = null;
            this.timeOffset = null;
            this.skipOffset = null;
            this.ad = null;
            this.creative = null;
            this.extension = null;
            this.clickThrough = null;
            this.clickTracking = null;
            this.dsp = 'etc';
            this.adIndexLabel = null;
            this.icon = null;
        }

        Ad.prototype.init = function() {
            this.id = null;
            this.videoUrl = null;
            this.type = constants.VIDEO_TYPE.AD;
            this.breakId = null;
            this.breakType = null;
            this.timeOffset = null;
            this.skipOffset = null;
            this.ad = null;
            this.creative = null;
            this.extension = null;
            this.clickThrough = null;
            this.clickTracking = null;
            this.dsp = 'etc';
            this.adIndexLabel = null;
            this.icon = [];
        };

        Ad.prototype.set = function(values) {
            debug.log('%c%s', 'color: #EF1414', '[Set] Ad', values);

            bean.set.call(this, values);
        };

        return Ad;
    })();

    exports.addModule('model.ad', new Ad());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var State;

    State = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var constants = exports.constants;

        var ClipBean = exports.loadModule('model.clip');
        var LiveBean = exports.loadModule('model.live');

        function State() {
            this.customControlActivated = null;
            this.modalContentActivated = null;
            this.skipAdEnabled = null;
            this.seekEnabled = null;
            this.volumeChanging = null;
            this.seeking = null;
            this.adControlActivated = null;
            this.currentVideo = null;
            this.profile = null;
            this.completionLoaded = null;
            this.allAdsCompleted = null;
            this.pausedBeforeSeek = null;
            this.isSettingMenuOpened = null;
            this.isContextMenuOpened = null;
            this.mutedBeforeSeek = null;
            this.preventTogglePlayPause = null;
            this.ended = null;
            this.isCheckNextVideo = null;
            this.autoplay = null;
            this.hasRelated = null;
            this.continuousPlay = null;
            this.isPrerollEnded = null;
            this.isPostrollEnded = null;
            this.isNonLinearAdShown = null;
            this.hasStillVideo = null;
            this.playbackRate = null;
            this.needSetTrack = null;
            this.autoplayFail = null;
            this.dash = null;
            this.dashError = null;
            this.playerClass = null;
            this.isShowError = null;
            this.isFirstPlay = null;
            this.midrollIndex = null;
            this.needMidrollRequest = null;
            this.isVastRequesting = false;
            this.lockAirplayChangeEvent = null;
            this.hasAction = null;
            this.initialState = null;
            this.onIma = null;
            this.hls = null;
        }

        State.prototype.init = function() {
            this.customControlActivated = false;
            this.modalContentActivated = false;
            this.skipAdEnabled = false;
            this.seekEnabled = true;
            this.volumeChanging = false;
            this.seeking = false;
            this.adControlActivated = false;
            this.currentVideo = null;
            this.profile = 'MAIN';
            this.completionLoaded = false;
            this.allAdsCompleted = false;
            this.pausedBeforeSeek = false;
            this.isSettingMenuOpened = false;
            this.isContextMenuOpened = false;
            this.mutedBeforeSeek = false;
            this.preventTogglePlayPause = false;
            this.ended = false;
            this.isCheckNextVideo = false;
            this.autoplay = false;
            this.hasRelated = false;
            this.continuousPlay = false;
            this.isPrerollEnded = false;
            this.isPostrollEnded = false;
            this.isNonLinearAdShown = false;
            this.hasStillVideo = false;
            this.playbackRate = 1;
            this.needSetTrack = false;
            this.autoplayFail = false;
            this.dash = false;
            this.dashError = false;
            this.playerClass = null;
            this.isShowError = false;
            this.isFirstPlay = true;
            this.midrollIndex = null;
            this.needMidrollRequest = false;
            this.isVastRequesting = false;
            this.lockAirplayChangeEvent = false;
            this.hasAction = false;
            this.onIma = false;
            this.hls = true;

            debug.info('[state] initialized');
        };

        State.prototype.initInitialState = function() {
            this.initialState = {};
            this.initialState.start = '0';
            this.initialState.startMuted = false;

            debug.info('[state] initialState initialized');
        };

        State.prototype.initCurrentVideo = function(id, type) {
            var currentVideo = {};
            var VIDEO_TYPE = constants.VIDEO_TYPE;

            if (type === VIDEO_TYPE.VOD) {
                ClipBean.init();
                currentVideo = ClipBean;
            } else if (type === VIDEO_TYPE.LIVE) {
                LiveBean.init();
                currentVideo = LiveBean;
            }

            currentVideo.set({ id: id });
            this.currentVideo = currentVideo;
        };

        return State;
    })();

    exports.addModule('controller.state', new State());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    function Html5Player() {
        this.videoElement = null;
    }

    Html5Player.prototype = (function() {
        return {
            init: function(player) {
                this.el = this.videoElement = player.videoElement;
                this.name = 'html5player';
                this.type = player.type;
            },
            load: function() {
                this.el.load();
                exports.queue.emit('load:videosource');
            },
            play: function() {
                if (this.el.paused || this.el.ended) {
                    return this.el.play();
                }
            },
            pause: function() {
                if (!this.el.paused) {
                    this.el.pause();
                }
            },
            stop: function() {
                this.pause();
                this.reset();
                this.load();
            },
            reset: function() {
                this.el.removeAttribute('src');
                this.el.setAttribute('aria-hidden', 'true');
            },
            setVolume: function(volume) {
                this.videoElement.volume = volume;
            },
            getVolume: function() {
                return this.videoElement.volume;
            },
            setMute: function(muted) {
                this.videoElement.muted = muted;
            },
            getMute: function() {
                return this.videoElement.muted;
            },
            setTime: function(time) {
                this.el.setAttribute('data-current-time', time);
            },
            seekTo: function(time) {
                if (!isNaN(time)) {
                    this.el.currentTime = time;
                }
            },
            setVideoSource: function(url) {
                if (this.el.src === url) {
                    return;
                }
                this.el.src = url;

                exports.queue.emit('set:videosource');
            },
            setPlaybackRate: function(rate, calcMode) {
                if (rate && !isNaN(rate) && !calcMode) {
                    this.el.playbackRate = rate;
                } else {
                    if ((rate < 0 && this.el.playbackRate > 0.25) || (rate > 0 && this.el.playbackRate < 2)) {
                        this.el.playbackRate += rate;
                    }
                }
                return this.el.playbackRate;
            },
            getPlaybackRate: function() {
                return this.el.playbackRate;
            },
            getDurationRound: function() {
                return Math.round(this.el.duration);
            },
            getCurrentTimeRound: function() {
                return Math.round(this.el.currentTime);
            },
            getCurrentTime: function() {
                return this.el.currentTime;
            },
            isPaused: function() {
                return this.el.paused;
            },
            isReady: function() {
                return this.el.readyState > 2;
            },
            setCredential: function() {
                this.el.crossorigin = 'use-credentials';
            },
            setTextTrack: function(subtitle) {
                var trackList = this.el.textTracks;

                for (var i = 0; i < trackList.length; i++) {
                    if (trackList[i].language === subtitle) {
                        trackList[i].mode = 'showing';
                    } else {
                        trackList[i].mode = 'hidden';
                    }
                }
            },
            getTextTracks: function() {
                var textTracks = [];
                var trackList = this.el.textTracks;

                for (var i = 0; i < trackList.length; i++) {
                    textTracks.push({ language: trackList[i].language });
                }

                return textTracks;
            }
        };
    })();

    exports.addModule('player.html5', new Html5Player());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';
    var state = exports.loadModule('controller.state');
    var queue = exports.loadModule('playlist.queue');

    var constants = exports.constants;
    var helpers = exports.helpers;
    var debug = helpers.debug;
    var ua = exports.ua;
    var shakaEvents = [
        'adaptation',
        'buffering',
        'drmsessionupdate',
        'emsg',
        'expirationupdated',
        'largegap',
        'loading',
        'streaming',
        'texttrackvisibility',
        'timelineregionadded',
        'timelineregionenter',
        'timelineregionexit',
        'trackschanged',
        'unloading'
    ];
    var bandwidthQueue = [];
    var ABR_KEY = constants.STORAGE.ABR;
    var PROFILE_KEY = constants.STORAGE.PROFILE;

    function ShakaPlayer() {
        this.player = null;
        this.castProxy = null;
        this.tracks = null;
        this.outputList = null;
        this.videoElement = null;
        this.key = '';
        this.preDropFrames = 0;
        this.prevProfile = '';
        this.originPlayer = null;
    }

    ShakaPlayer.prototype = (function() {
        function onShakaEvent(event) {
            debug.info('%c%s', 'color: #20b408', '[ShakaPlayer] onShakaEvent type = ' + event.type, event);
            switch (event.type) {
                case 'adaptation':
                    exports.queue.emit('change:stream');
                    break;
                case 'buffering':
                    exports.queue.emit('shaka:buffering', event.buffering);
                    break;
                case 'drmsessionupdate':
                    break;
                case 'emsg':
                    break;
                case 'expirationupdated':
                    break;
                case 'largegap':
                    break;
                case 'loading':
                    break;
                case 'streaming':
                    break;
                case 'texttrackvisibility':
                    break;
                case 'timelineregionadded':
                    break;
                case 'timelineregionexit':
                    break;
                case 'trackschanged':
                    break;
                case 'unloading':
                    break;
                default:
                    break;
            }
        }

        function changePlayerForFailover() {
            var currentVideo = state.currentVideo;
            var profile = currentVideo.originProfile || currentVideo.profile || constants.PROFILE.BASE;
            state.dash = false;
            state.dashError = true;

            if (state.isFirstPlay) {
                exports.queue.emit('set:defaultOptions');
            }

            exports.queue.emit('loadAndPlay:videoById', currentVideo.id, profile, 0, null, Object.assign({}, state));
            exports.queue.emit('shaka:error');
        }

        function onErrorEvent(event) {
            var video = (queue && queue.front) || state.currentVideo;
            var shakaError = constants.SHAKA.ERROR;

            switch (event.code || (event.detail && event.detail.code)) {
                case shakaError.HTTP_ERROR.CODE:
                    debug.error('%c%s', 'color: #20b408', '[ShakaPlayer] HTTP_ERROR', event);
                    break;
                case shakaError.MEDIA_FORMAT_ERROR.CODE:
                    debug.error('%c%s', 'color: #20b408', '[ShakaPlayer] MEDIA_FORMAT_ERROR', event);
                    break;
                case shakaError.BAD_HTTP_STATUS.CODE:
                    changePlayerForFailover();
                    break;
                default:
                    debug.error('%c%s', 'color: #20b408', '[ShakaPlayer] onError ', event);
                    if (!state.autoplayFail && video && video.type !== 'AD') {
                        changePlayerForFailover();
                    } else {
                        if (dt.StopWatch.has('startPlay')) {
                            dt.StopWatch.stop('startPlay');
                        }

                        if (dt.StopWatch.has('rebuffering')) {
                            dt.StopWatch.stop('rebuffering');
                        }
                    }
                    break;
            }
        }

        return {
            init: function(player) {
                var self = this;

                window.shaka.polyfill.installAll();
                if (player.type === 'LIVE' || !this.isBrowserSupported()) {
                    return;
                }

                if (!this.videoElement) {
                    this.videoElement = player.videoElement;
                }

                if (!this.player || (this.player.getMediaElement && !this.player.getMediaElement())) {
                    this.player = new window.shaka.Player(this.videoElement);
                    this.castProxy = new window.shaka.cast.CastProxy(this.videoElement, this.player, 'app ID');

                    this.player.configure(
                        ua.platform === 'pc' ? constants.SHAKA.CONFIGURE.PC : constants.SHAKA.CONFIGURE.MOBILE
                    );
                    this.player.addEventListener('error', onErrorEvent);
                    shakaEvents.forEach(function(v) {
                        self.player.addEventListener(v, onShakaEvent);
                    });

                    exports.shakaPlayer = this.player;
                    exports.shakaPlayer.castProxy = this.castProxy;
                }
            },
            isBrowserSupported: function() {
                return window.shaka.Player.isBrowserSupported();
            },
            setManifestUri: function(url) {
                if (this.src === url) {
                    return;
                }

                var urlPath = url.substring(0, url.indexOf('?'));
                var queryString = url.substring(url.indexOf('?') + 1).replace(/\?/g, '&');

                this.src = urlPath;
                if (queryString) {
                    this.key = '?' + queryString;
                    this.src += '?' + queryString;
                }
            },
            load: function(callback) {
                var self = this;
                var storeABR = helpers.store.get(ABR_KEY);
                var storeProfile = helpers.store.get(PROFILE_KEY);

                this.unload();

                this.player.getNetworkingEngine().registerRequestFilter(function(type, request) {
                    if (!self.key) {
                        request.allowCrossSiteCredentials = true;
                    }

                    if (type === window.shaka.net.NetworkingEngine.RequestType.SEGMENT) {
                        if (request && request.uris && self.key) {
                            request.uris.forEach(function(v, i) {
                                if (request.uris[i].indexOf('?') === -1) {
                                    request.uris[i] += self.key;
                                }

                                if (request.headers.Range) {
                                    var range = request.headers.Range;
                                    var bytes = '';
                                    if (range.indexOf('bytes=') !== -1) {
                                        bytes = range.substring(range.indexOf('=') + 1, range.length);
                                        request.uris[i] += '&range=' + bytes;
                                        delete request.headers['Range'];
                                    }
                                }
                            });
                        }
                    }
                });

                this.player.getNetworkingEngine().registerResponseFilter(function(type, response) {
                    if (!response.fromCache && type === window.shaka.net.NetworkingEngine.RequestType.SEGMENT) {
                        var bandwidth = (response.data.byteLength * 8000) / response.timeMs;
                        bandwidthQueue.push(bandwidth);
                    }
                });

                if (storeABR === 'false' && ua.platform !== 'pc') {
                    var dashProfileList = constants.DASH_PROFILE;
                    for (var p in dashProfileList) {
                        if (dashProfileList.hasOwnProperty(p) && storeProfile === dashProfileList[p]) {
                            state.currentVideo.profile = p;
                            break;
                        }
                    }
                    state.needSetTrack = true;
                }

                this.player
                    .load(this.src)
                    .then(function() {
                        callback();
                    })
                    .catch(onErrorEvent);
            },
            unload: function() {
                try {
                    this.player.unload(true);
                    this.player.getNetworkingEngine().clearAllRequestFilters();
                    this.player.getNetworkingEngine().clearAllResponseFilters();
                } catch (e) {
                    debug.error('shaka:unload ', e);
                }
            },
            setTrack: function(index) {
                var config;
                var trackIndex;
                if (index === constants.PROFILE.AUTO) {
                    config = { abr: { enabled: true } };
                    this.player.configure(config);
                } else {
                    config = { abr: { enabled: false } };
                    trackIndex = this.tracks[index] ? index : 2;
                    state.currentVideo.profile = trackIndex;
                    this.player.configure(config);
                    this.player.selectVariantTrack(this.tracks[trackIndex], true);
                    this.prevProfile = this.tracks[trackIndex].originalVideoId;
                }
            },
            setConfig: function(config) {
                this.player.configure(config);
            },
            setPrevProfile: function(currentProfile) {
                this.prevProfile = currentProfile;
            },
            parseTracks: function(variantTrack) {
                var selectedAudio = null;
                var availableAudioList = ['AUDIO', '128-44100', '96-48000', '96-44100', '96-22050', null];
                var validTrack = [];
                var outputs = [];
                var profileIndex = 0;

                variantTrack.sort(function(a, b) {
                    return a.bandwidth > b.bandwidth ? 1 : a.bandwidth < b.bandwidth ? -1 : 0;
                });

                outputs.push({ profile: constants.PROFILE.AUTO, label: '자동' });

                variantTrack.forEach(function(v) {
                    if (
                        (availableAudioList.indexOf(v.originalAudioId) !== -1 && selectedAudio === null) ||
                        selectedAudio === v.audioId ||
                        v.originalId
                    ) {
                        if (selectedAudio === null && !v.originalId) {
                            selectedAudio = v.audioId;
                        }

                        var videoId = v.originalVideoId || v.originalId;
                        var profileResolution = constants.PROFILE_RESOULTION[videoId];
                        var label = profileResolution || videoId;

                        var isAlreadyExists = outputs.filter(function(output) {
                            return output.label === label;
                        });

                        if (isAlreadyExists.length === 0) {
                            validTrack.push(v);
                            outputs.push({
                                profile: profileIndex,
                                label: label
                            });
                            profileIndex++;
                        }
                    }
                });

                this.outputList = outputs;
                this.tracks = validTrack;
            },
            getOutputs: function(cb) {
                var self = this;
                var callback = cb;

                var variantTrack = this.player.getVariantTracks();
                this.parseTracks(variantTrack);

                if (this.tracks.length === 0) {
                    var parser = new window.shaka.dash.DashParser();

                    parser.configure({
                        retryParameters: null,
                        dash: {}
                    });
                    this.player.getNetworkingEngine().registerRequestFilter(function(type, request) {
                        if (!self.key) {
                            request.allowCrossSiteCredentials = true;
                        }
                    });
                    var playerInterface = {
                        networkingEngine: this.player.getNetworkingEngine(),
                        filterAllPeriods: function() {},
                        onError: onErrorEvent
                    };

                    parser
                        .start(this.src, playerInterface)
                        .then(function(e) {
                            var variants = e.periods[0].variants;
                            var tracks = [];

                            for (var i = 0; i < variants.length; i++) {
                                tracks.push(variants[i].video);
                            }

                            self.parseTracks(tracks);
                            callback(self.outputList);
                        })
                        .catch(function(e) {
                            debug.warn('shaka:getOutputs e.code = ', e.code);
                        });
                } else {
                    callback(this.outputList);
                }
            },
            getCurrentProfile: function() {
                var profile = '';
                var currentHeight = 0;

                if (this.player && this.tracks !== null) {
                    var stats = this.getStats();
                    currentHeight = stats && stats.height;

                    this.tracks.forEach(function(v) {
                        if (v.height === currentHeight) {
                            profile = constants.PROFILE_RESOULTION[v.originalVideoId]
                                ? constants.PROFILE_RESOULTION[v.originalVideoId]
                                : v.originalVideoId || '';
                        }
                    });
                }

                return profile;
            },
            getDropFrames: function() {
                var stats;
                var dropFrames = 0;

                if (!this.player) {
                    return false;
                }

                stats = this.getStats();
                if (stats && stats.droppedFrames) {
                    dropFrames = stats.droppedFrames - this.preDropFrames;
                    this.preDropFrames = stats.droppedFrames;
                }

                return dropFrames;
            },
            getBandwidth: function() {
                var avgBandwidth = 0;

                if (!this.player) {
                    return false;
                }

                if (bandwidthQueue.length > 0) {
                    avgBandwidth =
                        bandwidthQueue.reduce(function(a, b) {
                            return a + b;
                        }) / bandwidthQueue.length;
                }

                bandwidthQueue = [];
                var stats = this.getStats();
                var ewmaBandwidth = stats && stats.estimatedBandwidth && stats.estimatedBandwidth.toFixed(0) / 1000;
                if (!isNaN(ewmaBandwidth)) {
                    debug.tooltip('[shaka] EWMA Bandwidth = ', ewmaBandwidth.toFixed(0) + 'Kbps');
                }

                return parseInt(avgBandwidth.toFixed(0), 10);
            },
            getStats: function() {
                var stats = {};

                try {
                    stats = this.player.getStats();
                } catch (e) {
                    debug.log('[shaka error] getStats ', e);
                }

                return stats;
            },
            getPrevProfile: function() {
                return this.prevProfile;
            },
            setTextTrack: function(subtitle) {
                this.player.setTextTrackVisibility(false);

                if (subtitle !== constants.SUBTITLE.STATUS.OFF) {
                    var selectTrack = null;
                    this.player.getTextTracks().forEach(function(v) {
                        if (v.language === subtitle) {
                            selectTrack = v;
                        }
                    });

                    if (selectTrack !== null) {
                        this.player.selectTextTrack(selectTrack);
                        this.player.setTextTrackVisibility(true);
                    }
                }
            },
            getTextTracks: function() {
                var textTracks = [];
                this.player.getTextTracks().forEach(function(v) {
                    textTracks.push({ language: v.language });
                });

                return textTracks;
            },
            detach: function() {
                this.unload();
                return this.player.detach();
            },
            attach: function(videoElement) {
                return this.player.attach(videoElement);
            },
            reset: function(videoElement) {
                var shaka = this;

                return shaka.detach().then(function() {
                    return shaka.attach(videoElement);
                });
            }
        };
    })();

    exports.addModule('player.shaka', new ShakaPlayer());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';

    var constants = exports.constants;
    var helpers = exports.helpers;
    var debug = helpers.debug;
    var ERROR_STATUS = constants.ERROR.STATUS;
    var state = exports.loadModule('controller.state');
    var isInstalledExtension = null;
    var isInstalledLiveAgent = null;

    function KampPlayer() {
        this.player = null;
        this.videoElement = null;
        this.videoUrl = null;
    }

    KampPlayer.prototype = (function() {
        function onNeedInstall() {
            if (state.currentVideo.contentType === constants.CONTENT_TYPE.NPP) {
                debug.info('Live Agent 실행 또는 설치가 필요합니다.');
                exports.queue.emit('show:error', {
                    info: {
                        code: ERROR_STATUS.LiveAgentNotInstalled.NAME,
                        profile: constants.PROFILE.HIGH
                    }
                });
            }
        }

        function onInstalled() {
            debug.info('Live Agent 설치되어, 실행 중 입니다.');
        }

        function onConnectedAgent() {
            debug.info('Live Agent와 연결이 되었습니다.');
        }

        function onDisconnectedAgent() {
            debug.info('Live Agent와 연결이 끊겼습니다.');
            exports.queue.emit('show:error', {
                info: {
                    code: ERROR_STATUS.NETWORK_OFFLINE.NAME
                }
            });
            helpers.sentry.captureMessage('Live Agent와 연결이 끊겼습니다.');
        }

        function checkInstalled() {
            try {
                if (window.kamp) {
                    window.kamp.util.checkLiveAgent(function(isInstalledExt, isInstalledAgent) {
                        isInstalledExtension = isInstalledExt;
                        isInstalledLiveAgent = isInstalledAgent;
                    });
                } else {
                    isInstalledLiveAgent = false;
                }
            } catch (e) {
                isInstalledLiveAgent = false;
            }
        }

        function checkForAgentInstallation(profile) {
            if (window.kamp) {
                window.kamp.util.checkForAgentInstallation(function(err) {
                    if (err) {
                        debug.info('Live Agent 설치가 되지 않았습니다.');
                        return;
                    }
                    isInstalledLiveAgent = true;
                    exports.queue.emit('live:getLocation', profile);
                    exports.queue.emit('hide:error');
                    debug.info('Live Agent 설치가 완료 되었습니다.');
                });
            }
        }

        function checkForExtInstallation(profile) {
            if (window.kamp) {
                window.kamp.util.checkForExtInstallation(function(err) {
                    if (err) {
                        debug.info('Chrome Extension 설치가 되지 않았습니다.');
                        return;
                    }
                    isInstalledExtension = true;
                    exports.queue.emit('live:updateSetupView', profile);
                    checkForAgentInstallation(profile);
                    debug.info('Chrome Extension 설치가 완료 되었습니다.');
                });
            }
        }

        function onClosed() {
            exports.queue.emit('reset:playList');
            exports.queue.emit('onClosed:videoEvent');
        }

        function bindEvent(player) {
            player.on('onconnected', onConnectedAgent);
            player.on('ondisconnected', onDisconnectedAgent);
            player.on('closed', onClosed);
            player.tech().on('needInstallLiveAgent', onNeedInstall);
            player.tech().on('installedLiveAgent', onInstalled);
        }

        return {
            init: function(player) {
                this.videoElement = player.videoElement;
                checkInstalled();
            },
            load: function(videoUrl) {
                if (videoUrl) {
                    this.videoUrl = videoUrl;
                }

                var mediaType = constants.MEDIA_TYPE[state.currentVideo.contentType];
                var sourceDatas = {
                    src: this.videoUrl,
                    type: mediaType
                };
                var options = {
                    autoplay: true,
                    techOrder: ['Kamp', 'Html5'],
                    controls: false,
                    preload: 'auto',
                    muted: true,
                    children: ['MediaLoader']
                };

                if (window.videojs) {
                    this.player = window.videojs(this.videoElement, options);
                    exports.kampPlayer = this.player;

                    bindEvent(exports.kampPlayer);
                }

                this.player.src(sourceDatas);
                this.videoElement = this.player.$('video');
                exports.queue.emit('addlistener:videoEvent', this.player.$('video'));

                this.player.play();
            },
            isReady: function() {
                if (this.player) {
                    return this.player.isReady_;
                }
                return false;
            },
            pause: function() {
                if (!this.videoElement.paused) {
                    this.player.pause();
                }
            },
            play: function() {
                if (this.videoElement.paused || this.videoElement.ended) {
                    return this.player.play();
                }
            },
            stop: function() {
                this.player.pause();
            },
            isPaused: function() {
                return this.player.paused();
            },
            setVolume: function(volume) {
                this.player.volume(volume);
            },
            setMute: function(muted) {
                this.player.muted(muted);
            },
            getCurrentTimeRound: function() {
                return Math.round(this.player.$('video').currentTime);
            },
            getCurrentTime: function() {
                return this.player.$('video').currentTime;
            },
            isSupported: function() {
                return window.kamp ? window.kamp.isSupportedWebRTC() : false;
            },
            isSupportedLiveAgentHLS: function() {
                return window.kamp ? window.kamp.isSupportedLiveAgentHLS() : false;
            },
            isInstalledLiveAgent: function() {
                return isInstalledLiveAgent;
            },
            isInstalledExtension: function() {
                return isInstalledExtension;
            },
            checkForAgentInstallation: function(profile) {
                checkForAgentInstallation(profile);
            },
            checkForExtInstallation: function(profile) {
                checkForExtInstallation(profile);
            }
        };
    })();

    exports.addModule('player.kamp', new KampPlayer());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var state = exports.loadModule('controller.state');

    function CastPlayer() {
        this.videoElement = null;
    }

    CastPlayer.prototype = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;

        var chrome = {};
        var session = {};

        function loadCastPlay(videoInfo) {
            chrome = window.chrome;

            var bean = state.currentVideo;
            var videoUrl = videoInfo.url;
            var mediaType = videoInfo.mediaType;
            var mediaInfo = new chrome.cast.media.MediaInfo(videoUrl, mediaType);

            mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
            mediaInfo.metadata.metadataType = chrome.cast.media.MetadataType.GENERIC;
            mediaInfo.metadata.title = bean.title;
            mediaInfo.metadata.images = [{ url: bean.coverUrl }];

            var request = new chrome.cast.media.LoadRequest(mediaInfo);
            session = window.cast.framework.CastContext.getInstance().getCurrentSession();
            return session.loadMedia(request);
        }

        function onErrorEvent(error) {
            var errorCode = chrome.cast.ErrorCode;

            switch (error.code) {
                case errorCode.API_NOT_INITIALIZED:
                    debug.error('[CastPlayer] API_NOT_INITIALIZED: ' + error.description);
                    break;
                case errorCode.SESSION_ERROR:
                    debug.error('[CastPlayer] SESSION_ERROR: ' + error.description);
                    break;
                default:
                    debug.log('[CastPlayer] On Error: ' + error);
                    break;
            }
        }

        return {
            init: function() {
                this.el = {};
                this.originPlayer = {};
                this.name = 'castPlayer';
                this.player = {};
                this.controller = {};
                this.activate = false;
            },
            setPlayer: function(originPlayer, player, controller) {
                this.el = this.videoElement = originPlayer.videoElement;
                this.originPlayer = originPlayer;
                this.player = player || this.player;
                this.controller = controller || this.controller;
            },
            load: function(videoInfo, start, callback) {
                var player = this;
                this.activate = true;

                loadCastPlay(videoInfo)
                    .then(function() {
                        if (start > 0) {
                            player.seekTo(start);
                        }

                        if (callback) {
                            callback();
                        }

                        player.play();
                    })
                    .catch(onErrorEvent);
            },
            play: function() {
                if (this.player.isPaused) {
                    this.controller.playOrPause();
                }
            },
            stop: function() {
                this.controller.stop();

                if (session.endSession) {
                    session.endSession(true);
                }
            },
            pause: function() {
                if (!this.player.isPaused) {
                    this.controller.playOrPause();
                }
            },
            setVolume: function(volume) {
                this.player.volumeLevel = parseFloat(volume);
                this.controller.setVolumeLevel();
            },
            getVolume: function() {
                return this.player.volumeLevel;
            },
            setMute: function(muted) {
                if (this.player.isMuted && !muted) {
                    this.controller.muteOrUnmute();
                } else if (!this.player.isMuted && muted) {
                    this.controller.muteOrUnmute();
                }
            },
            getMute: function() {
                return this.player.isMuted;
            },
            setTime: function(time) {
                this.el.setAttribute('data-current-time', time);
            },
            seekTo: function(time) {
                this.player.currentTime = time;
                this.controller.seek();
            },
            getDurationRound: function() {
                var duration = this.player.duration ? this.player.duration : 1;
                return Math.round(duration);
            },
            getCurrentTimeRound: function() {
                return Math.round(this.getCurrentTime());
            },
            getCurrentTime: function() {
                return this.player.currentTime ? this.player.currentTime : 0;
            },
            getPlayerInstance: function() {
                return this;
            },
            isPaused: function() {
                return this.player.isPaused;
            },
            isReady: function() {
                return this.activate;
            },
            getSession: function() {
                return session;
            }
        };
    })();

    exports.addModule('player.cast', new CastPlayer());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';
    var state = exports.loadModule('controller.state');
    var html5 = exports.loadModule('player.html5');
    var kamp = exports.loadModule('player.kamp');
    var shaka = exports.loadModule('player.shaka');
    var cast = exports.loadModule('player.cast');

    function PlayerAdapter() {}

    PlayerAdapter.prototype = (function() {
        var constants = exports.constants;

        return {
            init: function(player) {
                this.player = html5;
                this.videoElement = player.videoElement;
                this.name = 'player';
                this.type = player.type;
                this.duration = 0;
            },
            load: function(loadDatas) {
                var videoUrl = loadDatas.videoUrl;
                var callback = loadDatas.callback;
                var playerClass = loadDatas.playerClass;
                var muted = this.videoElement.muted;
                var volume = this.videoElement.volume;
                this.duration = 0;
                var remote = loadDatas.remote;

                if (playerClass === constants.PLAYERCLASS.KAMP) {
                    kamp.load(videoUrl);
                    kamp.setMute(muted);
                    kamp.setVolume(volume);
                    this.player = kamp;
                } else if (playerClass === constants.PLAYERCLASS.SHAKA) {
                    shaka.load(callback);
                } else if (playerClass === constants.PLAYERCLASS.CAST) {
                    cast.setPlayer(this.player, remote.player, remote.controller);
                    cast.load(remote.videoInfo, remote.start, callback);
                    this.player = cast;
                } else {
                    if (videoUrl.indexOf('m3u8') > -1) {
                        html5.setCredential();
                    }
                    html5.setVideoSource(videoUrl);
                    html5.load();
                }
                this.videoElement = this.player.videoElement;
            },
            play: function() {
                if (this.player.play) {
                    return this.player.play();
                }
            },
            pause: function() {
                if (this.player.pause) {
                    this.player.pause();
                }
            },
            stop: function() {
                if (this.player.stop) {
                    this.player.stop();
                }
            },
            reset: function() {
                this.player.reset();
            },
            setVolume: function(volume) {
                this.player.setVolume(volume);
            },
            getVolume: function() {
                return this.videoElement.volume;
            },
            setMute: function(muted) {
                this.player.setMute(muted);
            },
            getMute: function() {
                if (this.player.getMute) {
                    return this.player.getMute();
                }
                return this.videoElement.muted;
            },
            setTime: function(time) {
                if (this.player.setTime) {
                    this.player.setTime(time);
                }
            },
            seekTo: function(time) {
                if (this.player.seekTo) {
                    this.videoElement.setAttribute('data-time-before-seek', this.getCurrentTimeRound());
                    this.player.seekTo(time);
                }
            },
            setVideoSource: function(url) {
                if (this.player.setVideoSource) {
                    this.player.setVideoSource(url);
                }
            },
            setPlaybackRate: function(rate, calcMode) {
                if (this.player.setPlaybackRate) {
                    return this.player.setPlaybackRate(rate, calcMode);
                }
            },
            getPlaybackRate: function() {
                if (this.player.getPlaybackRate) {
                    return this.player.getPlaybackRate();
                }
            },
            setDuration: function(duration) {
                this.duration = duration;
            },
            getDurationRound: function() {
                if (this.duration > 0) {
                    return this.duration;
                }

                if (this.player.getDurationRound) {
                    return this.player.getDurationRound();
                }
            },
            getCurrentTimeRound: function() {
                if (this.player.getCurrentTimeRound) {
                    return this.player.getCurrentTimeRound();
                }
            },
            getCurrentTime: function() {
                if (this.player.getCurrentTime) {
                    return this.player.getCurrentTime();
                }
            },
            getPlayerInstance: function() {
                if (this.player.getPlayerInstance) {
                    return this.player.getPlayerInstance();
                }
            },
            getOriginPlayer: function() {
                if (this.player.originPlayer) {
                    return this.player.originPlayer;
                }
            },
            isPaused: function() {
                if (this.player.isPaused) {
                    return this.player.isPaused();
                }
            },
            isReady: function() {
                if (this.player.isReady) {
                    return this.player.isReady();
                }
            },
            isKampSupported: function() {
                return kamp.isSupported();
            },
            isSupportedLiveAgentHLS: function() {
                return kamp.isSupportedLiveAgentHLS();
            },
            isInstalledLiveAgent: function() {
                return kamp.isInstalledLiveAgent();
            },
            isInstalledExtension: function() {
                return kamp.isInstalledExtension();
            },
            checkForAgentInstallation: function(profile) {
                kamp.checkForAgentInstallation(profile);
            },
            checkForExtInstallation: function(profile) {
                kamp.checkForExtInstallation(profile);
            },
            setTextTrack: function(subtitle) {
                if (state.dash) {
                    shaka.setTextTrack(subtitle);
                } else {
                    if (this.player.setTextTrack) {
                        this.player.setTextTrack(subtitle);
                    }
                }
            },
            getTextTracks: function() {
                var textTracks = [];
                if (state.dash) {
                    textTracks = shaka.getTextTracks();
                } else {
                    if (this.player.getTextTracks) {
                        textTracks = this.player.getTextTracks();
                    }
                }
                return textTracks;
            },
            getBeforeSeekedTime: function() {
                return this.videoElement.getAttribute('data-time-before-seek');
            }
        };
    })();

    exports.addModule('player.adapter', new PlayerAdapter());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var A11y;

    A11y = (function() {
        function A11Y() {}

        A11Y.prototype.init = function() {};

        A11Y.prototype.setAria = function(target, attr, value) {
            target.setAttribute('aria-' + attr, value);
        };

        A11Y.prototype.removeAria = function(target, attr) {
            target.removeAttribute('aria-' + attr);
        };

        A11Y.prototype.onTabIndex = function(target) {
            target.setAttribute('tabindex', '0');
        };

        A11Y.prototype.offTabIndex = function(target) {
            target.setAttribute('tabindex', '-1');
        };

        A11Y.prototype.removeTabIndex = function(target) {
            target.removeAttribute('tabindex');
        };

        return A11Y;
    })();
    exports.addModule('etc.a11y', new A11y());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var state = exports.loadModule('controller.state');
    var PCTTracker;

    PCTTracker = (function() {
        var helpers = exports.helpers;
        var constants = exports.constants;
        var debug = helpers.debug;

        function track(url) {
            helpers.http.sendBeacon(url);
        }

        function PCTTracker() {}

        function setExternalData(data) {
            data.protocol = state.dash ? constants.CONTENT_TYPE.DASH : constants.CONTENT_TYPE.MP4;
            return data;
        }

        PCTTracker.prototype.init = function() {
            debug.log('[pct:tracker] initialized');
        };

        PCTTracker.prototype.create = function(pct) {
            this.url = pct.url;
        };

        PCTTracker.prototype.track = function(literal1, literal2) {
            var defaults = {
                literal1: literal1 || '',
                literal2: literal2 || ''
            };

            defaults = setExternalData(defaults);

            if (typeof this.url !== 'undefined') {
                this.trackURLs(this.url, defaults);

                debug.info('[pct:tracker] click event params', defaults);
            }
        };

        PCTTracker.prototype.trackURLs = function(url, variables) {
            var queryString = helpers.string.jsonToQueryString(variables);
            var trackUrl = url + '&' + queryString;

            return track(trackUrl);
        };

        return PCTTracker;
    })();

    exports.addModule('pct.tracker', new PCTTracker());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var state = exports.loadModule('controller.state');

    var PVTTracker = (function() {
        var helpers = exports.helpers;
        var constants = exports.constants;
        var debug = helpers.debug;
        var connection = helpers.webapi.network.getConnection();

        var intervalTimer = null;
        var passedByTimer = {};

        function track(trackingURL) {
            var results = [];
            var url;
            var externalData = {};

            if (!Array.isArray(trackingURL)) {
                externalData = setExternalData(externalData);
                url = trackingURL.shift();
                url += '&' + helpers.string.jsonToQueryString(externalData);
                helpers.http.sendBeacon(url);
                return trackingURL;
            } else {
                while (trackingURL.length > 0) {
                    if (typeof window !== 'undefined' && window !== null) {
                        externalData = setExternalData(externalData);
                        url = trackingURL.shift();
                        url += '&' + helpers.string.jsonToQueryString(externalData);
                        results.push(helpers.http.sendBeacon(url));
                    }
                }
                return results;
            }
        }

        function trackPassedByTime(_url, eventName, delay) {
            if (passedByTimer[delay]) {
                return;
            }

            passedByTimer[delay] = new dt.Timer(function() {
                debug.log('%c%s', 'color: #795548;', '[pvt:tracker]', eventName, _url);

                if (passedByTimer[delay]) {
                    passedByTimer[delay].clear();
                    passedByTimer[delay] = null;
                }
                track(_url);
            }, delay * 1000);
            passedByTimer[delay].start();
        }

        function trackIntervalTime(_url, eventName, _delay) {
            if (typeof _delay !== 'number') {
                return;
            }

            var intervalCallback = function() {
                var url = [];
                var time = player.getCurrentTimeRound();
                var connectionType = (connection && connection.type) || 'unknown';

                for (var i = 0; i < _url.length; i++) {
                    var urlReplace = _url[i];

                    if (urlReplace.includes('[[curt]]')) {
                        urlReplace = urlReplace.replace('[[curt]]', time);
                    }

                    if (urlReplace.includes('[[connt]]')) {
                        urlReplace = urlReplace.replace('[[connt]]', connectionType);
                    }

                    url.push(urlReplace);
                }

                debug.log('%c%s', 'color: #795548;', '[pvt:tracker]', eventName, url);
                track(url);
            };

            intervalTimer = new dt.Interval(intervalCallback, _delay * 1000);
            intervalTimer.start();
        }

        function PVTTracker() {
            this.pvtEvents = ['impression', 'start', 'playing:interval', 'profile_change', 'complete'];
        }

        function setExternalData(data) {
            data.protocol = state.dash ? constants.CONTENT_TYPE.DASH : constants.CONTENT_TYPE.MP4;
            return data;
        }

        function applyRunningTimers(pause) {
            for (var timer in passedByTimer) {
                if (passedByTimer.hasOwnProperty(timer) && passedByTimer[timer]) {
                    if (pause) {
                        passedByTimer[timer].pause();
                    } else {
                        passedByTimer[timer].resume();
                    }
                }
            }
        }

        PVTTracker.prototype.init = function(player, sandbox) {
            this.sandbox = sandbox;
            this.startedTracking = false;
            debug.log('[pvt:tracker] initialized');
        };

        PVTTracker.prototype.clear = function() {
            this.startedTracking = false;

            if (intervalTimer) {
                intervalTimer.stop();
                intervalTimer = null;
            }

            for (var timer in passedByTimer) {
                if (passedByTimer.hasOwnProperty(timer) && passedByTimer[timer]) {
                    passedByTimer[timer].clear();
                    passedByTimer = {};
                }
            }
        };

        PVTTracker.prototype.create = function(pvt) {
            var eventName, tracking, duration, time, eventtype;

            if (this.startedTracking) {
                return;
            }

            this.trackingEvents = {};

            this.pvt = pvt;
            this.offsetTiles = [];
            this.runningTiles = [];

            this.assetDuration = -1;

            if (!this.pvt.events) {
                return;
            }

            tracking = this.pvt.events;
            duration = player.getDurationRound();

            for (var item in tracking) {
                if (tracking.hasOwnProperty(item)) {
                    eventName = tracking[item].name;
                    eventtype = tracking[item].type;
                    time = tracking[item].time;

                    if (eventName === 'playing') {
                        if (eventtype === 'interval') {
                            this.interval = time;
                            eventName += ':interval';
                        } else if (eventtype === 'offset') {
                            eventName += ':offset-' + time;
                            this.offsetTiles[eventName] = time;
                        } else if (eventtype === 'running_time') {
                            eventName += ':running_time-' + time;
                            this.runningTiles[eventName] = time;
                        }
                    }

                    if (!this.trackingEvents[eventName]) {
                        this.trackingEvents[eventName] = [];
                    }

                    this.trackingEvents[eventName].push(tracking[item].url);
                }
            }

            this.setDuration(duration);
        };

        PVTTracker.prototype.setDuration = function(duration) {
            if (this.assetDuration > 0) {
                return;
            }

            if (!(duration > 1)) {
                return;
            }

            this.assetDuration = duration;
        };

        PVTTracker.prototype.setProgress = function(progress) {
            var eventName, events, time, ref, rtTime, rtRef;
            var trackingURL;

            if (this.pvt && progress > 0) {
                events = [];
                events.push('start');

                if (!this.startedTracking) {
                    this.startedTracking = true;

                    eventName = 'playing:interval';
                    trackingURL = this.trackingEvents[eventName];
                    if (trackingURL && !intervalTimer) {
                        trackIntervalTime(trackingURL, eventName, this.interval);
                    }

                    rtRef = this.runningTiles;

                    for (var runningTile in rtRef) {
                        rtTime = rtRef[runningTile];

                        eventName = 'playing:running_time-' + rtTime;
                        trackingURL = this.trackingEvents[eventName];
                        trackPassedByTime(trackingURL, eventName, rtTime);
                    }
                }

                ref = this.offsetTiles;
                for (var offsetTile in ref) {
                    time = ref[offsetTile];

                    if (time === progress) {
                        events.push(offsetTile);
                    }
                }

                for (var i = 0, len = events.length; i < len; i++) {
                    eventName = events[i];
                    this.track(eventName, true);
                }
            }
        };

        PVTTracker.prototype.complete = function() {
            this.clear();
            return this.track('complete');
        };

        PVTTracker.prototype.track = function(eventName, once) {
            var idx, trackingURL;
            if (once == null) {
                once = false;
            }

            trackingURL = this.trackingEvents && this.trackingEvents[eventName];

            idx = this.pvtEvents.indexOf(eventName);
            if (trackingURL != null) {
                this.emit(eventName, '');

                while (trackingURL.length > 0) {
                    debug.log('%c%s', 'color: #795548;', '[pvt:tracker]', eventName);

                    this.trackURLs(trackingURL);
                }
            }

            if (once === true) {
                delete this.trackingEvents[eventName];
                if (idx > -1) {
                    this.pvtEvents.splice(idx, 1);
                }
            }
        };

        PVTTracker.prototype.trackURLs = function(url, variables) {
            if (variables == null) {
                variables = {};
            }

            return track(url, variables);
        };

        PVTTracker.prototype.emit = function(event, param) {
            this.sandbox.emit(event, param);
        };

        PVTTracker.prototype.on = function(event, callback) {
            this.sandbox.on(event, callback);
        };

        PVTTracker.prototype.off = function(event, callback) {
            this.sandbox.off(event, callback);
        };

        PVTTracker.prototype.pause = function() {
            if (intervalTimer && intervalTimer.isRunning) {
                intervalTimer.stop();
            }

            applyRunningTimers(true);
        };

        PVTTracker.prototype.resume = function() {
            if (intervalTimer && !intervalTimer.isRunning) {
                intervalTimer.start();
            }

            applyRunningTimers(false);
        };

        PVTTracker.prototype.end = function(playingTime) {
            var endUrl = this.trackingEvents && this.trackingEvents['end'];

            if (endUrl) {
                endUrl[0] = endUrl[0].replace('[[playTime]]', playingTime);
                helpers.http
                    .fetch(endUrl[0], {
                        async: true,
                        timeout: 1000,
                        type: constants.HTTP.TYPE.JSON,
                        keepalive: true
                    })
                    .then(function() {
                        debug.info('PVTTracker::end Call Log Success');
                    })
                    .catch(function(e) {
                        debug.warn('PVTTracker::end Call Log Error e = ', e);
                    });
            }
        };

        return PVTTracker;
    })();

    exports.addModule('pvt.tracker', new PVTTracker());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var shaka = exports.loadModule('player.shaka');
    var player = exports.loadModule('player.adapter');
    var state = exports.loadModule('controller.state');
    var QOETracker;

    QOETracker = (function() {
        var helpers = exports.helpers;
        var constants = exports.constants;
        var debug = helpers.debug;
        var connection = helpers.webapi.network.getConnection();
        var qoeUrl = '';
        var events = [];
        var intervalEvents = {};
        var intervalCallback = {};
        var qoeEvent = constants.QOE.EVENT;

        function track(eventName, data) {
            var qoeData = data;
            debug.info('[qoe:tracker] Qoe Tracking name = ', eventName, data);
            if (eventName === qoeEvent.REBUFFERING) {
                debug.tooltip('[qoe:tracker] Qoe Tracking name = ' + eventName, ' data = ' + (data.l1 || data.n1));
            } else if (eventName === qoeEvent.RESOLUTION_CHANGE) {
                debug.tooltip(
                    '[qoe:tracker] Qoe Tracking name = ' + eventName,
                    ' literal1 = ' + data.l1 + ', resolution = ' + data.resolution
                );
            }

            if (typeof qoeUrl === 'undefined' || !qoeUrl) {
                return;
            }

            qoeData.event = getEventName(eventName);
            qoeData = setExternalData(qoeData, eventName);

            helpers.http
                .fetch(qoeUrl, {
                    async: true,
                    type: constants.HTTP.TYPE.JSON,
                    method: constants.HTTP.METHOD.POST,
                    body: JSON.stringify(qoeData),
                    contentType: 'text/plain;charset=UTF-8'
                })
                .then(function() {
                    debug.info('qoeTracker::complete Call Log Success');
                })
                .catch(function() {
                    debug.warn('qoeTracker::complete Call Log Error');
                });
        }

        function QOETracker() {}

        function bandwidthTrack() {
            var bandwidth = shaka.getBandwidth();
            var resolution;
            var connectionType;

            if (!bandwidth || !state.currentVideo || !state.currentVideo.profile) {
                return;
            }

            resolution = shaka.getCurrentProfile();
            connectionType = (connection && connection.type) || 'unknown';
            resolution = state.currentVideo.profile === 'AUTO' ? resolution : 'manual_' + resolution;
            if ((!player.videoElement.paused || bandwidth > 0) && state.dash) {
                bandwidth = bandwidth === 0 ? null : bandwidth;
                track(qoeEvent.BANDWIDTH, {
                    n1: bandwidth,
                    connt: connectionType,
                    rslu: resolution
                });
            }
        }

        function dropFrameTrack() {
            var dropFrame = shaka.getDropFrames();
            if (dropFrame && parseInt(dropFrame, 10) > 0 && state.dash) {
                track(qoeEvent.FRAME_DROP, { n1: dropFrame });
            }
        }

        function createInterval(name, time) {
            if (intervalCallback[name]) {
                if (intervalEvents[name]) {
                    intervalEvents[name].stop();
                }
                intervalEvents[name] = new dt.Interval(intervalCallback[name], time * 1000);
                intervalEvents[name].start();
            }
        }

        function setExternalData(data, eventName) {
            if (eventName === qoeEvent.PLAYBACK_FAIL) {
                data.protocol = constants.CONTENT_TYPE.DASH;
            } else {
                data.protocol = state.dash ? constants.CONTENT_TYPE.DASH : constants.CONTENT_TYPE.MP4;
            }
            return data;
        }

        function getEventName(type) {
            for (var item in events) {
                if (events.hasOwnProperty(item) && events[item].type === type) {
                    return events[item].name;
                } else if (events[item].type === 'interval') {
                    return type;
                }
            }
        }

        QOETracker.prototype.init = function() {
            debug.log('[qoe:tracker] initialized');
            events = [];

            intervalCallback[qoeEvent.FRAME_DROP] = dropFrameTrack;
            intervalCallback[qoeEvent.BANDWIDTH] = bandwidthTrack;
        };

        QOETracker.prototype.create = function(qoe) {
            var eventName, time, eventType;

            events = qoe && qoe.events;
            qoeUrl = qoe && qoe.url;

            for (var item in events) {
                if (events.hasOwnProperty(item)) {
                    eventName = events[item].name;
                    eventType = events[item].type;

                    if (eventType === 'interval') {
                        time = events[item].time;
                        createInterval(eventName, time);
                    }
                }
            }
        };

        QOETracker.prototype.track = function(eventName, data) {
            track(eventName, data);
        };

        QOETracker.prototype.clear = function() {
            for (var item in intervalEvents) {
                if (intervalEvents.hasOwnProperty(item)) {
                    intervalEvents[item].stop();
                }
            }
        };

        return QOETracker;
    })();

    exports.addModule('qoe.tracker', new QOETracker());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var helpers = exports.helpers;
    var debug = helpers.debug;
    var constants = exports.constants;
    var vastLogData = {
        videoUrl: '',
        vastDuration: '',
        videoDuration: '',
        unTrackingEvents: []
    };

    function track(url) {
        if (!Array.isArray(url)) {
            helpers.http.sendBeacon(url);
            return url;
        } else {
            var results = [];

            for (var i = 0; i < url.length; i++) {
                if (typeof window !== 'undefined' && window !== null) {
                    results.push(helpers.http.sendBeacon(url[i]));
                }
            }
        }

        return results;
    }

    var ExtensionTracker = (function() {
        function ExtensionTracker() {}

        ExtensionTracker.prototype.create = function(extensions) {
            var textAd = extensions[0].customObject.TextAd;
            debug.info('%c%s', 'color: #9c27b0;', '[vast:extensionTracker] created');
            debug.table(extensions);

            if (!textAd) {
                return;
            }

            this.impression = [].concat(textAd.Impression);
            this.clickTracking = [].concat(textAd.ClickTracking);
        };

        ExtensionTracker.prototype.click = function() {
            while (this.clickTracking.length > 0) {
                var uri = this.clickTracking.shift();
                track(uri);
                debug.info('%c%s', 'color: #9c27b0;', '[vast:extensionTracker] click');
            }
        };

        ExtensionTracker.prototype.load = function() {
            while (this.impression && this.impression.length > 0) {
                var uri = this.impression.shift();
                track(uri);
                debug.info('%c%s', 'color: #9c27b0;', '[vast:extensionTracker creativeView]');
            }
        };

        return ExtensionTracker;
    })();

    var MidTextAdTracker = (function() {
        function MidTextAdTracker() {}

        MidTextAdTracker.prototype.create = function(midTextAd) {
            debug.info('%c%s', 'color: #9c27b0;', '[vast:MidTextAdTracker] created');
            debug.table(midTextAd);

            this.impression = [].concat(midTextAd.Impression);
            this.clickTracking = [].concat(midTextAd.ClickTracking);
        };

        MidTextAdTracker.prototype.click = function() {
            while (this.clickTracking.length > 0) {
                var uri = this.clickTracking.shift();
                track(uri);
                debug.info('%c%s', 'color: #9c27b0;', '[vast:MidTextAdTracker] click');
            }
        };

        MidTextAdTracker.prototype.load = function() {
            while (this.impression.length > 0) {
                var url = this.impression.shift();
                track(url);
                debug.info('%c%s', 'color: #9c27b0;', '[vast:MidTextAdTracker creativeView]');
            }
        };

        return MidTextAdTracker;
    })();

    var MidImageAdTracker = (function() {
        function MidImageAdTracker() {}

        MidImageAdTracker.prototype.create = function(remindBanner) {
            debug.info('%c%s', 'color: #9c27b0;', '[vast:MidImageAdTracker] created');
            debug.table(remindBanner);

            this.impression = [].concat(remindBanner.Impression);
            this.clickTracking = [].concat(remindBanner.ClickTracking);
        };

        MidImageAdTracker.prototype.click = function() {
            while (this.clickTracking.length > 0) {
                var uri = this.clickTracking.shift();
                track(uri);
                debug.info('%c%s', 'color: #9c27b0;', '[vast:MidImageAdTracker] click');
            }
        };

        MidImageAdTracker.prototype.load = function() {
            while (this.impression.length > 0) {
                var url = this.impression.shift();
                track(url);
                debug.info('%c%s', 'color: #9c27b0;', '[vast:MidImageAdTracker creativeView]');
            }
        };

        return MidImageAdTracker;
    })();

    var VASTTracker = (function() {
        function VASTTracker() {
            this.skipDelayDefault = -1;
            this.trackingEvents = {};
            this.vastEvents = [
                'creativeView',
                'start',
                'firstQuartile',
                'midpoint',
                'thirdQuartile',
                'complete',
                'resume',
                'pause',
                'rewind',
                'skip',
                'closeLinear',
                'close'
            ];
        }

        VASTTracker.prototype.init = function(player, sandbox) {
            this.videoEl = player.videoElement;
            this.sandbox = sandbox;

            debug.log('[vast:tracker] initialized');
        };

        VASTTracker.prototype.create = function(ad, creative) {
            this.trackingEvents = {};
            this.muteOn = false;
            this.impressed = false;
            this.skipable = false;
            this.assetDuration = -1;

            this.ad = ad;
            this.impressions = this.ad.inline.impression;
            this.errors = this.ad.inline.error;

            if (creative.linear) {
                this.linear = creative.linear;

                var trackings = this.linear.trackingEvents.tracking;

                var clicks = this.linear.videoClicks;
                var skipoffset = this.linear.skipoffset;

                var creativeExtension = creative.creativeExtensions && creative.creativeExtensions.creativeExtension;

                if (creativeExtension && creativeExtension.length > 0) {
                    this.extension = new ExtensionTracker();
                    this.extension.create(creativeExtension);
                }

                var i = 0;
                while (i < trackings.length) {
                    var eventName = trackings[i]['@_event'];

                    if (eventName === 'progress') {
                        var offset = trackings[i]['@_offset'];

                        if (offset) {
                            eventName = 'progress-' + helpers.date.hhmmssToDate(offset).getSeconds();
                        }
                    }

                    if (!this.trackingEvents[eventName]) {
                        this.trackingEvents[eventName] = [];
                    }
                    this.trackingEvents[eventName].push(trackings[i]['@_uri']);
                    i++;
                }

                this.skipDelay = skipoffset;

                if (clicks) {
                    this.videoClickThrough = clicks.clickThrough;
                    this.videoClickTracking = clicks.clickTracking;
                }
                debug.info('%c%s', 'color: #607d8b;', '[vast:tracker] created');
                debug.table(this.trackingEvents);
            } else {
                this.skipDelay = -1;
            }
        };

        VASTTracker.prototype.setNonLinearTracker = function(extensions) {
            if (extensions) {
                this.midTextAdTracker = new MidTextAdTracker();
                this.midImageAdTracker = new MidImageAdTracker();

                for (var i = 0; i < extensions.length; i++) {
                    if (extensions[i].customObject.MidTextAd) {
                        this.midTextAdTracker.create(extensions[i].customObject.MidTextAd);
                    }
                    if (extensions[i].customObject.RemindBanner) {
                        this.midImageAdTracker.create(extensions[i].customObject.RemindBanner);
                    }
                }
            }
        };

        VASTTracker.prototype.emit = function(event, param) {
            this.sandbox.emit(event, param);
        };

        VASTTracker.prototype.on = function(event, callback) {
            this.sandbox.on(event, callback);
        };

        VASTTracker.prototype.off = function(event, callback) {
            this.sandbox.off(event, callback);
        };

        VASTTracker.prototype.setDuration = function(duration) {
            if (this.assetDuration > 0) {
                return;
            }

            if (!(duration > 1)) {
                return;
            }
            var creativeDuration = helpers.string.stringToSec(this.linear.duration);

            if (creativeDuration !== duration) {
                this.error('202');
                if (creativeDuration < duration) {
                    player.setDuration(creativeDuration);
                }
            }

            this.assetDuration = creativeDuration < duration ? creativeDuration : duration;
            this.quartiles = {
                firstQuartile: Math.ceil(0.25 * this.assetDuration),
                midpoint: Math.ceil(0.5 * this.assetDuration),
                thirdQuartile: Math.ceil(0.75 * this.assetDuration)
            };
        };

        VASTTracker.prototype.setProgress = function(progress) {
            var eventName, events, quartile, skipDelay, time, _i, _len, ref;

            skipDelay = this.skipDelay ? this.skipDelay : this.skipDelayDefault;

            if (skipDelay !== -1 && !this.skipable) {
                skipDelay = helpers.date.hhmmssToDate(skipDelay).getSeconds();

                if (skipDelay > progress) {
                    debug.info('%c%s', 'color: #607d8b;', '[vast:tracker event] skip-countdown', skipDelay - progress);
                } else {
                    this.skipable = true;
                }
            }
            if (this.linear && progress > 0) {
                events = [];

                if (!this.impressed) {
                    this.load();
                }

                events.push('start');
                events.push('progress-' + Math.round(progress));

                if (this.assetDuration > 0) {
                    ref = this.quartiles;
                    for (quartile in ref) {
                        if (ref.hasOwnProperty(quartile)) {
                            if (this.trackingEvents[quartile]) {
                                time = ref[quartile];
                            }

                            if (time && time <= progress) {
                                events.push(quartile);
                            }
                        }
                    }
                }

                for (_i = 0, _len = events.length; _i < _len; _i++) {
                    eventName = events[_i];
                    this.track(eventName, true);
                }
            }
        };

        VASTTracker.prototype.setMute = function(muteOn) {
            if (this.muteOn !== muteOn) {
                this.track(muteOn ? 'mute' : 'unmute');
            }
            this.muteOn = muteOn;
        };

        VASTTracker.prototype.pause = function(paused) {
            if (this.paused !== paused) {
                this.track(paused ? 'pause' : 'resume', false);
            }
            this.paused = paused;
        };

        VASTTracker.prototype.fullscreen = function(fullscreen) {
            if (this.fullscreen !== fullscreen) {
                this.track(fullscreen ? 'fullscreen' : 'exitFullscreen');
            }
            this.fullscreen = fullscreen;
        };

        VASTTracker.prototype.expand = function(expanded) {
            if (this.expanded !== expanded) {
                this.track(expanded ? 'expand' : 'collapse');
            }
            this.expanded = expanded;
        };

        VASTTracker.prototype.setSkipDelay = function(duration) {
            if (typeof duration === 'number') {
                this.skipDelay = duration;
            }
        };

        VASTTracker.prototype.load = function() {
            this.impressed = true;

            if (!this.impressions) {
                return;
            }

            debug.group('%c%s', 'color: #607d8b;', '[vast:tracker event]');
            while (this.impressions.length > 0) {
                var impression = this.impressions.shift();
                if (impression['@_uri'] && impression['@_uri'] !== '') {
                    this.trackURLs(impression['@_uri']);
                }

                debug.info('%c%s', 'color: #607d8b;', '[vast:tracker event] creativeView');
            }
            debug.groupEnd();

            return this.track('creativeView');
        };

        VASTTracker.prototype.error = function(code) {
            if (this.error['@_uri']) {
                var error = JSON.parse(JSON.stringify(this.error['@_uri']));
                for (var i = 0; i < error.length; i++) {
                    error[i] = error[i].replace('[ERRORCODE]', code);
                }
                debug.info('%c%s', 'color: #607d8b;', '[vast:tracker event] error', '\n', error);

                return this.trackURLs(error);
            }
        };

        VASTTracker.prototype.complete = function() {
            if (
                this.trackingEvents['firstQuartile'] ||
                this.trackingEvents['midpoint'] ||
                this.trackingEvents['thirdQuartile']
            ) {
                vastLogData.videoUrl = this.videoEl.currentSrc;
                vastLogData.videoDuration = this.videoEl.duration;
                vastLogData.vastDuration = this.linear.duration;
                for (var event in this.trackingEvents) {
                    if (this.trackingEvents.hasOwnProperty(event)) {
                        vastLogData.unTrackingEvents.push(event);
                    }
                }

                helpers.http
                    .fetch(constants.URL.KEMI_LOG_URL, {
                        async: true,
                        type: constants.HTTP.TYPE.JSON,
                        method: constants.HTTP.METHOD.POST,
                        body: JSON.stringify(vastLogData),
                        contentType: 'application/json'
                    })
                    .then(function() {
                        debug.info('vastTracker::complete Call Log Success');
                    })
                    .catch(function() {
                        debug.warn('vastTracker::complete Call Log Error');
                    });

                debug.info(
                    '%c%s',
                    'color: #607d8b;',
                    'VastTracker::complete Warning!! When call end event but, there is pre events'
                );
            } else {
                this.track('complete');
            }
            this.clear();
        };

        VASTTracker.prototype.clear = function() {
            this.trackingEvents = {};
        };

        VASTTracker.prototype.close = function() {
            return this.track(this.linear ? 'closeLinear' : 'close');
        };

        VASTTracker.prototype.skip = function() {
            this.track('skip');
            this.clear();
        };

        VASTTracker.prototype.click = function() {
            var clickThroughURL, clickTracking;

            if (this.videoClickTracking && this.videoClickTracking.length) {
                debug.group('%c%s', 'color: #607d8b;', '[vast:tracker event]');
                while (this.videoClickTracking.length > 0) {
                    clickTracking = this.videoClickTracking.shift();
                    this.trackURLs(clickTracking['@_uri']);

                    debug.info('%c%s', 'color: #607d8b;', '[vast:tracker event] clickTracking', clickTracking['@_uri']);
                }
                debug.groupEnd();
            }

            if (this.videoClickThrough) {
                clickThroughURL = this.videoClickThrough;
                return this.emit('clickthrough', clickThroughURL);
            }
        };

        VASTTracker.prototype.track = function(eventName, once) {
            var idx, trackingURL;
            if (once == null) {
                once = true;
            }
            if (eventName === 'closeLinear' && !this.trackingEvents[eventName] && this.trackingEvents['close']) {
                eventName = 'close';
            }

            if (this.trackingEvents[eventName]) {
                trackingURL = JSON.parse(JSON.stringify(this.trackingEvents[eventName]));
                idx = this.vastEvents.indexOf(eventName);
            }

            if (trackingURL) {
                this.emit(eventName, '');

                debug.group('%c%s', 'color: #607d8b;', '[vast:tracker event]');
                while (trackingURL.length > 0) {
                    var url = trackingURL.shift();
                    this.trackURLs(url);
                    debug.info('%c%s', 'color: #607d8b;', '[vast:tracker event] ' + eventName);
                }
                debug.groupEnd();
            } else if (idx !== -1) {
                this.emit(eventName, '');
            }
            if (once === true) {
                delete this.trackingEvents[eventName];
                if (idx > -1) {
                    this.vastEvents.splice(idx, 1);
                }
            }
        };

        VASTTracker.prototype.trackURLs = function(url, variables) {
            if (variables == null) {
                variables = {};
            }

            return track(url, variables);
        };

        return VASTTracker;
    })();

    exports.addModule('vast.tracker', new VASTTracker());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var VMAP;
    var AdBreak;
    var AdSource;
    var Extensions;

    var helpers = exports.helpers;
    var debug = helpers.debug;

    Extensions = (function() {
        function Extension($extensions) {
            this['extension'] = [];
            this.create($extensions);
        }

        Extension.prototype.create = function($extensions) {
            var extension = $extensions.Extension;
            if (extension) {
                extension = Array.isArray(extension) ? extension : [extension];

                this['extension'] = extension.map(function(obj) {
                    return obj;
                });
            }
        };

        return Extension;
    })();

    AdSource = (function() {
        function AdSource($adSource) {
            debug.log('%c[vmap:adsource] initialized', $adSource);

            this['@_id'] = $adSource['@_id'];
            this['@_allowMultipleAds'] = $adSource['@_allowMultipleAds'];
            this['@_followRedirects'] = $adSource['@_followRedirects'];
            this['vastAdData'] = null;
            this['adTagURI'] = null;
            this['customData'] = null;
            this.create($adSource);
        }

        AdSource.prototype.create = function($adSource) {
            for (var item in $adSource) {
                if ($adSource.hasOwnProperty(item)) {
                    var entry = $adSource[item];

                    if (item === 'VASTAdData') {
                        this['vastAdData'] = entry;
                    } else if (item === 'AdTagURI') {
                        this['adTagURI'] = {
                            '@_uri': entry['#text'],
                            '@_templateType': entry['@_templateType']
                        };
                    } else if (item === 'CustomAdData') {
                        this['customData'] = entry;
                    }
                }
            }
        };

        return AdSource;
    })();

    AdBreak = (function() {
        function AdBreak($adBreak) {
            debug.log('%c%s', 'color:#d9a221', '[vmap:adbreak] initialized', $adBreak);
            this['adSource'] = null;
            this['trackingEvents'] = [];
            this['extensions'] = [];
            this.create($adBreak);
        }

        AdBreak.prototype.create = function($adBreak) {
            for (var item in $adBreak) {
                if ($adBreak.hasOwnProperty(item)) {
                    var entry = $adBreak[item];

                    if (item === 'AdSource') {
                        this['adSource'] = new AdSource(entry);
                    } else if (item === 'TrackingEvents') {
                        var tracking = Array.isArray(entry.Tracking) ? entry.Tracking : [entry.Tracking];
                        this['trackingEvents'] = tracking.map(function($tracking) {
                            return {
                                uri: $tracking['#text'],
                                event: $tracking['@_event']
                            };
                        });
                    } else if (item === 'Extensions') {
                        this['extensions'] = new Extensions(entry);
                    } else {
                        this[item] = entry;
                    }
                }
            }
        };

        return AdBreak;
    })();

    VMAP = (function() {
        function VMAP() {}

        VMAP.prototype.init = function() {
            this['@_version'] = null;
            this['adBreak'] = [];
            this['extensions'] = [];

            debug.log('[vmap:parser] initialized');
        };

        VMAP.prototype.create = function($vmap) {
            this.init();
            debug.info('vmap json', $vmap);

            try {
                this['@_version'] = $vmap['@_version'];

                for (var item in $vmap) {
                    if ($vmap.hasOwnProperty(item)) {
                        var entry = $vmap[item];

                        if (item === 'AdBreak') {
                            entry = Array.isArray(entry) ? entry : [entry];
                            this['adBreak'] = entry.map(function(adbreak) {
                                return new AdBreak(adbreak);
                            });
                        } else if (item === 'Extensions') {
                            this['extensions'] = new Extensions(entry);
                        }
                    }
                }
                return this;
            } catch (error) {
                debug.error(error);
            }
        };

        return VMAP;
    })();

    exports.addModule('ads.vmap', new VMAP());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var VAST;
    var Ad;
    var InLine;
    var Wrapper;
    var Impression;
    var Survey;
    var Creative;
    var Extension;
    var Linear;
    var Companion;
    var NonLinear;
    var Tracking;
    var MediaFile;
    var VideoClicks;
    var Icon;
    var Resource;
    var Error;

    var helpers = exports.helpers;
    var debug = helpers.debug;

    var model = {
        VAST: function() {
            this['@_version'] = null;
            this['ad'] = [];
            this['error'] = [];
        },
        Ad: function() {
            this['@_id'] = null;
            this['@_sequence'] = null;
            this['@_adType'] = null;
            this['inline'] = null;
            this['wrapper'] = null;
        },
        Inline: function() {
            this.adSystem = [];
            this.adTitle = null;
            this.descrition = null;
            this.advertiser = null;
            this.pricing = [];
            this.survey = [];
            this.error = [];
            this.impression = [];
            this.creatives = {};
            this.extensions = {};
        },
        Wrapper: function() {
            this.adSystem = [];
            this.vastAdTagURI = null;
            this.error = {};
            this.impression = [];
            this.creatives = {};
        },
        Creative: function() {
            this['@_id'] = null;
            this['@_sequence'] = null;
            this['@_adId'] = null;
            this['@_apiFramework'] = null;
            this.creativeExtensions = {};
            this.linear = null;
            this.companionAds = {
                '@_required': null
            };
            this.nonLinearAds = null;
        },
        Linear: function() {
            this['@_skipoffset'] = null;
            this.adParameters = null;
            this.duration = null;
            this.mediaFiles = {};
            this.trackingEvents = {};
            this.videoClicks = null;
            this.icons = {};
        },
        Companion: function() {
            this['@_id'] = null;
            this['@_width'] = null;
            this['@_height'] = null;
            this['@_assetWidth'] = null;
            this['@_assetHeight'] = null;
            this['@_expandedWidth'] = null;
            this['@_expandedHeight'] = null;
            this['@_apiFramework'] = null;
            this['@_adSlotID'] = null;
            this.adParameters = null;
            this.altText = null;
            this.clickThrough = {};
            this.clickTracking = [];
            this.trackingEvents = {};
        },
        NonLinear: function() {
            this['@_id'] = null;
            this['@_width'] = null;
            this['@_height'] = null;
            this['@_expandedWidth'] = null;
            this['@_expandedHeight'] = null;
            this['@_scalable'] = null;
            this['@_maintainAspectRatio'] = null;
            this['@_minSuggestedDuration'] = null;
            this['@_apiFramework'] = null;
            this.clickThrough = {};
            this.clickTracking = [];
            this.adParameters = null;
        },
        MediaFile: function() {
            this['@_uri'] = null;
            this['@_delivery'] = null;
            this['@_type'] = null;
            this['@_bitrate'] = null;
            this['@_minBitrate'] = null;
            this['@_maxBitrate'] = null;
            this['@_width'] = null;
            this['@_height'] = null;
            this['@_scalable'] = null;
            this['@_mantainAspectRatio'] = null;
            this['@_codec'] = null;
            this['@_apiFramework'] = null;
        },
        Tracking: function() {
            this['@_uri'] = null;
            this['@_event'] = null;
            this['@_offset'] = null;
        },
        VideoClicks: function() {
            this.clickThrough = {};
            this.clickTracking = [];
            this.customClick = [];
        },
        Icon: function() {
            this['@_program'] = null;
            this['@_width'] = null;
            this['@_height'] = null;
            this['@_xPosition'] = null;
            this['@_yPosition'] = null;
            this['@_duration'] = null;
            this['@_offset'] = null;
            this['@_apiFramework'] = null;
            this.iconClicks = null;
            this.iconViewTracking = null;
        },
        Resource: function() {
            this.staticResource = [];
            this.iframeResource = [];
            this.htmlResource = [];
        },
        IconClicks: function() {
            this.iconClickThrough = {};
            this.iconClickTracking = [];
        },
        Impression: function() {
            this['@_id'] = null;
            this['@_uri'] = null;
        },
        Extension: function() {
            this['@_type'] = null;
            this.customObject = {};
        },
        Survey: function() {
            this['@_uri'] = null;
            this['@_type'] = null;
        },
        Error: function() {
            this['@_uri'] = null;
        }
    };

    function getType(target) {
        return Object.prototype.toString.call(target).slice(8, -1);
    }

    function getStringValueOfNode(obj) {
        return obj['#text'] ? obj['#text'] : obj;
    }

    function marshalToArray(data, creator) {
        var result = [];
        var type = getType(data);

        if (type === 'String') {
            result.push(creator(data));
            return result;
        }

        if (type === 'Array') {
            result = data;
        }

        if (type === 'Object') {
            result.push(data);
        }
        result = result.map(creator);
        return result;
    }

    Resource = function($resourceParent) {
        var resource = new model.Resource();

        if ($resourceParent.StaticResource) {
            resource.staticResource = marshalToArray($resourceParent.StaticResource, function(sr) {
                return {
                    '@_uri': getStringValueOfNode(sr),
                    '@_creativeType': sr['@_creativeType'] != null ? sr['@_creativeType'] : null
                };
            });
        }
        if ($resourceParent.IFrameResource) {
            resource.iframeResource = marshalToArray($resourceParent.IFrameResource, function(ir) {
                return {
                    '@_uri': getStringValueOfNode(ir)
                };
            });
        }
        if ($resourceParent.HTMLResource) {
            resource.htmlResource = marshalToArray($resourceParent.HTMLResource, function(hr) {
                return {
                    '@_uri': getStringValueOfNode(hr)
                };
            });
        }
        return resource;
    };

    Icon = function($icon) {
        // inherit Rsource(static, iframe, html)
        model.Icon.prototype = Resource($icon);
        model.Icon.prototype.constructor = model.Icon;
        var icon = new model.Icon();

        icon['@_program'] = $icon['@_program'] != null ? $icon['@_program'] : '';
        icon['@_width'] = $icon['@_width'] != null ? $icon['@_width'] : null;
        icon['@_height'] = $icon['@_height'] != null ? $icon['@_height'] : null;
        icon['@_xPosition'] = $icon['@_xPosition'] != null ? $icon['@_xPosition'] : null;
        icon['@_yPosition'] = $icon['@_yPosition'] != null ? $icon['@_yPosition'] : null;
        icon['@_duration'] = $icon['@_duration'] != null ? $icon['@_duration'] : null;
        icon['@_offset'] = $icon['@_offset'] != null ? $icon['@_offset'] : null;
        icon['@_apiFramework'] = $icon['@_apiFramework'] != null ? $icon['@_apiFramework'] : null;

        if ($icon.IconClicks) {
            icon.iconClicks = {
                iconClickThrough: {
                    '@_uri': $icon.IconClicks.IconClickThrough != null ? $icon.IconClicks.IconClickThrough : null
                },
                iconClickTrackings: marshalToArray($icon.IconClicks.IconClickTracking, function(ict) {
                    return {
                        '@_uri': getStringValueOfNode(ict),
                        '@_id': ict['@_id'] != null ? ict['@_id'] : null
                    };
                })
            };
        }

        icon.iconViewTracking = marshalToArray($icon.IconViewTracking, function(ivt) {
            return {
                '@_uri': getStringValueOfNode(ivt)
            };
        });

        return icon;
    };

    VideoClicks = function($videoClicks) {
        var videoClicks = new model.VideoClicks();

        if ($videoClicks.ClickThrough) {
            videoClicks.clickThrough = {
                '@_uri': getStringValueOfNode($videoClicks.ClickThrough),
                '@_id': $videoClicks.ClickThrough['@_id'] != null ? $videoClicks.ClickThrough['@_id'] : null
            };
        }

        if ($videoClicks.ClickTracking) {
            videoClicks.clickTracking = marshalToArray($videoClicks.ClickTracking, function(ct) {
                return {
                    '@_uri': getStringValueOfNode(ct),
                    '@_id': ct['@_id'] != null ? ct['@_id'] : null
                };
            });
        }

        if ($videoClicks.CustomClick) {
            videoClicks.customClick = marshalToArray($videoClicks.CustomClick, function(cc) {
                return {
                    '@_uri': getStringValueOfNode(cc),
                    '@_id': cc['@_id'] != null ? cc['@_id'] : null
                };
            });
        }

        return videoClicks;
    };

    Tracking = function($tracking) {
        var tracking = new model.Tracking();
        tracking['@_uri'] = getStringValueOfNode($tracking);
        tracking['@_event'] = $tracking['@_event'] != null ? $tracking['@_event'] : null;
        tracking['@_offset'] = $tracking['@_offset'] != null ? $tracking['@_offset'] : null;
        return tracking;
    };

    MediaFile = function($mediaFile) {
        var mediaFile = new model.MediaFile();

        mediaFile['@_uri'] = getStringValueOfNode($mediaFile);
        mediaFile['@_delivery'] = $mediaFile['@_delivery'] != null ? $mediaFile['@_delivery'] : null;
        mediaFile['@_type'] = $mediaFile['@_type'] != null ? $mediaFile['@_type'] : null;
        mediaFile['@_bitrate'] = $mediaFile['@_bitrate'] != null ? $mediaFile['@_bitrate'] : null;
        mediaFile['@_minBitrate'] = $mediaFile['@_minBitrate'] != null ? $mediaFile['@_minBitrate'] : null;
        mediaFile['@_maxBitrate'] = $mediaFile['@_maxBitrate'] != null ? $mediaFile['@_maxBitrate'] : null;
        mediaFile['@_width'] = $mediaFile['@_width'] != null ? $mediaFile['@_width'] : null;
        mediaFile['@_height'] = $mediaFile['@_height'] != null ? $mediaFile['@_height'] : null;
        mediaFile['@_scalable'] = $mediaFile['@_scalable'] != null ? $mediaFile['@_scalable'] : null;
        mediaFile['@_mantainAspectRatio'] =
            $mediaFile['@_mantainAspectRatio'] != null ? $mediaFile['@_mantainAspectRatio'] : null;
        mediaFile['@_codec'] = $mediaFile['@_codec'] != null ? $mediaFile['@_codec'] : null;
        mediaFile['@_apiFramework'] = $mediaFile['@_apiFramework'] != null ? $mediaFile['@_apiFramework'] : null;

        return mediaFile;
    };

    Companion = function($companion) {
        // inherit Rsource(static, iframe, html)
        model.Companion.prototype = Resource($companion);
        model.Companion.prototype.constructor = model.Companion;
        var companion = new model.Companion();

        companion['@_id'] = $companion['@_id'] != null ? $companion['@_id'] : null;
        companion['@_width'] = $companion['@_width'] != null ? $companion['@_width'] : null;
        companion['@_height'] = $companion['@_height'] != null ? $companion['@_height'] : null;
        companion['@_assetWidth'] = $companion['@_assetWidth'] != null ? $companion['@_assetWidth'] : null;
        companion['@_assetHeight'] = $companion['@_assetHeight'] != null ? $companion['@_assetHeight'] : null;
        companion['@_expandedWidth'] = $companion['@_expandedWidth'] != null ? $companion['@_expandedWidth'] : null;
        companion['@_expandedHeight'] = $companion['@_expandedHeight'] != null ? $companion['@_expandedHeight'] : null;
        companion['@_apiFramework'] = $companion['@_apiFramework'] != null ? $companion['@_apiFramework'] : null;
        companion['@_adSlotID'] = $companion['@_adSlotID'] != null ? $companion['@_adSlotID'] : null;

        if ($companion.AdParameters != null) {
            companion.adParameters = {
                '@_content': getStringValueOfNode($companion.AdParameters),
                '@_xmlEncoded': $companion.AdParameters['@_xmlEncoded']
            };
        }
        companion.altText = $companion.AltText != null ? $companion.AltText : null;
        companion.clickThrough['@_uri'] =
            $companion.CompanionClickThrough != null ? $companion.CompanionClickThrough : null;

        if ($companion.CompanionClickTracking) {
            companion.clickTracking = marshalToArray($companion.CompanionClickTracking, function(cct) {
                return {
                    '@_uri': getStringValueOfNode(cct),
                    '@_id': cct['@_id'] != null ? cct['@_id'] : null
                };
            });
        }

        if ($companion.TrackingEvents != null) {
            companion.trackingEvents.tracking = marshalToArray($companion.TrackingEvents.Tracking, Tracking);
        }
    };

    Linear = function($linear) {
        var linear = new model.Linear();
        linear['@_skipoffset'] = $linear['@_skipoffset'] != null ? $linear['@_skipoffset'] : null;
        if ($linear.AdParameters != null) {
            linear.adParameters = {
                '@_content': getStringValueOfNode($linear.AdParameters),
                '@_xmlEncoded': $linear.AdParameters['@_xmlEncoded']
            };
        }
        if ($linear.Duration != null) {
            linear.duration = $linear.Duration;
        }
        if ($linear.MediaFiles != null) {
            linear.mediaFiles.mediaFile = marshalToArray($linear.MediaFiles.MediaFile, MediaFile);
        }

        if ($linear.TrackingEvents != null) {
            linear.trackingEvents.tracking = marshalToArray($linear.TrackingEvents.Tracking, Tracking);
        }

        if ($linear.VideoClicks != null) {
            linear.videoClicks = VideoClicks($linear.VideoClicks);
        }

        if ($linear.Icons != null) {
            linear.icons.icon = marshalToArray($linear.Icons.Icon, Icon);
        }

        return linear;
    };

    NonLinear = function($nonlinear) {
        // inherit Rsource(static, iframe, html)
        model.NonLinear.prototype = Resource($nonlinear);
        model.NonLinear.prototype.constructor = model.NonLinear;

        var nonlinear = new model.NonLinear();
        nonlinear['@_id'] = $nonlinear['@_id'] != null ? $nonlinear['@_id'] : null;
        nonlinear['@_width'] = $nonlinear['@_width'] != null ? $nonlinear['@_width'] : null;
        nonlinear['@_height'] = $nonlinear['@_height'] != null ? $nonlinear['@_height'] : null;
        nonlinear['@_expandedWidth'] = $nonlinear['@_expandedWidth'] != null ? $nonlinear['@_expandedWidth'] : null;
        nonlinear['@_expandedHeight'] = $nonlinear['@_expandedHeight'] != null ? $nonlinear['@_expandedHeight'] : null;
        nonlinear['@_scalable'] = $nonlinear['@_scalable'] != null ? $nonlinear['@_scalable'] : null;
        nonlinear['@_maintainAspectRatio'] =
            $nonlinear['@_maintainAspectRatio'] != null ? $nonlinear['@_maintainAspectRatio'] : null;
        nonlinear['@_minSuggestedDuration'] =
            $nonlinear['@_minSuggestedDuration'] != null ? $nonlinear['@_minSuggestedDuration'] : null;
        nonlinear['@_apiFramework'] = $nonlinear['@_apiFramework'] != null ? $nonlinear['@_apiFramework'] : null;

        if ($nonlinear.AdParameters != null) {
            nonlinear.adParameters = {
                '@_content': getStringValueOfNode($nonlinear.AdParameters),
                '@_xmlEncoded': $nonlinear.AdParameters['@_xmlEncoded']
            };
        }
        nonlinear.clickThrough['@_uri'] =
            $nonlinear.CompanionClickThrough != null ? $nonlinear.CompanionClickThrough : null;

        if ($nonlinear.CompanionClickTracking) {
            nonlinear.clickTracking = marshalToArray($nonlinear.CompanionClickTracking, function(cct) {
                return {
                    '@_uri': getStringValueOfNode(cct),
                    '@_id': cct['@_id'] != null ? cct['@_id'] : null
                };
            });
        }

        if ($nonlinear.TrackingEvents != null) {
            nonlinear.trackingEvents.tracking = marshalToArray($nonlinear.TrackingEvents.Tracking, Tracking);
        }
    };

    Extension = function($extension) {
        var extension = new model.Extension();
        for (var item in $extension) {
            if ($extension.hasOwnProperty(item)) {
                if (item === 'type') {
                    extension['@_type'] = $extension[item];
                } else {
                    extension.customObject[item] = $extension[item];
                }
            }
        }
        return extension;
    };

    Creative = function($creative) {
        var creative = {};

        if ($creative['@_id']) {
            creative['@_id'] = $creative['@_id'];
        }

        if ($creative['@_sequence']) {
            creative['@_sequence'] = $creative['@_sequence'];
        }

        if ($creative['@_adId']) {
            creative['@_adId'] = $creative['@_adId'];
        }

        if ($creative['@_apiFramework']) {
            creative['@_apiFramework'] = $creative['@_apiFramework'];
        }

        if ($creative.CreativeExtensions) {
            creative.creativeExtensions = {};
            creative.creativeExtensions.creativeExtension = marshalToArray(
                $creative.CreativeExtensions.CreativeExtension,
                Extension
            );
        }

        if ($creative.Linear) {
            creative.linear = Linear($creative.Linear);
        }

        if ($creative.CompanionAds) {
            creative.companionAds = {};
            creative.companionAds['@_required'] =
                $creative.CompanionAds['@_required'] != null ? $creative.CompanionAds['@_required'] : null;
            creative.companionAds.companion = marshalToArray($creative.CompanionAds.Companion, Companion);
        }

        if ($creative.NonLinearAds) {
            creative.nonLinearAds = marshalToArray($creative.NonLinearAds.NonLinear, NonLinear);
        }
        return creative;
    };

    Survey = function($survey) {
        var survey = new model.Survey();
        survey['@_uri'] = getStringValueOfNode($survey);
        survey['@_type'] = $survey['@_type'];
        return survey;
    };

    Impression = function($impression) {
        var impression = new model.Impression();
        impression['@_uri'] = getStringValueOfNode($impression);
        impression['@_id'] = $impression['@_id'];
        return impression;
    };

    Error = function($error) {
        var error = new model.Error();
        error['@_uri'] = getStringValueOfNode($error);
        return error;
    };

    InLine = function($inline) {
        var inline = new model.Inline();

        inline.adSystem = $inline.AdSystem != null ? $inline.AdSystem : null;
        inline.adTitle = $inline.AdTitle != null ? $inline.AdTitle : null;
        inline.descrition = $inline.Description != null ? $inline.Description : null;
        inline.advertiser = $inline.Advertiser != null ? $inline.Advertiser : null;
        inline.pricing = $inline.Pricing != null ? $inline.Pricing : null;

        if ($inline.Error != null) {
            inline.error = marshalToArray($inline.Error, Error);
        }

        if ($inline.Survey != null) {
            inline.survey = marshalToArray($inline.Survey, Survey);
        }
        if ($inline.Impression != null) {
            inline.impression = marshalToArray($inline.Impression, Impression);
        }
        if ($inline.Creatives != null) {
            inline.creatives.creative = marshalToArray($inline.Creatives.Creative, Creative);
        }
        if ($inline.Extensions != null) {
            inline.extensions.extension = marshalToArray($inline.Extensions.Extension, Extension);
        }

        return inline;
    };

    Wrapper = function($wrapper) {
        var wrapper = new model.Wrapper();
        wrapper.adSystem = $wrapper.AdSystem != null ? $wrapper.AdSystem : null;
        return wrapper;
    };

    Ad = function($ad) {
        var ad = new model.Ad();
        ad['@_id'] = $ad['@_id'];
        ad['@_sequence'] = $ad['@_sequence'];
        ad['@_adType'] = $ad['@_adType'];

        if ($ad.InLine != null) {
            ad.inline = InLine($ad.InLine);
        }
        if ($ad.Wrapper != null) {
            ad.wrapper = Wrapper($ad.Wrapper);
        }
        return ad;
    };

    VAST = (function() {
        function VAST() {}

        VAST.prototype.init = function() {};

        VAST.prototype.create = function($vast) {
            try {
                var vast = new model.VAST();
                vast['@_version'] = $vast['@_version'];

                if ($vast.Ad != null) {
                    var ads = Array.isArray($vast.Ad) ? $vast.Ad : [$vast.Ad];
                    vast.ad = ads.map(Ad);
                }

                if ($vast.Error != null) {
                    vast.error = marshalToArray($vast.Error, Error);
                }

                return vast;
            } catch (error) {
                debug.error(error);
            }
        };

        return VAST;
    })();

    exports.addModule('ads.vast', new VAST());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var PARSER = (function() {
        var vmap = exports.loadModule('ads.vmap');
        var vast = exports.loadModule('ads.vast');
        var helpers = exports.helpers;
        var debug = helpers.debug;

        function PARSER() {}

        PARSER.prototype.init = function() {};

        PARSER.prototype.parseVmap = function(xml) {
            var result = helpers.parser.xml2json(xml);
            if (result.VMAP) {
                return vmap.create(result.VMAP);
            }
        };

        PARSER.prototype.parseVast = function(xml) {
            var result = helpers.parser.xml2json(xml);
            debug.info('parse vast to json -', result);
            if (result.VAST) {
                return vast.create(result.VAST);
            }
        };

        return PARSER;
    })();

    exports.addModule('ads.parser', new PARSER());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var pvtTracker = exports.loadModule('pvt.tracker');
    var vastTracker = exports.loadModule('vast.tracker');
    var pctTracker = exports.loadModule('pct.tracker');
    var qoeTracker = exports.loadModule('qoe.tracker');

    var Tracker;

    Tracker = (function() {
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;

        var externalTracker = {
            beacons: null,
            checkBeaconData: function(percent) {
                try {
                    if (this.beacons && this.beacons.length > 0) {
                        var beacon = this.beacons[0];
                        if (percent.toFixed(6) >= beacon.ratio) {
                            helpers.http.sendBeacon(beacon.url);
                            this.beacons.shift();

                            debug.info('[extenal:tracker event] - ratio:', beacon.ratio);
                        }
                    }
                } catch (e) {
                    debug.error(e);
                }
            },
            sendLeftBeaconData: function() {
                if (this.beacons && this.beacons.length > 0) {
                    while (this.beacons.length > 0) {
                        var beacon = this.beacons.shift();
                        if (beacon.ratio === 1) {
                            helpers.http.sendBeacon(beacon.url);

                            debug.info('[extenal:tracker event] - ratio:', beacon.ratio, ', url:', beacon.url);
                        }
                    }
                }
            }
        };

        function Tracker() {}

        Tracker.prototype.init = function() {
            debug.log('[tracker] initialized');
        };

        Tracker.prototype.setTracker = function(video) {
            if (video.type === constants.VIDEO_TYPE.AD) {
                vastTracker.create(video.ad, video.creative);
            } else {
                pvtTracker.create(video.tracking.pvt);
            }
        };

        Tracker.prototype.setNonLinearTracker = function(extensions) {
            vastTracker.setNonLinearTracker(extensions);
        };

        Tracker.prototype.setPCTTracker = function(pct) {
            pctTracker.create(pct);
        };

        Tracker.prototype.setQOETracker = function(qoe) {
            qoeTracker.create(qoe);
        };

        Tracker.prototype.setBeaconData = function(beacons) {
            externalTracker.beacons = JSON.parse(beacons);
        };

        Tracker.prototype.checkBeaconData = function(percent) {
            externalTracker.checkBeaconData(percent);
        };

        Tracker.prototype.sendLeftBeaconData = function() {
            externalTracker.sendLeftBeaconData();
        };

        return Tracker;
    })();

    exports.addModule('etc.tracker', new Tracker());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var state = exports.loadModule('controller.state');

    var KEYCODE = {
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SPACE: 32,
        Z: 90,
        COMMA: 188,
        PERIOD: 190,
        PAGEUP: 33,
        PAGEDOWN: 34,
        END: 35,
        HOME: 36,
        TAB: 9,
        ESC: 27
    };

    var KeyboardAddon;

    KeyboardAddon = (function() {
        function KeyboardAddon() {}

        var event = dt.event;
        var helpers = exports.helpers;
        var debug = helpers.debug;

        KeyboardAddon.prototype.init = function() {};

        KeyboardAddon.prototype.initWithConfig = function(config) {
            var keyDownCount = 0;
            var keydownCallback = config.keydownCallback;
            var keyupCallback = config.keyupCallback;

            event.on(document.body, 'keydown', function(e) {
                debug.info('keydown');

                if (helpers.debug.isShowServerSetting() || state.isShowError || state.onIma) {
                    return;
                }

                for (var name in KEYCODE) {
                    if (KEYCODE.hasOwnProperty(name)) {
                        if (KEYCODE[name] === e.keyCode && KEYCODE[name] !== KEYCODE.TAB) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                }

                switch (e.keyCode) {
                    case KEYCODE.LEFT:
                        keydownCallback.left(keyDownCount);
                        break;
                    case KEYCODE.RIGHT:
                        keydownCallback.right(keyDownCount);
                        break;
                    case KEYCODE.UP:
                        keydownCallback.up();
                        break;
                    case KEYCODE.DOWN:
                        keydownCallback.down();
                        break;
                    case KEYCODE.SPACE:
                        keydownCallback.space();
                        break;
                    case KEYCODE.Z:
                        keydownCallback.z();
                        break;
                    case KEYCODE.COMMA:
                        keydownCallback.comma();
                        break;
                    case KEYCODE.PERIOD:
                        keydownCallback.period();
                        break;
                    case KEYCODE.PAGEUP:
                        keydownCallback.pageUp(keyDownCount);
                        break;
                    case KEYCODE.PAGEDOWN:
                        keydownCallback.pageDown(keyDownCount);
                        break;
                    case KEYCODE.END:
                        keydownCallback.end();
                        break;
                    case KEYCODE.HOME:
                        keydownCallback.home();
                        break;
                    case KEYCODE.TAB:
                        keydownCallback.tab();
                        break;
                    case KEYCODE.ESC:
                        keydownCallback.esc();
                        break;
                }

                keyDownCount++;
            });

            event.on(
                document.body,
                'keyup',
                helpers.waiter.debounce(function(e) {
                    keyDownCount = 0;

                    switch (e.keyCode) {
                        case KEYCODE.LEFT:
                            player.setMute(state.mutedBeforeSeek);
                            keyupCallback.left();
                            break;
                        case KEYCODE.RIGHT:
                            player.setMute(state.mutedBeforeSeek);
                            keyupCallback.right();
                            break;
                        case KEYCODE.UP:
                            keyupCallback.up();
                            break;
                        case KEYCODE.DOWN:
                            keyupCallback.down();
                            break;
                        case KEYCODE.SPACE:
                            keyupCallback.space();
                            break;
                        case KEYCODE.Z:
                            keyupCallback.z();
                            break;
                        case KEYCODE.COMMA:
                            keyupCallback.comma();
                            break;
                        case KEYCODE.PERIOD:
                            keyupCallback.period();
                            break;
                        case KEYCODE.PAGEUP:
                            player.setMute(state.mutedBeforeSeek);
                            keyupCallback.pageUp();
                            break;
                        case KEYCODE.PAGEDOWN:
                            player.setMute(state.mutedBeforeSeek);
                            keyupCallback.pageDown();
                            break;
                        case KEYCODE.END:
                            keyupCallback.end();
                            break;
                        case KEYCODE.HOME:
                            keyupCallback.home();
                            break;
                    }
                }),
                500
            );
        };

        return KeyboardAddon;
    })();

    exports.addModule('addon.keyboard', new KeyboardAddon());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';

    var Playlist;

    Playlist = (function() {
        function Playlist() {}

        Playlist.prototype.init = function() {
            this.isAutoPlay = false;
            this.vidList = [];
        };

        Playlist.prototype.getVidList = function() {
            return this.vidList;
        };

        Playlist.prototype.setVidList = function(vidList) {
            this.vidList = vidList;
        };

        Playlist.prototype.getIndex = function(vid) {
            return this.vidList.indexOf(vid);
        };

        Playlist.prototype.getNext = function(vid) {
            return this.vidList[this.getIndex(vid) + 1];
        };

        Playlist.prototype.getPrev = function(vid) {
            return this.vidList[this.getIndex(vid) - 1];
        };

        Playlist.prototype.hasNext = function(vid) {
            return !!this.getNext(vid);
        };

        return Playlist;
    })();

    exports.addModule('playlist.playlist', new Playlist());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var Queue;

    Queue = (function() {
        function Queue() {
            this.init();
        }

        Queue.prototype.init = function() {
            this.playList = [];
            this.front = null;

            this.prerolls = [];
            this.contents = [];
            this.midrolls = [];
            this.postrolls = [];

            this.overlayAds = [];
            this.sdkAds = [];
        };

        Queue.prototype.set = function(arr) {
            this.playList = arr;
        };

        Queue.prototype.get = function() {
            return this.playList;
        };

        Queue.prototype.enqueue = function(data) {
            this.front = data;
            this.playList.push(data);
        };

        Queue.prototype.enqueueArray = function(array) {
            this.playList = this.playList.concat(array);
        };

        Queue.prototype.dequeue = function() {
            this.front = this.playList.shift();
            return this.front;
        };

        Queue.prototype.dequeueCancel = function(data) {
            this.front = data;
            this.playList.unshift(data);
        };

        Queue.prototype.size = function() {
            return this.playList.length;
        };

        Queue.prototype.isEmpty = function() {
            return !(this.size() > 0);
        };

        Queue.prototype.peek = function() {
            return this.front;
        };

        Queue.prototype.hasNextQueue = function() {
            return this.prerolls.length > 0 || this.postrolls.length > 0 || this.contents.length > 0;
        };

        Queue.prototype.resetQueue = function() {
            this.playList = [];
        };

        return Queue;
    })();

    exports.addModule('playlist.queue', new Queue());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');

    function DataLoader() {}

    DataLoader.prototype = (function() {
        var ua = exports.ua;
        var helpers = exports.helpers;
        var constants = exports.constants;
        var debug = helpers.debug;
        var env = exports.ENV;
        var PHASE = constants.PHASE[env.phase.toUpperCase()];
        var ERROR_STATUS = constants.ERROR.STATUS;
        var URL_HOST = helpers.serverHost.create(env.klimtServer, PHASE);

        var isIE9 = (function() {
            var isPC = ua.platform === 'pc';
            return isPC && ua.browser.msie && ua.browser.version.major === '9';
        })();

        function normalizeAdUrl(url) {
            if (!isIE9) {
                return url;
            }
            var urlArray = url.split('/');
            urlArray[2] = URL_HOST.replace('//', '');
            return urlArray.join('/');
        }

        var API = {
            CLIP_READY: {
                URL: '/katz/v2/ft/cliplink/{CLIP_LINK_ID}/ready',
                PARAM: {
                    player: 'monet_html5',
                    referer: env.referer ? encodeURIComponent(env.referer) : '',
                    uuid: '',
                    service: '',
                    section: '',
                    dteType: '',
                    profile: 'MAIN',
                    contentType: '',
                    playerVersion: env.playerVersion
                }
            },
            CLIP_PLAY: {
                URL: '/katz/v2/ft/cliplink/{CLIP_LINK_ID}/play',
                PARAM: {
                    player: 'monet_html5',
                    referer: env.referer ? encodeURIComponent(env.referer) : '',
                    uuid: '',
                    profile: 'MAIN',
                    service: '',
                    section: '',
                    tid: '',
                    playerVersion: env.playerVersion
                }
            },
            CLIP_READY_AND_PLAY: {
                URL: '/katz/v2/ft/cliplink/{CLIP_LINK_ID}/readyNplay',
                PARAM: {
                    player: 'monet_html5',
                    referer: env.referer ? encodeURIComponent(env.referer) : '',
                    pageReferer: env.referer ? encodeURIComponent(env.referer) : '',
                    uuid: '',
                    profile: 'MAIN',
                    service: '',
                    section: '',
                    fields: 'seekUrl,abrVideoLocationList',
                    playerVersion: env.playerVersion,
                    startPosition: '0',
                    tid: ''
                }
            },
            CLIP_META: {
                EXCLUDE_PARAM: 'fields=@html5vod'
            },
            CLIP_LOCATION: {
                URL: '/katz/v2/ft/cliplink/{CLIP_LINK_ID}/videoLocation',
                PARAM: {
                    service: '',
                    section: '',
                    player: 'monet_html5'
                }
            },
            LIVE_READY_AND_PLAY: {
                URL: '/katz/v2/ft/livelink/{LIVE_LINK_ID}/readyNplay',
                PARAM: {
                    player: 'monet_html5',
                    referer: env.referer ? encodeURIComponent(env.referer) : '',
                    pageReferer: env.referer ? encodeURIComponent(env.referer) : '',
                    uuid: '',
                    service: '',
                    section: '',
                    dteType: '',
                    profile: 'MAIN',
                    playerVersion: env.playerVersion
                }
            },
            LIVE_META: {
                EXCLUDE_PARAM: 'fields=@html5live'
            },
            LIVE_LOCATION: {
                URL: '/katz/v2/ft/livelink/{LIVE_LINK_ID}/videoLocation',
                PARAM: {
                    service: '',
                    section: '',
                    contentType: constants.CONTENT_TYPE.NPP
                }
            },
            LIVE_STAT: {
                URL: '/api/v2/ft/livelinks/{LIVE_LINK_ID}/stat'
            },
            RELATED_CLIP: {
                URL: '/api/v2/ft/cliplinks/{CLIP_LINK_ID}/related/cliplinks',
                PARAM: {
                    uuid: ''
                },
                EXCLUDE_PARAM: 'fields=-user,-clipChapterThumbnailList,-tagList,-channel&fulllevels=list'
            },
            RECOMMENDED_CLIP: {
                URL: '/api/v1/ft/livelinks/{LIVE_LINK_ID}/recommended/cliplinks',
                EXCLUDE_PARAM: 'fields=-user,-clipChapterThumbnailList,-tagList,-channel,-feedBackData&fulllevels=list'
            },
            CLIP_INFO_MODIFY: {
                URL: '/api/v1/ft/clips/{CLIP_ID}'
            },
            CLIP_COVER_MODIFY: {
                URL: '/api/v1/ft/clips/{CLIP_ID}/chapterthumbnails/{THUMB_INDEX}'
            },
            OUTPUT_PROCESSING_INFO: {
                URL: '/api/v1/ft/clips/{CLIP_ID}/outputProcessingInfo'
            },
            AUTH_VERFICATION: {
                URL:
                    PHASE === constants.PHASE.SANDBOX
                        ? '//sandbox-auth.kakao.com/ageauths/ageauth_status.json'
                        : '//auth.kakao.com/ageauths/ageauth_status.json',
                PARAM: {
                    service: ''
                }
            },
            ANALYTICS_CLIP_PLAY: {
                URL:
                    PHASE === constants.PHASE.SANDBOX
                        ? '//sandbox-pollock.kakao.com/mongodb-api/api/playchart/v1/clip/stat?clipLinkId={CLIP_LINK_ID}'
                        : PHASE === constants.PHASE.CBT
                        ? '//cbt-pollock.kakao.com/mongodb-api/api/playchart/v1/clip/stat?clipLinkId={CLIP_LINK_ID}'
                        : '//pollock.kakao.com/mongodb-api/api/playchart/v1/clip/stat?clipLinkId={CLIP_LINK_ID}'
            }
        };

        function getCurrentDate() {
            var date = new Date();
            var month = date.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            var day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            var hour = date.getHours();
            if (hour < 10) {
                hour = '0' + hour;
            }
            var min = date.getMinutes();
            if (min < 10) {
                min = '0' + min;
            }

            return date.getFullYear() + '' + month + '' + day + '' + hour + '' + min + '00';
        }

        function addMockData(vmapReq) {
            if (helpers.url.isValidate(env.adMediaFile)) {
                vmapReq.preview = {};
                vmapReq.preview.video_url = env.adMediaFile;

                if (helpers.url.isValidate(env.adClickThrough)) {
                    vmapReq.preview.landing_url = env.adClickThrough;
                }
                if (!isNaN(env.adSkipoffset) && env.adSkipoffset > 0) {
                    vmapReq.preview.skip_seconds = env.adSkipoffset;
                }
            }

            return vmapReq;
        }

        function buildVmapRequest(req) {
            var vmapReq = addMockData(req);
            var reqString = JSON.stringify(vmapReq);
            var reqtime = getCurrentDate();

            var resolution = {
                width: window.screen.width,
                height: window.screen.height
            };

            var viewport = {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            };

            var devicePixelRatio = window.getDevicePixelRatio();
            var orientation = helpers.orientation.getOrientation();
            var connection = helpers.webapi.network.getConnection();
            var connectionType = (connection && connection.type) || 'unknown';

            reqString = reqString
                .replace('#IMP_REQUEST__REPLAY#', '0')
                .replace('#IMP_REQUEST__PLAYER_TYPE#', '0')
                .replace('#DEVICE__ORIENTATION#', orientation === 'landscape' ? '1' : '0')
                .replace('#DEVICE__ID#', helpers.uuid.get())
                .replace('#DEVICE__OS#', '' + ua.os.name)
                .replace('#DEVICE__PX_RATIO#', devicePixelRatio)
                .replace('#DEVICE__RESOLUTION__WIDTH#', resolution.width)
                .replace('#DEVICE__RESOLUTION__HEIGHT#', resolution.height)
                .replace('#DEVICE__DPI#', '1')
                .replace('#DEVICE__CONNECTION_TYPE#', connectionType)
                .replace('#DEVICE__VERSION#', '' + ua.os.version.info)
                .replace('#PLAYER__WIDTH_DP#', viewport.width)
                .replace('#PLAYER__HEIGHT_DP#', viewport.height)
                .replace('#PLAYER__VERSION#', env.playerVersion)
                .replace('#INFO__REQ_TIME#', reqtime);

            return reqString;
        }

        return {
            init: function() {},
            getClipReady: function(clipLinkId, params) {
                var url, pathname, queryString;
                var defaults = API.CLIP_READY.PARAM;

                dt.extend(defaults, params, true);

                pathname = API.CLIP_READY.URL.replace('{CLIP_LINK_ID}', clipLinkId);
                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + pathname + '?' + queryString;

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(url, {
                            async: true,
                            timeout: 5000,
                            type: constants.HTTP.TYPE.JSON
                        })
                        .then(function(data) {
                            resolve(data);
                            return data;
                        })
                        .then(function(data) {
                            exports.queue.emit('complete:ready', {
                                status: 'success',
                                data: data,
                                videoType: constants.VIDEO_TYPE.VOD
                            });
                        })
                        .catch(function(e) {
                            if (e.code) {
                                exports.queue.emit('show:error', { info: e });
                            }
                            reject(e);
                        });
                });
            },
            getClipPlay: function(clipLinkId, params) {
                var url, pathname, queryString;
                var defaults = API.CLIP_PLAY.PARAM;

                dt.extend(defaults, params, true);

                pathname = API.CLIP_PLAY.URL.replace('{CLIP_LINK_ID}', clipLinkId);
                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + pathname + '?' + queryString;

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(url, {
                            async: true,
                            timeout: 5000,
                            type: constants.HTTP.TYPE.JSON
                        })
                        .then(function(data) {
                            resolve(data);
                            return data;
                        })
                        .then(function(data) {
                            exports.queue.emit('complete:play', {
                                status: 'success',
                                data: data,
                                videoType: constants.VIDEO_TYPE.VOD
                            });
                        })
                        .catch(function(e) {
                            if (e.code) {
                                exports.queue.emit('show:error', { info: e });
                            }
                            reject(e);
                        });
                });
            },
            getClipReadyAndPlay: function(clipLinkId, params) {
                var url, pathname, queryString;
                var defaults = API.CLIP_READY_AND_PLAY.PARAM;

                dt.extend(defaults, params, true);

                pathname = API.CLIP_READY_AND_PLAY.URL.replace('{CLIP_LINK_ID}', clipLinkId);
                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + pathname + '?' + queryString + '&' + Date.now();

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(url, {
                            async: true,
                            timeout: 5000,
                            type: constants.HTTP.TYPE.JSON,
                            credentials: 'include'
                        })
                        .then(function(data) {
                            resolve(data);
                            return data;
                        })
                        .then(function(data) {
                            exports.queue.emit('complete:readyAndPlay', {
                                status: 'success',
                                data: data,
                                videoType: constants.VIDEO_TYPE.VOD
                            });
                        })
                        .catch(function(e) {
                            if (e.code) {
                                exports.queue.emit('show:error', { info: e });
                            }
                            reject(e);
                        });
                });
            },
            getMeta: function(url, type) {
                var params = API.CLIP_META.EXCLUDE_PARAM;

                if (type === constants.VIDEO_TYPE.LIVE) {
                    params = API.LIVE_META.EXCLUDE_PARAM;
                }

                url = url + '?' + params;

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(url, {
                            async: true,
                            type: constants.HTTP.TYPE.JSON
                        })
                        .then(function(data) {
                            resolve(data);
                            return data;
                        })
                        .then(function(data) {
                            exports.queue.emit('complete:meta', {
                                status: 'success',
                                data: data
                            });
                        })
                        .catch(function(e) {
                            debug.warn('Meta error status :', e);

                            reject();
                        });
                });
            },
            getAction: function(url) {
                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(url, {
                            async: true,
                            type: constants.HTTP.TYPE.JSON
                        })
                        .then(function(data) {
                            resolve(data);
                            return data;
                        })
                        .catch(function(e) {
                            debug.warn('getAction error status :', e);

                            reject();
                        });
                });
            },
            getClipLocation: function(clipBean, params, callback) {
                var url, pathname, queryString;
                var defaults = API.CLIP_LOCATION.PARAM;

                dt.extend(defaults, params, true);

                pathname = API.CLIP_LOCATION.URL.replace('{CLIP_LINK_ID}', clipBean.id);
                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + pathname + '?' + queryString;

                helpers.http.ajax(
                    url,
                    {
                        onSuccess: function(data) {
                            var videoLocation = data && data.videoLocation;

                            if (!videoLocation) {
                                debug.warn('failed to get clip location. caused data empty');
                                return;
                            }

                            var videoUrl = videoLocation.url;
                            var profile = videoLocation.profile;

                            clipBean.videoUrl = videoUrl;
                            clipBean.profile = profile;

                            exports.queue.emit('complete:location', {
                                status: 'success',
                                callback: callback
                            });
                        },
                        onError: function(e) {
                            if (e.code) {
                                debug.warn('failed to get clip location. caused by error:', e);
                                exports.queue.emit('show:error', { info: e });
                            }
                        }
                    },
                    {
                        async: false,
                        type: constants.HTTP.TYPE.JSON
                    }
                );
            },
            getLiveReadyAndPlay: function(liveLinkId, params) {
                var url, pathname, queryString;
                var defaults = API.LIVE_READY_AND_PLAY.PARAM;

                dt.extend(defaults, params, true);

                pathname = API.LIVE_READY_AND_PLAY.URL.replace('{LIVE_LINK_ID}', liveLinkId);
                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + pathname + '?' + queryString + '&' + Date.now();

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(url, {
                            async: true,
                            timeout: 5000,
                            type: constants.HTTP.TYPE.JSON
                        })
                        .then(function(data) {
                            resolve(data);
                            return data;
                        })
                        .then(function(data) {
                            exports.queue.emit('complete:readyAndPlay', {
                                status: 'success',
                                data: data,
                                params: params
                            });
                        })
                        .catch(function(e) {
                            var error = e || {};

                            if (error.type === 'onTimeout') {
                                error.code = ERROR_STATUS.LivefarmServerError.NAME;
                            }

                            if (error.code) {
                                exports.queue.emit('show:error', { info: error });
                            }

                            reject();
                        });
                });
            },
            getLiveLocation: function(liveBean, params, callback) {
                var url, pathname, queryString;
                var defaults = API.LIVE_LOCATION.PARAM;

                dt.extend(defaults, params, true);

                pathname = API.LIVE_LOCATION.URL.replace('{LIVE_LINK_ID}', liveBean.id);
                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + pathname + '?' + queryString;

                helpers.http.ajax(
                    url,
                    {
                        onSuccess: function(data) {
                            var videoLocation = data && data.videoLocation;

                            if (!videoLocation) {
                                debug.warn('failed to get live location. caused data empty');
                                return;
                            }

                            var videoUrl = videoLocation.url;
                            var profile = videoLocation.profile;

                            liveBean.videoUrl = videoUrl;
                            liveBean.profile = profile;

                            exports.queue.emit('complete:location', {
                                status: 'success',
                                callback: callback
                            });
                        },
                        onError: function(e) {
                            if (e.code) {
                                debug.warn('failed to get live location. caused by error:', e);
                                exports.queue.emit('show:error', { info: e });
                            }
                        }
                    },
                    {
                        async: false,
                        type: constants.HTTP.TYPE.JSON
                    }
                );
            },
            getLiveStat: function(liveLinkId) {
                var pathname = API.LIVE_STAT.URL.replace('{LIVE_LINK_ID}', liveLinkId);
                var url = URL_HOST + pathname;

                helpers.http
                    .fetch(url, {
                        async: true,
                        type: constants.HTTP.TYPE.JSON
                    })
                    .then(function(data) {
                        exports.queue.emit('complete:stat', data);
                    })
                    .catch(function(e) {
                        if (e.code) {
                            debug.warn('failed to get live stat. caused by error:', e);
                        }
                    });
            },
            fetchVmap: function(req) {
                if (!req) {
                    debug.log('Vmap request has not pre property!!');
                    return;
                }

                var vmapUrl = normalizeAdUrl(req.req_url);
                var reqString = buildVmapRequest(req);

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(vmapUrl, {
                            async: true,
                            type: constants.HTTP.TYPE.TEXT,
                            credentials: 'include',
                            method: constants.HTTP.METHOD.POST,
                            body: reqString,
                            timeout: 5000,
                            contentType: 'application/json',
                            headers: {
                                Accept: 'application/xml'
                            }
                        })
                        .then(function(data) {
                            exports.queue
                                .emit('complete:vmap', {
                                    status: 'success',
                                    req: req,
                                    res: data
                                })
                                .then(function() {
                                    resolve();
                                });
                        })
                        .catch(function(e) {
                            exports.queue
                                .emit('complete:vmap', {
                                    status: 'error',
                                    error: e
                                })
                                .then(function() {
                                    reject(e);
                                });
                        });
                });
            },
            fetchVast: function(req) {
                var isAsync = helpers.device.isSupportAjaxAsync(ua);
                var adTagURI = req.adSource && req.adSource.adTagURI;

                if (!adTagURI) {
                    debug.log('xylophone vast adTagURI does not exist!!');
                    return false;
                }

                var uri = adTagURI['@_uri'];
                if (!uri || uri === '') {
                    debug.log('xylophone vast ad uri is empty!!');
                    return false;
                }

                var vastUrl = normalizeAdUrl(uri);
                vastUrl = vastUrl
                    .replace('[PLAYTIME]', (dt.StopWatch.has('midrollPlayingTime') / 1000).toFixed(0))
                    .replace('[SEEKFROM]', helpers.string.sec2hhmmss(player.getBeforeSeekedTime()))
                    .replace('[CONTENTPLAYHEAD]', helpers.string.sec2hhmmss(player.getCurrentTime()));
                debug.tooltip(
                    'Midroll AD Request  PLAYTIME : ' +
                        (dt.StopWatch.has('midrollPlayingTime') / 1000).toFixed(0) +
                        ', CONTENTPLAYHEAD : ',
                    helpers.string.sec2hhmmss(player.getCurrentTime())
                );

                return new Promise(function(resolve, reject) {
                    helpers.http
                        .fetch(vastUrl, {
                            async: isAsync,
                            type: constants.HTTP.TYPE.TEXT,
                            credentials: 'include',
                            method: constants.HTTP.METHOD.GET,
                            timeout: 5000,
                            contentType: 'application/json',
                            headers: {
                                Accept: 'application/xml'
                            }
                        })
                        .then(function(data) {
                            exports.queue
                                .emit('complete:vast', {
                                    status: 'success',
                                    req: req,
                                    res: data
                                })
                                .then(resolve)
                                .catch(reject);
                        })
                        .catch(function(e) {
                            if (req.timeOffset === 'start') {
                                exports.queue
                                    .emit('complete:vast', {
                                        status: 'error',
                                        error: e
                                    })
                                    .then(function() {
                                        reject();
                                    });
                            }
                        });
                });
            },
            getRelatedClip: function(clipLinkId, params, size) {
                var url, pathname, queryString;
                var defaults = API.RELATED_CLIP.PARAM;

                dt.extend(defaults, params, true);
                queryString = helpers.string.jsonToQueryString(defaults);

                pathname = API.RELATED_CLIP.URL.replace('{CLIP_LINK_ID}', clipLinkId);
                url = URL_HOST + pathname + '?' + queryString + '&' + API.RELATED_CLIP.EXCLUDE_PARAM + '&size=' + size;

                helpers.http
                    .fetch(url, {
                        async: true,
                        type: constants.HTTP.TYPE.JSON
                    })
                    .then(function(data) {
                        exports.queue.emit('load:clip:related', { status: 'success', data: data });
                    })
                    .catch(function(e) {
                        exports.queue.emit('load:clip:related', { status: 'error', error: e });
                    });
            },
            getRecommendedClip: function(liveLinkId, callback) {
                var url, pathname;

                pathname = API.RECOMMENDED_CLIP.URL.replace('{LIVE_LINK_ID}', liveLinkId);
                url = URL_HOST + pathname + '?' + API.RECOMMENDED_CLIP.EXCLUDE_PARAM;

                helpers.http
                    .fetch(url, {
                        async: true,
                        type: constants.HTTP.TYPE.JSON
                    })
                    .then(function(data) {
                        exports.queue.emit('load:clip:recommended', {
                            status: 'success',
                            data: data,
                            callback: callback
                        });
                    })
                    .catch(function(e) {
                        exports.queue.emit('load:clip:recommended', {
                            status: 'error',
                            error: e
                        });
                    });
            },
            updateClipInfo: function(clipId, params) {
                var url = API.CLIP_INFO_MODIFY.URL.replace('{CLIP_ID}', clipId);

                var reqString = JSON.stringify(params);

                helpers.http
                    .fetch(url, {
                        async: true,
                        method: constants.HTTP.METHOD.PUT,
                        type: constants.HTTP.TYPE.JSON,
                        body: reqString,
                        contentType: 'application/json'
                    })
                    .then(function(data) {
                        exports.queue.emit('update:clipinfo', { status: 'success', result: data });
                    })
                    .catch(function(e) {
                        exports.queue.emit('update:clipinfo', { status: 'error', error: e });
                    });
            },
            updateClipCover: function(clipId, params, index) {
                var url = API.CLIP_COVER_MODIFY.URL.replace('{CLIP_ID}', clipId).replace('{THUMB_INDEX}', index);

                var reqString = JSON.stringify(params);

                helpers.http
                    .fetch(url, {
                        async: true,
                        method: constants.HTTP.METHOD.PUT,
                        type: constants.HTTP.TYPE.JSON,
                        body: reqString,
                        contentType: 'application/json'
                    })
                    .then(function(data) {
                        exports.queue.emit('update:clipcover', { status: 'success', result: data, index: index });
                    })
                    .catch(function(e) {
                        exports.queue.emit('update:clipcover', { status: 'error', error: e });
                    });
            },
            getOutputProcessingInfo: function(clipId) {
                var url = API.OUTPUT_PROCESSING_INFO.URL.replace('{CLIP_ID}', clipId);

                helpers.http
                    .fetch(url, {
                        async: true,
                        type: constants.HTTP.TYPE.JSON
                    })
                    .then(function(data) {
                        exports.queue.emit('output:processing', { status: 'success', result: data });
                    })
                    .catch(function(e) {
                        if (e.code) {
                            debug.warn('failed to get clip location. caused by error:', e);
                        }

                        exports.queue.emit('output:processing', { status: 'error' });
                    });
            },
            checkAuthStatus: function(chekUrl, params) {
                var url, queryString;
                var defaults = API.AUTH_VERFICATION.PARAM;

                dt.extend(defaults, params, true);

                queryString = helpers.string.jsonToQueryString(defaults);

                url = URL_HOST + chekUrl + '&' + queryString;

                helpers.http.ajax(
                    url,
                    {
                        onSuccess: function(data) {
                            debug.log('auth status', data);

                            exports.queue.emit('check:auth', { status: 'success', result: data });
                        },
                        onError: function(e) {
                            exports.queue.emit('check:auth', { status: 'error', result: e });
                        }
                    },
                    {
                        async: false,
                        timeout: 5000,
                        type: constants.HTTP.TYPE.JSON
                    }
                );
            },
            getAnalyticsClipPlay: function(clipLinkId) {
                var url = API.ANALYTICS_CLIP_PLAY.URL.replace('{CLIP_LINK_ID}', clipLinkId);

                helpers.http.ajax(
                    url,
                    {
                        onSuccess: function(data) {
                            exports.queue.emit('analytics:clip:play', { status: 'success', data: data });
                        },
                        onError: function(e) {
                            exports.queue.emit('analytics:clip:play', { status: 'error', error: e });
                        }
                    },
                    {
                        async: true,
                        type: constants.HTTP.TYPE.JSON,
                        contentType: 'text/plain;charset=UTF-8'
                    }
                );
            }
        };
    })();

    exports.addModule('playlist.dataloader', new DataLoader());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';

    var queue = exports.loadModule('playlist.queue');
    var player = exports.loadModule('player.adapter');
    var state = exports.loadModule('controller.state');

    var MediaSession = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var ua = exports.ua;
        var constants = exports.constants;

        function updatePositionState() {
            if ('setPositionState' in navigator.mediaSession) {
                var playbackRate = player.getPlaybackRate();
                var duration = player.getDurationRound();
                var position = player.getCurrentTimeRound();

                navigator.mediaSession.setPositionState({
                    duration: duration,
                    playbackRate: playbackRate === 0 ? 1 : playbackRate,
                    position: position
                });
            }
        }

        function updateMetadata(title, artist, isPlayingGdn) {
            var size = ua.platform === 'pc' ? 'C640x360' : 'C480x270';
            var coverUrl = helpers.string.getThumbnailFarmUrl(state.currentVideo.coverUrl, size);

            if ('mediaSession' in navigator) {
                navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: title || '',
                    artist: artist || '',
                    artwork: [
                        { src: coverUrl, sizes: '96x96', type: 'image/png' },
                        { src: coverUrl, sizes: '128x128', type: 'image/png' },
                        { src: coverUrl, sizes: '192x192', type: 'image/png' },
                        { src: coverUrl, sizes: '256x256', type: 'image/png' },
                        { src: coverUrl, sizes: '384x384', type: 'image/png' },
                        { src: coverUrl, sizes: '512x512', type: 'image/png' }
                    ]
                });

                if (!isPlayingGdn && queue.front.type === constants.VIDEO_TYPE.VOD) {
                    updatePositionState(navigator.mediaSession);
                }
            }
        }

        function setPlaybackState(isPaused) {
            var state = 'none';

            if ('mediaSession' in navigator) {
                if (typeof isPaused === 'boolean') {
                    state = isPaused ? 'paused' : 'playing';
                }
                navigator.mediaSession.playbackState = state;
            }
        }

        function resetMediaSession() {
            if ('mediaSession' in navigator) {
                setPlaybackState('none');

                if (navigator.mediaSession.setPositionState) {
                    navigator.mediaSession.setPositionState(null);
                }
                navigator.mediaSession.metadata = null;
            }
        }

        function registerMediaSessionActionHandlers() {
            if ('mediaSession' in navigator) {
                navigator.mediaSession.setActionHandler('play', function() {
                    debug.log('[media.session] user clicked play');
                    if (state.ended && queue.front.type === constants.VIDEO_TYPE.LIVE) {
                        return;
                    }

                    player.play();
                    setPlaybackState('playing');

                    exports.queue.emit('play:ima');
                });

                navigator.mediaSession.setActionHandler('pause', function() {
                    debug.log('[media.session] user clicked pause');
                    player.pause();
                    setPlaybackState('paused');

                    exports.queue.emit('pause:ima');
                });

                navigator.mediaSession.setActionHandler('seekbackward', function(details) {
                    debug.log('[media.session] user clicked seekbackward', details);

                    if (
                        queue.front.type === constants.VIDEO_TYPE.AD ||
                        queue.front.type === constants.VIDEO_TYPE.LIVE
                    ) {
                        return;
                    }

                    var currentTime = player.getCurrentTimeRound() - 10;
                    if (currentTime > 0) {
                        player.seekTo(currentTime);
                        updatePositionState(navigator.mediaSession);
                    }
                });

                navigator.mediaSession.setActionHandler('seekforward', function(details) {
                    debug.log('[media.session] user clicked seekforward', details);

                    if (
                        queue.front.type === constants.VIDEO_TYPE.AD ||
                        queue.front.type === constants.VIDEO_TYPE.LIVE
                    ) {
                        return;
                    }

                    var currentTime = player.getCurrentTimeRound() + 10;
                    if (currentTime < player.getDurationRound()) {
                        player.seekTo(currentTime);
                        updatePositionState();
                    }
                });

                try {
                    navigator.mediaSession.setActionHandler('skipad', function(details) {
                        debug.log('[media.session] user clicked skipad', details);
                    });
                } catch (error) {
                    debug.log(error);
                }
            }
        }

        function MediaSession() {}

        MediaSession.prototype.init = function(player, sandbox) {
            registerMediaSessionActionHandlers();

            sandbox.on('onClosed:videoEvent', function() {
                var title = '라이브 방송이 종료되었습니다.';
                var artist = '';

                updateMetadata(title, artist);
                setPlaybackState(false);
            });
        };

        MediaSession.prototype.updateMetadata = function(title, artist, isPlayingGdn) {
            updateMetadata(title, artist, isPlayingGdn);
        };

        MediaSession.prototype.resetMediaSession = function() {
            resetMediaSession();
        };

        MediaSession.prototype.setPlaybackState = function(isPaused) {
            setPlaybackState(isPaused);
        };

        return MediaSession;
    })();

    exports.addModule('media.session', new MediaSession());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';

    var ServerSetting;

    ServerSetting = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var constants = exports.constants;
        var ua = exports.ua;
        var env = exports.ENV;
        var helpers = exports.helpers;

        var phase = constants.PHASE[env.phase.toUpperCase()];

        var klimtServer = '';
        var playerServer = '';

        var EL = {
            SERVER_SETTING_CONTAINER: $('serverSettingContainer'),
            FINISH_BUTTON: $$('#serverSettingContainer .btn_finish')[0],
            CANCEL_BUTTON: $$('#serverSettingContainer .btn_cancel')[0],
            KLIMT_INPUT: $$('#klimtServer .server_input')[0],
            PLAYER_INPUT: $$('#playerServer .server_input')[0],
            KLIMT_SELECT: $$('#klimtServer .server_select')[0],
            PLAYER_SELECT: $$('#playerServer .server_select')[0]
        };

        var server = {
            el: EL.SERVER_SETTING_CONTAINER,
            show: function() {
                if (this.el) {
                    dt.classList.remove(this.el, 'hide');
                }
            },
            hide: function() {
                if (this.el) {
                    dt.classList.add(this.el, 'hide');
                }
            }
        };

        var listener = {
            viewEvent: function() {
                event.on(EL.SERVER_SETTING_CONTAINER, 'click', function(e) {
                    var playerUrl = '//';
                    event.preventDefault(e);

                    if (e.target === EL.FINISH_BUTTON) {
                        var queryString = window.location.search;
                        klimtServer = EL.KLIMT_INPUT.value;
                        playerServer = EL.PLAYER_INPUT.value;

                        if (queryString.indexOf('klimt') !== -1) {
                            queryString = queryString.substr(0, queryString.indexOf('&klimt'));
                        }

                        playerUrl += playerServer + window.location.pathname + '/' + queryString;
                        window.open(playerUrl + '&klimt=' + klimtServer, '_self');
                        helpers.debug.setShowServerSetting(false);
                        server.hide();
                    }

                    if (e.target === EL.CANCEL_BUTTON) {
                        EL.KLIMT_INPUT.value = klimtServer;
                        EL.PLAYER_INPUT.value = playerServer;
                        helpers.debug.setShowServerSetting(false);
                        server.hide();
                    }
                });

                event.on(EL.KLIMT_SELECT, 'change', function(e) {
                    EL.KLIMT_INPUT.value = getKlimtServer(e.target.value);
                });

                event.on(EL.PLAYER_SELECT, 'change', function(e) {
                    EL.PLAYER_INPUT.value = getPlayerServer(e.target.value);
                });
            }
        };

        function getKlimtServer(serverNum) {
            var defaultServerHost = 'tv.devel.kakao.com';
            var klimtServerHost = defaultServerHost;
            var klimtPhase = phase;

            if (phase === constants.PHASE.CBT) {
                klimtPhase = 'beta';
            } else if (phase === constants.PHASE.DEV) {
                klimtPhase = 'alpha';
            }

            if (phase !== constants.PHASE.PROD) {
                if (serverNum > 1) {
                    klimtServerHost =
                        klimtPhase + (serverNum === '10' ? '10' : '0' + serverNum) + '-' + defaultServerHost;
                } else {
                    klimtServerHost = klimtPhase + '-' + defaultServerHost;
                }
            }

            if (phase !== constants.PHASE.SANDBOX || parseInt(serverNum, 10) <= 5) {
                klimtServerHost = klimtServerHost.replace('devel.', '');
            }

            return klimtServerHost.toLowerCase();
        }

        function getPlayerServer(serverNum) {
            var defaultServerHost = 'player.devel.kakao.com';
            var playerServerHost = 'pg-' + defaultServerHost;

            if (phase !== constants.PHASE.PROD) {
                if (serverNum > 1) {
                    playerServerHost = phase + (serverNum === '10' ? '10' : '0' + serverNum) + '-' + defaultServerHost;
                } else {
                    playerServerHost = phase + '-' + defaultServerHost;
                }
            } else {
                playerServerHost = playerServerHost.replace('devel.', '');
            }

            return playerServerHost.toLowerCase();
        }

        function ServerSetting() {}

        ServerSetting.prototype.init = function() {
            if (ua.platform !== 'pc') {
                return;
            }

            if (env.klimtServer) {
                klimtServer = env.klimtServer;
            } else if (window.location.host.indexOf('tv.kakao.com') !== -1) {
                klimtServer = window.location.host;
            } else {
                klimtServer = getKlimtServer(1);
            }

            playerServer = env.host.replace(/^http:\/\/|^https:\/\//g, '');

            if (EL.KLIMT_INPUT) {
                EL.KLIMT_INPUT.value = klimtServer;
            }

            if (EL.PLAYER_INPUT) {
                EL.PLAYER_INPUT.value = playerServer;
            }

            listener.viewEvent();
        };

        ServerSetting.prototype.show = function() {
            helpers.debug.setShowServerSetting(true);
            server.show();
        };

        return ServerSetting;
    })();

    exports.addModule('view.serversetting', new ServerSetting());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var html5 = exports.loadModule('player.html5');
    var state = exports.loadModule('controller.state');
    var pctTracker = exports.loadModule('pct.tracker');
    var Analytics;

    Analytics = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;
        var playDatas = [];
        var ageDatas = [];
        var genderDatas = [];
        var minSec = 10;
        var playChart = null;
        var genderChart = null;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var CHART_KEY = constants.STORAGE.CHART;

        var SELECTOR = {
            CHART_CIRCLE: '#chartContainer circle',
            BUTTON_CHART_DATA: '.btn_chartdata',
            BUTTON_CLOSE: '#videoDetailContainer .btn_close'
        };

        var EL = {
            CHART_CONTAINER: $('chartContainer'),
            CHART_MENU: $$('.box_chart')[0],
            CHART_CONTEXT_MENU: $$('.btn_chart_toggle')[0],
            DETAIL_CONTAINER: $('videoDetailContainer'),
            DETAIL_BUTTON: $$('.btn_chartdata')[0],
            DETAIL_CONTEXT_MENU: $$('.btn_video_data')[0],
            PLAYER_CONTAINER: $('playerContainer'),
            PROGRESSBAR: $('progress')
        };

        function createPlayChart() {
            playChart = window.AmCharts.makeChart('playChartDiv', {
                type: 'serial',
                categoryField: 'time',
                hideCredits: true,
                color: '#FFFFFF',
                theme: 'default',
                categoryAxis: {
                    startOnAxis: true,
                    labelsEnabled: false,
                    axisThickness: 0,
                    tickLength: 0,
                    gridThickness: 0
                },
                graphs: [
                    {
                        balloonText: '구간별 재생수 [[value]]',
                        bullet: 'round',
                        bulletHitAreaSize: 20,
                        bulletBorderAlpha: 0,
                        bulletSize: 8,
                        fillAlphas: 0,
                        type: 'line',
                        valueField: 'series',
                        fillColors: '#ff0962',
                        lineColor: '#ff0962',
                        lineThickness: 3
                    }
                ],
                valueAxes: [
                    {
                        labelsEnabled: false,
                        axisThickness: 0,
                        tickLength: 0,
                        gridThickness: 0,
                        gridAlpha: 0
                    }
                ],
                balloon: {
                    borderThickness: 0,
                    fontSize: 12,
                    fillAlpha: 1,
                    fontFamily: 'Apple SD Gothic Neo',
                    color: '#FFFFFF',
                    fillColor: '#363d50'
                },
                dataProvider: playDatas
            });
        }

        function createAgeChart() {
            window.AmCharts.makeChart('ageChartDiv', {
                type: 'serial',
                categoryField: 'age',
                categoryAxis: {
                    axisThickness: 0,
                    tickLength: 0,
                    gridThickness: 0,
                    labelFrequency: 1,
                    color: '#FFFFFF'
                },
                valueAxes: [
                    {
                        color: '#FFFFFF',
                        axisThickness: 0,
                        tickLength: 0,
                        gridThickness: 0,
                        labelFrequency: 1,
                        unit: '명'
                    }
                ],
                balloon: {
                    borderThickness: 0,
                    fontSize: 12,
                    fontFamily: 'Apple SD Gothic Neo',
                    color: '#FFFFFF',
                    fillColor: '#363d50'
                },
                graphs: [
                    {
                        balloonText: '[[value]]명',
                        columnWidth: 0.35,
                        fillAlphas: 1,
                        fillColorsField: 'color',
                        lineThickness: 0,
                        type: 'column',
                        valueField: 'series'
                    }
                ],
                dataProvider: ageDatas
            });
        }

        function createGenderChart() {
            genderChart = window.AmCharts.makeChart('genderChartDiv', {
                type: 'pie',
                innerRadius: '70%',
                titleField: 'gender',
                valueField: 'value',
                gradientType: 'linear',
                labelsEnabled: true,
                labelText: '[[percents]]%',
                color: '#FFFFFF',
                fontFamily: 'Apple SD Gothic Neo',
                baseColor: '#01fae0',
                colorField: 'color',
                outlineAlpha: 0.8,
                outlineColor: '#000000',
                outlineThickness: 1,
                radius: '40%',
                labelRadius: -55,
                pullOutRadius: '0%',
                startRadius: '0%',
                balloonText: '[[percents]]% ([[value]]명)',
                balloon: {
                    borderThickness: 0,
                    fontSize: 12,
                    fontFamily: 'Apple SD Gothic Neo',
                    color: '#FFFFFF',
                    fillColor: '#363d50'
                },
                dataProvider: genderDatas
            });
        }

        function setChartDatas(data) {
            ageDatas = [];
            genderDatas = [];
            playDatas = [];

            setPlayDatas(data.playSection);
            setAgeDatas(data.demography.age);
            setGenderDatas(data.demography.gender);
        }

        function setPlayDatas(playSection) {
            var duration = state.currentVideo.duration;

            if (playSection.series && playSection.series.length > 0) {
                minSec = playSection.sectionSize || 10;
                playDatas.push({ time: 0, series: playSection.series[0][0] });
                for (var i = 0; i < playSection.series[0].length; i++) {
                    playDatas.push({
                        time: playSection.labels[i],
                        series: playSection.series[0][i]
                    });
                }
                playDatas.push({ time: duration, series: playSection.series[0][playSection.series[0].length - 1] });
            }
        }

        function setAgeDatas(age) {
            var maxPlayAgeIndex = 0;
            var maxPlayAge = 0;

            if (age.series.length > 0) {
                for (var i = 0; i < age.series[0].length; i++) {
                    ageDatas.push({
                        age: age.labels[i] + '대',
                        series: age.series[0][i],
                        color: '#00baff'
                    });

                    if (maxPlayAge < age.series[0][i]) {
                        maxPlayAge = age.series[0][i];
                        maxPlayAgeIndex = i;
                    }
                }
                ageDatas[maxPlayAgeIndex].color = '#ff0962';
            }
        }

        function setGenderDatas(gender) {
            if (gender) {
                genderDatas.push({ gender: '남성', value: gender.maleCount, color: '#01fae0' });
                genderDatas.push({ gender: '여성', value: gender.femaleCount, color: '#bf50f6' });
            }
        }

        var analytics = {
            chart: {
                isShow: false,
                isCanShow: true,
                el: EL.CHART_CONTAINER,
                show: function() {
                    this.isShow = true;
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                        this.reSize();
                    }
                },
                hide: function() {
                    this.isShow = false;
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                },
                reSize: function() {
                    if (this.el) {
                        var playerWidth =
                            parseInt(EL.PLAYER_CONTAINER.style.width.replace('px', '')) ||
                            EL.PLAYER_CONTAINER.clientWidth;
                        var isMaxSize = playerWidth >= 1920 || EL.PLAYER_CONTAINER.parentElement.offsetWidth >= 1920;
                        var defaultCahrtHeight = isMaxSize ? 200 : 110;
                        var defaultProgressBottom = 41;
                        var chartHeight = this.el.clientHeight ? this.el.clientHeight : defaultCahrtHeight;
                        var chartTop =
                            EL.PLAYER_CONTAINER.clientHeight - defaultProgressBottom + EL.PLAYER_CONTAINER.offsetTop;
                        this.el.style.width = EL.PLAYER_CONTAINER.style.width;
                        this.el.style.left = EL.PLAYER_CONTAINER.style.left;
                        this.el.style.top = chartTop - chartHeight + 'px';

                        if (playChart) {
                            playChart.graphs[0].lineThickness = isMaxSize ? 6 : 3;
                            playChart.graphs[0].bulletSize = isMaxSize ? 16 : 8;
                        }

                        if (genderChart) {
                            genderChart.labelRadius = isMaxSize ? -80 : -55;
                        }
                    }
                }
            },
            detail: {
                isCanShow: true,
                el: EL.DETAIL_CONTAINER,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                }
            }
        };

        var listener = {
            viewEvent: function() {
                event.delegate(EL.PLAYER_CONTAINER, SELECTOR.CHART_CIRCLE, 'click', function(e) {
                    event.preventDefault(e);

                    var childCount = e.target.parentNode.childElementCount;
                    for (var i = 0; i < childCount; i++) {
                        if (e.target.parentNode.childNodes[i] === e.target) {
                            var seekTime = parseInt(i / 2);
                            html5.seekTo(seekTime * minSec);
                            break;
                        }
                    }
                    pctTracker.track('chart', 'pointer');
                });

                event.delegate(EL.PLAYER_CONTAINER, SELECTOR.BUTTON_CHART_DATA, 'click', function(e) {
                    event.preventDefault(e);

                    analytics.detail.show();
                    exports.queue.emit('hide:controller');
                    exports.queue.emit('analytics:chart', true);
                    pctTracker.track('detail_data');
                });

                event.delegate(EL.PLAYER_CONTAINER, SELECTOR.BUTTON_CLOSE, 'click', function(e) {
                    event.preventDefault(e);

                    analytics.detail.hide();

                    if (helpers.store.get(CHART_KEY) !== 'false') {
                        exports.queue.emit('analytics:chart', false);
                    }
                });
            },
            customEvent: function(sandbox) {
                sandbox.on('analytics:clip:play', function(result) {
                    var status = result.status;
                    var data = result.data;

                    if (status === 'success') {
                        setChartDatas(data);

                        if (playDatas.length > 0) {
                            createPlayChart();
                            dt.classList.remove(EL.CHART_MENU, 'hide');
                        } else {
                            analytics.chart.isCanShow = false;
                            dt.classList.add(EL.CHART_CONTEXT_MENU, 'hide');
                        }

                        if (ageDatas.length > 0) {
                            createAgeChart();
                            createGenderChart();
                        } else {
                            analytics.detail.isCanShow = false;
                            dt.classList.add(EL.DETAIL_BUTTON, 'hide');
                            dt.classList.add(EL.DETAIL_CONTEXT_MENU, 'hide');
                        }
                    }
                });
            }
        };

        function Analytics() {}

        Analytics.prototype.init = function(player, sandbox) {
            listener.viewEvent();
            listener.customEvent(sandbox);
        };

        Analytics.prototype.chartShow = function() {
            analytics.chart.show();
        };

        Analytics.prototype.chartHide = function() {
            analytics.chart.hide();
        };

        Analytics.prototype.detailShow = function() {
            analytics.detail.show();
        };

        Analytics.prototype.detailHide = function() {
            analytics.detail.hide();
        };

        Analytics.prototype.isChartShow = function() {
            return analytics.chart.isShow;
        };

        Analytics.prototype.isCanShowPlayChart = function() {
            return analytics.chart.isCanShow;
        };

        Analytics.prototype.isCanShowDataChart = function() {
            return analytics.detail.isCanShow;
        };

        Analytics.prototype.reSize = function() {
            return analytics.chart.reSize();
        };

        return Analytics;
    })();

    exports.addModule('view.analytics', new Analytics());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var state = exports.loadModule('controller.state');
    var pctTracker = exports.loadModule('pct.tracker');
    var serverSetting = exports.loadModule('view.serversetting');
    var analytics = exports.loadModule('view.analytics');

    var ContextMenu;

    ContextMenu = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var ua = exports.ua;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;
        var constants = exports.constants;

        var EL = {
            PLAYER_CONTAINER: $('playerContainer'),
            VIDEO_CONTAINER: $('videoContainer'),
            PLAYER_CONTROLLER_CONTAINER: $('controllerContainer'),
            CONTEXT_MENU: $('contextMenu'),
            PIP_BUTTON: $$('.btn_pip')[0],
            COPY_URL_BUTTON: $$('.btn_urlcopy')[0],
            VERSION_TEXT: $$('.version_syntax')[0],
            VIDEO_CHART_BUTTON: $$('.btn_chart_toggle')[0],
            VIDEO_CHART_INPUT: $$('.btn_chart_toggle .inp_toggle')[0],
            VIDEO_CHART_LABEL: $$('.btn_chart_toggle .lab_toggle')[0],
            SETTING_SERVER_BUTTON: $$('.btn_setting_server')[0],
            VIDEO_DATA_BUTTON: $$('.btn_video_data')[0],
            SERVER_NAME_BOX: $$('.server_name_box')[0],
            PLAYER_SERVER_NAME: $$('.player_server_name')[0]
        };

        var isSupportClipBoard = window.ClipboardJS.isSupported();

        var menu = {
            el: EL.CONTEXT_MENU,
            show: function() {
                state.isContextMenuOpened = true;
                dt.classList.remove(this.el, 'hide');
            },
            hide: function() {
                state.isContextMenuOpened = false;
                dt.classList.add(this.el, 'hide');
            },
            toggle: function() {
                if (state.isContextMenuOpened) {
                    this.hide();
                } else {
                    this.show();
                }
            },
            setPosition: function(x, y) {
                var playerRect = EL.PLAYER_CONTAINER.getBoundingClientRect();
                var posX = x - playerRect.left + 'px';
                var posY = y - playerRect.top + 'px';
                var menuWidth = this.el.offsetWidth + 5;
                var menuHeight = this.el.offsetHeight + 5;

                if (window.innerWidth - x < menuWidth) {
                    posX = window.innerWidth - playerRect.left - menuWidth + 'px';
                }

                if (window.innerHeight - y < menuHeight) {
                    posY = window.innerHeight - playerRect.top - menuHeight + 'px';
                }

                this.el.style.left = posX;
                this.el.style.top = posY;
            },
            pip: {
                el: EL.PIP_BUTTON,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                },
                toggleButton: function(isPipMode) {
                    if (isPipMode) {
                        this.el.innerHTML = 'PIP 모드 종료';
                    } else {
                        this.el.innerHTML = 'PIP 모드';
                    }
                },
                togglePip: function() {
                    var isPipScreen = helpers.webapi.pip.isPipScreen();
                    if (isPipScreen) {
                        exitPictureInPicture();
                    } else {
                        requestPictureInPicture();
                    }
                    this.toggleButton(isPipScreen);
                }
            },
            share: {
                el: EL.COPY_URL_BUTTON,
                setUrl: function(url) {
                    dt.dataset(this.el, 'clipboard-text', url);
                },
                show: function() {
                    dt.classList.add(this.el, 'show');
                },
                hide: function() {
                    dt.classList.add(this.el, 'hide');
                }
            },
            setVersion: function() {
                EL.VERSION_TEXT.innerHTML = env.playerVersion;
                debug.log('[context.menu] set version:', env.playerVersion);
            },
            server: {
                el: EL.SETTING_SERVER_BUTTON,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                }
            },
            videoChart: {
                el: EL.VIDEO_CHART_BUTTON,
                toggle: EL.VIDEO_CHART_INPUT,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                }
            },
            videoData: {
                el: EL.VIDEO_DATA_BUTTON,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                }
            },
            serverName: {
                el: EL.SERVER_NAME_BOX,
                show: function() {
                    var serverName = env.playerServerName;

                    if (this.el && EL.PLAYER_SERVER_NAME) {
                        dt.classList.remove(this.el, 'hide');
                        EL.PLAYER_SERVER_NAME.innerText = serverName;
                    }
                }
            }
        };

        function getPosition(e) {
            var posX = e.pageX;
            var posY = e.pageY;

            return {
                x: posX,
                y: posY
            };
        }

        function setPositionMenu(e) {
            var pos = getPosition(e);
            menu.setPosition(pos.x, pos.y);
        }

        function requestPictureInPicture() {
            if (!helpers.webapi.pip.isPipScreen()) {
                helpers.webapi.pip.request(player.videoElement);
            }
        }

        function exitPictureInPicture() {
            if (helpers.webapi.pip.isPipScreen()) {
                helpers.webapi.pip.exit();
            }
        }

        function showPip(videoEl) {
            var video = videoEl || this;
            if (video.readyState === 0 || !document.pictureInPictureEnabled || video.disablePictureInPicture) {
                return;
            }
            menu.pip.show();
        }

        function onContextMenu(e) {
            event.preventDefault(e);
            menu.show();
            setPositionMenu(e);
        }

        function initContextMenu(videoEl) {
            var isSupportPiP = document.pictureInPictureEnabled;

            if (isSupportPiP) {
                showPip(videoEl);
                event.on(videoEl, 'loadedmetadata', showPip);
                event.on(videoEl, 'emptied', showPip);
            }

            if (!isSupportClipBoard || state.currentVideo.isLegacy) {
                menu.share.hide();
            } else {
                menu.share.show();
            }

            if (env.isPrivateIp) {
                menu.server.show();
            }

            if (env.playerServerName) {
                menu.serverName.show();
            }

            menu.setVersion();
        }

        function onEnterPictureInPicture(e) {
            var isPipMode = true;
            exports.queue.emit('request:pip');
            menu.pip.toggleButton(isPipMode);
            debug.log('[context.menu] enterpictureinpicture event handler - video entered picture-in-picture', e);
        }

        function onLeavePictureInPicture(e) {
            var isPipMode = false;

            exports.queue.emit('cancel:pip');
            menu.pip.toggleButton(isPipMode);

            pctTracker.track('pip_player', 'main_player');
            debug.log('[context.menu] leavepictureinpicture event handler - video left picture-in-picture', e);
        }

        function showNotification(isSuccess) {
            var relatedData = {
                message: isSuccess ? 'URL을 복사했습니다. 원하는 곳에 붙여넣기 하세요.' : 'URL 복사에 실패하였습니다.',
                callback: function() {
                    exports.queue.emit('hide:modal');
                }
            };
            exports.queue.emit('show:notification', relatedData);
        }

        function videoChartToggle() {
            if (EL.VIDEO_CHART_INPUT) {
                EL.VIDEO_CHART_INPUT.checked = analytics.isChartShow();
            }
        }

        var listener = {
            viewEvent: function(videoEl) {
                event.on(document, 'contextmenu', function(e) {
                    event.preventDefault(e);
                });
                event.on(EL.VIDEO_CONTAINER, 'contextmenu', onContextMenu);
                event.on(EL.PLAYER_CONTROLLER_CONTAINER, 'contextmenu', onContextMenu);
                event.on(videoEl, 'enterpictureinpicture', onEnterPictureInPicture);
                event.on(videoEl, 'leavepictureinpicture', onLeavePictureInPicture);

                event.on(
                    window,
                    'resize',
                    helpers.waiter.throttle(function() {
                        menu.hide();
                    }, 50)
                );

                event.on(EL.CONTEXT_MENU, 'click', function(e) {
                    if (
                        e.target === EL.VIDEO_CHART_INPUT ||
                        e.target === EL.VIDEO_CHART_BUTTON ||
                        e.target === EL.VIDEO_CHART_LABEL
                    ) {
                        exports.queue.emit('analytics:chart', analytics.isChartShow());
                        videoChartToggle();
                        if (e.target !== EL.VIDEO_CHART_INPUT) {
                            event.preventDefault(e);
                        }
                        helpers.store.set(constants.STORAGE.CHART, analytics.isChartShow());

                        if (analytics.isChartShow()) {
                            pctTracker.track('chart', 'on');
                        } else {
                            pctTracker.track('chart', 'off');
                        }
                        return;
                    }

                    event.preventDefault(e);
                    if (e.target === EL.PIP_BUTTON) {
                        menu.pip.togglePip();
                        pctTracker.track('context_menu', 'pip_player');
                    }

                    if (e.target === EL.COPY_URL_BUTTON) {
                        pctTracker.track('context_menu', 'url_copy');
                    }

                    if (e.target === EL.SETTING_SERVER_BUTTON) {
                        serverSetting.show();
                    }

                    if (e.target === EL.VIDEO_DATA_BUTTON) {
                        analytics.detailShow();
                        exports.queue.emit('hide:controller');
                        exports.queue.emit('analytics:chart', true);
                        pctTracker.track('detail_data');
                    }

                    menu.hide();
                });

                event.on(document, 'click', function(e) {
                    var button = e.which || e.button;

                    if (
                        e.target === EL.VIDEO_CHART_INPUT ||
                        e.target === EL.VIDEO_CHART_BUTTON ||
                        e.target === EL.VIDEO_CHART_LABEL
                    ) {
                        return;
                    }

                    if (button === 1) {
                        menu.hide();
                    }
                });

                event.on(window, 'blur', function() {
                    menu.hide();
                });
            },
            customEvent: function(player, sandbox) {
                sandbox.on('show:modal', function() {
                    menu.hide();
                });

                sandbox.on('show:completion', function() {
                    menu.hide();
                });

                sandbox.on('show:error', function() {
                    exitPictureInPicture();
                });

                sandbox.on('create:contextmenu', function() {
                    initContextMenu(player.videoElement);
                });
            },
            clipboardEvent: function(clipboard) {
                var isSuccess = true;

                clipboard.on('success', function() {
                    showNotification(isSuccess);
                });

                clipboard.on('error', function() {
                    isSuccess = false;
                    showNotification(isSuccess);
                });
            }
        };

        function ContextMenu() {}

        ContextMenu.prototype.init = function(player, sandbox) {
            this.videoEl = player.videoElement;

            if (ua.platform === 'pc') {
                var clipboard = new window.ClipboardJS('#contextMenu .urlcopy', { container: $('playerContainer') });
                listener.viewEvent(this.videoEl);
                listener.customEvent(player, sandbox);
                listener.clipboardEvent(clipboard);
            }
        };

        ContextMenu.prototype.show = function() {
            menu.show();
        };

        ContextMenu.prototype.hide = function() {
            menu.hide();
        };

        ContextMenu.prototype.toggle = function() {
            menu.toggle();
        };

        ContextMenu.prototype.setShareUrl = function(url) {
            menu.share.setUrl(url);
        };

        ContextMenu.prototype.exitPictureInPicture = function() {
            exitPictureInPicture();
        };

        ContextMenu.prototype.showAnalyticButton = function() {
            if (analytics.isCanShowPlayChart()) {
                menu.videoChart.show();
            }

            if (analytics.isCanShowDataChart()) {
                menu.videoData.show();
            }
        };

        ContextMenu.prototype.hideAnalyticButton = function() {
            menu.videoChart.hide();
            menu.videoData.hide();
        };

        ContextMenu.prototype.videoChartToggle = function() {
            videoChartToggle();
        };

        ContextMenu.prototype.showPip = function() {
            menu.pip.show();
        };

        ContextMenu.prototype.hidePip = function() {
            menu.pip.hide();
        };

        return ContextMenu;
    })();

    exports.addModule('view.contextmenu', new ContextMenu());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    function Error() {}

    Error.prototype = (function() {
        var state = exports.loadModule('controller.state');
        var dataloader = exports.loadModule('playlist.dataloader');
        var player = exports.loadModule('player.adapter');
        var pctTracker = exports.loadModule('pct.tracker');
        var playerTemplate = exports.template;

        var $ = dt.$;
        var $$ = dt.$$;
        var ua = exports.ua;
        var event = dt.event;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;

        var ERROR = constants.ERROR;
        var ERROR_STATUS = constants.ERROR.STATUS;

        var EL = {
            ERROR: $('errorView'),
            NOTICE_INFO: $('noticeInfo'),
            PROCESS_INFO: $('processInfo'),
            THUMBNAIL_CONTAINER: $('thumbnailImageContainer'),
            THUMBNAIL_IMAGE: $('thumbnailImage'),
            ALERT_MESSAGE: $('alertMessage'),
            ALERT_LIVEAGENT: $('alertLiveAgent')
        };

        var errorTemplate = {
            linkInfo: playerTemplate.link_info
        };

        var error = {
            el: EL.ERROR,
            status: null,
            infoEl: EL.NOTICE_INFO,
            messageEl: null,
            callback: function() {},
            setOption: function(option) {
                dt.extend(this, option, true);
            },
            normalizeInfoType: function(status) {
                error.hideBackground();
                if (status.MESSAGE_TYPE === 'notice') {
                    this.infoEl = EL.NOTICE_INFO;
                } else if (status.MESSAGE_TYPE === 'process') {
                    this.infoEl = EL.PROCESS_INFO;
                } else if (status.MESSAGE_TYPE === 'input') {
                    this.infoEl = EL.INPUT_INFO;
                }
            },
            show: function(status, info, option) {
                this.status = status;
                this.setOption(option);
                this.normalizeInfoType(status);
                setTemplate(status, info, this.infoEl);

                dt.classList.add(this.el, 'visible');
                dt.classList.remove(this.el, 'hidden');

                this.callback();
            },
            hide: function() {
                if (this.infoEl) {
                    dt.classList.add(this.infoEl, 'hide');
                }

                if (EL.ALERT_LIVEAGENT) {
                    dt.classList.add(EL.ALERT_LIVEAGENT, 'hide');
                }

                dt.classList.add(this.el, 'hidden');
                dt.classList.remove(this.el, 'visible');
            },
            showBackground: function() {
                if (EL.COVER_IMAGE) {
                    dt.classList.remove(EL.COVER_IMAGE, 'hide');
                }
            },
            hideBackground: function() {
                if (EL.COVER_IMAGE) {
                    dt.classList.add(EL.COVER_IMAGE, 'hide');
                }
            },
            showThumbnailImage: function() {
                if (EL.THUMBNAIL_CONTAINER) {
                    dt.classList.remove(EL.THUMBNAIL_CONTAINER, 'hide');
                }
            },
            setThumbnailImage: function(url) {
                if (EL.THUMBNAIL_IMAGE) {
                    EL.THUMBNAIL_IMAGE.style['background'] = 'url(' + url + ')';
                    EL.THUMBNAIL_IMAGE.style['background-size'] = '100%';
                }
            }
        };

        function showConfirmThumbnailImage() {
            exports.queue.emit('show:confirmThumbnailImage');
        }

        function showCoverThumbnailImage() {
            if (state.currentVideo && state.currentVideo.coverThumbnailUrl) {
                error.setThumbnailImage(state.currentVideo.coverThumbnailUrl);
            }
            error.showThumbnailImage();
        }

        function checkValidation(video) {
            if (!video) {
                return false;
            }

            if (video.playingInfo) {
                return false;
            }

            return true;
        }

        function getStatusByCode(errorCode) {
            var status = ERROR_STATUS[errorCode];

            if (!status) {
                status = ERROR.STATUS.UNAVAILABLE;
            }

            return status;
        }

        function setErrorMessage(info) {
            var status = getStatusByCode(info.code);

            if (info.message) {
                status.DESCRIPTION = helpers.string.replaceLinefeed(info.message);
            }
        }

        function showError(statusCode, info, option) {
            var isNoPurchase = info.code === constants.CONFIRM.STATUS.NoPurchased.NAME;
            var isNeedPurchase = info.code === constants.CONFIRM.STATUS.NeedPurchased.NAME;

            state.isShowError = true;

            exports.queue.emit('spinner:end');
            exports.queue.emit('hide:cover');
            exports.queue.emit('layerStatus:check');

            if (!isNoPurchase && !isNeedPurchase) {
                exports.queue.emit('hide:container');
            }

            var errorStatus = getStatusByCode(statusCode);
            var confirmCode = constants.CONFIRM.STATUS[statusCode];

            if (confirmCode) {
                if (ua.platform === 'mobile' && isNoPurchase) {
                    confirmCode = constants.CONFIRM.STATUS.NoPurchasedForMobile;
                }

                var confirmName = confirmCode.NAME;
                // todo confirm.js와 error.js가 순환되지않도록 변경해야함 / error를 confirm, notice가 구현하는 방법으로 변경
                if (confirmName !== ERROR_STATUS.EncodingNotCompleted.NAME || ua.platform !== 'pc') {
                    exports.queue.emit('show:confirm', {
                        status: confirmName,
                        info: info,
                        option: option
                    });
                    return;
                }
            }

            if (errorStatus.MESSAGE_TYPE === 'process' && ua.platform === 'pc') {
                dataloader.getOutputProcessingInfo(env.clipId);
            }

            error.show(errorStatus, info, option);

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayError);
            debug.info('show error type: ', errorStatus.MESSAGE_TYPE);
        }

        function hideError() {
            exports.queue.emit('show:container');

            state.isShowError = false;
            error.hide();
        }

        function setTemplate(status, info, target) {
            var paragraphEl = $$('p', target)[0];

            if (status.NAME === ERROR_STATUS.LiveAgentNotInstalled.NAME) {
                dt.classList.remove(EL.ALERT_LIVEAGENT, 'hide');
                dt.classList.add(EL.ALERT_MESSAGE, 'hide');
                exports.queue.emit('live:updateSetupView', info.profile);
                return;
            } else {
                dt.classList.remove(EL.ALERT_MESSAGE, 'hide');
                dt.classList.add(EL.ALERT_LIVEAGENT, 'hide');
            }

            if (
                status.MESSAGE_TYPE !== 'process' ||
                (ua.platform !== 'pc' && status.NAME === ERROR_STATUS.EncodingNotCompleted.NAME)
            ) {
                paragraphEl.innerHTML = status.DESCRIPTION;
            }

            if (status.NAME === ERROR_STATUS.LegacyPlayerNotice.NAME) {
                var view = {
                    infoUrl: status.LINK_URL
                };
                paragraphEl.innerHTML += errorTemplate.linkInfo.render(view);
            }

            var classes = status.CLASS_NAME && status.CLASS_NAME.split(' ');

            if (dt.classList.has(target.parentElement, constants.ERROR.CLASS.BACKGROUND_ALPHA)) {
                dt.classList.remove(target.parentElement, constants.ERROR.CLASS.BACKGROUND_ALPHA);
            }

            while (classes.length > 0) {
                var className = classes.pop();
                if (
                    className === constants.ERROR.CLASS.BACKGROUND_ALPHA ||
                    className === constants.ERROR.CLASS.BACKGROUND_DIMMED
                ) {
                    dt.classList.add(target.parentElement, className);
                } else if (className === constants.ERROR.CLASS.THUMBNAIL_IMG) {
                    showCoverThumbnailImage();
                } else {
                    dt.classList.add(target, className);
                }
            }

            var linkType = status.LINK_TYPE;

            if (linkType) {
                var button = null;
                var link = null;

                var linkContainer = $$('.' + linkType, target)[0];

                if (linkContainer) {
                    dt.classList.remove(linkContainer, 'hide');

                    if (linkType === 'qna') {
                        link = $$('a', linkContainer)[0];
                        link.href = status.LINK_URL || 'http://www.kakao.com/policy/right';
                    } else {
                        button = $$('button', linkContainer)[0];
                    }

                    if (button && info && info.checkUrl) {
                        button.setAttribute('data-url', info.checkUrl);
                    }
                }
            }

            if (status.NAME === ERROR_STATUS.LiveFinished.NAME || status.NAME === ERROR_STATUS.LiveException.NAME) {
                dt.classList.add(target, 'finished');
            }

            dt.classList.remove(target, 'hide');
        }

        function checkAuth(url) {
            var params = {
                service: 'kakao_tv'
            };

            dataloader.checkAuthStatus(url, params);
        }

        var listener = {
            viewEvent: function() {
                event.delegate(EL.ERROR, '.link_refresh', 'click', function() {
                    pctTracker.track('alert_network', 'refresh');
                    location.reload();
                });
                event.delegate(EL.ERROR, '.auth button', 'click', function(e) {
                    if (e.target.tagName === 'BUTTON') {
                        if (dt.classList.has(e.target, 'check')) {
                            var checkUrl = e.target.getAttribute('data-url');
                            debug.log(checkUrl);
                            checkAuth(checkUrl);
                            pctTracker.track('age_limit', 'verify');
                        }

                        if (dt.classList.has(e.target, 'complete')) {
                            location.reload();
                        }
                    }
                });
                event.delegate(EL.ERROR, '.link_redirect', 'click', function(e) {
                    e.preventDefault();

                    env.playerLegacy = false;
                    error.hide();
                    var profile = state.dash
                        ? constants.DASH_PROFILE[state.currentVideo.profile]
                        : state.currentVideo.profile;
                    exports.queue.emit('loadAndPlay:videoById', state.currentVideo.id, profile);
                });
                event.delegate(EL.ERROR, '.setup_guide', 'click', function() {
                    window.open(constants.URL.LIVEAGENT_SETUP_GUIDE, '_blank');
                    pctTracker.track('live_install', 'guide');
                });
                event.delegate(EL.ERROR, '.btn_extension_setup', 'click', function(e) {
                    if (e.target.tagName !== 'BUTTON') {
                        return;
                    }

                    window.open(constants.URL.LIVEAGENT_CHROME_EXTENSION, '_blank');
                    var profile =
                        $$('.btn_agent_setup', EL.ALERT_LIVEAGENT)[0].getAttribute('data-profile') ||
                        constants.PROFILE.HIGH;
                    pctTracker.track('live_install', 'chrome_extension');

                    player.checkForExtInstallation(profile);
                });

                event.delegate(EL.ERROR, '.btn_agent_setup', 'click', function() {
                    var downloadUrl =
                        ua.os.name === 'mac'
                            ? constants.URL.LIVEAGENT_DOWNLOAD_URL_MAC
                            : constants.URL.LIVEAGENT_DOWNLOAD_URL_WIN;
                    var profile =
                        $$('.alert_liveagent .btn_agent_setup')[0].getAttribute('data-profile') ||
                        constants.PROFILE.HIGH;
                    window.open(downloadUrl, '_self');
                    pctTracker.track('live_install', 'liveagent');

                    player.checkForAgentInstallation(profile);
                });

                event.delegate(EL.ERROR, '.a_agent_not_setup', 'click', function() {
                    hideError();
                    if (state.currentVideo.profile === constants.PROFILE.BASE) {
                        if (state.playerClass === constants.PLAYERCLASS.KAMP) {
                            player.play();
                        } else {
                            exports.queue.emit('load:videoById', 0, true);
                        }
                        pctTracker.track('live_install', 'play');
                        return;
                    }

                    if (player.isPaused()) {
                        state.currentVideo.profile = constants.PROFILE.BASE;
                        exports.queue.emit('load:videoById', 0, true);
                    }

                    pctTracker.track('liveagent', 'install');
                });

                event.delegate(EL.ERROR, '.btn_close', 'click', function() {
                    hideError();
                });
            },
            customEvent: function(sandbox) {
                var timer = null;
                var errorCount = 0;

                sandbox.on('show:error', function(data) {
                    var errorInfo = data.info;
                    var errorStatus = getStatusByCode(errorInfo.code);

                    setErrorMessage(errorInfo);
                    showError(errorInfo.code, errorInfo);

                    if (
                        (errorInfo.metaUrl &&
                            errorStatus.CLASS_NAME.indexOf(constants.ERROR.CLASS.THUMBNAIL_IMG) > 0) ||
                        errorInfo.code === constants.CONFIRM.STATUS.NoPurchased.NAME
                    ) {
                        exports.queue.emit('load:meta', {
                            metaUrl: errorInfo.metaUrl,
                            callback:
                                errorInfo.code === constants.CONFIRM.STATUS.NoPurchased.NAME
                                    ? showConfirmThumbnailImage
                                    : showCoverThumbnailImage
                        });
                    }

                    debug.info('show error');
                });
                sandbox.on('hide:error', function() {
                    hideError();
                });
                sandbox.on('output:processing', function(data) {
                    var callDelay = 5 * 1000;
                    var pState;

                    if (data.status === 'success') {
                        pState = data.result.state;

                        if (pState === 'PROCESSING') {
                            $('loadingNum').innerHTML = data.result.progress;
                        } else if (pState === 'WAIT_FINISH') {
                            $('loadingNum').innerHTML = 99;
                        } else if (pState === 'DONE') {
                            $('loadingNum').innerHTML = 100;
                            location.reload();
                            return;
                        }
                    } else {
                        errorCount++;
                    }

                    if (errorCount > 5) {
                        alert('인코딩 진행정보를 받아오는데 실패하였습니다.\n잠시후에 다시 시도해주세요.');
                        return;
                    }

                    timer = setTimeout(function() {
                        dataloader.getOutputProcessingInfo(env.clipId);
                        clearTimeout(timer);
                    }, callDelay);
                });
                sandbox.on('check:auth', function(data) {
                    var protocol = window.location.protocol;
                    var host = env.host.replace(/^http:|^https:/g, protocol);
                    var returnUrl = host + '/embed/player/playerpopupcallback';
                    var specs =
                        'fullscreen=no, width=800, height=800, menubar=no, ' +
                        'scrollbars=no, status=no, titlebar=no, resizable=yes';

                    var url = data.result.additionalInfo && data.result.additionalInfo.url;

                    // 인증이 안된경우 status code가 401로 내려오기때문에 임시로 error부분에서 인증관련 로직추가.
                    // todo 웹에 맞는 로그인 프로세스로 수정해야함.
                    if (data.status === 'success') {
                        if (url !== '') {
                            url = url + '&service=kakao_tv&';
                        }
                    } else {
                        var errorCode = data.result.code;

                        if (errorCode === 'NeedLogin') {
                            debug.warn('로그인이 필요합니다.', data.result);

                            if (url !== '') {
                                url = url + '?';
                            }
                        } else {
                            debug.warn('본인인증이 필요합니다.', data.result);

                            if (url !== '') {
                                url = url + '&service=kakao_tv&';
                            }
                        }
                    }

                    if (ua.platform === 'pc') {
                        url = url + 'continue=' + encodeURIComponent(returnUrl);
                        window.open(url, '_blank', specs);
                    } else {
                        url = url + 'continue=' + encodeURIComponent(env.referer);
                        top.location.href = url;
                    }
                });
            }
        };

        return {
            init: function(player, sandbox) {
                listener.viewEvent();
                listener.customEvent(sandbox);
            },
            showError: function(statusCode, info, option) {
                showError(statusCode, info, option);
            },
            hideError: function() {
                hideError();
            },
            setTemplate: function(status, info, target) {
                setTemplate(status, info, target);
            },
            addStyle: function(cname) {
                dt.classList.add(EL.NOTICE_INFO, cname);
            },
            getErrorStatus: function() {
                return error.status;
            },
            checkValidation: checkValidation,
            getStatusByCode: getStatusByCode
        };
    })();

    exports.addModule('view.error', new Error());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var state = exports.loadModule('controller.state');
    var pctTracker = exports.loadModule('pct.tracker');

    var Action;
    Action = (function() {
        var $$ = dt.$$;
        var event = dt.event;
        var helpers = exports.helpers;
        var playerTemplate = exports.template;
        var actionData = null;

        var EL = {
            ACTION_CONTAINER: $$('.bizmeta_control')[0]
        };

        var action = {
            button: {
                template: playerTemplate.action_button,
                trackingUrl: '',
                set: function(action) {
                    if (EL.ACTION_CONTAINER) {
                        EL.ACTION_CONTAINER.innerHTML = this.template.render({
                            actionUrl: action.actionButton.landingUri,
                            actionText: action.actionButton.buttonText
                        });
                        this.trackingUrl = action.actionButton.clickTracking;
                        state.hasAction = true;
                    }
                    actionData = action;
                },
                show: function() {
                    if (EL.ACTION_CONTAINER) {
                        dt.classList.remove(EL.ACTION_CONTAINER, 'hide');
                    }
                },
                hide: function() {
                    if (EL.ACTION_CONTAINER) {
                        dt.classList.add(EL.ACTION_CONTAINER, 'hide');
                    }
                }
            }
        };

        var listener = {
            viewEvent: function() {
                event.delegate(EL.ACTION_CONTAINER, '.link_go', 'click', function() {
                    helpers.http.sendBeacon(action.button.trackingUrl);
                    pctTracker.track('action_button', actionData.actionButton.buttonText);
                });
            }
        };

        function Action() {}

        Action.prototype.init = function() {
            listener.viewEvent();
        };

        Action.prototype.setButton = function(actionData) {
            action.button.set(actionData);
        };

        Action.prototype.showButton = function() {
            action.button.show();
        };

        Action.prototype.hideButton = function() {
            action.button.hide();
        };

        return Action;
    })();

    exports.addModule('view.action', new Action());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var shaka = exports.loadModule('player.shaka');
    var player = exports.loadModule('player.adapter');
    var queue = exports.loadModule('playlist.queue');
    var state = exports.loadModule('controller.state');
    var a11y = exports.loadModule('etc.a11y');
    var contextMenu = exports.loadModule('view.contextmenu');
    var vastTracker = exports.loadModule('vast.tracker');
    var pctTracker = exports.loadModule('pct.tracker');
    var qoeTracker = exports.loadModule('qoe.tracker');
    var dataLoader = exports.loadModule('playlist.dataloader');
    var analytics = exports.loadModule('view.analytics');
    var error = exports.loadModule('view.error');
    var playerTemplate = exports.template;

    var Inline;

    Inline = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;

        var PHASE = constants.PHASE[env.phase.toUpperCase()];
        var ERROR_STATUS = constants.ERROR.STATUS;
        var CONFIRM_STATUS = constants.CONFIRM.STATUS;
        var QOE_EVENTS = constants.QOE.EVENT;

        var orien = new dt.Orientation();

        var NEXT_VIDEO_SHOW_DURATION = 5;
        var nonLinearAdTimer = null;
        var nonLinearAdDuration = 0;
        var liveStatTimeout = null;

        var fullscreenHelper;

        var MUTE_STATE_KEY = constants.STORAGE.MUTE;
        var CHART_KEY = constants.STORAGE.CHART;

        var FULL_SCREEN_API = {
            REQUEST: 'request',
            CANCEL: 'cancel'
        };

        var CNAME = {
            PLAYER_PLAY: 'player_play',
            PLAYER_PAUSE: 'player_pause',
            PLAYER_REPLAY: 'player_replay',
            BUTTON_SETTING: 'btn_setup',
            BUTTON_PROFILE: 'profile',
            BUTTON_SUBTITLE: 'subtitle'
        };

        var EL = {
            PLAYER: $('player'),
            PLAYER_FRAME: $('playerFrame'),
            PLAYER_CONTAINER: $('playerContainer'),
            VIDEO_CONTAINER: $('videoContainer'),
            PLAYER_CONTROLLER_TOGGLE_BUTTON: $$('#videoContainer button')[0],
            VIDEO_OVERLAY: $('videoOverlay'),
            AD_CONTROLLER: $('adController'),
            AD_COUNT: $('adCount'),
            AD_TIME: $('adTime'),
            AD_TEXT: $('adSkipOffsetText'),
            AD_PLAY_PAUSE_BUTTON_WRAP: $('adPlayPauseBtnWrap'),
            AD_PLAY: $('adPlayBtn'),
            AD_PAUSE: $('adPauseBtn'),
            AD_LINK: $('adLinkBtn'),
            AD_SKIP: $('adSkipBtn'),
            AD_ADVERTISER: $('advertiser'),
            AD_PLAY_PROGRESS: $('adProgress'),
            AD_LINEAR_CONTAINER: $('linear'),
            AD_LINEAR_BANNER: $('linearBanner'),
            AD_LINEAR_BANNER_TEXT: $$('#linearBanner .banner_text')[0],
            AD_NONLINEAR_CONTAINER: $('nonLinear'),
            AD_NONLINEAR_TEXT_BANNER_INFO: $$('#nonLinear .link_adinfo')[0],
            AD_NONLINEAR_TEXT_BANNER_CLOSE: $$('#nonLinear .close_textad')[0],
            AD_NONLINEAR_TEXT_BANNER_BOX: $$('#nonLinear .text_adbox')[0],
            AD_NONLINEAR_TEXT_BANNER: $$('#nonLinear .link_textad')[0],
            AD_NONLINEAR_TEXT_BANNER_TITLE: $$('#nonLinear .link_textad strong')[0],
            AD_NONLINEAR_IMAGE_BANNER_BOX: $$('#nonLinear .section_banner')[0],
            AD_NONLINEAR_IMAGE_BANNER_CLOSE: $$('#nonLinear .close_imagead')[0],
            AD_NONLINEAR_IMAGE_BANNER: $$('#nonLinear .link_imagead')[0],
            AD_NONLINEAR_IMAGE_BANNER_IMG: $$('#nonLinear .thumb_img')[0],
            AD_NONLINEAR_POINT: $('nonLinearPoint'),
            AD_MUTE_BUTTON: $$('#adController .btn_mute')[0],
            AD_UNMUTE_BUTTON: $$('#adController .btn_muteoff')[0],
            AD_MUTE_BUTTON_WRAP: $('adMuteBtnWrap'),
            AD_NOTI: $('adNoti'),
            MUTE_BUTTON: $$('#controller .btn_mute')[0],
            UNMUTE_BUTTON: $$('#controller .btn_muteoff')[0],
            MUTE_BUTTON_WRAP: $('muteBtnWrap'),
            PLAYER_CONTROLLER_CONTAINER: $('controllerContainer'),
            PLAYER_CONTROLLER: $('controller'),
            PLAYER_CONTROLLER_HEAD: $$('#controller .player_head')[0],
            PLAYER_CONTROLLER_BODY: $$('#controller .player_body')[0],
            PLAYER_CONTROLLER_FOOT: $$('#controller .player_foot')[0],
            PLAYER_FUNCTION: $$('.player_function')[0],
            PLAYER_TITLE: $$('#controller .tit_player')[0],
            TITLE_LINK: $$('#controller .link_title')[0],
            REPLAY: $$('#controller .live_re')[0],
            AGE_LIMIT_ICON_HEAD: $('headTough'),
            AGE_LIMIT_ICON_VIEWER: $('viewerTough'),
            LIVE_ICON: $$('#controller .ico_live')[0],
            COVER_LIVE_ICON: $$('#customCover .ico_live')[0],
            COVER_TITLE: $$('#customCover .tit_player')[0],
            COVER_PLAY_BUTTON_WRAP: $('coverPlayBtnWrap'),
            VIEWER_BOX: $$('#controller .box_viewer')[0],
            VIEWER_COUNT: $('viewerCount'),
            PLAYER_BLIND: $('playerBlind'),
            PLAYER_NOTIFICATION: $('notification'),
            PLAY_BUTTON: $$('.' + CNAME.PLAYER_PLAY)[0],
            PAUSE_BUTTON: $$('.' + CNAME.PLAYER_PAUSE)[0],
            REPLAY_BUTTON: $$('.' + CNAME.PLAYER_REPLAY)[0],
            PLAY_PAUSE_BUTTON_WRAP: $('playPauseBtnWrap'),
            SEEKING_BUTTON_WRAP: $('seekingBtnWrap'),
            SOUND_CONTROL: $$('.sound_control')[0],
            VOLUME_PANEL: $$('.vol_panel')[0],
            SETTING_BUTTON: $$('.btn_setup')[0],
            SETUP_BUTTON: $$('.' + CNAME.BUTTON_SETTING)[0],
            TIME_SEEK: $('timeSeek'),
            FULLSCREEN_BUTTON: $('fullscreenBtn'),
            PROGRESSBAR: $('progress'),
            PROGRESSBAR_TOTALBAR: $$('#progress .total_bar')[0],
            PROGRESS_POINT: $('pointProgress'),
            LOAD_PROGRESS: $('loadProgress'),
            PLAY_PROGRESS: $('playProgress'),
            TIME_POINT: $$('.check_time')[0],
            DURATION: $('duration'),
            CURRENT_TIME: $('currentTime'),
            SPINNER_CONTAINER: $('spinnerContainer'),
            ERROR_CONTAINER: $('errorView'),
            ERROR_MESSAGE: $('errorMessage'),
            PROFILE_BUTTON: $$('.profile')[0],
            APPLINK_BUTTON: $$('#controller .btn_liveHD')[0],
            STILL_CONTAINER: $$('.thumb_section')[0],
            STILL_VIDEO: $('stillVideo'),
            STILL_VIDEO_TIME: $$('.txt_time')[0],
            SEEK_BAR: $$('.thumb_bar')[0],
            EXTENSTION_CONTAINER: $$('#controller .extensions')[0],
            DIMMED_LAYER: $$('#controller .dimmed_layer')[0],
            PLAY_TIME_CONTAINER: $$('.play_time')[0],
            CHART_BUTTON: $$('.btn_chart')[0],
            ACTION_CONTAINER: $$('.bizmeta_control')[0],
            NUM_VIEWER: $$('.num_viewer')[0],
            RATING_CONTAINER: $('ratingContainer'),
            TVOD_CONTAINER: $$('.tvod_container')[0],
            TVOD_MESSAGE: $$('.tvod_message')[0],
            TVOD_LINK: $$('.tvod_link')[0]
        };

        var VOLUME_STATE_KEY = constants.STORAGE.VOLUME;
        var VOLUME_DEFUALT = 0.5;

        var profileTemplate = {
            profile_text: playerTemplate.mobile_profile_text,
            supHD: playerTemplate.superscript_hd,
            sup4K: playerTemplate.superscript_4k
        };

        var adTemplate = {
            notiText: playerTemplate.ad_noti_text
        };

        var defaultUI = {
            control: {
                el: EL.VIDEO_CONTAINER,
                show: function() {
                    dt.classList.remove(this.el, 'hide_default_control');
                    dt.classList.add(EL.PLAYER_CONTROLLER_CONTAINER, 'hide');
                },
                hide: function() {
                    dt.classList.add(this.el, 'hide_default_control');
                    dt.classList.remove(EL.PLAYER_CONTROLLER_CONTAINER, 'hide');
                }
            },
            video: {
                hideCursor: function() {
                    dt.classList.add(player.videoElement, 'hide_cursor');
                },
                showCursor: function() {
                    dt.classList.remove(player.videoElement, 'hide_cursor');
                }
            }
        };

        var customUI = {
            setSize: function() {
                var body = document.documentElement || document.body;
                EL.PLAYER_CONTAINER.style.width = body.clientWidth + 'px';
                EL.PLAYER_CONTAINER.style.height = body.clientHeight + 'px';
            },
            reSize: function() {
                var videoHeight = player.videoElement.videoHeight;
                var videoWidth = player.videoElement.videoWidth;
                var videoRatio = videoWidth / videoHeight;
                var body = document.documentElement || document.body;
                var width = body.clientWidth;
                var height = body.clientHeight;
                var ratio = width / height;

                if (ratio < 1.77) {
                    height = (width * 9) / 16;
                } else {
                    width = (height * 16) / 9;
                }

                if (videoRatio <= 1) {
                    EL.PLAYER_CONTAINER.style.width = '100%';
                    EL.PLAYER_CONTAINER.style.height = '100%';
                    EL.PLAYER_CONTAINER.style.top = '';
                    EL.PLAYER_CONTAINER.style.left = '';
                } else {
                    EL.PLAYER_CONTAINER.style.width = width + 'px';
                    EL.PLAYER_CONTAINER.style.height = height + 'px';

                    this.relocate(width, height);
                }

                if (env.isPrivateIp) {
                    analytics.reSize();
                }
            },
            relocate: function(width, height) {
                EL.PLAYER_CONTAINER.style.top = 'calc(50% - ' + height / 2 + 'px)';
                EL.PLAYER_CONTAINER.style.left = 'calc(50% - ' + width / 2 + 'px)';
            },
            blind: {
                el: EL.PLAYER_BLIND,
                show: function() {
                    dt.classList.remove(this.el, 'hide');
                },
                hide: function() {
                    dt.classList.add(this.el, 'hide');
                }
            },
            notification: {
                el: EL.PLAYER_NOTIFICATION,
                timer: null,
                show: function(message, callback) {
                    var self = this;

                    dt.classList.remove(this.el, 'hide');
                    this.el.innerHTML = message;

                    if (this.timer) {
                        clearTimeout(this.timer);
                    }

                    this.timer = setTimeout(function() {
                        self.hide();
                        self.timer = null;

                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    }, 1500);
                },
                hide: function() {
                    this.el.innerHTML = '';
                    dt.classList.add(this.el, 'hide');
                }
            },
            overlay: {
                el: EL.VIDEO_OVERLAY,
                show: function() {
                    dt.classList.remove(this.el, 'hidden');
                    dt.classList.add(this.el, 'visible');
                },
                hide: function() {
                    if (dt.classList.has(this.el, 'visible')) {
                        dt.classList.remove(this.el, 'visible');
                        dt.classList.add(this.el, 'hidden');
                    }
                }
            },
            control: {
                el: EL.PLAYER_CONTROLLER,
                controlTimer: null,
                showStatus: false,
                clearTimer: function() {
                    if (this.controlTimer) {
                        clearTimeout(this.controlTimer);
                    }
                },
                show: function(isfreeze) {
                    var self = this;

                    if (state.isShowError) {
                        return;
                    }

                    if (ua.platform === 'mobile') {
                        exports.queue.emit('hide:rating');
                    }

                    this.showStatus = true;
                    state.customControlActivated = true;

                    if (dt.classList.has(this.el, 'hide')) {
                        dt.classList.remove(this.el, 'hide');
                    }

                    dt.classList.remove(EL.PLAYER, 'hide-custom-control');
                    dt.classList.add(EL.PLAYER, 'show-custom-control');

                    this.clearTimer();

                    if (isfreeze) {
                        return;
                    }

                    this.controlTimer = setTimeout(function() {
                        if (!state.isSettingMenuOpened && !env.keepShowControl) {
                            self.hide();
                            self.hideSeekTime();
                        }
                        self.controlTimer = null;
                    }, 1500);
                },
                hide: function() {
                    this.showStatus = false;
                    state.customControlActivated = false;

                    dt.classList.remove(EL.PLAYER, 'show-custom-control');
                    dt.classList.add(EL.PLAYER, 'hide-custom-control');

                    exports.queue.emit('hide:customUI');

                    if (ua.platform === 'mobile') {
                        exports.queue.emit('hide:rating');
                    }
                },
                toggleUI: function() {
                    if (this.showStatus) {
                        this.hide();
                    } else {
                        this.show(true);
                    }
                },
                showPlayPause: function() {
                    if (EL.PLAY_PAUSE_BUTTON_WRAP) {
                        dt.classList.remove(EL.PLAY_PAUSE_BUTTON_WRAP, 'hide');
                    }
                },
                hidePlayPause: function() {
                    if (EL.PLAY_PAUSE_BUTTON_WRAP) {
                        dt.classList.add(EL.PLAY_PAUSE_BUTTON_WRAP, 'hide');
                    }
                },
                showSeeking: function() {
                    if (EL.SEEKING_BUTTON_WRAP) {
                        dt.classList.remove(EL.SEEKING_BUTTON_WRAP, 'hide');
                    }
                },
                hideSeeking: function() {
                    if (EL.SEEKING_BUTTON_WRAP) {
                        dt.classList.add(EL.SEEKING_BUTTON_WRAP, 'hide');
                    }
                },
                hideAdPlayPause: function() {
                    if (EL.AD_PLAY_PAUSE_BUTTON_WRAP) {
                        dt.classList.add(EL.AD_PLAY_PAUSE_BUTTON_WRAP, 'hide');
                    }
                },
                hideCoverPlay: function() {
                    if (EL.COVER_PLAY_BUTTON_WRAP) {
                        dt.classList.add(EL.COVER_PLAY_BUTTON_WRAP, 'hide');
                    }
                },
                showSeekTime: function() {
                    if (EL.TIME_SEEK) {
                        dt.classList.remove(EL.TIME_SEEK, 'hide');
                    }
                },
                hideSeekTime: function() {
                    if (EL.TIME_SEEK) {
                        dt.classList.add(EL.TIME_SEEK, 'hide');
                    }
                },
                setDuration: function(duration) {
                    if (EL.DURATION) {
                        EL.DURATION.innerHTML = helpers.string.delimitTimes(duration);
                    }
                },
                setTitle: function(data) {
                    if (data.title) {
                        EL.TITLE_LINK.innerHTML = helpers.string.escapeHtml(data.title);
                    }
                },
                showTitle: function() {
                    if (EL.PLAYER_TITLE) {
                        dt.classList.remove(EL.PLAYER_TITLE, 'hide');
                    }
                },
                hideTitle: function() {
                    if (EL.PLAYER_TITLE) {
                        dt.classList.add(EL.PLAYER_TITLE, 'hide');
                    }
                },
                showReplay: function() {
                    if (EL.REPLAY) {
                        dt.classList.remove(EL.REPLAY, 'hide');
                    }
                },
                setViewerCount: function(count) {
                    if (!EL.VIEWER_COUNT) {
                        return;
                    }

                    if (!count) {
                        this.hideViewerBox();
                        return;
                    }

                    if (!isNaN(count)) {
                        count = helpers.string.delimitNumbers(count);
                    }

                    this.showViewerBox();
                    EL.VIEWER_COUNT.innerHTML = count;
                },
                setAgeLimit: function(age) {
                    var isShownTitle = env.popup || (!env.isInternal && env.showInfo);
                    if (age === 'AGE_19') {
                        dt.classList.remove(isShownTitle ? EL.AGE_LIMIT_ICON_HEAD : EL.AGE_LIMIT_ICON_VIEWER, 'hide');
                    }
                },
                setCurrentTime: function(currentTime, duration) {
                    var rate = Math.floor((currentTime / duration) * 100);

                    if (rate > 100 || rate < 0 || isNaN(currentTime)) {
                        return;
                    }

                    if (EL.CURRENT_TIME) {
                        EL.CURRENT_TIME.innerHTML = helpers.string.delimitTimes(currentTime);
                    }

                    if (EL.TIME_SEEK) {
                        EL.TIME_SEEK.innerHTML = helpers.string.delimitTimes(currentTime);
                    }
                },
                hideAppLinkButton: function() {
                    if (EL.APPLINK_BUTTON) {
                        dt.classList.add(EL.APPLINK_BUTTON, 'hide');
                    }
                },
                hideProfile: function() {
                    if (EL.PROFILE_BUTTON && EL.PROFILE_BUTTON.parentElement) {
                        dt.classList.add(EL.PROFILE_BUTTON.parentElement, 'hide');
                    }
                },
                showProfile: function() {
                    if (EL.PROFILE_BUTTON && EL.PROFILE_BUTTON.parentElement) {
                        dt.classList.remove(EL.PROFILE_BUTTON.parentElement, 'hide');
                    }
                },
                toggleMute: function(muteOn) {
                    var muteButton = EL.MUTE_BUTTON;
                    var unMuteButton = EL.UNMUTE_BUTTON;

                    if (muteOn) {
                        dt.classList.remove(muteButton, 'hide');
                        dt.classList.add(unMuteButton, 'hide');
                    } else {
                        dt.classList.add(muteButton, 'hide');
                        dt.classList.remove(unMuteButton, 'hide');
                    }
                },
                toggleAdMute: function(muteOn) {
                    var muteButton = EL.AD_MUTE_BUTTON;
                    var unMuteButton = EL.AD_UNMUTE_BUTTON;

                    if (muteOn) {
                        dt.classList.remove(muteButton, 'hide');
                        dt.classList.add(unMuteButton, 'hide');
                    } else {
                        dt.classList.add(muteButton, 'hide');
                        dt.classList.remove(unMuteButton, 'hide');
                    }
                },
                showExtension: function() {
                    if (EL.EXTENSTION_CONTAINER) {
                        dt.classList.remove(EL.EXTENSTION_CONTAINER, 'hide');
                    }
                },
                hideExtension: function() {
                    if (EL.EXTENSTION_CONTAINER) {
                        dt.classList.add(EL.EXTENSTION_CONTAINER, 'hide');
                    }
                },
                showDimmedLayer: function() {
                    if (EL.DIMMED_LAYER) {
                        dt.classList.remove(EL.DIMMED_LAYER, 'hide');
                    }
                },
                hideDimmedLayer: function() {
                    if (EL.DIMMED_LAYER) {
                        dt.classList.add(EL.DIMMED_LAYER, 'hide');
                    }
                },
                hideMute: function() {
                    if (EL.MUTE_BUTTON_WRAP) {
                        dt.classList.add(EL.MUTE_BUTTON_WRAP, 'hide');
                    }
                },
                hideAdMute: function() {
                    if (EL.AD_MUTE_BUTTON_WRAP) {
                        dt.classList.add(EL.AD_MUTE_BUTTON_WRAP, 'hide');
                    }
                },
                hideLiveIcon: function() {
                    if (EL.LIVE_ICON) {
                        dt.classList.add(EL.LIVE_ICON, 'hide');
                    }
                },
                hideCoverLiveIcon: function() {
                    if (EL.COVER_LIVE_ICON) {
                        dt.classList.add(EL.COVER_LIVE_ICON, 'hide');
                    }
                },
                hideCoverTitle: function() {
                    if (EL.COVER_TITLE) {
                        dt.classList.add(EL.COVER_TITLE, 'hide');
                    }
                },
                showViewerBox: function() {
                    if (EL.VIEWER_BOX) {
                        dt.classList.remove(EL.VIEWER_BOX, 'hide');
                    }

                    if (EL.NUM_VIEWER) {
                        dt.classList.remove(EL.NUM_VIEWER, 'info_none');
                    }
                },
                hideViewerBox: function() {
                    if (EL.VIEWER_BOX) {
                        dt.classList.add(EL.VIEWER_BOX, 'hide');
                    }

                    if (EL.NUM_VIEWER) {
                        dt.classList.add(EL.NUM_VIEWER, 'info_none');
                    }
                },
                hideViewerBackground: function() {
                    if (EL.VIEWER_BOX) {
                        dt.classList.add(EL.VIEWER_BOX, 'hide_liveicon');
                    }
                },
                showChartButton: function() {
                    if (EL.CHART_BUTTON) {
                        dt.classList.remove(EL.CHART_BUTTON, 'hide');
                    }
                },
                hideChartButton: function() {
                    if (EL.CHART_BUTTON) {
                        dt.classList.add(EL.CHART_BUTTON, 'hide');
                    }
                }
            },
            fullscreen: {
                el: EL.FULLSCREEN_BUTTON,
                show: function() {
                    dt.classList.remove(EL.FULLSCREEN_BUTTON, 'hide');
                },
                hide: function() {
                    dt.classList.add(EL.FULLSCREEN_BUTTON, 'hide');
                },
                toggle: function(isFullScreen) {
                    var nextElement = this.el.nextElementSibling;

                    if (isFullScreen) {
                        dt.classList.add(EL.PLAYER, 'fullscreen');
                        this.el.setAttribute('aria-label', '기본화면');

                        if (nextElement && nextElement.className === 'box_tooltip') {
                            nextElement.innerHTML = '기본화면';
                        }
                    } else {
                        dt.classList.remove(EL.PLAYER, 'fullscreen');
                        this.el.setAttribute('aria-label', '전체화면');

                        if (nextElement && nextElement.className === 'box_tooltip') {
                            nextElement.innerHTML = '전체화면';
                        }
                    }
                }
            },
            progress: {
                el: EL.PROGRESSBAR,
                show: function() {
                    if (EL.PROGRESSBAR) {
                        dt.classList.remove(EL.PROGRESSBAR, 'hide');
                    }
                },
                hide: function() {
                    if (EL.PROGRESSBAR) {
                        dt.classList.add(EL.PROGRESSBAR, 'hide');
                    }
                },
                on: function() {
                    if (EL.PROGRESSBAR) {
                        dt.classList.add(EL.PROGRESSBAR, 'on');
                    }
                },
                off: function() {
                    if (EL.PROGRESSBAR) {
                        dt.classList.remove(EL.PROGRESSBAR, 'on');
                    }
                },
                updateLoad: function(loadEndPercentage) {
                    var transform = helpers.polyfill.getProps('transform');
                    var sx = 0;
                    if (EL.LOAD_PROGRESS && loadEndPercentage > 0) {
                        sx = loadEndPercentage.toFixed(3);
                        EL.LOAD_PROGRESS.style[transform] = 'scaleX(' + sx + ')';
                    }
                },
                updatePlay: function(percentage) {
                    if (percentage > 100) {
                        return;
                    }

                    if (EL.PLAY_PROGRESS) {
                        EL.PLAY_PROGRESS.style.width = percentage + '%';
                    }
                }
            },
            ad: {
                el: EL.AD_CONTROLLER,
                timer: null,
                show: function() {
                    dt.classList.remove(this.el, 'hide');
                },
                hide: function() {
                    dt.classList.add(this.el, 'hide');
                },
                setup: function() {
                    var video = queue.front;
                    var staticResource = null;
                    var adnotiText = '';
                    var sourceText = '';
                    var optouthide = true;
                    var optoutImageUrl = '';
                    var optoutClickUrl = '';

                    if (EL.AD_LINK) {
                        if (video.clickThrough && video.clickThrough['@_uri']) {
                            EL.AD_LINK.href = video.clickThrough['@_uri'];
                        } else {
                            this.hideLink();
                        }
                    }

                    if (video.timeOffset === 'end') {
                        if (video.extension && video.extension.length > 0) {
                            var textAd = video.extension[0].customObject && video.extension[0].customObject.TextAd;
                            if (textAd) {
                                this.setLinearBanner(textAd.Click, textAd.Title);
                            }
                        }
                    }

                    if (video.icon) {
                        video.icon.forEach(function(v) {
                            staticResource = v.staticResource;

                            if (v['program'] === 'source') {
                                if (staticResource) {
                                    sourceText = staticResource[0]['@_uri'] || '';
                                    adnotiText = helpers.string.replaceLinefeed(sourceText);
                                }
                            } else if (v['program'] === 'optout') {
                                var clickUrl = v.iconClicks && v.iconClicks.iconClickThrough;
                                if (staticResource && clickUrl) {
                                    optoutImageUrl = staticResource[0]['@_uri'] || '';
                                    optoutClickUrl = clickUrl['@_uri'] || '';
                                    optouthide = false;
                                }
                            }
                        });
                    }

                    if (EL.AD_NOTI) {
                        EL.AD_NOTI.innerHTML = adnotiText
                            ? adTemplate.notiText.render({
                                  txt_single: adnotiText.indexOf('<br>') === -1,
                                  notiText: adnotiText,
                                  optouthide: optouthide,
                                  optoutImage: optoutImageUrl,
                                  optoutClickUrl: optoutClickUrl
                              })
                            : '';
                    }
                },
                setupMidTextAd: function(click, title) {
                    this.hideCount();
                    this.hideLink();
                    this.hideSkip();
                    this.setNonLinearTextBanner(click, title);
                    this.hideNonLinearContainer();
                },
                setupMidImageAd: function(click, banner) {
                    this.setNonLinearImageBanner(click, banner);
                },
                end: function() {
                    this.hideCount();
                    this.hideSkip();
                    this.hideLinearBanner();
                },
                reset: function() {
                    var video = queue.front;
                    var duration = player.getDurationRound();
                    var skipOffset = video.skipOffset && video.skipOffset < duration ? video.skipOffset : duration;
                    var skipCheck = skipOffset - duration !== 0;

                    this.updateTime(skipOffset, skipCheck);

                    if (video.timeOffset === 'end') {
                        this.hideCount();
                        this.hideLink();
                        this.hideSkip();

                        var creativeExtension = video.extension;
                        if (creativeExtension && creativeExtension.length > 0) {
                            if (creativeExtension[0].customObject && creativeExtension[0].customObject.TextAd) {
                                this.showLinearBanner();
                            }
                        }
                    } else {
                        this.showCount();
                        this.showLink();
                        this.hideSkip();
                        this.hideLinearBanner();
                    }
                },
                showSkip: function() {
                    if (EL.AD_SKIP) {
                        dt.classList.remove(EL.AD_SKIP, 'hide');
                    }
                },
                hideSkip: function() {
                    if (EL.AD_SKIP) {
                        dt.classList.add(EL.AD_SKIP, 'hide');
                    }
                },
                showLink: function() {
                    if (EL.AD_LINK) {
                        dt.classList.remove(EL.AD_LINK, 'hide');
                    }
                },
                hideLink: function() {
                    if (EL.AD_LINK) {
                        dt.classList.add(EL.AD_LINK, 'hide');
                    }
                },
                showCount: function() {
                    if (EL.AD_COUNT) {
                        dt.classList.remove(EL.AD_COUNT, 'hide');
                    }
                },
                hideCount: function() {
                    if (EL.AD_COUNT) {
                        dt.classList.add(EL.AD_COUNT, 'hide');
                    }
                },
                setLinearBanner: function(url, title) {
                    if (EL.AD_LINEAR_BANNER && url) {
                        EL.AD_LINEAR_BANNER.href = url;
                    }

                    if (EL.AD_LINEAR_BANNER_TEXT && title && title !== '') {
                        EL.AD_LINEAR_BANNER_TEXT.innerHTML = title;
                    }
                },
                showLinearBanner: function() {
                    if (EL.AD_LINEAR_BANNER) {
                        dt.classList.remove(EL.AD_LINEAR_BANNER, 'hide');
                    }
                },
                hideLinearBanner: function() {
                    if (EL.AD_LINEAR_BANNER) {
                        dt.classList.add(EL.AD_LINEAR_BANNER, 'hide');
                    }
                },
                showLinearContainer: function() {
                    if (EL.AD_LINEAR_CONTAINER) {
                        dt.classList.remove(EL.AD_LINEAR_CONTAINER, 'hide');
                    }
                },
                hideLinearContainer: function() {
                    if (EL.AD_LINEAR_CONTAINER) {
                        dt.classList.add(EL.AD_LINEAR_CONTAINER, 'hide');
                    }
                },
                showNonLinearContainer: function() {
                    if (EL.AD_NONLINEAR_CONTAINER) {
                        dt.classList.remove(EL.AD_NONLINEAR_CONTAINER, 'hide');
                    }
                },
                hideNonLinearContainer: function() {
                    if (EL.AD_NONLINEAR_CONTAINER) {
                        dt.classList.add(EL.AD_NONLINEAR_CONTAINER, 'hide');
                    }
                },
                setNonLinearContainerStyle: function(adType) {
                    if (EL.AD_NONLINEAR_CONTAINER) {
                        EL.AD_NONLINEAR_CONTAINER.className = adType;
                    }
                },
                setNonLinearTextBanner: function(url, title) {
                    this.setNonLinearContainerStyle('text');

                    if (EL.AD_NONLINEAR_TEXT_BANNER && EL.AD_NONLINEAR_TEXT_BANNER !== '') {
                        EL.AD_NONLINEAR_TEXT_BANNER.href = url;
                    }

                    if (EL.AD_NONLINEAR_TEXT_BANNER_TITLE) {
                        EL.AD_NONLINEAR_TEXT_BANNER_TITLE.innerHTML = title;
                    }
                },
                setNonLinearImageBanner: function(url, imgSrc) {
                    this.setNonLinearContainerStyle('image');

                    if (EL.AD_NONLINEAR_IMAGE_BANNER && EL.AD_NONLINEAR_IMAGE_BANNER !== '') {
                        EL.AD_NONLINEAR_IMAGE_BANNER.href = url;
                    }

                    if (EL.AD_NONLINEAR_IMAGE_BANNER_IMG) {
                        EL.AD_NONLINEAR_IMAGE_BANNER_IMG.src = imgSrc;
                    }
                },
                setNonLinearProgressPoint: function(duration, displayPer) {
                    if (env.debugMode) {
                        var midAdDuration = duration > -1 ? duration : 5;
                        var pointWidth = (midAdDuration * 100) / player.getDurationRound();

                        if (EL.AD_NONLINEAR_POINT) {
                            EL.AD_NONLINEAR_POINT.style.width = pointWidth.toFixed(2) + '%';
                            if (!isNaN(displayPer) && displayPer > 0) {
                                EL.AD_NONLINEAR_POINT.style.left = displayPer + '%';
                            }
                        }
                    }
                },
                setMidrollPoint: function(index, isStarted, timeOffset) {
                    var pointLeft = (timeOffset * 100) / player.getDurationRound();
                    var midrollPointNode = document.getElementById('midrollPoint' + index);

                    if (EL.PROGRESSBAR_TOTALBAR) {
                        if (!isStarted) {
                            if (!midrollPointNode) {
                                midrollPointNode = document.createElement('div');
                                midrollPointNode.id = 'midrollPoint' + index;
                                dt.classList.add(midrollPointNode, 'midroll_point');
                                EL.PROGRESSBAR_TOTALBAR.appendChild(midrollPointNode);
                            }
                            midrollPointNode.style.left = pointLeft + '%';
                            dt.classList.remove(midrollPointNode, 'hide');
                            if (env.debugMode) {
                                dt.classList.remove(midrollPointNode, 'started');
                            }
                        } else if (isStarted) {
                            midrollPointNode = document.getElementById('midrollPoint' + index);

                            if (env.debugMode) {
                                dt.classList.add(midrollPointNode, 'started');
                            } else {
                                dt.classList.add(midrollPointNode, 'hide');
                            }
                        }
                    }
                },
                showNonLinearAdTextBox: function() {
                    if (EL.AD_NONLINEAR_TEXT_BANNER_BOX) {
                        dt.classList.remove(EL.AD_NONLINEAR_TEXT_BANNER_BOX, 'hide');
                    }
                },
                hideNonLinearAdText: function() {
                    if (EL.AD_NONLINEAR_TEXT_BANNER_BOX) {
                        dt.classList.add(EL.AD_NONLINEAR_TEXT_BANNER_BOX, 'hide');
                    }
                },
                showNonLinearAdTextInfo: function() {
                    if (EL.AD_NONLINEAR_TEXT_BANNER_INFO) {
                        dt.classList.remove(EL.AD_NONLINEAR_TEXT_BANNER_INFO, 'hide');
                    }
                },
                hideNonLinearAdTextInfo: function() {
                    if (EL.AD_NONLINEAR_TEXT_BANNER_INFO) {
                        dt.classList.add(EL.AD_NONLINEAR_TEXT_BANNER_INFO, 'hide');
                    }
                },
                showNonLinearAdImageBox: function() {
                    if (EL.AD_NONLINEAR_IMAGE_BANNER_BOX) {
                        dt.classList.remove(EL.AD_NONLINEAR_IMAGE_BANNER_BOX, 'hide');
                    }
                },
                hideNonLinearAdImage: function() {
                    if (EL.AD_NONLINEAR_IMAGE_BANNER_BOX) {
                        dt.classList.add(EL.AD_NONLINEAR_IMAGE_BANNER_BOX, 'hide');
                    }
                },
                showButton: function() {
                    if (EL.AD_PLAY_PAUSE_BUTTON_WRAP) {
                        dt.classList.remove(EL.AD_PLAY_PAUSE_BUTTON_WRAP, 'hidden');
                        dt.classList.add(EL.AD_PLAY_PAUSE_BUTTON_WRAP, 'visible');
                    }

                    if (this.timer) {
                        clearTimeout(this.timer);
                    }

                    if (ua.platform !== 'pc' && isFullScreen()) {
                        customUI.control.show(false);
                    }

                    if (player.isPaused() && !state.ended) {
                        return;
                    }

                    var self = this;
                    this.timer = setTimeout(function() {
                        self.hideButton();
                        self.timer = null;
                    }, 1500);
                },
                hideButton: function() {
                    if (EL.AD_PLAY_PAUSE_BUTTON_WRAP) {
                        dt.classList.add(EL.AD_PLAY_PAUSE_BUTTON_WRAP, 'hidden');
                        dt.classList.remove(EL.AD_PLAY_PAUSE_BUTTON_WRAP, 'visible');
                    }

                    if (ua.platform !== 'pc' && isFullScreen()) {
                        customUI.control.hide();
                    }
                },
                updateTime: function(time, skip) {
                    if (EL.AD_TIME) {
                        EL.AD_TIME.innerHTML = time;
                        EL.AD_TEXT.innerHTML = skip ? ' 초 후 SKIP' : ' 초 후 재생';
                    }
                },
                updatePlay: function(percentage) {
                    if (percentage > 100) {
                        return;
                    }

                    if (EL.AD_PLAY_PROGRESS) {
                        EL.AD_PLAY_PROGRESS.style.width = percentage + '%';
                    }
                }
            },
            stillVideo: {
                videoElement: null,
                isFirstPlay: true,
                set: function(url) {
                    if (!this.videoElement) {
                        this.create();
                    }
                    this.videoElement.src = url;
                    this.load();
                    state.hasStillVideo = true;
                },
                create: function() {
                    var self = this;

                    this.videoElement = document.createElement('video');
                    this.videoElement.setAttribute('id', 'stillVideo');
                    this.videoElement.setAttribute('playsinline', '');
                    this.videoElement.setAttribute('muted', '');

                    event.on(this.videoElement, 'canplay', function() {
                        if (self.isFirstPlay) {
                            self.setSize();
                        }
                    });

                    event.on(this.videoElement, 'play', function() {
                        self.isFirstPlay = false;
                        this.pause();
                    });

                    event.on(this.videoElement, 'error', function() {
                        if (this.crossOrigin) {
                            state.hasStillVideo = false;
                            hideStillVideo();
                            if (EL.TIME_POINT) {
                                dt.classList.add(EL.TIME_POINT, 'hide');
                            }

                            customUI.control.setCurrentTime(player.getCurrentTimeRound(), player.getDurationRound());
                            player.seekTo(player.getCurrentTimeRound());
                        } else {
                            this.setAttribute('crossorigin', 'use-credentials');
                            this.load();
                        }
                    });

                    EL.STILL_CONTAINER.appendChild(this.videoElement);
                },
                load: function() {
                    this.videoElement.load();
                },
                show: function() {
                    var video = this.videoElement;
                    var self = this;

                    if (self.isFirstPlay) {
                        video.play();
                    }
                    dt.classList.remove(EL.STILL_CONTAINER, 'hide');
                },
                hide: function() {
                    if (state.hasStillVideo && !this.videoElement.paused) {
                        this.videoElement.pause();
                    }
                    dt.classList.add(EL.STILL_CONTAINER, 'hide');
                },
                seekTo: function(time) {
                    if (!isNaN(time)) {
                        if (this.videoElement.readyState > 3) {
                            this.videoElement.currentTime = Math.round(time);
                        }
                    }
                },
                move: function(pageX) {
                    var rect = EL.PROGRESSBAR.getBoundingClientRect();
                    if (isFullScreen()) {
                        rect = checkRectSize(rect);
                    }
                    var offsetLeft = Math.floor(rect.left);
                    var offsetX = pageX && pageX - offsetLeft;
                    var videoWidthHalf = this.videoElement.clientWidth / 2;
                    var leftLimit = videoWidthHalf;
                    var rightLimit = rect.width - videoWidthHalf;

                    if (videoWidthHalf === 0) {
                        return;
                    }

                    if (offsetX < leftLimit) {
                        offsetX = leftLimit;
                    } else if (offsetX > rightLimit) {
                        offsetX = rightLimit;
                    }

                    this.setPosition(offsetX);
                },
                setSize: function() {
                    var video = {
                        width: this.videoElement.videoWidth,
                        height: this.videoElement.videoHeight
                    };

                    var viewport = {
                        width: document.documentElement.clientWidth,
                        height: document.documentElement.clientHeight
                    };

                    var videoWidthForPC = 156;
                    var videoWidthForMobile = 200;

                    var ratio = 9 / 16;
                    var width = ua.platform === 'pc' ? videoWidthForPC : videoWidthForMobile;

                    if (video.height >= video.width) {
                        if (ua.platform !== 'pc' && !isFullScreen() && viewport.width > viewport.height) {
                            EL.STILL_CONTAINER.style['height'] = null;
                        } else {
                            width = ua.platform === 'pc' ? videoWidthForPC * ratio : videoWidthForMobile * ratio;
                            EL.STILL_CONTAINER.style['height'] = 'auto';
                        }
                    } else {
                        if (ua.platform !== 'pc' && !isFullScreen()) {
                            width = videoWidthForMobile;
                        }
                        EL.STILL_CONTAINER.style['height'] = null;
                    }

                    EL.STILL_CONTAINER.style.width = width + 'px';
                    EL.STILL_CONTAINER.style.marginLeft = -(width / 2) + 'px';
                },
                setPosition: function(offsetX) {
                    EL.STILL_CONTAINER.style['left'] = ua.platform === 'pc' ? offsetX + 'px' : offsetX + 50 + 'px';
                    EL.TIME_POINT.style['left'] = ua.platform === 'pc' ? offsetX + 'px' : offsetX + 50 + 'px';

                    if (EL.STILL_VIDEO_TIME) {
                        EL.STILL_VIDEO_TIME.style['left'] = isFullScreen() ? offsetX + 50 + 'px' : '50%';
                    }
                },
                resetPosition: function() {
                    if (EL.STILL_CONTAINER) {
                        EL.STILL_CONTAINER.style['left'] = null;
                    }
                    if (EL.STILL_VIDEO_TIME) {
                        EL.STILL_VIDEO_TIME.style['left'] = null;
                    }
                }
            },
            tvod: {
                el: {
                    container: EL.TVOD_CONTAINER,
                    message: EL.TVOD_MESSAGE,
                    link: EL.TVOD_LINK
                },
                show: function() {
                    dt.classList.remove(this.el.container, 'hide');
                },
                hide: function() {
                    dt.classList.add(this.el.container, 'hide');
                },
                setMessage: function(message) {
                    if (this.el.message) {
                        this.el.message.innerHTML = message;
                    }
                },
                setTvodData: function(data) {
                    this.setMessage(data.guideMessage);
                }
            },
            container: {
                el: EL.VIDEO_CONTAINER,
                show: function() {
                    dt.classList.remove(this.el, 'hidden');
                },
                hide: function() {
                    dt.classList.add(this.el, 'hidden');
                }
            },
            rating: {
                el: EL.RATING_CONTAINER,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                }
            }
        };

        function checkRectSize(rect) {
            if (rect.height < 1) {
                var resizeRect = {};
                for (var o in rect) {
                    if (rect.hasOwnProperty(o)) {
                        resizeRect[o] = rect[o] * 100;
                    }
                }
                return resizeRect;
            }
            return rect;
        }

        function sendReport() {
            var video = state.currentVideo;
            var type, id;

            if (video.type === 'VOD') {
                id = video.id;
                type = constants.VIDEO_TYPE.VOD;
            } else if (video.type === 'LIVE') {
                id = video.id;
                type = constants.VIDEO_TYPE.LIVE;
            }

            var width = 440;
            var height = 620;

            openReportWindow(type, id, width, height);
        }

        function openReportWindow(type, id, width, height) {
            var currentUrl = window.location.href;
            var reportUrl = helpers.serverHost.create(env.klimtServer, PHASE);
            var param;

            if (currentUrl.indexOf('kakao.com') > -1) {
                if (type === constants.VIDEO_TYPE.VOD) {
                    param = 'type=clipLink&id=' + id;
                } else {
                    param = 'type=liveLink&id=' + id;
                }

                reportUrl += '/report?' + param;
            } else {
                if (type === constants.VIDEO_TYPE.VOD) {
                    param = 'contentType=' + type + '&articleId=' + id;
                } else {
                    param = 'contentType=' + type + '&articleId=' + id;
                }

                if (PHASE === constants.PHASE.PROD) {
                    reportUrl =
                        'http://' +
                        (ua.platform !== 'pc' ? 'm.' : '') +
                        'spam119.daum.net/form?platformCode=KAKAOTV&serviceCode=70&' +
                        param;
                } else {
                    reportUrl =
                        'http://' +
                        (ua.platform !== 'pc' ? 'm.' : '') +
                        'spam119.dev.daum.net/form?platformCode=KAKAOTV&serviceCode=70&' +
                        param;
                }
            }

            var features =
                'fullscreen=no, width=' +
                width +
                ', height=' +
                height +
                ', menubar=no, scrollbars=no, status=no, titlebar=no, resizable=yes';

            openPopup(reportUrl, 'reportWindow', features);
        }

        function openPopup(url, name, features) {
            if (isFullScreen()) {
                if (ua.platform === 'pc') {
                    cancelFullscreen();
                }
            }
            helpers.window.openPopup(url, name, features);
        }

        function toggleCustomUI() {
            if (state.customControlActivated) {
                activateCustomUI(false);
            } else {
                activateCustomUI(true);
            }
        }

        function hideControl() {
            customUI.control.hide();
        }

        function showControlHead() {
            dt.classList.remove(EL.PLAYER_CONTROLLER_HEAD, 'hide');
        }

        function hideControlHead() {
            dt.classList.add(EL.PLAYER_CONTROLLER_HEAD, 'hide');
        }

        function showControlFoot() {
            if (env.controls) {
                dt.classList.remove(EL.PLAYER_CONTROLLER_FOOT, 'hide');
            }
        }

        function hideControlFoot() {
            dt.classList.add(EL.PLAYER_CONTROLLER_FOOT, 'hide');
        }

        function activateAdPlayPause(isPaused) {
            if (!EL.AD_PLAY_PAUSE_BUTTON_WRAP) {
                return;
            }

            if (dt.classList.has(EL.AD_PLAY_PAUSE_BUTTON_WRAP, 'hidden')) {
                customUI.ad.showButton();
            } else {
                customUI.ad.hideButton();
            }

            toggleAdPlayPause(isPaused);
        }

        function toggleAdPlayPause(isPaused) {
            var playButton = EL.AD_PLAY;
            var pauseButton = EL.AD_PAUSE;

            if (isPaused) {
                dt.classList.remove(playButton, 'hidden');
                dt.classList.add(pauseButton, 'hidden');
            } else {
                dt.classList.add(playButton, 'hidden');
                dt.classList.remove(pauseButton, 'hidden');
            }
        }

        function activateCustomUI(activated, isfreeze) {
            var video = queue.front;

            if (activated) {
                if (video && video.type === constants.VIDEO_TYPE.AD) {
                    if (ua.platform !== 'pc' && !isFullScreen()) {
                        customUI.control.hide();
                    } else {
                        if (video.timeOffset !== 'end') {
                            customUI.control.show(isfreeze);
                            return;
                        }
                    }
                    customUI.ad.show();
                } else {
                    customUI.control.show(isfreeze);
                }
            } else {
                if (ua.platform === 'mobile' && player.isPaused() && !state.isShowError && !state.ended) {
                    return;
                }
                customUI.control.hide();
                customUI.control.hideSeekTime();
            }
        }

        function updateProgress(currentTime, duration) {
            var percentage = (100 * currentTime) / duration;
            var video = queue.front;

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                customUI.ad.updatePlay(percentage);
                customUI.progress.updatePlay(percentage);
            } else if (video && video.type === constants.VIDEO_TYPE.VOD) {
                customUI.progress.updatePlay(percentage);
            }
        }

        function updateTime(currentTime, duration) {
            if (duration > 0) {
                customUI.control.setCurrentTime(currentTime, duration);
                updateProgress(currentTime, duration);
            }
        }

        function updateLoad(loadEndPercentage) {
            customUI.progress.updateLoad(loadEndPercentage);
        }

        function updateAdSkipTime() {
            var skipOffset, remainTime, skipCheck;

            if (!state.adControlActivated) {
                return;
            }

            var currentTime = player.getCurrentTimeRound();
            var duration = player.getDurationRound();

            var video = queue.front;

            if (duration > 0) {
                if (state.skipAdEnabled) {
                    return;
                }

                skipOffset = video.skipOffset && video.skipOffset < duration ? video.skipOffset : duration;
                remainTime = skipOffset - currentTime;
                skipCheck = skipOffset - duration !== 0;

                if (remainTime < 1 && skipCheck) {
                    state.skipAdEnabled = true;
                    customUI.ad.hideCount();
                    customUI.ad.showSkip();
                } else if (remainTime > 0) {
                    customUI.ad.updateTime(remainTime, skipCheck);
                }
            }
        }

        function checkNextVideo(currentTime, duration) {
            var remainTime = Math.round(duration - currentTime);

            if (remainTime <= NEXT_VIDEO_SHOW_DURATION) {
                if (state.autoplay || state.continuousPlay) {
                    if (!state.isCheckNextVideo) {
                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onCheckNextVideo, [
                            state.currentVideo.id
                        ]);
                        state.isCheckNextVideo = true;
                    }
                }
            }
        }

        function showBlind() {
            customUI.control.hide();
            customUI.blind.show();
        }

        function hideBlind() {
            customUI.blind.hide();
        }

        function showNotification(message, callback) {
            showBlind();
            customUI.notification.show(message, callback);
        }

        function startSpinner() {
            customUI.overlay.show();
        }

        function endSpinner() {
            setTimeout(function() {
                customUI.overlay.hide();
            }, 250);
        }

        function showDefaultControl() {
            player.videoElement.setAttribute('controls', 'true');
            defaultUI.control.show();
        }

        function hideDefaultControl() {
            player.videoElement.removeAttribute('controls');
            defaultUI.control.hide();
        }

        function getProgressRate(e) {
            var rect = EL.PROGRESSBAR.getBoundingClientRect();
            if (isFullScreen()) {
                rect = checkRectSize(rect);
            }

            var pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
            var offsetLeft = Math.floor(rect.left);

            var offsetX = pageX && pageX - offsetLeft;
            var offsetWidth = rect.width;
            var rate = 0;

            if (offsetX > offsetWidth) {
                rate = 100;
            }

            if (offsetX >= 0 && offsetX <= offsetWidth) {
                rate = (offsetX / offsetWidth) * 100;
            }

            return rate;
        }

        function isFullScreen() {
            return fullscreenHelper.isFullScreen();
        }

        function isFullScreenSupport() {
            return fullscreenHelper.isSupport();
        }

        function requestFullscreen() {
            var options = {
                navigationUI: 'hide'
            };

            if (fullscreenHelper.isSupport()) {
                fullscreenHelper.request(options);
            } else if (fullscreenHelper.isSupportOnlyIOS()) {
                fullscreenHelper.setFullscreen(true);
            } else {
                alert('현재 환경에서는 전체화면을 지원하지 않습니다');
            }
            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onFullScreenChange, [
                FULL_SCREEN_API.REQUEST,
                state.currentVideo.id
            ]);
        }

        function cancelFullscreen() {
            var video = queue.front;

            if (fullscreenHelper.isSupport()) {
                fullscreenHelper.exit();
            } else if (fullscreenHelper.isSupportOnlyIOS()) {
                fullscreenHelper.setFullscreen(false);
            }

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onFullScreenChange, [
                FULL_SCREEN_API.CANCEL,
                video && video.id
            ]);
        }

        function lockScreenInLandscape() {
            if (!('orientation' in screen)) {
                return;
            }

            screen.orientation
                .lock('landscape')
                .then(function() {
                    listenToDeviceOrientationChanges();
                })
                .catch(function(error) {
                    debug.tooltip(error.name + ': ' + error.message);
                });
        }

        function listenToDeviceOrientationChanges() {
            if (!('DeviceOrientationEvent' in window)) {
                return;
            }

            var previousDeviceOrientation, currentDeviceOrientation;
            event.on(window, 'deviceorientation', function onDeviceOrientationChange(event) {
                if (Math.abs(event.gamma) > 10 || Math.abs(event.beta) < 10) {
                    previousDeviceOrientation = currentDeviceOrientation;
                    currentDeviceOrientation = 'landscape';
                    return;
                }
                if (Math.abs(event.gamma) < 10 || Math.abs(event.beta) > 10) {
                    previousDeviceOrientation = currentDeviceOrientation;
                    if (previousDeviceOrientation === 'landscape') {
                        if (!isFullScreen()) {
                            screen.orientation.unlock();
                            customUI.stillVideo.resetPosition();
                        }
                        window.removeEventListener('deviceorientation', onDeviceOrientationChange);
                    }
                }
            });
        }

        function applyParameters() {
            if (!env.fs) {
                customUI.fullscreen.hide();
            }

            if (!env.showProfile) {
                customUI.control.hideProfile();
            }

            if (!env.appLink) {
                customUI.control.hideAppLinkButton();
            }

            if (!env.showProgress) {
                customUI.progress.hide();
            }

            if (!env.showMute) {
                customUI.control.hideMute();
                customUI.control.hideAdMute();
            }

            if (!env.showPlayback) {
                customUI.control.hidePlayPause();
                customUI.control.hideSeeking();
                customUI.control.hideAdPlayPause();
                customUI.control.hideCoverPlay();
            }

            if (!env.showLiveIcon) {
                customUI.control.hideLiveIcon();
                customUI.control.hideCoverLiveIcon();
                customUI.control.hideCoverTitle();
                customUI.control.hideViewerBackground();
                customUI.control.hideTitle();
            }

            if (!env.showViewer) {
                customUI.control.hideViewerBox();
                customUI.control.hideTitle();
            }
        }

        function updateStat() {
            if (state.currentVideo.type === 'LIVE') {
                dataLoader.getLiveStat(state.currentVideo.id);
            }
        }

        function statCallback(data) {
            var video = state.currentVideo;
            var nextInterval = data.nextInterval || 60;
            video.title = data.displayTitle || '';
            video.ccuCount = data.ccuCount || '';

            customUI.control.setTitle({
                title: video.title
            });
            customUI.control.setAgeLimit(video.ageLimit);
            customUI.control.setViewerCount(data.ccuCount);

            liveStatTimeout = setTimeout(function() {
                updateStat();
            }, nextInterval * 1000);
        }

        function getClipLocation(profile, callback) {
            var tid = state.currentVideo && state.currentVideo.tid;
            var isHLSContentType =
                state.currentVideo && state.currentVideo.videoUrl && state.currentVideo.videoUrl.indexOf('m3u8') > -1;

            var options = {
                service: env.service,
                section: env.section,
                tid: tid,
                profile: profile,
                dteType: helpers.device.getDteType(ua),
                contentType: isHLSContentType ? constants.CONTENT_TYPE.HLS : constants.CONTENT_TYPE.MP4
            };

            dataLoader.getClipLocation(state.currentVideo, options, callback);
        }

        function getLiveLocation(profile, callback) {
            var tid = state.currentVideo && state.currentVideo.tid;
            var contentType = state.currentVideo && state.currentVideo.contentType;

            var options = {
                service: env.service,
                section: env.section,
                tid: tid,
                profile: profile,
                dteType: helpers.device.getDteType(ua),
                contentType: contentType
            };

            dataLoader.getLiveLocation(state.currentVideo, options, callback);
        }

        function onSeeked() {
            var currentTime = player.getCurrentTimeRound();
            var duration = player.getDurationRound();

            state.preventTogglePlayPause = false;

            if (currentTime >= player.getDurationRound()) {
                state.ended = true;
                return;
            }

            updateTime(currentTime, duration);
            state.ended = false;
            resizeControl();

            if (player.isPaused() && state.isSettingMenuOpened) {
                exports.queue.emit('close:menubox');
            }
        }

        function setupNonLinearAd(ad) {
            var displayPer = ad.DisplayPer > 0 ? ad.DisplayPer : 1;
            nonLinearAdDuration = (ad.Duration || 5) * 1000;

            if (ad.Title) {
                customUI.ad.setupMidTextAd(ad.Click, ad.Title);
            } else if (ad.BannerUrl) {
                customUI.ad.setupMidImageAd(ad.Click, ad.BannerUrl);
            }
            customUI.ad.setNonLinearProgressPoint(ad.Duration, displayPer);
            debug.info('setupNonLinearAd', ad.Duration, displayPer);
        }

        function setupMidrollAd(index, isStarted, timeOffset) {
            customUI.ad.setMidrollPoint(index, isStarted, timeOffset);
        }

        function showLinearAdContainer() {
            customUI.ad.showLinearContainer();
        }

        function hideLinearAdContainer() {
            customUI.ad.hideLinearContainer();
        }

        function showNonLinearAdContainer() {
            var video = queue.front;
            if (video && video.type !== constants.VIDEO_TYPE.AD) {
                hideLinearAdContainer();
                customUI.ad.showNonLinearContainer();
            }
        }

        function hideNonLinearAdContainer() {
            customUI.ad.hideNonLinearContainer();
        }

        function showNonLinearAd(isStarted, adType) {
            showNonLinearAdContainer();
            if (adType === 'text') {
                showMidTextAd(isStarted);
            } else if (adType === 'image') {
                showMidImageAd(isStarted);
            }
        }

        function hideNonLinearAd() {
            closeMidTextAd();
            closeMidImageAd();
        }

        function showMidTextAd(isStarted) {
            customUI.ad.hideNonLinearAdImage();
            customUI.ad.hideNonLinearAdTextInfo();
            customUI.ad.showNonLinearAdTextBox();
            customUI.ad.show();

            if (isStarted) {
                nonLinearAdTimer = new dt.Timer(closeMidTextAd, nonLinearAdDuration);
                nonLinearAdTimer.start();
            }
            vastTracker.midTextAdTracker.load();
        }

        function closeNonLinearAd() {
            if (nonLinearAdTimer) {
                nonLinearAdTimer.clear();
                nonLinearAdTimer = null;
                debug.info('Nonlinear Image Ad - Finish!!', player.getCurrentTimeRound());
            }
            if (state.isNonLinearAdShown) {
                customUI.ad.setNonLinearProgressPoint(0);
            }
        }

        function closeMidTextAd() {
            closeNonLinearAd();
            customUI.ad.showNonLinearAdTextInfo();
            customUI.ad.hideNonLinearAdText();
        }

        function closeMidImageAd() {
            hideNonLinearAdContainer();
            closeNonLinearAd();
            customUI.ad.hideNonLinearAdImage();
        }

        function showMidImageAd(isStarted) {
            customUI.ad.hideNonLinearAdText();
            customUI.ad.showNonLinearAdImageBox();
            customUI.ad.show();

            if (isStarted) {
                nonLinearAdTimer = new dt.Timer(closeMidImageAd, nonLinearAdDuration);
                nonLinearAdTimer.start();
                debug.info('Nonlinear Image Ad - Start!', player.getCurrentTimeRound());
            }
            vastTracker.midImageAdTracker.load();
        }

        function pauseNonLinearAd() {
            if (nonLinearAdTimer) {
                nonLinearAdTimer.pause();
            }
            hideNonLinearAdContainer();
        }

        function resumeNonLinearAd() {
            if (nonLinearAdTimer) {
                nonLinearAdTimer.resume();
            }
            showNonLinearAdContainer();
        }

        function removeText(text) {
            var re = / |P|HD|4K/g;
            return text.replace(re, '');
        }

        function setProfile(profile) {
            var profileTextTemplate = profileTemplate.profile_text;
            var profileList = state.currentVideo.outputList;
            var profileLabel = '';
            var profileText = '';
            var templateData = {
                profileAuto: profile === constants.PROFILE.AUTO,
                profile: '',
                profileHD: false,
                profile4K: false
            };

            if (state.dash) {
                profileLabel = shaka.getCurrentProfile();
                profileText = removeText(shaka.getCurrentProfile());
            } else {
                for (var i in profileList) {
                    if (profileList.hasOwnProperty(i) && profileList[i].profile === profile) {
                        profileLabel = profileList[i].label;
                        profileText = removeText(profileLabel);
                        break;
                    }
                }
            }

            templateData.profile = profileText;
            templateData.profileHD = profileLabel.indexOf('HD') > 0;
            templateData.profile4K = profileLabel.indexOf('4K') > 0;

            dt.classList.remove(EL.SETUP_BUTTON, 'btn_hd');
            dt.classList.remove(EL.SETUP_BUTTON, 'btn_4k');

            if (templateData.profileHD) {
                dt.classList.add(EL.SETUP_BUTTON, 'btn_hd');
            } else if (templateData.profile4K) {
                dt.classList.add(EL.SETUP_BUTTON, 'btn_4k');
            }

            EL.PROFILE_BUTTON.innerHTML = profileTextTemplate.render(templateData);
        }

        function toggleMuteUI(muteOn) {
            if (helpers.device.isSupportMutedControl(ua)) {
                customUI.control.toggleAdMute(muteOn);
                customUI.control.toggleMute(muteOn);
            }
        }

        function initVolumeControl() {
            var muteOn = getRecentMute();
            var volume = muteOn ? 0 : getRecentVolume();
            setVolume(volume, muteOn);
            toggleMuteUI(muteOn);
        }

        function setVolume(volume, muteOn) {
            var vol = isNaN(volume) || volume > 1 || volume < 0 ? VOLUME_DEFUALT : volume;

            if (ua.platform === 'pc') {
                player.setVolume(vol);
            }
            player.setMute(muteOn);
        }

        function getRecentMute() {
            return (
                state.initialState.startMuted ||
                helpers.store.get(MUTE_STATE_KEY) === true ||
                helpers.store.get(MUTE_STATE_KEY) === 'true'
            );
        }

        function getRecentVolume() {
            var storedVolume = helpers.store.get(VOLUME_STATE_KEY);
            if (!storedVolume) {
                storedVolume = VOLUME_DEFUALT;
            }
            return storedVolume;
        }

        function setRecentVolume(volume) {
            if (!isNaN(volume)) {
                helpers.store.set(VOLUME_STATE_KEY, volume.toFixed(2));
            }
        }

        function saveRecentMute(muteOn) {
            helpers.store.set(MUTE_STATE_KEY, muteOn);
        }

        function setStillVideo(seekUrl, callback) {
            if (seekUrl && seekUrl !== '' && helpers.device.isSupportThumbnailVideo(ua)) {
                customUI.stillVideo.set(seekUrl);

                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
        }

        function setStillVideoCurrentTime(currentTime) {
            EL.STILL_VIDEO_TIME.innerHTML = helpers.string.delimitTimes(currentTime);
        }

        function showStillVideo() {
            customUI.stillVideo.show();
            if (EL.TIME_POINT) {
                dt.classList.remove(EL.TIME_POINT, 'hide');
            }
        }

        function hideStillVideo() {
            customUI.stillVideo.hide();
            if (EL.TIME_POINT) {
                dt.classList.add(EL.TIME_POINT, 'hide');
            }
        }

        function setSeekThumbnail() {
            var video = state.currentVideo;
            var seekUrl = video.seekUrl;

            if (seekUrl) {
                setStillVideo(seekUrl);
            }
        }

        function getShowTitle() {
            var video = state.currentVideo;
            var showTitle = true;

            if (!env.isInternal && env.showInfo) {
                if (video.type === 'LIVE' && !(env.showLiveIcon && env.showViewer)) {
                    showTitle = false;
                }
            } else {
                showTitle = false;
            }

            return showTitle;
        }

        function setShowTitle() {
            var showTitle = getShowTitle();
            if (env.popup || showTitle) {
                customUI.control.showTitle();
            }
        }

        function setKakaoTVLink() {
            var video = state.currentVideo;
            var link = '/channel/#{channelId}/cliplink/#{linkId}';

            if (video.type === 'LIVE') {
                link = '/channel/#{channelId}/livelink/#{linkId}';
            }

            link = helpers.string.format(helpers.serverHost.link(PHASE) + link, {
                channelId: video.channelId,
                linkId: video.id
            });

            customUI.control.setTitle({
                title: video.title,
                url: link
            });
        }

        function setRatingLevel() {
            var video = state.currentVideo;
            var ratingValue = video.ratingValue;
            var template = playerTemplate.rating_level;
            var isMobile = ua.platform === 'mobile';
            var ratingList = [];
            var ageLimit = getAgeLimit();
            var ratingKeys = ratingValue && Object.keys(ratingValue);

            if (!video.hasRating) {
                return;
            }

            ratingKeys.forEach(function(k) {
                var rating = ratingValue[k];
                var level = rating.level;

                if (isShowingRating(level.value)) {
                    ratingList.push(ratingValue[k]);
                }
            });

            EL.RATING_CONTAINER.innerHTML = template.render({
                ratingList: ratingList,
                ageLimit: ageLimit,
                isMobile: isMobile
            });
        }

        function getAgeLimit() {
            var video = state.currentVideo;
            var AGE_LIMIT = constants.AGE_LIMIT;
            var videoAgeLimit = video.ageLimit;
            var ageLimitTemplateData = {};

            if (videoAgeLimit && AGE_LIMIT[videoAgeLimit]) {
                ageLimitTemplateData = AGE_LIMIT[videoAgeLimit];
            }

            return ageLimitTemplateData;
        }

        function isShowingRating(level) {
            var RATING_LEVEL = constants.RATING_LEVEL;
            return level > RATING_LEVEL.LOW.value;
        }

        function runClickHandler(target, selector, callback) {
            var closest = target.closest(selector);
            if (closest) {
                callback(closest);
            }
        }

        function resizeControl() {
            if (state.ended) {
                dt.classList.add(EL.PLAYER, 'ended');
            } else {
                dt.classList.remove(EL.PLAYER, 'ended');
                customUI.progress.off();
            }
        }

        var handler = {
            onTouchStartProgress: function(e) {
                var video = queue.front;
                var currentTime = 0;

                if (
                    !state.seekEnabled ||
                    (video && video.type === constants.VIDEO_TYPE.AD) ||
                    (video && video.type === constants.VIDEO_TYPE.LIVE)
                ) {
                    return;
                }

                state.pausedBeforeSeek = state.ended ? false : player.isPaused();
                state.mutedBeforeSeek = player.getMute();
                var orientation = helpers.orientation.getOrientation();
                var pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
                var rate = getProgressRate(e);

                if (rate >= 0 && rate <= 100) {
                    currentTime = (player.getDurationRound() * rate) / 100;
                    if (!state.hasStillVideo) {
                        player.seekTo(currentTime);
                        player.setMute(true);
                        customUI.control.setCurrentTime(currentTime, player.getDurationRound());
                        customUI.control.showSeekTime();
                    } else {
                        if (ua.platform !== 'pc') {
                            showStillVideo();
                            setStillVideoCurrentTime(currentTime);
                            customUI.control.hideTitle();
                            customUI.control.hideExtension();
                            customUI.control.showDimmedLayer();

                            if (isFullScreen() && orientation === 'landscape') {
                                customUI.stillVideo.move(pageX);
                            }
                        }
                    }
                    customUI.progress.updatePlay(rate);
                }

                customUI.progress.on();
                customUI.control.hidePlayPause();
                customUI.control.hideSeeking();
                customUI.control.clearTimer();

                state.seeking = true;

                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onTouchEventStart);
            },
            onTouchEndProgress: function(e) {
                var rate = getProgressRate(e);
                var currentTime = 0;
                var showTitle = getShowTitle();
                var video = queue.front;

                if (
                    video === null ||
                    video.type === constants.VIDEO_TYPE.AD ||
                    video.type === constants.VIDEO_TYPE.LIVE
                ) {
                    return;
                }

                if (dt.StopWatch.has('rebuffering')) {
                    dt.StopWatch.stop('rebuffering');
                }
                dt.StopWatch.start('seek');

                if (state.seekEnabled) {
                    customUI.control.hideSeekTime();
                    customUI.control.showSeeking();
                    customUI.control.showPlayPause();
                    customUI.progress.off();

                    state.seeking = false;
                    player.setMute(state.mutedBeforeSeek);

                    if (ua.platform !== 'pc') {
                        var isFreeze = state.pausedBeforeSeek;
                        customUI.control.show(isFreeze);

                        if (state.hasStillVideo) {
                            hideStillVideo();
                        }

                        customUI.control.showExtension();
                        customUI.control.hideDimmedLayer();

                        if (showTitle) {
                            customUI.control.showTitle();
                        }
                    }

                    if (rate >= 0 && rate <= 100) {
                        startSpinner();
                        currentTime = (player.getDurationRound() * rate) / 100;
                        player.seekTo(currentTime);
                    }

                    pctTracker.track('progress', player.getCurrentTimeRound());
                    helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onTouchEventEnd);
                }
            },
            onTouchMoveProgressPoint: function(e) {
                var video = queue.front;

                if (!state.seeking) {
                    return false;
                }

                if (video.type === constants.VIDEO_TYPE.AD || video.type === constants.VIDEO_TYPE.LIVE) {
                    return;
                }

                var orientation = helpers.orientation.getOrientation();
                var pageX = e.changedTouches ? e.changedTouches[0].pageX : e.pageX;
                var rate = getProgressRate(e);
                var currentTime = 0;

                customUI.progress.updatePlay(rate);
                customUI.progress.on();

                if (rate > 0 && rate <= 100) {
                    currentTime = (player.getDurationRound() * rate) / 100;

                    if (state.hasStillVideo) {
                        if (ua.platform !== 'pc') {
                            showStillVideo();
                            if (EL.TIME_POINT) {
                                dt.classList.remove(EL.TIME_POINT, 'hide');
                            }

                            setStillVideoCurrentTime(currentTime);
                            customUI.stillVideo.seekTo(currentTime);

                            if (isFullScreen() && orientation === 'landscape') {
                                customUI.stillVideo.move(pageX);
                            }
                        }
                    } else {
                        hideStillVideo();
                        customUI.control.setCurrentTime(currentTime, player.getDurationRound());
                        player.seekTo(currentTime);
                    }
                }
            },
            onClickMenu: function(e) {
                event.preventDefault(e);
                event.stopPropagation(e);

                customUI.control.hide();
                exports.queue.emit('show:modal', { target: 'setting' });
            },
            onClickProfile: function(e) {
                event.preventDefault(e);
                event.stopPropagation(e);

                customUI.control.hide();
                exports.queue.emit('show:modal', { target: 'profile' });
            },
            onClickSubtitle: function(e) {
                event.preventDefault(e);
                event.stopPropagation(e);

                customUI.control.hide();
                exports.queue.emit('show:modal', { target: 'subtitle' });
            },
            onShowNotification: function(data) {
                var message = data.message;
                var callback = data.callback;

                if (!message || typeof message !== 'string') {
                    debug.log('message does not exsist');
                    return;
                }

                showNotification(message, callback);
            },
            onFullScreenChange: function(e) {
                var video = queue.front;

                if (!fullscreenHelper.isFullScreenChangeEvent(e)) {
                    endSpinner();
                    return;
                }

                if (!helpers.device.isSupportCustomController(ua)) {
                    endSpinner();
                    return;
                }

                if (!state.ended && !player.isPaused()) {
                    player.play();
                }

                if (isFullScreen()) {
                    customUI.fullscreen.toggle(true);
                    exports.queue.emit('request:fullscreen');
                    helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onFullScreenChange, [
                        FULL_SCREEN_API.REQUEST,
                        video && video.id
                    ]);
                } else {
                    customUI.fullscreen.toggle(false);
                    customUI.stillVideo.resetPosition();

                    exports.queue.emit('cancel:fullscreen');
                    helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onFullScreenChange, [
                        FULL_SCREEN_API.CANCEL,
                        video && video.id
                    ]);

                    hideDefaultControl();
                    endSpinner();
                }
            },
            onOrientationChange: function() {
                if (ua.platform === 'pc') {
                    customUI.reSize();
                }
            },
            onClickAdController: function(e) {
                var target = e.target;

                runClickHandler(target, '.link_skip', function() {
                    event.stopPropagation(e);

                    if (state.skipAdEnabled) {
                        dt.StopWatch.start(queue.front.breakId !== 'midroll' ? 'startPlay' : 'rebuffering');
                        exports.queue.emit('skip:ad');
                        vastTracker.skip();
                        if (queue.front.breakId === 'preroll') {
                            pctTracker.track('linear_pre', 'skip');
                        } else if (queue.front.breakId === 'midroll') {
                            pctTracker.track('linear_mid', 'skip');
                        }
                    }
                });

                runClickHandler(target, '.link_more', function(closest) {
                    event.stopPropagation(e);

                    if (ua.platform === 'pc') {
                        customUI.control.show(true);
                    }

                    if (closest.href) {
                        player.pause();
                        vastTracker.click();
                        if (queue.front.breakId === 'preroll') {
                            pctTracker.track('linear_pre', 'link');
                        } else if (queue.front.breakId === 'midroll') {
                            pctTracker.track('linear_mid', 'link');
                        }
                    }
                });

                runClickHandler(target, '.link_smrad', function(closest) {
                    event.stopPropagation(e);

                    if (closest.href) {
                        player.pause();
                        vastTracker.extension.click();
                        pctTracker.track('linear_post_text', 'link');
                    }
                });

                runClickHandler(target, '.link_textad', function(closest) {
                    event.stopPropagation(e);
                    pauseNonLinearAd();

                    if (closest.href) {
                        player.pause();
                        vastTracker.midTextAdTracker.click();
                        pctTracker.track('nonlinear_text', 'link');
                    }
                });

                runClickHandler(target, '.close_textad', function() {
                    event.stopPropagation(e);

                    closeMidTextAd();
                    pctTracker.track('nonlinear_text', 'close');
                });

                runClickHandler(target, '.link_nonlinear_text', function() {
                    event.stopPropagation(e);

                    showNonLinearAd(false, 'text');
                    pctTracker.track('nonlinear_text', 'info');
                });

                runClickHandler(target, '.link_imagead', function(closest) {
                    event.stopPropagation(e);
                    pauseNonLinearAd();

                    if (closest.href) {
                        player.pause();
                        vastTracker.midImageAdTracker.click();
                        pctTracker.track('nonlinear_image', 'link');
                    }
                });

                runClickHandler(target, '.close_imagead', function() {
                    event.stopPropagation(e);

                    closeMidImageAd();
                    pctTracker.track('nonlinear_image', 'close');
                });

                runClickHandler(target, '.link_optout', function() {
                    pctTracker.track('ad_optout');
                });
            },
            onClickPlayerController: function(e) {
                var target = e.target;

                runClickHandler(target, '.btn_liveHD', function() {
                    event.stopPropagation(e);
                    hideControl();

                    exports.queue.emit('play:live', 'HIGH');
                    pctTracker.track('liveapp', 'open');
                });

                runClickHandler(target, '.btn_mute', function() {
                    event.stopPropagation(e);

                    player.setMute(false);
                    saveRecentMute(false);
                    exports.queue.emit('reset:env:mute');
                    pctTracker.track('mute', 'false');
                });

                runClickHandler(target, '.btn_muteoff', function() {
                    event.stopPropagation(e);

                    player.setMute(true);
                    saveRecentMute(true);
                    pctTracker.track('mute', 'true');
                });

                runClickHandler(target, '.player_play', function() {
                    event.stopPropagation(e);

                    if (state.needMidrollRequest) {
                        state.needMidrollRequest = false;
                        exports.queue.emit('ad:checkMidrollAd');
                    }

                    player.play();
                    activateCustomUI(true);

                    helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onClickEventStart, [
                        constants.PLAYER_CLICK_ACTION.PLAY,
                        env.clipLinkId
                    ]);
                    pctTracker.track('play_pause');
                });

                runClickHandler(target, '.player_pause', function() {
                    event.stopPropagation(e);

                    player.pause();
                    activateCustomUI(true);

                    helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onClickEventStart, [
                        constants.PLAYER_CLICK_ACTION.PAUSE,
                        env.clipLinkId
                    ]);
                    pctTracker.track('play_pause');
                });

                runClickHandler(target, '.player_replay', function() {
                    event.stopPropagation(e);

                    activateCustomUI(false);
                    startSpinner();

                    exports.queue.emit('hide:completion');

                    var preserveState = {
                        autoplay: state.autoplay
                    };

                    if (state.dash) {
                        shaka.unload();
                    }

                    exports.queue.emit(
                        'loadAndPlay:videoById:replay',
                        state.currentVideo.id,
                        state.dash ? constants.DASH_PROFILE[state.currentVideo.profile] : state.currentVideo.profile,
                        null,
                        null,
                        preserveState
                    );
                    pctTracker.track('replay');
                });

                runClickHandler(target, '.btn_back10s', function() {
                    event.stopPropagation(e);
                    state.pausedBeforeSeek = state.ended ? false : player.isPaused();

                    var currentTime = player.getCurrentTimeRound() - 10;
                    if (currentTime < 0) {
                        return;
                    }

                    state.preventTogglePlayPause = true;
                    player.seekTo(currentTime);
                    activateCustomUI(true);
                    pctTracker.track('10s_seeking', 'forward');
                });

                runClickHandler(target, '.btn_front10s', function() {
                    event.stopPropagation(e);
                    state.pausedBeforeSeek = state.ended ? false : player.isPaused();

                    var currentTime = player.getCurrentTimeRound() + 10;
                    if (currentTime > player.getDurationRound()) {
                        return;
                    }

                    state.preventTogglePlayPause = true;
                    player.seekTo(currentTime);
                    activateCustomUI(true);
                    pctTracker.track('10s_seeking', 'backward');
                });

                runClickHandler(target, '#fullscreenBtn', function() {
                    event.stopPropagation(e);

                    if (isFullScreen()) {
                        cancelFullscreen();
                    } else {
                        requestFullscreen();
                        if (ua.platform === 'pc') {
                            contextMenu.exitPictureInPicture();
                        } else {
                            var video = player.videoElement;
                            if (video.videoWidth >= video.videoHeight) {
                                lockScreenInLandscape();
                            }
                        }
                    }
                    pctTracker.track('fullscreen');
                });
            }
        };

        var listener = {
            viewEvent: function() {
                var thread;
                var prefix = helpers.polyfill.getPrefix(document, 'visibilityState');
                var visibilityChange = prefix + 'visibilitychange';

                event.on(EL.AD_CONTROLLER, 'click', handler.onClickAdController);

                event.on(EL.PLAYER_CONTROLLER, 'click', handler.onClickPlayerController);

                event.on(document, visibilityChange, function() {
                    if (document.visibilityState === 'hidden') {
                        pauseNonLinearAd();

                        if (ua.platform === 'mobile') {
                            player.pause();
                            state.pausedBeforeSeek = player.isPaused();
                        }
                    } else if (document.visibilityState === 'visible') {
                        var video = queue.front;

                        if (state.pausedBeforeSeek && player.isPaused()) {
                            player.pause();

                            if (video && video.type === constants.VIDEO_TYPE.VOD) {
                                customUI.control.show(player.isPaused());
                            } else if (video && video.type === constants.VIDEO_TYPE.AD) {
                                customUI.ad.showButton();
                            }
                        } else {
                            if (video && video.type === constants.VIDEO_TYPE.VOD && !state.ended) {
                                customUI.control.hide();
                            } else if (video && video.type === constants.VIDEO_TYPE.AD) {
                                customUI.ad.hideButton();
                            }
                        }

                        if (state.hasStillVideo && helpers.device.isPCWithSafari(ua)) {
                            customUI.stillVideo.load();
                        }
                    }
                });

                event.delegate(EL.PLAYER, '.report', 'click', function(e) {
                    event.stopPropagation(e);
                    event.preventDefault(e);

                    sendReport();
                    exports.queue.emit('close:settingbox');

                    pctTracker.track('report');
                });

                if (ua.platform === 'pc') {
                    orien.onOrientationChange(
                        helpers.waiter.throttle(function(e) {
                            handler.onOrientationChange(e);
                        }, 250)
                    );

                    event.delegate(EL.PLAYER_CONTROLLER, '.progress_bar', 'mousemove', function(e) {
                        var video = queue.front;

                        if (
                            env.isAdType ||
                            !env.controls ||
                            (video && video.type === constants.VIDEO_TYPE.AD) ||
                            (video && video.type === constants.VIDEO_TYPE.LIVE)
                        ) {
                            return;
                        }

                        var timePlay = $$('.time_play')[0];
                        var rate = getProgressRate(e);

                        if (rate > 0) {
                            var currentTime = (player.getDurationRound() * rate) / 100;

                            if (!isNaN(currentTime)) {
                                var rect = EL.PROGRESSBAR.getBoundingClientRect();
                                if (isFullScreen()) {
                                    rect = checkRectSize(rect);
                                }

                                var pageX = e.pageX;
                                var offsetLeft = Math.floor(rect.left);
                                var offsetX = pageX && pageX - offsetLeft;
                                var seekBarWidth = (offsetX / EL.PROGRESSBAR.offsetWidth) * 100;

                                EL.SEEK_BAR.style['width'] = seekBarWidth + '%';

                                timePlay.innerHTML = helpers.string.delimitTimes(currentTime);

                                if (state.hasStillVideo) {
                                    showStillVideo();
                                    customUI.stillVideo.seekTo(currentTime);
                                    customUI.stillVideo.move(pageX);
                                } else {
                                    EL.TIME_POINT.style['left'] = offsetX + 'px';
                                }
                            }
                        }
                    });

                    event.delegate(EL.PLAYER_CONTROLLER, '.progress_bar', 'mouseover', function() {
                        if (env.isAdType || !env.controls) {
                            return;
                        }

                        if (EL.TIME_POINT) {
                            dt.classList.remove(EL.TIME_POINT, 'hide');
                        }
                    });

                    event.on(document, 'mouseout', function(e) {
                        var from = e.relatedTarget || e.toElement;
                        if (!from || from.nodeName === 'HTML') {
                            if (!env.controls || state.ended) {
                                return;
                            }

                            if (
                                player.videoElement.readyState > 3 &&
                                !state.ended &&
                                !env.isAdType &&
                                !state.seeking &&
                                !player.isPaused() &&
                                !env.keepShowControl
                            ) {
                                customUI.control.hide();
                            }
                        }
                    });

                    event.on(EL.PLAYER_CONTROLLER_CONTAINER, 'mousemove', function() {
                        var onmousestop = function() {
                            if (
                                !env.controls ||
                                state.seeking ||
                                state.ended ||
                                player.isPaused() ||
                                state.isSettingMenuOpened ||
                                env.keepShowControl
                            ) {
                                return;
                            }
                            customUI.control.hide();
                        };

                        if (player.isReady() && !state.ended && !env.isAdType) {
                            customUI.control.show(player.isPaused());
                        }

                        if (thread) {
                            clearTimeout(thread);
                        }

                        thread = setTimeout(onmousestop, 1500);
                    });
                } else {
                    orien.onOrientationChange(function(e) {
                        if (isFullScreen()) {
                            customUI.stillVideo.resetPosition();
                        }
                        handler.onOrientationChange(e);
                    });

                    event.on(EL.PLAYER_CONTROLLER_CONTAINER, 'click', function() {
                        var video = queue.front;

                        if (player.videoElement.readyState === 4) {
                            if (video && video.type === constants.VIDEO_TYPE.AD) {
                                return;
                            }

                            if (!player.isPaused()) {
                                toggleCustomUI();
                            } else {
                                customUI.control.toggleUI();
                            }
                        }
                    });

                    if (EL.TVOD_LINK) {
                        event.on(EL.TVOD_LINK, 'click', function() {
                            var currentVideo = state.currentVideo;

                            var purchase = currentVideo.purchase;

                            if (ua.platform !== 'pc' && purchase) {
                                helpers.web2app.launchTalk(purchase.purchaseLink);
                            }
                        });
                    }

                    event.on(EL.AD_CONTROLLER, 'click', function(e) {
                        var video = queue.front;
                        if (video && video.type === constants.VIDEO_TYPE.AD) {
                            if (
                                dt.classList.has(e.target, 'link_skip') ||
                                dt.classList.has(e.target, 'img_player') ||
                                dt.classList.has(e.target, 'link_play') ||
                                dt.classList.has(e.target, 'link_pause')
                            ) {
                                customUI.ad.showButton();
                                return;
                            }
                            activateAdPlayPause(player.isPaused());
                        }
                    });

                    event.on(EL.AD_PLAY, 'click', function() {
                        player.play();
                        pctTracker.track('play_pause');
                    });

                    event.on(EL.AD_PAUSE, 'click', function() {
                        player.pause();
                        pctTracker.track('play_pause');
                    });

                    event.on(EL.AD_MUTE_BUTTON, 'click', function() {
                        player.setMute(false);
                        saveRecentMute(false);

                        pctTracker.track('mute', 'false');
                    });

                    event.on(EL.AD_UNMUTE_BUTTON, 'click', function() {
                        player.setMute(true);
                        saveRecentMute(true);

                        pctTracker.track('mute', 'true');
                    });

                    event.on(EL.PLAYER_CONTROLLER_TOGGLE_BUTTON, 'click', function() {
                        customUI.control.show(true);
                        if (player.isPaused()) {
                            EL.PLAY_BUTTON.focus();
                        } else {
                            EL.PAUSE_BUTTON.focus();
                        }
                    });

                    event.delegate(EL.PLAYER_FUNCTION, '.' + CNAME.BUTTON_SETTING, 'click', handler.onClickMenu);
                    event.delegate(EL.PLAYER, '.' + CNAME.BUTTON_PROFILE, 'click', handler.onClickProfile);
                    event.delegate(EL.PLAYER, '.' + CNAME.BUTTON_SUBTITLE, 'click', handler.onClickSubtitle);
                }

                event.on(
                    window,
                    'resize',
                    helpers.waiter.debounce(function() {
                        var body = document.documentElement || document.body;
                        qoeTracker.track(QOE_EVENTS.DISPLAY_SIZE_CHANGE, {
                            n1: body.clientWidth,
                            n2: body.clientHeight
                        });
                    }, 300)
                );

                function addEventFullScreenChange() {
                    var fullscreenEvents = [
                        'fullscreenchange',
                        'MSFullscreenChange',
                        'mozfullscreenchange',
                        'webkitfullscreenchange',
                        'webkitbeginfullscreen',
                        'webkitendfullscreen'
                    ];

                    var webkitFullscreenEvents = ['webkitbeginfullscreen', 'webkitendfullscreen'];

                    fullscreenEvents.forEach(function(item) {
                        event.on(document, item, function(e) {
                            handler.onFullScreenChange(e);
                        });
                    });

                    webkitFullscreenEvents.forEach(function(item) {
                        event.on(player.videoElement, item, function(e) {
                            handler.onFullScreenChange(e);
                        });
                    });
                }

                addEventFullScreenChange();
            },
            customEvent: function(sandbox) {
                sandbox.on('complete:play', function() {
                    if (!env.controls) {
                        hideControlFoot();
                    }

                    if (env.menu) {
                        if (EL.SETTING_BUTTON) {
                            dt.classList.remove(EL.SETTING_BUTTON, 'hide');
                        }
                    }
                });

                sandbox.on('show:notification', function(data) {
                    handler.onShowNotification(data);
                });

                sandbox.on('complete:stat', function(data) {
                    statCallback(data);
                });

                sandbox.on('change:orientation', function(data) {
                    debug.info('change:orientation', data.body.type);

                    if (data.body.type === 'landscape') {
                        requestFullscreen();
                    } else {
                        cancelFullscreen();
                    }
                    // customUI.fullscreen.toggle(data.body.fullscreen);
                });

                sandbox.on('request:pip', function() {
                    cancelFullscreen();
                });

                sandbox.on('hide:controller', function() {
                    activateCustomUI(false);
                });

                sandbox.on('show:container', function() {
                    customUI.container.show();
                });

                sandbox.on('hide:container', function() {
                    customUI.container.hide();
                });

                sandbox.on('hide:rating', function() {
                    customUI.rating.hide();
                });
            },
            gestureEvent: function() {
                var progressbar, doc;

                if (!EL.PROGRESSBAR) {
                    return;
                }

                progressbar = window.gesture.GestureListener(EL.PROGRESSBAR);
                doc = window.gesture.GestureListener(document);

                progressbar.onGestureStart(function(session) {
                    if (!env.isAdType && env.controls) {
                        handler.onTouchStartProgress(session.targetEvent);
                    }
                });

                progressbar.onGestureMove(function(session) {
                    if (!env.isAdType && env.controls) {
                        handler.onTouchMoveProgressPoint(session.targetEvent);
                    }
                });

                progressbar.onGestureEnd(function(session) {
                    if (!env.isAdType && env.controls) {
                        handler.onTouchEndProgress(session.targetEvent);
                    }
                });

                doc.onGestureMove(function(session) {
                    handler.onTouchMoveProgressPoint(session.targetEvent);
                });

                doc.onGestureEnd(function(session) {
                    if (state.seeking) {
                        handler.onTouchEndProgress(session.targetEvent);
                    }
                });
            }
        };

        function applyFullscreenEnabled() {
            var fullscreenEnabled =
                document.fullscreenEnabled ||
                document.webkitFullscreenEnabled ||
                fullscreenHelper.isSupportOnlyIOS() ||
                document.msFullscreenEnabled ||
                document.mozFullScreenEnabled;

            if (!fullscreenEnabled) {
                customUI.fullscreen.hide();
            } else {
                customUI.fullscreen.show();
            }
        }

        function Inline() {}

        Inline.prototype.init = function(player, sandbox) {
            var isSupportCustomController = helpers.device.isSupportCustomController(ua);
            var connection = helpers.webapi.network.getConnection();
            fullscreenHelper = helpers.fullscreen(EL.PLAYER_CONTAINER, player.videoElement);

            debug.tooltip('Support custom ui: ', isSupportCustomController);
            debug.tooltip('browser info : ', ua.browser.name + ' / ' + ua.browser.version.info);
            debug.tooltip('ua platform : ', ua.platform + ', ' + ua.os.name);
            debug.tooltip('network type : ', connection && connection.type);
            debug.log('[view:inline] initialized');

            if (isSupportCustomController) {
                applyParameters();
                hideDefaultControl();

                listener.viewEvent();
            } else {
                showDefaultControl();
            }

            if (!helpers.device.isSupportMutedControl(ua)) {
                dt.classList.add(EL.AD_MUTE_BUTTON, 'hide');
                dt.classList.add(EL.AD_UNMUTE_BUTTON, 'hide');
                dt.classList.add(EL.MUTE_BUTTON, 'hide');
                dt.classList.add(EL.UNMUTE_BUTTON, 'hide');
            }

            listener.customEvent(sandbox);
            listener.gestureEvent();
        };

        Inline.prototype.setSize = function() {
            customUI.setSize();
        };

        Inline.prototype.reSize = function() {
            customUI.reSize();
        };

        Inline.prototype.showBlind = function() {
            showBlind();
        };

        Inline.prototype.hideBlind = function() {
            hideBlind();
        };

        Inline.prototype.showNotification = function(message, callback) {
            showNotification(message, callback);
        };

        Inline.prototype.startSpinner = function() {
            startSpinner();
        };

        Inline.prototype.endSpinner = function() {
            endSpinner();
        };

        Inline.prototype.showAd = function() {
            customUI.ad.show();
        };

        Inline.prototype.hideAd = function() {
            customUI.ad.hide();
        };

        Inline.prototype.setupAd = function() {
            state.skipAdEnabled = false;
            customUI.ad.reset();
            customUI.ad.setup();
        };

        Inline.prototype.setupVideoControl = function() {
            var video = state.currentVideo;
            var storeChart = helpers.store.get(CHART_KEY);

            if (video.wasLive) {
                customUI.control.showReplay();
            }

            var duration = player.getDurationRound();

            dt.classList.remove(EL.PLAYER_CONTROLLER, 'ad_type');

            if (env.isAdType || env.miniProgress) {
                dt.classList.add(EL.PLAYER_CONTROLLER, 'mini_progress');
            } else {
                customUI.control.setDuration(duration);
                customUI.control.setCurrentTime(0, duration);
                customUI.progress.updatePlay(0);

                if (state.allAdsCompleted) {
                    customUI.control.setCurrentTime(duration, duration);
                    customUI.progress.updatePlay(100);
                }

                dt.classList.remove(EL.PLAYER_CONTROLLER, 'mini_progress');

                if (ua.platform === 'pc' && env.isPrivateIp && !env.popup) {
                    contextMenu.showAnalyticButton();
                    customUI.control.showChartButton();

                    if (!state.isPostrollEnded && storeChart !== 'false') {
                        exports.queue.emit('analytics:chart', false);
                    }
                }
            }
        };

        Inline.prototype.setupAdControl = function() {
            var duration = player.getDurationRound();

            customUI.control.setDuration(duration);
            customUI.control.setCurrentTime(0, player.getDurationRound());
            customUI.progress.updatePlay(0);

            dt.classList.add(EL.PLAYER_CONTROLLER, 'ad_type');

            if (ua.platform !== 'pc' && !isFullScreen()) {
                customUI.control.hide();
            } else {
                contextMenu.hideAnalyticButton();
                customUI.control.hideChartButton();
            }
        };

        Inline.prototype.setupLiveControl = function() {
            dt.classList.remove(EL.PLAYER_CONTROLLER, 'ad_type');
            if (EL.PLAY_TIME_CONTAINER) {
                dt.classList.add(EL.PLAY_TIME_CONTAINER, 'hide');
            }
            if (EL.PLAY_PROGRESS) {
                dt.classList.add(EL.PLAY_PROGRESS, 'hide');
            }

            if (!liveStatTimeout) {
                updateStat();
            }
        };

        Inline.prototype.showControl = function(isfreeze) {
            activateCustomUI(true, isfreeze);
        };

        Inline.prototype.showAdControl = function(isPaused) {
            activateAdPlayPause(isPaused);
        };

        Inline.prototype.hideActivatedControl = function() {
            activateCustomUI(false);
        };

        Inline.prototype.hideControl = function() {
            hideControl();
        };

        Inline.prototype.clearTimer = function() {
            customUI.control.clearTimer();
        };

        Inline.prototype.resizeControl = function() {
            resizeControl();
        };

        Inline.prototype.showControlHead = function() {
            showControlHead();
        };

        Inline.prototype.hideControlHead = function() {
            hideControlHead();
        };

        Inline.prototype.showControlFooter = function() {
            showControlFoot();
        };

        Inline.prototype.onTimeUpdate = function(currentTime, duration) {
            var video = queue.front;

            if (state.seeking) {
                customUI.control.setCurrentTime(currentTime, duration);
                return;
            }

            updateTime(currentTime, duration);

            if (video && video.type === constants.VIDEO_TYPE.VOD) {
                checkNextVideo(currentTime, duration);
            } else if (video && video.type === constants.VIDEO_TYPE.AD) {
                if (video.timeOffset !== 'end') {
                    updateAdSkipTime();
                }
            }
        };

        Inline.prototype.updateProgressTime = function(currentTime, duration) {
            updateTime(currentTime, duration);
        };

        Inline.prototype.onProgress = function(loadEndPercentage) {
            updateLoad(loadEndPercentage);
        };

        Inline.prototype.onEndVideo = function() {
            var video = state.currentVideo;

            if (ua.platform !== 'pc' && state.hasStillVideo) {
                hideStillVideo();
                customUI.control.showExtension();
                customUI.control.hideDimmedLayer();
                customUI.control.showSeeking();
                customUI.control.showPlayPause();
                customUI.tvod.hide();

                if (EL.TIME_POINT) {
                    dt.classList.add(EL.TIME_POINT, 'hide');
                }
            }

            if (video.purchase) {
                var info = {
                    checkUrl: video.purchase.purchaseLink,
                    message: video.purchase.guideMessage,
                    code: 'NeedPurchased',
                    type: 'onError',
                    preview: true
                };
                error.showError(CONFIRM_STATUS.NeedPurchased.NAME, info);
            } else if (env.rel && state.hasRelated) {
                exports.queue.emit('show:completion');
                exports.queue.emit('hide:modal');

                if (video.type === 'LIVE') {
                    if (isFullScreen()) {
                        cancelFullscreen();
                    }

                    error.showError(ERROR_STATUS.LiveFinished.NAME, {});
                } else {
                    activateCustomUI(false);
                }
            } else {
                var isAutoPlay = false;
                var startTime = 0;

                if (state.dash) {
                    shaka.unload();
                }

                exports.queue.emit('load:videoById:withPlayerUnload', startTime, isAutoPlay);
            }
        };

        Inline.prototype.onSeeked = function() {
            onSeeked();
        };

        Inline.prototype.requestFullscreen = function() {
            requestFullscreen();
        };

        Inline.prototype.cancelFullscreen = function() {
            cancelFullscreen();
        };

        Inline.prototype.isFullScreen = function() {
            return isFullScreen();
        };

        Inline.prototype.isFullScreenSupport = function() {
            return isFullScreenSupport();
        };

        Inline.prototype.applyFullscreenEnabled = function() {
            return applyFullscreenEnabled();
        };

        Inline.prototype.togglePlayPause = function(isPaused) {
            if (state.preventTogglePlayPause) {
                return;
            }

            if (isPaused) {
                if (state.ended) {
                    dt.classList.add(EL.PAUSE_BUTTON, 'hidden');
                    dt.classList.remove(EL.PLAY_BUTTON, 'hidden');
                } else {
                    dt.classList.remove(EL.PLAY_BUTTON, 'hidden');
                    dt.classList.add(EL.PAUSE_BUTTON, 'hidden');
                }
            } else {
                dt.classList.add(EL.PLAY_BUTTON, 'hidden');
                dt.classList.remove(EL.PAUSE_BUTTON, 'hidden');
            }
        };

        Inline.prototype.toggleAdPlayPause = function(isPaused) {
            if (player.getCurrentTime() > 0) {
                customUI.ad.showButton();
            }

            toggleAdPlayPause(isPaused);
        };

        Inline.prototype.getClipLocation = function(profile, callback) {
            getClipLocation(profile, callback);
        };

        Inline.prototype.getLiveLocation = function(profile, callback) {
            getLiveLocation(profile, callback);
        };

        Inline.prototype.setupNonLinearAd = function(ad) {
            setupNonLinearAd(ad);
        };

        Inline.prototype.setupMidrollAd = function(index, isStarted, timeOffset) {
            setupMidrollAd(index, isStarted, timeOffset);
        };

        Inline.prototype.showNonLinearAd = function(isStarted, adType) {
            showNonLinearAd(isStarted, adType);
        };

        Inline.prototype.hideNonLinearAd = function() {
            hideNonLinearAd();
        };

        Inline.prototype.pauseNonLinearAd = function() {
            pauseNonLinearAd();
        };

        Inline.prototype.resumeNonLinearAd = function() {
            resumeNonLinearAd();
        };

        Inline.prototype.showLinearAdContainer = function() {
            showLinearAdContainer();
        };

        Inline.prototype.hideLinearAdContainer = function() {
            hideLinearAdContainer();
        };

        Inline.prototype.showNonLinearAdContainer = function() {
            showNonLinearAdContainer();
        };

        Inline.prototype.hideNonLinearAdContainer = function() {
            hideNonLinearAdContainer();
        };

        Inline.prototype.setProfile = function(profile) {
            setProfile(profile);
        };

        Inline.prototype.setStillVideo = function(seekUrl, callback) {
            setStillVideo(seekUrl, callback);
        };

        Inline.prototype.showStillVideo = function() {
            showStillVideo();
        };

        Inline.prototype.hideStillVideo = function() {
            hideStillVideo();
        };

        Inline.prototype.onLoadStart = function() {
            var video = queue.front;
            if (video.type === constants.VIDEO_TYPE.VOD) {
                setSeekThumbnail();
            }
        };

        Inline.prototype.toggleMuteUI = function(muteOn) {
            toggleMuteUI(muteOn);
        };

        Inline.prototype.getRecentMute = function() {
            return getRecentMute();
        };

        Inline.prototype.getRecentVolume = function() {
            return getRecentVolume();
        };

        Inline.prototype.setRecentVolume = function(volume) {
            setRecentVolume(volume);
        };

        Inline.prototype.saveRecentMute = function(muteOn) {
            saveRecentMute(muteOn);
        };

        Inline.prototype.onCompleteMeta = function() {
            setShowTitle();
            setKakaoTVLink();
            setRatingLevel();
            customUI.control.showProfile();
        };

        Inline.prototype.setKakaoTVLink = function() {
            setKakaoTVLink();
        };

        Inline.prototype.setRatingLevel = function() {
            setRatingLevel();
        };

        Inline.prototype.setVolume = function(volume, muteOn) {
            setVolume(volume, muteOn);
        };

        Inline.prototype.hideDefaultControl = function() {
            hideDefaultControl();
        };

        Inline.prototype.setAriaAttr = function() {
            if (EL.PLAYER_CONTROLLER_TOGGLE_BUTTON) {
                a11y.removeAria(EL.PLAYER_CONTROLLER_TOGGLE_BUTTON, 'hidden');
            }
            a11y.removeAria(player.videoElement, 'hidden');
            a11y.setAria(player.videoElement, 'describedby', 'videoDesc');
        };

        Inline.prototype.resetAriaAttr = function() {
            if (EL.PLAYER_CONTROLLER_TOGGLE_BUTTON) {
                a11y.setAria(EL.PLAYER_CONTROLLER_TOGGLE_BUTTON, 'hidden', 'true');
            }
            a11y.setAria(player.videoElement, 'hidden', 'true');
            a11y.removeAria(player.videoElement, 'describedby');
        };

        Inline.prototype.hideVideoCursor = function() {
            defaultUI.video.hideCursor();
        };

        Inline.prototype.showVideoCursor = function() {
            defaultUI.video.showCursor();
        };

        Inline.prototype.openPopup = function(url, name, features) {
            openPopup(url, name, features);
        };

        Inline.prototype.setShowTitle = function() {
            setShowTitle();
        };

        Inline.prototype.setDuration = function(duration) {
            customUI.control.setDuration(duration);
        };

        Inline.prototype.setTvod = function(data) {
            customUI.tvod.setTvodData(data);
        };

        Inline.prototype.showTvod = function() {
            customUI.tvod.show();
        };

        Inline.prototype.hideTvod = function() {
            customUI.tvod.hide();
        };

        Inline.prototype.showRating = function() {
            customUI.rating.show();
        };

        Inline.prototype.hideRating = function() {
            customUI.rating.hide();
        };

        Inline.prototype.initVolumeControl = function() {
            initVolumeControl();
        };

        return Inline;
    })();

    exports.addModule('view.inline', new Inline());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var InlinePC;

    InlinePC = (function() {
        var state = exports.loadModule('controller.state');
        var dataLoader = exports.loadModule('playlist.dataloader');
        var shaka = exports.loadModule('player.shaka');
        var player = exports.loadModule('player.adapter');
        var queue = exports.loadModule('playlist.queue');
        var contextMenu = exports.loadModule('view.contextmenu');
        var inline = exports.loadModule('view.inline');
        var pctTracker = exports.loadModule('pct.tracker');
        var pvtTracker = exports.loadModule('pvt.tracker');
        var keyboardAddOn = exports.loadModule('addon.keyboard');
        var analytics = exports.loadModule('view.analytics');
        var playerTemplate = exports.template;

        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;

        var ID = {
            CLIP_INFO_MODIFY: 'clipInfoModify',
            CLIP_INFO_PANEL: 'clipInfoPanel',
            CLIP_COVER_PANEL: 'clipCoverImagePanel'
        };

        var KEYBOARD_TYPE = {
            FRONT_5S: 'ico_front5s',
            BACK_5S: 'ico_back5s',
            FRONT_60S: 'ico_front60s',
            BACK_60S: 'ico_back60s',
            VOLUME_MUTE: 'ico_volumeno',
            VOLUME_DOWN: 'ico_volumedown',
            VOLUME_UP: 'ico_volumeup',
            SPEED_DOWN: 'ico_speeddown',
            SPEED_UP: 'ico_speedup'
        };

        var DEFAULT_SPEED = 1.0;

        var EL = {
            PLAYER_CONTAINER: $('playerContainer'),
            CONTROLLER: $('controller'),
            CONTROLLER_BODY: $$('#controller .player_body')[0],
            CONTROLLER_PLAY_BUTTON: $$('.player_body button')[0],
            CONTROLLER_PLAY_BUTTON_TEXT: $$('.player_body .img_player')[0],
            PLAY_BUTTON: $$('.player_play')[0],
            REPLAY_BUTTON: $$('.player_replay')[0] || null,
            PROGRESSBAR: $('progress'),
            SOUND_CONTROL: $$('.sound_control')[0],
            VOLUME: $('volume'),
            MUTE_BUTTON: $('volumeBtn'),
            VOLUMEBAR: $('volumeBar'),
            VOLUMEBAR_BG: $('volumeBarBg'),
            VOLUME_POINT: $('pointVolume'),
            SETTING_BUTTON: $('settingBtn'),
            CHART_BUTTON: $('chartBtn'),
            WIDE_SCREEN_BUTTON: $('widescreebBtn'),
            POPUP_BUTTON: $('popupBtn'),
            SETUP_BOX: $$('.box_setup')[0],
            CHART_BOX: $$('.box_chart')[0],
            SETTING_BOX: $$('.box_setting')[0],
            MODIFY_BUTTON: $$('.box_setting .clip_modify')[0],
            AUTOPLAY_CHECK: $$('.box_setting .clip_autoplay')[0],
            STILL_IMAGE: $('stillImage'),
            AUTO_PLAY: $('autoPlay'),
            STILL_IMAGE_LIST: $$('#stillImage .list_section')[0],
            PUBLIC_MODE: $('publicMode'),
            CLIP_INFO_MODIFY: $(ID.CLIP_INFO_MODIFY) || null,
            CLIP_INFO_PANEL: $(ID.CLIP_INFO_PANEL) || null,
            CLIP_COVER_PANEL: $(ID.CLIP_COVER_PANEL) || null,
            PLAYER_FUNCTION: $$('.player_function')[0],
            AD_CONTROLLER: $('adController'),
            QUALITY_BOX: $$('.box_quality')[0],
            QUALITY_BUTTON: $$('.box_setting .btn_quality')[0],
            QUALITY_LIST: $$('.list_quality')[0],
            QUALITY_TEXT: $$('.txt_quality')[0],
            QUALITY_TITLE: $$('.box_quality .tit_quality')[0],
            SPEED_BOX: $$('.box_setup .box_playspeed')[0],
            MENU_SPEED_BUTTON: $$('.box_setting .clip_speed')[0],
            SUBTITLE_BOX: $$('.box_setup .box_subtitles')[0],
            SUBTITLE_TEXT: $('current_subtitle'),
            SUBTITLE_LIST: $$('.list_subtitles')[0],
            MENU_SUBTITLE_BUTTON: $$('.box_setting .lang_subtitles')[0],
            SUBTITLE_BUTTON: $$('.box_setting .btn_langsubtitles')[0],
            MENU_QUALITY_BUTTON: $$('.box_setting .dp_quality')[0],
            SPEED_TITLE: $$('.box_playspeed .tit_playspeed')[0],
            SPEED_LIST: $$('.list_playspeed')[0],
            SPEED_TEXT: $('current_speed'),
            KEYBOARD_EFFECT: $$('.player_body .ico_keyboard')[0],
            MIRRORING_TEXT: $$('.txt_mirroring')[0],
            ALERT_LIVEAGENT: $('alertLiveAgent')
        };

        var PROFILE_KEY = constants.STORAGE.PROFILE;
        var SUBTITLE_KEY = constants.STORAGE.SUBTITLE;
        var MINI_PLAYER_MAX_WIDTH = 500;

        var customUI = {
            control: {
                playback: {
                    el: EL.CONTROLLER_PLAY_BUTTON,
                    timer: null,
                    show: function() {
                        var self = this;
                        dt.classList.remove(this.el, 'hide');

                        this.timer = setTimeout(function() {
                            self.hide();
                            self.timer = null;
                        }, 500);
                    },
                    hide: function() {
                        dt.classList.add(this.el, 'hide');
                    }
                },
                volume: {
                    el: EL.MUTE_BUTTON,
                    timer: null,
                    show: function() {
                        dt.classList.add(EL.SOUND_CONTROL, 'open');
                    },
                    hide: function() {
                        dt.classList.remove(EL.SOUND_CONTROL, 'open');
                    },
                    mute: function(muted) {
                        if (muted) {
                            dt.classList.remove(this.el, 'btn_sound');
                            dt.classList.add(this.el, 'btn_soundoff');
                            this.el.setAttribute('aria-label', '음소거 해제');
                            this.el.nextElementSibling.innerHTML = '음소거 해제';
                        } else {
                            dt.classList.remove(this.el, 'btn_soundoff');
                            dt.classList.add(this.el, 'btn_sound');
                            this.el.setAttribute('aria-label', '음소거');
                            this.el.nextElementSibling.innerHTML = '음소거';
                        }
                    },
                    update: function(volume) {
                        var volumeRate = (volume * 100).toFixed(2) + '%';

                        EL.VOLUMEBAR.style['width'] = volumeRate;
                        EL.SOUND_CONTROL.setAttribute('aria-valuetext', volumeRate);
                    }
                },
                profile: {
                    el: EL.QUALITY_LIST,
                    timer: null,
                    template: {
                        profileList: playerTemplate.pc_profile_list,
                        supHD: playerTemplate.superscript_hd,
                        sup4K: playerTemplate.superscript_4k,
                        profileText: playerTemplate.profile_text
                    },
                    create: function(outputs) {
                        var supHDTemplate = this.template.supHD;
                        var sup4KTemplate = this.template.sup4K;

                        var view = {
                            outputs: []
                        };

                        var profile, profileLabel;

                        for (var i = outputs.length - 1; i >= 0; i--) {
                            profile = outputs[i].profile.toString();
                            profileLabel = outputs[i].label;

                            if (profile === state.currentVideo.profile) {
                                this.updateLabel(profileLabel);
                            }

                            if (profile !== 'AUDIO') {
                                view.outputs.push({
                                    profileOn: profile === state.currentVideo.profile ? 'on' : '',
                                    profileName: profile,
                                    profileLabel: this.removeText(profileLabel),
                                    supHD: (function() {
                                        if (profileLabel.indexOf('HD') >= 0) {
                                            return supHDTemplate.render();
                                        } else {
                                            return '';
                                        }
                                    })(),
                                    sup4K: (function() {
                                        if (profileLabel.indexOf('4K') >= 0) {
                                            return sup4KTemplate.render();
                                        } else {
                                            return '';
                                        }
                                    })()
                                });
                            }
                        }

                        var fragment = this.createTemplate(view);
                        this.render(fragment);
                    },
                    createTemplate: function(view) {
                        var template = this.template.profileList;
                        return template.render(view);
                    },
                    render: function(htmlStr) {
                        EL.QUALITY_LIST.innerHTML = htmlStr;
                    },
                    showList: function() {
                        dt.classList.add(EL.QUALITY_BOX, 'open');
                    },
                    hideList: function() {
                        dt.classList.remove(EL.QUALITY_BOX, 'open');
                    },
                    removeText: function(text) {
                        var re = / |P|HD|4K/g;
                        return text.replace(re, '');
                    },
                    updateLabel: function(label) {
                        var profileAuto = state.currentVideo.profile === constants.PROFILE.AUTO;
                        var labelString = profileAuto
                            ? this.removeText(shaka.getCurrentProfile())
                            : this.removeText(label);
                        var supHD = profileAuto
                            ? shaka.getCurrentProfile().indexOf('HD') !== -1
                            : label.indexOf('HD') !== -1;
                        var sup4K = label && label.indexOf('4K') !== -1;
                        var view = {
                            profileText: labelString,
                            profileAuto: profileAuto,
                            profileHD: supHD,
                            profile4K: sup4K
                        };
                        var labelHTML = this.template.profileText.render(view);

                        dt.classList.remove(EL.SETTING_BUTTON, 'btn_hd');
                        dt.classList.remove(EL.SETTING_BUTTON, 'btn_4k');

                        if (supHD) {
                            dt.classList.add(EL.SETTING_BUTTON, 'btn_hd');
                        } else if (sup4K) {
                            dt.classList.add(EL.SETTING_BUTTON, 'btn_4k');
                        }

                        EL.QUALITY_TEXT.innerHTML = labelHTML;
                    }
                },
                setting: {
                    el: EL.SETUP_BOX,
                    show: function() {
                        dt.classList.add(this.el, 'open');
                    },
                    hide: function() {
                        dt.classList.remove(this.el, 'open');
                    },
                    showAutoPlay: function() {
                        if (EL.AUTOPLAY_CHECK) {
                            dt.classList.remove(EL.AUTOPLAY_CHECK, 'hide');
                        }
                    },
                    hideAutoPlay: function() {
                        if (EL.AUTOPLAY_CHECK) {
                            dt.classList.add(EL.AUTOPLAY_CHECK, 'hide');
                        }
                    },
                    showDpQualityButton: function() {
                        if (EL.MENU_QUALITY_BUTTON) {
                            dt.classList.remove(EL.MENU_QUALITY_BUTTON, 'hide');
                        }
                    },
                    hideDpQualityButton: function() {
                        if (EL.MENU_QUALITY_BUTTON) {
                            dt.classList.add(EL.MENU_QUALITY_BUTTON, 'hide');
                        }
                    },
                    showSubtitleButton: function() {
                        if (EL.MENU_SUBTITLE_BUTTON) {
                            dt.classList.remove(EL.MENU_SUBTITLE_BUTTON, 'hide');
                        }
                    },
                    hideSubtitleButton: function() {
                        if (EL.MENU_SUBTITLE_BUTTON) {
                            dt.classList.add(EL.MENU_SUBTITLE_BUTTON, 'hide');
                        }
                    },
                    showSpeedButton: function() {
                        if (EL.MENU_SPEED_BUTTON) {
                            dt.classList.remove(EL.MENU_SPEED_BUTTON, 'hide');
                        }
                    },
                    hideSpeedButton: function() {
                        if (EL.MENU_SPEED_BUTTON) {
                            dt.classList.add(EL.MENU_SPEED_BUTTON, 'hide');
                        }
                    }
                },
                stillImage: {
                    el: EL.STILL_IMAGE,
                    template: playerTemplate.still_image,
                    create: function(thumbnails) {
                        var image = '';
                        var seconds = 0;
                        var maxLength = thumbnails.length > 6 ? 6 : thumbnails.length;

                        var view = {
                            thumbnails: []
                        };

                        for (var i = 0; i < maxLength; i++) {
                            seconds = thumbnails[i].timeInSec;

                            if (thumbnails[i].thumbnailUrl) {
                                image =
                                    '//t1.daumcdn.net/thumb/C180x100/?fname=' +
                                    encodeURIComponent(thumbnails[i].thumbnailUrl);
                            }

                            view.thumbnails.push({
                                seconds: seconds,
                                imageSrc: image,
                                time: helpers.string.delimitTimes(seconds)
                            });
                        }

                        var fragment = this.createTemplate(view);
                        this.render(fragment);
                    },
                    createTemplate: function(view) {
                        return this.template.render(view);
                    },
                    render: function(htmlStr) {
                        EL.STILL_IMAGE_LIST.innerHTML = htmlStr;
                    },
                    show: function() {
                        dt.classList.remove(this.el, 'hide');
                    },
                    hide: function() {
                        dt.classList.add(this.el, 'hide');
                    },
                    on: function() {
                        dt.classList.add(this.el, 'on');
                    },
                    off: function() {
                        dt.classList.remove(this.el, 'on');
                    }
                },
                menu: {
                    template: playerTemplate.clip_cover_image,
                    activateTab: $$('#clipInfoModify .on a')[0] || null,
                    showClipInfo: function() {
                        dt.classList.remove(EL.CLIP_INFO_PANEL, 'hide');
                        dt.classList.add(EL.CLIP_COVER_PANEL, 'hide');
                    },
                    showClipCover: function() {
                        dt.classList.remove(EL.CLIP_COVER_PANEL, 'hide');
                        dt.classList.add(EL.CLIP_INFO_PANEL, 'hide');
                    },
                    setClipInfo: function() {
                        var lblName = $('lblName');
                        var scrapChecked = $$('input[name="scrapAllow"]');
                        var openedChecked = $$('input[name="isOpen"]');

                        var video = state.currentVideo;

                        if (video.canScrap) {
                            scrapChecked[0].checked = true;
                        }

                        if (video.isLegacy) {
                            dt.classList.add(EL.PUBLIC_MODE, 'hide');

                            for (var i = 0, len = openedChecked.length; i < len; i++) {
                                var r = openedChecked[i];
                                r.checked = false;
                                r.disabled = true;
                            }
                        } else {
                            dt.classList.remove(EL.PUBLIC_MODE, 'hide');

                            if (video.isOpen) {
                                openedChecked[0].checked = true;
                            }
                        }

                        lblName.value = video.title;
                    },
                    setClipCover: function(thumbnails) {
                        var image = '';
                        var maxLength = thumbnails.length > 6 ? 6 : thumbnails.length;

                        if (thumbnails.length < 1) {
                            return;
                        }

                        var view = {
                            thumbnails: []
                        };

                        for (var i = 0; i < maxLength; i++) {
                            if (thumbnails[i].thumbnailUrl) {
                                image =
                                    '//t1.daumcdn.net/thumb/C180x100/?fname=' +
                                    encodeURIComponent(thumbnails[i].thumbnailUrl);
                            }

                            view.thumbnails.push({
                                className: thumbnails[i].isDefault ? 'on' : '',
                                imageIndex: i,
                                imageSrc: image
                            });
                        }

                        var target = $$('.list_cover', EL.CLIP_COVER_PANEL)[0];
                        var fragment = this.createTemplate(view);

                        this.render(target, fragment);
                    },
                    createTemplate: function(view) {
                        return this.template.render(view);
                    },
                    render: function(target, htmlStr) {
                        target.innerHTML = htmlStr;
                    },
                    submitClipInfo: function() {
                        var scrapCheck = $$('input[name="scrapAllow"]');
                        var openedCheck = $$('input[name="isOpen"]');
                        var title = $('lblName').value;
                        var clipId = state.currentVideo.clipId;
                        var isOpen = openedCheck[0].checked;
                        var canScrap = scrapCheck[0].checked;

                        var options = {
                            title: title,
                            id: clipId,
                            canScrap: canScrap,
                            isOpen: isOpen
                        };
                        dataLoader.updateClipInfo(clipId, options);
                    },
                    submitClipCover: function(index) {
                        var clipId = state.currentVideo.clipId;

                        var options = {
                            isDefault: true
                        };
                        dataLoader.updateClipCover(clipId, options, index);
                    },
                    selectTab: function(targetId) {
                        if (targetId) {
                            dt.classList.remove(this.activateTab.parentNode, 'on');

                            var selectedTab = $$('a[href="#' + targetId + '"]')[0];
                            dt.classList.add(selectedTab.parentNode, 'on');

                            this.activateTab = selectedTab;
                        }
                    },
                    togglePanel: function(target) {
                        if ($(target) === EL.CLIP_INFO_PANEL) {
                            this.showClipInfo();
                        }

                        if ($(target) === EL.CLIP_COVER_PANEL) {
                            this.showClipCover();
                        }
                    }
                },
                screen: {
                    showWide: function() {
                        if (EL.WIDE_SCREEN_BUTTON) {
                            dt.classList.remove(EL.WIDE_SCREEN_BUTTON, 'hide');
                        }
                    },
                    hideWide: function() {
                        if (EL.WIDE_SCREEN_BUTTON) {
                            dt.classList.add(EL.WIDE_SCREEN_BUTTON, 'hide');
                        }
                    }
                },
                popup: {
                    el: EL.POPUP_BUTTON,
                    show: function() {
                        dt.classList.remove(EL.POPUP_BUTTON, 'hide');
                    },
                    hide: function() {
                        dt.classList.add(EL.POPUP_BUTTON, 'hide');
                    }
                },
                subtitle: {
                    el: EL.SUBTITLE_BOX,
                    template: playerTemplate.pc_subtitle_list,
                    create: function(textTracks) {
                        var view = {
                            textTracks: []
                        };

                        textTracks.forEach(function(v) {
                            var isoCode = v.language.substr(0, 2);
                            if (window.ISO6391.getNativeName(isoCode)) {
                                view.textTracks.push({
                                    subtitle: v.language,
                                    subtitleText: window.ISO6391.getNativeName(isoCode)
                                });
                            }
                        });

                        if (view.textTracks.length > 0) {
                            EL.SUBTITLE_LIST.innerHTML = this.template.render(view);
                            customUI.control.setting.showSubtitleButton();
                        }
                    },
                    showList: function() {
                        if (this.el) {
                            dt.classList.add(this.el, 'open');
                        }
                    },
                    hideList: function() {
                        if (this.el) {
                            dt.classList.remove(this.el, 'open');
                        }
                    },
                    setSubtitleText: function(subtitle) {
                        var preSubtitleElement = $$('.list_subtitles .on', this.el)[0];
                        var el = $$('[data-subtitle="' + subtitle + '"]', this.el)[0];

                        if (preSubtitleElement) {
                            dt.classList.remove(preSubtitleElement, 'on');
                        }

                        if (el) {
                            dt.classList.add(el.parentElement, 'on');
                        }

                        if (EL.SUBTITLE_TEXT) {
                            EL.SUBTITLE_TEXT.innerText =
                                subtitle === constants.SUBTITLE.STATUS.OFF
                                    ? '사용안함'
                                    : window.ISO6391.getNativeName(subtitle);
                        }
                    }
                },
                speed: {
                    el: EL.SPEED_BOX,
                    showList: function() {
                        if (this.el) {
                            dt.classList.add(this.el, 'open');
                        }
                    },
                    hideList: function() {
                        if (this.el) {
                            dt.classList.remove(this.el, 'open');
                        }
                    },
                    setSpeedText: function(speed) {
                        if (this.el) {
                            var preSpeedElement = $$('.list_playspeed .on', this.el)[0];
                            var el = $$('[data-speed="' + speed + '"]', this.el)[0];

                            if (preSpeedElement) {
                                dt.classList.remove(preSpeedElement, 'on');
                            }

                            if (el) {
                                dt.classList.add(el.parentElement, 'on');
                            }
                        }

                        if (EL.SPEED_TEXT) {
                            if (parseFloat(speed) === DEFAULT_SPEED) {
                                speed = '보통';
                            }
                            EL.SPEED_TEXT.innerText = speed;
                        }
                    }
                },
                keyboard: {
                    el: EL.KEYBOARD_EFFECT,
                    timer: null,
                    type: null,
                    template: playerTemplate.keyboard_effect_text,
                    setup: function(type, text) {
                        dt.classList.remove(this.el, this.type);
                        dt.classList.add(this.el, type);

                        if (text) {
                            if (type === KEYBOARD_TYPE.SPEED_UP || type === KEYBOARD_TYPE.SPEED_DOWN) {
                                this.el.innerHTML = this.template.render({ className: 'speed_txt', effectText: text });
                            } else if (type === KEYBOARD_TYPE.VOLUME_UP || type === KEYBOARD_TYPE.VOLUME_DOWN) {
                                this.el.innerHTML = this.template.render({ className: 'volume_txt', effectText: text });
                            } else {
                                this.el.innerHTML = text;
                            }
                        } else {
                            this.el.innerHTML = '';
                        }

                        this.type = type;
                    },
                    show: function() {
                        var self = this;
                        if (!this.timer) {
                            dt.classList.remove(this.el, 'hide');

                            this.timer = setTimeout(function() {
                                self.timer = null;
                                self.hide();
                            }, 500);
                        }
                    },
                    hide: function() {
                        dt.classList.add(this.el, 'hide');
                    }
                },
                tv: {
                    showMirroringText: function() {
                        if (EL.MIRRORING_TEXT) {
                            dt.classList.remove(EL.MIRRORING_TEXT, 'hide');
                        }
                    },
                    hideMirroringText: function() {
                        if (EL.MIRRORING_TEXT) {
                            dt.classList.add(EL.MIRRORING_TEXT, 'hide');
                        }
                    }
                },
                install: {
                    template: playerTemplate.install_agent,
                    setupView: function(profile) {
                        if (EL.ALERT_LIVEAGENT) {
                            EL.ALERT_LIVEAGENT.innerHTML = this.template.render({
                                installExt: player.isInstalledExtension(),
                                profile: profile,
                                isChromePC: ua.platform === 'pc' && ua.browser.chrome
                            });
                        }
                    }
                }
            }
        };

        var control = customUI.control;
        var existRelatedTimer = null;

        function setVolume(volume, muteOn) {
            inline.setVolume(volume, muteOn);
            updateVolumeUI(volume);
        }

        function toggleMuteUI(volume, muteOn) {
            muteVolumeUI(muteOn);
            updateVolumeUI(muteOn ? 0 : volume);
        }

        function muteVolumeUI(muteOn) {
            control.volume.mute(muteOn);
        }

        function updateVolumeUI(volume) {
            control.volume.update(volume);
        }

        function updateVolume(rate) {
            var volume = (rate / 100).toFixed(2);
            var muteOn = checkMuteRange(rate);

            debug.info('updateVolume', volume, muteOn);
            setVolume(volume, muteOn);
        }

        function initVolumeControl() {
            var muteOn = inline.getRecentMute();
            var volume = muteOn ? 0 : getRecentVolume();
            setVolume(volume, muteOn);
        }

        function getRecentVolume() {
            return inline.getRecentVolume();
        }

        function setRecentVolume(volume) {
            inline.setRecentVolume(volume);
        }

        function initModifyButton() {
            var isOwner = state.currentVideo.owner;
            var isLive = state.currentVideo.type === constants.VIDEO_TYPE.LIVE;

            if (isOwner && !isLive) {
                dt.classList.remove(EL.MODIFY_BUTTON, 'hide');
            } else {
                dt.classList.add(EL.MODIFY_BUTTON, 'hide');
            }
        }

        function createProfileList() {
            var outputList = state.currentVideo.outputList;

            if (outputList && outputList.length > 0) {
                control.profile.create(outputList);
            }
        }

        function createSubtitle() {
            var textTracks = player.getTextTracks();

            if (textTracks.length > 0) {
                control.subtitle.create(textTracks);
            }
        }

        function setClipInfoAndCover() {
            var thumbnailList = state.currentVideo.thumbnailList;
            if (thumbnailList && thumbnailList.length > 0) {
                control.menu.setClipCover(thumbnailList);
            }
            control.menu.setClipInfo();
        }

        function setProfileLabel(label) {
            EL.QUALITY_BUTTON.setAttribute('data-label-temp', label);
        }

        function checkRectSize(rect) {
            if (rect.height < 1) {
                var resizeRect = {};
                for (var o in rect) {
                    if (rect.hasOwnProperty(o)) {
                        resizeRect[o] = rect[o] * 100;
                    }
                }
                return resizeRect;
            }
            return rect;
        }

        function getVolumeRate(e) {
            var rect = EL.VOLUMEBAR_BG.getBoundingClientRect();
            if (inline.isFullScreen()) {
                rect = checkRectSize(rect);
            }

            var pageX = e.pageX;
            var offsetLeft = Math.floor(rect.left);
            var offsetX = pageX && pageX - offsetLeft;
            var offsetWidth = rect.width;
            var rate = 0;

            if (offsetX > offsetWidth) {
                rate = 100;
            }

            if (offsetX >= 0 && offsetX <= offsetWidth) {
                rate = (offsetX / offsetWidth) * 100;
            }

            return rate;
        }

        function checkMuteRange(rate) {
            return rate < 10;
        }

        function onTouchMoveVolume(e) {
            var rate = getVolumeRate(e);
            updateVolume(rate);

            state.volumeChanging = true;
            inline.clearTimer();
        }

        function onTouchEndVolume(e) {
            var rate = getVolumeRate(e);
            var muteOn = checkMuteRange(rate);

            updateVolume(rate);
            setRecentVolume(player.getVolume());
            inline.saveRecentMute(muteOn);

            state.volumeChanging = false;

            pctTracker.track('volume', parseInt(rate));
        }

        function applyParameters() {
            if (!env.isInternal || env.popup) {
                control.setting.hideAutoPlay();
                control.screen.hideWide();
            }

            if (env.popup) {
                control.popup.hide();
                control.screen.hideWide();
            }
        }

        function existRelatedClip() {
            existRelatedTimer = setTimeout(function() {
                var isfreeze = true;
                inline.showControl(isfreeze);
                inline.resizeControl();
                showCompletion();
            }, 300);
        }

        function showCompletion() {
            exports.queue.emit('show:completion');
        }

        function openSettingBox() {
            control.setting.show();
            state.isSettingMenuOpened = true;
            dt.classList.add(EL.SETTING_BUTTON, 'open');
        }

        function closeSettingBox() {
            control.setting.hide();
            control.speed.hideList();
            control.subtitle.hideList();
            state.isSettingMenuOpened = false;
            dt.classList.remove(EL.SETTING_BUTTON, 'open');
        }

        function openChartBox() {
            analytics.chartShow();
            if (EL.CHART_BOX) {
                dt.classList.add(EL.CHART_BOX, 'open');
            }
        }

        function closeChartBox() {
            analytics.chartHide();
            if (EL.CHART_BOX) {
                dt.classList.remove(EL.CHART_BOX, 'open');
            }
        }

        function closeMenuBox() {
            control.profile.hideList();
            closeSettingBox();
        }

        function togglePlayback() {
            var isPaused = player.isPaused();
            if (!state.isContextMenuOpened && !state.isSettingMenuOpened) {
                if (isPaused) {
                    if (state.needMidrollRequest) {
                        state.needMidrollRequest = false;
                        exports.queue.emit('ad:checkMidrollAd');
                    }

                    player.play();
                } else {
                    player.pause();
                }

                togglePlayPause(isPaused);
                control.playback.show();
                pctTracker.track('play_pause');
            }

            if (state.isContextMenuOpened) {
                contextMenu.hide();
            }

            if (state.isSettingMenuOpened) {
                closeMenuBox();
            }
        }

        function togglePlayPause(isPaused) {
            if (isPaused) {
                if (!state.ended) {
                    EL.CONTROLLER_PLAY_BUTTON_TEXT.innerHTML = '일시정지';
                    dt.classList.remove(EL.CONTROLLER_PLAY_BUTTON, 'link_play');
                    dt.classList.add(EL.CONTROLLER_PLAY_BUTTON, 'link_pause');
                    dt.classList.add(EL.REPLAY_BUTTON, 'hidden');
                } else {
                    dt.classList.add(EL.PLAY_BUTTON, 'hidden');
                    dt.classList.remove(EL.REPLAY_BUTTON, 'hidden');
                }
            } else {
                EL.CONTROLLER_PLAY_BUTTON_TEXT.innerHTML = '재생하기';
                dt.classList.add(EL.CONTROLLER_PLAY_BUTTON, 'link_play');
                dt.classList.remove(EL.CONTROLLER_PLAY_BUTTON, 'link_pause');
                dt.classList.add(EL.REPLAY_BUTTON, 'hidden');
            }
        }

        function toggleFullScreen() {
            if (inline.isFullScreen()) {
                inline.cancelFullscreen();
            } else {
                inline.requestFullscreen();
            }
        }

        function setStillImage() {
            var thumbnailList = state.currentVideo.thumbnailList;
            if (thumbnailList && thumbnailList.length > 0) {
                control.stillImage.create(thumbnailList);
            }
            showStillImage();
        }

        function showStillImage() {
            control.stillImage.show();
        }

        function hideStillImage() {
            control.stillImage.hide();
        }

        function setStillVideo(seekUrl) {
            inline.setStillVideo(seekUrl, function() {
                showStillVideo();
            });
        }

        function showStillVideo() {
            inline.showStillVideo();
        }

        function hideStillVideo() {
            inline.hideStillVideo();
        }

        function setSeekThumbnail() {
            var video = state.currentVideo;
            var seekUrl = video.seekUrl;
            if (seekUrl) {
                hideStillImage();
                setStillVideo(seekUrl);
            } else {
                hideStillVideo();
                setStillImage(seekUrl);
            }
        }

        function getWidthOutOfRange(boxElement) {
            if (!boxElement) {
                return;
            }

            var buttonRect = EL.SETTING_BUTTON.getBoundingClientRect();
            var playerRect = EL.PLAYER_CONTAINER.getBoundingClientRect();
            var boxRect = boxElement.getBoundingClientRect();
            var playerMarginRight = 15;

            var buttonCenter = buttonRect.right - buttonRect.width / 2;
            var maxWidth = playerRect.width - playerMarginRight;

            return maxWidth - buttonCenter - boxRect.width / 2;
        }

        function moveSettingBox() {
            var settingBoxMarginLeft = -86;
            var qualityBoxMarginLeft = -43;
            var speedBoxMarginLeft = -43;
            var overOuterHalfWidth = (window.outerWidth - player.videoElement.clientWidth) / 2;
            var settingBoxOverWidth = getWidthOutOfRange(EL.SETTING_BOX) + overOuterHalfWidth;
            var qualityBoxOverWidth = getWidthOutOfRange(EL.QUALITY_BOX) + overOuterHalfWidth;
            var speedBoxOverWidth = getWidthOutOfRange(EL.SPEED_BOX) + overOuterHalfWidth;
            var isOutOfRange = settingBoxOverWidth < 0;

            if (isOutOfRange) {
                EL.SETTING_BOX.style.marginLeft = settingBoxMarginLeft + settingBoxOverWidth + 'px';
                EL.QUALITY_BOX.style.marginLeft = qualityBoxMarginLeft + qualityBoxOverWidth + 'px';
                EL.SPEED_BOX.style.marginLeft = speedBoxMarginLeft + speedBoxOverWidth + 'px';
            } else {
                EL.SETTING_BOX.style.marginLeft = settingBoxMarginLeft + 'px';
                EL.QUALITY_BOX.style.marginLeft = qualityBoxMarginLeft + 'px';
                EL.SPEED_BOX.style.marginLeft = speedBoxMarginLeft + 'px';
            }
        }

        function setSpeed(speed) {
            state.playbackRate = player.setPlaybackRate(parseFloat(speed));
            control.speed.setSpeedText(speed);
        }

        function resetSpeed() {
            setSpeed(DEFAULT_SPEED);
        }

        function setSubtitle(subtitle) {
            var selectTrack = null;
            player.getTextTracks().forEach(function(v) {
                if (v.language === subtitle) {
                    selectTrack = v;
                }
            });

            if (selectTrack || subtitle === 'off') {
                player.setTextTrack(subtitle);
                control.subtitle.setSubtitleText(subtitle);
            }
        }

        function isMiniPlayer() {
            var playerWidth = document.documentElement.clientWidth;

            return playerWidth <= MINI_PLAYER_MAX_WIDTH;
        }

        function isSeekable() {
            return queue.front.type === constants.VIDEO_TYPE.VOD && !state.modalContentActivated;
        }

        var listener = {
            viewEvent: function() {
                var menu = control.menu;

                if (ua.platform === 'pc') {
                    event.on(
                        window,
                        'resize',
                        helpers.waiter.throttle(function() {
                            if (isMiniPlayer()) {
                                exports.queue.emit('hide:modal');

                                if (env.isPrivateIp) {
                                    closeChartBox();
                                    contextMenu.videoChartToggle();
                                }
                            }
                        }, 100)
                    );

                    event.on(EL.CONTROLLER_BODY, 'click', function() {
                        togglePlayback();
                    });

                    event.on(EL.SOUND_CONTROL, 'mouseover', function() {
                        if (!state.seeking) {
                            control.volume.show();
                        }
                    });

                    event.on(EL.SOUND_CONTROL, 'mouseout', function() {
                        if (!state.volumeChanging) {
                            control.volume.hide();
                        }
                    });

                    event.on(EL.MUTE_BUTTON, 'click', function() {
                        var muteOn = player.getMute();
                        var volume = !muteOn ? 0 : getRecentVolume();

                        if (muteOn) {
                            player.setVolume(volume);
                            exports.queue.emit('reset:env:mute');
                        }

                        toggleMuteUI(volume, !muteOn);
                        player.setMute(!muteOn);
                        inline.saveRecentMute(!muteOn);

                        inline.clearTimer();
                        pctTracker.track('mute', (!muteOn).toString());
                    });

                    event.delegate(EL.QUALITY_LIST, 'button', 'click', function(e) {
                        var buttonEl, profile, label, preQualityElement;
                        var isOnTv = helpers.tv.isOnTv(player.videoElement);

                        closeMenuBox();

                        buttonEl = e.target.tagName !== 'SUP' ? e.target : e.target.parentElement;
                        profile = buttonEl.getAttribute('data-profile');
                        preQualityElement = $$('.list_quality .on')[0];
                        label = buttonEl.innerText;

                        if (profile === state.currentVideo.profile) {
                            return;
                        }

                        if (state.dash && !isOnTv) {
                            state.currentVideo.profile = profile;
                            shaka.setTrack(profile);
                            control.profile.updateLabel(label);
                            if (state.ended) {
                                player.seekTo(0);
                            }
                        } else {
                            setProfileLabel(label);
                            if (state.ended) {
                                exports.queue.emit('loadAndPlay:videoById', state.currentVideo.id, profile);
                            } else {
                                if (queue.front.type === constants.VIDEO_TYPE.VOD) {
                                    inline.pauseNonLinearAd();
                                    inline.getClipLocation(profile);
                                } else {
                                    state.currentVideo.contentType = constants.CONTENT_TYPE.HLS;

                                    if (profile !== constants.PROFILE.BASE && profile !== constants.PROFILE.LOW) {
                                        if (player.isInstalledLiveAgent()) {
                                            state.currentVideo.contentType = constants.CONTENT_TYPE.NPP;
                                        } else {
                                            exports.queue.emit('show:error', {
                                                info: {
                                                    code: constants.ERROR.STATUS.LiveAgentNotInstalled.NAME,
                                                    profile: profile
                                                }
                                            });
                                            return;
                                        }
                                    }

                                    inline.startSpinner();
                                    inline.getLiveLocation(profile);
                                }
                            }
                        }

                        if (profile !== constants.PROFILE.AUTO) {
                            helpers.store.set(PROFILE_KEY, state.dash ? constants.DASH_PROFILE[profile] : profile);
                        }

                        if (preQualityElement) {
                            dt.classList.remove(preQualityElement, 'on');
                        }
                        dt.classList.add(buttonEl.parentElement, 'on');

                        pvtTracker.pause();
                        pctTracker.track('profile', state.dash ? constants.DASH_PROFILE[profile] : profile);
                    });

                    event.on(EL.SETTING_BUTTON, 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        moveSettingBox();

                        var isOpened = dt.classList.has(EL.SETUP_BOX, 'open') || dt.classList.has(EL.SPEED_BOX, 'open');

                        if (isOpened) {
                            closeSettingBox();
                        } else {
                            control.profile.hideList();
                            openSettingBox();
                        }

                        pctTracker.track('setting');
                    });

                    event.on(EL.CONTROLLER_BODY, 'dblclick', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        if (inline.isFullScreenSupport()) {
                            toggleFullScreen();
                        }
                    });

                    event.delegate(EL.PLAYER_FUNCTION, '.btn_chart', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        var isOpened = dt.classList.has(EL.CHART_BOX, 'open') || dt.classList.has(EL.CHART_BOX, 'open');

                        if (isOpened) {
                            closeChartBox();
                        } else {
                            openChartBox();
                        }

                        helpers.store.set(constants.STORAGE.CHART, !isOpened);

                        contextMenu.videoChartToggle();
                        pctTracker.track('chart', isOpened ? 'off' : 'on');
                    });

                    event.delegate(EL.PLAYER_FUNCTION, '.btn_wide', 'click', function() {
                        debug.log('click wide screen button');
                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onWideScreenChange);
                        pctTracker.track('wide_screen');
                    });

                    event.delegate(EL.PLAYER_FUNCTION, '.btn_popup', 'click', function() {
                        var pathname = window.location.pathname;
                        var search = window.location.search;

                        search = helpers.url.setParameter(search, 'popup', '1');
                        search = helpers.url.setParameter(search, 'autoplay', '1');

                        var url = pathname + search;
                        var features =
                            'width=720, height=427, left=0, top=0,' +
                            'location=no, toolbar=no, menubar=no, scrollbars=no, status=no, resizable=yes';

                        inline.openPopup(url, 'popupModePlayerWindow', features);
                        player.pause();
                        pctTracker.track('popup_player');
                    });

                    event.delegate(EL.SETTING_BOX, '.clip_modify', 'click', function() {
                        var callback = null;
                        var isfreeze = false;

                        exports.queue.emit('hide:completion');

                        if (state.ended) {
                            isfreeze = true;
                            inline.showControl(isfreeze);

                            callback = function() {
                                showCompletion();
                                inline.showControl(isfreeze);
                            };
                        } else {
                            inline.hideActivatedControl();
                        }

                        control.menu.setClipInfo();
                        control.menu.setClipCover(state.currentVideo.thumbnailList);

                        exports.queue.emit('show:modal', {
                            target: 'clipInfoModify',
                            callback: callback
                        });

                        closeSettingBox();
                    });

                    event.delegate(EL.SETUP_BOX, '.btn_quality', 'click', function() {
                        control.setting.hide();
                        control.profile.showList();

                        pctTracker.track('profile');
                    });

                    event.delegate(EL.QUALITY_BOX, '.tit_quality', 'click', function() {
                        control.profile.hideList();
                        openSettingBox();
                    });

                    event.delegate(EL.SETUP_BOX, '.btn_langsubtitles', 'click', function() {
                        control.setting.hide();
                        control.subtitle.showList();

                        pctTracker.track('subtitle');
                    });

                    event.delegate(EL.SETUP_BOX, '.tit_subtitles', 'click', function() {
                        control.subtitle.hideList();
                        openSettingBox();
                    });

                    event.delegate(EL.SETUP_BOX, '.list_subtitles', 'click', function(e) {
                        var buttonEl = e.target;
                        var subtitle = buttonEl.getAttribute('data-subtitle');
                        helpers.store.set(SUBTITLE_KEY, subtitle);

                        if (!dt.classList.has(buttonEl.parentElement, 'on')) {
                            setSubtitle(subtitle);
                        }

                        control.subtitle.hideList();

                        openSettingBox();

                        pctTracker.track('subtitle', subtitle);
                    });

                    event.delegate(EL.SETUP_BOX, '.btn_playspeed', 'click', function() {
                        control.setting.hide();
                        control.speed.showList();

                        pctTracker.track('speed');
                    });

                    event.delegate(EL.SETUP_BOX, '.tit_playspeed', 'click', function() {
                        control.speed.hideList();
                        openSettingBox();
                    });

                    event.delegate(EL.SETUP_BOX, '.list_playspeed', 'click', function(e) {
                        var buttonEl = e.target;
                        var speed = buttonEl.getAttribute('data-speed');

                        setSpeed(speed);
                        control.speed.hideList();

                        openSettingBox();

                        pctTracker.track('speed', speed);
                    });

                    event.delegate(EL.CONTROLLER, '#stillImage', 'mouseover', function() {
                        var video = queue.front;

                        if (
                            state.ended ||
                            state.seeking ||
                            player.isPaused() ||
                            state.hasStillVideo ||
                            (video && video.type !== constants.VIDEO_TYPE.VOD)
                        ) {
                            return;
                        }
                        control.stillImage.on();
                    });

                    event.delegate(EL.CONTROLLER, '#stillImage', 'mouseout', function() {
                        if (!state.ended) {
                            control.stillImage.off();
                        }
                    });

                    event.delegate(EL.CONTROLLER, '.link_section', 'click', function(e) {
                        if (!state.ended) {
                            var target = e.target;

                            if (target.tagName === 'A' || target.tagName === 'IMG' || target.tagName === 'SPAN') {
                                event.preventDefault(e);
                                event.stopPropagation(e);

                                if (target.parentNode && target.parentNode.tagName === 'A') {
                                    target = target.parentNode;
                                }

                                var sec = target.getAttribute('data-time');
                                player.seekTo(parseInt(sec, 10));
                                pctTracker.track('still_image');
                            }
                            control.stillImage.off();
                        }
                    });

                    event.delegate(EL.CLIP_INFO_MODIFY, '.link_share', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        var current = e.target;
                        var target = current.href.split('#')[1];

                        menu.selectTab(target);
                        menu.togglePanel(target);
                    });

                    event.delegate(EL.CLIP_INFO_MODIFY, '.link_cover', 'click', function(e) {
                        var target = e.target;

                        if (target.tagName === 'A' || target.tagName === 'IMG') {
                            event.preventDefault(e);
                            event.stopPropagation(e);

                            if (target.parentNode && target.parentNode.tagName === 'A') {
                                target = target.parentNode;
                            }

                            dt.classListAll.remove($$('li', EL.CLIP_COVER_PANEL), 'on');
                            dt.classList.add(target.parentNode, 'on');

                            $('thumnailIndex').value = target.getAttribute('data-thumbnail-index');
                        }
                    });

                    event.delegate(EL.CLIP_INFO_PANEL, '.btn_edit', 'click', function() {
                        var lblName = $('lblName');

                        if (lblName.value === '') {
                            alert('동영상 제목을 입력해 주세요.');
                            lblName.focus();
                            return;
                        }

                        if (lblName.length >= 30) {
                            alert('동영상 제목은 20자내에서 입력해 주세요.');
                            lblName.focus();
                            return;
                        }

                        menu.submitClipInfo();
                    });

                    event.delegate(EL.CLIP_COVER_PANEL, '.btn_edit', 'click', function() {
                        var index = $('thumnailIndex').value;
                        menu.submitClipCover(index);
                    });

                    event.delegate(EL.CONTROLLER, 'autoPlay', 'click', function(e) {
                        var isAutoPlay = e.target.checked;
                        state.autoplay = isAutoPlay;

                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onChangeAutoPlayMode, [
                            isAutoPlay
                        ]);
                    });
                }
            },
            customEvent: function(sandbox) {
                sandbox.on('hide:customUI', function() {
                    closeSettingBox();
                    control.profile.hideList();
                    if (control.stillImage.el) {
                        control.stillImage.off();
                    }
                    control.volume.hide();
                    dt.classList.remove(EL.SETTING_BUTTON, 'open');
                });

                sandbox.on('update:clipinfo', function(data) {
                    var message = '';

                    if (data.status === 'success') {
                        message = '동영상의 정보 수정이 완료되었습니다.';

                        state.currentVideo.title = data.result.title;
                        state.currentVideo.canScrap = data.result.canScrap;
                        state.currentVideo.isOpen = data.result.isOpen;
                    } else {
                        message = '동영상의 정보 수정 중 오류가 발생하였습니다.';
                    }

                    exports.queue.emit('hide:modal', {
                        callback: function() {
                            var callback = function() {
                                inline.hideBlind();

                                if (state.ended) {
                                    showCompletion();
                                    inline.showControl(true);
                                }
                            };
                            inline.showNotification(message, callback);
                        }
                    });
                });

                sandbox.on('update:clipcover', function(data) {
                    var message = '';

                    if (data.status === 'success') {
                        message = '동영상의 대표이미지 수정이 완료되었습니다.';

                        var index = data.index;
                        var thumbnailList = state.currentVideo.thumbnailList;

                        for (var i = 0; i < thumbnailList.length; i++) {
                            thumbnailList[i].isDefault = false;
                        }
                        thumbnailList[index] = data.result;

                        state.currentVideo.thumbnailList = thumbnailList;
                    } else {
                        message = '동영상의 대표이미지 수정 중 오류가 발생하였습니다.';
                    }

                    exports.queue.emit('hide:modal', {
                        callback: function() {
                            var callback = function() {
                                inline.hideBlind();

                                if (state.ended) {
                                    showCompletion();
                                    inline.showControl(true);
                                }
                            };
                            inline.showNotification(message, callback);
                        }
                    });
                });

                sandbox.on('close:menubox', function() {
                    closeMenuBox();
                });

                sandbox.on('close:settingbox', function() {
                    closeSettingBox();
                });

                sandbox.on('analytics:chart', function(isShow) {
                    if (!isShow) {
                        openChartBox();
                    } else {
                        closeChartBox();
                    }
                    contextMenu.videoChartToggle();
                });
            },
            gestureEvent: function() {
                var volumeListener = window.gesture.GestureListener(EL.VOLUME);

                volumeListener.onGestureMove(function(session) {
                    onTouchMoveVolume(session.targetEvent);
                });

                volumeListener.onGestureEnd(function(session) {
                    onTouchEndVolume(session.targetEvent);
                });
            }
        };

        function InlinePC() {}

        InlinePC.prototype.init = function(initPlayer, sandbox) {
            if (ua.platform === 'pc') {
                applyParameters();

                listener.viewEvent();
                listener.customEvent(sandbox);
                listener.gestureEvent();

                keyboardAddOn.initWithConfig({
                    keydownCallback: {
                        up: function() {
                            if (!queue.front) {
                                return;
                            }

                            if (!state.seeking) {
                                inline.showControl(player.isPaused());
                                control.volume.show();
                            }
                            var volume = parseFloat(getRecentVolume()) + 0.1;
                            var newVolume = volume > 1.0 ? 1.0 : volume;
                            var newVolumePercentage = newVolume * 100;
                            var muteOn = checkMuteRange(newVolumePercentage);

                            updateVolume(newVolumePercentage);
                            setRecentVolume(newVolume);
                            inline.saveRecentMute(muteOn);

                            control.keyboard.setup(KEYBOARD_TYPE.VOLUME_UP, newVolumePercentage.toFixed(0) + '%');
                            control.keyboard.show();
                        },
                        down: function() {
                            if (!queue.front) {
                                return;
                            }

                            if (!state.seeking) {
                                inline.showControl(player.isPaused());
                                control.volume.show();
                            }

                            var volume = parseFloat(getRecentVolume()) - 0.1;
                            var newVolume = volume < 0.0 ? 0.0 : volume;
                            var newVolumePercentage = newVolume * 100;
                            var muteOn = checkMuteRange(newVolumePercentage);

                            updateVolume(newVolumePercentage);
                            setRecentVolume(newVolume);
                            inline.saveRecentMute(muteOn);

                            control.keyboard.setup(
                                newVolume === 0 ? KEYBOARD_TYPE.VOLUME_MUTE : KEYBOARD_TYPE.VOLUME_DOWN,
                                newVolumePercentage.toFixed(0) + '%'
                            );
                            control.keyboard.show();
                        },
                        left: function(keyDownCount) {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                if (!isSeekable()) {
                                    return;
                                }
                                state.pausedBeforeSeek = state.ended ? false : player.isPaused();

                                if (keyDownCount < 1) {
                                    state.mutedBeforeSeek = player.getMute();
                                }

                                var currentTime = player.getCurrentTimeRound() - 5;
                                if (currentTime < 0) {
                                    return;
                                }
                                player.setMute(true);
                                player.seekTo(currentTime);
                                inline.showControl(player.isPaused());
                                control.keyboard.setup(KEYBOARD_TYPE.BACK_5S);
                                control.keyboard.show();
                            }
                        },
                        right: function(keyDownCount) {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                if (!isSeekable()) {
                                    return;
                                }
                                state.pausedBeforeSeek = state.ended ? false : player.isPaused();

                                if (keyDownCount < 1) {
                                    state.mutedBeforeSeek = player.getMute();
                                }

                                var currentTime = player.getCurrentTimeRound() + 5;
                                if (currentTime > player.getDurationRound()) {
                                    return;
                                }
                                player.setMute(true);
                                player.seekTo(currentTime);
                                inline.showControl(player.isPaused());
                                control.keyboard.setup(KEYBOARD_TYPE.FRONT_5S);
                                control.keyboard.show();
                            }
                        },
                        space: function() {
                            var currentVideo = state.currentVideo;
                            var frontVideo = queue.front;

                            if (state.ended) {
                                exports.queue.emit('loadAndPlay:videoById', currentVideo.id, currentVideo.profile);
                                return;
                            }

                            if (frontVideo && frontVideo.type === constants.VIDEO_TYPE.AD) {
                                togglePlayback();
                                return;
                            }

                            if (state.isFirstPlay) {
                                if (currentVideo.type !== constants.VIDEO_TYPE.VOD) {
                                    exports.queue.emit('play:vod', currentVideo.profile);
                                } else if (currentVideo.type !== constants.VIDEO_TYPE.LIVE) {
                                    exports.queue.emit('play:live', currentVideo.profile);
                                }
                            } else {
                                togglePlayback();
                            }
                        },
                        z: function() {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                var speed = player.setPlaybackRate(DEFAULT_SPEED, false);
                                control.speed.setSpeedText(speed);
                                state.playbackRate = speed;
                            }
                        },
                        comma: function() {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                var speed = player.setPlaybackRate(-0.25, true);
                                control.speed.setSpeedText(speed);
                                state.playbackRate = speed;

                                inline.showControl(player.isPaused());
                                control.keyboard.setup(KEYBOARD_TYPE.SPEED_UP, speed.toString());
                                control.keyboard.show();
                            }
                        },
                        period: function() {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                var speed = player.setPlaybackRate(0.25, true);
                                control.speed.setSpeedText(speed);
                                state.playbackRate = speed;

                                inline.showControl(player.isPaused());
                                control.keyboard.setup(KEYBOARD_TYPE.SPEED_DOWN, speed.toString());
                                control.keyboard.show();
                            }
                        },
                        pageUp: function(keyDownCount) {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                if (queue.front.type === constants.VIDEO_TYPE.VOD) {
                                    state.pausedBeforeSeek = state.ended ? false : player.isPaused();

                                    if (keyDownCount < 1) {
                                        state.mutedBeforeSeek = player.getMute();
                                    }

                                    var currentTime = player.getCurrentTimeRound() + 60;
                                    if (currentTime > player.getDurationRound()) {
                                        currentTime = player.getDurationRound();
                                        state.ended = true;
                                    }
                                    player.setMute(true);
                                    player.seekTo(currentTime);
                                    inline.showControl(player.isPaused());
                                    control.keyboard.setup(KEYBOARD_TYPE.FRONT_60S);
                                    control.keyboard.show();
                                }
                            }
                        },
                        pageDown: function(keyDownCount) {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                if (queue.front.type === constants.VIDEO_TYPE.VOD) {
                                    state.pausedBeforeSeek = state.ended ? false : player.isPaused();

                                    if (keyDownCount < 1) {
                                        state.mutedBeforeSeek = player.getMute();
                                    }

                                    var currentTime = player.getCurrentTimeRound() - 60;
                                    if (currentTime < 0) {
                                        currentTime = 0;
                                    }
                                    player.setMute(true);
                                    player.seekTo(currentTime);
                                    inline.showControl(player.isPaused());
                                    inline.onSeeked();
                                    control.keyboard.setup(KEYBOARD_TYPE.BACK_60S);
                                    control.keyboard.show();
                                }
                            }
                        },
                        end: function() {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                var currentTime = player.getDurationRound();
                                state.ended = true;

                                player.seekTo(currentTime);
                                inline.showControl(player.isPaused());
                                inline.onSeeked();
                            }
                        },
                        home: function() {
                            if (queue.front && queue.front.type === constants.VIDEO_TYPE.VOD) {
                                state.pausedBeforeSeek = state.ended ? false : player.isPaused();
                                var currentTime = 0;
                                player.seekTo(currentTime);
                                inline.showControl(player.isPaused());
                            }
                        },
                        tab: function() {
                            if (!queue.front) {
                                return;
                            }

                            if (player.videoElement.src !== '' && !state.modalContentActivated && !state.ended) {
                                inline.showControl(player.isPaused());
                            }
                        },
                        esc: function() {
                            if (!queue.front) {
                                return;
                            }

                            if (state.modalContentActivated) {
                                exports.queue.emit('hide:modal');
                            }
                            if (state.isSettingMenuOpened) {
                                closeMenuBox();
                            }
                            if (state.isContextMenuOpened) {
                                contextMenu.hide();
                            }
                        }
                    },
                    keyupCallback: {
                        up: function() {
                            pctTracker.track('keyboard', 'volume_up');
                        },
                        down: function() {
                            pctTracker.track('keyboard', 'volume_down');
                        },
                        left: function() {
                            pctTracker.track('keyboard', 'prev');
                        },
                        right: function() {
                            pctTracker.track('keyboard', 'next');
                        },
                        space: function() {
                            pctTracker.track('keyboard', !player.isPaused() ? 'play' : 'pause');
                        },
                        z: function() {
                            pctTracker.track('keyboard', 'z');
                            pctTracker.track('speed', player.getPlaybackRate());
                        },
                        comma: function() {
                            pctTracker.track('keyboard', '<');
                            pctTracker.track('speed', player.getPlaybackRate());
                        },
                        period: function() {
                            pctTracker.track('keyboard', '>');
                            pctTracker.track('speed', player.getPlaybackRate());
                        },
                        pageUp: function() {
                            pctTracker.track('keyboard', 'pageUp');
                        },
                        pageDown: function() {
                            pctTracker.track('keyboard', 'pageDown');
                        },
                        home: function() {
                            pctTracker.track('keyboard', 'home');
                        },
                        end: function() {
                            pctTracker.track('keyboard', 'end');
                        }
                    }
                });
            }
        };

        InlinePC.prototype.togglePlayPause = function(isPaused) {
            inline.togglePlayPause(isPaused);
            togglePlayPause(isPaused);
        };

        InlinePC.prototype.toggleMuteUI = function(volume, muteOn) {
            toggleMuteUI(volume, muteOn);
        };

        InlinePC.prototype.onEndVideo = function() {
            var video = queue.front;

            if (env.isPrivateIp && video && video.type === constants.VIDEO_TYPE.VOD) {
                closeChartBox();
                contextMenu.videoChartToggle();
                analytics.detailHide();
            }

            if (state.currentVideo.purchase) {
                inline.hideTvod();
                exports.queue.emit('show:error', {
                    info: {
                        checkUrl: state.currentVideo.purchase.purchaseLink,
                        code: constants.CONFIRM.STATUS.NeedPurchased.NAME
                    }
                });
            } else if (video && video.type === constants.VIDEO_TYPE.AD) {
                // 포스트롤 광고가 끝난경우
                if (video.timeOffset === 'start') {
                    return;
                }

                queue.enqueue(state.currentVideo);
                exports.queue.emit('load:videoUrl', state.currentVideo, function() {
                    existRelatedClip();
                });
            } else {
                // 컨텐츠 영상이 끝난경우
                resetSpeed();

                if (env.service === 'daum_ad_brand_search') {
                    var isAutoPlay = false;
                    var startTime = 0;

                    exports.queue.emit('load:videoById', startTime, isAutoPlay);
                } else {
                    if (video.type === 'LIVE') {
                        exports.queue.emit('show:error', {
                            info: {
                                code: constants.ERROR.STATUS.LiveFinished.NAME
                            }
                        });
                    } else {
                        existRelatedClip();
                    }
                }
            }
            inline.hideControlHead();
            control.stillImage.off();
        };

        InlinePC.prototype.changeProfileLabel = function() {
            var label = EL.QUALITY_BUTTON.getAttribute('data-label-temp');
            control.profile.updateLabel(label);
        };

        InlinePC.prototype.setAutoPlay = function(isAutoPlay) {
            state.autoplay = isAutoPlay;
            if (EL.AUTO_PLAY) {
                EL.AUTO_PLAY.checked = isAutoPlay;
            }
        };

        InlinePC.prototype.setWideScreen = function(isWideScreen) {
            if (EL.WIDE_SCREEN_BUTTON) {
                if (isWideScreen) {
                    dt.classList.remove(EL.WIDE_SCREEN_BUTTON, 'btn_cinema');
                    dt.classList.add(EL.WIDE_SCREEN_BUTTON, 'btn_basic');
                    EL.WIDE_SCREEN_BUTTON.setAttribute('aria-label', '기본 모드');
                    EL.WIDE_SCREEN_BUTTON.nextElementSibling.innerHTML = '기본 모드';
                } else {
                    dt.classList.remove(EL.WIDE_SCREEN_BUTTON, 'btn_basic');
                    dt.classList.add(EL.WIDE_SCREEN_BUTTON, 'btn_cinema');
                    EL.WIDE_SCREEN_BUTTON.setAttribute('aria-label', '시네마 모드');
                    EL.WIDE_SCREEN_BUTTON.nextElementSibling.innerHTML = '시네마 모드';
                }
            }
        };

        InlinePC.prototype.setRecentVolume = function(volume) {
            if (volume > 0) {
                setRecentVolume(volume);
            }
        };

        InlinePC.prototype.updateVolumePanel = function(volume) {
            updateVolume(volume * 100);
            if (volume > 0) {
                setRecentVolume(volume);
            }
        };

        InlinePC.prototype.showAutoPlay = function() {
            control.setting.showAutoPlay();
        };

        InlinePC.prototype.hideAutoPlay = function() {
            control.setting.hideAutoPlay();
        };

        InlinePC.prototype.showWide = function() {
            control.screen.showWide();
        };

        InlinePC.prototype.hideWide = function() {
            control.screen.hideWide();
        };

        InlinePC.prototype.hideProfileList = function() {
            control.profile.hideList();
        };

        InlinePC.prototype.closeMenuBox = function() {
            closeMenuBox();
        };

        InlinePC.prototype.onCompleteMeta = function() {
            initModifyButton();
            customUI.control.setting.showDpQualityButton();
            inline.setShowTitle();
            inline.setKakaoTVLink();
            inline.setRatingLevel();
            createProfileList();
        };

        InlinePC.prototype.onLoadStart = function() {
            var video = queue.front;
            if (video.type === constants.VIDEO_TYPE.VOD) {
                setClipInfoAndCover();
                setSeekThumbnail();
            }
            createProfileList();
        };

        InlinePC.prototype.onLoadedData = function() {
            var video = queue.front;
            var storeSubtitle = helpers.store.get(SUBTITLE_KEY);

            if (video.type === constants.VIDEO_TYPE.VOD) {
                createSubtitle();
                if (storeSubtitle) {
                    setSubtitle(storeSubtitle);
                }
            }
        };

        InlinePC.prototype.clearRelatedTimer = function() {
            if (existRelatedTimer !== null) {
                clearTimeout(existRelatedTimer);
            }
        };

        InlinePC.prototype.resetSpeed = function() {
            resetSpeed();
        };

        InlinePC.prototype.hideMenuOnCast = function(isAirplay) {
            if (!isAirplay) {
                customUI.control.setting.hideDpQualityButton();
            }
            customUI.control.setting.hideSubtitleButton();
            customUI.control.setting.hideSpeedButton();
            control.popup.hide();
        };

        InlinePC.prototype.showMenuOnCast = function(isAirplay) {
            if (!isAirplay) {
                customUI.control.setting.showDpQualityButton();
            }
            customUI.control.setting.showSubtitleButton();
            customUI.control.setting.showSpeedButton();
            control.popup.show();
        };

        InlinePC.prototype.hideLoadedMenuOnCast = function() {
            customUI.control.tv.hideMirroringText();
        };

        InlinePC.prototype.showLoadedMenuOnCast = function() {
            customUI.control.tv.showMirroringText();
        };

        InlinePC.prototype.updateSetupView = function(profile) {
            customUI.control.install.setupView(profile);
        };

        InlinePC.prototype.initVolumeControl = function() {
            initVolumeControl();
        };

        return InlinePC;
    })();

    exports.addModule('view.inline.pc', new InlinePC());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var state = exports.loadModule('controller.state');
    var pctTracker = exports.loadModule('pct.tracker');
    var playerTemplate = exports.template;

    var Cover;

    Cover = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;
        var env = exports.ENV;
        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var PROFILE_KEY = constants.STORAGE.PROFILE;
        var ABR_KEY = constants.STORAGE.ABR;

        var EL = {
            COVER: $('customCover'),
            COVER_THUMB: $('coverImage'),
            COVER_TIME_CONTATINER: $$('.custom_cover .time_player')[0],
            COVER_TIME_SCREEN_OUT: $$('.custom_cover .time_player span')[0],
            COVER_TIME: $$('.custom_cover .time_player em')[0],
            PLAYER_TITLE: $$('.custom_cover .tit_player')[0],
            COVER_TITLE: $$('.custom_cover .link_title')[0],
            SHARE_BUTTON: $$('.custom_cover .btn_share')[0],
            SOCIAL_SHARE_KAKAOTALK: $$('.kakaotalk')[0],
            SOCIAL_SHARE_KAKAOSTORY: $$('.kakaostory')[0],
            PLAY_BUTTON: $$('.custom_cover .link_play')[0],
            QUALITY_CONTAINER: $$('.cover_quality div')[0],
            APPLINK_BUTTON: $$('.custom_cover .btn_liveHD')[0]
        };

        var cover = {
            el: EL.COVER,
            show: function() {
                dt.classList.remove(this.el, 'hidden');
                dt.classList.add(this.el, 'visible');
            },
            hide: function() {
                dt.classList.add(this.el, 'hidden');
                dt.classList.remove(this.el, 'visible');
            },
            setThumbnail: function(url) {
                if (url && EL.COVER_THUMB) {
                    EL.COVER_THUMB.style.backgroundImage = 'url("' + url + '")';
                }
            },
            setTime: function(duration) {
                if (EL.COVER_TIME) {
                    EL.COVER_TIME.innerHTML = helpers.string.delimitTimes(duration);
                }

                if (EL.COVER_TIME_SCREEN_OUT) {
                    var text = document.createTextNode(helpers.string.timeToString(duration));
                    EL.COVER_TIME_SCREEN_OUT.appendChild(text);
                }
            },
            hideTime: function() {
                if (EL.COVER_TIME_CONTATINER) {
                    dt.classList.add(EL.COVER_TIME_CONTATINER, 'hide');
                }
            },
            setTitle: function(url, title) {
                EL.COVER_TITLE.innerHTML = helpers.string.escapeHtml(title);
            },
            showTitle: function() {
                if (EL.PLAYER_TITLE) {
                    dt.classList.remove(EL.PLAYER_TITLE, 'hide');
                }
            },
            showShareButton: function() {
                if (EL.SHARE_BUTTON) {
                    dt.classList.remove(EL.SHARE_BUTTON, 'hide');
                }
            },
            hideShareButton: function() {
                if (EL.SHARE_BUTTON) {
                    dt.classList.add(EL.SHARE_BUTTON, 'hide');
                }
            },
            hideAppLinkButton: function() {
                if (EL.APPLINK_BUTTON) {
                    dt.classList.add(EL.APPLINK_BUTTON, 'hide');
                }
            },
            profile: {
                el: EL.QUALITY_CONTAINER,
                template: {
                    profileList: playerTemplate.cover_profile_list,
                    supHD: playerTemplate.superscript_hd,
                    sup4K: playerTemplate.superscript_4k
                },
                create: function(outputs) {
                    var storeABR = helpers.store.get(ABR_KEY);
                    var storeProfile = helpers.store.get(PROFILE_KEY);

                    var supHDTemplate = this.template.supHD;
                    var sup4KTemplate = this.template.sup4K;
                    var profile, profileLabel;
                    var view = {
                        outputs: []
                    };

                    var storeCheck = outputs.filter(function(p) {
                        return state.dash
                            ? constants.DASH_PROFILE[p.profile] === storeProfile
                            : p.profile === storeProfile;
                    });

                    for (var i in outputs) {
                        if (outputs.hasOwnProperty(i) && isAvailableProfile(outputs, i)) {
                            profile = outputs[i].profile;
                            profileLabel = outputs[i].label;

                            view.outputs.push({
                                profileName: profile,
                                profileLabel: this.removeText(profileLabel),
                                supHD: (function() {
                                    if (profileLabel.indexOf('HD') >= 0) {
                                        return supHDTemplate.render();
                                    } else {
                                        return '';
                                    }
                                })(),
                                sup4K: (function() {
                                    if (profileLabel.indexOf('4K') >= 0) {
                                        return sup4KTemplate.render();
                                    } else {
                                        return '';
                                    }
                                })(),
                                profileOn: (function() {
                                    if (storeProfile && storeCheck.length > 0) {
                                        if (
                                            outputs[i].profile === storeProfile ||
                                            (constants.DASH_PROFILE[outputs[i].profile] === storeProfile &&
                                                storeABR === 'false')
                                        ) {
                                            return 'on';
                                        }
                                    } else if (
                                        outputs[i].profile === state.currentVideo.profile ||
                                        (outputs[i].profile === 2 && storeABR === 'false')
                                    ) {
                                        return 'on';
                                    }
                                    return '';
                                })()
                            });
                        }
                    }

                    view.outputs = outputLengthCheck(view.outputs);

                    var fragment = this.createTemplate(view);
                    this.render(fragment);
                },
                createTemplate: function(view) {
                    var template = this.template.profileList;
                    return template.render(view);
                },
                render: function(htmlStr) {
                    EL.QUALITY_CONTAINER.innerHTML = htmlStr;
                },
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                },
                removeText: function(text) {
                    var re = / |P|HD|4K/g;
                    return text.replace(re, '');
                }
            }
        };

        function onCoverPlayBtn(type, profile) {
            if (type === 'VOD') {
                exports.queue.emit('play:vod', profile);
            } else if (type === 'LIVE') {
                if (state.autoplayFail && state.playerClass === constants.PLAYERCLASS.KAMP) {
                    player.play();
                } else {
                    exports.queue.emit('play:live', profile);
                }
            }

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onClickEventStart, [
                constants.PLAYER_CLICK_ACTION.PLAY,
                env.clipLinkId
            ]);
        }

        function showCover() {
            if (env.showCover) {
                cover.show();
            }
        }

        function hideCover() {
            cover.hide();
        }

        function checkVisibleExtensionInLegacy() {
            if (ua.platform === 'pc') {
                if (state.currentVideo.isLegacy) {
                    if (state.currentVideo.canScrap) {
                        cover.showShareButton();
                    } else {
                        cover.hideShareButton();
                    }
                } else {
                    cover.showShareButton();
                }
            } else {
                if (state.currentVideo.isLegacy) {
                    cover.hideShareButton();
                } else {
                    cover.showShareButton();
                }
            }
        }

        function checkVisibleShareButton() {
            if (env.extensions) {
                checkVisibleExtensionInLegacy();
            } else {
                cover.hideShareButton();
            }
        }

        function applyParameters() {
            if (ua.platform !== 'pc') {
                if (!env.coverProfile) {
                    cover.profile.hide();
                }

                if (!env.coverTime) {
                    cover.hideTime();
                }

                if (!env.appLink) {
                    cover.hideAppLinkButton();
                }
            }
        }

        function isAvailableProfile(outputs, index) {
            var autoProfileCheck = outputs[index].profile !== constants.PROFILE.AUTO;

            return autoProfileCheck;
        }

        function outputLengthCheck(outputList) {
            var list = [];

            for (var i in outputList) {
                if (list.length > 3) {
                    list.splice(list[0].profileOn === 'on' ? 1 : 0, 1);
                }
                list.push(outputList[i]);
            }

            return list;
        }

        function bindEvent(player) {
            event.on(EL.PLAY_BUTTON, 'click', function(e) {
                helpers.ui.preventDoubleClick(this);

                var storeABR = helpers.store.get(ABR_KEY);
                var storeProfile = helpers.store.get(PROFILE_KEY);
                var outputs = state.currentVideo.outputList;
                var storeCheck = null;
                var profile = null;

                if (player.type === 'LIVE') {
                    profile = env.profile || constants.PROFILE.MAIN;
                } else {
                    storeCheck = outputs.filter(function(p) {
                        return state.dash
                            ? constants.DASH_PROFILE[p.profile] === storeProfile
                            : p.profile === storeProfile;
                    });

                    if (storeProfile && storeCheck.length > 0) {
                        profile = storeProfile;
                    } else {
                        profile = state.currentVideo.profile;
                    }

                    if (state.dash && (ua.platform === 'pc' || storeABR !== 'false')) {
                        profile = constants.PROFILE.AUTO;
                    }
                }

                onCoverPlayBtn(player.type, profile);

                event.preventDefault(e);
                event.stopPropagation(e);

                pctTracker.track('play');
            });

            event.delegate(EL.COVER, '.btn_quality', 'click', function(e) {
                var buttonEl = e.target;
                var profile = buttonEl.getAttribute('data-profile');

                if (!helpers.feature.supportsVideoProfile(profile) && !state.dash) {
                    profile = constants.PROFILE.BASE;
                }

                if (profile !== constants.PROFILE.AUTO) {
                    helpers.store.set(PROFILE_KEY, state.dash ? constants.DASH_PROFILE[profile] : profile);
                    helpers.store.set(ABR_KEY, false);
                } else {
                    helpers.store.set(ABR_KEY, true);
                }

                onCoverPlayBtn(player.type, profile);

                event.preventDefault(e);
                event.stopPropagation(e);

                pctTracker.track('cover_profile', profile);
            });

            event.delegate(EL.COVER, '.btn_liveHD', 'click', function(e) {
                onCoverPlayBtn(player.type, 'HIGH');

                event.preventDefault(e);
                event.stopPropagation(e);

                pctTracker.track('liveapp', 'open');
            });

            event.on(EL.COVER, 'click', function(e) {
                if (e.target === EL.SHARE_BUTTON) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    exports.queue.emit('show:modal', {
                        target: 'socialShare',
                        callback: function() {
                            cover.showShareButton();
                        }
                    });

                    if (ua.platform === 'pc') {
                        EL.SOCIAL_SHARE_KAKAOSTORY.focus();
                    } else {
                        EL.SOCIAL_SHARE_KAKAOTALK.focus();
                    }
                    cover.hideShareButton();
                }
            });
        }

        function Cover() {}

        Cover.prototype.init = function(player, sandbox) {
            applyParameters();
            bindEvent(player, sandbox);
        };

        Cover.prototype.setThumbnail = function(url) {
            cover.setThumbnail(url);
        };

        Cover.prototype.setTime = function(duration) {
            cover.setTime(duration);
        };

        Cover.prototype.setTitle = function(url, title) {
            cover.setTitle(url, title);
        };

        Cover.prototype.showCover = function() {
            showCover();
        };

        Cover.prototype.hideCover = function() {
            hideCover();
        };

        Cover.prototype.onCompleteMeta = function() {
            var video = state.currentVideo;

            if (env.popup || (!env.isInternal && env.showInfo)) {
                if (video.type !== 'LIVE' || env.showLiveIcon) {
                    cover.showTitle();
                }
            }

            checkVisibleShareButton();
        };

        Cover.prototype.createProfileList = function(outputList) {
            cover.profile.create(outputList);
        };

        return Cover;
    })();

    exports.addModule('view.cover', new Cover());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var Extension;

    Extension = (function() {
        var shaka = exports.loadModule('player.shaka');
        var player = exports.loadModule('player.adapter');
        var inline = exports.loadModule('view.inline');
        var contextMenu = exports.loadModule('view.contextmenu');
        var state = exports.loadModule('controller.state');
        var pctTracker = exports.loadModule('pct.tracker');
        var pvtTracker = exports.loadModule('pvt.tracker');
        var playerTemplate = exports.template;

        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;
        var PHASE = constants.PHASE[env.phase.toUpperCase()];

        var SHARE_URL_HOST = helpers.serverHost.link(PHASE);

        var VOD_LINK = SHARE_URL_HOST + '/v/#{clipLinkId}';
        var LIVE_LINK = SHARE_URL_HOST + '/l/#{liveLinkId}';
        var SCRAP_LINK = 'http://scrap.cafe.daum.net/_dss_/scrap_tvpot?';

        var PROFILE_KEY = constants.STORAGE.PROFILE;
        var ABR_KEY = constants.STORAGE.ABR;
        var SUBTITLE_KEY = constants.STORAGE.SUBTITLE;

        var ID = {
            SOCIAL_SHARE: 'socialShare',
            SHARE_PANEL_URL: 'sharePanelUrl',
            SHARE_PANEL_EMBED: 'sharePanelEmbed'
        };

        var CNAME = {
            CLOSE_BUTTON: '.btn_close'
        };

        var LINK_TEMPLATE = {
            VOD_HORIZONTAL: 2516,
            VOD_VERTICAL: 2517,
            LIVE_HORIZONTAL: 2518,
            LIVE_VERTICAL: 2519,
            VOD_ORIGINAL: 33747,
            LIVE_ORIGINAL: 33748
        };

        var EL = {
            PLAYER: $('player'),
            PLAYER_CONTROLLER: $('controller'),
            PLAYER_MODAL: $('playerModal'),
            MODAL_CONTENTS: $$('#playerModal .modal_content'),
            MODAL_CLOSE_BUTTON: $$(CNAME.CLOSE_BUTTON),
            SHARE_BUTTON: $('socialShareBtn'),
            SOCIAL_SHARE_KAKAOTALK: $$('.kakaotalk')[0],
            SOCIAL_SHARE_KAKAOSTORY: $$('.kakaostory')[0],
            RELATED_BUTTON: $('relatedClipBtn'),
            DONATE_BUTTON: $$('#controller .btn_support')[0],
            ADD_PLAYLIST_BUTTON: $$('#controller .btn_plus')[0],
            SOCIAL_SHARE_URLCOPY: $$('#socialShare .urlcopy')[0],
            SHARE_URL: $('shareUrl'),
            COPYURL_BOX: $('copyUrlBox'),
            EMBED_URL: $('iframeUrl'),
            EXTENSION_LAYER: $('extension'),
            SOCIAL_SHARE: $(ID.SOCIAL_SHARE) || null,
            SHARE_PANEL_URL: $(ID.SHARE_PANEL_URL) || null,
            SHARE_PANEL_EMBED: $(ID.SHARE_PANEL_EMBED) || null,
            EMBED_SIZE_LIST: $$('#' + ID.SHARE_PANEL_EMBED + ' .opt_comm')[0] || null,
            DEFAULT_SETTING: $('defaultSetting') || null,
            DETAIL_SETTING: $('detailSetting') || null,
            SIZE_SELECT_BUTTON: $$('#' + ID.SHARE_PANEL_EMBED + ' .link_selected')[0] || null,
            PROFILE_LIST_CONTAINER: $$('.list_quality')[0],
            SUBTITLE_BUTTON: $$('.subtitle')[0],
            SUBTITLE_LIST_CONTAINER: $$('.list_subtitle')[0],
            MENU_LIST_CONTAINER: $$('.list_menu')[0],
            KAKAOTALK_SHARE_BUTTON: $('kakaotalkBtn'),
            AUTOPLAY_CHECKBOX: $('autoplayCheckbox'),
            FACEBOOK: $$('.facebook')[0]
        };

        var profileTemplate = {
            profileList: playerTemplate.extension_profile_list,
            supHD: playerTemplate.superscript_hd,
            sup4K: playerTemplate.superscript_4k
        };

        var isSupportClipBoard = window.ClipboardJS.isSupported();

        function createShareLink() {
            var video = state.currentVideo;

            if (!video) {
                return constants.HOST;
            }

            if (video.type === 'VOD') {
                return helpers.string.format(VOD_LINK, {
                    channelId: video.channelId,
                    clipLinkId: video.id
                });
            } else {
                return helpers.string.format(LIVE_LINK, {
                    channelId: video.channelId,
                    liveLinkId: video.id
                });
            }
        }

        function getTemplatedId() {
            var isVertical = state.currentVideo.isVertical;
            var isOriginal = state.currentVideo.isOriginal;
            var videoType = state.currentVideo.type;

            if (isOriginal) {
                if (videoType === constants.VIDEO_TYPE.VOD) {
                    return LINK_TEMPLATE.VOD_ORIGINAL;
                } else {
                    return LINK_TEMPLATE.LIVE_ORIGINAL;
                }
            } else {
                if (videoType === constants.VIDEO_TYPE.VOD) {
                    return isVertical ? LINK_TEMPLATE.VOD_VERTICAL : LINK_TEMPLATE.VOD_HORIZONTAL;
                } else {
                    return isVertical ? LINK_TEMPLATE.LIVE_VERTICAL : LINK_TEMPLATE.LIVE_HORIZONTAL;
                }
            }
        }

        function getThumbnail(url) {
            var DEFAULT_SIZE = 'S640x360';
            var VERTICAL_DEFAULT_SIZE = 'S480x640';

            var isVertical = state.currentVideo.isVertical;
            var isOriginal = state.currentVideo.isOriginal;
            var size;

            if (!url || url === '') {
                return '';
            }

            if (!isVertical || isOriginal) {
                size = DEFAULT_SIZE;
            } else {
                size = VERTICAL_DEFAULT_SIZE;
            }

            return (
                window.location.protocol +
                '//t1.daumcdn.net/thumb/' +
                size +
                '/' +
                '?fname=' +
                encodeURIComponent(url) +
                '&scode=kakaotv'
            );
        }

        function openWindow(url) {
            var options = '';
            if (ua.platform === 'pc') {
                options = 'width=500, height=500, toolbar=0, menubar=no';
            }

            window.open(url, '_blank', options);
        }

        function selectTextField(target) {
            target.focus();
            target.select();
        }
        var extension = {
            modal: {
                el: EL.PLAYER_MODAL,
                callback: null,
                focusedElement: null,
                show: function() {
                    state.modalContentActivated = true;
                    dt.classList.remove(this.el, 'hide');
                    this.el.setAttribute('aria-hidden', 'false');
                },
                hide: function() {
                    state.modalContentActivated = false;
                    dt.classList.add(this.el, 'hide');
                    this.el.setAttribute('aria-hidden', 'true');
                },
                clearContent: function() {
                    dt.classListAll.add(EL.MODAL_CONTENTS, 'hide');
                },
                selectContent: function(modalContent) {
                    dt.classList.remove(modalContent, 'hide');
                },
                isHide: function() {
                    return dt.classList.has(this.el, 'hide');
                }
            },
            share: {
                kakaotalk: {
                    create: function() {
                        var templateId = getTemplatedId();
                        var templateArgs = this.buildTemplate();

                        debug.info('templateID', templateId);
                        debug.info('templateArgs', templateArgs);

                        window.Kakao.Link.createCustomButton({
                            container: '#kakaotalkBtn',
                            templateId: templateId,
                            templateArgs: templateArgs,
                            installTalk: true
                        });
                    },
                    buildTemplate: function() {
                        var video = state.currentVideo;
                        var thumbUrl = getThumbnail(video.coverUrl);
                        var videoType = state.currentVideo.type;
                        var templateArgs = {};

                        if (video.isOriginal) {
                            var profileImageUrl = 'https://img1.daumcdn.net/kakaotv/originals/kakaotv_profile.png';

                            if (['sandbox', 'dev'].indexOf(env.phase) > -1) {
                                profileImageUrl =
                                    'http://sandbox-p.talk.kakao.co.kr/talkp/wkdNgmdjkT/7LTQdL4aHYvkIahpqIFGKk/2j9l4j.jpg';
                            }

                            if (videoType === constants.VIDEO_TYPE.VOD) {
                                templateArgs = {
                                    title: video.title,
                                    duration: video.duration,
                                    programId: video.channelId,
                                    synopsis: video.description,
                                    profileImageUrl: profileImageUrl,
                                    programTitle: video.channelName,
                                    clipLinkId: video.id,
                                    thumbnailUrl: thumbUrl
                                };
                            } else {
                                templateArgs = {
                                    title: video.title,
                                    programId: video.channelId,
                                    thumbnailUrl: thumbUrl,
                                    liveLinkId: video.id,
                                    synopsis: video.description,
                                    profileImageUrl: profileImageUrl,
                                    programTitle: video.channelName
                                };
                            }
                        } else {
                            if (videoType === constants.VIDEO_TYPE.VOD) {
                                templateArgs = {
                                    title: video.title,
                                    duration: video.duration,
                                    playCount: video.playCount,
                                    clipLinkId: video.id,
                                    thumbnailUrl: thumbUrl,
                                    channelName: video.channelName,
                                    channelId: video.channelId
                                };
                            } else {
                                templateArgs = {
                                    title: video.title,
                                    liveLinkId: video.id,
                                    thumbnailUrl: thumbUrl,
                                    channelName: video.channelName,
                                    channelId: video.channelId
                                };
                            }
                            if (video.profileImageUrl) {
                                templateArgs.channelProfileImageUrl = video.profileImageUrl;
                            }
                        }

                        return templateArgs;
                    }
                },
                kakaostory: function() {
                    var video = state.currentVideo;
                    var link = createShareLink();
                    var title = video.title;

                    if (ua.platform !== 'pc') {
                        window.Kakao.Story.open({
                            url: link,
                            text: title,
                            install: true
                        });
                    } else {
                        window.Kakao.Story.share({
                            url: link,
                            text: title
                        });
                    }
                },
                facebook: {
                    el: EL.FACEBOOK,
                    hide: function() {
                        if (this.el) {
                            dt.classList.add(this.el.parentElement, 'hide');
                        }
                    },
                    open: function() {
                        var link = createShareLink();
                        var url = 'https://m.facebook.com/sharer.php?u=' + encodeURIComponent(link);

                        openWindow(url);
                    }
                },
                twitter: function() {
                    var link = createShareLink();
                    var title = state.currentVideo.title;
                    var url =
                        'https://twitter.com/intent/tweet?url=' +
                        encodeURIComponent(link) +
                        '&text=' +
                        encodeURIComponent(title);

                    openWindow(url);
                },
                cafe: function() {
                    var params = {
                        folder_id: 0,
                        location_id: state.currentVideo.channelId,
                        data_id: state.currentVideo.id,
                        source_location_code: 8,
                        target_location_code: 1
                    };

                    var queryString = helpers.string.jsonToQueryString(params);
                    var url = SCRAP_LINK + queryString;

                    openWindow(url);
                },
                blog: function() {
                    var params = {
                        folder_id: 0,
                        location_id: state.currentVideo.channelId,
                        data_id: state.currentVideo.id,
                        source_location_code: 8,
                        target_location_code: 4
                    };

                    var queryString = helpers.string.jsonToQueryString(params);
                    var url = SCRAP_LINK + queryString;

                    openWindow(url);
                },
                setShareUrl: function() {
                    var shareUrl = createShareLink();
                    EL.SHARE_URL.value = shareUrl;
                    dt.dataset(EL.SOCIAL_SHARE_URLCOPY, 'clipboard-text', shareUrl);

                    if (ua.platform === 'pc') {
                        contextMenu.setShareUrl(shareUrl);
                    }
                },
                embed: {
                    activateTab: $$('#socialShare .on a')[0] || null,
                    setEmbedUrl: function(_start, _width, _height, _autoplay) {
                        var video = state.currentVideo;
                        var iframeTemplate =
                            '<iframe title="##TITLE##" ' +
                            'width="##WIDTH##" height="##HEIGHT##" src="##IFRAME_URL##" ' +
                            'allowfullscreen frameborder="0" scrolling="no" allow="autoplay"></iframe>';

                        var width = _width || 640;
                        var height = _height || 360;

                        var embedUrl = constants.SHARE_DOMAIN;

                        if (video.type === 'VOD') {
                            embedUrl += '/embed/player/cliplink/' + video.id + '?service=player_share';

                            if (_start > 0) {
                                embedUrl += '&start=' + _start;
                            }
                        } else if (video.type === 'LIVE') {
                            // TODO: 서버 쪽 cliplink도 수정되면 cliplink도 적용 필요.
                            embedUrl += '/embed/player/livelink?liveLinkId=' + video.id + '&service=player_share';
                        }

                        if (_autoplay) {
                            embedUrl += '&autoplay=1';
                        }

                        var htmlString = iframeTemplate.replace('##TITLE##', state.currentVideo.title);
                        htmlString = htmlString.replace('##IFRAME_URL##', embedUrl);
                        htmlString = htmlString.replace('##WIDTH##', width);
                        htmlString = htmlString.replace('##HEIGHT##', height);

                        EL.EMBED_URL.innerHTML = helpers.string.escapeHtml(htmlString);
                    },
                    setOption: function() {
                        var size = this.getSelectedSize();
                        var start = this.getStartTime();
                        var autoplay = this.getAutoPlay();
                        var width = size.split('x')[0];
                        var height = size.split('x')[1];

                        this.setEmbedUrl(start, width, height, autoplay);
                    },
                    selectSize: function(size) {
                        EL.SIZE_SELECT_BUTTON.setAttribute('data-selected', size);
                        EL.SIZE_SELECT_BUTTON.innerHTML = size;
                    },
                    getSelectedSize: function() {
                        return EL.SIZE_SELECT_BUTTON.getAttribute('data-selected');
                    },
                    getAutoPlay: function() {
                        return EL.AUTOPLAY_CHECKBOX.checked;
                    },
                    validateStartTime: function() {
                        var minute = $('minute').value;
                        var second = $('second').value;

                        if (isNaN(minute)) {
                            alert('시작시간은 숫자로 입력해주세요.');
                            $('minute').value = '';
                            $('minute').focus();
                            return false;
                        }

                        if (isNaN(second)) {
                            alert('시작시간은 숫자로 입력해주세요.');
                            $('minute').value = '';
                            $('second').focus();
                            return false;
                        }
                        return true;
                    },
                    getStartTime: function() {
                        var checkedEl = $$('input[name="playType"]:checked');
                        var startTime = 0;

                        if (checkedEl.length === 0) {
                            return;
                        }

                        if (dt.classList.has(checkedEl[0], 'current')) {
                            if (player.getCurrentTimeRound() > 0) {
                                startTime = player.getCurrentTimeRound();
                            }
                        }

                        if (dt.classList.has(checkedEl[0], 'point')) {
                            if (this.validateStartTime()) {
                                var minute = $('minute').value || 0;
                                var second = $('second').value || 0;

                                startTime = parseInt(minute, 10) * 60 + parseInt(second, 10);
                            }
                        }

                        return startTime;
                    },
                    showSizeList: function() {
                        dt.classList.add(EL.EMBED_SIZE_LIST, 'opt_open');
                    },
                    hideSizeList: function() {
                        dt.classList.remove(EL.EMBED_SIZE_LIST, 'opt_open');
                    },
                    toggleSizeList: function() {
                        if (dt.classList.has(EL.EMBED_SIZE_LIST, 'opt_open')) {
                            this.hideSizeList();
                        } else {
                            this.showSizeList();
                        }
                    },
                    resetPanel: function() {
                        var video = state.currentVideo;
                        var selectTab;

                        if (video.isLegacy) {
                            dt.classList.add(EL.SHARE_PANEL_URL, 'hide');
                            dt.classList.remove(EL.SHARE_PANEL_EMBED, 'hide');

                            selectTab = ID.SHARE_PANEL_EMBED;
                        } else {
                            dt.classList.remove(EL.SHARE_PANEL_URL, 'hide');
                            dt.classList.add(EL.SHARE_PANEL_EMBED, 'hide');

                            selectTab = ID.SHARE_PANEL_URL;
                        }

                        this.selectTab(selectTab);
                        this.setOption();
                    },
                    showDefaultSetting: function() {
                        dt.classList.remove(EL.DEFAULT_SETTING, 'hide');
                        dt.classList.add(EL.DETAIL_SETTING, 'hide');
                    },
                    hideDefaultSetting: function() {
                        dt.classList.add(EL.DEFAULT_SETTING, 'hide');
                        dt.classList.remove(EL.DETAIL_SETTING, 'hide');
                    },
                    selectTab: function(targetId) {
                        if (targetId) {
                            dt.classList.remove(this.activateTab.parentNode, 'on');

                            var selectedTab = $$('a[href="#' + targetId + '"]')[0];
                            dt.classList.remove(selectedTab.parentNode, 'hide');
                            dt.classList.add(selectedTab.parentNode, 'on');

                            this.activateTab = selectedTab;
                        }
                    },
                    showTab: function(targetId) {
                        if (targetId) {
                            var selectedTab = $$('a[href="#' + targetId + '"]')[0];
                            dt.classList.remove(selectedTab.parentNode, 'hide');
                        }
                    },
                    hideTab: function(targetId) {
                        if (targetId) {
                            var selectedTab = $$('a[href="#' + targetId + '"]')[0];
                            dt.classList.add(selectedTab.parentNode, 'hide');
                        }
                    },
                    togglePanel: function(target) {
                        if ($(target) === EL.SHARE_PANEL_URL) {
                            dt.classList.remove(EL.SHARE_PANEL_URL, 'hide');
                            dt.classList.add(EL.SHARE_PANEL_EMBED, 'hide');
                        }

                        if ($(target) === EL.SHARE_PANEL_EMBED) {
                            dt.classList.remove(EL.SHARE_PANEL_EMBED, 'hide');
                            dt.classList.add(EL.SHARE_PANEL_URL, 'hide');

                            this.showDefaultSetting();
                        }
                    }
                }
            },
            profile: {
                template: profileTemplate.profileList,
                create: function(profileList) {
                    var supHDTemplate = profileTemplate.supHD;
                    var sup4KTemplate = profileTemplate.sup4K;

                    var view = {
                        outputs: []
                    };

                    var profile, profileLabel;

                    for (var i in profileList) {
                        if (profileList.hasOwnProperty(i)) {
                            profile = profileList[i].profile;
                            profileLabel = profileList[i].label;

                            view.outputs.push({
                                profileName: profile,
                                profileLabel: removeText(profileLabel),
                                supHD: (function() {
                                    if (profileLabel.indexOf('HD') >= 0) {
                                        return supHDTemplate.render();
                                    } else {
                                        return '';
                                    }
                                })(),
                                sup4K: (function() {
                                    if (profileLabel.indexOf('4K') >= 0) {
                                        return sup4KTemplate.render();
                                    } else {
                                        return '';
                                    }
                                })(),
                                profileOn: (function() {
                                    if (profile === 'MAIN') {
                                        return 'on';
                                    }
                                    return '';
                                })()
                            });
                        }
                    }

                    EL.PROFILE_LIST_CONTAINER.innerHTML = this.template.render(view);
                },
                setOn: function(profile) {
                    var selectProfile = $$('[data-profile="' + profile + '"]', EL.PROFILE_LIST_CONTAINER)[0];
                    var preSelectProfile = $$('.on', EL.PROFILE_LIST_CONTAINER)[0];

                    if (selectProfile) {
                        if (typeof preSelectProfile !== 'undefined') {
                            dt.classList.remove(preSelectProfile, 'on');
                        }
                        dt.classList.add(selectProfile.parentElement, 'on');
                    }
                }
            },
            subtitle: {
                template: playerTemplate.mobile_subtitle_list,
                showButton: function() {
                    if (EL.SUBTITLE_BUTTON && EL.SUBTITLE_BUTTON.parentElement) {
                        dt.classList.remove(EL.SUBTITLE_BUTTON.parentElement, 'hide');
                    }
                },
                create: function(textTracks) {
                    var view = {
                        textTracks: []
                    };

                    textTracks.forEach(function(v) {
                        var isoCode = v.language.substr(0, 2);
                        if (window.ISO6391.getNativeName(isoCode)) {
                            view.textTracks.push({
                                subtitle: v.language,
                                subtitleText: window.ISO6391.getNativeName(isoCode)
                            });
                        }
                    });

                    if (view.textTracks.length > 0) {
                        EL.SUBTITLE_LIST_CONTAINER.innerHTML = this.template.render(view);
                        this.showButton();
                    }
                },
                setOn: function(subtitle) {
                    var selectSubtitle = $$('[data-subtitle="' + subtitle + '"]', EL.SUBTITLE_LIST_CONTAINER)[0];
                    var preSelectSubtitle = $$('.on', EL.SUBTITLE_LIST_CONTAINER)[0];

                    if (selectSubtitle) {
                        if (typeof preSelectSubtitle !== 'undefined') {
                            dt.classList.remove(preSelectSubtitle, 'on');
                        }
                        dt.classList.add(selectSubtitle.parentElement, 'on');
                    }
                }
            }
        };

        function showModal(data) {
            var target = data.target;

            if (!target || typeof target !== 'string') {
                debug.log('target does not exsist');
                return;
            }

            if (data) {
                if (typeof data.callback === 'function') {
                    extension.modal.callback = data.callback;
                }
            }

            var modalContent = $(target);
            if (modalContent) {
                extension.modal.clearContent();
                extension.modal.selectContent(modalContent);
                extension.modal.show();
                inline.hideActivatedControl();
                exports.queue.emit('hide:action');
                target = target.replace('socialShare', 'share');
                pctTracker.track(target);
            }
        }

        function hideModal(data) {
            var isHide = extension.modal.isHide();

            if (!state.modalContentActivated && isHide) {
                return;
            }

            extension.modal.hide();

            if (data && typeof data.callback === 'function') {
                data.callback();
            }

            if (typeof extension.modal.callback === 'function') {
                extension.modal.callback();
                extension.modal.callback = null;
            }

            if (extension.modal.focusedElement) {
                extension.modal.focusedElement.focus();
            }

            exports.queue.emit('show:action');
        }

        function showAddPlayListButton() {
            if (EL.ADD_PLAYLIST_BUTTON) {
                dt.classList.remove(EL.ADD_PLAYLIST_BUTTON, 'hide');
            }
        }

        function hideAddPlayListButton() {
            if (EL.ADD_PLAYLIST_BUTTON) {
                dt.classList.add(EL.ADD_PLAYLIST_BUTTON, 'hide');
            }
        }

        function showShareButton() {
            if (EL.SHARE_BUTTON) {
                dt.classList.remove(EL.SHARE_BUTTON, 'hide');
            }
        }

        function hideShareButton() {
            if (EL.SHARE_BUTTON) {
                dt.classList.add(EL.SHARE_BUTTON, 'hide');
            }
        }

        function showRelatedButton() {
            if (EL.RELATED_BUTTON) {
                dt.classList.remove(EL.RELATED_BUTTON, 'hide');
            }
        }

        function hideRelatedButton() {
            if (EL.RELATED_BUTTON) {
                dt.classList.add(EL.RELATED_BUTTON, 'hide');
            }
        }

        function showDonateButton() {
            if (EL.DONATE_BUTTON) {
                dt.classList.remove(EL.DONATE_BUTTON, 'hide');
            }
        }

        function hideDonateButton() {
            if (EL.DONATE_BUTTON) {
                dt.classList.add(EL.DONATE_BUTTON, 'hide');
            }
        }

        function closeModal(data) {
            inline.hideBlind();
            hideModal(data);
        }

        function initSharePanel() {
            if (state.currentVideo.isLegacy) {
                if (state.currentVideo.canScrap) {
                    extension.share.embed.selectTab('sharePanelEmbed');
                    extension.share.embed.hideTab('sharePanelUrl');
                    extension.share.embed.togglePanel('sharePanelEmbed');
                }
            } else {
                if (state.currentVideo.canScrap) {
                    extension.share.embed.showTab('sharePanelEmbed');
                    extension.share.embed.selectTab('sharePanelUrl');
                    extension.share.embed.togglePanel('sharePanelUrl');
                }
            }

            if (!state.currentVideo.canScrap) {
                extension.share.embed.hideTab('sharePanelEmbed');
                extension.share.embed.togglePanel('sharePanelUrl');
            }

            if (isSupportClipBoard) {
                dt.classList.remove(EL.SOCIAL_SHARE_URLCOPY, 'hide');
            } else {
                dt.classList.add(EL.SOCIAL_SHARE_URLCOPY, 'hide');
            }
        }

        function checkVisibleShareButton() {
            if (env.extensions) {
                if (ua.platform === 'pc') {
                    if (state.currentVideo.isLegacy) {
                        if (state.currentVideo.canScrap) {
                            showShareButton();
                        } else {
                            hideShareButton();
                        }
                    } else {
                        showShareButton();
                    }
                } else {
                    if (state.currentVideo.isLegacy) {
                        hideShareButton();
                    } else {
                        showShareButton();
                    }
                }
            } else {
                hideShareButton();
            }
        }

        function removeText(text) {
            var re = / |P|HD|4K/g;
            return text.replace(re, '');
        }

        function createProfileList(profileList) {
            extension.profile.create(profileList);
        }

        function createSubtitleList() {
            var textTracks = player.getTextTracks();

            if (textTracks.length > 0) {
                extension.subtitle.create(textTracks);
            }
        }

        function setSubtitle(subtitle) {
            player.setTextTrack(subtitle);
            extension.subtitle.setOn(subtitle);
        }

        var listener = {
            viewEvent: function() {
                var share = extension.share;

                event.on(EL.PLAYER_CONTROLLER, 'click', function(e) {
                    if (e.target === EL.SHARE_BUTTON) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        inline.hideControl();

                        if (ua.platform === 'pc') {
                            share.embed.resetPanel();
                        }

                        exports.queue.emit('show:modal', {
                            target: 'socialShare'
                        });

                        if (ua.platform === 'pc') {
                            EL.SOCIAL_SHARE_KAKAOSTORY.focus();
                        } else {
                            EL.SOCIAL_SHARE_KAKAOTALK.focus();
                        }
                    }

                    if (e.target === EL.ADD_PLAYLIST_BUTTON) {
                        if (ua.platform === 'pc' && inline.isFullScreen()) {
                            inline.cancelFullscreen(document);
                        }

                        exports.queue.emit('hide:nonelinear');

                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onAddPlaylist, [
                            state.currentVideo.clipId
                        ]);
                        pctTracker.track('keep');
                    }

                    if (e.target === EL.RELATED_BUTTON) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        inline.hideActivatedControl();
                        exports.queue.emit('show:completion');

                        pctTracker.track('related');
                    }

                    if (e.target === EL.DONATE_BUTTON) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        var video = state.currentVideo;
                        var donateUrl = constants.URL.DONATE_URL;
                        var linkLinkId = video.id;
                        var phaseHost = '//';
                        var features =
                            'fullscreen=no, width=457, height=542, menubar=no, scrollbars=no, status=no, titlebar=no, resizable=yes';

                        if (
                            window.location.host.indexOf('tv.kakao.com') >= 0 ||
                            window.location.host.indexOf('tv.devel.kakao.com') >= 0 ||
                            window.location.host.indexOf('daum.net') >= 0 ||
                            window.location.host.indexOf('dev.daum.net') >= 0
                        ) {
                            phaseHost += window.location.host;
                        } else {
                            phaseHost += constants.SUB_DOMAIN.KAKAO[PHASE] + '.kakao.com';
                        }

                        donateUrl = donateUrl.replace('#{livelinkid}', linkLinkId);
                        inline.openPopup(phaseHost + donateUrl, 'Donate', features);

                        pctTracker.track('donate');
                    }
                });

                event.delegate(EL.PLAYER_MODAL, '.kakaostory', 'click', function() {
                    share.kakaostory();
                    pctTracker.track('share', 'story');
                });

                event.delegate(EL.PLAYER_MODAL, '.facebook', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    share.facebook.open();
                    pctTracker.track('share', 'facebook');
                });

                event.delegate(EL.PLAYER_MODAL, '.twitter', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    share.twitter();
                    pctTracker.track('share', 'twitter');
                });

                event.delegate(EL.PLAYER_MODAL, '.cafe', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    share.cafe();
                });

                event.delegate(EL.PLAYER_MODAL, '.blog', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    share.blog();
                });

                event.delegate(EL.PLAYER_MODAL, CNAME.CLOSE_BUTTON, 'click', function() {
                    exports.queue.emit('hide:modal');
                    pctTracker.track('quit_layer');
                });

                event.on(EL.SHARE_URL, 'click', function() {
                    selectTextField(this);
                });

                if (ua.platform === 'pc') {
                    event.delegate(EL.SHARE_PANEL_EMBED, '.link_selected', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        share.embed.toggleSizeList();
                    });

                    event.delegate(EL.SHARE_PANEL_EMBED, '.link_select', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        var element = e.target;
                        var size = element.getAttribute('data-size');

                        share.embed.selectSize(size);
                        share.embed.hideSizeList();
                    });

                    event.delegate(EL.SHARE_PANEL_EMBED, '.link_option', 'click', function() {
                        share.embed.hideDefaultSetting();
                    });

                    event.delegate(EL.SHARE_PANEL_EMBED, '.inp_autoplay', 'click', function() {
                        var autoplay = share.embed.getAutoPlay();
                        share.embed.setOption();
                        pctTracker.track('get_source', autoplay ? 'autoplay_check' : 'autoplay_uncheck');
                    });

                    event.delegate(EL.DETAIL_SETTING, '.btn_function', 'click', function(e) {
                        var video = state.currentVideo;
                        var playPointType = 'playpoint_first';

                        if (dt.classList.has(e.target, 'btn_finish')) {
                            share.embed.setOption();

                            var checkedEl = $$('input[name="playType"]:checked');
                            if (dt.classList.has(checkedEl[0], 'current')) {
                                playPointType = 'playpoint_now';
                            } else if (dt.classList.has(checkedEl[0], 'point')) {
                                playPointType = 'playpoint_custom';
                            }

                            if (video.type !== 'LIVE') {
                                pctTracker.track('get_source', playPointType);
                            }
                            pctTracker.track('get_source', 'size_' + share.embed.getSelectedSize());
                        }

                        share.embed.showDefaultSetting();
                    });

                    event.delegate(EL.SOCIAL_SHARE, '.link_share', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        var current = e.target;
                        var target = current.href.split('#')[1];

                        share.embed.selectTab(target);
                        share.embed.togglePanel(target);
                    });

                    event.on(EL.EMBED_URL, 'click', function() {
                        selectTextField(this);
                    });
                } else {
                    // PC 카카오톡 공유하기 추가 전까지 모바일에만 적용되도록 분기 처리
                    event.on(EL.KAKAOTALK_SHARE_BUTTON, 'click', function() {
                        pctTracker.track('share', 'talk');
                    });

                    event.on(EL.PLAYER_MODAL, 'click', function(e) {
                        if (e.target.tagName !== 'A' && e.target.tagName !== 'SPAN' && e.target.tagName !== 'INPUT') {
                            exports.queue.emit('hide:modal');
                        }
                    });

                    event.delegate(EL.SUBTITLE_LIST_CONTAINER, '.link_subtitle', 'click', function(e) {
                        var buttonEl = e.target;
                        var subtitle = buttonEl.getAttribute('data-subtitle');

                        helpers.store.set(SUBTITLE_KEY, subtitle);

                        if (!dt.classList.has(buttonEl.parentElement, 'on')) {
                            setSubtitle(subtitle);
                        }
                    });

                    if (EL.PROFILE_LIST_CONTAINER) {
                        event.delegate(EL.PROFILE_LIST_CONTAINER, '.link_quality', 'click', function(e) {
                            var buttonEl = e.target;
                            var profile = buttonEl.getAttribute('data-profile');

                            if (!helpers.feature.supportsVideoProfile(profile) && !state.dash) {
                                profile = constants.PROFILE.BASE;
                            }

                            if (state.dash) {
                                state.currentVideo.profile = profile;
                                shaka.setTrack(profile);
                            } else {
                                inline.getClipLocation(profile);
                            }

                            if (profile !== constants.PROFILE.AUTO) {
                                helpers.store.set(PROFILE_KEY, state.dash ? constants.DASH_PROFILE[profile] : profile);
                                helpers.store.set(ABR_KEY, false);
                            } else {
                                helpers.store.set(ABR_KEY, true);
                            }

                            inline.setProfile(profile);
                            extension.profile.setOn(profile);
                            exports.queue.emit('hide:modal');

                            pvtTracker.pause();
                            pctTracker.track('profile', state.dash ? constants.DASH_PROFILE[profile] : profile);
                        });
                    }
                }
            },
            customEvent: function(sandbox) {
                sandbox.on('show:modal', function(data) {
                    showModal(data);
                });

                sandbox.on('hide:modal', function(data) {
                    closeModal(data);
                });
            },
            clipboardEvent: function(clipboard) {
                clipboard.on('success', function(e) {
                    extension.modal.hide();

                    var delimiter = ua.platform !== 'pc' ? '<br />' : ' ';
                    var relatedData = {
                        message: ['URL을 복사했습니다.', delimiter, '원하는 곳에 붙여넣기 하세요.'].join(''),
                        callback: function() {
                            inline.hideBlind();
                            extension.modal.show();

                            if (state.ended) {
                                inline.showControl(true);
                                exports.queue.emit('show:completion');
                            }
                        }
                    };
                    exports.queue.emit('show:notification', relatedData);
                    e.clearSelection();

                    pctTracker.track('share', 'url_copy');
                });

                clipboard.on('error', function() {
                    if (ua.platform !== 'pc') {
                        dt.classList.remove(EL.COPYURL_BOX, 'hide');

                        exports.queue.emit('show:modal', {
                            target: 'copyUrlBox'
                        });
                    }
                });
            }
        };

        function Extension() {}

        Extension.prototype.init = function(player, sandbox) {
            this.videoElement = player.videoElement;
            var clipboard = new window.ClipboardJS('#socialShare .urlcopy', { container: $('playerContainer') });
            listener.viewEvent(player.videoElement);
            listener.customEvent(sandbox);
            listener.clipboardEvent(clipboard);

            if (helpers.device.isIeBrowser11Under(ua)) {
                extension.share.facebook.hide();
            }
        };

        Extension.prototype.hideModal = function(data) {
            closeModal(data);
        };

        Extension.prototype.showRelatedButton = function() {
            showRelatedButton();
        };

        Extension.prototype.hideRelatedButton = function() {
            hideRelatedButton();
        };

        Extension.prototype.onCompleteMeta = function() {
            var video = state.currentVideo;
            extension.share.setShareUrl();

            if (ua.platform === 'pc') {
                extension.share.embed.setEmbedUrl();
                initSharePanel();
            } else {
                extension.share.kakaotalk.create();
            }

            if (env.isInternal && !env.popup && video.status === 'AVAILABLE') {
                showAddPlayListButton();
            } else {
                hideAddPlayListButton();
            }

            if (video.hasBizDonationPartner) {
                showDonateButton();
            } else {
                hideDonateButton();
            }

            checkVisibleShareButton();
        };

        Extension.prototype.createProfileList = function(profileList) {
            createProfileList(profileList);
        };

        Extension.prototype.setProfile = function(profile) {
            extension.profile.setOn(profile);
        };

        Extension.prototype.onLoadedData = function() {
            var storeSubtitle = helpers.store.get(SUBTITLE_KEY);
            if (state.currentVideo.type === constants.VIDEO_TYPE.VOD) {
                createSubtitleList();
            }

            if (storeSubtitle) {
                setSubtitle(storeSubtitle);
            }
        };

        return Extension;
    })();

    exports.addModule('view.extension', new Extension());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var inline = exports.loadModule('view.inline');
    var inlinePC = exports.loadModule('view.inline.pc');
    var shaka = exports.loadModule('player.shaka');
    var player = exports.loadModule('player.adapter');
    var error = exports.loadModule('view.error');
    var dataloader = exports.loadModule('playlist.dataloader');
    var state = exports.loadModule('controller.state');
    var extension = exports.loadModule('view.extension');
    var pctTracker = exports.loadModule('pct.tracker');

    var Completion;

    Completion = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;
        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;
        var playerTemplate = exports.template;

        var orien = new dt.Orientation();
        var iscroll;
        var isShown = false;

        var EL = {
            COMPLETION_CONTAINER: $('completionContainer'),
            WAITING_CONTAINER: $('waitingContainer'),
            COMPLETION: $('completion'),
            WAITING: $('waiting'),
            NEXT_VIDEO_TITLE: $('nextVideoTitle'),
            COMPLETION_MORE_INFO: $$('#completion .more_info')[0],
            SCROLLER: $('scroller'),
            LIST: $$('#completionContainer ul')[0],
            SHARE_BUTTON: $$('#completion .btn_share')[0],
            CLOSE_BUTTON: $$('#completion .btn_close')[0],
            SOCIAL_SHARE_KAKAOTALK: $$('.kakaotalk')[0],
            SOCIAL_SHARE_KAKAOSTORY: $$('.kakaostory')[0],
            NEXT_BTN: $$('#completion .btn_next')[0],
            PREV_BTN: $$('#completion .btn_prev')[0],
            REPLAY_BTN: $$('#completion .link_replay')[0],
            ITEM_OTHER: $$('#completion .item_other')[0]
        };

        var loader = {
            relateClip: function(id, size) {
                var options = {
                    uuid: helpers.uuid.get()
                };
                dataloader.getRelatedClip(id, options, size);
            },
            recommendClip: function(id, callback) {
                dataloader.getRecommendedClip(id, callback);
            }
        };

        var completion = {
            el: EL.COMPLETION,
            template: {
                clipList: ua.platform === 'pc' ? playerTemplate.pc_clip_list : playerTemplate.m_clip_list,
                noData: playerTemplate.list_no_data
            },
            clipList: null,
            maxLength: null,
            totalItem: null,
            totalPageNum: null,
            nextItemCount: null,
            currentPage: 1,
            init: function(id, callback) {
                if (player.type === 'VOD') {
                    var size = ua.platform === 'mobile' ? 10 : 36;
                    loader.relateClip(id, size);
                } else if (player.type === 'LIVE') {
                    loader.recommendClip(id, callback);
                }

                state.completionLoaded = true;
            },
            create: function(clipList) {
                var thumbnailUrl, coverImgUrl;
                var maxLength = this.maxLength;
                var duration = '';

                var partial = {
                    noData: this.template.noData
                };

                var view = {
                    clipList: [],
                    noDataList: function() {
                        var j = 0;

                        if (clipList.length < maxLength) {
                            var noImageLength = maxLength - clipList.length;

                            while (j < noImageLength) {
                                j++;
                            }
                        }

                        return new Array(j);
                    }
                };

                var size = 'C600x320';

                if (ua.platform === 'mobile') {
                    size = 'C140x80';
                    view.noDataList = [];
                    this.maxLength = 10;
                }

                for (var i = 0; i < clipList.length; i++) {
                    if (this.maxLength > i) {
                        thumbnailUrl = clipList[i].clip.thumbnailUrl;

                        if (thumbnailUrl) {
                            coverImgUrl = helpers.string.getThumbnailFarmUrl(thumbnailUrl, size);
                        }

                        duration = helpers.string.delimitTimes(clipList[i].clip.duration);

                        view.clipList.push({
                            linkUrl: '/embed/player/cliplink/' + clipList[i].id,
                            clipLinkID: clipList[i].id,
                            clipID: clipList[i].clip.id,
                            channelID: clipList[i].channelId,
                            feedbackID: clipList[i].fbId || '',
                            imageUrl: coverImgUrl || '',
                            title: clipList[i].clip.title || '',
                            viewCount: clipList[i].clip.playCount || '',
                            duration: duration
                        });

                        if (isShown) {
                            helpers.http.sendBeacon(clipList[i].vimpUrl);
                        }
                    }
                }

                var fragment = this.createTemplate(view, partial);
                this.render(fragment);
            },
            createTemplate: function(view, partial) {
                var template = this.template.clipList;
                return template.render(view, partial);
            },
            render: function(htmlStr) {
                var template = this.template.noData;
                EL.LIST.innerHTML = htmlStr;

                var thumbImgs = $$('.thumb_item', EL.LIST);
                if (thumbImgs && thumbImgs.length > 0) {
                    for (var i = 0; i < thumbImgs.length; i++) {
                        thumbImgs[i].onerror = function() {
                            var liElement = this.parentElement.parentElement;
                            liElement.innerHTML = template.render();
                        };
                    }
                }
            },
            resizeScroll: function() {
                var itemWidth = 189;
                var margin = 30;
                EL.SCROLLER.style.width = itemWidth * this.clipList.length + margin + 'px';
            },
            resize: function() {
                if (ua.platform === 'pc') {
                    this.currentPage = 1;
                    this.maxLength = getMaxItemLength();
                    this.calculate(this.currentPage);
                } else {
                    this.resizeScroll();
                }
            },
            calculate: function(pageNum) {
                var end = this.maxLength * pageNum;
                var start = end - this.maxLength;

                if (!this.clipList || this.clipList.length < 1) {
                    return;
                }

                var clipList = this.clipList.slice(start, end);

                if (end < this.totalItem) {
                    this.nextItemCount = this.totalItem - end;
                } else {
                    this.nextItemCount = 0;
                }

                if (this.nextItemCount > 0) {
                    dt.classList.remove(EL.NEXT_BTN, 'hide');

                    if (end > this.totalItem) {
                        dt.classList.add(EL.NEXT_BTN, 'hide');
                    }
                } else {
                    dt.classList.add(EL.NEXT_BTN, 'hide');
                }

                if (pageNum > 1) {
                    dt.classList.remove(EL.PREV_BTN, 'hide');
                    this.currentPage = pageNum;
                } else {
                    this.currentPage = 1;
                    dt.classList.add(EL.PREV_BTN, 'hide');

                    if (this.nextItemCount > 0) {
                        dt.classList.remove(EL.NEXT_BTN, 'hide');
                    }
                }

                completion.create(clipList);
            },
            showPrev: function() {
                if (this.currentPage > 1) {
                    this.currentPage = this.currentPage - 1;
                }

                debug.log('show prev', this.currentPage);

                this.calculate(this.currentPage);
            },
            showNext: function() {
                if (this.nextItemCount > 0) {
                    this.currentPage = this.currentPage + 1;
                }

                this.calculate(this.currentPage);
            },
            show: function() {
                state.modalContentActivated = true;
                dt.classList.remove(EL.COMPLETION_CONTAINER, 'hide');
            },
            hide: function() {
                state.modalContentActivated = false;
                dt.classList.add(EL.COMPLETION_CONTAINER, 'hide');
            },
            showReplay: function() {
                if (EL.REPLAY_BTN) {
                    dt.classList.remove(EL.REPLAY_BTN, 'hidden');
                }
            },
            hideReplay: function() {
                if (EL.REPLAY_BTN) {
                    dt.classList.add(EL.REPLAY_BTN, 'hidden');
                }
            },
            showItem: function() {
                if (EL.ITEM_OTHER) {
                    dt.classList.remove(EL.ITEM_OTHER, 'hidden');
                }
            },
            hideItem: function() {
                if (EL.ITEM_OTHER) {
                    dt.classList.add(EL.ITEM_OTHER, 'hidden');
                }
            },
            showMoreInfo: function() {
                if (EL.COMPLETION_MORE_INFO) {
                    dt.classList.add(EL.COMPLETION_MORE_INFO, 'visible');
                    dt.classList.remove(EL.COMPLETION_MORE_INFO, 'hidden');
                }
            },
            hideMoreInfo: function() {
                if (EL.COMPLETION_MORE_INFO) {
                    dt.classList.remove(EL.COMPLETION_MORE_INFO, 'visible');
                    dt.classList.add(EL.COMPLETION_MORE_INFO, 'hidden');
                }
            },
            showShareButton: function() {
                if (EL.SHARE_BUTTON) {
                    dt.classList.remove(EL.SHARE_BUTTON, 'hide');
                }
            },
            hideShareButton: function() {
                if (EL.SHARE_BUTTON) {
                    dt.classList.add(EL.SHARE_BUTTON, 'hide');
                }
            },
            hideCloseButton: function() {
                if (EL.CLOSE_BUTTON) {
                    dt.classList.add(EL.CLOSE_BUTTON, 'hide');
                }
            },
            showCloseButton: function() {
                if (EL.CLOSE_BUTTON) {
                    dt.classList.remove(EL.CLOSE_BUTTON, 'hide');
                }
            }
        };

        var waiting = {
            el: EL.WAITING,
            autoPlayTimer: null,
            progressBar: null,
            clearTimer: function() {
                if (this.autoPlayTimer) {
                    clearTimeout(this.autoPlayTimer);
                }
            },
            show: function(callback) {
                var self = this;

                if (!this.el) {
                    return;
                }

                dt.classList.remove(EL.WAITING_CONTAINER, 'hide');
                dt.classList.remove(this.el, 'hidden');
                dt.classList.add(this.el, 'visible');

                this.clearTimer();
                this.progress();

                this.autoPlayTimer = setTimeout(function() {
                    if (callback && typeof callback === 'function') {
                        callback();
                    }

                    self.autoPlayTimer = null;
                }, 5000);
            },
            hide: function() {
                if (this.el) {
                    dt.classList.remove(this.el, 'visible');
                    dt.classList.add(this.el, 'hidden');
                    dt.classList.add(EL.WAITING_CONTAINER, 'hide');
                }
            },
            progress: function() {
                if (!this.progressBar) {
                    this.progressBar = new window.ProgressBar.Circle('#loaderCircle', {
                        strokeWidth: 6,
                        easing: 'linear',
                        duration: 5000,
                        color: '#FAE100'
                    });
                }
                this.progressBar.set(0);
                this.progressBar.animate(1);
            }
        };

        function scrollEndUpdate(position) {
            var orientation = helpers.orientation.getOrientation();

            if (orientation === 'landscape' && window.innerWidth >= 480) {
                return;
            }

            if (position < 0) {
                completion.hideMoreInfo();
            } else {
                completion.showMoreInfo();
            }
        }

        function attachEventForMobile() {
            iscroll = new window.IScroll('#scrollWrap', {
                probeType: 1,
                scrollX: true,
                snap: true,
                click: true,
                momentum: true,
                resizePolling: 30,
                disablePointer: false,
                disableTouch: false,
                disableMouse: false
            });

            iscroll.on('scroll', function() {
                scrollEndUpdate(this.x);
            });

            iscroll.on('scrollEnd', function() {
                scrollEndUpdate(this.x);
            });

            orien.onPortrait(function() {
                scrollEndUpdate(iscroll.x);
            });

            orien.onLandscape(function() {
                completion.showMoreInfo();
            });

            debug.log('attached:iscroll');
        }

        function getMaxItemLength() {
            var orientation = helpers.orientation.getOrientation();
            var listItem = document.getElementsByClassName('list_item')[0];
            var maxItemLength = 9;

            if (listItem.childElementCount > 0) {
                var controlHeight = document.getElementsByClassName('player_function')[0].clientHeight;
                var progressHeight = document.getElementsByClassName('progress_bar')[0].clientHeight;
                var barHeight = controlHeight + progressHeight;

                var listItemHeight = listItem.clientHeight / 2;
                var itemHeightHalf = listItem.childNodes[0].clientHeight / 2;

                if (window.innerWidth >= 1024) {
                    if (listItemHeight - barHeight > itemHeightHalf * 3) {
                        maxItemLength = 9;
                    } else if (listItemHeight - barHeight > itemHeightHalf * 2) {
                        maxItemLength = 6;
                    } else {
                        maxItemLength = 3;
                    }
                } else if (window.innerWidth >= 850 && window.innerWidth < 1024) {
                    if (listItemHeight - barHeight > itemHeightHalf * 2) {
                        maxItemLength = 6;
                    } else {
                        maxItemLength = 3;
                    }
                } else if (window.innerWidth >= 640 && window.innerWidth < 850) {
                    if (listItemHeight - barHeight > itemHeightHalf * 2) {
                        maxItemLength = 4;
                    } else {
                        maxItemLength = 2;
                    }
                } else if (window.innerWidth >= 560 && window.innerWidth < 640) {
                    maxItemLength = 2;
                } else if (window.innerWidth < 560) {
                    maxItemLength = 2;

                    if (orientation === 'portrait') {
                        maxItemLength = 1;
                    }
                }

                return maxItemLength;
            } else {
                return maxItemLength;
            }
        }

        function attachEventForPC() {
            event.on(
                window,
                'resize',
                helpers.waiter.throttle(function() {
                    var prevMaxLength = completion.maxLength;
                    completion.maxLength = getMaxItemLength();

                    if (prevMaxLength !== completion.maxLength) {
                        completion.resize();
                    }
                }, 50)
            );

            event.on(EL.PREV_BTN, 'click', function() {
                completion.showPrev();
            });

            event.on(EL.NEXT_BTN, 'click', function() {
                completion.showNext();
            });
        }

        function createCompletion(callback) {
            if (!state.completionLoaded) {
                completion.init(state.currentVideo.id, callback);
            }

            if (ua.platform !== 'pc') {
                attachEventForMobile();
            } else {
                attachEventForPC();
            }
        }

        function renderCompletion() {
            if (completion.clipList && completion.clipList.length > 0) {
                completion.create(completion.clipList);
                completion.resize();
            }
        }

        function showExtensionButton() {
            if (!state.ended) {
                completion.hideShareButton();
                completion.showCloseButton();
            } else {
                if (env.extensions) {
                    if (!state.currentVideo.canScrap && state.currentVideo.isLegacy) {
                        completion.hideShareButton();
                    } else {
                        completion.showShareButton();
                    }
                } else {
                    completion.hideShareButton();
                }

                completion.hideCloseButton();
            }
        }

        function showCompletion() {
            debug.log('showCompletion', state.hasRelated);
            isShown = true;

            if (state.hasRelated) {
                if (ua.platform !== 'pc') {
                    setTimeout(function() {
                        iscroll.refresh();
                    }, 100);
                } else {
                    completion.showItem();
                    completion.hideReplay();
                    showExtensionButton();
                }
            } else {
                if (!state.ended) {
                    return;
                }

                completion.hideItem();
                completion.showReplay();
                completion.hideCloseButton();
                if (state.currentVideo.canScrap) {
                    completion.showShareButton();
                }
            }
            completion.show();
            renderCompletion();

            exports.queue.emit('hide:action');
        }

        function hideCompletion() {
            isShown = false;
            completion.hide();

            if (!state.ended) {
                exports.queue.emit('show:action');
            }
        }

        function showWaiting(callback) {
            waiting.show(callback);
        }

        function hideWaiting() {
            waiting.hide();
        }

        var listener = {
            dataloaderEvent: function(sandbox) {
                sandbox.on('load:clip:related', function(result) {
                    if (result.status !== 'success') {
                        return;
                    }

                    completion.clipList = result.data.list;
                    completion.totalItem = completion.clipList.length;

                    if (completion.clipList.length > 0) {
                        state.hasRelated = true;
                        extension.showRelatedButton();
                        renderCompletion();
                    } else {
                        state.hasRelated = false;
                        extension.hideRelatedButton();
                    }
                });

                sandbox.on('load:clip:recommended', function(result) {
                    debug.log('load:clip:recommended', result);

                    if (
                        result.status !== 'success' ||
                        (player.type === constants.VIDEO_TYPE.LIVE && ua.platform === 'pc')
                    ) {
                        return;
                    }

                    completion.clipList = result.data.list;

                    if (completion.clipList.length > 0) {
                        state.hasRelated = true;
                        renderCompletion();

                        var errorStatus = error.getErrorStatus();
                        if (state.isShowError && errorStatus.NAME === 'LiveFinished') {
                            showCompletion();
                        }
                    } else {
                        state.hasRelated = false;
                        error.addStyle('no_data');
                        debug.warn('recommended clip is empty');
                    }

                    if (result.callback && typeof result.callback === 'function') {
                        result.callback(result);
                    }
                });
            },
            viewEvent: function() {
                if (!helpers.device.isSupportCustomController(ua)) {
                    return;
                }

                event.delegate(EL.COMPLETION_CONTAINER, '.btn_share', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    exports.queue.emit('hide:completion');

                    var callback = function() {
                        exports.queue.emit('show:completion');
                    };

                    exports.queue.emit('show:modal', { target: 'socialShare', callback: callback });

                    if (ua.platform === 'pc') {
                        var isfreeze = true;
                        inline.showControl(isfreeze);
                        EL.SOCIAL_SHARE_KAKAOSTORY.focus();
                    } else {
                        EL.SOCIAL_SHARE_KAKAOTALK.focus();
                    }
                });

                event.delegate(EL.COMPLETION_CONTAINER, '.btn_plus', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onAddPlaylist, [
                        state.currentVideo.clipId
                    ]);
                });

                event.delegate(EL.COMPLETION_CONTAINER, '.link_replay', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    exports.queue.emit('hide:completion');

                    if (state.dash) {
                        shaka.unload();
                    }
                    var profile = state.dash
                        ? constants.DASH_PROFILE[state.currentVideo.profile]
                        : state.currentVideo.profile;

                    exports.queue.emit('loadAndPlay:videoById:withPlayerUnload', state.currentVideo.id, profile);
                    pctTracker.track('replay');
                });

                event.delegate(EL.COMPLETION_CONTAINER, '.btn_close', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    exports.queue.emit('hide:completion');
                });

                event.delegate(EL.COMPLETION_CONTAINER, '.link_item', 'click', function(e) {
                    var target = e.target;

                    if (
                        target.tagName === 'A' ||
                        target.tagName === 'IMG' ||
                        target.tagName === 'EM' ||
                        target.tagName === 'STRONG' ||
                        target.tagName === 'SPAN'
                    ) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        exports.queue.emit('hide:completion');
                        exports.queue.emit('hide:error');

                        if (target.parentNode && target.parentNode.tagName === 'A') {
                            target = target.parentNode;
                        }

                        var clipLinkId = target.getAttribute('data-cliplink-id');
                        var channelId = target.getAttribute('data-channel-id');
                        var feedbackId = target.getAttribute('data-feedback-id');
                        var channelViewLink = '/channel/' + channelId + '/cliplink/' + clipLinkId;

                        if (feedbackId && feedbackId !== '') {
                            channelViewLink += '?fbId=' + feedbackId;
                        }

                        debug.info('channelViewLink', channelViewLink);
                        debug.info('channelViewLink', channelViewLink);

                        if (env.isInternal && !env.popup) {
                            top.location.href = channelViewLink;
                        } else {
                            if (player.type === constants.VIDEO_TYPE.LIVE) {
                                location.href =
                                    env.host + '/embed/player/cliplink/' + clipLinkId + '?service=' + env.service;
                            } else {
                                exports.queue.emit(
                                    'loadAndPlay:videoById:withPlayerUnload',
                                    clipLinkId,
                                    state.currentVideo.profile,
                                    null,
                                    feedbackId
                                );
                            }
                        }
                        pctTracker.track('relate_clip', clipLinkId);
                    }
                });

                if (ua.platform === 'pc') {
                    event.delegate(EL.WAITING_CONTAINER, '.link_waiting', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        debug.info('link_waiting', e.target);

                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onEndAutoPlayTimer);
                    });

                    event.delegate(EL.WAITING_CONTAINER, '.link_next', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onEndAutoPlayTimer);
                    });

                    event.delegate(EL.WAITING_CONTAINER, '.link_cancel', 'click', function(e) {
                        event.preventDefault(e);
                        event.stopPropagation(e);

                        waiting.clearTimer();
                        waiting.hide();

                        inlinePC.onEndVideo();
                    });
                }
            },
            customEvent: function(player, sandbox) {
                sandbox.on('show:completion', function() {
                    showCompletion();
                });

                sandbox.on('hide:completion', function() {
                    hideCompletion();
                });

                sandbox.on('create:completion', function() {
                    createCompletion();
                });
            }
        };

        function Completion() {}

        Completion.prototype.init = function(player, sandbox) {
            listener.dataloaderEvent(sandbox);
            listener.viewEvent();
            listener.customEvent(player, sandbox);
        };

        Completion.prototype.createCompletion = function(callback) {
            createCompletion(callback);
        };

        Completion.prototype.showCompletion = function() {
            showCompletion();
        };

        Completion.prototype.hideCompletion = function() {
            hideCompletion();
        };

        Completion.prototype.setNextVideo = function(title) {
            if (EL.NEXT_VIDEO_TITLE) {
                EL.NEXT_VIDEO_TITLE.innerHTML = title;
            }
        };

        Completion.prototype.hasNextVideo = function() {
            var title = EL.NEXT_VIDEO_TITLE.innerHTML;
            return title !== '';
        };

        Completion.prototype.showWaiting = function() {
            showWaiting.apply(this, arguments);
        };

        Completion.prototype.hideWaiting = function() {
            hideWaiting();
        };

        return Completion;
    })();

    exports.addModule('view.completion', new Completion());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var shaka = exports.loadModule('player.shaka');
    var state = exports.loadModule('controller.state');
    var inline = exports.loadModule('view.inline');

    var Retry;

    Retry = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var helpers = exports.helpers;
        var constants = exports.constants;
        var debug = helpers.debug;

        var timer;

        var EL = {
            RETRY_CONTAINER: $('retryContainer'),
            RETRY_BUTTON: $$('#retryContainer .link_retry')
        };

        var retry = {
            el: EL.RETRY_CONTAINER,
            show: function() {
                if (this.el) {
                    dt.classList.remove(this.el, 'hide');
                }
            },
            hide: function() {
                if (this.el) {
                    dt.classList.add(this.el, 'hide');
                }
            }
        };

        function showRetry() {
            exports.queue.emit('layerStatus:check');
            retry.show();
        }

        function hideRetry() {
            retry.hide();
        }

        function clearTimer() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        }

        function setTimer() {
            var pastTime = player.getCurrentTimeRound();

            clearTimer();

            timer = setTimeout(function() {
                var currentTime = player.getCurrentTimeRound();

                var isTimeout = currentTime > 0 && currentTime <= pastTime;

                inline.endSpinner();

                if (!state.ended && isTimeout) {
                    debug.log('[timeout - showRetry]', 'pastTime: ' + pastTime, 'currentTime: ' + currentTime);
                    if (state.currentVideo && state.currentVideo.type !== 'LIVE') {
                        showRetry();
                    }
                }
            }, 8 * 1000);
        }

        var listener = {
            viewEvent: function() {
                event.delegate(EL.RETRY_CONTAINER, '.link_retry', 'click', function(e) {
                    event.preventDefault(e);
                    event.stopPropagation(e);

                    hideRetry();

                    if (state.dash) {
                        shaka.unload();
                    }
                    var profile = state.dash
                        ? constants.DASH_PROFILE[state.currentVideo.profile]
                        : state.currentVideo.profile;

                    exports.queue.emit('loadAndPlay:videoById', state.currentVideo.id, profile);
                });
            }
        };

        function Retry() {}

        Retry.prototype.init = function() {
            listener.viewEvent();
        };

        Retry.prototype.showRetry = function() {
            showRetry();
        };

        Retry.prototype.hideRetry = function() {
            hideRetry();
        };

        Retry.prototype.setTimer = function() {
            setTimer();
        };

        Retry.prototype.clearTimer = function() {
            hideRetry();
            clearTimer();
        };

        Retry.prototype.resetTimer = function() {
            hideRetry();
            setTimer();
        };

        return Retry;
    })();

    exports.addModule('view.retry', new Retry());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    function Confirm() {}

    Confirm.prototype = (function() {
        var state = exports.loadModule('controller.state');
        var error = exports.loadModule('view.error');
        var pctTracker = exports.loadModule('pct.tracker');

        var $ = dt.$;
        var $$ = dt.$$;
        var ua = exports.ua;
        var event = dt.event;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var CONFIRM = constants.CONFIRM;
        var env = exports.ENV;
        var PHASE = constants.PHASE[env.phase.toUpperCase()];

        var EL = {
            CONFIRM: $('confirmView'),
            CONFIRM_INFO: $('confirmInfo'),
            COVER_IMAGE: $('coverImage2'),
            PASSWORD_FORM: $$('.pass_input form')[0],
            PASSWORD_INPUT: $('inpPass'),
            PASSWORD_BUTTON: $('btnPass'),
            PASSWORD_LABEL: $('lblPass'),
            PASSWORD_TITLE: $('titPass'),
            PURCHASE_BUTTON: $('btnPurchase'),
            PURCHASE_REPLAY: $('btnPurchaseReplay'),
            THUMBNAIL_CONTAINER: $('confirmThumbnailImageContainer'),
            THUMBNAIL_IMAGE: $('confirmThumbnailImage')
        };

        var confirmEl = {
            el: EL.CONFIRM,
            acceptCallback: function() {},
            cancelCallback: function() {},
            setOption: function(option) {
                dt.extend(this, option, true);
            },
            show: function() {
                if (this.el) {
                    dt.classList.remove(this.el, 'hide');
                }
            },
            hide: function() {
                if (this.el) {
                    dt.classList.add(this.el, 'hide');
                }
            },
            showBackground: function() {
                if (EL.COVER_IMAGE) {
                    dt.classList.remove(EL.COVER_IMAGE, 'hide');
                }
            },
            hideBackground: function() {
                if (EL.COVER_IMAGE) {
                    dt.classList.add(EL.COVER_IMAGE, 'hide');
                }
            },
            setPasswordBtnDisable: function() {
                if (EL.PASSWORD_BUTTON) {
                    dt.classList.add(EL.PASSWORD_BUTTON, 'btn_disabled');
                    dt.classList.remove(EL.PASSWORD_LABEL, 'screen_out');
                    EL.PASSWORD_BUTTON.disabled = true;
                }
            },
            setPasswordBtnEnable: function() {
                if (EL.PASSWORD_BUTTON) {
                    dt.classList.remove(EL.PASSWORD_BUTTON, 'btn_disabled');
                    dt.classList.add(EL.PASSWORD_LABEL, 'screen_out');
                    EL.PASSWORD_BUTTON.disabled = false;
                }
            },
            setPasswordTitle: function(text) {
                if (EL.PASSWORD_TITLE) {
                    EL.PASSWORD_TITLE.innerHTML = text;
                }
            },
            setPurchaseBtnText: function(text) {
                if (EL.PURCHASE_BUTTON) {
                    EL.PURCHASE_BUTTON.innerHTML = text;
                }
            },
            setThumbnailImage: function(url) {
                if (EL.THUMBNAIL_IMAGE) {
                    EL.THUMBNAIL_IMAGE.style['background'] = 'url(' + url + ')';
                    EL.THUMBNAIL_IMAGE.style['background-size'] = '100%';
                }
            },
            showThumbnailImage: function() {
                if (EL.THUMBNAIL_CONTAINER) {
                    dt.classList.remove(EL.THUMBNAIL_CONTAINER, 'hide');
                }
            }
        };

        function getConfirmStatus(code) {
            var status = CONFIRM.STATUS[code];
            var isSupportH264 = helpers.feature.supportsH264();
            var isSupportHLS = !!(helpers.feature.supportsHLSAndroid() || helpers.feature.supportsHLS());

            if (code === CONFIRM.STATUS.NeedLogin.NAME || code === CONFIRM.STATUS.NeedPassword) {
                if (ua.platform === 'mobile') {
                    if (!isSupportH264 || !isSupportHLS) {
                        status = CONFIRM.STATUS.NeedLaunchApp;
                    }
                }
            }

            return status;
        }

        function show(statusCode, info, option) {
            exports.queue.emit('spinner:end');
            exports.queue.emit('hide:cover');

            var confirmStatus = getConfirmStatus(statusCode);
            debug.info('confirmStatus', confirmStatus);

            if (!confirmStatus) {
                return;
            }

            resetConfirmView();
            error.setTemplate(confirmStatus, info, EL.CONFIRM_INFO);

            if (statusCode !== CONFIRM.STATUS.NeedLogin.NAME && statusCode === CONFIRM.STATUS.NeedPassword) {
                confirmEl.showBackground();
            }

            if (statusCode === CONFIRM.STATUS.PasswordIncorrect.NAME) {
                confirmEl.setPasswordTitle(info.message);
                confirmEl.setPasswordBtnDisable();
            }

            if (statusCode === CONFIRM.STATUS.NoPurchased.NAME || statusCode === CONFIRM.STATUS.NeedPurchased.NAME) {
                var text = ua.platform === 'mobile' ? '카카오톡에서 구매하기' : '카카오톡으로 구매하기 링크 받기';
                confirmEl.setPurchaseBtnText(text);

                if (info.preview) {
                    if (EL.PURCHASE_REPLAY) {
                        dt.classList.remove(EL.PURCHASE_REPLAY, 'hide');
                    }
                }
            }

            confirmEl.setOption(option);
            confirmEl.show();
        }

        function showConfirmThumbnailImage() {
            if (state.currentVideo && state.currentVideo.coverUrl) {
                confirmEl.setThumbnailImage(state.currentVideo.coverUrl);
            }
            confirmEl.showThumbnailImage();
        }

        function resetConfirmView() {
            var buttons = $$('.function_btn>div', EL.CONFIRM_INFO);
            for (var i = 0; i < buttons.length; i++) {
                dt.classList.add(buttons[i], 'hide');
            }
        }

        function hide() {
            confirmEl.hide();
        }

        function checkLogin(callback) {
            var _callback = function() {};

            if (typeof callback === 'function') {
                _callback = callback;
            }

            window.Kakao.Auth.getStatusInfo(function(status) {
                debug.log('Auth status', status);

                if (status !== undefined && status.status !== undefined) {
                    if (status.status === 'not_connected') {
                        window.Kakao.Auth.login({
                            persistAccessToken: false,
                            persistRefreshToken: false,
                            success: function() {
                                _callback();
                            },
                            fail: function() {
                                alert('로그인에 실패하였습니다. 다시 시도해 주세요.');
                            },
                            throughTalk: false
                        });
                    } else {
                        location.reload();
                    }
                }
            });
        }

        var listener = {
            viewEvent: function() {
                event.delegate(EL.CONFIRM, '.cancel', 'click', function() {
                    debug.log('cancel');
                    confirmEl.cancelCallback();
                    hide();
                });
                event.delegate(EL.CONFIRM, '.accept', 'click', function() {
                    debug.log('accept');
                    confirmEl.acceptCallback();
                    hide();
                });
                event.delegate(EL.CONFIRM, '.link_refresh', 'click', function() {
                    location.reload();
                });
                event.delegate(EL.CONFIRM, '.login button', 'click', function(e) {
                    if (e.target.tagName === 'BUTTON') {
                        checkLogin(function() {
                            e.target.innerHTML = '인증완료';
                            location.reload();
                        });

                        pctTracker.track('login');
                    }
                });

                event.on(EL.PASSWORD_FORM, 'submit', function(e) {
                    e.preventDefault();

                    var password = EL.PASSWORD_INPUT.value;
                    EL.PASSWORD_INPUT.value = '';
                    confirmEl.hide();

                    state.currentVideo = state.currentVideo || {};
                    state.currentVideo.playingInfo = null;
                    state.currentVideo.profile = env.profile;
                    exports.queue.emit('load:videoById', 0, true, password);

                    pctTracker.track('password', 'play');
                });

                event.delegate(EL.CONFIRM, '.inp_pass', 'input', function(e) {
                    e.preventDefault();

                    if (e.target.value) {
                        confirmEl.setPasswordBtnEnable();
                    } else {
                        confirmEl.setPasswordBtnDisable();
                    }
                });
                event.delegate(EL.CONFIRM, '.app', 'click', function() {
                    var profile = constants.PROFILE.HIGH;
                    var linkId = env.liveLinkId || env.clipLinkId;

                    helpers.web2app.launchKakaoTV(ua, linkId, profile);
                    pctTracker.track('liveapp_only');
                });
                event.delegate(EL.CONFIRM, '.btn_purchase', 'click', function(e) {
                    e.preventDefault();
                    var purchaseUrl = e.target.getAttribute('data-url');

                    if (ua.platform === 'mobile') {
                        helpers.web2app.launchTalk(purchaseUrl);
                    } else {
                        var video = state.currentVideo;
                        var templateID = PHASE === constants.PHASE.SANDBOX ? 865 : 37938;
                        var templateArgs = {};
                        templateArgs.title = video.channelName + ' - ' + video.title;
                        templateArgs.description = '영상 시청을 위해 구매가 필요합니다.';
                        templateArgs.thumbnail_url = video.coverUrl;
                        templateArgs.mobile_url = purchaseUrl;
                        var relatedData = {
                            message: '',
                            callback: function() {
                                exports.queue.emit('hide:modal');
                            }
                        };

                        helpers.kakao.sendMe(
                            templateID,
                            templateArgs,
                            function() {
                                relatedData.message = '카카오톡으로 구매 링크가 발송되었습니다.';
                                exports.queue.emit('show:notification', relatedData);
                            },
                            function() {
                                relatedData.message = '카카오톡이 연결된 카카오TV 계정 로그인이 필요합니다.';
                                exports.queue.emit('show:notification', relatedData);
                            }
                        );
                    }
                    pctTracker.track('purchase');
                });

                event.delegate(EL.CONFIRM, '.btn_replay', 'click', function() {
                    confirmEl.hide();
                    var profile = state.dash
                        ? constants.DASH_PROFILE[state.currentVideo.profile]
                        : state.currentVideo.profile;

                    exports.queue.emit('loadAndPlay:videoById', state.currentVideo.id, profile);
                });
            },
            customEvent: function(sandbox) {
                sandbox.on('show:confirm', function(data) {
                    show(data.status, data.info, data.option);

                    debug.info('show confirm');
                });

                sandbox.on('show:confirmThumbnailImage', function() {
                    showConfirmThumbnailImage();
                    debug.info('show confirmThumbnailImage');
                });
            }
        };

        return {
            init: function(player, sandbox) {
                listener.viewEvent();
                listener.customEvent(sandbox);
            },
            show: function(statusCode, info, option) {
                show(statusCode, info, option);
            }
        };
    })();

    exports.addModule('view.confirm', new Confirm());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var player = exports.loadModule('player.adapter');
    var pctTracker = exports.loadModule('pct.tracker');

    var Cast;

    Cast = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var event = dt.event;

        var ua = exports.ua;
        var helpers = exports.helpers;
        var debug = helpers.debug;

        var EL = {
            TV_CAST_BOX: $$('.cast_tv')[0],
            AIRPLAY: $('airplay'),
            CHROMECAST: $('chromecast'),
            CHROMECAST_BOX: $$('.box_chromecast')[0],
            CONNECTED_DEVICE_TEXT: $$('.connected_device')[0]
        };

        var cast = {
            castBox: {
                el: EL.TV_CAST_BOX,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                }
            },
            chromecastBox: {
                el: EL.CHROMECAST_BOX,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                }
            },
            airplay: {
                el: EL.AIRPLAY,
                show: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'hide');
                    }
                },
                hide: function() {
                    if (this.el) {
                        dt.classList.add(this.el, 'hide');
                    }
                },
                connected: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'disconnected');
                        dt.classList.add(this.el, 'connected');
                    }
                },
                disconnected: function() {
                    if (this.el) {
                        dt.classList.remove(this.el, 'connected');
                        dt.classList.add(this.el, 'disconnected');
                    }
                }
            },
            text: {
                setConnectedDeviceText: function(device) {
                    if (EL.CONNECTED_DEVICE_TEXT) {
                        EL.CONNECTED_DEVICE_TEXT.innerText = device;
                    }
                }
            }
        };

        var listener = {
            viewEvent: function() {
                if (ua.platform === 'pc') {
                    var videoElement = player.videoElement;

                    if (window.WebKitPlaybackTargetAvailabilityEvent) {
                        videoElement.addEventListener('webkitplaybacktargetavailabilitychanged', function(event) {
                            debug.log('[AirPlay Event] airplay button state: ', event.availability);

                            switch (event.availability) {
                                case 'available':
                                    cast.castBox.show();
                                    cast.airplay.disconnected();
                                    cast.airplay.show();
                                    break;
                                case 'not-available':
                                    cast.airplay.hide();
                                    break;
                            }
                        });
                    }

                    if (EL.TV_CAST_BOX) {
                        event.on(EL.TV_CAST_BOX, 'click', function(e) {
                            if (e.target === EL.AIRPLAY) {
                                if (!window.WebKitPlaybackTargetAvailabilityEvent) {
                                    return;
                                }

                                videoElement.webkitShowPlaybackTargetPicker();

                                pctTracker.track('airplay');
                            }

                            if (e.target === EL.CHROMECAST) {
                                pctTracker.track('chromecast');
                            }
                        });
                    }
                }
            }
        };

        function Cast() {}

        Cast.prototype.init = function() {
            listener.viewEvent();
        };

        Cast.prototype.showBox = function() {
            cast.castBox.show();
        };

        Cast.prototype.hideBox = function() {
            cast.castBox.hide();
        };

        Cast.prototype.showChromecastBox = function() {
            cast.chromecastBox.show();
        };

        Cast.prototype.hideChromecastBox = function() {
            cast.chromecastBox.hide();
        };

        Cast.prototype.showConnected = function() {
            cast.airplay.connected();
        };

        Cast.prototype.showDisconnected = function() {
            cast.airplay.disconnected();
        };

        Cast.prototype.setConnectedDeviceText = function(device) {
            cast.text.setConnectedDeviceText(device);
        };

        return Cast;
    })();

    exports.addModule('view.cast', new Cast());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var inline = exports.loadModule('view.inline');
    var completion = exports.loadModule('view.completion');
    var mediaSession = exports.loadModule('media.session');
    var state = exports.loadModule('controller.state');

    var ImaAds;

    ImaAds = (function() {
        var $ = dt.$;
        var ua = exports.ua;
        var helpers = exports.helpers;
        var debug = helpers.debug;

        var adsLoader;
        var adsManager;
        var adDisplayContainer;
        var videoEndedCallback;
        var videoContent;
        var adsDone = false;
        var contentCompleteCalled = false;
        var googleIma = window.google && window.google.ima;

        var IMAERRORCODE = {
            VAST_EMPTY_RESPONSE: 1009
        };

        var PAT = {
            URL_LIST: {},
            PARAM: {},
            EVENT: {
                IMPRESSION: 'impression',
                START: 'start',
                SKIP: 'skip',
                CLICK: 'click',
                COMPLETE: 'complete',
                FIRST_QUARTILE: 'firstQuartile',
                MID_POINT: 'midpoint',
                THIRD_QUARTILE: 'thirdQuartile',
                PAUSE: 'pause',
                RESUME: 'resume',
                PROGRESS: 'progress',
                ERROR: 'error'
            }
        };

        var TAG_URL = {
            LINEAR_PC_VOD:
                'https://googleads.g.doubleclick.net/pagead/ads?' +
                'client=ca-video-pub-3302927352513848&' +
                'slotname=9888066795&' +
                'ad_type=skippablevideo&' +
                'description_url=https%3A%2F%2Ftv.kakao.com&' +
                'videoad_start_delay=0'
        };

        var EL = {
            AD_CONTAINER: $('adContainer')
        };

        var videoAdUI = {
            el: EL.AD_CONTAINER,
            show: function() {
                dt.classList.remove(this.el, 'hidden');
                dt.classList.add(this.el, 'visible');
            },
            hide: function() {
                dt.classList.remove(this.el, 'visible');
                dt.classList.add(this.el, 'hidden');
            }
        };

        function onAdError(adErrorEvent) {
            var error = adErrorEvent.getError();
            var errorCode = error.getErrorCode();
            var errorMessage = error.getMessage();

            if (adsManager) {
                adsManager.destroy();
            }
            if (typeof videoEndedCallback === 'function') {
                videoEndedCallback();
            }

            if (errorCode === IMAERRORCODE.VAST_EMPTY_RESPONSE) {
                debug.warn('Ad event: Error ', errorMessage);
            } else {
                debug.error('Ad event: Error Code = ', errorCode, errorMessage);
            }
        }

        function normalizeURL(eventName) {
            var trackUrl = PAT.URL_LIST[eventName] && PAT.URL_LIST[eventName].url;

            if (!trackUrl) {
                return;
            }

            if (PAT.URL_LIST[eventName] && eventName !== PAT.EVENT.PAUSE && eventName !== PAT.EVENT.RESUME) {
                delete PAT.URL_LIST[eventName];
            }

            if (!PAT.PARAM.mediaUrl) {
                var currentAdData = adsManager.getCurrentAd();
                PAT.PARAM.duration = currentAdData.getDuration();
                PAT.PARAM.skipOffset = currentAdData.getSkipTimeOffset();
                PAT.PARAM.mediaUrl = encodeURIComponent(currentAdData.getMediaUrl());
            }

            debug.info('normalizeURL eventName = ' + eventName);

            trackUrl = trackUrl
                .replace('[DURATION]', PAT.PARAM.duration)
                .replace('[SKIPOFFSET]', PAT.PARAM.skipOffset)
                .replace('[MEDIAURL]', PAT.PARAM.mediaUrl);

            return trackUrl;
        }

        function track(eventName) {
            var trackUrl = normalizeURL(eventName);

            if (!trackUrl) {
                return;
            }

            helpers.http.sendBeacon(trackUrl);

            debug.info('pat event', eventName, trackUrl);
        }

        function contentEndedListener() {
            contentCompleteCalled = true;
            adsLoader.contentComplete();

            if (typeof videoEndedCallback === 'function') {
                videoEndedCallback();
            }
        }

        function onContentPauseRequested() {
            debug.info('Ad event: CONTENT_PAUSE_REQUESTED');
            videoContent.pause();
            videoContent.removeEventListener('ended', contentEndedListener);
        }

        function onContentResumeRequested() {
            debug.info('Ad event: CONTENT_RESUME_REQUESTED');
            videoContent.addEventListener('ended', contentEndedListener);

            if (!contentCompleteCalled) {
                videoContent.play();
            }
        }

        function startAds() {
            adsManager.init('100%', '100%', googleIma.ViewMode.NORMAL);
            adsManager.start();
        }

        function updateMediaSessionMetadata() {
            var title = '광고 재생 중입니다.';
            var artist = '';
            var isPlayGdn = true;

            mediaSession.updateMetadata(title, artist, isPlayGdn);
        }

        function onAdsManagerLoaded(adsManagerLoadedEvent) {
            var adsRenderingSettings = new googleIma.AdsRenderingSettings();
            // Tell the SDK NOT to save and restore content video state on our behalf.
            adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = false;

            adsManager = adsManagerLoadedEvent.getAdsManager(videoContent, adsRenderingSettings);

            var googleAdEventType = googleIma.AdEvent.Type;
            var googleAdErrorEventType = googleIma.AdErrorEvent.Type;

            adsManager.addEventListener(googleAdErrorEventType.AD_ERROR, onAdError);

            adsManager.addEventListener(googleAdEventType.IMPRESSION, function() {
                debug.info('gdn event - impression');

                state.onIma = true;

                track(PAT.EVENT.IMPRESSION);
            });

            adsManager.addEventListener(googleAdEventType.STARTED, function() {
                debug.info('gdn event - started');
                updateMediaSessionMetadata();

                inline.hideBlind();
                inline.endSpinner();
                completion.hideCompletion();
                exports.queue.emit('hide:action');
                track(PAT.EVENT.START);
            });

            adsManager.addEventListener(googleAdEventType.SKIPPED, function() {
                debug.info('gdn event - skipped');

                track(PAT.EVENT.SKIP);
            });

            adsManager.addEventListener(googleAdEventType.AD_PROGRESS, function(e) {
                track(PAT.EVENT.PROGRESS + '-' + Math.round(e.getAdData().currentTime));
            });

            adsManager.addEventListener(googleAdEventType.CLICK, function() {
                debug.info('gdn event - click');

                track(PAT.EVENT.CLICK);
            });

            adsManager.addEventListener(googleAdEventType.COMPLETE, function() {
                debug.info('gdn event - complete');

                track(PAT.EVENT.COMPLETE);
            });

            adsManager.addEventListener(googleAdEventType.FIRST_QUARTILE, function() {
                debug.info('gdn event - first quartile');

                track(PAT.EVENT.FIRST_QUARTILE);
            });

            adsManager.addEventListener(googleAdEventType.MIDPOINT, function() {
                debug.info('gdn event - midpoint');

                track(PAT.EVENT.MID_POINT);
            });

            adsManager.addEventListener(googleAdEventType.THIRD_QUARTILE, function() {
                debug.info('gdn event - third quartile');

                track(PAT.EVENT.THIRD_QUARTILE);
            });

            adsManager.addEventListener(googleAdEventType.CONTENT_PAUSE_REQUESTED, onContentPauseRequested);

            adsManager.addEventListener(googleAdEventType.CONTENT_RESUME_REQUESTED, onContentResumeRequested);

            adsManager.addEventListener(googleAdEventType.LOADED, function() {
                videoAdUI.show();
            });

            adsManager.addEventListener(googleAdEventType.PAUSED, function() {
                mediaSession.setPlaybackState(true);
                track(PAT.EVENT.PAUSE);
            });

            adsManager.addEventListener(googleAdEventType.RESUMED, function() {
                inline.endSpinner();
                mediaSession.setPlaybackState(false);
                track(PAT.EVENT.RESUME);
            });

            adsManager.addEventListener(googleAdEventType.ALL_ADS_COMPLETED, function() {
                debug.info('gdn event - all ads complete');

                adsManager.destroy();

                if (typeof videoEndedCallback === 'function') {
                    videoEndedCallback();
                }
            });

            startAds();
            videoAdUI.show();
        }

        function initialImaAds() {
            debug.info('initialImaAds');

            googleIma.settings.setLocale('ko');

            if (ua.os.ios && ua.os.version.major >= 10 && ua.platform === 'mobile') {
                googleIma.settings.setDisableCustomPlaybackForIOS10Plus(true);
            }

            adDisplayContainer = new googleIma.AdDisplayContainer(EL.AD_CONTAINER, videoContent);
            adsLoader = new googleIma.AdsLoader(adDisplayContainer);

            adsLoader.addEventListener(
                googleIma.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
                onAdsManagerLoaded,
                false
            );

            adsLoader.addEventListener(googleIma.AdErrorEvent.Type.AD_ERROR, onAdError, false);
        }

        function initialUserAction() {
            adDisplayContainer.initialize();
            videoContent.load();
        }

        var listener = {
            customEvent: function(sandbox) {
                sandbox.on('play:ima', function() {
                    if (adsManager) {
                        adsManager.resume();
                    }
                });

                sandbox.on('pause:ima', function() {
                    if (adsManager) {
                        adsManager.pause();
                    }
                });
            }
        };

        function ImaAds() {}

        ImaAds.prototype.init = function(player, sandbox) {
            videoContent = player.videoElement;
            listener.customEvent(sandbox);
        };

        ImaAds.prototype.setup = function(callback) {
            videoEndedCallback = callback;

            if (googleIma && !adsDone) {
                initialImaAds();
                initialUserAction();
                adsDone = true;
            }
        };

        ImaAds.prototype.setTracker = function(trackingList) {
            var eventName, url;

            trackingList.forEach(function(item) {
                eventName = item.event;
                url = item.value;

                if (eventName === 'progress') {
                    var offset = helpers.string.stringToSec(item.offset);
                    eventName = eventName + '-' + offset;
                }

                PAT.URL_LIST[eventName] = {};
                PAT.URL_LIST[eventName].url = url;
            });
        };

        ImaAds.prototype.destroy = function() {
            if (googleIma && adsManager) {
                adsManager.destroy();
                this.hide();
            }
        };

        ImaAds.prototype.requestAds = function() {
            if (googleIma) {
                this.destroy();

                var adsRequest = new googleIma.AdsRequest();
                adsRequest.adTagUrl = TAG_URL.LINEAR_PC_VOD;
                adsLoader.requestAds(adsRequest);
            }
        };

        ImaAds.prototype.hide = function() {
            if (googleIma) {
                videoAdUI.hide();
            }
        };

        return ImaAds;
    })();

    exports.addModule('controller.ima', new ImaAds());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var AdController;

    AdController = (function() {
        var adParser = exports.loadModule('ads.parser');
        var inline = exports.loadModule('view.inline');
        var adBean = exports.loadModule('model.ad');
        var state = exports.loadModule('controller.state');
        var queue = exports.loadModule('playlist.queue');
        var cover = exports.loadModule('view.cover');
        var imaAds = exports.loadModule('controller.ima');
        var player = exports.loadModule('player.adapter');
        var shaka = exports.loadModule('player.shaka');
        var dataloader = exports.loadModule('playlist.dataloader');

        var helpers = exports.helpers;
        var debug = helpers.debug;
        var ua = exports.ua;
        var constants = exports.constants;

        function activateAdControl() {
            state.seekEnabled = false;
            state.adControlActivated = true;

            inline.showAd();

            if (ua.platform === 'pc') {
                inline.hideControlHead();
            }
        }

        function inactivateAdControl() {
            state.seekEnabled = true;
            state.adControlActivated = false;
            inline.hideAd();
        }

        function getNonLinearAd() {
            var overlayAds = queue.overlayAds;
            var overlayAd;

            for (var i = 0; i < overlayAds.length; i++) {
                overlayAd = overlayAds[i].customObject.MidTextAd || overlayAds[i].customObject.RemindBanner;
                if (overlayAd) {
                    break;
                }
            }
            return overlayAd;
        }

        function showNonLinearAd() {
            inline.showNonLinearAd();
        }

        function hideNonLinearAd() {
            inline.hideNonLinearAd();
        }

        function setupNonLinearAd() {
            var nonLinearAd = getNonLinearAd();
            if (nonLinearAd) {
                inline.setupNonLinearAd(nonLinearAd);
            }
        }

        function setupMidrollAd() {
            var midrollReq = state.currentVideo.midrollReq;
            if (midrollReq) {
                midrollReq.forEach(function(v, i) {
                    inline.setupMidrollAd(i, v.isStarted, helpers.string.stringToSec(v['@_timeOffset']));
                });
            }
        }

        function pauseNonLinearAd() {
            if (state.isNonLinearAdShown) {
                inline.pauseNonLinearAd();
            }
        }

        function resumeNonLinearAd() {
            if (state.isNonLinearAdShown) {
                inline.resumeNonLinearAd();
            }
        }

        function checkNonLinearAd(currentTime, duration) {
            var nonLinearAd = getNonLinearAd();
            var displayPer = nonLinearAd.DisplayPer > 0 ? nonLinearAd.DisplayPer : 1;
            var displaySec = parseInt((duration * displayPer) / 100);
            var adType;

            debug.info('Check NonLinear Ad - time(sec): ' + displaySec + '/' + currentTime + '(display/current)');

            if (!nonLinearAd || state.isNonLinearAdShown || state.modalContentActivated) {
                return;
            }

            if (currentTime === displaySec) {
                if (nonLinearAd.Title) {
                    adType = 'text';
                } else if (nonLinearAd.BannerUrl) {
                    adType = 'image';
                }

                if (adType) {
                    state.isNonLinearAdShown = true;
                    inline.showNonLinearAd(true, adType);
                }
            }
        }

        function checkMidrollAd(isSeeking, callback) {
            var midrollReq = state.currentVideo.midrollReq;
            var currentTime = player.getCurrentTimeRound();
            var offsetArray = [];

            midrollReq.forEach(function(v) {
                offsetArray.push(helpers.string.stringToSec(v['@_timeOffset']));
            });

            for (var i = 0; i < offsetArray.length; i++) {
                if ((!isSeeking && offsetArray[i] === currentTime) || (isSeeking && offsetArray[i] < currentTime)) {
                    if (
                        (offsetArray[i + 1] && currentTime < offsetArray[i + 1]) ||
                        typeof offsetArray[i + 1] === 'undefined'
                    ) {
                        state.midrollIndex = i;
                        if (!midrollReq[i].isStarted) {
                            fetchMidroll().then(function() {
                                callback();
                            });
                        }
                        break;
                    }
                }
            }
        }

        function fetchAds(clip) {
            return dataloader.fetchVmap(clip.vmapReq);
        }

        function fetchVastAd(adReq) {
            return new Promise(function(resolve, reject) {
                debug.info('%c%s', 'color: #20b408', '7. [adController] fetch vast', adReq);
                var isRejectedAutoplay = !queue.contents.length && !state.isPrerollEnded;

                if (isRejectedAutoplay || !helpers.device.isSupportAd(ua) || !adReq) {
                    resolve();
                    return;
                }

                state.isVastRequesting = true;
                dataloader
                    .fetchVast(adReq)
                    .then(resolve)
                    .catch(reject);
            });
        }

        function fetchPreroll() {
            var clip = state.currentVideo;

            return new Promise(function(resolve, reject) {
                if (queue.prerolls.length > 0 || state.isPrerollEnded) {
                    resolve();
                    return;
                }

                fetchVastAd(clip.prerollReq)
                    .then(function() {
                        clip.prerollReq = null;
                        queue.enqueueArray(queue.prerolls);
                        resolve();
                    })
                    .catch(function() {
                        reject();
                    });
            });
        }

        function fetchMidroll() {
            return new Promise(function(resolve) {
                debug.info(
                    '%c%s',
                    'color: #2074c0;',
                    'Midroll fetchMidroll - state.midrollIndex ',
                    state.midrollIndex,
                    ', midroll playingTime',
                    dt.StopWatch.has('midrollPlayingTime')
                );

                fetchVastAd(state.currentVideo.midrollReq[state.midrollIndex]).then(function() {
                    if (queue.midrolls.length > 0) {
                        queue.enqueueArray(queue.midrolls.shift());
                        player.setTime(player.getCurrentTime());
                        dt.StopWatch.stop('midrollPlayingTime');
                        exports.queue.emit('close:menubox');
                        exports.queue.emit('close:settingbox');
                        exports.queue.emit('hide:modal');
                        if (state.dash) {
                            shaka.detach().then(resolve);
                        } else {
                            resolve();
                        }
                    }
                });
            });
        }

        function fetchPostroll() {
            var clip = state.currentVideo;
            return fetchVastAd(clip.postrollReq).then(function() {
                queue.enqueueArray(queue.postrolls);
            });
        }

        function fetchSdkData(sdkDataUrl) {
            return new Promise(function(resolve, reject) {
                helpers.http
                    .fetch(sdkDataUrl, {
                        async: false,
                        type: constants.HTTP.TYPE.JSON,
                        credentials: 'include',
                        method: constants.HTTP.METHOD.GET
                    })
                    .then(resolve)
                    .catch(reject);
            });
        }

        function updateMidrollState() {
            state.currentVideo.midrollReq[state.midrollIndex].isStarted = true;
            inline.setupMidrollAd(state.midrollIndex, true);
        }

        function getSdkAdData(sdkAdUrls) {
            return new Promise(function(resolve, reject) {
                if (sdkAdUrls) {
                    fetchSdkData(sdkAdUrls)
                        .then(function(data) {
                            if (data.dsp === 'gdn' && helpers.device.isIMASupportedBrowser(ua)) {
                                imaAds.setTracker(data.tracking_list);
                                loadGdnAd(resolve);
                            } else {
                                resolve();
                            }
                        })
                        .catch(function(e) {
                            debug.warn('Failed fetchSdkData e = ', e);
                            reject();
                        });
                } else {
                    resolve();
                }
            });
        }

        function loadGdnAd(callback) {
            imaAds.setup(callback);
            cover.hideCover();
            inline.startSpinner();
            imaAds.requestAds();
        }

        function getSdkAds(extension) {
            var sdkAds = [];

            extension.forEach(function(v) {
                if (v['@_type'] === 'sdk' && v.SdkAdData) {
                    sdkAds.push(v.SdkAdData);
                }
            });

            return sdkAds;
        }

        var adRequestSetter = {
            preroll: function(adBreak, clipBean) {
                clipBean.prerollReq = adBreak;
                if (adBreak.extensions && adBreak.extensions.extension && adBreak.extensions.extension.length > 0) {
                    queue.sdkAds = getSdkAds(adBreak.extensions.extension);
                }
            },
            midroll: function(adBreak, clipBean) {
                adBreak.isStarted = false;
                adBreak.index = clipBean.midrollReq.length;
                clipBean.midrollReq.push(adBreak);
            },
            postroll: function(adBreak, clipBean) {
                clipBean.postrollReq = adBreak;
            }
        };

        function resolveVmap(response) {
            var clipBean = state.currentVideo;
            var vmap = adParser.parseVmap(response);
            var adBreaks = vmap.adBreak;

            if (!adBreaks) {
                debug.info('adBreaks is empty');
                return;
            }

            for (var i = 0; i < adBreaks.length; i++) {
                var adBreak = adBreaks[i];
                var breakId = adBreak['@_breakId'];

                if (adRequestSetter.hasOwnProperty(breakId)) {
                    adRequestSetter[breakId](adBreak, clipBean);
                }
            }
        }

        var adQueueSetter = {
            preroll: function(adClipBean) {
                if (adClipBean.creative.linear) {
                    queue.prerolls.push(adClipBean);
                }

                if (adClipBean.extension) {
                    for (var i = 0; i < adClipBean.extension.length; i++) {
                        queue.overlayAds.push(adClipBean.extension[i]);
                    }
                }
            },
            midroll: function(adClipBean) {
                queue.midrolls.push(adClipBean);
            },
            postroll: function(adClipBean) {
                queue.postrolls.push(adClipBean);
            }
        };

        function insertAdQueue(adClipBean) {
            var breakId = adClipBean.breakId;

            if (adQueueSetter.hasOwnProperty(breakId)) {
                adQueueSetter[breakId](adClipBean);
            }
        }

        function validateAvailableAd(creatives, errorUrls) {
            var adAvailableList = ['linear', 'creativeExtensions'];
            var creativeKeys = Object.keys(creatives);

            if (!errorUrls || !creativeKeys) {
                return;
            }

            for (var i = 0; i < creativeKeys.length; i++) {
                if (adAvailableList.indexOf(creativeKeys[i]) < 0) {
                    var errorUrl = JSON.parse(JSON.stringify(errorUrls));
                    for (var k = 0; k < errorUrl.length; k++) {
                        var sendUrl = errorUrl[k]['@_uri'].replace('[ERRORCODE]', '200');
                        helpers.http.sendBeacon(sendUrl);
                    }
                }
            }
        }

        function setAdClipBean(data) {
            var creative = data.creative;
            var linear = creative.linear;
            var skipOffset;
            var adIndexLabel;
            var clickThrough;
            var clickTrackings;
            var videoUrl;
            var icon;
            var creativeExtension = creative.creativeExtensions ? creative.creativeExtensions.creativeExtension : null;

            if (linear) {
                if (linear.mediaFiles.mediaFile) {
                    videoUrl = linear.mediaFiles.mediaFile[0]['@_uri'];
                }
                if (linear.videoClicks) {
                    clickThrough = linear.videoClicks.clickThrough;
                    clickTrackings = linear.videoClicks.clickTracking;
                }

                if (linear.icons) {
                    icon = linear.icons.icon;
                }

                if (linear['@_skipoffset']) {
                    skipOffset = helpers.string.stringToSec(linear['@_skipoffset']);
                    adIndexLabel = 'ad_' + skipOffset;
                }
            }

            adBean.set({
                id: data.adId,
                videoUrl: videoUrl,
                breakId: data.breakId,
                breakType: data.breakType,
                timeOffset: data.timeOffset,
                skipOffset: skipOffset,
                ad: data.ad,
                creative: data.creative,
                extension: creativeExtension,
                clickThrough: clickThrough,
                clickTracking: clickTrackings,
                dsp: data.advertiser,
                adIndexLabel: adIndexLabel,
                icon: icon
            });

            insertAdQueue(adBean);
            debug.info('%c%s', 'color: #20b408', '[adController] set adClipBean');
            debug.table(adBean);
        }

        function resolveVast(request, response) {
            var vast = adParser.parseVast(response);
            var ads = vast.ad;

            if (!ads) {
                debug.info('ad is empty');
                return;
            }

            for (var i = 0; i < ads.length; i++) {
                var ad = ads[i];
                var inline = ad.inline;
                var creatives = inline.creatives.creative;

                if (creatives) {
                    creatives.forEach(function(creative) {
                        validateAvailableAd(creative, inline.error);
                        setAdClipBean({
                            ad: ad,
                            adIndex: i,
                            adId: ad['@_id'],
                            advertiser: inline.advertiser,
                            breakId: request['@_breakId'],
                            breakType: request['@_breakType'],
                            timeOffset: request['@_timeOffset'],
                            creative: creative
                        });
                    });
                }
            }
        }

        var listener = {
            customEvent: function(sandbox) {
                sandbox.on('show:modal', function() {
                    inline.hideNonLinearAdContainer();
                });

                sandbox.on('hide:modal', function() {
                    inline.showNonLinearAdContainer();
                });

                sandbox.on('show:completion', function() {
                    inline.hideNonLinearAdContainer();
                });

                sandbox.on('hide:completion', function() {
                    inline.showNonLinearAdContainer();
                });

                sandbox.on('show:nonelinear', function() {
                    inline.showNonLinearAdContainer();
                });

                sandbox.on('hide:nonelinear', function() {
                    inline.hideNonLinearAdContainer();
                });
            }
        };

        function AdController() {}

        AdController.prototype.init = function(player, sandbox) {
            listener.customEvent(sandbox);
        };

        AdController.prototype.setupAdControl = function() {
            inline.setupAdControl();
            inline.setupAd();
        };

        AdController.prototype.activateAdControl = function() {
            activateAdControl();
        };

        AdController.prototype.inactivateAdControl = function() {
            inactivateAdControl();
        };

        AdController.prototype.showLinearAdContainer = function() {
            inline.showLinearAdContainer();
        };

        AdController.prototype.hideLinearAdContainer = function() {
            inline.hideLinearAdContainer();
        };

        AdController.prototype.showNonLinearAd = function() {
            showNonLinearAd();
        };

        AdController.prototype.hideNonLinearAd = function() {
            hideNonLinearAd();
        };

        AdController.prototype.checkNonLinearAd = function(currentTime, duration) {
            checkNonLinearAd(currentTime, duration);
        };

        AdController.prototype.checkMidrollAd = function(isSeeking, callback) {
            checkMidrollAd(isSeeking, callback);
        };

        AdController.prototype.updateMidrollState = function() {
            updateMidrollState();
        };

        AdController.prototype.setupNonLinearAd = function() {
            setupNonLinearAd();
        };

        AdController.prototype.setupMidrollAd = function() {
            setupMidrollAd();
        };

        AdController.prototype.pauseNonLinearAd = function() {
            pauseNonLinearAd();
        };

        AdController.prototype.resumeNonLinearAd = function() {
            resumeNonLinearAd();
        };

        AdController.prototype.resolveVmap = function(request) {
            resolveVmap(request);
        };

        AdController.prototype.resolveVast = function(request, response) {
            resolveVast(request, response);
        };

        AdController.prototype.fetchAds = function(bean) {
            return fetchAds(bean);
        };

        AdController.prototype.fetchPostroll = function() {
            return fetchPostroll();
        };

        AdController.prototype.fetchPreroll = function() {
            return fetchPreroll();
        };

        AdController.prototype.getSdkAdData = function(sdkAdUrls) {
            return getSdkAdData(sdkAdUrls);
        };

        return AdController;
    })();

    exports.addModule('controller.ad', new AdController());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';
    var dataloader = exports.loadModule('playlist.dataloader');
    var actionView = exports.loadModule('view.action');

    var ActionController;

    ActionController = (function() {
        var helpers = exports.helpers;
        var debug = helpers.debug;

        function load(url) {
            fetchAction(url)
                .then(function(action) {
                    completeAction(action);
                    exports.queue.emit('show:action');
                })
                .catch(function(e) {
                    debug.error('fetchAction error = ', e);
                });
        }

        function fetchAction(url) {
            return dataloader.getAction(url);
        }

        function completeAction(action) {
            if (action.actionButton && action.actionButton !== null) {
                actionView.setButton(action);
            }
        }

        function ActionController() {}

        ActionController.prototype.init = function() {};

        ActionController.prototype.load = function(url) {
            load(url);
        };

        return ActionController;
    })();

    exports.addModule('controller.action', new ActionController());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports, dt) {
    'use strict';

    var cover = exports.loadModule('view.cover');
    var error = exports.loadModule('view.error');
    var queue = exports.loadModule('playlist.queue');
    var tracker = exports.loadModule('etc.tracker');
    var state = exports.loadModule('controller.state');
    var shaka = exports.loadModule('player.shaka');
    var player = exports.loadModule('player.adapter');
    var dataloader = exports.loadModule('playlist.dataloader');
    var imaAds = exports.loadModule('controller.ima');
    var inline = exports.loadModule('view.inline');
    var inlinePC = exports.loadModule('view.inline.pc');
    var extension = exports.loadModule('view.extension');
    var completion = exports.loadModule('view.completion');
    var confirmView = exports.loadModule('view.confirm');
    var pvtTracker = exports.loadModule('pvt.tracker');
    var adController = exports.loadModule('controller.ad');
    var actionController = exports.loadModule('controller.action');

    var Controller;

    Controller = (function() {
        var $ = dt.$;
        var $$ = dt.$$;
        var ua = exports.ua;
        var env = exports.ENV;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;

        var PHASE = constants.PHASE[env.phase.toUpperCase()];
        var APP_KEY = constants.APP_KEY[PHASE];
        var ERROR_STATUS = constants.ERROR.STATUS;
        var CONFIRM_STATUS = constants.CONFIRM.STATUS;
        var AGE_LIMIT = constants.AGE_LIMIT;

        function isSupportedCodecWindows() {
            var isSupportH264 = helpers.feature.supportsH264();
            return !(ua.platform === 'pc' && ua.os.windows && !isSupportH264);
        }

        function showError(info, option) {
            var code = info.code;
            inline.endSpinner();
            error.showError(code, info, option);
        }

        function showConfirm(option) {
            var MESSAGE_COOKIE_NAME = constants.STORAGE.ALERT_MSG;
            var isVisibleMsg = true;

            var defaults = {
                status: {},
                accept: function() {},
                cancel: function() {}
            };

            dt.extend(defaults, option, true);

            if (defaults.status.NAME === CONFIRM_STATUS.CARRIER.NAME) {
                isVisibleMsg = helpers.store.get(MESSAGE_COOKIE_NAME) !== '1';
            }

            if (isVisibleMsg) {
                if (env.isInternal) {
                    confirmView.show(
                        defaults.status.NAME,
                        {},
                        {
                            acceptCallback: function() {
                                helpers.store.set(MESSAGE_COOKIE_NAME, '1', 2);
                                return defaults.accept();
                            },
                            cancelCallback: function() {
                                return defaults.cancel();
                            }
                        }
                    );
                } else {
                    if (confirm(defaults.status.DESCRIPTION.replace('<br />', ''))) {
                        helpers.store.set(MESSAGE_COOKIE_NAME, '1', 2);
                        return defaults.accept();
                    } else {
                        return defaults.cancel();
                    }
                }
            } else {
                return defaults.accept();
            }
        }

        function alert3G4G(status, callback) {
            var isWifi = helpers.webapi.network.isWifi();
            var isShowConfirm =
                ua.platform !== 'pc' && !helpers.device.isFacebookWebview() && !isWifi && env.showConfirm;

            if (isShowConfirm) {
                return showConfirm({
                    status: status,
                    accept: function() {
                        callback();
                    },
                    cancel: function() {
                        cover.showCover();
                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayCancel);
                    }
                });
            } else {
                error.hideError();
                callback();
            }
        }

        function checkLoadedVideo(callback) {
            var interval = setInterval(function() {
                if (player.videoElement.readyState > 0 || state.playerClass === constants.PLAYERCLASS.KAMP) {
                    if (typeof callback === 'function') {
                        callback();
                    }
                    clearInterval(interval);
                }
            }, 50);
        }

        function shakaLoadCallback() {
            shaka.getOutputs(function(outputList) {
                if (!state.currentVideo.originOutputList) {
                    state.currentVideo.originOutputList = state.currentVideo.outputList;
                }
                state.currentVideo.outputList = outputList;

                if (ua.platform === 'pc') {
                    inlinePC.onLoadStart();
                } else {
                    extension.createProfileList(state.currentVideo.outputList);
                    extension.setProfile(state.currentVideo.profile);
                    inline.setProfile(state.currentVideo.profile);
                    inline.onLoadStart();
                }
            });
        }

        function loadFlashPlayer() {
            location.href = location.href + '&flash=1';
        }

        function loadVideoResource(clip, callback) {
            debug.info(
                '%c%s',
                'color: #FF5722; font-weight: bold;',
                '------- load video resource -------',
                clip.videoUrl
            );

            var videoUrl = clip.videoUrl;
            var overlayAds = queue.overlayAds;

            state.ended = state.allAdsCompleted;
            state.isCheckNextVideo = false;

            var loadDatas = {
                videoUrl: videoUrl,
                playerClass: null,
                callback: null
            };

            loadDatas.playerClass = state.playerClass = constants.PLAYERCLASS.HTML5;

            if (state.currentVideo.type === 'LIVE' && ua.platform === 'pc') {
                if (player.isKampSupported() || player.isSupportedLiveAgentHLS()) {
                    if (clip.type !== 'AD') {
                        loadDatas.playerClass = state.playerClass = constants.PLAYERCLASS.KAMP;
                    }
                } else {
                    loadFlashPlayer();
                    return;
                }
            } else if (state.dash && clip.type !== 'AD') {
                loadDatas.playerClass = state.playerClass = constants.PLAYERCLASS.SHAKA;
                loadDatas.callback = shakaLoadCallback;
            } else if (helpers.tv.isConnected()) {
                loadDatas.playerClass = state.playerClass = constants.PLAYERCLASS.CAST;
                loadDatas.remote = {
                    videoInfo: {
                        url: videoUrl,
                        mediaType: constants.MEDIA_TYPE.MP4
                    }
                };
            }

            tracker.setTracker(clip);
            if (overlayAds) {
                tracker.setNonLinearTracker(overlayAds);
            }

            player.load(loadDatas);

            checkLoadedVideo(function() {
                if (typeof callback === 'function') {
                    callback();
                }
            });
        }

        function loadReadyAndPlay(id, profile, fbId, isReplay) {
            return fetchReadyAndPlay(id, profile, fbId).then(function(readyAndPlay) {
                setReadyAndPlay(id, readyAndPlay, isReplay);
            });
        }

        function loadMeta() {
            fetchMeta().then(function() {
                onCompleteMeta();
                var clipBean = state.currentVideo;

                if (ua.platform !== 'pc') {
                    if (state.dash) {
                        shaka.getOutputs(function(outputList) {
                            clipBean.outputList = outputList;
                            setProfile(clipBean.outputList, clipBean.profile);
                        });
                    } else {
                        setProfile(clipBean.outputList, clipBean.profile);
                    }
                }
            });
        }

        function fetchMeta() {
            var video = state.currentVideo;
            var metaUrl = video.metaUrl;

            return new Promise(function(resolve, reject) {
                dataloader
                    .getMeta(metaUrl, video.type)
                    .then(function(meta) {
                        appendBean(meta);
                        resolve(meta);
                    })
                    .catch(function(e) {
                        debug.log('Meta server error', e);
                        reject(e);
                    });
            });
        }

        function appendBean(meta) {
            var video = state.currentVideo;
            if (video.type === constants.VIDEO_TYPE.VOD) {
                appendClipBean(meta);
            } else if (video.type === constants.VIDEO_TYPE.LIVE) {
                appendLiveBean(meta);
            }
        }

        function stopVideo() {
            var isAutoPlay = false;
            var startTime = 0;

            try {
                imaAds.destroy();
                adController.inactivateAdControl();
            } catch (e) {
                debug.error(e);
            }

            player.stop();
            exports.queue.emit('load:videoById', startTime, isAutoPlay);
        }

        function playVideo() {
            var timing = player.videoElement.getAttribute('data-current-time');

            if (isAgeLimit() && state.isFirstPlay && !timing) {
                var ageLimit = state.currentVideo.ageLimit;
                var ageLimitErrorName;

                if (ageLimit === AGE_LIMIT.AGE_18.name) {
                    ageLimitErrorName = ERROR_STATUS.Age18.NAME;
                } else {
                    ageLimitErrorName = ERROR_STATUS.Age19.NAME;
                }

                error.showError(ageLimitErrorName, {});

                setTimeout(function() {
                    error.hideError();
                    play();
                }, 2000);
            } else {
                play();
            }
        }

        function play() {
            var playPromise = player.play();

            if (playPromise !== undefined) {
                playPromise
                    .then(function() {
                        cover.hideCover();
                    })
                    .catch(function(error) {
                        debug.tooltip(
                            '현재 브라우저의 환경에서는 자동재생 기능을 지원하지 않습니다. Play버튼을 클릭하면 재생할 수 있습니다.' +
                                error
                        );
                        state.autoplayFail = true;
                        stopVideo();
                    });
            } else {
                inline.endSpinner();
            }
        }

        function isAgeLimit() {
            var video = queue.front;
            var ageLimit = state.currentVideo.ageLimit;
            var isAgeLimit = ageLimit === AGE_LIMIT.AGE_18.name || ageLimit === AGE_LIMIT.AGE_19.name;

            return video.type === constants.VIDEO_TYPE.VOD && isAgeLimit;
        }

        function startVideo(clip) {
            debug.info('%c%s', 'color: #20b408', '9. [controller] startVideo', clip.type, clip.timeOffset);

            if (clip && clip.breakId === 'midroll') {
                pvtTracker.pause();
            }

            inline.startSpinner();
            imaAds.destroy();

            if (!clip || !clip.videoUrl) {
                return;
            }

            if (clip.type !== constants.VIDEO_TYPE.AD) {
                if (!error.checkValidation(clip)) {
                    return;
                }
            }

            loadVideoResource(clip, function() {
                playVideo();

                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayStart, [
                    state.currentVideo.vid,
                    clip && clip.type,
                    state.currentVideo.id,
                    state.currentVideo.tid
                ]);
                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayInlineStart);
            });
        }

        function startNextQueue(callback) {
            var bean;

            if (queue.contents.length > 0) {
                bean = queue.contents.shift();
                queue.enqueue(bean);
            } else if (queue.front && queue.front.breakId === 'midroll') {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            } else {
                if (state.isPrerollEnded && !state.isPostrollEnded && queue.playList.length === 0) {
                    state.isPostrollEnded = true;
                    state.allAdsCompleted = true;

                    if (callback && typeof callback === 'function') {
                        callback();
                        return;
                    }
                }
            }

            if (queue.prerolls.length === 0 && !state.isPrerollEnded) {
                adController
                    .getSdkAdData(queue.sdkAds.shift())
                    .catch(function() {
                        debug.info('Failed getSdkAdData Or no ad data');
                    })
                    .finally(function() {
                        state.isPrerollEnded = true;
                        state.onIma = false;
                        startNextQueue();
                    });
                return;
            }

            if (queue.playList.length > 0) {
                startVideo(queue.dequeue());
            }

            debug.info('startNextQueue - state.allAdsCompleted:', state.allAdsCompleted, ', state.ended:', state.ended);
        }

        function loadVideo(clip) {
            debug.info('%c%s', 'color: #20b408', '6. [controller] load video', clip);

            var callbackParameters = helpers.sdk.getDefaultCallbackParams(state.currentVideo);
            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onStartLoadVideo, callbackParameters);

            adController
                .fetchPreroll()
                .then(startNextQueue)
                .catch(function() {
                    if (clip.skipOnErrorOfAdApi) {
                        readyVideo(clip);
                    }
                });

            if (queue.front && queue.front.type !== constants.VIDEO_TYPE.AD) {
                dt.StopWatch.start('startPlay');
            }
        }

        function preStartVideo(profile) {
            if (!state.currentVideo) {
                return;
            }

            alert3G4G(CONFIRM_STATUS.CARRIER, function() {
                cover.hideCover();
                inline.startSpinner();

                if (ua.platform === 'pc') {
                    loadVideo(state.currentVideo);
                } else {
                    if (profile && state.currentVideo.profile === profile) {
                        loadVideo(state.currentVideo);
                    } else if (state.dash) {
                        state.currentVideo.profile = profile;
                        loadVideo(state.currentVideo);
                        state.needSetTrack = true;
                    } else {
                        inline.getClipLocation(profile, function() {
                            loadVideo(state.currentVideo);
                        });
                    }

                    extension.setProfile(profile);
                    inline.setProfile(profile);
                }
            });
        }

        function setStartTime(start) {
            var instanceStart = state.initialState.start;
            var startTime = start || (instanceStart !== '' ? instanceStart : '0');
            startTime = startTime.replace(',', '');

            if (!isNaN(startTime)) {
                startTime = parseFloat(startTime);

                if (startTime > 0) {
                    player.setTime(startTime);
                }
            }
        }

        function cancelFullScreen() {
            inline.cancelFullscreen();
        }

        function setClipCover() {
            if (env.showCover) {
                var clipBean = state.currentVideo;
                var vodLink = '/channel/#{channelId}/cliplink/#{clipLinkId}';
                vodLink = helpers.string.format(vodLink, {
                    channelId: clipBean.channelId,
                    clipLinkId: clipBean.id
                });

                var size = ua.platform === 'pc' ? 'C640x360' : 'C480x270';
                var coverUrl = helpers.string.getThumbnailFarmUrl(clipBean.coverUrl, size);
                if (env.coverUrl !== '') {
                    coverUrl = env.coverUrl;
                }
                cover.setThumbnail(coverUrl);
                cover.setTime(clipBean.duration);
                cover.setTitle(vodLink, clipBean.title);
            }
        }

        function onCompleteMeta() {
            debug.info('isSupportedCodecWindows', isSupportedCodecWindows());

            // PC 윈도우즈 환경에서 VOD플레이어 H.264 코덱 미지원인 경우
            if (!isSupportedCodecWindows()) {
                error.showError(ERROR_STATUS.CodecNotInstalled.NAME, {});
                return;
            }

            setClipCover();
        }

        function fetchReadyAndPlay(id, profile, fbId) {
            var uuid = helpers.uuid.get();
            var options = {
                service: env.service,
                section: env.section,
                uuid: uuid,
                profile: profile || env.profile,
                dteType: helpers.device.getDteType(ua),
                continuousPlay: state.continuousPlay,
                contentType: '',
                startPosition: state.initialState.start || '0'
            };

            if (env.ptoken) {
                options.ptoken = env.ptoken;
            }

            if (fbId) {
                options.fbId = fbId;
            }

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onStartImpression, [id]);

            return dataloader.getClipReadyAndPlay(id, options);
        }

        function setProfile(outputList, profile) {
            cover.createProfileList(outputList);
            extension.createProfileList(outputList);
            extension.setProfile(profile);
            inline.setProfile(profile);
        }

        function setReadyAndPlay(id, readyAndPlay, isReplay) {
            var uuid = readyAndPlay.uuid;
            helpers.uuid.set(uuid);
            setReadyAndPlayBean(id, readyAndPlay, isReplay);

            if (readyAndPlay && readyAndPlay.pct) {
                tracker.setPCTTracker(readyAndPlay.pct);
            }

            if (readyAndPlay && readyAndPlay.pit && readyAndPlay.pit.url) {
                helpers.http.sendBeacon(readyAndPlay.pit.url);
            }

            inline.endSpinner();
            pvtTracker.clear();

            loadMeta();

            if (env.isPrivateIp && ua.platform === 'pc' && state.currentVideo.type === 'VOD') {
                dataloader.getAnalyticsClipPlay(state.currentVideo.linkId);
            }
        }

        function setReadyAndPlayBean(id, readyAndPlay, isReplay) {
            var metaUrl = readyAndPlay.metaUrl;
            var clipBean = {};
            var videoLocation = readyAndPlay.videoLocation;

            if (!videoLocation || !videoLocation.url) {
                throw Error('Clip url not found');
            }

            if (
                readyAndPlay.abrVideoLocationList &&
                readyAndPlay.abrVideoLocationList.length > 0 &&
                !state.dashError &&
                env.dash
            ) {
                debug.tooltip('Dash Support : ', 'true');
                readyAndPlay.abrVideoLocationList.forEach(function(v) {
                    if (!clipBean.videoUrl) {
                        if (shaka.isBrowserSupported() && v.type.toUpperCase() === constants.CONTENT_TYPE.DASH) {
                            clipBean.videoUrl = v.url + '?' + (v.params ? v.params : '');
                            clipBean.profile = constants.PROFILE.AUTO;

                            clipBean.originVideoUrl = videoLocation && videoLocation.url;
                            clipBean.originProfile = videoLocation && videoLocation.profile;

                            shaka.setManifestUri(clipBean.videoUrl);
                            state.dash = true;
                        } else if (state.hls && v.type.toUpperCase() === constants.CONTENT_TYPE.HLS) {
                            clipBean.videoUrl = v.url;
                            clipBean.profile = v.profile;

                            clipBean.originVideoUrl = videoLocation && videoLocation.url;
                            clipBean.originProfile = videoLocation && videoLocation.profile;
                        }
                    }
                });

                if (!clipBean.videoUrl) {
                    clipBean.videoUrl = videoLocation && videoLocation.url;
                    clipBean.profile = videoLocation && videoLocation.profile;
                    state.dash = false;
                }
            } else {
                debug.tooltip('Dash Support :', 'false');
                clipBean.videoUrl = videoLocation && videoLocation.url;
                clipBean.profile = videoLocation && videoLocation.profile;
                state.dash = false;
            }

            clipBean.tid = readyAndPlay.tid;
            clipBean.linkId = readyAndPlay.linkId;
            clipBean.metaUrl = metaUrl;
            clipBean.tracking = {
                pvt: readyAndPlay.pvt
            };
            clipBean.vmapReq = readyAndPlay.vmapReq;
            clipBean.skipOnErrorOfAdApi = readyAndPlay.skipOnErrorOfAdApi;
            clipBean.skipOnErrorOfAdContents = readyAndPlay.skipOnErrorOfAdContents;
            clipBean.seekUrl = readyAndPlay.seekUrl;
            clipBean.abrVideoLocationList = readyAndPlay.abrVideoLocationList;
            clipBean.contentType = videoLocation && videoLocation.contentType;
            clipBean.ageLimit = readyAndPlay.ageLimit;
            clipBean.purchase = readyAndPlay.purchase;

            if (readyAndPlay && readyAndPlay.qoe) {
                tracker.setQOETracker(readyAndPlay.qoe);
            }

            if (readyAndPlay.resumeOffset && !isReplay) {
                player.setTime(readyAndPlay.resumeOffset);
            }

            inline.endSpinner();

            try {
                clipBean.dsp = readyAndPlay.vmapReq.pre.imp_request.dsp_id;
            } catch (e) {}

            if (readyAndPlay.actionReq) {
                actionController.load(readyAndPlay.actionReq.url);
            }

            if (readyAndPlay.purchase) {
                inline.setTvod(readyAndPlay.purchase);
            } else {
                clipBean.resumeOffset = readyAndPlay.resumeOffset;
            }

            state.currentVideo.set(clipBean);
        }

        function checkAutoPlay(replayAuto) {
            var autoplay = !!env.autoplay;

            if (typeof replayAuto === 'boolean') {
                autoplay = replayAuto;
            }
            return autoplay;
        }

        function readyVideo(clipBean, isAutoplay) {
            var autoplay = checkAutoPlay(isAutoplay);
            var callbackParameters = helpers.sdk.getDefaultCallbackParams(state.currentVideo);
            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onReadyVideo, callbackParameters);

            if (autoplay) {
                loadVideo(clipBean);
            } else {
                inline.endSpinner();
                cover.showCover();
            }
        }

        function readyClipVideo(isAutoPlay, start) {
            var clipBean = state.currentVideo;
            queue.contents.push(clipBean);
            setStartTime(start);
            readyVideo(clipBean, isAutoPlay);
        }

        function resetCustomUIForPC() {
            inline.showControlHead();
            inline.showControlFooter();
            inline.hideVideoCursor();
            inline.resizeControl();
            completion.hideWaiting();
        }

        function resetCustomUI() {
            error.hideError();
            cover.hideCover();
            extension.hideModal();
            completion.hideCompletion();
            inline.applyFullscreenEnabled();

            if (ua.platform === 'pc') {
                resetCustomUIForPC();
            }
        }

        function resetForLoad() {
            resetCustomUI();
            inline.startSpinner();
            inline.resetAriaAttr();
            resetPlayerInfo();
            adController.hideLinearAdContainer();
            adController.hideNonLinearAd();

            if (ua.platform === 'pc') {
                resetForLoadOnPc();
            }
        }

        function resetPlayerInfo() {
            state.init();
            queue.init();
        }

        function resetForLoadOnPc() {
            inlinePC.resetSpeed();
        }

        function initVolumeControl() {
            if (ua.platform === 'pc') {
                inlinePC.initVolumeControl();
            } else {
                inline.initVolumeControl();
            }
        }

        function appendClipBean(meta) {
            // 섬네일 이미지 리스트가 생성되지 않는 경우(sandbox환경)에서 테스트하는 용도
            var dummyThumbnailList = [
                {
                    thumbnailUrl: 'http://t1.daumcdn.net/tvpot/thumb/s4da871AGx0iAmGCCmGimk1/0.png',
                    timeInSec: 27,
                    isDefault: true
                },
                {
                    thumbnailUrl: 'http://t1.daumcdn.net/tvpot/thumb/s4da871AGx0iAmGCCmGimk1/1.png',
                    timeInSec: 55,
                    isDefault: false
                },
                {
                    thumbnailUrl: 'http://t1.daumcdn.net/tvpot/thumb/s4da871AGx0iAmGCCmGimk1/2.png',
                    timeInSec: 83,
                    isDefault: false
                },
                {
                    thumbnailUrl: 'http://t1.daumcdn.net/tvpot/thumb/s4da871AGx0iAmGCCmGimk1/3.png',
                    timeInSec: 110,
                    isDefault: false
                },
                {
                    thumbnailUrl: 'http://t1.daumcdn.net/tvpot/thumb/s4da871AGx0iAmGCCmGimk1/4.png',
                    timeInSec: 138,
                    isDefault: false
                },
                {
                    thumbnailUrl: 'http://t1.daumcdn.net/tvpot/thumb/s4da871AGx0iAmGCCmGimk1/5.png',
                    timeInSec: 166,
                    isDefault: false
                }
            ];

            var clipBean = {};
            var clip = meta.clipLink.clip;
            var channel = meta.clipLink.channel;
            var outputList = clip.videoOutputList || [];

            clipBean.channelId = meta.clipLink.channelId;
            clipBean.clipId = clip.id;
            clipBean.userId = clip.userId;
            clipBean.vid = clip.vid;
            clipBean.status = clip.status;
            clipBean.coverUrl = clip.thumbnailUrl;
            clipBean.thumbnailList =
                clip.clipChapterThumbnailList || (helpers.env.isSandbox() ? dummyThumbnailList : []);
            clipBean.duration = clip.duration;
            clipBean.title = clip.title;
            clipBean.canScrap = clip.canScrap;
            clipBean.shouldGeoBlock = clip.shouldGeoBlock;
            clipBean.isOpen = clip.isOpen;
            clipBean.isVertical = clip.isVertical;
            clipBean.wasLive = clip.wasLive;
            clipBean.hasPlusFriend = channel.hasPlusFriend || false;
            clipBean.plusFriendProfile = channel.plusFriendProfile || {};
            clipBean.isLegacy = channel.isLegacy;
            clipBean.isOriginal = clip.isOriginal;
            clipBean.description = clip.description;
            clipBean.login = meta.login;
            clipBean.owner = meta.owner;
            clipBean.playCount = clip.playCount;
            clipBean.channelName = channel.name;
            clipBean.profileImageUrl = (channel.channelSkinData || {}).profileImageUrl;
            clipBean.outputList = getOutputList(outputList);
            clipBean.ageLimit = clip.ageLimit;
            clipBean.hasRating = meta.hasOwnProperty('ratingValue');
            clipBean.ratingValue = setRatingValue(meta.ratingValue);

            state.currentVideo.set(clipBean);
        }

        function getOutputList(outputs) {
            var outputList = [];
            var profile;

            for (var i = 0; i < outputs.length; i++) {
                profile = outputs[i].profile.toString();

                if (profile !== 'AUDIO') {
                    outputList.push(outputs[i]);
                }
            }

            return outputList;
        }

        function isAdBlock() {
            var div = $('adblockPixelTag');
            var img = $$('img', div)[0];
            return window.getComputedStyle(div).display === 'none' || window.getComputedStyle(img).display === 'none';
        }

        function load(id, profile, start, isAutoPlay, fbId, preserveState, isReplay) {
            if (typeof isAutoPlay !== 'undefined' && !isAutoPlay && !(state.isPrerollEnded && state.isPostrollEnded)) {
                queue.dequeueCancel(queue.front);
                cover.showCover();
                return;
            }

            var clipId = normalizeVideoId(id);

            player.stop();
            inline.hideActivatedControl();

            resetForLoad();
            initVolumeControl();
            state.initInitialState();
            state.initCurrentVideo(id, constants.VIDEO_TYPE.VOD);

            if (preserveState) {
                serPreserveState(preserveState);
            }

            loadReadyAndPlay(clipId, profile, fbId, isReplay)
                .then(function() {
                    var clipBean = state.currentVideo;

                    if (clipBean.vmapReq && clipBean.vmapReq.req_url && isAdBlock()) {
                        exports.queue.emit('show:error', {
                            info: {
                                code: ERROR_STATUS.UNAVAILABLE_ADBLOCK.NAME
                            }
                        });
                        throw Error(ERROR_STATUS.UNAVAILABLE_ADBLOCK.NAME);
                    }
                    return adController.fetchAds(clipBean);
                })
                .then(function() {
                    readyClipVideo(isAutoPlay, start);
                })
                .catch(function(e) {
                    var clipBean = state.currentVideo;

                    if (clipBean.skipOnErrorOfAdApi) {
                        readyClipVideo(isAutoPlay, start);
                        return;
                    }

                    debug.error('Failed clip loadReady: ', e);
                });
        }

        function serPreserveState(preserveState) {
            for (var prop in preserveState) {
                if (preserveState.hasOwnProperty(prop)) {
                    if (state[prop] !== undefined) {
                        state[prop] = preserveState[prop];
                    }
                }
            }
        }

        function seekToTime(time) {
            try {
                state.pausedBeforeSeek = state.ended ? false : player.isPaused();
                player.seekTo(time);
            } catch (err) {
                debug.error('video content might not be loaded');
            }
        }

        function normalizeVideoId(id) {
            if (isNaN(id)) {
                return id;
            } else {
                return parseInt(id, 10);
            }
        }

        function setupControl() {
            if (player.type === 'VOD') {
                inline.setupVideoControl();
            } else if (player.type === 'LIVE') {
                inline.setupLiveControl();
            }
        }

        function setMute(muteOn) {
            player.setMute(muteOn);
        }

        function setVolume(volume) {
            inlinePC.updateVolumePanel(volume);
        }

        function setAutoPlayMode(isAutoPlay) {
            var autoplay = isAutoPlay === 'true' || isAutoPlay === true;
            inlinePC.setAutoPlay(autoplay);
        }

        function setWideScreenMode(isWideScreen) {
            var wideScreen = isWideScreen === 'true' || isWideScreen === true;
            inlinePC.setWideScreen(wideScreen);
        }

        function changeVideoResource() {
            var clipBean = state.currentVideo;
            var prevTime = player.getCurrentTimeRound();
            var loadDatas = {
                videoUrl: clipBean.videoUrl,
                playerClass: state.playerClass,
                callback: null
            };
            player.load(loadDatas);
            player.setTime(prevTime);
        }

        function appendLiveBean(meta) {
            var liveBean = {};
            var channel = meta.liveLink.channel;
            var live = meta.liveLink.live;

            if (!liveBean.id) {
                liveBean.id = meta.liveLink.id;
            }
            if (!liveBean.linkId) {
                liveBean.linkId = meta.liveLink.id;
            }
            liveBean.channelId = meta.liveLink.channelId;
            liveBean.liveId = live.id;
            liveBean.userId = live.userId;
            liveBean.coverUrl = live.thumbnailUri;
            liveBean.status = live.status;
            liveBean.duration = live.duration;
            liveBean.title = live.title;
            liveBean.liveType = live.liveType;
            liveBean.canScrap = live.canScrap;
            liveBean.hasPlusFriend = channel.hasPlusFriend;
            liveBean.shouldGeoBlock = live.shouldGeoBlock;
            liveBean.isOpen = live.isOpen;
            liveBean.needPassword = live.needPassword;
            liveBean.ccuCount = live.ccuCount;
            liveBean.description = live.description;
            liveBean.isOriginal = live.isOriginal;
            liveBean.login = meta.login;
            liveBean.owner = meta.owner;
            liveBean.channelName = channel.name;
            liveBean.profileImageUrl = (channel.channelSkinData || {}).profileImageUrl;
            liveBean.coverThumbnailUrl = live.coverThumbnailUrl;
            liveBean.hasBizDonationPartner = channel.hasBizDonationPartner;
            liveBean.outputList = live.liveProfileList;
            liveBean.ageLimit = live.ageLimit;

            state.currentVideo.set(liveBean);
        }

        function setRatingValue(ratingValue) {
            var RATING = constants.RATING;
            var RATING_LEVEL = constants.RATING_LEVEL;
            var ratings = {};

            if (ratingValue) {
                var ratingKeys = Object.keys(RATING);

                ratingKeys.forEach(function(key) {
                    var ratingLevel = ratingValue[key] && ratingValue[key].toUpperCase();

                    if (!ratingLevel) {
                        return;
                    }

                    if (RATING[key]) {
                        ratings[key] = RATING[key];
                        ratings[key].level = RATING_LEVEL[ratingLevel];
                    }
                });
            }

            return ratings;
        }

        function setPlaybackRate(rate) {
            player.setPlaybackRate(rate);
        }

        function initInitialEnvironment() {
            state.initInitialState();
            setDefaultOptions();
        }

        function setDefaultOptions() {
            var initialState = state.initialState;

            if (env.mute) {
                initialState.startMuted = true;
            }

            if (env.start) {
                initialState.start = env.start;
            }
        }

        function Controller() {}

        Controller.prototype.init = function() {
            if (inline) {
                inline.startSpinner();
            }

            initInitialEnvironment();
            window.registerApiMessenger(env.usePostMessage);

            if (typeof window.Kakao !== 'undefined' && window.Kakao.Auth === undefined) {
                (function(originPromise) {
                    window.Kakao.init(APP_KEY);
                    window.Promise = originPromise;
                })(window.Promise);
            }

            Promise.config({
                cancellation: true
            });

            if (!helpers.device.isSupportCustomController(ua)) {
            }
        };

        Controller.prototype.changeVideoResource = function() {
            changeVideoResource();
        };

        Controller.prototype.loadVideo = function(clip) {
            loadVideo(clip);
        };

        Controller.prototype.load = function(id, profile, start, isAutoPlay) {
            load(id, profile, start, isAutoPlay);
        };

        Controller.prototype.loadAndPlay = function(id, profile, start, bucket, preserveState, isReplay) {
            if (dt.StopWatch.has('playingTime')) {
                pvtTracker.end(dt.StopWatch.stop('playingTime'));
            }
            var isAutoPlay = true;
            load(id, profile, start, isAutoPlay, bucket, preserveState, isReplay);
        };

        Controller.prototype.normalizeVideoId = function(id) {
            normalizeVideoId(id);
        };

        Controller.prototype.startNextQueue = function(callback) {
            startNextQueue(callback);
        };

        Controller.prototype.preStartVideo = function(profile) {
            preStartVideo(profile);
        };

        Controller.prototype.play = function(profile) {
            if (player.videoElement.src !== '') {
                playVideo();
                return;
            }

            if (!profile) {
                profile = state.currentVideo.profile;
            }

            preStartVideo(profile);
        };

        Controller.prototype.pause = function() {
            player.pause();
        };

        Controller.prototype.stop = function() {
            stopVideo();
        };

        Controller.prototype.seekTo = function(time) {
            seekToTime(time);
        };

        Controller.prototype.getDuration = function() {
            return player.getDurationRound();
        };

        Controller.prototype.setVolume = function(volume) {
            setVolume(volume);
        };

        Controller.prototype.setMute = function(muteOn) {
            setMute(muteOn);
        };

        Controller.prototype.setAutoPlayMode = function(isAutoPlay) {
            setAutoPlayMode(isAutoPlay);
        };

        Controller.prototype.setWideScreenMode = function(isWideScreen) {
            setWideScreenMode(isWideScreen);
        };

        Controller.prototype.setNextVideo = function(title) {
            if (title && title !== '') {
                debug.info('setNextVideo', decodeURIComponent(title));
                completion.setNextVideo(decodeURIComponent(title));
            }
        };

        Controller.prototype.setAutoplayVisible = function(visibility) {
            if (visibility === true) {
                inlinePC.showAutoPlay();
            } else {
                inlinePC.hideAutoPlay();
            }
        };

        Controller.prototype.setContinuousPlay = function(isContinuousPlay) {
            if (typeof isContinuousPlay !== 'boolean') {
                return;
            }

            state.continuousPlay = isContinuousPlay;
        };

        Controller.prototype.setBeaconData = function(beacon) {
            tracker.setBeaconData(beacon);
        };

        Controller.prototype.setPlaybackRate = function(rate) {
            setPlaybackRate(rate);
        };

        Controller.prototype.setupControl = function() {
            setupControl();
        };

        Controller.prototype.resetCustomUI = function() {
            resetCustomUI();
        };

        Controller.prototype.showError = function(info, option) {
            showError(info, option);
        };

        Controller.prototype.showConfirm = function(option) {
            showConfirm(option);
        };

        Controller.prototype.alert3G4G = function(status, callback) {
            alert3G4G(status, callback);
        };

        Controller.prototype.readyVideo = function(currentVideo, isAutoPlay) {
            readyVideo(currentVideo, isAutoPlay);
        };

        Controller.prototype.loadVideoResource = function(clip) {
            loadVideoResource(clip);
        };

        Controller.prototype.cancelFullScreen = function() {
            cancelFullScreen();
        };

        Controller.prototype.fetchMeta = function() {
            return fetchMeta();
        };

        Controller.prototype.resetPlayerInfo = function() {
            resetPlayerInfo();
        };

        Controller.prototype.isAdBlock = function() {
            return isAdBlock();
        };

        Controller.prototype.initVolumeControl = function() {
            initVolumeControl();
        };

        Controller.prototype.setDefaultOptions = function() {
            setDefaultOptions();
        };

        return Controller;
    })();

    exports.addModule('controller.video', new Controller());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';

    var Controller;

    Controller = (function() {
        var inline = exports.loadModule('view.inline');
        var cover = exports.loadModule('view.cover');
        var queue = exports.loadModule('playlist.queue');
        var tracker = exports.loadModule('etc.tracker');
        var state = exports.loadModule('controller.state');
        var player = exports.loadModule('player.adapter');
        var controller = exports.loadModule('controller.video');
        var actionController = exports.loadModule('controller.action');
        var dataloader = exports.loadModule('playlist.dataloader');
        var pvtTracker = exports.loadModule('pvt.tracker');
        var pctTracker = exports.loadModule('pct.tracker');
        var adController = exports.loadModule('controller.ad');

        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;
        var ERROR_STATUS = constants.ERROR.STATUS;
        var CONFIRM_STATUS = constants.CONFIRM.STATUS;

        var isSupportedHLSAndroid = helpers.feature.supportsHLSAndroid();

        var livePlayer = {
            filter3G4GAlert: function(url, callback) {
                controller.alert3G4G(CONFIRM_STATUS.CARRIER, callback);
            },
            filterHDAlert: function(profile) {
                return controller.showConfirm({
                    status: CONFIRM_STATUS.LAUNCH_APP,
                    accept: function() {
                        if (player.videoElement.src === '') {
                            cover.showCover();
                        }

                        livePlayer.goApp(profile);

                        pctTracker.track('liveapp', 'ok');
                    },
                    cancel: function() {
                        if (player.videoElement.src === '') {
                            cover.showCover();
                        } else {
                            inline.showControl();
                        }
                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayCancel);
                    }
                });
            },
            filterLinear: function(profile) {
                return controller.showConfirm({
                    status: CONFIRM_STATUS.LinearLive,
                    accept: function() {
                        cover.showCover();
                        livePlayer.goApp(profile);
                    },
                    cancel: function() {
                        cover.showCover();
                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayCancel);
                    }
                });
            },
            goApp: function(profile) {
                var liveLinkId = state.currentVideo.id;
                helpers.web2app.launchKakaoTV(ua, liveLinkId, profile);
            },
            isSupportHLS: function() {
                if (ua.os.android) {
                    if (isSupportedHLSAndroid) {
                        return true;
                    }
                }

                if (ua.os.ios) {
                    if (helpers.feature.supportsHLS()) {
                        return true;
                    }
                }

                return false;
            },
            isSupportNPP: function() {
                if (ua.platform === 'pc') {
                    return true;
                }

                return false;
            }
        };

        function setLiveContentType(profile) {
            var contentType = constants.CONTENT_TYPE.HLS;

            if (ua.os.android && !isSupportedHLSAndroid) {
                contentType = constants.CONTENT_TYPE.RTSP;
            } else if (ua.platform === 'pc' && player.isInstalledLiveAgent() && profile !== constants.PROFILE.BASE) {
                contentType = constants.CONTENT_TYPE.NPP;
            }

            if (env.liveTypeLinear) {
                contentType = constants.CONTENT_TYPE.LINEAR;
            }

            if (state.currentVideo) {
                state.currentVideo.contentType = contentType;
            }
            return contentType;
        }

        function setLiveCover() {
            if (env.showCover) {
                var video = state.currentVideo;
                var liveLink = '/channel/#{channelId}/livelink/#{liveLinkId}';
                liveLink = helpers.string.format(liveLink, {
                    channelId: video.channelId,
                    liveLinkId: video.id
                });

                var coverUrl = helpers.string.getThumbnailFarmUrl(video.coverUrl, 'C640x360');

                if (env.coverUrl !== '') {
                    coverUrl = env.coverUrl;
                }

                cover.setThumbnail(coverUrl);
                cover.setTitle(liveLink, video.title);
            }
        }

        function loadReadyAndPlay(id, profile, password) {
            return fetchReadyAndPlay(id, profile, password).then(function(readyAndPlay) {
                setReadyAndPlay(id, readyAndPlay);
                setLiveContentType(profile);

                var contentType = state.currentVideo.contentType;

                if (
                    !player.isInstalledLiveAgent() &&
                    ua.platform === 'pc' &&
                    (profile === constants.PROFILE.MAIN ||
                        profile === constants.PROFILE.HIGH ||
                        profile === constants.PROFILE.HIGH4)
                ) {
                    if (!ua.browser.msie) {
                        exports.queue.emit('show:error', {
                            info: {
                                code: ERROR_STATUS.LiveAgentNotInstalled.NAME,
                                profile: profile
                            }
                        });
                    } else {
                        if (!player.isSupportedLiveAgentHLS()) {
                            location.href = location.href + '&flash=1';
                        }

                        exports.queue.emit('show:error', {
                            info: {
                                code: ERROR_STATUS.LiveAgentNotInstalled.NAME,
                                profile: profile
                            }
                        });
                    }
                    throw Error('Live agent not installed');
                }

                if (contentType === constants.CONTENT_TYPE.LINEAR) {
                    livePlayer.filterLinear(profile);
                    inline.endSpinner();
                    throw Error('Linear contentType');
                }

                if (readyAndPlay && readyAndPlay.pct) {
                    tracker.setPCTTracker(readyAndPlay.pct);
                }

                if (readyAndPlay && readyAndPlay.pit) {
                    helpers.http.sendBeacon(readyAndPlay.pit.url);
                }

                loadMeta();

                if (readyAndPlay.actionReq) {
                    actionController.load(readyAndPlay.actionReq.url);
                }
            });
        }

        function fetchReadyAndPlay(id, profile, password) {
            var uuid = helpers.uuid.get();
            var options = {
                service: env.service,
                section: env.section,
                uuid: uuid,
                dteType: helpers.device.getDteType(ua),
                profile: profile,
                liveLinkId: id,
                contentType: setLiveContentType(profile),
                password: password ? encodeURIComponent(password) : ''
            };

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onStartImpression, [id]);

            return dataloader.getLiveReadyAndPlay(id, options);
        }

        function loadMeta() {
            return controller
                .fetchMeta()
                .then(function() {
                    onCompleteMeta();
                })
                .catch(function(e) {
                    debug.log('Meta server error', e);
                });
        }

        function preStartVideo(profile) {
            var video = state.currentVideo;

            if (!video) {
                return;
            }

            if (env.showHDConfirm && profile === constants.PROFILE.HIGH) {
                livePlayer.filterHDAlert(profile);
                return;
            }

            var videoUrl = state.currentVideo.videoUrl;
            var isSupportHLS = livePlayer.isSupportHLS();
            var isSupportNPP = livePlayer.isSupportNPP();
            debug.tooltip('isSupportHLS', isSupportHLS);

            livePlayer.filter3G4GAlert(videoUrl, function() {
                cover.hideCover();

                if (!isSupportHLS && !isSupportNPP) {
                    window.open(videoUrl, '_top');
                    cover.showCover();
                    debug.tooltip('현재 브라우저의 환경에서는 라이브 재생(HLS, NPP)을 지원하지 않습니다.', '');
                } else {
                    controller.loadVideo(video);
                }
            });
        }

        function normalizeLiveId(id) {
            return isNaN(id) ? id : parseInt(id, 10);
        }

        function setReadyAndPlay(id, readyAndPlay) {
            var videoLocation = readyAndPlay.videoLocation;
            var liveBean = {};

            if (!videoLocation || !videoLocation.url) {
                throw Error('Live url not found');
            }
            helpers.uuid.set(readyAndPlay.uuid);

            liveBean.linkId = readyAndPlay.linkId;
            liveBean.tid = readyAndPlay.tid;
            liveBean.vid = env.vid;
            liveBean.videoUrl = videoLocation && videoLocation.url;
            liveBean.profile = videoLocation && videoLocation.profile;
            liveBean.vmapReq = readyAndPlay.vmapReq;
            liveBean.tracking = {
                pvt: readyAndPlay.pvt,
                pct: readyAndPlay.pct,
                pit: readyAndPlay.pit
            };
            liveBean.skipOnErrorOfAdApi = readyAndPlay.skipOnErrorOfAdApi;
            liveBean.skipOnErrorOfAdContents = readyAndPlay.skipOnErrorOfAdContents;
            liveBean.metaUrl = readyAndPlay.metaUrl;
            liveBean.ageLimit = readyAndPlay.ageLimit;

            try {
                liveBean.dsp = readyAndPlay.vmapReq.pre.imp_request.dsp_id;
            } catch (e) {}

            state.currentVideo.set(liveBean);
            pvtTracker.clear();
        }

        function readyVideo(liveBean, profile, isAutoPlay) {
            if (env.showHDConfirm && isAutoPlay && profile === constants.PROFILE.HIGH) {
                livePlayer.filterHDAlert(profile);
                return;
            }

            controller.readyVideo(liveBean, isAutoPlay);
        }

        function onCompleteMeta() {
            setLiveContentType(state.currentVideo.profile);
            setLiveCover();

            exports.queue.emit('create:kakaotalkLink');
        }

        function load($id, $profile, $isAutoPlay, $password) {
            var profile = $profile;
            var isAutoPlay = $isAutoPlay;

            if (controller.isAdBlock()) {
                exports.queue.emit('show:error', {
                    info: {
                        code: ERROR_STATUS.UNAVAILABLE_ADBLOCK.NAME
                    }
                });
                return;
            }

            if (ua.platform === 'pc') {
                if (!player.isKampSupported() && !player.isSupportedLiveAgentHLS()) {
                    location.href = location.href + '&flash=1';
                    return;
                }

                if (player.isInstalledLiveAgent() === null) {
                    debug.warn('Live Agent 확인이 완료되지 않았습니다.');
                    setTimeout(function() {
                        load($id, profile, isAutoPlay, $password);
                    }, 300);
                    return;
                }
            }

            if (!player.isInstalledLiveAgent() && !env.forceProfile) {
                profile = constants.PROFILE.BASE;
            }

            if (typeof isAutoPlay === 'boolean' && !isAutoPlay && !(state.isPrerollEnded && state.isPostrollEnded)) {
                queue.dequeueCancel(queue.front);
                cover.showCover();
                return;
            }

            controller.resetPlayerInfo();
            controller.initVolumeControl();
            inline.startSpinner();
            state.initInitialState();
            state.initCurrentVideo($id, constants.VIDEO_TYPE.LIVE);

            loadReadyAndPlay($id, profile, $password)
                .then(function() {
                    var liveBean = state.currentVideo;
                    return adController.fetchAds(liveBean);
                })
                .then(function() {
                    var bean = state.currentVideo;
                    queue.contents.push(bean);

                    if (!player.isKampSupported() && player.isSupportedLiveAgentHLS() && !env.popup) {
                        isAutoPlay = false;
                    }
                    readyVideo(bean, profile, isAutoPlay);
                })
                .catch(function(e) {
                    debug.info('Failed live loadReadyAndPlay: ', e);
                });
        }

        function Controller() {}

        Controller.prototype.init = function() {};

        Controller.prototype.load = function($id, $profile, $isAutoPlay, $password) {
            var id = normalizeLiveId($id);
            player.stop();
            load(id, $profile, $isAutoPlay, $password);
        };

        Controller.prototype.loadAndPlay = function($id, $profile) {
            load($id, $profile, true);
        };

        Controller.prototype.play = function($profile) {
            var profile = $profile;

            if (player.videoElement.src !== '') {
                if (queue.front.type !== constants.VIDEO_TYPE.AD) {
                    inline.hideActivatedControl();
                }
                cover.hideCover();
                player.play();
                return;
            }

            if (!profile) {
                profile = state.currentVideo.profile;
            }

            preStartVideo(profile);
        };

        Controller.prototype.preStartVideo = function(profile) {
            preStartVideo(profile);
        };

        return Controller;
    })();

    exports.addModule('controller.live', new Controller());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var state = exports.loadModule('controller.state');
    var player = exports.loadModule('player.adapter');
    var shaka = exports.loadModule('player.shaka');
    var dataloader = exports.loadModule('playlist.dataloader');
    var inlinePC = exports.loadModule('view.inline.pc');
    var extension = exports.loadModule('view.extension');
    var contextMenu = exports.loadModule('view.contextmenu');
    var cast = exports.loadModule('view.cast');

    var CastController;

    CastController = (function() {
        var ua = exports.ua;
        var env = exports.ENV;
        var constants = exports.constants;
        var helpers = exports.helpers;

        var isDash = false;
        var castFramework = {};
        var chrome = {};
        var remotePlayer = {};
        var remoteController = {};
        var eventListener = function() {};

        function init() {
            remotePlayer = {};
            remoteController = {};

            create();
        }

        function create() {
            var options = {};

            castFramework = window.cast.framework;
            chrome = window.chrome;

            remotePlayer = new castFramework.RemotePlayer();

            options.receiverApplicationId = chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID;
            options.autoJoinPolicy = chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED;

            castFramework.CastContext.getInstance().setOptions(options);
            remoteController = new castFramework.RemotePlayerController(remotePlayer);
        }

        function resetCastPlayer() {
            var originPlayer = player.getOriginPlayer();
            var playerClass = constants.PLAYERCLASS.HTML5;

            if (originPlayer) {
                return;
            }

            if (state.dash) {
                playerClass = constants.PLAYERCLASS.SHAKA;
            }

            init();
            initPlayer(originPlayer, {
                playerClass: playerClass,
                videoUrl: false
            });
        }

        function registerRemoteEventListener(listener) {
            eventListener = listener;

            if (typeof eventListener === 'function') {
                eventListener(remoteController);
            }
        }

        function hideMenuOnCast(isAirplay) {
            if (!isAirplay) {
                extension.hideRelatedButton();
            }
            inlinePC.hideMenuOnCast(isAirplay);
            contextMenu.hidePip();
        }

        function showMenuOnCast(isAirplay) {
            inlinePC.showMenuOnCast(isAirplay);
            contextMenu.showPip();
        }

        function loadRemotePlayer() {
            if (state.dash) {
                player.setTextTrack(constants.SUBTITLE.STATUS.OFF);
                shaka.reset(player.videoElement);
                state.dash = false;
                isDash = true;
                swapVideoUrl();
            }

            var videoInfo = {
                url: state.currentVideo.videoUrl,
                mediaType: constants.MEDIA_TYPE.MP4
            };

            hideMenuOnCast();
            load(videoInfo, player.getCurrentTimeRound());
        }

        function swapVideoUrl() {
            var videoUrl = state.currentVideo.originVideoUrl;
            state.currentVideo.originVideoUrl = state.currentVideo.videoUrl;
            state.currentVideo.videoUrl = videoUrl;
        }

        function loadRemotePlayerForLive() {
            var bean = state.currentVideo;
            var uuid = helpers.uuid.get();
            var params = {
                service: env.service,
                section: env.section,
                uuid: uuid,
                dteType: helpers.device.getDteType(ua),
                profile: constants.PROFILE.MAIN,
                liveLinkId: bean.id,
                contentType: constants.CONTENT_TYPE.HLS
            };

            dataloader.getLiveImpression(bean.id, params, function(result) {
                if (result.status !== 'success') {
                    return;
                }
                var data = result.data;
                var videoUrl = data.raw.videoLocation.url;
                var videoInfo = {
                    url: videoUrl,
                    mediaType: constants.MEDIA_TYPE.HLS
                };
                hideMenuOnCast();
                load(videoInfo, 0);
            });
        }

        function cancelRemotePlayer(currentTime) {
            var playerClass = constants.PLAYERCLASS.HTML5;
            var loadedCallback = {};

            if (isDash) {
                swapVideoUrl();
                state.dash = true;
                playerClass = constants.PLAYERCLASS.SHAKA;
                loadedCallback = function() {
                    if (currentTime > 0) {
                        player.seekTo(currentTime);
                        player.play();
                    }
                };
            }

            var loadData = {
                playerClass: playerClass,
                videoUrl: state.currentVideo.videoUrl,
                callback: loadedCallback
            };

            showMenuOnCast();
            unload(loadData, currentTime);
        }

        function cancelRemotePlayerForLive() {
            var loadData = {
                playerClass: constants.PLAYERCLASS.KAMP,
                videoUrl: state.currentVideo.videoUrl
            };

            showMenuOnCast();
            unload(loadData, 0);
        }

        function load(videoInfo, start) {
            player.pause();
            player.load({
                playerClass: constants.PLAYERCLASS.CAST,
                remote: {
                    player: remotePlayer,
                    controller: remoteController,
                    videoInfo: videoInfo,
                    start: start
                },
                callback: function() {
                    var playerInstance = player.getPlayerInstance();
                    var castSession = playerInstance.getSession ? playerInstance.getSession() : {};

                    if (castSession.getCastDevice) {
                        var device = castSession.getCastDevice();
                        cast.setConnectedDeviceText(device.friendlyName);
                        inlinePC.showLoadedMenuOnCast();
                    }
                }
            });
        }

        function unload(loadData, start) {
            var originPlayer = player.getOriginPlayer();

            player.stop();

            if (!originPlayer) {
                return;
            }

            inlinePC.hideLoadedMenuOnCast();
            initPlayer(originPlayer, loadData);

            if (state.ended) {
                return;
            }
            if (start > 0) {
                player.seekTo(start);
            }

            player.play();
        }

        function initPlayer(playerInstance, loadData) {
            player.init(playerInstance);
            if (!state.ended) {
                player.load(loadData);
            }
        }

        function convertSrcMode() {
            if (state.currentVideo.profile === constants.PROFILE.AUTO) {
                state.currentVideo.profile = state.currentVideo.originProfile;
            }

            var outputList = state.currentVideo.originOutputList;

            state.currentVideo.originOutputList = state.currentVideo.outputList;
            state.currentVideo.outputList = outputList;
            state.dash = false;
            state.playerClass = constants.PLAYERCLASS.HTML5;

            swapVideoUrl();
            inlinePC.onLoadStart();

            shaka.detach().then(function() {
                player.load({
                    videoUrl: state.currentVideo.videoUrl
                });
            });
        }

        function CastController() {}

        CastController.prototype.init = function() {};

        CastController.prototype.create = function() {
            create();
        };

        CastController.prototype.loadRemotePlayer = function() {
            loadRemotePlayer();
        };

        CastController.prototype.loadRemotePlayerForLive = function() {
            loadRemotePlayerForLive();
        };

        CastController.prototype.cancelRemotePlayer = function(currentTime) {
            cancelRemotePlayer(currentTime);
        };

        CastController.prototype.cancelRemotePlayerForLive = function() {
            cancelRemotePlayerForLive();
        };

        CastController.prototype.resetCastPlayer = function() {
            resetCastPlayer();
        };

        CastController.prototype.registerRemoteEventListener = function(eventListener) {
            registerRemoteEventListener(eventListener);
        };

        CastController.prototype.getRemoteEventType = function() {
            return castFramework.RemotePlayerEventType;
        };

        CastController.prototype.getMediaState = function() {
            return chrome.cast.media.PlayerState;
        };

        CastController.prototype.convertSrcMode = function() {
            convertSrcMode();
        };

        CastController.prototype.showMenuOnCast = function(isAirplay) {
            showMenuOnCast(isAirplay);
        };

        CastController.prototype.hideMenuOnCast = function(isAirplay) {
            hideMenuOnCast(isAirplay);
        };

        return CastController;
    })();

    exports.addModule('controller.cast', new CastController());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var error = exports.loadModule('view.error');
    var queue = exports.loadModule('playlist.queue');
    var tracker = exports.loadModule('etc.tracker');
    var vastTracker = exports.loadModule('vast.tracker');
    var pvtTracker = exports.loadModule('pvt.tracker');
    var qoeTracker = exports.loadModule('qoe.tracker');
    var state = exports.loadModule('controller.state');
    var player = exports.loadModule('player.adapter');
    var shaka = exports.loadModule('player.shaka');
    var inline = exports.loadModule('view.inline');
    var inlinePC = exports.loadModule('view.inline.pc');
    var adController = exports.loadModule('controller.ad');
    var controller = exports.loadModule('controller.video');
    var completion = exports.loadModule('view.completion');
    var retry = exports.loadModule('view.retry');
    var analytics = exports.loadModule('view.analytics');
    var mediaSession = exports.loadModule('media.session');
    var extension = exports.loadModule('view.extension');

    var EventVideo;

    EventVideo = (function() {
        var $ = dt.$;
        var event = dt.event;
        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;
        var ERROR_STATUS = constants.ERROR.STATUS;
        var currentTime = 0;
        var pastTime = 0;
        var supposedCurrentTime = 0;
        var isSupportCustomController = helpers.device.isSupportCustomController(ua);
        var requestAnimateId = null;
        var qoeEvent = constants.QOE.EVENT;
        var timeupdateTimeout = null;

        function onLoadVideoSize() {
            var docBody = document.body;

            var playerWidth = docBody.clientWidth;
            var scale = playerWidth / player.videoElement.videoWidth;
            var toHeight = player.videoElement.videoHeight * scale;

            var video = queue.front;

            if (video && player.videoElement.videoWidth > 1) {
                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onMeasureHeight, [
                    toHeight,
                    playerWidth,
                    video.id
                ]);
            }
        }

        function togglePlayPause(isPaused) {
            var video = queue.front;

            if (ua.platform === 'pc') {
                inlinePC.togglePlayPause(isPaused);
            } else {
                if (video && video.type === constants.VIDEO_TYPE.AD) {
                    inline.toggleAdPlayPause(isPaused);
                } else {
                    inline.togglePlayPause(isPaused);
                }
            }
        }

        function showControl(isFreeze) {
            var video = queue.front;
            var currentVideo = state.currentVideo;

            if (!state.modalContentActivated && video && video.type !== constants.VIDEO_TYPE.AD && !state.isFirstPlay) {
                inline.showControl(isFreeze);
            } else if (video && video.type === constants.VIDEO_TYPE.AD && queue.front.breakId === 'midroll') {
                inline.showAdControl(isFreeze);
            }

            if (video && video.type !== constants.VIDEO_TYPE.AD && state.isFirstPlay && !currentVideo.resumeOffset) {
                inline.showRating();
                setTimeout(function() {
                    inline.hideRating();
                }, 3000);
            }
        }

        function isFullScreen() {
            return inline.isFullScreen();
        }

        function onAbort() {
            debug.info('%c%s', 'color: #2074c0;', '[video event] abort');
        }

        function onDurationChange() {
            var video = queue.front;

            debug.info('%c%s', 'color: #2074c0;', '[video event] durationchange - ', video && video.type);

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                adController.setupAdControl();
                adController.showLinearAdContainer();
            } else {
                controller.setupControl();

                if (!state.isNonLinearAdShown) {
                    adController.setupNonLinearAd();
                }

                if (state.currentVideo.midrollReq) {
                    adController.setupMidrollAd();
                }

                if (env.isAdType) {
                    inline.showControl(true);
                }
            }
            onLoadVideoSize();
        }

        function onCanPlay() {
            var video = queue.front;
            currentTime = 0;
            pastTime = 0;

            debug.info('%c%s', 'color: #2074c0;', '[video event] canplay - ', video && video.type, state.ended);
            togglePlayPause(player.isPaused());

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                adController.activateAdControl();
            }
        }

        function onTimeUpDate() {
            var video = queue.front;
            var isCheckableNonLinearAd =
                !player.isPaused() && !state.seeking && queue.overlayAds && queue.overlayAds.length > 0;
            var isShowLiveAgentInstallView = !dt.classList.has($('alertLiveAgent'), 'hide');

            if (!player.videoElement.seeking) {
                supposedCurrentTime = player.getCurrentTime();
            }

            // timeupdate event가 random하게 발생하는 부분을 보완하기 위해 1초단위로 파싱
            currentTime = player.getCurrentTimeRound();

            // throttle function 호출은 full seconds가 바뀌었을 때 (e.g 1, 2, 3 ..)
            if (currentTime > pastTime) {
                debug.log('%c%s', 'color: #2074c0;', '[video event] timeupdate - currentTime', currentTime);

                clearTimeupdateTimeout();
                sendOffsetPointUpdate();
                inline.onTimeUpdate(currentTime, player.getDurationRound());

                if (!isShowLiveAgentInstallView) {
                    error.hideError();
                }
                retry.resetTimer();

                if (video && video.type === constants.VIDEO_TYPE.AD) {
                    vastTracker.setDuration(player.getDurationRound());
                    vastTracker.setProgress(currentTime);

                    inline.setDuration(player.getDurationRound());
                    if (player.getDurationRound() < currentTime) {
                        excuteEnded(false);
                    }
                } else {
                    pvtTracker.setDuration(player.getDurationRound());
                    pvtTracker.setProgress(currentTime);

                    if (player.getDurationRound() > 1) {
                        tracker.checkBeaconData(currentTime / player.getDurationRound());
                    }

                    if (isCheckableNonLinearAd) {
                        adController.checkNonLinearAd(currentTime, player.getDurationRound());
                    }

                    if (video && video.type !== constants.VIDEO_TYPE.LIVE && !state.seeking) {
                        if (player.isPaused()) {
                            state.needMidrollRequest = true;
                        } else {
                            adController.checkMidrollAd(false, controller.startNextQueue);
                        }
                    }
                }

                if (ua.os.android && video && video.type === constants.VIDEO_TYPE.LIVE) {
                    timeupdateTimeout = setTimeout(function() {
                        if (!player.videoElement.paused) {
                            var info = {
                                code: 'LiveException',
                                message: '라이브가 종료되었거나, 재생이 원활하지 않습니다.',
                                needCheck: false
                            };

                            state.ended = true;
                            error.showError(info.code, info, null);
                            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onVideoStateChange, [
                                constants.PLAYER_VIDEO_STATE.ENDED,
                                env.clipLinkId,
                                player.getCurrentTimeRound(),
                                video && video.type
                            ]);
                        }
                    }, 10 * 1000);
                } else if (ua.os.ios) {
                    timeupdateTimeout = setTimeout(function() {
                        if (!window.navigator.onLine) {
                            retry.clearTimer();

                            exports.queue.emit('show:error', {
                                info: {
                                    code: ERROR_STATUS.NETWORK_OFFLINE.NAME
                                }
                            });
                            inline.endSpinner();
                        } else if (!player.videoElement.paused) {
                            player.pause();
                        }
                    }, 5 * 1000);
                }
            }

            pastTime = currentTime;
        }

        function onSeeking() {
            var video = queue.front;
            debug.info('%c%s', 'color: #2074c0;', '[video event] seeking');

            if (!state.seeking) {
                inline.startSpinner();
            }

            if (player.getCurrentTimeRound() < player.getDurationRound()) {
                completion.hideCompletion();
            }

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                var delta = player.getCurrentTime() - supposedCurrentTime;

                if (Math.abs(delta) > 0.01) {
                    player.videoElement.currentTime = supposedCurrentTime;
                }
            }
        }

        function onSeeked() {
            if (dt.StopWatch.has('seek')) {
                qoeTracker.track(qoeEvent.SEEK, { n1: dt.StopWatch.stop('seek') });
            }

            var video = queue.front;

            debug.info('%c%s', 'color: #2074c0;', '[video event] seeked -', video && video.type, this.currentTime);

            inline.endSpinner();
            inline.onSeeked();

            if (video && video.type !== constants.VIDEO_TYPE.AD && isSupportCustomController) {
                if (!state.ended) {
                    togglePlayPause(player.isPaused());
                    if (!state.seeking) {
                        showControl(player.isPaused());
                    }
                }
            }

            if (video && video.type === constants.VIDEO_TYPE.VOD) {
                if (state.ended) {
                    excuteEnded(false);
                } else {
                    if (state.pausedBeforeSeek && player.isPaused()) {
                        player.pause();
                        state.needMidrollRequest = true;
                    } else {
                        player.play();
                        adController.checkMidrollAd(true, controller.startNextQueue);
                        player.videoElement.setAttribute('data-time-before-seek', '');
                    }
                }
            }

            retry.clearTimer();
        }

        function updateBufferable() {
            var bufferLen = this.buffered.length;
            var buffered = this.buffered;

            if (player.getDurationRound() > 0 && bufferLen > 0) {
                var range = bufferLen - 1;
                var end = buffered.end(range);
                inline.onProgress(end / this.duration);
            }
        }

        function onProgress() {
            var video = queue.front;
            if (video && video.type !== constants.VIDEO_TYPE.LIVE) {
                updateBufferable.apply(this);
            }
        }

        function onPlay() {
            var video = queue.front;

            debug.info(
                '%c%s',
                'color: #2074c0;',
                '[video event] play -',
                video && video.type,
                ', isResume -',
                state.isFirstPlay,
                ', width, height -',
                this.videoWidth,
                this.videoHeight
            );

            controller.resetCustomUI();
            togglePlayPause(player.isPaused());
            state.preventTogglePlayPause = false;
            state.pausedBeforeSeek = false;
            state.ended = false;

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                if (this.currentTime > 0) {
                    vastTracker.pause(false);
                }
                exports.queue.emit('hide:action');
            } else {
                adController.resumeNonLinearAd();
                exports.queue.emit('show:action');

                if (video.purchase) {
                    exports.queue.emit('show:preview');
                }
            }

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onVideoStateChange, [
                constants.PLAYER_VIDEO_STATE.PLAY,
                env.clipLinkId,
                player.getCurrentTimeRound(),
                video && video.type
            ]);

            if (ua.platform === 'pc') {
                inlinePC.clearRelatedTimer();
            }

            showControl(false);

            requestAnimateId = window.requestAnimationFrame(updateProgress);

            clearTimeupdateTimeout();
            retry.clearTimer();

            if (video && video.type !== constants.VIDEO_TYPE.LIVE) {
                inline.endSpinner();
            }
        }

        function onPlaying() {
            var video = queue.front;
            var title = video.title;
            var artist = video.channelName;

            debug.info('%c%s', 'color: #2074c0;', '[video event] playing - ', this.videoWidth, this.videoHeight);

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onVideoStateChange, [
                constants.PLAYER_VIDEO_STATE.PLAYING,
                env.clipLinkId,
                player.getCurrentTimeRound(),
                video && video.type
            ]);

            if (video && video.type !== constants.VIDEO_TYPE.AD) {
                pvtTracker.resume();

                if (!dt.StopWatch.has('playingTime')) {
                    dt.StopWatch.start('playingTime');
                } else {
                    dt.StopWatch.resume('playingTime');
                }

                if (!dt.StopWatch.has('midrollPlayingTime')) {
                    dt.StopWatch.start('midrollPlayingTime');
                } else {
                    dt.StopWatch.resume('midrollPlayingTime');
                }

                var timing = player.videoElement.getAttribute('data-current-time');
                timing = parseInt(timing);
                setTimeout(
                    function() {
                        if (timing && timing > 0) {
                            controller.seekTo(timing);
                            player.videoElement.removeAttribute('data-current-time');
                            if (player.videoElement.duration <= timing) {
                                excuteEnded(false);
                            } else {
                                if (state.currentVideo.resumeOffset) {
                                    var relatedData = {
                                        message: '마지막 시청 지점부터 이어서 재생됩니다.',
                                        callback: function() {
                                            exports.queue.emit('hide:modal');
                                        }
                                    };
                                    exports.queue.emit('show:notification', relatedData);
                                    state.currentVideo.resumeOffset = null;
                                }

                                player.play();
                            }
                        }
                    },
                    ua.os.ios || helpers.device.isPCWithSafari(ua) ? 500 : 10
                );
            } else {
                title = '광고 재생 중입니다.';
                artist = '';
            }

            mediaSession.updateMetadata(title, artist);
            inline.endSpinner();

            if (ua.platform === 'pc') {
                if (video && video.type === constants.VIDEO_TYPE.AD && env.isPrivateIp) {
                    analytics.chartHide();
                }

                inline.setSize();
                inline.reSize();
            }

            if (video && video.type !== constants.VIDEO_TYPE.AD && state.isFirstPlay) {
                onLoadVideoSize();
                state.isFirstPlay = false;
            }

            var self = this;

            var timer = setInterval(function() {
                if (self.currentTime > 0) {
                    if (dt.StopWatch.has('startPlay')) {
                        qoeTracker.track(qoeEvent.INITIAL_DELAY, { n1: dt.StopWatch.stop('startPlay') });
                    }

                    if (dt.StopWatch.has('rebuffering')) {
                        qoeTracker.track(qoeEvent.REBUFFERING, { n1: dt.StopWatch.stop('rebuffering') });
                    }
                    clearInterval(timer);
                }

                if (video && video.type !== constants.VIDEO_TYPE.AD) {
                    if (state.playbackRate !== player.getPlaybackRate()) {
                        player.setPlaybackRate(state.playbackRate, false);
                    }
                }
            }, 150);
        }

        function onPause() {
            var video = queue.front;
            debug.info('%c%s', 'color: #2074c0;', '[video event] pause - ', video && video.type, this.ended);
            togglePlayPause(player.isPaused());
            mediaSession.setPlaybackState(player.paused);

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                vastTracker.pause(true);
            } else {
                if (!state.seeking) {
                    adController.pauseNonLinearAd();
                }
                pvtTracker.pause();
            }

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onVideoStateChange, [
                constants.PLAYER_VIDEO_STATE.PAUSE,
                env.clipLinkId,
                player.getCurrentTimeRound(),
                video && video.type
            ]);

            if (ua.platform === 'pc') {
                if (video && video.type === constants.VIDEO_TYPE.VOD) {
                    if (this.ended) {
                        if (state.isMenuOpened) {
                            inlinePC.closeMenuBox();
                        }
                    }
                }
            }

            if (
                !this.ended &&
                !state.modalContentActivated &&
                (video && video.type) !== constants.VIDEO_TYPE.AD &&
                !state.isShowError
            ) {
                inline.showControl(true);
            }

            cancelAnimationFrame(requestAnimateId);
            retry.clearTimer();

            if (video && video.type !== constants.VIDEO_TYPE.AD) {
                dt.StopWatch.pause('playingTime');
                dt.StopWatch.pause('midrollPlayingTime');
            }
        }

        function onWaiting() {
            var video = queue.front;
            if (video && video.type !== constants.VIDEO_TYPE.LIVE) {
                if (!state.seeking) {
                    inline.startSpinner();
                    if (!dt.StopWatch.has('seek') && !dt.StopWatch.has('startPlay')) {
                        dt.StopWatch.start('rebuffering');
                    }
                }
            }
        }

        function onVolumeChange() {
            debug.info(
                '%c%s',
                'color: #2074c0;',
                '[video event] volumechange -',
                'mute:',
                this.muted,
                'volume:',
                this.volume
            );

            var video = queue.front;
            var muteOn = this.muted;
            var volume = this.volume;

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                vastTracker.setMute(muteOn);
            }

            if (ua.platform === 'pc') {
                inlinePC.toggleMuteUI(volume, muteOn);
            } else {
                inline.toggleMuteUI(muteOn);
            }
        }

        // 포스트롤 광고가 끝나거나 컨텐츠 영상이 끝난 경우에만 호출
        function onEndVideo() {
            state.ended = true;

            togglePlayPause(true);

            if (ua.platform === 'pc') {
                // 자동재생이 활성화 되어있고, 다음영상정보가 있는경우
                if (state.autoplay && completion.hasNextVideo()) {
                    inline.hideActivatedControl();
                    completion.showWaiting(function() {
                        helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onEndAutoPlayTimer);
                    });
                } else if (state.continuousPlay && completion.hasNextVideo()) {
                    inline.hideActivatedControl();
                } else {
                    inlinePC.onEndVideo();
                }
            } else {
                if (isFullScreen()) {
                    inline.hideDefaultControl();
                    inline.cancelFullscreen(player.videoElement);
                }

                clearTimeupdateTimeout();
                inline.hideActivatedControl();
                inline.onEndVideo();
            }

            tracker.sendLeftBeaconData();

            helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onPlayEnd);

            qoeTracker.clear();
        }

        var endVideo = {
            checkAdsComplete: function(video, isAdType, error) {
                if (isAdType) {
                    if (video.breakId === 'preroll') {
                        state.isPrerollEnded = true;
                        dt.StopWatch.start('startPlay');
                    } else if (video.breakId === 'midroll') {
                        state.currentVideo.midrollReq[state.midrollIndex].isStarted = true;
                        inline.setupMidrollAd(state.midrollIndex, true);
                    } else if (video.breakId === 'postroll') {
                        state.isPostrollEnded = true;
                    }

                    adController.inactivateAdControl();
                    if (!error) {
                        vastTracker.complete();
                    }
                } else {
                    state.isPrerollEnded = true;

                    pvtTracker.complete();
                }
            },
            loadPostroll: function(isMediaError) {
                if (state.isPrerollEnded && !state.isPostrollEnded) {
                    if (isMediaError) {
                        this.startQueueBeforeEnded();
                        state.isPostrollEnded = true;
                        return;
                    }

                    var self = this;

                    if (!state.isVastRequesting) {
                        adController.fetchPostroll().then(function() {
                            self.startQueueBeforeEnded();
                        });
                    }
                } else {
                    state.allAdsCompleted = true;
                    onEndVideo();
                }
            },
            startQueueBeforeEnded: function() {
                controller.startNextQueue(function() {
                    queue.contents.push(state.currentVideo);
                    onEndVideo();
                });
            },
            resolveCustomUI: function(video) {
                if (video && video.type === constants.VIDEO_TYPE.AD) {
                    adController.hideLinearAdContainer();
                } else if (video && video.type === constants.VIDEO_TYPE.VOD) {
                    adController.hideNonLinearAd();
                }

                inline.showVideoCursor();
                inline.updateProgressTime(player.getCurrentTimeRound(), player.getDurationRound());
            },
            complete: function(isMediaError) {
                var video = queue.front;

                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onVideoStateChange, [
                    constants.PLAYER_VIDEO_STATE.ENDED,
                    env.clipLinkId,
                    player.getCurrentTimeRound(),
                    video && video.type
                ]);

                if (!isSupportCustomController) {
                    onEndVideo();
                    return;
                }

                endVideo.loadPostroll(isMediaError);
            }
        };

        function excuteEnded(isMediaError) {
            var video = queue.front;
            var isAdType = video && video.type === constants.VIDEO_TYPE.AD;

            supposedCurrentTime = 0;

            exports.queue.emit('hide:customUI');

            debug.info('%c%s', 'color: #2074c0;', '[video event] ended', video && video.type, state.ended);

            endVideo.checkAdsComplete(video, isAdType, isMediaError);
            endVideo.resolveCustomUI(video);

            if (video && video.breakId === 'midroll' && isAdType) {
                queue.contents.push(state.currentVideo);

                if (state.dash) {
                    shaka.attach(player.videoElement).then(controller.startNextQueue);
                } else {
                    controller.startNextQueue();
                }
            } else if (!isAdType || (isAdType && video.breakId === 'postroll')) {
                endVideo.complete(isMediaError);
            } else {
                controller.startNextQueue();
            }

            exports.queue.emit('hide:action');
        }

        function onEnded() {
            if (state.playerClass === constants.PLAYERCLASS.KAMP) {
                return;
            }

            excuteEnded(false);
            inline.resetAriaAttr();
            mediaSession.resetMediaSession();
        }

        function onLoadedData() {
            var video = queue.front;
            var videoElement = player.videoElement;
            var callbackParameters = helpers.sdk.getDefaultCallbackParams(state.currentVideo);

            debug.info('%c%s', 'color: #2074c0;', '[video event] loadeddata -', video && video.type, state.ended);

            if (!state.ended) {
                inline.updateProgressTime(player.getCurrentTimeRound(), player.getDurationRound());
            }

            if (video && video.type !== constants.VIDEO_TYPE.LIVE && !helpers.tv.isConnected()) {
                updateBufferable.apply(videoElement);
            }

            if (video && video.type !== constants.VIDEO_TYPE.AD) {
                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onLoadedContentVideo, callbackParameters);
            }

            if (vastTracker && video && video.type === constants.VIDEO_TYPE.AD) {
                vastTracker.load();

                if (vastTracker.extension && video.timeOffset === 'end') {
                    vastTracker.extension.load();
                }
            }
            inline.setAriaAttr();

            clearTimeupdateTimeout();
            retry.clearTimer();

            if (ua.platform === 'pc') {
                inlinePC.onLoadedData();
            } else {
                extension.onLoadedData();
            }
        }

        function onLoadedMetaData() {
            debug.info('%c%s', 'color: #2074c0;', '[video event] loadedmetadata -', this.videoWidth, this.videoHeight);
        }

        function onError() {
            var video = queue.front;
            var error = this.error;

            debug.info('%c%s', 'color: #2074c0;', '[video event] error - ', video && video.type, error);

            inline.endSpinner();

            if (state.lockAirplayChangeEvent) {
                return;
            }

            if (error) {
                switch (error.code) {
                    case MediaError.MEDIA_ERR_ABORTED:
                    case MediaError.MEDIA_ERR_DECODE:
                    case MediaError.MEDIA_ERR_NETWORK:
                        retry.clearTimer();

                        exports.queue.emit('show:error', {
                            info: {
                                code: ERROR_STATUS.UNAVAILABLE.NAME
                            }
                        });
                        var messageData = {
                            title: 'videoMediaError',
                            code: error.code
                        };

                        helpers.sentry.captureMessage(JSON.stringify(messageData));
                        break;
                    case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
                        var currentVideo = state.currentVideo;
                        var isMediaError = true;
                        var errorCode =
                            queue.front && queue.front.type === 'AD'
                                ? ERROR_STATUS.UNAVAILABLE_ADCONTENTS.NAME
                                : ERROR_STATUS.UNAVAILABLE.NAME;

                        if (
                            queue.front &&
                            queue.front.type === constants.VIDEO_TYPE.AD &&
                            currentVideo.skipOnErrorOfAdContents
                        ) {
                            excuteEnded(isMediaError);
                        } else if (
                            state.hls &&
                            currentVideo.videoUrl &&
                            helpers.validator.isHlsVideo(currentVideo.videoUrl)
                        ) {
                            state.hls = false;
                            exports.queue.emit(
                                'loadAndPlay:videoById',
                                currentVideo.id,
                                currentVideo.profile,
                                0,
                                null,
                                Object.assign({}, state)
                            );
                        } else {
                            exports.queue.emit('show:error', {
                                info: {
                                    code: errorCode
                                }
                            });
                        }
                        break;
                }
            } else if (window.navigator.onLine) {
                exports.queue.emit('show:error', {
                    info: {
                        code: ERROR_STATUS.UNAVAILABLE.NAME
                    }
                });
            } else {
                exports.queue.emit('show:error', {
                    info: {
                        code: ERROR_STATUS.NETWORK_OFFLINE.NAME
                    }
                });
            }

            if (queue.front && queue.front.type === 'AD') {
                vastTracker.error('403');
            }
            inline.resetAriaAttr();
        }

        function onLoadStart() {
            var video = queue.front;

            if (!video) {
                return;
            }

            if (video.type === constants.VIDEO_TYPE.AD) {
                adController.hideNonLinearAd();
            } else {
                adController.hideLinearAdContainer();
            }

            if (ua.platform === 'pc') {
                inlinePC.onLoadStart();
            } else {
                inline.onLoadStart();
            }

            debug.info('%c%s', 'color: #2074c0;', '[video event] loadstart');
        }

        function onSuspend() {
            debug.info('%c%s', 'color: #2074c0;', '[video event] suspend');
        }

        function onEmptied() {
            debug.info('%c%s', 'color: #2074c0;', '[video event] emptied');
        }

        function updateProgress() {
            inline.onTimeUpdate(player.getCurrentTime(), player.getDurationRound());
            requestAnimateId = window.requestAnimationFrame(updateProgress);
        }

        function clearTimeupdateTimeout() {
            if (timeupdateTimeout) {
                clearTimeout(timeupdateTimeout);
                timeupdateTimeout = null;
            }
        }

        function sendOffsetPointUpdate() {
            var currentTime = player.getCurrentTimeRound();
            var offsetPoints = env.offsetPoints;
            var video = queue.front;

            if (offsetPoints && offsetPoints[currentTime] && video.type !== constants.VIDEO_TYPE.AD) {
                helpers.sdk.sendEventCallback(constants.PLAYER_CALLBACK_NAME.onOffsetPointUpdate, [currentTime]);
            }
        }

        var listener = {
            videoEvent: function(videoEl) {
                event.on(videoEl, 'abort', onAbort);
                event.on(videoEl, 'canplay', onCanPlay);
                event.on(videoEl, 'durationchange', onDurationChange);
                event.on(videoEl, 'emptied', onEmptied);
                event.on(videoEl, 'ended', onEnded);
                event.on(videoEl, 'error', onError);
                event.on(videoEl, 'loadeddata', onLoadedData);
                event.on(videoEl, 'loadedmetadata', onLoadedMetaData);
                event.on(videoEl, 'loadstart', onLoadStart);
                event.on(videoEl, 'pause', onPause);
                event.on(videoEl, 'play', onPlay);
                event.on(videoEl, 'playing', onPlaying);
                event.on(videoEl, 'progress', onProgress);
                event.on(videoEl, 'seeking', onSeeking);
                event.on(videoEl, 'seeked', onSeeked);
                event.on(videoEl, 'suspend', onSuspend);
                event.on(videoEl, 'timeupdate', onTimeUpDate);
                event.on(videoEl, 'volumechange', onVolumeChange);
                event.on(videoEl, 'waiting', onWaiting);

                event.on(window, 'beforeunload', function() {
                    if (queue.front && queue.front.type === 'AD') {
                        vastTracker.close();
                    }
                });
            },
            customEvent: function(sandbox) {
                sandbox.on('video:abort', onAbort);
                sandbox.on('video:canplay', onCanPlay);
                sandbox.on('video:durationchange', onDurationChange);
                sandbox.on('video:emptied', onEmptied);
                sandbox.on('video:ended', onEnded);
                sandbox.on('video:error', onError);
                sandbox.on('video:loadeddata', onLoadedData);
                sandbox.on('video:loadedmetadata', onLoadedMetaData);
                sandbox.on('video:loadstart', onLoadStart);
                sandbox.on('video:pause', onPause);
                sandbox.on('video:play', onPlay);
                sandbox.on('video:playing', onPlaying);
                sandbox.on('video:progress', onProgress);
                sandbox.on('video:seeking', onSeeking);
                sandbox.on('video:seeked', onSeeked);
                sandbox.on('video:suspend', onSuspend);
                sandbox.on('video:timeupdate', onTimeUpDate);
                sandbox.on('video:volumechange', onVolumeChange);
                sandbox.on('video:waiting', onWaiting);
            }
        };

        function EventVideo() {}

        EventVideo.prototype.init = function(player, sandbox) {
            this.videoEl = player.videoElement;
            listener.videoEvent(this.videoEl, sandbox);
            listener.customEvent(sandbox);
        };

        EventVideo.prototype.setEventListner = function(videoElement) {
            this.videoEl = videoElement;
            listener.videoEvent(this.videoEl);
        };

        EventVideo.prototype.onEnded = function() {
            excuteEnded(false);
            inline.resetAriaAttr();
        };

        return EventVideo;
    })();

    exports.addModule('event.video', new EventVideo());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var queue = exports.loadModule('playlist.queue');
    var state = exports.loadModule('controller.state');
    var pvtTracker = exports.loadModule('pvt.tracker');
    var qoeTracker = exports.loadModule('qoe.tracker');
    var shaka = exports.loadModule('player.shaka');
    var player = exports.loadModule('player.adapter');
    var inlinePC = exports.loadModule('view.inline.pc');
    var inline = exports.loadModule('view.inline');
    var cover = exports.loadModule('view.cover');
    var extension = exports.loadModule('view.extension');
    var completion = exports.loadModule('view.completion');
    var controller = exports.loadModule('controller.video');
    var liveController = exports.loadModule('controller.live');
    var adController = exports.loadModule('controller.ad');
    var eventVideo = exports.loadModule('event.video');
    var action = exports.loadModule('view.action');

    var CustomEvent;

    CustomEvent = (function() {
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;
        var ua = exports.ua;
        var ERROR_STATUS = constants.ERROR.STATUS;
        var qoeEvent = constants.QOE.EVENT;

        var addListener = function(sandbox) {
            sandbox.on('skip:ad', function() {
                adController.inactivateAdControl();

                if (queue.front.type === 'AD' && queue.front.breakId === 'preroll') {
                    state.isPrerollEnded = true;
                    controller.startNextQueue();
                } else if (queue.front.type === 'AD' && queue.front.breakId === 'midroll') {
                    controller.startNextQueue(function() {
                        adController.updateMidrollState();
                        queue.contents.push(state.currentVideo);

                        if (state.dash) {
                            shaka.attach(player.videoElement).then(controller.startNextQueue);
                        } else {
                            controller.startNextQueue();
                        }
                    });
                }
            });

            sandbox.on('play:live', function(profile) {
                liveController.preStartVideo(profile);
                debug.log('play:live', profile);
            });

            sandbox.on('play:vod', function(profile) {
                controller.preStartVideo(profile);
                debug.log('play:vod', profile);
            });

            sandbox.on('load:videoUrl', function(clip, callback) {
                controller.loadVideoResource(clip);

                if (callback && typeof callback === 'function') {
                    callback();
                }
                debug.log('load:videoUrl', clip);
            });

            sandbox.on('load:videoById', function(startTime, isAutoPlay, password) {
                var id = state.currentVideo.id || env.id;
                var profile = state.dash
                    ? constants.DASH_PROFILE[state.currentVideo.profile]
                    : state.currentVideo.profile || env.profile;

                if (player.type === 'VOD') {
                    controller.load(id, profile, startTime, isAutoPlay);
                } else if (player.type === 'LIVE') {
                    liveController.load(id, profile, isAutoPlay, password);
                }

                helpers.debug.tooltip('load:videoById', id, profile, startTime, isAutoPlay);
            });

            sandbox.on('loadAndPlay:videoById', function(_id, _profile, startTime, bucket, preserveState, isReplay) {
                controller.loadAndPlay(_id, _profile, startTime, bucket, preserveState, isReplay);

                helpers.debug.tooltip(
                    'loadAndPlay:videoById',
                    _id,
                    _profile,
                    startTime,
                    bucket,
                    preserveState,
                    isReplay
                );
            });

            sandbox.on('load:meta', function(info) {
                var metaUrl = info.metaUrl;
                var callback = info.callback;

                state.currentVideo.set({ metaUrl: metaUrl });
                controller.fetchMeta().then(callback);
            });

            sandbox.on('complete:readyAndPlay', function(result) {
                exports.queue.emit('complete:ready', result);
                exports.queue.emit('complete:play', result);
                debug.info('%c%s', 'color: #20b408', '2-1. [custom event] complete readyAndPlay', result);
            });

            sandbox.on('complete:ready', function(result) {
                debug.info('%c%s', 'color: #20b408', '1. [custom event] complete ready', result);
            });

            sandbox.on('complete:play', function(result) {
                var data, videoLocation;

                if (result.status === 'success') {
                    data = result.data;
                    videoLocation = data.videoLocation;

                    if (!videoLocation || !videoLocation.url) {
                        exports.queue.emit('show:error', {
                            info: {
                                code: ERROR_STATUS.UNAVAILABLE.NAME
                            }
                        });
                    }
                }
                debug.info('%c%s', 'color: #20b408', '2. [custom event] complete play', result);
            });

            sandbox.on('complete:meta', function(result) {
                if (result.status === 'success') {
                    if (cover) {
                        cover.onCompleteMeta();
                    }

                    if (extension) {
                        extension.onCompleteMeta();
                    }

                    if (ua.platform === 'pc') {
                        inlinePC.onCompleteMeta();
                    } else {
                        inline.onCompleteMeta();
                    }

                    if (env.rel) {
                        exports.queue.emit('create:completion');
                    }
                    exports.queue.emit('create:contextmenu');
                }
                debug.info('%c%s', 'color: #20b408', '3. [custom event] complete meta', result);
            });
            sandbox.on('complete:vmap', function(result) {
                var skipOnErrorOfAdApi = state.currentVideo.skipOnErrorOfAdApi;
                var response = result.res;

                debug.info('%c%s', 'color: #20b408', '4. [custom event] complete:vmap', result);

                if (result.status === 'success') {
                    if (response) {
                        adController.resolveVmap(response);
                    }
                } else if (result.status === 'error' && !skipOnErrorOfAdApi) {
                    exports.queue.emit('show:error', {
                        info: {
                            code: ERROR_STATUS.UNAVAILABLE_ADBLOCK.NAME
                        }
                    });
                }
                debug.info('%c%s', 'color: #20b408', '5. [custom event] complete:parse:vmap', result);
            });

            sandbox.on('complete:vast', function(result) {
                var response = result.res;
                var request = result.req;
                var skipOnErrorOfAdApi = state.currentVideo.skipOnErrorOfAdApi;
                state.isVastRequesting = false;

                if (result.status === 'success') {
                    if (response) {
                        adController.resolveVast(request, response);
                    }
                } else if (result.status === 'error') {
                    if (skipOnErrorOfAdApi) {
                        adController.inactivateAdControl();
                    } else {
                        exports.queue.emit('show:error', {
                            info: {
                                code: ERROR_STATUS.UNAVAILABLE_ADBLOCK.NAME
                            }
                        });
                    }
                }
                debug.info('%c%s', 'color: #20b408', '8. [custom event] complete:vast', result);
            });

            sandbox.on('complete:location', function(data) {
                debug.info('complete:location', data);

                if (data.status === 'success') {
                    if (ua.platform === 'pc') {
                        inlinePC.changeProfileLabel();
                        inlinePC.hideProfileList();
                    }
                    controller.changeVideoResource();
                    player.play();
                }

                if (data.callback && typeof data.callback === 'function') {
                    data.callback();
                }
            });

            sandbox.on('set:videosource', function() {
                debug.info('set:videosource');
            });

            sandbox.on('request:fullscreen', function() {
                if (ua.platform === 'pc') {
                    inlinePC.hideWide();
                }
            });

            sandbox.on('cancel:fullscreen', function() {
                if (env.isInternal && !env.popup && ua.platform === 'pc') {
                    inlinePC.showWide();
                }
            });

            sandbox.on('layerStatus:check', function() {
                if (inline.isFullScreen()) {
                    inline.cancelFullscreen();
                }

                inline.hideActivatedControl();
                extension.hideModal();
            });

            sandbox.on('show:cover', function() {
                cover.showCover();
            });

            sandbox.on('hide:cover', function() {
                cover.hideCover();
            });

            sandbox.on('window:unload', function() {
                player.stop();
                pvtTracker.end(dt.StopWatch.stop('playingTime'));
                debug.info('unload:player');
            });

            sandbox.on('change:stream', function() {
                var prevProfile = '';
                var currentProfile = '';

                if (state.needSetTrack) {
                    state.needSetTrack = false;
                    shaka.getOutputs(function() {
                        shaka.setTrack(state.currentVideo.profile);
                        if (ua.platform !== 'pc') {
                            extension.setProfile(state.currentVideo.profile);
                            inline.setProfile(state.currentVideo.profile);
                        }
                    });
                } else {
                    prevProfile = shaka.getPrevProfile();
                    currentProfile = shaka.getCurrentProfile();

                    if (prevProfile !== currentProfile) {
                        qoeTracker.track(qoeEvent.RESOLUTION_CHANGE, {
                            l1: prevProfile,
                            rslu: currentProfile
                        });
                        shaka.setPrevProfile(currentProfile);
                    }

                    if (ua.platform === 'pc') {
                        inlinePC.changeProfileLabel();
                    } else {
                        inline.setProfile(constants.PROFILE.AUTO);
                    }
                }
            });

            sandbox.on('shaka:buffering', function(buffering) {
                if (buffering) {
                    inline.startSpinner();
                    if (!dt.StopWatch.has('seek') && !dt.StopWatch.has('startPlay')) {
                        dt.StopWatch.start('rebuffering');
                    }
                } else {
                    inline.endSpinner();
                    if (dt.StopWatch.has('rebuffering')) {
                        qoeTracker.track(qoeEvent.REBUFFERING, { n1: dt.StopWatch.stop('rebuffering') });
                    }
                }
            });

            sandbox.on('shaka:error', function() {
                var currentTime = player.getCurrentTime();
                qoeTracker.track(qoeEvent.PLAYBACK_FAIL, { l1: currentTime ? 'middle' : 'initail' });
                qoeTracker.clear();
            });

            sandbox.on('addlistener:videoEvent', function(videoElement) {
                eventVideo.setEventListner(videoElement);
            });

            sandbox.on('onClosed:videoEvent', function() {
                eventVideo.onEnded();
            });

            sandbox.on('hide:modal', function() {
                if (!state.ended) {
                    completion.hideCompletion();
                }
            });

            sandbox.on('spinner:end', function() {
                inline.endSpinner();
            });

            sandbox.on('ad:checkMidrollAd', function() {
                adController.checkMidrollAd(true, controller.startNextQueue);
            });

            sandbox.on('live:getLocation', function(profile) {
                state.currentVideo.contentType = constants.CONTENT_TYPE.NPP;
                inline.startSpinner();
                inline.getLiveLocation(profile);
            });

            sandbox.on('live:updateSetupView', function(profile) {
                inlinePC.updateSetupView(profile);
            });

            sandbox.on('load:videoById:withPlayerUnload', function(startTime, isAutoPlay, password) {
                exports.queue
                    .emit('unload:player')
                    .then(function() {
                        exports.queue.emit('load:videoById', startTime, isAutoPlay, password);
                    })
                    .catch(function(e) {
                        debug.warn('Fail load:videoById:withPlayerUnload ', e);
                    });
            });

            sandbox.on('loadAndPlay:videoById:withPlayerUnload', function(
                _id,
                _profile,
                startTime,
                bucket,
                preserveState
            ) {
                exports.queue
                    .emit('unload:player')
                    .then(function() {
                        exports.queue.emit('loadAndPlay:videoById', _id, _profile, startTime, bucket, preserveState);
                    })
                    .catch(function(e) {
                        debug.warn('Fail loadAndPlay:videoById:withPlayerUnload ', e);
                    });
            });

            sandbox.on('loadAndPlay:videoById:replay', function(_id, _profile, startTime, bucket, preserveState) {
                exports.queue
                    .emit('unload:player')
                    .then(function() {
                        exports.queue.emit(
                            'loadAndPlay:videoById',
                            _id,
                            _profile,
                            startTime,
                            bucket,
                            preserveState,
                            true
                        );
                    })
                    .catch(function(e) {
                        debug.warn('Fail loadAndPlay:videoById:withPlayerUnload ', e);
                    });
            });

            sandbox.on('show:action', function() {
                var video = queue.front;

                if (video && video.type !== constants.VIDEO_TYPE.AD) {
                    if (!player.isPaused() && state.hasAction && state.isPrerollEnded && !state.modalContentActivated) {
                        action.showButton();
                    }
                }
            });

            sandbox.on('hide:action', function() {
                action.hideButton();
            });

            sandbox.on('unload:player', function() {
                state.initInitialState();

                if (state.dash) {
                    shaka.reset(player.videoElement);
                }
            });

            sandbox.on('show:preview', function() {
                inline.showTvod();
            });

            sandbox.on('reset:playList', function() {
                queue.set([]);
            });

            sandbox.on('set:defaultOptions', function() {
                controller.setDefaultOptions();
            });

            sandbox.on('reset:env:mute', function() {
                env.mute = false;
            });
        };

        function CustomEvent() {}

        CustomEvent.prototype.init = function(player, sandbox) {
            addListener(sandbox);
        };

        return CustomEvent;
    })();

    exports.addModule('event.custom', new CustomEvent());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports, dt) {
    'use strict';

    var state = exports.loadModule('controller.state');
    var player = exports.loadModule('player.adapter');
    var adController = exports.loadModule('controller.ad');
    var controller = exports.loadModule('controller.video');
    var castController = exports.loadModule('controller.cast');
    var queue = exports.loadModule('playlist.queue');
    var inline = exports.loadModule('view.inline');
    var cast = exports.loadModule('view.cast');
    var retry = exports.loadModule('view.retry');

    var EventCastVideo;

    EventCastVideo = (function() {
        var ua = exports.ua;
        var event = dt.event;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var constants = exports.constants;

        var currentTime = 0;

        var airplayTimer = null;

        var airplay = {
            timer: null,
            play: function() {
                if (this.timer) {
                    return;
                }

                var airplay = this;

                this.timer = setInterval(function() {
                    var videoElement = player.videoElement;
                    var isOnTv = videoElement.webkitCurrentPlaybackTargetIsWireless;

                    if (isOnTv) {
                        setTimeout(function() {
                            if (player.isPaused()) {
                                player.play();
                                if (currentTime > 0) {
                                    player.seekTo(currentTime);
                                }
                            } else {
                                clearInterval(airplay.timer);
                                airplay.timer = null;
                            }
                        }, 1000);
                    }
                }, 1500);
            }
        };

        function onConnectedChange(e) {
            var videoType = state.currentVideo && state.currentVideo.type;
            var isConnected = e.value;

            debug.log('[Remote Event] IS_CONNECTED_CHANGED: ', videoType, e);

            if (!state.currentVideo) {
                castController.resetCastPlayer();
                castController.registerRemoteEventListener(removeRemoteEventListener);
                return;
            }

            if (videoType === constants.VIDEO_TYPE.LIVE && isConnected) {
                castController.loadRemotePlayerForLive();
                return;
            } else if (videoType === constants.VIDEO_TYPE.LIVE) {
                castController.cancelRemotePlayerForLive();
                return;
            }

            if (isConnected) {
                castController.loadRemotePlayer();
                return;
            }

            castController.cancelRemotePlayer(currentTime);
        }

        function onPlayerStateChange(e) {
            debug.log('[Remote Event] PLAYER_STATE_CHANGED: ', e);

            var remoteState = e.value;
            var mediaState = castController.getMediaState();

            if (remoteState === mediaState.PLAYING) {
                inline.endSpinner();
                exports.queue.emit('video:playing');
                exports.queue.emit('video:play');
            }
        }

        function onIsPausedChange(e) {
            debug.log('[Remote Event] IS_PAUSED_CHANGED: ', e);
            var isPaused = e.value;

            if (isPaused) {
                exports.queue.emit('video:pause');
            } else {
                exports.queue.emit('video:play');
            }
        }

        function onCurrentTimeChange(e) {
            debug.log('[Remote Event] CURRENT_TIME_CHANGED: ', e);

            var video = queue.front;
            var remoteCurrentTime = e.value;
            var playerCurrentTime = player.getCurrentTimeRound();
            var playerDuration = player.getDurationRound();
            var isEnded = playerDuration && playerCurrentTime === playerDuration;
            var isSeeked = false;

            if (playerCurrentTime !== 0 && playerCurrentTime !== currentTime + 1) {
                isSeeked = true;
            }

            inline.endSpinner();

            if (isEnded) {
                debug.log('[Remote Event] IS_MEDIA_LOADED_CHANGED - ENDED: ', video.type, currentTime, playerDuration);
                var ended = exports.queue.emit('onClosed:videoEvent');

                if (video && video.type === constants.VIDEO_TYPE.AD) {
                    exports.queue.emit('video:timeupdate');
                } else {
                    currentTime = 0;
                    ended.then(function() {
                        player.stop();

                        if (state.currentVideo.type === constants.VIDEO_TYPE.VOD) {
                            state.ended = true;
                            removeRemoteEventListener();
                            castController.cancelRemotePlayer();
                        } else if (state.currentVideo.type === constants.VIDEO_TYPE.LIVE) {
                            castController.cancelRemotePlayerForLive();
                        }
                    });
                }
            }

            if (isSeeked && video.type === constants.VIDEO_TYPE.VOD) {
                if (playerCurrentTime === 0 || playerCurrentTime === currentTime) {
                    return;
                }

                debug.log('[Remote Event] SEEKED: ', playerCurrentTime, currentTime);

                currentTime = playerCurrentTime;

                if (!state.ended) {
                    if (!state.pausedBeforeSeek) {
                        player.play();
                        if (player.isPaused()) {
                            state.needMidrollRequest = true;
                        } else {
                            adController.checkMidrollAd(true, controller.startNextQueue);
                        }
                    } else {
                        state.needMidrollRequest = true;
                    }
                }
                return;
            }

            if (remoteCurrentTime > 0 && video.type !== constants.VIDEO_TYPE.AD) {
                currentTime = playerCurrentTime;
                exports.queue.emit('video:timeupdate');
            }

            if (player.isPaused()) {
                retry.clearTimer();
            }
        }

        function onIsMedeaLoadedChange(e) {
            debug.log('[Remote Event] IS_MEDIA_LOADED_CHANGED: ', e, currentTime);
            var isLoaded = e.value;

            if (isLoaded) {
                exports.queue.emit('video:loadstart');
                exports.queue.emit('video:loadeddata');
                exports.queue.emit('video:canplay');
            }
        }

        function onDurationChange(e) {
            debug.log('[Remote Event] DURATION_CHANGED: ', e);
            exports.queue.emit('video:durationchange');
        }

        function onVolumeChange(e) {
            debug.log('[Remote Event] VOLUME_LEVEL_CHANGED: ', e);
        }

        function onMutedChange(e) {
            debug.log('[Remote Event] IS_MUTED_CHANGED: ', e);
        }

        function registerRemoteEventListener(remoteController) {
            setRemoteEventListener(remoteController);
        }

        function removeRemoteEventListener(remoteController) {
            setRemoteEventListener(remoteController, true);
        }

        function setRemoteEventListener(remoteController, isRemoving) {
            var remoteEventType = castController.getRemoteEventType();
            var eventListenerMethod = event.on;

            if (isRemoving) {
                eventListenerMethod = event.off;
            }

            eventListenerMethod(remoteController, remoteEventType.IS_CONNECTED_CHANGED, onConnectedChange);
            eventListenerMethod(remoteController, remoteEventType.PLAYER_STATE_CHANGED, onPlayerStateChange);
            eventListenerMethod(remoteController, remoteEventType.IS_PAUSED_CHANGED, onIsPausedChange);
            eventListenerMethod(remoteController, remoteEventType.CURRENT_TIME_CHANGED, onCurrentTimeChange);
            eventListenerMethod(remoteController, remoteEventType.IS_MEDIA_LOADED_CHANGED, onIsMedeaLoadedChange);
            eventListenerMethod(remoteController, remoteEventType.DURATION_CHANGED, onDurationChange);
            eventListenerMethod(remoteController, remoteEventType.VOLUME_LEVEL_CHANGED, onVolumeChange);
            eventListenerMethod(remoteController, remoteEventType.IS_MUTED_CHANGED, onMutedChange);
        }

        function onChangeAirplayDisplay() {
            var video = queue.front;
            var videoElement = player.videoElement;
            var isOnTv = videoElement.webkitCurrentPlaybackTargetIsWireless;

            debug.log(
                '[AirPlay Event] Change Display',
                ', isDash: ',
                state.dash,
                ', isTv: ',
                isOnTv,
                ', lockAirplayChangeEvent: ',
                state.lockAirplayChangeEvent
            );

            if (isOnTv) {
                cast.showConnected();
            } else {
                cast.showDisconnected();
            }

            castController.hideMenuOnCast(true);

            if (state.lockAirplayChangeEvent) {
                return;
            } else {
                state.lockAirplayChangeEvent = true;
            }

            player.pause();

            if (video && video.type === constants.VIDEO_TYPE.AD) {
                return;
            } else {
                currentTime = player.getCurrentTimeRound();
            }

            if (!state.dash || airplayTimer || state.isFirstPlay) {
                return;
            }

            castController.convertSrcMode();
        }

        function registerAirplayEventListener() {
            var videoElement = player.videoElement;
            var airPlayDisplayChangeEvent = 'webkitcurrentplaybacktargetiswirelesschanged';

            event.on(videoElement, airPlayDisplayChangeEvent, onChangeAirplayDisplay);
        }

        var listener = {
            videoEvent: function() {
                if (ua.platform !== 'pc') {
                    return;
                }

                window['__onGCastApiAvailable'] = function(isAvailable) {
                    try {
                        if (isAvailable) {
                            castController.create();
                            castController.registerRemoteEventListener(registerRemoteEventListener);
                            cast.showBox();
                            cast.showChromecastBox();
                        } else {
                            cast.hideBox();
                            cast.hideChromecastBox();
                        }
                    } catch (e) {
                        debug.warn('Chromecast failed to load: ', e);
                    }
                };

                if (window.WebKitPlaybackTargetAvailabilityEvent) {
                    registerAirplayEventListener();
                    var videoElement = player.videoElement;

                    videoElement.addEventListener('canplay', function() {
                        var isOnTv = videoElement.webkitCurrentPlaybackTargetIsWireless;
                        state.lockAirplayChangeEvent = false;

                        if (isOnTv) {
                            inline.endSpinner();
                            airplay.play();
                        }
                    });
                }
            }
        };

        function EventCastVideo() {}

        EventCastVideo.prototype.init = function(player, sandbox) {
            this.videoEl = player.videoElement;
            listener.videoEvent(this.videoEl, sandbox);
        };

        return EventCastVideo;
    })();

    exports.addModule('event.video.cast', new EventCastVideo());
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet), window.daumtools);

(function(exports) {
    'use strict';

    var helpers = exports.helpers;

    function sendEventCallback(eventName, args) {
        helpers.sdk.sendEventCallback(eventName, args);
    }

    function BaseApiAdapter() {}

    BaseApiAdapter.prototype = {
        load: function() {},
        loadAndPlay: function() {},
        play: function() {},
        pause: function() {},
        stop: function() {},
        seekTo: function() {},
        mute: function() {},
        unMute: function() {},
        setVolume: function() {},
        getDuration: function() {},
        increaseUpCnt: function() {},
        setListPlayMode: function() {},
        setRepeatMode: function() {},
        setVerticalMode: function() {},
        setAutoplayVisible: function() {},
        setContinuousPlay: function() {},
        unsetVerticalMode: function() {},
        popupUrl: function() {},
        setBeaconData: function() {},
        changeScreenType: function() {},
        setAutoPlayMode: function() {},
        setWideScreenMode: function() {},
        requestFullScreen: function() {},
        cancelFullScreen: function() {},
        changeOrientation: function() {},
        setCallback: function() {},
        fireEvent: function(eventName, args) {
            sendEventCallback(eventName, args);
        },
        checkInited: function() {
            helpers.sendOnAlreadyInited();
        }
    };

    function FlashVodApiAdapter() {}

    FlashVodApiAdapter.prototype = new BaseApiAdapter();
    FlashVodApiAdapter.prototype.loadAndPlay = function(id) {
        window.daumVodPlayerPlay(id);
    };
    FlashVodApiAdapter.prototype.play = function() {
        window.daumVodPlayerVideoPlay(true);
    };
    FlashVodApiAdapter.prototype.pause = function() {
        window.daumVodPlayerVideoPause(true);
    };
    FlashVodApiAdapter.prototype.seekTo = function(sec) {
        window.daumVodPlayerSeek(sec);
    };
    FlashVodApiAdapter.prototype.setVolume = function(number) {
        window.daumVodPlayerSetVolume(number * 100);
    };
    FlashVodApiAdapter.prototype.getDuration = function() {
        return window.daumVodPlayerPlayDuration();
    };
    /**
     * @deprecated
     */
    FlashVodApiAdapter.prototype.increaseUpCnt = function() {
        window.daumVodPlayerIncreaseUpCnt();
    };
    FlashVodApiAdapter.prototype.setListPlayMode = function(isListPlay) {
        window.daumVodPlayerListPlayMode(isListPlay);
    };
    FlashVodApiAdapter.prototype.setRepeatMode = function(type) {
        window.daumVodPlayerRepeatMode(type);
    };
    FlashVodApiAdapter.prototype.setVerticalMode = function() {
        window.daumVodPlayerSetVerticalMode();
    };
    FlashVodApiAdapter.prototype.unsetVerticalMode = function() {
        window.daumVodPlayerUnsetVerticalMode();
    };
    FlashVodApiAdapter.prototype.popupUrl = function(url) {
        window.popupBydaumVodPlayer(url);
    };
    FlashVodApiAdapter.prototype.changeScreenType = function(screenType) {
        window.changeScreenType(screenType);
    };
    FlashVodApiAdapter.prototype.setCallback = function(callbacks) {
        if (window.apiMessenger) {
            window.apiMessenger.setCallback(callbacks);
        }
    };

    function Html5PlayerAdapter(player) {
        this.player = player;
    }

    Html5PlayerAdapter.prototype = new BaseApiAdapter();

    Html5PlayerAdapter.prototype.load = function(id, profile, start) {
        this.player.load(id, profile, start);
    };
    Html5PlayerAdapter.prototype.loadAndPlay = function(id, profile, start) {
        this.player.loadAndPlay(id, profile, start);
    };
    Html5PlayerAdapter.prototype.play = function(profile) {
        this.player.play(profile);
    };
    Html5PlayerAdapter.prototype.pause = function() {
        this.player.pause();
    };
    Html5PlayerAdapter.prototype.stop = function() {
        this.player.stop();
    };
    Html5PlayerAdapter.prototype.seekTo = function(sec) {
        this.player.seekTo(sec);
    };
    Html5PlayerAdapter.prototype.setVolume = function(number) {
        this.player.setVolume(number);
    };
    Html5PlayerAdapter.prototype.mute = function() {
        this.player.setMute(true);
    };
    Html5PlayerAdapter.prototype.unMute = function() {
        this.player.setMute(false);
    };
    Html5PlayerAdapter.prototype.getDuration = function() {
        this.player.getDuration();
    };
    Html5PlayerAdapter.prototype.setBeaconData = function(beaconData) {
        this.player.setBeaconData(beaconData);
    };
    Html5PlayerAdapter.prototype.setAutoPlayMode = function(isAutoPlay) {
        this.player.setAutoPlayMode(isAutoPlay);
    };
    Html5PlayerAdapter.prototype.setNextVideo = function(clipLinkId) {
        this.player.setNextVideo(clipLinkId);
    };
    Html5PlayerAdapter.prototype.setContinuousPlay = function(isContinuousPlay) {
        this.player.setContinuousPlay(isContinuousPlay);
    };
    Html5PlayerAdapter.prototype.setAutoplayVisible = function(visibility) {
        this.player.setAutoplayVisible(visibility);
    };

    Html5PlayerAdapter.prototype.setPlaybackRate = function(rate) {
        this.player.setPlaybackRate(rate);
    };

    Html5PlayerAdapter.prototype.setWideScreenMode = function(isWideScreen) {
        this.player.setWideScreenMode(isWideScreen);
    };

    Html5PlayerAdapter.prototype.requestFullScreen = function() {
        this.player.requestFullScreen();
    };

    Html5PlayerAdapter.prototype.cancelFullScreen = function() {
        this.player.cancelFullScreen();
    };

    Html5PlayerAdapter.prototype.changeOrientation = function(data) {
        this.player.changeOrientation(data);
    };

    Html5PlayerAdapter.prototype.setCallback = function(callbacks) {
        if (window.apiMessenger) {
            window.apiMessenger.setCallback(callbacks);
        }
    };

    function registerApiAdapter(apiAdapter) {
        window.API = apiAdapter;
    }

    function registerApiMessenger(usePostMessage) {
        window.apiMessenger = (function() {
            var _callbacks = null;

            function sendMessage(message) {
                try {
                    if (window.postMessage && usePostMessage && window !== parent) {
                        parent.postMessage(JSON.stringify(message), '*');
                    }
                } catch (e) {}
            }

            function receiveMessage(e) {
                var data = e.data;
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    return;
                }

                var action = data.action;
                var args = data.args;

                if (window.API && typeof window.API[action] === 'function') {
                    if (Array.isArray(args)) {
                        window.API[action].apply(window.API, args);
                    } else {
                        window.API[action].call(window.API, args);
                    }
                }
            }

            if (window.addEventListener) {
                window.addEventListener('message', receiveMessage);
            } else if (window.attachEvent) {
                window.attachEvent('onmessage', receiveMessage);
            }

            return {
                setCallback: function(callbacks) {
                    _callbacks = callbacks;
                },
                sendCallback: function(callbackName, args) {
                    var name = null;

                    if (typeof callbackName === 'function') {
                        name = callbackName.name;
                    } else {
                        name = callbackName;
                    }

                    if (_callbacks) {
                        if (typeof _callbacks[name] === 'function') {
                            if (typeof args !== 'undefined') {
                                _callbacks[name].apply(window, args);
                            } else {
                                _callbacks[name].apply(window);
                            }
                        }
                    } else {
                        sendMessage({
                            action: name,
                            args: args
                        });
                    }
                }
            };
        })();
    }

    window.FlashVodApiAdapter = FlashVodApiAdapter;
    window.Html5PlayerAdapter = Html5PlayerAdapter;
    window.registerApiAdapter = registerApiAdapter;
    window.registerApiMessenger = registerApiMessenger;
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));

(function(exports) {
    'use strict';

    var Player = (window.Player = function(videoElement, playerSetting) {
        this.init(videoElement, playerSetting);
    });

    Player.prototype = (function() {
        var html5 = exports.loadModule('player.html5');
        var controller = exports.loadModule('controller.video');
        var liveController = exports.loadModule('controller.live');
        var queue = exports.loadModule('playlist.queue');

        var ua = exports.ua;
        var constants = exports.constants;
        var helpers = exports.helpers;
        var debug = helpers.debug;
        var env = exports.ENV;

        var PROFILE_KEY = constants.STORAGE.PROFILE;
        var ABR_KEY = constants.STORAGE.ABR;

        function createPlayer() {
            debug.info('video type:', this.type);

            if (ua.platform === 'pc') {
                if ((ua.browser.msie && ua.browser.version.major < 9) || this.type === 'LIVE') {
                    //  player = controller.getFlashPlayer();
                } else {
                    return html5;
                }
            } else {
                return html5;
            }
        }

        function initModules(player) {
            exports.init(player);
        }

        function profileCheck(config, paramProfile) {
            var defaultProfile = config.profile;
            var forceProfile = config.forceProfile;
            var storeProfile = helpers.store.get(PROFILE_KEY);
            var storeABR = helpers.store.get(ABR_KEY);
            var profile = '';

            if (defaultProfile === constants.PROFILE.AUTO && storeABR !== 'false' && !forceProfile) {
                return defaultProfile;
            } else {
                profile = forceProfile || storeProfile || defaultProfile || paramProfile || constants.PROFILE.BASE;
                if (!helpers.feature.supportsVideoProfile(profile)) {
                    helpers.sentry.captureMessage('This profile is not available. profile = ' + profile);
                    profile = constants.PROFILE.BASE;
                }
            }

            return profile;
        }

        function initInstanceDomain() {
            if (document.domain) {
                if (document.domain.indexOf('kakao.com') > -1) {
                    document.domain = 'kakao.com';
                } else if (document.domain.indexOf('daum.net') > -1) {
                    document.domain = 'daum.net';
                }
            }
        }

        return {
            init: function(videoElement, setting) {
                if (!(videoElement.tagName && videoElement.tagName.toLowerCase() === 'video')) {
                    debug.log('video element is not exists, please check parameter for video element ');
                    return;
                }

                this.videoElement = videoElement;
                this.env = setting.env || {};
                this.type = setting.type || constants.VIDEO_TYPE.VOD;
                this.html5 = createPlayer.bind(this)();

                initModules(this);
                initInstanceDomain();

                if (env.offsetPoints && typeof env.offsetPoints === 'string') {
                    var offsetPoints = {};

                    env.offsetPoints.split(',').forEach(function(point) {
                        offsetPoints[point] = true;
                    });

                    env.offsetPoints = offsetPoints;
                }

                window.registerApiAdapter(new window.Html5PlayerAdapter(this));

                debug.info('player type:', this.type);
                debug.info('player platform:', ua.platform);

                return this;
            },
            loadAndPlay: function(id, profile, start) {
                this.profile = profileCheck(this.env, profile);

                if (this.type === 'VOD') {
                    controller.loadAndPlay(id, this.profile, start);
                } else if (this.type === 'LIVE') {
                    liveController.loadAndPlay(id, this.profile);
                }
            },
            load: function(id, profile, start) {
                this.profile = profileCheck(this.env, profile);

                if (this.type === 'VOD') {
                    controller.load(id, this.profile, start);
                } else if (this.type === 'LIVE') {
                    liveController.load(id, this.profile);
                }
            },
            play: function(profile) {
                this.profile = this.env.profile || profile || constants.PROFILE.BASE;

                if (this.type === 'VOD') {
                    controller.play(this.profile);
                } else if (this.type === 'LIVE') {
                    liveController.play(this.profile);
                }
            },
            pause: function() {
                controller.pause();
            },
            stop: function() {
                controller.stop();
            },
            seekTo: function(sec) {
                if (!queue.front) {
                    debug.warn('seekTo function only working after play');
                    return;
                }

                if (queue.front.type === constants.VIDEO_TYPE.AD && helpers.env.isProd()) {
                    debug.warn('seekTo function only working on vod or live', helpers.env.isProd());
                    return;
                }
                controller.seekTo(sec);
            },
            getDuration: function() {
                return controller.getDuration();
            },
            setVolume: function(number) {
                if (!queue.front) {
                    debug.warn('setVolume function only working after play');
                    return;
                }

                if (queue.front.type === constants.VIDEO_TYPE.AD) {
                    debug.warn('setVolume function only working on vod or live');
                    return;
                }

                if (ua.platform !== 'pc') {
                    debug.warn('setVolume function only working on PC');
                    return;
                }

                this.setMute(false);
                controller.setVolume(number);
            },
            setMute: function(muteOn) {
                controller.setMute(muteOn);
            },
            setAutoPlayMode: function(isAutoPlay) {
                controller.setAutoPlayMode(isAutoPlay);
            },
            setNextVideo: function(clipLinkId) {
                controller.setNextVideo(clipLinkId);
            },
            setContinuousPlay: function(isContinuousPlay) {
                controller.setContinuousPlay(isContinuousPlay);
            },
            setAutoplayVisible: function(visiblility) {
                controller.setAutoplayVisible(visiblility);
            },
            setBeaconData: function(beacon) {
                controller.setBeaconData(beacon);
            },
            setPlaybackRate: function(rate) {
                controller.setPlaybackRate(rate);
            },
            setWideScreenMode: function(isWideScreen) {
                controller.setWideScreenMode(isWideScreen);
            },
            cancelFullScreen: function() {
                controller.cancelFullScreen();
            },
            changeOrientation: function(data) {
                exports.queue.emit('change:orientation', data);
            }
        };
    })();
})((window.monet = typeof window.monet === 'undefined' ? {} : window.monet));
